/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: number; output: number };
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: string | number; output: string };
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: string; output: string };
  /** The day, does not include a time. */
  Date: { input: any; output: any };
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: string; output: string };
};

/**
 * Flat projection of the single currently-accepted human finding for an IB
 * line:
 * - denialCode             — audit_finding.audit_finding_rule_type
 * - discrepantQuantity     — audit_finding.improper_payment_units_charged
 * - discrepantBilledAmount — batch_claim_line_item.original_billed_amount
 * - determinedSavings      — audit_finding.improper_payment_cost
 */
export type AcceptedFindingByIbLine = {
  __typename?: "AcceptedFindingByIbLine";
  denialCode?: Maybe<Scalars["String"]["output"]>;
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  discrepantBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  discrepantQuantity?: Maybe<Scalars["Int"]["output"]>;
  ibLineId: Scalars["UUID"]["output"];
  rationale?: Maybe<Scalars["String"]["output"]>;
  revCode?: Maybe<Scalars["String"]["output"]>;
};

export type ActiveClaimAssignee = Node & {
  __typename?: "ActiveClaimAssignee";
  /** Reads a single `AuditorUser` that is related to this `ActiveClaimAssignee`. */
  auditorUser?: Maybe<AuditorUser>;
  auditorUserId: Scalars["UUID"]["output"];
  /** Reads a single `BatchClaim` that is related to this `ActiveClaimAssignee`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

/** The fields on `activeClaimAssignee` to look up the row to connect. */
export type ActiveClaimAssigneeActiveClaimAssigneesBatchClaimIdAuditorUserIdKeyConnect =
  {
    auditorUserId: Scalars["UUID"]["input"];
    batchClaimId: Scalars["UUID"]["input"];
  };

/** The fields on `activeClaimAssignee` to look up the row to connect. */
export type ActiveClaimAssigneeActiveClaimAssigneesPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

export type ActiveClaimAssigneeAggregates = {
  __typename?: "ActiveClaimAssigneeAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ActiveClaimAssigneeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `ActiveClaimAssignee` object types. */
export type ActiveClaimAssigneeAggregatesFilter = {
  /** Distinct count aggregate over matching `ActiveClaimAssignee` objects. */
  distinctCount?: InputMaybe<ActiveClaimAssigneeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ActiveClaimAssignee` object to be included within the aggregate. */
  filter?: InputMaybe<ActiveClaimAssigneeFilter>;
};

/**
 * A condition to be used against `ActiveClaimAssignee` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ActiveClaimAssigneeCondition = {
  /** Checks for equality with the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type ActiveClaimAssigneeDistinctCountAggregateFilter = {
  auditorUserId?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type ActiveClaimAssigneeDistinctCountAggregates = {
  __typename?: "ActiveClaimAssigneeDistinctCountAggregates";
  /** Distinct count of auditorUserId across the matching connection */
  auditorUserId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ActiveClaimAssignee` object types. All fields are combined with a logical ‘and.’ */
export type ActiveClaimAssigneeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActiveClaimAssigneeFilter>>;
  /** Filter by the object’s `auditorUser` relation. */
  auditorUser?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActiveClaimAssigneeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActiveClaimAssigneeFilter>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ActiveClaimAssigneeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `activeClaimAssignee` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `activeClaimAssignee` to look up the row to update. */
export type ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyUsingActiveClaimAssigneesBatchClaimIdAuditorUserIdKeyUpdate =
  {
    auditorUserId: Scalars["UUID"]["input"];
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `activeClaimAssignee` being updated. */
    patch: updateActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyPatch;
  };

/** The fields on `activeClaimAssignee` to look up the row to update. */
export type ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyUsingActiveClaimAssigneesPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `activeClaimAssignee` being updated. */
    patch: updateActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `activeClaimAssignee` to look up the row to update. */
export type ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyUsingActiveClaimAssigneesBatchClaimIdAuditorUserIdKeyUpdate =
  {
    auditorUserId: Scalars["UUID"]["input"];
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `activeClaimAssignee` being updated. */
    patch: updateActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyPatch;
  };

/** The fields on `activeClaimAssignee` to look up the row to update. */
export type ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyUsingActiveClaimAssigneesPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `activeClaimAssignee` being updated. */
    patch: updateActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `ActiveClaimAssignee`. Fields that are set will be updated. */
export type ActiveClaimAssigneePatch = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInput>;
};

/** Input for the nested mutation of `auditorUser` in the `ActiveClaimAssigneeInput` mutation. */
export type ActiveClaimAssigneesAuditorUserIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `activeClaimAssignee` in the `AuditorUserInput` mutation. */
export type ActiveClaimAssigneesAuditorUserIdFkeyInverseInput = {
  /** The primary key(s) for `activeClaimAssignee` for the far side of the relationship. */
  connectByBatchClaimIdAndAuditorUserId?: InputMaybe<
    Array<ActiveClaimAssigneeActiveClaimAssigneesBatchClaimIdAuditorUserIdKeyConnect>
  >;
  /** The primary key(s) for `activeClaimAssignee` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ActiveClaimAssigneeActiveClaimAssigneesPkeyConnect>
  >;
  /** The primary key(s) for `activeClaimAssignee` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ActiveClaimAssigneeNodeIdConnect>>;
  /** The primary key(s) and patch data for `activeClaimAssignee` for the far side of the relationship. */
  updateByBatchClaimIdAndAuditorUserId?: InputMaybe<
    Array<ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyUsingActiveClaimAssigneesBatchClaimIdAuditorUserIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `activeClaimAssignee` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyUsingActiveClaimAssigneesPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `activeClaimAssignee` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyNodeIdUpdate>
  >;
};

/** Input for the nested mutation of `batchClaim` in the `ActiveClaimAssigneeInput` mutation. */
export type ActiveClaimAssigneesBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `activeClaimAssignee` in the `BatchClaimInput` mutation. */
export type ActiveClaimAssigneesBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `activeClaimAssignee` for the far side of the relationship. */
  connectByBatchClaimIdAndAuditorUserId?: InputMaybe<
    Array<ActiveClaimAssigneeActiveClaimAssigneesBatchClaimIdAuditorUserIdKeyConnect>
  >;
  /** The primary key(s) for `activeClaimAssignee` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ActiveClaimAssigneeActiveClaimAssigneesPkeyConnect>
  >;
  /** The primary key(s) for `activeClaimAssignee` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ActiveClaimAssigneeNodeIdConnect>>;
  /** The primary key(s) and patch data for `activeClaimAssignee` for the far side of the relationship. */
  updateByBatchClaimIdAndAuditorUserId?: InputMaybe<
    Array<ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyUsingActiveClaimAssigneesBatchClaimIdAuditorUserIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `activeClaimAssignee` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyUsingActiveClaimAssigneesPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `activeClaimAssignee` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/** A connection to a list of `ActiveClaimAssignee` values. */
export type ActiveClaimAssigneesConnection = {
  __typename?: "ActiveClaimAssigneesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ActiveClaimAssigneeAggregates>;
  /** A list of edges which contains the `ActiveClaimAssignee` and cursor to aid in pagination. */
  edges: Array<ActiveClaimAssigneesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ActiveClaimAssigneeAggregates>>;
  /** A list of `ActiveClaimAssignee` objects. */
  nodes: Array<Maybe<ActiveClaimAssignee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActiveClaimAssignee` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ActiveClaimAssignee` values. */
export type ActiveClaimAssigneesConnectiongroupedAggregatesArgs = {
  groupBy: Array<ActiveClaimAssigneesGroupBy>;
  having?: InputMaybe<ActiveClaimAssigneesHavingInput>;
};

/** A `ActiveClaimAssignee` edge in the connection. */
export type ActiveClaimAssigneesEdge = {
  __typename?: "ActiveClaimAssigneesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ActiveClaimAssignee` at the end of the edge. */
  node?: Maybe<ActiveClaimAssignee>;
};

/** Grouping methods for `ActiveClaimAssignee` for usage during aggregation. */
export enum ActiveClaimAssigneesGroupBy {
  AUDITOR_USER_ID = "AUDITOR_USER_ID",
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
}

export type ActiveClaimAssigneesHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveClaimAssigneesHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ActiveClaimAssignee` aggregates. */
export type ActiveClaimAssigneesHavingInput = {
  AND?: InputMaybe<Array<ActiveClaimAssigneesHavingInput>>;
  OR?: InputMaybe<Array<ActiveClaimAssigneesHavingInput>>;
  average?: InputMaybe<ActiveClaimAssigneesHavingAverageInput>;
  distinctCount?: InputMaybe<ActiveClaimAssigneesHavingDistinctCountInput>;
  max?: InputMaybe<ActiveClaimAssigneesHavingMaxInput>;
  min?: InputMaybe<ActiveClaimAssigneesHavingMinInput>;
  stddevPopulation?: InputMaybe<ActiveClaimAssigneesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ActiveClaimAssigneesHavingStddevSampleInput>;
  sum?: InputMaybe<ActiveClaimAssigneesHavingSumInput>;
  variancePopulation?: InputMaybe<ActiveClaimAssigneesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ActiveClaimAssigneesHavingVarianceSampleInput>;
};

export type ActiveClaimAssigneesHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveClaimAssigneesHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveClaimAssigneesHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveClaimAssigneesHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveClaimAssigneesHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveClaimAssigneesHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveClaimAssigneesHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `ActiveClaimAssignee`. */
export enum ActiveClaimAssigneesOrderBy {
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC",
  AUDITOR_USER_ID_ASC = "AUDITOR_USER_ID_ASC",
  AUDITOR_USER_ID_DESC = "AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

export type ActiveIbLinesView = {
  __typename?: "ActiveIbLinesView";
  alaRowId?: Maybe<Scalars["UUID"]["output"]>;
  batchClaimId?: Maybe<Scalars["UUID"]["output"]>;
  chinDescription?: Maybe<Scalars["String"]["output"]>;
  chinItemNumber?: Maybe<Scalars["String"]["output"]>;
  chinModifier?: Maybe<Scalars["String"]["output"]>;
  chinProcedureCode?: Maybe<Scalars["String"]["output"]>;
  chinRevCode?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["Datetime"]["output"]>;
  dateOfService?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  groupCode?: Maybe<Scalars["String"]["output"]>;
  ibId?: Maybe<Scalars["UUID"]["output"]>;
  ibLineId?: Maybe<Scalars["UUID"]["output"]>;
  itemNumber?: Maybe<Scalars["String"]["output"]>;
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  pageNumber?: Maybe<Scalars["Int"]["output"]>;
  procedureCode?: Maybe<Scalars["String"]["output"]>;
  procedureCodeModifier?: Maybe<Scalars["String"]["output"]>;
  revCode?: Maybe<Scalars["String"]["output"]>;
  s3InputSourceId?: Maybe<Scalars["UUID"]["output"]>;
  tableNumber?: Maybe<Scalars["Int"]["output"]>;
  totalCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  units?: Maybe<Scalars["Int"]["output"]>;
  updatedAt?: Maybe<Scalars["Datetime"]["output"]>;
  versionFingerprint?: Maybe<Scalars["UUID"]["output"]>;
};

export type ActiveIbLinesViewAggregates = {
  __typename?: "ActiveIbLinesViewAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ActiveIbLinesViewAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ActiveIbLinesViewDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ActiveIbLinesViewMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ActiveIbLinesViewMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ActiveIbLinesViewStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ActiveIbLinesViewStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ActiveIbLinesViewSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ActiveIbLinesViewVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ActiveIbLinesViewVarianceSampleAggregates>;
};

export type ActiveIbLinesViewAverageAggregates = {
  __typename?: "ActiveIbLinesViewAverageAggregates";
  /** Mean average of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of totalCharge across the matching connection */
  totalCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

/**
 * A condition to be used against `ActiveIbLinesView` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ActiveIbLinesViewCondition = {
  /** Checks for equality with the object’s `alaRowId` field. */
  alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `chinDescription` field. */
  chinDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `chinItemNumber` field. */
  chinItemNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `chinModifier` field. */
  chinModifier?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `chinProcedureCode` field. */
  chinProcedureCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `chinRevCode` field. */
  chinRevCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateOfService` field. */
  dateOfService?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `groupCode` field. */
  groupCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `ibId` field. */
  ibId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `ibLineId` field. */
  ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `itemNumber` field. */
  itemNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `procedureCode` field. */
  procedureCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCodeModifier` field. */
  procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `revCode` field. */
  revCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `s3InputSourceId` field. */
  s3InputSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tableNumber` field. */
  tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `totalCharge` field. */
  totalCharge?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Checks for equality with the object’s `units` field. */
  units?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `versionFingerprint` field. */
  versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type ActiveIbLinesViewDistinctCountAggregates = {
  __typename?: "ActiveIbLinesViewDistinctCountAggregates";
  /** Distinct count of alaRowId across the matching connection */
  alaRowId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of chinDescription across the matching connection */
  chinDescription?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of chinItemNumber across the matching connection */
  chinItemNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of chinModifier across the matching connection */
  chinModifier?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of chinProcedureCode across the matching connection */
  chinProcedureCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of chinRevCode across the matching connection */
  chinRevCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dateOfService across the matching connection */
  dateOfService?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of groupCode across the matching connection */
  groupCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of ibId across the matching connection */
  ibId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of ibLineId across the matching connection */
  ibLineId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of itemNumber across the matching connection */
  itemNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode across the matching connection */
  procedureCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCodeModifier across the matching connection */
  procedureCodeModifier?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of revCode across the matching connection */
  revCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of s3InputSourceId across the matching connection */
  s3InputSourceId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of totalCharge across the matching connection */
  totalCharge?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of units across the matching connection */
  units?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of versionFingerprint across the matching connection */
  versionFingerprint?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ActiveIbLinesView` object types. All fields are combined with a logical ‘and.’ */
export type ActiveIbLinesViewFilter = {
  /** Filter by the object’s `alaRowId` field. */
  alaRowId?: InputMaybe<UUIDFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActiveIbLinesViewFilter>>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `chinDescription` field. */
  chinDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `chinItemNumber` field. */
  chinItemNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `chinModifier` field. */
  chinModifier?: InputMaybe<StringFilter>;
  /** Filter by the object’s `chinProcedureCode` field. */
  chinProcedureCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `chinRevCode` field. */
  chinRevCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateOfService` field. */
  dateOfService?: InputMaybe<DateFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `groupCode` field. */
  groupCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ibId` field. */
  ibId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `ibLineId` field. */
  ibLineId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `itemNumber` field. */
  itemNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActiveIbLinesViewFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActiveIbLinesViewFilter>>;
  /** Filter by the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `procedureCode` field. */
  procedureCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCodeModifier` field. */
  procedureCodeModifier?: InputMaybe<StringFilter>;
  /** Filter by the object’s `revCode` field. */
  revCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `s3InputSourceId` field. */
  s3InputSourceId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `tableNumber` field. */
  tableNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalCharge` field. */
  totalCharge?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `units` field. */
  units?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `versionFingerprint` field. */
  versionFingerprint?: InputMaybe<UUIDFilter>;
};

/** Grouping methods for `ActiveIbLinesView` for usage during aggregation. */
export enum ActiveIbLinesViewGroupBy {
  ALA_ROW_ID = "ALA_ROW_ID",
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CHIN_DESCRIPTION = "CHIN_DESCRIPTION",
  CHIN_ITEM_NUMBER = "CHIN_ITEM_NUMBER",
  CHIN_MODIFIER = "CHIN_MODIFIER",
  CHIN_PROCEDURE_CODE = "CHIN_PROCEDURE_CODE",
  CHIN_REV_CODE = "CHIN_REV_CODE",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DATE_OF_SERVICE = "DATE_OF_SERVICE",
  DESCRIPTION = "DESCRIPTION",
  GROUP_CODE = "GROUP_CODE",
  IB_ID = "IB_ID",
  ITEM_NUMBER = "ITEM_NUMBER",
  LINE_NUMBER = "LINE_NUMBER",
  PAGE_NUMBER = "PAGE_NUMBER",
  PROCEDURE_CODE = "PROCEDURE_CODE",
  PROCEDURE_CODE_MODIFIER = "PROCEDURE_CODE_MODIFIER",
  REV_CODE = "REV_CODE",
  S3_INPUT_SOURCE_ID = "S3_INPUT_SOURCE_ID",
  TABLE_NUMBER = "TABLE_NUMBER",
  TOTAL_CHARGE = "TOTAL_CHARGE",
  UNITS = "UNITS",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
  VERSION_FINGERPRINT = "VERSION_FINGERPRINT",
}

export type ActiveIbLinesViewHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfService?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  totalCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveIbLinesViewHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfService?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  totalCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ActiveIbLinesView` aggregates. */
export type ActiveIbLinesViewHavingInput = {
  AND?: InputMaybe<Array<ActiveIbLinesViewHavingInput>>;
  OR?: InputMaybe<Array<ActiveIbLinesViewHavingInput>>;
  average?: InputMaybe<ActiveIbLinesViewHavingAverageInput>;
  distinctCount?: InputMaybe<ActiveIbLinesViewHavingDistinctCountInput>;
  max?: InputMaybe<ActiveIbLinesViewHavingMaxInput>;
  min?: InputMaybe<ActiveIbLinesViewHavingMinInput>;
  stddevPopulation?: InputMaybe<ActiveIbLinesViewHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ActiveIbLinesViewHavingStddevSampleInput>;
  sum?: InputMaybe<ActiveIbLinesViewHavingSumInput>;
  variancePopulation?: InputMaybe<ActiveIbLinesViewHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ActiveIbLinesViewHavingVarianceSampleInput>;
};

export type ActiveIbLinesViewHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfService?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  totalCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveIbLinesViewHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfService?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  totalCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveIbLinesViewHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfService?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  totalCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveIbLinesViewHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfService?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  totalCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveIbLinesViewHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfService?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  totalCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveIbLinesViewHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfService?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  totalCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveIbLinesViewHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfService?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  totalCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ActiveIbLinesViewMaxAggregates = {
  __typename?: "ActiveIbLinesViewMaxAggregates";
  /** Maximum of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of totalCharge across the matching connection */
  totalCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Maximum of units across the matching connection */
  units?: Maybe<Scalars["Int"]["output"]>;
};

export type ActiveIbLinesViewMinAggregates = {
  __typename?: "ActiveIbLinesViewMinAggregates";
  /** Minimum of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of totalCharge across the matching connection */
  totalCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Minimum of units across the matching connection */
  units?: Maybe<Scalars["Int"]["output"]>;
};

export type ActiveIbLinesViewStddevPopulationAggregates = {
  __typename?: "ActiveIbLinesViewStddevPopulationAggregates";
  /** Population standard deviation of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of totalCharge across the matching connection */
  totalCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ActiveIbLinesViewStddevSampleAggregates = {
  __typename?: "ActiveIbLinesViewStddevSampleAggregates";
  /** Sample standard deviation of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of totalCharge across the matching connection */
  totalCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ActiveIbLinesViewSumAggregates = {
  __typename?: "ActiveIbLinesViewSumAggregates";
  /** Sum of lineNumber across the matching connection */
  lineNumber: Scalars["BigInt"]["output"];
  /** Sum of pageNumber across the matching connection */
  pageNumber: Scalars["BigInt"]["output"];
  /** Sum of tableNumber across the matching connection */
  tableNumber: Scalars["BigInt"]["output"];
  /** Sum of totalCharge across the matching connection */
  totalCharge: Scalars["BigFloat"]["output"];
  /** Sum of units across the matching connection */
  units: Scalars["BigInt"]["output"];
};

export type ActiveIbLinesViewVariancePopulationAggregates = {
  __typename?: "ActiveIbLinesViewVariancePopulationAggregates";
  /** Population variance of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of totalCharge across the matching connection */
  totalCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ActiveIbLinesViewVarianceSampleAggregates = {
  __typename?: "ActiveIbLinesViewVarianceSampleAggregates";
  /** Sample variance of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of totalCharge across the matching connection */
  totalCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** A connection to a list of `ActiveIbLinesView` values. */
export type ActiveIbLinesViewsConnection = {
  __typename?: "ActiveIbLinesViewsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ActiveIbLinesViewAggregates>;
  /** A list of edges which contains the `ActiveIbLinesView` and cursor to aid in pagination. */
  edges: Array<ActiveIbLinesViewsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ActiveIbLinesViewAggregates>>;
  /** A list of `ActiveIbLinesView` objects. */
  nodes: Array<Maybe<ActiveIbLinesView>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActiveIbLinesView` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ActiveIbLinesView` values. */
export type ActiveIbLinesViewsConnectiongroupedAggregatesArgs = {
  groupBy: Array<ActiveIbLinesViewGroupBy>;
  having?: InputMaybe<ActiveIbLinesViewHavingInput>;
};

/** A `ActiveIbLinesView` edge in the connection. */
export type ActiveIbLinesViewsEdge = {
  __typename?: "ActiveIbLinesViewsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ActiveIbLinesView` at the end of the edge. */
  node?: Maybe<ActiveIbLinesView>;
};

/** Methods to use when ordering `ActiveIbLinesView`. */
export enum ActiveIbLinesViewsOrderBy {
  ALA_ROW_ID_ASC = "ALA_ROW_ID_ASC",
  ALA_ROW_ID_DESC = "ALA_ROW_ID_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CHIN_DESCRIPTION_ASC = "CHIN_DESCRIPTION_ASC",
  CHIN_DESCRIPTION_DESC = "CHIN_DESCRIPTION_DESC",
  CHIN_ITEM_NUMBER_ASC = "CHIN_ITEM_NUMBER_ASC",
  CHIN_ITEM_NUMBER_DESC = "CHIN_ITEM_NUMBER_DESC",
  CHIN_MODIFIER_ASC = "CHIN_MODIFIER_ASC",
  CHIN_MODIFIER_DESC = "CHIN_MODIFIER_DESC",
  CHIN_PROCEDURE_CODE_ASC = "CHIN_PROCEDURE_CODE_ASC",
  CHIN_PROCEDURE_CODE_DESC = "CHIN_PROCEDURE_CODE_DESC",
  CHIN_REV_CODE_ASC = "CHIN_REV_CODE_ASC",
  CHIN_REV_CODE_DESC = "CHIN_REV_CODE_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DATE_OF_SERVICE_ASC = "DATE_OF_SERVICE_ASC",
  DATE_OF_SERVICE_DESC = "DATE_OF_SERVICE_DESC",
  DESCRIPTION_ASC = "DESCRIPTION_ASC",
  DESCRIPTION_DESC = "DESCRIPTION_DESC",
  GROUP_CODE_ASC = "GROUP_CODE_ASC",
  GROUP_CODE_DESC = "GROUP_CODE_DESC",
  IB_ID_ASC = "IB_ID_ASC",
  IB_ID_DESC = "IB_ID_DESC",
  IB_LINE_ID_ASC = "IB_LINE_ID_ASC",
  IB_LINE_ID_DESC = "IB_LINE_ID_DESC",
  ITEM_NUMBER_ASC = "ITEM_NUMBER_ASC",
  ITEM_NUMBER_DESC = "ITEM_NUMBER_DESC",
  LINE_NUMBER_ASC = "LINE_NUMBER_ASC",
  LINE_NUMBER_DESC = "LINE_NUMBER_DESC",
  NATURAL = "NATURAL",
  PAGE_NUMBER_ASC = "PAGE_NUMBER_ASC",
  PAGE_NUMBER_DESC = "PAGE_NUMBER_DESC",
  PROCEDURE_CODE_ASC = "PROCEDURE_CODE_ASC",
  PROCEDURE_CODE_DESC = "PROCEDURE_CODE_DESC",
  PROCEDURE_CODE_MODIFIER_ASC = "PROCEDURE_CODE_MODIFIER_ASC",
  PROCEDURE_CODE_MODIFIER_DESC = "PROCEDURE_CODE_MODIFIER_DESC",
  REV_CODE_ASC = "REV_CODE_ASC",
  REV_CODE_DESC = "REV_CODE_DESC",
  S3_INPUT_SOURCE_ID_ASC = "S3_INPUT_SOURCE_ID_ASC",
  S3_INPUT_SOURCE_ID_DESC = "S3_INPUT_SOURCE_ID_DESC",
  TABLE_NUMBER_ASC = "TABLE_NUMBER_ASC",
  TABLE_NUMBER_DESC = "TABLE_NUMBER_DESC",
  TOTAL_CHARGE_ASC = "TOTAL_CHARGE_ASC",
  TOTAL_CHARGE_DESC = "TOTAL_CHARGE_DESC",
  UNITS_ASC = "UNITS_ASC",
  UNITS_DESC = "UNITS_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
  VERSION_FINGERPRINT_ASC = "VERSION_FINGERPRINT_ASC",
  VERSION_FINGERPRINT_DESC = "VERSION_FINGERPRINT_DESC",
}

export type ActiveStatistics = {
  __typename?: "ActiveStatistics";
  allowedAmount: FloatStat;
  billedAmount: FloatStat;
  claimsAssigned: IntStat;
  claimsAwaitingDocumentation: IntStat;
  claimsCompleted: IntStat;
  claimsInProgress: IntStat;
  claimsUnderReview: IntStat;
  claimsWithProviderSignOff: IntStat;
  determinedClientSavings: FloatStat;
  determinedDiscrepantAmount: FloatStat;
  numberOfLives: IntStat;
  potentialClientSavings: FloatStat;
  potentialDiscrepantAmount: FloatStat;
  savingsPerLife: FloatStat;
};

export type Agent = {
  __typename?: "Agent";
  case?: Maybe<Case>;
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["ID"]["output"];
  instanceId: Scalars["UUID"]["output"];
  messages?: Maybe<Array<AgentMessage>>;
  name: Scalars["String"]["output"];
  recommendation?: Maybe<AgentRecommendation>;
  taskId: Scalars["UUID"]["output"];
  threadId: Scalars["UUID"]["output"];
  totalMessages?: Maybe<Scalars["Int"]["output"]>;
};

export type AgentArtifact = {
  __typename?: "AgentArtifact";
  agentMetadata: AgentMetadata;
  artifactTemplate?: Maybe<AgentArtifactTemplate>;
  artifacts?: Maybe<Array<AgentArtifact>>;
  citations?: Maybe<Array<Citation>>;
  createdAt: Scalars["String"]["output"];
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  parentId?: Maybe<Scalars["UUID"]["output"]>;
  recommendation?: Maybe<Scalars["JSON"]["output"]>;
  recommendationCitations?: Maybe<Array<Citation>>;
  sequenceNumber: Scalars["Int"]["output"];
  taskArtifactOutput?: Maybe<Scalars["JSON"]["output"]>;
  taskArtifactTemplateKey?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  workflowStatusId: Scalars["Int"]["output"];
};

export type AgentArtifactTemplate = {
  __typename?: "AgentArtifactTemplate";
  artifactTemplateKey: Scalars["String"]["output"];
  jsonSchema: Scalars["JSON"]["output"];
};

export type AgentMessage = IAgentMessage & {
  __typename?: "AgentMessage";
  agent?: Maybe<Agent>;
  agentId: Scalars["ID"]["output"];
  citations?: Maybe<Array<InlineCitations>>;
  content: AgentMessageContent;
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  messages?: Maybe<Array<AgentMessage>>;
  name: Scalars["String"]["output"];
  parentReferenceId?: Maybe<Scalars["UUID"]["output"]>;
  referenceId?: Maybe<Scalars["UUID"]["output"]>;
  revision?: Maybe<AgentMessageRevision>;
  schema?: Maybe<Scalars["JSON"]["output"]>;
  sequence: Scalars["Int"]["output"];
  subTaskId?: Maybe<Scalars["UUID"]["output"]>;
  userValidation?: Maybe<AgentMessageUserValidation>;
  workflowStatusId: Scalars["Int"]["output"];
};

export type AgentMessageContent = {
  __typename?: "AgentMessageContent";
  markdownBody?: Maybe<Scalars["String"]["output"]>;
  markdownTitle?: Maybe<Scalars["String"]["output"]>;
  taskArtifactOutput?: Maybe<Scalars["JSON"]["output"]>;
};

export type AgentMessageRevision = {
  __typename?: "AgentMessageRevision";
  authorId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
  reasonAuthorId?: Maybe<Scalars["UUID"]["output"]>;
  reasonCreatedAt?: Maybe<Scalars["Datetime"]["output"]>;
  revisionId: Scalars["ID"]["output"];
  revisionReasonId?: Maybe<Scalars["ID"]["output"]>;
};

export type AgentMessageRevisionInput = {
  reason?: InputMaybe<Scalars["String"]["input"]>;
  revisedTaskArtifactOutput: Scalars["JSON"]["input"];
  revisionId?: InputMaybe<Scalars["ID"]["input"]>;
  revisionJsonPatches: Array<JsonPatchOperation>;
};

export type AgentMessageUserValidation = {
  __typename?: "AgentMessageUserValidation";
  author?: Maybe<Author>;
  createdAt: Scalars["Datetime"]["output"];
  rejectionReason?: Maybe<Scalars["String"]["output"]>;
  revisionId: Scalars["ID"]["output"];
  status: AgentMessageUserValidationStatus;
  userId: Scalars["UUID"]["output"];
};

export type AgentMessageUserValidationInput = {
  rejectionReason?: InputMaybe<Scalars["String"]["input"]>;
  status: AgentMessageUserValidationStatus;
};

export enum AgentMessageUserValidationStatus {
  ACCEPTED = "ACCEPTED",
  UNSET = "UNSET",
}

export type AgentMetadata = {
  __typename?: "AgentMetadata";
  case?: Maybe<Case>;
  caseId: Scalars["UUID"]["output"];
  documentIds: Array<Scalars["UUID"]["output"]>;
  instanceId: Scalars["UUID"]["output"];
  taskDisplayLabel: Scalars["String"]["output"];
  taskId: Scalars["UUID"]["output"];
  taskName?: Maybe<Scalars["String"]["output"]>;
  threadId: Scalars["UUID"]["output"];
  totalMessages?: Maybe<Scalars["Int"]["output"]>;
};

export type AgentOutputJsonCitation = {
  __typename?: "AgentOutputJsonCitation";
  citation_key: Scalars["String"]["output"];
  document_id: Scalars["UUID"]["output"];
  file_id: Scalars["UUID"]["output"];
  page_index?: Maybe<Scalars["Int"]["output"]>;
};

export type AgentRecommendation = {
  __typename?: "AgentRecommendation";
  agentId: Scalars["ID"]["output"];
  agentMessageId: Scalars["ID"]["output"];
  citations: Array<InlineCitations>;
  content: AgentRecommendationContent;
  revision?: Maybe<AgentMessageRevision>;
};

export type AgentRecommendationContent = {
  __typename?: "AgentRecommendationContent";
  citations: Array<AgentOutputJsonCitation>;
  markdown: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type AgentRecommendationRevisionInput = {
  revisedRecommendationMarkdown: Scalars["String"]["input"];
  revisionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AgentType = {
  __typename?: "AgentType";
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type AgentsInput = {
  caseId: Scalars["UUID"]["input"];
};

export type Aggregate = {
  __typename?: "Aggregate";
  count?: Maybe<Scalars["Int"]["output"]>;
  sum?: Maybe<Scalars["Float"]["output"]>;
};

export type Annotation = {
  authorId: Scalars["ID"]["output"];
  comment?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["ID"]["output"];
  labels: Array<Scalars["String"]["output"]>;
};

export type AnnotationLabel = {
  __typename?: "AnnotationLabel";
  category: AnnotationLabelCategory;
  createdAt: Scalars["Datetime"]["output"];
  label: Scalars["String"]["output"];
  labelDescription?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
};

export enum AnnotationLabelCategory {
  AI_TRAINING = "AI_TRAINING",
  PAYMENT_INTEGRITY = "PAYMENT_INTEGRITY",
}

export type AskAutodorCreateSavedPromptInput = {
  prompt: Scalars["String"]["input"];
  tags: Array<Scalars["String"]["input"]>;
};

export type AskAutodorCreateSavedPromptResponse = {
  __typename?: "AskAutodorCreateSavedPromptResponse";
  savedPromptId: Scalars["UUID"]["output"];
};

export type AskAutodorDeleteSavedPromptInput = {
  promptId: Scalars["UUID"]["input"];
};

export type AskAutodorFileVectorsExistInput = {
  documentIds: Array<Scalars["UUID"]["input"]>;
};

export type AskAutodorFileVectorsExistResponse = {
  __typename?: "AskAutodorFileVectorsExistResponse";
  documentIds: Array<Maybe<Scalars["UUID"]["output"]>>;
};

export type AskAutodorGetSavedPromptsInput = {
  tags: Array<Scalars["String"]["input"]>;
};

export type AskAutodorQueue = {
  __typename?: "AskAutodorQueue";
  cases: Array<Case>;
  createdAt: Scalars["String"]["output"];
  files: Array<File>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  summary: AskAutodorQueueSummary;
};

export type AskAutodorQueueName = {
  __typename?: "AskAutodorQueueName";
  createdAt: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
};

export type AskAutodorQueueSummary = {
  __typename?: "AskAutodorQueueSummary";
  caseCount: Scalars["Int"]["output"];
  completedCaseCount: Scalars["Int"]["output"];
  fileCount: Scalars["Int"]["output"];
  openCaseCount: Scalars["Int"]["output"];
};

/**
 * Connection arguments for paginating through AskAutodorQueues.
 *
 * Note: The filter fields (filter, filterArray, filterGraph) are mutually exclusive.
 * Only one filter type may be provided per query. An error will be returned if multiple filter types are specified.
 */
export type AskAutodorQueuesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  /**
   * Array-based filter (legacy support, will be replaced by graph filters in a future version).
   * Mutually exclusive with filterArray and filterGraph.
   */
  filter?: InputMaybe<Array<AskAutodorQueuesFilter>>;
  /**
   * Explicit array-based filter.
   * Mutually exclusive with filter and filterGraph.
   */
  filterArray?: InputMaybe<Array<AskAutodorQueuesFilter>>;
  /**
   * PostGraphile-style object graph filter.
   * Mutually exclusive with filter and filterArray.
   */
  filterGraph?: InputMaybe<AskAutodorQueuesFilterGraph>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AskAutodorQueuesOrdering>>;
};

export type AskAutodorQueuesConnection = {
  __typename?: "AskAutodorQueuesConnection";
  edges: Array<AskAutodorQueuesEdge>;
  nodes: Array<AskAutodorQueue>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type AskAutodorQueuesEdge = {
  __typename?: "AskAutodorQueuesEdge";
  cursor: Scalars["Cursor"]["output"];
  node: AskAutodorQueue;
};

/** Supports all PostGraphile-style operators */
export type AskAutodorQueuesFieldFilter = {
  distinctFrom?: InputMaybe<Scalars["JSON"]["input"]>;
  endsWith?: InputMaybe<Scalars["String"]["input"]>;
  endsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  equalTo?: InputMaybe<Scalars["JSON"]["input"]>;
  equalToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  greaterThan?: InputMaybe<Scalars["JSON"]["input"]>;
  greaterThanInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  greaterThanOrEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["JSON"]["input"]>>;
  inInsensitive?: InputMaybe<Array<Scalars["String"]["input"]>>;
  includes?: InputMaybe<Scalars["String"]["input"]>;
  includesInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  lessThan?: InputMaybe<Scalars["JSON"]["input"]>;
  lessThanInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  lessThanOrEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  like?: InputMaybe<Scalars["String"]["input"]>;
  likeInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  notDistinctFrom?: InputMaybe<Scalars["JSON"]["input"]>;
  notEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  notIn?: InputMaybe<Array<Scalars["JSON"]["input"]>>;
  notLike?: InputMaybe<Scalars["String"]["input"]>;
  notLikeInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
  startsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
};

export type AskAutodorQueuesFilter = {
  field: AskAutodorQueuesFilterField;
  op: AskAutodorQueuesFilterOperator;
  value: Scalars["JSON"]["input"];
};

export enum AskAutodorQueuesFilterField {
  NAME = "NAME",
}

/** PostGraphile-style object graph filter */
export type AskAutodorQueuesFilterGraph = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AskAutodorQueuesFilterGraph>>;
  /** Filter by the object's `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AskAutodorQueuesFilterGraph>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AskAutodorQueuesFilterGraph>>;
};

export enum AskAutodorQueuesFilterOperator {
  ANY = "ANY",
  EQ = "EQ",
  GT = "GT",
  ILIKE = "ILIKE",
  IN = "IN",
  LIKE = "LIKE",
  LT = "LT",
}

export enum AskAutodorQueuesOrderField {
  CREATED_AT = "CREATED_AT",
  ID = "ID",
  NAME = "NAME",
}

export type AskAutodorQueuesOrdering = {
  direction?: SortDirection;
  field: AskAutodorQueuesOrderField;
};

export type AskAutodorSavedPrompt = {
  __typename?: "AskAutodorSavedPrompt";
  authorId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  isDeleted: Scalars["Boolean"]["output"];
  prompt: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type AskAutodorSavedPromptTag = {
  __typename?: "AskAutodorSavedPromptTag";
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  isDeleted: Scalars["Boolean"]["output"];
  tag: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type AskAutodorSavedPromptTagGroup = {
  __typename?: "AskAutodorSavedPromptTagGroup";
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  promptId: Scalars["UUID"]["output"];
  tagId: Scalars["UUID"]["output"];
};

export type AskAutodorSavedPromptsNewTagsInput = {
  promptId: Scalars["UUID"]["input"];
  tags: Array<Scalars["String"]["input"]>;
};

export type AssignClaimsToAuditGroupInput = {
  /** 1..N batch claim ids. Duplicates are deduped server-side. */
  batchClaimIds: Array<Scalars["UUID"]["input"]>;
  claimAuditGroupId: Scalars["UUID"]["input"];
  /**
   * When true, claims already in a different audit group are moved
   * into the target group. When false (default), those claims are
   * skipped and their ids returned in `skippedBatchClaimIds`.
   */
  reassign?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AssignClaimsToAuditGroupPayload = {
  __typename?: "AssignClaimsToAuditGroupPayload";
  claimAuditGroup: ClaimAuditGroup;
  /**
   * Ids that were not assigned because they already belong to a
   * different audit group and `reassign` was false. Empty
   * otherwise.
   */
  skippedBatchClaimIds: Array<Scalars["UUID"]["output"]>;
};

export type AuditDocumentation = {
  __typename?: "AuditDocumentation";
  fileName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  process: AuditDocumentationProcessTypes;
  signedUrl: Scalars["String"]["output"];
  size: Scalars["Int"]["output"];
  subFile?: Maybe<Scalars["String"]["output"]>;
  /**
   * The timestamp when the document upload was first confirmed by the system.
   *
   * Returns NULL in the following cases:
   * - Document was created on or before 2024-11-05 (pre-migration data limitation)
   * - Document upload was never confirmed (no processing states exist)
   *
   * For documents uploaded after 2024-11-05, this represents the earliest timestamp
   * when the system confirmed it received/processed the file. This is typically
   * within seconds of the user-initiated upload (98.6% of cases), but may be later
   * if the upload was healed by automated processing (0.2% of cases).
   */
  uploadConfirmedAt?: Maybe<Scalars["String"]["output"]>;
};

export enum AuditDocumentationProcessTypes {
  OCR = "OCR",
  ORIGINAL = "ORIGINAL",
}

export type AuditFinding = Node & {
  __typename?: "AuditFinding";
  accepted?: Maybe<Scalars["Boolean"]["output"]>;
  /** Reads a single `AuditFindingJob` that is related to this `AuditFinding`. */
  auditFindingJob?: Maybe<AuditFindingJob>;
  auditFindingJobId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `AuditFindingReasonCode`. */
  auditFindingReasonCodes: AuditFindingReasonCodesConnection;
  /** Reads a single `AuditFindingReview` that is related to this `AuditFinding`. */
  auditFindingReviewByReviewId?: Maybe<AuditFindingReview>;
  /** Reads and enables pagination through a set of `AuditFindingReview`. */
  auditFindingReviewsByOriginalId: AuditFindingReviewsConnection;
  /**
   * Reads and enables pagination through a set of `AuditFindingReview`.
   * @deprecated Please use auditFindingReviewByReviewId instead
   */
  auditFindingReviewsByReviewId: AuditFindingReviewsConnection;
  auditFindingRuleType: Scalars["String"]["output"];
  /** Reads a single `AuditFindingRuleType` that is related to this `AuditFinding`. */
  auditFindingRuleTypeByAuditFindingRuleType?: Maybe<AuditFindingRuleType>;
  auditFindingSeedType: AuditFindingSeedType;
  /** Reads and enables pagination through a set of `AuditFinding`. */
  auditFindingsByPreviousVersionId: AuditFindingsConnection;
  auditType?: Maybe<AuditTypeEnum>;
  auditorComment?: Maybe<Scalars["String"]["output"]>;
  auditorReviewed: Scalars["Boolean"]["output"];
  /** Reads a single `AuditorUser` that is related to this `AuditFinding`. */
  author?: Maybe<AuditorUser>;
  authorId?: Maybe<Scalars["UUID"]["output"]>;
  /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
  autodorFindingId?: Maybe<Scalars["UUID"]["output"]>;
  /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
  autodorFindingS3Key?: Maybe<Scalars["String"]["output"]>;
  /** RULE or AGENT — kind of automation that authored this finding. Set together with automation_source_id. Only writer is createIbLineFindingsV2. */
  automationKind?: Maybe<AutomationKindEnum>;
  /** FK to v3.automation_author.id. NULL for user-authored findings. Set together with automation_kind. Only writer is createIbLineFindingsV2. */
  automationSourceId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `BatchClaim` that is related to this `AuditFinding`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  /** Reads a single `BatchClaimLine` that is related to this `AuditFinding`. */
  batchClaimLine?: Maybe<BatchClaimLine>;
  batchClaimLineId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `BatchClaimLineItemAudit` that is related to this `AuditFinding`. */
  batchClaimLineItemAudit?: Maybe<BatchClaimLineItemAudit>;
  /**
   * Reads and enables pagination through a set of `BatchClaimLineItemAudit`.
   * @deprecated Please use batchClaimLineItemAudit instead
   */
  batchClaimLineItemAudits: BatchClaimLineItemAuditsConnection;
  confidence: Scalars["BigFloat"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  /**
   * The user or automation credited with authoring this finding —
   * same union used by Finding.createdBy. Populated live from
   * auditor_user for human-authored findings and from
   * automation_author for automation-authored findings.
   *
   * Nullable because audit_finding.author_id has ON DELETE SET NULL:
   * deleting a user's auditor_user row leaves their human-authored
   * findings with both author_id and automation_source_id null.
   * Rather than null the whole AuditFinding, resolve to null and
   * surface a resolver error at this field.
   */
  createdBy?: Maybe<FindingCreatedBy>;
  /**
   * ### Overview
   * Determines whether a finding has been explicitly declined. If a finding has not been reviewed, this will return false.
   */
  declined?: Maybe<Scalars["Boolean"]["output"]>;
  /** Soft-delete timestamp. Only writer is deleteFindingsByAutomationSource. */
  deletedAt?: Maybe<Scalars["Datetime"]["output"]>;
  /** User id who initiated the soft-delete. Set together with deleted_at. */
  deletedBy?: Maybe<Scalars["UUID"]["output"]>;
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  discrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["UUID"]["output"];
  improperPaymentCost: Scalars["Float"]["output"];
  improperPaymentReason: Scalars["String"]["output"];
  improperPaymentUnitsCharged: Scalars["Int"]["output"];
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  isOriginal?: Maybe<Scalars["Boolean"]["output"]>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  latestReview?: Maybe<ReviewedAuditFinding>;
  metaDataAocPrimaryCode?: Maybe<Scalars["String"]["output"]>;
  metaDataEmCode?: Maybe<Scalars["String"]["output"]>;
  metaDataEmCorrectLevel?: Maybe<Scalars["Int"]["output"]>;
  metaDataEmOriginalLevel?: Maybe<Scalars["Int"]["output"]>;
  metaDataNcciMueAjudicationValue?: Maybe<Scalars["Int"]["output"]>;
  metaDataNcciMueOhpMueValue?: Maybe<Scalars["Int"]["output"]>;
  metaDataNcciPtpCode?: Maybe<Scalars["String"]["output"]>;
  metaDataNcciPtpModifier?: Maybe<Scalars["Int"]["output"]>;
  metaDataPricingCorrectPrice?: Maybe<Scalars["BigFloat"]["output"]>;
  metaDataUnitsCorrectUnits?: Maybe<Scalars["Int"]["output"]>;
  needsReview: Scalars["Boolean"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Reads a single `AuditFinding` that is related to this `AuditFinding`. */
  previousVersion?: Maybe<AuditFinding>;
  previousVersionId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `ReportedFinding`. */
  reportedFindings: ReportedFindingsConnection;
  /** Reads and enables pagination through a set of `ReviewedAuditFinding`. */
  reviewedAuditFindings: ReviewedAuditFindingsConnection;
  superseded?: Maybe<Scalars["Boolean"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

export type AuditFindingauditFindingReasonCodesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReasonCodeCondition>;
  filter?: InputMaybe<AuditFindingReasonCodeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReasonCodesOrderBy>>;
};

export type AuditFindingauditFindingReviewsByOriginalIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReviewCondition>;
  filter?: InputMaybe<AuditFindingReviewFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReviewsOrderBy>>;
};

export type AuditFindingauditFindingReviewsByReviewIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReviewCondition>;
  filter?: InputMaybe<AuditFindingReviewFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReviewsOrderBy>>;
};

export type AuditFindingauditFindingsByPreviousVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingCondition>;
  filter?: InputMaybe<AuditFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingsOrderBy>>;
};

export type AuditFindingbatchClaimLineItemAuditsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemAuditCondition>;
  filter?: InputMaybe<BatchClaimLineItemAuditFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemAuditsOrderBy>>;
};

export type AuditFindingreportedFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ReportedFindingCondition>;
  filter?: InputMaybe<ReportedFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ReportedFindingsOrderBy>>;
};

export type AuditFindingreviewedAuditFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ReviewedAuditFindingCondition>;
  filter?: InputMaybe<ReviewedAuditFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ReviewedAuditFindingsOrderBy>>;
};

export type AuditFindingAggregates = {
  __typename?: "AuditFindingAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AuditFindingAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuditFindingDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AuditFindingMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AuditFindingMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AuditFindingStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AuditFindingStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AuditFindingSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AuditFindingVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AuditFindingVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AuditFinding` object types. */
export type AuditFindingAggregatesFilter = {
  /** Mean average aggregate over matching `AuditFinding` objects. */
  average?: InputMaybe<AuditFindingAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AuditFinding` objects. */
  distinctCount?: InputMaybe<AuditFindingDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AuditFinding` object to be included within the aggregate. */
  filter?: InputMaybe<AuditFindingFilter>;
  /** Maximum aggregate over matching `AuditFinding` objects. */
  max?: InputMaybe<AuditFindingMaxAggregateFilter>;
  /** Minimum aggregate over matching `AuditFinding` objects. */
  min?: InputMaybe<AuditFindingMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AuditFinding` objects. */
  stddevPopulation?: InputMaybe<AuditFindingStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AuditFinding` objects. */
  stddevSample?: InputMaybe<AuditFindingStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AuditFinding` objects. */
  sum?: InputMaybe<AuditFindingSumAggregateFilter>;
  /** Population variance aggregate over matching `AuditFinding` objects. */
  variancePopulation?: InputMaybe<AuditFindingVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AuditFinding` objects. */
  varianceSample?: InputMaybe<AuditFindingVarianceSampleAggregateFilter>;
};

/** The fields on `auditFinding` to look up the row to connect. */
export type AuditFindingAuditFindingClaimLinePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The `auditFinding` to be created by this mutation. */
export type AuditFindingAuditFindingRuleTypeFkeyAuditFindingCreateInput = {
  auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
  auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
  auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
  auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
  auditFindingSeedType: AuditFindingSeedType;
  auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
  auditType?: InputMaybe<AuditTypeEnum>;
  auditorComment?: InputMaybe<Scalars["String"]["input"]>;
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
  autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
  confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  improperPaymentCost: Scalars["Float"]["input"];
  improperPaymentReason: Scalars["String"]["input"];
  improperPaymentUnitsCharged: Scalars["Int"]["input"];
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview: Scalars["Boolean"]["input"];
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditFindingRuleType` in the `AuditFindingInput` mutation. */
export type AuditFindingAuditFindingRuleTypeFkeyInput = {
  /** The primary key(s) for `auditFindingRuleType` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingRuleTypeNodeIdConnect>;
  /** The primary key(s) for `auditFindingRuleType` for the far side of the relationship. */
  connectByType?: InputMaybe<AuditFindingRuleTypeAuditFindingRuleTypePkeyConnect>;
  /** The primary key(s) and patch data for `auditFindingRuleType` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `auditFindingRuleType` for the far side of the relationship. */
  updateByType?: InputMaybe<AuditFindingRuleTypeOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyUsingAuditFindingRuleTypePkeyUpdate>;
};

/** Input for the nested mutation of `auditFinding` in the `AuditFindingRuleTypeInput` mutation. */
export type AuditFindingAuditFindingRuleTypeFkeyInverseInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditFindingAuditFindingClaimLinePkeyConnect>>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingNodeIdConnect>>;
  /** A `AuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditFindingAuditFindingRuleTypeFkeyAuditFindingCreateInput>
  >;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyUsingAuditFindingClaimLinePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditFindingRuleTypeOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyNodeIdUpdate>
  >;
};

export type AuditFindingAverageAggregateFilter = {
  confidence?: InputMaybe<BigFloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  discrepantAmount?: InputMaybe<FloatFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<BigFloatFilter>;
  metaDataEmCorrectLevel?: InputMaybe<BigFloatFilter>;
  metaDataEmOriginalLevel?: InputMaybe<BigFloatFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<BigFloatFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<BigFloatFilter>;
  metaDataNcciPtpModifier?: InputMaybe<BigFloatFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<BigFloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<BigFloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
};

export type AuditFindingAverageAggregates = {
  __typename?: "AuditFindingAverageAggregates";
  /** Mean average of confidence across the matching connection */
  confidence?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of this field across the matching connection. */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of this field across the matching connection. */
  discrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of improperPaymentCost across the matching connection */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of improperPaymentUnitsCharged across the matching connection */
  improperPaymentUnitsCharged?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of metaDataEmCorrectLevel across the matching connection */
  metaDataEmCorrectLevel?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of metaDataEmOriginalLevel across the matching connection */
  metaDataEmOriginalLevel?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of metaDataNcciMueAjudicationValue across the matching connection */
  metaDataNcciMueAjudicationValue?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of metaDataNcciMueOhpMueValue across the matching connection */
  metaDataNcciMueOhpMueValue?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of metaDataNcciPtpModifier across the matching connection */
  metaDataNcciPtpModifier?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of metaDataPricingCorrectPrice across the matching connection */
  metaDataPricingCorrectPrice?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of metaDataUnitsCorrectUnits across the matching connection */
  metaDataUnitsCorrectUnits?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of this field across the matching connection. */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
};

/** The `auditFinding` to be created by this mutation. */
export type AuditFindingClaimLineAuditFindingJobIdFkeyAuditFindingCreateInput =
  {
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType: AuditFindingSeedType;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id: Scalars["UUID"]["input"];
    improperPaymentCost: Scalars["Float"]["input"];
    improperPaymentReason: Scalars["String"]["input"];
    improperPaymentUnitsCharged: Scalars["Int"]["input"];
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview: Scalars["Boolean"]["input"];
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `auditFindingJob` in the `AuditFindingInput` mutation. */
export type AuditFindingClaimLineAuditFindingJobIdFkeyInput = {
  /** The primary key(s) for `auditFindingJob` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingJobAuditFindingJobPkeyConnect>;
  /** The primary key(s) for `auditFindingJob` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingJobNodeIdConnect>;
  /** The primary key(s) and patch data for `auditFindingJob` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingJobOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyUsingAuditFindingJobPkeyUpdate>;
  /** The primary key(s) and patch data for `auditFindingJob` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFinding` in the `AuditFindingJobInput` mutation. */
export type AuditFindingClaimLineAuditFindingJobIdFkeyInverseInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditFindingAuditFindingClaimLinePkeyConnect>>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingNodeIdConnect>>;
  /** A `AuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditFindingClaimLineAuditFindingJobIdFkeyAuditFindingCreateInput>
  >;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyUsingAuditFindingClaimLinePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditFindingJobOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyNodeIdUpdate>
  >;
};

/** The `auditFinding` to be created by this mutation. */
export type AuditFindingClaimLineAuthorIdFkeyAuditFindingCreateInput = {
  auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
  auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
  auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
  auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
  auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
  auditFindingSeedType: AuditFindingSeedType;
  auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
  auditType?: InputMaybe<AuditTypeEnum>;
  auditorComment?: InputMaybe<Scalars["String"]["input"]>;
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
  /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
  autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
  confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  improperPaymentCost: Scalars["Float"]["input"];
  improperPaymentReason: Scalars["String"]["input"];
  improperPaymentUnitsCharged: Scalars["Int"]["input"];
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview: Scalars["Boolean"]["input"];
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `AuditFindingInput` mutation. */
export type AuditFindingClaimLineAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFinding` in the `AuditorUserInput` mutation. */
export type AuditFindingClaimLineAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditFindingAuditFindingClaimLinePkeyConnect>>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingNodeIdConnect>>;
  /** A `AuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditFindingClaimLineAuthorIdFkeyAuditFindingCreateInput>
  >;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyUsingAuditFindingClaimLinePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyNodeIdUpdate>
  >;
};

/** The `auditFinding` to be created by this mutation. */
export type AuditFindingClaimLineBatchClaimIdFkeyAuditFindingCreateInput = {
  auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
  auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
  auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
  auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
  auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
  auditFindingSeedType: AuditFindingSeedType;
  auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
  auditType?: InputMaybe<AuditTypeEnum>;
  auditorComment?: InputMaybe<Scalars["String"]["input"]>;
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
  autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
  confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  improperPaymentCost: Scalars["Float"]["input"];
  improperPaymentReason: Scalars["String"]["input"];
  improperPaymentUnitsCharged: Scalars["Int"]["input"];
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview: Scalars["Boolean"]["input"];
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `batchClaim` in the `AuditFindingInput` mutation. */
export type AuditFindingClaimLineBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFinding` in the `BatchClaimInput` mutation. */
export type AuditFindingClaimLineBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditFindingAuditFindingClaimLinePkeyConnect>>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingNodeIdConnect>>;
  /** A `AuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditFindingClaimLineBatchClaimIdFkeyAuditFindingCreateInput>
  >;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyUsingAuditFindingClaimLinePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/** The `auditFinding` to be created by this mutation. */
export type AuditFindingClaimLineBatchClaimLineIdFkeyAuditFindingCreateInput = {
  auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
  auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
  auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
  auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
  auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
  auditFindingSeedType: AuditFindingSeedType;
  auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
  auditType?: InputMaybe<AuditTypeEnum>;
  auditorComment?: InputMaybe<Scalars["String"]["input"]>;
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
  autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
  confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  improperPaymentCost: Scalars["Float"]["input"];
  improperPaymentReason: Scalars["String"]["input"];
  improperPaymentUnitsCharged: Scalars["Int"]["input"];
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview: Scalars["Boolean"]["input"];
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `batchClaimLine` in the `AuditFindingInput` mutation. */
export type AuditFindingClaimLineBatchClaimLineIdFkeyInput = {
  /** The primary key(s) for `batchClaimLine` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimLineBatchClaimLinePkeyConnect>;
  /** The primary key(s) for `batchClaimLine` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimLineNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaimLine` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimLineOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyUsingBatchClaimLinePkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimLine` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFinding` in the `BatchClaimLineInput` mutation. */
export type AuditFindingClaimLineBatchClaimLineIdFkeyInverseInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditFindingAuditFindingClaimLinePkeyConnect>>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingNodeIdConnect>>;
  /** A `AuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditFindingClaimLineBatchClaimLineIdFkeyAuditFindingCreateInput>
  >;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyUsingAuditFindingClaimLinePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimLineOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyNodeIdUpdate>
  >;
};

/** The `auditFinding` to be created by this mutation. */
export type AuditFindingClaimLinePreviousVersionIdFkeyAuditFindingCreateInput =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType: AuditFindingSeedType;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id: Scalars["UUID"]["input"];
    improperPaymentCost: Scalars["Float"]["input"];
    improperPaymentReason: Scalars["String"]["input"];
    improperPaymentUnitsCharged: Scalars["Int"]["input"];
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview: Scalars["Boolean"]["input"];
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `auditFinding` in the `AuditFindingInput` mutation. */
export type AuditFindingClaimLinePreviousVersionIdFkeyInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingAuditFindingClaimLinePkeyConnect>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingNodeIdConnect>;
  /** A `AuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyAuditFindingCreateInput>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingOnAuditFindingForAuditFindingClaimLinePreviousVersionIdFkeyUsingAuditFindingClaimLinePkeyUpdate>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingOnAuditFindingForAuditFindingClaimLinePreviousVersionIdFkeyNodeIdUpdate>;
};

export enum AuditFindingClaimStatus {
  CLOSED = "CLOSED",
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  DOCUMENTATION_REQUESTED = "DOCUMENTATION_REQUESTED",
  DOCUMENTATION_REQUEST_COMPLETE = "DOCUMENTATION_REQUEST_COMPLETE",
  DOCUMENTATION_TO_REQUEST = "DOCUMENTATION_TO_REQUEST",
  IN_PROGRESS = "IN_PROGRESS",
}

/** A filter to be used against AuditFindingClaimStatus fields. All fields are combined with a logical ‘and.’ */
export type AuditFindingClaimStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AuditFindingClaimStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AuditFindingClaimStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AuditFindingClaimStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AuditFindingClaimStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AuditFindingClaimStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AuditFindingClaimStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AuditFindingClaimStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AuditFindingClaimStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AuditFindingClaimStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AuditFindingClaimStatus>>;
};

/**
 * A condition to be used against `AuditFinding` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuditFindingCondition = {
  /** Checks for equality with the object’s `auditFindingJobId` field. */
  auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `auditFindingRuleType` field. */
  auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `auditFindingSeedType` field. */
  auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
  /** Checks for equality with the object’s `auditType` field. */
  auditType?: InputMaybe<AuditTypeEnum>;
  /** Checks for equality with the object’s `auditorComment` field. */
  auditorComment?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `auditorReviewed` field. */
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `autodorFindingId` field. */
  autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `autodorFindingS3Key` field. */
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `automationKind` field. */
  automationKind?: InputMaybe<AutomationKindEnum>;
  /** Checks for equality with the object’s `automationSourceId` field. */
  automationSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimLineId` field. */
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `confidence` field. */
  confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `deletedBy` field. */
  deletedBy?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `improperPaymentCost` field. */
  improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `improperPaymentReason` field. */
  improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `improperPaymentUnitsCharged` field. */
  improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `metaDataAocPrimaryCode` field. */
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `metaDataEmCode` field. */
  metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `metaDataEmCorrectLevel` field. */
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `metaDataEmOriginalLevel` field. */
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `metaDataNcciMueAjudicationValue` field. */
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `metaDataNcciMueOhpMueValue` field. */
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `metaDataNcciPtpCode` field. */
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `metaDataNcciPtpModifier` field. */
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `metaDataPricingCorrectPrice` field. */
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Checks for equality with the object’s `metaDataUnitsCorrectUnits` field. */
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `needsReview` field. */
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `previousVersionId` field. */
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type AuditFindingDistinctCountAggregateFilter = {
  accepted?: InputMaybe<BooleanFilter>;
  auditFindingJobId?: InputMaybe<BigIntFilter>;
  auditFindingRuleType?: InputMaybe<BigIntFilter>;
  auditFindingSeedType?: InputMaybe<BigIntFilter>;
  auditType?: InputMaybe<BigIntFilter>;
  auditorComment?: InputMaybe<BigIntFilter>;
  auditorReviewed?: InputMaybe<BigIntFilter>;
  authorId?: InputMaybe<BigIntFilter>;
  autodorFindingId?: InputMaybe<BigIntFilter>;
  autodorFindingS3Key?: InputMaybe<BigIntFilter>;
  automationKind?: InputMaybe<BigIntFilter>;
  automationSourceId?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  batchClaimLineId?: InputMaybe<BigIntFilter>;
  confidence?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  declined?: InputMaybe<BooleanFilter>;
  deletedAt?: InputMaybe<BigIntFilter>;
  deletedBy?: InputMaybe<BigIntFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  discrepantAmount?: InputMaybe<FloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  improperPaymentCost?: InputMaybe<BigIntFilter>;
  improperPaymentReason?: InputMaybe<BigIntFilter>;
  improperPaymentUnitsCharged?: InputMaybe<BigIntFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  isOriginal?: InputMaybe<BooleanFilter>;
  isValid?: InputMaybe<BooleanFilter>;
  metaDataAocPrimaryCode?: InputMaybe<BigIntFilter>;
  metaDataEmCode?: InputMaybe<BigIntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<BigIntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<BigIntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<BigIntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<BigIntFilter>;
  metaDataNcciPtpCode?: InputMaybe<BigIntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<BigIntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<BigIntFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<BigIntFilter>;
  needsReview?: InputMaybe<BigIntFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
  previousVersionId?: InputMaybe<BigIntFilter>;
  superseded?: InputMaybe<BooleanFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type AuditFindingDistinctCountAggregates = {
  __typename?: "AuditFindingDistinctCountAggregates";
  /** Distinct count of this field across the matching connection. */
  accepted?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditFindingJobId across the matching connection */
  auditFindingJobId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditFindingRuleType across the matching connection */
  auditFindingRuleType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditFindingSeedType across the matching connection */
  auditFindingSeedType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditType across the matching connection */
  auditType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditorComment across the matching connection */
  auditorComment?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditorReviewed across the matching connection */
  auditorReviewed?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of autodorFindingId across the matching connection */
  autodorFindingId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of autodorFindingS3Key across the matching connection */
  autodorFindingS3Key?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of automationKind across the matching connection */
  automationKind?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of automationSourceId across the matching connection */
  automationSourceId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimLineId across the matching connection */
  batchClaimLineId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of confidence across the matching connection */
  confidence?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Determines whether a finding has been explicitly declined. If a finding has not been reviewed, this will return false.
   */
  declined?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of deletedAt across the matching connection */
  deletedAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of deletedBy across the matching connection */
  deletedBy?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  determinedClientSavings?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  discrepantAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of improperPaymentCost across the matching connection */
  improperPaymentCost?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of improperPaymentReason across the matching connection */
  improperPaymentReason?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of improperPaymentUnitsCharged across the matching connection */
  improperPaymentUnitsCharged?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  isActive?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  isOriginal?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  isValid?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  latestReview?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of metaDataAocPrimaryCode across the matching connection */
  metaDataAocPrimaryCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of metaDataEmCode across the matching connection */
  metaDataEmCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of metaDataEmCorrectLevel across the matching connection */
  metaDataEmCorrectLevel?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of metaDataEmOriginalLevel across the matching connection */
  metaDataEmOriginalLevel?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of metaDataNcciMueAjudicationValue across the matching connection */
  metaDataNcciMueAjudicationValue?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of metaDataNcciMueOhpMueValue across the matching connection */
  metaDataNcciMueOhpMueValue?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of metaDataNcciPtpCode across the matching connection */
  metaDataNcciPtpCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of metaDataNcciPtpModifier across the matching connection */
  metaDataNcciPtpModifier?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of metaDataPricingCorrectPrice across the matching connection */
  metaDataPricingCorrectPrice?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of metaDataUnitsCorrectUnits across the matching connection */
  metaDataUnitsCorrectUnits?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of needsReview across the matching connection */
  needsReview?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  potentialClientSavings?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of previousVersionId across the matching connection */
  previousVersionId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  superseded?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `AuditFinding` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingFilter = {
  /** Filter by the object’s `accepted` field. */
  accepted?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditFindingFilter>>;
  /** Filter by the object’s `auditFindingJob` relation. */
  auditFindingJob?: InputMaybe<AuditFindingJobFilter>;
  /** A related `auditFindingJob` exists. */
  auditFindingJobExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `auditFindingJobId` field. */
  auditFindingJobId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `auditFindingReasonCodes` relation. */
  auditFindingReasonCodes?: InputMaybe<AuditFindingToManyAuditFindingReasonCodeFilter>;
  /** Some related `auditFindingReasonCodes` exist. */
  auditFindingReasonCodesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `auditFindingReviewByReviewId` relation. */
  auditFindingReviewByReviewId?: InputMaybe<AuditFindingReviewFilter>;
  /** A related `auditFindingReviewByReviewId` exists. */
  auditFindingReviewByReviewIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `auditFindingReviewsByOriginalId` relation. */
  auditFindingReviewsByOriginalId?: InputMaybe<AuditFindingToManyAuditFindingReviewFilter>;
  /** Some related `auditFindingReviewsByOriginalId` exist. */
  auditFindingReviewsByOriginalIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `auditFindingRuleType` field. */
  auditFindingRuleType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `auditFindingRuleTypeByAuditFindingRuleType` relation. */
  auditFindingRuleTypeByAuditFindingRuleType?: InputMaybe<AuditFindingRuleTypeFilter>;
  /** Filter by the object’s `auditFindingSeedType` field. */
  auditFindingSeedType?: InputMaybe<AuditFindingSeedTypeFilter>;
  /** Filter by the object’s `auditFindingsByPreviousVersionId` relation. */
  auditFindingsByPreviousVersionId?: InputMaybe<AuditFindingToManyAuditFindingFilter>;
  /** Some related `auditFindingsByPreviousVersionId` exist. */
  auditFindingsByPreviousVersionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `auditType` field. */
  auditType?: InputMaybe<AuditTypeEnumFilter>;
  /** Filter by the object’s `auditorComment` field. */
  auditorComment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `auditorReviewed` field. */
  auditorReviewed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** A related `author` exists. */
  authorExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `autodorFindingId` field. */
  autodorFindingId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `autodorFindingS3Key` field. */
  autodorFindingS3Key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `automationKind` field. */
  automationKind?: InputMaybe<AutomationKindEnumFilter>;
  /** Filter by the object’s `automationSourceId` field. */
  automationSourceId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaimLine` relation. */
  batchClaimLine?: InputMaybe<BatchClaimLineFilter>;
  /** A related `batchClaimLine` exists. */
  batchClaimLineExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimLineId` field. */
  batchClaimLineId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaimLineItemAudit` relation. */
  batchClaimLineItemAudit?: InputMaybe<BatchClaimLineItemAuditFilter>;
  /** A related `batchClaimLineItemAudit` exists. */
  batchClaimLineItemAuditExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `confidence` field. */
  confidence?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `declined` field. */
  declined?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedBy` field. */
  deletedBy?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `determinedClientSavings` field. */
  determinedClientSavings?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `discrepantAmount` field. */
  discrepantAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `improperPaymentCost` field. */
  improperPaymentCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `improperPaymentReason` field. */
  improperPaymentReason?: InputMaybe<StringFilter>;
  /** Filter by the object’s `improperPaymentUnitsCharged` field. */
  improperPaymentUnitsCharged?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isOriginal` field. */
  isOriginal?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isValid` field. */
  isValid?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `metaDataAocPrimaryCode` field. */
  metaDataAocPrimaryCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metaDataEmCode` field. */
  metaDataEmCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metaDataEmCorrectLevel` field. */
  metaDataEmCorrectLevel?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metaDataEmOriginalLevel` field. */
  metaDataEmOriginalLevel?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metaDataNcciMueAjudicationValue` field. */
  metaDataNcciMueAjudicationValue?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metaDataNcciMueOhpMueValue` field. */
  metaDataNcciMueOhpMueValue?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metaDataNcciPtpCode` field. */
  metaDataNcciPtpCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metaDataNcciPtpModifier` field. */
  metaDataNcciPtpModifier?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metaDataPricingCorrectPrice` field. */
  metaDataPricingCorrectPrice?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `metaDataUnitsCorrectUnits` field. */
  metaDataUnitsCorrectUnits?: InputMaybe<IntFilter>;
  /** Filter by the object’s `needsReview` field. */
  needsReview?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditFindingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditFindingFilter>>;
  /** Filter by the object’s `potentialClientSavings` field. */
  potentialClientSavings?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `previousVersion` relation. */
  previousVersion?: InputMaybe<AuditFindingFilter>;
  /** A related `previousVersion` exists. */
  previousVersionExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `previousVersionId` field. */
  previousVersionId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `reportedFindings` relation. */
  reportedFindings?: InputMaybe<AuditFindingToManyReportedFindingFilter>;
  /** Some related `reportedFindings` exist. */
  reportedFindingsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `reviewedAuditFindings` relation. */
  reviewedAuditFindings?: InputMaybe<AuditFindingToManyReviewedAuditFindingFilter>;
  /** Some related `reviewedAuditFindings` exist. */
  reviewedAuditFindingsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `superseded` field. */
  superseded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `AuditFinding` for usage during aggregation. */
export enum AuditFindingGroupBy {
  AUDITOR_COMMENT = "AUDITOR_COMMENT",
  AUDITOR_REVIEWED = "AUDITOR_REVIEWED",
  AUDIT_FINDING_JOB_ID = "AUDIT_FINDING_JOB_ID",
  AUDIT_FINDING_RULE_TYPE = "AUDIT_FINDING_RULE_TYPE",
  AUDIT_FINDING_SEED_TYPE = "AUDIT_FINDING_SEED_TYPE",
  AUDIT_TYPE = "AUDIT_TYPE",
  AUTHOR_ID = "AUTHOR_ID",
  AUTODOR_FINDING_ID = "AUTODOR_FINDING_ID",
  AUTODOR_FINDING_S3_KEY = "AUTODOR_FINDING_S3_KEY",
  AUTOMATION_KIND = "AUTOMATION_KIND",
  AUTOMATION_SOURCE_ID = "AUTOMATION_SOURCE_ID",
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  BATCH_CLAIM_LINE_ID = "BATCH_CLAIM_LINE_ID",
  CONFIDENCE = "CONFIDENCE",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DELETED_AT = "DELETED_AT",
  DELETED_AT_TRUNCATED_TO_DAY = "DELETED_AT_TRUNCATED_TO_DAY",
  DELETED_AT_TRUNCATED_TO_HOUR = "DELETED_AT_TRUNCATED_TO_HOUR",
  DELETED_BY = "DELETED_BY",
  IMPROPER_PAYMENT_COST = "IMPROPER_PAYMENT_COST",
  IMPROPER_PAYMENT_REASON = "IMPROPER_PAYMENT_REASON",
  IMPROPER_PAYMENT_UNITS_CHARGED = "IMPROPER_PAYMENT_UNITS_CHARGED",
  META_DATA_AOC_PRIMARY_CODE = "META_DATA_AOC_PRIMARY_CODE",
  META_DATA_EM_CODE = "META_DATA_EM_CODE",
  META_DATA_EM_CORRECT_LEVEL = "META_DATA_EM_CORRECT_LEVEL",
  META_DATA_EM_ORIGINAL_LEVEL = "META_DATA_EM_ORIGINAL_LEVEL",
  META_DATA_NCCI_MUE_AJUDICATION_VALUE = "META_DATA_NCCI_MUE_AJUDICATION_VALUE",
  META_DATA_NCCI_MUE_OHP_MUE_VALUE = "META_DATA_NCCI_MUE_OHP_MUE_VALUE",
  META_DATA_NCCI_PTP_CODE = "META_DATA_NCCI_PTP_CODE",
  META_DATA_NCCI_PTP_MODIFIER = "META_DATA_NCCI_PTP_MODIFIER",
  META_DATA_PRICING_CORRECT_PRICE = "META_DATA_PRICING_CORRECT_PRICE",
  META_DATA_UNITS_CORRECT_UNITS = "META_DATA_UNITS_CORRECT_UNITS",
  NEEDS_REVIEW = "NEEDS_REVIEW",
  PREVIOUS_VERSION_ID = "PREVIOUS_VERSION_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type AuditFindingHavingAverageAuditFindingDeterminedClientSavingsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingAverageAuditFindingDiscrepantAmountInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingAverageAuditFindingPotentialClientSavingsInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingAverageInput = {
  confidence?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  determinedClientSavings?: InputMaybe<AuditFindingHavingAverageAuditFindingDeterminedClientSavingsInput>;
  discrepantAmount?: InputMaybe<AuditFindingHavingAverageAuditFindingDiscrepantAmountInput>;
  improperPaymentCost?: InputMaybe<HavingFloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<HavingIntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<HavingIntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<HavingIntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<HavingBigfloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<HavingIntFilter>;
  potentialClientSavings?: InputMaybe<AuditFindingHavingAverageAuditFindingPotentialClientSavingsInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingHavingDistinctCountAuditFindingDeterminedClientSavingsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingDistinctCountAuditFindingDiscrepantAmountInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingDistinctCountAuditFindingPotentialClientSavingsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingDistinctCountInput = {
  confidence?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  determinedClientSavings?: InputMaybe<AuditFindingHavingDistinctCountAuditFindingDeterminedClientSavingsInput>;
  discrepantAmount?: InputMaybe<AuditFindingHavingDistinctCountAuditFindingDiscrepantAmountInput>;
  improperPaymentCost?: InputMaybe<HavingFloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<HavingIntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<HavingIntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<HavingIntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<HavingBigfloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<HavingIntFilter>;
  potentialClientSavings?: InputMaybe<AuditFindingHavingDistinctCountAuditFindingPotentialClientSavingsInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AuditFinding` aggregates. */
export type AuditFindingHavingInput = {
  AND?: InputMaybe<Array<AuditFindingHavingInput>>;
  OR?: InputMaybe<Array<AuditFindingHavingInput>>;
  average?: InputMaybe<AuditFindingHavingAverageInput>;
  distinctCount?: InputMaybe<AuditFindingHavingDistinctCountInput>;
  max?: InputMaybe<AuditFindingHavingMaxInput>;
  min?: InputMaybe<AuditFindingHavingMinInput>;
  stddevPopulation?: InputMaybe<AuditFindingHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuditFindingHavingStddevSampleInput>;
  sum?: InputMaybe<AuditFindingHavingSumInput>;
  variancePopulation?: InputMaybe<AuditFindingHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuditFindingHavingVarianceSampleInput>;
};

export type AuditFindingHavingMaxAuditFindingDeterminedClientSavingsInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingMaxAuditFindingDiscrepantAmountInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingMaxAuditFindingPotentialClientSavingsInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingMaxInput = {
  confidence?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  determinedClientSavings?: InputMaybe<AuditFindingHavingMaxAuditFindingDeterminedClientSavingsInput>;
  discrepantAmount?: InputMaybe<AuditFindingHavingMaxAuditFindingDiscrepantAmountInput>;
  improperPaymentCost?: InputMaybe<HavingFloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<HavingIntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<HavingIntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<HavingIntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<HavingBigfloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<HavingIntFilter>;
  potentialClientSavings?: InputMaybe<AuditFindingHavingMaxAuditFindingPotentialClientSavingsInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingHavingMinAuditFindingDeterminedClientSavingsInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingMinAuditFindingDiscrepantAmountInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingMinAuditFindingPotentialClientSavingsInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingMinInput = {
  confidence?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  determinedClientSavings?: InputMaybe<AuditFindingHavingMinAuditFindingDeterminedClientSavingsInput>;
  discrepantAmount?: InputMaybe<AuditFindingHavingMinAuditFindingDiscrepantAmountInput>;
  improperPaymentCost?: InputMaybe<HavingFloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<HavingIntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<HavingIntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<HavingIntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<HavingBigfloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<HavingIntFilter>;
  potentialClientSavings?: InputMaybe<AuditFindingHavingMinAuditFindingPotentialClientSavingsInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingHavingStddevPopulationAuditFindingDeterminedClientSavingsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingStddevPopulationAuditFindingDiscrepantAmountInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingStddevPopulationAuditFindingPotentialClientSavingsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingStddevPopulationInput = {
  confidence?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  determinedClientSavings?: InputMaybe<AuditFindingHavingStddevPopulationAuditFindingDeterminedClientSavingsInput>;
  discrepantAmount?: InputMaybe<AuditFindingHavingStddevPopulationAuditFindingDiscrepantAmountInput>;
  improperPaymentCost?: InputMaybe<HavingFloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<HavingIntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<HavingIntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<HavingIntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<HavingBigfloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<HavingIntFilter>;
  potentialClientSavings?: InputMaybe<AuditFindingHavingStddevPopulationAuditFindingPotentialClientSavingsInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingHavingStddevSampleAuditFindingDeterminedClientSavingsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingStddevSampleAuditFindingDiscrepantAmountInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingStddevSampleAuditFindingPotentialClientSavingsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingStddevSampleInput = {
  confidence?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  determinedClientSavings?: InputMaybe<AuditFindingHavingStddevSampleAuditFindingDeterminedClientSavingsInput>;
  discrepantAmount?: InputMaybe<AuditFindingHavingStddevSampleAuditFindingDiscrepantAmountInput>;
  improperPaymentCost?: InputMaybe<HavingFloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<HavingIntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<HavingIntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<HavingIntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<HavingBigfloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<HavingIntFilter>;
  potentialClientSavings?: InputMaybe<AuditFindingHavingStddevSampleAuditFindingPotentialClientSavingsInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingHavingSumAuditFindingDeterminedClientSavingsInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingSumAuditFindingDiscrepantAmountInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingSumAuditFindingPotentialClientSavingsInput = {
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditFindingHavingSumInput = {
  confidence?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  determinedClientSavings?: InputMaybe<AuditFindingHavingSumAuditFindingDeterminedClientSavingsInput>;
  discrepantAmount?: InputMaybe<AuditFindingHavingSumAuditFindingDiscrepantAmountInput>;
  improperPaymentCost?: InputMaybe<HavingFloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<HavingIntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<HavingIntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<HavingIntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<HavingBigfloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<HavingIntFilter>;
  potentialClientSavings?: InputMaybe<AuditFindingHavingSumAuditFindingPotentialClientSavingsInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingHavingVariancePopulationAuditFindingDeterminedClientSavingsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingVariancePopulationAuditFindingDiscrepantAmountInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingVariancePopulationAuditFindingPotentialClientSavingsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingVariancePopulationInput = {
  confidence?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  determinedClientSavings?: InputMaybe<AuditFindingHavingVariancePopulationAuditFindingDeterminedClientSavingsInput>;
  discrepantAmount?: InputMaybe<AuditFindingHavingVariancePopulationAuditFindingDiscrepantAmountInput>;
  improperPaymentCost?: InputMaybe<HavingFloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<HavingIntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<HavingIntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<HavingIntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<HavingBigfloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<HavingIntFilter>;
  potentialClientSavings?: InputMaybe<AuditFindingHavingVariancePopulationAuditFindingPotentialClientSavingsInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingHavingVarianceSampleAuditFindingDeterminedClientSavingsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingVarianceSampleAuditFindingDiscrepantAmountInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingVarianceSampleAuditFindingPotentialClientSavingsInput =
  {
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditFindingHavingVarianceSampleInput = {
  confidence?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  deletedAt?: InputMaybe<HavingDatetimeFilter>;
  determinedClientSavings?: InputMaybe<AuditFindingHavingVarianceSampleAuditFindingDeterminedClientSavingsInput>;
  discrepantAmount?: InputMaybe<AuditFindingHavingVarianceSampleAuditFindingDiscrepantAmountInput>;
  improperPaymentCost?: InputMaybe<HavingFloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<HavingIntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<HavingIntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<HavingIntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<HavingIntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<HavingBigfloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<HavingIntFilter>;
  potentialClientSavings?: InputMaybe<AuditFindingHavingVarianceSampleAuditFindingPotentialClientSavingsInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `AuditFinding` */
export type AuditFindingInput = {
  auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
  auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
  auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
  auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
  auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
  auditFindingSeedType: AuditFindingSeedType;
  auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
  auditType?: InputMaybe<AuditTypeEnum>;
  auditorComment?: InputMaybe<Scalars["String"]["input"]>;
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
  autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
  confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  improperPaymentCost: Scalars["Float"]["input"];
  improperPaymentReason: Scalars["String"]["input"];
  improperPaymentUnitsCharged: Scalars["Int"]["input"];
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview: Scalars["Boolean"]["input"];
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type AuditFindingJob = Node & {
  __typename?: "AuditFindingJob";
  /** Reads and enables pagination through a set of `AuditFinding`. */
  auditFindings: AuditFindingsConnection;
  /** Reads a single `AuditorUser` that is related to this `AuditFindingJob`. */
  author?: Maybe<AuditorUser>;
  authorId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `BatchFile` that is related to this `AuditFindingJob`. */
  batchFile?: Maybe<BatchFile>;
  batchFileId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type AuditFindingJobauditFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingCondition>;
  filter?: InputMaybe<AuditFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingsOrderBy>>;
};

export type AuditFindingJobAggregates = {
  __typename?: "AuditFindingJobAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuditFindingJobDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `AuditFindingJob` object types. */
export type AuditFindingJobAggregatesFilter = {
  /** Distinct count aggregate over matching `AuditFindingJob` objects. */
  distinctCount?: InputMaybe<AuditFindingJobDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AuditFindingJob` object to be included within the aggregate. */
  filter?: InputMaybe<AuditFindingJobFilter>;
};

/** The fields on `auditFindingJob` to look up the row to connect. */
export type AuditFindingJobAuditFindingJobPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `auditorUser` in the `AuditFindingJobInput` mutation. */
export type AuditFindingJobAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingJobOnAuditFindingJobForAuditFindingJobAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingJob` in the `AuditorUserInput` mutation. */
export type AuditFindingJobAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingJob` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditFindingJobAuditFindingJobPkeyConnect>>;
  /** The primary key(s) for `auditFindingJob` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingJobNodeIdConnect>>;
  /** The primary key(s) and patch data for `auditFindingJob` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingJobOnAuditFindingJobForAuditFindingJobAuthorIdFkeyUsingAuditFindingJobPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingJob` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyNodeIdUpdate>
  >;
};

/** Input for the nested mutation of `batchFile` in the `AuditFindingJobInput` mutation. */
export type AuditFindingJobBatchFileIdFkeyInput = {
  /** The primary key(s) for `batchFile` for the far side of the relationship. */
  connectById?: InputMaybe<BatchFileBatchFilePkeyConnect>;
  /** The primary key(s) for `batchFile` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchFileNodeIdConnect>;
  /** The primary key(s) and patch data for `batchFile` for the far side of the relationship. */
  updateById?: InputMaybe<BatchFileOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyUsingBatchFilePkeyUpdate>;
  /** The primary key(s) and patch data for `batchFile` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingJobOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingJob` in the `BatchFileInput` mutation. */
export type AuditFindingJobBatchFileIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingJob` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditFindingJobAuditFindingJobPkeyConnect>>;
  /** The primary key(s) for `auditFindingJob` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingJobNodeIdConnect>>;
  /** The primary key(s) and patch data for `auditFindingJob` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingJobOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyUsingAuditFindingJobPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingJob` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchFileOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `AuditFindingJob` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuditFindingJobCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchFileId` field. */
  batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type AuditFindingJobDistinctCountAggregateFilter = {
  authorId?: InputMaybe<BigIntFilter>;
  batchFileId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type AuditFindingJobDistinctCountAggregates = {
  __typename?: "AuditFindingJobDistinctCountAggregates";
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchFileId across the matching connection */
  batchFileId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `AuditFindingJob` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingJobFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditFindingJobFilter>>;
  /** Filter by the object’s `auditFindings` relation. */
  auditFindings?: InputMaybe<AuditFindingJobToManyAuditFindingFilter>;
  /** Some related `auditFindings` exist. */
  auditFindingsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** A related `author` exists. */
  authorExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchFile` relation. */
  batchFile?: InputMaybe<BatchFileFilter>;
  /** Filter by the object’s `batchFileId` field. */
  batchFileId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditFindingJobFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditFindingJobFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `AuditFindingJob` for usage during aggregation. */
export enum AuditFindingJobGroupBy {
  AUTHOR_ID = "AUTHOR_ID",
  BATCH_FILE_ID = "BATCH_FILE_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type AuditFindingJobHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingJobHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AuditFindingJob` aggregates. */
export type AuditFindingJobHavingInput = {
  AND?: InputMaybe<Array<AuditFindingJobHavingInput>>;
  OR?: InputMaybe<Array<AuditFindingJobHavingInput>>;
  average?: InputMaybe<AuditFindingJobHavingAverageInput>;
  distinctCount?: InputMaybe<AuditFindingJobHavingDistinctCountInput>;
  max?: InputMaybe<AuditFindingJobHavingMaxInput>;
  min?: InputMaybe<AuditFindingJobHavingMinInput>;
  stddevPopulation?: InputMaybe<AuditFindingJobHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuditFindingJobHavingStddevSampleInput>;
  sum?: InputMaybe<AuditFindingJobHavingSumInput>;
  variancePopulation?: InputMaybe<AuditFindingJobHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuditFindingJobHavingVarianceSampleInput>;
};

export type AuditFindingJobHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingJobHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingJobHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingJobHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingJobHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingJobHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingJobHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AuditFindingJobNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `auditFindingJob` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingJobOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `auditFindingJob` to look up the row to update. */
export type AuditFindingJobOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyUsingAuditFindingJobPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingJob` being updated. */
    patch: updateAuditFindingJobOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingJobOnAuditFindingJobForAuditFindingJobAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `auditFindingJob` to look up the row to update. */
export type AuditFindingJobOnAuditFindingJobForAuditFindingJobAuthorIdFkeyUsingAuditFindingJobPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingJob` being updated. */
    patch: updateAuditFindingJobOnAuditFindingJobForAuditFindingJobAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingJobOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchFile` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchFile` being updated. */
    patch: BatchFilePatch;
  };

/** The fields on `auditFindingJob` to look up the row to update. */
export type AuditFindingJobOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyUsingAuditFindingJobPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingJob` being updated. */
    patch: updateAuditFindingJobOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyPatch;
  };

/** Represents an update to a `AuditFindingJob`. Fields that are set will be updated. */
export type AuditFindingJobPatch = {
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingJobAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchFileToBatchFileId?: InputMaybe<AuditFindingJobBatchFileIdFkeyInput>;
};

/** A filter to be used against many `AuditFinding` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingJobToManyAuditFindingFilter = {
  /** Aggregates across related `AuditFinding` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingAggregatesFilter>;
  /** Every related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingFilter>;
  /** No related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingFilter>;
  /** Some related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingFilter>;
};

/** A connection to a list of `AuditFindingJob` values. */
export type AuditFindingJobsConnection = {
  __typename?: "AuditFindingJobsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuditFindingJobAggregates>;
  /** A list of edges which contains the `AuditFindingJob` and cursor to aid in pagination. */
  edges: Array<AuditFindingJobsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuditFindingJobAggregates>>;
  /** A list of `AuditFindingJob` objects. */
  nodes: Array<Maybe<AuditFindingJob>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditFindingJob` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `AuditFindingJob` values. */
export type AuditFindingJobsConnectiongroupedAggregatesArgs = {
  groupBy: Array<AuditFindingJobGroupBy>;
  having?: InputMaybe<AuditFindingJobHavingInput>;
};

/** A `AuditFindingJob` edge in the connection. */
export type AuditFindingJobsEdge = {
  __typename?: "AuditFindingJobsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuditFindingJob` at the end of the edge. */
  node?: Maybe<AuditFindingJob>;
};

/** Methods to use when ordering `AuditFindingJob`. */
export enum AuditFindingJobsOrderBy {
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_CONFIDENCE_ASC = "AUDIT_FINDINGS_AVERAGE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_AVERAGE_CONFIDENCE_DESC = "AUDIT_FINDINGS_AVERAGE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDINGS_AVERAGE_DELETED_AT_ASC = "AUDIT_FINDINGS_AVERAGE_DELETED_AT_ASC",
  AUDIT_FINDINGS_AVERAGE_DELETED_AT_DESC = "AUDIT_FINDINGS_AVERAGE_DELETED_AT_DESC",
  AUDIT_FINDINGS_AVERAGE_DELETED_BY_ASC = "AUDIT_FINDINGS_AVERAGE_DELETED_BY_ASC",
  AUDIT_FINDINGS_AVERAGE_DELETED_BY_DESC = "AUDIT_FINDINGS_AVERAGE_DELETED_BY_DESC",
  AUDIT_FINDINGS_AVERAGE_ID_ASC = "AUDIT_FINDINGS_AVERAGE_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_ID_DESC = "AUDIT_FINDINGS_AVERAGE_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_JOB_ID__COUNT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_JOB_ID__COUNT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_JOB_ID__COUNT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_JOB_ID__COUNT_DESC",
  AUDIT_FINDINGS_COUNT_ASC = "AUDIT_FINDINGS_COUNT_ASC",
  AUDIT_FINDINGS_COUNT_DESC = "AUDIT_FINDINGS_COUNT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_MAX_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_MAX_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC = "AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC = "AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_MAX_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_MAX_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_MAX_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_MAX_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_MAX_CONFIDENCE_ASC = "AUDIT_FINDINGS_MAX_CONFIDENCE_ASC",
  AUDIT_FINDINGS_MAX_CONFIDENCE_DESC = "AUDIT_FINDINGS_MAX_CONFIDENCE_DESC",
  AUDIT_FINDINGS_MAX_CREATED_AT_ASC = "AUDIT_FINDINGS_MAX_CREATED_AT_ASC",
  AUDIT_FINDINGS_MAX_CREATED_AT_DESC = "AUDIT_FINDINGS_MAX_CREATED_AT_DESC",
  AUDIT_FINDINGS_MAX_DELETED_AT_ASC = "AUDIT_FINDINGS_MAX_DELETED_AT_ASC",
  AUDIT_FINDINGS_MAX_DELETED_AT_DESC = "AUDIT_FINDINGS_MAX_DELETED_AT_DESC",
  AUDIT_FINDINGS_MAX_DELETED_BY_ASC = "AUDIT_FINDINGS_MAX_DELETED_BY_ASC",
  AUDIT_FINDINGS_MAX_DELETED_BY_DESC = "AUDIT_FINDINGS_MAX_DELETED_BY_DESC",
  AUDIT_FINDINGS_MAX_ID_ASC = "AUDIT_FINDINGS_MAX_ID_ASC",
  AUDIT_FINDINGS_MAX_ID_DESC = "AUDIT_FINDINGS_MAX_ID_DESC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_MAX_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_MAX_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_MAX_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_MAX_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_MAX_UPDATED_AT_ASC = "AUDIT_FINDINGS_MAX_UPDATED_AT_ASC",
  AUDIT_FINDINGS_MAX_UPDATED_AT_DESC = "AUDIT_FINDINGS_MAX_UPDATED_AT_DESC",
  AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_MIN_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_MIN_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC = "AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC = "AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_MIN_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_MIN_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_MIN_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_MIN_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_MIN_CONFIDENCE_ASC = "AUDIT_FINDINGS_MIN_CONFIDENCE_ASC",
  AUDIT_FINDINGS_MIN_CONFIDENCE_DESC = "AUDIT_FINDINGS_MIN_CONFIDENCE_DESC",
  AUDIT_FINDINGS_MIN_CREATED_AT_ASC = "AUDIT_FINDINGS_MIN_CREATED_AT_ASC",
  AUDIT_FINDINGS_MIN_CREATED_AT_DESC = "AUDIT_FINDINGS_MIN_CREATED_AT_DESC",
  AUDIT_FINDINGS_MIN_DELETED_AT_ASC = "AUDIT_FINDINGS_MIN_DELETED_AT_ASC",
  AUDIT_FINDINGS_MIN_DELETED_AT_DESC = "AUDIT_FINDINGS_MIN_DELETED_AT_DESC",
  AUDIT_FINDINGS_MIN_DELETED_BY_ASC = "AUDIT_FINDINGS_MIN_DELETED_BY_ASC",
  AUDIT_FINDINGS_MIN_DELETED_BY_DESC = "AUDIT_FINDINGS_MIN_DELETED_BY_DESC",
  AUDIT_FINDINGS_MIN_ID_ASC = "AUDIT_FINDINGS_MIN_ID_ASC",
  AUDIT_FINDINGS_MIN_ID_DESC = "AUDIT_FINDINGS_MIN_ID_DESC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_MIN_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_MIN_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_MIN_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_MIN_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_MIN_UPDATED_AT_ASC = "AUDIT_FINDINGS_MIN_UPDATED_AT_ASC",
  AUDIT_FINDINGS_MIN_UPDATED_AT_DESC = "AUDIT_FINDINGS_MIN_UPDATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_SUM_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_SUM_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC = "AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC = "AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_SUM_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_SUM_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_SUM_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_SUM_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_SUM_CONFIDENCE_ASC = "AUDIT_FINDINGS_SUM_CONFIDENCE_ASC",
  AUDIT_FINDINGS_SUM_CONFIDENCE_DESC = "AUDIT_FINDINGS_SUM_CONFIDENCE_DESC",
  AUDIT_FINDINGS_SUM_CREATED_AT_ASC = "AUDIT_FINDINGS_SUM_CREATED_AT_ASC",
  AUDIT_FINDINGS_SUM_CREATED_AT_DESC = "AUDIT_FINDINGS_SUM_CREATED_AT_DESC",
  AUDIT_FINDINGS_SUM_DELETED_AT_ASC = "AUDIT_FINDINGS_SUM_DELETED_AT_ASC",
  AUDIT_FINDINGS_SUM_DELETED_AT_DESC = "AUDIT_FINDINGS_SUM_DELETED_AT_DESC",
  AUDIT_FINDINGS_SUM_DELETED_BY_ASC = "AUDIT_FINDINGS_SUM_DELETED_BY_ASC",
  AUDIT_FINDINGS_SUM_DELETED_BY_DESC = "AUDIT_FINDINGS_SUM_DELETED_BY_DESC",
  AUDIT_FINDINGS_SUM_ID_ASC = "AUDIT_FINDINGS_SUM_ID_ASC",
  AUDIT_FINDINGS_SUM_ID_DESC = "AUDIT_FINDINGS_SUM_ID_DESC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_SUM_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_SUM_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_SUM_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_SUM_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_SUM_UPDATED_AT_ASC = "AUDIT_FINDINGS_SUM_UPDATED_AT_ASC",
  AUDIT_FINDINGS_SUM_UPDATED_AT_DESC = "AUDIT_FINDINGS_SUM_UPDATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__AUTHOR_ID_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__AUTHOR_ID_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__AUTHOR_ID_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__AUTHOR_ID_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_NAME_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_NAME_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_NAME_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_NAME_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_URL_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_URL_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_URL_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_URL_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_NAME_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_NAME_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_NAME_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_NAME_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__CREATED_AT_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__CREATED_AT_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__CREATED_AT_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__CREATED_AT_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__ID_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__ID_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__ID_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__ID_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__INSURER_ID_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__INSURER_ID_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__INSURER_ID_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__INSURER_ID_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__OWNER_ID_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__OWNER_ID_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__OWNER_ID_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__OWNER_ID_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__UPDATED_AT_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__UPDATED_AT_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__UPDATED_AT_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__UPDATED_AT_DESC",
  BATCH_FILE_ID_ASC = "BATCH_FILE_ID_ASC",
  BATCH_FILE_ID_DESC = "BATCH_FILE_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type AuditFindingMaxAggregateFilter = {
  confidence?: InputMaybe<BigFloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  discrepantAmount?: InputMaybe<FloatFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<IntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<IntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<IntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<IntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<IntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<IntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<BigFloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<IntFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
};

export type AuditFindingMaxAggregates = {
  __typename?: "AuditFindingMaxAggregates";
  /** Maximum of confidence across the matching connection */
  confidence?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Maximum of this field across the matching connection. */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of this field across the matching connection. */
  discrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of improperPaymentCost across the matching connection */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of improperPaymentUnitsCharged across the matching connection */
  improperPaymentUnitsCharged?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of metaDataEmCorrectLevel across the matching connection */
  metaDataEmCorrectLevel?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of metaDataEmOriginalLevel across the matching connection */
  metaDataEmOriginalLevel?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of metaDataNcciMueAjudicationValue across the matching connection */
  metaDataNcciMueAjudicationValue?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of metaDataNcciMueOhpMueValue across the matching connection */
  metaDataNcciMueOhpMueValue?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of metaDataNcciPtpModifier across the matching connection */
  metaDataNcciPtpModifier?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of metaDataPricingCorrectPrice across the matching connection */
  metaDataPricingCorrectPrice?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Maximum of metaDataUnitsCorrectUnits across the matching connection */
  metaDataUnitsCorrectUnits?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of this field across the matching connection. */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditFindingMinAggregateFilter = {
  confidence?: InputMaybe<BigFloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  discrepantAmount?: InputMaybe<FloatFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<IntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<IntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<IntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<IntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<IntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<IntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<BigFloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<IntFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
};

export type AuditFindingMinAggregates = {
  __typename?: "AuditFindingMinAggregates";
  /** Minimum of confidence across the matching connection */
  confidence?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Minimum of this field across the matching connection. */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of this field across the matching connection. */
  discrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of improperPaymentCost across the matching connection */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of improperPaymentUnitsCharged across the matching connection */
  improperPaymentUnitsCharged?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of metaDataEmCorrectLevel across the matching connection */
  metaDataEmCorrectLevel?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of metaDataEmOriginalLevel across the matching connection */
  metaDataEmOriginalLevel?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of metaDataNcciMueAjudicationValue across the matching connection */
  metaDataNcciMueAjudicationValue?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of metaDataNcciMueOhpMueValue across the matching connection */
  metaDataNcciMueOhpMueValue?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of metaDataNcciPtpModifier across the matching connection */
  metaDataNcciPtpModifier?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of metaDataPricingCorrectPrice across the matching connection */
  metaDataPricingCorrectPrice?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Minimum of metaDataUnitsCorrectUnits across the matching connection */
  metaDataUnitsCorrectUnits?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of this field across the matching connection. */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AuditFindingNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingRuleType` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingRuleType` being updated. */
    patch: AuditFindingRuleTypePatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingJob` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingJob` being updated. */
    patch: AuditFindingJobPatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLine` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLine` being updated. */
    patch: BatchClaimLinePatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingClaimLinePreviousVersionIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnAuditFindingForAuditFindingClaimLinePreviousVersionIdFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnAuditFindingForAuditFindingClaimLinePreviousVersionIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReasonCode` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReasonCode` being updated. */
    patch: AuditFindingReasonCodePatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReview` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: AuditFindingReviewPatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReview` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: AuditFindingReviewPatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItemAudit` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
    patch: BatchClaimLineItemAuditPatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `reportedFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `reportedFinding` being updated. */
    patch: ReportedFindingPatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `reviewedAuditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `reviewedAuditFinding` being updated. */
    patch: ReviewedAuditFindingPatch;
  };

/** The fields on `auditFinding` to look up the row to update. */
export type AuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyUsingAuditFindingClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: updateAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyPatch;
  };

/** Represents an update to a `AuditFinding`. Fields that are set will be updated. */
export type AuditFindingPatch = {
  auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
  auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
  auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
  auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
  auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
  auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
  auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
  auditType?: InputMaybe<AuditTypeEnum>;
  auditorComment?: InputMaybe<Scalars["String"]["input"]>;
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
  autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
  confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
  improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
  improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type AuditFindingReasonCode = Node & {
  __typename?: "AuditFindingReasonCode";
  /** Reads a single `AuditFinding` that is related to this `AuditFindingReasonCode`. */
  auditFinding?: Maybe<AuditFinding>;
  auditFindingId: Scalars["UUID"]["output"];
  /** Reads a single `AuditorUser` that is related to this `AuditFindingReasonCode`. */
  author?: Maybe<AuditorUser>;
  authorId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `ReasonCode` that is related to this `AuditFindingReasonCode`. */
  reasonCode?: Maybe<ReasonCode>;
  reasonCodeId: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type AuditFindingReasonCodeAggregates = {
  __typename?: "AuditFindingReasonCodeAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuditFindingReasonCodeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `AuditFindingReasonCode` object types. */
export type AuditFindingReasonCodeAggregatesFilter = {
  /** Distinct count aggregate over matching `AuditFindingReasonCode` objects. */
  distinctCount?: InputMaybe<AuditFindingReasonCodeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AuditFindingReasonCode` object to be included within the aggregate. */
  filter?: InputMaybe<AuditFindingReasonCodeFilter>;
};

/** The `auditFinding` to be created by this mutation. */
export type AuditFindingReasonCodeAuditFindingIdFkeyAuditFindingCreateInput = {
  auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
  auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
  auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
  auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
  auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
  auditFindingSeedType: AuditFindingSeedType;
  auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
  auditType?: InputMaybe<AuditTypeEnum>;
  auditorComment?: InputMaybe<Scalars["String"]["input"]>;
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
  autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
  confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  improperPaymentCost: Scalars["Float"]["input"];
  improperPaymentReason: Scalars["String"]["input"];
  improperPaymentUnitsCharged: Scalars["Int"]["input"];
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview: Scalars["Boolean"]["input"];
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The `auditFindingReasonCode` to be created by this mutation. */
export type AuditFindingReasonCodeAuditFindingIdFkeyAuditFindingReasonCodeCreateInput =
  {
    auditFindingToAuditFindingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    reasonCodeId?: InputMaybe<Scalars["String"]["input"]>;
    reasonCodeToReasonCodeId?: InputMaybe<AuditFindingReasonCodeReasonCodeIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `auditFinding` in the `AuditFindingReasonCodeInput` mutation. */
export type AuditFindingReasonCodeAuditFindingIdFkeyInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingAuditFindingClaimLinePkeyConnect>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingNodeIdConnect>;
  /** A `AuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyAuditFindingCreateInput>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyUsingAuditFindingClaimLinePkeyUpdate>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingReasonCode` in the `AuditFindingInput` mutation. */
export type AuditFindingReasonCodeAuditFindingIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingReasonCode` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuditFindingReasonCodeAuditFindingReasonCodePkeyConnect>
  >;
  /** The primary key(s) for `auditFindingReasonCode` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingReasonCodeNodeIdConnect>>;
  /** A `AuditFindingReasonCodeInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditFindingReasonCodeAuditFindingIdFkeyAuditFindingReasonCodeCreateInput>
  >;
  /** The primary key(s) and patch data for `auditFindingReasonCode` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyUsingAuditFindingReasonCodePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReasonCode` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditFindingOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyNodeIdUpdate>
  >;
};

/** The fields on `auditFindingReasonCode` to look up the row to connect. */
export type AuditFindingReasonCodeAuditFindingReasonCodePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The `auditFindingReasonCode` to be created by this mutation. */
export type AuditFindingReasonCodeAuthorIdFkeyAuditFindingReasonCodeCreateInput =
  {
    auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingToAuditFindingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    reasonCodeId?: InputMaybe<Scalars["String"]["input"]>;
    reasonCodeToReasonCodeId?: InputMaybe<AuditFindingReasonCodeReasonCodeIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `auditorUser` in the `AuditFindingReasonCodeInput` mutation. */
export type AuditFindingReasonCodeAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingReasonCode` in the `AuditorUserInput` mutation. */
export type AuditFindingReasonCodeAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingReasonCode` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuditFindingReasonCodeAuditFindingReasonCodePkeyConnect>
  >;
  /** The primary key(s) for `auditFindingReasonCode` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingReasonCodeNodeIdConnect>>;
  /** A `AuditFindingReasonCodeInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditFindingReasonCodeAuthorIdFkeyAuditFindingReasonCodeCreateInput>
  >;
  /** The primary key(s) and patch data for `auditFindingReasonCode` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyUsingAuditFindingReasonCodePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReasonCode` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `AuditFindingReasonCode` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AuditFindingReasonCodeCondition = {
  /** Checks for equality with the object’s `auditFindingId` field. */
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `reasonCodeId` field. */
  reasonCodeId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type AuditFindingReasonCodeDistinctCountAggregateFilter = {
  auditFindingId?: InputMaybe<BigIntFilter>;
  authorId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  reasonCodeId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type AuditFindingReasonCodeDistinctCountAggregates = {
  __typename?: "AuditFindingReasonCodeDistinctCountAggregates";
  /** Distinct count of auditFindingId across the matching connection */
  auditFindingId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of reasonCodeId across the matching connection */
  reasonCodeId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `AuditFindingReasonCode` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingReasonCodeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditFindingReasonCodeFilter>>;
  /** Filter by the object’s `auditFinding` relation. */
  auditFinding?: InputMaybe<AuditFindingFilter>;
  /** Filter by the object’s `auditFindingId` field. */
  auditFindingId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditFindingReasonCodeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditFindingReasonCodeFilter>>;
  /** Filter by the object’s `reasonCode` relation. */
  reasonCode?: InputMaybe<ReasonCodeFilter>;
  /** Filter by the object’s `reasonCodeId` field. */
  reasonCodeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `AuditFindingReasonCode` for usage during aggregation. */
export enum AuditFindingReasonCodeGroupBy {
  AUDIT_FINDING_ID = "AUDIT_FINDING_ID",
  AUTHOR_ID = "AUTHOR_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  REASON_CODE_ID = "REASON_CODE_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type AuditFindingReasonCodeHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReasonCodeHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AuditFindingReasonCode` aggregates. */
export type AuditFindingReasonCodeHavingInput = {
  AND?: InputMaybe<Array<AuditFindingReasonCodeHavingInput>>;
  OR?: InputMaybe<Array<AuditFindingReasonCodeHavingInput>>;
  average?: InputMaybe<AuditFindingReasonCodeHavingAverageInput>;
  distinctCount?: InputMaybe<AuditFindingReasonCodeHavingDistinctCountInput>;
  max?: InputMaybe<AuditFindingReasonCodeHavingMaxInput>;
  min?: InputMaybe<AuditFindingReasonCodeHavingMinInput>;
  stddevPopulation?: InputMaybe<AuditFindingReasonCodeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuditFindingReasonCodeHavingStddevSampleInput>;
  sum?: InputMaybe<AuditFindingReasonCodeHavingSumInput>;
  variancePopulation?: InputMaybe<AuditFindingReasonCodeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuditFindingReasonCodeHavingVarianceSampleInput>;
};

export type AuditFindingReasonCodeHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReasonCodeHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReasonCodeHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReasonCodeHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReasonCodeHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReasonCodeHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReasonCodeHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `AuditFindingReasonCode` */
export type AuditFindingReasonCodeInput = {
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingToAuditFindingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  reasonCodeId?: InputMaybe<Scalars["String"]["input"]>;
  reasonCodeToReasonCodeId?: InputMaybe<AuditFindingReasonCodeReasonCodeIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AuditFindingReasonCodeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `auditFindingReasonCode` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `auditFindingReasonCode` to look up the row to update. */
export type AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyUsingAuditFindingReasonCodePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReasonCode` being updated. */
    patch: updateAuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `auditFindingReasonCode` to look up the row to update. */
export type AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyUsingAuditFindingReasonCodePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReasonCode` being updated. */
    patch: updateAuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `reasonCode` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `reasonCode` being updated. */
    patch: ReasonCodePatch;
  };

/** The fields on `auditFindingReasonCode` to look up the row to update. */
export type AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyUsingAuditFindingReasonCodePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReasonCode` being updated. */
    patch: updateAuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyPatch;
  };

/** Represents an update to a `AuditFindingReasonCode`. Fields that are set will be updated. */
export type AuditFindingReasonCodePatch = {
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingToAuditFindingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  reasonCodeId?: InputMaybe<Scalars["String"]["input"]>;
  reasonCodeToReasonCodeId?: InputMaybe<AuditFindingReasonCodeReasonCodeIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The `auditFindingReasonCode` to be created by this mutation. */
export type AuditFindingReasonCodeReasonCodeIdFkeyAuditFindingReasonCodeCreateInput =
  {
    auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingToAuditFindingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    reasonCodeToReasonCodeId?: InputMaybe<AuditFindingReasonCodeReasonCodeIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `reasonCode` in the `AuditFindingReasonCodeInput` mutation. */
export type AuditFindingReasonCodeReasonCodeIdFkeyInput = {
  /** The primary key(s) for `reasonCode` for the far side of the relationship. */
  connectById?: InputMaybe<ReasonCodeReasonCodePkeyConnect>;
  /** The primary key(s) for `reasonCode` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ReasonCodeNodeIdConnect>;
  /** The primary key(s) and patch data for `reasonCode` for the far side of the relationship. */
  updateById?: InputMaybe<ReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyUsingReasonCodePkeyUpdate>;
  /** The primary key(s) and patch data for `reasonCode` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingReasonCode` in the `ReasonCodeInput` mutation. */
export type AuditFindingReasonCodeReasonCodeIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingReasonCode` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuditFindingReasonCodeAuditFindingReasonCodePkeyConnect>
  >;
  /** The primary key(s) for `auditFindingReasonCode` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingReasonCodeNodeIdConnect>>;
  /** A `AuditFindingReasonCodeInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditFindingReasonCodeReasonCodeIdFkeyAuditFindingReasonCodeCreateInput>
  >;
  /** The primary key(s) and patch data for `auditFindingReasonCode` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyUsingAuditFindingReasonCodePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReasonCode` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<ReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyNodeIdUpdate>
  >;
};

/** A connection to a list of `AuditFindingReasonCode` values. */
export type AuditFindingReasonCodesConnection = {
  __typename?: "AuditFindingReasonCodesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuditFindingReasonCodeAggregates>;
  /** A list of edges which contains the `AuditFindingReasonCode` and cursor to aid in pagination. */
  edges: Array<AuditFindingReasonCodesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuditFindingReasonCodeAggregates>>;
  /** A list of `AuditFindingReasonCode` objects. */
  nodes: Array<Maybe<AuditFindingReasonCode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditFindingReasonCode` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `AuditFindingReasonCode` values. */
export type AuditFindingReasonCodesConnectiongroupedAggregatesArgs = {
  groupBy: Array<AuditFindingReasonCodeGroupBy>;
  having?: InputMaybe<AuditFindingReasonCodeHavingInput>;
};

/** A `AuditFindingReasonCode` edge in the connection. */
export type AuditFindingReasonCodesEdge = {
  __typename?: "AuditFindingReasonCodesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuditFindingReasonCode` at the end of the edge. */
  node?: Maybe<AuditFindingReasonCode>;
};

/** Methods to use when ordering `AuditFindingReasonCode`. */
export enum AuditFindingReasonCodesOrderBy {
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_DESC",
  AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_ID_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  REASON_CODE_BY_REASON_CODE_ID__CREATED_AT_ASC = "REASON_CODE_BY_REASON_CODE_ID__CREATED_AT_ASC",
  REASON_CODE_BY_REASON_CODE_ID__CREATED_AT_DESC = "REASON_CODE_BY_REASON_CODE_ID__CREATED_AT_DESC",
  REASON_CODE_BY_REASON_CODE_ID__DATE_EFFECTIVE_END_ASC = "REASON_CODE_BY_REASON_CODE_ID__DATE_EFFECTIVE_END_ASC",
  REASON_CODE_BY_REASON_CODE_ID__DATE_EFFECTIVE_END_DESC = "REASON_CODE_BY_REASON_CODE_ID__DATE_EFFECTIVE_END_DESC",
  REASON_CODE_BY_REASON_CODE_ID__DATE_EFFECTIVE_START_ASC = "REASON_CODE_BY_REASON_CODE_ID__DATE_EFFECTIVE_START_ASC",
  REASON_CODE_BY_REASON_CODE_ID__DATE_EFFECTIVE_START_DESC = "REASON_CODE_BY_REASON_CODE_ID__DATE_EFFECTIVE_START_DESC",
  REASON_CODE_BY_REASON_CODE_ID__DESCRIPTION_ASC = "REASON_CODE_BY_REASON_CODE_ID__DESCRIPTION_ASC",
  REASON_CODE_BY_REASON_CODE_ID__DESCRIPTION_DESC = "REASON_CODE_BY_REASON_CODE_ID__DESCRIPTION_DESC",
  REASON_CODE_BY_REASON_CODE_ID__ID_ASC = "REASON_CODE_BY_REASON_CODE_ID__ID_ASC",
  REASON_CODE_BY_REASON_CODE_ID__ID_DESC = "REASON_CODE_BY_REASON_CODE_ID__ID_DESC",
  REASON_CODE_BY_REASON_CODE_ID__LAST_UPDATED_ASC = "REASON_CODE_BY_REASON_CODE_ID__LAST_UPDATED_ASC",
  REASON_CODE_BY_REASON_CODE_ID__LAST_UPDATED_DESC = "REASON_CODE_BY_REASON_CODE_ID__LAST_UPDATED_DESC",
  REASON_CODE_BY_REASON_CODE_ID__NOTES_ASC = "REASON_CODE_BY_REASON_CODE_ID__NOTES_ASC",
  REASON_CODE_BY_REASON_CODE_ID__NOTES_DESC = "REASON_CODE_BY_REASON_CODE_ID__NOTES_DESC",
  REASON_CODE_BY_REASON_CODE_ID__UPDATED_AT_ASC = "REASON_CODE_BY_REASON_CODE_ID__UPDATED_AT_ASC",
  REASON_CODE_BY_REASON_CODE_ID__UPDATED_AT_DESC = "REASON_CODE_BY_REASON_CODE_ID__UPDATED_AT_DESC",
  REASON_CODE_ID_ASC = "REASON_CODE_ID_ASC",
  REASON_CODE_ID_DESC = "REASON_CODE_ID_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type AuditFindingReport = Node & {
  __typename?: "AuditFindingReport";
  auditFindingReportSubtype: AuditFindingReportSubtype;
  auditFindingReportType: AuditFindingReportType;
  /** Reads and enables pagination through a set of `AuditFindingReport`. */
  auditFindingReportsByOriginalVersionId: AuditFindingReportsConnection;
  /** Reads and enables pagination through a set of `AuditorBucket`. */
  auditorBuckets: AuditorBucketsConnection;
  /** Reads a single `AuditorUser` that is related to this `AuditFindingReport`. */
  author?: Maybe<AuditorUser>;
  authorId: Scalars["UUID"]["output"];
  /** Reads and enables pagination through a set of `BatchClaim`. */
  batchClaims: BatchClaimsConnection;
  claimFilter?: Maybe<Scalars["JSON"]["output"]>;
  createdAt: Scalars["Datetime"]["output"];
  determinedImproperPayments?: Maybe<ReportAggregate>;
  downloadUrl: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads a single `Insurer` that is related to this `AuditFindingReport`. */
  insurer?: Maybe<Insurer>;
  insurerId: Scalars["UUID"]["output"];
  isLatestVersion?: Maybe<Scalars["Boolean"]["output"]>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `AuditFindingReport` that is related to this `AuditFindingReport`. */
  originalVersion?: Maybe<AuditFindingReport>;
  originalVersionId: Scalars["UUID"]["output"];
  /** Reads a single `AuditorUser` that is related to this `AuditFindingReport`. */
  primaryPia?: Maybe<AuditorUser>;
  primaryPiaId: Scalars["UUID"]["output"];
  /** Reads a single `Provider` that is related to this `AuditFindingReport`. */
  provider?: Maybe<Provider>;
  providerId: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `ReportedClaim`. */
  reportedClaims: ReportedClaimsConnection;
  /** Reads and enables pagination through a set of `ReportedFinding`. */
  reportedFindings: ReportedFindingsConnection;
  s3Url?: Maybe<Scalars["String"]["output"]>;
  s3Version?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  transfers: Array<ClientSendReportTransfer>;
  updatedAt: Scalars["Datetime"]["output"];
  viewId: Scalars["UUID"]["output"];
};

export type AuditFindingReportauditFindingReportsByOriginalVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReportCondition>;
  filter?: InputMaybe<AuditFindingReportFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReportsOrderBy>>;
};

export type AuditFindingReportauditorBucketsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<AuditorBucketFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AuditFindingReportbatchClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<BatchClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AuditFindingReportreportedClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ReportedClaimCondition>;
  filter?: InputMaybe<ReportedClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ReportedClaimsOrderBy>>;
};

export type AuditFindingReportreportedFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ReportedFindingCondition>;
  filter?: InputMaybe<ReportedFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ReportedFindingsOrderBy>>;
};

export type AuditFindingReportAggregates = {
  __typename?: "AuditFindingReportAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuditFindingReportDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `AuditFindingReport` object types. */
export type AuditFindingReportAggregatesFilter = {
  /** Distinct count aggregate over matching `AuditFindingReport` objects. */
  distinctCount?: InputMaybe<AuditFindingReportDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AuditFindingReport` object to be included within the aggregate. */
  filter?: InputMaybe<AuditFindingReportFilter>;
};

/**
 * A condition to be used against `AuditFindingReport` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuditFindingReportCondition = {
  /** Checks for equality with the object’s `auditFindingReportSubtype` field. */
  auditFindingReportSubtype?: InputMaybe<AuditFindingReportSubtype>;
  /** Checks for equality with the object’s `auditFindingReportType` field. */
  auditFindingReportType?: InputMaybe<AuditFindingReportType>;
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `claimFilter` field. */
  claimFilter?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `insurerId` field. */
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `originalVersionId` field. */
  originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `primaryPiaId` field. */
  primaryPiaId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `s3Url` field. */
  s3Url?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `s3Version` field. */
  s3Version?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `viewId` field. */
  viewId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type AuditFindingReportDistinctCountAggregateFilter = {
  auditFindingReportSubtype?: InputMaybe<BigIntFilter>;
  auditFindingReportType?: InputMaybe<BigIntFilter>;
  authorId?: InputMaybe<BigIntFilter>;
  claimFilter?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  insurerId?: InputMaybe<BigIntFilter>;
  isLatestVersion?: InputMaybe<BooleanFilter>;
  originalVersionId?: InputMaybe<BigIntFilter>;
  primaryPiaId?: InputMaybe<BigIntFilter>;
  providerId?: InputMaybe<BigIntFilter>;
  s3Url?: InputMaybe<BigIntFilter>;
  s3Version?: InputMaybe<BigIntFilter>;
  title?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  viewId?: InputMaybe<BigIntFilter>;
};

export type AuditFindingReportDistinctCountAggregates = {
  __typename?: "AuditFindingReportDistinctCountAggregates";
  /** Distinct count of auditFindingReportSubtype across the matching connection */
  auditFindingReportSubtype?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditFindingReportType across the matching connection */
  auditFindingReportType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of claimFilter across the matching connection */
  claimFilter?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  determinedImproperPayments?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of insurerId across the matching connection */
  insurerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  isLatestVersion?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of originalVersionId across the matching connection */
  originalVersionId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of primaryPiaId across the matching connection */
  primaryPiaId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of providerId across the matching connection */
  providerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of s3Url across the matching connection */
  s3Url?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of s3Version across the matching connection */
  s3Version?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of title across the matching connection */
  title?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of viewId across the matching connection */
  viewId?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `AuditFindingReport` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingReportFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditFindingReportFilter>>;
  /** Filter by the object’s `auditFindingReportSubtype` field. */
  auditFindingReportSubtype?: InputMaybe<AuditFindingReportSubtypeFilter>;
  /** Filter by the object’s `auditFindingReportType` field. */
  auditFindingReportType?: InputMaybe<AuditFindingReportTypeFilter>;
  /** Filter by the object’s `auditFindingReportsByOriginalVersionId` relation. */
  auditFindingReportsByOriginalVersionId?: InputMaybe<AuditFindingReportToManyAuditFindingReportFilter>;
  /** Some related `auditFindingReportsByOriginalVersionId` exist. */
  auditFindingReportsByOriginalVersionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `claimFilter` field. */
  claimFilter?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `insurer` relation. */
  insurer?: InputMaybe<InsurerFilter>;
  /** Filter by the object’s `insurerId` field. */
  insurerId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `isLatestVersion` field. */
  isLatestVersion?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditFindingReportFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditFindingReportFilter>>;
  /** Filter by the object’s `originalVersion` relation. */
  originalVersion?: InputMaybe<AuditFindingReportFilter>;
  /** Filter by the object’s `originalVersionId` field. */
  originalVersionId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `primaryPia` relation. */
  primaryPia?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `primaryPiaId` field. */
  primaryPiaId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `provider` relation. */
  provider?: InputMaybe<ProviderFilter>;
  /** Filter by the object’s `providerId` field. */
  providerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reportedClaims` relation. */
  reportedClaims?: InputMaybe<AuditFindingReportToManyReportedClaimFilter>;
  /** Some related `reportedClaims` exist. */
  reportedClaimsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `reportedFindings` relation. */
  reportedFindings?: InputMaybe<AuditFindingReportToManyReportedFindingFilter>;
  /** Some related `reportedFindings` exist. */
  reportedFindingsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `s3Url` field. */
  s3Url?: InputMaybe<StringFilter>;
  /** Filter by the object’s `s3Version` field. */
  s3Version?: InputMaybe<StringFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `viewId` field. */
  viewId?: InputMaybe<UUIDFilter>;
};

/** Grouping methods for `AuditFindingReport` for usage during aggregation. */
export enum AuditFindingReportGroupBy {
  AUDIT_FINDING_REPORT_SUBTYPE = "AUDIT_FINDING_REPORT_SUBTYPE",
  AUDIT_FINDING_REPORT_TYPE = "AUDIT_FINDING_REPORT_TYPE",
  AUTHOR_ID = "AUTHOR_ID",
  CLAIM_FILTER = "CLAIM_FILTER",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  INSURER_ID = "INSURER_ID",
  ORIGINAL_VERSION_ID = "ORIGINAL_VERSION_ID",
  PRIMARY_PIA_ID = "PRIMARY_PIA_ID",
  PROVIDER_ID = "PROVIDER_ID",
  S3_URL = "S3_URL",
  S3_VERSION = "S3_VERSION",
  TITLE = "TITLE",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
  VIEW_ID = "VIEW_ID",
}

export type AuditFindingReportHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReportHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AuditFindingReport` aggregates. */
export type AuditFindingReportHavingInput = {
  AND?: InputMaybe<Array<AuditFindingReportHavingInput>>;
  OR?: InputMaybe<Array<AuditFindingReportHavingInput>>;
  average?: InputMaybe<AuditFindingReportHavingAverageInput>;
  distinctCount?: InputMaybe<AuditFindingReportHavingDistinctCountInput>;
  max?: InputMaybe<AuditFindingReportHavingMaxInput>;
  min?: InputMaybe<AuditFindingReportHavingMinInput>;
  stddevPopulation?: InputMaybe<AuditFindingReportHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuditFindingReportHavingStddevSampleInput>;
  sum?: InputMaybe<AuditFindingReportHavingSumInput>;
  variancePopulation?: InputMaybe<AuditFindingReportHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuditFindingReportHavingVarianceSampleInput>;
};

export type AuditFindingReportHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReportHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReportHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReportHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReportHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReportHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReportHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Input for the nested mutation of `insurer` in the `AuditFindingReportInput` mutation. */
export type AuditFindingReportInsurerIdFkeyInput = {
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByClientAbbreviation?: InputMaybe<InsurerInsurerUniqueClientAbbreviationConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectById?: InputMaybe<InsurerInsurerPkeyConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByName?: InputMaybe<InsurerInsurerUniqueNameConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<InsurerNodeIdConnect>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByClientAbbreviation?: InputMaybe<InsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateById?: InputMaybe<InsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyUsingInsurerPkeyUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByName?: InputMaybe<InsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyUsingInsurerUniqueNameUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingReportOnAuditFindingReportForAuditFindingReportInsurerIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingReport` in the `InsurerInput` mutation. */
export type AuditFindingReportInsurerIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuditFindingReportPreliminaryAuditFindingReportPkeyConnect>
  >;
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingReportNodeIdConnect>>;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingReportOnAuditFindingReportForAuditFindingReportInsurerIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<InsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyNodeIdUpdate>
  >;
};

/** The globally unique `ID` look up for the row to connect. */
export type AuditFindingReportNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `auditFindingReport` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReportOnAuditFindingReportForAuditFindingReportInsurerIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `insurer` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: InsurerPatch;
  };

/** The fields on `auditFindingReport` to look up the row to update. */
export type AuditFindingReportOnAuditFindingReportForAuditFindingReportInsurerIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: updateAuditFindingReportOnAuditFindingReportForAuditFindingReportInsurerIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReportOnAuditFindingReportForAuditFindingReportOriginalVersionIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReport` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: AuditFindingReportPatch;
  };

/** The fields on `auditFindingReport` to look up the row to update. */
export type AuditFindingReportOnAuditFindingReportForAuditFindingReportOriginalVersionIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: updateAuditFindingReportOnAuditFindingReportForAuditFindingReportOriginalVersionIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReportOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `auditFindingReport` to look up the row to update. */
export type AuditFindingReportOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: updateAuditFindingReportOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `auditFindingReport` to look up the row to update. */
export type AuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: updateAuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `provider` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: ProviderPatch;
  };

/** The fields on `auditFindingReport` to look up the row to update. */
export type AuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: updateAuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReportOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `reportedClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `reportedClaim` being updated. */
    patch: ReportedClaimPatch;
  };

/** The fields on `auditFindingReport` to look up the row to update. */
export type AuditFindingReportOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdUsingPreliminaryAuditFindingReportPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: updateAuditFindingReportOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReportOnReportedFindingForReportedFindingAuditFindingReportIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `reportedFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `reportedFinding` being updated. */
    patch: ReportedFindingPatch;
  };

/** The fields on `auditFindingReport` to look up the row to update. */
export type AuditFindingReportOnReportedFindingForReportedFindingAuditFindingReportIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: updateAuditFindingReportOnReportedFindingForReportedFindingAuditFindingReportIdFkeyPatch;
  };

/** Input for the nested mutation of `auditFindingReport` in the `AuditFindingReportInput` mutation. */
export type AuditFindingReportOriginalVersionIdFkeyInput = {
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingReportPreliminaryAuditFindingReportPkeyConnect>;
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingReportNodeIdConnect>;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingReportOnAuditFindingReportForAuditFindingReportOriginalVersionIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate>;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingReportOnAuditFindingReportForAuditFindingReportOriginalVersionIdFkeyNodeIdUpdate>;
};

/** Represents an update to a `AuditFindingReport`. Fields that are set will be updated. */
export type AuditFindingReportPatch = {
  auditFindingReportToOriginalVersionId?: InputMaybe<AuditFindingReportOriginalVersionIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInput>;
  auditorUserToPrimaryPiaId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<AuditFindingReportInsurerIdFkeyInput>;
  originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  primaryPiaId?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInput>;
  reportedClaimsUsingId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInverseInput>;
  reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInverseInput>;
};

/** The fields on `auditFindingReport` to look up the row to connect. */
export type AuditFindingReportPreliminaryAuditFindingReportPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `auditorUser` in the `AuditFindingReportInput` mutation. */
export type AuditFindingReportPrimaryPiaIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingReportOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingReport` in the `AuditorUserInput` mutation. */
export type AuditFindingReportPrimaryPiaIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuditFindingReportPreliminaryAuditFindingReportPkeyConnect>
  >;
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingReportNodeIdConnect>>;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingReportOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyNodeIdUpdate>
  >;
};

export enum AuditFindingReportSubtype {
  /** MDH - Creates an audit finding report file but does not save results to database */
  DRAFT = "DRAFT",
  /** MDH - The last audit finding report subtype sent to MDH, any challenge to these findings are an appeal. Note you can have multiple final reports, so this does NOT imply a single FINAL report exists for a given report family. */
  FINAL = "FINAL",
  /** MDH - Creates an audit finding report file but does not save results to database, is not currently called from the frontend but is a backend convenience handled in the report service */
  MANUAL = "MANUAL",
  /** MDH - The initial audit finding report sent to a provider to respond to, any challenge to these findings are a dispute */
  PRELIMINARY = "PRELIMINARY",
  /** Creates an audit finding report file based on our EOA format */
  PROCESSED = "PROCESSED",
}

/** A filter to be used against AuditFindingReportSubtype fields. All fields are combined with a logical ‘and.’ */
export type AuditFindingReportSubtypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AuditFindingReportSubtype>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AuditFindingReportSubtype>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AuditFindingReportSubtype>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AuditFindingReportSubtype>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AuditFindingReportSubtype>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AuditFindingReportSubtype>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AuditFindingReportSubtype>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AuditFindingReportSubtype>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AuditFindingReportSubtype>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AuditFindingReportSubtype>>;
};

/** A filter to be used against many `AuditFindingReport` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingReportToManyAuditFindingReportFilter = {
  /** Aggregates across related `AuditFindingReport` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingReportAggregatesFilter>;
  /** Every related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingReportFilter>;
  /** No related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingReportFilter>;
  /** Some related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingReportFilter>;
};

/** A filter to be used against many `ReportedClaim` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingReportToManyReportedClaimFilter = {
  /** Aggregates across related `ReportedClaim` match the filter criteria. */
  aggregates?: InputMaybe<ReportedClaimAggregatesFilter>;
  /** Every related `ReportedClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ReportedClaimFilter>;
  /** No related `ReportedClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ReportedClaimFilter>;
  /** Some related `ReportedClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ReportedClaimFilter>;
};

/** A filter to be used against many `ReportedFinding` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingReportToManyReportedFindingFilter = {
  /** Aggregates across related `ReportedFinding` match the filter criteria. */
  aggregates?: InputMaybe<ReportedFindingAggregatesFilter>;
  /** Every related `ReportedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ReportedFindingFilter>;
  /** No related `ReportedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ReportedFindingFilter>;
  /** Some related `ReportedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ReportedFindingFilter>;
};

export enum AuditFindingReportType {
  /** Standard explanation of adjustment report */
  EOA = "EOA",
  /** Itemized finding report is a csv dump of findings on IBs */
  IFR = "IFR",
  /** Maryland Department of Health formatted post-pay report */
  MDH = "MDH",
}

/** A filter to be used against AuditFindingReportType fields. All fields are combined with a logical ‘and.’ */
export type AuditFindingReportTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AuditFindingReportType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AuditFindingReportType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AuditFindingReportType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AuditFindingReportType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AuditFindingReportType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AuditFindingReportType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AuditFindingReportType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AuditFindingReportType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AuditFindingReportType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AuditFindingReportType>>;
};

/** A connection to a list of `AuditFindingReport` values. */
export type AuditFindingReportsConnection = {
  __typename?: "AuditFindingReportsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuditFindingReportAggregates>;
  /** A list of edges which contains the `AuditFindingReport` and cursor to aid in pagination. */
  edges: Array<AuditFindingReportsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuditFindingReportAggregates>>;
  /** A list of `AuditFindingReport` objects. */
  nodes: Array<Maybe<AuditFindingReport>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditFindingReport` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `AuditFindingReport` values. */
export type AuditFindingReportsConnectiongroupedAggregatesArgs = {
  groupBy: Array<AuditFindingReportGroupBy>;
  having?: InputMaybe<AuditFindingReportHavingInput>;
};

/** A `AuditFindingReport` edge in the connection. */
export type AuditFindingReportsEdge = {
  __typename?: "AuditFindingReportsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuditFindingReport` at the end of the edge. */
  node?: Maybe<AuditFindingReport>;
};

/** Methods to use when ordering `AuditFindingReport`. */
export enum AuditFindingReportsOrderBy {
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__EMAIL_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__EMAIL_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__EMAIL_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__EMAIL_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__ID_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__ID_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__ID_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__ID_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__TITLE_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__TITLE_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__TITLE_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__TITLE_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_PRIMARY_PIA_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_PRIMARY_PIA_ID__USER_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_AVERAGE_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_COUNT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_COUNT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_COUNT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_COUNT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_DISTINCT_COUNT_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MAX_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_MIN_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_POPULATION_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_STDDEV_SAMPLE_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_SUM_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_POPULATION_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID_VARIANCE_SAMPLE_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID__COUNT_ASC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID__COUNT_ASC",
  AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID__COUNT_DESC = "AUDIT_FINDING_REPORTS_BY_ORIGINAL_VERSION_ID__COUNT_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__CREATED_AT_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__CREATED_AT_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__CREATED_AT_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__CREATED_AT_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__ID_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__ID_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__ID_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__ID_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__INSURER_ID_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__INSURER_ID_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__INSURER_ID_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__INSURER_ID_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__PROVIDER_ID_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__PROVIDER_ID_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__S3_URL_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__S3_URL_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__S3_URL_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__S3_URL_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__S3_VERSION_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__S3_VERSION_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__S3_VERSION_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__S3_VERSION_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__TITLE_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__TITLE_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__TITLE_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__TITLE_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__UPDATED_AT_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__UPDATED_AT_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__UPDATED_AT_DESC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__VIEW_ID_ASC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__VIEW_ID_ASC",
  AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__VIEW_ID_DESC = "AUDIT_FINDING_REPORT_BY_ORIGINAL_VERSION_ID__VIEW_ID_DESC",
  AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORT_TYPE_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  CLAIM_FILTER_ASC = "CLAIM_FILTER_ASC",
  CLAIM_FILTER_DESC = "CLAIM_FILTER_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ID_ASC = "INSURER_BY_INSURER_ID__CLIENT_ID_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ID_DESC = "INSURER_BY_INSURER_ID__CLIENT_ID_DESC",
  INSURER_BY_INSURER_ID__CREATED_AT_ASC = "INSURER_BY_INSURER_ID__CREATED_AT_ASC",
  INSURER_BY_INSURER_ID__CREATED_AT_DESC = "INSURER_BY_INSURER_ID__CREATED_AT_DESC",
  INSURER_BY_INSURER_ID__ID_ASC = "INSURER_BY_INSURER_ID__ID_ASC",
  INSURER_BY_INSURER_ID__ID_DESC = "INSURER_BY_INSURER_ID__ID_DESC",
  INSURER_BY_INSURER_ID__NAME_ASC = "INSURER_BY_INSURER_ID__NAME_ASC",
  INSURER_BY_INSURER_ID__NAME_DESC = "INSURER_BY_INSURER_ID__NAME_DESC",
  INSURER_BY_INSURER_ID__UPDATED_AT_ASC = "INSURER_BY_INSURER_ID__UPDATED_AT_ASC",
  INSURER_BY_INSURER_ID__UPDATED_AT_DESC = "INSURER_BY_INSURER_ID__UPDATED_AT_DESC",
  INSURER_ID_ASC = "INSURER_ID_ASC",
  INSURER_ID_DESC = "INSURER_ID_DESC",
  NATURAL = "NATURAL",
  ORIGINAL_VERSION_ID_ASC = "ORIGINAL_VERSION_ID_ASC",
  ORIGINAL_VERSION_ID_DESC = "ORIGINAL_VERSION_ID_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PRIMARY_PIA_ID_ASC = "PRIMARY_PIA_ID_ASC",
  PRIMARY_PIA_ID_DESC = "PRIMARY_PIA_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__CITY_ASC = "PROVIDER_BY_PROVIDER_ID__CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__CITY_DESC = "PROVIDER_BY_PROVIDER_ID__CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC",
  PROVIDER_BY_PROVIDER_ID__ID_ASC = "PROVIDER_BY_PROVIDER_ID__ID_ASC",
  PROVIDER_BY_PROVIDER_ID__ID_DESC = "PROVIDER_BY_PROVIDER_ID__ID_DESC",
  PROVIDER_BY_PROVIDER_ID__NAME_ASC = "PROVIDER_BY_PROVIDER_ID__NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__NAME_DESC = "PROVIDER_BY_PROVIDER_ID__NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__NPI_ASC = "PROVIDER_BY_PROVIDER_ID__NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__NPI_DESC = "PROVIDER_BY_PROVIDER_ID__NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC",
  PROVIDER_BY_PROVIDER_ID__SPEC_ASC = "PROVIDER_BY_PROVIDER_ID__SPEC_ASC",
  PROVIDER_BY_PROVIDER_ID__SPEC_DESC = "PROVIDER_BY_PROVIDER_ID__SPEC_DESC",
  PROVIDER_BY_PROVIDER_ID__STATE_ASC = "PROVIDER_BY_PROVIDER_ID__STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__STATE_DESC = "PROVIDER_BY_PROVIDER_ID__STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC",
  PROVIDER_ID_ASC = "PROVIDER_ID_ASC",
  PROVIDER_ID_DESC = "PROVIDER_ID_DESC",
  REPORTED_CLAIMS_AVERAGE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_AVERAGE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_AVERAGE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_AVERAGE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_AVERAGE_CLAIM_ID_ASC = "REPORTED_CLAIMS_AVERAGE_CLAIM_ID_ASC",
  REPORTED_CLAIMS_AVERAGE_CLAIM_ID_DESC = "REPORTED_CLAIMS_AVERAGE_CLAIM_ID_DESC",
  REPORTED_CLAIMS_AVERAGE_ID_ASC = "REPORTED_CLAIMS_AVERAGE_ID_ASC",
  REPORTED_CLAIMS_AVERAGE_ID_DESC = "REPORTED_CLAIMS_AVERAGE_ID_DESC",
  REPORTED_CLAIMS_AVERAGE_STRATEGY_ASC = "REPORTED_CLAIMS_AVERAGE_STRATEGY_ASC",
  REPORTED_CLAIMS_AVERAGE_STRATEGY_DESC = "REPORTED_CLAIMS_AVERAGE_STRATEGY_DESC",
  REPORTED_CLAIMS_BY_AUDIT_FINDING_REPORT_ID__COUNT_ASC = "REPORTED_CLAIMS_BY_AUDIT_FINDING_REPORT_ID__COUNT_ASC",
  REPORTED_CLAIMS_BY_AUDIT_FINDING_REPORT_ID__COUNT_DESC = "REPORTED_CLAIMS_BY_AUDIT_FINDING_REPORT_ID__COUNT_DESC",
  REPORTED_CLAIMS_COUNT_ASC = "REPORTED_CLAIMS_COUNT_ASC",
  REPORTED_CLAIMS_COUNT_DESC = "REPORTED_CLAIMS_COUNT_DESC",
  REPORTED_CLAIMS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_DISTINCT_COUNT_CLAIM_ID_ASC = "REPORTED_CLAIMS_DISTINCT_COUNT_CLAIM_ID_ASC",
  REPORTED_CLAIMS_DISTINCT_COUNT_CLAIM_ID_DESC = "REPORTED_CLAIMS_DISTINCT_COUNT_CLAIM_ID_DESC",
  REPORTED_CLAIMS_DISTINCT_COUNT_ID_ASC = "REPORTED_CLAIMS_DISTINCT_COUNT_ID_ASC",
  REPORTED_CLAIMS_DISTINCT_COUNT_ID_DESC = "REPORTED_CLAIMS_DISTINCT_COUNT_ID_DESC",
  REPORTED_CLAIMS_DISTINCT_COUNT_STRATEGY_ASC = "REPORTED_CLAIMS_DISTINCT_COUNT_STRATEGY_ASC",
  REPORTED_CLAIMS_DISTINCT_COUNT_STRATEGY_DESC = "REPORTED_CLAIMS_DISTINCT_COUNT_STRATEGY_DESC",
  REPORTED_CLAIMS_MAX_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_MAX_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_MAX_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_MAX_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_MAX_CLAIM_ID_ASC = "REPORTED_CLAIMS_MAX_CLAIM_ID_ASC",
  REPORTED_CLAIMS_MAX_CLAIM_ID_DESC = "REPORTED_CLAIMS_MAX_CLAIM_ID_DESC",
  REPORTED_CLAIMS_MAX_ID_ASC = "REPORTED_CLAIMS_MAX_ID_ASC",
  REPORTED_CLAIMS_MAX_ID_DESC = "REPORTED_CLAIMS_MAX_ID_DESC",
  REPORTED_CLAIMS_MAX_STRATEGY_ASC = "REPORTED_CLAIMS_MAX_STRATEGY_ASC",
  REPORTED_CLAIMS_MAX_STRATEGY_DESC = "REPORTED_CLAIMS_MAX_STRATEGY_DESC",
  REPORTED_CLAIMS_MIN_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_MIN_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_MIN_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_MIN_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_MIN_CLAIM_ID_ASC = "REPORTED_CLAIMS_MIN_CLAIM_ID_ASC",
  REPORTED_CLAIMS_MIN_CLAIM_ID_DESC = "REPORTED_CLAIMS_MIN_CLAIM_ID_DESC",
  REPORTED_CLAIMS_MIN_ID_ASC = "REPORTED_CLAIMS_MIN_ID_ASC",
  REPORTED_CLAIMS_MIN_ID_DESC = "REPORTED_CLAIMS_MIN_ID_DESC",
  REPORTED_CLAIMS_MIN_STRATEGY_ASC = "REPORTED_CLAIMS_MIN_STRATEGY_ASC",
  REPORTED_CLAIMS_MIN_STRATEGY_DESC = "REPORTED_CLAIMS_MIN_STRATEGY_DESC",
  REPORTED_CLAIMS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_STDDEV_POPULATION_CLAIM_ID_ASC = "REPORTED_CLAIMS_STDDEV_POPULATION_CLAIM_ID_ASC",
  REPORTED_CLAIMS_STDDEV_POPULATION_CLAIM_ID_DESC = "REPORTED_CLAIMS_STDDEV_POPULATION_CLAIM_ID_DESC",
  REPORTED_CLAIMS_STDDEV_POPULATION_ID_ASC = "REPORTED_CLAIMS_STDDEV_POPULATION_ID_ASC",
  REPORTED_CLAIMS_STDDEV_POPULATION_ID_DESC = "REPORTED_CLAIMS_STDDEV_POPULATION_ID_DESC",
  REPORTED_CLAIMS_STDDEV_POPULATION_STRATEGY_ASC = "REPORTED_CLAIMS_STDDEV_POPULATION_STRATEGY_ASC",
  REPORTED_CLAIMS_STDDEV_POPULATION_STRATEGY_DESC = "REPORTED_CLAIMS_STDDEV_POPULATION_STRATEGY_DESC",
  REPORTED_CLAIMS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_STDDEV_SAMPLE_CLAIM_ID_ASC = "REPORTED_CLAIMS_STDDEV_SAMPLE_CLAIM_ID_ASC",
  REPORTED_CLAIMS_STDDEV_SAMPLE_CLAIM_ID_DESC = "REPORTED_CLAIMS_STDDEV_SAMPLE_CLAIM_ID_DESC",
  REPORTED_CLAIMS_STDDEV_SAMPLE_ID_ASC = "REPORTED_CLAIMS_STDDEV_SAMPLE_ID_ASC",
  REPORTED_CLAIMS_STDDEV_SAMPLE_ID_DESC = "REPORTED_CLAIMS_STDDEV_SAMPLE_ID_DESC",
  REPORTED_CLAIMS_STDDEV_SAMPLE_STRATEGY_ASC = "REPORTED_CLAIMS_STDDEV_SAMPLE_STRATEGY_ASC",
  REPORTED_CLAIMS_STDDEV_SAMPLE_STRATEGY_DESC = "REPORTED_CLAIMS_STDDEV_SAMPLE_STRATEGY_DESC",
  REPORTED_CLAIMS_SUM_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_SUM_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_SUM_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_SUM_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_SUM_CLAIM_ID_ASC = "REPORTED_CLAIMS_SUM_CLAIM_ID_ASC",
  REPORTED_CLAIMS_SUM_CLAIM_ID_DESC = "REPORTED_CLAIMS_SUM_CLAIM_ID_DESC",
  REPORTED_CLAIMS_SUM_ID_ASC = "REPORTED_CLAIMS_SUM_ID_ASC",
  REPORTED_CLAIMS_SUM_ID_DESC = "REPORTED_CLAIMS_SUM_ID_DESC",
  REPORTED_CLAIMS_SUM_STRATEGY_ASC = "REPORTED_CLAIMS_SUM_STRATEGY_ASC",
  REPORTED_CLAIMS_SUM_STRATEGY_DESC = "REPORTED_CLAIMS_SUM_STRATEGY_DESC",
  REPORTED_CLAIMS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_VARIANCE_POPULATION_CLAIM_ID_ASC = "REPORTED_CLAIMS_VARIANCE_POPULATION_CLAIM_ID_ASC",
  REPORTED_CLAIMS_VARIANCE_POPULATION_CLAIM_ID_DESC = "REPORTED_CLAIMS_VARIANCE_POPULATION_CLAIM_ID_DESC",
  REPORTED_CLAIMS_VARIANCE_POPULATION_ID_ASC = "REPORTED_CLAIMS_VARIANCE_POPULATION_ID_ASC",
  REPORTED_CLAIMS_VARIANCE_POPULATION_ID_DESC = "REPORTED_CLAIMS_VARIANCE_POPULATION_ID_DESC",
  REPORTED_CLAIMS_VARIANCE_POPULATION_STRATEGY_ASC = "REPORTED_CLAIMS_VARIANCE_POPULATION_STRATEGY_ASC",
  REPORTED_CLAIMS_VARIANCE_POPULATION_STRATEGY_DESC = "REPORTED_CLAIMS_VARIANCE_POPULATION_STRATEGY_DESC",
  REPORTED_CLAIMS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_VARIANCE_SAMPLE_CLAIM_ID_ASC = "REPORTED_CLAIMS_VARIANCE_SAMPLE_CLAIM_ID_ASC",
  REPORTED_CLAIMS_VARIANCE_SAMPLE_CLAIM_ID_DESC = "REPORTED_CLAIMS_VARIANCE_SAMPLE_CLAIM_ID_DESC",
  REPORTED_CLAIMS_VARIANCE_SAMPLE_ID_ASC = "REPORTED_CLAIMS_VARIANCE_SAMPLE_ID_ASC",
  REPORTED_CLAIMS_VARIANCE_SAMPLE_ID_DESC = "REPORTED_CLAIMS_VARIANCE_SAMPLE_ID_DESC",
  REPORTED_CLAIMS_VARIANCE_SAMPLE_STRATEGY_ASC = "REPORTED_CLAIMS_VARIANCE_SAMPLE_STRATEGY_ASC",
  REPORTED_CLAIMS_VARIANCE_SAMPLE_STRATEGY_DESC = "REPORTED_CLAIMS_VARIANCE_SAMPLE_STRATEGY_DESC",
  REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_AVERAGE_CREATED_AT_ASC = "REPORTED_FINDINGS_AVERAGE_CREATED_AT_ASC",
  REPORTED_FINDINGS_AVERAGE_CREATED_AT_DESC = "REPORTED_FINDINGS_AVERAGE_CREATED_AT_DESC",
  REPORTED_FINDINGS_AVERAGE_ID_ASC = "REPORTED_FINDINGS_AVERAGE_ID_ASC",
  REPORTED_FINDINGS_AVERAGE_ID_DESC = "REPORTED_FINDINGS_AVERAGE_ID_DESC",
  REPORTED_FINDINGS_AVERAGE_UPDATED_AT_ASC = "REPORTED_FINDINGS_AVERAGE_UPDATED_AT_ASC",
  REPORTED_FINDINGS_AVERAGE_UPDATED_AT_DESC = "REPORTED_FINDINGS_AVERAGE_UPDATED_AT_DESC",
  REPORTED_FINDINGS_BY_AUDIT_FINDING_REPORT_ID__COUNT_ASC = "REPORTED_FINDINGS_BY_AUDIT_FINDING_REPORT_ID__COUNT_ASC",
  REPORTED_FINDINGS_BY_AUDIT_FINDING_REPORT_ID__COUNT_DESC = "REPORTED_FINDINGS_BY_AUDIT_FINDING_REPORT_ID__COUNT_DESC",
  REPORTED_FINDINGS_COUNT_ASC = "REPORTED_FINDINGS_COUNT_ASC",
  REPORTED_FINDINGS_COUNT_DESC = "REPORTED_FINDINGS_COUNT_DESC",
  REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC = "REPORTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC",
  REPORTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC = "REPORTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC",
  REPORTED_FINDINGS_DISTINCT_COUNT_ID_ASC = "REPORTED_FINDINGS_DISTINCT_COUNT_ID_ASC",
  REPORTED_FINDINGS_DISTINCT_COUNT_ID_DESC = "REPORTED_FINDINGS_DISTINCT_COUNT_ID_DESC",
  REPORTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC = "REPORTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC",
  REPORTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC = "REPORTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC",
  REPORTED_FINDINGS_MAX_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_MAX_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_MAX_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_MAX_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_MAX_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_MAX_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_MAX_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_MAX_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_MAX_CREATED_AT_ASC = "REPORTED_FINDINGS_MAX_CREATED_AT_ASC",
  REPORTED_FINDINGS_MAX_CREATED_AT_DESC = "REPORTED_FINDINGS_MAX_CREATED_AT_DESC",
  REPORTED_FINDINGS_MAX_ID_ASC = "REPORTED_FINDINGS_MAX_ID_ASC",
  REPORTED_FINDINGS_MAX_ID_DESC = "REPORTED_FINDINGS_MAX_ID_DESC",
  REPORTED_FINDINGS_MAX_UPDATED_AT_ASC = "REPORTED_FINDINGS_MAX_UPDATED_AT_ASC",
  REPORTED_FINDINGS_MAX_UPDATED_AT_DESC = "REPORTED_FINDINGS_MAX_UPDATED_AT_DESC",
  REPORTED_FINDINGS_MIN_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_MIN_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_MIN_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_MIN_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_MIN_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_MIN_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_MIN_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_MIN_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_MIN_CREATED_AT_ASC = "REPORTED_FINDINGS_MIN_CREATED_AT_ASC",
  REPORTED_FINDINGS_MIN_CREATED_AT_DESC = "REPORTED_FINDINGS_MIN_CREATED_AT_DESC",
  REPORTED_FINDINGS_MIN_ID_ASC = "REPORTED_FINDINGS_MIN_ID_ASC",
  REPORTED_FINDINGS_MIN_ID_DESC = "REPORTED_FINDINGS_MIN_ID_DESC",
  REPORTED_FINDINGS_MIN_UPDATED_AT_ASC = "REPORTED_FINDINGS_MIN_UPDATED_AT_ASC",
  REPORTED_FINDINGS_MIN_UPDATED_AT_DESC = "REPORTED_FINDINGS_MIN_UPDATED_AT_DESC",
  REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC = "REPORTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC",
  REPORTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC = "REPORTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC",
  REPORTED_FINDINGS_STDDEV_POPULATION_ID_ASC = "REPORTED_FINDINGS_STDDEV_POPULATION_ID_ASC",
  REPORTED_FINDINGS_STDDEV_POPULATION_ID_DESC = "REPORTED_FINDINGS_STDDEV_POPULATION_ID_DESC",
  REPORTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC = "REPORTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC",
  REPORTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC = "REPORTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC = "REPORTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC = "REPORTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_ID_ASC = "REPORTED_FINDINGS_STDDEV_SAMPLE_ID_ASC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_ID_DESC = "REPORTED_FINDINGS_STDDEV_SAMPLE_ID_DESC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC = "REPORTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC = "REPORTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  REPORTED_FINDINGS_SUM_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_SUM_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_SUM_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_SUM_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_SUM_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_SUM_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_SUM_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_SUM_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_SUM_CREATED_AT_ASC = "REPORTED_FINDINGS_SUM_CREATED_AT_ASC",
  REPORTED_FINDINGS_SUM_CREATED_AT_DESC = "REPORTED_FINDINGS_SUM_CREATED_AT_DESC",
  REPORTED_FINDINGS_SUM_ID_ASC = "REPORTED_FINDINGS_SUM_ID_ASC",
  REPORTED_FINDINGS_SUM_ID_DESC = "REPORTED_FINDINGS_SUM_ID_DESC",
  REPORTED_FINDINGS_SUM_UPDATED_AT_ASC = "REPORTED_FINDINGS_SUM_UPDATED_AT_ASC",
  REPORTED_FINDINGS_SUM_UPDATED_AT_DESC = "REPORTED_FINDINGS_SUM_UPDATED_AT_DESC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC = "REPORTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC = "REPORTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_ID_ASC = "REPORTED_FINDINGS_VARIANCE_POPULATION_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_ID_DESC = "REPORTED_FINDINGS_VARIANCE_POPULATION_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC = "REPORTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC = "REPORTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_ID_ASC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_ID_DESC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  S3_URL_ASC = "S3_URL_ASC",
  S3_URL_DESC = "S3_URL_DESC",
  S3_VERSION_ASC = "S3_VERSION_ASC",
  S3_VERSION_DESC = "S3_VERSION_DESC",
  TITLE_ASC = "TITLE_ASC",
  TITLE_DESC = "TITLE_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
  VIEW_ID_ASC = "VIEW_ID_ASC",
  VIEW_ID_DESC = "VIEW_ID_DESC",
}

export type AuditFindingReview = Node & {
  __typename?: "AuditFindingReview";
  /** Reads a single `AuditorUser` that is related to this `AuditFindingReview`. */
  author?: Maybe<AuditorUser>;
  authorId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `AuditFinding` that is related to this `AuditFindingReview`. */
  original?: Maybe<AuditFinding>;
  originalId: Scalars["UUID"]["output"];
  /** Reads a single `AuditFinding` that is related to this `AuditFindingReview`. */
  review?: Maybe<AuditFinding>;
  reviewId: Scalars["UUID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type AuditFindingReviewAggregates = {
  __typename?: "AuditFindingReviewAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuditFindingReviewDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `AuditFindingReview` object types. */
export type AuditFindingReviewAggregatesFilter = {
  /** Distinct count aggregate over matching `AuditFindingReview` objects. */
  distinctCount?: InputMaybe<AuditFindingReviewDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AuditFindingReview` object to be included within the aggregate. */
  filter?: InputMaybe<AuditFindingReviewFilter>;
};

/** The fields on `auditFindingReview` to look up the row to connect. */
export type AuditFindingReviewAuditFindingReviewPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `auditFindingReview` to look up the row to connect. */
export type AuditFindingReviewAuditFindingReviewReviewIdOriginalIdKeyConnect = {
  originalId: Scalars["UUID"]["input"];
  reviewId: Scalars["UUID"]["input"];
};

/** The fields on `auditFindingReview` to look up the row to connect. */
export type AuditFindingReviewAuditFindingReviewUniqueReviewIdConnect = {
  reviewId: Scalars["UUID"]["input"];
};

/** The `auditFindingReview` to be created by this mutation. */
export type AuditFindingReviewAuthorIdFkeyAuditFindingReviewCreateInput = {
  auditFindingToOriginalId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInput>;
  auditFindingToReviewId?: InputMaybe<AuditFindingReviewReviewIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  originalId?: InputMaybe<Scalars["UUID"]["input"]>;
  reviewId?: InputMaybe<Scalars["UUID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `AuditFindingReviewInput` mutation. */
export type AuditFindingReviewAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingReview` in the `AuditorUserInput` mutation. */
export type AuditFindingReviewAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuditFindingReviewAuditFindingReviewPkeyConnect>
  >;
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingReviewNodeIdConnect>>;
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectByReviewId?: InputMaybe<
    Array<AuditFindingReviewAuditFindingReviewUniqueReviewIdConnect>
  >;
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectByReviewIdAndOriginalId?: InputMaybe<
    Array<AuditFindingReviewAuditFindingReviewReviewIdOriginalIdKeyConnect>
  >;
  /** A `AuditFindingReviewInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditFindingReviewAuthorIdFkeyAuditFindingReviewCreateInput>
  >;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditFindingReviewPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyNodeIdUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateByReviewId?: InputMaybe<
    Array<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditFindingReviewUniqueReviewIdUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateByReviewIdAndOriginalId?: InputMaybe<
    Array<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditFindingReviewReviewIdOriginalIdKeyUpdate>
  >;
};

/**
 * A condition to be used against `AuditFindingReview` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuditFindingReviewCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `originalId` field. */
  originalId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `reviewId` field. */
  reviewId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type AuditFindingReviewDistinctCountAggregateFilter = {
  authorId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  originalId?: InputMaybe<BigIntFilter>;
  reviewId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type AuditFindingReviewDistinctCountAggregates = {
  __typename?: "AuditFindingReviewDistinctCountAggregates";
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of originalId across the matching connection */
  originalId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of reviewId across the matching connection */
  reviewId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `AuditFindingReview` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingReviewFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditFindingReviewFilter>>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditFindingReviewFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditFindingReviewFilter>>;
  /** Filter by the object’s `original` relation. */
  original?: InputMaybe<AuditFindingFilter>;
  /** Filter by the object’s `originalId` field. */
  originalId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `review` relation. */
  review?: InputMaybe<AuditFindingFilter>;
  /** Filter by the object’s `reviewId` field. */
  reviewId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `AuditFindingReview` for usage during aggregation. */
export enum AuditFindingReviewGroupBy {
  AUTHOR_ID = "AUTHOR_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  ORIGINAL_ID = "ORIGINAL_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type AuditFindingReviewHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReviewHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AuditFindingReview` aggregates. */
export type AuditFindingReviewHavingInput = {
  AND?: InputMaybe<Array<AuditFindingReviewHavingInput>>;
  OR?: InputMaybe<Array<AuditFindingReviewHavingInput>>;
  average?: InputMaybe<AuditFindingReviewHavingAverageInput>;
  distinctCount?: InputMaybe<AuditFindingReviewHavingDistinctCountInput>;
  max?: InputMaybe<AuditFindingReviewHavingMaxInput>;
  min?: InputMaybe<AuditFindingReviewHavingMinInput>;
  stddevPopulation?: InputMaybe<AuditFindingReviewHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuditFindingReviewHavingStddevSampleInput>;
  sum?: InputMaybe<AuditFindingReviewHavingSumInput>;
  variancePopulation?: InputMaybe<AuditFindingReviewHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuditFindingReviewHavingVarianceSampleInput>;
};

export type AuditFindingReviewHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReviewHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReviewHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReviewHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReviewHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReviewHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditFindingReviewHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `AuditFindingReview` */
export type AuditFindingReviewInput = {
  auditFindingToOriginalId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInput>;
  auditFindingToReviewId?: InputMaybe<AuditFindingReviewReviewIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  originalId?: InputMaybe<Scalars["UUID"]["input"]>;
  reviewId?: InputMaybe<Scalars["UUID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AuditFindingReviewNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `auditFindingReview` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `auditFindingReview` to look up the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditFindingReviewPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyPatch;
  };

/** The fields on `auditFindingReview` to look up the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditFindingReviewReviewIdOriginalIdKeyUpdate =
  {
    originalId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyPatch;
    reviewId: Scalars["UUID"]["input"];
  };

/** The fields on `auditFindingReview` to look up the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditFindingReviewUniqueReviewIdUpdate =
  {
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyPatch;
    reviewId: Scalars["UUID"]["input"];
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `auditFindingReview` to look up the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyUsingAuditFindingReviewPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyPatch;
  };

/** The fields on `auditFindingReview` to look up the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyUsingAuditFindingReviewReviewIdOriginalIdKeyUpdate =
  {
    originalId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyPatch;
    reviewId: Scalars["UUID"]["input"];
  };

/** The fields on `auditFindingReview` to look up the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyUsingAuditFindingReviewUniqueReviewIdUpdate =
  {
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyPatch;
    reviewId: Scalars["UUID"]["input"];
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `auditFindingReview` to look up the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyUsingAuditFindingReviewPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyPatch;
  };

/** The fields on `auditFindingReview` to look up the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyUsingAuditFindingReviewReviewIdOriginalIdKeyUpdate =
  {
    originalId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyPatch;
    reviewId: Scalars["UUID"]["input"];
  };

/** The fields on `auditFindingReview` to look up the row to update. */
export type AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyUsingAuditFindingReviewUniqueReviewIdUpdate =
  {
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyPatch;
    reviewId: Scalars["UUID"]["input"];
  };

/** The `auditFinding` to be created by this mutation. */
export type AuditFindingReviewOriginalIdFkeyAuditFindingCreateInput = {
  auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
  auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
  auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
  auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
  auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
  auditFindingSeedType: AuditFindingSeedType;
  auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
  auditType?: InputMaybe<AuditTypeEnum>;
  auditorComment?: InputMaybe<Scalars["String"]["input"]>;
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
  autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
  confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  improperPaymentCost: Scalars["Float"]["input"];
  improperPaymentReason: Scalars["String"]["input"];
  improperPaymentUnitsCharged: Scalars["Int"]["input"];
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview: Scalars["Boolean"]["input"];
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The `auditFindingReview` to be created by this mutation. */
export type AuditFindingReviewOriginalIdFkeyAuditFindingReviewCreateInput = {
  auditFindingToOriginalId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInput>;
  auditFindingToReviewId?: InputMaybe<AuditFindingReviewReviewIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  reviewId?: InputMaybe<Scalars["UUID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditFinding` in the `AuditFindingReviewInput` mutation. */
export type AuditFindingReviewOriginalIdFkeyInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingAuditFindingClaimLinePkeyConnect>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingNodeIdConnect>;
  /** A `AuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuditFindingReviewOriginalIdFkeyAuditFindingCreateInput>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyUsingAuditFindingClaimLinePkeyUpdate>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingReview` in the `AuditFindingInput` mutation. */
export type AuditFindingReviewOriginalIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuditFindingReviewAuditFindingReviewPkeyConnect>
  >;
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingReviewNodeIdConnect>>;
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectByReviewId?: InputMaybe<
    Array<AuditFindingReviewAuditFindingReviewUniqueReviewIdConnect>
  >;
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectByReviewIdAndOriginalId?: InputMaybe<
    Array<AuditFindingReviewAuditFindingReviewReviewIdOriginalIdKeyConnect>
  >;
  /** A `AuditFindingReviewInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditFindingReviewOriginalIdFkeyAuditFindingReviewCreateInput>
  >;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyUsingAuditFindingReviewPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditFindingOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyNodeIdUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateByReviewId?: InputMaybe<
    Array<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyUsingAuditFindingReviewUniqueReviewIdUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateByReviewIdAndOriginalId?: InputMaybe<
    Array<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyUsingAuditFindingReviewReviewIdOriginalIdKeyUpdate>
  >;
};

/** Represents an update to a `AuditFindingReview`. Fields that are set will be updated. */
export type AuditFindingReviewPatch = {
  auditFindingToOriginalId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInput>;
  auditFindingToReviewId?: InputMaybe<AuditFindingReviewReviewIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  originalId?: InputMaybe<Scalars["UUID"]["input"]>;
  reviewId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `auditFinding` to be created by this mutation. */
export type AuditFindingReviewReviewIdFkeyAuditFindingCreateInput = {
  auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
  auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
  auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
  auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
  auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
  auditFindingSeedType: AuditFindingSeedType;
  auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
  auditType?: InputMaybe<AuditTypeEnum>;
  auditorComment?: InputMaybe<Scalars["String"]["input"]>;
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
  autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
  confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  improperPaymentCost: Scalars["Float"]["input"];
  improperPaymentReason: Scalars["String"]["input"];
  improperPaymentUnitsCharged: Scalars["Int"]["input"];
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview: Scalars["Boolean"]["input"];
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The `auditFindingReview` to be created by this mutation. */
export type AuditFindingReviewReviewIdFkeyAuditFindingReviewCreateInput = {
  auditFindingToOriginalId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInput>;
  auditFindingToReviewId?: InputMaybe<AuditFindingReviewReviewIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  originalId?: InputMaybe<Scalars["UUID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditFinding` in the `AuditFindingReviewInput` mutation. */
export type AuditFindingReviewReviewIdFkeyInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingAuditFindingClaimLinePkeyConnect>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingNodeIdConnect>;
  /** A `AuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuditFindingReviewReviewIdFkeyAuditFindingCreateInput>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyUsingAuditFindingClaimLinePkeyUpdate>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingReview` in the `AuditFindingInput` mutation. */
export type AuditFindingReviewReviewIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingReviewAuditFindingReviewPkeyConnect>;
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingReviewNodeIdConnect>;
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectByReviewId?: InputMaybe<AuditFindingReviewAuditFindingReviewUniqueReviewIdConnect>;
  /** The primary key(s) for `auditFindingReview` for the far side of the relationship. */
  connectByReviewIdAndOriginalId?: InputMaybe<AuditFindingReviewAuditFindingReviewReviewIdOriginalIdKeyConnect>;
  /** A `AuditFindingReviewInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditFindingReviewReviewIdFkeyAuditFindingReviewCreateInput>
  >;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyUsingAuditFindingReviewPkeyUpdate>;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateByReviewId?: InputMaybe<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyUsingAuditFindingReviewUniqueReviewIdUpdate>;
  /** The primary key(s) and patch data for `auditFindingReview` for the far side of the relationship. */
  updateByReviewIdAndOriginalId?: InputMaybe<AuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyUsingAuditFindingReviewReviewIdOriginalIdKeyUpdate>;
};

export type AuditFindingReviewValuesInput = {
  auditFindingId: Scalars["UUID"]["input"];
  auditFindingValues: CreateAuditFindingValuesInput;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemValues?: InputMaybe<CreateBatchClaimLineItemValuesInput>;
};

/** A connection to a list of `AuditFindingReview` values. */
export type AuditFindingReviewsConnection = {
  __typename?: "AuditFindingReviewsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuditFindingReviewAggregates>;
  /** A list of edges which contains the `AuditFindingReview` and cursor to aid in pagination. */
  edges: Array<AuditFindingReviewsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuditFindingReviewAggregates>>;
  /** A list of `AuditFindingReview` objects. */
  nodes: Array<Maybe<AuditFindingReview>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditFindingReview` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `AuditFindingReview` values. */
export type AuditFindingReviewsConnectiongroupedAggregatesArgs = {
  groupBy: Array<AuditFindingReviewGroupBy>;
  having?: InputMaybe<AuditFindingReviewHavingInput>;
};

/** A `AuditFindingReview` edge in the connection. */
export type AuditFindingReviewsEdge = {
  __typename?: "AuditFindingReviewsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuditFindingReview` at the end of the edge. */
  node?: Maybe<AuditFindingReview>;
};

/** Methods to use when ordering `AuditFindingReview`. */
export enum AuditFindingReviewsOrderBy {
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDITOR_COMMENT_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDITOR_COMMENT_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDITOR_REVIEWED_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDITOR_REVIEWED_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDITOR_REVIEWED_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDITOR_REVIEWED_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_TYPE_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_TYPE_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_TYPE_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUDIT_TYPE_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUTODOR_FINDING_ID_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUTODOR_FINDING_ID_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUTOMATION_KIND_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUTOMATION_KIND_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUTOMATION_KIND_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUTOMATION_KIND_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__BATCH_CLAIM_ID_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__BATCH_CLAIM_ID_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__BATCH_CLAIM_ID_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__BATCH_CLAIM_ID_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__CONFIDENCE_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__CONFIDENCE_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__CONFIDENCE_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__CONFIDENCE_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__CREATED_AT_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__CREATED_AT_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__CREATED_AT_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__CREATED_AT_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__DELETED_AT_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__DELETED_AT_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__DELETED_AT_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__DELETED_AT_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__DELETED_BY_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__DELETED_BY_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__DELETED_BY_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__DELETED_BY_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__ID_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__ID_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__ID_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__ID_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_CODE_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_CODE_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_CODE_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_CODE_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__NEEDS_REVIEW_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__NEEDS_REVIEW_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__NEEDS_REVIEW_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__NEEDS_REVIEW_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDING_BY_ORIGINAL_ID__UPDATED_AT_ASC = "AUDIT_FINDING_BY_ORIGINAL_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_BY_ORIGINAL_ID__UPDATED_AT_DESC = "AUDIT_FINDING_BY_ORIGINAL_ID__UPDATED_AT_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDITOR_COMMENT_ASC = "AUDIT_FINDING_BY_REVIEW_ID__AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDITOR_COMMENT_DESC = "AUDIT_FINDING_BY_REVIEW_ID__AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDITOR_REVIEWED_ASC = "AUDIT_FINDING_BY_REVIEW_ID__AUDITOR_REVIEWED_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDITOR_REVIEWED_DESC = "AUDIT_FINDING_BY_REVIEW_ID__AUDITOR_REVIEWED_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDING_BY_REVIEW_ID__AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDIT_TYPE_ASC = "AUDIT_FINDING_BY_REVIEW_ID__AUDIT_TYPE_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__AUDIT_TYPE_DESC = "AUDIT_FINDING_BY_REVIEW_ID__AUDIT_TYPE_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_BY_REVIEW_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_BY_REVIEW_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__AUTODOR_FINDING_ID_ASC = "AUDIT_FINDING_BY_REVIEW_ID__AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__AUTODOR_FINDING_ID_DESC = "AUDIT_FINDING_BY_REVIEW_ID__AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDING_BY_REVIEW_ID__AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDING_BY_REVIEW_ID__AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__AUTOMATION_KIND_ASC = "AUDIT_FINDING_BY_REVIEW_ID__AUTOMATION_KIND_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__AUTOMATION_KIND_DESC = "AUDIT_FINDING_BY_REVIEW_ID__AUTOMATION_KIND_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDING_BY_REVIEW_ID__AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDING_BY_REVIEW_ID__AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__BATCH_CLAIM_ID_ASC = "AUDIT_FINDING_BY_REVIEW_ID__BATCH_CLAIM_ID_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__BATCH_CLAIM_ID_DESC = "AUDIT_FINDING_BY_REVIEW_ID__BATCH_CLAIM_ID_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_BY_REVIEW_ID__BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_BY_REVIEW_ID__BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__CONFIDENCE_ASC = "AUDIT_FINDING_BY_REVIEW_ID__CONFIDENCE_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__CONFIDENCE_DESC = "AUDIT_FINDING_BY_REVIEW_ID__CONFIDENCE_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__CREATED_AT_ASC = "AUDIT_FINDING_BY_REVIEW_ID__CREATED_AT_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__CREATED_AT_DESC = "AUDIT_FINDING_BY_REVIEW_ID__CREATED_AT_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__DELETED_AT_ASC = "AUDIT_FINDING_BY_REVIEW_ID__DELETED_AT_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__DELETED_AT_DESC = "AUDIT_FINDING_BY_REVIEW_ID__DELETED_AT_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__DELETED_BY_ASC = "AUDIT_FINDING_BY_REVIEW_ID__DELETED_BY_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__DELETED_BY_DESC = "AUDIT_FINDING_BY_REVIEW_ID__DELETED_BY_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__ID_ASC = "AUDIT_FINDING_BY_REVIEW_ID__ID_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__ID_DESC = "AUDIT_FINDING_BY_REVIEW_ID__ID_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_BY_REVIEW_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_CODE_ASC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_CODE_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_CODE_DESC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_CODE_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDING_BY_REVIEW_ID__META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__NEEDS_REVIEW_ASC = "AUDIT_FINDING_BY_REVIEW_ID__NEEDS_REVIEW_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__NEEDS_REVIEW_DESC = "AUDIT_FINDING_BY_REVIEW_ID__NEEDS_REVIEW_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDING_BY_REVIEW_ID__PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDING_BY_REVIEW_ID__PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDING_BY_REVIEW_ID__UPDATED_AT_ASC = "AUDIT_FINDING_BY_REVIEW_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_BY_REVIEW_ID__UPDATED_AT_DESC = "AUDIT_FINDING_BY_REVIEW_ID__UPDATED_AT_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  ORIGINAL_ID_ASC = "ORIGINAL_ID_ASC",
  ORIGINAL_ID_DESC = "ORIGINAL_ID_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  REVIEW_ID_ASC = "REVIEW_ID_ASC",
  REVIEW_ID_DESC = "REVIEW_ID_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type AuditFindingRuleType = Node & {
  __typename?: "AuditFindingRuleType";
  /** Reads and enables pagination through a set of `AuditFinding`. */
  auditFindingsByAuditFindingRuleType: AuditFindingsConnection;
  author?: Maybe<Scalars["String"]["output"]>;
  claimDataType: AuditFindingSeedType;
  deprecated?: Maybe<Scalars["Boolean"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  displayName: Scalars["String"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  rationaleTemplate?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
};

export type AuditFindingRuleTypeauditFindingsByAuditFindingRuleTypeArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingCondition>;
  filter?: InputMaybe<AuditFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingsOrderBy>>;
};

export type AuditFindingRuleTypeAggregates = {
  __typename?: "AuditFindingRuleTypeAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuditFindingRuleTypeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** The fields on `auditFindingRuleType` to look up the row to connect. */
export type AuditFindingRuleTypeAuditFindingRuleTypePkeyConnect = {
  type: Scalars["String"]["input"];
};

/**
 * A condition to be used against `AuditFindingRuleType` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AuditFindingRuleTypeCondition = {
  /** Checks for equality with the object’s `author` field. */
  author?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `claimDataType` field. */
  claimDataType?: InputMaybe<AuditFindingSeedType>;
  /** Checks for equality with the object’s `deprecated` field. */
  deprecated?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `displayName` field. */
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `rationaleTemplate` field. */
  rationaleTemplate?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type AuditFindingRuleTypeDistinctCountAggregates = {
  __typename?: "AuditFindingRuleTypeDistinctCountAggregates";
  /** Distinct count of author across the matching connection */
  author?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of claimDataType across the matching connection */
  claimDataType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of deprecated across the matching connection */
  deprecated?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of displayName across the matching connection */
  displayName?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of rationaleTemplate across the matching connection */
  rationaleTemplate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `AuditFindingRuleType` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingRuleTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditFindingRuleTypeFilter>>;
  /** Filter by the object’s `auditFindingsByAuditFindingRuleType` relation. */
  auditFindingsByAuditFindingRuleType?: InputMaybe<AuditFindingRuleTypeToManyAuditFindingFilter>;
  /** Some related `auditFindingsByAuditFindingRuleType` exist. */
  auditFindingsByAuditFindingRuleTypeExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `author` field. */
  author?: InputMaybe<StringFilter>;
  /** Filter by the object’s `claimDataType` field. */
  claimDataType?: InputMaybe<AuditFindingSeedTypeFilter>;
  /** Filter by the object’s `deprecated` field. */
  deprecated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditFindingRuleTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditFindingRuleTypeFilter>>;
  /** Filter by the object’s `rationaleTemplate` field. */
  rationaleTemplate?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** Grouping methods for `AuditFindingRuleType` for usage during aggregation. */
export enum AuditFindingRuleTypeGroupBy {
  AUTHOR = "AUTHOR",
  CLAIM_DATA_TYPE = "CLAIM_DATA_TYPE",
  DEPRECATED = "DEPRECATED",
  DESCRIPTION = "DESCRIPTION",
  DISPLAY_NAME = "DISPLAY_NAME",
  RATIONALE_TEMPLATE = "RATIONALE_TEMPLATE",
}

/** Conditions for `AuditFindingRuleType` aggregates. */
export type AuditFindingRuleTypeHavingInput = {
  AND?: InputMaybe<Array<AuditFindingRuleTypeHavingInput>>;
  OR?: InputMaybe<Array<AuditFindingRuleTypeHavingInput>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AuditFindingRuleTypeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `auditFindingRuleType` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type AuditFindingRuleTypeOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `auditFindingRuleType` to look up the row to update. */
export type AuditFindingRuleTypeOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyUsingAuditFindingRuleTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `auditFindingRuleType` being updated. */
    patch: updateAuditFindingRuleTypeOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyPatch;
    type: Scalars["String"]["input"];
  };

/** Represents an update to a `AuditFindingRuleType`. Fields that are set will be updated. */
export type AuditFindingRuleTypePatch = {
  auditFindingsUsingType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInverseInput>;
};

/** A filter to be used against many `AuditFinding` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingRuleTypeToManyAuditFindingFilter = {
  /** Aggregates across related `AuditFinding` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingAggregatesFilter>;
  /** Every related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingFilter>;
  /** No related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingFilter>;
  /** Some related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingFilter>;
};

/** A connection to a list of `AuditFindingRuleType` values. */
export type AuditFindingRuleTypesConnection = {
  __typename?: "AuditFindingRuleTypesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuditFindingRuleTypeAggregates>;
  /** A list of edges which contains the `AuditFindingRuleType` and cursor to aid in pagination. */
  edges: Array<AuditFindingRuleTypesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuditFindingRuleTypeAggregates>>;
  /** A list of `AuditFindingRuleType` objects. */
  nodes: Array<Maybe<AuditFindingRuleType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditFindingRuleType` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `AuditFindingRuleType` values. */
export type AuditFindingRuleTypesConnectiongroupedAggregatesArgs = {
  groupBy: Array<AuditFindingRuleTypeGroupBy>;
  having?: InputMaybe<AuditFindingRuleTypeHavingInput>;
};

/** A `AuditFindingRuleType` edge in the connection. */
export type AuditFindingRuleTypesEdge = {
  __typename?: "AuditFindingRuleTypesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuditFindingRuleType` at the end of the edge. */
  node?: Maybe<AuditFindingRuleType>;
};

/** Methods to use when ordering `AuditFindingRuleType`. */
export enum AuditFindingRuleTypesOrderBy {
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_COUNT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_COUNT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_COUNT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_COUNT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MAX_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_MIN_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_SUM_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE__COUNT_ASC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE__COUNT_ASC",
  AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE__COUNT_DESC = "AUDIT_FINDINGS_BY_AUDIT_FINDING_RULE_TYPE__COUNT_DESC",
  AUTHOR_ASC = "AUTHOR_ASC",
  AUTHOR_DESC = "AUTHOR_DESC",
  CLAIM_DATA_TYPE_ASC = "CLAIM_DATA_TYPE_ASC",
  CLAIM_DATA_TYPE_DESC = "CLAIM_DATA_TYPE_DESC",
  DEPRECATED_ASC = "DEPRECATED_ASC",
  DEPRECATED_DESC = "DEPRECATED_DESC",
  DESCRIPTION_ASC = "DESCRIPTION_ASC",
  DESCRIPTION_DESC = "DESCRIPTION_DESC",
  DISPLAY_NAME_ASC = "DISPLAY_NAME_ASC",
  DISPLAY_NAME_DESC = "DISPLAY_NAME_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  RATIONALE_TEMPLATE_ASC = "RATIONALE_TEMPLATE_ASC",
  RATIONALE_TEMPLATE_DESC = "RATIONALE_TEMPLATE_DESC",
  TYPE_ASC = "TYPE_ASC",
  TYPE_DESC = "TYPE_DESC",
}

export enum AuditFindingSeedType {
  /** Audit finding for an Itemlized Bill line item */
  IB_CLAIM_LINE = "IB_CLAIM_LINE",
  /** Audit finding for a UB04 claim */
  UB_CLAIM = "UB_CLAIM",
  /** Audit finding for a UB04 claim line */
  UB_CLAIM_LINE = "UB_CLAIM_LINE",
}

/** A filter to be used against AuditFindingSeedType fields. All fields are combined with a logical ‘and.’ */
export type AuditFindingSeedTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AuditFindingSeedType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AuditFindingSeedType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AuditFindingSeedType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AuditFindingSeedType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AuditFindingSeedType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AuditFindingSeedType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AuditFindingSeedType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AuditFindingSeedType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AuditFindingSeedType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AuditFindingSeedType>>;
};

export type AuditFindingStddevPopulationAggregateFilter = {
  confidence?: InputMaybe<BigFloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  discrepantAmount?: InputMaybe<FloatFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<BigFloatFilter>;
  metaDataEmCorrectLevel?: InputMaybe<BigFloatFilter>;
  metaDataEmOriginalLevel?: InputMaybe<BigFloatFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<BigFloatFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<BigFloatFilter>;
  metaDataNcciPtpModifier?: InputMaybe<BigFloatFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<BigFloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<BigFloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
};

export type AuditFindingStddevPopulationAggregates = {
  __typename?: "AuditFindingStddevPopulationAggregates";
  /** Population standard deviation of confidence across the matching connection */
  confidence?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of this field across the matching connection. */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of this field across the matching connection. */
  discrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of improperPaymentCost across the matching connection */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of improperPaymentUnitsCharged across the matching connection */
  improperPaymentUnitsCharged?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of metaDataEmCorrectLevel across the matching connection */
  metaDataEmCorrectLevel?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of metaDataEmOriginalLevel across the matching connection */
  metaDataEmOriginalLevel?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of metaDataNcciMueAjudicationValue across the matching connection */
  metaDataNcciMueAjudicationValue?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of metaDataNcciMueOhpMueValue across the matching connection */
  metaDataNcciMueOhpMueValue?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of metaDataNcciPtpModifier across the matching connection */
  metaDataNcciPtpModifier?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of metaDataPricingCorrectPrice across the matching connection */
  metaDataPricingCorrectPrice?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of metaDataUnitsCorrectUnits across the matching connection */
  metaDataUnitsCorrectUnits?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of this field across the matching connection. */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditFindingStddevSampleAggregateFilter = {
  confidence?: InputMaybe<BigFloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  discrepantAmount?: InputMaybe<FloatFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<BigFloatFilter>;
  metaDataEmCorrectLevel?: InputMaybe<BigFloatFilter>;
  metaDataEmOriginalLevel?: InputMaybe<BigFloatFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<BigFloatFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<BigFloatFilter>;
  metaDataNcciPtpModifier?: InputMaybe<BigFloatFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<BigFloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<BigFloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
};

export type AuditFindingStddevSampleAggregates = {
  __typename?: "AuditFindingStddevSampleAggregates";
  /** Sample standard deviation of confidence across the matching connection */
  confidence?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of this field across the matching connection. */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of this field across the matching connection. */
  discrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of improperPaymentCost across the matching connection */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of improperPaymentUnitsCharged across the matching connection */
  improperPaymentUnitsCharged?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of metaDataEmCorrectLevel across the matching connection */
  metaDataEmCorrectLevel?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of metaDataEmOriginalLevel across the matching connection */
  metaDataEmOriginalLevel?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of metaDataNcciMueAjudicationValue across the matching connection */
  metaDataNcciMueAjudicationValue?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of metaDataNcciMueOhpMueValue across the matching connection */
  metaDataNcciMueOhpMueValue?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of metaDataNcciPtpModifier across the matching connection */
  metaDataNcciPtpModifier?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of metaDataPricingCorrectPrice across the matching connection */
  metaDataPricingCorrectPrice?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of metaDataUnitsCorrectUnits across the matching connection */
  metaDataUnitsCorrectUnits?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of this field across the matching connection. */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditFindingSumAggregateFilter = {
  confidence?: InputMaybe<BigFloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  discrepantAmount?: InputMaybe<FloatFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<BigIntFilter>;
  metaDataEmCorrectLevel?: InputMaybe<BigIntFilter>;
  metaDataEmOriginalLevel?: InputMaybe<BigIntFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<BigIntFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<BigIntFilter>;
  metaDataNcciPtpModifier?: InputMaybe<BigIntFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<BigFloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<BigIntFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
};

export type AuditFindingSumAggregates = {
  __typename?: "AuditFindingSumAggregates";
  /** Sum of confidence across the matching connection */
  confidence: Scalars["BigFloat"]["output"];
  /** Sum of this field across the matching connection. */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Sum of this field across the matching connection. */
  discrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sum of improperPaymentCost across the matching connection */
  improperPaymentCost: Scalars["Float"]["output"];
  /** Sum of improperPaymentUnitsCharged across the matching connection */
  improperPaymentUnitsCharged: Scalars["BigInt"]["output"];
  /** Sum of metaDataEmCorrectLevel across the matching connection */
  metaDataEmCorrectLevel: Scalars["BigInt"]["output"];
  /** Sum of metaDataEmOriginalLevel across the matching connection */
  metaDataEmOriginalLevel: Scalars["BigInt"]["output"];
  /** Sum of metaDataNcciMueAjudicationValue across the matching connection */
  metaDataNcciMueAjudicationValue: Scalars["BigInt"]["output"];
  /** Sum of metaDataNcciMueOhpMueValue across the matching connection */
  metaDataNcciMueOhpMueValue: Scalars["BigInt"]["output"];
  /** Sum of metaDataNcciPtpModifier across the matching connection */
  metaDataNcciPtpModifier: Scalars["BigInt"]["output"];
  /** Sum of metaDataPricingCorrectPrice across the matching connection */
  metaDataPricingCorrectPrice: Scalars["BigFloat"]["output"];
  /** Sum of metaDataUnitsCorrectUnits across the matching connection */
  metaDataUnitsCorrectUnits: Scalars["BigInt"]["output"];
  /** Sum of this field across the matching connection. */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditFindingSummary = {
  __typename?: "AuditFindingSummary";
  accepted: Scalars["Boolean"]["output"];
  auditFindingRuleType?: Maybe<Scalars["String"]["output"]>;
  auditFindingSeedType?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  improperPaymentReason?: Maybe<Scalars["String"]["output"]>;
  improperPaymentUnitsCharged?: Maybe<Scalars["Int"]["output"]>;
  isActive: Scalars["Boolean"]["output"];
};

/** A filter to be used against many `AuditFinding` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingToManyAuditFindingFilter = {
  /** Aggregates across related `AuditFinding` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingAggregatesFilter>;
  /** Every related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingFilter>;
  /** No related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingFilter>;
  /** Some related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingFilter>;
};

/** A filter to be used against many `AuditFindingReasonCode` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingToManyAuditFindingReasonCodeFilter = {
  /** Aggregates across related `AuditFindingReasonCode` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingReasonCodeAggregatesFilter>;
  /** Every related `AuditFindingReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingReasonCodeFilter>;
  /** No related `AuditFindingReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingReasonCodeFilter>;
  /** Some related `AuditFindingReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingReasonCodeFilter>;
};

/** A filter to be used against many `AuditFindingReview` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingToManyAuditFindingReviewFilter = {
  /** Aggregates across related `AuditFindingReview` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingReviewAggregatesFilter>;
  /** Every related `AuditFindingReview` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingReviewFilter>;
  /** No related `AuditFindingReview` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingReviewFilter>;
  /** Some related `AuditFindingReview` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingReviewFilter>;
};

/** A filter to be used against many `ReportedFinding` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingToManyReportedFindingFilter = {
  /** Aggregates across related `ReportedFinding` match the filter criteria. */
  aggregates?: InputMaybe<ReportedFindingAggregatesFilter>;
  /** Every related `ReportedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ReportedFindingFilter>;
  /** No related `ReportedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ReportedFindingFilter>;
  /** Some related `ReportedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ReportedFindingFilter>;
};

/** A filter to be used against many `ReviewedAuditFinding` object types. All fields are combined with a logical ‘and.’ */
export type AuditFindingToManyReviewedAuditFindingFilter = {
  /** Aggregates across related `ReviewedAuditFinding` match the filter criteria. */
  aggregates?: InputMaybe<ReviewedAuditFindingAggregatesFilter>;
  /** Every related `ReviewedAuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ReviewedAuditFindingFilter>;
  /** No related `ReviewedAuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ReviewedAuditFindingFilter>;
  /** Some related `ReviewedAuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ReviewedAuditFindingFilter>;
};

export type AuditFindingValuesInputV2 = {
  auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
  confidence?: InputMaybe<Scalars["Int"]["input"]>;
  improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
  improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
  improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AuditFindingVariancePopulationAggregateFilter = {
  confidence?: InputMaybe<BigFloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  discrepantAmount?: InputMaybe<FloatFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<BigFloatFilter>;
  metaDataEmCorrectLevel?: InputMaybe<BigFloatFilter>;
  metaDataEmOriginalLevel?: InputMaybe<BigFloatFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<BigFloatFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<BigFloatFilter>;
  metaDataNcciPtpModifier?: InputMaybe<BigFloatFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<BigFloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<BigFloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
};

export type AuditFindingVariancePopulationAggregates = {
  __typename?: "AuditFindingVariancePopulationAggregates";
  /** Population variance of confidence across the matching connection */
  confidence?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of this field across the matching connection. */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of this field across the matching connection. */
  discrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of improperPaymentCost across the matching connection */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of improperPaymentUnitsCharged across the matching connection */
  improperPaymentUnitsCharged?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of metaDataEmCorrectLevel across the matching connection */
  metaDataEmCorrectLevel?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of metaDataEmOriginalLevel across the matching connection */
  metaDataEmOriginalLevel?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of metaDataNcciMueAjudicationValue across the matching connection */
  metaDataNcciMueAjudicationValue?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of metaDataNcciMueOhpMueValue across the matching connection */
  metaDataNcciMueOhpMueValue?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of metaDataNcciPtpModifier across the matching connection */
  metaDataNcciPtpModifier?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of metaDataPricingCorrectPrice across the matching connection */
  metaDataPricingCorrectPrice?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of metaDataUnitsCorrectUnits across the matching connection */
  metaDataUnitsCorrectUnits?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of this field across the matching connection. */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditFindingVarianceSampleAggregateFilter = {
  confidence?: InputMaybe<BigFloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  discrepantAmount?: InputMaybe<FloatFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  improperPaymentUnitsCharged?: InputMaybe<BigFloatFilter>;
  metaDataEmCorrectLevel?: InputMaybe<BigFloatFilter>;
  metaDataEmOriginalLevel?: InputMaybe<BigFloatFilter>;
  metaDataNcciMueAjudicationValue?: InputMaybe<BigFloatFilter>;
  metaDataNcciMueOhpMueValue?: InputMaybe<BigFloatFilter>;
  metaDataNcciPtpModifier?: InputMaybe<BigFloatFilter>;
  metaDataPricingCorrectPrice?: InputMaybe<BigFloatFilter>;
  metaDataUnitsCorrectUnits?: InputMaybe<BigFloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
};

export type AuditFindingVarianceSampleAggregates = {
  __typename?: "AuditFindingVarianceSampleAggregates";
  /** Sample variance of confidence across the matching connection */
  confidence?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of this field across the matching connection. */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of this field across the matching connection. */
  discrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of improperPaymentCost across the matching connection */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of improperPaymentUnitsCharged across the matching connection */
  improperPaymentUnitsCharged?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of metaDataEmCorrectLevel across the matching connection */
  metaDataEmCorrectLevel?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of metaDataEmOriginalLevel across the matching connection */
  metaDataEmOriginalLevel?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of metaDataNcciMueAjudicationValue across the matching connection */
  metaDataNcciMueAjudicationValue?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of metaDataNcciMueOhpMueValue across the matching connection */
  metaDataNcciMueOhpMueValue?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of metaDataNcciPtpModifier across the matching connection */
  metaDataNcciPtpModifier?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of metaDataPricingCorrectPrice across the matching connection */
  metaDataPricingCorrectPrice?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of metaDataUnitsCorrectUnits across the matching connection */
  metaDataUnitsCorrectUnits?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of this field across the matching connection. */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
};

/** A connection to a list of `AuditFinding` values. */
export type AuditFindingsConnection = {
  __typename?: "AuditFindingsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuditFindingAggregates>;
  /** A list of edges which contains the `AuditFinding` and cursor to aid in pagination. */
  edges: Array<AuditFindingsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuditFindingAggregates>>;
  /** A list of `AuditFinding` objects. */
  nodes: Array<Maybe<AuditFinding>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditFinding` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `AuditFinding` values. */
export type AuditFindingsConnectiongroupedAggregatesArgs = {
  groupBy: Array<AuditFindingGroupBy>;
  having?: InputMaybe<AuditFindingHavingInput>;
};

/** A `AuditFinding` edge in the connection. */
export type AuditFindingsEdge = {
  __typename?: "AuditFindingsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuditFinding` at the end of the edge. */
  node?: Maybe<AuditFinding>;
};

/** Methods to use when ordering `AuditFinding`. */
export enum AuditFindingsOrderBy {
  AUDITOR_COMMENT_ASC = "AUDITOR_COMMENT_ASC",
  AUDITOR_COMMENT_DESC = "AUDITOR_COMMENT_DESC",
  AUDITOR_REVIEWED_ASC = "AUDITOR_REVIEWED_ASC",
  AUDITOR_REVIEWED_DESC = "AUDITOR_REVIEWED_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_COUNT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_COUNT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_COUNT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_COUNT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MAX_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_MIN_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_SUM_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CONFIDENCE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CONFIDENCE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DELETED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DELETED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DELETED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DELETED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DELETED_BY_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DELETED_BY_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DELETED_BY_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DELETED_BY_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID__COUNT_ASC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID__COUNT_ASC",
  AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID__COUNT_DESC = "AUDIT_FINDINGS_BY_PREVIOUS_VERSION_ID__COUNT_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDITOR_COMMENT_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDITOR_COMMENT_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDITOR_REVIEWED_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDITOR_REVIEWED_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDITOR_REVIEWED_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDITOR_REVIEWED_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_TYPE_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_TYPE_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_TYPE_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUDIT_TYPE_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTODOR_FINDING_ID_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTODOR_FINDING_ID_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTOMATION_KIND_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTOMATION_KIND_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTOMATION_KIND_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTOMATION_KIND_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__BATCH_CLAIM_ID_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__BATCH_CLAIM_ID_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__BATCH_CLAIM_ID_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__BATCH_CLAIM_ID_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__CONFIDENCE_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__CONFIDENCE_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__CONFIDENCE_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__CONFIDENCE_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__CREATED_AT_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__CREATED_AT_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__CREATED_AT_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__CREATED_AT_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__DELETED_AT_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__DELETED_AT_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__DELETED_AT_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__DELETED_AT_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__DELETED_BY_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__DELETED_BY_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__DELETED_BY_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__DELETED_BY_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__ID_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__ID_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__ID_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__ID_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_CODE_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_CODE_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_CODE_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_CODE_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__NEEDS_REVIEW_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__NEEDS_REVIEW_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__NEEDS_REVIEW_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__NEEDS_REVIEW_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__UPDATED_AT_ASC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__UPDATED_AT_DESC = "AUDIT_FINDING_BY_PREVIOUS_VERSION_ID__UPDATED_AT_DESC",
  AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__BATCH_FILE_ID_ASC = "AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__BATCH_FILE_ID_ASC",
  AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__BATCH_FILE_ID_DESC = "AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__BATCH_FILE_ID_DESC",
  AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__CREATED_AT_ASC = "AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__CREATED_AT_ASC",
  AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__CREATED_AT_DESC = "AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__CREATED_AT_DESC",
  AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__ID_ASC = "AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__ID_ASC",
  AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__ID_DESC = "AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__ID_DESC",
  AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__UPDATED_AT_ASC = "AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__UPDATED_AT_DESC = "AUDIT_FINDING_JOB_BY_AUDIT_FINDING_JOB_ID__UPDATED_AT_DESC",
  AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_ID_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_ID_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_BY_AUDIT_FINDING_ID__COUNT_ASC = "AUDIT_FINDING_REASON_CODES_BY_AUDIT_FINDING_ID__COUNT_ASC",
  AUDIT_FINDING_REASON_CODES_BY_AUDIT_FINDING_ID__COUNT_DESC = "AUDIT_FINDING_REASON_CODES_BY_AUDIT_FINDING_ID__COUNT_DESC",
  AUDIT_FINDING_REASON_CODES_COUNT_ASC = "AUDIT_FINDING_REASON_CODES_COUNT_ASC",
  AUDIT_FINDING_REASON_CODES_COUNT_DESC = "AUDIT_FINDING_REASON_CODES_COUNT_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_ID_ASC = "AUDIT_FINDING_REASON_CODES_MAX_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_ID_DESC = "AUDIT_FINDING_REASON_CODES_MAX_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_ID_ASC = "AUDIT_FINDING_REASON_CODES_MIN_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_ID_DESC = "AUDIT_FINDING_REASON_CODES_MIN_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_ID_ASC = "AUDIT_FINDING_REASON_CODES_SUM_ID_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_ID_DESC = "AUDIT_FINDING_REASON_CODES_SUM_ID_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_ORIGINAL_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_ORIGINAL_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_ORIGINAL_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_ORIGINAL_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_REVIEW_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_REVIEW_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_REVIEW_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_REVIEW_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_COUNT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_COUNT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_COUNT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_COUNT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_ORIGINAL_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_ORIGINAL_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_ORIGINAL_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_ORIGINAL_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_REVIEW_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_REVIEW_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_REVIEW_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_REVIEW_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_AUTHOR_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_AUTHOR_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_CREATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_CREATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_CREATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_CREATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_ORIGINAL_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_ORIGINAL_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_ORIGINAL_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_ORIGINAL_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_REVIEW_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_REVIEW_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_REVIEW_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_REVIEW_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_UPDATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_UPDATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_UPDATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MAX_UPDATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_AUTHOR_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_AUTHOR_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_CREATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_CREATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_CREATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_CREATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_ORIGINAL_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_ORIGINAL_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_ORIGINAL_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_ORIGINAL_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_REVIEW_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_REVIEW_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_REVIEW_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_REVIEW_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_UPDATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_UPDATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_UPDATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_MIN_UPDATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_ORIGINAL_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_ORIGINAL_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_ORIGINAL_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_ORIGINAL_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_REVIEW_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_REVIEW_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_REVIEW_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_REVIEW_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_ORIGINAL_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_ORIGINAL_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_ORIGINAL_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_ORIGINAL_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_REVIEW_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_REVIEW_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_REVIEW_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_REVIEW_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_AUTHOR_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_AUTHOR_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_CREATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_CREATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_CREATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_CREATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_ORIGINAL_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_ORIGINAL_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_ORIGINAL_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_ORIGINAL_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_REVIEW_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_REVIEW_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_REVIEW_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_REVIEW_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_UPDATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_UPDATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_UPDATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_SUM_UPDATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_ORIGINAL_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_ORIGINAL_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_ORIGINAL_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_ORIGINAL_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_REVIEW_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_REVIEW_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_REVIEW_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_REVIEW_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_ORIGINAL_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_ORIGINAL_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_ORIGINAL_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_ORIGINAL_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_REVIEW_ID_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_REVIEW_ID_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_REVIEW_ID_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_REVIEW_ID_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID__COUNT_ASC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID__COUNT_ASC",
  AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID__COUNT_DESC = "AUDIT_FINDING_REVIEWS_BY_ORIGINAL_ID__COUNT_DESC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__CREATED_AT_ASC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__CREATED_AT_ASC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__CREATED_AT_DESC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__CREATED_AT_DESC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__ID_ASC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__ID_ASC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__ID_DESC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__ID_DESC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__ORIGINAL_ID_ASC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__ORIGINAL_ID_ASC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__ORIGINAL_ID_DESC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__ORIGINAL_ID_DESC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__REVIEW_ID_ASC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__REVIEW_ID_ASC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__REVIEW_ID_DESC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__REVIEW_ID_DESC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__UPDATED_AT_ASC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_REVIEW_BY_REVIEW_ID__UPDATED_AT_DESC = "AUDIT_FINDING_REVIEW_BY_REVIEW_ID__UPDATED_AT_DESC",
  AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__AUTHOR_ASC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__AUTHOR_ASC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__AUTHOR_DESC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__AUTHOR_DESC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__CLAIM_DATA_TYPE_ASC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__CLAIM_DATA_TYPE_ASC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__CLAIM_DATA_TYPE_DESC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__CLAIM_DATA_TYPE_DESC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DEPRECATED_ASC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DEPRECATED_ASC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DEPRECATED_DESC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DEPRECATED_DESC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DESCRIPTION_ASC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DESCRIPTION_ASC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DESCRIPTION_DESC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DESCRIPTION_DESC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DISPLAY_NAME_ASC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DISPLAY_NAME_ASC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DISPLAY_NAME_DESC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__DISPLAY_NAME_DESC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__RATIONALE_TEMPLATE_ASC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__RATIONALE_TEMPLATE_ASC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__RATIONALE_TEMPLATE_DESC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__RATIONALE_TEMPLATE_DESC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__TYPE_ASC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__TYPE_ASC",
  AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__TYPE_DESC = "AUDIT_FINDING_RULE_TYPE_BY_AUDIT_FINDING_RULE_TYPE__TYPE_DESC",
  AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_TYPE_ASC = "AUDIT_TYPE_ASC",
  AUDIT_TYPE_DESC = "AUDIT_TYPE_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  AUTODOR_FINDING_ID_ASC = "AUTODOR_FINDING_ID_ASC",
  AUTODOR_FINDING_ID_DESC = "AUTODOR_FINDING_ID_DESC",
  AUTODOR_FINDING_S3_KEY_ASC = "AUTODOR_FINDING_S3_KEY_ASC",
  AUTODOR_FINDING_S3_KEY_DESC = "AUTODOR_FINDING_S3_KEY_DESC",
  AUTOMATION_KIND_ASC = "AUTOMATION_KIND_ASC",
  AUTOMATION_KIND_DESC = "AUTOMATION_KIND_DESC",
  AUTOMATION_SOURCE_ID_ASC = "AUTOMATION_SOURCE_ID_ASC",
  AUTOMATION_SOURCE_ID_DESC = "AUTOMATION_SOURCE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CREATED_AT_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CREATED_AT_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CREATED_AT_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CREATED_AT_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__ID_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__ID_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__ID_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__ID_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_SRC_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_SRC_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__SERVICE_DATE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__SERVICE_DATE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__SERVICE_DATE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__SERVICE_DATE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNITS_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNITS_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNITS_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNITS_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UPDATED_AT_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UPDATED_AT_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__AUDIT_FINDING_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__AUDIT_FINDING_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__AUDIT_FINDING_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__AUDIT_FINDING_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDIT_BY_AUDIT_FINDING_ID__UPDATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_AVERAGE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_COUNT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_COUNT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_COUNT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_COUNT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_DISTINCT_COUNT_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MAX_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_MIN_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_SUM_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_AUDIT_FINDING_CLAIM_LINE_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  CONFIDENCE_ASC = "CONFIDENCE_ASC",
  CONFIDENCE_DESC = "CONFIDENCE_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DELETED_AT_ASC = "DELETED_AT_ASC",
  DELETED_AT_DESC = "DELETED_AT_DESC",
  DELETED_BY_ASC = "DELETED_BY_ASC",
  DELETED_BY_DESC = "DELETED_BY_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  IMPROPER_PAYMENT_COST_ASC = "IMPROPER_PAYMENT_COST_ASC",
  IMPROPER_PAYMENT_COST_DESC = "IMPROPER_PAYMENT_COST_DESC",
  IMPROPER_PAYMENT_REASON_ASC = "IMPROPER_PAYMENT_REASON_ASC",
  IMPROPER_PAYMENT_REASON_DESC = "IMPROPER_PAYMENT_REASON_DESC",
  IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  META_DATA_AOC_PRIMARY_CODE_ASC = "META_DATA_AOC_PRIMARY_CODE_ASC",
  META_DATA_AOC_PRIMARY_CODE_DESC = "META_DATA_AOC_PRIMARY_CODE_DESC",
  META_DATA_EM_CODE_ASC = "META_DATA_EM_CODE_ASC",
  META_DATA_EM_CODE_DESC = "META_DATA_EM_CODE_DESC",
  META_DATA_EM_CORRECT_LEVEL_ASC = "META_DATA_EM_CORRECT_LEVEL_ASC",
  META_DATA_EM_CORRECT_LEVEL_DESC = "META_DATA_EM_CORRECT_LEVEL_DESC",
  META_DATA_EM_ORIGINAL_LEVEL_ASC = "META_DATA_EM_ORIGINAL_LEVEL_ASC",
  META_DATA_EM_ORIGINAL_LEVEL_DESC = "META_DATA_EM_ORIGINAL_LEVEL_DESC",
  META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  META_DATA_NCCI_PTP_CODE_ASC = "META_DATA_NCCI_PTP_CODE_ASC",
  META_DATA_NCCI_PTP_CODE_DESC = "META_DATA_NCCI_PTP_CODE_DESC",
  META_DATA_NCCI_PTP_MODIFIER_ASC = "META_DATA_NCCI_PTP_MODIFIER_ASC",
  META_DATA_NCCI_PTP_MODIFIER_DESC = "META_DATA_NCCI_PTP_MODIFIER_DESC",
  META_DATA_PRICING_CORRECT_PRICE_ASC = "META_DATA_PRICING_CORRECT_PRICE_ASC",
  META_DATA_PRICING_CORRECT_PRICE_DESC = "META_DATA_PRICING_CORRECT_PRICE_DESC",
  META_DATA_UNITS_CORRECT_UNITS_ASC = "META_DATA_UNITS_CORRECT_UNITS_ASC",
  META_DATA_UNITS_CORRECT_UNITS_DESC = "META_DATA_UNITS_CORRECT_UNITS_DESC",
  NATURAL = "NATURAL",
  NEEDS_REVIEW_ASC = "NEEDS_REVIEW_ASC",
  NEEDS_REVIEW_DESC = "NEEDS_REVIEW_DESC",
  PREVIOUS_VERSION_ID_ASC = "PREVIOUS_VERSION_ID_ASC",
  PREVIOUS_VERSION_ID_DESC = "PREVIOUS_VERSION_ID_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_AVERAGE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_AVERAGE_CREATED_AT_ASC = "REPORTED_FINDINGS_AVERAGE_CREATED_AT_ASC",
  REPORTED_FINDINGS_AVERAGE_CREATED_AT_DESC = "REPORTED_FINDINGS_AVERAGE_CREATED_AT_DESC",
  REPORTED_FINDINGS_AVERAGE_ID_ASC = "REPORTED_FINDINGS_AVERAGE_ID_ASC",
  REPORTED_FINDINGS_AVERAGE_ID_DESC = "REPORTED_FINDINGS_AVERAGE_ID_DESC",
  REPORTED_FINDINGS_AVERAGE_UPDATED_AT_ASC = "REPORTED_FINDINGS_AVERAGE_UPDATED_AT_ASC",
  REPORTED_FINDINGS_AVERAGE_UPDATED_AT_DESC = "REPORTED_FINDINGS_AVERAGE_UPDATED_AT_DESC",
  REPORTED_FINDINGS_BY_AUDIT_FINDING_ID__COUNT_ASC = "REPORTED_FINDINGS_BY_AUDIT_FINDING_ID__COUNT_ASC",
  REPORTED_FINDINGS_BY_AUDIT_FINDING_ID__COUNT_DESC = "REPORTED_FINDINGS_BY_AUDIT_FINDING_ID__COUNT_DESC",
  REPORTED_FINDINGS_COUNT_ASC = "REPORTED_FINDINGS_COUNT_ASC",
  REPORTED_FINDINGS_COUNT_DESC = "REPORTED_FINDINGS_COUNT_DESC",
  REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC = "REPORTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC",
  REPORTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC = "REPORTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC",
  REPORTED_FINDINGS_DISTINCT_COUNT_ID_ASC = "REPORTED_FINDINGS_DISTINCT_COUNT_ID_ASC",
  REPORTED_FINDINGS_DISTINCT_COUNT_ID_DESC = "REPORTED_FINDINGS_DISTINCT_COUNT_ID_DESC",
  REPORTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC = "REPORTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC",
  REPORTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC = "REPORTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC",
  REPORTED_FINDINGS_MAX_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_MAX_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_MAX_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_MAX_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_MAX_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_MAX_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_MAX_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_MAX_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_MAX_CREATED_AT_ASC = "REPORTED_FINDINGS_MAX_CREATED_AT_ASC",
  REPORTED_FINDINGS_MAX_CREATED_AT_DESC = "REPORTED_FINDINGS_MAX_CREATED_AT_DESC",
  REPORTED_FINDINGS_MAX_ID_ASC = "REPORTED_FINDINGS_MAX_ID_ASC",
  REPORTED_FINDINGS_MAX_ID_DESC = "REPORTED_FINDINGS_MAX_ID_DESC",
  REPORTED_FINDINGS_MAX_UPDATED_AT_ASC = "REPORTED_FINDINGS_MAX_UPDATED_AT_ASC",
  REPORTED_FINDINGS_MAX_UPDATED_AT_DESC = "REPORTED_FINDINGS_MAX_UPDATED_AT_DESC",
  REPORTED_FINDINGS_MIN_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_MIN_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_MIN_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_MIN_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_MIN_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_MIN_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_MIN_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_MIN_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_MIN_CREATED_AT_ASC = "REPORTED_FINDINGS_MIN_CREATED_AT_ASC",
  REPORTED_FINDINGS_MIN_CREATED_AT_DESC = "REPORTED_FINDINGS_MIN_CREATED_AT_DESC",
  REPORTED_FINDINGS_MIN_ID_ASC = "REPORTED_FINDINGS_MIN_ID_ASC",
  REPORTED_FINDINGS_MIN_ID_DESC = "REPORTED_FINDINGS_MIN_ID_DESC",
  REPORTED_FINDINGS_MIN_UPDATED_AT_ASC = "REPORTED_FINDINGS_MIN_UPDATED_AT_ASC",
  REPORTED_FINDINGS_MIN_UPDATED_AT_DESC = "REPORTED_FINDINGS_MIN_UPDATED_AT_DESC",
  REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC = "REPORTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC",
  REPORTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC = "REPORTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC",
  REPORTED_FINDINGS_STDDEV_POPULATION_ID_ASC = "REPORTED_FINDINGS_STDDEV_POPULATION_ID_ASC",
  REPORTED_FINDINGS_STDDEV_POPULATION_ID_DESC = "REPORTED_FINDINGS_STDDEV_POPULATION_ID_DESC",
  REPORTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC = "REPORTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC",
  REPORTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC = "REPORTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC = "REPORTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC = "REPORTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_ID_ASC = "REPORTED_FINDINGS_STDDEV_SAMPLE_ID_ASC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_ID_DESC = "REPORTED_FINDINGS_STDDEV_SAMPLE_ID_DESC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC = "REPORTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  REPORTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC = "REPORTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  REPORTED_FINDINGS_SUM_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_SUM_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_SUM_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_SUM_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_SUM_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_SUM_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_SUM_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_SUM_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_SUM_CREATED_AT_ASC = "REPORTED_FINDINGS_SUM_CREATED_AT_ASC",
  REPORTED_FINDINGS_SUM_CREATED_AT_DESC = "REPORTED_FINDINGS_SUM_CREATED_AT_DESC",
  REPORTED_FINDINGS_SUM_ID_ASC = "REPORTED_FINDINGS_SUM_ID_ASC",
  REPORTED_FINDINGS_SUM_ID_DESC = "REPORTED_FINDINGS_SUM_ID_DESC",
  REPORTED_FINDINGS_SUM_UPDATED_AT_ASC = "REPORTED_FINDINGS_SUM_UPDATED_AT_ASC",
  REPORTED_FINDINGS_SUM_UPDATED_AT_DESC = "REPORTED_FINDINGS_SUM_UPDATED_AT_DESC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC = "REPORTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC = "REPORTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_ID_ASC = "REPORTED_FINDINGS_VARIANCE_POPULATION_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_ID_DESC = "REPORTED_FINDINGS_VARIANCE_POPULATION_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC = "REPORTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  REPORTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC = "REPORTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_ID_ASC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_ID_ASC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_ID_DESC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_ID_DESC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  REPORTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "REPORTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_ACCEPTED_ASC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_ACCEPTED_ASC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_ACCEPTED_DESC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_ACCEPTED_DESC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_ID_ASC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_ID_DESC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_DELETED_ASC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_DELETED_ASC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_DELETED_DESC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_DELETED_DESC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_ID_ASC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_ID_DESC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_RATIONALE_ASC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_RATIONALE_ASC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_RATIONALE_DESC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_RATIONALE_DESC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_BY_AUDIT_FINDING_ID__COUNT_ASC = "REVIEWED_AUDIT_FINDINGS_BY_AUDIT_FINDING_ID__COUNT_ASC",
  REVIEWED_AUDIT_FINDINGS_BY_AUDIT_FINDING_ID__COUNT_DESC = "REVIEWED_AUDIT_FINDINGS_BY_AUDIT_FINDING_ID__COUNT_DESC",
  REVIEWED_AUDIT_FINDINGS_COUNT_ASC = "REVIEWED_AUDIT_FINDINGS_COUNT_ASC",
  REVIEWED_AUDIT_FINDINGS_COUNT_DESC = "REVIEWED_AUDIT_FINDINGS_COUNT_DESC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ACCEPTED_ASC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ACCEPTED_ASC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ACCEPTED_DESC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ACCEPTED_DESC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_ASC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_ASC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_DESC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_DESC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_RATIONALE_ASC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_RATIONALE_ASC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_RATIONALE_DESC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_RATIONALE_DESC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_MAX_ACCEPTED_ASC = "REVIEWED_AUDIT_FINDINGS_MAX_ACCEPTED_ASC",
  REVIEWED_AUDIT_FINDINGS_MAX_ACCEPTED_DESC = "REVIEWED_AUDIT_FINDINGS_MAX_ACCEPTED_DESC",
  REVIEWED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_ID_ASC = "REVIEWED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_ID_DESC = "REVIEWED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC = "REVIEWED_AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC = "REVIEWED_AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_MAX_CREATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_MAX_CREATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_MAX_CREATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_MAX_CREATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_MAX_DELETED_ASC = "REVIEWED_AUDIT_FINDINGS_MAX_DELETED_ASC",
  REVIEWED_AUDIT_FINDINGS_MAX_DELETED_DESC = "REVIEWED_AUDIT_FINDINGS_MAX_DELETED_DESC",
  REVIEWED_AUDIT_FINDINGS_MAX_ID_ASC = "REVIEWED_AUDIT_FINDINGS_MAX_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_MAX_ID_DESC = "REVIEWED_AUDIT_FINDINGS_MAX_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_MAX_RATIONALE_ASC = "REVIEWED_AUDIT_FINDINGS_MAX_RATIONALE_ASC",
  REVIEWED_AUDIT_FINDINGS_MAX_RATIONALE_DESC = "REVIEWED_AUDIT_FINDINGS_MAX_RATIONALE_DESC",
  REVIEWED_AUDIT_FINDINGS_MAX_UPDATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_MAX_UPDATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_MAX_UPDATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_MAX_UPDATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_MIN_ACCEPTED_ASC = "REVIEWED_AUDIT_FINDINGS_MIN_ACCEPTED_ASC",
  REVIEWED_AUDIT_FINDINGS_MIN_ACCEPTED_DESC = "REVIEWED_AUDIT_FINDINGS_MIN_ACCEPTED_DESC",
  REVIEWED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_ID_ASC = "REVIEWED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_ID_DESC = "REVIEWED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC = "REVIEWED_AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC = "REVIEWED_AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_MIN_CREATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_MIN_CREATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_MIN_CREATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_MIN_CREATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_MIN_DELETED_ASC = "REVIEWED_AUDIT_FINDINGS_MIN_DELETED_ASC",
  REVIEWED_AUDIT_FINDINGS_MIN_DELETED_DESC = "REVIEWED_AUDIT_FINDINGS_MIN_DELETED_DESC",
  REVIEWED_AUDIT_FINDINGS_MIN_ID_ASC = "REVIEWED_AUDIT_FINDINGS_MIN_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_MIN_ID_DESC = "REVIEWED_AUDIT_FINDINGS_MIN_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_MIN_RATIONALE_ASC = "REVIEWED_AUDIT_FINDINGS_MIN_RATIONALE_ASC",
  REVIEWED_AUDIT_FINDINGS_MIN_RATIONALE_DESC = "REVIEWED_AUDIT_FINDINGS_MIN_RATIONALE_DESC",
  REVIEWED_AUDIT_FINDINGS_MIN_UPDATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_MIN_UPDATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_MIN_UPDATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_MIN_UPDATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ACCEPTED_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ACCEPTED_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ACCEPTED_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ACCEPTED_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_RATIONALE_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_RATIONALE_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_RATIONALE_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_RATIONALE_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ACCEPTED_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ACCEPTED_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ACCEPTED_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ACCEPTED_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_RATIONALE_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_RATIONALE_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_RATIONALE_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_RATIONALE_DESC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_SUM_ACCEPTED_ASC = "REVIEWED_AUDIT_FINDINGS_SUM_ACCEPTED_ASC",
  REVIEWED_AUDIT_FINDINGS_SUM_ACCEPTED_DESC = "REVIEWED_AUDIT_FINDINGS_SUM_ACCEPTED_DESC",
  REVIEWED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_ID_ASC = "REVIEWED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_ID_DESC = "REVIEWED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC = "REVIEWED_AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC = "REVIEWED_AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_SUM_CREATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_SUM_CREATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_SUM_CREATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_SUM_CREATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_SUM_DELETED_ASC = "REVIEWED_AUDIT_FINDINGS_SUM_DELETED_ASC",
  REVIEWED_AUDIT_FINDINGS_SUM_DELETED_DESC = "REVIEWED_AUDIT_FINDINGS_SUM_DELETED_DESC",
  REVIEWED_AUDIT_FINDINGS_SUM_ID_ASC = "REVIEWED_AUDIT_FINDINGS_SUM_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_SUM_ID_DESC = "REVIEWED_AUDIT_FINDINGS_SUM_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_SUM_RATIONALE_ASC = "REVIEWED_AUDIT_FINDINGS_SUM_RATIONALE_ASC",
  REVIEWED_AUDIT_FINDINGS_SUM_RATIONALE_DESC = "REVIEWED_AUDIT_FINDINGS_SUM_RATIONALE_DESC",
  REVIEWED_AUDIT_FINDINGS_SUM_UPDATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_SUM_UPDATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_SUM_UPDATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_SUM_UPDATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ACCEPTED_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ACCEPTED_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ACCEPTED_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ACCEPTED_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_RATIONALE_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_RATIONALE_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_RATIONALE_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_RATIONALE_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ACCEPTED_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ACCEPTED_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ACCEPTED_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ACCEPTED_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_RATIONALE_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_RATIONALE_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_RATIONALE_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_RATIONALE_DESC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type AuditRule = {
  __typename?: "AuditRule";
  _type: Scalars["String"]["output"];
  genericRule: Scalars["JSON"]["output"];
  mue?: Maybe<MUEAuditRule>;
  nonBillable?: Maybe<NonBillableAuditRule>;
  ptp?: Maybe<PTPAuditRule>;
};

export type AuditStatus = {
  __typename?: "AuditStatus";
  color: Scalars["String"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  inUse: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  sortIndex: Scalars["Int"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

/** Filter by audit status keyword (e.g. "CLAIM_READY", "CLOSED"). Values may be supplied as the keyword slug or its resolved UUID. Slugs are resolved sync via uuidv5; no DB lookup. Backed by claim_facets_audit_status_idx (uuid expression btree). NOTE: planned for removal — see source file header. */
export type AuditStatusFacetFilterInput = {
  /** Exact match. Accepts an audit-status slug or keyword UUID. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match any audit status in the list (slug or UUID). */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** True for claims with no audit status set. */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Not equal. Accepts an audit-status slug or keyword UUID. */
  notEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match no audit status in the list (slug or UUID). */
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AuditStatusReorderInput = {
  id: Scalars["ID"]["input"];
  sortIndex: Scalars["Int"]["input"];
};

export enum AuditTypeEnum {
  ADD_ON_CODE = "ADD_ON_CODE",
  AGE_MODIFIER = "AGE_MODIFIER",
  CPT_ICD10 = "CPT_ICD10",
  CPT_MOD = "CPT_MOD",
  EM = "EM",
  GENDER_MODIFIER = "GENDER_MODIFIER",
  NCCI_MUE = "NCCI_MUE",
  NCCI_PTP = "NCCI_PTP",
  OTHER = "OTHER",
  PRICING = "PRICING",
  UNITS = "UNITS",
}

/** A filter to be used against AuditTypeEnum fields. All fields are combined with a logical ‘and.’ */
export type AuditTypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AuditTypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AuditTypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AuditTypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AuditTypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AuditTypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AuditTypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AuditTypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AuditTypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AuditTypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AuditTypeEnum>>;
};

export type AuditorBucket = Node & {
  __typename?: "AuditorBucket";
  /** Reads a single `AuditorUser` that is related to this `AuditorBucket`. */
  assignee?: Maybe<AuditorUser>;
  assigneeId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `AuditorUser`. */
  assignees: AuditorUsersConnection;
  /** Reads and enables pagination through a set of `AuditFinding`. */
  auditFindings: AuditFindingsConnection;
  /** Reads and enables pagination through a set of `AuditorBucketAssignee`. */
  auditorBucketAssignees: AuditorBucketAssigneesConnection;
  /** Reads a single `AuditorUser` that is related to this `AuditorBucket`. */
  author?: Maybe<AuditorUser>;
  authorId: Scalars["UUID"]["output"];
  /** Reads and enables pagination through a set of `BatchClaim`. */
  batchClaims: BatchClaimsConnection;
  /** Reads and enables pagination through a set of `BucketClaim`. */
  bucketClaims: BucketClaimsConnection;
  createdAt: Scalars["Datetime"]["output"];
  dueDate?: Maybe<Scalars["Datetime"]["output"]>;
  filter?: Maybe<Scalars["JSON"]["output"]>;
  id: Scalars["UUID"]["output"];
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /** Reads a single `Insurer` that is related to this `AuditorBucket`. */
  insurer?: Maybe<Insurer>;
  insurerId: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `Provider` that is related to this `AuditorBucket`. */
  provider?: Maybe<Provider>;
  providerId: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type AuditorBucketassigneesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<AuditorUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AuditorBucketauditFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<AuditFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AuditorBucketauditorBucketAssigneesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditorBucketAssigneeCondition>;
  filter?: InputMaybe<AuditorBucketAssigneeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditorBucketAssigneesOrderBy>>;
};

export type AuditorBucketbatchClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<BatchClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AuditorBucketbucketClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BucketClaimCondition>;
  filter?: InputMaybe<BucketClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BucketClaimsOrderBy>>;
};

export type AuditorBucketimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AuditorBucketAggregates = {
  __typename?: "AuditorBucketAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AuditorBucketAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuditorBucketDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AuditorBucketMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AuditorBucketMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AuditorBucketStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AuditorBucketStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AuditorBucketSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AuditorBucketVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AuditorBucketVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AuditorBucket` object types. */
export type AuditorBucketAggregatesFilter = {
  /** Mean average aggregate over matching `AuditorBucket` objects. */
  average?: InputMaybe<AuditorBucketAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AuditorBucket` objects. */
  distinctCount?: InputMaybe<AuditorBucketDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AuditorBucket` object to be included within the aggregate. */
  filter?: InputMaybe<AuditorBucketFilter>;
  /** Maximum aggregate over matching `AuditorBucket` objects. */
  max?: InputMaybe<AuditorBucketMaxAggregateFilter>;
  /** Minimum aggregate over matching `AuditorBucket` objects. */
  min?: InputMaybe<AuditorBucketMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AuditorBucket` objects. */
  stddevPopulation?: InputMaybe<AuditorBucketStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AuditorBucket` objects. */
  stddevSample?: InputMaybe<AuditorBucketStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AuditorBucket` objects. */
  sum?: InputMaybe<AuditorBucketSumAggregateFilter>;
  /** Population variance aggregate over matching `AuditorBucket` objects. */
  variancePopulation?: InputMaybe<AuditorBucketVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AuditorBucket` objects. */
  varianceSample?: InputMaybe<AuditorBucketVarianceSampleAggregateFilter>;
};

export type AuditorBucketAssignee = Node & {
  __typename?: "AuditorBucketAssignee";
  /** Reads a single `AuditorBucket` that is related to this `AuditorBucketAssignee`. */
  auditorBucket?: Maybe<AuditorBucket>;
  auditorBucketId: Scalars["UUID"]["output"];
  /** Reads a single `AuditorUser` that is related to this `AuditorBucketAssignee`. */
  auditorUser?: Maybe<AuditorUser>;
  auditorUserId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  unassigned: Scalars["Boolean"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type AuditorBucketAssigneeAggregates = {
  __typename?: "AuditorBucketAssigneeAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuditorBucketAssigneeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `AuditorBucketAssignee` object types. */
export type AuditorBucketAssigneeAggregatesFilter = {
  /** Distinct count aggregate over matching `AuditorBucketAssignee` objects. */
  distinctCount?: InputMaybe<AuditorBucketAssigneeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AuditorBucketAssignee` object to be included within the aggregate. */
  filter?: InputMaybe<AuditorBucketAssigneeFilter>;
};

/** The fields on `auditorBucketAssignee` to look up the row to connect. */
export type AuditorBucketAssigneeAuditorBucketAssigneePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The `auditorBucketAssignee` to be created by this mutation. */
export type AuditorBucketAssigneeAuditorBucketIdFkeyAuditorBucketAssigneeCreateInput =
  {
    auditorBucketToAuditorBucketId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInput>;
    auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuditorUserId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    unassigned?: InputMaybe<Scalars["Boolean"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** The `auditorBucket` to be created by this mutation. */
export type AuditorBucketAssigneeAuditorBucketIdFkeyAuditorBucketCreateInput = {
  assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
  auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditorBucket` in the `AuditorBucketAssigneeInput` mutation. */
export type AuditorBucketAssigneeAuditorBucketIdFkeyInput = {
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorBucketAuditorBucketPkeyConnect>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorBucketNodeIdConnect>;
  /** A `AuditorBucketInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyAuditorBucketCreateInput>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteById?: InputMaybe<AuditorBucketAuditorBucketPkeyDelete>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<AuditorBucketNodeIdDelete>;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorBucketOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyUsingAuditorBucketPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditorBucketAssignee` in the `AuditorBucketInput` mutation. */
export type AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput = {
  /** The primary key(s) for `auditorBucketAssignee` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuditorBucketAssigneeAuditorBucketAssigneePkeyConnect>
  >;
  /** The primary key(s) for `auditorBucketAssignee` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditorBucketAssigneeNodeIdConnect>>;
  /** A `AuditorBucketAssigneeInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditorBucketAssigneeAuditorBucketIdFkeyAuditorBucketAssigneeCreateInput>
  >;
  /** The primary key(s) and patch data for `auditorBucketAssignee` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyUsingAuditorBucketAssigneePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditorBucketAssignee` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorBucketOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyNodeIdUpdate>
  >;
};

/** The `auditorBucketAssignee` to be created by this mutation. */
export type AuditorBucketAssigneeAuditorUserIdFkeyAuditorBucketAssigneeCreateInput =
  {
    auditorBucketId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorBucketToAuditorBucketId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInput>;
    auditorUserToAuditorUserId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    unassigned?: InputMaybe<Scalars["Boolean"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `auditorUser` in the `AuditorBucketAssigneeInput` mutation. */
export type AuditorBucketAssigneeAuditorUserIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditorBucketAssignee` in the `AuditorUserInput` mutation. */
export type AuditorBucketAssigneeAuditorUserIdFkeyInverseInput = {
  /** The primary key(s) for `auditorBucketAssignee` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuditorBucketAssigneeAuditorBucketAssigneePkeyConnect>
  >;
  /** The primary key(s) for `auditorBucketAssignee` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditorBucketAssigneeNodeIdConnect>>;
  /** A `AuditorBucketAssigneeInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditorBucketAssigneeAuditorUserIdFkeyAuditorBucketAssigneeCreateInput>
  >;
  /** The primary key(s) and patch data for `auditorBucketAssignee` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyUsingAuditorBucketAssigneePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditorBucketAssignee` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `AuditorBucketAssignee` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AuditorBucketAssigneeCondition = {
  /** Checks for equality with the object’s `auditorBucketId` field. */
  auditorBucketId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `unassigned` field. */
  unassigned?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type AuditorBucketAssigneeDistinctCountAggregateFilter = {
  auditorBucketId?: InputMaybe<BigIntFilter>;
  auditorUserId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  unassigned?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type AuditorBucketAssigneeDistinctCountAggregates = {
  __typename?: "AuditorBucketAssigneeDistinctCountAggregates";
  /** Distinct count of auditorBucketId across the matching connection */
  auditorBucketId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditorUserId across the matching connection */
  auditorUserId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of unassigned across the matching connection */
  unassigned?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `AuditorBucketAssignee` object types. All fields are combined with a logical ‘and.’ */
export type AuditorBucketAssigneeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditorBucketAssigneeFilter>>;
  /** Filter by the object’s `auditorBucket` relation. */
  auditorBucket?: InputMaybe<AuditorBucketFilter>;
  /** Filter by the object’s `auditorBucketId` field. */
  auditorBucketId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `auditorUser` relation. */
  auditorUser?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditorBucketAssigneeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditorBucketAssigneeFilter>>;
  /** Filter by the object’s `unassigned` field. */
  unassigned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `AuditorBucketAssignee` for usage during aggregation. */
export enum AuditorBucketAssigneeGroupBy {
  AUDITOR_BUCKET_ID = "AUDITOR_BUCKET_ID",
  AUDITOR_USER_ID = "AUDITOR_USER_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  UNASSIGNED = "UNASSIGNED",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type AuditorBucketAssigneeHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketAssigneeHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AuditorBucketAssignee` aggregates. */
export type AuditorBucketAssigneeHavingInput = {
  AND?: InputMaybe<Array<AuditorBucketAssigneeHavingInput>>;
  OR?: InputMaybe<Array<AuditorBucketAssigneeHavingInput>>;
  average?: InputMaybe<AuditorBucketAssigneeHavingAverageInput>;
  distinctCount?: InputMaybe<AuditorBucketAssigneeHavingDistinctCountInput>;
  max?: InputMaybe<AuditorBucketAssigneeHavingMaxInput>;
  min?: InputMaybe<AuditorBucketAssigneeHavingMinInput>;
  stddevPopulation?: InputMaybe<AuditorBucketAssigneeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuditorBucketAssigneeHavingStddevSampleInput>;
  sum?: InputMaybe<AuditorBucketAssigneeHavingSumInput>;
  variancePopulation?: InputMaybe<AuditorBucketAssigneeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuditorBucketAssigneeHavingVarianceSampleInput>;
};

export type AuditorBucketAssigneeHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketAssigneeHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketAssigneeHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketAssigneeHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketAssigneeHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketAssigneeHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketAssigneeHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** The `auditorBucket` to be created by this mutation. */
export type AuditorBucketAssigneeIdFkeyAuditorBucketCreateInput = {
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
  auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `AuditorBucketInput` mutation. */
export type AuditorBucketAssigneeIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditorBucketOnAuditorBucketForAuditorBucketAssigneeIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditorBucket` in the `AuditorUserInput` mutation. */
export type AuditorBucketAssigneeIdFkeyInverseInput = {
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditorBucketAuditorBucketPkeyConnect>>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditorBucketNodeIdConnect>>;
  /** A `AuditorBucketInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditorBucketAssigneeIdFkeyAuditorBucketCreateInput>
  >;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AuditorBucketAuditorBucketPkeyDelete>>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<AuditorBucketNodeIdDelete>>;
  /** Flag indicating whether all other `auditorBucket` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditorBucketOnAuditorBucketForAuditorBucketAssigneeIdFkeyUsingAuditorBucketPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyNodeIdUpdate>
  >;
};

/** An input for mutations affecting `AuditorBucketAssignee` */
export type AuditorBucketAssigneeInput = {
  auditorBucketId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketToAuditorBucketId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInput>;
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  unassigned?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AuditorBucketAssigneeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `auditorBucketAssignee` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type AuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorBucket` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucket` being updated. */
    patch: AuditorBucketPatch;
  };

/** The fields on `auditorBucketAssignee` to look up the row to update. */
export type AuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyUsingAuditorBucketAssigneePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucketAssignee` being updated. */
    patch: updateAuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `auditorBucketAssignee` to look up the row to update. */
export type AuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyUsingAuditorBucketAssigneePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucketAssignee` being updated. */
    patch: updateAuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyPatch;
  };

/** Represents an update to a `AuditorBucketAssignee`. Fields that are set will be updated. */
export type AuditorBucketAssigneePatch = {
  auditorBucketId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketToAuditorBucketId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInput>;
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInput>;
};

/** A connection to a list of `AuditorBucketAssignee` values. */
export type AuditorBucketAssigneesConnection = {
  __typename?: "AuditorBucketAssigneesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuditorBucketAssigneeAggregates>;
  /** A list of edges which contains the `AuditorBucketAssignee` and cursor to aid in pagination. */
  edges: Array<AuditorBucketAssigneesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuditorBucketAssigneeAggregates>>;
  /** A list of `AuditorBucketAssignee` objects. */
  nodes: Array<Maybe<AuditorBucketAssignee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditorBucketAssignee` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `AuditorBucketAssignee` values. */
export type AuditorBucketAssigneesConnectiongroupedAggregatesArgs = {
  groupBy: Array<AuditorBucketAssigneeGroupBy>;
  having?: InputMaybe<AuditorBucketAssigneeHavingInput>;
};

/** A `AuditorBucketAssignee` edge in the connection. */
export type AuditorBucketAssigneesEdge = {
  __typename?: "AuditorBucketAssigneesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuditorBucketAssignee` at the end of the edge. */
  node?: Maybe<AuditorBucketAssignee>;
};

/** Methods to use when ordering `AuditorBucketAssignee`. */
export enum AuditorBucketAssigneesOrderBy {
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ASSIGNEE_ID_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ASSIGNEE_ID_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ASSIGNEE_ID_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ASSIGNEE_ID_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__AUTHOR_ID_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__AUTHOR_ID_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__AUTHOR_ID_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__AUTHOR_ID_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__CREATED_AT_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__CREATED_AT_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__CREATED_AT_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__CREATED_AT_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__DUE_DATE_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__DUE_DATE_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__DUE_DATE_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__DUE_DATE_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__FILTER_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__FILTER_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__FILTER_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__FILTER_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ID_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ID_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ID_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ID_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__INSURER_ID_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__INSURER_ID_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__INSURER_ID_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__INSURER_ID_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__NAME_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__NAME_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__NAME_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__NAME_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__PROVIDER_ID_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__PROVIDER_ID_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__PROVIDER_ID_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__PROVIDER_ID_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__UPDATED_AT_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__UPDATED_AT_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__UPDATED_AT_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__UPDATED_AT_DESC",
  AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC",
  AUDITOR_USER_ID_ASC = "AUDITOR_USER_ID_ASC",
  AUDITOR_USER_ID_DESC = "AUDITOR_USER_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UNASSIGNED_ASC = "UNASSIGNED_ASC",
  UNASSIGNED_DESC = "UNASSIGNED_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** The fields on `auditorBucket` to look up the row to connect. */
export type AuditorBucketAuditorBucketPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `auditorBucket` to look up the row to delete. */
export type AuditorBucketAuditorBucketPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** The `auditorBucket` to be created by this mutation. */
export type AuditorBucketAuthorIdFkeyAuditorBucketCreateInput = {
  assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
  auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
  bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `AuditorBucketInput` mutation. */
export type AuditorBucketAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditorBucketOnAuditorBucketForAuditorBucketAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditorBucket` in the `AuditorUserInput` mutation. */
export type AuditorBucketAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditorBucketAuditorBucketPkeyConnect>>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditorBucketNodeIdConnect>>;
  /** A `AuditorBucketInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AuditorBucketAuthorIdFkeyAuditorBucketCreateInput>>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AuditorBucketAuditorBucketPkeyDelete>>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<AuditorBucketNodeIdDelete>>;
  /** Flag indicating whether all other `auditorBucket` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditorBucketOnAuditorBucketForAuditorBucketAuthorIdFkeyUsingAuditorBucketPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyNodeIdUpdate>
  >;
};

export type AuditorBucketAverageAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type AuditorBucketAverageAggregates = {
  __typename?: "AuditorBucketAverageAggregates";
  /** Mean average of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditorBucketAverageAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * A condition to be used against `AuditorBucket` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuditorBucketCondition = {
  /** Checks for equality with the object’s `assigneeId` field. */
  assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dueDate` field. */
  dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `filter` field. */
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `insurerId` field. */
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type AuditorBucketDistinctCountAggregateFilter = {
  assigneeId?: InputMaybe<BigIntFilter>;
  authorId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  dueDate?: InputMaybe<BigIntFilter>;
  filter?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  insurerId?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<BigIntFilter>;
  providerId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type AuditorBucketDistinctCountAggregates = {
  __typename?: "AuditorBucketDistinctCountAggregates";
  /** Distinct count of assigneeId across the matching connection */
  assigneeId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dueDate across the matching connection */
  dueDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of filter across the matching connection */
  filter?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of insurerId across the matching connection */
  insurerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of providerId across the matching connection */
  providerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

export type AuditorBucketDistinctCountAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A filter to be used against `AuditorBucket` object types. All fields are combined with a logical ‘and.’ */
export type AuditorBucketFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditorBucketFilter>>;
  /** Filter by the object’s `assignee` relation. */
  assignee?: InputMaybe<AuditorUserFilter>;
  /** A related `assignee` exists. */
  assigneeExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `assigneeId` field. */
  assigneeId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `auditorBucketAssignees` relation. */
  auditorBucketAssignees?: InputMaybe<AuditorBucketToManyAuditorBucketAssigneeFilter>;
  /** Some related `auditorBucketAssignees` exist. */
  auditorBucketAssigneesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `bucketClaims` relation. */
  bucketClaims?: InputMaybe<AuditorBucketToManyBucketClaimFilter>;
  /** Some related `bucketClaims` exist. */
  bucketClaimsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dueDate` field. */
  dueDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `filter` field. */
  filter?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `improperPaymentCost` field. */
  improperPaymentCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `insurer` relation. */
  insurer?: InputMaybe<InsurerFilter>;
  /** Filter by the object’s `insurerId` field. */
  insurerId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditorBucketFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditorBucketFilter>>;
  /** Filter by the object’s `provider` relation. */
  provider?: InputMaybe<ProviderFilter>;
  /** Filter by the object’s `providerId` field. */
  providerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `AuditorBucket` for usage during aggregation. */
export enum AuditorBucketGroupBy {
  ASSIGNEE_ID = "ASSIGNEE_ID",
  AUTHOR_ID = "AUTHOR_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DUE_DATE = "DUE_DATE",
  DUE_DATE_TRUNCATED_TO_DAY = "DUE_DATE_TRUNCATED_TO_DAY",
  DUE_DATE_TRUNCATED_TO_HOUR = "DUE_DATE_TRUNCATED_TO_HOUR",
  FILTER = "FILTER",
  INSURER_ID = "INSURER_ID",
  NAME = "NAME",
  PROVIDER_ID = "PROVIDER_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type AuditorBucketHavingAverageAuditorBucketImproperPaymentCostArgsInput =
  {
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type AuditorBucketHavingAverageAuditorBucketImproperPaymentCostInput = {
  args?: InputMaybe<AuditorBucketHavingAverageAuditorBucketImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditorBucketHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<AuditorBucketHavingAverageAuditorBucketImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketHavingDistinctCountAuditorBucketImproperPaymentCostArgsInput =
  {
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type AuditorBucketHavingDistinctCountAuditorBucketImproperPaymentCostInput =
  {
    args?: InputMaybe<AuditorBucketHavingDistinctCountAuditorBucketImproperPaymentCostArgsInput>;
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditorBucketHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<AuditorBucketHavingDistinctCountAuditorBucketImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AuditorBucket` aggregates. */
export type AuditorBucketHavingInput = {
  AND?: InputMaybe<Array<AuditorBucketHavingInput>>;
  OR?: InputMaybe<Array<AuditorBucketHavingInput>>;
  average?: InputMaybe<AuditorBucketHavingAverageInput>;
  distinctCount?: InputMaybe<AuditorBucketHavingDistinctCountInput>;
  max?: InputMaybe<AuditorBucketHavingMaxInput>;
  min?: InputMaybe<AuditorBucketHavingMinInput>;
  stddevPopulation?: InputMaybe<AuditorBucketHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuditorBucketHavingStddevSampleInput>;
  sum?: InputMaybe<AuditorBucketHavingSumInput>;
  variancePopulation?: InputMaybe<AuditorBucketHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuditorBucketHavingVarianceSampleInput>;
};

export type AuditorBucketHavingMaxAuditorBucketImproperPaymentCostArgsInput = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AuditorBucketHavingMaxAuditorBucketImproperPaymentCostInput = {
  args?: InputMaybe<AuditorBucketHavingMaxAuditorBucketImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditorBucketHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<AuditorBucketHavingMaxAuditorBucketImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketHavingMinAuditorBucketImproperPaymentCostArgsInput = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AuditorBucketHavingMinAuditorBucketImproperPaymentCostInput = {
  args?: InputMaybe<AuditorBucketHavingMinAuditorBucketImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditorBucketHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<AuditorBucketHavingMinAuditorBucketImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketHavingStddevPopulationAuditorBucketImproperPaymentCostArgsInput =
  {
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type AuditorBucketHavingStddevPopulationAuditorBucketImproperPaymentCostInput =
  {
    args?: InputMaybe<AuditorBucketHavingStddevPopulationAuditorBucketImproperPaymentCostArgsInput>;
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditorBucketHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<AuditorBucketHavingStddevPopulationAuditorBucketImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketHavingStddevSampleAuditorBucketImproperPaymentCostArgsInput =
  {
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type AuditorBucketHavingStddevSampleAuditorBucketImproperPaymentCostInput =
  {
    args?: InputMaybe<AuditorBucketHavingStddevSampleAuditorBucketImproperPaymentCostArgsInput>;
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditorBucketHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<AuditorBucketHavingStddevSampleAuditorBucketImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketHavingSumAuditorBucketImproperPaymentCostArgsInput = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AuditorBucketHavingSumAuditorBucketImproperPaymentCostInput = {
  args?: InputMaybe<AuditorBucketHavingSumAuditorBucketImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type AuditorBucketHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<AuditorBucketHavingSumAuditorBucketImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketHavingVariancePopulationAuditorBucketImproperPaymentCostArgsInput =
  {
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type AuditorBucketHavingVariancePopulationAuditorBucketImproperPaymentCostInput =
  {
    args?: InputMaybe<AuditorBucketHavingVariancePopulationAuditorBucketImproperPaymentCostArgsInput>;
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditorBucketHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<AuditorBucketHavingVariancePopulationAuditorBucketImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorBucketHavingVarianceSampleAuditorBucketImproperPaymentCostArgsInput =
  {
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type AuditorBucketHavingVarianceSampleAuditorBucketImproperPaymentCostInput =
  {
    args?: InputMaybe<AuditorBucketHavingVarianceSampleAuditorBucketImproperPaymentCostArgsInput>;
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type AuditorBucketHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<AuditorBucketHavingVarianceSampleAuditorBucketImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `AuditorBucket` */
export type AuditorBucketInput = {
  assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
  auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The `auditorBucket` to be created by this mutation. */
export type AuditorBucketInsurerIdFkeyAuditorBucketCreateInput = {
  assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
  auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `insurer` in the `AuditorBucketInput` mutation. */
export type AuditorBucketInsurerIdFkeyInput = {
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByClientAbbreviation?: InputMaybe<InsurerInsurerUniqueClientAbbreviationConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectById?: InputMaybe<InsurerInsurerPkeyConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByName?: InputMaybe<InsurerInsurerUniqueNameConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<InsurerNodeIdConnect>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByClientAbbreviation?: InputMaybe<InsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateById?: InputMaybe<InsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyUsingInsurerPkeyUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByName?: InputMaybe<InsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyUsingInsurerUniqueNameUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditorBucketOnAuditorBucketForAuditorBucketInsurerIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditorBucket` in the `InsurerInput` mutation. */
export type AuditorBucketInsurerIdFkeyInverseInput = {
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditorBucketAuditorBucketPkeyConnect>>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditorBucketNodeIdConnect>>;
  /** A `AuditorBucketInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditorBucketInsurerIdFkeyAuditorBucketCreateInput>
  >;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AuditorBucketAuditorBucketPkeyDelete>>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<AuditorBucketNodeIdDelete>>;
  /** Flag indicating whether all other `auditorBucket` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditorBucketOnAuditorBucketForAuditorBucketInsurerIdFkeyUsingAuditorBucketPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<InsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyNodeIdUpdate>
  >;
};

export type AuditorBucketMaxAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type AuditorBucketMaxAggregates = {
  __typename?: "AuditorBucketMaxAggregates";
  /** Maximum of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditorBucketMaxAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AuditorBucketMinAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type AuditorBucketMinAggregates = {
  __typename?: "AuditorBucketMinAggregates";
  /** Minimum of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditorBucketMinAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AuditorBucketNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `auditorBucket` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to delete. */
export type AuditorBucketNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `auditorBucket` to be deleted. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type AuditorBucketOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorBucketAssignee` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucketAssignee` being updated. */
    patch: AuditorBucketAssigneePatch;
  };

/** The fields on `auditorBucket` to look up the row to update. */
export type AuditorBucketOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyUsingAuditorBucketPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucket` being updated. */
    patch: updateAuditorBucketOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorBucketOnAuditorBucketForAuditorBucketAssigneeIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `auditorBucket` to look up the row to update. */
export type AuditorBucketOnAuditorBucketForAuditorBucketAssigneeIdFkeyUsingAuditorBucketPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucket` being updated. */
    patch: updateAuditorBucketOnAuditorBucketForAuditorBucketAssigneeIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorBucketOnAuditorBucketForAuditorBucketAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `auditorBucket` to look up the row to update. */
export type AuditorBucketOnAuditorBucketForAuditorBucketAuthorIdFkeyUsingAuditorBucketPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucket` being updated. */
    patch: updateAuditorBucketOnAuditorBucketForAuditorBucketAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorBucketOnAuditorBucketForAuditorBucketInsurerIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `insurer` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: InsurerPatch;
  };

/** The fields on `auditorBucket` to look up the row to update. */
export type AuditorBucketOnAuditorBucketForAuditorBucketInsurerIdFkeyUsingAuditorBucketPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucket` being updated. */
    patch: updateAuditorBucketOnAuditorBucketForAuditorBucketInsurerIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorBucketOnAuditorBucketForFkeyAuditorBucketProviderIdNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `provider` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: ProviderPatch;
  };

/** The fields on `auditorBucket` to look up the row to update. */
export type AuditorBucketOnAuditorBucketForFkeyAuditorBucketProviderIdUsingAuditorBucketPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucket` being updated. */
    patch: updateAuditorBucketOnAuditorBucketForFkeyAuditorBucketProviderIdPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorBucketOnBucketClaimForBucketClaimAuditorBucketIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `bucketClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `bucketClaim` being updated. */
    patch: BucketClaimPatch;
  };

/** The fields on `auditorBucket` to look up the row to update. */
export type AuditorBucketOnBucketClaimForBucketClaimAuditorBucketIdFkeyUsingAuditorBucketPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucket` being updated. */
    patch: updateAuditorBucketOnBucketClaimForBucketClaimAuditorBucketIdFkeyPatch;
  };

/** Represents an update to a `AuditorBucket`. Fields that are set will be updated. */
export type AuditorBucketPatch = {
  assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
  auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type AuditorBucketStddevPopulationAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type AuditorBucketStddevPopulationAggregates = {
  __typename?: "AuditorBucketStddevPopulationAggregates";
  /** Population standard deviation of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditorBucketStddevPopulationAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AuditorBucketStddevSampleAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type AuditorBucketStddevSampleAggregates = {
  __typename?: "AuditorBucketStddevSampleAggregates";
  /** Sample standard deviation of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditorBucketStddevSampleAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AuditorBucketSumAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type AuditorBucketSumAggregates = {
  __typename?: "AuditorBucketSumAggregates";
  /** Sum of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditorBucketSumAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A filter to be used against many `AuditorBucketAssignee` object types. All fields are combined with a logical ‘and.’ */
export type AuditorBucketToManyAuditorBucketAssigneeFilter = {
  /** Aggregates across related `AuditorBucketAssignee` match the filter criteria. */
  aggregates?: InputMaybe<AuditorBucketAssigneeAggregatesFilter>;
  /** Every related `AuditorBucketAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditorBucketAssigneeFilter>;
  /** No related `AuditorBucketAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditorBucketAssigneeFilter>;
  /** Some related `AuditorBucketAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditorBucketAssigneeFilter>;
};

/** A filter to be used against many `BucketClaim` object types. All fields are combined with a logical ‘and.’ */
export type AuditorBucketToManyBucketClaimFilter = {
  /** Aggregates across related `BucketClaim` match the filter criteria. */
  aggregates?: InputMaybe<BucketClaimAggregatesFilter>;
  /** Every related `BucketClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BucketClaimFilter>;
  /** No related `BucketClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BucketClaimFilter>;
  /** Some related `BucketClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BucketClaimFilter>;
};

export type AuditorBucketVariancePopulationAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type AuditorBucketVariancePopulationAggregates = {
  __typename?: "AuditorBucketVariancePopulationAggregates";
  /** Population variance of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditorBucketVariancePopulationAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AuditorBucketVarianceSampleAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type AuditorBucketVarianceSampleAggregates = {
  __typename?: "AuditorBucketVarianceSampleAggregates";
  /** Sample variance of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type AuditorBucketVarianceSampleAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A connection to a list of `AuditorBucket` values. */
export type AuditorBucketsConnection = {
  __typename?: "AuditorBucketsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuditorBucketAggregates>;
  /** A list of edges which contains the `AuditorBucket` and cursor to aid in pagination. */
  edges: Array<AuditorBucketsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuditorBucketAggregates>>;
  /** A list of `AuditorBucket` objects. */
  nodes: Array<Maybe<AuditorBucket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditorBucket` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `AuditorBucket` values. */
export type AuditorBucketsConnectiongroupedAggregatesArgs = {
  groupBy: Array<AuditorBucketGroupBy>;
  having?: InputMaybe<AuditorBucketHavingInput>;
};

/** A `AuditorBucket` edge in the connection. */
export type AuditorBucketsEdge = {
  __typename?: "AuditorBucketsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuditorBucket` at the end of the edge. */
  node?: Maybe<AuditorBucket>;
};

/** Methods to use when ordering `AuditorBucket`. */
export enum AuditorBucketsOrderBy {
  ASSIGNEE_ID_ASC = "ASSIGNEE_ID_ASC",
  ASSIGNEE_ID_DESC = "ASSIGNEE_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_BY_AUDITOR_BUCKET_ID__COUNT_ASC = "AUDITOR_BUCKET_ASSIGNEES_BY_AUDITOR_BUCKET_ID__COUNT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_BY_AUDITOR_BUCKET_ID__COUNT_DESC = "AUDITOR_BUCKET_ASSIGNEES_BY_AUDITOR_BUCKET_ID__COUNT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_COUNT_ASC = "AUDITOR_BUCKET_ASSIGNEES_COUNT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_COUNT_DESC = "AUDITOR_BUCKET_ASSIGNEES_COUNT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__EMAIL_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__EMAIL_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__EMAIL_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__EMAIL_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__ID_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__ID_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__ID_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__ID_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__TITLE_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__TITLE_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__TITLE_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__TITLE_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_ASSIGNEE_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_ASSIGNEE_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_ASSIGNEE_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_ASSIGNEE_ID__USER_TYPE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  BUCKET_CLAIMS_AVERAGE_AUDITOR_BUCKET_ID_ASC = "BUCKET_CLAIMS_AVERAGE_AUDITOR_BUCKET_ID_ASC",
  BUCKET_CLAIMS_AVERAGE_AUDITOR_BUCKET_ID_DESC = "BUCKET_CLAIMS_AVERAGE_AUDITOR_BUCKET_ID_DESC",
  BUCKET_CLAIMS_AVERAGE_BATCH_CLAIM_ID_ASC = "BUCKET_CLAIMS_AVERAGE_BATCH_CLAIM_ID_ASC",
  BUCKET_CLAIMS_AVERAGE_BATCH_CLAIM_ID_DESC = "BUCKET_CLAIMS_AVERAGE_BATCH_CLAIM_ID_DESC",
  BUCKET_CLAIMS_AVERAGE_CREATED_AT_ASC = "BUCKET_CLAIMS_AVERAGE_CREATED_AT_ASC",
  BUCKET_CLAIMS_AVERAGE_CREATED_AT_DESC = "BUCKET_CLAIMS_AVERAGE_CREATED_AT_DESC",
  BUCKET_CLAIMS_AVERAGE_ID_ASC = "BUCKET_CLAIMS_AVERAGE_ID_ASC",
  BUCKET_CLAIMS_AVERAGE_ID_DESC = "BUCKET_CLAIMS_AVERAGE_ID_DESC",
  BUCKET_CLAIMS_AVERAGE_SELECTION_METHOD_ASC = "BUCKET_CLAIMS_AVERAGE_SELECTION_METHOD_ASC",
  BUCKET_CLAIMS_AVERAGE_SELECTION_METHOD_DESC = "BUCKET_CLAIMS_AVERAGE_SELECTION_METHOD_DESC",
  BUCKET_CLAIMS_AVERAGE_STATUS_ASC = "BUCKET_CLAIMS_AVERAGE_STATUS_ASC",
  BUCKET_CLAIMS_AVERAGE_STATUS_DESC = "BUCKET_CLAIMS_AVERAGE_STATUS_DESC",
  BUCKET_CLAIMS_AVERAGE_UPDATED_AT_ASC = "BUCKET_CLAIMS_AVERAGE_UPDATED_AT_ASC",
  BUCKET_CLAIMS_AVERAGE_UPDATED_AT_DESC = "BUCKET_CLAIMS_AVERAGE_UPDATED_AT_DESC",
  BUCKET_CLAIMS_BY_AUDITOR_BUCKET_ID__COUNT_ASC = "BUCKET_CLAIMS_BY_AUDITOR_BUCKET_ID__COUNT_ASC",
  BUCKET_CLAIMS_BY_AUDITOR_BUCKET_ID__COUNT_DESC = "BUCKET_CLAIMS_BY_AUDITOR_BUCKET_ID__COUNT_DESC",
  BUCKET_CLAIMS_COUNT_ASC = "BUCKET_CLAIMS_COUNT_ASC",
  BUCKET_CLAIMS_COUNT_DESC = "BUCKET_CLAIMS_COUNT_DESC",
  BUCKET_CLAIMS_DISTINCT_COUNT_AUDITOR_BUCKET_ID_ASC = "BUCKET_CLAIMS_DISTINCT_COUNT_AUDITOR_BUCKET_ID_ASC",
  BUCKET_CLAIMS_DISTINCT_COUNT_AUDITOR_BUCKET_ID_DESC = "BUCKET_CLAIMS_DISTINCT_COUNT_AUDITOR_BUCKET_ID_DESC",
  BUCKET_CLAIMS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BUCKET_CLAIMS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BUCKET_CLAIMS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BUCKET_CLAIMS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BUCKET_CLAIMS_DISTINCT_COUNT_CREATED_AT_ASC = "BUCKET_CLAIMS_DISTINCT_COUNT_CREATED_AT_ASC",
  BUCKET_CLAIMS_DISTINCT_COUNT_CREATED_AT_DESC = "BUCKET_CLAIMS_DISTINCT_COUNT_CREATED_AT_DESC",
  BUCKET_CLAIMS_DISTINCT_COUNT_ID_ASC = "BUCKET_CLAIMS_DISTINCT_COUNT_ID_ASC",
  BUCKET_CLAIMS_DISTINCT_COUNT_ID_DESC = "BUCKET_CLAIMS_DISTINCT_COUNT_ID_DESC",
  BUCKET_CLAIMS_DISTINCT_COUNT_SELECTION_METHOD_ASC = "BUCKET_CLAIMS_DISTINCT_COUNT_SELECTION_METHOD_ASC",
  BUCKET_CLAIMS_DISTINCT_COUNT_SELECTION_METHOD_DESC = "BUCKET_CLAIMS_DISTINCT_COUNT_SELECTION_METHOD_DESC",
  BUCKET_CLAIMS_DISTINCT_COUNT_STATUS_ASC = "BUCKET_CLAIMS_DISTINCT_COUNT_STATUS_ASC",
  BUCKET_CLAIMS_DISTINCT_COUNT_STATUS_DESC = "BUCKET_CLAIMS_DISTINCT_COUNT_STATUS_DESC",
  BUCKET_CLAIMS_DISTINCT_COUNT_UPDATED_AT_ASC = "BUCKET_CLAIMS_DISTINCT_COUNT_UPDATED_AT_ASC",
  BUCKET_CLAIMS_DISTINCT_COUNT_UPDATED_AT_DESC = "BUCKET_CLAIMS_DISTINCT_COUNT_UPDATED_AT_DESC",
  BUCKET_CLAIMS_MAX_AUDITOR_BUCKET_ID_ASC = "BUCKET_CLAIMS_MAX_AUDITOR_BUCKET_ID_ASC",
  BUCKET_CLAIMS_MAX_AUDITOR_BUCKET_ID_DESC = "BUCKET_CLAIMS_MAX_AUDITOR_BUCKET_ID_DESC",
  BUCKET_CLAIMS_MAX_BATCH_CLAIM_ID_ASC = "BUCKET_CLAIMS_MAX_BATCH_CLAIM_ID_ASC",
  BUCKET_CLAIMS_MAX_BATCH_CLAIM_ID_DESC = "BUCKET_CLAIMS_MAX_BATCH_CLAIM_ID_DESC",
  BUCKET_CLAIMS_MAX_CREATED_AT_ASC = "BUCKET_CLAIMS_MAX_CREATED_AT_ASC",
  BUCKET_CLAIMS_MAX_CREATED_AT_DESC = "BUCKET_CLAIMS_MAX_CREATED_AT_DESC",
  BUCKET_CLAIMS_MAX_ID_ASC = "BUCKET_CLAIMS_MAX_ID_ASC",
  BUCKET_CLAIMS_MAX_ID_DESC = "BUCKET_CLAIMS_MAX_ID_DESC",
  BUCKET_CLAIMS_MAX_SELECTION_METHOD_ASC = "BUCKET_CLAIMS_MAX_SELECTION_METHOD_ASC",
  BUCKET_CLAIMS_MAX_SELECTION_METHOD_DESC = "BUCKET_CLAIMS_MAX_SELECTION_METHOD_DESC",
  BUCKET_CLAIMS_MAX_STATUS_ASC = "BUCKET_CLAIMS_MAX_STATUS_ASC",
  BUCKET_CLAIMS_MAX_STATUS_DESC = "BUCKET_CLAIMS_MAX_STATUS_DESC",
  BUCKET_CLAIMS_MAX_UPDATED_AT_ASC = "BUCKET_CLAIMS_MAX_UPDATED_AT_ASC",
  BUCKET_CLAIMS_MAX_UPDATED_AT_DESC = "BUCKET_CLAIMS_MAX_UPDATED_AT_DESC",
  BUCKET_CLAIMS_MIN_AUDITOR_BUCKET_ID_ASC = "BUCKET_CLAIMS_MIN_AUDITOR_BUCKET_ID_ASC",
  BUCKET_CLAIMS_MIN_AUDITOR_BUCKET_ID_DESC = "BUCKET_CLAIMS_MIN_AUDITOR_BUCKET_ID_DESC",
  BUCKET_CLAIMS_MIN_BATCH_CLAIM_ID_ASC = "BUCKET_CLAIMS_MIN_BATCH_CLAIM_ID_ASC",
  BUCKET_CLAIMS_MIN_BATCH_CLAIM_ID_DESC = "BUCKET_CLAIMS_MIN_BATCH_CLAIM_ID_DESC",
  BUCKET_CLAIMS_MIN_CREATED_AT_ASC = "BUCKET_CLAIMS_MIN_CREATED_AT_ASC",
  BUCKET_CLAIMS_MIN_CREATED_AT_DESC = "BUCKET_CLAIMS_MIN_CREATED_AT_DESC",
  BUCKET_CLAIMS_MIN_ID_ASC = "BUCKET_CLAIMS_MIN_ID_ASC",
  BUCKET_CLAIMS_MIN_ID_DESC = "BUCKET_CLAIMS_MIN_ID_DESC",
  BUCKET_CLAIMS_MIN_SELECTION_METHOD_ASC = "BUCKET_CLAIMS_MIN_SELECTION_METHOD_ASC",
  BUCKET_CLAIMS_MIN_SELECTION_METHOD_DESC = "BUCKET_CLAIMS_MIN_SELECTION_METHOD_DESC",
  BUCKET_CLAIMS_MIN_STATUS_ASC = "BUCKET_CLAIMS_MIN_STATUS_ASC",
  BUCKET_CLAIMS_MIN_STATUS_DESC = "BUCKET_CLAIMS_MIN_STATUS_DESC",
  BUCKET_CLAIMS_MIN_UPDATED_AT_ASC = "BUCKET_CLAIMS_MIN_UPDATED_AT_ASC",
  BUCKET_CLAIMS_MIN_UPDATED_AT_DESC = "BUCKET_CLAIMS_MIN_UPDATED_AT_DESC",
  BUCKET_CLAIMS_STDDEV_POPULATION_AUDITOR_BUCKET_ID_ASC = "BUCKET_CLAIMS_STDDEV_POPULATION_AUDITOR_BUCKET_ID_ASC",
  BUCKET_CLAIMS_STDDEV_POPULATION_AUDITOR_BUCKET_ID_DESC = "BUCKET_CLAIMS_STDDEV_POPULATION_AUDITOR_BUCKET_ID_DESC",
  BUCKET_CLAIMS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BUCKET_CLAIMS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BUCKET_CLAIMS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BUCKET_CLAIMS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BUCKET_CLAIMS_STDDEV_POPULATION_CREATED_AT_ASC = "BUCKET_CLAIMS_STDDEV_POPULATION_CREATED_AT_ASC",
  BUCKET_CLAIMS_STDDEV_POPULATION_CREATED_AT_DESC = "BUCKET_CLAIMS_STDDEV_POPULATION_CREATED_AT_DESC",
  BUCKET_CLAIMS_STDDEV_POPULATION_ID_ASC = "BUCKET_CLAIMS_STDDEV_POPULATION_ID_ASC",
  BUCKET_CLAIMS_STDDEV_POPULATION_ID_DESC = "BUCKET_CLAIMS_STDDEV_POPULATION_ID_DESC",
  BUCKET_CLAIMS_STDDEV_POPULATION_SELECTION_METHOD_ASC = "BUCKET_CLAIMS_STDDEV_POPULATION_SELECTION_METHOD_ASC",
  BUCKET_CLAIMS_STDDEV_POPULATION_SELECTION_METHOD_DESC = "BUCKET_CLAIMS_STDDEV_POPULATION_SELECTION_METHOD_DESC",
  BUCKET_CLAIMS_STDDEV_POPULATION_STATUS_ASC = "BUCKET_CLAIMS_STDDEV_POPULATION_STATUS_ASC",
  BUCKET_CLAIMS_STDDEV_POPULATION_STATUS_DESC = "BUCKET_CLAIMS_STDDEV_POPULATION_STATUS_DESC",
  BUCKET_CLAIMS_STDDEV_POPULATION_UPDATED_AT_ASC = "BUCKET_CLAIMS_STDDEV_POPULATION_UPDATED_AT_ASC",
  BUCKET_CLAIMS_STDDEV_POPULATION_UPDATED_AT_DESC = "BUCKET_CLAIMS_STDDEV_POPULATION_UPDATED_AT_DESC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_ASC = "BUCKET_CLAIMS_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_ASC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_DESC = "BUCKET_CLAIMS_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_DESC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BUCKET_CLAIMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BUCKET_CLAIMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_CREATED_AT_ASC = "BUCKET_CLAIMS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_CREATED_AT_DESC = "BUCKET_CLAIMS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_ID_ASC = "BUCKET_CLAIMS_STDDEV_SAMPLE_ID_ASC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_ID_DESC = "BUCKET_CLAIMS_STDDEV_SAMPLE_ID_DESC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_SELECTION_METHOD_ASC = "BUCKET_CLAIMS_STDDEV_SAMPLE_SELECTION_METHOD_ASC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_SELECTION_METHOD_DESC = "BUCKET_CLAIMS_STDDEV_SAMPLE_SELECTION_METHOD_DESC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_STATUS_ASC = "BUCKET_CLAIMS_STDDEV_SAMPLE_STATUS_ASC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_STATUS_DESC = "BUCKET_CLAIMS_STDDEV_SAMPLE_STATUS_DESC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_ASC = "BUCKET_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BUCKET_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_DESC = "BUCKET_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BUCKET_CLAIMS_SUM_AUDITOR_BUCKET_ID_ASC = "BUCKET_CLAIMS_SUM_AUDITOR_BUCKET_ID_ASC",
  BUCKET_CLAIMS_SUM_AUDITOR_BUCKET_ID_DESC = "BUCKET_CLAIMS_SUM_AUDITOR_BUCKET_ID_DESC",
  BUCKET_CLAIMS_SUM_BATCH_CLAIM_ID_ASC = "BUCKET_CLAIMS_SUM_BATCH_CLAIM_ID_ASC",
  BUCKET_CLAIMS_SUM_BATCH_CLAIM_ID_DESC = "BUCKET_CLAIMS_SUM_BATCH_CLAIM_ID_DESC",
  BUCKET_CLAIMS_SUM_CREATED_AT_ASC = "BUCKET_CLAIMS_SUM_CREATED_AT_ASC",
  BUCKET_CLAIMS_SUM_CREATED_AT_DESC = "BUCKET_CLAIMS_SUM_CREATED_AT_DESC",
  BUCKET_CLAIMS_SUM_ID_ASC = "BUCKET_CLAIMS_SUM_ID_ASC",
  BUCKET_CLAIMS_SUM_ID_DESC = "BUCKET_CLAIMS_SUM_ID_DESC",
  BUCKET_CLAIMS_SUM_SELECTION_METHOD_ASC = "BUCKET_CLAIMS_SUM_SELECTION_METHOD_ASC",
  BUCKET_CLAIMS_SUM_SELECTION_METHOD_DESC = "BUCKET_CLAIMS_SUM_SELECTION_METHOD_DESC",
  BUCKET_CLAIMS_SUM_STATUS_ASC = "BUCKET_CLAIMS_SUM_STATUS_ASC",
  BUCKET_CLAIMS_SUM_STATUS_DESC = "BUCKET_CLAIMS_SUM_STATUS_DESC",
  BUCKET_CLAIMS_SUM_UPDATED_AT_ASC = "BUCKET_CLAIMS_SUM_UPDATED_AT_ASC",
  BUCKET_CLAIMS_SUM_UPDATED_AT_DESC = "BUCKET_CLAIMS_SUM_UPDATED_AT_DESC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_ASC = "BUCKET_CLAIMS_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_ASC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_DESC = "BUCKET_CLAIMS_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_DESC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BUCKET_CLAIMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BUCKET_CLAIMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_CREATED_AT_ASC = "BUCKET_CLAIMS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_CREATED_AT_DESC = "BUCKET_CLAIMS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_ID_ASC = "BUCKET_CLAIMS_VARIANCE_POPULATION_ID_ASC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_ID_DESC = "BUCKET_CLAIMS_VARIANCE_POPULATION_ID_DESC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_SELECTION_METHOD_ASC = "BUCKET_CLAIMS_VARIANCE_POPULATION_SELECTION_METHOD_ASC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_SELECTION_METHOD_DESC = "BUCKET_CLAIMS_VARIANCE_POPULATION_SELECTION_METHOD_DESC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_STATUS_ASC = "BUCKET_CLAIMS_VARIANCE_POPULATION_STATUS_ASC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_STATUS_DESC = "BUCKET_CLAIMS_VARIANCE_POPULATION_STATUS_DESC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_ASC = "BUCKET_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BUCKET_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_DESC = "BUCKET_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_ASC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_ASC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_DESC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_DESC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_ID_ASC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_ID_ASC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_ID_DESC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_ID_DESC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_SELECTION_METHOD_ASC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_SELECTION_METHOD_ASC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_SELECTION_METHOD_DESC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_SELECTION_METHOD_DESC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_STATUS_ASC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_STATUS_ASC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_STATUS_DESC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_STATUS_DESC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BUCKET_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BUCKET_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DUE_DATE_ASC = "DUE_DATE_ASC",
  DUE_DATE_DESC = "DUE_DATE_DESC",
  FILTER_ASC = "FILTER_ASC",
  FILTER_DESC = "FILTER_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ID_ASC = "INSURER_BY_INSURER_ID__CLIENT_ID_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ID_DESC = "INSURER_BY_INSURER_ID__CLIENT_ID_DESC",
  INSURER_BY_INSURER_ID__CREATED_AT_ASC = "INSURER_BY_INSURER_ID__CREATED_AT_ASC",
  INSURER_BY_INSURER_ID__CREATED_AT_DESC = "INSURER_BY_INSURER_ID__CREATED_AT_DESC",
  INSURER_BY_INSURER_ID__ID_ASC = "INSURER_BY_INSURER_ID__ID_ASC",
  INSURER_BY_INSURER_ID__ID_DESC = "INSURER_BY_INSURER_ID__ID_DESC",
  INSURER_BY_INSURER_ID__NAME_ASC = "INSURER_BY_INSURER_ID__NAME_ASC",
  INSURER_BY_INSURER_ID__NAME_DESC = "INSURER_BY_INSURER_ID__NAME_DESC",
  INSURER_BY_INSURER_ID__UPDATED_AT_ASC = "INSURER_BY_INSURER_ID__UPDATED_AT_ASC",
  INSURER_BY_INSURER_ID__UPDATED_AT_DESC = "INSURER_BY_INSURER_ID__UPDATED_AT_DESC",
  INSURER_ID_ASC = "INSURER_ID_ASC",
  INSURER_ID_DESC = "INSURER_ID_DESC",
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__CITY_ASC = "PROVIDER_BY_PROVIDER_ID__CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__CITY_DESC = "PROVIDER_BY_PROVIDER_ID__CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC",
  PROVIDER_BY_PROVIDER_ID__ID_ASC = "PROVIDER_BY_PROVIDER_ID__ID_ASC",
  PROVIDER_BY_PROVIDER_ID__ID_DESC = "PROVIDER_BY_PROVIDER_ID__ID_DESC",
  PROVIDER_BY_PROVIDER_ID__NAME_ASC = "PROVIDER_BY_PROVIDER_ID__NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__NAME_DESC = "PROVIDER_BY_PROVIDER_ID__NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__NPI_ASC = "PROVIDER_BY_PROVIDER_ID__NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__NPI_DESC = "PROVIDER_BY_PROVIDER_ID__NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC",
  PROVIDER_BY_PROVIDER_ID__SPEC_ASC = "PROVIDER_BY_PROVIDER_ID__SPEC_ASC",
  PROVIDER_BY_PROVIDER_ID__SPEC_DESC = "PROVIDER_BY_PROVIDER_ID__SPEC_DESC",
  PROVIDER_BY_PROVIDER_ID__STATE_ASC = "PROVIDER_BY_PROVIDER_ID__STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__STATE_DESC = "PROVIDER_BY_PROVIDER_ID__STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC",
  PROVIDER_ID_ASC = "PROVIDER_ID_ASC",
  PROVIDER_ID_DESC = "PROVIDER_ID_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUser = Node & {
  __typename?: "AuditorUser";
  /** Reads and enables pagination through a set of `ActiveClaimAssignee`. */
  activeClaimAssignees: ActiveClaimAssigneesConnection;
  /** Reads and enables pagination through a set of `AuditFindingReport`. */
  auditFindingReportsByPrimaryPiaId: AuditFindingReportsConnection;
  /** Reads and enables pagination through a set of `AuditorBucketAssignee`. */
  auditorBucketAssignees: AuditorBucketAssigneesConnection;
  /** Reads and enables pagination through a set of `AuditorBucket`. */
  auditorBucketsByAssigneeId: AuditorBucketsConnection;
  /** Reads and enables pagination through a set of `AuditFindingJob`. */
  authoredAuditFindingJobs: AuditFindingJobsConnection;
  /** Reads and enables pagination through a set of `AuditFindingReasonCode`. */
  authoredAuditFindingReasonCodes: AuditFindingReasonCodesConnection;
  /** Reads and enables pagination through a set of `AuditFindingReport`. */
  authoredAuditFindingReports: AuditFindingReportsConnection;
  /** Reads and enables pagination through a set of `AuditFindingReview`. */
  authoredAuditFindingReviews: AuditFindingReviewsConnection;
  /** Reads and enables pagination through a set of `AuditFinding`. */
  authoredAuditFindings: AuditFindingsConnection;
  /** Reads and enables pagination through a set of `AuditorBucket`. */
  authoredAuditorBuckets: AuditorBucketsConnection;
  /** Reads and enables pagination through a set of `BatchClaimLineItemAudit`. */
  authoredBatchClaimLineItemAudits: BatchClaimLineItemAuditsConnection;
  /** Reads and enables pagination through a set of `BatchClaimLineItemNnIbLine`. */
  authoredBatchClaimLineItemNnIbLines: BatchClaimLineItemNnIbLinesConnection;
  /** Reads and enables pagination through a set of `BatchClaimLineItem`. */
  authoredBatchClaimLineItems: BatchClaimLineItemsConnection;
  /** Reads and enables pagination through a set of `BatchClaim`. */
  authoredBatchClaims: BatchClaimsConnection;
  /** Reads and enables pagination through a set of `BatchFile`. */
  authoredBatchFiles: BatchFilesConnection;
  /** Reads and enables pagination through a set of `DisputedFinding`. */
  authoredDisputedFindings: DisputedFindingsConnection;
  /** Reads and enables pagination through a set of `DocumentUploadCreated`. */
  authoredDocumentUploadCreateds: DocumentUploadCreatedsConnection;
  /** Reads and enables pagination through a set of `NnIbLine`. */
  authoredNnIbLines: NnIbLinesConnection;
  /** Reads and enables pagination through a set of `Queue`. */
  authoredQueues: QueuesConnection;
  /** Reads and enables pagination through a set of `ReviewedAuditFinding`. */
  authoredReviewedAuditFindings: ReviewedAuditFindingsConnection;
  /** Reads and enables pagination through a set of `BatchClaimAppealed`. */
  batchClaimAppealedsByCreatedBy: BatchClaimAppealedsConnection;
  /** Reads and enables pagination through a set of `BatchClaimAssignee`. */
  batchClaimAssignees: BatchClaimAssigneesConnection;
  /** Reads and enables pagination through a set of `BatchClaimAuditor`. */
  batchClaimAuditors: BatchClaimAuditorsConnection;
  /** Reads and enables pagination through a set of `BatchClaimState`. */
  batchClaimStates: BatchClaimStatesConnection;
  /** Reads and enables pagination through a set of `BatchClaimTechDenial`. */
  batchClaimTechDenialsByCreatedBy: BatchClaimTechDenialsConnection;
  /** Reads and enables pagination through a set of `ClaimAuditGroup`. */
  claimAuditGroupsByCreatedBy: ClaimAuditGroupsConnection;
  /** Reads and enables pagination through a set of `ClaimFacetHistory`. */
  claimFacetHistoriesByAppliedBy: ClaimFacetHistoriesConnection;
  claimIntakeEnabled: Scalars["Boolean"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  /** Reads and enables pagination through a set of `DocumentationClaimState`. */
  documentationClaimStatesByCreatedBy: DocumentationClaimStatesConnection;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  /** The sub (id) generated by the external IDP system (e.g. Cognito) */
  idpSub: Scalars["UUID"]["output"];
  /** Reads and enables pagination through a set of `InsurerUser`. */
  insurerUsers: InsurerUsersConnection;
  internalOnly?: Maybe<Scalars["Boolean"]["output"]>;
  lastName: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `MessageCreated`. */
  messageCreatedsBySenderUserId: MessageCreatedsConnection;
  /** Reads and enables pagination through a set of `MessageSent`. */
  messageSentsByRecipientUserId: MessageSentsConnection;
  /** Timestamp when user migrated to federated SSO via first login. */
  migratedToFederatedAt?: Maybe<Scalars["Datetime"]["output"]>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
  preSsoMigrationIdpSub?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `Provider` that is related to this `AuditorUser`. */
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `ProviderUserFacility`. */
  providerUserFacilities: ProviderUserFacilitiesConnection;
  /** Reads and enables pagination through a set of `QaClaimStateRow`. */
  qaClaimStateRowsByCreatedBy: QaClaimStateRowsConnection;
  readOnly?: Maybe<Scalars["Boolean"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
  userCognitoSettings: UserCognitoSettings;
  /** Reads and enables pagination through a set of `UserInviteCreated`. */
  userInviteCreateds: UserInviteCreatedsConnection;
  userType: UserTypeEnum;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUseractiveClaimAssigneesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ActiveClaimAssigneeCondition>;
  filter?: InputMaybe<ActiveClaimAssigneeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ActiveClaimAssigneesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauditFindingReportsByPrimaryPiaIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReportCondition>;
  filter?: InputMaybe<AuditFindingReportFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReportsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauditorBucketAssigneesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditorBucketAssigneeCondition>;
  filter?: InputMaybe<AuditorBucketAssigneeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditorBucketAssigneesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauditorBucketsByAssigneeIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditorBucketCondition>;
  filter?: InputMaybe<AuditorBucketFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditorBucketsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredAuditFindingJobsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingJobCondition>;
  filter?: InputMaybe<AuditFindingJobFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingJobsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredAuditFindingReasonCodesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReasonCodeCondition>;
  filter?: InputMaybe<AuditFindingReasonCodeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReasonCodesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredAuditFindingReportsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReportCondition>;
  filter?: InputMaybe<AuditFindingReportFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReportsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredAuditFindingReviewsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReviewCondition>;
  filter?: InputMaybe<AuditFindingReviewFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReviewsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredAuditFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingCondition>;
  filter?: InputMaybe<AuditFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredAuditorBucketsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditorBucketCondition>;
  filter?: InputMaybe<AuditorBucketFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditorBucketsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredBatchClaimLineItemAuditsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemAuditCondition>;
  filter?: InputMaybe<BatchClaimLineItemAuditFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemAuditsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredBatchClaimLineItemNnIbLinesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemNnIbLineCondition>;
  filter?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemNnIbLinesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredBatchClaimLineItemsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemCondition>;
  filter?: InputMaybe<BatchClaimLineItemFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredBatchClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimCondition>;
  filter?: InputMaybe<BatchClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredBatchFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchFileCondition>;
  filter?: InputMaybe<BatchFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchFilesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredDisputedFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DisputedFindingCondition>;
  filter?: InputMaybe<DisputedFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DisputedFindingsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredDocumentUploadCreatedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentUploadCreatedCondition>;
  filter?: InputMaybe<DocumentUploadCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentUploadCreatedsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredNnIbLinesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<NnIbLineCondition>;
  filter?: InputMaybe<NnIbLineFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<NnIbLinesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredQueuesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<QueueCondition>;
  filter?: InputMaybe<QueueFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<QueuesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserauthoredReviewedAuditFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ReviewedAuditFindingCondition>;
  filter?: InputMaybe<ReviewedAuditFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ReviewedAuditFindingsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserbatchClaimAppealedsByCreatedByArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAppealedCondition>;
  filter?: InputMaybe<BatchClaimAppealedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAppealedsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserbatchClaimAssigneesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAssigneeCondition>;
  filter?: InputMaybe<BatchClaimAssigneeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAssigneesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserbatchClaimAuditorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAuditorCondition>;
  filter?: InputMaybe<BatchClaimAuditorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAuditorsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserbatchClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimStateCondition>;
  filter?: InputMaybe<BatchClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimStatesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserbatchClaimTechDenialsByCreatedByArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimTechDenialCondition>;
  filter?: InputMaybe<BatchClaimTechDenialFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimTechDenialsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserclaimAuditGroupsByCreatedByArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimAuditGroupCondition>;
  filter?: InputMaybe<ClaimAuditGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimAuditGroupsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserclaimFacetHistoriesByAppliedByArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimFacetHistoryCondition>;
  filter?: InputMaybe<ClaimFacetHistoryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimFacetHistoriesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserdocumentationClaimStatesByCreatedByArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentationClaimStateCondition>;
  filter?: InputMaybe<DocumentationClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentationClaimStatesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserinsurerUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<InsurerUserCondition>;
  filter?: InputMaybe<InsurerUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<InsurerUsersOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUsermessageCreatedsBySenderUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MessageCreatedCondition>;
  filter?: InputMaybe<MessageCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MessageCreatedsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUsermessageSentsByRecipientUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MessageSentCondition>;
  filter?: InputMaybe<MessageSentFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MessageSentsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserproviderUserFacilitiesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProviderUserFacilityCondition>;
  filter?: InputMaybe<ProviderUserFacilityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProviderUserFacilitiesOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUserqaClaimStateRowsByCreatedByArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<QaClaimStateRowCondition>;
  filter?: InputMaybe<QaClaimStateRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<QaClaimStateRowsOrderBy>>;
};

/**
 * All user creation and updates must go through the createUser custom resolver to ensure
 * Temporal workflow is queued for updating batch_claim.permitted_insurer_users arrays.
 */
export type AuditorUseruserInviteCreatedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserInviteCreatedCondition>;
  filter?: InputMaybe<UserInviteCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserInviteCreatedsOrderBy>>;
};

export type AuditorUserAggregates = {
  __typename?: "AuditorUserAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuditorUserDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `AuditorUser` object types. */
export type AuditorUserAggregatesFilter = {
  /** Distinct count aggregate over matching `AuditorUser` objects. */
  distinctCount?: InputMaybe<AuditorUserDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AuditorUser` object to be included within the aggregate. */
  filter?: InputMaybe<AuditorUserFilter>;
};

/** The fields on `auditorUser` to look up the row to connect. */
export type AuditorUserAuditorUserEmailUniqueKeyConnect = {
  email: Scalars["String"]["input"];
};

/** The fields on `auditorUser` to look up the row to connect. */
export type AuditorUserAuditorUserIdpSubUniqueConnect = {
  /** The sub (id) generated by the external IDP system (e.g. Cognito) */
  idpSub: Scalars["UUID"]["input"];
};

/** The fields on `auditorUser` to look up the row to connect. */
export type AuditorUserAuditorUserPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `AuditorUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AuditorUserCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `idpSub` field. */
  idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `internalOnly` field. */
  internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `migratedToFederatedAt` field. */
  migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `preSsoMigrationIdpSub` field. */
  preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `readOnly` field. */
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `userType` field. */
  userType?: InputMaybe<UserTypeEnum>;
};

export type AuditorUserDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  email?: InputMaybe<BigIntFilter>;
  firstName?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  idpSub?: InputMaybe<BigIntFilter>;
  internalOnly?: InputMaybe<BigIntFilter>;
  lastName?: InputMaybe<BigIntFilter>;
  migratedToFederatedAt?: InputMaybe<BigIntFilter>;
  preSsoMigrationIdpSub?: InputMaybe<BigIntFilter>;
  providerId?: InputMaybe<BigIntFilter>;
  readOnly?: InputMaybe<BigIntFilter>;
  title?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  userType?: InputMaybe<BigIntFilter>;
};

export type AuditorUserDistinctCountAggregates = {
  __typename?: "AuditorUserDistinctCountAggregates";
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of email across the matching connection */
  email?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of firstName across the matching connection */
  firstName?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of idpSub across the matching connection */
  idpSub?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of internalOnly across the matching connection */
  internalOnly?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of lastName across the matching connection */
  lastName?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of migratedToFederatedAt across the matching connection */
  migratedToFederatedAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of preSsoMigrationIdpSub across the matching connection */
  preSsoMigrationIdpSub?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of providerId across the matching connection */
  providerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of readOnly across the matching connection */
  readOnly?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of title across the matching connection */
  title?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of userType across the matching connection */
  userType?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `AuditorUser` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserFilter = {
  /** Filter by the object’s `activeClaimAssignees` relation. */
  activeClaimAssignees?: InputMaybe<AuditorUserToManyActiveClaimAssigneeFilter>;
  /** Some related `activeClaimAssignees` exist. */
  activeClaimAssigneesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditorUserFilter>>;
  /** Filter by the object’s `auditFindingReportsByPrimaryPiaId` relation. */
  auditFindingReportsByPrimaryPiaId?: InputMaybe<AuditorUserToManyAuditFindingReportFilter>;
  /** Some related `auditFindingReportsByPrimaryPiaId` exist. */
  auditFindingReportsByPrimaryPiaIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `auditorBucketAssignees` relation. */
  auditorBucketAssignees?: InputMaybe<AuditorUserToManyAuditorBucketAssigneeFilter>;
  /** Some related `auditorBucketAssignees` exist. */
  auditorBucketAssigneesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `auditorBucketsByAssigneeId` relation. */
  auditorBucketsByAssigneeId?: InputMaybe<AuditorUserToManyAuditorBucketFilter>;
  /** Some related `auditorBucketsByAssigneeId` exist. */
  auditorBucketsByAssigneeIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredAuditFindingJobs` relation. */
  authoredAuditFindingJobs?: InputMaybe<AuditorUserToManyAuditFindingJobFilter>;
  /** Some related `authoredAuditFindingJobs` exist. */
  authoredAuditFindingJobsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredAuditFindingReasonCodes` relation. */
  authoredAuditFindingReasonCodes?: InputMaybe<AuditorUserToManyAuditFindingReasonCodeFilter>;
  /** Some related `authoredAuditFindingReasonCodes` exist. */
  authoredAuditFindingReasonCodesExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `authoredAuditFindingReports` relation. */
  authoredAuditFindingReports?: InputMaybe<AuditorUserToManyAuditFindingReportFilter>;
  /** Some related `authoredAuditFindingReports` exist. */
  authoredAuditFindingReportsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredAuditFindingReviews` relation. */
  authoredAuditFindingReviews?: InputMaybe<AuditorUserToManyAuditFindingReviewFilter>;
  /** Some related `authoredAuditFindingReviews` exist. */
  authoredAuditFindingReviewsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredAuditFindings` relation. */
  authoredAuditFindings?: InputMaybe<AuditorUserToManyAuditFindingFilter>;
  /** Some related `authoredAuditFindings` exist. */
  authoredAuditFindingsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredAuditorBuckets` relation. */
  authoredAuditorBuckets?: InputMaybe<AuditorUserToManyAuditorBucketFilter>;
  /** Some related `authoredAuditorBuckets` exist. */
  authoredAuditorBucketsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredBatchClaimLineItemAudits` relation. */
  authoredBatchClaimLineItemAudits?: InputMaybe<AuditorUserToManyBatchClaimLineItemAuditFilter>;
  /** Some related `authoredBatchClaimLineItemAudits` exist. */
  authoredBatchClaimLineItemAuditsExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `authoredBatchClaimLineItemNnIbLines` relation. */
  authoredBatchClaimLineItemNnIbLines?: InputMaybe<AuditorUserToManyBatchClaimLineItemNnIbLineFilter>;
  /** Some related `authoredBatchClaimLineItemNnIbLines` exist. */
  authoredBatchClaimLineItemNnIbLinesExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `authoredBatchClaimLineItems` relation. */
  authoredBatchClaimLineItems?: InputMaybe<AuditorUserToManyBatchClaimLineItemFilter>;
  /** Some related `authoredBatchClaimLineItems` exist. */
  authoredBatchClaimLineItemsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredBatchClaims` relation. */
  authoredBatchClaims?: InputMaybe<AuditorUserToManyBatchClaimFilter>;
  /** Some related `authoredBatchClaims` exist. */
  authoredBatchClaimsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredBatchFiles` relation. */
  authoredBatchFiles?: InputMaybe<AuditorUserToManyBatchFileFilter>;
  /** Some related `authoredBatchFiles` exist. */
  authoredBatchFilesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredDisputedFindings` relation. */
  authoredDisputedFindings?: InputMaybe<AuditorUserToManyDisputedFindingFilter>;
  /** Some related `authoredDisputedFindings` exist. */
  authoredDisputedFindingsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredDocumentUploadCreateds` relation. */
  authoredDocumentUploadCreateds?: InputMaybe<AuditorUserToManyDocumentUploadCreatedFilter>;
  /** Some related `authoredDocumentUploadCreateds` exist. */
  authoredDocumentUploadCreatedsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredNnIbLines` relation. */
  authoredNnIbLines?: InputMaybe<AuditorUserToManyNnIbLineFilter>;
  /** Some related `authoredNnIbLines` exist. */
  authoredNnIbLinesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredQueues` relation. */
  authoredQueues?: InputMaybe<AuditorUserToManyQueueFilter>;
  /** Some related `authoredQueues` exist. */
  authoredQueuesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authoredReviewedAuditFindings` relation. */
  authoredReviewedAuditFindings?: InputMaybe<AuditorUserToManyReviewedAuditFindingFilter>;
  /** Some related `authoredReviewedAuditFindings` exist. */
  authoredReviewedAuditFindingsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimAppealedsByCreatedBy` relation. */
  batchClaimAppealedsByCreatedBy?: InputMaybe<AuditorUserToManyBatchClaimAppealedFilter>;
  /** Some related `batchClaimAppealedsByCreatedBy` exist. */
  batchClaimAppealedsByCreatedByExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimAssignees` relation. */
  batchClaimAssignees?: InputMaybe<AuditorUserToManyBatchClaimAssigneeFilter>;
  /** Some related `batchClaimAssignees` exist. */
  batchClaimAssigneesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimAuditors` relation. */
  batchClaimAuditors?: InputMaybe<AuditorUserToManyBatchClaimAuditorFilter>;
  /** Some related `batchClaimAuditors` exist. */
  batchClaimAuditorsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimStates` relation. */
  batchClaimStates?: InputMaybe<AuditorUserToManyBatchClaimStateFilter>;
  /** Some related `batchClaimStates` exist. */
  batchClaimStatesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimTechDenialsByCreatedBy` relation. */
  batchClaimTechDenialsByCreatedBy?: InputMaybe<AuditorUserToManyBatchClaimTechDenialFilter>;
  /** Some related `batchClaimTechDenialsByCreatedBy` exist. */
  batchClaimTechDenialsByCreatedByExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `claimAuditGroupsByCreatedBy` relation. */
  claimAuditGroupsByCreatedBy?: InputMaybe<AuditorUserToManyClaimAuditGroupFilter>;
  /** Some related `claimAuditGroupsByCreatedBy` exist. */
  claimAuditGroupsByCreatedByExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `claimFacetHistoriesByAppliedBy` relation. */
  claimFacetHistoriesByAppliedBy?: InputMaybe<AuditorUserToManyClaimFacetHistoryFilter>;
  /** Some related `claimFacetHistoriesByAppliedBy` exist. */
  claimFacetHistoriesByAppliedByExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `documentationClaimStatesByCreatedBy` relation. */
  documentationClaimStatesByCreatedBy?: InputMaybe<AuditorUserToManyDocumentationClaimStateFilter>;
  /** Some related `documentationClaimStatesByCreatedBy` exist. */
  documentationClaimStatesByCreatedByExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `idpSub` field. */
  idpSub?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `insurerUsers` relation. */
  insurerUsers?: InputMaybe<AuditorUserToManyInsurerUserFilter>;
  /** Some related `insurerUsers` exist. */
  insurerUsersExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `internalOnly` field. */
  internalOnly?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `messageCreatedsBySenderUserId` relation. */
  messageCreatedsBySenderUserId?: InputMaybe<AuditorUserToManyMessageCreatedFilter>;
  /** Some related `messageCreatedsBySenderUserId` exist. */
  messageCreatedsBySenderUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `messageSentsByRecipientUserId` relation. */
  messageSentsByRecipientUserId?: InputMaybe<AuditorUserToManyMessageSentFilter>;
  /** Some related `messageSentsByRecipientUserId` exist. */
  messageSentsByRecipientUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `migratedToFederatedAt` field. */
  migratedToFederatedAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditorUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditorUserFilter>>;
  /** Filter by the object’s `preSsoMigrationIdpSub` field. */
  preSsoMigrationIdpSub?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `provider` relation. */
  provider?: InputMaybe<ProviderFilter>;
  /** A related `provider` exists. */
  providerExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `providerId` field. */
  providerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `providerUserFacilities` relation. */
  providerUserFacilities?: InputMaybe<AuditorUserToManyProviderUserFacilityFilter>;
  /** Some related `providerUserFacilities` exist. */
  providerUserFacilitiesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `qaClaimStateRowsByCreatedBy` relation. */
  qaClaimStateRowsByCreatedBy?: InputMaybe<AuditorUserToManyQaClaimStateRowFilter>;
  /** Some related `qaClaimStateRowsByCreatedBy` exist. */
  qaClaimStateRowsByCreatedByExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `readOnly` field. */
  readOnly?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userInviteCreateds` relation. */
  userInviteCreateds?: InputMaybe<AuditorUserToManyUserInviteCreatedFilter>;
  /** Some related `userInviteCreateds` exist. */
  userInviteCreatedsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `userType` field. */
  userType?: InputMaybe<UserTypeEnumFilter>;
};

/** Grouping methods for `AuditorUser` for usage during aggregation. */
export enum AuditorUserGroupBy {
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  FIRST_NAME = "FIRST_NAME",
  INTERNAL_ONLY = "INTERNAL_ONLY",
  LAST_NAME = "LAST_NAME",
  MIGRATED_TO_FEDERATED_AT = "MIGRATED_TO_FEDERATED_AT",
  MIGRATED_TO_FEDERATED_AT_TRUNCATED_TO_DAY = "MIGRATED_TO_FEDERATED_AT_TRUNCATED_TO_DAY",
  MIGRATED_TO_FEDERATED_AT_TRUNCATED_TO_HOUR = "MIGRATED_TO_FEDERATED_AT_TRUNCATED_TO_HOUR",
  PRE_SSO_MIGRATION_IDP_SUB = "PRE_SSO_MIGRATION_IDP_SUB",
  PROVIDER_ID = "PROVIDER_ID",
  READ_ONLY = "READ_ONLY",
  TITLE = "TITLE",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
  USER_TYPE = "USER_TYPE",
}

export type AuditorUserHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedToFederatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorUserHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedToFederatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `AuditorUser` aggregates. */
export type AuditorUserHavingInput = {
  AND?: InputMaybe<Array<AuditorUserHavingInput>>;
  OR?: InputMaybe<Array<AuditorUserHavingInput>>;
  average?: InputMaybe<AuditorUserHavingAverageInput>;
  distinctCount?: InputMaybe<AuditorUserHavingDistinctCountInput>;
  max?: InputMaybe<AuditorUserHavingMaxInput>;
  min?: InputMaybe<AuditorUserHavingMinInput>;
  stddevPopulation?: InputMaybe<AuditorUserHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuditorUserHavingStddevSampleInput>;
  sum?: InputMaybe<AuditorUserHavingSumInput>;
  variancePopulation?: InputMaybe<AuditorUserHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuditorUserHavingVarianceSampleInput>;
};

export type AuditorUserHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedToFederatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorUserHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedToFederatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorUserHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedToFederatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorUserHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedToFederatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorUserHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedToFederatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorUserHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedToFederatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type AuditorUserHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  migratedToFederatedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AuditorUserNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `activeClaimAssignee` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `activeClaimAssignee` being updated. */
    patch: ActiveClaimAssigneePatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingJob` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingJob` being updated. */
    patch: AuditFindingJobPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReasonCode` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReasonCode` being updated. */
    patch: AuditFindingReasonCodePatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReport` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: AuditFindingReportPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReport` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: AuditFindingReportPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReview` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReview` being updated. */
    patch: AuditFindingReviewPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorBucketAssignee` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucketAssignee` being updated. */
    patch: AuditorBucketAssigneePatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorBucket` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucket` being updated. */
    patch: AuditorBucketPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorBucket` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucket` being updated. */
    patch: AuditorBucketPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnAuditorUserForAuditorUserProviderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `provider` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `provider` being updated. */
  patch: ProviderPatch;
};

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorUserForAuditorUserProviderIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorUserForAuditorUserProviderIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorUserForAuditorUserProviderIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorUserForAuditorUserProviderIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnAuditorUserForAuditorUserProviderIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnAuditorUserForAuditorUserProviderIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimAppealed` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAppealed` being updated. */
    patch: BatchClaimAppealedPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimAssignee` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAssignee` being updated. */
    patch: BatchClaimAssigneePatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimAuditor` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAuditor` being updated. */
    patch: BatchClaimAuditorPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `batchClaim` being updated. */
  patch: BatchClaimPatch;
};

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItemAudit` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
    patch: BatchClaimLineItemAuditPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItem` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: BatchClaimLineItemPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItemNnIbLine` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
    patch: BatchClaimLineItemNnIbLinePatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimState` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimState` being updated. */
    patch: BatchClaimStatePatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimTechDenial` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimTechDenial` being updated. */
    patch: BatchClaimTechDenialPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnBatchFileForBatchFileAuthorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `batchFile` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `batchFile` being updated. */
  patch: BatchFilePatch;
};

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchFileForBatchFileAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchFileForBatchFileAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchFileForBatchFileAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchFileForBatchFileAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnBatchFileForBatchFileAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnBatchFileForBatchFileAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `claimAuditGroup` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
    patch: ClaimAuditGroupPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `claimFacetHistory` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `claimFacetHistory` being updated. */
    patch: ClaimFacetHistoryPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `disputedFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `disputedFinding` being updated. */
    patch: DisputedFindingPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `documentUploadCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
    patch: DocumentUploadCreatedPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `documentationClaimState` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `documentationClaimState` being updated. */
    patch: DocumentationClaimStatePatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `insurerUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `insurerUser` being updated. */
    patch: InsurerUserPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `messageCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: MessageCreatedPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `messageSent` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `messageSent` being updated. */
    patch: MessageSentPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `nnIbLine` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `nnIbLine` being updated. */
  patch: NnIbLinePatch;
};

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `providerUserFacility` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `providerUserFacility` being updated. */
    patch: ProviderUserFacilityPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `qaClaimStateRow` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `qaClaimStateRow` being updated. */
    patch: QaClaimStateRowPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnQueueForQueueAuthorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `queue` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `queue` being updated. */
  patch: QueuePatch;
};

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnQueueForQueueAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnQueueForQueueAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnQueueForQueueAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnQueueForQueueAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnQueueForQueueAuthorIdFkeyUsingAuditorUserPkeyUpdate = {
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `auditorUser` being updated. */
  patch: updateAuditorUserOnQueueForQueueAuthorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `reviewedAuditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `reviewedAuditFinding` being updated. */
    patch: ReviewedAuditFindingPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type AuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `userInviteCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `userInviteCreated` being updated. */
    patch: UserInviteCreatedPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate =
  {
    email: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate =
  {
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyPatch;
  };

/** The fields on `auditorUser` to look up the row to update. */
export type AuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyUsingAuditorUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: updateAuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyPatch;
  };

/** Represents an update to a `AuditorUser`. Fields that are set will be updated. */
export type AuditorUserPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
  auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
  auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
  auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
  auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
  auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
  auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
  batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
  batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
  batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
  batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
  batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
  claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The sub (id) generated by the external IDP system (e.g. Cognito) */
  idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
  internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
  messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
  /** Timestamp when user migrated to federated SSO via first login. */
  migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
  /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
  preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
  providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
  queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
  userType?: InputMaybe<UserTypeEnum>;
};

/** Input for the nested mutation of `provider` in the `AuditorUserInput` mutation. */
export type AuditorUserProviderIdFkeyInput = {
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectById?: InputMaybe<ProviderProviderPkeyConnect>;
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProviderNodeIdConnect>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateById?: InputMaybe<ProviderOnAuditorUserForAuditorUserProviderIdFkeyUsingProviderPkeyUpdate>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditorUserOnAuditorUserForAuditorUserProviderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditorUser` in the `ProviderInput` mutation. */
export type AuditorUserProviderIdFkeyInverseInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<
    Array<AuditorUserAuditorUserEmailUniqueKeyConnect>
  >;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditorUserAuditorUserPkeyConnect>>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<
    Array<AuditorUserAuditorUserIdpSubUniqueConnect>
  >;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditorUserNodeIdConnect>>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<
    Array<AuditorUserOnAuditorUserForAuditorUserProviderIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditorUserOnAuditorUserForAuditorUserProviderIdFkeyUsingAuditorUserPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<
    Array<AuditorUserOnAuditorUserForAuditorUserProviderIdFkeyUsingAuditorUserIdpSubUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<ProviderOnAuditorUserForAuditorUserProviderIdFkeyNodeIdUpdate>
  >;
};

/** A filter to be used against many `ActiveClaimAssignee` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyActiveClaimAssigneeFilter = {
  /** Aggregates across related `ActiveClaimAssignee` match the filter criteria. */
  aggregates?: InputMaybe<ActiveClaimAssigneeAggregatesFilter>;
  /** Every related `ActiveClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ActiveClaimAssigneeFilter>;
  /** No related `ActiveClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ActiveClaimAssigneeFilter>;
  /** Some related `ActiveClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ActiveClaimAssigneeFilter>;
};

/** A filter to be used against many `AuditFinding` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyAuditFindingFilter = {
  /** Aggregates across related `AuditFinding` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingAggregatesFilter>;
  /** Every related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingFilter>;
  /** No related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingFilter>;
  /** Some related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingFilter>;
};

/** A filter to be used against many `AuditFindingJob` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyAuditFindingJobFilter = {
  /** Aggregates across related `AuditFindingJob` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingJobAggregatesFilter>;
  /** Every related `AuditFindingJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingJobFilter>;
  /** No related `AuditFindingJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingJobFilter>;
  /** Some related `AuditFindingJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingJobFilter>;
};

/** A filter to be used against many `AuditFindingReasonCode` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyAuditFindingReasonCodeFilter = {
  /** Aggregates across related `AuditFindingReasonCode` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingReasonCodeAggregatesFilter>;
  /** Every related `AuditFindingReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingReasonCodeFilter>;
  /** No related `AuditFindingReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingReasonCodeFilter>;
  /** Some related `AuditFindingReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingReasonCodeFilter>;
};

/** A filter to be used against many `AuditFindingReport` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyAuditFindingReportFilter = {
  /** Aggregates across related `AuditFindingReport` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingReportAggregatesFilter>;
  /** Every related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingReportFilter>;
  /** No related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingReportFilter>;
  /** Some related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingReportFilter>;
};

/** A filter to be used against many `AuditFindingReview` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyAuditFindingReviewFilter = {
  /** Aggregates across related `AuditFindingReview` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingReviewAggregatesFilter>;
  /** Every related `AuditFindingReview` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingReviewFilter>;
  /** No related `AuditFindingReview` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingReviewFilter>;
  /** Some related `AuditFindingReview` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingReviewFilter>;
};

/** A filter to be used against many `AuditorBucketAssignee` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyAuditorBucketAssigneeFilter = {
  /** Aggregates across related `AuditorBucketAssignee` match the filter criteria. */
  aggregates?: InputMaybe<AuditorBucketAssigneeAggregatesFilter>;
  /** Every related `AuditorBucketAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditorBucketAssigneeFilter>;
  /** No related `AuditorBucketAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditorBucketAssigneeFilter>;
  /** Some related `AuditorBucketAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditorBucketAssigneeFilter>;
};

/** A filter to be used against many `AuditorBucket` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyAuditorBucketFilter = {
  /** Aggregates across related `AuditorBucket` match the filter criteria. */
  aggregates?: InputMaybe<AuditorBucketAggregatesFilter>;
  /** Every related `AuditorBucket` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditorBucketFilter>;
  /** No related `AuditorBucket` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditorBucketFilter>;
  /** Some related `AuditorBucket` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditorBucketFilter>;
};

/** A filter to be used against many `BatchClaimAppealed` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyBatchClaimAppealedFilter = {
  /** Aggregates across related `BatchClaimAppealed` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAppealedAggregatesFilter>;
  /** Every related `BatchClaimAppealed` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimAppealedFilter>;
  /** No related `BatchClaimAppealed` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimAppealedFilter>;
  /** Some related `BatchClaimAppealed` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimAppealedFilter>;
};

/** A filter to be used against many `BatchClaimAssignee` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyBatchClaimAssigneeFilter = {
  /** Aggregates across related `BatchClaimAssignee` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAssigneeAggregatesFilter>;
  /** Every related `BatchClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimAssigneeFilter>;
  /** No related `BatchClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimAssigneeFilter>;
  /** Some related `BatchClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimAssigneeFilter>;
};

/** A filter to be used against many `BatchClaimAuditor` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyBatchClaimAuditorFilter = {
  /** Aggregates across related `BatchClaimAuditor` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAuditorAggregatesFilter>;
  /** Every related `BatchClaimAuditor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimAuditorFilter>;
  /** No related `BatchClaimAuditor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimAuditorFilter>;
  /** Some related `BatchClaimAuditor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimAuditorFilter>;
};

/** A filter to be used against many `BatchClaim` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyBatchClaimFilter = {
  /** Aggregates across related `BatchClaim` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAggregatesFilter>;
  /** Every related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimFilter>;
  /** No related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimFilter>;
  /** Some related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimFilter>;
};

/** A filter to be used against many `BatchClaimLineItemAudit` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyBatchClaimLineItemAuditFilter = {
  /** Aggregates across related `BatchClaimLineItemAudit` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimLineItemAuditAggregatesFilter>;
  /** Every related `BatchClaimLineItemAudit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimLineItemAuditFilter>;
  /** No related `BatchClaimLineItemAudit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimLineItemAuditFilter>;
  /** Some related `BatchClaimLineItemAudit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimLineItemAuditFilter>;
};

/** A filter to be used against many `BatchClaimLineItem` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyBatchClaimLineItemFilter = {
  /** Aggregates across related `BatchClaimLineItem` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimLineItemAggregatesFilter>;
  /** Every related `BatchClaimLineItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimLineItemFilter>;
  /** No related `BatchClaimLineItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimLineItemFilter>;
  /** Some related `BatchClaimLineItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimLineItemFilter>;
};

/** A filter to be used against many `BatchClaimLineItemNnIbLine` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyBatchClaimLineItemNnIbLineFilter = {
  /** Aggregates across related `BatchClaimLineItemNnIbLine` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimLineItemNnIbLineAggregatesFilter>;
  /** Every related `BatchClaimLineItemNnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
  /** No related `BatchClaimLineItemNnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
  /** Some related `BatchClaimLineItemNnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
};

/** A filter to be used against many `BatchClaimState` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyBatchClaimStateFilter = {
  /** Aggregates across related `BatchClaimState` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimStateAggregatesFilter>;
  /** Every related `BatchClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimStateFilter>;
  /** No related `BatchClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimStateFilter>;
  /** Some related `BatchClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimStateFilter>;
};

/** A filter to be used against many `BatchClaimTechDenial` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyBatchClaimTechDenialFilter = {
  /** Aggregates across related `BatchClaimTechDenial` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimTechDenialAggregatesFilter>;
  /** Every related `BatchClaimTechDenial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimTechDenialFilter>;
  /** No related `BatchClaimTechDenial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimTechDenialFilter>;
  /** Some related `BatchClaimTechDenial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimTechDenialFilter>;
};

/** A filter to be used against many `BatchFile` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyBatchFileFilter = {
  /** Aggregates across related `BatchFile` match the filter criteria. */
  aggregates?: InputMaybe<BatchFileAggregatesFilter>;
  /** Every related `BatchFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchFileFilter>;
  /** No related `BatchFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchFileFilter>;
  /** Some related `BatchFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchFileFilter>;
};

/** A filter to be used against many `ClaimAuditGroup` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyClaimAuditGroupFilter = {
  /** Aggregates across related `ClaimAuditGroup` match the filter criteria. */
  aggregates?: InputMaybe<ClaimAuditGroupAggregatesFilter>;
  /** Every related `ClaimAuditGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ClaimAuditGroupFilter>;
  /** No related `ClaimAuditGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ClaimAuditGroupFilter>;
  /** Some related `ClaimAuditGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ClaimAuditGroupFilter>;
};

/** A filter to be used against many `ClaimFacetHistory` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyClaimFacetHistoryFilter = {
  /** Aggregates across related `ClaimFacetHistory` match the filter criteria. */
  aggregates?: InputMaybe<ClaimFacetHistoryAggregatesFilter>;
  /** Every related `ClaimFacetHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ClaimFacetHistoryFilter>;
  /** No related `ClaimFacetHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ClaimFacetHistoryFilter>;
  /** Some related `ClaimFacetHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ClaimFacetHistoryFilter>;
};

/** A filter to be used against many `DisputedFinding` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyDisputedFindingFilter = {
  /** Aggregates across related `DisputedFinding` match the filter criteria. */
  aggregates?: InputMaybe<DisputedFindingAggregatesFilter>;
  /** Every related `DisputedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DisputedFindingFilter>;
  /** No related `DisputedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DisputedFindingFilter>;
  /** Some related `DisputedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DisputedFindingFilter>;
};

/** A filter to be used against many `DocumentUploadCreated` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyDocumentUploadCreatedFilter = {
  /** Aggregates across related `DocumentUploadCreated` match the filter criteria. */
  aggregates?: InputMaybe<DocumentUploadCreatedAggregatesFilter>;
  /** Every related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUploadCreatedFilter>;
  /** No related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUploadCreatedFilter>;
  /** Some related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUploadCreatedFilter>;
};

/** A filter to be used against many `DocumentationClaimState` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyDocumentationClaimStateFilter = {
  /** Aggregates across related `DocumentationClaimState` match the filter criteria. */
  aggregates?: InputMaybe<DocumentationClaimStateAggregatesFilter>;
  /** Every related `DocumentationClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentationClaimStateFilter>;
  /** No related `DocumentationClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentationClaimStateFilter>;
  /** Some related `DocumentationClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentationClaimStateFilter>;
};

/** A filter to be used against many `InsurerUser` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyInsurerUserFilter = {
  /** Aggregates across related `InsurerUser` match the filter criteria. */
  aggregates?: InputMaybe<InsurerUserAggregatesFilter>;
  /** Every related `InsurerUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<InsurerUserFilter>;
  /** No related `InsurerUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<InsurerUserFilter>;
  /** Some related `InsurerUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<InsurerUserFilter>;
};

/** A filter to be used against many `MessageCreated` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyMessageCreatedFilter = {
  /** Aggregates across related `MessageCreated` match the filter criteria. */
  aggregates?: InputMaybe<MessageCreatedAggregatesFilter>;
  /** Every related `MessageCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MessageCreatedFilter>;
  /** No related `MessageCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MessageCreatedFilter>;
  /** Some related `MessageCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MessageCreatedFilter>;
};

/** A filter to be used against many `MessageSent` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyMessageSentFilter = {
  /** Aggregates across related `MessageSent` match the filter criteria. */
  aggregates?: InputMaybe<MessageSentAggregatesFilter>;
  /** Every related `MessageSent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MessageSentFilter>;
  /** No related `MessageSent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MessageSentFilter>;
  /** Some related `MessageSent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MessageSentFilter>;
};

/** A filter to be used against many `NnIbLine` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyNnIbLineFilter = {
  /** Aggregates across related `NnIbLine` match the filter criteria. */
  aggregates?: InputMaybe<NnIbLineAggregatesFilter>;
  /** Every related `NnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NnIbLineFilter>;
  /** No related `NnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NnIbLineFilter>;
  /** Some related `NnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NnIbLineFilter>;
};

/** A filter to be used against many `ProviderUserFacility` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyProviderUserFacilityFilter = {
  /** Aggregates across related `ProviderUserFacility` match the filter criteria. */
  aggregates?: InputMaybe<ProviderUserFacilityAggregatesFilter>;
  /** Every related `ProviderUserFacility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProviderUserFacilityFilter>;
  /** No related `ProviderUserFacility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProviderUserFacilityFilter>;
  /** Some related `ProviderUserFacility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProviderUserFacilityFilter>;
};

/** A filter to be used against many `QaClaimStateRow` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyQaClaimStateRowFilter = {
  /** Aggregates across related `QaClaimStateRow` match the filter criteria. */
  aggregates?: InputMaybe<QaClaimStateRowAggregatesFilter>;
  /** Every related `QaClaimStateRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<QaClaimStateRowFilter>;
  /** No related `QaClaimStateRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<QaClaimStateRowFilter>;
  /** Some related `QaClaimStateRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<QaClaimStateRowFilter>;
};

/** A filter to be used against many `Queue` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyQueueFilter = {
  /** Aggregates across related `Queue` match the filter criteria. */
  aggregates?: InputMaybe<QueueAggregatesFilter>;
  /** Every related `Queue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<QueueFilter>;
  /** No related `Queue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<QueueFilter>;
  /** Some related `Queue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<QueueFilter>;
};

/** A filter to be used against many `ReviewedAuditFinding` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyReviewedAuditFindingFilter = {
  /** Aggregates across related `ReviewedAuditFinding` match the filter criteria. */
  aggregates?: InputMaybe<ReviewedAuditFindingAggregatesFilter>;
  /** Every related `ReviewedAuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ReviewedAuditFindingFilter>;
  /** No related `ReviewedAuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ReviewedAuditFindingFilter>;
  /** Some related `ReviewedAuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ReviewedAuditFindingFilter>;
};

/** A filter to be used against many `UserInviteCreated` object types. All fields are combined with a logical ‘and.’ */
export type AuditorUserToManyUserInviteCreatedFilter = {
  /** Aggregates across related `UserInviteCreated` match the filter criteria. */
  aggregates?: InputMaybe<UserInviteCreatedAggregatesFilter>;
  /** Every related `UserInviteCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserInviteCreatedFilter>;
  /** No related `UserInviteCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserInviteCreatedFilter>;
  /** Some related `UserInviteCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserInviteCreatedFilter>;
};

/** A connection to a list of `AuditorUser` values. */
export type AuditorUsersConnection = {
  __typename?: "AuditorUsersConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuditorUserAggregates>;
  /** A list of edges which contains the `AuditorUser` and cursor to aid in pagination. */
  edges: Array<AuditorUsersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuditorUserAggregates>>;
  /** A list of `AuditorUser` objects. */
  nodes: Array<Maybe<AuditorUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditorUser` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `AuditorUser` values. */
export type AuditorUsersConnectiongroupedAggregatesArgs = {
  groupBy: Array<AuditorUserGroupBy>;
  having?: InputMaybe<AuditorUserHavingInput>;
};

/** A `AuditorUser` edge in the connection. */
export type AuditorUsersEdge = {
  __typename?: "AuditorUsersEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuditorUser` at the end of the edge. */
  node?: Maybe<AuditorUser>;
};

/** Methods to use when ordering `AuditorUser`. */
export enum AuditorUsersOrderBy {
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_ASC = "ACTIVE_CLAIM_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_DESC = "ACTIVE_CLAIM_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_COUNT_ASC = "ACTIVE_CLAIM_ASSIGNEES_COUNT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_COUNT_DESC = "ACTIVE_CLAIM_ASSIGNEES_COUNT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_MAX_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_MAX_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MAX_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MAX_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_MIN_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_MIN_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MIN_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MIN_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_SUM_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_SUM_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_SUM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_SUM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_CREATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_CREATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_CREATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_CREATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_DUE_DATE_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_DUE_DATE_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_DUE_DATE_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_DUE_DATE_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_FILTER_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_FILTER_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_FILTER_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_FILTER_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_INSURER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_INSURER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_INSURER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_INSURER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_NAME_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_NAME_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_NAME_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_NAME_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_UPDATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_UPDATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_AVERAGE_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_COUNT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_COUNT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_COUNT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_COUNT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_CREATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_CREATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_DUE_DATE_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_DUE_DATE_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_DUE_DATE_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_DUE_DATE_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_FILTER_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_FILTER_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_FILTER_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_FILTER_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_INSURER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_INSURER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_INSURER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_INSURER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_NAME_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_NAME_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_NAME_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_NAME_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_CREATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_CREATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_CREATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_CREATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_DUE_DATE_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_DUE_DATE_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_DUE_DATE_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_DUE_DATE_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_FILTER_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_FILTER_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_FILTER_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_FILTER_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_INSURER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_INSURER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_INSURER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_INSURER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_NAME_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_NAME_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_NAME_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_NAME_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_UPDATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_UPDATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MAX_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_CREATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_CREATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_CREATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_CREATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_DUE_DATE_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_DUE_DATE_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_DUE_DATE_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_DUE_DATE_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_FILTER_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_FILTER_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_FILTER_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_FILTER_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_INSURER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_INSURER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_INSURER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_INSURER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_NAME_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_NAME_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_NAME_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_NAME_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_UPDATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_UPDATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_MIN_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_CREATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_CREATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_DUE_DATE_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_DUE_DATE_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_DUE_DATE_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_DUE_DATE_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_FILTER_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_FILTER_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_FILTER_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_FILTER_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_INSURER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_INSURER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_INSURER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_INSURER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_NAME_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_NAME_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_NAME_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_NAME_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_DUE_DATE_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_DUE_DATE_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_DUE_DATE_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_DUE_DATE_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_FILTER_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_FILTER_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_FILTER_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_FILTER_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_INSURER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_INSURER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_INSURER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_INSURER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_NAME_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_NAME_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_NAME_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_NAME_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_CREATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_CREATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_CREATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_CREATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_DUE_DATE_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_DUE_DATE_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_DUE_DATE_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_DUE_DATE_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_FILTER_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_FILTER_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_FILTER_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_FILTER_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_INSURER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_INSURER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_INSURER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_INSURER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_NAME_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_NAME_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_NAME_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_NAME_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_UPDATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_UPDATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_SUM_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_DUE_DATE_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_DUE_DATE_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_DUE_DATE_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_DUE_DATE_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_FILTER_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_FILTER_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_FILTER_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_FILTER_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_INSURER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_INSURER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_INSURER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_INSURER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_NAME_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_NAME_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_NAME_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_NAME_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_DUE_DATE_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_DUE_DATE_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_DUE_DATE_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_DUE_DATE_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_FILTER_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_FILTER_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_FILTER_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_FILTER_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_INSURER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_INSURER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_INSURER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_INSURER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_NAME_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_NAME_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_NAME_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_NAME_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID__COUNT_ASC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID__COUNT_ASC",
  AUDITOR_BUCKETS_BY_ASSIGNEE_ID__COUNT_DESC = "AUDITOR_BUCKETS_BY_ASSIGNEE_ID__COUNT_DESC",
  AUDITOR_BUCKETS_BY_AUTHOR_ID__COUNT_ASC = "AUDITOR_BUCKETS_BY_AUTHOR_ID__COUNT_ASC",
  AUDITOR_BUCKETS_BY_AUTHOR_ID__COUNT_DESC = "AUDITOR_BUCKETS_BY_AUTHOR_ID__COUNT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_AVERAGE_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_ASC = "AUDITOR_BUCKET_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_DESC = "AUDITOR_BUCKET_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_COUNT_ASC = "AUDITOR_BUCKET_ASSIGNEES_COUNT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_COUNT_DESC = "AUDITOR_BUCKET_ASSIGNEES_COUNT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_MAX_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MAX_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_MAX_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_MIN_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_MIN_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_MIN_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_SUM_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_SUM_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_SUM_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_BUCKET_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_DESC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDITOR_BUCKET_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_AUTHOR_ID__COUNT_ASC = "AUDIT_FINDINGS_BY_AUTHOR_ID__COUNT_ASC",
  AUDIT_FINDINGS_BY_AUTHOR_ID__COUNT_DESC = "AUDIT_FINDINGS_BY_AUTHOR_ID__COUNT_DESC",
  AUDIT_FINDING_JOBS_BY_AUTHOR_ID__COUNT_ASC = "AUDIT_FINDING_JOBS_BY_AUTHOR_ID__COUNT_ASC",
  AUDIT_FINDING_JOBS_BY_AUTHOR_ID__COUNT_DESC = "AUDIT_FINDING_JOBS_BY_AUTHOR_ID__COUNT_DESC",
  AUDIT_FINDING_REASON_CODES_BY_AUTHOR_ID__COUNT_ASC = "AUDIT_FINDING_REASON_CODES_BY_AUTHOR_ID__COUNT_ASC",
  AUDIT_FINDING_REASON_CODES_BY_AUTHOR_ID__COUNT_DESC = "AUDIT_FINDING_REASON_CODES_BY_AUTHOR_ID__COUNT_DESC",
  AUDIT_FINDING_REPORTS_BY_AUTHOR_ID__COUNT_ASC = "AUDIT_FINDING_REPORTS_BY_AUTHOR_ID__COUNT_ASC",
  AUDIT_FINDING_REPORTS_BY_AUTHOR_ID__COUNT_DESC = "AUDIT_FINDING_REPORTS_BY_AUTHOR_ID__COUNT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_AVERAGE_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_COUNT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_COUNT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_COUNT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_COUNT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_DISTINCT_COUNT_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MAX_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_MIN_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_POPULATION_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_STDDEV_SAMPLE_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_SUM_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_POPULATION_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_TITLE_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_TITLE_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID_VARIANCE_SAMPLE_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID__COUNT_ASC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID__COUNT_ASC",
  AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID__COUNT_DESC = "AUDIT_FINDING_REPORTS_BY_PRIMARY_PIA_ID__COUNT_DESC",
  AUDIT_FINDING_REVIEWS_BY_AUTHOR_ID__COUNT_ASC = "AUDIT_FINDING_REVIEWS_BY_AUTHOR_ID__COUNT_ASC",
  AUDIT_FINDING_REVIEWS_BY_AUTHOR_ID__COUNT_DESC = "AUDIT_FINDING_REVIEWS_BY_AUTHOR_ID__COUNT_DESC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_CREATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_CREATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_DUE_DATE_ASC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_DUE_DATE_ASC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_DUE_DATE_DESC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_DUE_DATE_DESC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_FILTER_ASC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_FILTER_ASC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_FILTER_DESC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_FILTER_DESC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_INSURER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_INSURER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_INSURER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_INSURER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_NAME_ASC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_NAME_ASC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_NAME_DESC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_NAME_DESC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_COUNT_ASC = "AUTHORED_AUDITOR_BUCKETS_COUNT_ASC",
  AUTHORED_AUDITOR_BUCKETS_COUNT_DESC = "AUTHORED_AUDITOR_BUCKETS_COUNT_DESC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_ASC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_ASC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_DESC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_DESC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_ASC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_ASC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_DESC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_DESC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_ASC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_ASC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_DESC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_DESC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_MAX_AUTHOR_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_MAX_AUTHOR_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_MAX_AUTHOR_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_MAX_AUTHOR_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_MAX_CREATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_MAX_CREATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_MAX_CREATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_MAX_CREATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_MAX_DUE_DATE_ASC = "AUTHORED_AUDITOR_BUCKETS_MAX_DUE_DATE_ASC",
  AUTHORED_AUDITOR_BUCKETS_MAX_DUE_DATE_DESC = "AUTHORED_AUDITOR_BUCKETS_MAX_DUE_DATE_DESC",
  AUTHORED_AUDITOR_BUCKETS_MAX_FILTER_ASC = "AUTHORED_AUDITOR_BUCKETS_MAX_FILTER_ASC",
  AUTHORED_AUDITOR_BUCKETS_MAX_FILTER_DESC = "AUTHORED_AUDITOR_BUCKETS_MAX_FILTER_DESC",
  AUTHORED_AUDITOR_BUCKETS_MAX_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_MAX_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_MAX_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_MAX_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_MAX_INSURER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_MAX_INSURER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_MAX_INSURER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_MAX_INSURER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_MAX_NAME_ASC = "AUTHORED_AUDITOR_BUCKETS_MAX_NAME_ASC",
  AUTHORED_AUDITOR_BUCKETS_MAX_NAME_DESC = "AUTHORED_AUDITOR_BUCKETS_MAX_NAME_DESC",
  AUTHORED_AUDITOR_BUCKETS_MAX_PROVIDER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_MAX_PROVIDER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_MAX_PROVIDER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_MAX_PROVIDER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_MAX_UPDATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_MAX_UPDATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_MAX_UPDATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_MAX_UPDATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_MIN_AUTHOR_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_MIN_AUTHOR_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_MIN_AUTHOR_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_MIN_AUTHOR_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_MIN_CREATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_MIN_CREATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_MIN_CREATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_MIN_CREATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_MIN_DUE_DATE_ASC = "AUTHORED_AUDITOR_BUCKETS_MIN_DUE_DATE_ASC",
  AUTHORED_AUDITOR_BUCKETS_MIN_DUE_DATE_DESC = "AUTHORED_AUDITOR_BUCKETS_MIN_DUE_DATE_DESC",
  AUTHORED_AUDITOR_BUCKETS_MIN_FILTER_ASC = "AUTHORED_AUDITOR_BUCKETS_MIN_FILTER_ASC",
  AUTHORED_AUDITOR_BUCKETS_MIN_FILTER_DESC = "AUTHORED_AUDITOR_BUCKETS_MIN_FILTER_DESC",
  AUTHORED_AUDITOR_BUCKETS_MIN_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_MIN_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_MIN_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_MIN_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_MIN_INSURER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_MIN_INSURER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_MIN_INSURER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_MIN_INSURER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_MIN_NAME_ASC = "AUTHORED_AUDITOR_BUCKETS_MIN_NAME_ASC",
  AUTHORED_AUDITOR_BUCKETS_MIN_NAME_DESC = "AUTHORED_AUDITOR_BUCKETS_MIN_NAME_DESC",
  AUTHORED_AUDITOR_BUCKETS_MIN_PROVIDER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_MIN_PROVIDER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_MIN_PROVIDER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_MIN_PROVIDER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_MIN_UPDATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_MIN_UPDATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_MIN_UPDATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_MIN_UPDATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_SUM_AUTHOR_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_SUM_AUTHOR_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_SUM_AUTHOR_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_SUM_AUTHOR_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_SUM_CREATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_SUM_CREATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_SUM_CREATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_SUM_CREATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_SUM_DUE_DATE_ASC = "AUTHORED_AUDITOR_BUCKETS_SUM_DUE_DATE_ASC",
  AUTHORED_AUDITOR_BUCKETS_SUM_DUE_DATE_DESC = "AUTHORED_AUDITOR_BUCKETS_SUM_DUE_DATE_DESC",
  AUTHORED_AUDITOR_BUCKETS_SUM_FILTER_ASC = "AUTHORED_AUDITOR_BUCKETS_SUM_FILTER_ASC",
  AUTHORED_AUDITOR_BUCKETS_SUM_FILTER_DESC = "AUTHORED_AUDITOR_BUCKETS_SUM_FILTER_DESC",
  AUTHORED_AUDITOR_BUCKETS_SUM_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_SUM_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_SUM_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_SUM_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_SUM_INSURER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_SUM_INSURER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_SUM_INSURER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_SUM_INSURER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_SUM_NAME_ASC = "AUTHORED_AUDITOR_BUCKETS_SUM_NAME_ASC",
  AUTHORED_AUDITOR_BUCKETS_SUM_NAME_DESC = "AUTHORED_AUDITOR_BUCKETS_SUM_NAME_DESC",
  AUTHORED_AUDITOR_BUCKETS_SUM_PROVIDER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_SUM_PROVIDER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_SUM_PROVIDER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_SUM_PROVIDER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_SUM_UPDATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_SUM_UPDATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_SUM_UPDATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_SUM_UPDATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_CONFIDENCE_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_CONFIDENCE_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_CONFIDENCE_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_CONFIDENCE_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_DELETED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_DELETED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_DELETED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_DELETED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_DELETED_BY_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_DELETED_BY_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_DELETED_BY_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_DELETED_BY_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_COUNT_ASC = "AUTHORED_AUDIT_FINDINGS_COUNT_ASC",
  AUTHORED_AUDIT_FINDINGS_COUNT_DESC = "AUTHORED_AUDIT_FINDINGS_COUNT_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_AUDIT_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUTOMATION_KIND_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_AUTOMATION_KIND_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUTOMATION_KIND_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_AUTOMATION_KIND_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_CONFIDENCE_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_CONFIDENCE_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_CONFIDENCE_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_CONFIDENCE_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_DELETED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_DELETED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_DELETED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_DELETED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_DELETED_BY_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_DELETED_BY_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_DELETED_BY_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_DELETED_BY_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_NEEDS_REVIEW_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_NEEDS_REVIEW_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_NEEDS_REVIEW_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_NEEDS_REVIEW_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MAX_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_MAX_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_MAX_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_MAX_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_AUDIT_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUTOMATION_KIND_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_AUTOMATION_KIND_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUTOMATION_KIND_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_AUTOMATION_KIND_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_CONFIDENCE_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_CONFIDENCE_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_CONFIDENCE_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_CONFIDENCE_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_DELETED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_DELETED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_DELETED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_DELETED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_DELETED_BY_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_DELETED_BY_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_DELETED_BY_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_DELETED_BY_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_NEEDS_REVIEW_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_NEEDS_REVIEW_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_NEEDS_REVIEW_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_NEEDS_REVIEW_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_MIN_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_MIN_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_MIN_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_MIN_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_AUDIT_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUTOMATION_KIND_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_AUTOMATION_KIND_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUTOMATION_KIND_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_AUTOMATION_KIND_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_CONFIDENCE_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_CONFIDENCE_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_CONFIDENCE_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_CONFIDENCE_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_DELETED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_DELETED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_DELETED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_DELETED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_DELETED_BY_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_DELETED_BY_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_DELETED_BY_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_DELETED_BY_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_ID_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_ID_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_NEEDS_REVIEW_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_NEEDS_REVIEW_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_NEEDS_REVIEW_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_NEEDS_REVIEW_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_SUM_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_SUM_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_SUM_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_SUM_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_NEEDS_REVIEW_IS_WRONG_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_NEEDS_REVIEW_IS_WRONG_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_NEEDS_REVIEW_IS_WRONG_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_NEEDS_REVIEW_IS_WRONG_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_COUNT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_COUNT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_COUNT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_COUNT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_NEEDS_REVIEW_IS_WRONG_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_NEEDS_REVIEW_IS_WRONG_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_NEEDS_REVIEW_IS_WRONG_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_NEEDS_REVIEW_IS_WRONG_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_NEEDS_REVIEW_IS_WRONG_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_NEEDS_REVIEW_IS_WRONG_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_NEEDS_REVIEW_IS_WRONG_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_NEEDS_REVIEW_IS_WRONG_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_NEEDS_REVIEW_IS_WRONG_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_NEEDS_REVIEW_IS_WRONG_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_NEEDS_REVIEW_IS_WRONG_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_NEEDS_REVIEW_IS_WRONG_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_NEEDS_REVIEW_IS_WRONG_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_NEEDS_REVIEW_IS_WRONG_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_NEEDS_REVIEW_IS_WRONG_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_NEEDS_REVIEW_IS_WRONG_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_NEEDS_REVIEW_IS_WRONG_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_NEEDS_REVIEW_IS_WRONG_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_NEEDS_REVIEW_IS_WRONG_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_NEEDS_REVIEW_IS_WRONG_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_NEEDS_REVIEW_IS_WRONG_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_NEEDS_REVIEW_IS_WRONG_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_NEEDS_REVIEW_IS_WRONG_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_NEEDS_REVIEW_IS_WRONG_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_NEEDS_REVIEW_IS_WRONG_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_NEEDS_REVIEW_IS_WRONG_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_NEEDS_REVIEW_IS_WRONG_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_NEEDS_REVIEW_IS_WRONG_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_NEEDS_REVIEW_IS_WRONG_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_NEEDS_REVIEW_IS_WRONG_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_NEEDS_REVIEW_IS_WRONG_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_NEEDS_REVIEW_IS_WRONG_DESC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_BATCH_FILE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_BATCH_FILE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_BATCH_FILE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_BATCH_FILE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_COUNT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_COUNT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_COUNT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_COUNT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_BATCH_FILE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_BATCH_FILE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_BATCH_FILE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_BATCH_FILE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_MAX_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_MAX_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_MAX_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_MAX_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_MAX_BATCH_FILE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_MAX_BATCH_FILE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_MAX_BATCH_FILE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_MAX_BATCH_FILE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_MAX_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_MAX_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_MAX_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_MAX_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_MAX_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_MAX_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_MAX_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_MAX_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_MAX_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_MAX_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_MAX_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_MAX_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_MIN_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_MIN_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_MIN_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_MIN_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_MIN_BATCH_FILE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_MIN_BATCH_FILE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_MIN_BATCH_FILE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_MIN_BATCH_FILE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_MIN_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_MIN_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_MIN_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_MIN_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_MIN_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_MIN_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_MIN_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_MIN_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_MIN_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_MIN_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_MIN_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_MIN_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_BATCH_FILE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_BATCH_FILE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_BATCH_FILE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_BATCH_FILE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_SUM_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_SUM_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_SUM_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_SUM_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_SUM_BATCH_FILE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_SUM_BATCH_FILE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_SUM_BATCH_FILE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_SUM_BATCH_FILE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_SUM_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_SUM_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_SUM_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_SUM_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_SUM_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_SUM_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_SUM_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_SUM_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_SUM_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_SUM_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_SUM_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_SUM_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_COUNT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_COUNT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_COUNT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_COUNT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_TITLE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_TITLE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_TITLE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_TITLE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_COUNT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_COUNT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_COUNT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_COUNT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_INSURER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_INSURER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_INSURER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_INSURER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_S3_URL_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_S3_URL_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_S3_URL_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_S3_URL_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_S3_VERSION_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_S3_VERSION_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_S3_VERSION_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_S3_VERSION_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_TITLE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_TITLE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_TITLE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_TITLE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_VIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_VIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MAX_VIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MAX_VIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_INSURER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_INSURER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_INSURER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_INSURER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_S3_URL_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_S3_URL_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_S3_URL_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_S3_URL_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_S3_VERSION_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_S3_VERSION_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_S3_VERSION_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_S3_VERSION_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_TITLE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_TITLE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_TITLE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_TITLE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_VIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_VIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_MIN_VIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_MIN_VIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_INSURER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_INSURER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_INSURER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_INSURER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_S3_URL_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_S3_URL_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_S3_URL_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_S3_URL_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_S3_VERSION_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_S3_VERSION_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_S3_VERSION_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_S3_VERSION_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_TITLE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_TITLE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_TITLE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_TITLE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_VIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_VIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_SUM_VIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_SUM_VIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_ORIGINAL_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_ORIGINAL_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_ORIGINAL_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_ORIGINAL_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_REVIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_REVIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_REVIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_REVIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_COUNT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_COUNT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_COUNT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_COUNT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_ORIGINAL_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_ORIGINAL_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_ORIGINAL_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_ORIGINAL_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_REVIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_REVIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_REVIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_REVIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_ORIGINAL_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_ORIGINAL_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_ORIGINAL_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_ORIGINAL_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_REVIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_REVIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_REVIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_REVIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MAX_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MAX_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_ORIGINAL_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_ORIGINAL_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_ORIGINAL_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_ORIGINAL_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_REVIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_REVIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_REVIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_REVIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_MIN_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_MIN_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_ORIGINAL_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_ORIGINAL_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_ORIGINAL_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_ORIGINAL_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_REVIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_REVIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_REVIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_REVIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_ORIGINAL_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_ORIGINAL_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_ORIGINAL_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_ORIGINAL_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_REVIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_REVIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_REVIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_REVIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_ORIGINAL_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_ORIGINAL_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_ORIGINAL_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_ORIGINAL_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_REVIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_REVIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_REVIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_REVIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_SUM_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_SUM_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_ORIGINAL_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_ORIGINAL_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_ORIGINAL_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_ORIGINAL_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_REVIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_REVIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_REVIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_REVIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_ORIGINAL_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_ORIGINAL_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_ORIGINAL_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_ORIGINAL_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_REVIEW_ID_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_REVIEW_ID_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_REVIEW_ID_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_REVIEW_ID_DESC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_AUDIT_FINDING_REVIEWS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_CREATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_CREATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_INPUT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_INPUT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_INPUT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_INPUT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_UDPATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_UDPATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_UDPATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_AVERAGE_UDPATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_COUNT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_COUNT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_COUNT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_COUNT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_INPUT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_INPUT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_INPUT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_INPUT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_UDPATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_UDPATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_UDPATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_DISTINCT_COUNT_UDPATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_MAX_AUTHOR_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_MAX_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_MAX_AUTHOR_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_MAX_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_MAX_CREATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_MAX_CREATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_MAX_CREATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_MAX_CREATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_MAX_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_MAX_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_MAX_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_MAX_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_MAX_INPUT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_MAX_INPUT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_MAX_INPUT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_MAX_INPUT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_MAX_UDPATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_MAX_UDPATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_MAX_UDPATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_MAX_UDPATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_MIN_AUTHOR_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_MIN_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_MIN_AUTHOR_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_MIN_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_MIN_CREATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_MIN_CREATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_MIN_CREATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_MIN_CREATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_MIN_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_MIN_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_MIN_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_MIN_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_MIN_INPUT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_MIN_INPUT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_MIN_INPUT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_MIN_INPUT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_MIN_UDPATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_MIN_UDPATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_MIN_UDPATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_MIN_UDPATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_INPUT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_INPUT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_INPUT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_INPUT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_UDPATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_UDPATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_UDPATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_POPULATION_UDPATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_INPUT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_INPUT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_INPUT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_INPUT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_UDPATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_UDPATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_UDPATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_STDDEV_SAMPLE_UDPATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_SUM_AUTHOR_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_SUM_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_SUM_AUTHOR_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_SUM_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_SUM_CREATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_SUM_CREATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_SUM_CREATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_SUM_CREATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_SUM_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_SUM_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_SUM_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_SUM_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_SUM_INPUT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_SUM_INPUT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_SUM_INPUT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_SUM_INPUT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_SUM_UDPATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_SUM_UDPATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_SUM_UDPATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_SUM_UDPATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_INPUT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_INPUT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_INPUT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_INPUT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_UDPATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_UDPATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_UDPATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_POPULATION_UDPATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_INPUT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_INPUT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_INPUT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_INPUT_DESC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_UDPATED_AT_ASC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_UDPATED_AT_ASC",
  AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_UDPATED_AT_DESC = "AUTHORED_AUDIT_SELECTION_JOBS_VARIANCE_SAMPLE_UDPATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_ADM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_ADM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_ADM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_ADM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_APR_DRG_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_APR_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_APR_DRG_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_APR_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_BILL_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_BILL_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_BILL_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_BILL_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_ICN_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_ICN_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_ADMIT_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_ADMIT_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_ADMIT_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_ADMIT_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_1_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_1_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_1_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_1_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_2_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_2_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_2_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_2_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_3_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_3_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_3_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_3_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_4_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_4_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_4_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_4_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_5_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_5_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_5_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_5_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_6_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_6_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_6_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_6_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_7_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_7_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_7_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_7_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_8_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_8_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_8_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_8_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_9_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_9_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_9_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_9_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_10_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_10_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_10_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_10_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_11_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_11_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_11_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_11_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_12_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_12_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_12_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_12_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_13_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_13_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_13_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_13_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_14_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_14_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_14_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_14_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_15_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_15_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_15_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_15_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_16_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_16_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_16_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_16_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_17_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_17_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_17_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_17_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_18_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_18_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_18_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_18_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_19_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_19_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_19_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_19_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_20_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_20_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_20_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_20_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_21_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_21_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_21_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_21_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_22_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_22_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_22_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_22_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_23_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_23_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_23_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_23_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_24_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_24_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_24_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DIAG_24_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DRG_CODE_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DRG_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_DRG_CODE_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_DRG_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_ICN_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_ICN_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_ID_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_ID_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_INSURER_ID_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_INSURER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_INSURER_ID_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_INSURER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_OWNER_ID_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_OWNER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_OWNER_ID_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_OWNER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PAID_DATE_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PAID_DATE_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PAID_DATE_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PAID_DATE_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_DOB_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_DOB_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_DOB_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_DOB_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_ID_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_ID_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_ID_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PATIENT_ID_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_1_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_1_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_1_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_1_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_2_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_2_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_2_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_2_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_3_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_3_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_3_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_3_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_4_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_4_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_4_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_4_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_5_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_5_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_5_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_5_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_6_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_6_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_6_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_6_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_7_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_7_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_7_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_7_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_8_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_8_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_8_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_8_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_9_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_9_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_9_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_9_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_10_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_10_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_10_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_10_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_11_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_11_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_11_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_11_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_12_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_12_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_12_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_12_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_13_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_13_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_13_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_13_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_14_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_14_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_14_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_14_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_15_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_15_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_15_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_15_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_16_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_16_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_16_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_16_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_17_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_17_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_17_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_17_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_18_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_18_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_18_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_18_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_19_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_19_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_19_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_19_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_20_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_20_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_20_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_20_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_21_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_21_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_21_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_21_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_22_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_22_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_22_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_22_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_23_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_23_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_23_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_23_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_24_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_24_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_24_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_24_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_25_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_25_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_POA_25_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_POA_25_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PREPAY_DENY_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PREPAY_DENY_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PREPAY_DENY_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PREPAY_DENY_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROVIDER_ID_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROVIDER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_PROVIDER_ID_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_PROVIDER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_VERSION_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_VERSION_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_VERSION_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_VERSION_DESC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_VERSION_GROUP_ASC = "AUTHORED_BATCH_CLAIMS_AVERAGE_VERSION_GROUP_ASC",
  AUTHORED_BATCH_CLAIMS_AVERAGE_VERSION_GROUP_DESC = "AUTHORED_BATCH_CLAIMS_AVERAGE_VERSION_GROUP_DESC",
  AUTHORED_BATCH_CLAIMS_COUNT_ASC = "AUTHORED_BATCH_CLAIMS_COUNT_ASC",
  AUTHORED_BATCH_CLAIMS_COUNT_DESC = "AUTHORED_BATCH_CLAIMS_COUNT_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ICN_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ICN_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ID_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ID_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_1_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_1_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_1_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_1_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_2_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_2_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_2_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_2_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_3_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_3_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_3_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_3_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_4_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_4_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_4_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_4_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_5_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_5_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_5_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_5_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_6_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_6_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_6_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_6_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_7_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_7_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_7_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_7_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_8_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_8_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_8_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_8_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_9_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_9_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_9_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_9_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_10_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_10_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_10_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_10_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_11_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_11_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_11_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_11_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_12_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_12_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_12_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_12_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_13_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_13_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_13_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_13_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_14_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_14_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_14_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_14_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_15_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_15_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_15_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_15_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_16_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_16_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_16_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_16_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_17_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_17_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_17_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_17_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_18_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_18_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_18_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_18_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_19_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_19_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_19_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_19_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_20_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_20_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_20_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_20_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_21_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_21_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_21_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_21_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_22_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_22_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_22_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_22_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_23_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_23_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_23_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_23_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_24_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_24_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_24_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_24_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_25_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_25_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_25_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_POA_25_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_VERSION_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_VERSION_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_VERSION_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_VERSION_DESC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_ASC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_ASC",
  AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_DESC = "AUTHORED_BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_ADMIT_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_MAX_ADMIT_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_ADMIT_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_MAX_ADMIT_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_ADM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_MAX_ADM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_ADM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_MAX_ADM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_AMOUNT_CHARGED_ASC = "AUTHORED_BATCH_CLAIMS_MAX_AMOUNT_CHARGED_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_AMOUNT_CHARGED_DESC = "AUTHORED_BATCH_CLAIMS_MAX_AMOUNT_CHARGED_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_ASC = "AUTHORED_BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_DESC = "AUTHORED_BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_APR_DRG_ASC = "AUTHORED_BATCH_CLAIMS_MAX_APR_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_APR_DRG_DESC = "AUTHORED_BATCH_CLAIMS_MAX_APR_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIMS_MAX_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIMS_MAX_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_BATCH_FILE_ID_ASC = "AUTHORED_BATCH_CLAIMS_MAX_BATCH_FILE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_BATCH_FILE_ID_DESC = "AUTHORED_BATCH_CLAIMS_MAX_BATCH_FILE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_BILL_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_MAX_BILL_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_BILL_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_MAX_BILL_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_CLAIM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_MAX_CLAIM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_CLAIM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_MAX_CLAIM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_ASC = "AUTHORED_BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_DESC = "AUTHORED_BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_CLIENT_ICN_ASC = "AUTHORED_BATCH_CLAIMS_MAX_CLIENT_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_CLIENT_ICN_DESC = "AUTHORED_BATCH_CLAIMS_MAX_CLIENT_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_ASC = "AUTHORED_BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_DESC = "AUTHORED_BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_ASC = "AUTHORED_BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_DESC = "AUTHORED_BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_ASC = "AUTHORED_BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_DESC = "AUTHORED_BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_MAX_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_MAX_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DATE_ADMIT_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DATE_ADMIT_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DATE_ADMIT_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DATE_ADMIT_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DATE_DISCHARGE_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DATE_DISCHARGE_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DATE_DISCHARGE_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DATE_DISCHARGE_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_1_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_1_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_1_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_1_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_2_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_2_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_2_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_2_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_3_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_3_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_3_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_3_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_4_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_4_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_4_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_4_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_5_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_5_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_5_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_5_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_6_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_6_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_6_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_6_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_7_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_7_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_7_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_7_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_8_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_8_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_8_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_8_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_9_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_9_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_9_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_9_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_10_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_10_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_10_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_10_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_11_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_11_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_11_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_11_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_12_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_12_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_12_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_12_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_13_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_13_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_13_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_13_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_14_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_14_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_14_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_14_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_15_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_15_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_15_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_15_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_16_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_16_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_16_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_16_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_17_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_17_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_17_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_17_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_18_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_18_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_18_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_18_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_19_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_19_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_19_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_19_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_20_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_20_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_20_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_20_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_21_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_21_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_21_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_21_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_22_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_22_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_22_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_22_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_23_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_23_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_23_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_23_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_24_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_24_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DIAG_24_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DIAG_24_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DISCHARGE_STATUS_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DISCHARGE_STATUS_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DISCHARGE_STATUS_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DISCHARGE_STATUS_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_DRG_CODE_ASC = "AUTHORED_BATCH_CLAIMS_MAX_DRG_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_DRG_CODE_DESC = "AUTHORED_BATCH_CLAIMS_MAX_DRG_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_ICN_ASC = "AUTHORED_BATCH_CLAIMS_MAX_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_ICN_DESC = "AUTHORED_BATCH_CLAIMS_MAX_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_ID_ASC = "AUTHORED_BATCH_CLAIMS_MAX_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_ID_DESC = "AUTHORED_BATCH_CLAIMS_MAX_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_INSURER_ID_ASC = "AUTHORED_BATCH_CLAIMS_MAX_INSURER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_INSURER_ID_DESC = "AUTHORED_BATCH_CLAIMS_MAX_INSURER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_OWNER_ID_ASC = "AUTHORED_BATCH_CLAIMS_MAX_OWNER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_OWNER_ID_DESC = "AUTHORED_BATCH_CLAIMS_MAX_OWNER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PAID_DATE_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PAID_DATE_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PAID_DATE_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PAID_DATE_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PATIENT_DOB_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PATIENT_DOB_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PATIENT_DOB_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PATIENT_DOB_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PATIENT_GENDER_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PATIENT_GENDER_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PATIENT_GENDER_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PATIENT_GENDER_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PATIENT_ID_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PATIENT_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PATIENT_ID_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PATIENT_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PAYMENT_RATE_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PAYMENT_RATE_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PAYMENT_RATE_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PAYMENT_RATE_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_1_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_1_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_1_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_1_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_2_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_2_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_2_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_2_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_3_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_3_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_3_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_3_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_4_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_4_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_4_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_4_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_5_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_5_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_5_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_5_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_6_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_6_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_6_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_6_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_7_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_7_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_7_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_7_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_8_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_8_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_8_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_8_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_9_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_9_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_9_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_9_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_10_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_10_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_10_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_10_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_11_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_11_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_11_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_11_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_12_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_12_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_12_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_12_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_13_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_13_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_13_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_13_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_14_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_14_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_14_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_14_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_15_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_15_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_15_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_15_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_16_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_16_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_16_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_16_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_17_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_17_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_17_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_17_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_18_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_18_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_18_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_18_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_19_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_19_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_19_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_19_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_20_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_20_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_20_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_20_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_21_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_21_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_21_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_21_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_22_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_22_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_22_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_22_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_23_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_23_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_23_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_23_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_24_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_24_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_24_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_24_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_25_ASC = "AUTHORED_BATCH_CLAIMS_MAX_POA_25_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_POA_25_DESC = "AUTHORED_BATCH_CLAIMS_MAX_POA_25_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PREPAY_DENY_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PREPAY_DENY_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PREPAY_DENY_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PREPAY_DENY_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_POA_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_POA_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_POA_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_POA_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_PROVIDER_ID_ASC = "AUTHORED_BATCH_CLAIMS_MAX_PROVIDER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_PROVIDER_ID_DESC = "AUTHORED_BATCH_CLAIMS_MAX_PROVIDER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_SUBMITTED_DRG_ASC = "AUTHORED_BATCH_CLAIMS_MAX_SUBMITTED_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_SUBMITTED_DRG_DESC = "AUTHORED_BATCH_CLAIMS_MAX_SUBMITTED_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_MAX_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_MAX_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_VERSION_ASC = "AUTHORED_BATCH_CLAIMS_MAX_VERSION_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_VERSION_DESC = "AUTHORED_BATCH_CLAIMS_MAX_VERSION_DESC",
  AUTHORED_BATCH_CLAIMS_MAX_VERSION_GROUP_ASC = "AUTHORED_BATCH_CLAIMS_MAX_VERSION_GROUP_ASC",
  AUTHORED_BATCH_CLAIMS_MAX_VERSION_GROUP_DESC = "AUTHORED_BATCH_CLAIMS_MAX_VERSION_GROUP_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_ADMIT_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_MIN_ADMIT_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_ADMIT_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_MIN_ADMIT_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_ADM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_MIN_ADM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_ADM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_MIN_ADM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_AMOUNT_CHARGED_ASC = "AUTHORED_BATCH_CLAIMS_MIN_AMOUNT_CHARGED_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_AMOUNT_CHARGED_DESC = "AUTHORED_BATCH_CLAIMS_MIN_AMOUNT_CHARGED_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_ASC = "AUTHORED_BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_DESC = "AUTHORED_BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_APR_DRG_ASC = "AUTHORED_BATCH_CLAIMS_MIN_APR_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_APR_DRG_DESC = "AUTHORED_BATCH_CLAIMS_MIN_APR_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIMS_MIN_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIMS_MIN_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_BATCH_FILE_ID_ASC = "AUTHORED_BATCH_CLAIMS_MIN_BATCH_FILE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_BATCH_FILE_ID_DESC = "AUTHORED_BATCH_CLAIMS_MIN_BATCH_FILE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_BILL_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_MIN_BILL_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_BILL_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_MIN_BILL_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_CLAIM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_MIN_CLAIM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_CLAIM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_MIN_CLAIM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_ASC = "AUTHORED_BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_DESC = "AUTHORED_BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_CLIENT_ICN_ASC = "AUTHORED_BATCH_CLAIMS_MIN_CLIENT_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_CLIENT_ICN_DESC = "AUTHORED_BATCH_CLAIMS_MIN_CLIENT_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_ASC = "AUTHORED_BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_DESC = "AUTHORED_BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_ASC = "AUTHORED_BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_DESC = "AUTHORED_BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_ASC = "AUTHORED_BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_DESC = "AUTHORED_BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_MIN_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_MIN_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DATE_ADMIT_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DATE_ADMIT_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DATE_ADMIT_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DATE_ADMIT_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DATE_DISCHARGE_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DATE_DISCHARGE_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DATE_DISCHARGE_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DATE_DISCHARGE_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_1_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_1_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_1_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_1_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_2_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_2_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_2_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_2_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_3_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_3_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_3_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_3_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_4_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_4_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_4_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_4_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_5_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_5_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_5_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_5_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_6_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_6_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_6_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_6_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_7_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_7_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_7_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_7_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_8_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_8_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_8_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_8_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_9_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_9_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_9_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_9_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_10_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_10_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_10_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_10_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_11_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_11_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_11_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_11_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_12_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_12_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_12_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_12_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_13_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_13_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_13_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_13_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_14_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_14_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_14_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_14_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_15_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_15_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_15_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_15_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_16_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_16_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_16_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_16_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_17_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_17_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_17_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_17_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_18_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_18_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_18_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_18_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_19_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_19_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_19_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_19_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_20_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_20_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_20_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_20_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_21_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_21_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_21_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_21_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_22_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_22_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_22_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_22_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_23_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_23_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_23_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_23_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_24_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_24_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DIAG_24_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DIAG_24_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DISCHARGE_STATUS_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DISCHARGE_STATUS_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DISCHARGE_STATUS_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DISCHARGE_STATUS_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_DRG_CODE_ASC = "AUTHORED_BATCH_CLAIMS_MIN_DRG_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_DRG_CODE_DESC = "AUTHORED_BATCH_CLAIMS_MIN_DRG_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_ICN_ASC = "AUTHORED_BATCH_CLAIMS_MIN_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_ICN_DESC = "AUTHORED_BATCH_CLAIMS_MIN_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_ID_ASC = "AUTHORED_BATCH_CLAIMS_MIN_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_ID_DESC = "AUTHORED_BATCH_CLAIMS_MIN_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_INSURER_ID_ASC = "AUTHORED_BATCH_CLAIMS_MIN_INSURER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_INSURER_ID_DESC = "AUTHORED_BATCH_CLAIMS_MIN_INSURER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_OWNER_ID_ASC = "AUTHORED_BATCH_CLAIMS_MIN_OWNER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_OWNER_ID_DESC = "AUTHORED_BATCH_CLAIMS_MIN_OWNER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PAID_DATE_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PAID_DATE_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PAID_DATE_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PAID_DATE_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PATIENT_DOB_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PATIENT_DOB_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PATIENT_DOB_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PATIENT_DOB_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PATIENT_GENDER_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PATIENT_GENDER_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PATIENT_GENDER_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PATIENT_GENDER_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PATIENT_ID_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PATIENT_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PATIENT_ID_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PATIENT_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PAYMENT_RATE_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PAYMENT_RATE_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PAYMENT_RATE_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PAYMENT_RATE_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_1_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_1_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_1_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_1_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_2_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_2_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_2_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_2_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_3_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_3_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_3_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_3_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_4_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_4_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_4_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_4_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_5_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_5_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_5_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_5_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_6_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_6_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_6_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_6_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_7_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_7_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_7_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_7_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_8_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_8_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_8_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_8_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_9_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_9_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_9_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_9_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_10_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_10_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_10_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_10_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_11_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_11_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_11_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_11_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_12_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_12_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_12_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_12_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_13_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_13_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_13_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_13_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_14_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_14_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_14_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_14_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_15_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_15_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_15_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_15_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_16_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_16_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_16_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_16_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_17_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_17_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_17_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_17_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_18_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_18_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_18_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_18_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_19_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_19_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_19_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_19_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_20_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_20_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_20_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_20_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_21_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_21_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_21_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_21_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_22_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_22_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_22_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_22_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_23_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_23_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_23_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_23_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_24_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_24_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_24_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_24_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_25_ASC = "AUTHORED_BATCH_CLAIMS_MIN_POA_25_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_POA_25_DESC = "AUTHORED_BATCH_CLAIMS_MIN_POA_25_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PREPAY_DENY_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PREPAY_DENY_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PREPAY_DENY_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PREPAY_DENY_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_POA_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_POA_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_POA_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_POA_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_PROVIDER_ID_ASC = "AUTHORED_BATCH_CLAIMS_MIN_PROVIDER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_PROVIDER_ID_DESC = "AUTHORED_BATCH_CLAIMS_MIN_PROVIDER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_SUBMITTED_DRG_ASC = "AUTHORED_BATCH_CLAIMS_MIN_SUBMITTED_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_SUBMITTED_DRG_DESC = "AUTHORED_BATCH_CLAIMS_MIN_SUBMITTED_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_MIN_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_MIN_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_VERSION_ASC = "AUTHORED_BATCH_CLAIMS_MIN_VERSION_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_VERSION_DESC = "AUTHORED_BATCH_CLAIMS_MIN_VERSION_DESC",
  AUTHORED_BATCH_CLAIMS_MIN_VERSION_GROUP_ASC = "AUTHORED_BATCH_CLAIMS_MIN_VERSION_GROUP_ASC",
  AUTHORED_BATCH_CLAIMS_MIN_VERSION_GROUP_DESC = "AUTHORED_BATCH_CLAIMS_MIN_VERSION_GROUP_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ICN_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ICN_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_1_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_1_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_1_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_1_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_2_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_2_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_2_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_2_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_3_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_3_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_3_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_3_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_4_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_4_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_4_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_4_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_5_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_5_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_5_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_5_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_6_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_6_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_6_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_6_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_7_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_7_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_7_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_7_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_8_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_8_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_8_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_8_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_9_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_9_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_9_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_9_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_10_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_10_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_10_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_10_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_11_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_11_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_11_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_11_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_12_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_12_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_12_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_12_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_13_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_13_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_13_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_13_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_14_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_14_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_14_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_14_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_15_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_15_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_15_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_15_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_16_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_16_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_16_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_16_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_17_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_17_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_17_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_17_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_18_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_18_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_18_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_18_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_19_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_19_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_19_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_19_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_20_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_20_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_20_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_20_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_21_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_21_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_21_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_21_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_22_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_22_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_22_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_22_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_23_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_23_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_23_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_23_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_24_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_24_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_24_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_24_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_25_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_25_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_25_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_POA_25_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_VERSION_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_VERSION_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_VERSION_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_VERSION_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ICN_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ICN_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_DESC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_ASC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_ASC",
  AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_DESC = "AUTHORED_BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_ADMIT_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_SUM_ADMIT_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_ADMIT_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_SUM_ADMIT_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_ADM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_SUM_ADM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_ADM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_SUM_ADM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_AMOUNT_CHARGED_ASC = "AUTHORED_BATCH_CLAIMS_SUM_AMOUNT_CHARGED_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_AMOUNT_CHARGED_DESC = "AUTHORED_BATCH_CLAIMS_SUM_AMOUNT_CHARGED_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_ASC = "AUTHORED_BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_DESC = "AUTHORED_BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_APR_DRG_ASC = "AUTHORED_BATCH_CLAIMS_SUM_APR_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_APR_DRG_DESC = "AUTHORED_BATCH_CLAIMS_SUM_APR_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIMS_SUM_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIMS_SUM_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_BATCH_FILE_ID_ASC = "AUTHORED_BATCH_CLAIMS_SUM_BATCH_FILE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_BATCH_FILE_ID_DESC = "AUTHORED_BATCH_CLAIMS_SUM_BATCH_FILE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_BILL_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_SUM_BILL_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_BILL_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_SUM_BILL_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_CLAIM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_SUM_CLAIM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_CLAIM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_SUM_CLAIM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_ASC = "AUTHORED_BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_DESC = "AUTHORED_BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_CLIENT_ICN_ASC = "AUTHORED_BATCH_CLAIMS_SUM_CLIENT_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_CLIENT_ICN_DESC = "AUTHORED_BATCH_CLAIMS_SUM_CLIENT_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_ASC = "AUTHORED_BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_DESC = "AUTHORED_BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_ASC = "AUTHORED_BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_DESC = "AUTHORED_BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_ASC = "AUTHORED_BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_DESC = "AUTHORED_BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_SUM_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_SUM_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DATE_ADMIT_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DATE_ADMIT_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DATE_ADMIT_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DATE_ADMIT_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DATE_DISCHARGE_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DATE_DISCHARGE_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DATE_DISCHARGE_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DATE_DISCHARGE_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_1_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_1_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_1_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_1_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_2_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_2_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_2_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_2_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_3_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_3_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_3_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_3_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_4_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_4_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_4_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_4_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_5_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_5_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_5_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_5_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_6_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_6_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_6_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_6_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_7_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_7_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_7_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_7_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_8_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_8_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_8_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_8_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_9_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_9_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_9_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_9_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_10_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_10_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_10_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_10_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_11_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_11_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_11_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_11_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_12_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_12_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_12_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_12_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_13_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_13_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_13_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_13_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_14_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_14_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_14_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_14_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_15_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_15_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_15_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_15_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_16_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_16_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_16_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_16_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_17_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_17_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_17_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_17_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_18_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_18_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_18_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_18_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_19_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_19_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_19_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_19_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_20_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_20_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_20_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_20_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_21_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_21_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_21_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_21_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_22_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_22_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_22_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_22_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_23_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_23_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_23_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_23_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_24_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_24_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DIAG_24_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DIAG_24_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DISCHARGE_STATUS_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DISCHARGE_STATUS_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DISCHARGE_STATUS_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DISCHARGE_STATUS_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_DRG_CODE_ASC = "AUTHORED_BATCH_CLAIMS_SUM_DRG_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_DRG_CODE_DESC = "AUTHORED_BATCH_CLAIMS_SUM_DRG_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_ICN_ASC = "AUTHORED_BATCH_CLAIMS_SUM_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_ICN_DESC = "AUTHORED_BATCH_CLAIMS_SUM_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_ID_ASC = "AUTHORED_BATCH_CLAIMS_SUM_ID_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_ID_DESC = "AUTHORED_BATCH_CLAIMS_SUM_ID_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_INSURER_ID_ASC = "AUTHORED_BATCH_CLAIMS_SUM_INSURER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_INSURER_ID_DESC = "AUTHORED_BATCH_CLAIMS_SUM_INSURER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_OWNER_ID_ASC = "AUTHORED_BATCH_CLAIMS_SUM_OWNER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_OWNER_ID_DESC = "AUTHORED_BATCH_CLAIMS_SUM_OWNER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PAID_DATE_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PAID_DATE_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PAID_DATE_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PAID_DATE_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PATIENT_DOB_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PATIENT_DOB_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PATIENT_DOB_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PATIENT_DOB_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PATIENT_GENDER_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PATIENT_GENDER_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PATIENT_GENDER_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PATIENT_GENDER_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PATIENT_ID_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PATIENT_ID_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PATIENT_ID_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PATIENT_ID_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PAYMENT_RATE_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PAYMENT_RATE_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PAYMENT_RATE_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PAYMENT_RATE_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_1_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_1_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_1_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_1_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_2_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_2_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_2_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_2_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_3_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_3_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_3_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_3_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_4_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_4_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_4_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_4_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_5_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_5_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_5_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_5_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_6_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_6_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_6_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_6_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_7_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_7_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_7_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_7_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_8_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_8_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_8_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_8_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_9_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_9_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_9_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_9_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_10_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_10_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_10_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_10_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_11_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_11_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_11_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_11_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_12_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_12_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_12_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_12_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_13_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_13_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_13_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_13_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_14_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_14_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_14_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_14_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_15_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_15_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_15_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_15_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_16_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_16_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_16_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_16_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_17_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_17_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_17_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_17_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_18_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_18_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_18_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_18_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_19_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_19_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_19_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_19_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_20_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_20_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_20_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_20_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_21_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_21_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_21_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_21_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_22_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_22_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_22_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_22_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_23_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_23_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_23_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_23_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_24_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_24_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_24_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_24_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_25_ASC = "AUTHORED_BATCH_CLAIMS_SUM_POA_25_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_POA_25_DESC = "AUTHORED_BATCH_CLAIMS_SUM_POA_25_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PREPAY_DENY_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PREPAY_DENY_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PREPAY_DENY_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PREPAY_DENY_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_POA_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_POA_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_POA_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_POA_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_PROVIDER_ID_ASC = "AUTHORED_BATCH_CLAIMS_SUM_PROVIDER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_PROVIDER_ID_DESC = "AUTHORED_BATCH_CLAIMS_SUM_PROVIDER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_SUBMITTED_DRG_ASC = "AUTHORED_BATCH_CLAIMS_SUM_SUBMITTED_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_SUBMITTED_DRG_DESC = "AUTHORED_BATCH_CLAIMS_SUM_SUBMITTED_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_SUM_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_SUM_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_VERSION_ASC = "AUTHORED_BATCH_CLAIMS_SUM_VERSION_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_VERSION_DESC = "AUTHORED_BATCH_CLAIMS_SUM_VERSION_DESC",
  AUTHORED_BATCH_CLAIMS_SUM_VERSION_GROUP_ASC = "AUTHORED_BATCH_CLAIMS_SUM_VERSION_GROUP_ASC",
  AUTHORED_BATCH_CLAIMS_SUM_VERSION_GROUP_DESC = "AUTHORED_BATCH_CLAIMS_SUM_VERSION_GROUP_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ICN_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ICN_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_DESC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_ASC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_ASC",
  AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_DESC = "AUTHORED_BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_COUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_COUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_COUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_COUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUDIT_FINDING_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUDIT_FINDING_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUDIT_FINDING_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUDIT_FINDING_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_COUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_COUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_COUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_COUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUDIT_FINDING_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUDIT_FINDING_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUDIT_FINDING_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUDIT_FINDING_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUDIT_FINDING_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUDIT_FINDING_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUDIT_FINDING_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUDIT_FINDING_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUDIT_FINDING_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUDIT_FINDING_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUDIT_FINDING_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUDIT_FINDING_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_DESC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_BATCH_FILES_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_BATCH_FILES_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_FILES_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_BATCH_FILES_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_FILES_AVERAGE_BATCH_FILE_NAME_ASC = "AUTHORED_BATCH_FILES_AVERAGE_BATCH_FILE_NAME_ASC",
  AUTHORED_BATCH_FILES_AVERAGE_BATCH_FILE_NAME_DESC = "AUTHORED_BATCH_FILES_AVERAGE_BATCH_FILE_NAME_DESC",
  AUTHORED_BATCH_FILES_AVERAGE_BATCH_FILE_URL_ASC = "AUTHORED_BATCH_FILES_AVERAGE_BATCH_FILE_URL_ASC",
  AUTHORED_BATCH_FILES_AVERAGE_BATCH_FILE_URL_DESC = "AUTHORED_BATCH_FILES_AVERAGE_BATCH_FILE_URL_DESC",
  AUTHORED_BATCH_FILES_AVERAGE_BATCH_NAME_ASC = "AUTHORED_BATCH_FILES_AVERAGE_BATCH_NAME_ASC",
  AUTHORED_BATCH_FILES_AVERAGE_BATCH_NAME_DESC = "AUTHORED_BATCH_FILES_AVERAGE_BATCH_NAME_DESC",
  AUTHORED_BATCH_FILES_AVERAGE_CREATED_AT_ASC = "AUTHORED_BATCH_FILES_AVERAGE_CREATED_AT_ASC",
  AUTHORED_BATCH_FILES_AVERAGE_CREATED_AT_DESC = "AUTHORED_BATCH_FILES_AVERAGE_CREATED_AT_DESC",
  AUTHORED_BATCH_FILES_AVERAGE_ID_ASC = "AUTHORED_BATCH_FILES_AVERAGE_ID_ASC",
  AUTHORED_BATCH_FILES_AVERAGE_ID_DESC = "AUTHORED_BATCH_FILES_AVERAGE_ID_DESC",
  AUTHORED_BATCH_FILES_AVERAGE_INSURER_ID_ASC = "AUTHORED_BATCH_FILES_AVERAGE_INSURER_ID_ASC",
  AUTHORED_BATCH_FILES_AVERAGE_INSURER_ID_DESC = "AUTHORED_BATCH_FILES_AVERAGE_INSURER_ID_DESC",
  AUTHORED_BATCH_FILES_AVERAGE_OWNER_ID_ASC = "AUTHORED_BATCH_FILES_AVERAGE_OWNER_ID_ASC",
  AUTHORED_BATCH_FILES_AVERAGE_OWNER_ID_DESC = "AUTHORED_BATCH_FILES_AVERAGE_OWNER_ID_DESC",
  AUTHORED_BATCH_FILES_AVERAGE_UPDATED_AT_ASC = "AUTHORED_BATCH_FILES_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_BATCH_FILES_AVERAGE_UPDATED_AT_DESC = "AUTHORED_BATCH_FILES_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_BATCH_FILES_COUNT_ASC = "AUTHORED_BATCH_FILES_COUNT_ASC",
  AUTHORED_BATCH_FILES_COUNT_DESC = "AUTHORED_BATCH_FILES_COUNT_DESC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_NAME_ASC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_NAME_ASC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_NAME_DESC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_NAME_DESC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_URL_ASC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_URL_ASC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_URL_DESC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_URL_DESC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_NAME_ASC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_NAME_ASC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_NAME_DESC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_BATCH_NAME_DESC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_ID_ASC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_ID_ASC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_ID_DESC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_ID_DESC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_INSURER_ID_ASC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_INSURER_ID_ASC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_INSURER_ID_DESC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_INSURER_ID_DESC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_OWNER_ID_ASC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_OWNER_ID_ASC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_OWNER_ID_DESC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_OWNER_ID_DESC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_BATCH_FILES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_BATCH_FILES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_BATCH_FILES_MAX_AUTHOR_ID_ASC = "AUTHORED_BATCH_FILES_MAX_AUTHOR_ID_ASC",
  AUTHORED_BATCH_FILES_MAX_AUTHOR_ID_DESC = "AUTHORED_BATCH_FILES_MAX_AUTHOR_ID_DESC",
  AUTHORED_BATCH_FILES_MAX_BATCH_FILE_NAME_ASC = "AUTHORED_BATCH_FILES_MAX_BATCH_FILE_NAME_ASC",
  AUTHORED_BATCH_FILES_MAX_BATCH_FILE_NAME_DESC = "AUTHORED_BATCH_FILES_MAX_BATCH_FILE_NAME_DESC",
  AUTHORED_BATCH_FILES_MAX_BATCH_FILE_URL_ASC = "AUTHORED_BATCH_FILES_MAX_BATCH_FILE_URL_ASC",
  AUTHORED_BATCH_FILES_MAX_BATCH_FILE_URL_DESC = "AUTHORED_BATCH_FILES_MAX_BATCH_FILE_URL_DESC",
  AUTHORED_BATCH_FILES_MAX_BATCH_NAME_ASC = "AUTHORED_BATCH_FILES_MAX_BATCH_NAME_ASC",
  AUTHORED_BATCH_FILES_MAX_BATCH_NAME_DESC = "AUTHORED_BATCH_FILES_MAX_BATCH_NAME_DESC",
  AUTHORED_BATCH_FILES_MAX_CREATED_AT_ASC = "AUTHORED_BATCH_FILES_MAX_CREATED_AT_ASC",
  AUTHORED_BATCH_FILES_MAX_CREATED_AT_DESC = "AUTHORED_BATCH_FILES_MAX_CREATED_AT_DESC",
  AUTHORED_BATCH_FILES_MAX_ID_ASC = "AUTHORED_BATCH_FILES_MAX_ID_ASC",
  AUTHORED_BATCH_FILES_MAX_ID_DESC = "AUTHORED_BATCH_FILES_MAX_ID_DESC",
  AUTHORED_BATCH_FILES_MAX_INSURER_ID_ASC = "AUTHORED_BATCH_FILES_MAX_INSURER_ID_ASC",
  AUTHORED_BATCH_FILES_MAX_INSURER_ID_DESC = "AUTHORED_BATCH_FILES_MAX_INSURER_ID_DESC",
  AUTHORED_BATCH_FILES_MAX_OWNER_ID_ASC = "AUTHORED_BATCH_FILES_MAX_OWNER_ID_ASC",
  AUTHORED_BATCH_FILES_MAX_OWNER_ID_DESC = "AUTHORED_BATCH_FILES_MAX_OWNER_ID_DESC",
  AUTHORED_BATCH_FILES_MAX_UPDATED_AT_ASC = "AUTHORED_BATCH_FILES_MAX_UPDATED_AT_ASC",
  AUTHORED_BATCH_FILES_MAX_UPDATED_AT_DESC = "AUTHORED_BATCH_FILES_MAX_UPDATED_AT_DESC",
  AUTHORED_BATCH_FILES_MIN_AUTHOR_ID_ASC = "AUTHORED_BATCH_FILES_MIN_AUTHOR_ID_ASC",
  AUTHORED_BATCH_FILES_MIN_AUTHOR_ID_DESC = "AUTHORED_BATCH_FILES_MIN_AUTHOR_ID_DESC",
  AUTHORED_BATCH_FILES_MIN_BATCH_FILE_NAME_ASC = "AUTHORED_BATCH_FILES_MIN_BATCH_FILE_NAME_ASC",
  AUTHORED_BATCH_FILES_MIN_BATCH_FILE_NAME_DESC = "AUTHORED_BATCH_FILES_MIN_BATCH_FILE_NAME_DESC",
  AUTHORED_BATCH_FILES_MIN_BATCH_FILE_URL_ASC = "AUTHORED_BATCH_FILES_MIN_BATCH_FILE_URL_ASC",
  AUTHORED_BATCH_FILES_MIN_BATCH_FILE_URL_DESC = "AUTHORED_BATCH_FILES_MIN_BATCH_FILE_URL_DESC",
  AUTHORED_BATCH_FILES_MIN_BATCH_NAME_ASC = "AUTHORED_BATCH_FILES_MIN_BATCH_NAME_ASC",
  AUTHORED_BATCH_FILES_MIN_BATCH_NAME_DESC = "AUTHORED_BATCH_FILES_MIN_BATCH_NAME_DESC",
  AUTHORED_BATCH_FILES_MIN_CREATED_AT_ASC = "AUTHORED_BATCH_FILES_MIN_CREATED_AT_ASC",
  AUTHORED_BATCH_FILES_MIN_CREATED_AT_DESC = "AUTHORED_BATCH_FILES_MIN_CREATED_AT_DESC",
  AUTHORED_BATCH_FILES_MIN_ID_ASC = "AUTHORED_BATCH_FILES_MIN_ID_ASC",
  AUTHORED_BATCH_FILES_MIN_ID_DESC = "AUTHORED_BATCH_FILES_MIN_ID_DESC",
  AUTHORED_BATCH_FILES_MIN_INSURER_ID_ASC = "AUTHORED_BATCH_FILES_MIN_INSURER_ID_ASC",
  AUTHORED_BATCH_FILES_MIN_INSURER_ID_DESC = "AUTHORED_BATCH_FILES_MIN_INSURER_ID_DESC",
  AUTHORED_BATCH_FILES_MIN_OWNER_ID_ASC = "AUTHORED_BATCH_FILES_MIN_OWNER_ID_ASC",
  AUTHORED_BATCH_FILES_MIN_OWNER_ID_DESC = "AUTHORED_BATCH_FILES_MIN_OWNER_ID_DESC",
  AUTHORED_BATCH_FILES_MIN_UPDATED_AT_ASC = "AUTHORED_BATCH_FILES_MIN_UPDATED_AT_ASC",
  AUTHORED_BATCH_FILES_MIN_UPDATED_AT_DESC = "AUTHORED_BATCH_FILES_MIN_UPDATED_AT_DESC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_NAME_ASC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_NAME_ASC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_NAME_DESC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_NAME_DESC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_URL_ASC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_URL_ASC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_URL_DESC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_URL_DESC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_NAME_ASC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_NAME_ASC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_NAME_DESC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_BATCH_NAME_DESC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_ID_ASC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_ID_ASC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_ID_DESC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_ID_DESC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_INSURER_ID_ASC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_INSURER_ID_ASC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_INSURER_ID_DESC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_INSURER_ID_DESC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_OWNER_ID_ASC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_OWNER_ID_ASC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_OWNER_ID_DESC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_OWNER_ID_DESC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_BATCH_FILES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_BATCH_FILES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_NAME_ASC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_NAME_ASC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_NAME_DESC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_NAME_DESC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_URL_ASC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_URL_ASC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_URL_DESC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_URL_DESC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_NAME_ASC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_NAME_ASC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_NAME_DESC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_BATCH_NAME_DESC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_ID_ASC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_ID_DESC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_INSURER_ID_ASC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_INSURER_ID_ASC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_INSURER_ID_DESC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_INSURER_ID_DESC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_OWNER_ID_ASC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_OWNER_ID_ASC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_OWNER_ID_DESC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_OWNER_ID_DESC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_BATCH_FILES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_BATCH_FILES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_BATCH_FILES_SUM_AUTHOR_ID_ASC = "AUTHORED_BATCH_FILES_SUM_AUTHOR_ID_ASC",
  AUTHORED_BATCH_FILES_SUM_AUTHOR_ID_DESC = "AUTHORED_BATCH_FILES_SUM_AUTHOR_ID_DESC",
  AUTHORED_BATCH_FILES_SUM_BATCH_FILE_NAME_ASC = "AUTHORED_BATCH_FILES_SUM_BATCH_FILE_NAME_ASC",
  AUTHORED_BATCH_FILES_SUM_BATCH_FILE_NAME_DESC = "AUTHORED_BATCH_FILES_SUM_BATCH_FILE_NAME_DESC",
  AUTHORED_BATCH_FILES_SUM_BATCH_FILE_URL_ASC = "AUTHORED_BATCH_FILES_SUM_BATCH_FILE_URL_ASC",
  AUTHORED_BATCH_FILES_SUM_BATCH_FILE_URL_DESC = "AUTHORED_BATCH_FILES_SUM_BATCH_FILE_URL_DESC",
  AUTHORED_BATCH_FILES_SUM_BATCH_NAME_ASC = "AUTHORED_BATCH_FILES_SUM_BATCH_NAME_ASC",
  AUTHORED_BATCH_FILES_SUM_BATCH_NAME_DESC = "AUTHORED_BATCH_FILES_SUM_BATCH_NAME_DESC",
  AUTHORED_BATCH_FILES_SUM_CREATED_AT_ASC = "AUTHORED_BATCH_FILES_SUM_CREATED_AT_ASC",
  AUTHORED_BATCH_FILES_SUM_CREATED_AT_DESC = "AUTHORED_BATCH_FILES_SUM_CREATED_AT_DESC",
  AUTHORED_BATCH_FILES_SUM_ID_ASC = "AUTHORED_BATCH_FILES_SUM_ID_ASC",
  AUTHORED_BATCH_FILES_SUM_ID_DESC = "AUTHORED_BATCH_FILES_SUM_ID_DESC",
  AUTHORED_BATCH_FILES_SUM_INSURER_ID_ASC = "AUTHORED_BATCH_FILES_SUM_INSURER_ID_ASC",
  AUTHORED_BATCH_FILES_SUM_INSURER_ID_DESC = "AUTHORED_BATCH_FILES_SUM_INSURER_ID_DESC",
  AUTHORED_BATCH_FILES_SUM_OWNER_ID_ASC = "AUTHORED_BATCH_FILES_SUM_OWNER_ID_ASC",
  AUTHORED_BATCH_FILES_SUM_OWNER_ID_DESC = "AUTHORED_BATCH_FILES_SUM_OWNER_ID_DESC",
  AUTHORED_BATCH_FILES_SUM_UPDATED_AT_ASC = "AUTHORED_BATCH_FILES_SUM_UPDATED_AT_ASC",
  AUTHORED_BATCH_FILES_SUM_UPDATED_AT_DESC = "AUTHORED_BATCH_FILES_SUM_UPDATED_AT_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_NAME_ASC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_NAME_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_NAME_DESC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_NAME_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_URL_ASC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_URL_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_URL_DESC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_URL_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_NAME_ASC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_NAME_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_NAME_DESC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_BATCH_NAME_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_ID_ASC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_ID_DESC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_INSURER_ID_ASC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_INSURER_ID_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_INSURER_ID_DESC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_INSURER_ID_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_OWNER_ID_ASC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_OWNER_ID_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_OWNER_ID_DESC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_OWNER_ID_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_BATCH_FILES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_NAME_ASC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_NAME_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_NAME_DESC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_NAME_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_URL_ASC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_URL_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_URL_DESC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_URL_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_NAME_ASC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_NAME_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_NAME_DESC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_BATCH_NAME_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_INSURER_ID_ASC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_INSURER_ID_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_INSURER_ID_DESC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_INSURER_ID_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_OWNER_ID_ASC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_OWNER_ID_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_OWNER_ID_DESC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_OWNER_ID_DESC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_BATCH_FILES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_CLAIM_CASES_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_CLAIM_CASES_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_CLAIM_CASES_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_CLAIM_CASES_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_CLAIM_CASES_AVERAGE_CASE_ID_ASC = "AUTHORED_CLAIM_CASES_AVERAGE_CASE_ID_ASC",
  AUTHORED_CLAIM_CASES_AVERAGE_CASE_ID_DESC = "AUTHORED_CLAIM_CASES_AVERAGE_CASE_ID_DESC",
  AUTHORED_CLAIM_CASES_AVERAGE_CLAIM_ID_ASC = "AUTHORED_CLAIM_CASES_AVERAGE_CLAIM_ID_ASC",
  AUTHORED_CLAIM_CASES_AVERAGE_CLAIM_ID_DESC = "AUTHORED_CLAIM_CASES_AVERAGE_CLAIM_ID_DESC",
  AUTHORED_CLAIM_CASES_AVERAGE_CREATED_AT_ASC = "AUTHORED_CLAIM_CASES_AVERAGE_CREATED_AT_ASC",
  AUTHORED_CLAIM_CASES_AVERAGE_CREATED_AT_DESC = "AUTHORED_CLAIM_CASES_AVERAGE_CREATED_AT_DESC",
  AUTHORED_CLAIM_CASES_AVERAGE_ID_ASC = "AUTHORED_CLAIM_CASES_AVERAGE_ID_ASC",
  AUTHORED_CLAIM_CASES_AVERAGE_ID_DESC = "AUTHORED_CLAIM_CASES_AVERAGE_ID_DESC",
  AUTHORED_CLAIM_CASES_AVERAGE_UPDATED_AT_ASC = "AUTHORED_CLAIM_CASES_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_CLAIM_CASES_AVERAGE_UPDATED_AT_DESC = "AUTHORED_CLAIM_CASES_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_CLAIM_CASES_AVERAGE_UPDATED_BY_ASC = "AUTHORED_CLAIM_CASES_AVERAGE_UPDATED_BY_ASC",
  AUTHORED_CLAIM_CASES_AVERAGE_UPDATED_BY_DESC = "AUTHORED_CLAIM_CASES_AVERAGE_UPDATED_BY_DESC",
  AUTHORED_CLAIM_CASES_COUNT_ASC = "AUTHORED_CLAIM_CASES_COUNT_ASC",
  AUTHORED_CLAIM_CASES_COUNT_DESC = "AUTHORED_CLAIM_CASES_COUNT_DESC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CASE_ID_ASC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CASE_ID_ASC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CASE_ID_DESC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CASE_ID_DESC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CLAIM_ID_ASC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CLAIM_ID_ASC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CLAIM_ID_DESC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CLAIM_ID_DESC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_ID_ASC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_ID_ASC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_ID_DESC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_ID_DESC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_UPDATED_BY_ASC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_UPDATED_BY_ASC",
  AUTHORED_CLAIM_CASES_DISTINCT_COUNT_UPDATED_BY_DESC = "AUTHORED_CLAIM_CASES_DISTINCT_COUNT_UPDATED_BY_DESC",
  AUTHORED_CLAIM_CASES_MAX_AUTHOR_ID_ASC = "AUTHORED_CLAIM_CASES_MAX_AUTHOR_ID_ASC",
  AUTHORED_CLAIM_CASES_MAX_AUTHOR_ID_DESC = "AUTHORED_CLAIM_CASES_MAX_AUTHOR_ID_DESC",
  AUTHORED_CLAIM_CASES_MAX_CASE_ID_ASC = "AUTHORED_CLAIM_CASES_MAX_CASE_ID_ASC",
  AUTHORED_CLAIM_CASES_MAX_CASE_ID_DESC = "AUTHORED_CLAIM_CASES_MAX_CASE_ID_DESC",
  AUTHORED_CLAIM_CASES_MAX_CLAIM_ID_ASC = "AUTHORED_CLAIM_CASES_MAX_CLAIM_ID_ASC",
  AUTHORED_CLAIM_CASES_MAX_CLAIM_ID_DESC = "AUTHORED_CLAIM_CASES_MAX_CLAIM_ID_DESC",
  AUTHORED_CLAIM_CASES_MAX_CREATED_AT_ASC = "AUTHORED_CLAIM_CASES_MAX_CREATED_AT_ASC",
  AUTHORED_CLAIM_CASES_MAX_CREATED_AT_DESC = "AUTHORED_CLAIM_CASES_MAX_CREATED_AT_DESC",
  AUTHORED_CLAIM_CASES_MAX_ID_ASC = "AUTHORED_CLAIM_CASES_MAX_ID_ASC",
  AUTHORED_CLAIM_CASES_MAX_ID_DESC = "AUTHORED_CLAIM_CASES_MAX_ID_DESC",
  AUTHORED_CLAIM_CASES_MAX_UPDATED_AT_ASC = "AUTHORED_CLAIM_CASES_MAX_UPDATED_AT_ASC",
  AUTHORED_CLAIM_CASES_MAX_UPDATED_AT_DESC = "AUTHORED_CLAIM_CASES_MAX_UPDATED_AT_DESC",
  AUTHORED_CLAIM_CASES_MAX_UPDATED_BY_ASC = "AUTHORED_CLAIM_CASES_MAX_UPDATED_BY_ASC",
  AUTHORED_CLAIM_CASES_MAX_UPDATED_BY_DESC = "AUTHORED_CLAIM_CASES_MAX_UPDATED_BY_DESC",
  AUTHORED_CLAIM_CASES_MIN_AUTHOR_ID_ASC = "AUTHORED_CLAIM_CASES_MIN_AUTHOR_ID_ASC",
  AUTHORED_CLAIM_CASES_MIN_AUTHOR_ID_DESC = "AUTHORED_CLAIM_CASES_MIN_AUTHOR_ID_DESC",
  AUTHORED_CLAIM_CASES_MIN_CASE_ID_ASC = "AUTHORED_CLAIM_CASES_MIN_CASE_ID_ASC",
  AUTHORED_CLAIM_CASES_MIN_CASE_ID_DESC = "AUTHORED_CLAIM_CASES_MIN_CASE_ID_DESC",
  AUTHORED_CLAIM_CASES_MIN_CLAIM_ID_ASC = "AUTHORED_CLAIM_CASES_MIN_CLAIM_ID_ASC",
  AUTHORED_CLAIM_CASES_MIN_CLAIM_ID_DESC = "AUTHORED_CLAIM_CASES_MIN_CLAIM_ID_DESC",
  AUTHORED_CLAIM_CASES_MIN_CREATED_AT_ASC = "AUTHORED_CLAIM_CASES_MIN_CREATED_AT_ASC",
  AUTHORED_CLAIM_CASES_MIN_CREATED_AT_DESC = "AUTHORED_CLAIM_CASES_MIN_CREATED_AT_DESC",
  AUTHORED_CLAIM_CASES_MIN_ID_ASC = "AUTHORED_CLAIM_CASES_MIN_ID_ASC",
  AUTHORED_CLAIM_CASES_MIN_ID_DESC = "AUTHORED_CLAIM_CASES_MIN_ID_DESC",
  AUTHORED_CLAIM_CASES_MIN_UPDATED_AT_ASC = "AUTHORED_CLAIM_CASES_MIN_UPDATED_AT_ASC",
  AUTHORED_CLAIM_CASES_MIN_UPDATED_AT_DESC = "AUTHORED_CLAIM_CASES_MIN_UPDATED_AT_DESC",
  AUTHORED_CLAIM_CASES_MIN_UPDATED_BY_ASC = "AUTHORED_CLAIM_CASES_MIN_UPDATED_BY_ASC",
  AUTHORED_CLAIM_CASES_MIN_UPDATED_BY_DESC = "AUTHORED_CLAIM_CASES_MIN_UPDATED_BY_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CASE_ID_ASC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CASE_ID_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CASE_ID_DESC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CASE_ID_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CLAIM_ID_ASC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CLAIM_ID_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CLAIM_ID_DESC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CLAIM_ID_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_ID_ASC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_ID_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_ID_DESC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_ID_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_UPDATED_BY_ASC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_UPDATED_BY_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_POPULATION_UPDATED_BY_DESC = "AUTHORED_CLAIM_CASES_STDDEV_POPULATION_UPDATED_BY_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CASE_ID_ASC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CASE_ID_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CASE_ID_DESC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CASE_ID_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CLAIM_ID_ASC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CLAIM_ID_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CLAIM_ID_DESC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CLAIM_ID_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_ID_ASC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_ID_DESC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_UPDATED_BY_ASC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_UPDATED_BY_ASC",
  AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_UPDATED_BY_DESC = "AUTHORED_CLAIM_CASES_STDDEV_SAMPLE_UPDATED_BY_DESC",
  AUTHORED_CLAIM_CASES_SUM_AUTHOR_ID_ASC = "AUTHORED_CLAIM_CASES_SUM_AUTHOR_ID_ASC",
  AUTHORED_CLAIM_CASES_SUM_AUTHOR_ID_DESC = "AUTHORED_CLAIM_CASES_SUM_AUTHOR_ID_DESC",
  AUTHORED_CLAIM_CASES_SUM_CASE_ID_ASC = "AUTHORED_CLAIM_CASES_SUM_CASE_ID_ASC",
  AUTHORED_CLAIM_CASES_SUM_CASE_ID_DESC = "AUTHORED_CLAIM_CASES_SUM_CASE_ID_DESC",
  AUTHORED_CLAIM_CASES_SUM_CLAIM_ID_ASC = "AUTHORED_CLAIM_CASES_SUM_CLAIM_ID_ASC",
  AUTHORED_CLAIM_CASES_SUM_CLAIM_ID_DESC = "AUTHORED_CLAIM_CASES_SUM_CLAIM_ID_DESC",
  AUTHORED_CLAIM_CASES_SUM_CREATED_AT_ASC = "AUTHORED_CLAIM_CASES_SUM_CREATED_AT_ASC",
  AUTHORED_CLAIM_CASES_SUM_CREATED_AT_DESC = "AUTHORED_CLAIM_CASES_SUM_CREATED_AT_DESC",
  AUTHORED_CLAIM_CASES_SUM_ID_ASC = "AUTHORED_CLAIM_CASES_SUM_ID_ASC",
  AUTHORED_CLAIM_CASES_SUM_ID_DESC = "AUTHORED_CLAIM_CASES_SUM_ID_DESC",
  AUTHORED_CLAIM_CASES_SUM_UPDATED_AT_ASC = "AUTHORED_CLAIM_CASES_SUM_UPDATED_AT_ASC",
  AUTHORED_CLAIM_CASES_SUM_UPDATED_AT_DESC = "AUTHORED_CLAIM_CASES_SUM_UPDATED_AT_DESC",
  AUTHORED_CLAIM_CASES_SUM_UPDATED_BY_ASC = "AUTHORED_CLAIM_CASES_SUM_UPDATED_BY_ASC",
  AUTHORED_CLAIM_CASES_SUM_UPDATED_BY_DESC = "AUTHORED_CLAIM_CASES_SUM_UPDATED_BY_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CASE_ID_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CASE_ID_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CASE_ID_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CASE_ID_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CLAIM_ID_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CLAIM_ID_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CLAIM_ID_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CLAIM_ID_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_ID_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_ID_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_UPDATED_BY_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_UPDATED_BY_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_UPDATED_BY_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_POPULATION_UPDATED_BY_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CASE_ID_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CASE_ID_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CASE_ID_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CASE_ID_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CLAIM_ID_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CLAIM_ID_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CLAIM_ID_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CLAIM_ID_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_UPDATED_BY_ASC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_UPDATED_BY_ASC",
  AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_UPDATED_BY_DESC = "AUTHORED_CLAIM_CASES_VARIANCE_SAMPLE_UPDATED_BY_DESC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_CREATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_CREATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_DELETED_ASC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_DELETED_ASC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_DELETED_DESC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_DELETED_DESC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_COUNT_ASC = "AUTHORED_DISPUTED_FINDINGS_COUNT_ASC",
  AUTHORED_DISPUTED_FINDINGS_COUNT_DESC = "AUTHORED_DISPUTED_FINDINGS_COUNT_DESC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_ASC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_ASC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_DESC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_DESC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_MAX_AUTHOR_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_MAX_AUTHOR_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_MAX_AUTHOR_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_MAX_AUTHOR_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_MAX_CREATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_MAX_CREATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_MAX_CREATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_MAX_CREATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_MAX_DELETED_ASC = "AUTHORED_DISPUTED_FINDINGS_MAX_DELETED_ASC",
  AUTHORED_DISPUTED_FINDINGS_MAX_DELETED_DESC = "AUTHORED_DISPUTED_FINDINGS_MAX_DELETED_DESC",
  AUTHORED_DISPUTED_FINDINGS_MAX_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_MAX_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_MAX_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_MAX_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_MAX_PROVIDER_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_MAX_PROVIDER_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_MAX_PROVIDER_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_MAX_PROVIDER_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_MAX_UPDATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_MAX_UPDATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_MAX_UPDATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_MAX_UPDATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_MIN_AUTHOR_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_MIN_AUTHOR_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_MIN_AUTHOR_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_MIN_AUTHOR_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_MIN_CREATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_MIN_CREATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_MIN_CREATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_MIN_CREATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_MIN_DELETED_ASC = "AUTHORED_DISPUTED_FINDINGS_MIN_DELETED_ASC",
  AUTHORED_DISPUTED_FINDINGS_MIN_DELETED_DESC = "AUTHORED_DISPUTED_FINDINGS_MIN_DELETED_DESC",
  AUTHORED_DISPUTED_FINDINGS_MIN_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_MIN_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_MIN_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_MIN_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_MIN_PROVIDER_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_MIN_PROVIDER_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_MIN_PROVIDER_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_MIN_PROVIDER_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_MIN_UPDATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_MIN_UPDATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_MIN_UPDATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_MIN_UPDATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_SUM_AUTHOR_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_SUM_AUTHOR_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_SUM_AUTHOR_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_SUM_AUTHOR_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_SUM_CREATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_SUM_CREATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_SUM_CREATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_SUM_CREATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_SUM_DELETED_ASC = "AUTHORED_DISPUTED_FINDINGS_SUM_DELETED_ASC",
  AUTHORED_DISPUTED_FINDINGS_SUM_DELETED_DESC = "AUTHORED_DISPUTED_FINDINGS_SUM_DELETED_DESC",
  AUTHORED_DISPUTED_FINDINGS_SUM_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_SUM_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_SUM_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_SUM_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_SUM_PROVIDER_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_SUM_PROVIDER_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_SUM_PROVIDER_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_SUM_PROVIDER_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_SUM_UPDATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_SUM_UPDATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_SUM_UPDATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_SUM_UPDATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_COUNT_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_COUNT_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_COUNT_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_COUNT_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_DESC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUTHORED_DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUTHORED_NN_IB_LINES_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_NN_IB_LINES_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_NN_IB_LINES_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_NN_IB_LINES_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_NN_IB_LINES_AVERAGE_CREATED_AT_ASC = "AUTHORED_NN_IB_LINES_AVERAGE_CREATED_AT_ASC",
  AUTHORED_NN_IB_LINES_AVERAGE_CREATED_AT_DESC = "AUTHORED_NN_IB_LINES_AVERAGE_CREATED_AT_DESC",
  AUTHORED_NN_IB_LINES_AVERAGE_FINGERPRINT_ASC = "AUTHORED_NN_IB_LINES_AVERAGE_FINGERPRINT_ASC",
  AUTHORED_NN_IB_LINES_AVERAGE_FINGERPRINT_DESC = "AUTHORED_NN_IB_LINES_AVERAGE_FINGERPRINT_DESC",
  AUTHORED_NN_IB_LINES_AVERAGE_ID_ASC = "AUTHORED_NN_IB_LINES_AVERAGE_ID_ASC",
  AUTHORED_NN_IB_LINES_AVERAGE_ID_DESC = "AUTHORED_NN_IB_LINES_AVERAGE_ID_DESC",
  AUTHORED_NN_IB_LINES_AVERAGE_S3_KEY_ASC = "AUTHORED_NN_IB_LINES_AVERAGE_S3_KEY_ASC",
  AUTHORED_NN_IB_LINES_AVERAGE_S3_KEY_DESC = "AUTHORED_NN_IB_LINES_AVERAGE_S3_KEY_DESC",
  AUTHORED_NN_IB_LINES_AVERAGE_UPDATED_AT_ASC = "AUTHORED_NN_IB_LINES_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_NN_IB_LINES_AVERAGE_UPDATED_AT_DESC = "AUTHORED_NN_IB_LINES_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_NN_IB_LINES_COUNT_ASC = "AUTHORED_NN_IB_LINES_COUNT_ASC",
  AUTHORED_NN_IB_LINES_COUNT_DESC = "AUTHORED_NN_IB_LINES_COUNT_DESC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_FINGERPRINT_ASC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_FINGERPRINT_ASC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_FINGERPRINT_DESC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_FINGERPRINT_DESC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_ID_ASC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_ID_ASC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_ID_DESC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_ID_DESC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_S3_KEY_ASC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_S3_KEY_ASC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_S3_KEY_DESC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_S3_KEY_DESC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_NN_IB_LINES_MAX_AUTHOR_ID_ASC = "AUTHORED_NN_IB_LINES_MAX_AUTHOR_ID_ASC",
  AUTHORED_NN_IB_LINES_MAX_AUTHOR_ID_DESC = "AUTHORED_NN_IB_LINES_MAX_AUTHOR_ID_DESC",
  AUTHORED_NN_IB_LINES_MAX_CREATED_AT_ASC = "AUTHORED_NN_IB_LINES_MAX_CREATED_AT_ASC",
  AUTHORED_NN_IB_LINES_MAX_CREATED_AT_DESC = "AUTHORED_NN_IB_LINES_MAX_CREATED_AT_DESC",
  AUTHORED_NN_IB_LINES_MAX_FINGERPRINT_ASC = "AUTHORED_NN_IB_LINES_MAX_FINGERPRINT_ASC",
  AUTHORED_NN_IB_LINES_MAX_FINGERPRINT_DESC = "AUTHORED_NN_IB_LINES_MAX_FINGERPRINT_DESC",
  AUTHORED_NN_IB_LINES_MAX_ID_ASC = "AUTHORED_NN_IB_LINES_MAX_ID_ASC",
  AUTHORED_NN_IB_LINES_MAX_ID_DESC = "AUTHORED_NN_IB_LINES_MAX_ID_DESC",
  AUTHORED_NN_IB_LINES_MAX_S3_KEY_ASC = "AUTHORED_NN_IB_LINES_MAX_S3_KEY_ASC",
  AUTHORED_NN_IB_LINES_MAX_S3_KEY_DESC = "AUTHORED_NN_IB_LINES_MAX_S3_KEY_DESC",
  AUTHORED_NN_IB_LINES_MAX_UPDATED_AT_ASC = "AUTHORED_NN_IB_LINES_MAX_UPDATED_AT_ASC",
  AUTHORED_NN_IB_LINES_MAX_UPDATED_AT_DESC = "AUTHORED_NN_IB_LINES_MAX_UPDATED_AT_DESC",
  AUTHORED_NN_IB_LINES_MIN_AUTHOR_ID_ASC = "AUTHORED_NN_IB_LINES_MIN_AUTHOR_ID_ASC",
  AUTHORED_NN_IB_LINES_MIN_AUTHOR_ID_DESC = "AUTHORED_NN_IB_LINES_MIN_AUTHOR_ID_DESC",
  AUTHORED_NN_IB_LINES_MIN_CREATED_AT_ASC = "AUTHORED_NN_IB_LINES_MIN_CREATED_AT_ASC",
  AUTHORED_NN_IB_LINES_MIN_CREATED_AT_DESC = "AUTHORED_NN_IB_LINES_MIN_CREATED_AT_DESC",
  AUTHORED_NN_IB_LINES_MIN_FINGERPRINT_ASC = "AUTHORED_NN_IB_LINES_MIN_FINGERPRINT_ASC",
  AUTHORED_NN_IB_LINES_MIN_FINGERPRINT_DESC = "AUTHORED_NN_IB_LINES_MIN_FINGERPRINT_DESC",
  AUTHORED_NN_IB_LINES_MIN_ID_ASC = "AUTHORED_NN_IB_LINES_MIN_ID_ASC",
  AUTHORED_NN_IB_LINES_MIN_ID_DESC = "AUTHORED_NN_IB_LINES_MIN_ID_DESC",
  AUTHORED_NN_IB_LINES_MIN_S3_KEY_ASC = "AUTHORED_NN_IB_LINES_MIN_S3_KEY_ASC",
  AUTHORED_NN_IB_LINES_MIN_S3_KEY_DESC = "AUTHORED_NN_IB_LINES_MIN_S3_KEY_DESC",
  AUTHORED_NN_IB_LINES_MIN_UPDATED_AT_ASC = "AUTHORED_NN_IB_LINES_MIN_UPDATED_AT_ASC",
  AUTHORED_NN_IB_LINES_MIN_UPDATED_AT_DESC = "AUTHORED_NN_IB_LINES_MIN_UPDATED_AT_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_FINGERPRINT_ASC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_FINGERPRINT_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_FINGERPRINT_DESC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_FINGERPRINT_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_ID_ASC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_ID_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_ID_DESC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_ID_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_S3_KEY_ASC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_S3_KEY_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_S3_KEY_DESC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_S3_KEY_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_FINGERPRINT_ASC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_FINGERPRINT_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_FINGERPRINT_DESC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_FINGERPRINT_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_ID_ASC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_ID_DESC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_S3_KEY_ASC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_S3_KEY_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_S3_KEY_DESC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_S3_KEY_DESC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_NN_IB_LINES_SUM_AUTHOR_ID_ASC = "AUTHORED_NN_IB_LINES_SUM_AUTHOR_ID_ASC",
  AUTHORED_NN_IB_LINES_SUM_AUTHOR_ID_DESC = "AUTHORED_NN_IB_LINES_SUM_AUTHOR_ID_DESC",
  AUTHORED_NN_IB_LINES_SUM_CREATED_AT_ASC = "AUTHORED_NN_IB_LINES_SUM_CREATED_AT_ASC",
  AUTHORED_NN_IB_LINES_SUM_CREATED_AT_DESC = "AUTHORED_NN_IB_LINES_SUM_CREATED_AT_DESC",
  AUTHORED_NN_IB_LINES_SUM_FINGERPRINT_ASC = "AUTHORED_NN_IB_LINES_SUM_FINGERPRINT_ASC",
  AUTHORED_NN_IB_LINES_SUM_FINGERPRINT_DESC = "AUTHORED_NN_IB_LINES_SUM_FINGERPRINT_DESC",
  AUTHORED_NN_IB_LINES_SUM_ID_ASC = "AUTHORED_NN_IB_LINES_SUM_ID_ASC",
  AUTHORED_NN_IB_LINES_SUM_ID_DESC = "AUTHORED_NN_IB_LINES_SUM_ID_DESC",
  AUTHORED_NN_IB_LINES_SUM_S3_KEY_ASC = "AUTHORED_NN_IB_LINES_SUM_S3_KEY_ASC",
  AUTHORED_NN_IB_LINES_SUM_S3_KEY_DESC = "AUTHORED_NN_IB_LINES_SUM_S3_KEY_DESC",
  AUTHORED_NN_IB_LINES_SUM_UPDATED_AT_ASC = "AUTHORED_NN_IB_LINES_SUM_UPDATED_AT_ASC",
  AUTHORED_NN_IB_LINES_SUM_UPDATED_AT_DESC = "AUTHORED_NN_IB_LINES_SUM_UPDATED_AT_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_FINGERPRINT_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_FINGERPRINT_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_FINGERPRINT_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_FINGERPRINT_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_ID_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_ID_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_S3_KEY_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_S3_KEY_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_S3_KEY_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_S3_KEY_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_FINGERPRINT_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_FINGERPRINT_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_FINGERPRINT_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_FINGERPRINT_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_S3_KEY_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_S3_KEY_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_S3_KEY_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_S3_KEY_DESC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_QUEUES_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_QUEUES_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_QUEUES_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_QUEUES_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_QUEUES_AVERAGE_CREATED_AT_ASC = "AUTHORED_QUEUES_AVERAGE_CREATED_AT_ASC",
  AUTHORED_QUEUES_AVERAGE_CREATED_AT_DESC = "AUTHORED_QUEUES_AVERAGE_CREATED_AT_DESC",
  AUTHORED_QUEUES_AVERAGE_DELETED_ASC = "AUTHORED_QUEUES_AVERAGE_DELETED_ASC",
  AUTHORED_QUEUES_AVERAGE_DELETED_DESC = "AUTHORED_QUEUES_AVERAGE_DELETED_DESC",
  AUTHORED_QUEUES_AVERAGE_DESCRIPTION_ASC = "AUTHORED_QUEUES_AVERAGE_DESCRIPTION_ASC",
  AUTHORED_QUEUES_AVERAGE_DESCRIPTION_DESC = "AUTHORED_QUEUES_AVERAGE_DESCRIPTION_DESC",
  AUTHORED_QUEUES_AVERAGE_FILTER_ASC = "AUTHORED_QUEUES_AVERAGE_FILTER_ASC",
  AUTHORED_QUEUES_AVERAGE_FILTER_DESC = "AUTHORED_QUEUES_AVERAGE_FILTER_DESC",
  AUTHORED_QUEUES_AVERAGE_ID_ASC = "AUTHORED_QUEUES_AVERAGE_ID_ASC",
  AUTHORED_QUEUES_AVERAGE_ID_DESC = "AUTHORED_QUEUES_AVERAGE_ID_DESC",
  AUTHORED_QUEUES_AVERAGE_INDEXED_FILTER_TAGS_ASC = "AUTHORED_QUEUES_AVERAGE_INDEXED_FILTER_TAGS_ASC",
  AUTHORED_QUEUES_AVERAGE_INDEXED_FILTER_TAGS_DESC = "AUTHORED_QUEUES_AVERAGE_INDEXED_FILTER_TAGS_DESC",
  AUTHORED_QUEUES_AVERAGE_NAME_ASC = "AUTHORED_QUEUES_AVERAGE_NAME_ASC",
  AUTHORED_QUEUES_AVERAGE_NAME_DESC = "AUTHORED_QUEUES_AVERAGE_NAME_DESC",
  AUTHORED_QUEUES_AVERAGE_UPDATED_AT_ASC = "AUTHORED_QUEUES_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_QUEUES_AVERAGE_UPDATED_AT_DESC = "AUTHORED_QUEUES_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_QUEUES_COUNT_ASC = "AUTHORED_QUEUES_COUNT_ASC",
  AUTHORED_QUEUES_COUNT_DESC = "AUTHORED_QUEUES_COUNT_DESC",
  AUTHORED_QUEUES_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_QUEUES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_QUEUES_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_QUEUES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_QUEUES_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_QUEUES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_QUEUES_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_QUEUES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_QUEUES_DISTINCT_COUNT_DELETED_ASC = "AUTHORED_QUEUES_DISTINCT_COUNT_DELETED_ASC",
  AUTHORED_QUEUES_DISTINCT_COUNT_DELETED_DESC = "AUTHORED_QUEUES_DISTINCT_COUNT_DELETED_DESC",
  AUTHORED_QUEUES_DISTINCT_COUNT_DESCRIPTION_ASC = "AUTHORED_QUEUES_DISTINCT_COUNT_DESCRIPTION_ASC",
  AUTHORED_QUEUES_DISTINCT_COUNT_DESCRIPTION_DESC = "AUTHORED_QUEUES_DISTINCT_COUNT_DESCRIPTION_DESC",
  AUTHORED_QUEUES_DISTINCT_COUNT_FILTER_ASC = "AUTHORED_QUEUES_DISTINCT_COUNT_FILTER_ASC",
  AUTHORED_QUEUES_DISTINCT_COUNT_FILTER_DESC = "AUTHORED_QUEUES_DISTINCT_COUNT_FILTER_DESC",
  AUTHORED_QUEUES_DISTINCT_COUNT_ID_ASC = "AUTHORED_QUEUES_DISTINCT_COUNT_ID_ASC",
  AUTHORED_QUEUES_DISTINCT_COUNT_ID_DESC = "AUTHORED_QUEUES_DISTINCT_COUNT_ID_DESC",
  AUTHORED_QUEUES_DISTINCT_COUNT_INDEXED_FILTER_TAGS_ASC = "AUTHORED_QUEUES_DISTINCT_COUNT_INDEXED_FILTER_TAGS_ASC",
  AUTHORED_QUEUES_DISTINCT_COUNT_INDEXED_FILTER_TAGS_DESC = "AUTHORED_QUEUES_DISTINCT_COUNT_INDEXED_FILTER_TAGS_DESC",
  AUTHORED_QUEUES_DISTINCT_COUNT_NAME_ASC = "AUTHORED_QUEUES_DISTINCT_COUNT_NAME_ASC",
  AUTHORED_QUEUES_DISTINCT_COUNT_NAME_DESC = "AUTHORED_QUEUES_DISTINCT_COUNT_NAME_DESC",
  AUTHORED_QUEUES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_QUEUES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_QUEUES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_QUEUES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_QUEUES_MAX_AUTHOR_ID_ASC = "AUTHORED_QUEUES_MAX_AUTHOR_ID_ASC",
  AUTHORED_QUEUES_MAX_AUTHOR_ID_DESC = "AUTHORED_QUEUES_MAX_AUTHOR_ID_DESC",
  AUTHORED_QUEUES_MAX_CREATED_AT_ASC = "AUTHORED_QUEUES_MAX_CREATED_AT_ASC",
  AUTHORED_QUEUES_MAX_CREATED_AT_DESC = "AUTHORED_QUEUES_MAX_CREATED_AT_DESC",
  AUTHORED_QUEUES_MAX_DELETED_ASC = "AUTHORED_QUEUES_MAX_DELETED_ASC",
  AUTHORED_QUEUES_MAX_DELETED_DESC = "AUTHORED_QUEUES_MAX_DELETED_DESC",
  AUTHORED_QUEUES_MAX_DESCRIPTION_ASC = "AUTHORED_QUEUES_MAX_DESCRIPTION_ASC",
  AUTHORED_QUEUES_MAX_DESCRIPTION_DESC = "AUTHORED_QUEUES_MAX_DESCRIPTION_DESC",
  AUTHORED_QUEUES_MAX_FILTER_ASC = "AUTHORED_QUEUES_MAX_FILTER_ASC",
  AUTHORED_QUEUES_MAX_FILTER_DESC = "AUTHORED_QUEUES_MAX_FILTER_DESC",
  AUTHORED_QUEUES_MAX_ID_ASC = "AUTHORED_QUEUES_MAX_ID_ASC",
  AUTHORED_QUEUES_MAX_ID_DESC = "AUTHORED_QUEUES_MAX_ID_DESC",
  AUTHORED_QUEUES_MAX_INDEXED_FILTER_TAGS_ASC = "AUTHORED_QUEUES_MAX_INDEXED_FILTER_TAGS_ASC",
  AUTHORED_QUEUES_MAX_INDEXED_FILTER_TAGS_DESC = "AUTHORED_QUEUES_MAX_INDEXED_FILTER_TAGS_DESC",
  AUTHORED_QUEUES_MAX_NAME_ASC = "AUTHORED_QUEUES_MAX_NAME_ASC",
  AUTHORED_QUEUES_MAX_NAME_DESC = "AUTHORED_QUEUES_MAX_NAME_DESC",
  AUTHORED_QUEUES_MAX_UPDATED_AT_ASC = "AUTHORED_QUEUES_MAX_UPDATED_AT_ASC",
  AUTHORED_QUEUES_MAX_UPDATED_AT_DESC = "AUTHORED_QUEUES_MAX_UPDATED_AT_DESC",
  AUTHORED_QUEUES_MIN_AUTHOR_ID_ASC = "AUTHORED_QUEUES_MIN_AUTHOR_ID_ASC",
  AUTHORED_QUEUES_MIN_AUTHOR_ID_DESC = "AUTHORED_QUEUES_MIN_AUTHOR_ID_DESC",
  AUTHORED_QUEUES_MIN_CREATED_AT_ASC = "AUTHORED_QUEUES_MIN_CREATED_AT_ASC",
  AUTHORED_QUEUES_MIN_CREATED_AT_DESC = "AUTHORED_QUEUES_MIN_CREATED_AT_DESC",
  AUTHORED_QUEUES_MIN_DELETED_ASC = "AUTHORED_QUEUES_MIN_DELETED_ASC",
  AUTHORED_QUEUES_MIN_DELETED_DESC = "AUTHORED_QUEUES_MIN_DELETED_DESC",
  AUTHORED_QUEUES_MIN_DESCRIPTION_ASC = "AUTHORED_QUEUES_MIN_DESCRIPTION_ASC",
  AUTHORED_QUEUES_MIN_DESCRIPTION_DESC = "AUTHORED_QUEUES_MIN_DESCRIPTION_DESC",
  AUTHORED_QUEUES_MIN_FILTER_ASC = "AUTHORED_QUEUES_MIN_FILTER_ASC",
  AUTHORED_QUEUES_MIN_FILTER_DESC = "AUTHORED_QUEUES_MIN_FILTER_DESC",
  AUTHORED_QUEUES_MIN_ID_ASC = "AUTHORED_QUEUES_MIN_ID_ASC",
  AUTHORED_QUEUES_MIN_ID_DESC = "AUTHORED_QUEUES_MIN_ID_DESC",
  AUTHORED_QUEUES_MIN_INDEXED_FILTER_TAGS_ASC = "AUTHORED_QUEUES_MIN_INDEXED_FILTER_TAGS_ASC",
  AUTHORED_QUEUES_MIN_INDEXED_FILTER_TAGS_DESC = "AUTHORED_QUEUES_MIN_INDEXED_FILTER_TAGS_DESC",
  AUTHORED_QUEUES_MIN_NAME_ASC = "AUTHORED_QUEUES_MIN_NAME_ASC",
  AUTHORED_QUEUES_MIN_NAME_DESC = "AUTHORED_QUEUES_MIN_NAME_DESC",
  AUTHORED_QUEUES_MIN_UPDATED_AT_ASC = "AUTHORED_QUEUES_MIN_UPDATED_AT_ASC",
  AUTHORED_QUEUES_MIN_UPDATED_AT_DESC = "AUTHORED_QUEUES_MIN_UPDATED_AT_DESC",
  AUTHORED_QUEUES_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_QUEUES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_QUEUES_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_QUEUES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_QUEUES_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_QUEUES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_QUEUES_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_QUEUES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_QUEUES_STDDEV_POPULATION_DELETED_ASC = "AUTHORED_QUEUES_STDDEV_POPULATION_DELETED_ASC",
  AUTHORED_QUEUES_STDDEV_POPULATION_DELETED_DESC = "AUTHORED_QUEUES_STDDEV_POPULATION_DELETED_DESC",
  AUTHORED_QUEUES_STDDEV_POPULATION_DESCRIPTION_ASC = "AUTHORED_QUEUES_STDDEV_POPULATION_DESCRIPTION_ASC",
  AUTHORED_QUEUES_STDDEV_POPULATION_DESCRIPTION_DESC = "AUTHORED_QUEUES_STDDEV_POPULATION_DESCRIPTION_DESC",
  AUTHORED_QUEUES_STDDEV_POPULATION_FILTER_ASC = "AUTHORED_QUEUES_STDDEV_POPULATION_FILTER_ASC",
  AUTHORED_QUEUES_STDDEV_POPULATION_FILTER_DESC = "AUTHORED_QUEUES_STDDEV_POPULATION_FILTER_DESC",
  AUTHORED_QUEUES_STDDEV_POPULATION_ID_ASC = "AUTHORED_QUEUES_STDDEV_POPULATION_ID_ASC",
  AUTHORED_QUEUES_STDDEV_POPULATION_ID_DESC = "AUTHORED_QUEUES_STDDEV_POPULATION_ID_DESC",
  AUTHORED_QUEUES_STDDEV_POPULATION_INDEXED_FILTER_TAGS_ASC = "AUTHORED_QUEUES_STDDEV_POPULATION_INDEXED_FILTER_TAGS_ASC",
  AUTHORED_QUEUES_STDDEV_POPULATION_INDEXED_FILTER_TAGS_DESC = "AUTHORED_QUEUES_STDDEV_POPULATION_INDEXED_FILTER_TAGS_DESC",
  AUTHORED_QUEUES_STDDEV_POPULATION_NAME_ASC = "AUTHORED_QUEUES_STDDEV_POPULATION_NAME_ASC",
  AUTHORED_QUEUES_STDDEV_POPULATION_NAME_DESC = "AUTHORED_QUEUES_STDDEV_POPULATION_NAME_DESC",
  AUTHORED_QUEUES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_QUEUES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_QUEUES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_QUEUES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_QUEUES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_QUEUES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_QUEUES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_QUEUES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_DELETED_ASC = "AUTHORED_QUEUES_STDDEV_SAMPLE_DELETED_ASC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_DELETED_DESC = "AUTHORED_QUEUES_STDDEV_SAMPLE_DELETED_DESC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_DESCRIPTION_ASC = "AUTHORED_QUEUES_STDDEV_SAMPLE_DESCRIPTION_ASC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_DESCRIPTION_DESC = "AUTHORED_QUEUES_STDDEV_SAMPLE_DESCRIPTION_DESC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_FILTER_ASC = "AUTHORED_QUEUES_STDDEV_SAMPLE_FILTER_ASC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_FILTER_DESC = "AUTHORED_QUEUES_STDDEV_SAMPLE_FILTER_DESC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_ID_ASC = "AUTHORED_QUEUES_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_ID_DESC = "AUTHORED_QUEUES_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_INDEXED_FILTER_TAGS_ASC = "AUTHORED_QUEUES_STDDEV_SAMPLE_INDEXED_FILTER_TAGS_ASC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_INDEXED_FILTER_TAGS_DESC = "AUTHORED_QUEUES_STDDEV_SAMPLE_INDEXED_FILTER_TAGS_DESC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_NAME_ASC = "AUTHORED_QUEUES_STDDEV_SAMPLE_NAME_ASC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_NAME_DESC = "AUTHORED_QUEUES_STDDEV_SAMPLE_NAME_DESC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_QUEUES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_QUEUES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_QUEUES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_QUEUES_SUM_AUTHOR_ID_ASC = "AUTHORED_QUEUES_SUM_AUTHOR_ID_ASC",
  AUTHORED_QUEUES_SUM_AUTHOR_ID_DESC = "AUTHORED_QUEUES_SUM_AUTHOR_ID_DESC",
  AUTHORED_QUEUES_SUM_CREATED_AT_ASC = "AUTHORED_QUEUES_SUM_CREATED_AT_ASC",
  AUTHORED_QUEUES_SUM_CREATED_AT_DESC = "AUTHORED_QUEUES_SUM_CREATED_AT_DESC",
  AUTHORED_QUEUES_SUM_DELETED_ASC = "AUTHORED_QUEUES_SUM_DELETED_ASC",
  AUTHORED_QUEUES_SUM_DELETED_DESC = "AUTHORED_QUEUES_SUM_DELETED_DESC",
  AUTHORED_QUEUES_SUM_DESCRIPTION_ASC = "AUTHORED_QUEUES_SUM_DESCRIPTION_ASC",
  AUTHORED_QUEUES_SUM_DESCRIPTION_DESC = "AUTHORED_QUEUES_SUM_DESCRIPTION_DESC",
  AUTHORED_QUEUES_SUM_FILTER_ASC = "AUTHORED_QUEUES_SUM_FILTER_ASC",
  AUTHORED_QUEUES_SUM_FILTER_DESC = "AUTHORED_QUEUES_SUM_FILTER_DESC",
  AUTHORED_QUEUES_SUM_ID_ASC = "AUTHORED_QUEUES_SUM_ID_ASC",
  AUTHORED_QUEUES_SUM_ID_DESC = "AUTHORED_QUEUES_SUM_ID_DESC",
  AUTHORED_QUEUES_SUM_INDEXED_FILTER_TAGS_ASC = "AUTHORED_QUEUES_SUM_INDEXED_FILTER_TAGS_ASC",
  AUTHORED_QUEUES_SUM_INDEXED_FILTER_TAGS_DESC = "AUTHORED_QUEUES_SUM_INDEXED_FILTER_TAGS_DESC",
  AUTHORED_QUEUES_SUM_NAME_ASC = "AUTHORED_QUEUES_SUM_NAME_ASC",
  AUTHORED_QUEUES_SUM_NAME_DESC = "AUTHORED_QUEUES_SUM_NAME_DESC",
  AUTHORED_QUEUES_SUM_UPDATED_AT_ASC = "AUTHORED_QUEUES_SUM_UPDATED_AT_ASC",
  AUTHORED_QUEUES_SUM_UPDATED_AT_DESC = "AUTHORED_QUEUES_SUM_UPDATED_AT_DESC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_QUEUES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_QUEUES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_QUEUES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_QUEUES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_DELETED_ASC = "AUTHORED_QUEUES_VARIANCE_POPULATION_DELETED_ASC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_DELETED_DESC = "AUTHORED_QUEUES_VARIANCE_POPULATION_DELETED_DESC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_DESCRIPTION_ASC = "AUTHORED_QUEUES_VARIANCE_POPULATION_DESCRIPTION_ASC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_DESCRIPTION_DESC = "AUTHORED_QUEUES_VARIANCE_POPULATION_DESCRIPTION_DESC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_FILTER_ASC = "AUTHORED_QUEUES_VARIANCE_POPULATION_FILTER_ASC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_FILTER_DESC = "AUTHORED_QUEUES_VARIANCE_POPULATION_FILTER_DESC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_ID_ASC = "AUTHORED_QUEUES_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_ID_DESC = "AUTHORED_QUEUES_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_INDEXED_FILTER_TAGS_ASC = "AUTHORED_QUEUES_VARIANCE_POPULATION_INDEXED_FILTER_TAGS_ASC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_INDEXED_FILTER_TAGS_DESC = "AUTHORED_QUEUES_VARIANCE_POPULATION_INDEXED_FILTER_TAGS_DESC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_NAME_ASC = "AUTHORED_QUEUES_VARIANCE_POPULATION_NAME_ASC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_NAME_DESC = "AUTHORED_QUEUES_VARIANCE_POPULATION_NAME_DESC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_QUEUES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_QUEUES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_QUEUES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_DELETED_ASC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_DELETED_ASC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_DELETED_DESC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_DELETED_DESC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_DESCRIPTION_ASC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_DESCRIPTION_ASC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_DESCRIPTION_DESC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_DESCRIPTION_DESC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_FILTER_ASC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_FILTER_ASC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_FILTER_DESC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_FILTER_DESC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_INDEXED_FILTER_TAGS_ASC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_INDEXED_FILTER_TAGS_ASC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_INDEXED_FILTER_TAGS_DESC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_INDEXED_FILTER_TAGS_DESC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_NAME_ASC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_NAME_ASC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_NAME_DESC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_NAME_DESC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_QUEUES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_QUEUES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_ACCEPTED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_ACCEPTED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_ACCEPTED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_ACCEPTED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_DELETED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_DELETED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_DELETED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_DELETED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_RATIONALE_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_RATIONALE_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_RATIONALE_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_RATIONALE_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_COUNT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_COUNT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_COUNT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_COUNT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ACCEPTED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ACCEPTED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ACCEPTED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ACCEPTED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_RATIONALE_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_RATIONALE_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_RATIONALE_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_RATIONALE_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_ACCEPTED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_ACCEPTED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_ACCEPTED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_ACCEPTED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_AUDIT_FINDING_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_CREATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_CREATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_CREATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_CREATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_DELETED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_DELETED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_DELETED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_DELETED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_RATIONALE_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_RATIONALE_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_RATIONALE_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_RATIONALE_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_UPDATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_UPDATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_UPDATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MAX_UPDATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_ACCEPTED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_ACCEPTED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_ACCEPTED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_ACCEPTED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_AUDIT_FINDING_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_CREATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_CREATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_CREATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_CREATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_DELETED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_DELETED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_DELETED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_DELETED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_RATIONALE_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_RATIONALE_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_RATIONALE_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_RATIONALE_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_UPDATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_UPDATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_UPDATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_MIN_UPDATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ACCEPTED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ACCEPTED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ACCEPTED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ACCEPTED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_RATIONALE_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_RATIONALE_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_RATIONALE_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_RATIONALE_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ACCEPTED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ACCEPTED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ACCEPTED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ACCEPTED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_RATIONALE_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_RATIONALE_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_RATIONALE_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_RATIONALE_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_ACCEPTED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_ACCEPTED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_ACCEPTED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_ACCEPTED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_AUDIT_FINDING_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_CREATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_CREATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_CREATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_CREATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_DELETED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_DELETED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_DELETED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_DELETED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_RATIONALE_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_RATIONALE_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_RATIONALE_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_RATIONALE_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_UPDATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_UPDATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_UPDATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_SUM_UPDATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ACCEPTED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ACCEPTED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ACCEPTED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ACCEPTED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_RATIONALE_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_RATIONALE_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_RATIONALE_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_RATIONALE_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ACCEPTED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ACCEPTED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ACCEPTED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ACCEPTED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_RATIONALE_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_RATIONALE_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_RATIONALE_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_RATIONALE_DESC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUTHORED_REVIEWED_AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIMS_BY_AUTHOR_ID__COUNT_ASC = "BATCH_CLAIMS_BY_AUTHOR_ID__COUNT_ASC",
  BATCH_CLAIMS_BY_AUTHOR_ID__COUNT_DESC = "BATCH_CLAIMS_BY_AUTHOR_ID__COUNT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_APPEALED_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_APPEALED_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_APPEALED_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_APPEALED_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_COUNT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_COUNT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_COUNT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_COUNT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_APPEALED_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_APPEALED_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_APPEALED_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_APPEALED_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_APPEALED_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_APPEALED_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_APPEALED_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_APPEALED_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_CREATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_CREATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_CREATED_BY_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_CREATED_BY_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_CREATED_BY_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_CREATED_BY_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_APPEALED_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_APPEALED_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_APPEALED_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_APPEALED_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_CREATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_CREATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_CREATED_BY_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_CREATED_BY_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_CREATED_BY_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_CREATED_BY_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_APPEALED_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_APPEALED_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_APPEALED_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_APPEALED_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_APPEALED_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_APPEALED_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_APPEALED_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_APPEALED_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_APPEALED_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_APPEALED_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_APPEALED_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_APPEALED_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_CREATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_CREATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_CREATED_BY_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_CREATED_BY_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_CREATED_BY_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_CREATED_BY_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_APPEALED_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_APPEALED_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_APPEALED_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_APPEALED_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_APPEALED_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_APPEALED_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_APPEALED_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_APPEALED_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY__COUNT_ASC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY__COUNT_ASC",
  BATCH_CLAIM_APPEALEDS_BY_CREATED_BY__COUNT_DESC = "BATCH_CLAIM_APPEALEDS_BY_CREATED_BY__COUNT_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_ID_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_ID_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_ASC = "BATCH_CLAIM_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_ASC",
  BATCH_CLAIM_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_DESC = "BATCH_CLAIM_ASSIGNEES_BY_AUDITOR_USER_ID__COUNT_DESC",
  BATCH_CLAIM_ASSIGNEES_COUNT_ASC = "BATCH_CLAIM_ASSIGNEES_COUNT_ASC",
  BATCH_CLAIM_ASSIGNEES_COUNT_DESC = "BATCH_CLAIM_ASSIGNEES_COUNT_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_AVERAGE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_AVERAGE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_AVERAGE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_AVERAGE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_AVERAGE_ID_ASC = "BATCH_CLAIM_AUDITORS_AVERAGE_ID_ASC",
  BATCH_CLAIM_AUDITORS_AVERAGE_ID_DESC = "BATCH_CLAIM_AUDITORS_AVERAGE_ID_DESC",
  BATCH_CLAIM_AUDITORS_BY_AUDITOR_USER_ID__COUNT_ASC = "BATCH_CLAIM_AUDITORS_BY_AUDITOR_USER_ID__COUNT_ASC",
  BATCH_CLAIM_AUDITORS_BY_AUDITOR_USER_ID__COUNT_DESC = "BATCH_CLAIM_AUDITORS_BY_AUDITOR_USER_ID__COUNT_DESC",
  BATCH_CLAIM_AUDITORS_COUNT_ASC = "BATCH_CLAIM_AUDITORS_COUNT_ASC",
  BATCH_CLAIM_AUDITORS_COUNT_DESC = "BATCH_CLAIM_AUDITORS_COUNT_DESC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_AUDITORS_MAX_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_MAX_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_MAX_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_MAX_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_MAX_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_MAX_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_MAX_ID_ASC = "BATCH_CLAIM_AUDITORS_MAX_ID_ASC",
  BATCH_CLAIM_AUDITORS_MAX_ID_DESC = "BATCH_CLAIM_AUDITORS_MAX_ID_DESC",
  BATCH_CLAIM_AUDITORS_MIN_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_MIN_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_MIN_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_MIN_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_MIN_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_MIN_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_MIN_ID_ASC = "BATCH_CLAIM_AUDITORS_MIN_ID_ASC",
  BATCH_CLAIM_AUDITORS_MIN_ID_DESC = "BATCH_CLAIM_AUDITORS_MIN_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_AUDITORS_SUM_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_SUM_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_SUM_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_SUM_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_SUM_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_SUM_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_SUM_ID_ASC = "BATCH_CLAIM_AUDITORS_SUM_ID_ASC",
  BATCH_CLAIM_AUDITORS_SUM_ID_DESC = "BATCH_CLAIM_AUDITORS_SUM_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_COUNT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_COUNT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_COUNT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_COUNT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC",
  BATCH_CLAIM_LINE_ITEMS_BY_AUTHOR_ID__COUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_BY_AUTHOR_ID__COUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_BY_AUTHOR_ID__COUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_BY_AUTHOR_ID__COUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_BY_AUTHOR_ID__COUNT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_BY_AUTHOR_ID__COUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_BY_AUTHOR_ID__COUNT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_BY_AUTHOR_ID__COUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_AUTHOR_ID__COUNT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_AUTHOR_ID__COUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_AUTHOR_ID__COUNT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_AUTHOR_ID__COUNT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_AVERAGE_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_COUNT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_COUNT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_COUNT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_COUNT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_DISTINCT_COUNT_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MAX_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_MIN_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_POPULATION_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_STDDEV_SAMPLE_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_SUM_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_POPULATION_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_USER_ID_VARIANCE_SAMPLE_USER_ID_DESC",
  BATCH_CLAIM_STATES_AVERAGE_APPEALED_ASC = "BATCH_CLAIM_STATES_AVERAGE_APPEALED_ASC",
  BATCH_CLAIM_STATES_AVERAGE_APPEALED_DESC = "BATCH_CLAIM_STATES_AVERAGE_APPEALED_DESC",
  BATCH_CLAIM_STATES_AVERAGE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_AVERAGE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_AVERAGE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_AVERAGE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_AVERAGE_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_AVERAGE_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_AVERAGE_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_AVERAGE_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_AVERAGE_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DUE_DATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DUE_DATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_ID_ASC = "BATCH_CLAIM_STATES_AVERAGE_ID_ASC",
  BATCH_CLAIM_STATES_AVERAGE_ID_DESC = "BATCH_CLAIM_STATES_AVERAGE_ID_DESC",
  BATCH_CLAIM_STATES_AVERAGE_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_AVERAGE_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_AVERAGE_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_AVERAGE_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_AVERAGE_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_AVERAGE_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_AVERAGE_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_PAY_DENY_ASC = "BATCH_CLAIM_STATES_AVERAGE_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_AVERAGE_PAY_DENY_DESC = "BATCH_CLAIM_STATES_AVERAGE_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_REPORTED_ASC = "BATCH_CLAIM_STATES_AVERAGE_REPORTED_ASC",
  BATCH_CLAIM_STATES_AVERAGE_REPORTED_DESC = "BATCH_CLAIM_STATES_AVERAGE_REPORTED_DESC",
  BATCH_CLAIM_STATES_AVERAGE_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_AVERAGE_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_AVERAGE_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_AVERAGE_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_AVERAGE_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_BY_AUDITOR_USER_ID__COUNT_ASC = "BATCH_CLAIM_STATES_BY_AUDITOR_USER_ID__COUNT_ASC",
  BATCH_CLAIM_STATES_BY_AUDITOR_USER_ID__COUNT_DESC = "BATCH_CLAIM_STATES_BY_AUDITOR_USER_ID__COUNT_DESC",
  BATCH_CLAIM_STATES_COUNT_ASC = "BATCH_CLAIM_STATES_COUNT_ASC",
  BATCH_CLAIM_STATES_COUNT_DESC = "BATCH_CLAIM_STATES_COUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_APPEALED_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_APPEALED_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_APPEALED_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_APPEALED_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DUE_DATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DUE_DATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_PAY_DENY_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_PAY_DENY_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_REPORTED_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_REPORTED_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_REPORTED_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_REPORTED_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_APPEALED_ASC = "BATCH_CLAIM_STATES_MAX_APPEALED_ASC",
  BATCH_CLAIM_STATES_MAX_APPEALED_DESC = "BATCH_CLAIM_STATES_MAX_APPEALED_DESC",
  BATCH_CLAIM_STATES_MAX_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_MAX_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_MAX_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_MAX_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_MAX_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_MAX_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_MAX_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_MAX_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_MAX_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_MAX_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_MAX_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_MAX_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_MAX_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_MAX_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_MAX_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_MAX_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_MAX_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_MAX_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_MAX_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_MAX_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_MAX_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MAX_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_DUE_DATE_ASC = "BATCH_CLAIM_STATES_MAX_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_MAX_DUE_DATE_DESC = "BATCH_CLAIM_STATES_MAX_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_MAX_ID_ASC = "BATCH_CLAIM_STATES_MAX_ID_ASC",
  BATCH_CLAIM_STATES_MAX_ID_DESC = "BATCH_CLAIM_STATES_MAX_ID_DESC",
  BATCH_CLAIM_STATES_MAX_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_MAX_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_MAX_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_MAX_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_MAX_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_MAX_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_MAX_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_MAX_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_MAX_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_PAY_DENY_ASC = "BATCH_CLAIM_STATES_MAX_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_MAX_PAY_DENY_DESC = "BATCH_CLAIM_STATES_MAX_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_REPORTED_ASC = "BATCH_CLAIM_STATES_MAX_REPORTED_ASC",
  BATCH_CLAIM_STATES_MAX_REPORTED_DESC = "BATCH_CLAIM_STATES_MAX_REPORTED_DESC",
  BATCH_CLAIM_STATES_MAX_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_MAX_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_MAX_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_MAX_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_MAX_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_APPEALED_ASC = "BATCH_CLAIM_STATES_MIN_APPEALED_ASC",
  BATCH_CLAIM_STATES_MIN_APPEALED_DESC = "BATCH_CLAIM_STATES_MIN_APPEALED_DESC",
  BATCH_CLAIM_STATES_MIN_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_MIN_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_MIN_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_MIN_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_MIN_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_MIN_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_MIN_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_MIN_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_MIN_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_MIN_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_MIN_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_MIN_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_MIN_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_MIN_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_MIN_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_MIN_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_MIN_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_MIN_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_MIN_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_MIN_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_MIN_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MIN_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_DUE_DATE_ASC = "BATCH_CLAIM_STATES_MIN_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_MIN_DUE_DATE_DESC = "BATCH_CLAIM_STATES_MIN_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_MIN_ID_ASC = "BATCH_CLAIM_STATES_MIN_ID_ASC",
  BATCH_CLAIM_STATES_MIN_ID_DESC = "BATCH_CLAIM_STATES_MIN_ID_DESC",
  BATCH_CLAIM_STATES_MIN_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_MIN_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_MIN_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_MIN_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_MIN_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_MIN_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_MIN_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_MIN_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_MIN_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_PAY_DENY_ASC = "BATCH_CLAIM_STATES_MIN_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_MIN_PAY_DENY_DESC = "BATCH_CLAIM_STATES_MIN_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_REPORTED_ASC = "BATCH_CLAIM_STATES_MIN_REPORTED_ASC",
  BATCH_CLAIM_STATES_MIN_REPORTED_DESC = "BATCH_CLAIM_STATES_MIN_REPORTED_DESC",
  BATCH_CLAIM_STATES_MIN_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_MIN_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_MIN_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_MIN_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_MIN_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_APPEALED_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_APPEALED_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_APPEALED_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_APPEALED_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DUE_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DUE_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_PAY_DENY_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_PAY_DENY_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_REPORTED_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_REPORTED_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_REPORTED_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_REPORTED_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_APPEALED_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_APPEALED_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_APPEALED_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_APPEALED_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DUE_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DUE_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_PAY_DENY_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_PAY_DENY_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_REPORTED_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_REPORTED_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_REPORTED_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_REPORTED_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_APPEALED_ASC = "BATCH_CLAIM_STATES_SUM_APPEALED_ASC",
  BATCH_CLAIM_STATES_SUM_APPEALED_DESC = "BATCH_CLAIM_STATES_SUM_APPEALED_DESC",
  BATCH_CLAIM_STATES_SUM_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_SUM_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_SUM_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_SUM_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_SUM_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_SUM_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_SUM_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_SUM_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_SUM_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_SUM_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_SUM_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_SUM_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_SUM_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_SUM_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_SUM_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_SUM_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_SUM_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_SUM_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_SUM_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_SUM_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_SUM_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_SUM_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_DUE_DATE_ASC = "BATCH_CLAIM_STATES_SUM_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_SUM_DUE_DATE_DESC = "BATCH_CLAIM_STATES_SUM_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_SUM_ID_ASC = "BATCH_CLAIM_STATES_SUM_ID_ASC",
  BATCH_CLAIM_STATES_SUM_ID_DESC = "BATCH_CLAIM_STATES_SUM_ID_DESC",
  BATCH_CLAIM_STATES_SUM_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_SUM_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_SUM_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_SUM_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_SUM_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_SUM_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_SUM_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_SUM_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_SUM_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_PAY_DENY_ASC = "BATCH_CLAIM_STATES_SUM_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_SUM_PAY_DENY_DESC = "BATCH_CLAIM_STATES_SUM_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_REPORTED_ASC = "BATCH_CLAIM_STATES_SUM_REPORTED_ASC",
  BATCH_CLAIM_STATES_SUM_REPORTED_DESC = "BATCH_CLAIM_STATES_SUM_REPORTED_DESC",
  BATCH_CLAIM_STATES_SUM_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_SUM_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_SUM_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_SUM_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_SUM_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_APPEALED_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_APPEALED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_APPEALED_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_APPEALED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DUE_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DUE_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_PAY_DENY_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_PAY_DENY_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_REPORTED_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_REPORTED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_REPORTED_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_REPORTED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_APPEALED_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_APPEALED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_APPEALED_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_APPEALED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DUE_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DUE_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PAY_DENY_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PAY_DENY_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_REPORTED_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_REPORTED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_REPORTED_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_REPORTED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_TECH_DENIED_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_TECH_DENIED_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_TECH_DENIED_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_TECH_DENIED_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_COUNT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_COUNT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_COUNT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_COUNT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_TECH_DENIED_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_TECH_DENIED_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_TECH_DENIED_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_TECH_DENIED_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_CREATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_CREATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_CREATED_BY_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_CREATED_BY_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_CREATED_BY_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_CREATED_BY_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_TECH_DENIED_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_TECH_DENIED_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_TECH_DENIED_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_TECH_DENIED_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_CREATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_CREATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_CREATED_BY_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_CREATED_BY_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_CREATED_BY_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_CREATED_BY_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_TECH_DENIED_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_TECH_DENIED_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_TECH_DENIED_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_TECH_DENIED_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_TECH_DENIED_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_TECH_DENIED_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_TECH_DENIED_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_TECH_DENIED_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_TECH_DENIED_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_TECH_DENIED_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_TECH_DENIED_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_TECH_DENIED_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_CREATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_CREATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_CREATED_BY_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_CREATED_BY_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_CREATED_BY_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_CREATED_BY_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_TECH_DENIED_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_TECH_DENIED_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_TECH_DENIED_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_TECH_DENIED_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_TECH_DENIED_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_TECH_DENIED_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_TECH_DENIED_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_TECH_DENIED_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_TECH_DENIED_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_TECH_DENIED_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_TECH_DENIED_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_TECH_DENIED_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY__COUNT_ASC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY__COUNT_ASC",
  BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY__COUNT_DESC = "BATCH_CLAIM_TECH_DENIALS_BY_CREATED_BY__COUNT_DESC",
  BATCH_FILES_BY_AUTHOR_ID__COUNT_ASC = "BATCH_FILES_BY_AUTHOR_ID__COUNT_ASC",
  BATCH_FILES_BY_AUTHOR_ID__COUNT_DESC = "BATCH_FILES_BY_AUTHOR_ID__COUNT_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_NAME_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_NAME_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_NAME_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_NAME_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_AVERAGE_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_COUNT_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_COUNT_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_COUNT_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_COUNT_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_NAME_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_NAME_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_NAME_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_NAME_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_DISTINCT_COUNT_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_NAME_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_NAME_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_NAME_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_NAME_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MAX_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_NAME_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_NAME_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_NAME_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_NAME_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_MIN_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_NAME_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_NAME_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_NAME_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_NAME_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_POPULATION_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_NAME_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_NAME_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_NAME_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_NAME_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_STDDEV_SAMPLE_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_NAME_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_NAME_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_NAME_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_NAME_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_SUM_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_NAME_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_NAME_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_NAME_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_NAME_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_POPULATION_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_NAME_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_NAME_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_NAME_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_NAME_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY_VARIANCE_SAMPLE_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY__COUNT_ASC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY__COUNT_ASC",
  CLAIM_AUDIT_GROUPS_BY_CREATED_BY__COUNT_DESC = "CLAIM_AUDIT_GROUPS_BY_CREATED_BY__COUNT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_AUTHOR_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_AUTHOR_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CASE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CASE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CASE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CASE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CLAIM_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CLAIM_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CLAIM_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CLAIM_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CREATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CREATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CREATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_CREATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_UPDATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_UPDATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_UPDATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_UPDATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_UPDATED_BY_ASC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_UPDATED_BY_ASC",
  CLAIM_CASES_BY_UPDATED_BY_AVERAGE_UPDATED_BY_DESC = "CLAIM_CASES_BY_UPDATED_BY_AVERAGE_UPDATED_BY_DESC",
  CLAIM_CASES_BY_UPDATED_BY_COUNT_ASC = "CLAIM_CASES_BY_UPDATED_BY_COUNT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_COUNT_DESC = "CLAIM_CASES_BY_UPDATED_BY_COUNT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_AUTHOR_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_AUTHOR_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CASE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CASE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CASE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CASE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CLAIM_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CLAIM_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CLAIM_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CLAIM_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_UPDATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_UPDATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_UPDATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_UPDATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_UPDATED_BY_ASC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_UPDATED_BY_ASC",
  CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_UPDATED_BY_DESC = "CLAIM_CASES_BY_UPDATED_BY_DISTINCT_COUNT_UPDATED_BY_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_AUTHOR_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_MAX_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_AUTHOR_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_MAX_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_CASE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_MAX_CASE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_CASE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_MAX_CASE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_CLAIM_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_MAX_CLAIM_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_CLAIM_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_MAX_CLAIM_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_CREATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_MAX_CREATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_CREATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_MAX_CREATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_MAX_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_MAX_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_UPDATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_MAX_UPDATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_UPDATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_MAX_UPDATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_UPDATED_BY_ASC = "CLAIM_CASES_BY_UPDATED_BY_MAX_UPDATED_BY_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MAX_UPDATED_BY_DESC = "CLAIM_CASES_BY_UPDATED_BY_MAX_UPDATED_BY_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_AUTHOR_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_MIN_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_AUTHOR_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_MIN_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_CASE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_MIN_CASE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_CASE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_MIN_CASE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_CLAIM_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_MIN_CLAIM_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_CLAIM_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_MIN_CLAIM_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_CREATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_MIN_CREATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_CREATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_MIN_CREATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_MIN_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_MIN_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_UPDATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_MIN_UPDATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_UPDATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_MIN_UPDATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_UPDATED_BY_ASC = "CLAIM_CASES_BY_UPDATED_BY_MIN_UPDATED_BY_ASC",
  CLAIM_CASES_BY_UPDATED_BY_MIN_UPDATED_BY_DESC = "CLAIM_CASES_BY_UPDATED_BY_MIN_UPDATED_BY_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_AUTHOR_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_AUTHOR_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CASE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CASE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CASE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CASE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CLAIM_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CLAIM_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CLAIM_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CLAIM_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_UPDATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_UPDATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_UPDATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_UPDATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_UPDATED_BY_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_UPDATED_BY_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_UPDATED_BY_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_POPULATION_UPDATED_BY_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_AUTHOR_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_AUTHOR_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CASE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CASE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CASE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CASE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CLAIM_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CLAIM_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CLAIM_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CLAIM_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_UPDATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_UPDATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_UPDATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_UPDATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_UPDATED_BY_ASC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_UPDATED_BY_ASC",
  CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_UPDATED_BY_DESC = "CLAIM_CASES_BY_UPDATED_BY_STDDEV_SAMPLE_UPDATED_BY_DESC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_AUTHOR_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_SUM_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_AUTHOR_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_SUM_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_CASE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_SUM_CASE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_CASE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_SUM_CASE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_CLAIM_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_SUM_CLAIM_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_CLAIM_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_SUM_CLAIM_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_CREATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_SUM_CREATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_CREATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_SUM_CREATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_SUM_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_SUM_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_UPDATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_SUM_UPDATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_UPDATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_SUM_UPDATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_UPDATED_BY_ASC = "CLAIM_CASES_BY_UPDATED_BY_SUM_UPDATED_BY_ASC",
  CLAIM_CASES_BY_UPDATED_BY_SUM_UPDATED_BY_DESC = "CLAIM_CASES_BY_UPDATED_BY_SUM_UPDATED_BY_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_AUTHOR_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_AUTHOR_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CASE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CASE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CASE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CASE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CLAIM_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CLAIM_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CLAIM_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CLAIM_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_UPDATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_UPDATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_UPDATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_UPDATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_UPDATED_BY_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_UPDATED_BY_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_UPDATED_BY_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_POPULATION_UPDATED_BY_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CASE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CASE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CASE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CASE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CLAIM_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CLAIM_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CLAIM_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CLAIM_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_ID_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_ID_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_UPDATED_AT_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_UPDATED_AT_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_UPDATED_BY_ASC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_UPDATED_BY_ASC",
  CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_UPDATED_BY_DESC = "CLAIM_CASES_BY_UPDATED_BY_VARIANCE_SAMPLE_UPDATED_BY_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_PATH_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_PATH_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_PATH_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_PATH_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_AVERAGE_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_COUNT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_COUNT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_COUNT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_COUNT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_PATH_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_PATH_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_PATH_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_PATH_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_DISTINCT_COUNT_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_PATH_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_PATH_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_PATH_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_PATH_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MAX_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_PATH_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_PATH_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_PATH_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_PATH_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_MIN_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_PATH_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_PATH_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_PATH_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_PATH_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_POPULATION_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_PATH_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_PATH_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_PATH_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_PATH_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_STDDEV_SAMPLE_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_PATH_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_PATH_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_PATH_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_PATH_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_SUM_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_PATH_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_PATH_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_PATH_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_PATH_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_POPULATION_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_ID_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_ID_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_PATH_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_PATH_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_PATH_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_PATH_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_VALUE_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_VALUE_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_VALUE_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY_VARIANCE_SAMPLE_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY__COUNT_ASC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY__COUNT_ASC",
  CLAIM_FACET_HISTORIES_BY_APPLIED_BY__COUNT_DESC = "CLAIM_FACET_HISTORIES_BY_APPLIED_BY__COUNT_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DISPUTED_FINDINGS_BY_AUTHOR_ID__COUNT_ASC = "DISPUTED_FINDINGS_BY_AUTHOR_ID__COUNT_ASC",
  DISPUTED_FINDINGS_BY_AUTHOR_ID__COUNT_DESC = "DISPUTED_FINDINGS_BY_AUTHOR_ID__COUNT_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_AVERAGE_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_COUNT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_COUNT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_COUNT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_COUNT_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_DISTINCT_COUNT_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MAX_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_MIN_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_POPULATION_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_STDDEV_SAMPLE_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_SUM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_POPULATION_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_ID_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_ID_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY_VARIANCE_SAMPLE_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY__COUNT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY__COUNT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY__COUNT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_CREATED_BY__COUNT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_AUTHOR_ID__COUNT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_AUTHOR_ID__COUNT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_AUTHOR_ID__COUNT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_AUTHOR_ID__COUNT_DESC",
  EMAIL_ASC = "EMAIL_ASC",
  EMAIL_DESC = "EMAIL_DESC",
  FIRST_NAME_ASC = "FIRST_NAME_ASC",
  FIRST_NAME_DESC = "FIRST_NAME_DESC",
  IDP_SUB_ASC = "IDP_SUB_ASC",
  IDP_SUB_DESC = "IDP_SUB_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INSURER_USERS_AVERAGE_AUDITOR_USER_ID_ASC = "INSURER_USERS_AVERAGE_AUDITOR_USER_ID_ASC",
  INSURER_USERS_AVERAGE_AUDITOR_USER_ID_DESC = "INSURER_USERS_AVERAGE_AUDITOR_USER_ID_DESC",
  INSURER_USERS_AVERAGE_CREATED_AT_ASC = "INSURER_USERS_AVERAGE_CREATED_AT_ASC",
  INSURER_USERS_AVERAGE_CREATED_AT_DESC = "INSURER_USERS_AVERAGE_CREATED_AT_DESC",
  INSURER_USERS_AVERAGE_ID_ASC = "INSURER_USERS_AVERAGE_ID_ASC",
  INSURER_USERS_AVERAGE_ID_DESC = "INSURER_USERS_AVERAGE_ID_DESC",
  INSURER_USERS_AVERAGE_INSURER_ID_ASC = "INSURER_USERS_AVERAGE_INSURER_ID_ASC",
  INSURER_USERS_AVERAGE_INSURER_ID_DESC = "INSURER_USERS_AVERAGE_INSURER_ID_DESC",
  INSURER_USERS_AVERAGE_UPDATED_AT_ASC = "INSURER_USERS_AVERAGE_UPDATED_AT_ASC",
  INSURER_USERS_AVERAGE_UPDATED_AT_DESC = "INSURER_USERS_AVERAGE_UPDATED_AT_DESC",
  INSURER_USERS_BY_AUDITOR_USER_ID__COUNT_ASC = "INSURER_USERS_BY_AUDITOR_USER_ID__COUNT_ASC",
  INSURER_USERS_BY_AUDITOR_USER_ID__COUNT_DESC = "INSURER_USERS_BY_AUDITOR_USER_ID__COUNT_DESC",
  INSURER_USERS_COUNT_ASC = "INSURER_USERS_COUNT_ASC",
  INSURER_USERS_COUNT_DESC = "INSURER_USERS_COUNT_DESC",
  INSURER_USERS_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "INSURER_USERS_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  INSURER_USERS_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "INSURER_USERS_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  INSURER_USERS_DISTINCT_COUNT_CREATED_AT_ASC = "INSURER_USERS_DISTINCT_COUNT_CREATED_AT_ASC",
  INSURER_USERS_DISTINCT_COUNT_CREATED_AT_DESC = "INSURER_USERS_DISTINCT_COUNT_CREATED_AT_DESC",
  INSURER_USERS_DISTINCT_COUNT_ID_ASC = "INSURER_USERS_DISTINCT_COUNT_ID_ASC",
  INSURER_USERS_DISTINCT_COUNT_ID_DESC = "INSURER_USERS_DISTINCT_COUNT_ID_DESC",
  INSURER_USERS_DISTINCT_COUNT_INSURER_ID_ASC = "INSURER_USERS_DISTINCT_COUNT_INSURER_ID_ASC",
  INSURER_USERS_DISTINCT_COUNT_INSURER_ID_DESC = "INSURER_USERS_DISTINCT_COUNT_INSURER_ID_DESC",
  INSURER_USERS_DISTINCT_COUNT_UPDATED_AT_ASC = "INSURER_USERS_DISTINCT_COUNT_UPDATED_AT_ASC",
  INSURER_USERS_DISTINCT_COUNT_UPDATED_AT_DESC = "INSURER_USERS_DISTINCT_COUNT_UPDATED_AT_DESC",
  INSURER_USERS_MAX_AUDITOR_USER_ID_ASC = "INSURER_USERS_MAX_AUDITOR_USER_ID_ASC",
  INSURER_USERS_MAX_AUDITOR_USER_ID_DESC = "INSURER_USERS_MAX_AUDITOR_USER_ID_DESC",
  INSURER_USERS_MAX_CREATED_AT_ASC = "INSURER_USERS_MAX_CREATED_AT_ASC",
  INSURER_USERS_MAX_CREATED_AT_DESC = "INSURER_USERS_MAX_CREATED_AT_DESC",
  INSURER_USERS_MAX_ID_ASC = "INSURER_USERS_MAX_ID_ASC",
  INSURER_USERS_MAX_ID_DESC = "INSURER_USERS_MAX_ID_DESC",
  INSURER_USERS_MAX_INSURER_ID_ASC = "INSURER_USERS_MAX_INSURER_ID_ASC",
  INSURER_USERS_MAX_INSURER_ID_DESC = "INSURER_USERS_MAX_INSURER_ID_DESC",
  INSURER_USERS_MAX_UPDATED_AT_ASC = "INSURER_USERS_MAX_UPDATED_AT_ASC",
  INSURER_USERS_MAX_UPDATED_AT_DESC = "INSURER_USERS_MAX_UPDATED_AT_DESC",
  INSURER_USERS_MIN_AUDITOR_USER_ID_ASC = "INSURER_USERS_MIN_AUDITOR_USER_ID_ASC",
  INSURER_USERS_MIN_AUDITOR_USER_ID_DESC = "INSURER_USERS_MIN_AUDITOR_USER_ID_DESC",
  INSURER_USERS_MIN_CREATED_AT_ASC = "INSURER_USERS_MIN_CREATED_AT_ASC",
  INSURER_USERS_MIN_CREATED_AT_DESC = "INSURER_USERS_MIN_CREATED_AT_DESC",
  INSURER_USERS_MIN_ID_ASC = "INSURER_USERS_MIN_ID_ASC",
  INSURER_USERS_MIN_ID_DESC = "INSURER_USERS_MIN_ID_DESC",
  INSURER_USERS_MIN_INSURER_ID_ASC = "INSURER_USERS_MIN_INSURER_ID_ASC",
  INSURER_USERS_MIN_INSURER_ID_DESC = "INSURER_USERS_MIN_INSURER_ID_DESC",
  INSURER_USERS_MIN_UPDATED_AT_ASC = "INSURER_USERS_MIN_UPDATED_AT_ASC",
  INSURER_USERS_MIN_UPDATED_AT_DESC = "INSURER_USERS_MIN_UPDATED_AT_DESC",
  INSURER_USERS_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "INSURER_USERS_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  INSURER_USERS_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "INSURER_USERS_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  INSURER_USERS_STDDEV_POPULATION_CREATED_AT_ASC = "INSURER_USERS_STDDEV_POPULATION_CREATED_AT_ASC",
  INSURER_USERS_STDDEV_POPULATION_CREATED_AT_DESC = "INSURER_USERS_STDDEV_POPULATION_CREATED_AT_DESC",
  INSURER_USERS_STDDEV_POPULATION_ID_ASC = "INSURER_USERS_STDDEV_POPULATION_ID_ASC",
  INSURER_USERS_STDDEV_POPULATION_ID_DESC = "INSURER_USERS_STDDEV_POPULATION_ID_DESC",
  INSURER_USERS_STDDEV_POPULATION_INSURER_ID_ASC = "INSURER_USERS_STDDEV_POPULATION_INSURER_ID_ASC",
  INSURER_USERS_STDDEV_POPULATION_INSURER_ID_DESC = "INSURER_USERS_STDDEV_POPULATION_INSURER_ID_DESC",
  INSURER_USERS_STDDEV_POPULATION_UPDATED_AT_ASC = "INSURER_USERS_STDDEV_POPULATION_UPDATED_AT_ASC",
  INSURER_USERS_STDDEV_POPULATION_UPDATED_AT_DESC = "INSURER_USERS_STDDEV_POPULATION_UPDATED_AT_DESC",
  INSURER_USERS_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "INSURER_USERS_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  INSURER_USERS_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "INSURER_USERS_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  INSURER_USERS_STDDEV_SAMPLE_CREATED_AT_ASC = "INSURER_USERS_STDDEV_SAMPLE_CREATED_AT_ASC",
  INSURER_USERS_STDDEV_SAMPLE_CREATED_AT_DESC = "INSURER_USERS_STDDEV_SAMPLE_CREATED_AT_DESC",
  INSURER_USERS_STDDEV_SAMPLE_ID_ASC = "INSURER_USERS_STDDEV_SAMPLE_ID_ASC",
  INSURER_USERS_STDDEV_SAMPLE_ID_DESC = "INSURER_USERS_STDDEV_SAMPLE_ID_DESC",
  INSURER_USERS_STDDEV_SAMPLE_INSURER_ID_ASC = "INSURER_USERS_STDDEV_SAMPLE_INSURER_ID_ASC",
  INSURER_USERS_STDDEV_SAMPLE_INSURER_ID_DESC = "INSURER_USERS_STDDEV_SAMPLE_INSURER_ID_DESC",
  INSURER_USERS_STDDEV_SAMPLE_UPDATED_AT_ASC = "INSURER_USERS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  INSURER_USERS_STDDEV_SAMPLE_UPDATED_AT_DESC = "INSURER_USERS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  INSURER_USERS_SUM_AUDITOR_USER_ID_ASC = "INSURER_USERS_SUM_AUDITOR_USER_ID_ASC",
  INSURER_USERS_SUM_AUDITOR_USER_ID_DESC = "INSURER_USERS_SUM_AUDITOR_USER_ID_DESC",
  INSURER_USERS_SUM_CREATED_AT_ASC = "INSURER_USERS_SUM_CREATED_AT_ASC",
  INSURER_USERS_SUM_CREATED_AT_DESC = "INSURER_USERS_SUM_CREATED_AT_DESC",
  INSURER_USERS_SUM_ID_ASC = "INSURER_USERS_SUM_ID_ASC",
  INSURER_USERS_SUM_ID_DESC = "INSURER_USERS_SUM_ID_DESC",
  INSURER_USERS_SUM_INSURER_ID_ASC = "INSURER_USERS_SUM_INSURER_ID_ASC",
  INSURER_USERS_SUM_INSURER_ID_DESC = "INSURER_USERS_SUM_INSURER_ID_DESC",
  INSURER_USERS_SUM_UPDATED_AT_ASC = "INSURER_USERS_SUM_UPDATED_AT_ASC",
  INSURER_USERS_SUM_UPDATED_AT_DESC = "INSURER_USERS_SUM_UPDATED_AT_DESC",
  INSURER_USERS_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "INSURER_USERS_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  INSURER_USERS_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "INSURER_USERS_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  INSURER_USERS_VARIANCE_POPULATION_CREATED_AT_ASC = "INSURER_USERS_VARIANCE_POPULATION_CREATED_AT_ASC",
  INSURER_USERS_VARIANCE_POPULATION_CREATED_AT_DESC = "INSURER_USERS_VARIANCE_POPULATION_CREATED_AT_DESC",
  INSURER_USERS_VARIANCE_POPULATION_ID_ASC = "INSURER_USERS_VARIANCE_POPULATION_ID_ASC",
  INSURER_USERS_VARIANCE_POPULATION_ID_DESC = "INSURER_USERS_VARIANCE_POPULATION_ID_DESC",
  INSURER_USERS_VARIANCE_POPULATION_INSURER_ID_ASC = "INSURER_USERS_VARIANCE_POPULATION_INSURER_ID_ASC",
  INSURER_USERS_VARIANCE_POPULATION_INSURER_ID_DESC = "INSURER_USERS_VARIANCE_POPULATION_INSURER_ID_DESC",
  INSURER_USERS_VARIANCE_POPULATION_UPDATED_AT_ASC = "INSURER_USERS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  INSURER_USERS_VARIANCE_POPULATION_UPDATED_AT_DESC = "INSURER_USERS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  INSURER_USERS_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "INSURER_USERS_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  INSURER_USERS_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "INSURER_USERS_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  INSURER_USERS_VARIANCE_SAMPLE_CREATED_AT_ASC = "INSURER_USERS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  INSURER_USERS_VARIANCE_SAMPLE_CREATED_AT_DESC = "INSURER_USERS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  INSURER_USERS_VARIANCE_SAMPLE_ID_ASC = "INSURER_USERS_VARIANCE_SAMPLE_ID_ASC",
  INSURER_USERS_VARIANCE_SAMPLE_ID_DESC = "INSURER_USERS_VARIANCE_SAMPLE_ID_DESC",
  INSURER_USERS_VARIANCE_SAMPLE_INSURER_ID_ASC = "INSURER_USERS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  INSURER_USERS_VARIANCE_SAMPLE_INSURER_ID_DESC = "INSURER_USERS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  INSURER_USERS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "INSURER_USERS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  INSURER_USERS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "INSURER_USERS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  INTERNAL_ONLY_ASC = "INTERNAL_ONLY_ASC",
  INTERNAL_ONLY_DESC = "INTERNAL_ONLY_DESC",
  LAST_NAME_ASC = "LAST_NAME_ASC",
  LAST_NAME_DESC = "LAST_NAME_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_AVERAGE_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_COUNT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_COUNT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_COUNT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_COUNT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_DISTINCT_COUNT_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MAX_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_MIN_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_POPULATION_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_STDDEV_SAMPLE_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_SUM_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_POPULATION_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_BY_ACTOR_USER_ID_VARIANCE_SAMPLE_ROLE_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_CREATED_AT_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_CREATED_AT_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_CREATED_AT_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_CREATED_AT_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_KIND_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_KIND_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_KIND_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_KIND_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_MESSAGE_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_MESSAGE_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_MESSAGE_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_MESSAGE_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_AVERAGE_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_COUNT_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_COUNT_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_COUNT_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_COUNT_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_CREATED_AT_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_CREATED_AT_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_KIND_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_KIND_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_KIND_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_KIND_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_MESSAGE_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_MESSAGE_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_MESSAGE_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_MESSAGE_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_DISTINCT_COUNT_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_CREATED_AT_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_CREATED_AT_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_CREATED_AT_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_CREATED_AT_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_KIND_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_KIND_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_KIND_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_KIND_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_MESSAGE_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_MESSAGE_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_MESSAGE_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_MESSAGE_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MAX_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_CREATED_AT_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_CREATED_AT_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_CREATED_AT_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_CREATED_AT_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_KIND_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_KIND_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_KIND_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_KIND_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_MESSAGE_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_MESSAGE_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_MESSAGE_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_MESSAGE_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_MIN_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_CREATED_AT_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_CREATED_AT_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_KIND_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_KIND_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_KIND_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_KIND_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_MESSAGE_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_MESSAGE_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_MESSAGE_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_MESSAGE_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_POPULATION_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_KIND_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_KIND_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_KIND_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_KIND_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_MESSAGE_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_MESSAGE_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_MESSAGE_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_MESSAGE_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_STDDEV_SAMPLE_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_CREATED_AT_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_CREATED_AT_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_CREATED_AT_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_CREATED_AT_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_KIND_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_KIND_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_KIND_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_KIND_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_MESSAGE_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_MESSAGE_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_MESSAGE_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_MESSAGE_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_SUM_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_KIND_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_KIND_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_KIND_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_KIND_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_MESSAGE_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_MESSAGE_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_MESSAGE_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_MESSAGE_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_POPULATION_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_KIND_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_KIND_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_KIND_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_KIND_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_MESSAGE_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_MESSAGE_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_MESSAGE_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_MESSAGE_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID_VARIANCE_SAMPLE_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID__COUNT_ASC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID__COUNT_ASC",
  MESSAGE_CREATEDS_BY_SENDER_USER_ID__COUNT_DESC = "MESSAGE_CREATEDS_BY_SENDER_USER_ID__COUNT_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_AVERAGE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_COUNT_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_COUNT_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_COUNT_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_COUNT_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MAX_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_MIN_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_SUM_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID__COUNT_ASC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID__COUNT_ASC",
  MESSAGE_SENTS_BY_RECIPIENT_USER_ID__COUNT_DESC = "MESSAGE_SENTS_BY_RECIPIENT_USER_ID__COUNT_DESC",
  MIGRATED_TO_FEDERATED_AT_ASC = "MIGRATED_TO_FEDERATED_AT_ASC",
  MIGRATED_TO_FEDERATED_AT_DESC = "MIGRATED_TO_FEDERATED_AT_DESC",
  NATURAL = "NATURAL",
  NN_IB_LINES_BY_AUTHOR_ID__COUNT_ASC = "NN_IB_LINES_BY_AUTHOR_ID__COUNT_ASC",
  NN_IB_LINES_BY_AUTHOR_ID__COUNT_DESC = "NN_IB_LINES_BY_AUTHOR_ID__COUNT_DESC",
  PRE_SSO_MIGRATION_IDP_SUB_ASC = "PRE_SSO_MIGRATION_IDP_SUB_ASC",
  PRE_SSO_MIGRATION_IDP_SUB_DESC = "PRE_SSO_MIGRATION_IDP_SUB_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__CITY_ASC = "PROVIDER_BY_PROVIDER_ID__CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__CITY_DESC = "PROVIDER_BY_PROVIDER_ID__CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC",
  PROVIDER_BY_PROVIDER_ID__ID_ASC = "PROVIDER_BY_PROVIDER_ID__ID_ASC",
  PROVIDER_BY_PROVIDER_ID__ID_DESC = "PROVIDER_BY_PROVIDER_ID__ID_DESC",
  PROVIDER_BY_PROVIDER_ID__NAME_ASC = "PROVIDER_BY_PROVIDER_ID__NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__NAME_DESC = "PROVIDER_BY_PROVIDER_ID__NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__NPI_ASC = "PROVIDER_BY_PROVIDER_ID__NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__NPI_DESC = "PROVIDER_BY_PROVIDER_ID__NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC",
  PROVIDER_BY_PROVIDER_ID__SPEC_ASC = "PROVIDER_BY_PROVIDER_ID__SPEC_ASC",
  PROVIDER_BY_PROVIDER_ID__SPEC_DESC = "PROVIDER_BY_PROVIDER_ID__SPEC_DESC",
  PROVIDER_BY_PROVIDER_ID__STATE_ASC = "PROVIDER_BY_PROVIDER_ID__STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__STATE_DESC = "PROVIDER_BY_PROVIDER_ID__STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC",
  PROVIDER_ID_ASC = "PROVIDER_ID_ASC",
  PROVIDER_ID_DESC = "PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_AVERAGE_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_AVERAGE_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_AVERAGE_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_AVERAGE_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_AVERAGE_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_AVERAGE_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_AVERAGE_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_AVERAGE_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_AVERAGE_ID_ASC = "PROVIDER_USER_FACILITIES_AVERAGE_ID_ASC",
  PROVIDER_USER_FACILITIES_AVERAGE_ID_DESC = "PROVIDER_USER_FACILITIES_AVERAGE_ID_DESC",
  PROVIDER_USER_FACILITIES_AVERAGE_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_AVERAGE_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_AVERAGE_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_AVERAGE_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_AVERAGE_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_AVERAGE_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_AVERAGE_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_AVERAGE_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_BY_AUDITOR_USER_ID__COUNT_ASC = "PROVIDER_USER_FACILITIES_BY_AUDITOR_USER_ID__COUNT_ASC",
  PROVIDER_USER_FACILITIES_BY_AUDITOR_USER_ID__COUNT_DESC = "PROVIDER_USER_FACILITIES_BY_AUDITOR_USER_ID__COUNT_DESC",
  PROVIDER_USER_FACILITIES_COUNT_ASC = "PROVIDER_USER_FACILITIES_COUNT_ASC",
  PROVIDER_USER_FACILITIES_COUNT_DESC = "PROVIDER_USER_FACILITIES_COUNT_DESC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_ID_ASC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_ID_ASC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_ID_DESC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_ID_DESC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_MAX_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_MAX_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_MAX_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_MAX_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_MAX_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_MAX_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_MAX_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_MAX_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_MAX_ID_ASC = "PROVIDER_USER_FACILITIES_MAX_ID_ASC",
  PROVIDER_USER_FACILITIES_MAX_ID_DESC = "PROVIDER_USER_FACILITIES_MAX_ID_DESC",
  PROVIDER_USER_FACILITIES_MAX_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_MAX_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_MAX_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_MAX_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_MAX_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_MAX_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_MAX_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_MAX_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_MIN_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_MIN_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_MIN_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_MIN_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_MIN_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_MIN_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_MIN_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_MIN_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_MIN_ID_ASC = "PROVIDER_USER_FACILITIES_MIN_ID_ASC",
  PROVIDER_USER_FACILITIES_MIN_ID_DESC = "PROVIDER_USER_FACILITIES_MIN_ID_DESC",
  PROVIDER_USER_FACILITIES_MIN_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_MIN_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_MIN_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_MIN_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_MIN_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_MIN_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_MIN_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_MIN_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_SUM_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_SUM_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_SUM_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_SUM_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_SUM_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_SUM_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_SUM_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_SUM_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_SUM_ID_ASC = "PROVIDER_USER_FACILITIES_SUM_ID_ASC",
  PROVIDER_USER_FACILITIES_SUM_ID_DESC = "PROVIDER_USER_FACILITIES_SUM_ID_DESC",
  PROVIDER_USER_FACILITIES_SUM_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_SUM_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_SUM_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_SUM_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_SUM_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_SUM_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_SUM_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_SUM_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_AVERAGE_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_COUNT_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_COUNT_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_COUNT_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_COUNT_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_DISTINCT_COUNT_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MAX_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_MIN_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_POPULATION_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_STDDEV_SAMPLE_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_SUM_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_POPULATION_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_ID_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY_VARIANCE_SAMPLE_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY__COUNT_ASC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY__COUNT_ASC",
  QA_CLAIM_STATE_ROWS_BY_CREATED_BY__COUNT_DESC = "QA_CLAIM_STATE_ROWS_BY_CREATED_BY__COUNT_DESC",
  QUEUES_BY_AUTHOR_ID__COUNT_ASC = "QUEUES_BY_AUTHOR_ID__COUNT_ASC",
  QUEUES_BY_AUTHOR_ID__COUNT_DESC = "QUEUES_BY_AUTHOR_ID__COUNT_DESC",
  READ_ONLY_ASC = "READ_ONLY_ASC",
  READ_ONLY_DESC = "READ_ONLY_DESC",
  REVIEWED_AUDIT_FINDINGS_BY_AUTHOR_ID__COUNT_ASC = "REVIEWED_AUDIT_FINDINGS_BY_AUTHOR_ID__COUNT_ASC",
  REVIEWED_AUDIT_FINDINGS_BY_AUTHOR_ID__COUNT_DESC = "REVIEWED_AUDIT_FINDINGS_BY_AUTHOR_ID__COUNT_DESC",
  TITLE_ASC = "TITLE_ASC",
  TITLE_DESC = "TITLE_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_AVERAGE_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_AVERAGE_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_AVERAGE_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_AVERAGE_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_AVERAGE_CREATED_AT_ASC = "USER_INVITE_CREATEDS_AVERAGE_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_AVERAGE_CREATED_AT_DESC = "USER_INVITE_CREATEDS_AVERAGE_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_AVERAGE_ID_ASC = "USER_INVITE_CREATEDS_AVERAGE_ID_ASC",
  USER_INVITE_CREATEDS_AVERAGE_ID_DESC = "USER_INVITE_CREATEDS_AVERAGE_ID_DESC",
  USER_INVITE_CREATEDS_AVERAGE_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_AVERAGE_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_AVERAGE_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_AVERAGE_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_AVERAGE_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_AVERAGE_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_AVERAGE_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_AVERAGE_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_AVERAGE_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_AVERAGE_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_AVERAGE_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_AVERAGE_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_AUDITOR_USER_ID__COUNT_ASC = "USER_INVITE_CREATEDS_BY_AUDITOR_USER_ID__COUNT_ASC",
  USER_INVITE_CREATEDS_BY_AUDITOR_USER_ID__COUNT_DESC = "USER_INVITE_CREATEDS_BY_AUDITOR_USER_ID__COUNT_DESC",
  USER_INVITE_CREATEDS_COUNT_ASC = "USER_INVITE_CREATEDS_COUNT_ASC",
  USER_INVITE_CREATEDS_COUNT_DESC = "USER_INVITE_CREATEDS_COUNT_DESC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_ID_ASC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_ID_ASC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_ID_DESC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_ID_DESC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_DISTINCT_COUNT_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_DISTINCT_COUNT_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_MAX_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_MAX_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_MAX_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_MAX_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_MAX_CREATED_AT_ASC = "USER_INVITE_CREATEDS_MAX_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_MAX_CREATED_AT_DESC = "USER_INVITE_CREATEDS_MAX_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_MAX_ID_ASC = "USER_INVITE_CREATEDS_MAX_ID_ASC",
  USER_INVITE_CREATEDS_MAX_ID_DESC = "USER_INVITE_CREATEDS_MAX_ID_DESC",
  USER_INVITE_CREATEDS_MAX_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_MAX_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_MAX_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_MAX_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_MAX_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_MAX_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_MAX_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_MAX_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_MAX_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_MAX_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_MAX_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_MAX_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_MIN_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_MIN_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_MIN_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_MIN_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_MIN_CREATED_AT_ASC = "USER_INVITE_CREATEDS_MIN_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_MIN_CREATED_AT_DESC = "USER_INVITE_CREATEDS_MIN_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_MIN_ID_ASC = "USER_INVITE_CREATEDS_MIN_ID_ASC",
  USER_INVITE_CREATEDS_MIN_ID_DESC = "USER_INVITE_CREATEDS_MIN_ID_DESC",
  USER_INVITE_CREATEDS_MIN_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_MIN_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_MIN_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_MIN_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_MIN_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_MIN_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_MIN_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_MIN_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_MIN_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_MIN_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_MIN_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_MIN_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_ID_ASC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_ID_ASC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_ID_DESC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_ID_DESC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_STDDEV_POPULATION_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_STDDEV_POPULATION_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_ID_ASC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_ID_ASC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_ID_DESC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_ID_DESC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_STDDEV_SAMPLE_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_SUM_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_SUM_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_SUM_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_SUM_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_SUM_CREATED_AT_ASC = "USER_INVITE_CREATEDS_SUM_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_SUM_CREATED_AT_DESC = "USER_INVITE_CREATEDS_SUM_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_SUM_ID_ASC = "USER_INVITE_CREATEDS_SUM_ID_ASC",
  USER_INVITE_CREATEDS_SUM_ID_DESC = "USER_INVITE_CREATEDS_SUM_ID_DESC",
  USER_INVITE_CREATEDS_SUM_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_SUM_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_SUM_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_SUM_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_SUM_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_SUM_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_SUM_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_SUM_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_SUM_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_SUM_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_SUM_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_SUM_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_ID_ASC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_ID_ASC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_ID_DESC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_ID_DESC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_VARIANCE_POPULATION_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_ID_ASC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_ID_ASC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_ID_DESC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_ID_DESC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  USER_TYPE_ASC = "USER_TYPE_ASC",
  USER_TYPE_DESC = "USER_TYPE_DESC",
}

export type Author = {
  __typename?: "Author";
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  lastName: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type Autodor = {
  __typename?: "Autodor";
  autodorFindings: Array<AutodorFinding>;
  claimId: Scalars["UUID"]["output"];
  sinks: Array<AutodorSink>;
};

export enum AutodorBillType {
  IB = "IB",
  UB = "UB",
}

export type AutodorFinding = {
  __typename?: "AutodorFinding";
  auditType: Scalars["String"]["output"];
  autodorMetadata: AutodorMetadata;
  claimId: Scalars["UUID"]["output"];
  createdAt: Scalars["String"]["output"];
  denialCode: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  ibLineId?: Maybe<Scalars["UUID"]["output"]>;
  ibLineVersionFingerprint?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  improperCharge: Scalars["Float"]["output"];
  improperUnits: Scalars["Int"]["output"];
  s3Key: Scalars["String"]["output"];
  seedType: SeedType;
  stale: Scalars["Boolean"]["output"];
  ubLineId?: Maybe<Scalars["UUID"]["output"]>;
};

export type AutodorMetadata = {
  __typename?: "AutodorMetadata";
  auditType: Scalars["String"]["output"];
  billType: AutodorBillType;
  dateOfServiceStart: Scalars["Date"]["output"];
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  procedureCode: Scalars["String"]["output"];
  procedureCodeModifier?: Maybe<Scalars["String"]["output"]>;
  quarter: Scalars["String"]["output"];
  rule: AuditRule;
  unitCharge: Scalars["Float"]["output"];
  units: Scalars["Int"]["output"];
  versionId: Scalars["UUID"]["output"];
  year: Scalars["String"]["output"];
};

export type AutodorSink = {
  __typename?: "AutodorSink";
  s3Key: Scalars["String"]["output"];
  timestamp: Scalars["String"]["output"];
};

/** Discriminator for v3.automation_author and v3.audit_finding.automation_kind: AGENT (workflow definition) or RULE (autodor-py rule). */
export enum AutomationKindEnum {
  AGENT = "AGENT",
  RULE = "RULE",
}

/** A filter to be used against AutomationKindEnum fields. All fields are combined with a logical ‘and.’ */
export type AutomationKindEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AutomationKindEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AutomationKindEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AutomationKindEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AutomationKindEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AutomationKindEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AutomationKindEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AutomationKindEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AutomationKindEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AutomationKindEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AutomationKindEnum>>;
};

/**
 * A registered rule or agent that can author SUGGESTED findings.
 * Written by the rules and agents services via upsertAutomationAuthor;
 * read live by every finding query to project createdBy.name.
 *
 * Named AutomationSource (not AutomationAuthor) so it doesn't collide
 * with the auto-generated PostGraphile type for v3.automation_author.
 * Uses AutomationKindEnum — the auto-generated enum from
 * v3.automation_kind_enum — as the single source of truth for AGENT/RULE
 * values across both auto-generated finding fields and hand-written
 * automation types.
 */
export type AutomationSource = {
  __typename?: "AutomationSource";
  createdAt: Scalars["Datetime"]["output"];
  deletedAt?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  kind: AutomationKindEnum;
  name: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

/**
 * Pointer to the automation (rule or agent) that authored a SUGGESTED
 * finding. The name is not carried on the input — it lives on the
 * automation_author registry and is projected live on read.
 */
export type AutomationSourceInput = {
  id: Scalars["UUID"]["input"];
  kind: AutomationKindEnum;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaim = Node & {
  __typename?: "BatchClaim";
  /**
   * UI hints for lifecycle matrix actions (same as claimActionPermissions query).
   * NOT authorization. Available to ADMINISTRATOR, AUDITOR, PAYER, and PROVIDER.
   */
  actionPermissions: ClaimActionPermissions;
  /** Reads and enables pagination through a set of `AuditorUser`. */
  activeAssignees: AuditorUsersConnection;
  /** Active blocker categories and their current stages (empty when none). */
  activeBlockers: Array<BatchClaimActiveBlocker>;
  /** Reads and enables pagination through a set of `ActiveClaimAssignee`. */
  activeClaimAssignees: ActiveClaimAssigneesConnection;
  admType?: Maybe<Scalars["String"]["output"]>;
  /**
   * ### admit_diag
   *  the admission diagnosis for this claim as provided by the client. These values are not validated against icd-9 or icd-10 codes.
   */
  admitDiag?: Maybe<Scalars["String"]["output"]>;
  amountCharged?: Maybe<Scalars["Float"]["output"]>;
  amountReimbursed?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Appealed flag. true = Appealed; null = empty/clear.
   * Prefer batchClaimStateById.appealed for list filter/sort.
   */
  appealed?: Maybe<Scalars["Boolean"]["output"]>;
  /** Optional APR-DRG (All Patient Refined Diagnosis Related Group) code for the batch claim. */
  aprDrg?: Maybe<Scalars["String"]["output"]>;
  auditDocumentation: Array<AuditDocumentation>;
  /** Reads and enables pagination through a set of `AuditFinding`. */
  auditFindings: AuditFindingsConnection;
  /** Reads a single `AuditorUser` that is related to this `BatchClaim`. */
  author?: Maybe<AuditorUser>;
  authorId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `BatchClaimAppealed` that is related to this `BatchClaim`. */
  batchClaimAppealed?: Maybe<BatchClaimAppealed>;
  /**
   * Reads and enables pagination through a set of `BatchClaimAppealed`.
   * @deprecated Please use batchClaimAppealed instead
   */
  batchClaimAppealeds: BatchClaimAppealedsConnection;
  /** Reads and enables pagination through a set of `BatchClaimAssignee`. */
  batchClaimAssignees: BatchClaimAssigneesConnection;
  /** Reads and enables pagination through a set of `BatchClaimAuditStartDate`. */
  batchClaimAuditStartDates: BatchClaimAuditStartDatesConnection;
  /** Reads a single `BatchClaimAuditType` that is related to this `BatchClaim`. */
  batchClaimAuditType?: Maybe<BatchClaimAuditType>;
  /**
   * Reads and enables pagination through a set of `BatchClaimAuditType`.
   * @deprecated Please use batchClaimAuditType instead
   */
  batchClaimAuditTypes: BatchClaimAuditTypesConnection;
  /** Reads and enables pagination through a set of `BatchClaimAuditor`. */
  batchClaimAuditors: BatchClaimAuditorsConnection;
  /** Reads and enables pagination through a set of `BatchClaimClientRecoveryAmount`. */
  batchClaimClientRecoveryAmounts: BatchClaimClientRecoveryAmountsConnection;
  /** Reads and enables pagination through a set of `BatchClaimClientRecoveryCollectionDate`. */
  batchClaimClientRecoveryCollectionDates: BatchClaimClientRecoveryCollectionDatesConnection;
  /** Reads and enables pagination through a set of `BatchClaimDocument`. */
  batchClaimDocuments: BatchClaimDocumentsConnection;
  /** Reads and enables pagination through a set of `BatchClaimDueDate`. */
  batchClaimDueDates: BatchClaimDueDatesConnection;
  /** Reads and enables pagination through a set of `BatchClaimLineItem`. */
  batchClaimLineItems: BatchClaimLineItemsConnection;
  /** Reads and enables pagination through a set of `BatchClaimLine`. */
  batchClaimLines: BatchClaimLinesConnection;
  /**
   * Reads and enables pagination through a set of `BatchClaimPayDeny`.
   * @deprecated Please use batchClaimPayDeny instead
   */
  batchClaimPayDenies: BatchClaimPayDeniesConnection;
  /** Reads a single `BatchClaimPayDeny` that is related to this `BatchClaim`. */
  batchClaimPayDeny?: Maybe<BatchClaimPayDeny>;
  /** Reads a single `BatchClaimState` that is related to this `BatchClaim`. */
  batchClaimStateById?: Maybe<BatchClaimState>;
  /**
   * Reads and enables pagination through a set of `BatchClaimState`.
   * @deprecated Please use batchClaimStateById instead
   */
  batchClaimStatesById: BatchClaimStatesConnection;
  /** Reads a single `BatchClaimTechDenial` that is related to this `BatchClaim`. */
  batchClaimTechDenial?: Maybe<BatchClaimTechDenial>;
  /**
   * Reads and enables pagination through a set of `BatchClaimTechDenial`.
   * @deprecated Please use batchClaimTechDenial instead
   */
  batchClaimTechDenials: BatchClaimTechDenialsConnection;
  /** Reads and enables pagination through a set of `BatchClaim`. */
  batchClaimsByPreviousVersionId: BatchClaimsConnection;
  /** Reads a single `BatchFile` that is related to this `BatchClaim`. */
  batchFile?: Maybe<BatchFile>;
  batchFileId: Scalars["UUID"]["output"];
  billType?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `BucketClaim` that is related to this `BatchClaim`. */
  bucketClaim?: Maybe<BucketClaim>;
  /**
   * Reads and enables pagination through a set of `BucketClaim`.
   * @deprecated Please use bucketClaim instead
   */
  bucketClaims: BucketClaimsConnection;
  claimAuditType?: Maybe<ClaimAuditType>;
  claimAuditor?: Maybe<AuditorUser>;
  /** Reads a single `ClaimFacet` that is related to this `BatchClaim`. */
  claimFacet?: Maybe<ClaimFacet>;
  /** Reads and enables pagination through a set of `ClaimFacetHistory`. */
  claimFacetHistories: ClaimFacetHistoriesConnection;
  /**
   * Reads and enables pagination through a set of `ClaimFacet`.
   * @deprecated Please use claimFacet instead
   */
  claimFacets: ClaimFacetsConnection;
  /** Reads and enables pagination through a set of `ClaimPolicyDocument`. */
  claimPolicyDocuments: ClaimPolicyDocumentsConnection;
  /**
   * Claim facets with human-readable slugs instead of UUIDs.
   * Facet keys and keyword values are resolved to slugs where possible.
   * Unknown/deleted facets or keywords remain as UUIDs for debugging.
   * Returns flat JSON object: { facet_slug: value, ... }
   * Compare with claimFacet.facets to see UUID-keyed version.
   */
  claimProperties?: Maybe<Scalars["JSON"]["output"]>;
  claimType?: Maybe<Scalars["String"]["output"]>;
  clientGroupName?: Maybe<Scalars["String"]["output"]>;
  /** Exact value supplied by client identifying the claim. */
  clientIcn?: Maybe<Scalars["String"]["output"]>;
  clientLineOfBusiness?: Maybe<Scalars["String"]["output"]>;
  clientPlanId?: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `ClientSignOffClaimState`. */
  clientSignOffClaimStates: ClientSignOffClaimStatesConnection;
  /**
   * Comments on this claim, newest-first. Hard-capped at 500 rows;
   * this is a guardrail, not a paging mechanism. Internal-only:
   * admins see comments on any claim; auditors see comments on claims
   * assigned to them; provider and payer roles have no grant on the
   * underlying table and will be rejected with permission denied.
   */
  comments: Array<BatchClaimComment>;
  computationStrategy: ClaimComputationStrategyKind;
  createdAt: Scalars["Datetime"]["output"];
  dateAdmit?: Maybe<Scalars["Datetime"]["output"]>;
  dateDischarge?: Maybe<Scalars["Datetime"]["output"]>;
  dateOfServiceEnd: Scalars["Datetime"]["output"];
  dateOfServiceStart: Scalars["Datetime"]["output"];
  diag1?: Maybe<Scalars["String"]["output"]>;
  diag2?: Maybe<Scalars["String"]["output"]>;
  diag3?: Maybe<Scalars["String"]["output"]>;
  diag4?: Maybe<Scalars["String"]["output"]>;
  diag5?: Maybe<Scalars["String"]["output"]>;
  diag6?: Maybe<Scalars["String"]["output"]>;
  diag7?: Maybe<Scalars["String"]["output"]>;
  diag8?: Maybe<Scalars["String"]["output"]>;
  diag9?: Maybe<Scalars["String"]["output"]>;
  diag10?: Maybe<Scalars["String"]["output"]>;
  diag11?: Maybe<Scalars["String"]["output"]>;
  diag12?: Maybe<Scalars["String"]["output"]>;
  diag13?: Maybe<Scalars["String"]["output"]>;
  diag14?: Maybe<Scalars["String"]["output"]>;
  diag15?: Maybe<Scalars["String"]["output"]>;
  diag16?: Maybe<Scalars["String"]["output"]>;
  diag17?: Maybe<Scalars["String"]["output"]>;
  diag18?: Maybe<Scalars["String"]["output"]>;
  diag19?: Maybe<Scalars["String"]["output"]>;
  diag20?: Maybe<Scalars["String"]["output"]>;
  diag21?: Maybe<Scalars["String"]["output"]>;
  diag22?: Maybe<Scalars["String"]["output"]>;
  diag23?: Maybe<Scalars["String"]["output"]>;
  diag24?: Maybe<Scalars["String"]["output"]>;
  /** Optional discharge status for the batch claim. */
  dischargeStatus?: Maybe<Scalars["String"]["output"]>;
  /**
   * Disputed flag (derived from disputedFindingClaimState).
   * true = Disputed; null = empty/clear (NOT_DISPUTED).
   * Prefer batchClaimStateById.disputedFindingClaimState for list filter/sort.
   */
  disputed?: Maybe<Scalars["Boolean"]["output"]>;
  /** Reads and enables pagination through a set of `DisputedFinding`. */
  disputedFindings: DisputedFindingsConnection;
  /**
   *    Sort order of the Document blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the document facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the document facet is absent. Matches documentBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  documentBlockerStageSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /** Reads and enables pagination through a set of `DocumentRequestCreated`. */
  documentRequestCreateds: DocumentRequestCreatedsConnection;
  /** Reads and enables pagination through a set of `DocumentUploadCreated`. */
  documentUploadCreateds: DocumentUploadCreatedsConnection;
  /** Reads and enables pagination through a set of `DocumentationClaimState`. */
  documentationClaimStates: DocumentationClaimStatesConnection;
  /**
   * ### drg_code
   *  the drg code for this claim as provided by the client. These values are not validated.
   */
  drgCode?: Maybe<Scalars["String"]["output"]>;
  eventHistoryTimeline: HistoryTimelineEvents;
  icn: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /** Reads a single `Insurer` that is related to this `BatchClaim`. */
  insurer?: Maybe<Insurer>;
  insurerId: Scalars["UUID"]["output"];
  /** Reads and enables pagination through a set of `InvoiceClaimState`. */
  invoiceClaimStates: InvoiceClaimStatesConnection;
  /**
   * ### Overview
   * Determines if the querying user is assigned to a particular claim. Used on the auditor role for the claimIsAssignedToUserFilter filter in the UI
   */
  isAssignedToQueryingUser?: Maybe<Scalars["Boolean"]["output"]>;
  itemizedBill?: Maybe<ItemizedBill>;
  /**
   *    Returns hierarchical sort position (phase * 1000 + stage sort order).
   *    Enables efficient lifecycle progression sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: LIFECYCLE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  lifecycleSortOrder?: Maybe<Scalars["Int"]["output"]>;
  negotiationClaimState?: Maybe<NegotiationClaimStateEnum>;
  /** Reads and enables pagination through a set of `NegotiationClaimState`. */
  negotiationClaimStates: NegotiationClaimStatesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /**
   *    Sort order of the On Hold blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the on_hold facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the on_hold facet is absent. Matches onHoldBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  onHoldBlockerStageSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /**
   * ### Overview
   * Indicates if the given batch claim is on hold or not.
   */
  onHoldClaimState?: Maybe<OnHoldClaimStateEnum>;
  /** Reads and enables pagination through a set of `OnHoldClaimState`. */
  onHoldClaimStates: OnHoldClaimStatesConnection;
  ownerId?: Maybe<Scalars["UUID"]["output"]>;
  paidDate?: Maybe<Scalars["Datetime"]["output"]>;
  /** Reads a single `PatientDatum` that is related to this `BatchClaim`. */
  patient?: Maybe<PatientDatum>;
  /** Optional patient control number for the batch claim. */
  patientControlNumber?: Maybe<Scalars["String"]["output"]>;
  patientDob?: Maybe<Scalars["Datetime"]["output"]>;
  /** Patient gender (M/F) sourced from MedStar member records at claim ingest. Nullable; older rows are populated via the ALA-2186 backfill script from historical MedStar feeds. */
  patientGender?: Maybe<Scalars["String"]["output"]>;
  patientId?: Maybe<Scalars["UUID"]["output"]>;
  payDeny?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * # Overview
   * Calculates the payment rate at the batch claim level.
   * The `amount_reimbursed` at the batch claim level reflects the actual amount the payer pays on the claim bill.
   * The `amount_charged` at the batch claim level is the full amount billed on the claim bill.
   * The ratio of these two things is the fraction of the total bill the payer actually pays, also known as the payment rate.Note: today it is impossible for us to have the equivalent concept of payment rate at the batch claim line level or at the batch claim line item level, though accurate calculations for either would improve the accuracy of our own calculations
   */
  paymentRate: Scalars["Float"]["output"];
  /**
   * Capability slugs the current user is permitted on THIS
   * specific claim. Slugs are dot-less (namespace is implied by
   * this containing type). Check membership with .includes():
   * e.g. permissions.includes("canTransitionStage").
   */
  permissions: Array<Scalars["String"]["output"]>;
  permittedInsurerUsers?: Maybe<Array<Maybe<Scalars["UUID"]["output"]>>>;
  /**
   *    Returns phase sort order (1=intake, 2=audit, etc.).
   *    Enables efficient phase-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: PHASE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  phaseSortOrder?: Maybe<Scalars["Int"]["output"]>;
  poa1?: Maybe<Scalars["String"]["output"]>;
  poa2?: Maybe<Scalars["String"]["output"]>;
  poa3?: Maybe<Scalars["String"]["output"]>;
  poa4?: Maybe<Scalars["String"]["output"]>;
  poa5?: Maybe<Scalars["String"]["output"]>;
  poa6?: Maybe<Scalars["String"]["output"]>;
  poa7?: Maybe<Scalars["String"]["output"]>;
  poa8?: Maybe<Scalars["String"]["output"]>;
  poa9?: Maybe<Scalars["String"]["output"]>;
  poa10?: Maybe<Scalars["String"]["output"]>;
  poa11?: Maybe<Scalars["String"]["output"]>;
  poa12?: Maybe<Scalars["String"]["output"]>;
  poa13?: Maybe<Scalars["String"]["output"]>;
  poa14?: Maybe<Scalars["String"]["output"]>;
  poa15?: Maybe<Scalars["String"]["output"]>;
  poa16?: Maybe<Scalars["String"]["output"]>;
  poa17?: Maybe<Scalars["String"]["output"]>;
  poa18?: Maybe<Scalars["String"]["output"]>;
  poa19?: Maybe<Scalars["String"]["output"]>;
  poa20?: Maybe<Scalars["String"]["output"]>;
  poa21?: Maybe<Scalars["String"]["output"]>;
  poa22?: Maybe<Scalars["String"]["output"]>;
  poa23?: Maybe<Scalars["String"]["output"]>;
  poa24?: Maybe<Scalars["String"]["output"]>;
  poa25?: Maybe<Scalars["String"]["output"]>;
  prepayDeny?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaim`. */
  previousVersion?: Maybe<BatchClaim>;
  /** A FK to the previous version of this claim.  Null if this is the first version. */
  previousVersionId?: Maybe<Scalars["UUID"]["output"]>;
  /**
   * The document currently designated as the primary medical record for
   * this claim, or null if none has been designated. At most one document
   * per claim can hold this designation (enforced by partial unique index
   * on v3.batch_claim_document.is_primary_medical_record).
   */
  primaryMedicalRecord?: Maybe<File>;
  principalDiag?: Maybe<Scalars["String"]["output"]>;
  principalPoa?: Maybe<Scalars["String"]["output"]>;
  principalProcedureCode?: Maybe<Scalars["String"]["output"]>;
  procedureCode1?: Maybe<Scalars["String"]["output"]>;
  procedureCode2?: Maybe<Scalars["String"]["output"]>;
  procedureCode3?: Maybe<Scalars["String"]["output"]>;
  procedureCode4?: Maybe<Scalars["String"]["output"]>;
  procedureCode5?: Maybe<Scalars["String"]["output"]>;
  procedureCode6?: Maybe<Scalars["String"]["output"]>;
  procedureCode7?: Maybe<Scalars["String"]["output"]>;
  procedureCode8?: Maybe<Scalars["String"]["output"]>;
  procedureCode9?: Maybe<Scalars["String"]["output"]>;
  procedureCode10?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Provider` that is related to this `BatchClaim`. */
  provider?: Maybe<Provider>;
  providerId: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `ProviderSignOffClaimState`. */
  providerSignOffClaimStates: ProviderSignOffClaimStatesConnection;
  /** Reads and enables pagination through a set of `QaClaimStateRow`. */
  qaClaimStateRows: QaClaimStateRowsConnection;
  /**
   * ### Overview
   * Identifies all the different audit finding reports that contain a specific batch claim.
   * This is the same as returning the report family that contains the given batch claim.
   */
  reportVersions: AuditFindingReportsConnection;
  /** Reads and enables pagination through a set of `ReportedClaim`. */
  reportedClaimsByClaimId: ReportedClaimsConnection;
  roleAssignments: ClaimRoleAssignments;
  /** Reads and enables pagination through a set of `S3AuditDocumentation`. */
  s3AuditDocumentations: S3AuditDocumentationsConnection;
  /**
   *    Returns stage sort order within phase (1, 2, 3, etc.).
   *    Enables efficient stage-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: STAGE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  stageSortOrder?: Maybe<Scalars["Int"]["output"]>;
  stageTracker: StageTracker;
  /** DRG code submitted by the facility on the original claim, prior to payer adjudication. Distinct from drg_code, which stores the DRG the payer ultimately paid (may differ if the facility is on a different DRG grouper version). Initial source: Horizon monthly claims report (MDRG column). Nullable for feeds that do not supply it. */
  submittedDrg?: Maybe<Scalars["String"]["output"]>;
  supportingDocumentation: SupportingDocumentation;
  /**
   * Tech Denial flag. true = Tech Denied; null = empty/clear.
   * Prefer batchClaimStateById.techDenied for list filter/sort.
   */
  techDenied?: Maybe<Scalars["Boolean"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
  /** Defaults to 1, and incremented each time the same client_icn for the same version_group is submitted and changes to the core data fields detected. */
  version?: Maybe<Scalars["Int"]["output"]>;
  /** An identifier for a group of claims that are related.  Either directly supplied by the client, or derived based on the clients method for relating claims as part of integration. */
  versionGroup?: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `WorkflowClaimState`. */
  workflowClaimStates: WorkflowClaimStatesConnection;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimactiveAssigneesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<AuditorUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimactiveClaimAssigneesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ActiveClaimAssigneeCondition>;
  filter?: InputMaybe<ActiveClaimAssigneeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ActiveClaimAssigneesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimauditFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingCondition>;
  filter?: InputMaybe<AuditFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimAppealedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAppealedCondition>;
  filter?: InputMaybe<BatchClaimAppealedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAppealedsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimAssigneesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAssigneeCondition>;
  filter?: InputMaybe<BatchClaimAssigneeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAssigneesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimAuditStartDatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAuditStartDateCondition>;
  filter?: InputMaybe<BatchClaimAuditStartDateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAuditStartDatesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimAuditTypesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAuditTypeCondition>;
  filter?: InputMaybe<BatchClaimAuditTypeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAuditTypesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimAuditorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAuditorCondition>;
  filter?: InputMaybe<BatchClaimAuditorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAuditorsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimClientRecoveryAmountsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimClientRecoveryAmountCondition>;
  filter?: InputMaybe<BatchClaimClientRecoveryAmountFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimClientRecoveryAmountsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimClientRecoveryCollectionDatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimClientRecoveryCollectionDateCondition>;
  filter?: InputMaybe<BatchClaimClientRecoveryCollectionDateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimClientRecoveryCollectionDatesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimDocumentsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimDocumentCondition>;
  filter?: InputMaybe<BatchClaimDocumentFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimDocumentsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimDueDatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimDueDateCondition>;
  filter?: InputMaybe<BatchClaimDueDateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimDueDatesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimLineItemsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemCondition>;
  filter?: InputMaybe<BatchClaimLineItemFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimLinesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineCondition>;
  filter?: InputMaybe<BatchClaimLineFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLinesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimPayDeniesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimPayDenyCondition>;
  filter?: InputMaybe<BatchClaimPayDenyFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimPayDeniesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimStatesByIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimStateCondition>;
  filter?: InputMaybe<BatchClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimStatesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimTechDenialsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimTechDenialCondition>;
  filter?: InputMaybe<BatchClaimTechDenialFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimTechDenialsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbatchClaimsByPreviousVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimCondition>;
  filter?: InputMaybe<BatchClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimbucketClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BucketClaimCondition>;
  filter?: InputMaybe<BucketClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BucketClaimsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimclaimFacetHistoriesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimFacetHistoryCondition>;
  filter?: InputMaybe<ClaimFacetHistoryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimFacetHistoriesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimclaimFacetsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimFacetCondition>;
  filter?: InputMaybe<ClaimFacetFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimFacetsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimclaimPolicyDocumentsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimPolicyDocumentCondition>;
  filter?: InputMaybe<ClaimPolicyDocumentFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimPolicyDocumentsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimclientSignOffClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClientSignOffClaimStateCondition>;
  filter?: InputMaybe<ClientSignOffClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClientSignOffClaimStatesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimdisputedFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DisputedFindingCondition>;
  filter?: InputMaybe<DisputedFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DisputedFindingsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimdocumentRequestCreatedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentRequestCreatedCondition>;
  filter?: InputMaybe<DocumentRequestCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentRequestCreatedsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimdocumentUploadCreatedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentUploadCreatedCondition>;
  filter?: InputMaybe<DocumentUploadCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentUploadCreatedsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimdocumentationClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentationClaimStateCondition>;
  filter?: InputMaybe<DocumentationClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentationClaimStatesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimeventHistoryTimelineArgs = {
  exclude?: InputMaybe<Array<EventHistoryExcludeType>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimimproperPaymentCostArgs = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaiminvoiceClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<InvoiceClaimStateCondition>;
  filter?: InputMaybe<InvoiceClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<InvoiceClaimStatesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimnegotiationClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<NegotiationClaimStateCondition>;
  filter?: InputMaybe<NegotiationClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<NegotiationClaimStatesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimonHoldClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<OnHoldClaimStateCondition>;
  filter?: InputMaybe<OnHoldClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<OnHoldClaimStatesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimproviderSignOffClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProviderSignOffClaimStateCondition>;
  filter?: InputMaybe<ProviderSignOffClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProviderSignOffClaimStatesOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimqaClaimStateRowsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<QaClaimStateRowCondition>;
  filter?: InputMaybe<QaClaimStateRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<QaClaimStateRowsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimreportVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<AuditFindingReportFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimreportedClaimsByClaimIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ReportedClaimCondition>;
  filter?: InputMaybe<ReportedClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ReportedClaimsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaims3AuditDocumentationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<S3AuditDocumentationCondition>;
  filter?: InputMaybe<S3AuditDocumentationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<S3AuditDocumentationsOrderBy>>;
};

/**
 * ### Overview
 * Holds metadata about the medical claims that we store in our platform.
 * Ingestion and ETL on audit documentation upstream leads to creation of entries into this table.
 * Our auditors identify audit findings during their audits, which each end up on either the batch_claim_line or batch_claim_line_item table and link back to a specific claim in this table.
 */
export type BatchClaimworkflowClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowClaimStateCondition>;
  filter?: InputMaybe<WorkflowClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowClaimStatesOrderBy>>;
};

/**
 * Active blocker on a claim: category type and current stage.
 * Lightweight alternative to stageTracker.blockers for claim list queries.
 */
export type BatchClaimActiveBlocker = {
  __typename?: "BatchClaimActiveBlocker";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  stage: BatchClaimActiveBlockerStage;
};

export type BatchClaimActiveBlockerStage = {
  __typename?: "BatchClaimActiveBlockerStage";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
};

export type BatchClaimAggregates = {
  __typename?: "BatchClaimAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BatchClaimAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BatchClaimMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BatchClaimMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BatchClaimStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BatchClaimStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BatchClaimSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BatchClaimVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BatchClaimVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BatchClaim` object types. */
export type BatchClaimAggregatesFilter = {
  /** Mean average aggregate over matching `BatchClaim` objects. */
  average?: InputMaybe<BatchClaimAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BatchClaim` objects. */
  distinctCount?: InputMaybe<BatchClaimDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaim` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimFilter>;
  /** Maximum aggregate over matching `BatchClaim` objects. */
  max?: InputMaybe<BatchClaimMaxAggregateFilter>;
  /** Minimum aggregate over matching `BatchClaim` objects. */
  min?: InputMaybe<BatchClaimMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BatchClaim` objects. */
  stddevPopulation?: InputMaybe<BatchClaimStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BatchClaim` objects. */
  stddevSample?: InputMaybe<BatchClaimStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BatchClaim` objects. */
  sum?: InputMaybe<BatchClaimSumAggregateFilter>;
  /** Population variance aggregate over matching `BatchClaim` objects. */
  variancePopulation?: InputMaybe<BatchClaimVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BatchClaim` objects. */
  varianceSample?: InputMaybe<BatchClaimVarianceSampleAggregateFilter>;
};

/**
 * ### Overview
 * Source of truth for Appealed on a claim. appealed = true means Appealed;
 * NULL (or no row) means empty/clear. Cached on v3.batch_claim_state.appealed for
 * claims-list filter/sort. Written via setClaimAppealed.
 */
export type BatchClaimAppealed = Node & {
  __typename?: "BatchClaimAppealed";
  appealed?: Maybe<Scalars["Boolean"]["output"]>;
  /** Reads a single `AuditorUser` that is related to this `BatchClaimAppealed`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAppealed`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  createdBy?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type BatchClaimAppealedAggregates = {
  __typename?: "BatchClaimAppealedAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimAppealedDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `BatchClaimAppealed` object types. */
export type BatchClaimAppealedAggregatesFilter = {
  /** Distinct count aggregate over matching `BatchClaimAppealed` objects. */
  distinctCount?: InputMaybe<BatchClaimAppealedDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimAppealed` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimAppealedFilter>;
};

/** The fields on `batchClaimAppealed` to look up the row to connect. */
export type BatchClaimAppealedBatchClaimAppealedBatchClaimIdKeyConnect = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The fields on `batchClaimAppealed` to look up the row to delete. */
export type BatchClaimAppealedBatchClaimAppealedBatchClaimIdKeyDelete = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The fields on `batchClaimAppealed` to look up the row to connect. */
export type BatchClaimAppealedBatchClaimAppealedPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `batchClaimAppealed` to look up the row to delete. */
export type BatchClaimAppealedBatchClaimAppealedPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** The `batchClaimAppealed` to be created by this mutation. */
export type BatchClaimAppealedBatchClaimIdFkeyBatchClaimAppealedCreateInput = {
  appealed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToCreatedBy?: InputMaybe<BatchClaimAppealedCreatedByFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `batchClaim` in the `BatchClaimAppealedInput` mutation. */
export type BatchClaimAppealedBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimAppealed` in the `BatchClaimInput` mutation. */
export type BatchClaimAppealedBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  connectByBatchClaimId?: InputMaybe<BatchClaimAppealedBatchClaimAppealedBatchClaimIdKeyConnect>;
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimAppealedBatchClaimAppealedPkeyConnect>;
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimAppealedNodeIdConnect>;
  /** A `BatchClaimAppealedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimAppealedBatchClaimIdFkeyBatchClaimAppealedCreateInput>
  >;
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  deleteByBatchClaimId?: InputMaybe<BatchClaimAppealedBatchClaimAppealedBatchClaimIdKeyDelete>;
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  deleteById?: InputMaybe<BatchClaimAppealedBatchClaimAppealedPkeyDelete>;
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<BatchClaimAppealedNodeIdDelete>;
  /** Flag indicating whether all other `batchClaimAppealed` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `batchClaimAppealed` for the far side of the relationship. */
  updateByBatchClaimId?: InputMaybe<BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyUsingBatchClaimAppealedBatchClaimIdKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimAppealed` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyUsingBatchClaimAppealedPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimAppealed` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyNodeIdUpdate>;
};

/**
 * A condition to be used against `BatchClaimAppealed` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimAppealedCondition = {
  /** Checks for equality with the object’s `appealed` field. */
  appealed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The `batchClaimAppealed` to be created by this mutation. */
export type BatchClaimAppealedCreatedByFkeyBatchClaimAppealedCreateInput = {
  appealed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToCreatedBy?: InputMaybe<BatchClaimAppealedCreatedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `BatchClaimAppealedInput` mutation. */
export type BatchClaimAppealedCreatedByFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimAppealed` in the `AuditorUserInput` mutation. */
export type BatchClaimAppealedCreatedByFkeyInverseInput = {
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  connectByBatchClaimId?: InputMaybe<
    Array<BatchClaimAppealedBatchClaimAppealedBatchClaimIdKeyConnect>
  >;
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimAppealedBatchClaimAppealedPkeyConnect>
  >;
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimAppealedNodeIdConnect>>;
  /** A `BatchClaimAppealedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimAppealedCreatedByFkeyBatchClaimAppealedCreateInput>
  >;
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  deleteByBatchClaimId?: InputMaybe<
    Array<BatchClaimAppealedBatchClaimAppealedBatchClaimIdKeyDelete>
  >;
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<BatchClaimAppealedBatchClaimAppealedPkeyDelete>
  >;
  /** The primary key(s) for `batchClaimAppealed` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<BatchClaimAppealedNodeIdDelete>>;
  /** Flag indicating whether all other `batchClaimAppealed` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `batchClaimAppealed` for the far side of the relationship. */
  updateByBatchClaimId?: InputMaybe<
    Array<BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyUsingBatchClaimAppealedBatchClaimIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimAppealed` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyUsingBatchClaimAppealedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimAppealed` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyNodeIdUpdate>
  >;
};

export type BatchClaimAppealedDistinctCountAggregateFilter = {
  appealed?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  createdBy?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type BatchClaimAppealedDistinctCountAggregates = {
  __typename?: "BatchClaimAppealedDistinctCountAggregates";
  /** Distinct count of appealed across the matching connection */
  appealed?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimAppealed` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimAppealedFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimAppealedFilter>>;
  /** Filter by the object’s `appealed` field. */
  appealed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `auditorUserByCreatedBy` relation. */
  auditorUserByCreatedBy?: InputMaybe<AuditorUserFilter>;
  /** A related `auditorUserByCreatedBy` exists. */
  auditorUserByCreatedByExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimAppealedFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimAppealedFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BatchClaimAppealed` for usage during aggregation. */
export enum BatchClaimAppealedGroupBy {
  APPEALED = "APPEALED",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  CREATED_BY = "CREATED_BY",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type BatchClaimAppealedHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAppealedHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimAppealed` aggregates. */
export type BatchClaimAppealedHavingInput = {
  AND?: InputMaybe<Array<BatchClaimAppealedHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimAppealedHavingInput>>;
  average?: InputMaybe<BatchClaimAppealedHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimAppealedHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimAppealedHavingMaxInput>;
  min?: InputMaybe<BatchClaimAppealedHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimAppealedHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimAppealedHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimAppealedHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimAppealedHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimAppealedHavingVarianceSampleInput>;
};

export type BatchClaimAppealedHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAppealedHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAppealedHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAppealedHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAppealedHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAppealedHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAppealedHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimAppealed` */
export type BatchClaimAppealedInput = {
  appealed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToCreatedBy?: InputMaybe<BatchClaimAppealedCreatedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimAppealedNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimAppealed` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to delete. */
export type BatchClaimAppealedNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `batchClaimAppealed` to be deleted. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimAppealed` to look up the row to update. */
export type BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyUsingBatchClaimAppealedBatchClaimIdKeyUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAppealed` being updated. */
    patch: updateBatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaimAppealed` to look up the row to update. */
export type BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyUsingBatchClaimAppealedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAppealed` being updated. */
    patch: updateBatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `batchClaimAppealed` to look up the row to update. */
export type BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyUsingBatchClaimAppealedBatchClaimIdKeyUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAppealed` being updated. */
    patch: updateBatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyPatch;
  };

/** The fields on `batchClaimAppealed` to look up the row to update. */
export type BatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyUsingBatchClaimAppealedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAppealed` being updated. */
    patch: updateBatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyPatch;
  };

/** Represents an update to a `BatchClaimAppealed`. Fields that are set will be updated. */
export type BatchClaimAppealedPatch = {
  appealed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToCreatedBy?: InputMaybe<BatchClaimAppealedCreatedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** A connection to a list of `BatchClaimAppealed` values. */
export type BatchClaimAppealedsConnection = {
  __typename?: "BatchClaimAppealedsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimAppealedAggregates>;
  /** A list of edges which contains the `BatchClaimAppealed` and cursor to aid in pagination. */
  edges: Array<BatchClaimAppealedsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimAppealedAggregates>>;
  /** A list of `BatchClaimAppealed` objects. */
  nodes: Array<Maybe<BatchClaimAppealed>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimAppealed` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimAppealed` values. */
export type BatchClaimAppealedsConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimAppealedGroupBy>;
  having?: InputMaybe<BatchClaimAppealedHavingInput>;
};

/** A `BatchClaimAppealed` edge in the connection. */
export type BatchClaimAppealedsEdge = {
  __typename?: "BatchClaimAppealedsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimAppealed` at the end of the edge. */
  node?: Maybe<BatchClaimAppealed>;
};

/** Methods to use when ordering `BatchClaimAppealed`. */
export enum BatchClaimAppealedsOrderBy {
  APPEALED_ASC = "APPEALED_ASC",
  APPEALED_DESC = "APPEALED_DESC",
  AUDITOR_USER_BY_CREATED_BY__CREATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__CREATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__CREATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__CREATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__EMAIL_ASC = "AUDITOR_USER_BY_CREATED_BY__EMAIL_ASC",
  AUDITOR_USER_BY_CREATED_BY__EMAIL_DESC = "AUDITOR_USER_BY_CREATED_BY__EMAIL_DESC",
  AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_ASC = "AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_ASC",
  AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_DESC = "AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_DESC",
  AUDITOR_USER_BY_CREATED_BY__IDP_SUB_ASC = "AUDITOR_USER_BY_CREATED_BY__IDP_SUB_ASC",
  AUDITOR_USER_BY_CREATED_BY__IDP_SUB_DESC = "AUDITOR_USER_BY_CREATED_BY__IDP_SUB_DESC",
  AUDITOR_USER_BY_CREATED_BY__ID_ASC = "AUDITOR_USER_BY_CREATED_BY__ID_ASC",
  AUDITOR_USER_BY_CREATED_BY__ID_DESC = "AUDITOR_USER_BY_CREATED_BY__ID_DESC",
  AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_CREATED_BY__LAST_NAME_ASC = "AUDITOR_USER_BY_CREATED_BY__LAST_NAME_ASC",
  AUDITOR_USER_BY_CREATED_BY__LAST_NAME_DESC = "AUDITOR_USER_BY_CREATED_BY__LAST_NAME_DESC",
  AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_ASC = "AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_DESC = "AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_CREATED_BY__READ_ONLY_ASC = "AUDITOR_USER_BY_CREATED_BY__READ_ONLY_ASC",
  AUDITOR_USER_BY_CREATED_BY__READ_ONLY_DESC = "AUDITOR_USER_BY_CREATED_BY__READ_ONLY_DESC",
  AUDITOR_USER_BY_CREATED_BY__TITLE_ASC = "AUDITOR_USER_BY_CREATED_BY__TITLE_ASC",
  AUDITOR_USER_BY_CREATED_BY__TITLE_DESC = "AUDITOR_USER_BY_CREATED_BY__TITLE_DESC",
  AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__USER_TYPE_ASC = "AUDITOR_USER_BY_CREATED_BY__USER_TYPE_ASC",
  AUDITOR_USER_BY_CREATED_BY__USER_TYPE_DESC = "AUDITOR_USER_BY_CREATED_BY__USER_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  CREATED_BY_ASC = "CREATED_BY_ASC",
  CREATED_BY_DESC = "CREATED_BY_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type BatchClaimAssignee = Node & {
  __typename?: "BatchClaimAssignee";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimAssignee`. */
  auditorUser?: Maybe<AuditorUser>;
  auditorUserId: Scalars["UUID"]["output"];
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAssignee`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  unassigned: Scalars["Boolean"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type BatchClaimAssigneeAggregates = {
  __typename?: "BatchClaimAssigneeAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimAssigneeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `BatchClaimAssignee` object types. */
export type BatchClaimAssigneeAggregatesFilter = {
  /** Distinct count aggregate over matching `BatchClaimAssignee` objects. */
  distinctCount?: InputMaybe<BatchClaimAssigneeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimAssignee` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimAssigneeFilter>;
};

/** The `batchClaimAssignee` to be created by this mutation. */
export type BatchClaimAssigneeAuditorUserIdFkeyBatchClaimAssigneeCreateInput = {
  auditorUserToAuditorUserId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  unassigned?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `BatchClaimAssigneeInput` mutation. */
export type BatchClaimAssigneeAuditorUserIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimAssignee` in the `AuditorUserInput` mutation. */
export type BatchClaimAssigneeAuditorUserIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimAssignee` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimAssigneeBatchClaimAssigneePkeyConnect>
  >;
  /** The primary key(s) for `batchClaimAssignee` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimAssigneeNodeIdConnect>>;
  /** A `BatchClaimAssigneeInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimAssigneeAuditorUserIdFkeyBatchClaimAssigneeCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimAssignee` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyUsingBatchClaimAssigneePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimAssignee` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyNodeIdUpdate>
  >;
};

/** The fields on `batchClaimAssignee` to look up the row to connect. */
export type BatchClaimAssigneeBatchClaimAssigneePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The `batchClaimAssignee` to be created by this mutation. */
export type BatchClaimAssigneeBatchClaimIdFkeyBatchClaimAssigneeCreateInput = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  unassigned?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `batchClaim` in the `BatchClaimAssigneeInput` mutation. */
export type BatchClaimAssigneeBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimAssignee` in the `BatchClaimInput` mutation. */
export type BatchClaimAssigneeBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimAssignee` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimAssigneeBatchClaimAssigneePkeyConnect>
  >;
  /** The primary key(s) for `batchClaimAssignee` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimAssigneeNodeIdConnect>>;
  /** A `BatchClaimAssigneeInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimAssigneeBatchClaimIdFkeyBatchClaimAssigneeCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimAssignee` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyUsingBatchClaimAssigneePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimAssignee` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `BatchClaimAssignee` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimAssigneeCondition = {
  /** Checks for equality with the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `unassigned` field. */
  unassigned?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type BatchClaimAssigneeDistinctCountAggregateFilter = {
  auditorUserId?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  unassigned?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type BatchClaimAssigneeDistinctCountAggregates = {
  __typename?: "BatchClaimAssigneeDistinctCountAggregates";
  /** Distinct count of auditorUserId across the matching connection */
  auditorUserId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of unassigned across the matching connection */
  unassigned?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimAssignee` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimAssigneeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimAssigneeFilter>>;
  /** Filter by the object’s `auditorUser` relation. */
  auditorUser?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimAssigneeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimAssigneeFilter>>;
  /** Filter by the object’s `unassigned` field. */
  unassigned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BatchClaimAssignee` for usage during aggregation. */
export enum BatchClaimAssigneeGroupBy {
  AUDITOR_USER_ID = "AUDITOR_USER_ID",
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  UNASSIGNED = "UNASSIGNED",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type BatchClaimAssigneeHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAssigneeHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimAssignee` aggregates. */
export type BatchClaimAssigneeHavingInput = {
  AND?: InputMaybe<Array<BatchClaimAssigneeHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimAssigneeHavingInput>>;
  average?: InputMaybe<BatchClaimAssigneeHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimAssigneeHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimAssigneeHavingMaxInput>;
  min?: InputMaybe<BatchClaimAssigneeHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimAssigneeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimAssigneeHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimAssigneeHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimAssigneeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimAssigneeHavingVarianceSampleInput>;
};

export type BatchClaimAssigneeHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAssigneeHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAssigneeHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAssigneeHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAssigneeHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAssigneeHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAssigneeHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimAssignee` */
export type BatchClaimAssigneeInput = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  unassigned?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimAssigneeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimAssignee` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `batchClaimAssignee` to look up the row to update. */
export type BatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyUsingBatchClaimAssigneePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAssignee` being updated. */
    patch: updateBatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimAssignee` to look up the row to update. */
export type BatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyUsingBatchClaimAssigneePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAssignee` being updated. */
    patch: updateBatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimAssignee`. Fields that are set will be updated. */
export type BatchClaimAssigneePatch = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInput>;
};

/** A connection to a list of `BatchClaimAssignee` values. */
export type BatchClaimAssigneesConnection = {
  __typename?: "BatchClaimAssigneesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimAssigneeAggregates>;
  /** A list of edges which contains the `BatchClaimAssignee` and cursor to aid in pagination. */
  edges: Array<BatchClaimAssigneesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimAssigneeAggregates>>;
  /** A list of `BatchClaimAssignee` objects. */
  nodes: Array<Maybe<BatchClaimAssignee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimAssignee` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimAssignee` values. */
export type BatchClaimAssigneesConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimAssigneeGroupBy>;
  having?: InputMaybe<BatchClaimAssigneeHavingInput>;
};

/** A `BatchClaimAssignee` edge in the connection. */
export type BatchClaimAssigneesEdge = {
  __typename?: "BatchClaimAssigneesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimAssignee` at the end of the edge. */
  node?: Maybe<BatchClaimAssignee>;
};

/** Methods to use when ordering `BatchClaimAssignee`. */
export enum BatchClaimAssigneesOrderBy {
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC",
  AUDITOR_USER_ID_ASC = "AUDITOR_USER_ID_ASC",
  AUDITOR_USER_ID_DESC = "AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UNASSIGNED_ASC = "UNASSIGNED_ASC",
  UNASSIGNED_DESC = "UNASSIGNED_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type BatchClaimAuditStartDate = Node & {
  __typename?: "BatchClaimAuditStartDate";
  auditStartDate: Scalars["Datetime"]["output"];
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAuditStartDate`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  deleted: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

export type BatchClaimAuditStartDateAggregates = {
  __typename?: "BatchClaimAuditStartDateAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimAuditStartDateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `BatchClaimAuditStartDate` object types. */
export type BatchClaimAuditStartDateAggregatesFilter = {
  /** Distinct count aggregate over matching `BatchClaimAuditStartDate` objects. */
  distinctCount?: InputMaybe<BatchClaimAuditStartDateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimAuditStartDate` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimAuditStartDateFilter>;
};

/** The fields on `batchClaimAuditStartDate` to look up the row to connect. */
export type BatchClaimAuditStartDateBatchClaimAuditStartDatePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The `batchClaimAuditStartDate` to be created by this mutation. */
export type BatchClaimAuditStartDateBatchClaimIdFkeyBatchClaimAuditStartDateCreateInput =
  {
    auditStartDate: Scalars["Datetime"]["input"];
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `batchClaim` in the `BatchClaimAuditStartDateInput` mutation. */
export type BatchClaimAuditStartDateBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimAuditStartDateOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimAuditStartDate` in the `BatchClaimInput` mutation. */
export type BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimAuditStartDate` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimAuditStartDateBatchClaimAuditStartDatePkeyConnect>
  >;
  /** The primary key(s) for `batchClaimAuditStartDate` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimAuditStartDateNodeIdConnect>>;
  /** A `BatchClaimAuditStartDateInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimAuditStartDateBatchClaimIdFkeyBatchClaimAuditStartDateCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimAuditStartDate` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimAuditStartDateOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyUsingBatchClaimAuditStartDatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimAuditStartDate` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `BatchClaimAuditStartDate` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimAuditStartDateCondition = {
  /** Checks for equality with the object’s `auditStartDate` field. */
  auditStartDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimAuditStartDateDistinctCountAggregateFilter = {
  auditStartDate?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  deleted?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type BatchClaimAuditStartDateDistinctCountAggregates = {
  __typename?: "BatchClaimAuditStartDateDistinctCountAggregates";
  /** Distinct count of auditStartDate across the matching connection */
  auditStartDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of deleted across the matching connection */
  deleted?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimAuditStartDate` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimAuditStartDateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimAuditStartDateFilter>>;
  /** Filter by the object’s `auditStartDate` field. */
  auditStartDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimAuditStartDateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimAuditStartDateFilter>>;
};

/** Grouping methods for `BatchClaimAuditStartDate` for usage during aggregation. */
export enum BatchClaimAuditStartDateGroupBy {
  AUDIT_START_DATE = "AUDIT_START_DATE",
  AUDIT_START_DATE_TRUNCATED_TO_DAY = "AUDIT_START_DATE_TRUNCATED_TO_DAY",
  AUDIT_START_DATE_TRUNCATED_TO_HOUR = "AUDIT_START_DATE_TRUNCATED_TO_HOUR",
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DELETED = "DELETED",
}

export type BatchClaimAuditStartDateHavingAverageInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditStartDateHavingDistinctCountInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimAuditStartDate` aggregates. */
export type BatchClaimAuditStartDateHavingInput = {
  AND?: InputMaybe<Array<BatchClaimAuditStartDateHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimAuditStartDateHavingInput>>;
  average?: InputMaybe<BatchClaimAuditStartDateHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimAuditStartDateHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimAuditStartDateHavingMaxInput>;
  min?: InputMaybe<BatchClaimAuditStartDateHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimAuditStartDateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimAuditStartDateHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimAuditStartDateHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimAuditStartDateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimAuditStartDateHavingVarianceSampleInput>;
};

export type BatchClaimAuditStartDateHavingMaxInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditStartDateHavingMinInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditStartDateHavingStddevPopulationInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditStartDateHavingStddevSampleInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditStartDateHavingSumInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditStartDateHavingVariancePopulationInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditStartDateHavingVarianceSampleInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimAuditStartDate` */
export type BatchClaimAuditStartDateInput = {
  auditStartDate: Scalars["Datetime"]["input"];
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimAuditStartDateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimAuditStartDate` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimAuditStartDateOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimAuditStartDate` to look up the row to update. */
export type BatchClaimAuditStartDateOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyUsingBatchClaimAuditStartDatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAuditStartDate` being updated. */
    patch: updateBatchClaimAuditStartDateOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimAuditStartDate`. Fields that are set will be updated. */
export type BatchClaimAuditStartDatePatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInput>;
};

/** A connection to a list of `BatchClaimAuditStartDate` values. */
export type BatchClaimAuditStartDatesConnection = {
  __typename?: "BatchClaimAuditStartDatesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimAuditStartDateAggregates>;
  /** A list of edges which contains the `BatchClaimAuditStartDate` and cursor to aid in pagination. */
  edges: Array<BatchClaimAuditStartDatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimAuditStartDateAggregates>>;
  /** A list of `BatchClaimAuditStartDate` objects. */
  nodes: Array<Maybe<BatchClaimAuditStartDate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimAuditStartDate` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimAuditStartDate` values. */
export type BatchClaimAuditStartDatesConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimAuditStartDateGroupBy>;
  having?: InputMaybe<BatchClaimAuditStartDateHavingInput>;
};

/** A `BatchClaimAuditStartDate` edge in the connection. */
export type BatchClaimAuditStartDatesEdge = {
  __typename?: "BatchClaimAuditStartDatesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimAuditStartDate` at the end of the edge. */
  node?: Maybe<BatchClaimAuditStartDate>;
};

/** Methods to use when ordering `BatchClaimAuditStartDate`. */
export enum BatchClaimAuditStartDatesOrderBy {
  AUDIT_START_DATE_ASC = "AUDIT_START_DATE_ASC",
  AUDIT_START_DATE_DESC = "AUDIT_START_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DELETED_ASC = "DELETED_ASC",
  DELETED_DESC = "DELETED_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

export type BatchClaimAuditType = Node & {
  __typename?: "BatchClaimAuditType";
  auditType?: Maybe<ClaimAuditType>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAuditType`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type BatchClaimAuditTypeAggregates = {
  __typename?: "BatchClaimAuditTypeAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimAuditTypeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** The fields on `batchClaimAuditType` to look up the row to connect. */
export type BatchClaimAuditTypeBatchClaimAuditTypeBatchClaimIdKeyConnect = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The fields on `batchClaimAuditType` to look up the row to connect. */
export type BatchClaimAuditTypeBatchClaimAuditTypePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The `batchClaimAuditType` to be created by this mutation. */
export type BatchClaimAuditTypeBatchClaimIdFkeyBatchClaimAuditTypeCreateInput =
  {
    auditType?: InputMaybe<ClaimAuditType>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `batchClaim` in the `BatchClaimAuditTypeInput` mutation. */
export type BatchClaimAuditTypeBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimAuditTypeOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimAuditType` in the `BatchClaimInput` mutation. */
export type BatchClaimAuditTypeBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimAuditType` for the far side of the relationship. */
  connectByBatchClaimId?: InputMaybe<BatchClaimAuditTypeBatchClaimAuditTypeBatchClaimIdKeyConnect>;
  /** The primary key(s) for `batchClaimAuditType` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimAuditTypeBatchClaimAuditTypePkeyConnect>;
  /** The primary key(s) for `batchClaimAuditType` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimAuditTypeNodeIdConnect>;
  /** A `BatchClaimAuditTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimAuditTypeBatchClaimIdFkeyBatchClaimAuditTypeCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimAuditType` for the far side of the relationship. */
  updateByBatchClaimId?: InputMaybe<BatchClaimAuditTypeOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyUsingBatchClaimAuditTypeBatchClaimIdKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimAuditType` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimAuditTypeOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyUsingBatchClaimAuditTypePkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimAuditType` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyNodeIdUpdate>;
};

/**
 * A condition to be used against `BatchClaimAuditType` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimAuditTypeCondition = {
  /** Checks for equality with the object’s `auditType` field. */
  auditType?: InputMaybe<ClaimAuditType>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type BatchClaimAuditTypeDistinctCountAggregates = {
  __typename?: "BatchClaimAuditTypeDistinctCountAggregates";
  /** Distinct count of auditType across the matching connection */
  auditType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimAuditType` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimAuditTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimAuditTypeFilter>>;
  /** Filter by the object’s `auditType` field. */
  auditType?: InputMaybe<ClaimAuditTypeFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimAuditTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimAuditTypeFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BatchClaimAuditType` for usage during aggregation. */
export enum BatchClaimAuditTypeGroupBy {
  AUDIT_TYPE = "AUDIT_TYPE",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type BatchClaimAuditTypeHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditTypeHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimAuditType` aggregates. */
export type BatchClaimAuditTypeHavingInput = {
  AND?: InputMaybe<Array<BatchClaimAuditTypeHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimAuditTypeHavingInput>>;
  average?: InputMaybe<BatchClaimAuditTypeHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimAuditTypeHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimAuditTypeHavingMaxInput>;
  min?: InputMaybe<BatchClaimAuditTypeHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimAuditTypeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimAuditTypeHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimAuditTypeHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimAuditTypeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimAuditTypeHavingVarianceSampleInput>;
};

export type BatchClaimAuditTypeHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditTypeHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditTypeHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditTypeHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditTypeHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditTypeHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditTypeHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimAuditType` */
export type BatchClaimAuditTypeInput = {
  auditType?: InputMaybe<ClaimAuditType>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimAuditTypeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimAuditType` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimAuditTypeOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimAuditType` to look up the row to update. */
export type BatchClaimAuditTypeOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyUsingBatchClaimAuditTypeBatchClaimIdKeyUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAuditType` being updated. */
    patch: updateBatchClaimAuditTypeOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaimAuditType` to look up the row to update. */
export type BatchClaimAuditTypeOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyUsingBatchClaimAuditTypePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAuditType` being updated. */
    patch: updateBatchClaimAuditTypeOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimAuditType`. Fields that are set will be updated. */
export type BatchClaimAuditTypePatch = {
  auditType?: InputMaybe<ClaimAuditType>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** A connection to a list of `BatchClaimAuditType` values. */
export type BatchClaimAuditTypesConnection = {
  __typename?: "BatchClaimAuditTypesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimAuditTypeAggregates>;
  /** A list of edges which contains the `BatchClaimAuditType` and cursor to aid in pagination. */
  edges: Array<BatchClaimAuditTypesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimAuditTypeAggregates>>;
  /** A list of `BatchClaimAuditType` objects. */
  nodes: Array<Maybe<BatchClaimAuditType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimAuditType` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimAuditType` values. */
export type BatchClaimAuditTypesConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimAuditTypeGroupBy>;
  having?: InputMaybe<BatchClaimAuditTypeHavingInput>;
};

/** A `BatchClaimAuditType` edge in the connection. */
export type BatchClaimAuditTypesEdge = {
  __typename?: "BatchClaimAuditTypesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimAuditType` at the end of the edge. */
  node?: Maybe<BatchClaimAuditType>;
};

/** Methods to use when ordering `BatchClaimAuditType`. */
export enum BatchClaimAuditTypesOrderBy {
  AUDIT_TYPE_ASC = "AUDIT_TYPE_ASC",
  AUDIT_TYPE_DESC = "AUDIT_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type BatchClaimAuditor = Node & {
  __typename?: "BatchClaimAuditor";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimAuditor`. */
  auditorUser?: Maybe<AuditorUser>;
  auditorUserId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAuditor`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

export type BatchClaimAuditorAggregates = {
  __typename?: "BatchClaimAuditorAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimAuditorDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `BatchClaimAuditor` object types. */
export type BatchClaimAuditorAggregatesFilter = {
  /** Distinct count aggregate over matching `BatchClaimAuditor` objects. */
  distinctCount?: InputMaybe<BatchClaimAuditorDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimAuditor` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimAuditorFilter>;
};

/** The `batchClaimAuditor` to be created by this mutation. */
export type BatchClaimAuditorAuditorUserIdFkeyBatchClaimAuditorCreateInput = {
  auditorUserToAuditorUserId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `BatchClaimAuditorInput` mutation. */
export type BatchClaimAuditorAuditorUserIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimAuditor` in the `AuditorUserInput` mutation. */
export type BatchClaimAuditorAuditorUserIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimAuditor` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimAuditorBatchClaimAuditorPkeyConnect>
  >;
  /** The primary key(s) for `batchClaimAuditor` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimAuditorNodeIdConnect>>;
  /** A `BatchClaimAuditorInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimAuditorAuditorUserIdFkeyBatchClaimAuditorCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimAuditor` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyUsingBatchClaimAuditorPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimAuditor` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyNodeIdUpdate>
  >;
};

/** The fields on `batchClaimAuditor` to look up the row to connect. */
export type BatchClaimAuditorBatchClaimAuditorPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The `batchClaimAuditor` to be created by this mutation. */
export type BatchClaimAuditorBatchClaimIdFkeyBatchClaimAuditorCreateInput = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `batchClaim` in the `BatchClaimAuditorInput` mutation. */
export type BatchClaimAuditorBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimAuditor` in the `BatchClaimInput` mutation. */
export type BatchClaimAuditorBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimAuditor` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimAuditorBatchClaimAuditorPkeyConnect>
  >;
  /** The primary key(s) for `batchClaimAuditor` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimAuditorNodeIdConnect>>;
  /** A `BatchClaimAuditorInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimAuditorBatchClaimIdFkeyBatchClaimAuditorCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimAuditor` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyUsingBatchClaimAuditorPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimAuditor` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `BatchClaimAuditor` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimAuditorCondition = {
  /** Checks for equality with the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimAuditorDistinctCountAggregateFilter = {
  auditorUserId?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type BatchClaimAuditorDistinctCountAggregates = {
  __typename?: "BatchClaimAuditorDistinctCountAggregates";
  /** Distinct count of auditorUserId across the matching connection */
  auditorUserId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimAuditor` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimAuditorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimAuditorFilter>>;
  /** Filter by the object’s `auditorUser` relation. */
  auditorUser?: InputMaybe<AuditorUserFilter>;
  /** A related `auditorUser` exists. */
  auditorUserExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimAuditorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimAuditorFilter>>;
};

/** Grouping methods for `BatchClaimAuditor` for usage during aggregation. */
export enum BatchClaimAuditorGroupBy {
  AUDITOR_USER_ID = "AUDITOR_USER_ID",
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
}

export type BatchClaimAuditorHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditorHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimAuditor` aggregates. */
export type BatchClaimAuditorHavingInput = {
  AND?: InputMaybe<Array<BatchClaimAuditorHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimAuditorHavingInput>>;
  average?: InputMaybe<BatchClaimAuditorHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimAuditorHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimAuditorHavingMaxInput>;
  min?: InputMaybe<BatchClaimAuditorHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimAuditorHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimAuditorHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimAuditorHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimAuditorHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimAuditorHavingVarianceSampleInput>;
};

export type BatchClaimAuditorHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditorHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditorHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditorHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditorHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditorHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimAuditorHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimAuditor` */
export type BatchClaimAuditorInput = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimAuditorNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimAuditor` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `batchClaimAuditor` to look up the row to update. */
export type BatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyUsingBatchClaimAuditorPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAuditor` being updated. */
    patch: updateBatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimAuditor` to look up the row to update. */
export type BatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyUsingBatchClaimAuditorPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAuditor` being updated. */
    patch: updateBatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimAuditor`. Fields that are set will be updated. */
export type BatchClaimAuditorPatch = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInput>;
};

/** A connection to a list of `BatchClaimAuditor` values. */
export type BatchClaimAuditorsConnection = {
  __typename?: "BatchClaimAuditorsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimAuditorAggregates>;
  /** A list of edges which contains the `BatchClaimAuditor` and cursor to aid in pagination. */
  edges: Array<BatchClaimAuditorsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimAuditorAggregates>>;
  /** A list of `BatchClaimAuditor` objects. */
  nodes: Array<Maybe<BatchClaimAuditor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimAuditor` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimAuditor` values. */
export type BatchClaimAuditorsConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimAuditorGroupBy>;
  having?: InputMaybe<BatchClaimAuditorHavingInput>;
};

/** A `BatchClaimAuditor` edge in the connection. */
export type BatchClaimAuditorsEdge = {
  __typename?: "BatchClaimAuditorsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimAuditor` at the end of the edge. */
  node?: Maybe<BatchClaimAuditor>;
};

/** Methods to use when ordering `BatchClaimAuditor`. */
export enum BatchClaimAuditorsOrderBy {
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC",
  AUDITOR_USER_ID_ASC = "AUDITOR_USER_ID_ASC",
  AUDITOR_USER_ID_DESC = "AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

/** Input for the nested mutation of `auditorUser` in the `BatchClaimInput` mutation. */
export type BatchClaimAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaim` in the `AuditorUserInput` mutation. */
export type BatchClaimAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<Array<BatchClaimBatchClaimIcnKeyConnect>>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BatchClaimBatchClaimPkeyConnect>>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<
    Array<BatchClaimBatchClaimIdInsurerKeyConnect>
  >;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimNodeIdConnect>>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyUsingBatchClaimIcnKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyUsingBatchClaimPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyUsingBatchClaimIdInsurerKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyNodeIdUpdate>
  >;
};

export type BatchClaimAverageAggregateFilter = {
  amountCharged?: InputMaybe<FloatFilter>;
  amountReimbursed?: InputMaybe<FloatFilter>;
  documentBlockerStageSortOrder?: InputMaybe<IntFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  lifecycleSortOrder?: InputMaybe<IntFilter>;
  onHoldBlockerStageSortOrder?: InputMaybe<IntFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  phaseSortOrder?: InputMaybe<IntFilter>;
  stageSortOrder?: InputMaybe<IntFilter>;
  version?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimAverageAggregates = {
  __typename?: "BatchClaimAverageAggregates";
  /** Mean average of amountCharged across the matching connection */
  amountCharged?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of amountReimbursed across the matching connection */
  amountReimbursed?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the Document blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the document facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the document facet is absent. Matches documentBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  documentBlockerStageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   *    Returns hierarchical sort position (phase * 1000 + stage sort order).
   *    Enables efficient lifecycle progression sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: LIFECYCLE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  lifecycleSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the On Hold blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the on_hold facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the on_hold facet is absent. Matches onHoldBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  onHoldBlockerStageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   *    Returns phase sort order (1=intake, 2=audit, etc.).
   *    Enables efficient phase-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: PHASE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  phaseSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   *    Returns stage sort order within phase (1, 2, 3, etc.).
   *    Enables efficient stage-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: STAGE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  stageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of version across the matching connection */
  version?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type BatchClaimAverageAggregatesimproperPaymentCostArgs = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The fields on `batchClaim` to look up the row to connect. */
export type BatchClaimBatchClaimIcnKeyConnect = {
  icn: Scalars["String"]["input"];
};

/** The fields on `batchClaim` to look up the row to connect. */
export type BatchClaimBatchClaimIdInsurerKeyConnect = {
  id: Scalars["UUID"]["input"];
  insurerId: Scalars["UUID"]["input"];
};

/** The fields on `batchClaim` to look up the row to connect. */
export type BatchClaimBatchClaimPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `batchFile` in the `BatchClaimInput` mutation. */
export type BatchClaimBatchFileIdFkeyInput = {
  /** The primary key(s) for `batchFile` for the far side of the relationship. */
  connectById?: InputMaybe<BatchFileBatchFilePkeyConnect>;
  /** The primary key(s) for `batchFile` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchFileNodeIdConnect>;
  /** The primary key(s) and patch data for `batchFile` for the far side of the relationship. */
  updateById?: InputMaybe<BatchFileOnBatchClaimForBatchClaimBatchFileIdFkeyUsingBatchFilePkeyUpdate>;
  /** The primary key(s) and patch data for `batchFile` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaim` in the `BatchFileInput` mutation. */
export type BatchClaimBatchFileIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<Array<BatchClaimBatchClaimIcnKeyConnect>>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BatchClaimBatchClaimPkeyConnect>>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<
    Array<BatchClaimBatchClaimIdInsurerKeyConnect>
  >;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimNodeIdConnect>>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyUsingBatchClaimIcnKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyUsingBatchClaimPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyUsingBatchClaimIdInsurerKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchFileOnBatchClaimForBatchClaimBatchFileIdFkeyNodeIdUpdate>
  >;
};

/** History table tracking all changes to client recovery amounts for batch claims, including soft deletes. */
export type BatchClaimClientRecoveryAmount = Node & {
  __typename?: "BatchClaimClientRecoveryAmount";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimClientRecoveryAmount`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  /** Amount recovered by the client as invoiced savings for this claim */
  clientRecoveryAmount: Scalars["Float"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  /** When true, indicates this recovery amount has been cleared/removed */
  deleted: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

export type BatchClaimClientRecoveryAmountAggregates = {
  __typename?: "BatchClaimClientRecoveryAmountAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BatchClaimClientRecoveryAmountAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimClientRecoveryAmountDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BatchClaimClientRecoveryAmountMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BatchClaimClientRecoveryAmountMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BatchClaimClientRecoveryAmountStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BatchClaimClientRecoveryAmountStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BatchClaimClientRecoveryAmountSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BatchClaimClientRecoveryAmountVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BatchClaimClientRecoveryAmountVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BatchClaimClientRecoveryAmount` object types. */
export type BatchClaimClientRecoveryAmountAggregatesFilter = {
  /** Mean average aggregate over matching `BatchClaimClientRecoveryAmount` objects. */
  average?: InputMaybe<BatchClaimClientRecoveryAmountAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BatchClaimClientRecoveryAmount` objects. */
  distinctCount?: InputMaybe<BatchClaimClientRecoveryAmountDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimClientRecoveryAmount` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimClientRecoveryAmountFilter>;
  /** Maximum aggregate over matching `BatchClaimClientRecoveryAmount` objects. */
  max?: InputMaybe<BatchClaimClientRecoveryAmountMaxAggregateFilter>;
  /** Minimum aggregate over matching `BatchClaimClientRecoveryAmount` objects. */
  min?: InputMaybe<BatchClaimClientRecoveryAmountMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BatchClaimClientRecoveryAmount` objects. */
  stddevPopulation?: InputMaybe<BatchClaimClientRecoveryAmountStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BatchClaimClientRecoveryAmount` objects. */
  stddevSample?: InputMaybe<BatchClaimClientRecoveryAmountStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BatchClaimClientRecoveryAmount` objects. */
  sum?: InputMaybe<BatchClaimClientRecoveryAmountSumAggregateFilter>;
  /** Population variance aggregate over matching `BatchClaimClientRecoveryAmount` objects. */
  variancePopulation?: InputMaybe<BatchClaimClientRecoveryAmountVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BatchClaimClientRecoveryAmount` objects. */
  varianceSample?: InputMaybe<BatchClaimClientRecoveryAmountVarianceSampleAggregateFilter>;
};

export type BatchClaimClientRecoveryAmountAverageAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimClientRecoveryAmountAverageAggregates = {
  __typename?: "BatchClaimClientRecoveryAmountAverageAggregates";
  /** Mean average of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
};

/** The fields on `batchClaimClientRecoveryAmount` to look up the row to connect. */
export type BatchClaimClientRecoveryAmountBatchClaimClientRecoveryAmountPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** The `batchClaimClientRecoveryAmount` to be created by this mutation. */
export type BatchClaimClientRecoveryAmountBatchClaimIdFkeyBatchClaimClientRecoveryAmountCreateInput =
  {
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInput>;
    /** Amount recovered by the client as invoiced savings for this claim */
    clientRecoveryAmount: Scalars["Float"]["input"];
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    /** When true, indicates this recovery amount has been cleared/removed */
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `batchClaim` in the `BatchClaimClientRecoveryAmountInput` mutation. */
export type BatchClaimClientRecoveryAmountBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimClientRecoveryAmountOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimClientRecoveryAmount` in the `BatchClaimInput` mutation. */
export type BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimClientRecoveryAmount` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimClientRecoveryAmountBatchClaimClientRecoveryAmountPkeyConnect>
  >;
  /** The primary key(s) for `batchClaimClientRecoveryAmount` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<
    Array<BatchClaimClientRecoveryAmountNodeIdConnect>
  >;
  /** A `BatchClaimClientRecoveryAmountInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimClientRecoveryAmountBatchClaimIdFkeyBatchClaimClientRecoveryAmountCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimClientRecoveryAmount` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimClientRecoveryAmountOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyUsingBatchClaimClientRecoveryAmountPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimClientRecoveryAmount` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `BatchClaimClientRecoveryAmount` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimClientRecoveryAmountCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `clientRecoveryAmount` field. */
  clientRecoveryAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimClientRecoveryAmountDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  clientRecoveryAmount?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  deleted?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type BatchClaimClientRecoveryAmountDistinctCountAggregates = {
  __typename?: "BatchClaimClientRecoveryAmountDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of deleted across the matching connection */
  deleted?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimClientRecoveryAmount` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimClientRecoveryAmountFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimClientRecoveryAmountFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `clientRecoveryAmount` field. */
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimClientRecoveryAmountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimClientRecoveryAmountFilter>>;
};

/** Grouping methods for `BatchClaimClientRecoveryAmount` for usage during aggregation. */
export enum BatchClaimClientRecoveryAmountGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CLIENT_RECOVERY_AMOUNT = "CLIENT_RECOVERY_AMOUNT",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DELETED = "DELETED",
}

export type BatchClaimClientRecoveryAmountHavingAverageInput = {
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryAmountHavingDistinctCountInput = {
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimClientRecoveryAmount` aggregates. */
export type BatchClaimClientRecoveryAmountHavingInput = {
  AND?: InputMaybe<Array<BatchClaimClientRecoveryAmountHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimClientRecoveryAmountHavingInput>>;
  average?: InputMaybe<BatchClaimClientRecoveryAmountHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimClientRecoveryAmountHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimClientRecoveryAmountHavingMaxInput>;
  min?: InputMaybe<BatchClaimClientRecoveryAmountHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimClientRecoveryAmountHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimClientRecoveryAmountHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimClientRecoveryAmountHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimClientRecoveryAmountHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimClientRecoveryAmountHavingVarianceSampleInput>;
};

export type BatchClaimClientRecoveryAmountHavingMaxInput = {
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryAmountHavingMinInput = {
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryAmountHavingStddevPopulationInput = {
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryAmountHavingStddevSampleInput = {
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryAmountHavingSumInput = {
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryAmountHavingVariancePopulationInput = {
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryAmountHavingVarianceSampleInput = {
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimClientRecoveryAmount` */
export type BatchClaimClientRecoveryAmountInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInput>;
  /** Amount recovered by the client as invoiced savings for this claim */
  clientRecoveryAmount: Scalars["Float"]["input"];
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** When true, indicates this recovery amount has been cleared/removed */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimClientRecoveryAmountMaxAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimClientRecoveryAmountMaxAggregates = {
  __typename?: "BatchClaimClientRecoveryAmountMaxAggregates";
  /** Maximum of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimClientRecoveryAmountMinAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimClientRecoveryAmountMinAggregates = {
  __typename?: "BatchClaimClientRecoveryAmountMinAggregates";
  /** Minimum of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimClientRecoveryAmountNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimClientRecoveryAmount` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimClientRecoveryAmountOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimClientRecoveryAmount` to look up the row to update. */
export type BatchClaimClientRecoveryAmountOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyUsingBatchClaimClientRecoveryAmountPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimClientRecoveryAmount` being updated. */
    patch: updateBatchClaimClientRecoveryAmountOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimClientRecoveryAmount`. Fields that are set will be updated. */
export type BatchClaimClientRecoveryAmountPatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInput>;
};

export type BatchClaimClientRecoveryAmountStddevPopulationAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimClientRecoveryAmountStddevPopulationAggregates = {
  __typename?: "BatchClaimClientRecoveryAmountStddevPopulationAggregates";
  /** Population standard deviation of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimClientRecoveryAmountStddevSampleAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimClientRecoveryAmountStddevSampleAggregates = {
  __typename?: "BatchClaimClientRecoveryAmountStddevSampleAggregates";
  /** Sample standard deviation of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimClientRecoveryAmountSumAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimClientRecoveryAmountSumAggregates = {
  __typename?: "BatchClaimClientRecoveryAmountSumAggregates";
  /** Sum of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount: Scalars["Float"]["output"];
};

export type BatchClaimClientRecoveryAmountVariancePopulationAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimClientRecoveryAmountVariancePopulationAggregates = {
  __typename?: "BatchClaimClientRecoveryAmountVariancePopulationAggregates";
  /** Population variance of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimClientRecoveryAmountVarianceSampleAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimClientRecoveryAmountVarianceSampleAggregates = {
  __typename?: "BatchClaimClientRecoveryAmountVarianceSampleAggregates";
  /** Sample variance of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
};

/** A connection to a list of `BatchClaimClientRecoveryAmount` values. */
export type BatchClaimClientRecoveryAmountsConnection = {
  __typename?: "BatchClaimClientRecoveryAmountsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimClientRecoveryAmountAggregates>;
  /** A list of edges which contains the `BatchClaimClientRecoveryAmount` and cursor to aid in pagination. */
  edges: Array<BatchClaimClientRecoveryAmountsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimClientRecoveryAmountAggregates>>;
  /** A list of `BatchClaimClientRecoveryAmount` objects. */
  nodes: Array<Maybe<BatchClaimClientRecoveryAmount>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimClientRecoveryAmount` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimClientRecoveryAmount` values. */
export type BatchClaimClientRecoveryAmountsConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimClientRecoveryAmountGroupBy>;
  having?: InputMaybe<BatchClaimClientRecoveryAmountHavingInput>;
};

/** A `BatchClaimClientRecoveryAmount` edge in the connection. */
export type BatchClaimClientRecoveryAmountsEdge = {
  __typename?: "BatchClaimClientRecoveryAmountsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimClientRecoveryAmount` at the end of the edge. */
  node?: Maybe<BatchClaimClientRecoveryAmount>;
};

/** Methods to use when ordering `BatchClaimClientRecoveryAmount`. */
export enum BatchClaimClientRecoveryAmountsOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CLIENT_RECOVERY_AMOUNT_ASC = "CLIENT_RECOVERY_AMOUNT_ASC",
  CLIENT_RECOVERY_AMOUNT_DESC = "CLIENT_RECOVERY_AMOUNT_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DELETED_ASC = "DELETED_ASC",
  DELETED_DESC = "DELETED_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

/** History table tracking all changes to client recovery collection dates for batch claims, including soft deletes. */
export type BatchClaimClientRecoveryCollectionDate = Node & {
  __typename?: "BatchClaimClientRecoveryCollectionDate";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimClientRecoveryCollectionDate`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  /** Date when the client recovery amount was collected */
  clientRecoveryCollectionDate: Scalars["Datetime"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  /** When true, indicates this collection date has been cleared/removed */
  deleted: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

export type BatchClaimClientRecoveryCollectionDateAggregates = {
  __typename?: "BatchClaimClientRecoveryCollectionDateAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimClientRecoveryCollectionDateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `BatchClaimClientRecoveryCollectionDate` object types. */
export type BatchClaimClientRecoveryCollectionDateAggregatesFilter = {
  /** Distinct count aggregate over matching `BatchClaimClientRecoveryCollectionDate` objects. */
  distinctCount?: InputMaybe<BatchClaimClientRecoveryCollectionDateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimClientRecoveryCollectionDate` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimClientRecoveryCollectionDateFilter>;
};

/** The fields on `batchClaimClientRecoveryCollectionDate` to look up the row to connect. */
export type BatchClaimClientRecoveryCollectionDateBatchClaimClientRecoveryCollectionDatePkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** The `batchClaimClientRecoveryCollectionDate` to be created by this mutation. */
export type BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyBatchClaimClientRecoveryCollectionDateCreateInput =
  {
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInput>;
    /** Date when the client recovery amount was collected */
    clientRecoveryCollectionDate: Scalars["Datetime"]["input"];
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    /** When true, indicates this collection date has been cleared/removed */
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `batchClaim` in the `BatchClaimClientRecoveryCollectionDateInput` mutation. */
export type BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimClientRecoveryCollectionDateOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimClientRecoveryCollectionDate` in the `BatchClaimInput` mutation. */
export type BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput =
  {
    /** The primary key(s) for `batchClaimClientRecoveryCollectionDate` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<BatchClaimClientRecoveryCollectionDateBatchClaimClientRecoveryCollectionDatePkeyConnect>
    >;
    /** The primary key(s) for `batchClaimClientRecoveryCollectionDate` for the far side of the relationship. */
    connectByNodeId?: InputMaybe<
      Array<BatchClaimClientRecoveryCollectionDateNodeIdConnect>
    >;
    /** A `BatchClaimClientRecoveryCollectionDateInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyBatchClaimClientRecoveryCollectionDateCreateInput>
    >;
    /** The primary key(s) and patch data for `batchClaimClientRecoveryCollectionDate` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<BatchClaimClientRecoveryCollectionDateOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyUsingBatchClaimClientRecoveryCollectionDatePkeyUpdate>
    >;
    /** The primary key(s) and patch data for `batchClaimClientRecoveryCollectionDate` for the far side of the relationship. */
    updateByNodeId?: InputMaybe<
      Array<BatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyNodeIdUpdate>
    >;
  };

/**
 * A condition to be used against `BatchClaimClientRecoveryCollectionDate` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimClientRecoveryCollectionDateCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `clientRecoveryCollectionDate` field. */
  clientRecoveryCollectionDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimClientRecoveryCollectionDateDistinctCountAggregateFilter =
  {
    batchClaimId?: InputMaybe<BigIntFilter>;
    clientRecoveryCollectionDate?: InputMaybe<BigIntFilter>;
    createdAt?: InputMaybe<BigIntFilter>;
    deleted?: InputMaybe<BigIntFilter>;
    id?: InputMaybe<BigIntFilter>;
  };

export type BatchClaimClientRecoveryCollectionDateDistinctCountAggregates = {
  __typename?: "BatchClaimClientRecoveryCollectionDateDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientRecoveryCollectionDate across the matching connection */
  clientRecoveryCollectionDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of deleted across the matching connection */
  deleted?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimClientRecoveryCollectionDate` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimClientRecoveryCollectionDateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimClientRecoveryCollectionDateFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `clientRecoveryCollectionDate` field. */
  clientRecoveryCollectionDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimClientRecoveryCollectionDateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimClientRecoveryCollectionDateFilter>>;
};

/** Grouping methods for `BatchClaimClientRecoveryCollectionDate` for usage during aggregation. */
export enum BatchClaimClientRecoveryCollectionDateGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CLIENT_RECOVERY_COLLECTION_DATE = "CLIENT_RECOVERY_COLLECTION_DATE",
  CLIENT_RECOVERY_COLLECTION_DATE_TRUNCATED_TO_DAY = "CLIENT_RECOVERY_COLLECTION_DATE_TRUNCATED_TO_DAY",
  CLIENT_RECOVERY_COLLECTION_DATE_TRUNCATED_TO_HOUR = "CLIENT_RECOVERY_COLLECTION_DATE_TRUNCATED_TO_HOUR",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DELETED = "DELETED",
}

export type BatchClaimClientRecoveryCollectionDateHavingAverageInput = {
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryCollectionDateHavingDistinctCountInput = {
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimClientRecoveryCollectionDate` aggregates. */
export type BatchClaimClientRecoveryCollectionDateHavingInput = {
  AND?: InputMaybe<Array<BatchClaimClientRecoveryCollectionDateHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimClientRecoveryCollectionDateHavingInput>>;
  average?: InputMaybe<BatchClaimClientRecoveryCollectionDateHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimClientRecoveryCollectionDateHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimClientRecoveryCollectionDateHavingMaxInput>;
  min?: InputMaybe<BatchClaimClientRecoveryCollectionDateHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimClientRecoveryCollectionDateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimClientRecoveryCollectionDateHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimClientRecoveryCollectionDateHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimClientRecoveryCollectionDateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimClientRecoveryCollectionDateHavingVarianceSampleInput>;
};

export type BatchClaimClientRecoveryCollectionDateHavingMaxInput = {
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryCollectionDateHavingMinInput = {
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryCollectionDateHavingStddevPopulationInput =
  {
    clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
    createdAt?: InputMaybe<HavingDatetimeFilter>;
  };

export type BatchClaimClientRecoveryCollectionDateHavingStddevSampleInput = {
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryCollectionDateHavingSumInput = {
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimClientRecoveryCollectionDateHavingVariancePopulationInput =
  {
    clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
    createdAt?: InputMaybe<HavingDatetimeFilter>;
  };

export type BatchClaimClientRecoveryCollectionDateHavingVarianceSampleInput = {
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimClientRecoveryCollectionDate` */
export type BatchClaimClientRecoveryCollectionDateInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInput>;
  /** Date when the client recovery amount was collected */
  clientRecoveryCollectionDate: Scalars["Datetime"]["input"];
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** When true, indicates this collection date has been cleared/removed */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimClientRecoveryCollectionDateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimClientRecoveryCollectionDate` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimClientRecoveryCollectionDateOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimClientRecoveryCollectionDate` to look up the row to update. */
export type BatchClaimClientRecoveryCollectionDateOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyUsingBatchClaimClientRecoveryCollectionDatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimClientRecoveryCollectionDate` being updated. */
    patch: updateBatchClaimClientRecoveryCollectionDateOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimClientRecoveryCollectionDate`. Fields that are set will be updated. */
export type BatchClaimClientRecoveryCollectionDatePatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInput>;
};

/** A connection to a list of `BatchClaimClientRecoveryCollectionDate` values. */
export type BatchClaimClientRecoveryCollectionDatesConnection = {
  __typename?: "BatchClaimClientRecoveryCollectionDatesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimClientRecoveryCollectionDateAggregates>;
  /** A list of edges which contains the `BatchClaimClientRecoveryCollectionDate` and cursor to aid in pagination. */
  edges: Array<BatchClaimClientRecoveryCollectionDatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<
    Array<BatchClaimClientRecoveryCollectionDateAggregates>
  >;
  /** A list of `BatchClaimClientRecoveryCollectionDate` objects. */
  nodes: Array<Maybe<BatchClaimClientRecoveryCollectionDate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimClientRecoveryCollectionDate` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimClientRecoveryCollectionDate` values. */
export type BatchClaimClientRecoveryCollectionDatesConnectiongroupedAggregatesArgs =
  {
    groupBy: Array<BatchClaimClientRecoveryCollectionDateGroupBy>;
    having?: InputMaybe<BatchClaimClientRecoveryCollectionDateHavingInput>;
  };

/** A `BatchClaimClientRecoveryCollectionDate` edge in the connection. */
export type BatchClaimClientRecoveryCollectionDatesEdge = {
  __typename?: "BatchClaimClientRecoveryCollectionDatesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimClientRecoveryCollectionDate` at the end of the edge. */
  node?: Maybe<BatchClaimClientRecoveryCollectionDate>;
};

/** Methods to use when ordering `BatchClaimClientRecoveryCollectionDate`. */
export enum BatchClaimClientRecoveryCollectionDatesOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CLIENT_RECOVERY_COLLECTION_DATE_ASC = "CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  CLIENT_RECOVERY_COLLECTION_DATE_DESC = "CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DELETED_ASC = "DELETED_ASC",
  DELETED_DESC = "DELETED_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

/**
 * A free-text comment posted on a BatchClaim by an internal user
 * (admin or auditor).
 */
export type BatchClaimComment = {
  __typename?: "BatchClaimComment";
  authorId: Scalars["UUID"]["output"];
  /**
   * Display name of the author, joined from auditor_user
   * (first_name + ' ' + last_name). Empty string if the author row
   * cannot be resolved.
   */
  authorName: Scalars["String"]["output"];
  batchClaimId: Scalars["UUID"]["output"];
  body: Scalars["String"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  /**
   * Soft-delete timestamp. Null for live comments. Deleted comments
   * are filtered from the listing — this field is only ever returned
   * on the deletion mutation result.
   */
  deletedAt?: Maybe<Scalars["Datetime"]["output"]>;
  /**
   * Auditor user that performed the soft-delete. Null for live
   * comments.
   */
  deletedBy?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  /**
   * Last edit timestamp. Null until the body has been edited at
   * least once. FE can render an "edited" indicator when non-null.
   */
  updatedAt?: Maybe<Scalars["Datetime"]["output"]>;
};

/**
 * A condition to be used against `BatchClaim` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BatchClaimCondition = {
  /** Checks for equality with the object’s `admType` field. */
  admType?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `admitDiag` field. */
  admitDiag?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `amountCharged` field. */
  amountCharged?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `amountReimbursed` field. */
  amountReimbursed?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `aprDrg` field. */
  aprDrg?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchFileId` field. */
  batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `billType` field. */
  billType?: InputMaybe<Scalars["String"]["input"]>;
  /** Match claims currently in OR ever in the given lifecycle phase. Emits `(EXISTS(current) OR EXISTS(history))` — one subquery against v3.claim_facets, one against v3.claim_facet_history. Values are phase slugs (e.g. "audit") or phase UUIDs. */
  claimEverInPhase?: InputMaybe<ClaimEverInPhaseFilterInput>;
  /** Match claims currently in OR ever in the given lifecycle stage. Emits `(EXISTS(current) OR EXISTS(history))` — one subquery against v3.claim_facets, one against v3.claim_facet_history. Values are compound "<phase>/<stage>" slugs (e.g. "audit/QA_REVIEW") or stage keyword UUIDs. */
  claimEverInStage?: InputMaybe<ClaimEverInStageFilterInput>;
  /** Filter batch claims by claim lifecycle stage keyword IDs (claim_lifecycle_stage facet). */
  claimStageIdIn?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  /** Checks for equality with the object’s `claimType` field. */
  claimType?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `clientGroupName` field. */
  clientGroupName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `clientIcn` field. */
  clientIcn?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `clientLineOfBusiness` field. */
  clientLineOfBusiness?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `clientPlanId` field. */
  clientPlanId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `computationStrategy` field. */
  computationStrategy?: InputMaybe<ClaimComputationStrategyKind>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateAdmit` field. */
  dateAdmit?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDischarge` field. */
  dateDischarge?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateOfServiceEnd` field. */
  dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateOfServiceStart` field. */
  dateOfServiceStart?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `diag1` field. */
  diag1?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag2` field. */
  diag2?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag3` field. */
  diag3?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag4` field. */
  diag4?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag5` field. */
  diag5?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag6` field. */
  diag6?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag7` field. */
  diag7?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag8` field. */
  diag8?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag9` field. */
  diag9?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag10` field. */
  diag10?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag11` field. */
  diag11?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag12` field. */
  diag12?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag13` field. */
  diag13?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag14` field. */
  diag14?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag15` field. */
  diag15?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag16` field. */
  diag16?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag17` field. */
  diag17?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag18` field. */
  diag18?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag19` field. */
  diag19?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag20` field. */
  diag20?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag21` field. */
  diag21?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag22` field. */
  diag22?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag23` field. */
  diag23?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag24` field. */
  diag24?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `dischargeStatus` field. */
  dischargeStatus?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `drgCode` field. */
  drgCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter claim facets. All facet conditions — raw and typed — compose inside this single field, producing one optimized EXISTS subquery. Sibling fields imply AND; use and/or/not for explicit composition. */
  facetFilter?: InputMaybe<FacetFilterInput>;
  /** Filter by claim facet history. Match claims whose facet_history rows include the given keys / values. Composes with sibling condition fields via implicit AND; use and/or/not inside for explicit composition of history predicates. Peer to `facetFilter` (current state); compose current-and-history at the condition level (both siblings) or via the `filter:` connection-filter surface. */
  facetHistoryFilter?: InputMaybe<FacetHistoryFilterInput>;
  /** Checks for equality with the object’s `icn` field. */
  icn?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `insurerId` field. */
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `ownerId` field. */
  ownerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `paidDate` field. */
  paidDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `patientControlNumber` field. */
  patientControlNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `patientDob` field. */
  patientDob?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `patientGender` field. */
  patientGender?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `paymentRate` field. */
  paymentRate?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `permittedInsurerUsers` field. */
  permittedInsurerUsers?: InputMaybe<
    Array<InputMaybe<Scalars["UUID"]["input"]>>
  >;
  /** Checks for equality with the object’s `poa1` field. */
  poa1?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa2` field. */
  poa2?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa3` field. */
  poa3?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa4` field. */
  poa4?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa5` field. */
  poa5?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa6` field. */
  poa6?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa7` field. */
  poa7?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa8` field. */
  poa8?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa9` field. */
  poa9?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa10` field. */
  poa10?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa11` field. */
  poa11?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa12` field. */
  poa12?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa13` field. */
  poa13?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa14` field. */
  poa14?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa15` field. */
  poa15?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa16` field. */
  poa16?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa17` field. */
  poa17?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa18` field. */
  poa18?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa19` field. */
  poa19?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa20` field. */
  poa20?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa21` field. */
  poa21?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa22` field. */
  poa22?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa23` field. */
  poa23?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa24` field. */
  poa24?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `poa25` field. */
  poa25?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `prepayDeny` field. */
  prepayDeny?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `previousVersionId` field. */
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `principalDiag` field. */
  principalDiag?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `principalPoa` field. */
  principalPoa?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `principalProcedureCode` field. */
  principalProcedureCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCode1` field. */
  procedureCode1?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCode2` field. */
  procedureCode2?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCode3` field. */
  procedureCode3?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCode4` field. */
  procedureCode4?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCode5` field. */
  procedureCode5?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCode6` field. */
  procedureCode6?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCode7` field. */
  procedureCode7?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCode8` field. */
  procedureCode8?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCode9` field. */
  procedureCode9?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCode10` field. */
  procedureCode10?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `submittedDrg` field. */
  submittedDrg?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `versionGroup` field. */
  versionGroup?: InputMaybe<Scalars["String"]["input"]>;
};

export type BatchClaimDistinctCountAggregateFilter = {
  admType?: InputMaybe<BigIntFilter>;
  admitDiag?: InputMaybe<BigIntFilter>;
  amountCharged?: InputMaybe<BigIntFilter>;
  amountReimbursed?: InputMaybe<BigIntFilter>;
  aprDrg?: InputMaybe<BigIntFilter>;
  authorId?: InputMaybe<BigIntFilter>;
  batchFileId?: InputMaybe<BigIntFilter>;
  billType?: InputMaybe<BigIntFilter>;
  claimType?: InputMaybe<BigIntFilter>;
  clientGroupName?: InputMaybe<BigIntFilter>;
  clientIcn?: InputMaybe<BigIntFilter>;
  clientLineOfBusiness?: InputMaybe<BigIntFilter>;
  clientPlanId?: InputMaybe<BigIntFilter>;
  computationStrategy?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  dateAdmit?: InputMaybe<BigIntFilter>;
  dateDischarge?: InputMaybe<BigIntFilter>;
  dateOfServiceEnd?: InputMaybe<BigIntFilter>;
  dateOfServiceStart?: InputMaybe<BigIntFilter>;
  diag1?: InputMaybe<BigIntFilter>;
  diag2?: InputMaybe<BigIntFilter>;
  diag3?: InputMaybe<BigIntFilter>;
  diag4?: InputMaybe<BigIntFilter>;
  diag5?: InputMaybe<BigIntFilter>;
  diag6?: InputMaybe<BigIntFilter>;
  diag7?: InputMaybe<BigIntFilter>;
  diag8?: InputMaybe<BigIntFilter>;
  diag9?: InputMaybe<BigIntFilter>;
  diag10?: InputMaybe<BigIntFilter>;
  diag11?: InputMaybe<BigIntFilter>;
  diag12?: InputMaybe<BigIntFilter>;
  diag13?: InputMaybe<BigIntFilter>;
  diag14?: InputMaybe<BigIntFilter>;
  diag15?: InputMaybe<BigIntFilter>;
  diag16?: InputMaybe<BigIntFilter>;
  diag17?: InputMaybe<BigIntFilter>;
  diag18?: InputMaybe<BigIntFilter>;
  diag19?: InputMaybe<BigIntFilter>;
  diag20?: InputMaybe<BigIntFilter>;
  diag21?: InputMaybe<BigIntFilter>;
  diag22?: InputMaybe<BigIntFilter>;
  diag23?: InputMaybe<BigIntFilter>;
  diag24?: InputMaybe<BigIntFilter>;
  dischargeStatus?: InputMaybe<BigIntFilter>;
  documentBlockerStageSortOrder?: InputMaybe<IntFilter>;
  drgCode?: InputMaybe<BigIntFilter>;
  icn?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  insurerId?: InputMaybe<BigIntFilter>;
  isAssignedToQueryingUser?: InputMaybe<BooleanFilter>;
  lifecycleSortOrder?: InputMaybe<IntFilter>;
  negotiationClaimState?: InputMaybe<NegotiationClaimStateEnumFilter>;
  onHoldBlockerStageSortOrder?: InputMaybe<IntFilter>;
  onHoldClaimState?: InputMaybe<OnHoldClaimStateEnumFilter>;
  ownerId?: InputMaybe<BigIntFilter>;
  paidDate?: InputMaybe<BigIntFilter>;
  patientControlNumber?: InputMaybe<BigIntFilter>;
  patientDob?: InputMaybe<BigIntFilter>;
  patientGender?: InputMaybe<BigIntFilter>;
  patientId?: InputMaybe<BigIntFilter>;
  paymentRate?: InputMaybe<BigIntFilter>;
  permittedInsurerUsers?: InputMaybe<BigIntFilter>;
  phaseSortOrder?: InputMaybe<IntFilter>;
  poa1?: InputMaybe<BigIntFilter>;
  poa2?: InputMaybe<BigIntFilter>;
  poa3?: InputMaybe<BigIntFilter>;
  poa4?: InputMaybe<BigIntFilter>;
  poa5?: InputMaybe<BigIntFilter>;
  poa6?: InputMaybe<BigIntFilter>;
  poa7?: InputMaybe<BigIntFilter>;
  poa8?: InputMaybe<BigIntFilter>;
  poa9?: InputMaybe<BigIntFilter>;
  poa10?: InputMaybe<BigIntFilter>;
  poa11?: InputMaybe<BigIntFilter>;
  poa12?: InputMaybe<BigIntFilter>;
  poa13?: InputMaybe<BigIntFilter>;
  poa14?: InputMaybe<BigIntFilter>;
  poa15?: InputMaybe<BigIntFilter>;
  poa16?: InputMaybe<BigIntFilter>;
  poa17?: InputMaybe<BigIntFilter>;
  poa18?: InputMaybe<BigIntFilter>;
  poa19?: InputMaybe<BigIntFilter>;
  poa20?: InputMaybe<BigIntFilter>;
  poa21?: InputMaybe<BigIntFilter>;
  poa22?: InputMaybe<BigIntFilter>;
  poa23?: InputMaybe<BigIntFilter>;
  poa24?: InputMaybe<BigIntFilter>;
  poa25?: InputMaybe<BigIntFilter>;
  prepayDeny?: InputMaybe<BigIntFilter>;
  previousVersionId?: InputMaybe<BigIntFilter>;
  principalDiag?: InputMaybe<BigIntFilter>;
  principalPoa?: InputMaybe<BigIntFilter>;
  principalProcedureCode?: InputMaybe<BigIntFilter>;
  procedureCode1?: InputMaybe<BigIntFilter>;
  procedureCode2?: InputMaybe<BigIntFilter>;
  procedureCode3?: InputMaybe<BigIntFilter>;
  procedureCode4?: InputMaybe<BigIntFilter>;
  procedureCode5?: InputMaybe<BigIntFilter>;
  procedureCode6?: InputMaybe<BigIntFilter>;
  procedureCode7?: InputMaybe<BigIntFilter>;
  procedureCode8?: InputMaybe<BigIntFilter>;
  procedureCode9?: InputMaybe<BigIntFilter>;
  procedureCode10?: InputMaybe<BigIntFilter>;
  providerId?: InputMaybe<BigIntFilter>;
  stageSortOrder?: InputMaybe<IntFilter>;
  submittedDrg?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  version?: InputMaybe<BigIntFilter>;
  versionGroup?: InputMaybe<BigIntFilter>;
};

export type BatchClaimDistinctCountAggregates = {
  __typename?: "BatchClaimDistinctCountAggregates";
  /** Distinct count of admType across the matching connection */
  admType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of admitDiag across the matching connection */
  admitDiag?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of amountCharged across the matching connection */
  amountCharged?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of amountReimbursed across the matching connection */
  amountReimbursed?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of aprDrg across the matching connection */
  aprDrg?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchFileId across the matching connection */
  batchFileId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of billType across the matching connection */
  billType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of claimType across the matching connection */
  claimType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientGroupName across the matching connection */
  clientGroupName?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientIcn across the matching connection */
  clientIcn?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientLineOfBusiness across the matching connection */
  clientLineOfBusiness?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientPlanId across the matching connection */
  clientPlanId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of computationStrategy across the matching connection */
  computationStrategy?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dateAdmit across the matching connection */
  dateAdmit?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dateDischarge across the matching connection */
  dateDischarge?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dateOfServiceEnd across the matching connection */
  dateOfServiceEnd?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dateOfServiceStart across the matching connection */
  dateOfServiceStart?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag1 across the matching connection */
  diag1?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag2 across the matching connection */
  diag2?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag3 across the matching connection */
  diag3?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag4 across the matching connection */
  diag4?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag5 across the matching connection */
  diag5?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag6 across the matching connection */
  diag6?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag7 across the matching connection */
  diag7?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag8 across the matching connection */
  diag8?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag9 across the matching connection */
  diag9?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag10 across the matching connection */
  diag10?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag11 across the matching connection */
  diag11?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag12 across the matching connection */
  diag12?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag13 across the matching connection */
  diag13?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag14 across the matching connection */
  diag14?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag15 across the matching connection */
  diag15?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag16 across the matching connection */
  diag16?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag17 across the matching connection */
  diag17?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag18 across the matching connection */
  diag18?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag19 across the matching connection */
  diag19?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag20 across the matching connection */
  diag20?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag21 across the matching connection */
  diag21?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag22 across the matching connection */
  diag22?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag23 across the matching connection */
  diag23?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag24 across the matching connection */
  diag24?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dischargeStatus across the matching connection */
  dischargeStatus?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the Document blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the document facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the document facet is absent. Matches documentBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  documentBlockerStageSortOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of drgCode across the matching connection */
  drgCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of icn across the matching connection */
  icn?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of insurerId across the matching connection */
  insurerId?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Determines if the querying user is assigned to a particular claim. Used on the auditor role for the claimIsAssignedToUserFilter filter in the UI
   */
  isAssignedToQueryingUser?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   *    Returns hierarchical sort position (phase * 1000 + stage sort order).
   *    Enables efficient lifecycle progression sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: LIFECYCLE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  lifecycleSortOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of this field across the matching connection. */
  negotiationClaimState?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the On Hold blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the on_hold facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the on_hold facet is absent. Matches onHoldBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  onHoldBlockerStageSortOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Indicates if the given batch claim is on hold or not.
   */
  onHoldClaimState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of ownerId across the matching connection */
  ownerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of paidDate across the matching connection */
  paidDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of patientControlNumber across the matching connection */
  patientControlNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of patientDob across the matching connection */
  patientDob?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of patientGender across the matching connection */
  patientGender?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of patientId across the matching connection */
  patientId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of permittedInsurerUsers across the matching connection */
  permittedInsurerUsers?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   *    Returns phase sort order (1=intake, 2=audit, etc.).
   *    Enables efficient phase-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: PHASE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  phaseSortOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa1 across the matching connection */
  poa1?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa2 across the matching connection */
  poa2?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa3 across the matching connection */
  poa3?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa4 across the matching connection */
  poa4?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa5 across the matching connection */
  poa5?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa6 across the matching connection */
  poa6?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa7 across the matching connection */
  poa7?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa8 across the matching connection */
  poa8?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa9 across the matching connection */
  poa9?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa10 across the matching connection */
  poa10?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa11 across the matching connection */
  poa11?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa12 across the matching connection */
  poa12?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa13 across the matching connection */
  poa13?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa14 across the matching connection */
  poa14?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa15 across the matching connection */
  poa15?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa16 across the matching connection */
  poa16?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa17 across the matching connection */
  poa17?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa18 across the matching connection */
  poa18?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa19 across the matching connection */
  poa19?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa20 across the matching connection */
  poa20?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa21 across the matching connection */
  poa21?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa22 across the matching connection */
  poa22?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa23 across the matching connection */
  poa23?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa24 across the matching connection */
  poa24?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of poa25 across the matching connection */
  poa25?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of prepayDeny across the matching connection */
  prepayDeny?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of previousVersionId across the matching connection */
  previousVersionId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of principalDiag across the matching connection */
  principalDiag?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of principalPoa across the matching connection */
  principalPoa?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of principalProcedureCode across the matching connection */
  principalProcedureCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode1 across the matching connection */
  procedureCode1?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode2 across the matching connection */
  procedureCode2?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode3 across the matching connection */
  procedureCode3?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode4 across the matching connection */
  procedureCode4?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode5 across the matching connection */
  procedureCode5?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode6 across the matching connection */
  procedureCode6?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode7 across the matching connection */
  procedureCode7?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode8 across the matching connection */
  procedureCode8?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode9 across the matching connection */
  procedureCode9?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode10 across the matching connection */
  procedureCode10?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of providerId across the matching connection */
  providerId?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   *    Returns stage sort order within phase (1, 2, 3, etc.).
   *    Enables efficient stage-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: STAGE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  stageSortOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of submittedDrg across the matching connection */
  submittedDrg?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of version across the matching connection */
  version?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of versionGroup across the matching connection */
  versionGroup?: Maybe<Scalars["BigInt"]["output"]>;
};

export type BatchClaimDistinctCountAggregatesimproperPaymentCostArgs = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchClaimDocument = Node & {
  __typename?: "BatchClaimDocument";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimDocument`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  documentId: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  /**
   * Marks this document as the primary medical record for the batch claim. Nullable-or-TRUE; FALSE is disallowed. At most one document per batch_claim_id may have this set to TRUE (enforced by the deferrable compound UNIQUE constraint on (batch_claim_id, is_primary_medical_record) — NULLs are distinct so only TRUE rows collide).
   *
   * @omit create,update
   */
  isPrimaryMedicalRecord?: Maybe<Scalars["Boolean"]["output"]>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type BatchClaimDocumentAggregates = {
  __typename?: "BatchClaimDocumentAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimDocumentDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `BatchClaimDocument` object types. */
export type BatchClaimDocumentAggregatesFilter = {
  /** Distinct count aggregate over matching `BatchClaimDocument` objects. */
  distinctCount?: InputMaybe<BatchClaimDocumentDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimDocument` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimDocumentFilter>;
};

/** The fields on `batchClaimDocument` to look up the row to connect. */
export type BatchClaimDocumentBatchClaimDocumentBatchClaimIdDocumentIdKeyConnect =
  {
    batchClaimId: Scalars["UUID"]["input"];
    documentId: Scalars["UUID"]["input"];
  };

/** The fields on `batchClaimDocument` to look up the row to connect. */
export type BatchClaimDocumentBatchClaimDocumentPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `batchClaimDocument` to look up the row to connect. */
export type BatchClaimDocumentBatchClaimDocumentSinglePrimaryMrConnect = {
  batchClaimId: Scalars["UUID"]["input"];
  /**
   * Marks this document as the primary medical record for the batch claim. Nullable-or-TRUE; FALSE is disallowed. At most one document per batch_claim_id may have this set to TRUE (enforced by the deferrable compound UNIQUE constraint on (batch_claim_id, is_primary_medical_record) — NULLs are distinct so only TRUE rows collide).
   *
   * @omit create,update
   */
  isPrimaryMedicalRecord: Scalars["Boolean"]["input"];
};

/** The `batchClaimDocument` to be created by this mutation. */
export type BatchClaimDocumentBatchClaimIdFkeyBatchClaimDocumentCreateInput = {
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  documentId: Scalars["UUID"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /**
   * Marks this document as the primary medical record for the batch claim. Nullable-or-TRUE; FALSE is disallowed. At most one document per batch_claim_id may have this set to TRUE (enforced by the deferrable compound UNIQUE constraint on (batch_claim_id, is_primary_medical_record) — NULLs are distinct so only TRUE rows collide).
   *
   * @omit create,update
   */
  isPrimaryMedicalRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `batchClaim` in the `BatchClaimDocumentInput` mutation. */
export type BatchClaimDocumentBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimDocument` in the `BatchClaimInput` mutation. */
export type BatchClaimDocumentBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimDocument` for the far side of the relationship. */
  connectByBatchClaimIdAndDocumentId?: InputMaybe<
    Array<BatchClaimDocumentBatchClaimDocumentBatchClaimIdDocumentIdKeyConnect>
  >;
  /** The primary key(s) for `batchClaimDocument` for the far side of the relationship. */
  connectByBatchClaimIdAndIsPrimaryMedicalRecord?: InputMaybe<
    Array<BatchClaimDocumentBatchClaimDocumentSinglePrimaryMrConnect>
  >;
  /** The primary key(s) for `batchClaimDocument` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimDocumentBatchClaimDocumentPkeyConnect>
  >;
  /** The primary key(s) for `batchClaimDocument` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimDocumentNodeIdConnect>>;
  /** A `BatchClaimDocumentInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimDocumentBatchClaimIdFkeyBatchClaimDocumentCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimDocument` for the far side of the relationship. */
  updateByBatchClaimIdAndDocumentId?: InputMaybe<
    Array<BatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimDocumentBatchClaimIdDocumentIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimDocument` for the far side of the relationship. */
  updateByBatchClaimIdAndIsPrimaryMedicalRecord?: InputMaybe<
    Array<BatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimDocumentSinglePrimaryMrUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimDocument` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimDocumentPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimDocument` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `BatchClaimDocument` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimDocumentCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `isPrimaryMedicalRecord` field. */
  isPrimaryMedicalRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type BatchClaimDocumentDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  documentId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isPrimaryMedicalRecord?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type BatchClaimDocumentDistinctCountAggregates = {
  __typename?: "BatchClaimDocumentDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of documentId across the matching connection */
  documentId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of isPrimaryMedicalRecord across the matching connection */
  isPrimaryMedicalRecord?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimDocument` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimDocumentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimDocumentFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `isPrimaryMedicalRecord` field. */
  isPrimaryMedicalRecord?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimDocumentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimDocumentFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BatchClaimDocument` for usage during aggregation. */
export enum BatchClaimDocumentGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DOCUMENT_ID = "DOCUMENT_ID",
  IS_PRIMARY_MEDICAL_RECORD = "IS_PRIMARY_MEDICAL_RECORD",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type BatchClaimDocumentHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDocumentHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimDocument` aggregates. */
export type BatchClaimDocumentHavingInput = {
  AND?: InputMaybe<Array<BatchClaimDocumentHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimDocumentHavingInput>>;
  average?: InputMaybe<BatchClaimDocumentHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimDocumentHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimDocumentHavingMaxInput>;
  min?: InputMaybe<BatchClaimDocumentHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimDocumentHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimDocumentHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimDocumentHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimDocumentHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimDocumentHavingVarianceSampleInput>;
};

export type BatchClaimDocumentHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDocumentHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDocumentHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDocumentHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDocumentHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDocumentHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDocumentHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimDocument` */
export type BatchClaimDocumentInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  documentId: Scalars["UUID"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /**
   * Marks this document as the primary medical record for the batch claim. Nullable-or-TRUE; FALSE is disallowed. At most one document per batch_claim_id may have this set to TRUE (enforced by the deferrable compound UNIQUE constraint on (batch_claim_id, is_primary_medical_record) — NULLs are distinct so only TRUE rows collide).
   *
   * @omit create,update
   */
  isPrimaryMedicalRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimDocumentNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimDocument` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimDocument` to look up the row to update. */
export type BatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimDocumentBatchClaimIdDocumentIdKeyUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    documentId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimDocument` being updated. */
    patch: updateBatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaimDocument` to look up the row to update. */
export type BatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimDocumentPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimDocument` being updated. */
    patch: updateBatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaimDocument` to look up the row to update. */
export type BatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimDocumentSinglePrimaryMrUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    /**
     * Marks this document as the primary medical record for the batch claim. Nullable-or-TRUE; FALSE is disallowed. At most one document per batch_claim_id may have this set to TRUE (enforced by the deferrable compound UNIQUE constraint on (batch_claim_id, is_primary_medical_record) — NULLs are distinct so only TRUE rows collide).
     *
     * @omit create,update
     */
    isPrimaryMedicalRecord: Scalars["Boolean"]["input"];
    /** An object where the defined keys will be set on the `batchClaimDocument` being updated. */
    patch: updateBatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimDocument`. Fields that are set will be updated. */
export type BatchClaimDocumentPatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInput>;
  /**
   * Marks this document as the primary medical record for the batch claim. Nullable-or-TRUE; FALSE is disallowed. At most one document per batch_claim_id may have this set to TRUE (enforced by the deferrable compound UNIQUE constraint on (batch_claim_id, is_primary_medical_record) — NULLs are distinct so only TRUE rows collide).
   *
   * @omit create,update
   */
  isPrimaryMedicalRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A connection to a list of `BatchClaimDocument` values. */
export type BatchClaimDocumentsConnection = {
  __typename?: "BatchClaimDocumentsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimDocumentAggregates>;
  /** A list of edges which contains the `BatchClaimDocument` and cursor to aid in pagination. */
  edges: Array<BatchClaimDocumentsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimDocumentAggregates>>;
  /** A list of `BatchClaimDocument` objects. */
  nodes: Array<Maybe<BatchClaimDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimDocument` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimDocument` values. */
export type BatchClaimDocumentsConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimDocumentGroupBy>;
  having?: InputMaybe<BatchClaimDocumentHavingInput>;
};

/** A `BatchClaimDocument` edge in the connection. */
export type BatchClaimDocumentsEdge = {
  __typename?: "BatchClaimDocumentsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimDocument` at the end of the edge. */
  node?: Maybe<BatchClaimDocument>;
};

/** Methods to use when ordering `BatchClaimDocument`. */
export enum BatchClaimDocumentsOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DOCUMENT_ID_ASC = "DOCUMENT_ID_ASC",
  DOCUMENT_ID_DESC = "DOCUMENT_ID_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  IS_PRIMARY_MEDICAL_RECORD_ASC = "IS_PRIMARY_MEDICAL_RECORD_ASC",
  IS_PRIMARY_MEDICAL_RECORD_DESC = "IS_PRIMARY_MEDICAL_RECORD_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type BatchClaimDueDate = Node & {
  __typename?: "BatchClaimDueDate";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimDueDate`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  deleted: Scalars["Boolean"]["output"];
  dueDate: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

export type BatchClaimDueDateAggregates = {
  __typename?: "BatchClaimDueDateAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimDueDateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `BatchClaimDueDate` object types. */
export type BatchClaimDueDateAggregatesFilter = {
  /** Distinct count aggregate over matching `BatchClaimDueDate` objects. */
  distinctCount?: InputMaybe<BatchClaimDueDateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimDueDate` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimDueDateFilter>;
};

/** The fields on `batchClaimDueDate` to look up the row to connect. */
export type BatchClaimDueDateBatchClaimDueDatePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The `batchClaimDueDate` to be created by this mutation. */
export type BatchClaimDueDateBatchClaimIdFkBatchClaimDueDateCreateInput = {
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  dueDate: Scalars["Datetime"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `batchClaim` in the `BatchClaimDueDateInput` mutation. */
export type BatchClaimDueDateBatchClaimIdFkInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimDueDateOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimDueDate` in the `BatchClaimInput` mutation. */
export type BatchClaimDueDateBatchClaimIdFkInverseInput = {
  /** The primary key(s) for `batchClaimDueDate` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimDueDateBatchClaimDueDatePkeyConnect>
  >;
  /** The primary key(s) for `batchClaimDueDate` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimDueDateNodeIdConnect>>;
  /** A `BatchClaimDueDateInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimDueDateBatchClaimIdFkBatchClaimDueDateCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimDueDate` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimDueDateOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkUsingBatchClaimDueDatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimDueDate` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `BatchClaimDueDate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimDueDateCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `dueDate` field. */
  dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimDueDateDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  deleted?: InputMaybe<BigIntFilter>;
  dueDate?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type BatchClaimDueDateDistinctCountAggregates = {
  __typename?: "BatchClaimDueDateDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of deleted across the matching connection */
  deleted?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dueDate across the matching connection */
  dueDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimDueDate` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimDueDateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimDueDateFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dueDate` field. */
  dueDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimDueDateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimDueDateFilter>>;
};

/** Grouping methods for `BatchClaimDueDate` for usage during aggregation. */
export enum BatchClaimDueDateGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DELETED = "DELETED",
  DUE_DATE = "DUE_DATE",
  DUE_DATE_TRUNCATED_TO_DAY = "DUE_DATE_TRUNCATED_TO_DAY",
  DUE_DATE_TRUNCATED_TO_HOUR = "DUE_DATE_TRUNCATED_TO_HOUR",
}

export type BatchClaimDueDateHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDueDateHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimDueDate` aggregates. */
export type BatchClaimDueDateHavingInput = {
  AND?: InputMaybe<Array<BatchClaimDueDateHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimDueDateHavingInput>>;
  average?: InputMaybe<BatchClaimDueDateHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimDueDateHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimDueDateHavingMaxInput>;
  min?: InputMaybe<BatchClaimDueDateHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimDueDateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimDueDateHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimDueDateHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimDueDateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimDueDateHavingVarianceSampleInput>;
};

export type BatchClaimDueDateHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDueDateHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDueDateHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDueDateHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDueDateHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDueDateHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimDueDateHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimDueDate` */
export type BatchClaimDueDateInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  dueDate: Scalars["Datetime"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimDueDateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimDueDate` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimDueDateOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimDueDate` to look up the row to update. */
export type BatchClaimDueDateOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkUsingBatchClaimDueDatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimDueDate` being updated. */
    patch: updateBatchClaimDueDateOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkPatch;
  };

/** Represents an update to a `BatchClaimDueDate`. Fields that are set will be updated. */
export type BatchClaimDueDatePatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInput>;
};

/** A connection to a list of `BatchClaimDueDate` values. */
export type BatchClaimDueDatesConnection = {
  __typename?: "BatchClaimDueDatesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimDueDateAggregates>;
  /** A list of edges which contains the `BatchClaimDueDate` and cursor to aid in pagination. */
  edges: Array<BatchClaimDueDatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimDueDateAggregates>>;
  /** A list of `BatchClaimDueDate` objects. */
  nodes: Array<Maybe<BatchClaimDueDate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimDueDate` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimDueDate` values. */
export type BatchClaimDueDatesConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimDueDateGroupBy>;
  having?: InputMaybe<BatchClaimDueDateHavingInput>;
};

/** A `BatchClaimDueDate` edge in the connection. */
export type BatchClaimDueDatesEdge = {
  __typename?: "BatchClaimDueDatesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimDueDate` at the end of the edge. */
  node?: Maybe<BatchClaimDueDate>;
};

/** Methods to use when ordering `BatchClaimDueDate`. */
export enum BatchClaimDueDatesOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DELETED_ASC = "DELETED_ASC",
  DELETED_DESC = "DELETED_DESC",
  DUE_DATE_ASC = "DUE_DATE_ASC",
  DUE_DATE_DESC = "DUE_DATE_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

/** A filter to be used against `BatchClaim` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimFilter = {
  /** Filter by the object’s `activeClaimAssignees` relation. */
  activeClaimAssignees?: InputMaybe<BatchClaimToManyActiveClaimAssigneeFilter>;
  /** Some related `activeClaimAssignees` exist. */
  activeClaimAssigneesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `admType` field. */
  admType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `admitDiag` field. */
  admitDiag?: InputMaybe<StringFilter>;
  /** Filter by the object’s `amountCharged` field. */
  amountCharged?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `amountReimbursed` field. */
  amountReimbursed?: InputMaybe<FloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimFilter>>;
  /** Filter by the object’s `aprDrg` field. */
  aprDrg?: InputMaybe<StringFilter>;
  /** Filter by the object’s `auditFindings` relation. */
  auditFindings?: InputMaybe<BatchClaimToManyAuditFindingFilter>;
  /** Some related `auditFindings` exist. */
  auditFindingsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** A related `author` exists. */
  authorExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaimAppealed` relation. */
  batchClaimAppealed?: InputMaybe<BatchClaimAppealedFilter>;
  /** A related `batchClaimAppealed` exists. */
  batchClaimAppealedExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimAssignees` relation. */
  batchClaimAssignees?: InputMaybe<BatchClaimToManyBatchClaimAssigneeFilter>;
  /** Some related `batchClaimAssignees` exist. */
  batchClaimAssigneesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimAuditStartDates` relation. */
  batchClaimAuditStartDates?: InputMaybe<BatchClaimToManyBatchClaimAuditStartDateFilter>;
  /** Some related `batchClaimAuditStartDates` exist. */
  batchClaimAuditStartDatesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimAuditType` relation. */
  batchClaimAuditType?: InputMaybe<BatchClaimAuditTypeFilter>;
  /** A related `batchClaimAuditType` exists. */
  batchClaimAuditTypeExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimAuditors` relation. */
  batchClaimAuditors?: InputMaybe<BatchClaimToManyBatchClaimAuditorFilter>;
  /** Some related `batchClaimAuditors` exist. */
  batchClaimAuditorsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimClientRecoveryAmounts` relation. */
  batchClaimClientRecoveryAmounts?: InputMaybe<BatchClaimToManyBatchClaimClientRecoveryAmountFilter>;
  /** Some related `batchClaimClientRecoveryAmounts` exist. */
  batchClaimClientRecoveryAmountsExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `batchClaimClientRecoveryCollectionDates` relation. */
  batchClaimClientRecoveryCollectionDates?: InputMaybe<BatchClaimToManyBatchClaimClientRecoveryCollectionDateFilter>;
  /** Some related `batchClaimClientRecoveryCollectionDates` exist. */
  batchClaimClientRecoveryCollectionDatesExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `batchClaimDocuments` relation. */
  batchClaimDocuments?: InputMaybe<BatchClaimToManyBatchClaimDocumentFilter>;
  /** Some related `batchClaimDocuments` exist. */
  batchClaimDocumentsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimDueDates` relation. */
  batchClaimDueDates?: InputMaybe<BatchClaimToManyBatchClaimDueDateFilter>;
  /** Some related `batchClaimDueDates` exist. */
  batchClaimDueDatesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimLineItems` relation. */
  batchClaimLineItems?: InputMaybe<BatchClaimToManyBatchClaimLineItemFilter>;
  /** Some related `batchClaimLineItems` exist. */
  batchClaimLineItemsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimLines` relation. */
  batchClaimLines?: InputMaybe<BatchClaimToManyBatchClaimLineFilter>;
  /** Some related `batchClaimLines` exist. */
  batchClaimLinesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimPayDeny` relation. */
  batchClaimPayDeny?: InputMaybe<BatchClaimPayDenyFilter>;
  /** A related `batchClaimPayDeny` exists. */
  batchClaimPayDenyExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimStateById` relation. */
  batchClaimStateById?: InputMaybe<BatchClaimStateFilter>;
  /** A related `batchClaimStateById` exists. */
  batchClaimStateByIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimTechDenial` relation. */
  batchClaimTechDenial?: InputMaybe<BatchClaimTechDenialFilter>;
  /** A related `batchClaimTechDenial` exists. */
  batchClaimTechDenialExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimsByPreviousVersionId` relation. */
  batchClaimsByPreviousVersionId?: InputMaybe<BatchClaimToManyBatchClaimFilter>;
  /** Some related `batchClaimsByPreviousVersionId` exist. */
  batchClaimsByPreviousVersionIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchFile` relation. */
  batchFile?: InputMaybe<BatchFileFilter>;
  /** Filter by the object’s `batchFileId` field. */
  batchFileId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `billType` field. */
  billType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `bucketClaim` relation. */
  bucketClaim?: InputMaybe<BucketClaimFilter>;
  /** A related `bucketClaim` exists. */
  bucketClaimExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Match claims currently in OR ever in the given lifecycle phase. Emits `(EXISTS(current) OR EXISTS(history))`. Use this surface to compose with column predicates via or/and/not. */
  claimEverInPhase?: InputMaybe<ClaimEverInPhaseFilterInput>;
  /** Match claims currently in OR ever in the given lifecycle stage. Emits `(EXISTS(current) OR EXISTS(history))`. Use this surface to compose with column predicates via or/and/not. */
  claimEverInStage?: InputMaybe<ClaimEverInStageFilterInput>;
  /** Filter by the object’s `claimFacet` relation. */
  claimFacet?: InputMaybe<ClaimFacetFilter>;
  /** A related `claimFacet` exists. */
  claimFacetExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `claimFacetHistories` relation. */
  claimFacetHistories?: InputMaybe<BatchClaimToManyClaimFacetHistoryFilter>;
  /** Some related `claimFacetHistories` exist. */
  claimFacetHistoriesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `claimPolicyDocuments` relation. */
  claimPolicyDocuments?: InputMaybe<BatchClaimToManyClaimPolicyDocumentFilter>;
  /** Some related `claimPolicyDocuments` exist. */
  claimPolicyDocumentsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `claimType` field. */
  claimType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientGroupName` field. */
  clientGroupName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientIcn` field. */
  clientIcn?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientLineOfBusiness` field. */
  clientLineOfBusiness?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientPlanId` field. */
  clientPlanId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientSignOffClaimStates` relation. */
  clientSignOffClaimStates?: InputMaybe<BatchClaimToManyClientSignOffClaimStateFilter>;
  /** Some related `clientSignOffClaimStates` exist. */
  clientSignOffClaimStatesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `computationStrategy` field. */
  computationStrategy?: InputMaybe<ClaimComputationStrategyKindFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateAdmit` field. */
  dateAdmit?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDischarge` field. */
  dateDischarge?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateOfServiceEnd` field. */
  dateOfServiceEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateOfServiceStart` field. */
  dateOfServiceStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `diag1` field. */
  diag1?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag2` field. */
  diag2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag3` field. */
  diag3?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag4` field. */
  diag4?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag5` field. */
  diag5?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag6` field. */
  diag6?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag7` field. */
  diag7?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag8` field. */
  diag8?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag9` field. */
  diag9?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag10` field. */
  diag10?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag11` field. */
  diag11?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag12` field. */
  diag12?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag13` field. */
  diag13?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag14` field. */
  diag14?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag15` field. */
  diag15?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag16` field. */
  diag16?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag17` field. */
  diag17?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag18` field. */
  diag18?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag19` field. */
  diag19?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag20` field. */
  diag20?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag21` field. */
  diag21?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag22` field. */
  diag22?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag23` field. */
  diag23?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag24` field. */
  diag24?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dischargeStatus` field. */
  dischargeStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `disputedFindings` relation. */
  disputedFindings?: InputMaybe<BatchClaimToManyDisputedFindingFilter>;
  /** Some related `disputedFindings` exist. */
  disputedFindingsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `documentBlockerStageSortOrder` field. */
  documentBlockerStageSortOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `documentRequestCreateds` relation. */
  documentRequestCreateds?: InputMaybe<BatchClaimToManyDocumentRequestCreatedFilter>;
  /** Some related `documentRequestCreateds` exist. */
  documentRequestCreatedsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `documentUploadCreateds` relation. */
  documentUploadCreateds?: InputMaybe<BatchClaimToManyDocumentUploadCreatedFilter>;
  /** Some related `documentUploadCreateds` exist. */
  documentUploadCreatedsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `documentationClaimStates` relation. */
  documentationClaimStates?: InputMaybe<BatchClaimToManyDocumentationClaimStateFilter>;
  /** Some related `documentationClaimStates` exist. */
  documentationClaimStatesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `drgCode` field. */
  drgCode?: InputMaybe<StringFilter>;
  /** Filter claim facets. All facet conditions — raw and typed — compose inside this single field, producing one optimized EXISTS subquery. Sibling fields imply AND; use and/or/not for explicit composition. Same input shape as `condition.facetFilter`; use this surface when you need to compose facet predicates with column predicates via or/and/not. */
  facetFilter?: InputMaybe<FacetFilterInput>;
  /** Filter by claim facet history. All predicates compose inside this single field, producing one optimized EXISTS subquery against v3.claim_facet_history. Use this surface when you need to compose history predicates with column predicates via or/and/not. Peer to `facetFilter` (current state). */
  facetHistoryFilter?: InputMaybe<FacetHistoryFilterInput>;
  /** When true, matches batch claims that have a document flagged as the primary medical record. When false, matches claims that do not. */
  hasPrimaryMedicalRecordSelected?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `icn` field. */
  icn?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `improperPaymentCost` field. */
  improperPaymentCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `insurer` relation. */
  insurer?: InputMaybe<InsurerFilter>;
  /** Filter by the object’s `insurerId` field. */
  insurerId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `invoiceClaimStates` relation. */
  invoiceClaimStates?: InputMaybe<BatchClaimToManyInvoiceClaimStateFilter>;
  /** Some related `invoiceClaimStates` exist. */
  invoiceClaimStatesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `isAssignedToQueryingUser` field. */
  isAssignedToQueryingUser?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lifecycleSortOrder` field. */
  lifecycleSortOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `negotiationClaimState` field. */
  negotiationClaimState?: InputMaybe<NegotiationClaimStateEnumFilter>;
  /** Filter by the object’s `negotiationClaimStates` relation. */
  negotiationClaimStates?: InputMaybe<BatchClaimToManyNegotiationClaimStateFilter>;
  /** Some related `negotiationClaimStates` exist. */
  negotiationClaimStatesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `onHoldBlockerStageSortOrder` field. */
  onHoldBlockerStageSortOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `onHoldClaimState` field. */
  onHoldClaimState?: InputMaybe<OnHoldClaimStateEnumFilter>;
  /** Filter by the object’s `onHoldClaimStates` relation. */
  onHoldClaimStates?: InputMaybe<BatchClaimToManyOnHoldClaimStateFilter>;
  /** Some related `onHoldClaimStates` exist. */
  onHoldClaimStatesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimFilter>>;
  /** Filter by the object’s `ownerId` field. */
  ownerId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `paidDate` field. */
  paidDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `patient` relation. */
  patient?: InputMaybe<PatientDatumFilter>;
  /** Filter by the object’s `patientControlNumber` field. */
  patientControlNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `patientDob` field. */
  patientDob?: InputMaybe<DatetimeFilter>;
  /** A related `patient` exists. */
  patientExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `patientGender` field. */
  patientGender?: InputMaybe<StringFilter>;
  /** Filter by the object’s `patientId` field. */
  patientId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `paymentRate` field. */
  paymentRate?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `permittedInsurerUsers` field. */
  permittedInsurerUsers?: InputMaybe<UUIDListFilter>;
  /** Filter by the object’s `phaseSortOrder` field. */
  phaseSortOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `poa1` field. */
  poa1?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa2` field. */
  poa2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa3` field. */
  poa3?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa4` field. */
  poa4?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa5` field. */
  poa5?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa6` field. */
  poa6?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa7` field. */
  poa7?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa8` field. */
  poa8?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa9` field. */
  poa9?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa10` field. */
  poa10?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa11` field. */
  poa11?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa12` field. */
  poa12?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa13` field. */
  poa13?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa14` field. */
  poa14?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa15` field. */
  poa15?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa16` field. */
  poa16?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa17` field. */
  poa17?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa18` field. */
  poa18?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa19` field. */
  poa19?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa20` field. */
  poa20?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa21` field. */
  poa21?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa22` field. */
  poa22?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa23` field. */
  poa23?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa24` field. */
  poa24?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poa25` field. */
  poa25?: InputMaybe<StringFilter>;
  /** Filter by the object’s `prepayDeny` field. */
  prepayDeny?: InputMaybe<StringFilter>;
  /** Filter by the object’s `previousVersion` relation. */
  previousVersion?: InputMaybe<BatchClaimFilter>;
  /** A related `previousVersion` exists. */
  previousVersionExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `previousVersionId` field. */
  previousVersionId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `principalDiag` field. */
  principalDiag?: InputMaybe<StringFilter>;
  /** Filter by the object’s `principalPoa` field. */
  principalPoa?: InputMaybe<StringFilter>;
  /** Filter by the object’s `principalProcedureCode` field. */
  principalProcedureCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCode1` field. */
  procedureCode1?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCode2` field. */
  procedureCode2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCode3` field. */
  procedureCode3?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCode4` field. */
  procedureCode4?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCode5` field. */
  procedureCode5?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCode6` field. */
  procedureCode6?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCode7` field. */
  procedureCode7?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCode8` field. */
  procedureCode8?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCode9` field. */
  procedureCode9?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCode10` field. */
  procedureCode10?: InputMaybe<StringFilter>;
  /** Filter by the object’s `provider` relation. */
  provider?: InputMaybe<ProviderFilter>;
  /** Filter by the object’s `providerId` field. */
  providerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `providerSignOffClaimStates` relation. */
  providerSignOffClaimStates?: InputMaybe<BatchClaimToManyProviderSignOffClaimStateFilter>;
  /** Some related `providerSignOffClaimStates` exist. */
  providerSignOffClaimStatesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `qaClaimStateRows` relation. */
  qaClaimStateRows?: InputMaybe<BatchClaimToManyQaClaimStateRowFilter>;
  /** Some related `qaClaimStateRows` exist. */
  qaClaimStateRowsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `reportedClaimsByClaimId` relation. */
  reportedClaimsByClaimId?: InputMaybe<BatchClaimToManyReportedClaimFilter>;
  /** Some related `reportedClaimsByClaimId` exist. */
  reportedClaimsByClaimIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `s3AuditDocumentations` relation. */
  s3AuditDocumentations?: InputMaybe<BatchClaimToManyS3AuditDocumentationFilter>;
  /** Some related `s3AuditDocumentations` exist. */
  s3AuditDocumentationsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by lifecycle stage using claim_lifecycle_stage facet. */
  stage?: InputMaybe<ClaimStageFilter>;
  /** Filter by the object’s `stageSortOrder` field. */
  stageSortOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `submittedDrg` field. */
  submittedDrg?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<IntFilter>;
  /** Filter by the object’s `versionGroup` field. */
  versionGroup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `workflowClaimStates` relation. */
  workflowClaimStates?: InputMaybe<BatchClaimToManyWorkflowClaimStateFilter>;
  /** Some related `workflowClaimStates` exist. */
  workflowClaimStatesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Grouping methods for `BatchClaim` for usage during aggregation. */
export enum BatchClaimGroupBy {
  ADMIT_DIAG = "ADMIT_DIAG",
  ADM_TYPE = "ADM_TYPE",
  AMOUNT_CHARGED = "AMOUNT_CHARGED",
  AMOUNT_REIMBURSED = "AMOUNT_REIMBURSED",
  APR_DRG = "APR_DRG",
  AUTHOR_ID = "AUTHOR_ID",
  BATCH_FILE_ID = "BATCH_FILE_ID",
  BILL_TYPE = "BILL_TYPE",
  CLAIM_TYPE = "CLAIM_TYPE",
  CLIENT_GROUP_NAME = "CLIENT_GROUP_NAME",
  CLIENT_ICN = "CLIENT_ICN",
  CLIENT_LINE_OF_BUSINESS = "CLIENT_LINE_OF_BUSINESS",
  CLIENT_PLAN_ID = "CLIENT_PLAN_ID",
  COMPUTATION_STRATEGY = "COMPUTATION_STRATEGY",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DATE_ADMIT = "DATE_ADMIT",
  DATE_ADMIT_TRUNCATED_TO_DAY = "DATE_ADMIT_TRUNCATED_TO_DAY",
  DATE_ADMIT_TRUNCATED_TO_HOUR = "DATE_ADMIT_TRUNCATED_TO_HOUR",
  DATE_DISCHARGE = "DATE_DISCHARGE",
  DATE_DISCHARGE_TRUNCATED_TO_DAY = "DATE_DISCHARGE_TRUNCATED_TO_DAY",
  DATE_DISCHARGE_TRUNCATED_TO_HOUR = "DATE_DISCHARGE_TRUNCATED_TO_HOUR",
  DATE_OF_SERVICE_END = "DATE_OF_SERVICE_END",
  DATE_OF_SERVICE_END_TRUNCATED_TO_DAY = "DATE_OF_SERVICE_END_TRUNCATED_TO_DAY",
  DATE_OF_SERVICE_END_TRUNCATED_TO_HOUR = "DATE_OF_SERVICE_END_TRUNCATED_TO_HOUR",
  DATE_OF_SERVICE_START = "DATE_OF_SERVICE_START",
  DATE_OF_SERVICE_START_TRUNCATED_TO_DAY = "DATE_OF_SERVICE_START_TRUNCATED_TO_DAY",
  DATE_OF_SERVICE_START_TRUNCATED_TO_HOUR = "DATE_OF_SERVICE_START_TRUNCATED_TO_HOUR",
  DIAG_1 = "DIAG_1",
  DIAG_2 = "DIAG_2",
  DIAG_3 = "DIAG_3",
  DIAG_4 = "DIAG_4",
  DIAG_5 = "DIAG_5",
  DIAG_6 = "DIAG_6",
  DIAG_7 = "DIAG_7",
  DIAG_8 = "DIAG_8",
  DIAG_9 = "DIAG_9",
  DIAG_10 = "DIAG_10",
  DIAG_11 = "DIAG_11",
  DIAG_12 = "DIAG_12",
  DIAG_13 = "DIAG_13",
  DIAG_14 = "DIAG_14",
  DIAG_15 = "DIAG_15",
  DIAG_16 = "DIAG_16",
  DIAG_17 = "DIAG_17",
  DIAG_18 = "DIAG_18",
  DIAG_19 = "DIAG_19",
  DIAG_20 = "DIAG_20",
  DIAG_21 = "DIAG_21",
  DIAG_22 = "DIAG_22",
  DIAG_23 = "DIAG_23",
  DIAG_24 = "DIAG_24",
  DISCHARGE_STATUS = "DISCHARGE_STATUS",
  DRG_CODE = "DRG_CODE",
  INSURER_ID = "INSURER_ID",
  OWNER_ID = "OWNER_ID",
  PAID_DATE = "PAID_DATE",
  PAID_DATE_TRUNCATED_TO_DAY = "PAID_DATE_TRUNCATED_TO_DAY",
  PAID_DATE_TRUNCATED_TO_HOUR = "PAID_DATE_TRUNCATED_TO_HOUR",
  PATIENT_CONTROL_NUMBER = "PATIENT_CONTROL_NUMBER",
  PATIENT_DOB = "PATIENT_DOB",
  PATIENT_DOB_TRUNCATED_TO_DAY = "PATIENT_DOB_TRUNCATED_TO_DAY",
  PATIENT_DOB_TRUNCATED_TO_HOUR = "PATIENT_DOB_TRUNCATED_TO_HOUR",
  PATIENT_GENDER = "PATIENT_GENDER",
  PATIENT_ID = "PATIENT_ID",
  PAYMENT_RATE = "PAYMENT_RATE",
  PERMITTED_INSURER_USERS = "PERMITTED_INSURER_USERS",
  POA_1 = "POA_1",
  POA_2 = "POA_2",
  POA_3 = "POA_3",
  POA_4 = "POA_4",
  POA_5 = "POA_5",
  POA_6 = "POA_6",
  POA_7 = "POA_7",
  POA_8 = "POA_8",
  POA_9 = "POA_9",
  POA_10 = "POA_10",
  POA_11 = "POA_11",
  POA_12 = "POA_12",
  POA_13 = "POA_13",
  POA_14 = "POA_14",
  POA_15 = "POA_15",
  POA_16 = "POA_16",
  POA_17 = "POA_17",
  POA_18 = "POA_18",
  POA_19 = "POA_19",
  POA_20 = "POA_20",
  POA_21 = "POA_21",
  POA_22 = "POA_22",
  POA_23 = "POA_23",
  POA_24 = "POA_24",
  POA_25 = "POA_25",
  PREPAY_DENY = "PREPAY_DENY",
  PREVIOUS_VERSION_ID = "PREVIOUS_VERSION_ID",
  PRINCIPAL_DIAG = "PRINCIPAL_DIAG",
  PRINCIPAL_POA = "PRINCIPAL_POA",
  PRINCIPAL_PROCEDURE_CODE = "PRINCIPAL_PROCEDURE_CODE",
  PROCEDURE_CODE_1 = "PROCEDURE_CODE_1",
  PROCEDURE_CODE_2 = "PROCEDURE_CODE_2",
  PROCEDURE_CODE_3 = "PROCEDURE_CODE_3",
  PROCEDURE_CODE_4 = "PROCEDURE_CODE_4",
  PROCEDURE_CODE_5 = "PROCEDURE_CODE_5",
  PROCEDURE_CODE_6 = "PROCEDURE_CODE_6",
  PROCEDURE_CODE_7 = "PROCEDURE_CODE_7",
  PROCEDURE_CODE_8 = "PROCEDURE_CODE_8",
  PROCEDURE_CODE_9 = "PROCEDURE_CODE_9",
  PROCEDURE_CODE_10 = "PROCEDURE_CODE_10",
  PROVIDER_ID = "PROVIDER_ID",
  SUBMITTED_DRG = "SUBMITTED_DRG",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
  VERSION = "VERSION",
  VERSION_GROUP = "VERSION_GROUP",
}

export type BatchClaimHavingAverageBatchClaimDocumentBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingAverageBatchClaimImproperPaymentCostArgsInput = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchClaimHavingAverageBatchClaimImproperPaymentCostInput = {
  args?: InputMaybe<BatchClaimHavingAverageBatchClaimImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimHavingAverageBatchClaimLifecycleSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingAverageBatchClaimOnHoldBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingAverageBatchClaimPhaseSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingAverageBatchClaimStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingAverageInput = {
  amountCharged?: InputMaybe<HavingFloatFilter>;
  amountReimbursed?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateAdmit?: InputMaybe<HavingDatetimeFilter>;
  dateDischarge?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  documentBlockerStageSortOrder?: InputMaybe<BatchClaimHavingAverageBatchClaimDocumentBlockerStageSortOrderInput>;
  improperPaymentCost?: InputMaybe<BatchClaimHavingAverageBatchClaimImproperPaymentCostInput>;
  lifecycleSortOrder?: InputMaybe<BatchClaimHavingAverageBatchClaimLifecycleSortOrderInput>;
  onHoldBlockerStageSortOrder?: InputMaybe<BatchClaimHavingAverageBatchClaimOnHoldBlockerStageSortOrderInput>;
  paidDate?: InputMaybe<HavingDatetimeFilter>;
  patientDob?: InputMaybe<HavingDatetimeFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  phaseSortOrder?: InputMaybe<BatchClaimHavingAverageBatchClaimPhaseSortOrderInput>;
  stageSortOrder?: InputMaybe<BatchClaimHavingAverageBatchClaimStageSortOrderInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingDistinctCountBatchClaimDocumentBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingDistinctCountBatchClaimImproperPaymentCostArgsInput =
  {
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type BatchClaimHavingDistinctCountBatchClaimImproperPaymentCostInput = {
  args?: InputMaybe<BatchClaimHavingDistinctCountBatchClaimImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimHavingDistinctCountBatchClaimLifecycleSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingDistinctCountBatchClaimOnHoldBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingDistinctCountBatchClaimPhaseSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingDistinctCountBatchClaimStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingDistinctCountInput = {
  amountCharged?: InputMaybe<HavingFloatFilter>;
  amountReimbursed?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateAdmit?: InputMaybe<HavingDatetimeFilter>;
  dateDischarge?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  documentBlockerStageSortOrder?: InputMaybe<BatchClaimHavingDistinctCountBatchClaimDocumentBlockerStageSortOrderInput>;
  improperPaymentCost?: InputMaybe<BatchClaimHavingDistinctCountBatchClaimImproperPaymentCostInput>;
  lifecycleSortOrder?: InputMaybe<BatchClaimHavingDistinctCountBatchClaimLifecycleSortOrderInput>;
  onHoldBlockerStageSortOrder?: InputMaybe<BatchClaimHavingDistinctCountBatchClaimOnHoldBlockerStageSortOrderInput>;
  paidDate?: InputMaybe<HavingDatetimeFilter>;
  patientDob?: InputMaybe<HavingDatetimeFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  phaseSortOrder?: InputMaybe<BatchClaimHavingDistinctCountBatchClaimPhaseSortOrderInput>;
  stageSortOrder?: InputMaybe<BatchClaimHavingDistinctCountBatchClaimStageSortOrderInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BatchClaim` aggregates. */
export type BatchClaimHavingInput = {
  AND?: InputMaybe<Array<BatchClaimHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimHavingInput>>;
  average?: InputMaybe<BatchClaimHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimHavingMaxInput>;
  min?: InputMaybe<BatchClaimHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimHavingVarianceSampleInput>;
};

export type BatchClaimHavingMaxBatchClaimDocumentBlockerStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingMaxBatchClaimImproperPaymentCostArgsInput = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchClaimHavingMaxBatchClaimImproperPaymentCostInput = {
  args?: InputMaybe<BatchClaimHavingMaxBatchClaimImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimHavingMaxBatchClaimLifecycleSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingMaxBatchClaimOnHoldBlockerStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingMaxBatchClaimPhaseSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingMaxBatchClaimStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingMaxInput = {
  amountCharged?: InputMaybe<HavingFloatFilter>;
  amountReimbursed?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateAdmit?: InputMaybe<HavingDatetimeFilter>;
  dateDischarge?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  documentBlockerStageSortOrder?: InputMaybe<BatchClaimHavingMaxBatchClaimDocumentBlockerStageSortOrderInput>;
  improperPaymentCost?: InputMaybe<BatchClaimHavingMaxBatchClaimImproperPaymentCostInput>;
  lifecycleSortOrder?: InputMaybe<BatchClaimHavingMaxBatchClaimLifecycleSortOrderInput>;
  onHoldBlockerStageSortOrder?: InputMaybe<BatchClaimHavingMaxBatchClaimOnHoldBlockerStageSortOrderInput>;
  paidDate?: InputMaybe<HavingDatetimeFilter>;
  patientDob?: InputMaybe<HavingDatetimeFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  phaseSortOrder?: InputMaybe<BatchClaimHavingMaxBatchClaimPhaseSortOrderInput>;
  stageSortOrder?: InputMaybe<BatchClaimHavingMaxBatchClaimStageSortOrderInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingMinBatchClaimDocumentBlockerStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingMinBatchClaimImproperPaymentCostArgsInput = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchClaimHavingMinBatchClaimImproperPaymentCostInput = {
  args?: InputMaybe<BatchClaimHavingMinBatchClaimImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimHavingMinBatchClaimLifecycleSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingMinBatchClaimOnHoldBlockerStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingMinBatchClaimPhaseSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingMinBatchClaimStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingMinInput = {
  amountCharged?: InputMaybe<HavingFloatFilter>;
  amountReimbursed?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateAdmit?: InputMaybe<HavingDatetimeFilter>;
  dateDischarge?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  documentBlockerStageSortOrder?: InputMaybe<BatchClaimHavingMinBatchClaimDocumentBlockerStageSortOrderInput>;
  improperPaymentCost?: InputMaybe<BatchClaimHavingMinBatchClaimImproperPaymentCostInput>;
  lifecycleSortOrder?: InputMaybe<BatchClaimHavingMinBatchClaimLifecycleSortOrderInput>;
  onHoldBlockerStageSortOrder?: InputMaybe<BatchClaimHavingMinBatchClaimOnHoldBlockerStageSortOrderInput>;
  paidDate?: InputMaybe<HavingDatetimeFilter>;
  patientDob?: InputMaybe<HavingDatetimeFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  phaseSortOrder?: InputMaybe<BatchClaimHavingMinBatchClaimPhaseSortOrderInput>;
  stageSortOrder?: InputMaybe<BatchClaimHavingMinBatchClaimStageSortOrderInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingStddevPopulationBatchClaimDocumentBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingStddevPopulationBatchClaimImproperPaymentCostArgsInput =
  {
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type BatchClaimHavingStddevPopulationBatchClaimImproperPaymentCostInput =
  {
    args?: InputMaybe<BatchClaimHavingStddevPopulationBatchClaimImproperPaymentCostArgsInput>;
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type BatchClaimHavingStddevPopulationBatchClaimLifecycleSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingStddevPopulationBatchClaimOnHoldBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingStddevPopulationBatchClaimPhaseSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingStddevPopulationBatchClaimStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingStddevPopulationInput = {
  amountCharged?: InputMaybe<HavingFloatFilter>;
  amountReimbursed?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateAdmit?: InputMaybe<HavingDatetimeFilter>;
  dateDischarge?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  documentBlockerStageSortOrder?: InputMaybe<BatchClaimHavingStddevPopulationBatchClaimDocumentBlockerStageSortOrderInput>;
  improperPaymentCost?: InputMaybe<BatchClaimHavingStddevPopulationBatchClaimImproperPaymentCostInput>;
  lifecycleSortOrder?: InputMaybe<BatchClaimHavingStddevPopulationBatchClaimLifecycleSortOrderInput>;
  onHoldBlockerStageSortOrder?: InputMaybe<BatchClaimHavingStddevPopulationBatchClaimOnHoldBlockerStageSortOrderInput>;
  paidDate?: InputMaybe<HavingDatetimeFilter>;
  patientDob?: InputMaybe<HavingDatetimeFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  phaseSortOrder?: InputMaybe<BatchClaimHavingStddevPopulationBatchClaimPhaseSortOrderInput>;
  stageSortOrder?: InputMaybe<BatchClaimHavingStddevPopulationBatchClaimStageSortOrderInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingStddevSampleBatchClaimDocumentBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingStddevSampleBatchClaimImproperPaymentCostArgsInput =
  {
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type BatchClaimHavingStddevSampleBatchClaimImproperPaymentCostInput = {
  args?: InputMaybe<BatchClaimHavingStddevSampleBatchClaimImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimHavingStddevSampleBatchClaimLifecycleSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingStddevSampleBatchClaimOnHoldBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingStddevSampleBatchClaimPhaseSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingStddevSampleBatchClaimStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingStddevSampleInput = {
  amountCharged?: InputMaybe<HavingFloatFilter>;
  amountReimbursed?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateAdmit?: InputMaybe<HavingDatetimeFilter>;
  dateDischarge?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  documentBlockerStageSortOrder?: InputMaybe<BatchClaimHavingStddevSampleBatchClaimDocumentBlockerStageSortOrderInput>;
  improperPaymentCost?: InputMaybe<BatchClaimHavingStddevSampleBatchClaimImproperPaymentCostInput>;
  lifecycleSortOrder?: InputMaybe<BatchClaimHavingStddevSampleBatchClaimLifecycleSortOrderInput>;
  onHoldBlockerStageSortOrder?: InputMaybe<BatchClaimHavingStddevSampleBatchClaimOnHoldBlockerStageSortOrderInput>;
  paidDate?: InputMaybe<HavingDatetimeFilter>;
  patientDob?: InputMaybe<HavingDatetimeFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  phaseSortOrder?: InputMaybe<BatchClaimHavingStddevSampleBatchClaimPhaseSortOrderInput>;
  stageSortOrder?: InputMaybe<BatchClaimHavingStddevSampleBatchClaimStageSortOrderInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingSumBatchClaimDocumentBlockerStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingSumBatchClaimImproperPaymentCostArgsInput = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchClaimHavingSumBatchClaimImproperPaymentCostInput = {
  args?: InputMaybe<BatchClaimHavingSumBatchClaimImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimHavingSumBatchClaimLifecycleSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingSumBatchClaimOnHoldBlockerStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingSumBatchClaimPhaseSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingSumBatchClaimStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingSumInput = {
  amountCharged?: InputMaybe<HavingFloatFilter>;
  amountReimbursed?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateAdmit?: InputMaybe<HavingDatetimeFilter>;
  dateDischarge?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  documentBlockerStageSortOrder?: InputMaybe<BatchClaimHavingSumBatchClaimDocumentBlockerStageSortOrderInput>;
  improperPaymentCost?: InputMaybe<BatchClaimHavingSumBatchClaimImproperPaymentCostInput>;
  lifecycleSortOrder?: InputMaybe<BatchClaimHavingSumBatchClaimLifecycleSortOrderInput>;
  onHoldBlockerStageSortOrder?: InputMaybe<BatchClaimHavingSumBatchClaimOnHoldBlockerStageSortOrderInput>;
  paidDate?: InputMaybe<HavingDatetimeFilter>;
  patientDob?: InputMaybe<HavingDatetimeFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  phaseSortOrder?: InputMaybe<BatchClaimHavingSumBatchClaimPhaseSortOrderInput>;
  stageSortOrder?: InputMaybe<BatchClaimHavingSumBatchClaimStageSortOrderInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingVariancePopulationBatchClaimDocumentBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingVariancePopulationBatchClaimImproperPaymentCostArgsInput =
  {
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type BatchClaimHavingVariancePopulationBatchClaimImproperPaymentCostInput =
  {
    args?: InputMaybe<BatchClaimHavingVariancePopulationBatchClaimImproperPaymentCostArgsInput>;
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type BatchClaimHavingVariancePopulationBatchClaimLifecycleSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingVariancePopulationBatchClaimOnHoldBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingVariancePopulationBatchClaimPhaseSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingVariancePopulationBatchClaimStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingVariancePopulationInput = {
  amountCharged?: InputMaybe<HavingFloatFilter>;
  amountReimbursed?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateAdmit?: InputMaybe<HavingDatetimeFilter>;
  dateDischarge?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  documentBlockerStageSortOrder?: InputMaybe<BatchClaimHavingVariancePopulationBatchClaimDocumentBlockerStageSortOrderInput>;
  improperPaymentCost?: InputMaybe<BatchClaimHavingVariancePopulationBatchClaimImproperPaymentCostInput>;
  lifecycleSortOrder?: InputMaybe<BatchClaimHavingVariancePopulationBatchClaimLifecycleSortOrderInput>;
  onHoldBlockerStageSortOrder?: InputMaybe<BatchClaimHavingVariancePopulationBatchClaimOnHoldBlockerStageSortOrderInput>;
  paidDate?: InputMaybe<HavingDatetimeFilter>;
  patientDob?: InputMaybe<HavingDatetimeFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  phaseSortOrder?: InputMaybe<BatchClaimHavingVariancePopulationBatchClaimPhaseSortOrderInput>;
  stageSortOrder?: InputMaybe<BatchClaimHavingVariancePopulationBatchClaimStageSortOrderInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingVarianceSampleBatchClaimDocumentBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingVarianceSampleBatchClaimImproperPaymentCostArgsInput =
  {
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type BatchClaimHavingVarianceSampleBatchClaimImproperPaymentCostInput = {
  args?: InputMaybe<BatchClaimHavingVarianceSampleBatchClaimImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimHavingVarianceSampleBatchClaimLifecycleSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingVarianceSampleBatchClaimOnHoldBlockerStageSortOrderInput =
  {
    filter?: InputMaybe<HavingIntFilter>;
  };

export type BatchClaimHavingVarianceSampleBatchClaimPhaseSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingVarianceSampleBatchClaimStageSortOrderInput = {
  filter?: InputMaybe<HavingIntFilter>;
};

export type BatchClaimHavingVarianceSampleInput = {
  amountCharged?: InputMaybe<HavingFloatFilter>;
  amountReimbursed?: InputMaybe<HavingFloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateAdmit?: InputMaybe<HavingDatetimeFilter>;
  dateDischarge?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  documentBlockerStageSortOrder?: InputMaybe<BatchClaimHavingVarianceSampleBatchClaimDocumentBlockerStageSortOrderInput>;
  improperPaymentCost?: InputMaybe<BatchClaimHavingVarianceSampleBatchClaimImproperPaymentCostInput>;
  lifecycleSortOrder?: InputMaybe<BatchClaimHavingVarianceSampleBatchClaimLifecycleSortOrderInput>;
  onHoldBlockerStageSortOrder?: InputMaybe<BatchClaimHavingVarianceSampleBatchClaimOnHoldBlockerStageSortOrderInput>;
  paidDate?: InputMaybe<HavingDatetimeFilter>;
  patientDob?: InputMaybe<HavingDatetimeFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  phaseSortOrder?: InputMaybe<BatchClaimHavingVarianceSampleBatchClaimPhaseSortOrderInput>;
  stageSortOrder?: InputMaybe<BatchClaimHavingVarianceSampleBatchClaimStageSortOrderInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

/** Input for the nested mutation of `insurer` in the `BatchClaimInput` mutation. */
export type BatchClaimInsurerIdFkeyInput = {
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByClientAbbreviation?: InputMaybe<InsurerInsurerUniqueClientAbbreviationConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectById?: InputMaybe<InsurerInsurerPkeyConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByName?: InputMaybe<InsurerInsurerUniqueNameConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<InsurerNodeIdConnect>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByClientAbbreviation?: InputMaybe<InsurerOnBatchClaimForBatchClaimInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateById?: InputMaybe<InsurerOnBatchClaimForBatchClaimInsurerIdFkeyUsingInsurerPkeyUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByName?: InputMaybe<InsurerOnBatchClaimForBatchClaimInsurerIdFkeyUsingInsurerUniqueNameUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaim` in the `InsurerInput` mutation. */
export type BatchClaimInsurerIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<Array<BatchClaimBatchClaimIcnKeyConnect>>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BatchClaimBatchClaimPkeyConnect>>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<
    Array<BatchClaimBatchClaimIdInsurerKeyConnect>
  >;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimNodeIdConnect>>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyUsingBatchClaimIcnKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyUsingBatchClaimPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyUsingBatchClaimIdInsurerKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<InsurerOnBatchClaimForBatchClaimInsurerIdFkeyNodeIdUpdate>
  >;
};

export type BatchClaimLine = Node & {
  __typename?: "BatchClaimLine";
  /** Reads and enables pagination through a set of `AuditFinding`. */
  auditFindings: AuditFindingsConnection;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimLine`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  /** Reads a single `BatchClaimLineComputedValue` that is related to this `BatchClaimLine`. */
  batchClaimLineComputedValueById?: Maybe<BatchClaimLineComputedValue>;
  /**
   * Reads and enables pagination through a set of `BatchClaimLineComputedValue`.
   * @deprecated Please use batchClaimLineComputedValueById instead
   */
  batchClaimLineComputedValuesById: BatchClaimLineComputedValuesConnection;
  /** Reads and enables pagination through a set of `BatchClaimLineItem`. */
  batchClaimLineItems: BatchClaimLineItemsConnection;
  /** The value supplied by client identifying the line.  This is not required by all clients, but for certain clients is required for correctly reporting findings. */
  clientLineNumber?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Datetime"]["output"];
  diag1?: Maybe<Scalars["String"]["output"]>;
  diag1Description?: Maybe<Scalars["String"]["output"]>;
  diag2?: Maybe<Scalars["String"]["output"]>;
  diag2Description?: Maybe<Scalars["String"]["output"]>;
  diag3?: Maybe<Scalars["String"]["output"]>;
  diag3Description?: Maybe<Scalars["String"]["output"]>;
  diag4?: Maybe<Scalars["String"]["output"]>;
  diag4Description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Captures the order of the batch_claim_line row from the source input.  Conceptually maps back to the original UBO4/CMS1500 line number. */
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  nonCovCharge?: Maybe<Scalars["Float"]["output"]>;
  nonCoveredAmount: Scalars["Float"]["output"];
  paymentRate: Scalars["Float"]["output"];
  procedureCode?: Maybe<Scalars["String"]["output"]>;
  procedureCodeModifier1?: Maybe<Scalars["String"]["output"]>;
  procedureCodeModifier2?: Maybe<Scalars["String"]["output"]>;
  procedureCodeModifier3?: Maybe<Scalars["String"]["output"]>;
  procedureCodeModifier4?: Maybe<Scalars["String"]["output"]>;
  procedureDescription?: Maybe<Scalars["String"]["output"]>;
  revCode: Scalars["String"]["output"];
  revCodeSrc?: Maybe<Scalars["String"]["output"]>;
  revDescription?: Maybe<Scalars["String"]["output"]>;
  /** Captures the UB row specific ServDate if available. (Example: Box 45 of UB04) */
  serviceDate?: Maybe<Scalars["Datetime"]["output"]>;
  unitAllowableCharge?: Maybe<Scalars["Float"]["output"]>;
  unitCharge?: Maybe<Scalars["Float"]["output"]>;
  units?: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

export type BatchClaimLineauditFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingCondition>;
  filter?: InputMaybe<AuditFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingsOrderBy>>;
};

export type BatchClaimLinebatchClaimLineComputedValuesByIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineComputedValueCondition>;
  filter?: InputMaybe<BatchClaimLineComputedValueFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineComputedValuesOrderBy>>;
};

export type BatchClaimLinebatchClaimLineItemsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemCondition>;
  filter?: InputMaybe<BatchClaimLineItemFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemsOrderBy>>;
};

export type BatchClaimLineAggregates = {
  __typename?: "BatchClaimLineAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BatchClaimLineAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimLineDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BatchClaimLineMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BatchClaimLineMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BatchClaimLineStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BatchClaimLineStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BatchClaimLineSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BatchClaimLineVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BatchClaimLineVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BatchClaimLine` object types. */
export type BatchClaimLineAggregatesFilter = {
  /** Mean average aggregate over matching `BatchClaimLine` objects. */
  average?: InputMaybe<BatchClaimLineAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BatchClaimLine` objects. */
  distinctCount?: InputMaybe<BatchClaimLineDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimLine` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimLineFilter>;
  /** Maximum aggregate over matching `BatchClaimLine` objects. */
  max?: InputMaybe<BatchClaimLineMaxAggregateFilter>;
  /** Minimum aggregate over matching `BatchClaimLine` objects. */
  min?: InputMaybe<BatchClaimLineMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BatchClaimLine` objects. */
  stddevPopulation?: InputMaybe<BatchClaimLineStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BatchClaimLine` objects. */
  stddevSample?: InputMaybe<BatchClaimLineStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BatchClaimLine` objects. */
  sum?: InputMaybe<BatchClaimLineSumAggregateFilter>;
  /** Population variance aggregate over matching `BatchClaimLine` objects. */
  variancePopulation?: InputMaybe<BatchClaimLineVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BatchClaimLine` objects. */
  varianceSample?: InputMaybe<BatchClaimLineVarianceSampleAggregateFilter>;
};

export type BatchClaimLineAverageAggregateFilter = {
  lineNumber?: InputMaybe<BigFloatFilter>;
  nonCovCharge?: InputMaybe<FloatFilter>;
  nonCoveredAmount?: InputMaybe<FloatFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  unitAllowableCharge?: InputMaybe<FloatFilter>;
  unitCharge?: InputMaybe<FloatFilter>;
  units?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimLineAverageAggregates = {
  __typename?: "BatchClaimLineAverageAggregates";
  /** Mean average of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of nonCovCharge across the matching connection */
  nonCovCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of nonCoveredAmount across the matching connection */
  nonCoveredAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of unitAllowableCharge across the matching connection */
  unitAllowableCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** Input for the nested mutation of `batchClaim` in the `BatchClaimLineInput` mutation. */
export type BatchClaimLineBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLine` in the `BatchClaimInput` mutation. */
export type BatchClaimLineBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLine` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BatchClaimLineBatchClaimLinePkeyConnect>>;
  /** The primary key(s) for `batchClaimLine` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimLineNodeIdConnect>>;
  /** The primary key(s) and patch data for `batchClaimLine` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimLineOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyUsingBatchClaimLinePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLine` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/** The fields on `batchClaimLine` to look up the row to connect. */
export type BatchClaimLineBatchClaimLinePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/**
 * ### Overview
 * Computes calculations over audit findings for a given service (revenue code) on the unified bill, for use both in reporting and in the frontend.
 */
export type BatchClaimLineComputedValue = Node & {
  __typename?: "BatchClaimLineComputedValue";
  /** Reads a single `BatchClaimLine` that is related to this `BatchClaimLineComputedValue`. */
  batchClaimLineById?: Maybe<BatchClaimLine>;
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  determinedDiscrepantAmount: Scalars["Float"]["output"];
  determinedSavings: Scalars["Float"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  potentialDiscrepantAmount: Scalars["Float"]["output"];
  potentialSavings: Scalars["Float"]["output"];
};

export type BatchClaimLineComputedValueAggregates = {
  __typename?: "BatchClaimLineComputedValueAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BatchClaimLineComputedValueAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimLineComputedValueDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BatchClaimLineComputedValueMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BatchClaimLineComputedValueMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BatchClaimLineComputedValueStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BatchClaimLineComputedValueStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BatchClaimLineComputedValueSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BatchClaimLineComputedValueVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BatchClaimLineComputedValueVarianceSampleAggregates>;
};

export type BatchClaimLineComputedValueAverageAggregates = {
  __typename?: "BatchClaimLineComputedValueAverageAggregates";
  /** Mean average of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

/** The fields on `batchClaimLineComputedValue` to look up the row to connect. */
export type BatchClaimLineComputedValueBatchClaimLineComputedValuesPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/**
 * A condition to be used against `BatchClaimLineComputedValue` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimLineComputedValueCondition = {
  /** Checks for equality with the object’s `determinedAdjustedAllowedAmount` field. */
  determinedAdjustedAllowedAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `determinedAdjustedBilledAmount` field. */
  determinedAdjustedBilledAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `determinedDiscrepantAmount` field. */
  determinedDiscrepantAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `determinedSavings` field. */
  determinedSavings?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `potentialAdjustedAllowedAmount` field. */
  potentialAdjustedAllowedAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `potentialAdjustedBilledAmount` field. */
  potentialAdjustedBilledAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `potentialDiscrepantAmount` field. */
  potentialDiscrepantAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `potentialSavings` field. */
  potentialSavings?: InputMaybe<Scalars["Float"]["input"]>;
};

export type BatchClaimLineComputedValueDistinctCountAggregates = {
  __typename?: "BatchClaimLineComputedValueDistinctCountAggregates";
  /** Distinct count of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimLineComputedValue` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimLineComputedValueFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimLineComputedValueFilter>>;
  /** Filter by the object’s `batchClaimLineById` relation. */
  batchClaimLineById?: InputMaybe<BatchClaimLineFilter>;
  /** Filter by the object’s `determinedAdjustedAllowedAmount` field. */
  determinedAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `determinedAdjustedBilledAmount` field. */
  determinedAdjustedBilledAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `determinedDiscrepantAmount` field. */
  determinedDiscrepantAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `determinedSavings` field. */
  determinedSavings?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimLineComputedValueFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimLineComputedValueFilter>>;
  /** Filter by the object’s `potentialAdjustedAllowedAmount` field. */
  potentialAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `potentialAdjustedBilledAmount` field. */
  potentialAdjustedBilledAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `potentialDiscrepantAmount` field. */
  potentialDiscrepantAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `potentialSavings` field. */
  potentialSavings?: InputMaybe<FloatFilter>;
};

export type BatchClaimLineComputedValueMaxAggregates = {
  __typename?: "BatchClaimLineComputedValueMaxAggregates";
  /** Maximum of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimLineComputedValueMinAggregates = {
  __typename?: "BatchClaimLineComputedValueMinAggregates";
  /** Minimum of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimLineComputedValueNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimLineComputedValue` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineComputedValueOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLine` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLine` being updated. */
    patch: BatchClaimLinePatch;
  };

/** The fields on `batchClaimLineComputedValue` to look up the row to update. */
export type BatchClaimLineComputedValueOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyUsingBatchClaimLineComputedValuesPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineComputedValue` being updated. */
    patch: updateBatchClaimLineComputedValueOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimLineComputedValue`. Fields that are set will be updated. */
export type BatchClaimLineComputedValuePatch = {
  batchClaimLineToId?: InputMaybe<BatchClaimLineComputedValuesIdFkeyInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimLineComputedValueStddevPopulationAggregates = {
  __typename?: "BatchClaimLineComputedValueStddevPopulationAggregates";
  /** Population standard deviation of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimLineComputedValueStddevSampleAggregates = {
  __typename?: "BatchClaimLineComputedValueStddevSampleAggregates";
  /** Sample standard deviation of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimLineComputedValueSumAggregates = {
  __typename?: "BatchClaimLineComputedValueSumAggregates";
  /** Sum of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount: Scalars["Float"]["output"];
  /** Sum of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount: Scalars["Float"]["output"];
  /** Sum of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount: Scalars["Float"]["output"];
  /** Sum of determinedSavings across the matching connection */
  determinedSavings: Scalars["Float"]["output"];
  /** Sum of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount: Scalars["Float"]["output"];
  /** Sum of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount: Scalars["Float"]["output"];
  /** Sum of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount: Scalars["Float"]["output"];
  /** Sum of potentialSavings across the matching connection */
  potentialSavings: Scalars["Float"]["output"];
};

export type BatchClaimLineComputedValueVariancePopulationAggregates = {
  __typename?: "BatchClaimLineComputedValueVariancePopulationAggregates";
  /** Population variance of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimLineComputedValueVarianceSampleAggregates = {
  __typename?: "BatchClaimLineComputedValueVarianceSampleAggregates";
  /** Sample variance of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

/** A connection to a list of `BatchClaimLineComputedValue` values. */
export type BatchClaimLineComputedValuesConnection = {
  __typename?: "BatchClaimLineComputedValuesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimLineComputedValueAggregates>;
  /** A list of edges which contains the `BatchClaimLineComputedValue` and cursor to aid in pagination. */
  edges: Array<BatchClaimLineComputedValuesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimLineComputedValueAggregates>>;
  /** A list of `BatchClaimLineComputedValue` objects. */
  nodes: Array<Maybe<BatchClaimLineComputedValue>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimLineComputedValue` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimLineComputedValue` values. */
export type BatchClaimLineComputedValuesConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimLineComputedValuesGroupBy>;
  having?: InputMaybe<BatchClaimLineComputedValuesHavingInput>;
};

/** A `BatchClaimLineComputedValue` edge in the connection. */
export type BatchClaimLineComputedValuesEdge = {
  __typename?: "BatchClaimLineComputedValuesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimLineComputedValue` at the end of the edge. */
  node?: Maybe<BatchClaimLineComputedValue>;
};

/** Grouping methods for `BatchClaimLineComputedValue` for usage during aggregation. */
export enum BatchClaimLineComputedValuesGroupBy {
  DETERMINED_ADJUSTED_ALLOWED_AMOUNT = "DETERMINED_ADJUSTED_ALLOWED_AMOUNT",
  DETERMINED_ADJUSTED_BILLED_AMOUNT = "DETERMINED_ADJUSTED_BILLED_AMOUNT",
  DETERMINED_DISCREPANT_AMOUNT = "DETERMINED_DISCREPANT_AMOUNT",
  DETERMINED_SAVINGS = "DETERMINED_SAVINGS",
  POTENTIAL_ADJUSTED_ALLOWED_AMOUNT = "POTENTIAL_ADJUSTED_ALLOWED_AMOUNT",
  POTENTIAL_ADJUSTED_BILLED_AMOUNT = "POTENTIAL_ADJUSTED_BILLED_AMOUNT",
  POTENTIAL_DISCREPANT_AMOUNT = "POTENTIAL_DISCREPANT_AMOUNT",
  POTENTIAL_SAVINGS = "POTENTIAL_SAVINGS",
}

export type BatchClaimLineComputedValuesHavingAverageInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineComputedValuesHavingDistinctCountInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

/** Conditions for `BatchClaimLineComputedValue` aggregates. */
export type BatchClaimLineComputedValuesHavingInput = {
  AND?: InputMaybe<Array<BatchClaimLineComputedValuesHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimLineComputedValuesHavingInput>>;
  average?: InputMaybe<BatchClaimLineComputedValuesHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimLineComputedValuesHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimLineComputedValuesHavingMaxInput>;
  min?: InputMaybe<BatchClaimLineComputedValuesHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimLineComputedValuesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimLineComputedValuesHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimLineComputedValuesHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimLineComputedValuesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimLineComputedValuesHavingVarianceSampleInput>;
};

export type BatchClaimLineComputedValuesHavingMaxInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineComputedValuesHavingMinInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineComputedValuesHavingStddevPopulationInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineComputedValuesHavingStddevSampleInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineComputedValuesHavingSumInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineComputedValuesHavingVariancePopulationInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineComputedValuesHavingVarianceSampleInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

/** Input for the nested mutation of `batchClaimLine` in the `BatchClaimLineComputedValueInput` mutation. */
export type BatchClaimLineComputedValuesIdFkeyInput = {
  /** The primary key(s) for `batchClaimLine` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimLineBatchClaimLinePkeyConnect>;
  /** The primary key(s) for `batchClaimLine` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimLineNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaimLine` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimLineOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyUsingBatchClaimLinePkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimLine` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineComputedValueOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLineComputedValue` in the `BatchClaimLineInput` mutation. */
export type BatchClaimLineComputedValuesIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLineComputedValue` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimLineComputedValueBatchClaimLineComputedValuesPkeyConnect>;
  /** The primary key(s) for `batchClaimLineComputedValue` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimLineComputedValueNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaimLineComputedValue` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimLineComputedValueOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyUsingBatchClaimLineComputedValuesPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimLineComputedValue` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyNodeIdUpdate>;
};

/** Methods to use when ordering `BatchClaimLineComputedValue`. */
export enum BatchClaimLineComputedValuesOrderBy {
  BATCH_CLAIM_LINE_BY_ID__BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_BY_ID__BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_BY_ID__BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_BY_ID__BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_BY_ID__CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_BY_ID__CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_BY_ID__CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_BY_ID__CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_BY_ID__CREATED_AT_ASC = "BATCH_CLAIM_LINE_BY_ID__CREATED_AT_ASC",
  BATCH_CLAIM_LINE_BY_ID__CREATED_AT_DESC = "BATCH_CLAIM_LINE_BY_ID__CREATED_AT_DESC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_1_ASC = "BATCH_CLAIM_LINE_BY_ID__DIAG_1_ASC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_1_DESC = "BATCH_CLAIM_LINE_BY_ID__DIAG_1_DESC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_ID__DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_ID__DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_2_ASC = "BATCH_CLAIM_LINE_BY_ID__DIAG_2_ASC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_2_DESC = "BATCH_CLAIM_LINE_BY_ID__DIAG_2_DESC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_ID__DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_ID__DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_3_ASC = "BATCH_CLAIM_LINE_BY_ID__DIAG_3_ASC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_3_DESC = "BATCH_CLAIM_LINE_BY_ID__DIAG_3_DESC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_ID__DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_ID__DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_4_ASC = "BATCH_CLAIM_LINE_BY_ID__DIAG_4_ASC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_4_DESC = "BATCH_CLAIM_LINE_BY_ID__DIAG_4_DESC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_ID__DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_ID__DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_ID__DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_ID__ID_ASC = "BATCH_CLAIM_LINE_BY_ID__ID_ASC",
  BATCH_CLAIM_LINE_BY_ID__ID_DESC = "BATCH_CLAIM_LINE_BY_ID__ID_DESC",
  BATCH_CLAIM_LINE_BY_ID__LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_BY_ID__LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_BY_ID__LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_BY_ID__LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_BY_ID__NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINE_BY_ID__NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_BY_ID__NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINE_BY_ID__NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_BY_ID__NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINE_BY_ID__NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINE_BY_ID__NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINE_BY_ID__NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINE_BY_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_LINE_BY_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINE_BY_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_LINE_BY_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_ID__PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_ID__PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_ID__REV_CODE_ASC = "BATCH_CLAIM_LINE_BY_ID__REV_CODE_ASC",
  BATCH_CLAIM_LINE_BY_ID__REV_CODE_DESC = "BATCH_CLAIM_LINE_BY_ID__REV_CODE_DESC",
  BATCH_CLAIM_LINE_BY_ID__REV_CODE_SRC_ASC = "BATCH_CLAIM_LINE_BY_ID__REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINE_BY_ID__REV_CODE_SRC_DESC = "BATCH_CLAIM_LINE_BY_ID__REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINE_BY_ID__REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_ID__REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_ID__REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_ID__REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_ID__SERVICE_DATE_ASC = "BATCH_CLAIM_LINE_BY_ID__SERVICE_DATE_ASC",
  BATCH_CLAIM_LINE_BY_ID__SERVICE_DATE_DESC = "BATCH_CLAIM_LINE_BY_ID__SERVICE_DATE_DESC",
  BATCH_CLAIM_LINE_BY_ID__UNITS_ASC = "BATCH_CLAIM_LINE_BY_ID__UNITS_ASC",
  BATCH_CLAIM_LINE_BY_ID__UNITS_DESC = "BATCH_CLAIM_LINE_BY_ID__UNITS_DESC",
  BATCH_CLAIM_LINE_BY_ID__UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINE_BY_ID__UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINE_BY_ID__UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINE_BY_ID__UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINE_BY_ID__UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_BY_ID__UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_BY_ID__UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_BY_ID__UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_BY_ID__UPDATED_AT_ASC = "BATCH_CLAIM_LINE_BY_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_BY_ID__UPDATED_AT_DESC = "BATCH_CLAIM_LINE_BY_ID__UPDATED_AT_DESC",
  DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  DETERMINED_ADJUSTED_BILLED_AMOUNT_ASC = "DETERMINED_ADJUSTED_BILLED_AMOUNT_ASC",
  DETERMINED_ADJUSTED_BILLED_AMOUNT_DESC = "DETERMINED_ADJUSTED_BILLED_AMOUNT_DESC",
  DETERMINED_DISCREPANT_AMOUNT_ASC = "DETERMINED_DISCREPANT_AMOUNT_ASC",
  DETERMINED_DISCREPANT_AMOUNT_DESC = "DETERMINED_DISCREPANT_AMOUNT_DESC",
  DETERMINED_SAVINGS_ASC = "DETERMINED_SAVINGS_ASC",
  DETERMINED_SAVINGS_DESC = "DETERMINED_SAVINGS_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  POTENTIAL_ADJUSTED_BILLED_AMOUNT_ASC = "POTENTIAL_ADJUSTED_BILLED_AMOUNT_ASC",
  POTENTIAL_ADJUSTED_BILLED_AMOUNT_DESC = "POTENTIAL_ADJUSTED_BILLED_AMOUNT_DESC",
  POTENTIAL_DISCREPANT_AMOUNT_ASC = "POTENTIAL_DISCREPANT_AMOUNT_ASC",
  POTENTIAL_DISCREPANT_AMOUNT_DESC = "POTENTIAL_DISCREPANT_AMOUNT_DESC",
  POTENTIAL_SAVINGS_ASC = "POTENTIAL_SAVINGS_ASC",
  POTENTIAL_SAVINGS_DESC = "POTENTIAL_SAVINGS_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

/**
 * A condition to be used against `BatchClaimLine` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimLineCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `clientLineNumber` field. */
  clientLineNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `diag1` field. */
  diag1?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag1Description` field. */
  diag1Description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag2` field. */
  diag2?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag2Description` field. */
  diag2Description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag3` field. */
  diag3?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag3Description` field. */
  diag3Description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag4` field. */
  diag4?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `diag4Description` field. */
  diag4Description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `nonCovCharge` field. */
  nonCovCharge?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `nonCoveredAmount` field. */
  nonCoveredAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `paymentRate` field. */
  paymentRate?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `procedureCode` field. */
  procedureCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCodeModifier1` field. */
  procedureCodeModifier1?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCodeModifier2` field. */
  procedureCodeModifier2?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCodeModifier3` field. */
  procedureCodeModifier3?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCodeModifier4` field. */
  procedureCodeModifier4?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureDescription` field. */
  procedureDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `revCode` field. */
  revCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `revCodeSrc` field. */
  revCodeSrc?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `revDescription` field. */
  revDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `serviceDate` field. */
  serviceDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `unitAllowableCharge` field. */
  unitAllowableCharge?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `unitCharge` field. */
  unitCharge?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `units` field. */
  units?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type BatchClaimLineDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  clientLineNumber?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  diag1?: InputMaybe<BigIntFilter>;
  diag1Description?: InputMaybe<BigIntFilter>;
  diag2?: InputMaybe<BigIntFilter>;
  diag2Description?: InputMaybe<BigIntFilter>;
  diag3?: InputMaybe<BigIntFilter>;
  diag3Description?: InputMaybe<BigIntFilter>;
  diag4?: InputMaybe<BigIntFilter>;
  diag4Description?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  lineNumber?: InputMaybe<BigIntFilter>;
  nonCovCharge?: InputMaybe<BigIntFilter>;
  nonCoveredAmount?: InputMaybe<BigIntFilter>;
  paymentRate?: InputMaybe<BigIntFilter>;
  procedureCode?: InputMaybe<BigIntFilter>;
  procedureCodeModifier1?: InputMaybe<BigIntFilter>;
  procedureCodeModifier2?: InputMaybe<BigIntFilter>;
  procedureCodeModifier3?: InputMaybe<BigIntFilter>;
  procedureCodeModifier4?: InputMaybe<BigIntFilter>;
  procedureDescription?: InputMaybe<BigIntFilter>;
  revCode?: InputMaybe<BigIntFilter>;
  revCodeSrc?: InputMaybe<BigIntFilter>;
  revDescription?: InputMaybe<BigIntFilter>;
  serviceDate?: InputMaybe<BigIntFilter>;
  unitAllowableCharge?: InputMaybe<BigIntFilter>;
  unitCharge?: InputMaybe<BigIntFilter>;
  units?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type BatchClaimLineDistinctCountAggregates = {
  __typename?: "BatchClaimLineDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientLineNumber across the matching connection */
  clientLineNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag1 across the matching connection */
  diag1?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag1Description across the matching connection */
  diag1Description?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag2 across the matching connection */
  diag2?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag2Description across the matching connection */
  diag2Description?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag3 across the matching connection */
  diag3?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag3Description across the matching connection */
  diag3Description?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag4 across the matching connection */
  diag4?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of diag4Description across the matching connection */
  diag4Description?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of nonCovCharge across the matching connection */
  nonCovCharge?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of nonCoveredAmount across the matching connection */
  nonCoveredAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode across the matching connection */
  procedureCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCodeModifier1 across the matching connection */
  procedureCodeModifier1?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCodeModifier2 across the matching connection */
  procedureCodeModifier2?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCodeModifier3 across the matching connection */
  procedureCodeModifier3?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCodeModifier4 across the matching connection */
  procedureCodeModifier4?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureDescription across the matching connection */
  procedureDescription?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of revCode across the matching connection */
  revCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of revCodeSrc across the matching connection */
  revCodeSrc?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of revDescription across the matching connection */
  revDescription?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of serviceDate across the matching connection */
  serviceDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of unitAllowableCharge across the matching connection */
  unitAllowableCharge?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of units across the matching connection */
  units?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimLine` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimLineFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimLineFilter>>;
  /** Filter by the object’s `auditFindings` relation. */
  auditFindings?: InputMaybe<BatchClaimLineToManyAuditFindingFilter>;
  /** Some related `auditFindings` exist. */
  auditFindingsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaimLineComputedValueById` relation. */
  batchClaimLineComputedValueById?: InputMaybe<BatchClaimLineComputedValueFilter>;
  /** A related `batchClaimLineComputedValueById` exists. */
  batchClaimLineComputedValueByIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `batchClaimLineItems` relation. */
  batchClaimLineItems?: InputMaybe<BatchClaimLineToManyBatchClaimLineItemFilter>;
  /** Some related `batchClaimLineItems` exist. */
  batchClaimLineItemsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `clientLineNumber` field. */
  clientLineNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `diag1` field. */
  diag1?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag1Description` field. */
  diag1Description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag2` field. */
  diag2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag2Description` field. */
  diag2Description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag3` field. */
  diag3?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag3Description` field. */
  diag3Description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag4` field. */
  diag4?: InputMaybe<StringFilter>;
  /** Filter by the object’s `diag4Description` field. */
  diag4Description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nonCovCharge` field. */
  nonCovCharge?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `nonCoveredAmount` field. */
  nonCoveredAmount?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimLineFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimLineFilter>>;
  /** Filter by the object’s `paymentRate` field. */
  paymentRate?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `procedureCode` field. */
  procedureCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCodeModifier1` field. */
  procedureCodeModifier1?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCodeModifier2` field. */
  procedureCodeModifier2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCodeModifier3` field. */
  procedureCodeModifier3?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCodeModifier4` field. */
  procedureCodeModifier4?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureDescription` field. */
  procedureDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `revCode` field. */
  revCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `revCodeSrc` field. */
  revCodeSrc?: InputMaybe<StringFilter>;
  /** Filter by the object’s `revDescription` field. */
  revDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceDate` field. */
  serviceDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `unitAllowableCharge` field. */
  unitAllowableCharge?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `unitCharge` field. */
  unitCharge?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `units` field. */
  units?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BatchClaimLine` for usage during aggregation. */
export enum BatchClaimLineGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CLIENT_LINE_NUMBER = "CLIENT_LINE_NUMBER",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DIAG_1 = "DIAG_1",
  DIAG_1_DESCRIPTION = "DIAG_1_DESCRIPTION",
  DIAG_2 = "DIAG_2",
  DIAG_2_DESCRIPTION = "DIAG_2_DESCRIPTION",
  DIAG_3 = "DIAG_3",
  DIAG_3_DESCRIPTION = "DIAG_3_DESCRIPTION",
  DIAG_4 = "DIAG_4",
  DIAG_4_DESCRIPTION = "DIAG_4_DESCRIPTION",
  LINE_NUMBER = "LINE_NUMBER",
  NON_COVERED_AMOUNT = "NON_COVERED_AMOUNT",
  NON_COV_CHARGE = "NON_COV_CHARGE",
  PAYMENT_RATE = "PAYMENT_RATE",
  PROCEDURE_CODE = "PROCEDURE_CODE",
  PROCEDURE_CODE_MODIFIER_1 = "PROCEDURE_CODE_MODIFIER_1",
  PROCEDURE_CODE_MODIFIER_2 = "PROCEDURE_CODE_MODIFIER_2",
  PROCEDURE_CODE_MODIFIER_3 = "PROCEDURE_CODE_MODIFIER_3",
  PROCEDURE_CODE_MODIFIER_4 = "PROCEDURE_CODE_MODIFIER_4",
  PROCEDURE_DESCRIPTION = "PROCEDURE_DESCRIPTION",
  REV_CODE = "REV_CODE",
  REV_CODE_SRC = "REV_CODE_SRC",
  REV_DESCRIPTION = "REV_DESCRIPTION",
  SERVICE_DATE = "SERVICE_DATE",
  SERVICE_DATE_TRUNCATED_TO_DAY = "SERVICE_DATE_TRUNCATED_TO_DAY",
  SERVICE_DATE_TRUNCATED_TO_HOUR = "SERVICE_DATE_TRUNCATED_TO_HOUR",
  UNITS = "UNITS",
  UNIT_ALLOWABLE_CHARGE = "UNIT_ALLOWABLE_CHARGE",
  UNIT_CHARGE = "UNIT_CHARGE",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type BatchClaimLineHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  nonCovCharge?: InputMaybe<HavingFloatFilter>;
  nonCoveredAmount?: InputMaybe<HavingFloatFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  serviceDate?: InputMaybe<HavingDatetimeFilter>;
  unitAllowableCharge?: InputMaybe<HavingFloatFilter>;
  unitCharge?: InputMaybe<HavingFloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  nonCovCharge?: InputMaybe<HavingFloatFilter>;
  nonCoveredAmount?: InputMaybe<HavingFloatFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  serviceDate?: InputMaybe<HavingDatetimeFilter>;
  unitAllowableCharge?: InputMaybe<HavingFloatFilter>;
  unitCharge?: InputMaybe<HavingFloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimLine` aggregates. */
export type BatchClaimLineHavingInput = {
  AND?: InputMaybe<Array<BatchClaimLineHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimLineHavingInput>>;
  average?: InputMaybe<BatchClaimLineHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimLineHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimLineHavingMaxInput>;
  min?: InputMaybe<BatchClaimLineHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimLineHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimLineHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimLineHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimLineHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimLineHavingVarianceSampleInput>;
};

export type BatchClaimLineHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  nonCovCharge?: InputMaybe<HavingFloatFilter>;
  nonCoveredAmount?: InputMaybe<HavingFloatFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  serviceDate?: InputMaybe<HavingDatetimeFilter>;
  unitAllowableCharge?: InputMaybe<HavingFloatFilter>;
  unitCharge?: InputMaybe<HavingFloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  nonCovCharge?: InputMaybe<HavingFloatFilter>;
  nonCoveredAmount?: InputMaybe<HavingFloatFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  serviceDate?: InputMaybe<HavingDatetimeFilter>;
  unitAllowableCharge?: InputMaybe<HavingFloatFilter>;
  unitCharge?: InputMaybe<HavingFloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  nonCovCharge?: InputMaybe<HavingFloatFilter>;
  nonCoveredAmount?: InputMaybe<HavingFloatFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  serviceDate?: InputMaybe<HavingDatetimeFilter>;
  unitAllowableCharge?: InputMaybe<HavingFloatFilter>;
  unitCharge?: InputMaybe<HavingFloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  nonCovCharge?: InputMaybe<HavingFloatFilter>;
  nonCoveredAmount?: InputMaybe<HavingFloatFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  serviceDate?: InputMaybe<HavingDatetimeFilter>;
  unitAllowableCharge?: InputMaybe<HavingFloatFilter>;
  unitCharge?: InputMaybe<HavingFloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  nonCovCharge?: InputMaybe<HavingFloatFilter>;
  nonCoveredAmount?: InputMaybe<HavingFloatFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  serviceDate?: InputMaybe<HavingDatetimeFilter>;
  unitAllowableCharge?: InputMaybe<HavingFloatFilter>;
  unitCharge?: InputMaybe<HavingFloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  nonCovCharge?: InputMaybe<HavingFloatFilter>;
  nonCoveredAmount?: InputMaybe<HavingFloatFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  serviceDate?: InputMaybe<HavingDatetimeFilter>;
  unitAllowableCharge?: InputMaybe<HavingFloatFilter>;
  unitCharge?: InputMaybe<HavingFloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  nonCovCharge?: InputMaybe<HavingFloatFilter>;
  nonCoveredAmount?: InputMaybe<HavingFloatFilter>;
  paymentRate?: InputMaybe<HavingFloatFilter>;
  serviceDate?: InputMaybe<HavingDatetimeFilter>;
  unitAllowableCharge?: InputMaybe<HavingFloatFilter>;
  unitCharge?: InputMaybe<HavingFloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimLine` */
export type BatchClaimLineInput = {
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInverseInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineComputedValueUsingId?: InputMaybe<BatchClaimLineComputedValuesIdFkeyInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInverseInput>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInput>;
  /** The value supplied by client identifying the line.  This is not required by all clients, but for certain clients is required for correctly reporting findings. */
  clientLineNumber?: InputMaybe<Scalars["String"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  diag1?: InputMaybe<Scalars["String"]["input"]>;
  diag1Description?: InputMaybe<Scalars["String"]["input"]>;
  diag2?: InputMaybe<Scalars["String"]["input"]>;
  diag2Description?: InputMaybe<Scalars["String"]["input"]>;
  diag3?: InputMaybe<Scalars["String"]["input"]>;
  diag3Description?: InputMaybe<Scalars["String"]["input"]>;
  diag4?: InputMaybe<Scalars["String"]["input"]>;
  diag4Description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Captures the order of the batch_claim_line row from the source input.  Conceptually maps back to the original UBO4/CMS1500 line number. */
  lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
  nonCovCharge?: InputMaybe<Scalars["Float"]["input"]>;
  nonCoveredAmount?: InputMaybe<Scalars["Float"]["input"]>;
  paymentRate?: InputMaybe<Scalars["Float"]["input"]>;
  procedureCode?: InputMaybe<Scalars["String"]["input"]>;
  procedureCodeModifier1?: InputMaybe<Scalars["String"]["input"]>;
  procedureCodeModifier2?: InputMaybe<Scalars["String"]["input"]>;
  procedureCodeModifier3?: InputMaybe<Scalars["String"]["input"]>;
  procedureCodeModifier4?: InputMaybe<Scalars["String"]["input"]>;
  procedureDescription?: InputMaybe<Scalars["String"]["input"]>;
  revCode: Scalars["String"]["input"];
  revCodeSrc?: InputMaybe<Scalars["String"]["input"]>;
  revDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** Captures the UB row specific ServDate if available. (Example: Box 45 of UB04) */
  serviceDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  unitAllowableCharge?: InputMaybe<Scalars["Float"]["input"]>;
  unitCharge?: InputMaybe<Scalars["Float"]["input"]>;
  units?: InputMaybe<Scalars["Int"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type BatchClaimLineItem = Node & {
  __typename?: "BatchClaimLineItem";
  /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
  alaRowId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `AuditorUser` that is related to this `BatchClaimLineItem`. */
  author?: Maybe<AuditorUser>;
  authorId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimLineItem`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `BatchClaimLine` that is related to this `BatchClaimLineItem`. */
  batchClaimLine?: Maybe<BatchClaimLine>;
  batchClaimLineId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `BatchClaimLineItemAudit`. */
  batchClaimLineItemAudits: BatchClaimLineItemAuditsConnection;
  /** Reads a single `BatchClaimLineItemComputedValue` that is related to this `BatchClaimLineItem`. */
  batchClaimLineItemComputedValueById?: Maybe<BatchClaimLineItemComputedValue>;
  /**
   * Reads and enables pagination through a set of `BatchClaimLineItemComputedValue`.
   * @deprecated Please use batchClaimLineItemComputedValueById instead
   */
  batchClaimLineItemComputedValuesById: BatchClaimLineItemComputedValuesConnection;
  /** Reads and enables pagination through a set of `BatchClaimLineItemNnIbLine`. */
  batchClaimLineItemNnIbLines: BatchClaimLineItemNnIbLinesConnection;
  createdAt: Scalars["Datetime"]["output"];
  dateOfServiceEnd?: Maybe<Scalars["Datetime"]["output"]>;
  dateOfServiceStart: Scalars["Datetime"]["output"];
  description: Scalars["String"]["output"];
  ibLineId?: Maybe<Scalars["UUID"]["output"]>;
  ibLineVersionFingerprint?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  itemNumber?: Maybe<Scalars["String"]["output"]>;
  /** # Represents the order of the IB line in the source CSV input. */
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  originalBilledAmount?: Maybe<Scalars["BigFloat"]["output"]>;
  /**
   * ### original_version_id
   *  Original version id, used in versioning
   */
  originalVersionId?: Maybe<Scalars["UUID"]["output"]>;
  /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
  pageNumber?: Maybe<Scalars["Int"]["output"]>;
  /**
   * ### previous_version_id
   *  Previous version id, used in versioning
   */
  previousVersionId?: Maybe<Scalars["UUID"]["output"]>;
  procedureCode?: Maybe<Scalars["String"]["output"]>;
  procedureCodeModifier?: Maybe<Scalars["String"]["output"]>;
  revCode: Scalars["String"]["output"];
  /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
  s3InputSource?: Maybe<Scalars["String"]["output"]>;
  /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
  tableNumber?: Maybe<Scalars["Int"]["output"]>;
  unitCharge: Scalars["BigFloat"]["output"];
  units: Scalars["Int"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
  /**
   * ### version_fingerprint
   *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
   */
  versionFingerprint?: Maybe<Scalars["UUID"]["output"]>;
};

export type BatchClaimLineItembatchClaimLineItemAuditsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemAuditCondition>;
  filter?: InputMaybe<BatchClaimLineItemAuditFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemAuditsOrderBy>>;
};

export type BatchClaimLineItembatchClaimLineItemComputedValuesByIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemComputedValueCondition>;
  filter?: InputMaybe<BatchClaimLineItemComputedValueFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemComputedValuesOrderBy>>;
};

export type BatchClaimLineItembatchClaimLineItemNnIbLinesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemNnIbLineCondition>;
  filter?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemNnIbLinesOrderBy>>;
};

export type BatchClaimLineItemAggregates = {
  __typename?: "BatchClaimLineItemAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BatchClaimLineItemAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimLineItemDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BatchClaimLineItemMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BatchClaimLineItemMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BatchClaimLineItemStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BatchClaimLineItemStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BatchClaimLineItemSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BatchClaimLineItemVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BatchClaimLineItemVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BatchClaimLineItem` object types. */
export type BatchClaimLineItemAggregatesFilter = {
  /** Mean average aggregate over matching `BatchClaimLineItem` objects. */
  average?: InputMaybe<BatchClaimLineItemAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BatchClaimLineItem` objects. */
  distinctCount?: InputMaybe<BatchClaimLineItemDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimLineItem` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimLineItemFilter>;
  /** Maximum aggregate over matching `BatchClaimLineItem` objects. */
  max?: InputMaybe<BatchClaimLineItemMaxAggregateFilter>;
  /** Minimum aggregate over matching `BatchClaimLineItem` objects. */
  min?: InputMaybe<BatchClaimLineItemMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BatchClaimLineItem` objects. */
  stddevPopulation?: InputMaybe<BatchClaimLineItemStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BatchClaimLineItem` objects. */
  stddevSample?: InputMaybe<BatchClaimLineItemStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BatchClaimLineItem` objects. */
  sum?: InputMaybe<BatchClaimLineItemSumAggregateFilter>;
  /** Population variance aggregate over matching `BatchClaimLineItem` objects. */
  variancePopulation?: InputMaybe<BatchClaimLineItemVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BatchClaimLineItem` objects. */
  varianceSample?: InputMaybe<BatchClaimLineItemVarianceSampleAggregateFilter>;
};

export type BatchClaimLineItemAudit = Node & {
  __typename?: "BatchClaimLineItemAudit";
  /** Reads a single `AuditFinding` that is related to this `BatchClaimLineItemAudit`. */
  auditFinding?: Maybe<AuditFinding>;
  auditFindingId: Scalars["UUID"]["output"];
  /** Reads a single `AuditorUser` that is related to this `BatchClaimLineItemAudit`. */
  author?: Maybe<AuditorUser>;
  authorId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `BatchClaimLineItem` that is related to this `BatchClaimLineItemAudit`. */
  batchClaimLineItem?: Maybe<BatchClaimLineItem>;
  batchClaimLineItemId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type BatchClaimLineItemAuditAggregates = {
  __typename?: "BatchClaimLineItemAuditAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimLineItemAuditDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `BatchClaimLineItemAudit` object types. */
export type BatchClaimLineItemAuditAggregatesFilter = {
  /** Distinct count aggregate over matching `BatchClaimLineItemAudit` objects. */
  distinctCount?: InputMaybe<BatchClaimLineItemAuditDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimLineItemAudit` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimLineItemAuditFilter>;
};

/** The `auditFinding` to be created by this mutation. */
export type BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyAuditFindingCreateInput =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType: AuditFindingSeedType;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id: Scalars["UUID"]["input"];
    improperPaymentCost: Scalars["Float"]["input"];
    improperPaymentReason: Scalars["String"]["input"];
    improperPaymentUnitsCharged: Scalars["Int"]["input"];
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview: Scalars["Boolean"]["input"];
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** The `batchClaimLineItemAudit` to be created by this mutation. */
export type BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyBatchClaimLineItemAuditCreateInput =
  {
    auditFindingToAuditFindingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `auditFinding` in the `BatchClaimLineItemAuditInput` mutation. */
export type BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingAuditFindingClaimLinePkeyConnect>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingNodeIdConnect>;
  /** A `AuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyAuditFindingCreateInput>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyUsingAuditFindingClaimLinePkeyUpdate>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLineItemAudit` in the `AuditFindingInput` mutation. */
export type BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLineItemAudit` for the far side of the relationship. */
  connectByAuditFindingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemAuditAuditFindingIdUniqueConnect>;
  /** The primary key(s) for `batchClaimLineItemAudit` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemAuditPkeyConnect>;
  /** The primary key(s) for `batchClaimLineItemAudit` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimLineItemAuditNodeIdConnect>;
  /** A `BatchClaimLineItemAuditInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyBatchClaimLineItemAuditCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemAudit` for the far side of the relationship. */
  updateByAuditFindingId?: InputMaybe<BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyUsingBatchClaimLineItemAuditAuditFindingIdUniqueUpdate>;
  /** The primary key(s) and patch data for `batchClaimLineItemAudit` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyUsingBatchClaimLineItemAuditPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimLineItemAudit` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyNodeIdUpdate>;
};

/** The `batchClaimLineItemAudit` to be created by this mutation. */
export type BatchClaimLineItemAuditAuthorIdFkeyBatchClaimLineItemAuditCreateInput =
  {
    auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingToAuditFindingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInput>;
    batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `auditorUser` in the `BatchClaimLineItemAuditInput` mutation. */
export type BatchClaimLineItemAuditAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLineItemAudit` in the `AuditorUserInput` mutation. */
export type BatchClaimLineItemAuditAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLineItemAudit` for the far side of the relationship. */
  connectByAuditFindingId?: InputMaybe<
    Array<BatchClaimLineItemAuditBatchClaimLineItemAuditAuditFindingIdUniqueConnect>
  >;
  /** The primary key(s) for `batchClaimLineItemAudit` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimLineItemAuditBatchClaimLineItemAuditPkeyConnect>
  >;
  /** The primary key(s) for `batchClaimLineItemAudit` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimLineItemAuditNodeIdConnect>>;
  /** A `BatchClaimLineItemAuditInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimLineItemAuditAuthorIdFkeyBatchClaimLineItemAuditCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemAudit` for the far side of the relationship. */
  updateByAuditFindingId?: InputMaybe<
    Array<BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyUsingBatchClaimLineItemAuditAuditFindingIdUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemAudit` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyUsingBatchClaimLineItemAuditPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemAudit` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyNodeIdUpdate>
  >;
};

/** The fields on `batchClaimLineItemAudit` to look up the row to connect. */
export type BatchClaimLineItemAuditBatchClaimLineItemAuditAuditFindingIdUniqueConnect =
  {
    auditFindingId: Scalars["UUID"]["input"];
  };

/** The fields on `batchClaimLineItemAudit` to look up the row to connect. */
export type BatchClaimLineItemAuditBatchClaimLineItemAuditPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The `batchClaimLineItemAudit` to be created by this mutation. */
export type BatchClaimLineItemAuditBatchClaimLineItemIdFkeyBatchClaimLineItemAuditCreateInput =
  {
    auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingToAuditFindingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** The `batchClaimLineItem` to be created by this mutation. */
export type BatchClaimLineItemAuditBatchClaimLineItemIdFkeyBatchClaimLineItemCreateInput =
  {
    /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
    alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceStart: Scalars["Datetime"]["input"];
    description: Scalars["String"]["input"];
    ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    itemNumber?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the order of the IB line in the source CSV input. */
    lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
    originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
    /**
     * ### original_version_id
     *  Original version id, used in versioning
     */
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    /**
     * ### previous_version_id
     *  Previous version id, used in versioning
     */
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    procedureCode?: InputMaybe<Scalars["String"]["input"]>;
    procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
    revCode: Scalars["String"]["input"];
    /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
    s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
    tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
    unitCharge: Scalars["BigFloat"]["input"];
    units: Scalars["Int"]["input"];
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    /**
     * ### version_fingerprint
     *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
     */
    versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `batchClaimLineItem` in the `BatchClaimLineItemAuditInput` mutation. */
export type BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInput = {
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimLineItemBatchClaimLineItemPkeyConnect>;
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimLineItemNodeIdConnect>;
  /** A `BatchClaimLineItemInput` object that will be created and connected to this object. */
  create?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyBatchClaimLineItemCreateInput>;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimLineItemOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyUsingBatchClaimLineItemPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLineItemAudit` in the `BatchClaimLineItemInput` mutation. */
export type BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLineItemAudit` for the far side of the relationship. */
  connectByAuditFindingId?: InputMaybe<
    Array<BatchClaimLineItemAuditBatchClaimLineItemAuditAuditFindingIdUniqueConnect>
  >;
  /** The primary key(s) for `batchClaimLineItemAudit` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimLineItemAuditBatchClaimLineItemAuditPkeyConnect>
  >;
  /** The primary key(s) for `batchClaimLineItemAudit` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimLineItemAuditNodeIdConnect>>;
  /** A `BatchClaimLineItemAuditInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyBatchClaimLineItemAuditCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemAudit` for the far side of the relationship. */
  updateByAuditFindingId?: InputMaybe<
    Array<BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyUsingBatchClaimLineItemAuditAuditFindingIdUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemAudit` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyUsingBatchClaimLineItemAuditPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemAudit` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimLineItemOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `BatchClaimLineItemAudit` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimLineItemAuditCondition = {
  /** Checks for equality with the object’s `auditFindingId` field. */
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimLineItemId` field. */
  batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type BatchClaimLineItemAuditDistinctCountAggregateFilter = {
  auditFindingId?: InputMaybe<BigIntFilter>;
  authorId?: InputMaybe<BigIntFilter>;
  batchClaimLineItemId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type BatchClaimLineItemAuditDistinctCountAggregates = {
  __typename?: "BatchClaimLineItemAuditDistinctCountAggregates";
  /** Distinct count of auditFindingId across the matching connection */
  auditFindingId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimLineItemId across the matching connection */
  batchClaimLineItemId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimLineItemAudit` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimLineItemAuditFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimLineItemAuditFilter>>;
  /** Filter by the object’s `auditFinding` relation. */
  auditFinding?: InputMaybe<AuditFindingFilter>;
  /** Filter by the object’s `auditFindingId` field. */
  auditFindingId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** A related `author` exists. */
  authorExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaimLineItem` relation. */
  batchClaimLineItem?: InputMaybe<BatchClaimLineItemFilter>;
  /** Filter by the object’s `batchClaimLineItemId` field. */
  batchClaimLineItemId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimLineItemAuditFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimLineItemAuditFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BatchClaimLineItemAudit` for usage during aggregation. */
export enum BatchClaimLineItemAuditGroupBy {
  AUTHOR_ID = "AUTHOR_ID",
  BATCH_CLAIM_LINE_ITEM_ID = "BATCH_CLAIM_LINE_ITEM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type BatchClaimLineItemAuditHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemAuditHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimLineItemAudit` aggregates. */
export type BatchClaimLineItemAuditHavingInput = {
  AND?: InputMaybe<Array<BatchClaimLineItemAuditHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimLineItemAuditHavingInput>>;
  average?: InputMaybe<BatchClaimLineItemAuditHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimLineItemAuditHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimLineItemAuditHavingMaxInput>;
  min?: InputMaybe<BatchClaimLineItemAuditHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimLineItemAuditHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimLineItemAuditHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimLineItemAuditHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimLineItemAuditHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimLineItemAuditHavingVarianceSampleInput>;
};

export type BatchClaimLineItemAuditHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemAuditHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemAuditHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemAuditHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemAuditHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemAuditHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemAuditHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimLineItemAudit` */
export type BatchClaimLineItemAuditInput = {
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingToAuditFindingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimLineItemAuditNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimLineItemAudit` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `batchClaimLineItemAudit` to look up the row to update. */
export type BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyUsingBatchClaimLineItemAuditAuditFindingIdUniqueUpdate =
  {
    auditFindingId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
    patch: updateBatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyPatch;
  };

/** The fields on `batchClaimLineItemAudit` to look up the row to update. */
export type BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyUsingBatchClaimLineItemAuditPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
    patch: updateBatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `batchClaimLineItemAudit` to look up the row to update. */
export type BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyUsingBatchClaimLineItemAuditAuditFindingIdUniqueUpdate =
  {
    auditFindingId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
    patch: updateBatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyPatch;
  };

/** The fields on `batchClaimLineItemAudit` to look up the row to update. */
export type BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyUsingBatchClaimLineItemAuditPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
    patch: updateBatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItem` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: BatchClaimLineItemPatch;
  };

/** The fields on `batchClaimLineItemAudit` to look up the row to update. */
export type BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyUsingBatchClaimLineItemAuditAuditFindingIdUniqueUpdate =
  {
    auditFindingId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
    patch: updateBatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyPatch;
  };

/** The fields on `batchClaimLineItemAudit` to look up the row to update. */
export type BatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyUsingBatchClaimLineItemAuditPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
    patch: updateBatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimLineItemAudit`. Fields that are set will be updated. */
export type BatchClaimLineItemAuditPatch = {
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingToAuditFindingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInput>;
};

export type BatchClaimLineItemAuditV2 = {
  __typename?: "BatchClaimLineItemAuditV2";
  batchClaimLineItem?: Maybe<BatchClaimLineItemV2>;
};

/** A connection to a list of `BatchClaimLineItemAudit` values. */
export type BatchClaimLineItemAuditsConnection = {
  __typename?: "BatchClaimLineItemAuditsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimLineItemAuditAggregates>;
  /** A list of edges which contains the `BatchClaimLineItemAudit` and cursor to aid in pagination. */
  edges: Array<BatchClaimLineItemAuditsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimLineItemAuditAggregates>>;
  /** A list of `BatchClaimLineItemAudit` objects. */
  nodes: Array<Maybe<BatchClaimLineItemAudit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimLineItemAudit` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimLineItemAudit` values. */
export type BatchClaimLineItemAuditsConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimLineItemAuditGroupBy>;
  having?: InputMaybe<BatchClaimLineItemAuditHavingInput>;
};

/** A `BatchClaimLineItemAudit` edge in the connection. */
export type BatchClaimLineItemAuditsEdge = {
  __typename?: "BatchClaimLineItemAuditsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimLineItemAudit` at the end of the edge. */
  node?: Maybe<BatchClaimLineItemAudit>;
};

/** Methods to use when ordering `BatchClaimLineItemAudit`. */
export enum BatchClaimLineItemAuditsOrderBy {
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_DESC",
  AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_ID_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNITS_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNITS_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNITS_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNITS_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** The `batchClaimLineItem` to be created by this mutation. */
export type BatchClaimLineItemAuthorIdFkeyBatchClaimLineItemCreateInput = {
  /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
  alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
  batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateOfServiceStart: Scalars["Datetime"]["input"];
  description: Scalars["String"]["input"];
  ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  itemNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** # Represents the order of the IB line in the source CSV input. */
  lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
  originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /**
   * ### original_version_id
   *  Original version id, used in versioning
   */
  originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
  pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /**
   * ### previous_version_id
   *  Previous version id, used in versioning
   */
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  procedureCode?: InputMaybe<Scalars["String"]["input"]>;
  procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
  revCode: Scalars["String"]["input"];
  /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
  s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
  /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
  tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
  unitCharge: Scalars["BigFloat"]["input"];
  units: Scalars["Int"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /**
   * ### version_fingerprint
   *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
   */
  versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `BatchClaimLineItemInput` mutation. */
export type BatchClaimLineItemAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLineItem` in the `AuditorUserInput` mutation. */
export type BatchClaimLineItemAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimLineItemBatchClaimLineItemPkeyConnect>
  >;
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimLineItemNodeIdConnect>>;
  /** A `BatchClaimLineItemInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimLineItemAuthorIdFkeyBatchClaimLineItemCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyUsingBatchClaimLineItemPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyNodeIdUpdate>
  >;
};

export type BatchClaimLineItemAverageAggregateFilter = {
  lineNumber?: InputMaybe<BigFloatFilter>;
  originalBilledAmount?: InputMaybe<BigFloatFilter>;
  pageNumber?: InputMaybe<BigFloatFilter>;
  tableNumber?: InputMaybe<BigFloatFilter>;
  unitCharge?: InputMaybe<BigFloatFilter>;
  units?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimLineItemAverageAggregates = {
  __typename?: "BatchClaimLineItemAverageAggregates";
  /** Mean average of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of originalBilledAmount across the matching connection */
  originalBilledAmount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** The `batchClaimLineItem` to be created by this mutation. */
export type BatchClaimLineItemBatchClaimIdFkeyBatchClaimLineItemCreateInput = {
  /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
  alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
  batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateOfServiceStart: Scalars["Datetime"]["input"];
  description: Scalars["String"]["input"];
  ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  itemNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** # Represents the order of the IB line in the source CSV input. */
  lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
  originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /**
   * ### original_version_id
   *  Original version id, used in versioning
   */
  originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
  pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /**
   * ### previous_version_id
   *  Previous version id, used in versioning
   */
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  procedureCode?: InputMaybe<Scalars["String"]["input"]>;
  procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
  revCode: Scalars["String"]["input"];
  /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
  s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
  /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
  tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
  unitCharge: Scalars["BigFloat"]["input"];
  units: Scalars["Int"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /**
   * ### version_fingerprint
   *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
   */
  versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `batchClaim` in the `BatchClaimLineItemInput` mutation. */
export type BatchClaimLineItemBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLineItem` in the `BatchClaimInput` mutation. */
export type BatchClaimLineItemBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimLineItemBatchClaimLineItemPkeyConnect>
  >;
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimLineItemNodeIdConnect>>;
  /** A `BatchClaimLineItemInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimLineItemBatchClaimIdFkeyBatchClaimLineItemCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyUsingBatchClaimLineItemPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/** The `batchClaimLineItem` to be created by this mutation. */
export type BatchClaimLineItemBatchClaimLineIdFkeyBatchClaimLineItemCreateInput =
  {
    /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
    alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceStart: Scalars["Datetime"]["input"];
    description: Scalars["String"]["input"];
    ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    itemNumber?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the order of the IB line in the source CSV input. */
    lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
    originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
    /**
     * ### original_version_id
     *  Original version id, used in versioning
     */
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    /**
     * ### previous_version_id
     *  Previous version id, used in versioning
     */
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    procedureCode?: InputMaybe<Scalars["String"]["input"]>;
    procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
    revCode: Scalars["String"]["input"];
    /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
    s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
    tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
    unitCharge: Scalars["BigFloat"]["input"];
    units: Scalars["Int"]["input"];
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    /**
     * ### version_fingerprint
     *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
     */
    versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `batchClaimLine` in the `BatchClaimLineItemInput` mutation. */
export type BatchClaimLineItemBatchClaimLineIdFkeyInput = {
  /** The primary key(s) for `batchClaimLine` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimLineBatchClaimLinePkeyConnect>;
  /** The primary key(s) for `batchClaimLine` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimLineNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaimLine` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimLineOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyUsingBatchClaimLinePkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimLine` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLineItem` in the `BatchClaimLineInput` mutation. */
export type BatchClaimLineItemBatchClaimLineIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimLineItemBatchClaimLineItemPkeyConnect>
  >;
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimLineItemNodeIdConnect>>;
  /** A `BatchClaimLineItemInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimLineItemBatchClaimLineIdFkeyBatchClaimLineItemCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyUsingBatchClaimLineItemPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimLineOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyNodeIdUpdate>
  >;
};

/** The fields on `batchClaimLineItem` to look up the row to connect. */
export type BatchClaimLineItemBatchClaimLineItemPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/**
 * ### Overview
 * Computes calculations over the audit findings on an itemized bill for a given service, for use both in reporting and in the frontend.
 */
export type BatchClaimLineItemComputedValue = Node & {
  __typename?: "BatchClaimLineItemComputedValue";
  /** Reads a single `BatchClaimLineItem` that is related to this `BatchClaimLineItemComputedValue`. */
  batchClaimLineItemById?: Maybe<BatchClaimLineItem>;
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  determinedDiscrepantAmount: Scalars["Float"]["output"];
  determinedSavings: Scalars["Float"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  potentialDiscrepantAmount: Scalars["Float"]["output"];
  potentialSavings: Scalars["Float"]["output"];
};

export type BatchClaimLineItemComputedValueAggregates = {
  __typename?: "BatchClaimLineItemComputedValueAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BatchClaimLineItemComputedValueAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimLineItemComputedValueDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BatchClaimLineItemComputedValueMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BatchClaimLineItemComputedValueMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BatchClaimLineItemComputedValueStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BatchClaimLineItemComputedValueStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BatchClaimLineItemComputedValueSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BatchClaimLineItemComputedValueVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BatchClaimLineItemComputedValueVarianceSampleAggregates>;
};

export type BatchClaimLineItemComputedValueAverageAggregates = {
  __typename?: "BatchClaimLineItemComputedValueAverageAggregates";
  /** Mean average of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

/** The fields on `batchClaimLineItemComputedValue` to look up the row to connect. */
export type BatchClaimLineItemComputedValueBatchClaimLineItemComputedValuesPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/**
 * A condition to be used against `BatchClaimLineItemComputedValue` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimLineItemComputedValueCondition = {
  /** Checks for equality with the object’s `determinedAdjustedAllowedAmount` field. */
  determinedAdjustedAllowedAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `determinedAdjustedBilledAmount` field. */
  determinedAdjustedBilledAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `determinedDiscrepantAmount` field. */
  determinedDiscrepantAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `determinedSavings` field. */
  determinedSavings?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `potentialAdjustedAllowedAmount` field. */
  potentialAdjustedAllowedAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `potentialAdjustedBilledAmount` field. */
  potentialAdjustedBilledAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `potentialDiscrepantAmount` field. */
  potentialDiscrepantAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `potentialSavings` field. */
  potentialSavings?: InputMaybe<Scalars["Float"]["input"]>;
};

export type BatchClaimLineItemComputedValueDistinctCountAggregates = {
  __typename?: "BatchClaimLineItemComputedValueDistinctCountAggregates";
  /** Distinct count of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimLineItemComputedValue` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimLineItemComputedValueFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimLineItemComputedValueFilter>>;
  /** Filter by the object’s `batchClaimLineItemById` relation. */
  batchClaimLineItemById?: InputMaybe<BatchClaimLineItemFilter>;
  /** Filter by the object’s `determinedAdjustedAllowedAmount` field. */
  determinedAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `determinedAdjustedBilledAmount` field. */
  determinedAdjustedBilledAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `determinedDiscrepantAmount` field. */
  determinedDiscrepantAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `determinedSavings` field. */
  determinedSavings?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimLineItemComputedValueFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimLineItemComputedValueFilter>>;
  /** Filter by the object’s `potentialAdjustedAllowedAmount` field. */
  potentialAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `potentialAdjustedBilledAmount` field. */
  potentialAdjustedBilledAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `potentialDiscrepantAmount` field. */
  potentialDiscrepantAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `potentialSavings` field. */
  potentialSavings?: InputMaybe<FloatFilter>;
};

export type BatchClaimLineItemComputedValueMaxAggregates = {
  __typename?: "BatchClaimLineItemComputedValueMaxAggregates";
  /** Maximum of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimLineItemComputedValueMinAggregates = {
  __typename?: "BatchClaimLineItemComputedValueMinAggregates";
  /** Minimum of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimLineItemComputedValueNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimLineItemComputedValue` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemComputedValueOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItem` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: BatchClaimLineItemPatch;
  };

/** The fields on `batchClaimLineItemComputedValue` to look up the row to update. */
export type BatchClaimLineItemComputedValueOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyUsingBatchClaimLineItemComputedValuesPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemComputedValue` being updated. */
    patch: updateBatchClaimLineItemComputedValueOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimLineItemComputedValue`. Fields that are set will be updated. */
export type BatchClaimLineItemComputedValuePatch = {
  batchClaimLineItemToId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimLineItemComputedValueStddevPopulationAggregates = {
  __typename?: "BatchClaimLineItemComputedValueStddevPopulationAggregates";
  /** Population standard deviation of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimLineItemComputedValueStddevSampleAggregates = {
  __typename?: "BatchClaimLineItemComputedValueStddevSampleAggregates";
  /** Sample standard deviation of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimLineItemComputedValueSumAggregates = {
  __typename?: "BatchClaimLineItemComputedValueSumAggregates";
  /** Sum of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount: Scalars["Float"]["output"];
  /** Sum of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount: Scalars["Float"]["output"];
  /** Sum of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount: Scalars["Float"]["output"];
  /** Sum of determinedSavings across the matching connection */
  determinedSavings: Scalars["Float"]["output"];
  /** Sum of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount: Scalars["Float"]["output"];
  /** Sum of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount: Scalars["Float"]["output"];
  /** Sum of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount: Scalars["Float"]["output"];
  /** Sum of potentialSavings across the matching connection */
  potentialSavings: Scalars["Float"]["output"];
};

export type BatchClaimLineItemComputedValueVariancePopulationAggregates = {
  __typename?: "BatchClaimLineItemComputedValueVariancePopulationAggregates";
  /** Population variance of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimLineItemComputedValueVarianceSampleAggregates = {
  __typename?: "BatchClaimLineItemComputedValueVarianceSampleAggregates";
  /** Sample variance of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of determinedAdjustedBilledAmount across the matching connection */
  determinedAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of determinedSavings across the matching connection */
  determinedSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of potentialAdjustedBilledAmount across the matching connection */
  potentialAdjustedBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of potentialSavings across the matching connection */
  potentialSavings?: Maybe<Scalars["Float"]["output"]>;
};

/** A connection to a list of `BatchClaimLineItemComputedValue` values. */
export type BatchClaimLineItemComputedValuesConnection = {
  __typename?: "BatchClaimLineItemComputedValuesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimLineItemComputedValueAggregates>;
  /** A list of edges which contains the `BatchClaimLineItemComputedValue` and cursor to aid in pagination. */
  edges: Array<BatchClaimLineItemComputedValuesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimLineItemComputedValueAggregates>>;
  /** A list of `BatchClaimLineItemComputedValue` objects. */
  nodes: Array<Maybe<BatchClaimLineItemComputedValue>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimLineItemComputedValue` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimLineItemComputedValue` values. */
export type BatchClaimLineItemComputedValuesConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimLineItemComputedValuesGroupBy>;
  having?: InputMaybe<BatchClaimLineItemComputedValuesHavingInput>;
};

/** A `BatchClaimLineItemComputedValue` edge in the connection. */
export type BatchClaimLineItemComputedValuesEdge = {
  __typename?: "BatchClaimLineItemComputedValuesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimLineItemComputedValue` at the end of the edge. */
  node?: Maybe<BatchClaimLineItemComputedValue>;
};

/** Grouping methods for `BatchClaimLineItemComputedValue` for usage during aggregation. */
export enum BatchClaimLineItemComputedValuesGroupBy {
  DETERMINED_ADJUSTED_ALLOWED_AMOUNT = "DETERMINED_ADJUSTED_ALLOWED_AMOUNT",
  DETERMINED_ADJUSTED_BILLED_AMOUNT = "DETERMINED_ADJUSTED_BILLED_AMOUNT",
  DETERMINED_DISCREPANT_AMOUNT = "DETERMINED_DISCREPANT_AMOUNT",
  DETERMINED_SAVINGS = "DETERMINED_SAVINGS",
  POTENTIAL_ADJUSTED_ALLOWED_AMOUNT = "POTENTIAL_ADJUSTED_ALLOWED_AMOUNT",
  POTENTIAL_ADJUSTED_BILLED_AMOUNT = "POTENTIAL_ADJUSTED_BILLED_AMOUNT",
  POTENTIAL_DISCREPANT_AMOUNT = "POTENTIAL_DISCREPANT_AMOUNT",
  POTENTIAL_SAVINGS = "POTENTIAL_SAVINGS",
}

export type BatchClaimLineItemComputedValuesHavingAverageInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineItemComputedValuesHavingDistinctCountInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

/** Conditions for `BatchClaimLineItemComputedValue` aggregates. */
export type BatchClaimLineItemComputedValuesHavingInput = {
  AND?: InputMaybe<Array<BatchClaimLineItemComputedValuesHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimLineItemComputedValuesHavingInput>>;
  average?: InputMaybe<BatchClaimLineItemComputedValuesHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimLineItemComputedValuesHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimLineItemComputedValuesHavingMaxInput>;
  min?: InputMaybe<BatchClaimLineItemComputedValuesHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimLineItemComputedValuesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimLineItemComputedValuesHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimLineItemComputedValuesHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimLineItemComputedValuesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimLineItemComputedValuesHavingVarianceSampleInput>;
};

export type BatchClaimLineItemComputedValuesHavingMaxInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineItemComputedValuesHavingMinInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineItemComputedValuesHavingStddevPopulationInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineItemComputedValuesHavingStddevSampleInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineItemComputedValuesHavingSumInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineItemComputedValuesHavingVariancePopulationInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimLineItemComputedValuesHavingVarianceSampleInput = {
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  determinedSavings?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialAdjustedBilledAmount?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  potentialSavings?: InputMaybe<HavingFloatFilter>;
};

/** Input for the nested mutation of `batchClaimLineItem` in the `BatchClaimLineItemComputedValueInput` mutation. */
export type BatchClaimLineItemComputedValuesIdFkeyInput = {
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimLineItemBatchClaimLineItemPkeyConnect>;
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimLineItemNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimLineItemOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyUsingBatchClaimLineItemPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineItemComputedValueOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLineItemComputedValue` in the `BatchClaimLineItemInput` mutation. */
export type BatchClaimLineItemComputedValuesIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLineItemComputedValue` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimLineItemComputedValueBatchClaimLineItemComputedValuesPkeyConnect>;
  /** The primary key(s) for `batchClaimLineItemComputedValue` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimLineItemComputedValueNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaimLineItemComputedValue` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimLineItemComputedValueOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyUsingBatchClaimLineItemComputedValuesPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimLineItemComputedValue` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineItemOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyNodeIdUpdate>;
};

/** Methods to use when ordering `BatchClaimLineItemComputedValue`. */
export enum BatchClaimLineItemComputedValuesOrderBy {
  BATCH_CLAIM_LINE_ITEM_BY_ID__ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__UNITS_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__UNITS_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__UNITS_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__UNITS_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_ID__VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_ID__VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_ID__VERSION_FINGERPRINT_DESC",
  DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  DETERMINED_ADJUSTED_BILLED_AMOUNT_ASC = "DETERMINED_ADJUSTED_BILLED_AMOUNT_ASC",
  DETERMINED_ADJUSTED_BILLED_AMOUNT_DESC = "DETERMINED_ADJUSTED_BILLED_AMOUNT_DESC",
  DETERMINED_DISCREPANT_AMOUNT_ASC = "DETERMINED_DISCREPANT_AMOUNT_ASC",
  DETERMINED_DISCREPANT_AMOUNT_DESC = "DETERMINED_DISCREPANT_AMOUNT_DESC",
  DETERMINED_SAVINGS_ASC = "DETERMINED_SAVINGS_ASC",
  DETERMINED_SAVINGS_DESC = "DETERMINED_SAVINGS_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  POTENTIAL_ADJUSTED_BILLED_AMOUNT_ASC = "POTENTIAL_ADJUSTED_BILLED_AMOUNT_ASC",
  POTENTIAL_ADJUSTED_BILLED_AMOUNT_DESC = "POTENTIAL_ADJUSTED_BILLED_AMOUNT_DESC",
  POTENTIAL_DISCREPANT_AMOUNT_ASC = "POTENTIAL_DISCREPANT_AMOUNT_ASC",
  POTENTIAL_DISCREPANT_AMOUNT_DESC = "POTENTIAL_DISCREPANT_AMOUNT_DESC",
  POTENTIAL_SAVINGS_ASC = "POTENTIAL_SAVINGS_ASC",
  POTENTIAL_SAVINGS_DESC = "POTENTIAL_SAVINGS_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

/**
 * A condition to be used against `BatchClaimLineItem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimLineItemCondition = {
  /** Checks for equality with the object’s `alaRowId` field. */
  alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimLineId` field. */
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateOfServiceEnd` field. */
  dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateOfServiceStart` field. */
  dateOfServiceStart?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `ibLineId` field. */
  ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `ibLineVersionFingerprint` field. */
  ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `itemNumber` field. */
  itemNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `originalBilledAmount` field. */
  originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Checks for equality with the object’s `originalVersionId` field. */
  originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `previousVersionId` field. */
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `procedureCode` field. */
  procedureCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `procedureCodeModifier` field. */
  procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `revCode` field. */
  revCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `s3InputSource` field. */
  s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `tableNumber` field. */
  tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `unitCharge` field. */
  unitCharge?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Checks for equality with the object’s `units` field. */
  units?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `versionFingerprint` field. */
  versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimLineItemDistinctCountAggregateFilter = {
  alaRowId?: InputMaybe<BigIntFilter>;
  authorId?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  batchClaimLineId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  dateOfServiceEnd?: InputMaybe<BigIntFilter>;
  dateOfServiceStart?: InputMaybe<BigIntFilter>;
  description?: InputMaybe<BigIntFilter>;
  ibLineId?: InputMaybe<BigIntFilter>;
  ibLineVersionFingerprint?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  itemNumber?: InputMaybe<BigIntFilter>;
  lineNumber?: InputMaybe<BigIntFilter>;
  originalBilledAmount?: InputMaybe<BigIntFilter>;
  originalVersionId?: InputMaybe<BigIntFilter>;
  pageNumber?: InputMaybe<BigIntFilter>;
  previousVersionId?: InputMaybe<BigIntFilter>;
  procedureCode?: InputMaybe<BigIntFilter>;
  procedureCodeModifier?: InputMaybe<BigIntFilter>;
  revCode?: InputMaybe<BigIntFilter>;
  s3InputSource?: InputMaybe<BigIntFilter>;
  tableNumber?: InputMaybe<BigIntFilter>;
  unitCharge?: InputMaybe<BigIntFilter>;
  units?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  versionFingerprint?: InputMaybe<BigIntFilter>;
};

export type BatchClaimLineItemDistinctCountAggregates = {
  __typename?: "BatchClaimLineItemDistinctCountAggregates";
  /** Distinct count of alaRowId across the matching connection */
  alaRowId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimLineId across the matching connection */
  batchClaimLineId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dateOfServiceEnd across the matching connection */
  dateOfServiceEnd?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dateOfServiceStart across the matching connection */
  dateOfServiceStart?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of ibLineId across the matching connection */
  ibLineId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of ibLineVersionFingerprint across the matching connection */
  ibLineVersionFingerprint?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of itemNumber across the matching connection */
  itemNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of originalBilledAmount across the matching connection */
  originalBilledAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of originalVersionId across the matching connection */
  originalVersionId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of previousVersionId across the matching connection */
  previousVersionId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCode across the matching connection */
  procedureCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of procedureCodeModifier across the matching connection */
  procedureCodeModifier?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of revCode across the matching connection */
  revCode?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of s3InputSource across the matching connection */
  s3InputSource?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of units across the matching connection */
  units?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of versionFingerprint across the matching connection */
  versionFingerprint?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimLineItem` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimLineItemFilter = {
  /** Filter by the object’s `alaRowId` field. */
  alaRowId?: InputMaybe<UUIDFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimLineItemFilter>>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** A related `author` exists. */
  authorExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** A related `batchClaim` exists. */
  batchClaimExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaimLine` relation. */
  batchClaimLine?: InputMaybe<BatchClaimLineFilter>;
  /** A related `batchClaimLine` exists. */
  batchClaimLineExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimLineId` field. */
  batchClaimLineId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaimLineItemAudits` relation. */
  batchClaimLineItemAudits?: InputMaybe<BatchClaimLineItemToManyBatchClaimLineItemAuditFilter>;
  /** Some related `batchClaimLineItemAudits` exist. */
  batchClaimLineItemAuditsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaimLineItemComputedValueById` relation. */
  batchClaimLineItemComputedValueById?: InputMaybe<BatchClaimLineItemComputedValueFilter>;
  /** A related `batchClaimLineItemComputedValueById` exists. */
  batchClaimLineItemComputedValueByIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `batchClaimLineItemNnIbLines` relation. */
  batchClaimLineItemNnIbLines?: InputMaybe<BatchClaimLineItemToManyBatchClaimLineItemNnIbLineFilter>;
  /** Some related `batchClaimLineItemNnIbLines` exist. */
  batchClaimLineItemNnIbLinesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateOfServiceEnd` field. */
  dateOfServiceEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateOfServiceStart` field. */
  dateOfServiceStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ibLineId` field. */
  ibLineId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `ibLineVersionFingerprint` field. */
  ibLineVersionFingerprint?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `itemNumber` field. */
  itemNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineNumber` field. */
  lineNumber?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimLineItemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimLineItemFilter>>;
  /** Filter by the object’s `originalBilledAmount` field. */
  originalBilledAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `originalVersionId` field. */
  originalVersionId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `previousVersionId` field. */
  previousVersionId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `procedureCode` field. */
  procedureCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `procedureCodeModifier` field. */
  procedureCodeModifier?: InputMaybe<StringFilter>;
  /** Filter by the object’s `revCode` field. */
  revCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `s3InputSource` field. */
  s3InputSource?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tableNumber` field. */
  tableNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `unitCharge` field. */
  unitCharge?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `units` field. */
  units?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `versionFingerprint` field. */
  versionFingerprint?: InputMaybe<UUIDFilter>;
};

/** Grouping methods for `BatchClaimLineItem` for usage during aggregation. */
export enum BatchClaimLineItemGroupBy {
  ALA_ROW_ID = "ALA_ROW_ID",
  AUTHOR_ID = "AUTHOR_ID",
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  BATCH_CLAIM_LINE_ID = "BATCH_CLAIM_LINE_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DATE_OF_SERVICE_END = "DATE_OF_SERVICE_END",
  DATE_OF_SERVICE_END_TRUNCATED_TO_DAY = "DATE_OF_SERVICE_END_TRUNCATED_TO_DAY",
  DATE_OF_SERVICE_END_TRUNCATED_TO_HOUR = "DATE_OF_SERVICE_END_TRUNCATED_TO_HOUR",
  DATE_OF_SERVICE_START = "DATE_OF_SERVICE_START",
  DATE_OF_SERVICE_START_TRUNCATED_TO_DAY = "DATE_OF_SERVICE_START_TRUNCATED_TO_DAY",
  DATE_OF_SERVICE_START_TRUNCATED_TO_HOUR = "DATE_OF_SERVICE_START_TRUNCATED_TO_HOUR",
  DESCRIPTION = "DESCRIPTION",
  IB_LINE_ID = "IB_LINE_ID",
  IB_LINE_VERSION_FINGERPRINT = "IB_LINE_VERSION_FINGERPRINT",
  ITEM_NUMBER = "ITEM_NUMBER",
  LINE_NUMBER = "LINE_NUMBER",
  ORIGINAL_BILLED_AMOUNT = "ORIGINAL_BILLED_AMOUNT",
  ORIGINAL_VERSION_ID = "ORIGINAL_VERSION_ID",
  PAGE_NUMBER = "PAGE_NUMBER",
  PREVIOUS_VERSION_ID = "PREVIOUS_VERSION_ID",
  PROCEDURE_CODE = "PROCEDURE_CODE",
  PROCEDURE_CODE_MODIFIER = "PROCEDURE_CODE_MODIFIER",
  REV_CODE = "REV_CODE",
  S3_INPUT_SOURCE = "S3_INPUT_SOURCE",
  TABLE_NUMBER = "TABLE_NUMBER",
  UNITS = "UNITS",
  UNIT_CHARGE = "UNIT_CHARGE",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
  VERSION_FINGERPRINT = "VERSION_FINGERPRINT",
}

export type BatchClaimLineItemHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  originalBilledAmount?: InputMaybe<HavingBigfloatFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  unitCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  originalBilledAmount?: InputMaybe<HavingBigfloatFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  unitCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimLineItem` aggregates. */
export type BatchClaimLineItemHavingInput = {
  AND?: InputMaybe<Array<BatchClaimLineItemHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimLineItemHavingInput>>;
  average?: InputMaybe<BatchClaimLineItemHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimLineItemHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimLineItemHavingMaxInput>;
  min?: InputMaybe<BatchClaimLineItemHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimLineItemHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimLineItemHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimLineItemHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimLineItemHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimLineItemHavingVarianceSampleInput>;
};

export type BatchClaimLineItemHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  originalBilledAmount?: InputMaybe<HavingBigfloatFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  unitCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  originalBilledAmount?: InputMaybe<HavingBigfloatFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  unitCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  originalBilledAmount?: InputMaybe<HavingBigfloatFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  unitCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  originalBilledAmount?: InputMaybe<HavingBigfloatFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  unitCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  originalBilledAmount?: InputMaybe<HavingBigfloatFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  unitCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  originalBilledAmount?: InputMaybe<HavingBigfloatFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  unitCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceEnd?: InputMaybe<HavingDatetimeFilter>;
  dateOfServiceStart?: InputMaybe<HavingDatetimeFilter>;
  lineNumber?: InputMaybe<HavingIntFilter>;
  originalBilledAmount?: InputMaybe<HavingBigfloatFilter>;
  pageNumber?: InputMaybe<HavingIntFilter>;
  tableNumber?: InputMaybe<HavingIntFilter>;
  unitCharge?: InputMaybe<HavingBigfloatFilter>;
  units?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimLineItem` */
export type BatchClaimLineItemInput = {
  /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
  alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
  batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateOfServiceStart: Scalars["Datetime"]["input"];
  description: Scalars["String"]["input"];
  ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  itemNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** # Represents the order of the IB line in the source CSV input. */
  lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
  originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /**
   * ### original_version_id
   *  Original version id, used in versioning
   */
  originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
  pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /**
   * ### previous_version_id
   *  Previous version id, used in versioning
   */
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  procedureCode?: InputMaybe<Scalars["String"]["input"]>;
  procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
  revCode: Scalars["String"]["input"];
  /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
  s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
  /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
  tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
  unitCharge: Scalars["BigFloat"]["input"];
  units: Scalars["Int"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /**
   * ### version_fingerprint
   *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
   */
  versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimLineItemMaxAggregateFilter = {
  lineNumber?: InputMaybe<IntFilter>;
  originalBilledAmount?: InputMaybe<BigFloatFilter>;
  pageNumber?: InputMaybe<IntFilter>;
  tableNumber?: InputMaybe<IntFilter>;
  unitCharge?: InputMaybe<BigFloatFilter>;
  units?: InputMaybe<IntFilter>;
};

export type BatchClaimLineItemMaxAggregates = {
  __typename?: "BatchClaimLineItemMaxAggregates";
  /** Maximum of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of originalBilledAmount across the matching connection */
  originalBilledAmount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Maximum of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Maximum of units across the matching connection */
  units?: Maybe<Scalars["Int"]["output"]>;
};

export type BatchClaimLineItemMinAggregateFilter = {
  lineNumber?: InputMaybe<IntFilter>;
  originalBilledAmount?: InputMaybe<BigFloatFilter>;
  pageNumber?: InputMaybe<IntFilter>;
  tableNumber?: InputMaybe<IntFilter>;
  unitCharge?: InputMaybe<BigFloatFilter>;
  units?: InputMaybe<IntFilter>;
};

export type BatchClaimLineItemMinAggregates = {
  __typename?: "BatchClaimLineItemMinAggregates";
  /** Minimum of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of originalBilledAmount across the matching connection */
  originalBilledAmount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Minimum of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Minimum of units across the matching connection */
  units?: Maybe<Scalars["Int"]["output"]>;
};

export type BatchClaimLineItemNnIbLine = Node & {
  __typename?: "BatchClaimLineItemNnIbLine";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimLineItemNnIbLine`. */
  author?: Maybe<AuditorUser>;
  authorId: Scalars["UUID"]["output"];
  /** Reads a single `BatchClaimLineItem` that is related to this `BatchClaimLineItemNnIbLine`. */
  batchClaimLineItem?: Maybe<BatchClaimLineItem>;
  batchClaimLineItemId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads a single `NnIbLine` that is related to this `BatchClaimLineItemNnIbLine`. */
  nnIbLine?: Maybe<NnIbLine>;
  nnIbLineId: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type BatchClaimLineItemNnIbLineAggregates = {
  __typename?: "BatchClaimLineItemNnIbLineAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimLineItemNnIbLineDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `BatchClaimLineItemNnIbLine` object types. */
export type BatchClaimLineItemNnIbLineAggregatesFilter = {
  /** Distinct count aggregate over matching `BatchClaimLineItemNnIbLine` objects. */
  distinctCount?: InputMaybe<BatchClaimLineItemNnIbLineDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimLineItemNnIbLine` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
};

/** The `batchClaimLineItemNnIbLine` to be created by this mutation. */
export type BatchClaimLineItemNnIbLineAuthorIdFkeyBatchClaimLineItemNnIbLineCreateInput =
  {
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInput>;
    batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    nnIbLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    nnIbLineToNnIbLineId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `auditorUser` in the `BatchClaimLineItemNnIbLineInput` mutation. */
export type BatchClaimLineItemNnIbLineAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLineItemNnIbLine` in the `AuditorUserInput` mutation. */
export type BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  connectByBatchClaimLineItemIdAndNnIbLineId?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineBatchClaimLineItemNnIbLBatchClaimLineItemIdNnIKeyConnect>
  >;
  /** The primary key(s) for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineBatchClaimLineItemNnIbLinePkeyConnect>
  >;
  /** The primary key(s) for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimLineItemNnIbLineNodeIdConnect>>;
  /** A `BatchClaimLineItemNnIbLineInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineAuthorIdFkeyBatchClaimLineItemNnIbLineCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  updateByBatchClaimLineItemIdAndNnIbLineId?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyUsingBatchClaimLineItemNnIbLBatchClaimLineItemIdNnIKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyUsingBatchClaimLineItemNnIbLinePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyNodeIdUpdate>
  >;
};

/** The `batchClaimLineItem` to be created by this mutation. */
export type BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyBatchClaimLineItemCreateInput =
  {
    /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
    alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceStart: Scalars["Datetime"]["input"];
    description: Scalars["String"]["input"];
    ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    itemNumber?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the order of the IB line in the source CSV input. */
    lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
    originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
    /**
     * ### original_version_id
     *  Original version id, used in versioning
     */
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    /**
     * ### previous_version_id
     *  Previous version id, used in versioning
     */
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    procedureCode?: InputMaybe<Scalars["String"]["input"]>;
    procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
    revCode: Scalars["String"]["input"];
    /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
    s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
    tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
    unitCharge: Scalars["BigFloat"]["input"];
    units: Scalars["Int"]["input"];
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    /**
     * ### version_fingerprint
     *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
     */
    versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** The `batchClaimLineItemNnIbLine` to be created by this mutation. */
export type BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyBatchClaimLineItemNnIbLineCreateInput =
  {
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    nnIbLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    nnIbLineToNnIbLineId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `batchClaimLineItem` in the `BatchClaimLineItemNnIbLineInput` mutation. */
export type BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInput = {
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimLineItemBatchClaimLineItemPkeyConnect>;
  /** The primary key(s) for `batchClaimLineItem` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimLineItemNodeIdConnect>;
  /** A `BatchClaimLineItemInput` object that will be created and connected to this object. */
  create?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyBatchClaimLineItemCreateInput>;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimLineItemOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyUsingBatchClaimLineItemPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimLineItem` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLineItemNnIbLine` in the `BatchClaimLineItemInput` mutation. */
export type BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  connectByBatchClaimLineItemIdAndNnIbLineId?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineBatchClaimLineItemNnIbLBatchClaimLineItemIdNnIKeyConnect>
  >;
  /** The primary key(s) for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineBatchClaimLineItemNnIbLinePkeyConnect>
  >;
  /** The primary key(s) for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimLineItemNnIbLineNodeIdConnect>>;
  /** A `BatchClaimLineItemNnIbLineInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyBatchClaimLineItemNnIbLineCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  updateByBatchClaimLineItemIdAndNnIbLineId?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyUsingBatchClaimLineItemNnIbLBatchClaimLineItemIdNnIKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyUsingBatchClaimLineItemNnIbLinePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimLineItemOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyNodeIdUpdate>
  >;
};

/** The fields on `batchClaimLineItemNnIbLine` to look up the row to connect. */
export type BatchClaimLineItemNnIbLineBatchClaimLineItemNnIbLBatchClaimLineItemIdNnIKeyConnect =
  {
    batchClaimLineItemId: Scalars["UUID"]["input"];
    nnIbLineId: Scalars["UUID"]["input"];
  };

/** The fields on `batchClaimLineItemNnIbLine` to look up the row to connect. */
export type BatchClaimLineItemNnIbLineBatchClaimLineItemNnIbLinePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `BatchClaimLineItemNnIbLine` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimLineItemNnIbLineCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimLineItemId` field. */
  batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `nnIbLineId` field. */
  nnIbLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type BatchClaimLineItemNnIbLineDistinctCountAggregateFilter = {
  authorId?: InputMaybe<BigIntFilter>;
  batchClaimLineItemId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  nnIbLineId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type BatchClaimLineItemNnIbLineDistinctCountAggregates = {
  __typename?: "BatchClaimLineItemNnIbLineDistinctCountAggregates";
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimLineItemId across the matching connection */
  batchClaimLineItemId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of nnIbLineId across the matching connection */
  nnIbLineId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimLineItemNnIbLine` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimLineItemNnIbLineFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimLineItemNnIbLineFilter>>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaimLineItem` relation. */
  batchClaimLineItem?: InputMaybe<BatchClaimLineItemFilter>;
  /** Filter by the object’s `batchClaimLineItemId` field. */
  batchClaimLineItemId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `nnIbLine` relation. */
  nnIbLine?: InputMaybe<NnIbLineFilter>;
  /** Filter by the object’s `nnIbLineId` field. */
  nnIbLineId?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimLineItemNnIbLineFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BatchClaimLineItemNnIbLine` for usage during aggregation. */
export enum BatchClaimLineItemNnIbLineGroupBy {
  AUTHOR_ID = "AUTHOR_ID",
  BATCH_CLAIM_LINE_ITEM_ID = "BATCH_CLAIM_LINE_ITEM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  NN_IB_LINE_ID = "NN_IB_LINE_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type BatchClaimLineItemNnIbLineHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemNnIbLineHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimLineItemNnIbLine` aggregates. */
export type BatchClaimLineItemNnIbLineHavingInput = {
  AND?: InputMaybe<Array<BatchClaimLineItemNnIbLineHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimLineItemNnIbLineHavingInput>>;
  average?: InputMaybe<BatchClaimLineItemNnIbLineHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimLineItemNnIbLineHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimLineItemNnIbLineHavingMaxInput>;
  min?: InputMaybe<BatchClaimLineItemNnIbLineHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimLineItemNnIbLineHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimLineItemNnIbLineHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimLineItemNnIbLineHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimLineItemNnIbLineHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimLineItemNnIbLineHavingVarianceSampleInput>;
};

export type BatchClaimLineItemNnIbLineHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemNnIbLineHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemNnIbLineHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemNnIbLineHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemNnIbLineHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemNnIbLineHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimLineItemNnIbLineHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimLineItemNnIbLine` */
export type BatchClaimLineItemNnIbLineInput = {
  auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  nnIbLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  nnIbLineToNnIbLineId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The `batchClaimLineItemNnIbLine` to be created by this mutation. */
export type BatchClaimLineItemNnIbLineNnIbLineIdFkeyBatchClaimLineItemNnIbLineCreateInput =
  {
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    nnIbLineToNnIbLineId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `nnIbLine` in the `BatchClaimLineItemNnIbLineInput` mutation. */
export type BatchClaimLineItemNnIbLineNnIbLineIdFkeyInput = {
  /** The primary key(s) for `nnIbLine` for the far side of the relationship. */
  connectByFingerprintAndS3Key?: InputMaybe<NnIbLineNnIbLineFingerprintS3KeyKeyConnect>;
  /** The primary key(s) for `nnIbLine` for the far side of the relationship. */
  connectById?: InputMaybe<NnIbLineNnIbLinePkeyConnect>;
  /** The primary key(s) for `nnIbLine` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<NnIbLineNodeIdConnect>;
  /** A `NnIbLineInput` object that will be created and connected to this object. */
  create?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyNnIbLineCreateInput>;
  /** The primary key(s) and patch data for `nnIbLine` for the far side of the relationship. */
  updateByFingerprintAndS3Key?: InputMaybe<NnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyUsingNnIbLineFingerprintS3KeyKeyUpdate>;
  /** The primary key(s) and patch data for `nnIbLine` for the far side of the relationship. */
  updateById?: InputMaybe<NnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyUsingNnIbLinePkeyUpdate>;
  /** The primary key(s) and patch data for `nnIbLine` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimLineItemNnIbLine` in the `NnIbLineInput` mutation. */
export type BatchClaimLineItemNnIbLineNnIbLineIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  connectByBatchClaimLineItemIdAndNnIbLineId?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineBatchClaimLineItemNnIbLBatchClaimLineItemIdNnIKeyConnect>
  >;
  /** The primary key(s) for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineBatchClaimLineItemNnIbLinePkeyConnect>
  >;
  /** The primary key(s) for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimLineItemNnIbLineNodeIdConnect>>;
  /** A `BatchClaimLineItemNnIbLineInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineNnIbLineIdFkeyBatchClaimLineItemNnIbLineCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  updateByBatchClaimLineItemIdAndNnIbLineId?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyUsingBatchClaimLineItemNnIbLBatchClaimLineItemIdNnIKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyUsingBatchClaimLineItemNnIbLinePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimLineItemNnIbLine` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<NnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyNodeIdUpdate>
  >;
};

/** The `nnIbLine` to be created by this mutation. */
export type BatchClaimLineItemNnIbLineNnIbLineIdFkeyNnIbLineCreateInput = {
  auditorUserToAuthorId?: InputMaybe<NnIbLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  fingerprint: Scalars["UUID"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  s3Key: Scalars["String"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimLineItemNnIbLineNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimLineItemNnIbLine` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `batchClaimLineItemNnIbLine` to look up the row to update. */
export type BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyUsingBatchClaimLineItemNnIbLBatchClaimLineItemIdNnIKeyUpdate =
  {
    batchClaimLineItemId: Scalars["UUID"]["input"];
    nnIbLineId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
    patch: updateBatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyPatch;
  };

/** The fields on `batchClaimLineItemNnIbLine` to look up the row to update. */
export type BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyUsingBatchClaimLineItemNnIbLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
    patch: updateBatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItem` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: BatchClaimLineItemPatch;
  };

/** The fields on `batchClaimLineItemNnIbLine` to look up the row to update. */
export type BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyUsingBatchClaimLineItemNnIbLBatchClaimLineItemIdNnIKeyUpdate =
  {
    batchClaimLineItemId: Scalars["UUID"]["input"];
    nnIbLineId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
    patch: updateBatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyPatch;
  };

/** The fields on `batchClaimLineItemNnIbLine` to look up the row to update. */
export type BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyUsingBatchClaimLineItemNnIbLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
    patch: updateBatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `nnIbLine` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `nnIbLine` being updated. */
    patch: NnIbLinePatch;
  };

/** The fields on `batchClaimLineItemNnIbLine` to look up the row to update. */
export type BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyUsingBatchClaimLineItemNnIbLBatchClaimLineItemIdNnIKeyUpdate =
  {
    batchClaimLineItemId: Scalars["UUID"]["input"];
    nnIbLineId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
    patch: updateBatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyPatch;
  };

/** The fields on `batchClaimLineItemNnIbLine` to look up the row to update. */
export type BatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyUsingBatchClaimLineItemNnIbLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
    patch: updateBatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimLineItemNnIbLine`. Fields that are set will be updated. */
export type BatchClaimLineItemNnIbLinePatch = {
  auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  nnIbLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  nnIbLineToNnIbLineId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** A connection to a list of `BatchClaimLineItemNnIbLine` values. */
export type BatchClaimLineItemNnIbLinesConnection = {
  __typename?: "BatchClaimLineItemNnIbLinesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimLineItemNnIbLineAggregates>;
  /** A list of edges which contains the `BatchClaimLineItemNnIbLine` and cursor to aid in pagination. */
  edges: Array<BatchClaimLineItemNnIbLinesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimLineItemNnIbLineAggregates>>;
  /** A list of `BatchClaimLineItemNnIbLine` objects. */
  nodes: Array<Maybe<BatchClaimLineItemNnIbLine>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimLineItemNnIbLine` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimLineItemNnIbLine` values. */
export type BatchClaimLineItemNnIbLinesConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimLineItemNnIbLineGroupBy>;
  having?: InputMaybe<BatchClaimLineItemNnIbLineHavingInput>;
};

/** A `BatchClaimLineItemNnIbLine` edge in the connection. */
export type BatchClaimLineItemNnIbLinesEdge = {
  __typename?: "BatchClaimLineItemNnIbLinesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimLineItemNnIbLine` at the end of the edge. */
  node?: Maybe<BatchClaimLineItemNnIbLine>;
};

/** Methods to use when ordering `BatchClaimLineItemNnIbLine`. */
export enum BatchClaimLineItemNnIbLinesOrderBy {
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNITS_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNITS_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNITS_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNITS_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEM_BY_BATCH_CLAIM_LINE_ITEM_ID__VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  NN_IB_LINE_BY_NN_IB_LINE_ID__AUTHOR_ID_ASC = "NN_IB_LINE_BY_NN_IB_LINE_ID__AUTHOR_ID_ASC",
  NN_IB_LINE_BY_NN_IB_LINE_ID__AUTHOR_ID_DESC = "NN_IB_LINE_BY_NN_IB_LINE_ID__AUTHOR_ID_DESC",
  NN_IB_LINE_BY_NN_IB_LINE_ID__CREATED_AT_ASC = "NN_IB_LINE_BY_NN_IB_LINE_ID__CREATED_AT_ASC",
  NN_IB_LINE_BY_NN_IB_LINE_ID__CREATED_AT_DESC = "NN_IB_LINE_BY_NN_IB_LINE_ID__CREATED_AT_DESC",
  NN_IB_LINE_BY_NN_IB_LINE_ID__FINGERPRINT_ASC = "NN_IB_LINE_BY_NN_IB_LINE_ID__FINGERPRINT_ASC",
  NN_IB_LINE_BY_NN_IB_LINE_ID__FINGERPRINT_DESC = "NN_IB_LINE_BY_NN_IB_LINE_ID__FINGERPRINT_DESC",
  NN_IB_LINE_BY_NN_IB_LINE_ID__ID_ASC = "NN_IB_LINE_BY_NN_IB_LINE_ID__ID_ASC",
  NN_IB_LINE_BY_NN_IB_LINE_ID__ID_DESC = "NN_IB_LINE_BY_NN_IB_LINE_ID__ID_DESC",
  NN_IB_LINE_BY_NN_IB_LINE_ID__S3_KEY_ASC = "NN_IB_LINE_BY_NN_IB_LINE_ID__S3_KEY_ASC",
  NN_IB_LINE_BY_NN_IB_LINE_ID__S3_KEY_DESC = "NN_IB_LINE_BY_NN_IB_LINE_ID__S3_KEY_DESC",
  NN_IB_LINE_BY_NN_IB_LINE_ID__UPDATED_AT_ASC = "NN_IB_LINE_BY_NN_IB_LINE_ID__UPDATED_AT_ASC",
  NN_IB_LINE_BY_NN_IB_LINE_ID__UPDATED_AT_DESC = "NN_IB_LINE_BY_NN_IB_LINE_ID__UPDATED_AT_DESC",
  NN_IB_LINE_ID_ASC = "NN_IB_LINE_ID_ASC",
  NN_IB_LINE_ID_DESC = "NN_IB_LINE_ID_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimLineItemNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimLineItem` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItemAudit` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
    patch: BatchClaimLineItemAuditPatch;
  };

/** The fields on `batchClaimLineItem` to look up the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyUsingBatchClaimLineItemPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: updateBatchClaimLineItemOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItemComputedValue` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemComputedValue` being updated. */
    patch: BatchClaimLineItemComputedValuePatch;
  };

/** The fields on `batchClaimLineItem` to look up the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyUsingBatchClaimLineItemPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: updateBatchClaimLineItemOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `batchClaimLineItem` to look up the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyUsingBatchClaimLineItemPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: updateBatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimLineItem` to look up the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyUsingBatchClaimLineItemPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: updateBatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLine` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLine` being updated. */
    patch: BatchClaimLinePatch;
  };

/** The fields on `batchClaimLineItem` to look up the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyUsingBatchClaimLineItemPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: updateBatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItemNnIbLine` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
    patch: BatchClaimLineItemNnIbLinePatch;
  };

/** The fields on `batchClaimLineItem` to look up the row to update. */
export type BatchClaimLineItemOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyUsingBatchClaimLineItemPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: updateBatchClaimLineItemOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimLineItem`. Fields that are set will be updated. */
export type BatchClaimLineItemPatch = {
  /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
  alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
  batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateOfServiceStart?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  itemNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** # Represents the order of the IB line in the source CSV input. */
  lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
  originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /**
   * ### original_version_id
   *  Original version id, used in versioning
   */
  originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
  pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
  /**
   * ### previous_version_id
   *  Previous version id, used in versioning
   */
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  procedureCode?: InputMaybe<Scalars["String"]["input"]>;
  procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
  revCode?: InputMaybe<Scalars["String"]["input"]>;
  /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
  s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
  /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
  tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
  unitCharge?: InputMaybe<Scalars["BigFloat"]["input"]>;
  units?: InputMaybe<Scalars["Int"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /**
   * ### version_fingerprint
   *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
   */
  versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimLineItemStddevPopulationAggregateFilter = {
  lineNumber?: InputMaybe<BigFloatFilter>;
  originalBilledAmount?: InputMaybe<BigFloatFilter>;
  pageNumber?: InputMaybe<BigFloatFilter>;
  tableNumber?: InputMaybe<BigFloatFilter>;
  unitCharge?: InputMaybe<BigFloatFilter>;
  units?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimLineItemStddevPopulationAggregates = {
  __typename?: "BatchClaimLineItemStddevPopulationAggregates";
  /** Population standard deviation of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of originalBilledAmount across the matching connection */
  originalBilledAmount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type BatchClaimLineItemStddevSampleAggregateFilter = {
  lineNumber?: InputMaybe<BigFloatFilter>;
  originalBilledAmount?: InputMaybe<BigFloatFilter>;
  pageNumber?: InputMaybe<BigFloatFilter>;
  tableNumber?: InputMaybe<BigFloatFilter>;
  unitCharge?: InputMaybe<BigFloatFilter>;
  units?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimLineItemStddevSampleAggregates = {
  __typename?: "BatchClaimLineItemStddevSampleAggregates";
  /** Sample standard deviation of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of originalBilledAmount across the matching connection */
  originalBilledAmount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type BatchClaimLineItemSumAggregateFilter = {
  lineNumber?: InputMaybe<BigIntFilter>;
  originalBilledAmount?: InputMaybe<BigFloatFilter>;
  pageNumber?: InputMaybe<BigIntFilter>;
  tableNumber?: InputMaybe<BigIntFilter>;
  unitCharge?: InputMaybe<BigFloatFilter>;
  units?: InputMaybe<BigIntFilter>;
};

export type BatchClaimLineItemSumAggregates = {
  __typename?: "BatchClaimLineItemSumAggregates";
  /** Sum of lineNumber across the matching connection */
  lineNumber: Scalars["BigInt"]["output"];
  /** Sum of originalBilledAmount across the matching connection */
  originalBilledAmount: Scalars["BigFloat"]["output"];
  /** Sum of pageNumber across the matching connection */
  pageNumber: Scalars["BigInt"]["output"];
  /** Sum of tableNumber across the matching connection */
  tableNumber: Scalars["BigInt"]["output"];
  /** Sum of unitCharge across the matching connection */
  unitCharge: Scalars["BigFloat"]["output"];
  /** Sum of units across the matching connection */
  units: Scalars["BigInt"]["output"];
};

/** A filter to be used against many `BatchClaimLineItemAudit` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimLineItemToManyBatchClaimLineItemAuditFilter = {
  /** Aggregates across related `BatchClaimLineItemAudit` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimLineItemAuditAggregatesFilter>;
  /** Every related `BatchClaimLineItemAudit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimLineItemAuditFilter>;
  /** No related `BatchClaimLineItemAudit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimLineItemAuditFilter>;
  /** Some related `BatchClaimLineItemAudit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimLineItemAuditFilter>;
};

/** A filter to be used against many `BatchClaimLineItemNnIbLine` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimLineItemToManyBatchClaimLineItemNnIbLineFilter = {
  /** Aggregates across related `BatchClaimLineItemNnIbLine` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimLineItemNnIbLineAggregatesFilter>;
  /** Every related `BatchClaimLineItemNnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
  /** No related `BatchClaimLineItemNnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
  /** Some related `BatchClaimLineItemNnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
};

export type BatchClaimLineItemV2 = {
  __typename?: "BatchClaimLineItemV2";
  alaRowId?: Maybe<Scalars["UUID"]["output"]>;
  authorId?: Maybe<Scalars["UUID"]["output"]>;
  batchClaimLineId?: Maybe<Scalars["UUID"]["output"]>;
  createdAt?: Maybe<Scalars["Datetime"]["output"]>;
  dateOfServiceEnd?: Maybe<Scalars["Datetime"]["output"]>;
  dateOfServiceStart?: Maybe<Scalars["Datetime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  ibLineId?: Maybe<Scalars["UUID"]["output"]>;
  ibLineVersionFingerprint?: Maybe<Scalars["UUID"]["output"]>;
  id?: Maybe<Scalars["UUID"]["output"]>;
  itemNumber?: Maybe<Scalars["String"]["output"]>;
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  originalBilledAmount?: Maybe<Scalars["BigFloat"]["output"]>;
  procedureCode?: Maybe<Scalars["String"]["output"]>;
  procedureCodeModifier?: Maybe<Scalars["String"]["output"]>;
  revCode?: Maybe<Scalars["String"]["output"]>;
  s3InputSource?: Maybe<Scalars["String"]["output"]>;
  unitCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  units?: Maybe<Scalars["Int"]["output"]>;
  versionFingerprint?: Maybe<Scalars["UUID"]["output"]>;
};

export type BatchClaimLineItemValuesInputV2 = {
  alaRowId?: InputMaybe<Scalars["String"]["input"]>;
  dateOfServiceEnd?: InputMaybe<Scalars["Date"]["input"]>;
  dateOfServiceStart?: InputMaybe<Scalars["Date"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  ibLineVersionFingerprint?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  itemNumber?: InputMaybe<Scalars["String"]["input"]>;
  lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
  nnIbLineValues?: InputMaybe<Array<NnIbLineValueInputV2>>;
  originalBilledAmount?: InputMaybe<Scalars["Float"]["input"]>;
  procedureCode?: InputMaybe<Scalars["String"]["input"]>;
  procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
  revCode?: InputMaybe<Scalars["String"]["input"]>;
  s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
  unitCharge?: InputMaybe<Scalars["Float"]["input"]>;
  units?: InputMaybe<Scalars["Int"]["input"]>;
  versionFingerprint?: InputMaybe<Scalars["String"]["input"]>;
};

export type BatchClaimLineItemVariancePopulationAggregateFilter = {
  lineNumber?: InputMaybe<BigFloatFilter>;
  originalBilledAmount?: InputMaybe<BigFloatFilter>;
  pageNumber?: InputMaybe<BigFloatFilter>;
  tableNumber?: InputMaybe<BigFloatFilter>;
  unitCharge?: InputMaybe<BigFloatFilter>;
  units?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimLineItemVariancePopulationAggregates = {
  __typename?: "BatchClaimLineItemVariancePopulationAggregates";
  /** Population variance of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of originalBilledAmount across the matching connection */
  originalBilledAmount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type BatchClaimLineItemVarianceSampleAggregateFilter = {
  lineNumber?: InputMaybe<BigFloatFilter>;
  originalBilledAmount?: InputMaybe<BigFloatFilter>;
  pageNumber?: InputMaybe<BigFloatFilter>;
  tableNumber?: InputMaybe<BigFloatFilter>;
  unitCharge?: InputMaybe<BigFloatFilter>;
  units?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimLineItemVarianceSampleAggregates = {
  __typename?: "BatchClaimLineItemVarianceSampleAggregates";
  /** Sample variance of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of originalBilledAmount across the matching connection */
  originalBilledAmount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of pageNumber across the matching connection */
  pageNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of tableNumber across the matching connection */
  tableNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** A connection to a list of `BatchClaimLineItem` values. */
export type BatchClaimLineItemsConnection = {
  __typename?: "BatchClaimLineItemsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimLineItemAggregates>;
  /** A list of edges which contains the `BatchClaimLineItem` and cursor to aid in pagination. */
  edges: Array<BatchClaimLineItemsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimLineItemAggregates>>;
  /** A list of `BatchClaimLineItem` objects. */
  nodes: Array<Maybe<BatchClaimLineItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimLineItem` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimLineItem` values. */
export type BatchClaimLineItemsConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimLineItemGroupBy>;
  having?: InputMaybe<BatchClaimLineItemHavingInput>;
};

/** A `BatchClaimLineItem` edge in the connection. */
export type BatchClaimLineItemsEdge = {
  __typename?: "BatchClaimLineItemsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimLineItem` at the end of the edge. */
  node?: Maybe<BatchClaimLineItem>;
};

/** Methods to use when ordering `BatchClaimLineItem`. */
export enum BatchClaimLineItemsOrderBy {
  ALA_ROW_ID_ASC = "ALA_ROW_ID_ASC",
  ALA_ROW_ID_DESC = "ALA_ROW_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CREATED_AT_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CREATED_AT_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CREATED_AT_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__CREATED_AT_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__ID_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__ID_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__ID_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__ID_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_SRC_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_SRC_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__SERVICE_DATE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__SERVICE_DATE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__SERVICE_DATE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__SERVICE_DATE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNITS_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNITS_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNITS_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNITS_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UPDATED_AT_ASC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UPDATED_AT_DESC = "BATCH_CLAIM_LINE_BY_BATCH_CLAIM_LINE_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUDIT_FINDING_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUDIT_FINDING_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUDIT_FINDING_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUDIT_FINDING_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_BY_BATCH_CLAIM_LINE_ITEM_ID__COUNT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_BY_BATCH_CLAIM_LINE_ITEM_ID__COUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_BY_BATCH_CLAIM_LINE_ITEM_ID__COUNT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_BY_BATCH_CLAIM_LINE_ITEM_ID__COUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_COUNT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_COUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_COUNT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_COUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUDIT_FINDING_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUDIT_FINDING_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUDIT_FINDING_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUDIT_FINDING_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUDIT_FINDING_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUDIT_FINDING_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUDIT_FINDING_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUDIT_FINDING_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUDIT_FINDING_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUDIT_FINDING_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUDIT_FINDING_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUDIT_FINDING_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_AUDITS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_SAVINGS_ASC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_SAVINGS_ASC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_SAVINGS_DESC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__DETERMINED_SAVINGS_DESC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__ID_ASC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__ID_ASC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__ID_DESC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__ID_DESC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_SAVINGS_ASC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_SAVINGS_ASC",
  BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_SAVINGS_DESC = "BATCH_CLAIM_LINE_ITEM_COMPUTED_VALUE_BY_ID__POTENTIAL_SAVINGS_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_BATCH_CLAIM_LINE_ITEM_ID__COUNT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_BATCH_CLAIM_LINE_ITEM_ID__COUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_BATCH_CLAIM_LINE_ITEM_ID__COUNT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_BATCH_CLAIM_LINE_ITEM_ID__COUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DATE_OF_SERVICE_END_ASC = "DATE_OF_SERVICE_END_ASC",
  DATE_OF_SERVICE_END_DESC = "DATE_OF_SERVICE_END_DESC",
  DATE_OF_SERVICE_START_ASC = "DATE_OF_SERVICE_START_ASC",
  DATE_OF_SERVICE_START_DESC = "DATE_OF_SERVICE_START_DESC",
  DESCRIPTION_ASC = "DESCRIPTION_ASC",
  DESCRIPTION_DESC = "DESCRIPTION_DESC",
  IB_LINE_ID_ASC = "IB_LINE_ID_ASC",
  IB_LINE_ID_DESC = "IB_LINE_ID_DESC",
  IB_LINE_VERSION_FINGERPRINT_ASC = "IB_LINE_VERSION_FINGERPRINT_ASC",
  IB_LINE_VERSION_FINGERPRINT_DESC = "IB_LINE_VERSION_FINGERPRINT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  ITEM_NUMBER_ASC = "ITEM_NUMBER_ASC",
  ITEM_NUMBER_DESC = "ITEM_NUMBER_DESC",
  LINE_NUMBER_ASC = "LINE_NUMBER_ASC",
  LINE_NUMBER_DESC = "LINE_NUMBER_DESC",
  NATURAL = "NATURAL",
  ORIGINAL_BILLED_AMOUNT_ASC = "ORIGINAL_BILLED_AMOUNT_ASC",
  ORIGINAL_BILLED_AMOUNT_DESC = "ORIGINAL_BILLED_AMOUNT_DESC",
  ORIGINAL_VERSION_ID_ASC = "ORIGINAL_VERSION_ID_ASC",
  ORIGINAL_VERSION_ID_DESC = "ORIGINAL_VERSION_ID_DESC",
  PAGE_NUMBER_ASC = "PAGE_NUMBER_ASC",
  PAGE_NUMBER_DESC = "PAGE_NUMBER_DESC",
  PREVIOUS_VERSION_ID_ASC = "PREVIOUS_VERSION_ID_ASC",
  PREVIOUS_VERSION_ID_DESC = "PREVIOUS_VERSION_ID_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROCEDURE_CODE_ASC = "PROCEDURE_CODE_ASC",
  PROCEDURE_CODE_DESC = "PROCEDURE_CODE_DESC",
  PROCEDURE_CODE_MODIFIER_ASC = "PROCEDURE_CODE_MODIFIER_ASC",
  PROCEDURE_CODE_MODIFIER_DESC = "PROCEDURE_CODE_MODIFIER_DESC",
  REV_CODE_ASC = "REV_CODE_ASC",
  REV_CODE_DESC = "REV_CODE_DESC",
  S3_INPUT_SOURCE_ASC = "S3_INPUT_SOURCE_ASC",
  S3_INPUT_SOURCE_DESC = "S3_INPUT_SOURCE_DESC",
  TABLE_NUMBER_ASC = "TABLE_NUMBER_ASC",
  TABLE_NUMBER_DESC = "TABLE_NUMBER_DESC",
  UNITS_ASC = "UNITS_ASC",
  UNITS_DESC = "UNITS_DESC",
  UNIT_CHARGE_ASC = "UNIT_CHARGE_ASC",
  UNIT_CHARGE_DESC = "UNIT_CHARGE_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
  VERSION_FINGERPRINT_ASC = "VERSION_FINGERPRINT_ASC",
  VERSION_FINGERPRINT_DESC = "VERSION_FINGERPRINT_DESC",
}

export type BatchClaimLineMaxAggregateFilter = {
  lineNumber?: InputMaybe<IntFilter>;
  nonCovCharge?: InputMaybe<FloatFilter>;
  nonCoveredAmount?: InputMaybe<FloatFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  unitAllowableCharge?: InputMaybe<FloatFilter>;
  unitCharge?: InputMaybe<FloatFilter>;
  units?: InputMaybe<IntFilter>;
};

export type BatchClaimLineMaxAggregates = {
  __typename?: "BatchClaimLineMaxAggregates";
  /** Maximum of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of nonCovCharge across the matching connection */
  nonCovCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of nonCoveredAmount across the matching connection */
  nonCoveredAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of unitAllowableCharge across the matching connection */
  unitAllowableCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of units across the matching connection */
  units?: Maybe<Scalars["Int"]["output"]>;
};

export type BatchClaimLineMinAggregateFilter = {
  lineNumber?: InputMaybe<IntFilter>;
  nonCovCharge?: InputMaybe<FloatFilter>;
  nonCoveredAmount?: InputMaybe<FloatFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  unitAllowableCharge?: InputMaybe<FloatFilter>;
  unitCharge?: InputMaybe<FloatFilter>;
  units?: InputMaybe<IntFilter>;
};

export type BatchClaimLineMinAggregates = {
  __typename?: "BatchClaimLineMinAggregates";
  /** Minimum of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of nonCovCharge across the matching connection */
  nonCovCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of nonCoveredAmount across the matching connection */
  nonCoveredAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of unitAllowableCharge across the matching connection */
  unitAllowableCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of units across the matching connection */
  units?: Maybe<Scalars["Int"]["output"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimLineNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimLine` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `batchClaimLine` to look up the row to update. */
export type BatchClaimLineOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyUsingBatchClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLine` being updated. */
    patch: updateBatchClaimLineOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineComputedValue` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineComputedValue` being updated. */
    patch: BatchClaimLineComputedValuePatch;
  };

/** The fields on `batchClaimLine` to look up the row to update. */
export type BatchClaimLineOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyUsingBatchClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLine` being updated. */
    patch: updateBatchClaimLineOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimLine` to look up the row to update. */
export type BatchClaimLineOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyUsingBatchClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLine` being updated. */
    patch: updateBatchClaimLineOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimLineOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItem` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: BatchClaimLineItemPatch;
  };

/** The fields on `batchClaimLine` to look up the row to update. */
export type BatchClaimLineOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyUsingBatchClaimLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLine` being updated. */
    patch: updateBatchClaimLineOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimLine`. Fields that are set will be updated. */
export type BatchClaimLinePatch = {
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInverseInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineComputedValueUsingId?: InputMaybe<BatchClaimLineComputedValuesIdFkeyInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInverseInput>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInput>;
};

export type BatchClaimLineStddevPopulationAggregateFilter = {
  lineNumber?: InputMaybe<BigFloatFilter>;
  nonCovCharge?: InputMaybe<FloatFilter>;
  nonCoveredAmount?: InputMaybe<FloatFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  unitAllowableCharge?: InputMaybe<FloatFilter>;
  unitCharge?: InputMaybe<FloatFilter>;
  units?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimLineStddevPopulationAggregates = {
  __typename?: "BatchClaimLineStddevPopulationAggregates";
  /** Population standard deviation of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of nonCovCharge across the matching connection */
  nonCovCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of nonCoveredAmount across the matching connection */
  nonCoveredAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of unitAllowableCharge across the matching connection */
  unitAllowableCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type BatchClaimLineStddevSampleAggregateFilter = {
  lineNumber?: InputMaybe<BigFloatFilter>;
  nonCovCharge?: InputMaybe<FloatFilter>;
  nonCoveredAmount?: InputMaybe<FloatFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  unitAllowableCharge?: InputMaybe<FloatFilter>;
  unitCharge?: InputMaybe<FloatFilter>;
  units?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimLineStddevSampleAggregates = {
  __typename?: "BatchClaimLineStddevSampleAggregates";
  /** Sample standard deviation of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of nonCovCharge across the matching connection */
  nonCovCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of nonCoveredAmount across the matching connection */
  nonCoveredAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of unitAllowableCharge across the matching connection */
  unitAllowableCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type BatchClaimLineSumAggregateFilter = {
  lineNumber?: InputMaybe<BigIntFilter>;
  nonCovCharge?: InputMaybe<FloatFilter>;
  nonCoveredAmount?: InputMaybe<FloatFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  unitAllowableCharge?: InputMaybe<FloatFilter>;
  unitCharge?: InputMaybe<FloatFilter>;
  units?: InputMaybe<BigIntFilter>;
};

export type BatchClaimLineSumAggregates = {
  __typename?: "BatchClaimLineSumAggregates";
  /** Sum of lineNumber across the matching connection */
  lineNumber: Scalars["BigInt"]["output"];
  /** Sum of nonCovCharge across the matching connection */
  nonCovCharge: Scalars["Float"]["output"];
  /** Sum of nonCoveredAmount across the matching connection */
  nonCoveredAmount: Scalars["Float"]["output"];
  /** Sum of paymentRate across the matching connection */
  paymentRate: Scalars["Float"]["output"];
  /** Sum of unitAllowableCharge across the matching connection */
  unitAllowableCharge: Scalars["Float"]["output"];
  /** Sum of unitCharge across the matching connection */
  unitCharge: Scalars["Float"]["output"];
  /** Sum of units across the matching connection */
  units: Scalars["BigInt"]["output"];
};

/** A filter to be used against many `AuditFinding` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimLineToManyAuditFindingFilter = {
  /** Aggregates across related `AuditFinding` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingAggregatesFilter>;
  /** Every related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingFilter>;
  /** No related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingFilter>;
  /** Some related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingFilter>;
};

/** A filter to be used against many `BatchClaimLineItem` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimLineToManyBatchClaimLineItemFilter = {
  /** Aggregates across related `BatchClaimLineItem` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimLineItemAggregatesFilter>;
  /** Every related `BatchClaimLineItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimLineItemFilter>;
  /** No related `BatchClaimLineItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimLineItemFilter>;
  /** Some related `BatchClaimLineItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimLineItemFilter>;
};

export type BatchClaimLineVariancePopulationAggregateFilter = {
  lineNumber?: InputMaybe<BigFloatFilter>;
  nonCovCharge?: InputMaybe<FloatFilter>;
  nonCoveredAmount?: InputMaybe<FloatFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  unitAllowableCharge?: InputMaybe<FloatFilter>;
  unitCharge?: InputMaybe<FloatFilter>;
  units?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimLineVariancePopulationAggregates = {
  __typename?: "BatchClaimLineVariancePopulationAggregates";
  /** Population variance of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of nonCovCharge across the matching connection */
  nonCovCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of nonCoveredAmount across the matching connection */
  nonCoveredAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of unitAllowableCharge across the matching connection */
  unitAllowableCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type BatchClaimLineVarianceSampleAggregateFilter = {
  lineNumber?: InputMaybe<BigFloatFilter>;
  nonCovCharge?: InputMaybe<FloatFilter>;
  nonCoveredAmount?: InputMaybe<FloatFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  unitAllowableCharge?: InputMaybe<FloatFilter>;
  unitCharge?: InputMaybe<FloatFilter>;
  units?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimLineVarianceSampleAggregates = {
  __typename?: "BatchClaimLineVarianceSampleAggregates";
  /** Sample variance of lineNumber across the matching connection */
  lineNumber?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of nonCovCharge across the matching connection */
  nonCovCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of nonCoveredAmount across the matching connection */
  nonCoveredAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of unitAllowableCharge across the matching connection */
  unitAllowableCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of unitCharge across the matching connection */
  unitCharge?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of units across the matching connection */
  units?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** A connection to a list of `BatchClaimLine` values. */
export type BatchClaimLinesConnection = {
  __typename?: "BatchClaimLinesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimLineAggregates>;
  /** A list of edges which contains the `BatchClaimLine` and cursor to aid in pagination. */
  edges: Array<BatchClaimLinesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimLineAggregates>>;
  /** A list of `BatchClaimLine` objects. */
  nodes: Array<Maybe<BatchClaimLine>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimLine` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimLine` values. */
export type BatchClaimLinesConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimLineGroupBy>;
  having?: InputMaybe<BatchClaimLineHavingInput>;
};

/** A `BatchClaimLine` edge in the connection. */
export type BatchClaimLinesEdge = {
  __typename?: "BatchClaimLinesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimLine` at the end of the edge. */
  node?: Maybe<BatchClaimLine>;
};

/** Methods to use when ordering `BatchClaimLine`. */
export enum BatchClaimLinesOrderBy {
  AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_CONFIDENCE_ASC = "AUDIT_FINDINGS_AVERAGE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_AVERAGE_CONFIDENCE_DESC = "AUDIT_FINDINGS_AVERAGE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDINGS_AVERAGE_DELETED_AT_ASC = "AUDIT_FINDINGS_AVERAGE_DELETED_AT_ASC",
  AUDIT_FINDINGS_AVERAGE_DELETED_AT_DESC = "AUDIT_FINDINGS_AVERAGE_DELETED_AT_DESC",
  AUDIT_FINDINGS_AVERAGE_DELETED_BY_ASC = "AUDIT_FINDINGS_AVERAGE_DELETED_BY_ASC",
  AUDIT_FINDINGS_AVERAGE_DELETED_BY_DESC = "AUDIT_FINDINGS_AVERAGE_DELETED_BY_DESC",
  AUDIT_FINDINGS_AVERAGE_ID_ASC = "AUDIT_FINDINGS_AVERAGE_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_ID_DESC = "AUDIT_FINDINGS_AVERAGE_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_BATCH_CLAIM_LINE_ID__COUNT_ASC = "AUDIT_FINDINGS_BY_BATCH_CLAIM_LINE_ID__COUNT_ASC",
  AUDIT_FINDINGS_BY_BATCH_CLAIM_LINE_ID__COUNT_DESC = "AUDIT_FINDINGS_BY_BATCH_CLAIM_LINE_ID__COUNT_DESC",
  AUDIT_FINDINGS_COUNT_ASC = "AUDIT_FINDINGS_COUNT_ASC",
  AUDIT_FINDINGS_COUNT_DESC = "AUDIT_FINDINGS_COUNT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_MAX_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_MAX_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC = "AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC = "AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_MAX_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_MAX_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_MAX_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_MAX_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_MAX_CONFIDENCE_ASC = "AUDIT_FINDINGS_MAX_CONFIDENCE_ASC",
  AUDIT_FINDINGS_MAX_CONFIDENCE_DESC = "AUDIT_FINDINGS_MAX_CONFIDENCE_DESC",
  AUDIT_FINDINGS_MAX_CREATED_AT_ASC = "AUDIT_FINDINGS_MAX_CREATED_AT_ASC",
  AUDIT_FINDINGS_MAX_CREATED_AT_DESC = "AUDIT_FINDINGS_MAX_CREATED_AT_DESC",
  AUDIT_FINDINGS_MAX_DELETED_AT_ASC = "AUDIT_FINDINGS_MAX_DELETED_AT_ASC",
  AUDIT_FINDINGS_MAX_DELETED_AT_DESC = "AUDIT_FINDINGS_MAX_DELETED_AT_DESC",
  AUDIT_FINDINGS_MAX_DELETED_BY_ASC = "AUDIT_FINDINGS_MAX_DELETED_BY_ASC",
  AUDIT_FINDINGS_MAX_DELETED_BY_DESC = "AUDIT_FINDINGS_MAX_DELETED_BY_DESC",
  AUDIT_FINDINGS_MAX_ID_ASC = "AUDIT_FINDINGS_MAX_ID_ASC",
  AUDIT_FINDINGS_MAX_ID_DESC = "AUDIT_FINDINGS_MAX_ID_DESC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_MAX_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_MAX_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_MAX_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_MAX_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_MAX_UPDATED_AT_ASC = "AUDIT_FINDINGS_MAX_UPDATED_AT_ASC",
  AUDIT_FINDINGS_MAX_UPDATED_AT_DESC = "AUDIT_FINDINGS_MAX_UPDATED_AT_DESC",
  AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_MIN_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_MIN_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC = "AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC = "AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_MIN_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_MIN_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_MIN_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_MIN_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_MIN_CONFIDENCE_ASC = "AUDIT_FINDINGS_MIN_CONFIDENCE_ASC",
  AUDIT_FINDINGS_MIN_CONFIDENCE_DESC = "AUDIT_FINDINGS_MIN_CONFIDENCE_DESC",
  AUDIT_FINDINGS_MIN_CREATED_AT_ASC = "AUDIT_FINDINGS_MIN_CREATED_AT_ASC",
  AUDIT_FINDINGS_MIN_CREATED_AT_DESC = "AUDIT_FINDINGS_MIN_CREATED_AT_DESC",
  AUDIT_FINDINGS_MIN_DELETED_AT_ASC = "AUDIT_FINDINGS_MIN_DELETED_AT_ASC",
  AUDIT_FINDINGS_MIN_DELETED_AT_DESC = "AUDIT_FINDINGS_MIN_DELETED_AT_DESC",
  AUDIT_FINDINGS_MIN_DELETED_BY_ASC = "AUDIT_FINDINGS_MIN_DELETED_BY_ASC",
  AUDIT_FINDINGS_MIN_DELETED_BY_DESC = "AUDIT_FINDINGS_MIN_DELETED_BY_DESC",
  AUDIT_FINDINGS_MIN_ID_ASC = "AUDIT_FINDINGS_MIN_ID_ASC",
  AUDIT_FINDINGS_MIN_ID_DESC = "AUDIT_FINDINGS_MIN_ID_DESC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_MIN_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_MIN_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_MIN_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_MIN_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_MIN_UPDATED_AT_ASC = "AUDIT_FINDINGS_MIN_UPDATED_AT_ASC",
  AUDIT_FINDINGS_MIN_UPDATED_AT_DESC = "AUDIT_FINDINGS_MIN_UPDATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_SUM_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_SUM_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC = "AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC = "AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_SUM_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_SUM_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_SUM_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_SUM_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_SUM_CONFIDENCE_ASC = "AUDIT_FINDINGS_SUM_CONFIDENCE_ASC",
  AUDIT_FINDINGS_SUM_CONFIDENCE_DESC = "AUDIT_FINDINGS_SUM_CONFIDENCE_DESC",
  AUDIT_FINDINGS_SUM_CREATED_AT_ASC = "AUDIT_FINDINGS_SUM_CREATED_AT_ASC",
  AUDIT_FINDINGS_SUM_CREATED_AT_DESC = "AUDIT_FINDINGS_SUM_CREATED_AT_DESC",
  AUDIT_FINDINGS_SUM_DELETED_AT_ASC = "AUDIT_FINDINGS_SUM_DELETED_AT_ASC",
  AUDIT_FINDINGS_SUM_DELETED_AT_DESC = "AUDIT_FINDINGS_SUM_DELETED_AT_DESC",
  AUDIT_FINDINGS_SUM_DELETED_BY_ASC = "AUDIT_FINDINGS_SUM_DELETED_BY_ASC",
  AUDIT_FINDINGS_SUM_DELETED_BY_DESC = "AUDIT_FINDINGS_SUM_DELETED_BY_DESC",
  AUDIT_FINDINGS_SUM_ID_ASC = "AUDIT_FINDINGS_SUM_ID_ASC",
  AUDIT_FINDINGS_SUM_ID_DESC = "AUDIT_FINDINGS_SUM_ID_DESC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_SUM_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_SUM_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_SUM_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_SUM_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_SUM_UPDATED_AT_ASC = "AUDIT_FINDINGS_SUM_UPDATED_AT_ASC",
  AUDIT_FINDINGS_SUM_UPDATED_AT_DESC = "AUDIT_FINDINGS_SUM_UPDATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDITOR_COMMENT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDITOR_COMMENT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_NEEDS_REVIEW_IS_WRONG_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_NEEDS_REVIEW_IS_WRONG_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_NEEDS_REVIEW_IS_WRONG_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_NEEDS_REVIEW_IS_WRONG_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_COUNT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_COUNT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_COUNT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_COUNT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDITOR_COMMENT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDITOR_COMMENT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_NEEDS_REVIEW_IS_WRONG_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_NEEDS_REVIEW_IS_WRONG_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_NEEDS_REVIEW_IS_WRONG_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_NEEDS_REVIEW_IS_WRONG_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDITOR_COMMENT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDITOR_COMMENT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUTHOR_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUTHOR_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_CREATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_CREATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_CREATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_CREATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_NEEDS_REVIEW_IS_WRONG_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_NEEDS_REVIEW_IS_WRONG_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_NEEDS_REVIEW_IS_WRONG_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_NEEDS_REVIEW_IS_WRONG_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_UPDATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_UPDATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_UPDATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MAX_UPDATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDITOR_COMMENT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDITOR_COMMENT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUTHOR_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUTHOR_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_CREATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_CREATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_CREATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_CREATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_NEEDS_REVIEW_IS_WRONG_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_NEEDS_REVIEW_IS_WRONG_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_NEEDS_REVIEW_IS_WRONG_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_NEEDS_REVIEW_IS_WRONG_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_UPDATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_UPDATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_UPDATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_MIN_UPDATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_NEEDS_REVIEW_IS_WRONG_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_NEEDS_REVIEW_IS_WRONG_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_NEEDS_REVIEW_IS_WRONG_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_NEEDS_REVIEW_IS_WRONG_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_NEEDS_REVIEW_IS_WRONG_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_NEEDS_REVIEW_IS_WRONG_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_NEEDS_REVIEW_IS_WRONG_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_NEEDS_REVIEW_IS_WRONG_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDITOR_COMMENT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDITOR_COMMENT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUTHOR_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUTHOR_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_CREATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_CREATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_CREATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_CREATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_NEEDS_REVIEW_IS_WRONG_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_NEEDS_REVIEW_IS_WRONG_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_NEEDS_REVIEW_IS_WRONG_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_NEEDS_REVIEW_IS_WRONG_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_UPDATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_UPDATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_UPDATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_SUM_UPDATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_NEEDS_REVIEW_IS_WRONG_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_NEEDS_REVIEW_IS_WRONG_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_NEEDS_REVIEW_IS_WRONG_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_NEEDS_REVIEW_IS_WRONG_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_NEEDS_REVIEW_IS_WRONG_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_NEEDS_REVIEW_IS_WRONG_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_NEEDS_REVIEW_IS_WRONG_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_NEEDS_REVIEW_IS_WRONG_DESC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_CLAIM_LINE_ACCURACIES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_ADJUSTED_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_SAVINGS_ASC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_SAVINGS_ASC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_SAVINGS_DESC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__DETERMINED_SAVINGS_DESC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__ID_ASC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__ID_ASC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__ID_DESC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__ID_DESC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_ADJUSTED_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_SAVINGS_ASC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_SAVINGS_ASC",
  BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_SAVINGS_DESC = "BATCH_CLAIM_LINE_COMPUTED_VALUE_BY_ID__POTENTIAL_SAVINGS_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_BY_BATCH_CLAIM_LINE_ID__COUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_BY_BATCH_CLAIM_LINE_ID__COUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_BY_BATCH_CLAIM_LINE_ID__COUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_BY_BATCH_CLAIM_LINE_ID__COUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_COUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_COUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_COUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_COUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  CLIENT_LINE_NUMBER_ASC = "CLIENT_LINE_NUMBER_ASC",
  CLIENT_LINE_NUMBER_DESC = "CLIENT_LINE_NUMBER_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DIAG_1_ASC = "DIAG_1_ASC",
  DIAG_1_DESC = "DIAG_1_DESC",
  DIAG_1_DESCRIPTION_ASC = "DIAG_1_DESCRIPTION_ASC",
  DIAG_1_DESCRIPTION_DESC = "DIAG_1_DESCRIPTION_DESC",
  DIAG_2_ASC = "DIAG_2_ASC",
  DIAG_2_DESC = "DIAG_2_DESC",
  DIAG_2_DESCRIPTION_ASC = "DIAG_2_DESCRIPTION_ASC",
  DIAG_2_DESCRIPTION_DESC = "DIAG_2_DESCRIPTION_DESC",
  DIAG_3_ASC = "DIAG_3_ASC",
  DIAG_3_DESC = "DIAG_3_DESC",
  DIAG_3_DESCRIPTION_ASC = "DIAG_3_DESCRIPTION_ASC",
  DIAG_3_DESCRIPTION_DESC = "DIAG_3_DESCRIPTION_DESC",
  DIAG_4_ASC = "DIAG_4_ASC",
  DIAG_4_DESC = "DIAG_4_DESC",
  DIAG_4_DESCRIPTION_ASC = "DIAG_4_DESCRIPTION_ASC",
  DIAG_4_DESCRIPTION_DESC = "DIAG_4_DESCRIPTION_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  LINE_NUMBER_ASC = "LINE_NUMBER_ASC",
  LINE_NUMBER_DESC = "LINE_NUMBER_DESC",
  NATURAL = "NATURAL",
  NON_COVERED_AMOUNT_ASC = "NON_COVERED_AMOUNT_ASC",
  NON_COVERED_AMOUNT_DESC = "NON_COVERED_AMOUNT_DESC",
  NON_COV_CHARGE_ASC = "NON_COV_CHARGE_ASC",
  NON_COV_CHARGE_DESC = "NON_COV_CHARGE_DESC",
  PAYMENT_RATE_ASC = "PAYMENT_RATE_ASC",
  PAYMENT_RATE_DESC = "PAYMENT_RATE_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROCEDURE_CODE_ASC = "PROCEDURE_CODE_ASC",
  PROCEDURE_CODE_DESC = "PROCEDURE_CODE_DESC",
  PROCEDURE_CODE_MODIFIER_1_ASC = "PROCEDURE_CODE_MODIFIER_1_ASC",
  PROCEDURE_CODE_MODIFIER_1_DESC = "PROCEDURE_CODE_MODIFIER_1_DESC",
  PROCEDURE_CODE_MODIFIER_2_ASC = "PROCEDURE_CODE_MODIFIER_2_ASC",
  PROCEDURE_CODE_MODIFIER_2_DESC = "PROCEDURE_CODE_MODIFIER_2_DESC",
  PROCEDURE_CODE_MODIFIER_3_ASC = "PROCEDURE_CODE_MODIFIER_3_ASC",
  PROCEDURE_CODE_MODIFIER_3_DESC = "PROCEDURE_CODE_MODIFIER_3_DESC",
  PROCEDURE_CODE_MODIFIER_4_ASC = "PROCEDURE_CODE_MODIFIER_4_ASC",
  PROCEDURE_CODE_MODIFIER_4_DESC = "PROCEDURE_CODE_MODIFIER_4_DESC",
  PROCEDURE_DESCRIPTION_ASC = "PROCEDURE_DESCRIPTION_ASC",
  PROCEDURE_DESCRIPTION_DESC = "PROCEDURE_DESCRIPTION_DESC",
  REV_CODE_ASC = "REV_CODE_ASC",
  REV_CODE_DESC = "REV_CODE_DESC",
  REV_CODE_SRC_ASC = "REV_CODE_SRC_ASC",
  REV_CODE_SRC_DESC = "REV_CODE_SRC_DESC",
  REV_DESCRIPTION_ASC = "REV_DESCRIPTION_ASC",
  REV_DESCRIPTION_DESC = "REV_DESCRIPTION_DESC",
  SERVICE_DATE_ASC = "SERVICE_DATE_ASC",
  SERVICE_DATE_DESC = "SERVICE_DATE_DESC",
  UNITS_ASC = "UNITS_ASC",
  UNITS_DESC = "UNITS_DESC",
  UNIT_ALLOWABLE_CHARGE_ASC = "UNIT_ALLOWABLE_CHARGE_ASC",
  UNIT_ALLOWABLE_CHARGE_DESC = "UNIT_ALLOWABLE_CHARGE_DESC",
  UNIT_CHARGE_ASC = "UNIT_CHARGE_ASC",
  UNIT_CHARGE_DESC = "UNIT_CHARGE_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type BatchClaimMaxAggregateFilter = {
  amountCharged?: InputMaybe<FloatFilter>;
  amountReimbursed?: InputMaybe<FloatFilter>;
  documentBlockerStageSortOrder?: InputMaybe<IntFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  lifecycleSortOrder?: InputMaybe<IntFilter>;
  onHoldBlockerStageSortOrder?: InputMaybe<IntFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  phaseSortOrder?: InputMaybe<IntFilter>;
  stageSortOrder?: InputMaybe<IntFilter>;
  version?: InputMaybe<IntFilter>;
};

export type BatchClaimMaxAggregates = {
  __typename?: "BatchClaimMaxAggregates";
  /** Maximum of amountCharged across the matching connection */
  amountCharged?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of amountReimbursed across the matching connection */
  amountReimbursed?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the Document blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the document facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the document facet is absent. Matches documentBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  documentBlockerStageSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   *    Returns hierarchical sort position (phase * 1000 + stage sort order).
   *    Enables efficient lifecycle progression sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: LIFECYCLE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  lifecycleSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the On Hold blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the on_hold facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the on_hold facet is absent. Matches onHoldBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  onHoldBlockerStageSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   *    Returns phase sort order (1=intake, 2=audit, etc.).
   *    Enables efficient phase-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: PHASE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  phaseSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   *    Returns stage sort order within phase (1, 2, 3, etc.).
   *    Enables efficient stage-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: STAGE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  stageSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of version across the matching connection */
  version?: Maybe<Scalars["Int"]["output"]>;
};

export type BatchClaimMaxAggregatesimproperPaymentCostArgs = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchClaimMinAggregateFilter = {
  amountCharged?: InputMaybe<FloatFilter>;
  amountReimbursed?: InputMaybe<FloatFilter>;
  documentBlockerStageSortOrder?: InputMaybe<IntFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  lifecycleSortOrder?: InputMaybe<IntFilter>;
  onHoldBlockerStageSortOrder?: InputMaybe<IntFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  phaseSortOrder?: InputMaybe<IntFilter>;
  stageSortOrder?: InputMaybe<IntFilter>;
  version?: InputMaybe<IntFilter>;
};

export type BatchClaimMinAggregates = {
  __typename?: "BatchClaimMinAggregates";
  /** Minimum of amountCharged across the matching connection */
  amountCharged?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of amountReimbursed across the matching connection */
  amountReimbursed?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the Document blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the document facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the document facet is absent. Matches documentBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  documentBlockerStageSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   *    Returns hierarchical sort position (phase * 1000 + stage sort order).
   *    Enables efficient lifecycle progression sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: LIFECYCLE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  lifecycleSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the On Hold blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the on_hold facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the on_hold facet is absent. Matches onHoldBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  onHoldBlockerStageSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   *    Returns phase sort order (1=intake, 2=audit, etc.).
   *    Enables efficient phase-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: PHASE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  phaseSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   *    Returns stage sort order within phase (1, 2, 3, etc.).
   *    Enables efficient stage-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: STAGE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  stageSortOrder?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of version across the matching connection */
  version?: Maybe<Scalars["Int"]["output"]>;
};

export type BatchClaimMinAggregatesimproperPaymentCostArgs = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `activeClaimAssignee` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `activeClaimAssignee` being updated. */
    patch: ActiveClaimAssigneePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimAppealed` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAppealed` being updated. */
    patch: BatchClaimAppealedPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimAssignee` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAssignee` being updated. */
    patch: BatchClaimAssigneePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimAuditStartDate` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAuditStartDate` being updated. */
    patch: BatchClaimAuditStartDatePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimAuditType` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAuditType` being updated. */
    patch: BatchClaimAuditTypePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimAuditor` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimAuditor` being updated. */
    patch: BatchClaimAuditorPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimClientRecoveryAmount` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimClientRecoveryAmount` being updated. */
    patch: BatchClaimClientRecoveryAmountPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimClientRecoveryCollectionDate` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimClientRecoveryCollectionDate` being updated. */
    patch: BatchClaimClientRecoveryCollectionDatePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimDocument` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimDocument` being updated. */
    patch: BatchClaimDocumentPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimDueDate` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimDueDate` being updated. */
    patch: BatchClaimDueDatePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `auditorUser` being updated. */
  patch: AuditorUserPatch;
};

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `batchFile` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `batchFile` being updated. */
  patch: BatchFilePatch;
};

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `insurer` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `insurer` being updated. */
  patch: InsurerPatch;
};

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimPatientIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `patientDatum` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `patientDatum` being updated. */
  patch: PatientDatumPatch;
};

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimPatientIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimPatientIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimPatientIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimPatientIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimPatientIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimPatientIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimProviderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `provider` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `provider` being updated. */
  patch: ProviderPatch;
};

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimProviderIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimProviderIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimProviderIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimProviderIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimForBatchClaimProviderIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimForBatchClaimProviderIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLine` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLine` being updated. */
    patch: BatchClaimLinePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItem` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
    patch: BatchClaimLineItemPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimPayDeny` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimPayDeny` being updated. */
    patch: BatchClaimPayDenyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimState` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimState` being updated. */
    patch: BatchClaimStatePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimTechDenial` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimTechDenial` being updated. */
    patch: BatchClaimTechDenialPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `bucketClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `bucketClaim` being updated. */
    patch: BucketClaimPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `claimFacet` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `claimFacet` being updated. */
  patch: ClaimFacetPatch;
};

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `claimFacetHistory` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `claimFacetHistory` being updated. */
    patch: ClaimFacetHistoryPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `claimPolicyDocument` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `claimPolicyDocument` being updated. */
    patch: ClaimPolicyDocumentPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `clientSignOffClaimState` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `clientSignOffClaimState` being updated. */
    patch: ClientSignOffClaimStatePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `disputedFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `disputedFinding` being updated. */
    patch: DisputedFindingPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `documentRequestCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `documentRequestCreated` being updated. */
    patch: DocumentRequestCreatedPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `documentUploadCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
    patch: DocumentUploadCreatedPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `documentationClaimState` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `documentationClaimState` being updated. */
    patch: DocumentationClaimStatePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `invoiceClaimState` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `invoiceClaimState` being updated. */
    patch: InvoiceClaimStatePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `negotiationClaimState` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `negotiationClaimState` being updated. */
    patch: NegotiationClaimStatePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `onHoldClaimState` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `onHoldClaimState` being updated. */
    patch: OnHoldClaimStatePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `providerSignOffClaimState` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `providerSignOffClaimState` being updated. */
    patch: ProviderSignOffClaimStatePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `qaClaimStateRow` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `qaClaimStateRow` being updated. */
    patch: QaClaimStateRowPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnReportedClaimForReportedClaimClaimIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `reportedClaim` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `reportedClaim` being updated. */
  patch: ReportedClaimPatch;
};

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnReportedClaimForReportedClaimClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnReportedClaimForReportedClaimClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnReportedClaimForReportedClaimClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnReportedClaimForReportedClaimClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnReportedClaimForReportedClaimClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnReportedClaimForReportedClaimClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `s3AuditDocumentation` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `s3AuditDocumentation` being updated. */
    patch: S3AuditDocumentationPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `workflowClaimState` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `workflowClaimState` being updated. */
    patch: WorkflowClaimStatePatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate =
  {
    icn: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkPatch;
  };

/** The fields on `batchClaim` to look up the row to update. */
export type BatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: updateBatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkPatch;
  };

/** Represents an update to a `BatchClaim`. Fields that are set will be updated. */
export type BatchClaimPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
  batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
  batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
  batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
  batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
  batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
  batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
  batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
  batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
  batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
  bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
  claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
  claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
  clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
  invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
  negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
  onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
  patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
  patientId?: InputMaybe<Scalars["UUID"]["input"]>;
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
  providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
  reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
  s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
  workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
};

/** Input for the nested mutation of `patientDatum` in the `BatchClaimInput` mutation. */
export type BatchClaimPatientIdFkeyInput = {
  /** The primary key(s) for `patientDatum` for the far side of the relationship. */
  connectById?: InputMaybe<PatientDatumPatientDataPkeyConnect>;
  /** The primary key(s) for `patientDatum` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<PatientDatumNodeIdConnect>;
  /** The primary key(s) for `patientDatum` for the far side of the relationship. */
  connectByPayerPatientId?: InputMaybe<PatientDatumPatientDataMedicaidIdKeyConnect>;
  /** The primary key(s) and patch data for `patientDatum` for the far side of the relationship. */
  updateById?: InputMaybe<PatientDatumOnBatchClaimForBatchClaimPatientIdFkeyUsingPatientDataPkeyUpdate>;
  /** The primary key(s) and patch data for `patientDatum` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBatchClaimForBatchClaimPatientIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `patientDatum` for the far side of the relationship. */
  updateByPayerPatientId?: InputMaybe<PatientDatumOnBatchClaimForBatchClaimPatientIdFkeyUsingPatientDataMedicaidIdKeyUpdate>;
};

/** Input for the nested mutation of `batchClaim` in the `PatientDatumInput` mutation. */
export type BatchClaimPatientIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<Array<BatchClaimBatchClaimIcnKeyConnect>>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BatchClaimBatchClaimPkeyConnect>>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<
    Array<BatchClaimBatchClaimIdInsurerKeyConnect>
  >;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimNodeIdConnect>>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimPatientIdFkeyUsingBatchClaimIcnKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimPatientIdFkeyUsingBatchClaimPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimPatientIdFkeyUsingBatchClaimIdInsurerKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<PatientDatumOnBatchClaimForBatchClaimPatientIdFkeyNodeIdUpdate>
  >;
};

/** A connection to a list of `BatchClaimPayDeny` values. */
export type BatchClaimPayDeniesConnection = {
  __typename?: "BatchClaimPayDeniesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimPayDenyAggregates>;
  /** A list of edges which contains the `BatchClaimPayDeny` and cursor to aid in pagination. */
  edges: Array<BatchClaimPayDeniesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimPayDenyAggregates>>;
  /** A list of `BatchClaimPayDeny` objects. */
  nodes: Array<Maybe<BatchClaimPayDeny>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimPayDeny` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimPayDeny` values. */
export type BatchClaimPayDeniesConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimPayDenyGroupBy>;
  having?: InputMaybe<BatchClaimPayDenyHavingInput>;
};

/** A `BatchClaimPayDeny` edge in the connection. */
export type BatchClaimPayDeniesEdge = {
  __typename?: "BatchClaimPayDeniesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimPayDeny` at the end of the edge. */
  node?: Maybe<BatchClaimPayDeny>;
};

/** Methods to use when ordering `BatchClaimPayDeny`. */
export enum BatchClaimPayDeniesOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PAY_DENY_ASC = "PAY_DENY_ASC",
  PAY_DENY_DESC = "PAY_DENY_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type BatchClaimPayDeny = Node & {
  __typename?: "BatchClaimPayDeny";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimPayDeny`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  payDeny?: Maybe<Scalars["Boolean"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

export type BatchClaimPayDenyAggregates = {
  __typename?: "BatchClaimPayDenyAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimPayDenyDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** The `batchClaimPayDeny` to be created by this mutation. */
export type BatchClaimPayDenyBatchClaimIdFkeyBatchClaimPayDenyCreateInput = {
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  payDeny?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `batchClaim` in the `BatchClaimPayDenyInput` mutation. */
export type BatchClaimPayDenyBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimPayDenyOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimPayDeny` in the `BatchClaimInput` mutation. */
export type BatchClaimPayDenyBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimPayDeny` for the far side of the relationship. */
  connectByBatchClaimId?: InputMaybe<BatchClaimPayDenyBatchClaimPayDenyBatchClaimIdKeyConnect>;
  /** The primary key(s) for `batchClaimPayDeny` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimPayDenyBatchClaimPayDenyPkeyConnect>;
  /** The primary key(s) for `batchClaimPayDeny` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimPayDenyNodeIdConnect>;
  /** A `BatchClaimPayDenyInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimPayDenyBatchClaimIdFkeyBatchClaimPayDenyCreateInput>
  >;
  /** The primary key(s) and patch data for `batchClaimPayDeny` for the far side of the relationship. */
  updateByBatchClaimId?: InputMaybe<BatchClaimPayDenyOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyUsingBatchClaimPayDenyBatchClaimIdKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimPayDeny` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimPayDenyOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyUsingBatchClaimPayDenyPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimPayDeny` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyNodeIdUpdate>;
};

/** The fields on `batchClaimPayDeny` to look up the row to connect. */
export type BatchClaimPayDenyBatchClaimPayDenyBatchClaimIdKeyConnect = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The fields on `batchClaimPayDeny` to look up the row to connect. */
export type BatchClaimPayDenyBatchClaimPayDenyPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `BatchClaimPayDeny` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimPayDenyCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `payDeny` field. */
  payDeny?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type BatchClaimPayDenyDistinctCountAggregates = {
  __typename?: "BatchClaimPayDenyDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of payDeny across the matching connection */
  payDeny?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimPayDeny` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimPayDenyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimPayDenyFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimPayDenyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimPayDenyFilter>>;
  /** Filter by the object’s `payDeny` field. */
  payDeny?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BatchClaimPayDeny` for usage during aggregation. */
export enum BatchClaimPayDenyGroupBy {
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  PAY_DENY = "PAY_DENY",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type BatchClaimPayDenyHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimPayDenyHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimPayDeny` aggregates. */
export type BatchClaimPayDenyHavingInput = {
  AND?: InputMaybe<Array<BatchClaimPayDenyHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimPayDenyHavingInput>>;
  average?: InputMaybe<BatchClaimPayDenyHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimPayDenyHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimPayDenyHavingMaxInput>;
  min?: InputMaybe<BatchClaimPayDenyHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimPayDenyHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimPayDenyHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimPayDenyHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimPayDenyHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimPayDenyHavingVarianceSampleInput>;
};

export type BatchClaimPayDenyHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimPayDenyHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimPayDenyHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimPayDenyHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimPayDenyHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimPayDenyHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimPayDenyHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimPayDeny` */
export type BatchClaimPayDenyInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  payDeny?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimPayDenyNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimPayDeny` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimPayDenyOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimPayDeny` to look up the row to update. */
export type BatchClaimPayDenyOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyUsingBatchClaimPayDenyBatchClaimIdKeyUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimPayDeny` being updated. */
    patch: updateBatchClaimPayDenyOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaimPayDeny` to look up the row to update. */
export type BatchClaimPayDenyOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyUsingBatchClaimPayDenyPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimPayDeny` being updated. */
    patch: updateBatchClaimPayDenyOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimPayDeny`. Fields that are set will be updated. */
export type BatchClaimPayDenyPatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  payDeny?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/**
 * ### Overview
 * Pay vs deny decision cached on batch_claim_state (from v3.batch_claim_pay_deny).
 */
export enum BatchClaimPayDenyStateEnum {
  DENY = "DENY",
  PAY = "PAY",
}

/** A filter to be used against BatchClaimPayDenyStateEnum fields. All fields are combined with a logical ‘and.’ */
export type BatchClaimPayDenyStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BatchClaimPayDenyStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BatchClaimPayDenyStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BatchClaimPayDenyStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BatchClaimPayDenyStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BatchClaimPayDenyStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BatchClaimPayDenyStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BatchClaimPayDenyStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BatchClaimPayDenyStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BatchClaimPayDenyStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BatchClaimPayDenyStateEnum>>;
};

/** Input for the nested mutation of `batchClaim` in the `BatchClaimInput` mutation. */
export type BatchClaimPreviousVersionIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `provider` in the `BatchClaimInput` mutation. */
export type BatchClaimProviderIdFkeyInput = {
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectById?: InputMaybe<ProviderProviderPkeyConnect>;
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProviderNodeIdConnect>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateById?: InputMaybe<ProviderOnBatchClaimForBatchClaimProviderIdFkeyUsingProviderPkeyUpdate>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBatchClaimForBatchClaimProviderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaim` in the `ProviderInput` mutation. */
export type BatchClaimProviderIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<Array<BatchClaimBatchClaimIcnKeyConnect>>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BatchClaimBatchClaimPkeyConnect>>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<
    Array<BatchClaimBatchClaimIdInsurerKeyConnect>
  >;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimNodeIdConnect>>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimProviderIdFkeyUsingBatchClaimIcnKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimProviderIdFkeyUsingBatchClaimPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<
    Array<BatchClaimOnBatchClaimForBatchClaimProviderIdFkeyUsingBatchClaimIdInsurerKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<ProviderOnBatchClaimForBatchClaimProviderIdFkeyNodeIdUpdate>
  >;
};

/**
 * ### Overview
 * Computed fields related to all state associated with a claim. States include workflow state, document request state, is provider active state, report state disputes state, provider & client sign off state, invoice state, on hold state, negotiation state, det & pot adj allowed amount, det & pot client savings, det & pot discrepant amount, realized savings.
 */
export type BatchClaimState = Node & {
  __typename?: "BatchClaimState";
  /**
   * ### Overview
   * Cached Appealed flag from v3.batch_claim_appealed.
   * true = Appealed; NULL = empty/clear.
   */
  appealed?: Maybe<Scalars["Boolean"]["output"]>;
  auditStartDate?: Maybe<Scalars["Datetime"]["output"]>;
  /** Reads a single `AuditorUser` that is related to this `BatchClaimState`. */
  auditorUser?: Maybe<AuditorUser>;
  auditorUserId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimState`. */
  batchClaimById?: Maybe<BatchClaim>;
  /** Reads a single `ClaimAuditGroup` that is related to this `BatchClaimState`. */
  claimAuditGroup?: Maybe<ClaimAuditGroup>;
  /** Denormalized FK to v3.claim_audit_group(id), maintained by trigger t1_update_cache_batch_claim_state_from_batch_claim_audit_group on v3.batch_claim_audit_group. Never user-writable. NULL = claim is not assigned to any audit group. */
  claimAuditGroupId?: Maybe<Scalars["UUID"]["output"]>;
  claimAuditType?: Maybe<Scalars["String"]["output"]>;
  /** Cached value: Amount recovered by the client as invoiced savings for this claim. NULL if never set or cleared. */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Cached value: Date when the client recovery amount was collected. NULL if never set or cleared. */
  clientRecoveryCollectionDate?: Maybe<Scalars["Datetime"]["output"]>;
  clientSignOffClaimState?: Maybe<ClientSignOffClaimStateEnum>;
  /**
   * ### current_phase_id
   * claim_lifecycle_phase keyword id copied from claim_facets by trigger. Feeds generated is_provider_active (batch_claim_state cannot reference facet JSONB).
   */
  currentPhaseId?: Maybe<Scalars["UUID"]["output"]>;
  /**
   * ### current_stage_id
   * claim_lifecycle_stage keyword id copied from claim_facets by trigger. Feeds generated is_provider_active (batch_claim_state cannot reference facet JSONB).
   */
  currentStageId?: Maybe<Scalars["UUID"]["output"]>;
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  disputedFindingClaimState?: Maybe<DisputedFindingClaimStateEnum>;
  documentationClaimState: DocumentationClaimStateEnum;
  dueDate?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  invoiceClaimState?: Maybe<InvoiceClaimStateEnum>;
  /**
   * ### is_provider_active
   * Indicates whether a claim is visible to providers (generated from current_stage_id and current_phase_id).
   *
   * This column is the source of truth for provider visibility. It is GENERATED ALWAYS AS ... STORED; if visibility rules change, drop and recreate this column.
   *
   * is_provider_active is FALSE when:
   * - current_stage_id is CLAIM_SELECTION (1.1) or a closed-outcome stage NOT in the visible-closed allowlist (UUIDs resolved from facet keywords when the column is created)
   * - current_phase_id is the CLOSED phase (99.0) AND current_stage_id is not in the visible-closed allowlist
   *
   * is_provider_active is TRUE when neither hide rule applies, including:
   * - when current_stage_id and/or current_phase_id are NULL (no lifecycle set yet)
   * - when current_stage_id is in the visible-closed allowlist (currently: CLOSED_CLIENT_REPORT_SENT), even if current_phase_id is CLOSED
   *
   * New closed-outcome stages added to the closed facet are hidden by default; add their slug to the visible-closed allowlist in the migration and re-run to expose them to providers.
   */
  isProviderActive?: Maybe<Scalars["Boolean"]["output"]>;
  isRealized?: Maybe<Scalars["Boolean"]["output"]>;
  negotiationClaimState?: Maybe<NegotiationClaimStateEnum>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  onHoldClaimState?: Maybe<OnHoldClaimStateEnum>;
  /** Cached pay/deny from v3.batch_claim_pay_deny (true=PAY, false=DENY). */
  payDeny?: Maybe<BatchClaimPayDenyStateEnum>;
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  providerSignOffClaimState?: Maybe<ProviderSignOffClaimStateEnum>;
  qaClaimState: QaClaimStateOptions;
  reported?: Maybe<Scalars["Boolean"]["output"]>;
  /** Resolved claim lifecycle stage from facets; null when no lifecycle stage is set or data is missing. */
  stage?: Maybe<ClaimStage>;
  /**
   * ### Overview
   * Cached Tech Denial flag from v3.batch_claim_tech_denial.
   * true = Tech Denied; NULL = empty/clear.
   */
  techDenied?: Maybe<Scalars["Boolean"]["output"]>;
  workflowClaimState?: Maybe<WorkflowClaimStateEnum>;
};

export type BatchClaimStateAggregates = {
  __typename?: "BatchClaimStateAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BatchClaimStateAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimStateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BatchClaimStateMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BatchClaimStateMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BatchClaimStateStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BatchClaimStateStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BatchClaimStateSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BatchClaimStateVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BatchClaimStateVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BatchClaimState` object types. */
export type BatchClaimStateAggregatesFilter = {
  /** Mean average aggregate over matching `BatchClaimState` objects. */
  average?: InputMaybe<BatchClaimStateAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BatchClaimState` objects. */
  distinctCount?: InputMaybe<BatchClaimStateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimState` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimStateFilter>;
  /** Maximum aggregate over matching `BatchClaimState` objects. */
  max?: InputMaybe<BatchClaimStateMaxAggregateFilter>;
  /** Minimum aggregate over matching `BatchClaimState` objects. */
  min?: InputMaybe<BatchClaimStateMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BatchClaimState` objects. */
  stddevPopulation?: InputMaybe<BatchClaimStateStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BatchClaimState` objects. */
  stddevSample?: InputMaybe<BatchClaimStateStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BatchClaimState` objects. */
  sum?: InputMaybe<BatchClaimStateSumAggregateFilter>;
  /** Population variance aggregate over matching `BatchClaimState` objects. */
  variancePopulation?: InputMaybe<BatchClaimStateVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BatchClaimState` objects. */
  varianceSample?: InputMaybe<BatchClaimStateVarianceSampleAggregateFilter>;
};

/** Input for the nested mutation of `auditorUser` in the `BatchClaimStateInput` mutation. */
export type BatchClaimStateAuditorUserIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimStateOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimState` in the `AuditorUserInput` mutation. */
export type BatchClaimStateAuditorUserIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimState` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimStateCacheBatchClaimStatePkeyConnect>
  >;
  /** The primary key(s) for `batchClaimState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimStateNodeIdConnect>>;
  /** The primary key(s) and patch data for `batchClaimState` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimStateOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyUsingCacheBatchClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyNodeIdUpdate>
  >;
};

export type BatchClaimStateAverageAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<FloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimStateAverageAggregates = {
  __typename?: "BatchClaimStateAverageAggregates";
  /** Mean average of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of determinedClientSavings across the matching connection */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of potentialClientSavings across the matching connection */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Mean average of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
};

/** Input for the nested mutation of `batchClaim` in the `BatchClaimStateInput` mutation. */
export type BatchClaimStateBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimStateOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimState` in the `BatchClaimInput` mutation. */
export type BatchClaimStateBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimState` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimStateCacheBatchClaimStatePkeyConnect>;
  /** The primary key(s) for `batchClaimState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimStateNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaimState` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimStateOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyUsingCacheBatchClaimStatePkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyNodeIdUpdate>;
};

/** The fields on `batchClaimState` to look up the row to connect. */
export type BatchClaimStateCacheBatchClaimStatePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `claimAuditGroup` in the `BatchClaimStateInput` mutation. */
export type BatchClaimStateClaimAuditGroupIdFkeyInput = {
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  connectById?: InputMaybe<ClaimAuditGroupClaimAuditGroupPkeyConnect>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  connectByName?: InputMaybe<ClaimAuditGroupClaimAuditGroupNameKeyConnect>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ClaimAuditGroupNodeIdConnect>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<ClaimAuditGroupClaimAuditGroupPkeyDelete>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  deleteByName?: InputMaybe<ClaimAuditGroupClaimAuditGroupNameKeyDelete>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ClaimAuditGroupNodeIdDelete>;
  /** The primary key(s) and patch data for `claimAuditGroup` for the far side of the relationship. */
  updateById?: InputMaybe<ClaimAuditGroupOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyUsingClaimAuditGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `claimAuditGroup` for the far side of the relationship. */
  updateByName?: InputMaybe<ClaimAuditGroupOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyUsingClaimAuditGroupNameKeyUpdate>;
  /** The primary key(s) and patch data for `claimAuditGroup` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimStateOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimState` in the `ClaimAuditGroupInput` mutation. */
export type BatchClaimStateClaimAuditGroupIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimState` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimStateCacheBatchClaimStatePkeyConnect>
  >;
  /** The primary key(s) for `batchClaimState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimStateNodeIdConnect>>;
  /** The primary key(s) and patch data for `batchClaimState` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimStateOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyUsingCacheBatchClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<ClaimAuditGroupOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `BatchClaimState` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimStateCondition = {
  /** Checks for equality with the object’s `appealed` field. */
  appealed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `auditStartDate` field. */
  auditStartDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `claimAuditGroupId` field. */
  claimAuditGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `claimAuditType` field. */
  claimAuditType?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `clientRecoveryAmount` field. */
  clientRecoveryAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `clientRecoveryCollectionDate` field. */
  clientRecoveryCollectionDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `clientSignOffClaimState` field. */
  clientSignOffClaimState?: InputMaybe<ClientSignOffClaimStateEnum>;
  /** Checks for equality with the object’s `currentPhaseId` field. */
  currentPhaseId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `currentStageId` field. */
  currentStageId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `determinedAdjustedAllowedAmount` field. */
  determinedAdjustedAllowedAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `determinedClientSavings` field. */
  determinedClientSavings?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `determinedDiscrepantAmount` field. */
  determinedDiscrepantAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `disputedFindingClaimState` field. */
  disputedFindingClaimState?: InputMaybe<DisputedFindingClaimStateEnum>;
  /** Checks for equality with the object’s `documentationClaimState` field. */
  documentationClaimState?: InputMaybe<DocumentationClaimStateEnum>;
  /** Checks for equality with the object’s `dueDate` field. */
  dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `invoiceClaimState` field. */
  invoiceClaimState?: InputMaybe<InvoiceClaimStateEnum>;
  /** Checks for equality with the object’s `isProviderActive` field. */
  isProviderActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `isRealized` field. */
  isRealized?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `negotiationClaimState` field. */
  negotiationClaimState?: InputMaybe<NegotiationClaimStateEnum>;
  /** Checks for equality with the object’s `onHoldClaimState` field. */
  onHoldClaimState?: InputMaybe<OnHoldClaimStateEnum>;
  /** Checks for equality with the object’s `payDeny` field. */
  payDeny?: InputMaybe<BatchClaimPayDenyStateEnum>;
  /** Checks for equality with the object’s `potentialAdjustedAllowedAmount` field. */
  potentialAdjustedAllowedAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `potentialClientSavings` field. */
  potentialClientSavings?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `potentialDiscrepantAmount` field. */
  potentialDiscrepantAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `providerSignOffClaimState` field. */
  providerSignOffClaimState?: InputMaybe<ProviderSignOffClaimStateEnum>;
  /** Checks for equality with the object’s `qaClaimState` field. */
  qaClaimState?: InputMaybe<QaClaimStateOptions>;
  /** Checks for equality with the object’s `reported` field. */
  reported?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `techDenied` field. */
  techDenied?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `workflowClaimState` field. */
  workflowClaimState?: InputMaybe<WorkflowClaimStateEnum>;
};

export type BatchClaimStateDistinctCountAggregateFilter = {
  appealed?: InputMaybe<BigIntFilter>;
  auditStartDate?: InputMaybe<BigIntFilter>;
  auditorUserId?: InputMaybe<BigIntFilter>;
  claimAuditGroupId?: InputMaybe<BigIntFilter>;
  claimAuditType?: InputMaybe<BigIntFilter>;
  clientRecoveryAmount?: InputMaybe<BigIntFilter>;
  clientRecoveryCollectionDate?: InputMaybe<BigIntFilter>;
  clientSignOffClaimState?: InputMaybe<BigIntFilter>;
  currentPhaseId?: InputMaybe<BigIntFilter>;
  currentStageId?: InputMaybe<BigIntFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<BigIntFilter>;
  determinedClientSavings?: InputMaybe<BigIntFilter>;
  determinedDiscrepantAmount?: InputMaybe<BigIntFilter>;
  disputedFindingClaimState?: InputMaybe<BigIntFilter>;
  documentationClaimState?: InputMaybe<BigIntFilter>;
  dueDate?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  invoiceClaimState?: InputMaybe<BigIntFilter>;
  isProviderActive?: InputMaybe<BigIntFilter>;
  isRealized?: InputMaybe<BigIntFilter>;
  negotiationClaimState?: InputMaybe<BigIntFilter>;
  onHoldClaimState?: InputMaybe<BigIntFilter>;
  payDeny?: InputMaybe<BigIntFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<BigIntFilter>;
  potentialClientSavings?: InputMaybe<BigIntFilter>;
  potentialDiscrepantAmount?: InputMaybe<BigIntFilter>;
  providerSignOffClaimState?: InputMaybe<BigIntFilter>;
  qaClaimState?: InputMaybe<BigIntFilter>;
  reported?: InputMaybe<BigIntFilter>;
  techDenied?: InputMaybe<BigIntFilter>;
  workflowClaimState?: InputMaybe<BigIntFilter>;
};

export type BatchClaimStateDistinctCountAggregates = {
  __typename?: "BatchClaimStateDistinctCountAggregates";
  /** Distinct count of appealed across the matching connection */
  appealed?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditStartDate across the matching connection */
  auditStartDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditorUserId across the matching connection */
  auditorUserId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of claimAuditGroupId across the matching connection */
  claimAuditGroupId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of claimAuditType across the matching connection */
  claimAuditType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientRecoveryCollectionDate across the matching connection */
  clientRecoveryCollectionDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientSignOffClaimState across the matching connection */
  clientSignOffClaimState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of currentPhaseId across the matching connection */
  currentPhaseId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of currentStageId across the matching connection */
  currentStageId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of determinedClientSavings across the matching connection */
  determinedClientSavings?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of disputedFindingClaimState across the matching connection */
  disputedFindingClaimState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of documentationClaimState across the matching connection */
  documentationClaimState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dueDate across the matching connection */
  dueDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of invoiceClaimState across the matching connection */
  invoiceClaimState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of isProviderActive across the matching connection */
  isProviderActive?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of isRealized across the matching connection */
  isRealized?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of negotiationClaimState across the matching connection */
  negotiationClaimState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of onHoldClaimState across the matching connection */
  onHoldClaimState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of payDeny across the matching connection */
  payDeny?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of potentialClientSavings across the matching connection */
  potentialClientSavings?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of providerSignOffClaimState across the matching connection */
  providerSignOffClaimState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of qaClaimState across the matching connection */
  qaClaimState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of reported across the matching connection */
  reported?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of techDenied across the matching connection */
  techDenied?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of workflowClaimState across the matching connection */
  workflowClaimState?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimState` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimStateFilter>>;
  /** Filter by the object’s `appealed` field. */
  appealed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `auditStartDate` field. */
  auditStartDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `auditorUser` relation. */
  auditorUser?: InputMaybe<AuditorUserFilter>;
  /** A related `auditorUser` exists. */
  auditorUserExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaimById` relation. */
  batchClaimById?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `claimAuditGroup` relation. */
  claimAuditGroup?: InputMaybe<ClaimAuditGroupFilter>;
  /** A related `claimAuditGroup` exists. */
  claimAuditGroupExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `claimAuditGroupId` field. */
  claimAuditGroupId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `claimAuditType` field. */
  claimAuditType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientRecoveryAmount` field. */
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `clientRecoveryCollectionDate` field. */
  clientRecoveryCollectionDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `clientSignOffClaimState` field. */
  clientSignOffClaimState?: InputMaybe<ClientSignOffClaimStateEnumFilter>;
  /** Filter by the object’s `currentPhaseId` field. */
  currentPhaseId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `currentStageId` field. */
  currentStageId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `determinedAdjustedAllowedAmount` field. */
  determinedAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `determinedClientSavings` field. */
  determinedClientSavings?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `determinedDiscrepantAmount` field. */
  determinedDiscrepantAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `disputedFindingClaimState` field. */
  disputedFindingClaimState?: InputMaybe<DisputedFindingClaimStateEnumFilter>;
  /** Filter by the object’s `documentationClaimState` field. */
  documentationClaimState?: InputMaybe<DocumentationClaimStateEnumFilter>;
  /** Filter by the object’s `dueDate` field. */
  dueDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `invoiceClaimState` field. */
  invoiceClaimState?: InputMaybe<InvoiceClaimStateEnumFilter>;
  /** Filter by the object’s `isProviderActive` field. */
  isProviderActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isRealized` field. */
  isRealized?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `negotiationClaimState` field. */
  negotiationClaimState?: InputMaybe<NegotiationClaimStateEnumFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimStateFilter>;
  /** Filter by the object’s `onHoldClaimState` field. */
  onHoldClaimState?: InputMaybe<OnHoldClaimStateEnumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimStateFilter>>;
  /** Filter by the object’s `payDeny` field. */
  payDeny?: InputMaybe<BatchClaimPayDenyStateEnumFilter>;
  /** Filter by the object’s `potentialAdjustedAllowedAmount` field. */
  potentialAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `potentialClientSavings` field. */
  potentialClientSavings?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `potentialDiscrepantAmount` field. */
  potentialDiscrepantAmount?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `providerSignOffClaimState` field. */
  providerSignOffClaimState?: InputMaybe<ProviderSignOffClaimStateEnumFilter>;
  /** Filter by the object’s `qaClaimState` field. */
  qaClaimState?: InputMaybe<QaClaimStateOptionsFilter>;
  /** Filter by the object’s `reported` field. */
  reported?: InputMaybe<BooleanFilter>;
  /** Filter by lifecycle stage using claim_lifecycle_stage facet. */
  stage?: InputMaybe<ClaimStageFilter>;
  /** Filter by the object’s `techDenied` field. */
  techDenied?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `workflowClaimState` field. */
  workflowClaimState?: InputMaybe<WorkflowClaimStateEnumFilter>;
};

/** Grouping methods for `BatchClaimState` for usage during aggregation. */
export enum BatchClaimStateGroupBy {
  APPEALED = "APPEALED",
  AUDITOR_USER_ID = "AUDITOR_USER_ID",
  AUDIT_START_DATE = "AUDIT_START_DATE",
  AUDIT_START_DATE_TRUNCATED_TO_DAY = "AUDIT_START_DATE_TRUNCATED_TO_DAY",
  AUDIT_START_DATE_TRUNCATED_TO_HOUR = "AUDIT_START_DATE_TRUNCATED_TO_HOUR",
  CLAIM_AUDIT_GROUP_ID = "CLAIM_AUDIT_GROUP_ID",
  CLAIM_AUDIT_TYPE = "CLAIM_AUDIT_TYPE",
  CLIENT_RECOVERY_AMOUNT = "CLIENT_RECOVERY_AMOUNT",
  CLIENT_RECOVERY_COLLECTION_DATE = "CLIENT_RECOVERY_COLLECTION_DATE",
  CLIENT_RECOVERY_COLLECTION_DATE_TRUNCATED_TO_DAY = "CLIENT_RECOVERY_COLLECTION_DATE_TRUNCATED_TO_DAY",
  CLIENT_RECOVERY_COLLECTION_DATE_TRUNCATED_TO_HOUR = "CLIENT_RECOVERY_COLLECTION_DATE_TRUNCATED_TO_HOUR",
  CLIENT_SIGN_OFF_CLAIM_STATE = "CLIENT_SIGN_OFF_CLAIM_STATE",
  CURRENT_PHASE_ID = "CURRENT_PHASE_ID",
  CURRENT_STAGE_ID = "CURRENT_STAGE_ID",
  DETERMINED_ADJUSTED_ALLOWED_AMOUNT = "DETERMINED_ADJUSTED_ALLOWED_AMOUNT",
  DETERMINED_CLIENT_SAVINGS = "DETERMINED_CLIENT_SAVINGS",
  DETERMINED_DISCREPANT_AMOUNT = "DETERMINED_DISCREPANT_AMOUNT",
  DISPUTED_FINDING_CLAIM_STATE = "DISPUTED_FINDING_CLAIM_STATE",
  DOCUMENTATION_CLAIM_STATE = "DOCUMENTATION_CLAIM_STATE",
  DUE_DATE = "DUE_DATE",
  DUE_DATE_TRUNCATED_TO_DAY = "DUE_DATE_TRUNCATED_TO_DAY",
  DUE_DATE_TRUNCATED_TO_HOUR = "DUE_DATE_TRUNCATED_TO_HOUR",
  INVOICE_CLAIM_STATE = "INVOICE_CLAIM_STATE",
  IS_PROVIDER_ACTIVE = "IS_PROVIDER_ACTIVE",
  IS_REALIZED = "IS_REALIZED",
  NEGOTIATION_CLAIM_STATE = "NEGOTIATION_CLAIM_STATE",
  ON_HOLD_CLAIM_STATE = "ON_HOLD_CLAIM_STATE",
  PAY_DENY = "PAY_DENY",
  POTENTIAL_ADJUSTED_ALLOWED_AMOUNT = "POTENTIAL_ADJUSTED_ALLOWED_AMOUNT",
  POTENTIAL_CLIENT_SAVINGS = "POTENTIAL_CLIENT_SAVINGS",
  POTENTIAL_DISCREPANT_AMOUNT = "POTENTIAL_DISCREPANT_AMOUNT",
  PROVIDER_SIGN_OFF_CLAIM_STATE = "PROVIDER_SIGN_OFF_CLAIM_STATE",
  QA_CLAIM_STATE = "QA_CLAIM_STATE",
  REPORTED = "REPORTED",
  TECH_DENIED = "TECH_DENIED",
  WORKFLOW_CLAIM_STATE = "WORKFLOW_CLAIM_STATE",
}

export type BatchClaimStateHavingAverageInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedClientSavings?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialClientSavings?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimStateHavingDistinctCountInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedClientSavings?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialClientSavings?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
};

/** Conditions for `BatchClaimState` aggregates. */
export type BatchClaimStateHavingInput = {
  AND?: InputMaybe<Array<BatchClaimStateHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimStateHavingInput>>;
  average?: InputMaybe<BatchClaimStateHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimStateHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimStateHavingMaxInput>;
  min?: InputMaybe<BatchClaimStateHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimStateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimStateHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimStateHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimStateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimStateHavingVarianceSampleInput>;
};

export type BatchClaimStateHavingMaxInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedClientSavings?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialClientSavings?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimStateHavingMinInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedClientSavings?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialClientSavings?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimStateHavingStddevPopulationInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedClientSavings?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialClientSavings?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimStateHavingStddevSampleInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedClientSavings?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialClientSavings?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimStateHavingSumInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedClientSavings?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialClientSavings?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimStateHavingVariancePopulationInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedClientSavings?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialClientSavings?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimStateHavingVarianceSampleInput = {
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientRecoveryAmount?: InputMaybe<HavingFloatFilter>;
  clientRecoveryCollectionDate?: InputMaybe<HavingDatetimeFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  determinedClientSavings?: InputMaybe<HavingFloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<HavingFloatFilter>;
  potentialClientSavings?: InputMaybe<HavingFloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<HavingFloatFilter>;
};

export type BatchClaimStateMaxAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<FloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimStateMaxAggregates = {
  __typename?: "BatchClaimStateMaxAggregates";
  /** Maximum of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of determinedClientSavings across the matching connection */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of potentialClientSavings across the matching connection */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Maximum of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimStateMinAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<FloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimStateMinAggregates = {
  __typename?: "BatchClaimStateMinAggregates";
  /** Minimum of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of determinedClientSavings across the matching connection */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of potentialClientSavings across the matching connection */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Minimum of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimStateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimState` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimStateOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `batchClaimState` to look up the row to update. */
export type BatchClaimStateOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyUsingCacheBatchClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimState` being updated. */
    patch: updateBatchClaimStateOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimStateOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimState` to look up the row to update. */
export type BatchClaimStateOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyUsingCacheBatchClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimState` being updated. */
    patch: updateBatchClaimStateOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimStateOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `claimAuditGroup` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
    patch: ClaimAuditGroupPatch;
  };

/** The fields on `batchClaimState` to look up the row to update. */
export type BatchClaimStateOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyUsingCacheBatchClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimState` being updated. */
    patch: updateBatchClaimStateOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyPatch;
  };

/** Represents an update to a `BatchClaimState`. Fields that are set will be updated. */
export type BatchClaimStatePatch = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInput>;
  batchClaimToId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInput>;
  claimAuditGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
  claimAuditGroupToClaimAuditGroupId?: InputMaybe<BatchClaimStateClaimAuditGroupIdFkeyInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type BatchClaimStateStddevPopulationAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<FloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimStateStddevPopulationAggregates = {
  __typename?: "BatchClaimStateStddevPopulationAggregates";
  /** Population standard deviation of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of determinedClientSavings across the matching connection */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of potentialClientSavings across the matching connection */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimStateStddevSampleAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<FloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimStateStddevSampleAggregates = {
  __typename?: "BatchClaimStateStddevSampleAggregates";
  /** Sample standard deviation of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of determinedClientSavings across the matching connection */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of potentialClientSavings across the matching connection */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimStateSumAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<FloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimStateSumAggregates = {
  __typename?: "BatchClaimStateSumAggregates";
  /** Sum of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount: Scalars["Float"]["output"];
  /** Sum of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount: Scalars["Float"]["output"];
  /** Sum of determinedClientSavings across the matching connection */
  determinedClientSavings: Scalars["Float"]["output"];
  /** Sum of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount: Scalars["Float"]["output"];
  /** Sum of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount: Scalars["Float"]["output"];
  /** Sum of potentialClientSavings across the matching connection */
  potentialClientSavings: Scalars["Float"]["output"];
  /** Sum of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount: Scalars["Float"]["output"];
};

export type BatchClaimStateVariancePopulationAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<FloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimStateVariancePopulationAggregates = {
  __typename?: "BatchClaimStateVariancePopulationAggregates";
  /** Population variance of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of determinedClientSavings across the matching connection */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of potentialClientSavings across the matching connection */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchClaimStateVarianceSampleAggregateFilter = {
  clientRecoveryAmount?: InputMaybe<FloatFilter>;
  determinedAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  determinedClientSavings?: InputMaybe<FloatFilter>;
  determinedDiscrepantAmount?: InputMaybe<FloatFilter>;
  potentialAdjustedAllowedAmount?: InputMaybe<FloatFilter>;
  potentialClientSavings?: InputMaybe<FloatFilter>;
  potentialDiscrepantAmount?: InputMaybe<FloatFilter>;
};

export type BatchClaimStateVarianceSampleAggregates = {
  __typename?: "BatchClaimStateVarianceSampleAggregates";
  /** Sample variance of clientRecoveryAmount across the matching connection */
  clientRecoveryAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of determinedAdjustedAllowedAmount across the matching connection */
  determinedAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of determinedClientSavings across the matching connection */
  determinedClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of determinedDiscrepantAmount across the matching connection */
  determinedDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of potentialAdjustedAllowedAmount across the matching connection */
  potentialAdjustedAllowedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of potentialClientSavings across the matching connection */
  potentialClientSavings?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of potentialDiscrepantAmount across the matching connection */
  potentialDiscrepantAmount?: Maybe<Scalars["Float"]["output"]>;
};

/** A connection to a list of `BatchClaimState` values. */
export type BatchClaimStatesConnection = {
  __typename?: "BatchClaimStatesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimStateAggregates>;
  /** A list of edges which contains the `BatchClaimState` and cursor to aid in pagination. */
  edges: Array<BatchClaimStatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimStateAggregates>>;
  /** A list of `BatchClaimState` objects. */
  nodes: Array<Maybe<BatchClaimState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimState` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimState` values. */
export type BatchClaimStatesConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimStateGroupBy>;
  having?: InputMaybe<BatchClaimStateHavingInput>;
};

/** A `BatchClaimState` edge in the connection. */
export type BatchClaimStatesEdge = {
  __typename?: "BatchClaimStatesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimState` at the end of the edge. */
  node?: Maybe<BatchClaimState>;
};

/** Methods to use when ordering `BatchClaimState`. */
export enum BatchClaimStatesOrderBy {
  APPEALED_ASC = "APPEALED_ASC",
  APPEALED_DESC = "APPEALED_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC",
  AUDITOR_USER_ID_ASC = "AUDITOR_USER_ID_ASC",
  AUDITOR_USER_ID_DESC = "AUDITOR_USER_ID_DESC",
  AUDIT_START_DATE_ASC = "AUDIT_START_DATE_ASC",
  AUDIT_START_DATE_DESC = "AUDIT_START_DATE_DESC",
  BATCH_CLAIM_BY_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_ID__ICN_ASC = "BATCH_CLAIM_BY_ID__ICN_ASC",
  BATCH_CLAIM_BY_ID__ICN_DESC = "BATCH_CLAIM_BY_ID__ICN_DESC",
  BATCH_CLAIM_BY_ID__ID_ASC = "BATCH_CLAIM_BY_ID__ID_ASC",
  BATCH_CLAIM_BY_ID__ID_DESC = "BATCH_CLAIM_BY_ID__ID_DESC",
  BATCH_CLAIM_BY_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_ID__POA_1_ASC = "BATCH_CLAIM_BY_ID__POA_1_ASC",
  BATCH_CLAIM_BY_ID__POA_1_DESC = "BATCH_CLAIM_BY_ID__POA_1_DESC",
  BATCH_CLAIM_BY_ID__POA_2_ASC = "BATCH_CLAIM_BY_ID__POA_2_ASC",
  BATCH_CLAIM_BY_ID__POA_2_DESC = "BATCH_CLAIM_BY_ID__POA_2_DESC",
  BATCH_CLAIM_BY_ID__POA_3_ASC = "BATCH_CLAIM_BY_ID__POA_3_ASC",
  BATCH_CLAIM_BY_ID__POA_3_DESC = "BATCH_CLAIM_BY_ID__POA_3_DESC",
  BATCH_CLAIM_BY_ID__POA_4_ASC = "BATCH_CLAIM_BY_ID__POA_4_ASC",
  BATCH_CLAIM_BY_ID__POA_4_DESC = "BATCH_CLAIM_BY_ID__POA_4_DESC",
  BATCH_CLAIM_BY_ID__POA_5_ASC = "BATCH_CLAIM_BY_ID__POA_5_ASC",
  BATCH_CLAIM_BY_ID__POA_5_DESC = "BATCH_CLAIM_BY_ID__POA_5_DESC",
  BATCH_CLAIM_BY_ID__POA_6_ASC = "BATCH_CLAIM_BY_ID__POA_6_ASC",
  BATCH_CLAIM_BY_ID__POA_6_DESC = "BATCH_CLAIM_BY_ID__POA_6_DESC",
  BATCH_CLAIM_BY_ID__POA_7_ASC = "BATCH_CLAIM_BY_ID__POA_7_ASC",
  BATCH_CLAIM_BY_ID__POA_7_DESC = "BATCH_CLAIM_BY_ID__POA_7_DESC",
  BATCH_CLAIM_BY_ID__POA_8_ASC = "BATCH_CLAIM_BY_ID__POA_8_ASC",
  BATCH_CLAIM_BY_ID__POA_8_DESC = "BATCH_CLAIM_BY_ID__POA_8_DESC",
  BATCH_CLAIM_BY_ID__POA_9_ASC = "BATCH_CLAIM_BY_ID__POA_9_ASC",
  BATCH_CLAIM_BY_ID__POA_9_DESC = "BATCH_CLAIM_BY_ID__POA_9_DESC",
  BATCH_CLAIM_BY_ID__POA_10_ASC = "BATCH_CLAIM_BY_ID__POA_10_ASC",
  BATCH_CLAIM_BY_ID__POA_10_DESC = "BATCH_CLAIM_BY_ID__POA_10_DESC",
  BATCH_CLAIM_BY_ID__POA_11_ASC = "BATCH_CLAIM_BY_ID__POA_11_ASC",
  BATCH_CLAIM_BY_ID__POA_11_DESC = "BATCH_CLAIM_BY_ID__POA_11_DESC",
  BATCH_CLAIM_BY_ID__POA_12_ASC = "BATCH_CLAIM_BY_ID__POA_12_ASC",
  BATCH_CLAIM_BY_ID__POA_12_DESC = "BATCH_CLAIM_BY_ID__POA_12_DESC",
  BATCH_CLAIM_BY_ID__POA_13_ASC = "BATCH_CLAIM_BY_ID__POA_13_ASC",
  BATCH_CLAIM_BY_ID__POA_13_DESC = "BATCH_CLAIM_BY_ID__POA_13_DESC",
  BATCH_CLAIM_BY_ID__POA_14_ASC = "BATCH_CLAIM_BY_ID__POA_14_ASC",
  BATCH_CLAIM_BY_ID__POA_14_DESC = "BATCH_CLAIM_BY_ID__POA_14_DESC",
  BATCH_CLAIM_BY_ID__POA_15_ASC = "BATCH_CLAIM_BY_ID__POA_15_ASC",
  BATCH_CLAIM_BY_ID__POA_15_DESC = "BATCH_CLAIM_BY_ID__POA_15_DESC",
  BATCH_CLAIM_BY_ID__POA_16_ASC = "BATCH_CLAIM_BY_ID__POA_16_ASC",
  BATCH_CLAIM_BY_ID__POA_16_DESC = "BATCH_CLAIM_BY_ID__POA_16_DESC",
  BATCH_CLAIM_BY_ID__POA_17_ASC = "BATCH_CLAIM_BY_ID__POA_17_ASC",
  BATCH_CLAIM_BY_ID__POA_17_DESC = "BATCH_CLAIM_BY_ID__POA_17_DESC",
  BATCH_CLAIM_BY_ID__POA_18_ASC = "BATCH_CLAIM_BY_ID__POA_18_ASC",
  BATCH_CLAIM_BY_ID__POA_18_DESC = "BATCH_CLAIM_BY_ID__POA_18_DESC",
  BATCH_CLAIM_BY_ID__POA_19_ASC = "BATCH_CLAIM_BY_ID__POA_19_ASC",
  BATCH_CLAIM_BY_ID__POA_19_DESC = "BATCH_CLAIM_BY_ID__POA_19_DESC",
  BATCH_CLAIM_BY_ID__POA_20_ASC = "BATCH_CLAIM_BY_ID__POA_20_ASC",
  BATCH_CLAIM_BY_ID__POA_20_DESC = "BATCH_CLAIM_BY_ID__POA_20_DESC",
  BATCH_CLAIM_BY_ID__POA_21_ASC = "BATCH_CLAIM_BY_ID__POA_21_ASC",
  BATCH_CLAIM_BY_ID__POA_21_DESC = "BATCH_CLAIM_BY_ID__POA_21_DESC",
  BATCH_CLAIM_BY_ID__POA_22_ASC = "BATCH_CLAIM_BY_ID__POA_22_ASC",
  BATCH_CLAIM_BY_ID__POA_22_DESC = "BATCH_CLAIM_BY_ID__POA_22_DESC",
  BATCH_CLAIM_BY_ID__POA_23_ASC = "BATCH_CLAIM_BY_ID__POA_23_ASC",
  BATCH_CLAIM_BY_ID__POA_23_DESC = "BATCH_CLAIM_BY_ID__POA_23_DESC",
  BATCH_CLAIM_BY_ID__POA_24_ASC = "BATCH_CLAIM_BY_ID__POA_24_ASC",
  BATCH_CLAIM_BY_ID__POA_24_DESC = "BATCH_CLAIM_BY_ID__POA_24_DESC",
  BATCH_CLAIM_BY_ID__POA_25_ASC = "BATCH_CLAIM_BY_ID__POA_25_ASC",
  BATCH_CLAIM_BY_ID__POA_25_DESC = "BATCH_CLAIM_BY_ID__POA_25_DESC",
  BATCH_CLAIM_BY_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_ID__VERSION_ASC = "BATCH_CLAIM_BY_ID__VERSION_ASC",
  BATCH_CLAIM_BY_ID__VERSION_DESC = "BATCH_CLAIM_BY_ID__VERSION_DESC",
  BATCH_CLAIM_BY_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_ID__VERSION_GROUP_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CREATED_AT_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CREATED_AT_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CREATED_AT_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CREATED_AT_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CREATED_BY_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CREATED_BY_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CREATED_BY_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__CREATED_BY_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DUE_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DUE_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DUE_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__DUE_DATE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__ID_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__ID_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__ID_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__ID_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__INSURER_ID_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__INSURER_ID_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__INSURER_ID_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__INSURER_ID_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__NAME_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__NAME_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__NAME_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__NAME_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUP_BY_CLAIM_AUDIT_GROUP_ID__TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUP_ID_ASC = "CLAIM_AUDIT_GROUP_ID_ASC",
  CLAIM_AUDIT_GROUP_ID_DESC = "CLAIM_AUDIT_GROUP_ID_DESC",
  CLAIM_AUDIT_TYPE_ASC = "CLAIM_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_TYPE_DESC = "CLAIM_AUDIT_TYPE_DESC",
  CLIENT_RECOVERY_AMOUNT_ASC = "CLIENT_RECOVERY_AMOUNT_ASC",
  CLIENT_RECOVERY_AMOUNT_DESC = "CLIENT_RECOVERY_AMOUNT_DESC",
  CLIENT_RECOVERY_COLLECTION_DATE_ASC = "CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  CLIENT_RECOVERY_COLLECTION_DATE_DESC = "CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  CURRENT_PHASE_ID_ASC = "CURRENT_PHASE_ID_ASC",
  CURRENT_PHASE_ID_DESC = "CURRENT_PHASE_ID_DESC",
  CURRENT_STAGE_ID_ASC = "CURRENT_STAGE_ID_ASC",
  CURRENT_STAGE_ID_DESC = "CURRENT_STAGE_ID_DESC",
  DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  DETERMINED_CLIENT_SAVINGS_ASC = "DETERMINED_CLIENT_SAVINGS_ASC",
  DETERMINED_CLIENT_SAVINGS_DESC = "DETERMINED_CLIENT_SAVINGS_DESC",
  DETERMINED_DISCREPANT_AMOUNT_ASC = "DETERMINED_DISCREPANT_AMOUNT_ASC",
  DETERMINED_DISCREPANT_AMOUNT_DESC = "DETERMINED_DISCREPANT_AMOUNT_DESC",
  DISPUTED_FINDING_CLAIM_STATE_ASC = "DISPUTED_FINDING_CLAIM_STATE_ASC",
  DISPUTED_FINDING_CLAIM_STATE_DESC = "DISPUTED_FINDING_CLAIM_STATE_DESC",
  DOCUMENTATION_CLAIM_STATE_ASC = "DOCUMENTATION_CLAIM_STATE_ASC",
  DOCUMENTATION_CLAIM_STATE_DESC = "DOCUMENTATION_CLAIM_STATE_DESC",
  DUE_DATE_ASC = "DUE_DATE_ASC",
  DUE_DATE_DESC = "DUE_DATE_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INVOICE_CLAIM_STATE_ASC = "INVOICE_CLAIM_STATE_ASC",
  INVOICE_CLAIM_STATE_DESC = "INVOICE_CLAIM_STATE_DESC",
  IS_PROVIDER_ACTIVE_ASC = "IS_PROVIDER_ACTIVE_ASC",
  IS_PROVIDER_ACTIVE_DESC = "IS_PROVIDER_ACTIVE_DESC",
  IS_REALIZED_ASC = "IS_REALIZED_ASC",
  IS_REALIZED_DESC = "IS_REALIZED_DESC",
  NATURAL = "NATURAL",
  NEGOTIATION_CLAIM_STATE_ASC = "NEGOTIATION_CLAIM_STATE_ASC",
  NEGOTIATION_CLAIM_STATE_DESC = "NEGOTIATION_CLAIM_STATE_DESC",
  ON_HOLD_CLAIM_STATE_ASC = "ON_HOLD_CLAIM_STATE_ASC",
  ON_HOLD_CLAIM_STATE_DESC = "ON_HOLD_CLAIM_STATE_DESC",
  PAY_DENY_ASC = "PAY_DENY_ASC",
  PAY_DENY_DESC = "PAY_DENY_DESC",
  POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  POTENTIAL_CLIENT_SAVINGS_ASC = "POTENTIAL_CLIENT_SAVINGS_ASC",
  POTENTIAL_CLIENT_SAVINGS_DESC = "POTENTIAL_CLIENT_SAVINGS_DESC",
  POTENTIAL_DISCREPANT_AMOUNT_ASC = "POTENTIAL_DISCREPANT_AMOUNT_ASC",
  POTENTIAL_DISCREPANT_AMOUNT_DESC = "POTENTIAL_DISCREPANT_AMOUNT_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_DESC",
  REPORTED_ASC = "REPORTED_ASC",
  REPORTED_DESC = "REPORTED_DESC",
  TECH_DENIED_ASC = "TECH_DENIED_ASC",
  TECH_DENIED_DESC = "TECH_DENIED_DESC",
  WORKFLOW_CLAIM_STATE_ASC = "WORKFLOW_CLAIM_STATE_ASC",
  WORKFLOW_CLAIM_STATE_DESC = "WORKFLOW_CLAIM_STATE_DESC",
}

export type BatchClaimStddevPopulationAggregateFilter = {
  amountCharged?: InputMaybe<FloatFilter>;
  amountReimbursed?: InputMaybe<FloatFilter>;
  documentBlockerStageSortOrder?: InputMaybe<IntFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  lifecycleSortOrder?: InputMaybe<IntFilter>;
  onHoldBlockerStageSortOrder?: InputMaybe<IntFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  phaseSortOrder?: InputMaybe<IntFilter>;
  stageSortOrder?: InputMaybe<IntFilter>;
  version?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimStddevPopulationAggregates = {
  __typename?: "BatchClaimStddevPopulationAggregates";
  /** Population standard deviation of amountCharged across the matching connection */
  amountCharged?: Maybe<Scalars["Float"]["output"]>;
  /** Population standard deviation of amountReimbursed across the matching connection */
  amountReimbursed?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the Document blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the document facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the document facet is absent. Matches documentBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  documentBlockerStageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   *    Returns hierarchical sort position (phase * 1000 + stage sort order).
   *    Enables efficient lifecycle progression sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: LIFECYCLE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  lifecycleSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the On Hold blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the on_hold facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the on_hold facet is absent. Matches onHoldBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  onHoldBlockerStageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   *    Returns phase sort order (1=intake, 2=audit, etc.).
   *    Enables efficient phase-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: PHASE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  phaseSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   *    Returns stage sort order within phase (1, 2, 3, etc.).
   *    Enables efficient stage-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: STAGE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  stageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of version across the matching connection */
  version?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type BatchClaimStddevPopulationAggregatesimproperPaymentCostArgs = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchClaimStddevSampleAggregateFilter = {
  amountCharged?: InputMaybe<FloatFilter>;
  amountReimbursed?: InputMaybe<FloatFilter>;
  documentBlockerStageSortOrder?: InputMaybe<IntFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  lifecycleSortOrder?: InputMaybe<IntFilter>;
  onHoldBlockerStageSortOrder?: InputMaybe<IntFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  phaseSortOrder?: InputMaybe<IntFilter>;
  stageSortOrder?: InputMaybe<IntFilter>;
  version?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimStddevSampleAggregates = {
  __typename?: "BatchClaimStddevSampleAggregates";
  /** Sample standard deviation of amountCharged across the matching connection */
  amountCharged?: Maybe<Scalars["Float"]["output"]>;
  /** Sample standard deviation of amountReimbursed across the matching connection */
  amountReimbursed?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the Document blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the document facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the document facet is absent. Matches documentBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  documentBlockerStageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   *    Returns hierarchical sort position (phase * 1000 + stage sort order).
   *    Enables efficient lifecycle progression sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: LIFECYCLE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  lifecycleSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the On Hold blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the on_hold facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the on_hold facet is absent. Matches onHoldBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  onHoldBlockerStageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   *    Returns phase sort order (1=intake, 2=audit, etc.).
   *    Enables efficient phase-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: PHASE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  phaseSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   *    Returns stage sort order within phase (1, 2, 3, etc.).
   *    Enables efficient stage-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: STAGE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  stageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of version across the matching connection */
  version?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type BatchClaimStddevSampleAggregatesimproperPaymentCostArgs = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchClaimSumAggregateFilter = {
  amountCharged?: InputMaybe<FloatFilter>;
  amountReimbursed?: InputMaybe<FloatFilter>;
  documentBlockerStageSortOrder?: InputMaybe<IntFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  lifecycleSortOrder?: InputMaybe<IntFilter>;
  onHoldBlockerStageSortOrder?: InputMaybe<IntFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  phaseSortOrder?: InputMaybe<IntFilter>;
  stageSortOrder?: InputMaybe<IntFilter>;
  version?: InputMaybe<BigIntFilter>;
};

export type BatchClaimSumAggregates = {
  __typename?: "BatchClaimSumAggregates";
  /** Sum of amountCharged across the matching connection */
  amountCharged: Scalars["Float"]["output"];
  /** Sum of amountReimbursed across the matching connection */
  amountReimbursed: Scalars["Float"]["output"];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the Document blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the document facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the document facet is absent. Matches documentBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  documentBlockerStageSortOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /** Sum of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   *    Returns hierarchical sort position (phase * 1000 + stage sort order).
   *    Enables efficient lifecycle progression sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: LIFECYCLE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  lifecycleSortOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the On Hold blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the on_hold facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the on_hold facet is absent. Matches onHoldBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  onHoldBlockerStageSortOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /** Sum of paymentRate across the matching connection */
  paymentRate: Scalars["Float"]["output"];
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   *    Returns phase sort order (1=intake, 2=audit, etc.).
   *    Enables efficient phase-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: PHASE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  phaseSortOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   *    Returns stage sort order within phase (1, 2, 3, etc.).
   *    Enables efficient stage-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: STAGE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  stageSortOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /** Sum of version across the matching connection */
  version: Scalars["BigInt"]["output"];
};

export type BatchClaimSumAggregatesimproperPaymentCostArgs = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * ### Overview
 * Source of truth for Tech Denial on a claim. tech_denied = true means Tech Denied;
 * NULL (or no row) means empty/clear. Cached on v3.batch_claim_state.tech_denied for
 * claims-list filter/sort. Written via setClaimTechDenials.
 */
export type BatchClaimTechDenial = Node & {
  __typename?: "BatchClaimTechDenial";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimTechDenial`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimTechDenial`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  createdBy?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  techDenied?: Maybe<Scalars["Boolean"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

export type BatchClaimTechDenialAggregates = {
  __typename?: "BatchClaimTechDenialAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchClaimTechDenialDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `BatchClaimTechDenial` object types. */
export type BatchClaimTechDenialAggregatesFilter = {
  /** Distinct count aggregate over matching `BatchClaimTechDenial` objects. */
  distinctCount?: InputMaybe<BatchClaimTechDenialDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchClaimTechDenial` object to be included within the aggregate. */
  filter?: InputMaybe<BatchClaimTechDenialFilter>;
};

/** The `batchClaimTechDenial` to be created by this mutation. */
export type BatchClaimTechDenialBatchClaimIdFkeyBatchClaimTechDenialCreateInput =
  {
    auditorUserToCreatedBy?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    techDenied?: InputMaybe<Scalars["Boolean"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `batchClaim` in the `BatchClaimTechDenialInput` mutation. */
export type BatchClaimTechDenialBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimTechDenial` in the `BatchClaimInput` mutation. */
export type BatchClaimTechDenialBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  connectByBatchClaimId?: InputMaybe<BatchClaimTechDenialBatchClaimTechDenialBatchClaimIdKeyConnect>;
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimTechDenialBatchClaimTechDenialPkeyConnect>;
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimTechDenialNodeIdConnect>;
  /** A `BatchClaimTechDenialInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimTechDenialBatchClaimIdFkeyBatchClaimTechDenialCreateInput>
  >;
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  deleteByBatchClaimId?: InputMaybe<BatchClaimTechDenialBatchClaimTechDenialBatchClaimIdKeyDelete>;
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  deleteById?: InputMaybe<BatchClaimTechDenialBatchClaimTechDenialPkeyDelete>;
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<BatchClaimTechDenialNodeIdDelete>;
  /** Flag indicating whether all other `batchClaimTechDenial` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `batchClaimTechDenial` for the far side of the relationship. */
  updateByBatchClaimId?: InputMaybe<BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyUsingBatchClaimTechDenialBatchClaimIdKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimTechDenial` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyUsingBatchClaimTechDenialPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaimTechDenial` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyNodeIdUpdate>;
};

/** The fields on `batchClaimTechDenial` to look up the row to connect. */
export type BatchClaimTechDenialBatchClaimTechDenialBatchClaimIdKeyConnect = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The fields on `batchClaimTechDenial` to look up the row to delete. */
export type BatchClaimTechDenialBatchClaimTechDenialBatchClaimIdKeyDelete = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The fields on `batchClaimTechDenial` to look up the row to connect. */
export type BatchClaimTechDenialBatchClaimTechDenialPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `batchClaimTechDenial` to look up the row to delete. */
export type BatchClaimTechDenialBatchClaimTechDenialPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `BatchClaimTechDenial` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BatchClaimTechDenialCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `techDenied` field. */
  techDenied?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The `batchClaimTechDenial` to be created by this mutation. */
export type BatchClaimTechDenialCreatedByFkeyBatchClaimTechDenialCreateInput = {
  auditorUserToCreatedBy?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  techDenied?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `BatchClaimTechDenialInput` mutation. */
export type BatchClaimTechDenialCreatedByFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchClaimTechDenial` in the `AuditorUserInput` mutation. */
export type BatchClaimTechDenialCreatedByFkeyInverseInput = {
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  connectByBatchClaimId?: InputMaybe<
    Array<BatchClaimTechDenialBatchClaimTechDenialBatchClaimIdKeyConnect>
  >;
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<BatchClaimTechDenialBatchClaimTechDenialPkeyConnect>
  >;
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchClaimTechDenialNodeIdConnect>>;
  /** A `BatchClaimTechDenialInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BatchClaimTechDenialCreatedByFkeyBatchClaimTechDenialCreateInput>
  >;
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  deleteByBatchClaimId?: InputMaybe<
    Array<BatchClaimTechDenialBatchClaimTechDenialBatchClaimIdKeyDelete>
  >;
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<BatchClaimTechDenialBatchClaimTechDenialPkeyDelete>
  >;
  /** The primary key(s) for `batchClaimTechDenial` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<BatchClaimTechDenialNodeIdDelete>>;
  /** Flag indicating whether all other `batchClaimTechDenial` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `batchClaimTechDenial` for the far side of the relationship. */
  updateByBatchClaimId?: InputMaybe<
    Array<BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyUsingBatchClaimTechDenialBatchClaimIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimTechDenial` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyUsingBatchClaimTechDenialPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchClaimTechDenial` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyNodeIdUpdate>
  >;
};

export type BatchClaimTechDenialDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  createdBy?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  techDenied?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type BatchClaimTechDenialDistinctCountAggregates = {
  __typename?: "BatchClaimTechDenialDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of techDenied across the matching connection */
  techDenied?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BatchClaimTechDenial` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimTechDenialFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchClaimTechDenialFilter>>;
  /** Filter by the object’s `auditorUserByCreatedBy` relation. */
  auditorUserByCreatedBy?: InputMaybe<AuditorUserFilter>;
  /** A related `auditorUserByCreatedBy` exists. */
  auditorUserByCreatedByExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchClaimTechDenialFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchClaimTechDenialFilter>>;
  /** Filter by the object’s `techDenied` field. */
  techDenied?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BatchClaimTechDenial` for usage during aggregation. */
export enum BatchClaimTechDenialGroupBy {
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  CREATED_BY = "CREATED_BY",
  TECH_DENIED = "TECH_DENIED",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type BatchClaimTechDenialHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimTechDenialHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchClaimTechDenial` aggregates. */
export type BatchClaimTechDenialHavingInput = {
  AND?: InputMaybe<Array<BatchClaimTechDenialHavingInput>>;
  OR?: InputMaybe<Array<BatchClaimTechDenialHavingInput>>;
  average?: InputMaybe<BatchClaimTechDenialHavingAverageInput>;
  distinctCount?: InputMaybe<BatchClaimTechDenialHavingDistinctCountInput>;
  max?: InputMaybe<BatchClaimTechDenialHavingMaxInput>;
  min?: InputMaybe<BatchClaimTechDenialHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchClaimTechDenialHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchClaimTechDenialHavingStddevSampleInput>;
  sum?: InputMaybe<BatchClaimTechDenialHavingSumInput>;
  variancePopulation?: InputMaybe<BatchClaimTechDenialHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchClaimTechDenialHavingVarianceSampleInput>;
};

export type BatchClaimTechDenialHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimTechDenialHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimTechDenialHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimTechDenialHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimTechDenialHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimTechDenialHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchClaimTechDenialHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BatchClaimTechDenial` */
export type BatchClaimTechDenialInput = {
  auditorUserToCreatedBy?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  techDenied?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchClaimTechDenialNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchClaimTechDenial` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to delete. */
export type BatchClaimTechDenialNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `batchClaimTechDenial` to be deleted. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `batchClaimTechDenial` to look up the row to update. */
export type BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyUsingBatchClaimTechDenialBatchClaimIdKeyUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimTechDenial` being updated. */
    patch: updateBatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyPatch;
  };

/** The fields on `batchClaimTechDenial` to look up the row to update. */
export type BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyUsingBatchClaimTechDenialPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimTechDenial` being updated. */
    patch: updateBatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `batchClaimTechDenial` to look up the row to update. */
export type BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyUsingBatchClaimTechDenialBatchClaimIdKeyUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimTechDenial` being updated. */
    patch: updateBatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyPatch;
  };

/** The fields on `batchClaimTechDenial` to look up the row to update. */
export type BatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyUsingBatchClaimTechDenialPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimTechDenial` being updated. */
    patch: updateBatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyPatch;
  };

/** Represents an update to a `BatchClaimTechDenial`. Fields that are set will be updated. */
export type BatchClaimTechDenialPatch = {
  auditorUserToCreatedBy?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  techDenied?: InputMaybe<Scalars["Boolean"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** A connection to a list of `BatchClaimTechDenial` values. */
export type BatchClaimTechDenialsConnection = {
  __typename?: "BatchClaimTechDenialsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimTechDenialAggregates>;
  /** A list of edges which contains the `BatchClaimTechDenial` and cursor to aid in pagination. */
  edges: Array<BatchClaimTechDenialsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimTechDenialAggregates>>;
  /** A list of `BatchClaimTechDenial` objects. */
  nodes: Array<Maybe<BatchClaimTechDenial>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaimTechDenial` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaimTechDenial` values. */
export type BatchClaimTechDenialsConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimTechDenialGroupBy>;
  having?: InputMaybe<BatchClaimTechDenialHavingInput>;
};

/** A `BatchClaimTechDenial` edge in the connection. */
export type BatchClaimTechDenialsEdge = {
  __typename?: "BatchClaimTechDenialsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaimTechDenial` at the end of the edge. */
  node?: Maybe<BatchClaimTechDenial>;
};

/** Methods to use when ordering `BatchClaimTechDenial`. */
export enum BatchClaimTechDenialsOrderBy {
  AUDITOR_USER_BY_CREATED_BY__CREATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__CREATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__CREATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__CREATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__EMAIL_ASC = "AUDITOR_USER_BY_CREATED_BY__EMAIL_ASC",
  AUDITOR_USER_BY_CREATED_BY__EMAIL_DESC = "AUDITOR_USER_BY_CREATED_BY__EMAIL_DESC",
  AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_ASC = "AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_ASC",
  AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_DESC = "AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_DESC",
  AUDITOR_USER_BY_CREATED_BY__IDP_SUB_ASC = "AUDITOR_USER_BY_CREATED_BY__IDP_SUB_ASC",
  AUDITOR_USER_BY_CREATED_BY__IDP_SUB_DESC = "AUDITOR_USER_BY_CREATED_BY__IDP_SUB_DESC",
  AUDITOR_USER_BY_CREATED_BY__ID_ASC = "AUDITOR_USER_BY_CREATED_BY__ID_ASC",
  AUDITOR_USER_BY_CREATED_BY__ID_DESC = "AUDITOR_USER_BY_CREATED_BY__ID_DESC",
  AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_CREATED_BY__LAST_NAME_ASC = "AUDITOR_USER_BY_CREATED_BY__LAST_NAME_ASC",
  AUDITOR_USER_BY_CREATED_BY__LAST_NAME_DESC = "AUDITOR_USER_BY_CREATED_BY__LAST_NAME_DESC",
  AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_ASC = "AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_DESC = "AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_CREATED_BY__READ_ONLY_ASC = "AUDITOR_USER_BY_CREATED_BY__READ_ONLY_ASC",
  AUDITOR_USER_BY_CREATED_BY__READ_ONLY_DESC = "AUDITOR_USER_BY_CREATED_BY__READ_ONLY_DESC",
  AUDITOR_USER_BY_CREATED_BY__TITLE_ASC = "AUDITOR_USER_BY_CREATED_BY__TITLE_ASC",
  AUDITOR_USER_BY_CREATED_BY__TITLE_DESC = "AUDITOR_USER_BY_CREATED_BY__TITLE_DESC",
  AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__USER_TYPE_ASC = "AUDITOR_USER_BY_CREATED_BY__USER_TYPE_ASC",
  AUDITOR_USER_BY_CREATED_BY__USER_TYPE_DESC = "AUDITOR_USER_BY_CREATED_BY__USER_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  CREATED_BY_ASC = "CREATED_BY_ASC",
  CREATED_BY_DESC = "CREATED_BY_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  TECH_DENIED_ASC = "TECH_DENIED_ASC",
  TECH_DENIED_DESC = "TECH_DENIED_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** A filter to be used against many `ActiveClaimAssignee` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyActiveClaimAssigneeFilter = {
  /** Aggregates across related `ActiveClaimAssignee` match the filter criteria. */
  aggregates?: InputMaybe<ActiveClaimAssigneeAggregatesFilter>;
  /** Every related `ActiveClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ActiveClaimAssigneeFilter>;
  /** No related `ActiveClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ActiveClaimAssigneeFilter>;
  /** Some related `ActiveClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ActiveClaimAssigneeFilter>;
};

/** A filter to be used against many `AuditFinding` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyAuditFindingFilter = {
  /** Aggregates across related `AuditFinding` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingAggregatesFilter>;
  /** Every related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingFilter>;
  /** No related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingFilter>;
  /** Some related `AuditFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingFilter>;
};

/** A filter to be used against many `BatchClaimAssignee` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyBatchClaimAssigneeFilter = {
  /** Aggregates across related `BatchClaimAssignee` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAssigneeAggregatesFilter>;
  /** Every related `BatchClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimAssigneeFilter>;
  /** No related `BatchClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimAssigneeFilter>;
  /** Some related `BatchClaimAssignee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimAssigneeFilter>;
};

/** A filter to be used against many `BatchClaimAuditStartDate` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyBatchClaimAuditStartDateFilter = {
  /** Aggregates across related `BatchClaimAuditStartDate` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAuditStartDateAggregatesFilter>;
  /** Every related `BatchClaimAuditStartDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimAuditStartDateFilter>;
  /** No related `BatchClaimAuditStartDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimAuditStartDateFilter>;
  /** Some related `BatchClaimAuditStartDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimAuditStartDateFilter>;
};

/** A filter to be used against many `BatchClaimAuditor` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyBatchClaimAuditorFilter = {
  /** Aggregates across related `BatchClaimAuditor` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAuditorAggregatesFilter>;
  /** Every related `BatchClaimAuditor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimAuditorFilter>;
  /** No related `BatchClaimAuditor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimAuditorFilter>;
  /** Some related `BatchClaimAuditor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimAuditorFilter>;
};

/** A filter to be used against many `BatchClaimClientRecoveryAmount` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyBatchClaimClientRecoveryAmountFilter = {
  /** Aggregates across related `BatchClaimClientRecoveryAmount` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimClientRecoveryAmountAggregatesFilter>;
  /** Every related `BatchClaimClientRecoveryAmount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimClientRecoveryAmountFilter>;
  /** No related `BatchClaimClientRecoveryAmount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimClientRecoveryAmountFilter>;
  /** Some related `BatchClaimClientRecoveryAmount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimClientRecoveryAmountFilter>;
};

/** A filter to be used against many `BatchClaimClientRecoveryCollectionDate` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyBatchClaimClientRecoveryCollectionDateFilter = {
  /** Aggregates across related `BatchClaimClientRecoveryCollectionDate` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimClientRecoveryCollectionDateAggregatesFilter>;
  /** Every related `BatchClaimClientRecoveryCollectionDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimClientRecoveryCollectionDateFilter>;
  /** No related `BatchClaimClientRecoveryCollectionDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimClientRecoveryCollectionDateFilter>;
  /** Some related `BatchClaimClientRecoveryCollectionDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimClientRecoveryCollectionDateFilter>;
};

/** A filter to be used against many `BatchClaimDocument` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyBatchClaimDocumentFilter = {
  /** Aggregates across related `BatchClaimDocument` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimDocumentAggregatesFilter>;
  /** Every related `BatchClaimDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimDocumentFilter>;
  /** No related `BatchClaimDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimDocumentFilter>;
  /** Some related `BatchClaimDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimDocumentFilter>;
};

/** A filter to be used against many `BatchClaimDueDate` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyBatchClaimDueDateFilter = {
  /** Aggregates across related `BatchClaimDueDate` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimDueDateAggregatesFilter>;
  /** Every related `BatchClaimDueDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimDueDateFilter>;
  /** No related `BatchClaimDueDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimDueDateFilter>;
  /** Some related `BatchClaimDueDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimDueDateFilter>;
};

/** A filter to be used against many `BatchClaim` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyBatchClaimFilter = {
  /** Aggregates across related `BatchClaim` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAggregatesFilter>;
  /** Every related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimFilter>;
  /** No related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimFilter>;
  /** Some related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimFilter>;
};

/** A filter to be used against many `BatchClaimLine` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyBatchClaimLineFilter = {
  /** Aggregates across related `BatchClaimLine` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimLineAggregatesFilter>;
  /** Every related `BatchClaimLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimLineFilter>;
  /** No related `BatchClaimLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimLineFilter>;
  /** Some related `BatchClaimLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimLineFilter>;
};

/** A filter to be used against many `BatchClaimLineItem` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyBatchClaimLineItemFilter = {
  /** Aggregates across related `BatchClaimLineItem` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimLineItemAggregatesFilter>;
  /** Every related `BatchClaimLineItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimLineItemFilter>;
  /** No related `BatchClaimLineItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimLineItemFilter>;
  /** Some related `BatchClaimLineItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimLineItemFilter>;
};

/** A filter to be used against many `ClaimFacetHistory` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyClaimFacetHistoryFilter = {
  /** Aggregates across related `ClaimFacetHistory` match the filter criteria. */
  aggregates?: InputMaybe<ClaimFacetHistoryAggregatesFilter>;
  /** Every related `ClaimFacetHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ClaimFacetHistoryFilter>;
  /** No related `ClaimFacetHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ClaimFacetHistoryFilter>;
  /** Some related `ClaimFacetHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ClaimFacetHistoryFilter>;
};

/** A filter to be used against many `ClaimPolicyDocument` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyClaimPolicyDocumentFilter = {
  /** Aggregates across related `ClaimPolicyDocument` match the filter criteria. */
  aggregates?: InputMaybe<ClaimPolicyDocumentAggregatesFilter>;
  /** Every related `ClaimPolicyDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ClaimPolicyDocumentFilter>;
  /** No related `ClaimPolicyDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ClaimPolicyDocumentFilter>;
  /** Some related `ClaimPolicyDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ClaimPolicyDocumentFilter>;
};

/** A filter to be used against many `ClientSignOffClaimState` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyClientSignOffClaimStateFilter = {
  /** Aggregates across related `ClientSignOffClaimState` match the filter criteria. */
  aggregates?: InputMaybe<ClientSignOffClaimStateAggregatesFilter>;
  /** Every related `ClientSignOffClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ClientSignOffClaimStateFilter>;
  /** No related `ClientSignOffClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ClientSignOffClaimStateFilter>;
  /** Some related `ClientSignOffClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ClientSignOffClaimStateFilter>;
};

/** A filter to be used against many `DisputedFinding` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyDisputedFindingFilter = {
  /** Aggregates across related `DisputedFinding` match the filter criteria. */
  aggregates?: InputMaybe<DisputedFindingAggregatesFilter>;
  /** Every related `DisputedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DisputedFindingFilter>;
  /** No related `DisputedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DisputedFindingFilter>;
  /** Some related `DisputedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DisputedFindingFilter>;
};

/** A filter to be used against many `DocumentRequestCreated` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyDocumentRequestCreatedFilter = {
  /** Aggregates across related `DocumentRequestCreated` match the filter criteria. */
  aggregates?: InputMaybe<DocumentRequestCreatedAggregatesFilter>;
  /** Every related `DocumentRequestCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentRequestCreatedFilter>;
  /** No related `DocumentRequestCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentRequestCreatedFilter>;
  /** Some related `DocumentRequestCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentRequestCreatedFilter>;
};

/** A filter to be used against many `DocumentUploadCreated` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyDocumentUploadCreatedFilter = {
  /** Aggregates across related `DocumentUploadCreated` match the filter criteria. */
  aggregates?: InputMaybe<DocumentUploadCreatedAggregatesFilter>;
  /** Every related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUploadCreatedFilter>;
  /** No related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUploadCreatedFilter>;
  /** Some related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUploadCreatedFilter>;
};

/** A filter to be used against many `DocumentationClaimState` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyDocumentationClaimStateFilter = {
  /** Aggregates across related `DocumentationClaimState` match the filter criteria. */
  aggregates?: InputMaybe<DocumentationClaimStateAggregatesFilter>;
  /** Every related `DocumentationClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentationClaimStateFilter>;
  /** No related `DocumentationClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentationClaimStateFilter>;
  /** Some related `DocumentationClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentationClaimStateFilter>;
};

/** A filter to be used against many `InvoiceClaimState` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyInvoiceClaimStateFilter = {
  /** Aggregates across related `InvoiceClaimState` match the filter criteria. */
  aggregates?: InputMaybe<InvoiceClaimStateAggregatesFilter>;
  /** Every related `InvoiceClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<InvoiceClaimStateFilter>;
  /** No related `InvoiceClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<InvoiceClaimStateFilter>;
  /** Some related `InvoiceClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<InvoiceClaimStateFilter>;
};

/** A filter to be used against many `NegotiationClaimState` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyNegotiationClaimStateFilter = {
  /** Aggregates across related `NegotiationClaimState` match the filter criteria. */
  aggregates?: InputMaybe<NegotiationClaimStateAggregatesFilter>;
  /** Every related `NegotiationClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NegotiationClaimStateFilter>;
  /** No related `NegotiationClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NegotiationClaimStateFilter>;
  /** Some related `NegotiationClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NegotiationClaimStateFilter>;
};

/** A filter to be used against many `OnHoldClaimState` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyOnHoldClaimStateFilter = {
  /** Aggregates across related `OnHoldClaimState` match the filter criteria. */
  aggregates?: InputMaybe<OnHoldClaimStateAggregatesFilter>;
  /** Every related `OnHoldClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OnHoldClaimStateFilter>;
  /** No related `OnHoldClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OnHoldClaimStateFilter>;
  /** Some related `OnHoldClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OnHoldClaimStateFilter>;
};

/** A filter to be used against many `ProviderSignOffClaimState` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyProviderSignOffClaimStateFilter = {
  /** Aggregates across related `ProviderSignOffClaimState` match the filter criteria. */
  aggregates?: InputMaybe<ProviderSignOffClaimStateAggregatesFilter>;
  /** Every related `ProviderSignOffClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProviderSignOffClaimStateFilter>;
  /** No related `ProviderSignOffClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProviderSignOffClaimStateFilter>;
  /** Some related `ProviderSignOffClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProviderSignOffClaimStateFilter>;
};

/** A filter to be used against many `QaClaimStateRow` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyQaClaimStateRowFilter = {
  /** Aggregates across related `QaClaimStateRow` match the filter criteria. */
  aggregates?: InputMaybe<QaClaimStateRowAggregatesFilter>;
  /** Every related `QaClaimStateRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<QaClaimStateRowFilter>;
  /** No related `QaClaimStateRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<QaClaimStateRowFilter>;
  /** Some related `QaClaimStateRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<QaClaimStateRowFilter>;
};

/** A filter to be used against many `ReportedClaim` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyReportedClaimFilter = {
  /** Aggregates across related `ReportedClaim` match the filter criteria. */
  aggregates?: InputMaybe<ReportedClaimAggregatesFilter>;
  /** Every related `ReportedClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ReportedClaimFilter>;
  /** No related `ReportedClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ReportedClaimFilter>;
  /** Some related `ReportedClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ReportedClaimFilter>;
};

/** A filter to be used against many `S3AuditDocumentation` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyS3AuditDocumentationFilter = {
  /** Aggregates across related `S3AuditDocumentation` match the filter criteria. */
  aggregates?: InputMaybe<S3AuditDocumentationAggregatesFilter>;
  /** Every related `S3AuditDocumentation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<S3AuditDocumentationFilter>;
  /** No related `S3AuditDocumentation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<S3AuditDocumentationFilter>;
  /** Some related `S3AuditDocumentation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<S3AuditDocumentationFilter>;
};

/** A filter to be used against many `WorkflowClaimState` object types. All fields are combined with a logical ‘and.’ */
export type BatchClaimToManyWorkflowClaimStateFilter = {
  /** Aggregates across related `WorkflowClaimState` match the filter criteria. */
  aggregates?: InputMaybe<WorkflowClaimStateAggregatesFilter>;
  /** Every related `WorkflowClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowClaimStateFilter>;
  /** No related `WorkflowClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowClaimStateFilter>;
  /** Some related `WorkflowClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowClaimStateFilter>;
};

export type BatchClaimVariancePopulationAggregateFilter = {
  amountCharged?: InputMaybe<FloatFilter>;
  amountReimbursed?: InputMaybe<FloatFilter>;
  documentBlockerStageSortOrder?: InputMaybe<IntFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  lifecycleSortOrder?: InputMaybe<IntFilter>;
  onHoldBlockerStageSortOrder?: InputMaybe<IntFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  phaseSortOrder?: InputMaybe<IntFilter>;
  stageSortOrder?: InputMaybe<IntFilter>;
  version?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimVariancePopulationAggregates = {
  __typename?: "BatchClaimVariancePopulationAggregates";
  /** Population variance of amountCharged across the matching connection */
  amountCharged?: Maybe<Scalars["Float"]["output"]>;
  /** Population variance of amountReimbursed across the matching connection */
  amountReimbursed?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the Document blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the document facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the document facet is absent. Matches documentBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  documentBlockerStageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   *    Returns hierarchical sort position (phase * 1000 + stage sort order).
   *    Enables efficient lifecycle progression sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: LIFECYCLE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  lifecycleSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the On Hold blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the on_hold facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the on_hold facet is absent. Matches onHoldBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  onHoldBlockerStageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   *    Returns phase sort order (1=intake, 2=audit, etc.).
   *    Enables efficient phase-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: PHASE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  phaseSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   *    Returns stage sort order within phase (1, 2, 3, etc.).
   *    Enables efficient stage-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: STAGE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  stageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of version across the matching connection */
  version?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type BatchClaimVariancePopulationAggregatesimproperPaymentCostArgs = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchClaimVarianceSampleAggregateFilter = {
  amountCharged?: InputMaybe<FloatFilter>;
  amountReimbursed?: InputMaybe<FloatFilter>;
  documentBlockerStageSortOrder?: InputMaybe<IntFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  lifecycleSortOrder?: InputMaybe<IntFilter>;
  onHoldBlockerStageSortOrder?: InputMaybe<IntFilter>;
  paymentRate?: InputMaybe<FloatFilter>;
  phaseSortOrder?: InputMaybe<IntFilter>;
  stageSortOrder?: InputMaybe<IntFilter>;
  version?: InputMaybe<BigFloatFilter>;
};

export type BatchClaimVarianceSampleAggregates = {
  __typename?: "BatchClaimVarianceSampleAggregates";
  /** Sample variance of amountCharged across the matching connection */
  amountCharged?: Maybe<Scalars["Float"]["output"]>;
  /** Sample variance of amountReimbursed across the matching connection */
  amountReimbursed?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the Document blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the document facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the document facet is absent. Matches documentBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  documentBlockerStageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of this field across the matching connection. */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   *    Returns hierarchical sort position (phase * 1000 + stage sort order).
   *    Enables efficient lifecycle progression sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: LIFECYCLE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  lifecycleSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   *    Sort order of the On Hold blocker stage on the claim (facet_keyword.sort_order).
   *    Reads the on_hold facet key directly so Document and On Hold blockers can be active simultaneously.
   *    NULL when the on_hold facet is absent. Matches onHoldBlockerStage filter semantics.
   *
   *    GraphQL:
   *      batchClaims(orderBy: ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC) { ... }
   */
  onHoldBlockerStageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of paymentRate across the matching connection */
  paymentRate?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   *    Returns phase sort order (1=intake, 2=audit, etc.).
   *    Enables efficient phase-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: PHASE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  phaseSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   *    Returns stage sort order within phase (1, 2, 3, etc.).
   *    Enables efficient stage-level sorting in GraphQL queries.
   *
   *    Usage in GraphQL:
   *      allBatchClaims(orderBy: STAGE_SORT_ORDER_ASC) { ... }
   *
   *    Performance: Uses materialized view join, supports index-based ordering.
   */
  stageSortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of version across the matching connection */
  version?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type BatchClaimVarianceSampleAggregatesimproperPaymentCostArgs = {
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A connection to a list of `BatchClaim` values. */
export type BatchClaimsConnection = {
  __typename?: "BatchClaimsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchClaimAggregates>;
  /** A list of edges which contains the `BatchClaim` and cursor to aid in pagination. */
  edges: Array<BatchClaimsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchClaimAggregates>>;
  /** A list of `BatchClaim` objects. */
  nodes: Array<Maybe<BatchClaim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchClaim` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchClaim` values. */
export type BatchClaimsConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchClaimGroupBy>;
  having?: InputMaybe<BatchClaimHavingInput>;
};

/** A `BatchClaim` edge in the connection. */
export type BatchClaimsEdge = {
  __typename?: "BatchClaimsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchClaim` at the end of the edge. */
  node?: Maybe<BatchClaim>;
};

/** Methods to use when ordering `BatchClaim`. */
export enum BatchClaimsOrderBy {
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_AVERAGE_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_AVERAGE_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_BY_BATCH_CLAIM_ID__COUNT_ASC = "ACTIVE_CLAIM_ASSIGNEES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_BY_BATCH_CLAIM_ID__COUNT_DESC = "ACTIVE_CLAIM_ASSIGNEES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_COUNT_ASC = "ACTIVE_CLAIM_ASSIGNEES_COUNT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_COUNT_DESC = "ACTIVE_CLAIM_ASSIGNEES_COUNT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_MAX_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_MAX_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MAX_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MAX_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MAX_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_MIN_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_MIN_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_MIN_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_MIN_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_MIN_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_SUM_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_SUM_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_SUM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_SUM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_SUM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC",
  ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC = "ACTIVE_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC",
  ADMIT_DIAG_ASC = "ADMIT_DIAG_ASC",
  ADMIT_DIAG_DESC = "ADMIT_DIAG_DESC",
  ADM_TYPE_ASC = "ADM_TYPE_ASC",
  ADM_TYPE_DESC = "ADM_TYPE_DESC",
  AMOUNT_CHARGED_ASC = "AMOUNT_CHARGED_ASC",
  AMOUNT_CHARGED_DESC = "AMOUNT_CHARGED_DESC",
  AMOUNT_REIMBURSED_ASC = "AMOUNT_REIMBURSED_ASC",
  AMOUNT_REIMBURSED_DESC = "AMOUNT_REIMBURSED_DESC",
  APR_DRG_ASC = "APR_DRG_ASC",
  APR_DRG_DESC = "APR_DRG_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_AVERAGE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_AVERAGE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_AVERAGE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_AVERAGE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_CONFIDENCE_ASC = "AUDIT_FINDINGS_AVERAGE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_AVERAGE_CONFIDENCE_DESC = "AUDIT_FINDINGS_AVERAGE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDINGS_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDINGS_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDINGS_AVERAGE_DELETED_AT_ASC = "AUDIT_FINDINGS_AVERAGE_DELETED_AT_ASC",
  AUDIT_FINDINGS_AVERAGE_DELETED_AT_DESC = "AUDIT_FINDINGS_AVERAGE_DELETED_AT_DESC",
  AUDIT_FINDINGS_AVERAGE_DELETED_BY_ASC = "AUDIT_FINDINGS_AVERAGE_DELETED_BY_ASC",
  AUDIT_FINDINGS_AVERAGE_DELETED_BY_DESC = "AUDIT_FINDINGS_AVERAGE_DELETED_BY_DESC",
  AUDIT_FINDINGS_AVERAGE_ID_ASC = "AUDIT_FINDINGS_AVERAGE_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_ID_DESC = "AUDIT_FINDINGS_AVERAGE_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_AVERAGE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_AVERAGE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_AVERAGE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDINGS_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDINGS_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_BY_BATCH_CLAIM_ID__COUNT_ASC = "AUDIT_FINDINGS_BY_BATCH_CLAIM_ID__COUNT_ASC",
  AUDIT_FINDINGS_BY_BATCH_CLAIM_ID__COUNT_DESC = "AUDIT_FINDINGS_BY_BATCH_CLAIM_ID__COUNT_DESC",
  AUDIT_FINDINGS_COUNT_ASC = "AUDIT_FINDINGS_COUNT_ASC",
  AUDIT_FINDINGS_COUNT_DESC = "AUDIT_FINDINGS_COUNT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_CONFIDENCE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_AT_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_DELETED_BY_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_MAX_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_MAX_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_MAX_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_MAX_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_MAX_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_MAX_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_MAX_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC = "AUDIT_FINDINGS_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC = "AUDIT_FINDINGS_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_MAX_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_MAX_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_MAX_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_MAX_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_MAX_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_MAX_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_MAX_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_MAX_CONFIDENCE_ASC = "AUDIT_FINDINGS_MAX_CONFIDENCE_ASC",
  AUDIT_FINDINGS_MAX_CONFIDENCE_DESC = "AUDIT_FINDINGS_MAX_CONFIDENCE_DESC",
  AUDIT_FINDINGS_MAX_CREATED_AT_ASC = "AUDIT_FINDINGS_MAX_CREATED_AT_ASC",
  AUDIT_FINDINGS_MAX_CREATED_AT_DESC = "AUDIT_FINDINGS_MAX_CREATED_AT_DESC",
  AUDIT_FINDINGS_MAX_DELETED_AT_ASC = "AUDIT_FINDINGS_MAX_DELETED_AT_ASC",
  AUDIT_FINDINGS_MAX_DELETED_AT_DESC = "AUDIT_FINDINGS_MAX_DELETED_AT_DESC",
  AUDIT_FINDINGS_MAX_DELETED_BY_ASC = "AUDIT_FINDINGS_MAX_DELETED_BY_ASC",
  AUDIT_FINDINGS_MAX_DELETED_BY_DESC = "AUDIT_FINDINGS_MAX_DELETED_BY_DESC",
  AUDIT_FINDINGS_MAX_ID_ASC = "AUDIT_FINDINGS_MAX_ID_ASC",
  AUDIT_FINDINGS_MAX_ID_DESC = "AUDIT_FINDINGS_MAX_ID_DESC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_MAX_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_MAX_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_MAX_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_MAX_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_MAX_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_MAX_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_MAX_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_MAX_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_MAX_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_MAX_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_MAX_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_MAX_UPDATED_AT_ASC = "AUDIT_FINDINGS_MAX_UPDATED_AT_ASC",
  AUDIT_FINDINGS_MAX_UPDATED_AT_DESC = "AUDIT_FINDINGS_MAX_UPDATED_AT_DESC",
  AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_MIN_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_MIN_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_MIN_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_MIN_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_MIN_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_MIN_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_MIN_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC = "AUDIT_FINDINGS_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC = "AUDIT_FINDINGS_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_MIN_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_MIN_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_MIN_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_MIN_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_MIN_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_MIN_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_MIN_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_MIN_CONFIDENCE_ASC = "AUDIT_FINDINGS_MIN_CONFIDENCE_ASC",
  AUDIT_FINDINGS_MIN_CONFIDENCE_DESC = "AUDIT_FINDINGS_MIN_CONFIDENCE_DESC",
  AUDIT_FINDINGS_MIN_CREATED_AT_ASC = "AUDIT_FINDINGS_MIN_CREATED_AT_ASC",
  AUDIT_FINDINGS_MIN_CREATED_AT_DESC = "AUDIT_FINDINGS_MIN_CREATED_AT_DESC",
  AUDIT_FINDINGS_MIN_DELETED_AT_ASC = "AUDIT_FINDINGS_MIN_DELETED_AT_ASC",
  AUDIT_FINDINGS_MIN_DELETED_AT_DESC = "AUDIT_FINDINGS_MIN_DELETED_AT_DESC",
  AUDIT_FINDINGS_MIN_DELETED_BY_ASC = "AUDIT_FINDINGS_MIN_DELETED_BY_ASC",
  AUDIT_FINDINGS_MIN_DELETED_BY_DESC = "AUDIT_FINDINGS_MIN_DELETED_BY_DESC",
  AUDIT_FINDINGS_MIN_ID_ASC = "AUDIT_FINDINGS_MIN_ID_ASC",
  AUDIT_FINDINGS_MIN_ID_DESC = "AUDIT_FINDINGS_MIN_ID_DESC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_MIN_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_MIN_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_MIN_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_MIN_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_MIN_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_MIN_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_MIN_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_MIN_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_MIN_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_MIN_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_MIN_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_MIN_UPDATED_AT_ASC = "AUDIT_FINDINGS_MIN_UPDATED_AT_ASC",
  AUDIT_FINDINGS_MIN_UPDATED_AT_DESC = "AUDIT_FINDINGS_MIN_UPDATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_CONFIDENCE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_DELETED_BY_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_AT_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_DELETED_BY_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_SUM_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_SUM_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_SUM_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_SUM_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_SUM_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_SUM_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_SUM_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC = "AUDIT_FINDINGS_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC = "AUDIT_FINDINGS_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_SUM_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_SUM_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_SUM_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_SUM_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_SUM_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_SUM_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_SUM_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_SUM_CONFIDENCE_ASC = "AUDIT_FINDINGS_SUM_CONFIDENCE_ASC",
  AUDIT_FINDINGS_SUM_CONFIDENCE_DESC = "AUDIT_FINDINGS_SUM_CONFIDENCE_DESC",
  AUDIT_FINDINGS_SUM_CREATED_AT_ASC = "AUDIT_FINDINGS_SUM_CREATED_AT_ASC",
  AUDIT_FINDINGS_SUM_CREATED_AT_DESC = "AUDIT_FINDINGS_SUM_CREATED_AT_DESC",
  AUDIT_FINDINGS_SUM_DELETED_AT_ASC = "AUDIT_FINDINGS_SUM_DELETED_AT_ASC",
  AUDIT_FINDINGS_SUM_DELETED_AT_DESC = "AUDIT_FINDINGS_SUM_DELETED_AT_DESC",
  AUDIT_FINDINGS_SUM_DELETED_BY_ASC = "AUDIT_FINDINGS_SUM_DELETED_BY_ASC",
  AUDIT_FINDINGS_SUM_DELETED_BY_DESC = "AUDIT_FINDINGS_SUM_DELETED_BY_DESC",
  AUDIT_FINDINGS_SUM_ID_ASC = "AUDIT_FINDINGS_SUM_ID_ASC",
  AUDIT_FINDINGS_SUM_ID_DESC = "AUDIT_FINDINGS_SUM_ID_DESC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_SUM_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_SUM_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_SUM_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_SUM_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_SUM_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_SUM_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_SUM_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_SUM_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_SUM_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_SUM_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_SUM_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_SUM_UPDATED_AT_ASC = "AUDIT_FINDINGS_SUM_UPDATED_AT_ASC",
  AUDIT_FINDINGS_SUM_UPDATED_AT_DESC = "AUDIT_FINDINGS_SUM_UPDATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CONFIDENCE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_DELETED_BY_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_COMMENT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDITOR_REVIEWED_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUDIT_TYPE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_KIND_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CONFIDENCE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_AT_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_DELETED_BY_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_NEEDS_REVIEW_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_ID_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_ID_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_ID_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_ID_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_METHOD_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_METHOD_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_METHOD_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_METHOD_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_COUNT_ASC = "AUDIT_SELECTION_METHODS_COUNT_ASC",
  AUDIT_SELECTION_METHODS_COUNT_DESC = "AUDIT_SELECTION_METHODS_COUNT_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_ID_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_ID_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_ID_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_ID_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_METHOD_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_METHOD_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_METHOD_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_METHOD_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_MAX_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_MAX_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_MAX_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_MAX_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_MAX_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_MAX_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_MAX_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_MAX_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_MAX_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_MAX_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_MAX_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_MAX_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_MAX_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_MAX_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_MAX_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_MAX_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_MAX_ID_ASC = "AUDIT_SELECTION_METHODS_MAX_ID_ASC",
  AUDIT_SELECTION_METHODS_MAX_ID_DESC = "AUDIT_SELECTION_METHODS_MAX_ID_DESC",
  AUDIT_SELECTION_METHODS_MAX_METHOD_ASC = "AUDIT_SELECTION_METHODS_MAX_METHOD_ASC",
  AUDIT_SELECTION_METHODS_MAX_METHOD_DESC = "AUDIT_SELECTION_METHODS_MAX_METHOD_DESC",
  AUDIT_SELECTION_METHODS_MAX_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_MAX_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_MAX_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_MAX_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_MIN_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_MIN_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_MIN_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_MIN_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_MIN_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_MIN_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_MIN_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_MIN_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_MIN_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_MIN_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_MIN_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_MIN_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_MIN_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_MIN_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_MIN_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_MIN_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_MIN_ID_ASC = "AUDIT_SELECTION_METHODS_MIN_ID_ASC",
  AUDIT_SELECTION_METHODS_MIN_ID_DESC = "AUDIT_SELECTION_METHODS_MIN_ID_DESC",
  AUDIT_SELECTION_METHODS_MIN_METHOD_ASC = "AUDIT_SELECTION_METHODS_MIN_METHOD_ASC",
  AUDIT_SELECTION_METHODS_MIN_METHOD_DESC = "AUDIT_SELECTION_METHODS_MIN_METHOD_DESC",
  AUDIT_SELECTION_METHODS_MIN_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_MIN_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_MIN_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_MIN_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_METHOD_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_METHOD_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_METHOD_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_METHOD_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_METHOD_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_METHOD_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_METHOD_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_METHOD_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_SUM_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_SUM_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_SUM_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_SUM_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_SUM_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_SUM_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_SUM_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_SUM_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_SUM_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_SUM_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_SUM_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_SUM_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_SUM_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_SUM_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_SUM_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_SUM_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_SUM_ID_ASC = "AUDIT_SELECTION_METHODS_SUM_ID_ASC",
  AUDIT_SELECTION_METHODS_SUM_ID_DESC = "AUDIT_SELECTION_METHODS_SUM_ID_DESC",
  AUDIT_SELECTION_METHODS_SUM_METHOD_ASC = "AUDIT_SELECTION_METHODS_SUM_METHOD_ASC",
  AUDIT_SELECTION_METHODS_SUM_METHOD_DESC = "AUDIT_SELECTION_METHODS_SUM_METHOD_DESC",
  AUDIT_SELECTION_METHODS_SUM_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_SUM_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_SUM_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_SUM_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_METHOD_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_METHOD_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_METHOD_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_METHOD_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_METHOD_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_METHOD_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_METHOD_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_METHOD_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ADM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ADM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ADM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ADM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_APR_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_APR_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_APR_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_APR_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTHOR_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTHOR_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_BILL_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_BILL_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_BILL_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_BILL_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_ADMIT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_ADMIT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DIAG_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DRG_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DRG_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DRG_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_DRG_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_INSURER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_INSURER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_INSURER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_INSURER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_OWNER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_OWNER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_OWNER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_OWNER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PAID_DATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PAID_DATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PAID_DATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PAID_DATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_DOB_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_DOB_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PATIENT_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_25_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_25_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_25_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_POA_25_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREPAY_DENY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREPAY_DENY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROVIDER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROVIDER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_VERSION_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_VERSION_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_VERSION_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_VERSION_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_VERSION_GROUP_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_VERSION_GROUP_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_AVERAGE_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_COUNT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_COUNT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_COUNT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_COUNT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ADMIT_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ADMIT_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ADM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ADM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ADM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ADM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_APR_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_APR_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_APR_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_APR_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_AUTHOR_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BILL_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BILL_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BILL_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_BILL_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLAIM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLAIM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_ADMIT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_ADMIT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_ADMIT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_ADMIT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DIAG_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DRG_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DRG_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DRG_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_DRG_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_INSURER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_INSURER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_INSURER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_INSURER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_OWNER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_OWNER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_OWNER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_OWNER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PAID_DATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PAID_DATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PAID_DATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PAID_DATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_DOB_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_DOB_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_DOB_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_DOB_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_GENDER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_GENDER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PATIENT_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PAYMENT_RATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PAYMENT_RATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_25_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_25_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_25_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_POA_25_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREPAY_DENY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREPAY_DENY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREPAY_DENY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREPAY_DENY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROVIDER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROVIDER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROVIDER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_PROVIDER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_VERSION_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_VERSION_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_VERSION_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_VERSION_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_VERSION_GROUP_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_VERSION_GROUP_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_VERSION_GROUP_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_DISTINCT_COUNT_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ADMIT_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ADMIT_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ADM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ADM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ADM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ADM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_APR_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_APR_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_APR_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_APR_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AUTHOR_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AUTHOR_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AUTHOR_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_AUTHOR_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_BILL_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_BILL_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_BILL_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_BILL_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLAIM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLAIM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CREATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CREATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CREATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_CREATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_ADMIT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_ADMIT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_ADMIT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_ADMIT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DIAG_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DRG_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DRG_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DRG_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_DRG_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_INSURER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_INSURER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_INSURER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_INSURER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_OWNER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_OWNER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_OWNER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_OWNER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PAID_DATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PAID_DATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PAID_DATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PAID_DATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_DOB_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_DOB_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_DOB_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_DOB_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_GENDER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_GENDER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PATIENT_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PAYMENT_RATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PAYMENT_RATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_25_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_25_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_25_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_POA_25_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PREPAY_DENY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PREPAY_DENY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PREPAY_DENY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PREPAY_DENY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROVIDER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROVIDER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROVIDER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_PROVIDER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_UPDATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_UPDATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_UPDATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_UPDATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_VERSION_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_VERSION_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_VERSION_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_VERSION_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_VERSION_GROUP_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_VERSION_GROUP_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_VERSION_GROUP_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MAX_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ADMIT_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ADMIT_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ADM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ADM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ADM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ADM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_APR_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_APR_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_APR_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_APR_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AUTHOR_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AUTHOR_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AUTHOR_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_AUTHOR_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_BILL_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_BILL_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_BILL_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_BILL_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLAIM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLAIM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CREATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CREATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CREATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_CREATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_ADMIT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_ADMIT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_ADMIT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_ADMIT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DIAG_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DRG_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DRG_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DRG_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_DRG_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_INSURER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_INSURER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_INSURER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_INSURER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_OWNER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_OWNER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_OWNER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_OWNER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PAID_DATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PAID_DATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PAID_DATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PAID_DATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_DOB_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_DOB_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_DOB_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_DOB_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_GENDER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_GENDER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PATIENT_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PAYMENT_RATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PAYMENT_RATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_25_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_25_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_25_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_POA_25_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PREPAY_DENY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PREPAY_DENY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PREPAY_DENY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PREPAY_DENY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROVIDER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROVIDER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROVIDER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_PROVIDER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_UPDATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_UPDATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_UPDATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_UPDATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_VERSION_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_VERSION_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_VERSION_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_VERSION_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_VERSION_GROUP_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_VERSION_GROUP_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_VERSION_GROUP_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_MIN_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ADMIT_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ADMIT_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ADM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ADM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ADM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ADM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_APR_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_APR_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_APR_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_APR_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BILL_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BILL_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BILL_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_BILL_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLAIM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLAIM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_ADMIT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_ADMIT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_ADMIT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_ADMIT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DIAG_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DRG_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DRG_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DRG_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_DRG_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_INSURER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_INSURER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_OWNER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_OWNER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_OWNER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_OWNER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PAID_DATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PAID_DATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PAID_DATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PAID_DATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_DOB_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_DOB_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_DOB_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_DOB_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_GENDER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_GENDER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PATIENT_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PAYMENT_RATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PAYMENT_RATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_25_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_25_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_25_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_POA_25_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREPAY_DENY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREPAY_DENY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREPAY_DENY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREPAY_DENY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROVIDER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROVIDER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROVIDER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_PROVIDER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_VERSION_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_VERSION_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_VERSION_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_VERSION_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_VERSION_GROUP_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_VERSION_GROUP_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_VERSION_GROUP_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_POPULATION_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ADM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ADM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ADM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ADM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_APR_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_APR_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_APR_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_APR_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BILL_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BILL_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BILL_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_BILL_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_ADMIT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_ADMIT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DIAG_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DRG_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DRG_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DRG_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_DRG_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_OWNER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_OWNER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_OWNER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_OWNER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PAID_DATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PAID_DATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PAID_DATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PAID_DATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_DOB_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_DOB_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PATIENT_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_25_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_25_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_25_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_POA_25_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREPAY_DENY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREPAY_DENY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_VERSION_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_VERSION_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_VERSION_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_VERSION_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_VERSION_GROUP_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_VERSION_GROUP_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_STDDEV_SAMPLE_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ADMIT_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ADMIT_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ADM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ADM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ADM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ADM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_APR_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_APR_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_APR_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_APR_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AUTHOR_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AUTHOR_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AUTHOR_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_AUTHOR_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_BILL_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_BILL_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_BILL_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_BILL_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLAIM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLAIM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CREATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CREATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CREATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_CREATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_ADMIT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_ADMIT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_ADMIT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_ADMIT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DIAG_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DRG_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DRG_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DRG_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_DRG_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_INSURER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_INSURER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_INSURER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_INSURER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_OWNER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_OWNER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_OWNER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_OWNER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PAID_DATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PAID_DATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PAID_DATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PAID_DATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_DOB_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_DOB_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_DOB_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_DOB_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_GENDER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_GENDER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PATIENT_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PAYMENT_RATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PAYMENT_RATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_25_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_25_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_25_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_POA_25_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PREPAY_DENY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PREPAY_DENY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PREPAY_DENY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PREPAY_DENY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROVIDER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROVIDER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROVIDER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_PROVIDER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_UPDATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_UPDATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_UPDATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_UPDATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_VERSION_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_VERSION_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_VERSION_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_VERSION_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_VERSION_GROUP_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_VERSION_GROUP_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_VERSION_GROUP_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_SUM_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ADMIT_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ADMIT_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ADM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ADM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ADM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ADM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_APR_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_APR_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_APR_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_APR_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BILL_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BILL_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BILL_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_BILL_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLAIM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLAIM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_ADMIT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_ADMIT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_ADMIT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_ADMIT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DIAG_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DRG_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DRG_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DRG_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_DRG_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_INSURER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_INSURER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_OWNER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_OWNER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_OWNER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_OWNER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PAID_DATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PAID_DATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PAID_DATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PAID_DATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_DOB_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_DOB_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_DOB_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_DOB_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_GENDER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_GENDER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PATIENT_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PAYMENT_RATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PAYMENT_RATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_25_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_25_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_25_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_POA_25_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREPAY_DENY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREPAY_DENY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREPAY_DENY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREPAY_DENY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_VERSION_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_VERSION_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_VERSION_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_VERSION_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_VERSION_GROUP_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_VERSION_GROUP_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_VERSION_GROUP_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_POPULATION_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ADM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ADM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ADM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ADM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_APR_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_APR_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_APR_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_APR_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BILL_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BILL_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BILL_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_BILL_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_ADMIT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_ADMIT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DIAG_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DRG_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DRG_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DRG_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_DRG_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ICN_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ICN_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ICN_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ICN_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_OWNER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_OWNER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_OWNER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_OWNER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PAID_DATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PAID_DATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PAID_DATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PAID_DATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_DOB_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_DOB_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PATIENT_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_11_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_11_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_11_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_11_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_12_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_12_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_12_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_12_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_13_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_13_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_13_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_13_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_14_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_14_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_14_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_14_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_15_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_15_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_15_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_15_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_16_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_16_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_16_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_16_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_17_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_17_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_17_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_17_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_18_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_18_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_18_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_18_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_19_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_19_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_19_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_19_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_20_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_20_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_20_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_20_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_21_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_21_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_21_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_21_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_22_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_22_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_22_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_22_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_23_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_23_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_23_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_23_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_24_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_24_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_24_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_24_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_25_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_25_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_25_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_POA_25_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREPAY_DENY_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREPAY_DENY_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_VERSION_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_VERSION_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_VERSION_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_VERSION_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_VERSION_GROUP_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_VERSION_GROUP_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID_VARIANCE_SAMPLE_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID__COUNT_ASC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID__COUNT_ASC",
  BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID__COUNT_DESC = "BATCH_CLAIMS_BY_PREVIOUS_VERSION_ID__COUNT_DESC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__APPEALED_ASC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__APPEALED_ASC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__APPEALED_DESC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__APPEALED_DESC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__CREATED_BY_ASC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__CREATED_BY_ASC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__CREATED_BY_DESC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__CREATED_BY_DESC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_APPEALED_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_ID_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_ID_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_BY_AUDITOR_USER_NAME_ASC = "BATCH_CLAIM_ASSIGNEES_BY_AUDITOR_USER_NAME_ASC",
  BATCH_CLAIM_ASSIGNEES_BY_AUDITOR_USER_NAME_DESC = "BATCH_CLAIM_ASSIGNEES_BY_AUDITOR_USER_NAME_DESC",
  BATCH_CLAIM_ASSIGNEES_BY_BATCH_CLAIM_ID__COUNT_ASC = "BATCH_CLAIM_ASSIGNEES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  BATCH_CLAIM_ASSIGNEES_BY_BATCH_CLAIM_ID__COUNT_DESC = "BATCH_CLAIM_ASSIGNEES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  BATCH_CLAIM_ASSIGNEES_COUNT_ASC = "BATCH_CLAIM_ASSIGNEES_COUNT_ASC",
  BATCH_CLAIM_ASSIGNEES_COUNT_DESC = "BATCH_CLAIM_ASSIGNEES_COUNT_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_ID_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_ID_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UNASSIGNED_DESC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_ASSIGNEES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_AVERAGE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_AVERAGE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_AVERAGE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_AVERAGE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_AVERAGE_ID_ASC = "BATCH_CLAIM_AUDITORS_AVERAGE_ID_ASC",
  BATCH_CLAIM_AUDITORS_AVERAGE_ID_DESC = "BATCH_CLAIM_AUDITORS_AVERAGE_ID_DESC",
  BATCH_CLAIM_AUDITORS_BY_BATCH_CLAIM_ID__COUNT_ASC = "BATCH_CLAIM_AUDITORS_BY_BATCH_CLAIM_ID__COUNT_ASC",
  BATCH_CLAIM_AUDITORS_BY_BATCH_CLAIM_ID__COUNT_DESC = "BATCH_CLAIM_AUDITORS_BY_BATCH_CLAIM_ID__COUNT_DESC",
  BATCH_CLAIM_AUDITORS_COUNT_ASC = "BATCH_CLAIM_AUDITORS_COUNT_ASC",
  BATCH_CLAIM_AUDITORS_COUNT_DESC = "BATCH_CLAIM_AUDITORS_COUNT_DESC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_AUDITORS_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_AUDITORS_MAX_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_MAX_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_MAX_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_MAX_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_MAX_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_MAX_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_MAX_ID_ASC = "BATCH_CLAIM_AUDITORS_MAX_ID_ASC",
  BATCH_CLAIM_AUDITORS_MAX_ID_DESC = "BATCH_CLAIM_AUDITORS_MAX_ID_DESC",
  BATCH_CLAIM_AUDITORS_MIN_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_MIN_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_MIN_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_MIN_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_MIN_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_MIN_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_MIN_ID_ASC = "BATCH_CLAIM_AUDITORS_MIN_ID_ASC",
  BATCH_CLAIM_AUDITORS_MIN_ID_DESC = "BATCH_CLAIM_AUDITORS_MIN_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_AUDITORS_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_AUDITORS_SUM_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_SUM_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_SUM_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_SUM_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_SUM_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_SUM_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_SUM_ID_ASC = "BATCH_CLAIM_AUDITORS_SUM_ID_ASC",
  BATCH_CLAIM_AUDITORS_SUM_ID_DESC = "BATCH_CLAIM_AUDITORS_SUM_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_AUDITORS_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_AUDIT_START_DATE_ASC = "BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_AUDIT_START_DATE_DESC = "BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_DELETED_ASC = "BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_DELETED_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_DELETED_DESC = "BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_DELETED_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_AVERAGE_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_BY_BATCH_CLAIM_ID__COUNT_ASC = "BATCH_CLAIM_AUDIT_START_DATES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_BY_BATCH_CLAIM_ID__COUNT_DESC = "BATCH_CLAIM_AUDIT_START_DATES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_COUNT_ASC = "BATCH_CLAIM_AUDIT_START_DATES_COUNT_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_COUNT_DESC = "BATCH_CLAIM_AUDIT_START_DATES_COUNT_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_AUDIT_START_DATE_ASC = "BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_AUDIT_START_DATE_DESC = "BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_DELETED_ASC = "BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_DELETED_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_DELETED_DESC = "BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_DELETED_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_MAX_AUDIT_START_DATE_ASC = "BATCH_CLAIM_AUDIT_START_DATES_MAX_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_MAX_AUDIT_START_DATE_DESC = "BATCH_CLAIM_AUDIT_START_DATES_MAX_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_MAX_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_START_DATES_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_MAX_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_START_DATES_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_MAX_DELETED_ASC = "BATCH_CLAIM_AUDIT_START_DATES_MAX_DELETED_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_MAX_DELETED_DESC = "BATCH_CLAIM_AUDIT_START_DATES_MAX_DELETED_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_MAX_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_MAX_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_MAX_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_MAX_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_MIN_AUDIT_START_DATE_ASC = "BATCH_CLAIM_AUDIT_START_DATES_MIN_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_MIN_AUDIT_START_DATE_DESC = "BATCH_CLAIM_AUDIT_START_DATES_MIN_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_MIN_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_START_DATES_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_MIN_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_START_DATES_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_MIN_DELETED_ASC = "BATCH_CLAIM_AUDIT_START_DATES_MIN_DELETED_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_MIN_DELETED_DESC = "BATCH_CLAIM_AUDIT_START_DATES_MIN_DELETED_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_MIN_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_MIN_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_MIN_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_MIN_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_AUDIT_START_DATE_ASC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_AUDIT_START_DATE_DESC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_DELETED_ASC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_DELETED_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_DELETED_DESC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_DELETED_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_AUDIT_START_DATE_ASC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_AUDIT_START_DATE_DESC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_DELETED_ASC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_DELETED_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_DELETED_DESC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_DELETED_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_SUM_AUDIT_START_DATE_ASC = "BATCH_CLAIM_AUDIT_START_DATES_SUM_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_SUM_AUDIT_START_DATE_DESC = "BATCH_CLAIM_AUDIT_START_DATES_SUM_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_SUM_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_START_DATES_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_SUM_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_START_DATES_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_SUM_DELETED_ASC = "BATCH_CLAIM_AUDIT_START_DATES_SUM_DELETED_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_SUM_DELETED_DESC = "BATCH_CLAIM_AUDIT_START_DATES_SUM_DELETED_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_SUM_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_SUM_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_SUM_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_SUM_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_AUDIT_START_DATE_ASC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_AUDIT_START_DATE_DESC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_DELETED_ASC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_DELETED_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_DELETED_DESC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_DELETED_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_AUDIT_START_DATE_ASC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_AUDIT_START_DATE_DESC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_DELETED_ASC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_DELETED_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_DELETED_DESC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_DELETED_DESC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_AUDIT_START_DATES_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__AUDIT_TYPE_ASC = "BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__AUDIT_TYPE_ASC",
  BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__AUDIT_TYPE_DESC = "BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__AUDIT_TYPE_DESC",
  BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_AUDIT_TYPE_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ICN_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ICN_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ICN_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ICN_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ID_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ID_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ID_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ID_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_1_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_1_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_1_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_1_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_2_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_2_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_2_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_2_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_3_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_3_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_3_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_3_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_4_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_4_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_4_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_4_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_5_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_5_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_5_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_5_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_6_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_6_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_6_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_6_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_7_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_7_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_7_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_7_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_8_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_8_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_8_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_8_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_9_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_9_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_9_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_9_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_10_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_10_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_10_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_10_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_11_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_11_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_11_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_11_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_12_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_12_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_12_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_12_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_13_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_13_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_13_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_13_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_14_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_14_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_14_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_14_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_15_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_15_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_15_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_15_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_16_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_16_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_16_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_16_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_17_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_17_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_17_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_17_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_18_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_18_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_18_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_18_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_19_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_19_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_19_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_19_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_20_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_20_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_20_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_20_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_21_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_21_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_21_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_21_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_22_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_22_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_22_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_22_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_23_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_23_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_23_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_23_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_24_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_24_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_24_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_24_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_25_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_25_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_25_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__POA_25_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__VERSION_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__VERSION_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__VERSION_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__VERSION_DESC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_PREVIOUS_VERSION_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_AVERAGE_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_BY_BATCH_CLAIM_ID__COUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_BY_BATCH_CLAIM_ID__COUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_BY_BATCH_CLAIM_ID__COUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_BY_BATCH_CLAIM_ID__COUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_COUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_COUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_COUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_COUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MAX_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_MIN_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_SUM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_AMOUNTS_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_AVERAGE_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_BY_BATCH_CLAIM_ID__COUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_BY_BATCH_CLAIM_ID__COUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_COUNT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_COUNT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_COUNT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_COUNT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MAX_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_MIN_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_SUM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_DELETED_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_DELETED_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_DELETED_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_DELETED_DESC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_CLIENT_RECOVERY_COLLECTION_DATES_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_VERSION_DESC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_DOCUMENT_ID_ASC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_DOCUMENT_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_DOCUMENT_ID_DESC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_DOCUMENT_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_ID_ASC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_ID_DESC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_IS_PRIMARY_MEDICAL_RECORD_ASC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_IS_PRIMARY_MEDICAL_RECORD_ASC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_IS_PRIMARY_MEDICAL_RECORD_DESC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_IS_PRIMARY_MEDICAL_RECORD_DESC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_BY_BATCH_CLAIM_ID__COUNT_ASC = "BATCH_CLAIM_DOCUMENTS_BY_BATCH_CLAIM_ID__COUNT_ASC",
  BATCH_CLAIM_DOCUMENTS_BY_BATCH_CLAIM_ID__COUNT_DESC = "BATCH_CLAIM_DOCUMENTS_BY_BATCH_CLAIM_ID__COUNT_DESC",
  BATCH_CLAIM_DOCUMENTS_COUNT_ASC = "BATCH_CLAIM_DOCUMENTS_COUNT_ASC",
  BATCH_CLAIM_DOCUMENTS_COUNT_DESC = "BATCH_CLAIM_DOCUMENTS_COUNT_DESC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_DOCUMENT_ID_ASC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_DOCUMENT_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_DOCUMENT_ID_DESC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_DOCUMENT_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_IS_PRIMARY_MEDICAL_RECORD_ASC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_IS_PRIMARY_MEDICAL_RECORD_ASC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_IS_PRIMARY_MEDICAL_RECORD_DESC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_IS_PRIMARY_MEDICAL_RECORD_DESC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DOCUMENTS_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DOCUMENTS_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_MAX_CREATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_MAX_CREATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_MAX_DOCUMENT_ID_ASC = "BATCH_CLAIM_DOCUMENTS_MAX_DOCUMENT_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_MAX_DOCUMENT_ID_DESC = "BATCH_CLAIM_DOCUMENTS_MAX_DOCUMENT_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_MAX_ID_ASC = "BATCH_CLAIM_DOCUMENTS_MAX_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_MAX_ID_DESC = "BATCH_CLAIM_DOCUMENTS_MAX_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_MAX_IS_PRIMARY_MEDICAL_RECORD_ASC = "BATCH_CLAIM_DOCUMENTS_MAX_IS_PRIMARY_MEDICAL_RECORD_ASC",
  BATCH_CLAIM_DOCUMENTS_MAX_IS_PRIMARY_MEDICAL_RECORD_DESC = "BATCH_CLAIM_DOCUMENTS_MAX_IS_PRIMARY_MEDICAL_RECORD_DESC",
  BATCH_CLAIM_DOCUMENTS_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DOCUMENTS_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DOCUMENTS_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_MIN_CREATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_MIN_CREATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_MIN_DOCUMENT_ID_ASC = "BATCH_CLAIM_DOCUMENTS_MIN_DOCUMENT_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_MIN_DOCUMENT_ID_DESC = "BATCH_CLAIM_DOCUMENTS_MIN_DOCUMENT_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_MIN_ID_ASC = "BATCH_CLAIM_DOCUMENTS_MIN_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_MIN_ID_DESC = "BATCH_CLAIM_DOCUMENTS_MIN_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_MIN_IS_PRIMARY_MEDICAL_RECORD_ASC = "BATCH_CLAIM_DOCUMENTS_MIN_IS_PRIMARY_MEDICAL_RECORD_ASC",
  BATCH_CLAIM_DOCUMENTS_MIN_IS_PRIMARY_MEDICAL_RECORD_DESC = "BATCH_CLAIM_DOCUMENTS_MIN_IS_PRIMARY_MEDICAL_RECORD_DESC",
  BATCH_CLAIM_DOCUMENTS_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_DOCUMENT_ID_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_DOCUMENT_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_DOCUMENT_ID_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_DOCUMENT_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_IS_PRIMARY_MEDICAL_RECORD_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_IS_PRIMARY_MEDICAL_RECORD_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_IS_PRIMARY_MEDICAL_RECORD_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_IS_PRIMARY_MEDICAL_RECORD_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_DOCUMENT_ID_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_DOCUMENT_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_DOCUMENT_ID_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_DOCUMENT_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_IS_PRIMARY_MEDICAL_RECORD_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_IS_PRIMARY_MEDICAL_RECORD_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_IS_PRIMARY_MEDICAL_RECORD_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_IS_PRIMARY_MEDICAL_RECORD_DESC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DOCUMENTS_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DOCUMENTS_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_SUM_CREATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_SUM_CREATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_SUM_DOCUMENT_ID_ASC = "BATCH_CLAIM_DOCUMENTS_SUM_DOCUMENT_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_SUM_DOCUMENT_ID_DESC = "BATCH_CLAIM_DOCUMENTS_SUM_DOCUMENT_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_SUM_ID_ASC = "BATCH_CLAIM_DOCUMENTS_SUM_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_SUM_ID_DESC = "BATCH_CLAIM_DOCUMENTS_SUM_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_SUM_IS_PRIMARY_MEDICAL_RECORD_ASC = "BATCH_CLAIM_DOCUMENTS_SUM_IS_PRIMARY_MEDICAL_RECORD_ASC",
  BATCH_CLAIM_DOCUMENTS_SUM_IS_PRIMARY_MEDICAL_RECORD_DESC = "BATCH_CLAIM_DOCUMENTS_SUM_IS_PRIMARY_MEDICAL_RECORD_DESC",
  BATCH_CLAIM_DOCUMENTS_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_DOCUMENT_ID_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_DOCUMENT_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_DOCUMENT_ID_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_DOCUMENT_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_IS_PRIMARY_MEDICAL_RECORD_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_IS_PRIMARY_MEDICAL_RECORD_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_IS_PRIMARY_MEDICAL_RECORD_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_IS_PRIMARY_MEDICAL_RECORD_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_DOCUMENT_ID_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_DOCUMENT_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_DOCUMENT_ID_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_DOCUMENT_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_IS_PRIMARY_MEDICAL_RECORD_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_IS_PRIMARY_MEDICAL_RECORD_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_IS_PRIMARY_MEDICAL_RECORD_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_IS_PRIMARY_MEDICAL_RECORD_DESC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_DOCUMENTS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_DUE_DATES_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DUE_DATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DUE_DATES_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DUE_DATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DUE_DATES_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_DUE_DATES_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_DUE_DATES_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_DUE_DATES_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_DUE_DATES_AVERAGE_DELETED_ASC = "BATCH_CLAIM_DUE_DATES_AVERAGE_DELETED_ASC",
  BATCH_CLAIM_DUE_DATES_AVERAGE_DELETED_DESC = "BATCH_CLAIM_DUE_DATES_AVERAGE_DELETED_DESC",
  BATCH_CLAIM_DUE_DATES_AVERAGE_DUE_DATE_ASC = "BATCH_CLAIM_DUE_DATES_AVERAGE_DUE_DATE_ASC",
  BATCH_CLAIM_DUE_DATES_AVERAGE_DUE_DATE_DESC = "BATCH_CLAIM_DUE_DATES_AVERAGE_DUE_DATE_DESC",
  BATCH_CLAIM_DUE_DATES_AVERAGE_ID_ASC = "BATCH_CLAIM_DUE_DATES_AVERAGE_ID_ASC",
  BATCH_CLAIM_DUE_DATES_AVERAGE_ID_DESC = "BATCH_CLAIM_DUE_DATES_AVERAGE_ID_DESC",
  BATCH_CLAIM_DUE_DATES_BY_BATCH_CLAIM_ID__COUNT_ASC = "BATCH_CLAIM_DUE_DATES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  BATCH_CLAIM_DUE_DATES_BY_BATCH_CLAIM_ID__COUNT_DESC = "BATCH_CLAIM_DUE_DATES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  BATCH_CLAIM_DUE_DATES_COUNT_ASC = "BATCH_CLAIM_DUE_DATES_COUNT_ASC",
  BATCH_CLAIM_DUE_DATES_COUNT_DESC = "BATCH_CLAIM_DUE_DATES_COUNT_DESC",
  BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_DELETED_ASC = "BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_DELETED_ASC",
  BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_DELETED_DESC = "BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_DELETED_DESC",
  BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_DUE_DATE_ASC = "BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_DUE_DATE_ASC",
  BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_DUE_DATE_DESC = "BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_DUE_DATE_DESC",
  BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_DUE_DATES_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_DUE_DATES_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DUE_DATES_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DUE_DATES_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DUE_DATES_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DUE_DATES_MAX_CREATED_AT_ASC = "BATCH_CLAIM_DUE_DATES_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_DUE_DATES_MAX_CREATED_AT_DESC = "BATCH_CLAIM_DUE_DATES_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_DUE_DATES_MAX_DELETED_ASC = "BATCH_CLAIM_DUE_DATES_MAX_DELETED_ASC",
  BATCH_CLAIM_DUE_DATES_MAX_DELETED_DESC = "BATCH_CLAIM_DUE_DATES_MAX_DELETED_DESC",
  BATCH_CLAIM_DUE_DATES_MAX_DUE_DATE_ASC = "BATCH_CLAIM_DUE_DATES_MAX_DUE_DATE_ASC",
  BATCH_CLAIM_DUE_DATES_MAX_DUE_DATE_DESC = "BATCH_CLAIM_DUE_DATES_MAX_DUE_DATE_DESC",
  BATCH_CLAIM_DUE_DATES_MAX_ID_ASC = "BATCH_CLAIM_DUE_DATES_MAX_ID_ASC",
  BATCH_CLAIM_DUE_DATES_MAX_ID_DESC = "BATCH_CLAIM_DUE_DATES_MAX_ID_DESC",
  BATCH_CLAIM_DUE_DATES_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DUE_DATES_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DUE_DATES_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DUE_DATES_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DUE_DATES_MIN_CREATED_AT_ASC = "BATCH_CLAIM_DUE_DATES_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_DUE_DATES_MIN_CREATED_AT_DESC = "BATCH_CLAIM_DUE_DATES_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_DUE_DATES_MIN_DELETED_ASC = "BATCH_CLAIM_DUE_DATES_MIN_DELETED_ASC",
  BATCH_CLAIM_DUE_DATES_MIN_DELETED_DESC = "BATCH_CLAIM_DUE_DATES_MIN_DELETED_DESC",
  BATCH_CLAIM_DUE_DATES_MIN_DUE_DATE_ASC = "BATCH_CLAIM_DUE_DATES_MIN_DUE_DATE_ASC",
  BATCH_CLAIM_DUE_DATES_MIN_DUE_DATE_DESC = "BATCH_CLAIM_DUE_DATES_MIN_DUE_DATE_DESC",
  BATCH_CLAIM_DUE_DATES_MIN_ID_ASC = "BATCH_CLAIM_DUE_DATES_MIN_ID_ASC",
  BATCH_CLAIM_DUE_DATES_MIN_ID_DESC = "BATCH_CLAIM_DUE_DATES_MIN_ID_DESC",
  BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_DELETED_ASC = "BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_DELETED_ASC",
  BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_DELETED_DESC = "BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_DELETED_DESC",
  BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_DUE_DATE_ASC = "BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_DUE_DATE_ASC",
  BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_DUE_DATE_DESC = "BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_DUE_DATE_DESC",
  BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_DUE_DATES_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_DELETED_ASC = "BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_DELETED_ASC",
  BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_DELETED_DESC = "BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_DELETED_DESC",
  BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_DUE_DATE_ASC = "BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_DUE_DATE_ASC",
  BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_DUE_DATE_DESC = "BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_DUE_DATE_DESC",
  BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_DUE_DATES_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_DUE_DATES_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DUE_DATES_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DUE_DATES_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DUE_DATES_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DUE_DATES_SUM_CREATED_AT_ASC = "BATCH_CLAIM_DUE_DATES_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_DUE_DATES_SUM_CREATED_AT_DESC = "BATCH_CLAIM_DUE_DATES_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_DUE_DATES_SUM_DELETED_ASC = "BATCH_CLAIM_DUE_DATES_SUM_DELETED_ASC",
  BATCH_CLAIM_DUE_DATES_SUM_DELETED_DESC = "BATCH_CLAIM_DUE_DATES_SUM_DELETED_DESC",
  BATCH_CLAIM_DUE_DATES_SUM_DUE_DATE_ASC = "BATCH_CLAIM_DUE_DATES_SUM_DUE_DATE_ASC",
  BATCH_CLAIM_DUE_DATES_SUM_DUE_DATE_DESC = "BATCH_CLAIM_DUE_DATES_SUM_DUE_DATE_DESC",
  BATCH_CLAIM_DUE_DATES_SUM_ID_ASC = "BATCH_CLAIM_DUE_DATES_SUM_ID_ASC",
  BATCH_CLAIM_DUE_DATES_SUM_ID_DESC = "BATCH_CLAIM_DUE_DATES_SUM_ID_DESC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_DELETED_ASC = "BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_DELETED_ASC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_DELETED_DESC = "BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_DELETED_DESC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_DUE_DATE_ASC = "BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_DUE_DATE_ASC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_DUE_DATE_DESC = "BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_DUE_DATE_DESC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_DUE_DATES_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_DELETED_ASC = "BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_DELETED_ASC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_DELETED_DESC = "BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_DELETED_DESC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_DUE_DATE_ASC = "BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_DUE_DATE_ASC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_DUE_DATE_DESC = "BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_DUE_DATE_DESC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_DUE_DATES_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINES_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINES_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINES_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINES_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINES_AVERAGE_CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_AVERAGE_CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_AVERAGE_CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_AVERAGE_CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_LINES_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_LINES_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_LINES_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_1_ASC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_1_ASC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_1_DESC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_1_DESC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_2_ASC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_2_ASC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_2_DESC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_2_DESC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_3_ASC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_3_ASC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_3_DESC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_3_DESC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_4_ASC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_4_ASC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_4_DESC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_4_DESC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_AVERAGE_DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_AVERAGE_DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_AVERAGE_ID_ASC = "BATCH_CLAIM_LINES_AVERAGE_ID_ASC",
  BATCH_CLAIM_LINES_AVERAGE_ID_DESC = "BATCH_CLAIM_LINES_AVERAGE_ID_DESC",
  BATCH_CLAIM_LINES_AVERAGE_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_AVERAGE_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_AVERAGE_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_AVERAGE_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_AVERAGE_NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINES_AVERAGE_NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINES_AVERAGE_NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINES_AVERAGE_NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINES_AVERAGE_NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINES_AVERAGE_NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINES_AVERAGE_NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINES_AVERAGE_NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINES_AVERAGE_PAYMENT_RATE_ASC = "BATCH_CLAIM_LINES_AVERAGE_PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINES_AVERAGE_PAYMENT_RATE_DESC = "BATCH_CLAIM_LINES_AVERAGE_PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_AVERAGE_PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_AVERAGE_REV_CODE_ASC = "BATCH_CLAIM_LINES_AVERAGE_REV_CODE_ASC",
  BATCH_CLAIM_LINES_AVERAGE_REV_CODE_DESC = "BATCH_CLAIM_LINES_AVERAGE_REV_CODE_DESC",
  BATCH_CLAIM_LINES_AVERAGE_REV_CODE_SRC_ASC = "BATCH_CLAIM_LINES_AVERAGE_REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINES_AVERAGE_REV_CODE_SRC_DESC = "BATCH_CLAIM_LINES_AVERAGE_REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINES_AVERAGE_REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_AVERAGE_REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_AVERAGE_REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_AVERAGE_REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_AVERAGE_SERVICE_DATE_ASC = "BATCH_CLAIM_LINES_AVERAGE_SERVICE_DATE_ASC",
  BATCH_CLAIM_LINES_AVERAGE_SERVICE_DATE_DESC = "BATCH_CLAIM_LINES_AVERAGE_SERVICE_DATE_DESC",
  BATCH_CLAIM_LINES_AVERAGE_UNITS_ASC = "BATCH_CLAIM_LINES_AVERAGE_UNITS_ASC",
  BATCH_CLAIM_LINES_AVERAGE_UNITS_DESC = "BATCH_CLAIM_LINES_AVERAGE_UNITS_DESC",
  BATCH_CLAIM_LINES_AVERAGE_UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINES_AVERAGE_UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINES_AVERAGE_UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINES_AVERAGE_UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINES_AVERAGE_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINES_AVERAGE_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINES_AVERAGE_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINES_AVERAGE_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINES_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_LINES_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINES_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_LINES_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINES_BY_BATCH_CLAIM_ID__COUNT_ASC = "BATCH_CLAIM_LINES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  BATCH_CLAIM_LINES_BY_BATCH_CLAIM_ID__COUNT_DESC = "BATCH_CLAIM_LINES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  BATCH_CLAIM_LINES_COUNT_ASC = "BATCH_CLAIM_LINES_COUNT_ASC",
  BATCH_CLAIM_LINES_COUNT_DESC = "BATCH_CLAIM_LINES_COUNT_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_1_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_1_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_1_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_1_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_2_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_2_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_2_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_2_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_3_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_3_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_3_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_3_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_4_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_4_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_4_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_4_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PAYMENT_RATE_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PAYMENT_RATE_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_CODE_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_CODE_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_CODE_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_CODE_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_CODE_SRC_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_CODE_SRC_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_SERVICE_DATE_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_SERVICE_DATE_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_SERVICE_DATE_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_SERVICE_DATE_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_UNITS_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_UNITS_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_UNITS_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_UNITS_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_LINES_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_LINES_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_LINES_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINES_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINES_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINES_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINES_MAX_CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_MAX_CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_MAX_CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_MAX_CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_MAX_CREATED_AT_ASC = "BATCH_CLAIM_LINES_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_LINES_MAX_CREATED_AT_DESC = "BATCH_CLAIM_LINES_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_LINES_MAX_DIAG_1_ASC = "BATCH_CLAIM_LINES_MAX_DIAG_1_ASC",
  BATCH_CLAIM_LINES_MAX_DIAG_1_DESC = "BATCH_CLAIM_LINES_MAX_DIAG_1_DESC",
  BATCH_CLAIM_LINES_MAX_DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MAX_DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MAX_DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MAX_DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MAX_DIAG_2_ASC = "BATCH_CLAIM_LINES_MAX_DIAG_2_ASC",
  BATCH_CLAIM_LINES_MAX_DIAG_2_DESC = "BATCH_CLAIM_LINES_MAX_DIAG_2_DESC",
  BATCH_CLAIM_LINES_MAX_DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MAX_DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MAX_DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MAX_DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MAX_DIAG_3_ASC = "BATCH_CLAIM_LINES_MAX_DIAG_3_ASC",
  BATCH_CLAIM_LINES_MAX_DIAG_3_DESC = "BATCH_CLAIM_LINES_MAX_DIAG_3_DESC",
  BATCH_CLAIM_LINES_MAX_DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MAX_DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MAX_DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MAX_DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MAX_DIAG_4_ASC = "BATCH_CLAIM_LINES_MAX_DIAG_4_ASC",
  BATCH_CLAIM_LINES_MAX_DIAG_4_DESC = "BATCH_CLAIM_LINES_MAX_DIAG_4_DESC",
  BATCH_CLAIM_LINES_MAX_DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MAX_DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MAX_DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MAX_DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MAX_ID_ASC = "BATCH_CLAIM_LINES_MAX_ID_ASC",
  BATCH_CLAIM_LINES_MAX_ID_DESC = "BATCH_CLAIM_LINES_MAX_ID_DESC",
  BATCH_CLAIM_LINES_MAX_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_MAX_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_MAX_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_MAX_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_MAX_NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINES_MAX_NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINES_MAX_NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINES_MAX_NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINES_MAX_NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINES_MAX_NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINES_MAX_NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINES_MAX_NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINES_MAX_PAYMENT_RATE_ASC = "BATCH_CLAIM_LINES_MAX_PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINES_MAX_PAYMENT_RATE_DESC = "BATCH_CLAIM_LINES_MAX_PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MAX_PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MAX_PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MAX_REV_CODE_ASC = "BATCH_CLAIM_LINES_MAX_REV_CODE_ASC",
  BATCH_CLAIM_LINES_MAX_REV_CODE_DESC = "BATCH_CLAIM_LINES_MAX_REV_CODE_DESC",
  BATCH_CLAIM_LINES_MAX_REV_CODE_SRC_ASC = "BATCH_CLAIM_LINES_MAX_REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINES_MAX_REV_CODE_SRC_DESC = "BATCH_CLAIM_LINES_MAX_REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINES_MAX_REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MAX_REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MAX_REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MAX_REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MAX_SERVICE_DATE_ASC = "BATCH_CLAIM_LINES_MAX_SERVICE_DATE_ASC",
  BATCH_CLAIM_LINES_MAX_SERVICE_DATE_DESC = "BATCH_CLAIM_LINES_MAX_SERVICE_DATE_DESC",
  BATCH_CLAIM_LINES_MAX_UNITS_ASC = "BATCH_CLAIM_LINES_MAX_UNITS_ASC",
  BATCH_CLAIM_LINES_MAX_UNITS_DESC = "BATCH_CLAIM_LINES_MAX_UNITS_DESC",
  BATCH_CLAIM_LINES_MAX_UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINES_MAX_UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINES_MAX_UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINES_MAX_UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINES_MAX_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINES_MAX_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINES_MAX_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINES_MAX_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINES_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_LINES_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_LINES_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_LINES_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_LINES_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINES_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINES_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINES_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINES_MIN_CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_MIN_CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_MIN_CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_MIN_CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_MIN_CREATED_AT_ASC = "BATCH_CLAIM_LINES_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_LINES_MIN_CREATED_AT_DESC = "BATCH_CLAIM_LINES_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_LINES_MIN_DIAG_1_ASC = "BATCH_CLAIM_LINES_MIN_DIAG_1_ASC",
  BATCH_CLAIM_LINES_MIN_DIAG_1_DESC = "BATCH_CLAIM_LINES_MIN_DIAG_1_DESC",
  BATCH_CLAIM_LINES_MIN_DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MIN_DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MIN_DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MIN_DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MIN_DIAG_2_ASC = "BATCH_CLAIM_LINES_MIN_DIAG_2_ASC",
  BATCH_CLAIM_LINES_MIN_DIAG_2_DESC = "BATCH_CLAIM_LINES_MIN_DIAG_2_DESC",
  BATCH_CLAIM_LINES_MIN_DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MIN_DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MIN_DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MIN_DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MIN_DIAG_3_ASC = "BATCH_CLAIM_LINES_MIN_DIAG_3_ASC",
  BATCH_CLAIM_LINES_MIN_DIAG_3_DESC = "BATCH_CLAIM_LINES_MIN_DIAG_3_DESC",
  BATCH_CLAIM_LINES_MIN_DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MIN_DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MIN_DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MIN_DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MIN_DIAG_4_ASC = "BATCH_CLAIM_LINES_MIN_DIAG_4_ASC",
  BATCH_CLAIM_LINES_MIN_DIAG_4_DESC = "BATCH_CLAIM_LINES_MIN_DIAG_4_DESC",
  BATCH_CLAIM_LINES_MIN_DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MIN_DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MIN_DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MIN_DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MIN_ID_ASC = "BATCH_CLAIM_LINES_MIN_ID_ASC",
  BATCH_CLAIM_LINES_MIN_ID_DESC = "BATCH_CLAIM_LINES_MIN_ID_DESC",
  BATCH_CLAIM_LINES_MIN_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_MIN_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_MIN_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_MIN_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_MIN_NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINES_MIN_NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINES_MIN_NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINES_MIN_NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINES_MIN_NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINES_MIN_NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINES_MIN_NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINES_MIN_NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINES_MIN_PAYMENT_RATE_ASC = "BATCH_CLAIM_LINES_MIN_PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINES_MIN_PAYMENT_RATE_DESC = "BATCH_CLAIM_LINES_MIN_PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MIN_PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MIN_PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MIN_REV_CODE_ASC = "BATCH_CLAIM_LINES_MIN_REV_CODE_ASC",
  BATCH_CLAIM_LINES_MIN_REV_CODE_DESC = "BATCH_CLAIM_LINES_MIN_REV_CODE_DESC",
  BATCH_CLAIM_LINES_MIN_REV_CODE_SRC_ASC = "BATCH_CLAIM_LINES_MIN_REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINES_MIN_REV_CODE_SRC_DESC = "BATCH_CLAIM_LINES_MIN_REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINES_MIN_REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_MIN_REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_MIN_REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_MIN_REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_MIN_SERVICE_DATE_ASC = "BATCH_CLAIM_LINES_MIN_SERVICE_DATE_ASC",
  BATCH_CLAIM_LINES_MIN_SERVICE_DATE_DESC = "BATCH_CLAIM_LINES_MIN_SERVICE_DATE_DESC",
  BATCH_CLAIM_LINES_MIN_UNITS_ASC = "BATCH_CLAIM_LINES_MIN_UNITS_ASC",
  BATCH_CLAIM_LINES_MIN_UNITS_DESC = "BATCH_CLAIM_LINES_MIN_UNITS_DESC",
  BATCH_CLAIM_LINES_MIN_UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINES_MIN_UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINES_MIN_UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINES_MIN_UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINES_MIN_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINES_MIN_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINES_MIN_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINES_MIN_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINES_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_LINES_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_LINES_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_LINES_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_1_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_1_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_1_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_1_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_2_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_2_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_2_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_2_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_3_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_3_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_3_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_3_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_4_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_4_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_4_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_4_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PAYMENT_RATE_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PAYMENT_RATE_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_CODE_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_CODE_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_CODE_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_CODE_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_CODE_SRC_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_CODE_SRC_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_SERVICE_DATE_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_SERVICE_DATE_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_SERVICE_DATE_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_SERVICE_DATE_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_UNITS_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_UNITS_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_UNITS_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_UNITS_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINES_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINES_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_1_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_1_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_1_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_1_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_2_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_2_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_2_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_2_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_3_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_3_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_3_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_3_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_4_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_4_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_4_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_4_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PAYMENT_RATE_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PAYMENT_RATE_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_CODE_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_CODE_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_CODE_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_CODE_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_CODE_SRC_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_CODE_SRC_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_SERVICE_DATE_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_SERVICE_DATE_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_SERVICE_DATE_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_SERVICE_DATE_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNITS_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNITS_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNITS_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNITS_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINES_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINES_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINES_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINES_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINES_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINES_SUM_CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_SUM_CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_SUM_CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_SUM_CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_SUM_CREATED_AT_ASC = "BATCH_CLAIM_LINES_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_LINES_SUM_CREATED_AT_DESC = "BATCH_CLAIM_LINES_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_LINES_SUM_DIAG_1_ASC = "BATCH_CLAIM_LINES_SUM_DIAG_1_ASC",
  BATCH_CLAIM_LINES_SUM_DIAG_1_DESC = "BATCH_CLAIM_LINES_SUM_DIAG_1_DESC",
  BATCH_CLAIM_LINES_SUM_DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_SUM_DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_SUM_DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_SUM_DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_SUM_DIAG_2_ASC = "BATCH_CLAIM_LINES_SUM_DIAG_2_ASC",
  BATCH_CLAIM_LINES_SUM_DIAG_2_DESC = "BATCH_CLAIM_LINES_SUM_DIAG_2_DESC",
  BATCH_CLAIM_LINES_SUM_DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_SUM_DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_SUM_DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_SUM_DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_SUM_DIAG_3_ASC = "BATCH_CLAIM_LINES_SUM_DIAG_3_ASC",
  BATCH_CLAIM_LINES_SUM_DIAG_3_DESC = "BATCH_CLAIM_LINES_SUM_DIAG_3_DESC",
  BATCH_CLAIM_LINES_SUM_DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_SUM_DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_SUM_DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_SUM_DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_SUM_DIAG_4_ASC = "BATCH_CLAIM_LINES_SUM_DIAG_4_ASC",
  BATCH_CLAIM_LINES_SUM_DIAG_4_DESC = "BATCH_CLAIM_LINES_SUM_DIAG_4_DESC",
  BATCH_CLAIM_LINES_SUM_DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_SUM_DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_SUM_DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_SUM_DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_SUM_ID_ASC = "BATCH_CLAIM_LINES_SUM_ID_ASC",
  BATCH_CLAIM_LINES_SUM_ID_DESC = "BATCH_CLAIM_LINES_SUM_ID_DESC",
  BATCH_CLAIM_LINES_SUM_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_SUM_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_SUM_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_SUM_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_SUM_NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINES_SUM_NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINES_SUM_NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINES_SUM_NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINES_SUM_NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINES_SUM_NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINES_SUM_NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINES_SUM_NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINES_SUM_PAYMENT_RATE_ASC = "BATCH_CLAIM_LINES_SUM_PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINES_SUM_PAYMENT_RATE_DESC = "BATCH_CLAIM_LINES_SUM_PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_SUM_PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_SUM_PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_SUM_REV_CODE_ASC = "BATCH_CLAIM_LINES_SUM_REV_CODE_ASC",
  BATCH_CLAIM_LINES_SUM_REV_CODE_DESC = "BATCH_CLAIM_LINES_SUM_REV_CODE_DESC",
  BATCH_CLAIM_LINES_SUM_REV_CODE_SRC_ASC = "BATCH_CLAIM_LINES_SUM_REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINES_SUM_REV_CODE_SRC_DESC = "BATCH_CLAIM_LINES_SUM_REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINES_SUM_REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_SUM_REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_SUM_REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_SUM_REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_SUM_SERVICE_DATE_ASC = "BATCH_CLAIM_LINES_SUM_SERVICE_DATE_ASC",
  BATCH_CLAIM_LINES_SUM_SERVICE_DATE_DESC = "BATCH_CLAIM_LINES_SUM_SERVICE_DATE_DESC",
  BATCH_CLAIM_LINES_SUM_UNITS_ASC = "BATCH_CLAIM_LINES_SUM_UNITS_ASC",
  BATCH_CLAIM_LINES_SUM_UNITS_DESC = "BATCH_CLAIM_LINES_SUM_UNITS_DESC",
  BATCH_CLAIM_LINES_SUM_UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINES_SUM_UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINES_SUM_UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINES_SUM_UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINES_SUM_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINES_SUM_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINES_SUM_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINES_SUM_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINES_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_LINES_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_LINES_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_LINES_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_1_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_1_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_1_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_1_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_2_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_2_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_2_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_2_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_3_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_3_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_3_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_3_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_4_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_4_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_4_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_4_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PAYMENT_RATE_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PAYMENT_RATE_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_CODE_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_CODE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_CODE_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_CODE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_CODE_SRC_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_CODE_SRC_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_SERVICE_DATE_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_SERVICE_DATE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_SERVICE_DATE_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_SERVICE_DATE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNITS_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNITS_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNITS_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNITS_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINES_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_CLIENT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_CLIENT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_CLIENT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_CLIENT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_1_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_1_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_1_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_1_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_1_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_1_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_1_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_1_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_2_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_2_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_2_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_2_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_2_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_2_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_2_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_2_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_3_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_3_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_3_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_3_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_3_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_3_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_3_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_3_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_4_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_4_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_4_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_4_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_4_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_4_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_4_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_DIAG_4_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_LINE_NUMBER_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_LINE_NUMBER_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_NON_COVERED_AMOUNT_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_NON_COVERED_AMOUNT_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_NON_COVERED_AMOUNT_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_NON_COVERED_AMOUNT_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_NON_COV_CHARGE_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_NON_COV_CHARGE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_NON_COV_CHARGE_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_NON_COV_CHARGE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PAYMENT_RATE_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PAYMENT_RATE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PAYMENT_RATE_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PAYMENT_RATE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_1_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_1_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_1_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_1_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_2_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_2_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_2_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_2_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_3_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_3_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_3_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_3_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_4_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_4_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_4_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_4_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_PROCEDURE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_CODE_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_CODE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_CODE_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_CODE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_CODE_SRC_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_CODE_SRC_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_CODE_SRC_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_CODE_SRC_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_DESCRIPTION_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_DESCRIPTION_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_DESCRIPTION_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_REV_DESCRIPTION_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_SERVICE_DATE_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_SERVICE_DATE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_SERVICE_DATE_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_SERVICE_DATE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNITS_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNITS_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNITS_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNITS_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNIT_ALLOWABLE_CHARGE_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNIT_ALLOWABLE_CHARGE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNIT_ALLOWABLE_CHARGE_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNIT_ALLOWABLE_CHARGE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_AVERAGE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_BY_BATCH_CLAIM_ID__COUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_BY_BATCH_CLAIM_ID__COUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_BY_BATCH_CLAIM_ID__COUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_BY_BATCH_CLAIM_ID__COUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_COUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_COUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_COUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_COUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_DISTINCT_COUNT_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_MAX_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_MIN_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_POPULATION_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_STDDEV_SAMPLE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_SUM_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_POPULATION_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ALA_ROW_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_DESCRIPTION_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_IB_LINE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ITEM_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_LINE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_BILLED_AMOUNT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PAGE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_PROCEDURE_CODE_MODIFIER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_REV_CODE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_S3_INPUT_SOURCE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_TABLE_NUMBER_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNITS_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UNIT_CHARGE_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_ASC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_ASC",
  BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_DESC = "BATCH_CLAIM_LINE_ITEMS_VARIANCE_SAMPLE_VERSION_FINGERPRINT_DESC",
  BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__PAY_DENY_ASC = "BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__PAY_DENY_ASC",
  BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__PAY_DENY_DESC = "BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__PAY_DENY_DESC",
  BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_PAY_DENY_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_ROLE_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_ROLE_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_ROLE_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_ROLE_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_USER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_USER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_USER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENTS_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_USER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_COUNT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_BY_BATCH_CLAIM_ID_AND_INSURER_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_STATE_BY_ID__APPEALED_ASC = "BATCH_CLAIM_STATE_BY_ID__APPEALED_ASC",
  BATCH_CLAIM_STATE_BY_ID__APPEALED_DESC = "BATCH_CLAIM_STATE_BY_ID__APPEALED_DESC",
  BATCH_CLAIM_STATE_BY_ID__AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATE_BY_ID__AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATE_BY_ID__AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATE_BY_ID__AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATE_BY_ID__AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATE_BY_ID__AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATE_BY_ID__AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATE_BY_ID__CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATE_BY_ID__CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATE_BY_ID__CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATE_BY_ID__CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATE_BY_ID__CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATE_BY_ID__CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATE_BY_ID__CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATE_BY_ID__CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATE_BY_ID__CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATE_BY_ID__CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATE_BY_ID__CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATE_BY_ID__CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATE_BY_ID__CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATE_BY_ID__CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATE_BY_ID__CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATE_BY_ID__CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATE_BY_ID__CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATE_BY_ID__CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATE_BY_ID__CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATE_BY_ID__CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATE_BY_ID__CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATE_BY_ID__CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATE_BY_ID__CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATE_BY_ID__CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATE_BY_ID__CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATE_BY_ID__CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATE_BY_ID__DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATE_BY_ID__DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATE_BY_ID__DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATE_BY_ID__DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATE_BY_ID__DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATE_BY_ID__DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATE_BY_ID__DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATE_BY_ID__DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATE_BY_ID__DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATE_BY_ID__DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATE_BY_ID__DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATE_BY_ID__DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATE_BY_ID__DUE_DATE_ASC = "BATCH_CLAIM_STATE_BY_ID__DUE_DATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__DUE_DATE_DESC = "BATCH_CLAIM_STATE_BY_ID__DUE_DATE_DESC",
  BATCH_CLAIM_STATE_BY_ID__ID_ASC = "BATCH_CLAIM_STATE_BY_ID__ID_ASC",
  BATCH_CLAIM_STATE_BY_ID__ID_DESC = "BATCH_CLAIM_STATE_BY_ID__ID_DESC",
  BATCH_CLAIM_STATE_BY_ID__INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATE_BY_ID__INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATE_BY_ID__INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATE_BY_ID__IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATE_BY_ID__IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATE_BY_ID__IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATE_BY_ID__IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATE_BY_ID__IS_REALIZED_ASC = "BATCH_CLAIM_STATE_BY_ID__IS_REALIZED_ASC",
  BATCH_CLAIM_STATE_BY_ID__IS_REALIZED_DESC = "BATCH_CLAIM_STATE_BY_ID__IS_REALIZED_DESC",
  BATCH_CLAIM_STATE_BY_ID__NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATE_BY_ID__NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATE_BY_ID__NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATE_BY_ID__ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATE_BY_ID__ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATE_BY_ID__ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATE_BY_ID__PAY_DENY_ASC = "BATCH_CLAIM_STATE_BY_ID__PAY_DENY_ASC",
  BATCH_CLAIM_STATE_BY_ID__PAY_DENY_DESC = "BATCH_CLAIM_STATE_BY_ID__PAY_DENY_DESC",
  BATCH_CLAIM_STATE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATE_BY_ID__POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATE_BY_ID__POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATE_BY_ID__POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATE_BY_ID__POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATE_BY_ID__POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATE_BY_ID__POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATE_BY_ID__PRIMARY_AUDITOR_NAME_ASC = "BATCH_CLAIM_STATE_BY_ID__PRIMARY_AUDITOR_NAME_ASC",
  BATCH_CLAIM_STATE_BY_ID__PRIMARY_AUDITOR_NAME_DESC = "BATCH_CLAIM_STATE_BY_ID__PRIMARY_AUDITOR_NAME_DESC",
  BATCH_CLAIM_STATE_BY_ID__PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATE_BY_ID__PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATE_BY_ID__PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATE_BY_ID__QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATE_BY_ID__QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATE_BY_ID__QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATE_BY_ID__REPORTED_ASC = "BATCH_CLAIM_STATE_BY_ID__REPORTED_ASC",
  BATCH_CLAIM_STATE_BY_ID__REPORTED_DESC = "BATCH_CLAIM_STATE_BY_ID__REPORTED_DESC",
  BATCH_CLAIM_STATE_BY_ID__TECH_DENIED_ASC = "BATCH_CLAIM_STATE_BY_ID__TECH_DENIED_ASC",
  BATCH_CLAIM_STATE_BY_ID__TECH_DENIED_DESC = "BATCH_CLAIM_STATE_BY_ID__TECH_DENIED_DESC",
  BATCH_CLAIM_STATE_BY_ID__WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATE_BY_ID__WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATE_BY_ID__WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATE_BY_ID__WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__CREATED_BY_ASC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__CREATED_BY_ASC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__CREATED_BY_DESC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__CREATED_BY_DESC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__TECH_DENIED_ASC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__TECH_DENIED_ASC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__TECH_DENIED_DESC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__TECH_DENIED_DESC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_TECH_DENIAL_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_VALID_UPLOADED_AUDIT_DOCUMENTATION_COUNT_ASC = "BATCH_CLAIM_VALID_UPLOADED_AUDIT_DOCUMENTATION_COUNT_ASC",
  BATCH_CLAIM_VALID_UPLOADED_AUDIT_DOCUMENTATION_COUNT_DESC = "BATCH_CLAIM_VALID_UPLOADED_AUDIT_DOCUMENTATION_COUNT_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__AUTHOR_ID_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__AUTHOR_ID_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__AUTHOR_ID_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__AUTHOR_ID_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_NAME_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_NAME_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_NAME_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_NAME_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_URL_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_URL_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_URL_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_FILE_URL_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_NAME_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_NAME_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__BATCH_NAME_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__BATCH_NAME_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__CREATED_AT_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__CREATED_AT_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__CREATED_AT_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__CREATED_AT_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__ID_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__ID_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__ID_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__ID_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__INSURER_ID_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__INSURER_ID_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__INSURER_ID_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__INSURER_ID_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__OWNER_ID_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__OWNER_ID_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__OWNER_ID_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__OWNER_ID_DESC",
  BATCH_FILE_BY_BATCH_FILE_ID__UPDATED_AT_ASC = "BATCH_FILE_BY_BATCH_FILE_ID__UPDATED_AT_ASC",
  BATCH_FILE_BY_BATCH_FILE_ID__UPDATED_AT_DESC = "BATCH_FILE_BY_BATCH_FILE_ID__UPDATED_AT_DESC",
  BATCH_FILE_ID_ASC = "BATCH_FILE_ID_ASC",
  BATCH_FILE_ID_DESC = "BATCH_FILE_ID_DESC",
  BILL_TYPE_ASC = "BILL_TYPE_ASC",
  BILL_TYPE_DESC = "BILL_TYPE_DESC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__AUDITOR_BUCKET_ID_ASC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__AUDITOR_BUCKET_ID_ASC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__AUDITOR_BUCKET_ID_DESC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__AUDITOR_BUCKET_ID_DESC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__SELECTION_METHOD_ASC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__SELECTION_METHOD_ASC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__SELECTION_METHOD_DESC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__SELECTION_METHOD_DESC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__STATUS_ASC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__STATUS_ASC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__STATUS_DESC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__STATUS_DESC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BUCKET_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BUCKET_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_AUTHOR_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_AUTHOR_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CASE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CASE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CASE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CASE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CLAIM_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CLAIM_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CLAIM_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CLAIM_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CREATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CREATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CREATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_CREATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_UPDATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_UPDATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_UPDATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_UPDATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_UPDATED_BY_ASC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_UPDATED_BY_ASC",
  CLAIM_CASES_BY_CLAIM_ID_AVERAGE_UPDATED_BY_DESC = "CLAIM_CASES_BY_CLAIM_ID_AVERAGE_UPDATED_BY_DESC",
  CLAIM_CASES_BY_CLAIM_ID_COUNT_ASC = "CLAIM_CASES_BY_CLAIM_ID_COUNT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_COUNT_DESC = "CLAIM_CASES_BY_CLAIM_ID_COUNT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_AUTHOR_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_AUTHOR_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CASE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CASE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CASE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CASE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CLAIM_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CLAIM_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CLAIM_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CLAIM_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_UPDATED_BY_ASC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_UPDATED_BY_ASC",
  CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_UPDATED_BY_DESC = "CLAIM_CASES_BY_CLAIM_ID_DISTINCT_COUNT_UPDATED_BY_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_AUTHOR_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_MAX_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_AUTHOR_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_MAX_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_CASE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_MAX_CASE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_CASE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_MAX_CASE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_CLAIM_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_MAX_CLAIM_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_CLAIM_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_MAX_CLAIM_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_CREATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_MAX_CREATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_CREATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_MAX_CREATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_MAX_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_MAX_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_UPDATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_MAX_UPDATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_UPDATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_MAX_UPDATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_UPDATED_BY_ASC = "CLAIM_CASES_BY_CLAIM_ID_MAX_UPDATED_BY_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MAX_UPDATED_BY_DESC = "CLAIM_CASES_BY_CLAIM_ID_MAX_UPDATED_BY_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_AUTHOR_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_MIN_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_AUTHOR_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_MIN_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_CASE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_MIN_CASE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_CASE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_MIN_CASE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_CLAIM_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_MIN_CLAIM_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_CLAIM_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_MIN_CLAIM_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_CREATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_MIN_CREATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_CREATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_MIN_CREATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_MIN_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_MIN_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_UPDATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_MIN_UPDATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_UPDATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_MIN_UPDATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_UPDATED_BY_ASC = "CLAIM_CASES_BY_CLAIM_ID_MIN_UPDATED_BY_ASC",
  CLAIM_CASES_BY_CLAIM_ID_MIN_UPDATED_BY_DESC = "CLAIM_CASES_BY_CLAIM_ID_MIN_UPDATED_BY_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_AUTHOR_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_AUTHOR_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CASE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CASE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CASE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CASE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CLAIM_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CLAIM_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CLAIM_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CLAIM_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_UPDATED_BY_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_UPDATED_BY_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_UPDATED_BY_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_POPULATION_UPDATED_BY_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CASE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CASE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CASE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CASE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CLAIM_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CLAIM_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CLAIM_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CLAIM_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_UPDATED_BY_ASC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_UPDATED_BY_ASC",
  CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_UPDATED_BY_DESC = "CLAIM_CASES_BY_CLAIM_ID_STDDEV_SAMPLE_UPDATED_BY_DESC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_AUTHOR_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_SUM_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_AUTHOR_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_SUM_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_CASE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_SUM_CASE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_CASE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_SUM_CASE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_CLAIM_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_SUM_CLAIM_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_CLAIM_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_SUM_CLAIM_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_CREATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_SUM_CREATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_CREATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_SUM_CREATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_SUM_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_SUM_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_UPDATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_SUM_UPDATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_UPDATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_SUM_UPDATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_UPDATED_BY_ASC = "CLAIM_CASES_BY_CLAIM_ID_SUM_UPDATED_BY_ASC",
  CLAIM_CASES_BY_CLAIM_ID_SUM_UPDATED_BY_DESC = "CLAIM_CASES_BY_CLAIM_ID_SUM_UPDATED_BY_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CASE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CASE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CASE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CASE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CLAIM_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CLAIM_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CLAIM_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CLAIM_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_UPDATED_BY_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_UPDATED_BY_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_UPDATED_BY_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_POPULATION_UPDATED_BY_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CASE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CASE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CASE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CASE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CLAIM_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CLAIM_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CLAIM_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CLAIM_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_ID_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_ID_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_UPDATED_BY_ASC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_UPDATED_BY_ASC",
  CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_UPDATED_BY_DESC = "CLAIM_CASES_BY_CLAIM_ID_VARIANCE_SAMPLE_UPDATED_BY_DESC",
  CLAIM_FACET_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC = "CLAIM_FACET_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC = "CLAIM_FACET_BY_BATCH_CLAIM_ID__BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "CLAIM_FACET_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  CLAIM_FACET_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "CLAIM_FACET_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  CLAIM_FACET_BY_BATCH_CLAIM_ID__FACETS_ASC = "CLAIM_FACET_BY_BATCH_CLAIM_ID__FACETS_ASC",
  CLAIM_FACET_BY_BATCH_CLAIM_ID__FACETS_DESC = "CLAIM_FACET_BY_BATCH_CLAIM_ID__FACETS_DESC",
  CLAIM_FACET_BY_BATCH_CLAIM_ID__ID_ASC = "CLAIM_FACET_BY_BATCH_CLAIM_ID__ID_ASC",
  CLAIM_FACET_BY_BATCH_CLAIM_ID__ID_DESC = "CLAIM_FACET_BY_BATCH_CLAIM_ID__ID_DESC",
  CLAIM_FACET_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "CLAIM_FACET_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  CLAIM_FACET_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "CLAIM_FACET_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  CLAIM_FACET_HISTORIES_AVERAGE_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_AVERAGE_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_AVERAGE_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_AVERAGE_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_AVERAGE_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_AVERAGE_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_AVERAGE_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_AVERAGE_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_AVERAGE_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_AVERAGE_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_AVERAGE_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_AVERAGE_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_AVERAGE_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_AVERAGE_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_AVERAGE_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_AVERAGE_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_AVERAGE_ID_ASC = "CLAIM_FACET_HISTORIES_AVERAGE_ID_ASC",
  CLAIM_FACET_HISTORIES_AVERAGE_ID_DESC = "CLAIM_FACET_HISTORIES_AVERAGE_ID_DESC",
  CLAIM_FACET_HISTORIES_AVERAGE_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_AVERAGE_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_AVERAGE_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_AVERAGE_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_AVERAGE_PATH_ASC = "CLAIM_FACET_HISTORIES_AVERAGE_PATH_ASC",
  CLAIM_FACET_HISTORIES_AVERAGE_PATH_DESC = "CLAIM_FACET_HISTORIES_AVERAGE_PATH_DESC",
  CLAIM_FACET_HISTORIES_AVERAGE_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_AVERAGE_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_AVERAGE_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_AVERAGE_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_AVERAGE_VALUE_ASC = "CLAIM_FACET_HISTORIES_AVERAGE_VALUE_ASC",
  CLAIM_FACET_HISTORIES_AVERAGE_VALUE_DESC = "CLAIM_FACET_HISTORIES_AVERAGE_VALUE_DESC",
  CLAIM_FACET_HISTORIES_BY_BATCH_CLAIM_ID__COUNT_ASC = "CLAIM_FACET_HISTORIES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  CLAIM_FACET_HISTORIES_BY_BATCH_CLAIM_ID__COUNT_DESC = "CLAIM_FACET_HISTORIES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  CLAIM_FACET_HISTORIES_COUNT_ASC = "CLAIM_FACET_HISTORIES_COUNT_ASC",
  CLAIM_FACET_HISTORIES_COUNT_DESC = "CLAIM_FACET_HISTORIES_COUNT_DESC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_ID_ASC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_ID_ASC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_ID_DESC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_ID_DESC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_PATH_ASC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_PATH_ASC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_PATH_DESC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_PATH_DESC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_VALUE_ASC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_VALUE_ASC",
  CLAIM_FACET_HISTORIES_DISTINCT_COUNT_VALUE_DESC = "CLAIM_FACET_HISTORIES_DISTINCT_COUNT_VALUE_DESC",
  CLAIM_FACET_HISTORIES_MAX_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_MAX_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_MAX_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_MAX_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_MAX_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_MAX_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_MAX_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_MAX_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_MAX_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_MAX_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_MAX_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_MAX_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_MAX_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_MAX_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_MAX_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_MAX_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_MAX_ID_ASC = "CLAIM_FACET_HISTORIES_MAX_ID_ASC",
  CLAIM_FACET_HISTORIES_MAX_ID_DESC = "CLAIM_FACET_HISTORIES_MAX_ID_DESC",
  CLAIM_FACET_HISTORIES_MAX_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_MAX_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_MAX_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_MAX_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_MAX_PATH_ASC = "CLAIM_FACET_HISTORIES_MAX_PATH_ASC",
  CLAIM_FACET_HISTORIES_MAX_PATH_DESC = "CLAIM_FACET_HISTORIES_MAX_PATH_DESC",
  CLAIM_FACET_HISTORIES_MAX_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_MAX_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_MAX_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_MAX_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_MAX_VALUE_ASC = "CLAIM_FACET_HISTORIES_MAX_VALUE_ASC",
  CLAIM_FACET_HISTORIES_MAX_VALUE_DESC = "CLAIM_FACET_HISTORIES_MAX_VALUE_DESC",
  CLAIM_FACET_HISTORIES_MIN_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_MIN_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_MIN_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_MIN_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_MIN_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_MIN_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_MIN_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_MIN_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_MIN_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_MIN_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_MIN_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_MIN_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_MIN_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_MIN_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_MIN_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_MIN_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_MIN_ID_ASC = "CLAIM_FACET_HISTORIES_MIN_ID_ASC",
  CLAIM_FACET_HISTORIES_MIN_ID_DESC = "CLAIM_FACET_HISTORIES_MIN_ID_DESC",
  CLAIM_FACET_HISTORIES_MIN_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_MIN_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_MIN_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_MIN_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_MIN_PATH_ASC = "CLAIM_FACET_HISTORIES_MIN_PATH_ASC",
  CLAIM_FACET_HISTORIES_MIN_PATH_DESC = "CLAIM_FACET_HISTORIES_MIN_PATH_DESC",
  CLAIM_FACET_HISTORIES_MIN_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_MIN_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_MIN_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_MIN_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_MIN_VALUE_ASC = "CLAIM_FACET_HISTORIES_MIN_VALUE_ASC",
  CLAIM_FACET_HISTORIES_MIN_VALUE_DESC = "CLAIM_FACET_HISTORIES_MIN_VALUE_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_ID_ASC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_ID_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_ID_DESC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_ID_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_PATH_ASC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_PATH_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_PATH_DESC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_PATH_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_VALUE_ASC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_VALUE_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_POPULATION_VALUE_DESC = "CLAIM_FACET_HISTORIES_STDDEV_POPULATION_VALUE_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_ID_ASC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_ID_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_ID_DESC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_ID_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_PATH_ASC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_PATH_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_PATH_DESC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_PATH_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_VALUE_ASC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_VALUE_ASC",
  CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_VALUE_DESC = "CLAIM_FACET_HISTORIES_STDDEV_SAMPLE_VALUE_DESC",
  CLAIM_FACET_HISTORIES_SUM_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_SUM_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_SUM_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_SUM_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_SUM_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_SUM_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_SUM_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_SUM_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_SUM_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_SUM_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_SUM_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_SUM_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_SUM_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_SUM_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_SUM_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_SUM_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_SUM_ID_ASC = "CLAIM_FACET_HISTORIES_SUM_ID_ASC",
  CLAIM_FACET_HISTORIES_SUM_ID_DESC = "CLAIM_FACET_HISTORIES_SUM_ID_DESC",
  CLAIM_FACET_HISTORIES_SUM_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_SUM_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_SUM_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_SUM_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_SUM_PATH_ASC = "CLAIM_FACET_HISTORIES_SUM_PATH_ASC",
  CLAIM_FACET_HISTORIES_SUM_PATH_DESC = "CLAIM_FACET_HISTORIES_SUM_PATH_DESC",
  CLAIM_FACET_HISTORIES_SUM_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_SUM_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_SUM_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_SUM_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_SUM_VALUE_ASC = "CLAIM_FACET_HISTORIES_SUM_VALUE_ASC",
  CLAIM_FACET_HISTORIES_SUM_VALUE_DESC = "CLAIM_FACET_HISTORIES_SUM_VALUE_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_ID_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_ID_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_ID_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_ID_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_PATH_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_PATH_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_PATH_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_PATH_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_VALUE_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_VALUE_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_VALUE_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_POPULATION_VALUE_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_APPLIED_AT_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_APPLIED_AT_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_APPLIED_AT_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_APPLIED_AT_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_APPLIED_BY_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_APPLIED_BY_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_APPLIED_BY_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_APPLIED_BY_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_CONTEXT_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_CONTEXT_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_CONTEXT_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_CONTEXT_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_ID_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_ID_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_OPERATION_TYPE_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_OPERATION_TYPE_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_OPERATION_TYPE_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_OPERATION_TYPE_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_PATH_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_PATH_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_PATH_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_PATH_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_PREVIOUS_VALUE_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_PREVIOUS_VALUE_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_PREVIOUS_VALUE_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_PREVIOUS_VALUE_DESC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_VALUE_ASC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_VALUE_ASC",
  CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_VALUE_DESC = "CLAIM_FACET_HISTORIES_VARIANCE_SAMPLE_VALUE_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_AVERAGE_BATCH_CLAIM_ID_ASC = "CLAIM_POLICY_DOCUMENTS_AVERAGE_BATCH_CLAIM_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_AVERAGE_BATCH_CLAIM_ID_DESC = "CLAIM_POLICY_DOCUMENTS_AVERAGE_BATCH_CLAIM_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_AVERAGE_CREATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_AVERAGE_CREATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_AVERAGE_CREATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_AVERAGE_CREATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_AVERAGE_DOCUMENT_ID_ASC = "CLAIM_POLICY_DOCUMENTS_AVERAGE_DOCUMENT_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_AVERAGE_DOCUMENT_ID_DESC = "CLAIM_POLICY_DOCUMENTS_AVERAGE_DOCUMENT_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_AVERAGE_ID_ASC = "CLAIM_POLICY_DOCUMENTS_AVERAGE_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_AVERAGE_ID_DESC = "CLAIM_POLICY_DOCUMENTS_AVERAGE_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_AVERAGE_UPDATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_AVERAGE_UPDATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_AVERAGE_UPDATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_AVERAGE_UPDATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_BY_BATCH_CLAIM_ID__COUNT_ASC = "CLAIM_POLICY_DOCUMENTS_BY_BATCH_CLAIM_ID__COUNT_ASC",
  CLAIM_POLICY_DOCUMENTS_BY_BATCH_CLAIM_ID__COUNT_DESC = "CLAIM_POLICY_DOCUMENTS_BY_BATCH_CLAIM_ID__COUNT_DESC",
  CLAIM_POLICY_DOCUMENTS_COUNT_ASC = "CLAIM_POLICY_DOCUMENTS_COUNT_ASC",
  CLAIM_POLICY_DOCUMENTS_COUNT_DESC = "CLAIM_POLICY_DOCUMENTS_COUNT_DESC",
  CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_DOCUMENT_ID_ASC = "CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_DOCUMENT_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_DOCUMENT_ID_DESC = "CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_DOCUMENT_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_ID_ASC = "CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_ID_DESC = "CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_UPDATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_UPDATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_UPDATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_DISTINCT_COUNT_UPDATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_MAX_BATCH_CLAIM_ID_ASC = "CLAIM_POLICY_DOCUMENTS_MAX_BATCH_CLAIM_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_MAX_BATCH_CLAIM_ID_DESC = "CLAIM_POLICY_DOCUMENTS_MAX_BATCH_CLAIM_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_MAX_CREATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_MAX_CREATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_MAX_CREATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_MAX_CREATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_MAX_DOCUMENT_ID_ASC = "CLAIM_POLICY_DOCUMENTS_MAX_DOCUMENT_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_MAX_DOCUMENT_ID_DESC = "CLAIM_POLICY_DOCUMENTS_MAX_DOCUMENT_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_MAX_ID_ASC = "CLAIM_POLICY_DOCUMENTS_MAX_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_MAX_ID_DESC = "CLAIM_POLICY_DOCUMENTS_MAX_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_MAX_UPDATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_MAX_UPDATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_MAX_UPDATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_MAX_UPDATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_MIN_BATCH_CLAIM_ID_ASC = "CLAIM_POLICY_DOCUMENTS_MIN_BATCH_CLAIM_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_MIN_BATCH_CLAIM_ID_DESC = "CLAIM_POLICY_DOCUMENTS_MIN_BATCH_CLAIM_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_MIN_CREATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_MIN_CREATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_MIN_CREATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_MIN_CREATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_MIN_DOCUMENT_ID_ASC = "CLAIM_POLICY_DOCUMENTS_MIN_DOCUMENT_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_MIN_DOCUMENT_ID_DESC = "CLAIM_POLICY_DOCUMENTS_MIN_DOCUMENT_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_MIN_ID_ASC = "CLAIM_POLICY_DOCUMENTS_MIN_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_MIN_ID_DESC = "CLAIM_POLICY_DOCUMENTS_MIN_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_MIN_UPDATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_MIN_UPDATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_MIN_UPDATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_MIN_UPDATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_DOCUMENT_ID_ASC = "CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_DOCUMENT_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_DOCUMENT_ID_DESC = "CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_DOCUMENT_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_ID_ASC = "CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_ID_DESC = "CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_UPDATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_UPDATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_UPDATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_STDDEV_POPULATION_UPDATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_DOCUMENT_ID_ASC = "CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_DOCUMENT_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_DOCUMENT_ID_DESC = "CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_DOCUMENT_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_ID_ASC = "CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_ID_DESC = "CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_UPDATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_UPDATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_SUM_BATCH_CLAIM_ID_ASC = "CLAIM_POLICY_DOCUMENTS_SUM_BATCH_CLAIM_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_SUM_BATCH_CLAIM_ID_DESC = "CLAIM_POLICY_DOCUMENTS_SUM_BATCH_CLAIM_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_SUM_CREATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_SUM_CREATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_SUM_CREATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_SUM_CREATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_SUM_DOCUMENT_ID_ASC = "CLAIM_POLICY_DOCUMENTS_SUM_DOCUMENT_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_SUM_DOCUMENT_ID_DESC = "CLAIM_POLICY_DOCUMENTS_SUM_DOCUMENT_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_SUM_ID_ASC = "CLAIM_POLICY_DOCUMENTS_SUM_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_SUM_ID_DESC = "CLAIM_POLICY_DOCUMENTS_SUM_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_SUM_UPDATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_SUM_UPDATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_SUM_UPDATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_SUM_UPDATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_DOCUMENT_ID_ASC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_DOCUMENT_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_DOCUMENT_ID_DESC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_DOCUMENT_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_ID_ASC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_ID_DESC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_UPDATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_UPDATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_DOCUMENT_ID_ASC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_DOCUMENT_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_DOCUMENT_ID_DESC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_DOCUMENT_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_ID_ASC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_ID_DESC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "CLAIM_POLICY_DOCUMENTS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  CLAIM_TYPE_ASC = "CLAIM_TYPE_ASC",
  CLAIM_TYPE_DESC = "CLAIM_TYPE_DESC",
  CLIENT_GROUP_NAME_ASC = "CLIENT_GROUP_NAME_ASC",
  CLIENT_GROUP_NAME_DESC = "CLIENT_GROUP_NAME_DESC",
  CLIENT_ICN_ASC = "CLIENT_ICN_ASC",
  CLIENT_ICN_DESC = "CLIENT_ICN_DESC",
  CLIENT_LINE_OF_BUSINESS_ASC = "CLIENT_LINE_OF_BUSINESS_ASC",
  CLIENT_LINE_OF_BUSINESS_DESC = "CLIENT_LINE_OF_BUSINESS_DESC",
  CLIENT_PLAN_ID_ASC = "CLIENT_PLAN_ID_ASC",
  CLIENT_PLAN_ID_DESC = "CLIENT_PLAN_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_STATE_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_STATE_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_STATE_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_STATE_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_CREATED_AT_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_CREATED_AT_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_CREATED_AT_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_CREATED_AT_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_AVERAGE_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_COUNT_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_COUNT_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_COUNT_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_COUNT_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_STATE_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_STATE_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_STATE_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_STATE_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_STATE_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_STATE_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_STATE_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_STATE_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MAX_CREATED_AT_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_MAX_CREATED_AT_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MAX_CREATED_AT_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_MAX_CREATED_AT_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MAX_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_MAX_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MAX_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_MAX_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_STATE_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_STATE_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_STATE_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_STATE_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MIN_CREATED_AT_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_MIN_CREATED_AT_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MIN_CREATED_AT_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_MIN_CREATED_AT_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MIN_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_MIN_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_MIN_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_MIN_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_STATE_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_STATE_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_STATE_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_STATE_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_STATE_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_STATE_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_STATE_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_STATE_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_STATE_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_STATE_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_STATE_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_STATE_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_SUM_CREATED_AT_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_SUM_CREATED_AT_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_SUM_CREATED_AT_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_SUM_CREATED_AT_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_SUM_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_SUM_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_SUM_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_SUM_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_STATE_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_STATE_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_STATE_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_STATE_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_STATE_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_STATE_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_STATE_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_STATE_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC",
  CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC = "CLIENT_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC",
  COMPUTATION_STRATEGY_ASC = "COMPUTATION_STRATEGY_ASC",
  COMPUTATION_STRATEGY_DESC = "COMPUTATION_STRATEGY_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DATE_ADMIT_ASC = "DATE_ADMIT_ASC",
  DATE_ADMIT_DESC = "DATE_ADMIT_DESC",
  DATE_DISCHARGE_ASC = "DATE_DISCHARGE_ASC",
  DATE_DISCHARGE_DESC = "DATE_DISCHARGE_DESC",
  DATE_OF_SERVICE_END_ASC = "DATE_OF_SERVICE_END_ASC",
  DATE_OF_SERVICE_END_DESC = "DATE_OF_SERVICE_END_DESC",
  DATE_OF_SERVICE_START_ASC = "DATE_OF_SERVICE_START_ASC",
  DATE_OF_SERVICE_START_DESC = "DATE_OF_SERVICE_START_DESC",
  DIAG_1_ASC = "DIAG_1_ASC",
  DIAG_1_DESC = "DIAG_1_DESC",
  DIAG_2_ASC = "DIAG_2_ASC",
  DIAG_2_DESC = "DIAG_2_DESC",
  DIAG_3_ASC = "DIAG_3_ASC",
  DIAG_3_DESC = "DIAG_3_DESC",
  DIAG_4_ASC = "DIAG_4_ASC",
  DIAG_4_DESC = "DIAG_4_DESC",
  DIAG_5_ASC = "DIAG_5_ASC",
  DIAG_5_DESC = "DIAG_5_DESC",
  DIAG_6_ASC = "DIAG_6_ASC",
  DIAG_6_DESC = "DIAG_6_DESC",
  DIAG_7_ASC = "DIAG_7_ASC",
  DIAG_7_DESC = "DIAG_7_DESC",
  DIAG_8_ASC = "DIAG_8_ASC",
  DIAG_8_DESC = "DIAG_8_DESC",
  DIAG_9_ASC = "DIAG_9_ASC",
  DIAG_9_DESC = "DIAG_9_DESC",
  DIAG_10_ASC = "DIAG_10_ASC",
  DIAG_10_DESC = "DIAG_10_DESC",
  DIAG_11_ASC = "DIAG_11_ASC",
  DIAG_11_DESC = "DIAG_11_DESC",
  DIAG_12_ASC = "DIAG_12_ASC",
  DIAG_12_DESC = "DIAG_12_DESC",
  DIAG_13_ASC = "DIAG_13_ASC",
  DIAG_13_DESC = "DIAG_13_DESC",
  DIAG_14_ASC = "DIAG_14_ASC",
  DIAG_14_DESC = "DIAG_14_DESC",
  DIAG_15_ASC = "DIAG_15_ASC",
  DIAG_15_DESC = "DIAG_15_DESC",
  DIAG_16_ASC = "DIAG_16_ASC",
  DIAG_16_DESC = "DIAG_16_DESC",
  DIAG_17_ASC = "DIAG_17_ASC",
  DIAG_17_DESC = "DIAG_17_DESC",
  DIAG_18_ASC = "DIAG_18_ASC",
  DIAG_18_DESC = "DIAG_18_DESC",
  DIAG_19_ASC = "DIAG_19_ASC",
  DIAG_19_DESC = "DIAG_19_DESC",
  DIAG_20_ASC = "DIAG_20_ASC",
  DIAG_20_DESC = "DIAG_20_DESC",
  DIAG_21_ASC = "DIAG_21_ASC",
  DIAG_21_DESC = "DIAG_21_DESC",
  DIAG_22_ASC = "DIAG_22_ASC",
  DIAG_22_DESC = "DIAG_22_DESC",
  DIAG_23_ASC = "DIAG_23_ASC",
  DIAG_23_DESC = "DIAG_23_DESC",
  DIAG_24_ASC = "DIAG_24_ASC",
  DIAG_24_DESC = "DIAG_24_DESC",
  DISCHARGE_STATUS_ASC = "DISCHARGE_STATUS_ASC",
  DISCHARGE_STATUS_DESC = "DISCHARGE_STATUS_DESC",
  DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_AVERAGE_CREATED_AT_ASC = "DISPUTED_FINDINGS_AVERAGE_CREATED_AT_ASC",
  DISPUTED_FINDINGS_AVERAGE_CREATED_AT_DESC = "DISPUTED_FINDINGS_AVERAGE_CREATED_AT_DESC",
  DISPUTED_FINDINGS_AVERAGE_DELETED_ASC = "DISPUTED_FINDINGS_AVERAGE_DELETED_ASC",
  DISPUTED_FINDINGS_AVERAGE_DELETED_DESC = "DISPUTED_FINDINGS_AVERAGE_DELETED_DESC",
  DISPUTED_FINDINGS_AVERAGE_ID_ASC = "DISPUTED_FINDINGS_AVERAGE_ID_ASC",
  DISPUTED_FINDINGS_AVERAGE_ID_DESC = "DISPUTED_FINDINGS_AVERAGE_ID_DESC",
  DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_ASC = "DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_DESC = "DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_BY_BATCH_CLAIM_ID__COUNT_ASC = "DISPUTED_FINDINGS_BY_BATCH_CLAIM_ID__COUNT_ASC",
  DISPUTED_FINDINGS_BY_BATCH_CLAIM_ID__COUNT_DESC = "DISPUTED_FINDINGS_BY_BATCH_CLAIM_ID__COUNT_DESC",
  DISPUTED_FINDINGS_COUNT_ASC = "DISPUTED_FINDINGS_COUNT_ASC",
  DISPUTED_FINDINGS_COUNT_DESC = "DISPUTED_FINDINGS_COUNT_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_ID_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_ID_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_ID_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_ID_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_MAX_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_MAX_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_MAX_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_MAX_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_MAX_CREATED_AT_ASC = "DISPUTED_FINDINGS_MAX_CREATED_AT_ASC",
  DISPUTED_FINDINGS_MAX_CREATED_AT_DESC = "DISPUTED_FINDINGS_MAX_CREATED_AT_DESC",
  DISPUTED_FINDINGS_MAX_DELETED_ASC = "DISPUTED_FINDINGS_MAX_DELETED_ASC",
  DISPUTED_FINDINGS_MAX_DELETED_DESC = "DISPUTED_FINDINGS_MAX_DELETED_DESC",
  DISPUTED_FINDINGS_MAX_ID_ASC = "DISPUTED_FINDINGS_MAX_ID_ASC",
  DISPUTED_FINDINGS_MAX_ID_DESC = "DISPUTED_FINDINGS_MAX_ID_DESC",
  DISPUTED_FINDINGS_MAX_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_MAX_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_MAX_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_MAX_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_MAX_UPDATED_AT_ASC = "DISPUTED_FINDINGS_MAX_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_MAX_UPDATED_AT_DESC = "DISPUTED_FINDINGS_MAX_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_MIN_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_MIN_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_MIN_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_MIN_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_MIN_CREATED_AT_ASC = "DISPUTED_FINDINGS_MIN_CREATED_AT_ASC",
  DISPUTED_FINDINGS_MIN_CREATED_AT_DESC = "DISPUTED_FINDINGS_MIN_CREATED_AT_DESC",
  DISPUTED_FINDINGS_MIN_DELETED_ASC = "DISPUTED_FINDINGS_MIN_DELETED_ASC",
  DISPUTED_FINDINGS_MIN_DELETED_DESC = "DISPUTED_FINDINGS_MIN_DELETED_DESC",
  DISPUTED_FINDINGS_MIN_ID_ASC = "DISPUTED_FINDINGS_MIN_ID_ASC",
  DISPUTED_FINDINGS_MIN_ID_DESC = "DISPUTED_FINDINGS_MIN_ID_DESC",
  DISPUTED_FINDINGS_MIN_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_MIN_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_MIN_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_MIN_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_MIN_UPDATED_AT_ASC = "DISPUTED_FINDINGS_MIN_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_MIN_UPDATED_AT_DESC = "DISPUTED_FINDINGS_MIN_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_ID_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_ID_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_SUM_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_SUM_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_SUM_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_SUM_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_SUM_CREATED_AT_ASC = "DISPUTED_FINDINGS_SUM_CREATED_AT_ASC",
  DISPUTED_FINDINGS_SUM_CREATED_AT_DESC = "DISPUTED_FINDINGS_SUM_CREATED_AT_DESC",
  DISPUTED_FINDINGS_SUM_DELETED_ASC = "DISPUTED_FINDINGS_SUM_DELETED_ASC",
  DISPUTED_FINDINGS_SUM_DELETED_DESC = "DISPUTED_FINDINGS_SUM_DELETED_DESC",
  DISPUTED_FINDINGS_SUM_ID_ASC = "DISPUTED_FINDINGS_SUM_ID_ASC",
  DISPUTED_FINDINGS_SUM_ID_DESC = "DISPUTED_FINDINGS_SUM_ID_DESC",
  DISPUTED_FINDINGS_SUM_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_SUM_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_SUM_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_SUM_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_SUM_UPDATED_AT_ASC = "DISPUTED_FINDINGS_SUM_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_SUM_UPDATED_AT_DESC = "DISPUTED_FINDINGS_SUM_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_AVERAGE_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_AVERAGE_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_AVERAGE_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_AVERAGE_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_AVERAGE_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_AVERAGE_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_AVERAGE_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_AVERAGE_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_AVERAGE_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_AVERAGE_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_AVERAGE_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_AVERAGE_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_AVERAGE_ID_ASC = "DOCUMENTATION_CLAIM_STATES_AVERAGE_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_AVERAGE_ID_DESC = "DOCUMENTATION_CLAIM_STATES_AVERAGE_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC = "DOCUMENTATION_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  DOCUMENTATION_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC = "DOCUMENTATION_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  DOCUMENTATION_CLAIM_STATES_COUNT_ASC = "DOCUMENTATION_CLAIM_STATES_COUNT_ASC",
  DOCUMENTATION_CLAIM_STATES_COUNT_DESC = "DOCUMENTATION_CLAIM_STATES_COUNT_DESC",
  DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_ID_ASC = "DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_ID_DESC = "DOCUMENTATION_CLAIM_STATES_DISTINCT_COUNT_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_MAX_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_MAX_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_MAX_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_MAX_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_MAX_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_MAX_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_MAX_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_MAX_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_MAX_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_MAX_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_MAX_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_MAX_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_MAX_ID_ASC = "DOCUMENTATION_CLAIM_STATES_MAX_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_MAX_ID_DESC = "DOCUMENTATION_CLAIM_STATES_MAX_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_MIN_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_MIN_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_MIN_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_MIN_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_MIN_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_MIN_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_MIN_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_MIN_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_MIN_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_MIN_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_MIN_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_MIN_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_MIN_ID_ASC = "DOCUMENTATION_CLAIM_STATES_MIN_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_MIN_ID_DESC = "DOCUMENTATION_CLAIM_STATES_MIN_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_ID_ASC = "DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_ID_DESC = "DOCUMENTATION_CLAIM_STATES_STDDEV_POPULATION_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC = "DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC = "DOCUMENTATION_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_SUM_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_SUM_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_SUM_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_SUM_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_SUM_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_SUM_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_SUM_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_SUM_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_SUM_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_SUM_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_SUM_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_SUM_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_SUM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_SUM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_SUM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_SUM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_BY_ASC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_BY_ASC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_BY_DESC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_BY_DESC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_STATE_ASC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_STATE_DESC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_STATE_DESC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC",
  DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC = "DOCUMENTATION_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC",
  DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  DOCUMENT_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_AVERAGE_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_AVERAGE_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_AVERAGE_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_AVERAGE_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_AVERAGE_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_AVERAGE_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_AVERAGE_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_AVERAGE_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_AVERAGE_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_AVERAGE_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_AVERAGE_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_AVERAGE_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_BATCH_CLAIM_ID__COUNT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_BATCH_CLAIM_ID__COUNT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_BATCH_CLAIM_ID__COUNT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_BATCH_CLAIM_ID__COUNT_DESC",
  DOCUMENT_REQUEST_CREATEDS_COUNT_ASC = "DOCUMENT_REQUEST_CREATEDS_COUNT_ASC",
  DOCUMENT_REQUEST_CREATEDS_COUNT_DESC = "DOCUMENT_REQUEST_CREATEDS_COUNT_DESC",
  DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_DISTINCT_COUNT_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_MAX_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_MAX_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_MAX_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_MAX_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_MAX_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_MAX_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_MAX_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_MAX_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_MAX_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_MAX_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_MAX_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_MAX_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_MAX_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_MAX_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_MAX_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_MAX_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_MIN_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_MIN_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_MIN_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_MIN_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_MIN_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_MIN_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_MIN_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_MIN_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_MIN_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_MIN_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_MIN_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_MIN_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_MIN_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_MIN_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_MIN_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_MIN_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_POPULATION_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_SUM_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_SUM_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_SUM_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_SUM_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_SUM_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_SUM_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_SUM_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_SUM_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_SUM_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_SUM_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_SUM_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_SUM_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_SUM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_SUM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_SUM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_SUM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_BATCH_CLAIM_ID__COUNT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_BATCH_CLAIM_ID__COUNT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_BATCH_CLAIM_ID__COUNT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_BATCH_CLAIM_ID__COUNT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_COUNT_ASC = "DOCUMENT_UPLOAD_CREATEDS_COUNT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_COUNT_DESC = "DOCUMENT_UPLOAD_CREATEDS_COUNT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  DRG_CODE_ASC = "DRG_CODE_ASC",
  DRG_CODE_DESC = "DRG_CODE_DESC",
  ICN_ASC = "ICN_ASC",
  ICN_DESC = "ICN_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ID_ASC = "INSURER_BY_INSURER_ID__CLIENT_ID_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ID_DESC = "INSURER_BY_INSURER_ID__CLIENT_ID_DESC",
  INSURER_BY_INSURER_ID__CREATED_AT_ASC = "INSURER_BY_INSURER_ID__CREATED_AT_ASC",
  INSURER_BY_INSURER_ID__CREATED_AT_DESC = "INSURER_BY_INSURER_ID__CREATED_AT_DESC",
  INSURER_BY_INSURER_ID__ID_ASC = "INSURER_BY_INSURER_ID__ID_ASC",
  INSURER_BY_INSURER_ID__ID_DESC = "INSURER_BY_INSURER_ID__ID_DESC",
  INSURER_BY_INSURER_ID__NAME_ASC = "INSURER_BY_INSURER_ID__NAME_ASC",
  INSURER_BY_INSURER_ID__NAME_DESC = "INSURER_BY_INSURER_ID__NAME_DESC",
  INSURER_BY_INSURER_ID__UPDATED_AT_ASC = "INSURER_BY_INSURER_ID__UPDATED_AT_ASC",
  INSURER_BY_INSURER_ID__UPDATED_AT_DESC = "INSURER_BY_INSURER_ID__UPDATED_AT_DESC",
  INSURER_ID_ASC = "INSURER_ID_ASC",
  INSURER_ID_DESC = "INSURER_ID_DESC",
  INVOICE_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC = "INVOICE_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  INVOICE_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC = "INVOICE_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  INVOICE_CLAIM_STATES_AVERAGE_CREATED_AT_ASC = "INVOICE_CLAIM_STATES_AVERAGE_CREATED_AT_ASC",
  INVOICE_CLAIM_STATES_AVERAGE_CREATED_AT_DESC = "INVOICE_CLAIM_STATES_AVERAGE_CREATED_AT_DESC",
  INVOICE_CLAIM_STATES_AVERAGE_ID_ASC = "INVOICE_CLAIM_STATES_AVERAGE_ID_ASC",
  INVOICE_CLAIM_STATES_AVERAGE_ID_DESC = "INVOICE_CLAIM_STATES_AVERAGE_ID_DESC",
  INVOICE_CLAIM_STATES_AVERAGE_INVOICE_STATE_ASC = "INVOICE_CLAIM_STATES_AVERAGE_INVOICE_STATE_ASC",
  INVOICE_CLAIM_STATES_AVERAGE_INVOICE_STATE_DESC = "INVOICE_CLAIM_STATES_AVERAGE_INVOICE_STATE_DESC",
  INVOICE_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC = "INVOICE_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  INVOICE_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC = "INVOICE_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  INVOICE_CLAIM_STATES_COUNT_ASC = "INVOICE_CLAIM_STATES_COUNT_ASC",
  INVOICE_CLAIM_STATES_COUNT_DESC = "INVOICE_CLAIM_STATES_COUNT_DESC",
  INVOICE_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "INVOICE_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  INVOICE_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "INVOICE_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  INVOICE_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC = "INVOICE_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC",
  INVOICE_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC = "INVOICE_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC",
  INVOICE_CLAIM_STATES_DISTINCT_COUNT_ID_ASC = "INVOICE_CLAIM_STATES_DISTINCT_COUNT_ID_ASC",
  INVOICE_CLAIM_STATES_DISTINCT_COUNT_ID_DESC = "INVOICE_CLAIM_STATES_DISTINCT_COUNT_ID_DESC",
  INVOICE_CLAIM_STATES_DISTINCT_COUNT_INVOICE_STATE_ASC = "INVOICE_CLAIM_STATES_DISTINCT_COUNT_INVOICE_STATE_ASC",
  INVOICE_CLAIM_STATES_DISTINCT_COUNT_INVOICE_STATE_DESC = "INVOICE_CLAIM_STATES_DISTINCT_COUNT_INVOICE_STATE_DESC",
  INVOICE_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC = "INVOICE_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC",
  INVOICE_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC = "INVOICE_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC",
  INVOICE_CLAIM_STATES_MAX_CREATED_AT_ASC = "INVOICE_CLAIM_STATES_MAX_CREATED_AT_ASC",
  INVOICE_CLAIM_STATES_MAX_CREATED_AT_DESC = "INVOICE_CLAIM_STATES_MAX_CREATED_AT_DESC",
  INVOICE_CLAIM_STATES_MAX_ID_ASC = "INVOICE_CLAIM_STATES_MAX_ID_ASC",
  INVOICE_CLAIM_STATES_MAX_ID_DESC = "INVOICE_CLAIM_STATES_MAX_ID_DESC",
  INVOICE_CLAIM_STATES_MAX_INVOICE_STATE_ASC = "INVOICE_CLAIM_STATES_MAX_INVOICE_STATE_ASC",
  INVOICE_CLAIM_STATES_MAX_INVOICE_STATE_DESC = "INVOICE_CLAIM_STATES_MAX_INVOICE_STATE_DESC",
  INVOICE_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC = "INVOICE_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC",
  INVOICE_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC = "INVOICE_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC",
  INVOICE_CLAIM_STATES_MIN_CREATED_AT_ASC = "INVOICE_CLAIM_STATES_MIN_CREATED_AT_ASC",
  INVOICE_CLAIM_STATES_MIN_CREATED_AT_DESC = "INVOICE_CLAIM_STATES_MIN_CREATED_AT_DESC",
  INVOICE_CLAIM_STATES_MIN_ID_ASC = "INVOICE_CLAIM_STATES_MIN_ID_ASC",
  INVOICE_CLAIM_STATES_MIN_ID_DESC = "INVOICE_CLAIM_STATES_MIN_ID_DESC",
  INVOICE_CLAIM_STATES_MIN_INVOICE_STATE_ASC = "INVOICE_CLAIM_STATES_MIN_INVOICE_STATE_ASC",
  INVOICE_CLAIM_STATES_MIN_INVOICE_STATE_DESC = "INVOICE_CLAIM_STATES_MIN_INVOICE_STATE_DESC",
  INVOICE_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "INVOICE_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  INVOICE_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "INVOICE_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  INVOICE_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC = "INVOICE_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC",
  INVOICE_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC = "INVOICE_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC",
  INVOICE_CLAIM_STATES_STDDEV_POPULATION_ID_ASC = "INVOICE_CLAIM_STATES_STDDEV_POPULATION_ID_ASC",
  INVOICE_CLAIM_STATES_STDDEV_POPULATION_ID_DESC = "INVOICE_CLAIM_STATES_STDDEV_POPULATION_ID_DESC",
  INVOICE_CLAIM_STATES_STDDEV_POPULATION_INVOICE_STATE_ASC = "INVOICE_CLAIM_STATES_STDDEV_POPULATION_INVOICE_STATE_ASC",
  INVOICE_CLAIM_STATES_STDDEV_POPULATION_INVOICE_STATE_DESC = "INVOICE_CLAIM_STATES_STDDEV_POPULATION_INVOICE_STATE_DESC",
  INVOICE_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "INVOICE_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  INVOICE_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "INVOICE_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  INVOICE_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC = "INVOICE_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC",
  INVOICE_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC = "INVOICE_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC",
  INVOICE_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC = "INVOICE_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC",
  INVOICE_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC = "INVOICE_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC",
  INVOICE_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_STATE_ASC = "INVOICE_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_STATE_ASC",
  INVOICE_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_STATE_DESC = "INVOICE_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_STATE_DESC",
  INVOICE_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC = "INVOICE_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC",
  INVOICE_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC = "INVOICE_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC",
  INVOICE_CLAIM_STATES_SUM_CREATED_AT_ASC = "INVOICE_CLAIM_STATES_SUM_CREATED_AT_ASC",
  INVOICE_CLAIM_STATES_SUM_CREATED_AT_DESC = "INVOICE_CLAIM_STATES_SUM_CREATED_AT_DESC",
  INVOICE_CLAIM_STATES_SUM_ID_ASC = "INVOICE_CLAIM_STATES_SUM_ID_ASC",
  INVOICE_CLAIM_STATES_SUM_ID_DESC = "INVOICE_CLAIM_STATES_SUM_ID_DESC",
  INVOICE_CLAIM_STATES_SUM_INVOICE_STATE_ASC = "INVOICE_CLAIM_STATES_SUM_INVOICE_STATE_ASC",
  INVOICE_CLAIM_STATES_SUM_INVOICE_STATE_DESC = "INVOICE_CLAIM_STATES_SUM_INVOICE_STATE_DESC",
  INVOICE_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "INVOICE_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  INVOICE_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "INVOICE_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  INVOICE_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC = "INVOICE_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC",
  INVOICE_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC = "INVOICE_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC",
  INVOICE_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC = "INVOICE_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC",
  INVOICE_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC = "INVOICE_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC",
  INVOICE_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_STATE_ASC = "INVOICE_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_STATE_ASC",
  INVOICE_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_STATE_DESC = "INVOICE_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_STATE_DESC",
  INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC = "INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC = "INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC = "INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC",
  INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC = "INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC",
  INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_STATE_ASC = "INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_STATE_ASC",
  INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_STATE_DESC = "INVOICE_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_STATE_DESC",
  LIFECYCLE_SORT_ORDER_ASC = "LIFECYCLE_SORT_ORDER_ASC",
  LIFECYCLE_SORT_ORDER_DESC = "LIFECYCLE_SORT_ORDER_DESC",
  NATURAL = "NATURAL",
  NEGOTIATION_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC = "NEGOTIATION_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  NEGOTIATION_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC = "NEGOTIATION_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  NEGOTIATION_CLAIM_STATES_AVERAGE_CREATED_AT_ASC = "NEGOTIATION_CLAIM_STATES_AVERAGE_CREATED_AT_ASC",
  NEGOTIATION_CLAIM_STATES_AVERAGE_CREATED_AT_DESC = "NEGOTIATION_CLAIM_STATES_AVERAGE_CREATED_AT_DESC",
  NEGOTIATION_CLAIM_STATES_AVERAGE_ID_ASC = "NEGOTIATION_CLAIM_STATES_AVERAGE_ID_ASC",
  NEGOTIATION_CLAIM_STATES_AVERAGE_ID_DESC = "NEGOTIATION_CLAIM_STATES_AVERAGE_ID_DESC",
  NEGOTIATION_CLAIM_STATES_AVERAGE_NEGOTIATION_STATE_ASC = "NEGOTIATION_CLAIM_STATES_AVERAGE_NEGOTIATION_STATE_ASC",
  NEGOTIATION_CLAIM_STATES_AVERAGE_NEGOTIATION_STATE_DESC = "NEGOTIATION_CLAIM_STATES_AVERAGE_NEGOTIATION_STATE_DESC",
  NEGOTIATION_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC = "NEGOTIATION_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  NEGOTIATION_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC = "NEGOTIATION_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  NEGOTIATION_CLAIM_STATES_COUNT_ASC = "NEGOTIATION_CLAIM_STATES_COUNT_ASC",
  NEGOTIATION_CLAIM_STATES_COUNT_DESC = "NEGOTIATION_CLAIM_STATES_COUNT_DESC",
  NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC = "NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC",
  NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC = "NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC",
  NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_ID_ASC = "NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_ID_ASC",
  NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_ID_DESC = "NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_ID_DESC",
  NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_STATE_ASC = "NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_STATE_ASC",
  NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_STATE_DESC = "NEGOTIATION_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_STATE_DESC",
  NEGOTIATION_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC = "NEGOTIATION_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC",
  NEGOTIATION_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC = "NEGOTIATION_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC",
  NEGOTIATION_CLAIM_STATES_MAX_CREATED_AT_ASC = "NEGOTIATION_CLAIM_STATES_MAX_CREATED_AT_ASC",
  NEGOTIATION_CLAIM_STATES_MAX_CREATED_AT_DESC = "NEGOTIATION_CLAIM_STATES_MAX_CREATED_AT_DESC",
  NEGOTIATION_CLAIM_STATES_MAX_ID_ASC = "NEGOTIATION_CLAIM_STATES_MAX_ID_ASC",
  NEGOTIATION_CLAIM_STATES_MAX_ID_DESC = "NEGOTIATION_CLAIM_STATES_MAX_ID_DESC",
  NEGOTIATION_CLAIM_STATES_MAX_NEGOTIATION_STATE_ASC = "NEGOTIATION_CLAIM_STATES_MAX_NEGOTIATION_STATE_ASC",
  NEGOTIATION_CLAIM_STATES_MAX_NEGOTIATION_STATE_DESC = "NEGOTIATION_CLAIM_STATES_MAX_NEGOTIATION_STATE_DESC",
  NEGOTIATION_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC = "NEGOTIATION_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC",
  NEGOTIATION_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC = "NEGOTIATION_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC",
  NEGOTIATION_CLAIM_STATES_MIN_CREATED_AT_ASC = "NEGOTIATION_CLAIM_STATES_MIN_CREATED_AT_ASC",
  NEGOTIATION_CLAIM_STATES_MIN_CREATED_AT_DESC = "NEGOTIATION_CLAIM_STATES_MIN_CREATED_AT_DESC",
  NEGOTIATION_CLAIM_STATES_MIN_ID_ASC = "NEGOTIATION_CLAIM_STATES_MIN_ID_ASC",
  NEGOTIATION_CLAIM_STATES_MIN_ID_DESC = "NEGOTIATION_CLAIM_STATES_MIN_ID_DESC",
  NEGOTIATION_CLAIM_STATES_MIN_NEGOTIATION_STATE_ASC = "NEGOTIATION_CLAIM_STATES_MIN_NEGOTIATION_STATE_ASC",
  NEGOTIATION_CLAIM_STATES_MIN_NEGOTIATION_STATE_DESC = "NEGOTIATION_CLAIM_STATES_MIN_NEGOTIATION_STATE_DESC",
  NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC = "NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC",
  NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC = "NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC",
  NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_ID_ASC = "NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_ID_ASC",
  NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_ID_DESC = "NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_ID_DESC",
  NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_STATE_ASC = "NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_STATE_ASC",
  NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_STATE_DESC = "NEGOTIATION_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_STATE_DESC",
  NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC = "NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC",
  NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC = "NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC",
  NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC = "NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC",
  NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC = "NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC",
  NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_STATE_ASC = "NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_STATE_ASC",
  NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_STATE_DESC = "NEGOTIATION_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_STATE_DESC",
  NEGOTIATION_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC = "NEGOTIATION_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC",
  NEGOTIATION_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC = "NEGOTIATION_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC",
  NEGOTIATION_CLAIM_STATES_SUM_CREATED_AT_ASC = "NEGOTIATION_CLAIM_STATES_SUM_CREATED_AT_ASC",
  NEGOTIATION_CLAIM_STATES_SUM_CREATED_AT_DESC = "NEGOTIATION_CLAIM_STATES_SUM_CREATED_AT_DESC",
  NEGOTIATION_CLAIM_STATES_SUM_ID_ASC = "NEGOTIATION_CLAIM_STATES_SUM_ID_ASC",
  NEGOTIATION_CLAIM_STATES_SUM_ID_DESC = "NEGOTIATION_CLAIM_STATES_SUM_ID_DESC",
  NEGOTIATION_CLAIM_STATES_SUM_NEGOTIATION_STATE_ASC = "NEGOTIATION_CLAIM_STATES_SUM_NEGOTIATION_STATE_ASC",
  NEGOTIATION_CLAIM_STATES_SUM_NEGOTIATION_STATE_DESC = "NEGOTIATION_CLAIM_STATES_SUM_NEGOTIATION_STATE_DESC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC = "NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC = "NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC = "NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC = "NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_STATE_ASC = "NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_STATE_ASC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_STATE_DESC = "NEGOTIATION_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_STATE_DESC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC = "NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC = "NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC = "NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC = "NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_STATE_ASC = "NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_STATE_ASC",
  NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_STATE_DESC = "NEGOTIATION_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_STATE_DESC",
  ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  ON_HOLD_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC = "ON_HOLD_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  ON_HOLD_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC = "ON_HOLD_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  ON_HOLD_CLAIM_STATES_AVERAGE_CREATED_AT_ASC = "ON_HOLD_CLAIM_STATES_AVERAGE_CREATED_AT_ASC",
  ON_HOLD_CLAIM_STATES_AVERAGE_CREATED_AT_DESC = "ON_HOLD_CLAIM_STATES_AVERAGE_CREATED_AT_DESC",
  ON_HOLD_CLAIM_STATES_AVERAGE_ID_ASC = "ON_HOLD_CLAIM_STATES_AVERAGE_ID_ASC",
  ON_HOLD_CLAIM_STATES_AVERAGE_ID_DESC = "ON_HOLD_CLAIM_STATES_AVERAGE_ID_DESC",
  ON_HOLD_CLAIM_STATES_AVERAGE_ON_HOLD_STATE_ASC = "ON_HOLD_CLAIM_STATES_AVERAGE_ON_HOLD_STATE_ASC",
  ON_HOLD_CLAIM_STATES_AVERAGE_ON_HOLD_STATE_DESC = "ON_HOLD_CLAIM_STATES_AVERAGE_ON_HOLD_STATE_DESC",
  ON_HOLD_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC = "ON_HOLD_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  ON_HOLD_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC = "ON_HOLD_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  ON_HOLD_CLAIM_STATES_COUNT_ASC = "ON_HOLD_CLAIM_STATES_COUNT_ASC",
  ON_HOLD_CLAIM_STATES_COUNT_DESC = "ON_HOLD_CLAIM_STATES_COUNT_DESC",
  ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC = "ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC",
  ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC = "ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC",
  ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_ID_ASC = "ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_ID_ASC",
  ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_ID_DESC = "ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_ID_DESC",
  ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_STATE_ASC = "ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_STATE_ASC",
  ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_STATE_DESC = "ON_HOLD_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_STATE_DESC",
  ON_HOLD_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC = "ON_HOLD_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC",
  ON_HOLD_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC = "ON_HOLD_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC",
  ON_HOLD_CLAIM_STATES_MAX_CREATED_AT_ASC = "ON_HOLD_CLAIM_STATES_MAX_CREATED_AT_ASC",
  ON_HOLD_CLAIM_STATES_MAX_CREATED_AT_DESC = "ON_HOLD_CLAIM_STATES_MAX_CREATED_AT_DESC",
  ON_HOLD_CLAIM_STATES_MAX_ID_ASC = "ON_HOLD_CLAIM_STATES_MAX_ID_ASC",
  ON_HOLD_CLAIM_STATES_MAX_ID_DESC = "ON_HOLD_CLAIM_STATES_MAX_ID_DESC",
  ON_HOLD_CLAIM_STATES_MAX_ON_HOLD_STATE_ASC = "ON_HOLD_CLAIM_STATES_MAX_ON_HOLD_STATE_ASC",
  ON_HOLD_CLAIM_STATES_MAX_ON_HOLD_STATE_DESC = "ON_HOLD_CLAIM_STATES_MAX_ON_HOLD_STATE_DESC",
  ON_HOLD_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC = "ON_HOLD_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC",
  ON_HOLD_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC = "ON_HOLD_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC",
  ON_HOLD_CLAIM_STATES_MIN_CREATED_AT_ASC = "ON_HOLD_CLAIM_STATES_MIN_CREATED_AT_ASC",
  ON_HOLD_CLAIM_STATES_MIN_CREATED_AT_DESC = "ON_HOLD_CLAIM_STATES_MIN_CREATED_AT_DESC",
  ON_HOLD_CLAIM_STATES_MIN_ID_ASC = "ON_HOLD_CLAIM_STATES_MIN_ID_ASC",
  ON_HOLD_CLAIM_STATES_MIN_ID_DESC = "ON_HOLD_CLAIM_STATES_MIN_ID_DESC",
  ON_HOLD_CLAIM_STATES_MIN_ON_HOLD_STATE_ASC = "ON_HOLD_CLAIM_STATES_MIN_ON_HOLD_STATE_ASC",
  ON_HOLD_CLAIM_STATES_MIN_ON_HOLD_STATE_DESC = "ON_HOLD_CLAIM_STATES_MIN_ON_HOLD_STATE_DESC",
  ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC = "ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC",
  ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC = "ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC",
  ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_ID_ASC = "ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_ID_ASC",
  ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_ID_DESC = "ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_ID_DESC",
  ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_STATE_ASC = "ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_STATE_ASC",
  ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_STATE_DESC = "ON_HOLD_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_STATE_DESC",
  ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC = "ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC",
  ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC = "ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC",
  ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC = "ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC",
  ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC = "ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC",
  ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_STATE_ASC = "ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_STATE_ASC",
  ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_STATE_DESC = "ON_HOLD_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_STATE_DESC",
  ON_HOLD_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC = "ON_HOLD_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC",
  ON_HOLD_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC = "ON_HOLD_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC",
  ON_HOLD_CLAIM_STATES_SUM_CREATED_AT_ASC = "ON_HOLD_CLAIM_STATES_SUM_CREATED_AT_ASC",
  ON_HOLD_CLAIM_STATES_SUM_CREATED_AT_DESC = "ON_HOLD_CLAIM_STATES_SUM_CREATED_AT_DESC",
  ON_HOLD_CLAIM_STATES_SUM_ID_ASC = "ON_HOLD_CLAIM_STATES_SUM_ID_ASC",
  ON_HOLD_CLAIM_STATES_SUM_ID_DESC = "ON_HOLD_CLAIM_STATES_SUM_ID_DESC",
  ON_HOLD_CLAIM_STATES_SUM_ON_HOLD_STATE_ASC = "ON_HOLD_CLAIM_STATES_SUM_ON_HOLD_STATE_ASC",
  ON_HOLD_CLAIM_STATES_SUM_ON_HOLD_STATE_DESC = "ON_HOLD_CLAIM_STATES_SUM_ON_HOLD_STATE_DESC",
  ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC = "ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC",
  ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC = "ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC",
  ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC = "ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC",
  ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC = "ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC",
  ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_STATE_ASC = "ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_STATE_ASC",
  ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_STATE_DESC = "ON_HOLD_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_STATE_DESC",
  ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC = "ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC = "ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC = "ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC",
  ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC = "ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC",
  ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_STATE_ASC = "ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_STATE_ASC",
  ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_STATE_DESC = "ON_HOLD_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_STATE_DESC",
  OWNER_ID_ASC = "OWNER_ID_ASC",
  OWNER_ID_DESC = "OWNER_ID_DESC",
  PAID_DATE_ASC = "PAID_DATE_ASC",
  PAID_DATE_DESC = "PAID_DATE_DESC",
  PATIENT_CONTROL_NUMBER_ASC = "PATIENT_CONTROL_NUMBER_ASC",
  PATIENT_CONTROL_NUMBER_DESC = "PATIENT_CONTROL_NUMBER_DESC",
  PATIENT_DATUM_BY_PATIENT_ID__CREATED_AT_ASC = "PATIENT_DATUM_BY_PATIENT_ID__CREATED_AT_ASC",
  PATIENT_DATUM_BY_PATIENT_ID__CREATED_AT_DESC = "PATIENT_DATUM_BY_PATIENT_ID__CREATED_AT_DESC",
  PATIENT_DATUM_BY_PATIENT_ID__ID_ASC = "PATIENT_DATUM_BY_PATIENT_ID__ID_ASC",
  PATIENT_DATUM_BY_PATIENT_ID__ID_DESC = "PATIENT_DATUM_BY_PATIENT_ID__ID_DESC",
  PATIENT_DATUM_BY_PATIENT_ID__NAME_ASC = "PATIENT_DATUM_BY_PATIENT_ID__NAME_ASC",
  PATIENT_DATUM_BY_PATIENT_ID__NAME_DESC = "PATIENT_DATUM_BY_PATIENT_ID__NAME_DESC",
  PATIENT_DATUM_BY_PATIENT_ID__PAYER_PATIENT_ID_ASC = "PATIENT_DATUM_BY_PATIENT_ID__PAYER_PATIENT_ID_ASC",
  PATIENT_DATUM_BY_PATIENT_ID__PAYER_PATIENT_ID_DESC = "PATIENT_DATUM_BY_PATIENT_ID__PAYER_PATIENT_ID_DESC",
  PATIENT_DATUM_BY_PATIENT_ID__STATE_ASC = "PATIENT_DATUM_BY_PATIENT_ID__STATE_ASC",
  PATIENT_DATUM_BY_PATIENT_ID__STATE_DESC = "PATIENT_DATUM_BY_PATIENT_ID__STATE_DESC",
  PATIENT_DATUM_BY_PATIENT_ID__UPDATED_AT_ASC = "PATIENT_DATUM_BY_PATIENT_ID__UPDATED_AT_ASC",
  PATIENT_DATUM_BY_PATIENT_ID__UPDATED_AT_DESC = "PATIENT_DATUM_BY_PATIENT_ID__UPDATED_AT_DESC",
  PATIENT_DOB_ASC = "PATIENT_DOB_ASC",
  PATIENT_DOB_DESC = "PATIENT_DOB_DESC",
  PATIENT_GENDER_ASC = "PATIENT_GENDER_ASC",
  PATIENT_GENDER_DESC = "PATIENT_GENDER_DESC",
  PATIENT_ID_ASC = "PATIENT_ID_ASC",
  PATIENT_ID_DESC = "PATIENT_ID_DESC",
  PAYMENT_RATE_ASC = "PAYMENT_RATE_ASC",
  PAYMENT_RATE_DESC = "PAYMENT_RATE_DESC",
  PERMITTED_INSURER_USERS_ASC = "PERMITTED_INSURER_USERS_ASC",
  PERMITTED_INSURER_USERS_DESC = "PERMITTED_INSURER_USERS_DESC",
  PHASE_SORT_ORDER_ASC = "PHASE_SORT_ORDER_ASC",
  PHASE_SORT_ORDER_DESC = "PHASE_SORT_ORDER_DESC",
  POA_1_ASC = "POA_1_ASC",
  POA_1_DESC = "POA_1_DESC",
  POA_2_ASC = "POA_2_ASC",
  POA_2_DESC = "POA_2_DESC",
  POA_3_ASC = "POA_3_ASC",
  POA_3_DESC = "POA_3_DESC",
  POA_4_ASC = "POA_4_ASC",
  POA_4_DESC = "POA_4_DESC",
  POA_5_ASC = "POA_5_ASC",
  POA_5_DESC = "POA_5_DESC",
  POA_6_ASC = "POA_6_ASC",
  POA_6_DESC = "POA_6_DESC",
  POA_7_ASC = "POA_7_ASC",
  POA_7_DESC = "POA_7_DESC",
  POA_8_ASC = "POA_8_ASC",
  POA_8_DESC = "POA_8_DESC",
  POA_9_ASC = "POA_9_ASC",
  POA_9_DESC = "POA_9_DESC",
  POA_10_ASC = "POA_10_ASC",
  POA_10_DESC = "POA_10_DESC",
  POA_11_ASC = "POA_11_ASC",
  POA_11_DESC = "POA_11_DESC",
  POA_12_ASC = "POA_12_ASC",
  POA_12_DESC = "POA_12_DESC",
  POA_13_ASC = "POA_13_ASC",
  POA_13_DESC = "POA_13_DESC",
  POA_14_ASC = "POA_14_ASC",
  POA_14_DESC = "POA_14_DESC",
  POA_15_ASC = "POA_15_ASC",
  POA_15_DESC = "POA_15_DESC",
  POA_16_ASC = "POA_16_ASC",
  POA_16_DESC = "POA_16_DESC",
  POA_17_ASC = "POA_17_ASC",
  POA_17_DESC = "POA_17_DESC",
  POA_18_ASC = "POA_18_ASC",
  POA_18_DESC = "POA_18_DESC",
  POA_19_ASC = "POA_19_ASC",
  POA_19_DESC = "POA_19_DESC",
  POA_20_ASC = "POA_20_ASC",
  POA_20_DESC = "POA_20_DESC",
  POA_21_ASC = "POA_21_ASC",
  POA_21_DESC = "POA_21_DESC",
  POA_22_ASC = "POA_22_ASC",
  POA_22_DESC = "POA_22_DESC",
  POA_23_ASC = "POA_23_ASC",
  POA_23_DESC = "POA_23_DESC",
  POA_24_ASC = "POA_24_ASC",
  POA_24_DESC = "POA_24_DESC",
  POA_25_ASC = "POA_25_ASC",
  POA_25_DESC = "POA_25_DESC",
  PREPAY_DENY_ASC = "PREPAY_DENY_ASC",
  PREPAY_DENY_DESC = "PREPAY_DENY_DESC",
  PREVIOUS_VERSION_ID_ASC = "PREVIOUS_VERSION_ID_ASC",
  PREVIOUS_VERSION_ID_DESC = "PREVIOUS_VERSION_ID_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PRINCIPAL_DIAG_ASC = "PRINCIPAL_DIAG_ASC",
  PRINCIPAL_DIAG_DESC = "PRINCIPAL_DIAG_DESC",
  PRINCIPAL_POA_ASC = "PRINCIPAL_POA_ASC",
  PRINCIPAL_POA_DESC = "PRINCIPAL_POA_DESC",
  PRINCIPAL_PROCEDURE_CODE_ASC = "PRINCIPAL_PROCEDURE_CODE_ASC",
  PRINCIPAL_PROCEDURE_CODE_DESC = "PRINCIPAL_PROCEDURE_CODE_DESC",
  PROCEDURE_CODE_1_ASC = "PROCEDURE_CODE_1_ASC",
  PROCEDURE_CODE_1_DESC = "PROCEDURE_CODE_1_DESC",
  PROCEDURE_CODE_2_ASC = "PROCEDURE_CODE_2_ASC",
  PROCEDURE_CODE_2_DESC = "PROCEDURE_CODE_2_DESC",
  PROCEDURE_CODE_3_ASC = "PROCEDURE_CODE_3_ASC",
  PROCEDURE_CODE_3_DESC = "PROCEDURE_CODE_3_DESC",
  PROCEDURE_CODE_4_ASC = "PROCEDURE_CODE_4_ASC",
  PROCEDURE_CODE_4_DESC = "PROCEDURE_CODE_4_DESC",
  PROCEDURE_CODE_5_ASC = "PROCEDURE_CODE_5_ASC",
  PROCEDURE_CODE_5_DESC = "PROCEDURE_CODE_5_DESC",
  PROCEDURE_CODE_6_ASC = "PROCEDURE_CODE_6_ASC",
  PROCEDURE_CODE_6_DESC = "PROCEDURE_CODE_6_DESC",
  PROCEDURE_CODE_7_ASC = "PROCEDURE_CODE_7_ASC",
  PROCEDURE_CODE_7_DESC = "PROCEDURE_CODE_7_DESC",
  PROCEDURE_CODE_8_ASC = "PROCEDURE_CODE_8_ASC",
  PROCEDURE_CODE_8_DESC = "PROCEDURE_CODE_8_DESC",
  PROCEDURE_CODE_9_ASC = "PROCEDURE_CODE_9_ASC",
  PROCEDURE_CODE_9_DESC = "PROCEDURE_CODE_9_DESC",
  PROCEDURE_CODE_10_ASC = "PROCEDURE_CODE_10_ASC",
  PROCEDURE_CODE_10_DESC = "PROCEDURE_CODE_10_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__CITY_ASC = "PROVIDER_BY_PROVIDER_ID__CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__CITY_DESC = "PROVIDER_BY_PROVIDER_ID__CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC",
  PROVIDER_BY_PROVIDER_ID__ID_ASC = "PROVIDER_BY_PROVIDER_ID__ID_ASC",
  PROVIDER_BY_PROVIDER_ID__ID_DESC = "PROVIDER_BY_PROVIDER_ID__ID_DESC",
  PROVIDER_BY_PROVIDER_ID__NAME_ASC = "PROVIDER_BY_PROVIDER_ID__NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__NAME_DESC = "PROVIDER_BY_PROVIDER_ID__NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__NPI_ASC = "PROVIDER_BY_PROVIDER_ID__NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__NPI_DESC = "PROVIDER_BY_PROVIDER_ID__NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC",
  PROVIDER_BY_PROVIDER_ID__SPEC_ASC = "PROVIDER_BY_PROVIDER_ID__SPEC_ASC",
  PROVIDER_BY_PROVIDER_ID__SPEC_DESC = "PROVIDER_BY_PROVIDER_ID__SPEC_DESC",
  PROVIDER_BY_PROVIDER_ID__STATE_ASC = "PROVIDER_BY_PROVIDER_ID__STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__STATE_DESC = "PROVIDER_BY_PROVIDER_ID__STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC",
  PROVIDER_ID_ASC = "PROVIDER_ID_ASC",
  PROVIDER_ID_DESC = "PROVIDER_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_CREATED_AT_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_CREATED_AT_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_CREATED_AT_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_CREATED_AT_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_STATE_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_STATE_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_STATE_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_STATE_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_COUNT_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_COUNT_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_COUNT_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_COUNT_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_STATE_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_STATE_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_STATE_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_STATE_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_CREATED_AT_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_CREATED_AT_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_CREATED_AT_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_CREATED_AT_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_STATE_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_STATE_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_STATE_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_STATE_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_CREATED_AT_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_CREATED_AT_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_CREATED_AT_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_CREATED_AT_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_STATE_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_STATE_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_STATE_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_STATE_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_STATE_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_STATE_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_STATE_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_STATE_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_STATE_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_STATE_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_STATE_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_STATE_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_CREATED_AT_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_CREATED_AT_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_CREATED_AT_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_CREATED_AT_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_STATE_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_STATE_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_STATE_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_STATE_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_STATE_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_STATE_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_STATE_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_STATE_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_STATE_ASC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_STATE_ASC",
  PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_STATE_DESC = "PROVIDER_SIGN_OFF_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_STATE_DESC",
  QA_CLAIM_STATE_ROWS_AVERAGE_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_AVERAGE_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_AVERAGE_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_AVERAGE_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_AVERAGE_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_AVERAGE_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_AVERAGE_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_AVERAGE_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_AVERAGE_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_AVERAGE_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_AVERAGE_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_AVERAGE_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_AVERAGE_ID_ASC = "QA_CLAIM_STATE_ROWS_AVERAGE_ID_ASC",
  QA_CLAIM_STATE_ROWS_AVERAGE_ID_DESC = "QA_CLAIM_STATE_ROWS_AVERAGE_ID_DESC",
  QA_CLAIM_STATE_ROWS_AVERAGE_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_AVERAGE_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_AVERAGE_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_AVERAGE_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_BY_BATCH_CLAIM_ID__COUNT_ASC = "QA_CLAIM_STATE_ROWS_BY_BATCH_CLAIM_ID__COUNT_ASC",
  QA_CLAIM_STATE_ROWS_BY_BATCH_CLAIM_ID__COUNT_DESC = "QA_CLAIM_STATE_ROWS_BY_BATCH_CLAIM_ID__COUNT_DESC",
  QA_CLAIM_STATE_ROWS_COUNT_ASC = "QA_CLAIM_STATE_ROWS_COUNT_ASC",
  QA_CLAIM_STATE_ROWS_COUNT_DESC = "QA_CLAIM_STATE_ROWS_COUNT_DESC",
  QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_ID_ASC = "QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_ID_ASC",
  QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_ID_DESC = "QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_ID_DESC",
  QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_DISTINCT_COUNT_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_MAX_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_MAX_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_MAX_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_MAX_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_MAX_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_MAX_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_MAX_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_MAX_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_MAX_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_MAX_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_MAX_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_MAX_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_MAX_ID_ASC = "QA_CLAIM_STATE_ROWS_MAX_ID_ASC",
  QA_CLAIM_STATE_ROWS_MAX_ID_DESC = "QA_CLAIM_STATE_ROWS_MAX_ID_DESC",
  QA_CLAIM_STATE_ROWS_MAX_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_MAX_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_MAX_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_MAX_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_MIN_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_MIN_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_MIN_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_MIN_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_MIN_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_MIN_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_MIN_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_MIN_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_MIN_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_MIN_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_MIN_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_MIN_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_MIN_ID_ASC = "QA_CLAIM_STATE_ROWS_MIN_ID_ASC",
  QA_CLAIM_STATE_ROWS_MIN_ID_DESC = "QA_CLAIM_STATE_ROWS_MIN_ID_DESC",
  QA_CLAIM_STATE_ROWS_MIN_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_MIN_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_MIN_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_MIN_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_ID_ASC = "QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_ID_ASC",
  QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_ID_DESC = "QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_ID_DESC",
  QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_STDDEV_POPULATION_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_ID_ASC = "QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_ID_ASC",
  QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_ID_DESC = "QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_ID_DESC",
  QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_STDDEV_SAMPLE_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_SUM_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_SUM_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_SUM_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_SUM_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_SUM_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_SUM_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_SUM_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_SUM_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_SUM_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_SUM_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_SUM_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_SUM_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_SUM_ID_ASC = "QA_CLAIM_STATE_ROWS_SUM_ID_ASC",
  QA_CLAIM_STATE_ROWS_SUM_ID_DESC = "QA_CLAIM_STATE_ROWS_SUM_ID_DESC",
  QA_CLAIM_STATE_ROWS_SUM_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_SUM_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_SUM_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_SUM_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_ID_ASC = "QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_ID_ASC",
  QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_ID_DESC = "QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_ID_DESC",
  QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_VARIANCE_POPULATION_QA_CLAIM_STATE_DESC",
  QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_CREATED_AT_ASC = "QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_CREATED_AT_DESC = "QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_CREATED_BY_ASC = "QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_CREATED_BY_ASC",
  QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_CREATED_BY_DESC = "QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_CREATED_BY_DESC",
  QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_ID_ASC = "QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_ID_ASC",
  QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_ID_DESC = "QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_ID_DESC",
  QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_ROWS_VARIANCE_SAMPLE_QA_CLAIM_STATE_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_CLAIM_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_CLAIM_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_CLAIM_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_CLAIM_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_STRATEGY_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_STRATEGY_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_STRATEGY_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_AVERAGE_STRATEGY_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_COUNT_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_COUNT_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_COUNT_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_COUNT_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_CLAIM_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_CLAIM_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_CLAIM_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_CLAIM_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_STRATEGY_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_STRATEGY_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_STRATEGY_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_DISTINCT_COUNT_STRATEGY_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MAX_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_MAX_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MAX_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_MAX_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MAX_CLAIM_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_MAX_CLAIM_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MAX_CLAIM_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_MAX_CLAIM_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MAX_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_MAX_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MAX_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_MAX_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MAX_STRATEGY_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_MAX_STRATEGY_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MAX_STRATEGY_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_MAX_STRATEGY_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MIN_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_MIN_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MIN_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_MIN_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MIN_CLAIM_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_MIN_CLAIM_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MIN_CLAIM_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_MIN_CLAIM_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MIN_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_MIN_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MIN_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_MIN_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MIN_STRATEGY_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_MIN_STRATEGY_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_MIN_STRATEGY_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_MIN_STRATEGY_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_CLAIM_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_CLAIM_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_CLAIM_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_CLAIM_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_STRATEGY_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_STRATEGY_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_STRATEGY_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_POPULATION_STRATEGY_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_CLAIM_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_CLAIM_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_CLAIM_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_CLAIM_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_STRATEGY_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_STRATEGY_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_STRATEGY_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_STDDEV_SAMPLE_STRATEGY_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_SUM_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_SUM_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_SUM_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_SUM_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_SUM_CLAIM_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_SUM_CLAIM_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_SUM_CLAIM_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_SUM_CLAIM_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_SUM_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_SUM_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_SUM_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_SUM_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_SUM_STRATEGY_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_SUM_STRATEGY_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_SUM_STRATEGY_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_SUM_STRATEGY_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_CLAIM_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_CLAIM_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_CLAIM_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_CLAIM_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_STRATEGY_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_STRATEGY_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_STRATEGY_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_POPULATION_STRATEGY_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_CLAIM_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_CLAIM_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_CLAIM_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_CLAIM_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_ID_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_ID_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_ID_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_ID_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_STRATEGY_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_STRATEGY_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_STRATEGY_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID_VARIANCE_SAMPLE_STRATEGY_DESC",
  REPORTED_CLAIMS_BY_CLAIM_ID__COUNT_ASC = "REPORTED_CLAIMS_BY_CLAIM_ID__COUNT_ASC",
  REPORTED_CLAIMS_BY_CLAIM_ID__COUNT_DESC = "REPORTED_CLAIMS_BY_CLAIM_ID__COUNT_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_BATCH_CLAIM_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_BATCH_CLAIM_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_BATCH_CLAIM_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_BATCH_CLAIM_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_ETAG_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_ETAG_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_ETAG_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_ETAG_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_FILENAME_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_FILENAME_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_FILENAME_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_FILENAME_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_ICN_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_ICN_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_ICN_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_ICN_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_IS_UPLOADED_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_IS_UPLOADED_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_IS_UPLOADED_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_IS_UPLOADED_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_LAST_MODIFIED_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_LAST_MODIFIED_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_LAST_MODIFIED_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_LAST_MODIFIED_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_ORIGINAL_FILE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_ORIGINAL_FILE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_ORIGINAL_FILE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_ORIGINAL_FILE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_PROVIDER_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_PROVIDER_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_PROVIDER_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_PROVIDER_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_S3_KEY_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_S3_KEY_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_S3_KEY_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_S3_KEY_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_SIZE_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_SIZE_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_SIZE_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_SIZE_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_SUB_FILE_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_SUB_FILE_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_SUB_FILE_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_SUB_FILE_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_SUB_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_SUB_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_SUB_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_SUB_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_TAGS_ASC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_TAGS_ASC",
  S3_AUDIT_DOCUMENTATIONS_AVERAGE_TAGS_DESC = "S3_AUDIT_DOCUMENTATIONS_AVERAGE_TAGS_DESC",
  S3_AUDIT_DOCUMENTATIONS_BY_BATCH_CLAIM_ID__COUNT_ASC = "S3_AUDIT_DOCUMENTATIONS_BY_BATCH_CLAIM_ID__COUNT_ASC",
  S3_AUDIT_DOCUMENTATIONS_BY_BATCH_CLAIM_ID__COUNT_DESC = "S3_AUDIT_DOCUMENTATIONS_BY_BATCH_CLAIM_ID__COUNT_DESC",
  S3_AUDIT_DOCUMENTATIONS_COUNT_ASC = "S3_AUDIT_DOCUMENTATIONS_COUNT_ASC",
  S3_AUDIT_DOCUMENTATIONS_COUNT_DESC = "S3_AUDIT_DOCUMENTATIONS_COUNT_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ETAG_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ETAG_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ETAG_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ETAG_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_FILENAME_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_FILENAME_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_FILENAME_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_FILENAME_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ICN_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ICN_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ICN_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ICN_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_IS_UPLOADED_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_IS_UPLOADED_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_IS_UPLOADED_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_IS_UPLOADED_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_LAST_MODIFIED_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_LAST_MODIFIED_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_LAST_MODIFIED_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_LAST_MODIFIED_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ORIGINAL_FILE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ORIGINAL_FILE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ORIGINAL_FILE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_ORIGINAL_FILE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_PROVIDER_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_PROVIDER_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_S3_KEY_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_S3_KEY_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_S3_KEY_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_S3_KEY_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SIZE_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SIZE_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SIZE_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SIZE_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SUB_FILE_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SUB_FILE_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SUB_FILE_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SUB_FILE_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SUB_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SUB_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SUB_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_SUB_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_TAGS_ASC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_TAGS_ASC",
  S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_TAGS_DESC = "S3_AUDIT_DOCUMENTATIONS_DISTINCT_COUNT_TAGS_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_BATCH_CLAIM_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_BATCH_CLAIM_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_BATCH_CLAIM_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_BATCH_CLAIM_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_ETAG_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_ETAG_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_ETAG_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_ETAG_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_FILENAME_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_FILENAME_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_FILENAME_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_FILENAME_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_ICN_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_ICN_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_ICN_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_ICN_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_IS_UPLOADED_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_IS_UPLOADED_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_IS_UPLOADED_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_IS_UPLOADED_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_LAST_MODIFIED_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_LAST_MODIFIED_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_LAST_MODIFIED_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_LAST_MODIFIED_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_ORIGINAL_FILE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_ORIGINAL_FILE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_ORIGINAL_FILE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_ORIGINAL_FILE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_PROVIDER_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_PROVIDER_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_PROVIDER_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_PROVIDER_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_S3_KEY_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_S3_KEY_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_S3_KEY_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_S3_KEY_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_SIZE_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_SIZE_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_SIZE_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_SIZE_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_SUB_FILE_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_SUB_FILE_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_SUB_FILE_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_SUB_FILE_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_SUB_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_SUB_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_SUB_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_SUB_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_MAX_TAGS_ASC = "S3_AUDIT_DOCUMENTATIONS_MAX_TAGS_ASC",
  S3_AUDIT_DOCUMENTATIONS_MAX_TAGS_DESC = "S3_AUDIT_DOCUMENTATIONS_MAX_TAGS_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_BATCH_CLAIM_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_BATCH_CLAIM_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_BATCH_CLAIM_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_BATCH_CLAIM_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_ETAG_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_ETAG_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_ETAG_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_ETAG_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_FILENAME_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_FILENAME_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_FILENAME_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_FILENAME_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_ICN_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_ICN_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_ICN_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_ICN_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_IS_UPLOADED_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_IS_UPLOADED_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_IS_UPLOADED_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_IS_UPLOADED_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_LAST_MODIFIED_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_LAST_MODIFIED_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_LAST_MODIFIED_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_LAST_MODIFIED_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_ORIGINAL_FILE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_ORIGINAL_FILE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_ORIGINAL_FILE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_ORIGINAL_FILE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_PROVIDER_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_PROVIDER_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_PROVIDER_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_PROVIDER_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_S3_KEY_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_S3_KEY_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_S3_KEY_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_S3_KEY_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_SIZE_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_SIZE_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_SIZE_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_SIZE_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_SUB_FILE_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_SUB_FILE_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_SUB_FILE_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_SUB_FILE_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_SUB_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_SUB_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_SUB_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_SUB_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_MIN_TAGS_ASC = "S3_AUDIT_DOCUMENTATIONS_MIN_TAGS_ASC",
  S3_AUDIT_DOCUMENTATIONS_MIN_TAGS_DESC = "S3_AUDIT_DOCUMENTATIONS_MIN_TAGS_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ETAG_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ETAG_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ETAG_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ETAG_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_FILENAME_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_FILENAME_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_FILENAME_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_FILENAME_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ICN_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ICN_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ICN_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ICN_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_IS_UPLOADED_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_IS_UPLOADED_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_IS_UPLOADED_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_IS_UPLOADED_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_LAST_MODIFIED_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_LAST_MODIFIED_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_LAST_MODIFIED_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_LAST_MODIFIED_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ORIGINAL_FILE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ORIGINAL_FILE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ORIGINAL_FILE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_ORIGINAL_FILE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_PROVIDER_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_PROVIDER_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_S3_KEY_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_S3_KEY_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_S3_KEY_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_S3_KEY_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SIZE_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SIZE_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SIZE_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SIZE_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SUB_FILE_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SUB_FILE_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SUB_FILE_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SUB_FILE_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SUB_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SUB_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SUB_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_SUB_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_TAGS_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_TAGS_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_TAGS_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_POPULATION_TAGS_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ETAG_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ETAG_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ETAG_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ETAG_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_FILENAME_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_FILENAME_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_FILENAME_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_FILENAME_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ICN_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ICN_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ICN_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ICN_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_IS_UPLOADED_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_IS_UPLOADED_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_IS_UPLOADED_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_IS_UPLOADED_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_LAST_MODIFIED_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_LAST_MODIFIED_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_LAST_MODIFIED_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_LAST_MODIFIED_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ORIGINAL_FILE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ORIGINAL_FILE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ORIGINAL_FILE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_ORIGINAL_FILE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_S3_KEY_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_S3_KEY_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_S3_KEY_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_S3_KEY_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SIZE_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SIZE_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SIZE_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SIZE_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SUB_FILE_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SUB_FILE_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SUB_FILE_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SUB_FILE_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SUB_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SUB_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SUB_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_SUB_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_TAGS_ASC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_TAGS_ASC",
  S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_TAGS_DESC = "S3_AUDIT_DOCUMENTATIONS_STDDEV_SAMPLE_TAGS_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_BATCH_CLAIM_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_BATCH_CLAIM_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_BATCH_CLAIM_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_BATCH_CLAIM_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_ETAG_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_ETAG_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_ETAG_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_ETAG_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_FILENAME_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_FILENAME_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_FILENAME_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_FILENAME_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_ICN_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_ICN_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_ICN_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_ICN_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_IS_UPLOADED_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_IS_UPLOADED_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_IS_UPLOADED_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_IS_UPLOADED_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_LAST_MODIFIED_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_LAST_MODIFIED_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_LAST_MODIFIED_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_LAST_MODIFIED_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_ORIGINAL_FILE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_ORIGINAL_FILE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_ORIGINAL_FILE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_ORIGINAL_FILE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_PROVIDER_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_PROVIDER_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_PROVIDER_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_PROVIDER_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_S3_KEY_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_S3_KEY_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_S3_KEY_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_S3_KEY_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_SIZE_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_SIZE_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_SIZE_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_SIZE_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_SUB_FILE_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_SUB_FILE_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_SUB_FILE_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_SUB_FILE_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_SUB_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_SUB_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_SUB_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_SUB_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_SUM_TAGS_ASC = "S3_AUDIT_DOCUMENTATIONS_SUM_TAGS_ASC",
  S3_AUDIT_DOCUMENTATIONS_SUM_TAGS_DESC = "S3_AUDIT_DOCUMENTATIONS_SUM_TAGS_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ETAG_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ETAG_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ETAG_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ETAG_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_FILENAME_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_FILENAME_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_FILENAME_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_FILENAME_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ICN_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ICN_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ICN_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ICN_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_IS_UPLOADED_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_IS_UPLOADED_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_IS_UPLOADED_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_IS_UPLOADED_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_LAST_MODIFIED_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_LAST_MODIFIED_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_LAST_MODIFIED_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_LAST_MODIFIED_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ORIGINAL_FILE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ORIGINAL_FILE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ORIGINAL_FILE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_ORIGINAL_FILE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_S3_KEY_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_S3_KEY_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_S3_KEY_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_S3_KEY_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SIZE_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SIZE_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SIZE_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SIZE_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SUB_FILE_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SUB_FILE_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SUB_FILE_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SUB_FILE_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SUB_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SUB_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SUB_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_SUB_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_TAGS_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_TAGS_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_TAGS_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_POPULATION_TAGS_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ETAG_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ETAG_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ETAG_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ETAG_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_FILENAME_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_FILENAME_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_FILENAME_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_FILENAME_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ICN_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ICN_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ICN_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ICN_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_IS_UPLOADED_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_IS_UPLOADED_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_IS_UPLOADED_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_IS_UPLOADED_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_LAST_MODIFIED_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_LAST_MODIFIED_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_LAST_MODIFIED_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_LAST_MODIFIED_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ORIGINAL_FILE_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ORIGINAL_FILE_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ORIGINAL_FILE_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_ORIGINAL_FILE_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_S3_KEY_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_S3_KEY_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_S3_KEY_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_S3_KEY_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SIZE_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SIZE_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SIZE_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SIZE_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SUB_FILE_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SUB_FILE_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SUB_FILE_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SUB_FILE_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SUB_PROCESS_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SUB_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SUB_PROCESS_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_SUB_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_TAGS_ASC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_TAGS_ASC",
  S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_TAGS_DESC = "S3_AUDIT_DOCUMENTATIONS_VARIANCE_SAMPLE_TAGS_DESC",
  STAGE_SORT_ORDER_ASC = "STAGE_SORT_ORDER_ASC",
  STAGE_SORT_ORDER_DESC = "STAGE_SORT_ORDER_DESC",
  SUBMITTED_DRG_ASC = "SUBMITTED_DRG_ASC",
  SUBMITTED_DRG_DESC = "SUBMITTED_DRG_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
  VERSION_ASC = "VERSION_ASC",
  VERSION_DESC = "VERSION_DESC",
  VERSION_GROUP_ASC = "VERSION_GROUP_ASC",
  VERSION_GROUP_DESC = "VERSION_GROUP_DESC",
  WORKFLOW_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC = "WORKFLOW_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  WORKFLOW_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC = "WORKFLOW_CLAIM_STATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  WORKFLOW_CLAIM_STATES_AVERAGE_CREATED_AT_ASC = "WORKFLOW_CLAIM_STATES_AVERAGE_CREATED_AT_ASC",
  WORKFLOW_CLAIM_STATES_AVERAGE_CREATED_AT_DESC = "WORKFLOW_CLAIM_STATES_AVERAGE_CREATED_AT_DESC",
  WORKFLOW_CLAIM_STATES_AVERAGE_ID_ASC = "WORKFLOW_CLAIM_STATES_AVERAGE_ID_ASC",
  WORKFLOW_CLAIM_STATES_AVERAGE_ID_DESC = "WORKFLOW_CLAIM_STATES_AVERAGE_ID_DESC",
  WORKFLOW_CLAIM_STATES_AVERAGE_WORKFLOW_STATE_ASC = "WORKFLOW_CLAIM_STATES_AVERAGE_WORKFLOW_STATE_ASC",
  WORKFLOW_CLAIM_STATES_AVERAGE_WORKFLOW_STATE_DESC = "WORKFLOW_CLAIM_STATES_AVERAGE_WORKFLOW_STATE_DESC",
  WORKFLOW_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC = "WORKFLOW_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_ASC",
  WORKFLOW_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC = "WORKFLOW_CLAIM_STATES_BY_BATCH_CLAIM_ID__COUNT_DESC",
  WORKFLOW_CLAIM_STATES_COUNT_ASC = "WORKFLOW_CLAIM_STATES_COUNT_ASC",
  WORKFLOW_CLAIM_STATES_COUNT_DESC = "WORKFLOW_CLAIM_STATES_COUNT_DESC",
  WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC = "WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_ASC",
  WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC = "WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_CREATED_AT_DESC",
  WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_ID_ASC = "WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_ID_ASC",
  WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_ID_DESC = "WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_ID_DESC",
  WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_STATE_ASC = "WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_STATE_ASC",
  WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_STATE_DESC = "WORKFLOW_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_STATE_DESC",
  WORKFLOW_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC = "WORKFLOW_CLAIM_STATES_MAX_BATCH_CLAIM_ID_ASC",
  WORKFLOW_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC = "WORKFLOW_CLAIM_STATES_MAX_BATCH_CLAIM_ID_DESC",
  WORKFLOW_CLAIM_STATES_MAX_CREATED_AT_ASC = "WORKFLOW_CLAIM_STATES_MAX_CREATED_AT_ASC",
  WORKFLOW_CLAIM_STATES_MAX_CREATED_AT_DESC = "WORKFLOW_CLAIM_STATES_MAX_CREATED_AT_DESC",
  WORKFLOW_CLAIM_STATES_MAX_ID_ASC = "WORKFLOW_CLAIM_STATES_MAX_ID_ASC",
  WORKFLOW_CLAIM_STATES_MAX_ID_DESC = "WORKFLOW_CLAIM_STATES_MAX_ID_DESC",
  WORKFLOW_CLAIM_STATES_MAX_WORKFLOW_STATE_ASC = "WORKFLOW_CLAIM_STATES_MAX_WORKFLOW_STATE_ASC",
  WORKFLOW_CLAIM_STATES_MAX_WORKFLOW_STATE_DESC = "WORKFLOW_CLAIM_STATES_MAX_WORKFLOW_STATE_DESC",
  WORKFLOW_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC = "WORKFLOW_CLAIM_STATES_MIN_BATCH_CLAIM_ID_ASC",
  WORKFLOW_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC = "WORKFLOW_CLAIM_STATES_MIN_BATCH_CLAIM_ID_DESC",
  WORKFLOW_CLAIM_STATES_MIN_CREATED_AT_ASC = "WORKFLOW_CLAIM_STATES_MIN_CREATED_AT_ASC",
  WORKFLOW_CLAIM_STATES_MIN_CREATED_AT_DESC = "WORKFLOW_CLAIM_STATES_MIN_CREATED_AT_DESC",
  WORKFLOW_CLAIM_STATES_MIN_ID_ASC = "WORKFLOW_CLAIM_STATES_MIN_ID_ASC",
  WORKFLOW_CLAIM_STATES_MIN_ID_DESC = "WORKFLOW_CLAIM_STATES_MIN_ID_DESC",
  WORKFLOW_CLAIM_STATES_MIN_WORKFLOW_STATE_ASC = "WORKFLOW_CLAIM_STATES_MIN_WORKFLOW_STATE_ASC",
  WORKFLOW_CLAIM_STATES_MIN_WORKFLOW_STATE_DESC = "WORKFLOW_CLAIM_STATES_MIN_WORKFLOW_STATE_DESC",
  WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC = "WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_ASC",
  WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC = "WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_CREATED_AT_DESC",
  WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_ID_ASC = "WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_ID_ASC",
  WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_ID_DESC = "WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_ID_DESC",
  WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_STATE_ASC = "WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_STATE_ASC",
  WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_STATE_DESC = "WORKFLOW_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_STATE_DESC",
  WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC = "WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_ASC",
  WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC = "WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_CREATED_AT_DESC",
  WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC = "WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC",
  WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC = "WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC",
  WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_STATE_ASC = "WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_STATE_ASC",
  WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_STATE_DESC = "WORKFLOW_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_STATE_DESC",
  WORKFLOW_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC = "WORKFLOW_CLAIM_STATES_SUM_BATCH_CLAIM_ID_ASC",
  WORKFLOW_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC = "WORKFLOW_CLAIM_STATES_SUM_BATCH_CLAIM_ID_DESC",
  WORKFLOW_CLAIM_STATES_SUM_CREATED_AT_ASC = "WORKFLOW_CLAIM_STATES_SUM_CREATED_AT_ASC",
  WORKFLOW_CLAIM_STATES_SUM_CREATED_AT_DESC = "WORKFLOW_CLAIM_STATES_SUM_CREATED_AT_DESC",
  WORKFLOW_CLAIM_STATES_SUM_ID_ASC = "WORKFLOW_CLAIM_STATES_SUM_ID_ASC",
  WORKFLOW_CLAIM_STATES_SUM_ID_DESC = "WORKFLOW_CLAIM_STATES_SUM_ID_DESC",
  WORKFLOW_CLAIM_STATES_SUM_WORKFLOW_STATE_ASC = "WORKFLOW_CLAIM_STATES_SUM_WORKFLOW_STATE_ASC",
  WORKFLOW_CLAIM_STATES_SUM_WORKFLOW_STATE_DESC = "WORKFLOW_CLAIM_STATES_SUM_WORKFLOW_STATE_DESC",
  WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC = "WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_ASC",
  WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC = "WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_CREATED_AT_DESC",
  WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC = "WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC",
  WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC = "WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC",
  WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_STATE_ASC = "WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_STATE_ASC",
  WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_STATE_DESC = "WORKFLOW_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_STATE_DESC",
  WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC = "WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC = "WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC = "WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC",
  WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC = "WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC",
  WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_STATE_ASC = "WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_STATE_ASC",
  WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_STATE_DESC = "WORKFLOW_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_STATE_DESC",
}

export type BatchFile = Node & {
  __typename?: "BatchFile";
  /** Reads and enables pagination through a set of `AuditFindingJob`. */
  auditFindingJobs: AuditFindingJobsConnection;
  /** Reads a single `AuditorUser` that is related to this `BatchFile`. */
  author?: Maybe<AuditorUser>;
  authorId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `BatchClaim`. */
  batchClaims: BatchClaimsConnection;
  batchFileName: Scalars["String"]["output"];
  batchFileUrl?: Maybe<Scalars["String"]["output"]>;
  batchName: Scalars["String"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /**
   * ### Overview
   * Calculates improper payment cost per batch file using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  /** Reads a single `Insurer` that is related to this `BatchFile`. */
  insurer?: Maybe<Insurer>;
  /** Historically batch_files contained only claims for a single insurer record.  This is no longer true as claims are split between insurer groups, which are currently modeled as seperate entries in the insurer table.  This field is no longer required. */
  insurerId?: Maybe<Scalars["UUID"]["output"]>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  ownerId?: Maybe<Scalars["UUID"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

export type BatchFileauditFindingJobsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingJobCondition>;
  filter?: InputMaybe<AuditFindingJobFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingJobsOrderBy>>;
};

export type BatchFilebatchClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimCondition>;
  filter?: InputMaybe<BatchClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimsOrderBy>>;
};

export type BatchFileimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchFileAggregates = {
  __typename?: "BatchFileAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BatchFileAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BatchFileDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BatchFileMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BatchFileMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BatchFileStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BatchFileStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BatchFileSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BatchFileVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BatchFileVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BatchFile` object types. */
export type BatchFileAggregatesFilter = {
  /** Mean average aggregate over matching `BatchFile` objects. */
  average?: InputMaybe<BatchFileAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BatchFile` objects. */
  distinctCount?: InputMaybe<BatchFileDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BatchFile` object to be included within the aggregate. */
  filter?: InputMaybe<BatchFileFilter>;
  /** Maximum aggregate over matching `BatchFile` objects. */
  max?: InputMaybe<BatchFileMaxAggregateFilter>;
  /** Minimum aggregate over matching `BatchFile` objects. */
  min?: InputMaybe<BatchFileMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BatchFile` objects. */
  stddevPopulation?: InputMaybe<BatchFileStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BatchFile` objects. */
  stddevSample?: InputMaybe<BatchFileStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BatchFile` objects. */
  sum?: InputMaybe<BatchFileSumAggregateFilter>;
  /** Population variance aggregate over matching `BatchFile` objects. */
  variancePopulation?: InputMaybe<BatchFileVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BatchFile` objects. */
  varianceSample?: InputMaybe<BatchFileVarianceSampleAggregateFilter>;
};

/** Input for the nested mutation of `auditorUser` in the `BatchFileInput` mutation. */
export type BatchFileAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnBatchFileForBatchFileAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnBatchFileForBatchFileAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnBatchFileForBatchFileAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchFileOnBatchFileForBatchFileAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchFile` in the `AuditorUserInput` mutation. */
export type BatchFileAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `batchFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BatchFileBatchFilePkeyConnect>>;
  /** The primary key(s) for `batchFile` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchFileNodeIdConnect>>;
  /** The primary key(s) and patch data for `batchFile` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchFileOnBatchFileForBatchFileAuthorIdFkeyUsingBatchFilePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchFile` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnBatchFileForBatchFileAuthorIdFkeyNodeIdUpdate>
  >;
};

export type BatchFileAverageAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type BatchFileAverageAggregates = {
  __typename?: "BatchFileAverageAggregates";
  /**
   * Mean average of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Calculates improper payment cost per batch file using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchFileAverageAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The fields on `batchFile` to look up the row to connect. */
export type BatchFileBatchFilePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `BatchFile` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BatchFileCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchFileName` field. */
  batchFileName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `batchFileUrl` field. */
  batchFileUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `batchName` field. */
  batchName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `insurerId` field. */
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `ownerId` field. */
  ownerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type BatchFileDistinctCountAggregateFilter = {
  authorId?: InputMaybe<BigIntFilter>;
  batchFileName?: InputMaybe<BigIntFilter>;
  batchFileUrl?: InputMaybe<BigIntFilter>;
  batchName?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  improperPaymentCost?: InputMaybe<FloatFilter>;
  insurerId?: InputMaybe<BigIntFilter>;
  ownerId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type BatchFileDistinctCountAggregates = {
  __typename?: "BatchFileDistinctCountAggregates";
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchFileName across the matching connection */
  batchFileName?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchFileUrl across the matching connection */
  batchFileUrl?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchName across the matching connection */
  batchName?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Calculates improper payment cost per batch file using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of insurerId across the matching connection */
  insurerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of ownerId across the matching connection */
  ownerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

export type BatchFileDistinctCountAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A filter to be used against `BatchFile` object types. All fields are combined with a logical ‘and.’ */
export type BatchFileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchFileFilter>>;
  /** Filter by the object’s `auditFindingJobs` relation. */
  auditFindingJobs?: InputMaybe<BatchFileToManyAuditFindingJobFilter>;
  /** Some related `auditFindingJobs` exist. */
  auditFindingJobsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** A related `author` exists. */
  authorExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaims` relation. */
  batchClaims?: InputMaybe<BatchFileToManyBatchClaimFilter>;
  /** Some related `batchClaims` exist. */
  batchClaimsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchFileName` field. */
  batchFileName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `batchFileUrl` field. */
  batchFileUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `batchName` field. */
  batchName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `improperPaymentCost` field. */
  improperPaymentCost?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `insurer` relation. */
  insurer?: InputMaybe<InsurerFilter>;
  /** A related `insurer` exists. */
  insurerExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `insurerId` field. */
  insurerId?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchFileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchFileFilter>>;
  /** Filter by the object’s `ownerId` field. */
  ownerId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BatchFile` for usage during aggregation. */
export enum BatchFileGroupBy {
  AUTHOR_ID = "AUTHOR_ID",
  BATCH_FILE_NAME = "BATCH_FILE_NAME",
  BATCH_FILE_URL = "BATCH_FILE_URL",
  BATCH_NAME = "BATCH_NAME",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  INSURER_ID = "INSURER_ID",
  OWNER_ID = "OWNER_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type BatchFileHavingAverageBatchFileImproperPaymentCostArgsInput = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchFileHavingAverageBatchFileImproperPaymentCostInput = {
  args?: InputMaybe<BatchFileHavingAverageBatchFileImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchFileHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<BatchFileHavingAverageBatchFileImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchFileHavingDistinctCountBatchFileImproperPaymentCostArgsInput =
  {
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type BatchFileHavingDistinctCountBatchFileImproperPaymentCostInput = {
  args?: InputMaybe<BatchFileHavingDistinctCountBatchFileImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchFileHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<BatchFileHavingDistinctCountBatchFileImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BatchFile` aggregates. */
export type BatchFileHavingInput = {
  AND?: InputMaybe<Array<BatchFileHavingInput>>;
  OR?: InputMaybe<Array<BatchFileHavingInput>>;
  average?: InputMaybe<BatchFileHavingAverageInput>;
  distinctCount?: InputMaybe<BatchFileHavingDistinctCountInput>;
  max?: InputMaybe<BatchFileHavingMaxInput>;
  min?: InputMaybe<BatchFileHavingMinInput>;
  stddevPopulation?: InputMaybe<BatchFileHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BatchFileHavingStddevSampleInput>;
  sum?: InputMaybe<BatchFileHavingSumInput>;
  variancePopulation?: InputMaybe<BatchFileHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BatchFileHavingVarianceSampleInput>;
};

export type BatchFileHavingMaxBatchFileImproperPaymentCostArgsInput = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchFileHavingMaxBatchFileImproperPaymentCostInput = {
  args?: InputMaybe<BatchFileHavingMaxBatchFileImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchFileHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<BatchFileHavingMaxBatchFileImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchFileHavingMinBatchFileImproperPaymentCostArgsInput = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchFileHavingMinBatchFileImproperPaymentCostInput = {
  args?: InputMaybe<BatchFileHavingMinBatchFileImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchFileHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<BatchFileHavingMinBatchFileImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchFileHavingStddevPopulationBatchFileImproperPaymentCostArgsInput =
  {
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type BatchFileHavingStddevPopulationBatchFileImproperPaymentCostInput = {
  args?: InputMaybe<BatchFileHavingStddevPopulationBatchFileImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchFileHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<BatchFileHavingStddevPopulationBatchFileImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchFileHavingStddevSampleBatchFileImproperPaymentCostArgsInput = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchFileHavingStddevSampleBatchFileImproperPaymentCostInput = {
  args?: InputMaybe<BatchFileHavingStddevSampleBatchFileImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchFileHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<BatchFileHavingStddevSampleBatchFileImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchFileHavingSumBatchFileImproperPaymentCostArgsInput = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchFileHavingSumBatchFileImproperPaymentCostInput = {
  args?: InputMaybe<BatchFileHavingSumBatchFileImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchFileHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<BatchFileHavingSumBatchFileImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchFileHavingVariancePopulationBatchFileImproperPaymentCostArgsInput =
  {
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type BatchFileHavingVariancePopulationBatchFileImproperPaymentCostInput =
  {
    args?: InputMaybe<BatchFileHavingVariancePopulationBatchFileImproperPaymentCostArgsInput>;
    filter?: InputMaybe<HavingFloatFilter>;
  };

export type BatchFileHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<BatchFileHavingVariancePopulationBatchFileImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BatchFileHavingVarianceSampleBatchFileImproperPaymentCostArgsInput =
  {
    autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type BatchFileHavingVarianceSampleBatchFileImproperPaymentCostInput = {
  args?: InputMaybe<BatchFileHavingVarianceSampleBatchFileImproperPaymentCostArgsInput>;
  filter?: InputMaybe<HavingFloatFilter>;
};

export type BatchFileHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  improperPaymentCost?: InputMaybe<BatchFileHavingVarianceSampleBatchFileImproperPaymentCostInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Input for the nested mutation of `insurer` in the `BatchFileInput` mutation. */
export type BatchFileInsurerIdFkeyInput = {
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByClientAbbreviation?: InputMaybe<InsurerInsurerUniqueClientAbbreviationConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectById?: InputMaybe<InsurerInsurerPkeyConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByName?: InputMaybe<InsurerInsurerUniqueNameConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<InsurerNodeIdConnect>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByClientAbbreviation?: InputMaybe<InsurerOnBatchFileForBatchFileInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateById?: InputMaybe<InsurerOnBatchFileForBatchFileInsurerIdFkeyUsingInsurerPkeyUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByName?: InputMaybe<InsurerOnBatchFileForBatchFileInsurerIdFkeyUsingInsurerUniqueNameUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchFileOnBatchFileForBatchFileInsurerIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `batchFile` in the `InsurerInput` mutation. */
export type BatchFileInsurerIdFkeyInverseInput = {
  /** The primary key(s) for `batchFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BatchFileBatchFilePkeyConnect>>;
  /** The primary key(s) for `batchFile` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BatchFileNodeIdConnect>>;
  /** The primary key(s) and patch data for `batchFile` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BatchFileOnBatchFileForBatchFileInsurerIdFkeyUsingBatchFilePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `batchFile` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<InsurerOnBatchFileForBatchFileInsurerIdFkeyNodeIdUpdate>
  >;
};

export type BatchFileMaxAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type BatchFileMaxAggregates = {
  __typename?: "BatchFileMaxAggregates";
  /**
   * Maximum of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Calculates improper payment cost per batch file using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchFileMaxAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchFileMinAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type BatchFileMinAggregates = {
  __typename?: "BatchFileMinAggregates";
  /**
   * Minimum of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Calculates improper payment cost per batch file using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchFileMinAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BatchFileNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `batchFile` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BatchFileOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingJob` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingJob` being updated. */
    patch: AuditFindingJobPatch;
  };

/** The fields on `batchFile` to look up the row to update. */
export type BatchFileOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyUsingBatchFilePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchFile` being updated. */
    patch: updateBatchFileOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchFileOnBatchClaimForBatchClaimBatchFileIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `batchClaim` being updated. */
  patch: BatchClaimPatch;
};

/** The fields on `batchFile` to look up the row to update. */
export type BatchFileOnBatchClaimForBatchClaimBatchFileIdFkeyUsingBatchFilePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchFile` being updated. */
    patch: updateBatchFileOnBatchClaimForBatchClaimBatchFileIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchFileOnBatchFileForBatchFileAuthorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `auditorUser` being updated. */
  patch: AuditorUserPatch;
};

/** The fields on `batchFile` to look up the row to update. */
export type BatchFileOnBatchFileForBatchFileAuthorIdFkeyUsingBatchFilePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchFile` being updated. */
    patch: updateBatchFileOnBatchFileForBatchFileAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BatchFileOnBatchFileForBatchFileInsurerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `insurer` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `insurer` being updated. */
  patch: InsurerPatch;
};

/** The fields on `batchFile` to look up the row to update. */
export type BatchFileOnBatchFileForBatchFileInsurerIdFkeyUsingBatchFilePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `batchFile` being updated. */
    patch: updateBatchFileOnBatchFileForBatchFileInsurerIdFkeyPatch;
  };

/** Represents an update to a `BatchFile`. Fields that are set will be updated. */
export type BatchFilePatch = {
  auditFindingJobsUsingId?: InputMaybe<AuditFindingJobBatchFileIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchFileAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimsUsingId?: InputMaybe<BatchClaimBatchFileIdFkeyInverseInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<BatchFileInsurerIdFkeyInput>;
};

export type BatchFileStddevPopulationAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type BatchFileStddevPopulationAggregates = {
  __typename?: "BatchFileStddevPopulationAggregates";
  /**
   * Population standard deviation of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Calculates improper payment cost per batch file using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchFileStddevPopulationAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchFileStddevSampleAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type BatchFileStddevSampleAggregates = {
  __typename?: "BatchFileStddevSampleAggregates";
  /**
   * Sample standard deviation of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Calculates improper payment cost per batch file using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchFileStddevSampleAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchFileSumAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type BatchFileSumAggregates = {
  __typename?: "BatchFileSumAggregates";
  /**
   * Sum of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Calculates improper payment cost per batch file using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchFileSumAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A filter to be used against many `AuditFindingJob` object types. All fields are combined with a logical ‘and.’ */
export type BatchFileToManyAuditFindingJobFilter = {
  /** Aggregates across related `AuditFindingJob` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingJobAggregatesFilter>;
  /** Every related `AuditFindingJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingJobFilter>;
  /** No related `AuditFindingJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingJobFilter>;
  /** Some related `AuditFindingJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingJobFilter>;
};

/** A filter to be used against many `BatchClaim` object types. All fields are combined with a logical ‘and.’ */
export type BatchFileToManyBatchClaimFilter = {
  /** Aggregates across related `BatchClaim` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAggregatesFilter>;
  /** Every related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimFilter>;
  /** No related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimFilter>;
  /** Some related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimFilter>;
};

export type BatchFileVariancePopulationAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type BatchFileVariancePopulationAggregates = {
  __typename?: "BatchFileVariancePopulationAggregates";
  /**
   * Population variance of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Calculates improper payment cost per batch file using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchFileVariancePopulationAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BatchFileVarianceSampleAggregateFilter = {
  improperPaymentCost?: InputMaybe<FloatFilter>;
};

export type BatchFileVarianceSampleAggregates = {
  __typename?: "BatchFileVarianceSampleAggregates";
  /**
   * Sample variance of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Calculates improper payment cost per batch file using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
};

export type BatchFileVarianceSampleAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A connection to a list of `BatchFile` values. */
export type BatchFilesConnection = {
  __typename?: "BatchFilesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BatchFileAggregates>;
  /** A list of edges which contains the `BatchFile` and cursor to aid in pagination. */
  edges: Array<BatchFilesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BatchFileAggregates>>;
  /** A list of `BatchFile` objects. */
  nodes: Array<Maybe<BatchFile>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchFile` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BatchFile` values. */
export type BatchFilesConnectiongroupedAggregatesArgs = {
  groupBy: Array<BatchFileGroupBy>;
  having?: InputMaybe<BatchFileHavingInput>;
};

/** A `BatchFile` edge in the connection. */
export type BatchFilesEdge = {
  __typename?: "BatchFilesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BatchFile` at the end of the edge. */
  node?: Maybe<BatchFile>;
};

/** Methods to use when ordering `BatchFile`. */
export enum BatchFilesOrderBy {
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUDIT_FINDING_JOBS_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDING_JOBS_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDING_JOBS_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDING_JOBS_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDING_JOBS_AVERAGE_BATCH_FILE_ID_ASC = "AUDIT_FINDING_JOBS_AVERAGE_BATCH_FILE_ID_ASC",
  AUDIT_FINDING_JOBS_AVERAGE_BATCH_FILE_ID_DESC = "AUDIT_FINDING_JOBS_AVERAGE_BATCH_FILE_ID_DESC",
  AUDIT_FINDING_JOBS_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDING_JOBS_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDING_JOBS_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDING_JOBS_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDING_JOBS_AVERAGE_ID_ASC = "AUDIT_FINDING_JOBS_AVERAGE_ID_ASC",
  AUDIT_FINDING_JOBS_AVERAGE_ID_DESC = "AUDIT_FINDING_JOBS_AVERAGE_ID_DESC",
  AUDIT_FINDING_JOBS_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDING_JOBS_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDING_JOBS_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDING_JOBS_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDING_JOBS_BY_BATCH_FILE_ID__COUNT_ASC = "AUDIT_FINDING_JOBS_BY_BATCH_FILE_ID__COUNT_ASC",
  AUDIT_FINDING_JOBS_BY_BATCH_FILE_ID__COUNT_DESC = "AUDIT_FINDING_JOBS_BY_BATCH_FILE_ID__COUNT_DESC",
  AUDIT_FINDING_JOBS_COUNT_ASC = "AUDIT_FINDING_JOBS_COUNT_ASC",
  AUDIT_FINDING_JOBS_COUNT_DESC = "AUDIT_FINDING_JOBS_COUNT_DESC",
  AUDIT_FINDING_JOBS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDING_JOBS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDING_JOBS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDING_JOBS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDING_JOBS_DISTINCT_COUNT_BATCH_FILE_ID_ASC = "AUDIT_FINDING_JOBS_DISTINCT_COUNT_BATCH_FILE_ID_ASC",
  AUDIT_FINDING_JOBS_DISTINCT_COUNT_BATCH_FILE_ID_DESC = "AUDIT_FINDING_JOBS_DISTINCT_COUNT_BATCH_FILE_ID_DESC",
  AUDIT_FINDING_JOBS_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDING_JOBS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDING_JOBS_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDING_JOBS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDING_JOBS_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDING_JOBS_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDING_JOBS_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDING_JOBS_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDING_JOBS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDING_JOBS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDING_JOBS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDING_JOBS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDING_JOBS_MAX_AUTHOR_ID_ASC = "AUDIT_FINDING_JOBS_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDING_JOBS_MAX_AUTHOR_ID_DESC = "AUDIT_FINDING_JOBS_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDING_JOBS_MAX_BATCH_FILE_ID_ASC = "AUDIT_FINDING_JOBS_MAX_BATCH_FILE_ID_ASC",
  AUDIT_FINDING_JOBS_MAX_BATCH_FILE_ID_DESC = "AUDIT_FINDING_JOBS_MAX_BATCH_FILE_ID_DESC",
  AUDIT_FINDING_JOBS_MAX_CREATED_AT_ASC = "AUDIT_FINDING_JOBS_MAX_CREATED_AT_ASC",
  AUDIT_FINDING_JOBS_MAX_CREATED_AT_DESC = "AUDIT_FINDING_JOBS_MAX_CREATED_AT_DESC",
  AUDIT_FINDING_JOBS_MAX_ID_ASC = "AUDIT_FINDING_JOBS_MAX_ID_ASC",
  AUDIT_FINDING_JOBS_MAX_ID_DESC = "AUDIT_FINDING_JOBS_MAX_ID_DESC",
  AUDIT_FINDING_JOBS_MAX_UPDATED_AT_ASC = "AUDIT_FINDING_JOBS_MAX_UPDATED_AT_ASC",
  AUDIT_FINDING_JOBS_MAX_UPDATED_AT_DESC = "AUDIT_FINDING_JOBS_MAX_UPDATED_AT_DESC",
  AUDIT_FINDING_JOBS_MIN_AUTHOR_ID_ASC = "AUDIT_FINDING_JOBS_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDING_JOBS_MIN_AUTHOR_ID_DESC = "AUDIT_FINDING_JOBS_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDING_JOBS_MIN_BATCH_FILE_ID_ASC = "AUDIT_FINDING_JOBS_MIN_BATCH_FILE_ID_ASC",
  AUDIT_FINDING_JOBS_MIN_BATCH_FILE_ID_DESC = "AUDIT_FINDING_JOBS_MIN_BATCH_FILE_ID_DESC",
  AUDIT_FINDING_JOBS_MIN_CREATED_AT_ASC = "AUDIT_FINDING_JOBS_MIN_CREATED_AT_ASC",
  AUDIT_FINDING_JOBS_MIN_CREATED_AT_DESC = "AUDIT_FINDING_JOBS_MIN_CREATED_AT_DESC",
  AUDIT_FINDING_JOBS_MIN_ID_ASC = "AUDIT_FINDING_JOBS_MIN_ID_ASC",
  AUDIT_FINDING_JOBS_MIN_ID_DESC = "AUDIT_FINDING_JOBS_MIN_ID_DESC",
  AUDIT_FINDING_JOBS_MIN_UPDATED_AT_ASC = "AUDIT_FINDING_JOBS_MIN_UPDATED_AT_ASC",
  AUDIT_FINDING_JOBS_MIN_UPDATED_AT_DESC = "AUDIT_FINDING_JOBS_MIN_UPDATED_AT_DESC",
  AUDIT_FINDING_JOBS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_JOBS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_JOBS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_JOBS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_JOBS_STDDEV_POPULATION_BATCH_FILE_ID_ASC = "AUDIT_FINDING_JOBS_STDDEV_POPULATION_BATCH_FILE_ID_ASC",
  AUDIT_FINDING_JOBS_STDDEV_POPULATION_BATCH_FILE_ID_DESC = "AUDIT_FINDING_JOBS_STDDEV_POPULATION_BATCH_FILE_ID_DESC",
  AUDIT_FINDING_JOBS_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_JOBS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_JOBS_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_JOBS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_JOBS_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDING_JOBS_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDING_JOBS_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDING_JOBS_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDING_JOBS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_JOBS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_JOBS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_JOBS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_JOBS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_JOBS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_JOBS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_JOBS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_JOBS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC = "AUDIT_FINDING_JOBS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC",
  AUDIT_FINDING_JOBS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC = "AUDIT_FINDING_JOBS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC",
  AUDIT_FINDING_JOBS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_JOBS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_JOBS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_JOBS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_JOBS_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDING_JOBS_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDING_JOBS_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDING_JOBS_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDING_JOBS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_JOBS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_JOBS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_JOBS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_JOBS_SUM_AUTHOR_ID_ASC = "AUDIT_FINDING_JOBS_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDING_JOBS_SUM_AUTHOR_ID_DESC = "AUDIT_FINDING_JOBS_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDING_JOBS_SUM_BATCH_FILE_ID_ASC = "AUDIT_FINDING_JOBS_SUM_BATCH_FILE_ID_ASC",
  AUDIT_FINDING_JOBS_SUM_BATCH_FILE_ID_DESC = "AUDIT_FINDING_JOBS_SUM_BATCH_FILE_ID_DESC",
  AUDIT_FINDING_JOBS_SUM_CREATED_AT_ASC = "AUDIT_FINDING_JOBS_SUM_CREATED_AT_ASC",
  AUDIT_FINDING_JOBS_SUM_CREATED_AT_DESC = "AUDIT_FINDING_JOBS_SUM_CREATED_AT_DESC",
  AUDIT_FINDING_JOBS_SUM_ID_ASC = "AUDIT_FINDING_JOBS_SUM_ID_ASC",
  AUDIT_FINDING_JOBS_SUM_ID_DESC = "AUDIT_FINDING_JOBS_SUM_ID_DESC",
  AUDIT_FINDING_JOBS_SUM_UPDATED_AT_ASC = "AUDIT_FINDING_JOBS_SUM_UPDATED_AT_ASC",
  AUDIT_FINDING_JOBS_SUM_UPDATED_AT_DESC = "AUDIT_FINDING_JOBS_SUM_UPDATED_AT_DESC",
  AUDIT_FINDING_JOBS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_JOBS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_JOBS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_JOBS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_JOBS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC = "AUDIT_FINDING_JOBS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC",
  AUDIT_FINDING_JOBS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC = "AUDIT_FINDING_JOBS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC",
  AUDIT_FINDING_JOBS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_JOBS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_JOBS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_JOBS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_JOBS_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDING_JOBS_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDING_JOBS_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDING_JOBS_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDING_JOBS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_JOBS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_JOBS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_JOBS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC = "AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC",
  AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC = "AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC",
  AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_JOBS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_AVERAGE_ADM_TYPE_ASC = "BATCH_CLAIMS_AVERAGE_ADM_TYPE_ASC",
  BATCH_CLAIMS_AVERAGE_ADM_TYPE_DESC = "BATCH_CLAIMS_AVERAGE_ADM_TYPE_DESC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_AVERAGE_APR_DRG_ASC = "BATCH_CLAIMS_AVERAGE_APR_DRG_ASC",
  BATCH_CLAIMS_AVERAGE_APR_DRG_DESC = "BATCH_CLAIMS_AVERAGE_APR_DRG_DESC",
  BATCH_CLAIMS_AVERAGE_AUTHOR_ID_ASC = "BATCH_CLAIMS_AVERAGE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_AVERAGE_AUTHOR_ID_DESC = "BATCH_CLAIMS_AVERAGE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_AVERAGE_BILL_TYPE_ASC = "BATCH_CLAIMS_AVERAGE_BILL_TYPE_ASC",
  BATCH_CLAIMS_AVERAGE_BILL_TYPE_DESC = "BATCH_CLAIMS_AVERAGE_BILL_TYPE_DESC",
  BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_ICN_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_ICN_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIMS_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIMS_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIMS_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_ADMIT_ASC = "BATCH_CLAIMS_AVERAGE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_ADMIT_DESC = "BATCH_CLAIMS_AVERAGE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_1_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_1_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_1_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_1_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_2_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_2_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_2_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_2_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_3_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_3_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_3_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_3_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_4_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_4_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_4_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_4_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_5_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_5_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_5_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_5_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_6_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_6_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_6_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_6_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_7_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_7_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_7_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_7_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_8_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_8_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_8_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_8_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_9_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_9_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_9_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_9_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_10_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_10_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_10_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_10_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_11_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_11_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_11_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_11_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_12_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_12_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_12_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_12_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_13_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_13_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_13_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_13_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_14_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_14_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_14_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_14_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_15_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_15_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_15_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_15_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_16_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_16_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_16_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_16_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_17_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_17_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_17_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_17_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_18_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_18_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_18_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_18_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_19_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_19_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_19_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_19_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_20_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_20_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_20_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_20_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_21_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_21_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_21_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_21_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_22_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_22_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_22_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_22_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_23_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_23_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_23_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_23_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_24_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_24_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_24_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_24_DESC",
  BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_AVERAGE_DRG_CODE_ASC = "BATCH_CLAIMS_AVERAGE_DRG_CODE_ASC",
  BATCH_CLAIMS_AVERAGE_DRG_CODE_DESC = "BATCH_CLAIMS_AVERAGE_DRG_CODE_DESC",
  BATCH_CLAIMS_AVERAGE_ICN_ASC = "BATCH_CLAIMS_AVERAGE_ICN_ASC",
  BATCH_CLAIMS_AVERAGE_ICN_DESC = "BATCH_CLAIMS_AVERAGE_ICN_DESC",
  BATCH_CLAIMS_AVERAGE_ID_ASC = "BATCH_CLAIMS_AVERAGE_ID_ASC",
  BATCH_CLAIMS_AVERAGE_ID_DESC = "BATCH_CLAIMS_AVERAGE_ID_DESC",
  BATCH_CLAIMS_AVERAGE_INSURER_ID_ASC = "BATCH_CLAIMS_AVERAGE_INSURER_ID_ASC",
  BATCH_CLAIMS_AVERAGE_INSURER_ID_DESC = "BATCH_CLAIMS_AVERAGE_INSURER_ID_DESC",
  BATCH_CLAIMS_AVERAGE_OWNER_ID_ASC = "BATCH_CLAIMS_AVERAGE_OWNER_ID_ASC",
  BATCH_CLAIMS_AVERAGE_OWNER_ID_DESC = "BATCH_CLAIMS_AVERAGE_OWNER_ID_DESC",
  BATCH_CLAIMS_AVERAGE_PAID_DATE_ASC = "BATCH_CLAIMS_AVERAGE_PAID_DATE_ASC",
  BATCH_CLAIMS_AVERAGE_PAID_DATE_DESC = "BATCH_CLAIMS_AVERAGE_PAID_DATE_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_DOB_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_DOB_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_ID_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_ID_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_ID_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_ID_DESC",
  BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_AVERAGE_POA_1_ASC = "BATCH_CLAIMS_AVERAGE_POA_1_ASC",
  BATCH_CLAIMS_AVERAGE_POA_1_DESC = "BATCH_CLAIMS_AVERAGE_POA_1_DESC",
  BATCH_CLAIMS_AVERAGE_POA_2_ASC = "BATCH_CLAIMS_AVERAGE_POA_2_ASC",
  BATCH_CLAIMS_AVERAGE_POA_2_DESC = "BATCH_CLAIMS_AVERAGE_POA_2_DESC",
  BATCH_CLAIMS_AVERAGE_POA_3_ASC = "BATCH_CLAIMS_AVERAGE_POA_3_ASC",
  BATCH_CLAIMS_AVERAGE_POA_3_DESC = "BATCH_CLAIMS_AVERAGE_POA_3_DESC",
  BATCH_CLAIMS_AVERAGE_POA_4_ASC = "BATCH_CLAIMS_AVERAGE_POA_4_ASC",
  BATCH_CLAIMS_AVERAGE_POA_4_DESC = "BATCH_CLAIMS_AVERAGE_POA_4_DESC",
  BATCH_CLAIMS_AVERAGE_POA_5_ASC = "BATCH_CLAIMS_AVERAGE_POA_5_ASC",
  BATCH_CLAIMS_AVERAGE_POA_5_DESC = "BATCH_CLAIMS_AVERAGE_POA_5_DESC",
  BATCH_CLAIMS_AVERAGE_POA_6_ASC = "BATCH_CLAIMS_AVERAGE_POA_6_ASC",
  BATCH_CLAIMS_AVERAGE_POA_6_DESC = "BATCH_CLAIMS_AVERAGE_POA_6_DESC",
  BATCH_CLAIMS_AVERAGE_POA_7_ASC = "BATCH_CLAIMS_AVERAGE_POA_7_ASC",
  BATCH_CLAIMS_AVERAGE_POA_7_DESC = "BATCH_CLAIMS_AVERAGE_POA_7_DESC",
  BATCH_CLAIMS_AVERAGE_POA_8_ASC = "BATCH_CLAIMS_AVERAGE_POA_8_ASC",
  BATCH_CLAIMS_AVERAGE_POA_8_DESC = "BATCH_CLAIMS_AVERAGE_POA_8_DESC",
  BATCH_CLAIMS_AVERAGE_POA_9_ASC = "BATCH_CLAIMS_AVERAGE_POA_9_ASC",
  BATCH_CLAIMS_AVERAGE_POA_9_DESC = "BATCH_CLAIMS_AVERAGE_POA_9_DESC",
  BATCH_CLAIMS_AVERAGE_POA_10_ASC = "BATCH_CLAIMS_AVERAGE_POA_10_ASC",
  BATCH_CLAIMS_AVERAGE_POA_10_DESC = "BATCH_CLAIMS_AVERAGE_POA_10_DESC",
  BATCH_CLAIMS_AVERAGE_POA_11_ASC = "BATCH_CLAIMS_AVERAGE_POA_11_ASC",
  BATCH_CLAIMS_AVERAGE_POA_11_DESC = "BATCH_CLAIMS_AVERAGE_POA_11_DESC",
  BATCH_CLAIMS_AVERAGE_POA_12_ASC = "BATCH_CLAIMS_AVERAGE_POA_12_ASC",
  BATCH_CLAIMS_AVERAGE_POA_12_DESC = "BATCH_CLAIMS_AVERAGE_POA_12_DESC",
  BATCH_CLAIMS_AVERAGE_POA_13_ASC = "BATCH_CLAIMS_AVERAGE_POA_13_ASC",
  BATCH_CLAIMS_AVERAGE_POA_13_DESC = "BATCH_CLAIMS_AVERAGE_POA_13_DESC",
  BATCH_CLAIMS_AVERAGE_POA_14_ASC = "BATCH_CLAIMS_AVERAGE_POA_14_ASC",
  BATCH_CLAIMS_AVERAGE_POA_14_DESC = "BATCH_CLAIMS_AVERAGE_POA_14_DESC",
  BATCH_CLAIMS_AVERAGE_POA_15_ASC = "BATCH_CLAIMS_AVERAGE_POA_15_ASC",
  BATCH_CLAIMS_AVERAGE_POA_15_DESC = "BATCH_CLAIMS_AVERAGE_POA_15_DESC",
  BATCH_CLAIMS_AVERAGE_POA_16_ASC = "BATCH_CLAIMS_AVERAGE_POA_16_ASC",
  BATCH_CLAIMS_AVERAGE_POA_16_DESC = "BATCH_CLAIMS_AVERAGE_POA_16_DESC",
  BATCH_CLAIMS_AVERAGE_POA_17_ASC = "BATCH_CLAIMS_AVERAGE_POA_17_ASC",
  BATCH_CLAIMS_AVERAGE_POA_17_DESC = "BATCH_CLAIMS_AVERAGE_POA_17_DESC",
  BATCH_CLAIMS_AVERAGE_POA_18_ASC = "BATCH_CLAIMS_AVERAGE_POA_18_ASC",
  BATCH_CLAIMS_AVERAGE_POA_18_DESC = "BATCH_CLAIMS_AVERAGE_POA_18_DESC",
  BATCH_CLAIMS_AVERAGE_POA_19_ASC = "BATCH_CLAIMS_AVERAGE_POA_19_ASC",
  BATCH_CLAIMS_AVERAGE_POA_19_DESC = "BATCH_CLAIMS_AVERAGE_POA_19_DESC",
  BATCH_CLAIMS_AVERAGE_POA_20_ASC = "BATCH_CLAIMS_AVERAGE_POA_20_ASC",
  BATCH_CLAIMS_AVERAGE_POA_20_DESC = "BATCH_CLAIMS_AVERAGE_POA_20_DESC",
  BATCH_CLAIMS_AVERAGE_POA_21_ASC = "BATCH_CLAIMS_AVERAGE_POA_21_ASC",
  BATCH_CLAIMS_AVERAGE_POA_21_DESC = "BATCH_CLAIMS_AVERAGE_POA_21_DESC",
  BATCH_CLAIMS_AVERAGE_POA_22_ASC = "BATCH_CLAIMS_AVERAGE_POA_22_ASC",
  BATCH_CLAIMS_AVERAGE_POA_22_DESC = "BATCH_CLAIMS_AVERAGE_POA_22_DESC",
  BATCH_CLAIMS_AVERAGE_POA_23_ASC = "BATCH_CLAIMS_AVERAGE_POA_23_ASC",
  BATCH_CLAIMS_AVERAGE_POA_23_DESC = "BATCH_CLAIMS_AVERAGE_POA_23_DESC",
  BATCH_CLAIMS_AVERAGE_POA_24_ASC = "BATCH_CLAIMS_AVERAGE_POA_24_ASC",
  BATCH_CLAIMS_AVERAGE_POA_24_DESC = "BATCH_CLAIMS_AVERAGE_POA_24_DESC",
  BATCH_CLAIMS_AVERAGE_POA_25_ASC = "BATCH_CLAIMS_AVERAGE_POA_25_ASC",
  BATCH_CLAIMS_AVERAGE_POA_25_DESC = "BATCH_CLAIMS_AVERAGE_POA_25_DESC",
  BATCH_CLAIMS_AVERAGE_PREPAY_DENY_ASC = "BATCH_CLAIMS_AVERAGE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_AVERAGE_PREPAY_DENY_DESC = "BATCH_CLAIMS_AVERAGE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_AVERAGE_PROVIDER_ID_ASC = "BATCH_CLAIMS_AVERAGE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_AVERAGE_PROVIDER_ID_DESC = "BATCH_CLAIMS_AVERAGE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIMS_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIMS_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIMS_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIMS_AVERAGE_VERSION_ASC = "BATCH_CLAIMS_AVERAGE_VERSION_ASC",
  BATCH_CLAIMS_AVERAGE_VERSION_DESC = "BATCH_CLAIMS_AVERAGE_VERSION_DESC",
  BATCH_CLAIMS_AVERAGE_VERSION_GROUP_ASC = "BATCH_CLAIMS_AVERAGE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_AVERAGE_VERSION_GROUP_DESC = "BATCH_CLAIMS_AVERAGE_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_BATCH_FILE_ID__COUNT_ASC = "BATCH_CLAIMS_BY_BATCH_FILE_ID__COUNT_ASC",
  BATCH_CLAIMS_BY_BATCH_FILE_ID__COUNT_DESC = "BATCH_CLAIMS_BY_BATCH_FILE_ID__COUNT_DESC",
  BATCH_CLAIMS_COUNT_ASC = "BATCH_CLAIMS_COUNT_ASC",
  BATCH_CLAIMS_COUNT_DESC = "BATCH_CLAIMS_COUNT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ICN_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ICN_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ICN_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ICN_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_1_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_1_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_1_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_1_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_2_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_2_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_2_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_2_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_3_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_3_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_3_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_3_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_4_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_4_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_4_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_4_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_5_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_5_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_5_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_5_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_6_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_6_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_6_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_6_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_7_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_7_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_7_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_7_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_8_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_8_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_8_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_8_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_9_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_9_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_9_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_9_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_10_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_10_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_10_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_10_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_11_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_11_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_11_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_11_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_12_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_12_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_12_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_12_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_13_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_13_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_13_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_13_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_14_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_14_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_14_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_14_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_15_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_15_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_15_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_15_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_16_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_16_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_16_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_16_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_17_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_17_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_17_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_17_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_18_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_18_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_18_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_18_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_19_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_19_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_19_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_19_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_20_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_20_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_20_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_20_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_21_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_21_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_21_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_21_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_22_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_22_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_22_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_22_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_23_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_23_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_23_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_23_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_24_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_24_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_24_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_24_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_25_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_25_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_25_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_25_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_DESC",
  BATCH_CLAIMS_MAX_ADMIT_DIAG_ASC = "BATCH_CLAIMS_MAX_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_MAX_ADMIT_DIAG_DESC = "BATCH_CLAIMS_MAX_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_MAX_ADM_TYPE_ASC = "BATCH_CLAIMS_MAX_ADM_TYPE_ASC",
  BATCH_CLAIMS_MAX_ADM_TYPE_DESC = "BATCH_CLAIMS_MAX_ADM_TYPE_DESC",
  BATCH_CLAIMS_MAX_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_MAX_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_MAX_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_MAX_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_MAX_APR_DRG_ASC = "BATCH_CLAIMS_MAX_APR_DRG_ASC",
  BATCH_CLAIMS_MAX_APR_DRG_DESC = "BATCH_CLAIMS_MAX_APR_DRG_DESC",
  BATCH_CLAIMS_MAX_AUTHOR_ID_ASC = "BATCH_CLAIMS_MAX_AUTHOR_ID_ASC",
  BATCH_CLAIMS_MAX_AUTHOR_ID_DESC = "BATCH_CLAIMS_MAX_AUTHOR_ID_DESC",
  BATCH_CLAIMS_MAX_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_MAX_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_MAX_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_MAX_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_MAX_BILL_TYPE_ASC = "BATCH_CLAIMS_MAX_BILL_TYPE_ASC",
  BATCH_CLAIMS_MAX_BILL_TYPE_DESC = "BATCH_CLAIMS_MAX_BILL_TYPE_DESC",
  BATCH_CLAIMS_MAX_CLAIM_TYPE_ASC = "BATCH_CLAIMS_MAX_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_MAX_CLAIM_TYPE_DESC = "BATCH_CLAIMS_MAX_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_MAX_CLIENT_ICN_ASC = "BATCH_CLAIMS_MAX_CLIENT_ICN_ASC",
  BATCH_CLAIMS_MAX_CLIENT_ICN_DESC = "BATCH_CLAIMS_MAX_CLIENT_ICN_DESC",
  BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_MAX_CREATED_AT_ASC = "BATCH_CLAIMS_MAX_CREATED_AT_ASC",
  BATCH_CLAIMS_MAX_CREATED_AT_DESC = "BATCH_CLAIMS_MAX_CREATED_AT_DESC",
  BATCH_CLAIMS_MAX_DATE_ADMIT_ASC = "BATCH_CLAIMS_MAX_DATE_ADMIT_ASC",
  BATCH_CLAIMS_MAX_DATE_ADMIT_DESC = "BATCH_CLAIMS_MAX_DATE_ADMIT_DESC",
  BATCH_CLAIMS_MAX_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_MAX_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_MAX_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_MAX_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_MAX_DIAG_1_ASC = "BATCH_CLAIMS_MAX_DIAG_1_ASC",
  BATCH_CLAIMS_MAX_DIAG_1_DESC = "BATCH_CLAIMS_MAX_DIAG_1_DESC",
  BATCH_CLAIMS_MAX_DIAG_2_ASC = "BATCH_CLAIMS_MAX_DIAG_2_ASC",
  BATCH_CLAIMS_MAX_DIAG_2_DESC = "BATCH_CLAIMS_MAX_DIAG_2_DESC",
  BATCH_CLAIMS_MAX_DIAG_3_ASC = "BATCH_CLAIMS_MAX_DIAG_3_ASC",
  BATCH_CLAIMS_MAX_DIAG_3_DESC = "BATCH_CLAIMS_MAX_DIAG_3_DESC",
  BATCH_CLAIMS_MAX_DIAG_4_ASC = "BATCH_CLAIMS_MAX_DIAG_4_ASC",
  BATCH_CLAIMS_MAX_DIAG_4_DESC = "BATCH_CLAIMS_MAX_DIAG_4_DESC",
  BATCH_CLAIMS_MAX_DIAG_5_ASC = "BATCH_CLAIMS_MAX_DIAG_5_ASC",
  BATCH_CLAIMS_MAX_DIAG_5_DESC = "BATCH_CLAIMS_MAX_DIAG_5_DESC",
  BATCH_CLAIMS_MAX_DIAG_6_ASC = "BATCH_CLAIMS_MAX_DIAG_6_ASC",
  BATCH_CLAIMS_MAX_DIAG_6_DESC = "BATCH_CLAIMS_MAX_DIAG_6_DESC",
  BATCH_CLAIMS_MAX_DIAG_7_ASC = "BATCH_CLAIMS_MAX_DIAG_7_ASC",
  BATCH_CLAIMS_MAX_DIAG_7_DESC = "BATCH_CLAIMS_MAX_DIAG_7_DESC",
  BATCH_CLAIMS_MAX_DIAG_8_ASC = "BATCH_CLAIMS_MAX_DIAG_8_ASC",
  BATCH_CLAIMS_MAX_DIAG_8_DESC = "BATCH_CLAIMS_MAX_DIAG_8_DESC",
  BATCH_CLAIMS_MAX_DIAG_9_ASC = "BATCH_CLAIMS_MAX_DIAG_9_ASC",
  BATCH_CLAIMS_MAX_DIAG_9_DESC = "BATCH_CLAIMS_MAX_DIAG_9_DESC",
  BATCH_CLAIMS_MAX_DIAG_10_ASC = "BATCH_CLAIMS_MAX_DIAG_10_ASC",
  BATCH_CLAIMS_MAX_DIAG_10_DESC = "BATCH_CLAIMS_MAX_DIAG_10_DESC",
  BATCH_CLAIMS_MAX_DIAG_11_ASC = "BATCH_CLAIMS_MAX_DIAG_11_ASC",
  BATCH_CLAIMS_MAX_DIAG_11_DESC = "BATCH_CLAIMS_MAX_DIAG_11_DESC",
  BATCH_CLAIMS_MAX_DIAG_12_ASC = "BATCH_CLAIMS_MAX_DIAG_12_ASC",
  BATCH_CLAIMS_MAX_DIAG_12_DESC = "BATCH_CLAIMS_MAX_DIAG_12_DESC",
  BATCH_CLAIMS_MAX_DIAG_13_ASC = "BATCH_CLAIMS_MAX_DIAG_13_ASC",
  BATCH_CLAIMS_MAX_DIAG_13_DESC = "BATCH_CLAIMS_MAX_DIAG_13_DESC",
  BATCH_CLAIMS_MAX_DIAG_14_ASC = "BATCH_CLAIMS_MAX_DIAG_14_ASC",
  BATCH_CLAIMS_MAX_DIAG_14_DESC = "BATCH_CLAIMS_MAX_DIAG_14_DESC",
  BATCH_CLAIMS_MAX_DIAG_15_ASC = "BATCH_CLAIMS_MAX_DIAG_15_ASC",
  BATCH_CLAIMS_MAX_DIAG_15_DESC = "BATCH_CLAIMS_MAX_DIAG_15_DESC",
  BATCH_CLAIMS_MAX_DIAG_16_ASC = "BATCH_CLAIMS_MAX_DIAG_16_ASC",
  BATCH_CLAIMS_MAX_DIAG_16_DESC = "BATCH_CLAIMS_MAX_DIAG_16_DESC",
  BATCH_CLAIMS_MAX_DIAG_17_ASC = "BATCH_CLAIMS_MAX_DIAG_17_ASC",
  BATCH_CLAIMS_MAX_DIAG_17_DESC = "BATCH_CLAIMS_MAX_DIAG_17_DESC",
  BATCH_CLAIMS_MAX_DIAG_18_ASC = "BATCH_CLAIMS_MAX_DIAG_18_ASC",
  BATCH_CLAIMS_MAX_DIAG_18_DESC = "BATCH_CLAIMS_MAX_DIAG_18_DESC",
  BATCH_CLAIMS_MAX_DIAG_19_ASC = "BATCH_CLAIMS_MAX_DIAG_19_ASC",
  BATCH_CLAIMS_MAX_DIAG_19_DESC = "BATCH_CLAIMS_MAX_DIAG_19_DESC",
  BATCH_CLAIMS_MAX_DIAG_20_ASC = "BATCH_CLAIMS_MAX_DIAG_20_ASC",
  BATCH_CLAIMS_MAX_DIAG_20_DESC = "BATCH_CLAIMS_MAX_DIAG_20_DESC",
  BATCH_CLAIMS_MAX_DIAG_21_ASC = "BATCH_CLAIMS_MAX_DIAG_21_ASC",
  BATCH_CLAIMS_MAX_DIAG_21_DESC = "BATCH_CLAIMS_MAX_DIAG_21_DESC",
  BATCH_CLAIMS_MAX_DIAG_22_ASC = "BATCH_CLAIMS_MAX_DIAG_22_ASC",
  BATCH_CLAIMS_MAX_DIAG_22_DESC = "BATCH_CLAIMS_MAX_DIAG_22_DESC",
  BATCH_CLAIMS_MAX_DIAG_23_ASC = "BATCH_CLAIMS_MAX_DIAG_23_ASC",
  BATCH_CLAIMS_MAX_DIAG_23_DESC = "BATCH_CLAIMS_MAX_DIAG_23_DESC",
  BATCH_CLAIMS_MAX_DIAG_24_ASC = "BATCH_CLAIMS_MAX_DIAG_24_ASC",
  BATCH_CLAIMS_MAX_DIAG_24_DESC = "BATCH_CLAIMS_MAX_DIAG_24_DESC",
  BATCH_CLAIMS_MAX_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_MAX_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_MAX_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_MAX_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_MAX_DRG_CODE_ASC = "BATCH_CLAIMS_MAX_DRG_CODE_ASC",
  BATCH_CLAIMS_MAX_DRG_CODE_DESC = "BATCH_CLAIMS_MAX_DRG_CODE_DESC",
  BATCH_CLAIMS_MAX_ICN_ASC = "BATCH_CLAIMS_MAX_ICN_ASC",
  BATCH_CLAIMS_MAX_ICN_DESC = "BATCH_CLAIMS_MAX_ICN_DESC",
  BATCH_CLAIMS_MAX_ID_ASC = "BATCH_CLAIMS_MAX_ID_ASC",
  BATCH_CLAIMS_MAX_ID_DESC = "BATCH_CLAIMS_MAX_ID_DESC",
  BATCH_CLAIMS_MAX_INSURER_ID_ASC = "BATCH_CLAIMS_MAX_INSURER_ID_ASC",
  BATCH_CLAIMS_MAX_INSURER_ID_DESC = "BATCH_CLAIMS_MAX_INSURER_ID_DESC",
  BATCH_CLAIMS_MAX_OWNER_ID_ASC = "BATCH_CLAIMS_MAX_OWNER_ID_ASC",
  BATCH_CLAIMS_MAX_OWNER_ID_DESC = "BATCH_CLAIMS_MAX_OWNER_ID_DESC",
  BATCH_CLAIMS_MAX_PAID_DATE_ASC = "BATCH_CLAIMS_MAX_PAID_DATE_ASC",
  BATCH_CLAIMS_MAX_PAID_DATE_DESC = "BATCH_CLAIMS_MAX_PAID_DATE_DESC",
  BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_MAX_PATIENT_DOB_ASC = "BATCH_CLAIMS_MAX_PATIENT_DOB_ASC",
  BATCH_CLAIMS_MAX_PATIENT_DOB_DESC = "BATCH_CLAIMS_MAX_PATIENT_DOB_DESC",
  BATCH_CLAIMS_MAX_PATIENT_GENDER_ASC = "BATCH_CLAIMS_MAX_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_MAX_PATIENT_GENDER_DESC = "BATCH_CLAIMS_MAX_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_MAX_PATIENT_ID_ASC = "BATCH_CLAIMS_MAX_PATIENT_ID_ASC",
  BATCH_CLAIMS_MAX_PATIENT_ID_DESC = "BATCH_CLAIMS_MAX_PATIENT_ID_DESC",
  BATCH_CLAIMS_MAX_PAYMENT_RATE_ASC = "BATCH_CLAIMS_MAX_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_MAX_PAYMENT_RATE_DESC = "BATCH_CLAIMS_MAX_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_MAX_POA_1_ASC = "BATCH_CLAIMS_MAX_POA_1_ASC",
  BATCH_CLAIMS_MAX_POA_1_DESC = "BATCH_CLAIMS_MAX_POA_1_DESC",
  BATCH_CLAIMS_MAX_POA_2_ASC = "BATCH_CLAIMS_MAX_POA_2_ASC",
  BATCH_CLAIMS_MAX_POA_2_DESC = "BATCH_CLAIMS_MAX_POA_2_DESC",
  BATCH_CLAIMS_MAX_POA_3_ASC = "BATCH_CLAIMS_MAX_POA_3_ASC",
  BATCH_CLAIMS_MAX_POA_3_DESC = "BATCH_CLAIMS_MAX_POA_3_DESC",
  BATCH_CLAIMS_MAX_POA_4_ASC = "BATCH_CLAIMS_MAX_POA_4_ASC",
  BATCH_CLAIMS_MAX_POA_4_DESC = "BATCH_CLAIMS_MAX_POA_4_DESC",
  BATCH_CLAIMS_MAX_POA_5_ASC = "BATCH_CLAIMS_MAX_POA_5_ASC",
  BATCH_CLAIMS_MAX_POA_5_DESC = "BATCH_CLAIMS_MAX_POA_5_DESC",
  BATCH_CLAIMS_MAX_POA_6_ASC = "BATCH_CLAIMS_MAX_POA_6_ASC",
  BATCH_CLAIMS_MAX_POA_6_DESC = "BATCH_CLAIMS_MAX_POA_6_DESC",
  BATCH_CLAIMS_MAX_POA_7_ASC = "BATCH_CLAIMS_MAX_POA_7_ASC",
  BATCH_CLAIMS_MAX_POA_7_DESC = "BATCH_CLAIMS_MAX_POA_7_DESC",
  BATCH_CLAIMS_MAX_POA_8_ASC = "BATCH_CLAIMS_MAX_POA_8_ASC",
  BATCH_CLAIMS_MAX_POA_8_DESC = "BATCH_CLAIMS_MAX_POA_8_DESC",
  BATCH_CLAIMS_MAX_POA_9_ASC = "BATCH_CLAIMS_MAX_POA_9_ASC",
  BATCH_CLAIMS_MAX_POA_9_DESC = "BATCH_CLAIMS_MAX_POA_9_DESC",
  BATCH_CLAIMS_MAX_POA_10_ASC = "BATCH_CLAIMS_MAX_POA_10_ASC",
  BATCH_CLAIMS_MAX_POA_10_DESC = "BATCH_CLAIMS_MAX_POA_10_DESC",
  BATCH_CLAIMS_MAX_POA_11_ASC = "BATCH_CLAIMS_MAX_POA_11_ASC",
  BATCH_CLAIMS_MAX_POA_11_DESC = "BATCH_CLAIMS_MAX_POA_11_DESC",
  BATCH_CLAIMS_MAX_POA_12_ASC = "BATCH_CLAIMS_MAX_POA_12_ASC",
  BATCH_CLAIMS_MAX_POA_12_DESC = "BATCH_CLAIMS_MAX_POA_12_DESC",
  BATCH_CLAIMS_MAX_POA_13_ASC = "BATCH_CLAIMS_MAX_POA_13_ASC",
  BATCH_CLAIMS_MAX_POA_13_DESC = "BATCH_CLAIMS_MAX_POA_13_DESC",
  BATCH_CLAIMS_MAX_POA_14_ASC = "BATCH_CLAIMS_MAX_POA_14_ASC",
  BATCH_CLAIMS_MAX_POA_14_DESC = "BATCH_CLAIMS_MAX_POA_14_DESC",
  BATCH_CLAIMS_MAX_POA_15_ASC = "BATCH_CLAIMS_MAX_POA_15_ASC",
  BATCH_CLAIMS_MAX_POA_15_DESC = "BATCH_CLAIMS_MAX_POA_15_DESC",
  BATCH_CLAIMS_MAX_POA_16_ASC = "BATCH_CLAIMS_MAX_POA_16_ASC",
  BATCH_CLAIMS_MAX_POA_16_DESC = "BATCH_CLAIMS_MAX_POA_16_DESC",
  BATCH_CLAIMS_MAX_POA_17_ASC = "BATCH_CLAIMS_MAX_POA_17_ASC",
  BATCH_CLAIMS_MAX_POA_17_DESC = "BATCH_CLAIMS_MAX_POA_17_DESC",
  BATCH_CLAIMS_MAX_POA_18_ASC = "BATCH_CLAIMS_MAX_POA_18_ASC",
  BATCH_CLAIMS_MAX_POA_18_DESC = "BATCH_CLAIMS_MAX_POA_18_DESC",
  BATCH_CLAIMS_MAX_POA_19_ASC = "BATCH_CLAIMS_MAX_POA_19_ASC",
  BATCH_CLAIMS_MAX_POA_19_DESC = "BATCH_CLAIMS_MAX_POA_19_DESC",
  BATCH_CLAIMS_MAX_POA_20_ASC = "BATCH_CLAIMS_MAX_POA_20_ASC",
  BATCH_CLAIMS_MAX_POA_20_DESC = "BATCH_CLAIMS_MAX_POA_20_DESC",
  BATCH_CLAIMS_MAX_POA_21_ASC = "BATCH_CLAIMS_MAX_POA_21_ASC",
  BATCH_CLAIMS_MAX_POA_21_DESC = "BATCH_CLAIMS_MAX_POA_21_DESC",
  BATCH_CLAIMS_MAX_POA_22_ASC = "BATCH_CLAIMS_MAX_POA_22_ASC",
  BATCH_CLAIMS_MAX_POA_22_DESC = "BATCH_CLAIMS_MAX_POA_22_DESC",
  BATCH_CLAIMS_MAX_POA_23_ASC = "BATCH_CLAIMS_MAX_POA_23_ASC",
  BATCH_CLAIMS_MAX_POA_23_DESC = "BATCH_CLAIMS_MAX_POA_23_DESC",
  BATCH_CLAIMS_MAX_POA_24_ASC = "BATCH_CLAIMS_MAX_POA_24_ASC",
  BATCH_CLAIMS_MAX_POA_24_DESC = "BATCH_CLAIMS_MAX_POA_24_DESC",
  BATCH_CLAIMS_MAX_POA_25_ASC = "BATCH_CLAIMS_MAX_POA_25_ASC",
  BATCH_CLAIMS_MAX_POA_25_DESC = "BATCH_CLAIMS_MAX_POA_25_DESC",
  BATCH_CLAIMS_MAX_PREPAY_DENY_ASC = "BATCH_CLAIMS_MAX_PREPAY_DENY_ASC",
  BATCH_CLAIMS_MAX_PREPAY_DENY_DESC = "BATCH_CLAIMS_MAX_PREPAY_DENY_DESC",
  BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_MAX_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_MAX_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_MAX_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_MAX_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_MAX_PROVIDER_ID_ASC = "BATCH_CLAIMS_MAX_PROVIDER_ID_ASC",
  BATCH_CLAIMS_MAX_PROVIDER_ID_DESC = "BATCH_CLAIMS_MAX_PROVIDER_ID_DESC",
  BATCH_CLAIMS_MAX_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_MAX_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_MAX_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_MAX_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_MAX_UPDATED_AT_ASC = "BATCH_CLAIMS_MAX_UPDATED_AT_ASC",
  BATCH_CLAIMS_MAX_UPDATED_AT_DESC = "BATCH_CLAIMS_MAX_UPDATED_AT_DESC",
  BATCH_CLAIMS_MAX_VERSION_ASC = "BATCH_CLAIMS_MAX_VERSION_ASC",
  BATCH_CLAIMS_MAX_VERSION_DESC = "BATCH_CLAIMS_MAX_VERSION_DESC",
  BATCH_CLAIMS_MAX_VERSION_GROUP_ASC = "BATCH_CLAIMS_MAX_VERSION_GROUP_ASC",
  BATCH_CLAIMS_MAX_VERSION_GROUP_DESC = "BATCH_CLAIMS_MAX_VERSION_GROUP_DESC",
  BATCH_CLAIMS_MIN_ADMIT_DIAG_ASC = "BATCH_CLAIMS_MIN_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_MIN_ADMIT_DIAG_DESC = "BATCH_CLAIMS_MIN_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_MIN_ADM_TYPE_ASC = "BATCH_CLAIMS_MIN_ADM_TYPE_ASC",
  BATCH_CLAIMS_MIN_ADM_TYPE_DESC = "BATCH_CLAIMS_MIN_ADM_TYPE_DESC",
  BATCH_CLAIMS_MIN_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_MIN_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_MIN_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_MIN_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_MIN_APR_DRG_ASC = "BATCH_CLAIMS_MIN_APR_DRG_ASC",
  BATCH_CLAIMS_MIN_APR_DRG_DESC = "BATCH_CLAIMS_MIN_APR_DRG_DESC",
  BATCH_CLAIMS_MIN_AUTHOR_ID_ASC = "BATCH_CLAIMS_MIN_AUTHOR_ID_ASC",
  BATCH_CLAIMS_MIN_AUTHOR_ID_DESC = "BATCH_CLAIMS_MIN_AUTHOR_ID_DESC",
  BATCH_CLAIMS_MIN_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_MIN_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_MIN_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_MIN_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_MIN_BILL_TYPE_ASC = "BATCH_CLAIMS_MIN_BILL_TYPE_ASC",
  BATCH_CLAIMS_MIN_BILL_TYPE_DESC = "BATCH_CLAIMS_MIN_BILL_TYPE_DESC",
  BATCH_CLAIMS_MIN_CLAIM_TYPE_ASC = "BATCH_CLAIMS_MIN_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_MIN_CLAIM_TYPE_DESC = "BATCH_CLAIMS_MIN_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_MIN_CLIENT_ICN_ASC = "BATCH_CLAIMS_MIN_CLIENT_ICN_ASC",
  BATCH_CLAIMS_MIN_CLIENT_ICN_DESC = "BATCH_CLAIMS_MIN_CLIENT_ICN_DESC",
  BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_MIN_CREATED_AT_ASC = "BATCH_CLAIMS_MIN_CREATED_AT_ASC",
  BATCH_CLAIMS_MIN_CREATED_AT_DESC = "BATCH_CLAIMS_MIN_CREATED_AT_DESC",
  BATCH_CLAIMS_MIN_DATE_ADMIT_ASC = "BATCH_CLAIMS_MIN_DATE_ADMIT_ASC",
  BATCH_CLAIMS_MIN_DATE_ADMIT_DESC = "BATCH_CLAIMS_MIN_DATE_ADMIT_DESC",
  BATCH_CLAIMS_MIN_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_MIN_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_MIN_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_MIN_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_MIN_DIAG_1_ASC = "BATCH_CLAIMS_MIN_DIAG_1_ASC",
  BATCH_CLAIMS_MIN_DIAG_1_DESC = "BATCH_CLAIMS_MIN_DIAG_1_DESC",
  BATCH_CLAIMS_MIN_DIAG_2_ASC = "BATCH_CLAIMS_MIN_DIAG_2_ASC",
  BATCH_CLAIMS_MIN_DIAG_2_DESC = "BATCH_CLAIMS_MIN_DIAG_2_DESC",
  BATCH_CLAIMS_MIN_DIAG_3_ASC = "BATCH_CLAIMS_MIN_DIAG_3_ASC",
  BATCH_CLAIMS_MIN_DIAG_3_DESC = "BATCH_CLAIMS_MIN_DIAG_3_DESC",
  BATCH_CLAIMS_MIN_DIAG_4_ASC = "BATCH_CLAIMS_MIN_DIAG_4_ASC",
  BATCH_CLAIMS_MIN_DIAG_4_DESC = "BATCH_CLAIMS_MIN_DIAG_4_DESC",
  BATCH_CLAIMS_MIN_DIAG_5_ASC = "BATCH_CLAIMS_MIN_DIAG_5_ASC",
  BATCH_CLAIMS_MIN_DIAG_5_DESC = "BATCH_CLAIMS_MIN_DIAG_5_DESC",
  BATCH_CLAIMS_MIN_DIAG_6_ASC = "BATCH_CLAIMS_MIN_DIAG_6_ASC",
  BATCH_CLAIMS_MIN_DIAG_6_DESC = "BATCH_CLAIMS_MIN_DIAG_6_DESC",
  BATCH_CLAIMS_MIN_DIAG_7_ASC = "BATCH_CLAIMS_MIN_DIAG_7_ASC",
  BATCH_CLAIMS_MIN_DIAG_7_DESC = "BATCH_CLAIMS_MIN_DIAG_7_DESC",
  BATCH_CLAIMS_MIN_DIAG_8_ASC = "BATCH_CLAIMS_MIN_DIAG_8_ASC",
  BATCH_CLAIMS_MIN_DIAG_8_DESC = "BATCH_CLAIMS_MIN_DIAG_8_DESC",
  BATCH_CLAIMS_MIN_DIAG_9_ASC = "BATCH_CLAIMS_MIN_DIAG_9_ASC",
  BATCH_CLAIMS_MIN_DIAG_9_DESC = "BATCH_CLAIMS_MIN_DIAG_9_DESC",
  BATCH_CLAIMS_MIN_DIAG_10_ASC = "BATCH_CLAIMS_MIN_DIAG_10_ASC",
  BATCH_CLAIMS_MIN_DIAG_10_DESC = "BATCH_CLAIMS_MIN_DIAG_10_DESC",
  BATCH_CLAIMS_MIN_DIAG_11_ASC = "BATCH_CLAIMS_MIN_DIAG_11_ASC",
  BATCH_CLAIMS_MIN_DIAG_11_DESC = "BATCH_CLAIMS_MIN_DIAG_11_DESC",
  BATCH_CLAIMS_MIN_DIAG_12_ASC = "BATCH_CLAIMS_MIN_DIAG_12_ASC",
  BATCH_CLAIMS_MIN_DIAG_12_DESC = "BATCH_CLAIMS_MIN_DIAG_12_DESC",
  BATCH_CLAIMS_MIN_DIAG_13_ASC = "BATCH_CLAIMS_MIN_DIAG_13_ASC",
  BATCH_CLAIMS_MIN_DIAG_13_DESC = "BATCH_CLAIMS_MIN_DIAG_13_DESC",
  BATCH_CLAIMS_MIN_DIAG_14_ASC = "BATCH_CLAIMS_MIN_DIAG_14_ASC",
  BATCH_CLAIMS_MIN_DIAG_14_DESC = "BATCH_CLAIMS_MIN_DIAG_14_DESC",
  BATCH_CLAIMS_MIN_DIAG_15_ASC = "BATCH_CLAIMS_MIN_DIAG_15_ASC",
  BATCH_CLAIMS_MIN_DIAG_15_DESC = "BATCH_CLAIMS_MIN_DIAG_15_DESC",
  BATCH_CLAIMS_MIN_DIAG_16_ASC = "BATCH_CLAIMS_MIN_DIAG_16_ASC",
  BATCH_CLAIMS_MIN_DIAG_16_DESC = "BATCH_CLAIMS_MIN_DIAG_16_DESC",
  BATCH_CLAIMS_MIN_DIAG_17_ASC = "BATCH_CLAIMS_MIN_DIAG_17_ASC",
  BATCH_CLAIMS_MIN_DIAG_17_DESC = "BATCH_CLAIMS_MIN_DIAG_17_DESC",
  BATCH_CLAIMS_MIN_DIAG_18_ASC = "BATCH_CLAIMS_MIN_DIAG_18_ASC",
  BATCH_CLAIMS_MIN_DIAG_18_DESC = "BATCH_CLAIMS_MIN_DIAG_18_DESC",
  BATCH_CLAIMS_MIN_DIAG_19_ASC = "BATCH_CLAIMS_MIN_DIAG_19_ASC",
  BATCH_CLAIMS_MIN_DIAG_19_DESC = "BATCH_CLAIMS_MIN_DIAG_19_DESC",
  BATCH_CLAIMS_MIN_DIAG_20_ASC = "BATCH_CLAIMS_MIN_DIAG_20_ASC",
  BATCH_CLAIMS_MIN_DIAG_20_DESC = "BATCH_CLAIMS_MIN_DIAG_20_DESC",
  BATCH_CLAIMS_MIN_DIAG_21_ASC = "BATCH_CLAIMS_MIN_DIAG_21_ASC",
  BATCH_CLAIMS_MIN_DIAG_21_DESC = "BATCH_CLAIMS_MIN_DIAG_21_DESC",
  BATCH_CLAIMS_MIN_DIAG_22_ASC = "BATCH_CLAIMS_MIN_DIAG_22_ASC",
  BATCH_CLAIMS_MIN_DIAG_22_DESC = "BATCH_CLAIMS_MIN_DIAG_22_DESC",
  BATCH_CLAIMS_MIN_DIAG_23_ASC = "BATCH_CLAIMS_MIN_DIAG_23_ASC",
  BATCH_CLAIMS_MIN_DIAG_23_DESC = "BATCH_CLAIMS_MIN_DIAG_23_DESC",
  BATCH_CLAIMS_MIN_DIAG_24_ASC = "BATCH_CLAIMS_MIN_DIAG_24_ASC",
  BATCH_CLAIMS_MIN_DIAG_24_DESC = "BATCH_CLAIMS_MIN_DIAG_24_DESC",
  BATCH_CLAIMS_MIN_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_MIN_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_MIN_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_MIN_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_MIN_DRG_CODE_ASC = "BATCH_CLAIMS_MIN_DRG_CODE_ASC",
  BATCH_CLAIMS_MIN_DRG_CODE_DESC = "BATCH_CLAIMS_MIN_DRG_CODE_DESC",
  BATCH_CLAIMS_MIN_ICN_ASC = "BATCH_CLAIMS_MIN_ICN_ASC",
  BATCH_CLAIMS_MIN_ICN_DESC = "BATCH_CLAIMS_MIN_ICN_DESC",
  BATCH_CLAIMS_MIN_ID_ASC = "BATCH_CLAIMS_MIN_ID_ASC",
  BATCH_CLAIMS_MIN_ID_DESC = "BATCH_CLAIMS_MIN_ID_DESC",
  BATCH_CLAIMS_MIN_INSURER_ID_ASC = "BATCH_CLAIMS_MIN_INSURER_ID_ASC",
  BATCH_CLAIMS_MIN_INSURER_ID_DESC = "BATCH_CLAIMS_MIN_INSURER_ID_DESC",
  BATCH_CLAIMS_MIN_OWNER_ID_ASC = "BATCH_CLAIMS_MIN_OWNER_ID_ASC",
  BATCH_CLAIMS_MIN_OWNER_ID_DESC = "BATCH_CLAIMS_MIN_OWNER_ID_DESC",
  BATCH_CLAIMS_MIN_PAID_DATE_ASC = "BATCH_CLAIMS_MIN_PAID_DATE_ASC",
  BATCH_CLAIMS_MIN_PAID_DATE_DESC = "BATCH_CLAIMS_MIN_PAID_DATE_DESC",
  BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_MIN_PATIENT_DOB_ASC = "BATCH_CLAIMS_MIN_PATIENT_DOB_ASC",
  BATCH_CLAIMS_MIN_PATIENT_DOB_DESC = "BATCH_CLAIMS_MIN_PATIENT_DOB_DESC",
  BATCH_CLAIMS_MIN_PATIENT_GENDER_ASC = "BATCH_CLAIMS_MIN_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_MIN_PATIENT_GENDER_DESC = "BATCH_CLAIMS_MIN_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_MIN_PATIENT_ID_ASC = "BATCH_CLAIMS_MIN_PATIENT_ID_ASC",
  BATCH_CLAIMS_MIN_PATIENT_ID_DESC = "BATCH_CLAIMS_MIN_PATIENT_ID_DESC",
  BATCH_CLAIMS_MIN_PAYMENT_RATE_ASC = "BATCH_CLAIMS_MIN_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_MIN_PAYMENT_RATE_DESC = "BATCH_CLAIMS_MIN_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_MIN_POA_1_ASC = "BATCH_CLAIMS_MIN_POA_1_ASC",
  BATCH_CLAIMS_MIN_POA_1_DESC = "BATCH_CLAIMS_MIN_POA_1_DESC",
  BATCH_CLAIMS_MIN_POA_2_ASC = "BATCH_CLAIMS_MIN_POA_2_ASC",
  BATCH_CLAIMS_MIN_POA_2_DESC = "BATCH_CLAIMS_MIN_POA_2_DESC",
  BATCH_CLAIMS_MIN_POA_3_ASC = "BATCH_CLAIMS_MIN_POA_3_ASC",
  BATCH_CLAIMS_MIN_POA_3_DESC = "BATCH_CLAIMS_MIN_POA_3_DESC",
  BATCH_CLAIMS_MIN_POA_4_ASC = "BATCH_CLAIMS_MIN_POA_4_ASC",
  BATCH_CLAIMS_MIN_POA_4_DESC = "BATCH_CLAIMS_MIN_POA_4_DESC",
  BATCH_CLAIMS_MIN_POA_5_ASC = "BATCH_CLAIMS_MIN_POA_5_ASC",
  BATCH_CLAIMS_MIN_POA_5_DESC = "BATCH_CLAIMS_MIN_POA_5_DESC",
  BATCH_CLAIMS_MIN_POA_6_ASC = "BATCH_CLAIMS_MIN_POA_6_ASC",
  BATCH_CLAIMS_MIN_POA_6_DESC = "BATCH_CLAIMS_MIN_POA_6_DESC",
  BATCH_CLAIMS_MIN_POA_7_ASC = "BATCH_CLAIMS_MIN_POA_7_ASC",
  BATCH_CLAIMS_MIN_POA_7_DESC = "BATCH_CLAIMS_MIN_POA_7_DESC",
  BATCH_CLAIMS_MIN_POA_8_ASC = "BATCH_CLAIMS_MIN_POA_8_ASC",
  BATCH_CLAIMS_MIN_POA_8_DESC = "BATCH_CLAIMS_MIN_POA_8_DESC",
  BATCH_CLAIMS_MIN_POA_9_ASC = "BATCH_CLAIMS_MIN_POA_9_ASC",
  BATCH_CLAIMS_MIN_POA_9_DESC = "BATCH_CLAIMS_MIN_POA_9_DESC",
  BATCH_CLAIMS_MIN_POA_10_ASC = "BATCH_CLAIMS_MIN_POA_10_ASC",
  BATCH_CLAIMS_MIN_POA_10_DESC = "BATCH_CLAIMS_MIN_POA_10_DESC",
  BATCH_CLAIMS_MIN_POA_11_ASC = "BATCH_CLAIMS_MIN_POA_11_ASC",
  BATCH_CLAIMS_MIN_POA_11_DESC = "BATCH_CLAIMS_MIN_POA_11_DESC",
  BATCH_CLAIMS_MIN_POA_12_ASC = "BATCH_CLAIMS_MIN_POA_12_ASC",
  BATCH_CLAIMS_MIN_POA_12_DESC = "BATCH_CLAIMS_MIN_POA_12_DESC",
  BATCH_CLAIMS_MIN_POA_13_ASC = "BATCH_CLAIMS_MIN_POA_13_ASC",
  BATCH_CLAIMS_MIN_POA_13_DESC = "BATCH_CLAIMS_MIN_POA_13_DESC",
  BATCH_CLAIMS_MIN_POA_14_ASC = "BATCH_CLAIMS_MIN_POA_14_ASC",
  BATCH_CLAIMS_MIN_POA_14_DESC = "BATCH_CLAIMS_MIN_POA_14_DESC",
  BATCH_CLAIMS_MIN_POA_15_ASC = "BATCH_CLAIMS_MIN_POA_15_ASC",
  BATCH_CLAIMS_MIN_POA_15_DESC = "BATCH_CLAIMS_MIN_POA_15_DESC",
  BATCH_CLAIMS_MIN_POA_16_ASC = "BATCH_CLAIMS_MIN_POA_16_ASC",
  BATCH_CLAIMS_MIN_POA_16_DESC = "BATCH_CLAIMS_MIN_POA_16_DESC",
  BATCH_CLAIMS_MIN_POA_17_ASC = "BATCH_CLAIMS_MIN_POA_17_ASC",
  BATCH_CLAIMS_MIN_POA_17_DESC = "BATCH_CLAIMS_MIN_POA_17_DESC",
  BATCH_CLAIMS_MIN_POA_18_ASC = "BATCH_CLAIMS_MIN_POA_18_ASC",
  BATCH_CLAIMS_MIN_POA_18_DESC = "BATCH_CLAIMS_MIN_POA_18_DESC",
  BATCH_CLAIMS_MIN_POA_19_ASC = "BATCH_CLAIMS_MIN_POA_19_ASC",
  BATCH_CLAIMS_MIN_POA_19_DESC = "BATCH_CLAIMS_MIN_POA_19_DESC",
  BATCH_CLAIMS_MIN_POA_20_ASC = "BATCH_CLAIMS_MIN_POA_20_ASC",
  BATCH_CLAIMS_MIN_POA_20_DESC = "BATCH_CLAIMS_MIN_POA_20_DESC",
  BATCH_CLAIMS_MIN_POA_21_ASC = "BATCH_CLAIMS_MIN_POA_21_ASC",
  BATCH_CLAIMS_MIN_POA_21_DESC = "BATCH_CLAIMS_MIN_POA_21_DESC",
  BATCH_CLAIMS_MIN_POA_22_ASC = "BATCH_CLAIMS_MIN_POA_22_ASC",
  BATCH_CLAIMS_MIN_POA_22_DESC = "BATCH_CLAIMS_MIN_POA_22_DESC",
  BATCH_CLAIMS_MIN_POA_23_ASC = "BATCH_CLAIMS_MIN_POA_23_ASC",
  BATCH_CLAIMS_MIN_POA_23_DESC = "BATCH_CLAIMS_MIN_POA_23_DESC",
  BATCH_CLAIMS_MIN_POA_24_ASC = "BATCH_CLAIMS_MIN_POA_24_ASC",
  BATCH_CLAIMS_MIN_POA_24_DESC = "BATCH_CLAIMS_MIN_POA_24_DESC",
  BATCH_CLAIMS_MIN_POA_25_ASC = "BATCH_CLAIMS_MIN_POA_25_ASC",
  BATCH_CLAIMS_MIN_POA_25_DESC = "BATCH_CLAIMS_MIN_POA_25_DESC",
  BATCH_CLAIMS_MIN_PREPAY_DENY_ASC = "BATCH_CLAIMS_MIN_PREPAY_DENY_ASC",
  BATCH_CLAIMS_MIN_PREPAY_DENY_DESC = "BATCH_CLAIMS_MIN_PREPAY_DENY_DESC",
  BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_MIN_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_MIN_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_MIN_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_MIN_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_MIN_PROVIDER_ID_ASC = "BATCH_CLAIMS_MIN_PROVIDER_ID_ASC",
  BATCH_CLAIMS_MIN_PROVIDER_ID_DESC = "BATCH_CLAIMS_MIN_PROVIDER_ID_DESC",
  BATCH_CLAIMS_MIN_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_MIN_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_MIN_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_MIN_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_MIN_UPDATED_AT_ASC = "BATCH_CLAIMS_MIN_UPDATED_AT_ASC",
  BATCH_CLAIMS_MIN_UPDATED_AT_DESC = "BATCH_CLAIMS_MIN_UPDATED_AT_DESC",
  BATCH_CLAIMS_MIN_VERSION_ASC = "BATCH_CLAIMS_MIN_VERSION_ASC",
  BATCH_CLAIMS_MIN_VERSION_DESC = "BATCH_CLAIMS_MIN_VERSION_DESC",
  BATCH_CLAIMS_MIN_VERSION_GROUP_ASC = "BATCH_CLAIMS_MIN_VERSION_GROUP_ASC",
  BATCH_CLAIMS_MIN_VERSION_GROUP_DESC = "BATCH_CLAIMS_MIN_VERSION_GROUP_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ICN_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ICN_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ICN_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ICN_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_1_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_1_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_1_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_1_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_2_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_2_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_2_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_2_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_3_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_3_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_3_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_3_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_4_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_4_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_4_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_4_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_5_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_5_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_5_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_5_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_6_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_6_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_6_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_6_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_7_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_7_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_7_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_7_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_8_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_8_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_8_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_8_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_9_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_9_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_9_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_9_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_10_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_10_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_10_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_10_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_11_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_11_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_11_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_11_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_12_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_12_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_12_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_12_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_13_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_13_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_13_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_13_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_14_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_14_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_14_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_14_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_15_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_15_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_15_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_15_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_16_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_16_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_16_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_16_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_17_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_17_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_17_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_17_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_18_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_18_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_18_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_18_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_19_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_19_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_19_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_19_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_20_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_20_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_20_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_20_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_21_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_21_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_21_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_21_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_22_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_22_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_22_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_22_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_23_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_23_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_23_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_23_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_24_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_24_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_24_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_24_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_25_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_25_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_25_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_25_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ICN_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ICN_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ICN_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ICN_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_DESC",
  BATCH_CLAIMS_SUM_ADMIT_DIAG_ASC = "BATCH_CLAIMS_SUM_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_SUM_ADMIT_DIAG_DESC = "BATCH_CLAIMS_SUM_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_SUM_ADM_TYPE_ASC = "BATCH_CLAIMS_SUM_ADM_TYPE_ASC",
  BATCH_CLAIMS_SUM_ADM_TYPE_DESC = "BATCH_CLAIMS_SUM_ADM_TYPE_DESC",
  BATCH_CLAIMS_SUM_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_SUM_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_SUM_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_SUM_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_SUM_APR_DRG_ASC = "BATCH_CLAIMS_SUM_APR_DRG_ASC",
  BATCH_CLAIMS_SUM_APR_DRG_DESC = "BATCH_CLAIMS_SUM_APR_DRG_DESC",
  BATCH_CLAIMS_SUM_AUTHOR_ID_ASC = "BATCH_CLAIMS_SUM_AUTHOR_ID_ASC",
  BATCH_CLAIMS_SUM_AUTHOR_ID_DESC = "BATCH_CLAIMS_SUM_AUTHOR_ID_DESC",
  BATCH_CLAIMS_SUM_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_SUM_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_SUM_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_SUM_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_SUM_BILL_TYPE_ASC = "BATCH_CLAIMS_SUM_BILL_TYPE_ASC",
  BATCH_CLAIMS_SUM_BILL_TYPE_DESC = "BATCH_CLAIMS_SUM_BILL_TYPE_DESC",
  BATCH_CLAIMS_SUM_CLAIM_TYPE_ASC = "BATCH_CLAIMS_SUM_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_SUM_CLAIM_TYPE_DESC = "BATCH_CLAIMS_SUM_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_SUM_CLIENT_ICN_ASC = "BATCH_CLAIMS_SUM_CLIENT_ICN_ASC",
  BATCH_CLAIMS_SUM_CLIENT_ICN_DESC = "BATCH_CLAIMS_SUM_CLIENT_ICN_DESC",
  BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_SUM_CREATED_AT_ASC = "BATCH_CLAIMS_SUM_CREATED_AT_ASC",
  BATCH_CLAIMS_SUM_CREATED_AT_DESC = "BATCH_CLAIMS_SUM_CREATED_AT_DESC",
  BATCH_CLAIMS_SUM_DATE_ADMIT_ASC = "BATCH_CLAIMS_SUM_DATE_ADMIT_ASC",
  BATCH_CLAIMS_SUM_DATE_ADMIT_DESC = "BATCH_CLAIMS_SUM_DATE_ADMIT_DESC",
  BATCH_CLAIMS_SUM_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_SUM_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_SUM_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_SUM_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_SUM_DIAG_1_ASC = "BATCH_CLAIMS_SUM_DIAG_1_ASC",
  BATCH_CLAIMS_SUM_DIAG_1_DESC = "BATCH_CLAIMS_SUM_DIAG_1_DESC",
  BATCH_CLAIMS_SUM_DIAG_2_ASC = "BATCH_CLAIMS_SUM_DIAG_2_ASC",
  BATCH_CLAIMS_SUM_DIAG_2_DESC = "BATCH_CLAIMS_SUM_DIAG_2_DESC",
  BATCH_CLAIMS_SUM_DIAG_3_ASC = "BATCH_CLAIMS_SUM_DIAG_3_ASC",
  BATCH_CLAIMS_SUM_DIAG_3_DESC = "BATCH_CLAIMS_SUM_DIAG_3_DESC",
  BATCH_CLAIMS_SUM_DIAG_4_ASC = "BATCH_CLAIMS_SUM_DIAG_4_ASC",
  BATCH_CLAIMS_SUM_DIAG_4_DESC = "BATCH_CLAIMS_SUM_DIAG_4_DESC",
  BATCH_CLAIMS_SUM_DIAG_5_ASC = "BATCH_CLAIMS_SUM_DIAG_5_ASC",
  BATCH_CLAIMS_SUM_DIAG_5_DESC = "BATCH_CLAIMS_SUM_DIAG_5_DESC",
  BATCH_CLAIMS_SUM_DIAG_6_ASC = "BATCH_CLAIMS_SUM_DIAG_6_ASC",
  BATCH_CLAIMS_SUM_DIAG_6_DESC = "BATCH_CLAIMS_SUM_DIAG_6_DESC",
  BATCH_CLAIMS_SUM_DIAG_7_ASC = "BATCH_CLAIMS_SUM_DIAG_7_ASC",
  BATCH_CLAIMS_SUM_DIAG_7_DESC = "BATCH_CLAIMS_SUM_DIAG_7_DESC",
  BATCH_CLAIMS_SUM_DIAG_8_ASC = "BATCH_CLAIMS_SUM_DIAG_8_ASC",
  BATCH_CLAIMS_SUM_DIAG_8_DESC = "BATCH_CLAIMS_SUM_DIAG_8_DESC",
  BATCH_CLAIMS_SUM_DIAG_9_ASC = "BATCH_CLAIMS_SUM_DIAG_9_ASC",
  BATCH_CLAIMS_SUM_DIAG_9_DESC = "BATCH_CLAIMS_SUM_DIAG_9_DESC",
  BATCH_CLAIMS_SUM_DIAG_10_ASC = "BATCH_CLAIMS_SUM_DIAG_10_ASC",
  BATCH_CLAIMS_SUM_DIAG_10_DESC = "BATCH_CLAIMS_SUM_DIAG_10_DESC",
  BATCH_CLAIMS_SUM_DIAG_11_ASC = "BATCH_CLAIMS_SUM_DIAG_11_ASC",
  BATCH_CLAIMS_SUM_DIAG_11_DESC = "BATCH_CLAIMS_SUM_DIAG_11_DESC",
  BATCH_CLAIMS_SUM_DIAG_12_ASC = "BATCH_CLAIMS_SUM_DIAG_12_ASC",
  BATCH_CLAIMS_SUM_DIAG_12_DESC = "BATCH_CLAIMS_SUM_DIAG_12_DESC",
  BATCH_CLAIMS_SUM_DIAG_13_ASC = "BATCH_CLAIMS_SUM_DIAG_13_ASC",
  BATCH_CLAIMS_SUM_DIAG_13_DESC = "BATCH_CLAIMS_SUM_DIAG_13_DESC",
  BATCH_CLAIMS_SUM_DIAG_14_ASC = "BATCH_CLAIMS_SUM_DIAG_14_ASC",
  BATCH_CLAIMS_SUM_DIAG_14_DESC = "BATCH_CLAIMS_SUM_DIAG_14_DESC",
  BATCH_CLAIMS_SUM_DIAG_15_ASC = "BATCH_CLAIMS_SUM_DIAG_15_ASC",
  BATCH_CLAIMS_SUM_DIAG_15_DESC = "BATCH_CLAIMS_SUM_DIAG_15_DESC",
  BATCH_CLAIMS_SUM_DIAG_16_ASC = "BATCH_CLAIMS_SUM_DIAG_16_ASC",
  BATCH_CLAIMS_SUM_DIAG_16_DESC = "BATCH_CLAIMS_SUM_DIAG_16_DESC",
  BATCH_CLAIMS_SUM_DIAG_17_ASC = "BATCH_CLAIMS_SUM_DIAG_17_ASC",
  BATCH_CLAIMS_SUM_DIAG_17_DESC = "BATCH_CLAIMS_SUM_DIAG_17_DESC",
  BATCH_CLAIMS_SUM_DIAG_18_ASC = "BATCH_CLAIMS_SUM_DIAG_18_ASC",
  BATCH_CLAIMS_SUM_DIAG_18_DESC = "BATCH_CLAIMS_SUM_DIAG_18_DESC",
  BATCH_CLAIMS_SUM_DIAG_19_ASC = "BATCH_CLAIMS_SUM_DIAG_19_ASC",
  BATCH_CLAIMS_SUM_DIAG_19_DESC = "BATCH_CLAIMS_SUM_DIAG_19_DESC",
  BATCH_CLAIMS_SUM_DIAG_20_ASC = "BATCH_CLAIMS_SUM_DIAG_20_ASC",
  BATCH_CLAIMS_SUM_DIAG_20_DESC = "BATCH_CLAIMS_SUM_DIAG_20_DESC",
  BATCH_CLAIMS_SUM_DIAG_21_ASC = "BATCH_CLAIMS_SUM_DIAG_21_ASC",
  BATCH_CLAIMS_SUM_DIAG_21_DESC = "BATCH_CLAIMS_SUM_DIAG_21_DESC",
  BATCH_CLAIMS_SUM_DIAG_22_ASC = "BATCH_CLAIMS_SUM_DIAG_22_ASC",
  BATCH_CLAIMS_SUM_DIAG_22_DESC = "BATCH_CLAIMS_SUM_DIAG_22_DESC",
  BATCH_CLAIMS_SUM_DIAG_23_ASC = "BATCH_CLAIMS_SUM_DIAG_23_ASC",
  BATCH_CLAIMS_SUM_DIAG_23_DESC = "BATCH_CLAIMS_SUM_DIAG_23_DESC",
  BATCH_CLAIMS_SUM_DIAG_24_ASC = "BATCH_CLAIMS_SUM_DIAG_24_ASC",
  BATCH_CLAIMS_SUM_DIAG_24_DESC = "BATCH_CLAIMS_SUM_DIAG_24_DESC",
  BATCH_CLAIMS_SUM_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_SUM_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_SUM_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_SUM_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_SUM_DRG_CODE_ASC = "BATCH_CLAIMS_SUM_DRG_CODE_ASC",
  BATCH_CLAIMS_SUM_DRG_CODE_DESC = "BATCH_CLAIMS_SUM_DRG_CODE_DESC",
  BATCH_CLAIMS_SUM_ICN_ASC = "BATCH_CLAIMS_SUM_ICN_ASC",
  BATCH_CLAIMS_SUM_ICN_DESC = "BATCH_CLAIMS_SUM_ICN_DESC",
  BATCH_CLAIMS_SUM_ID_ASC = "BATCH_CLAIMS_SUM_ID_ASC",
  BATCH_CLAIMS_SUM_ID_DESC = "BATCH_CLAIMS_SUM_ID_DESC",
  BATCH_CLAIMS_SUM_INSURER_ID_ASC = "BATCH_CLAIMS_SUM_INSURER_ID_ASC",
  BATCH_CLAIMS_SUM_INSURER_ID_DESC = "BATCH_CLAIMS_SUM_INSURER_ID_DESC",
  BATCH_CLAIMS_SUM_OWNER_ID_ASC = "BATCH_CLAIMS_SUM_OWNER_ID_ASC",
  BATCH_CLAIMS_SUM_OWNER_ID_DESC = "BATCH_CLAIMS_SUM_OWNER_ID_DESC",
  BATCH_CLAIMS_SUM_PAID_DATE_ASC = "BATCH_CLAIMS_SUM_PAID_DATE_ASC",
  BATCH_CLAIMS_SUM_PAID_DATE_DESC = "BATCH_CLAIMS_SUM_PAID_DATE_DESC",
  BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_SUM_PATIENT_DOB_ASC = "BATCH_CLAIMS_SUM_PATIENT_DOB_ASC",
  BATCH_CLAIMS_SUM_PATIENT_DOB_DESC = "BATCH_CLAIMS_SUM_PATIENT_DOB_DESC",
  BATCH_CLAIMS_SUM_PATIENT_GENDER_ASC = "BATCH_CLAIMS_SUM_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_SUM_PATIENT_GENDER_DESC = "BATCH_CLAIMS_SUM_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_SUM_PATIENT_ID_ASC = "BATCH_CLAIMS_SUM_PATIENT_ID_ASC",
  BATCH_CLAIMS_SUM_PATIENT_ID_DESC = "BATCH_CLAIMS_SUM_PATIENT_ID_DESC",
  BATCH_CLAIMS_SUM_PAYMENT_RATE_ASC = "BATCH_CLAIMS_SUM_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_SUM_PAYMENT_RATE_DESC = "BATCH_CLAIMS_SUM_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_SUM_POA_1_ASC = "BATCH_CLAIMS_SUM_POA_1_ASC",
  BATCH_CLAIMS_SUM_POA_1_DESC = "BATCH_CLAIMS_SUM_POA_1_DESC",
  BATCH_CLAIMS_SUM_POA_2_ASC = "BATCH_CLAIMS_SUM_POA_2_ASC",
  BATCH_CLAIMS_SUM_POA_2_DESC = "BATCH_CLAIMS_SUM_POA_2_DESC",
  BATCH_CLAIMS_SUM_POA_3_ASC = "BATCH_CLAIMS_SUM_POA_3_ASC",
  BATCH_CLAIMS_SUM_POA_3_DESC = "BATCH_CLAIMS_SUM_POA_3_DESC",
  BATCH_CLAIMS_SUM_POA_4_ASC = "BATCH_CLAIMS_SUM_POA_4_ASC",
  BATCH_CLAIMS_SUM_POA_4_DESC = "BATCH_CLAIMS_SUM_POA_4_DESC",
  BATCH_CLAIMS_SUM_POA_5_ASC = "BATCH_CLAIMS_SUM_POA_5_ASC",
  BATCH_CLAIMS_SUM_POA_5_DESC = "BATCH_CLAIMS_SUM_POA_5_DESC",
  BATCH_CLAIMS_SUM_POA_6_ASC = "BATCH_CLAIMS_SUM_POA_6_ASC",
  BATCH_CLAIMS_SUM_POA_6_DESC = "BATCH_CLAIMS_SUM_POA_6_DESC",
  BATCH_CLAIMS_SUM_POA_7_ASC = "BATCH_CLAIMS_SUM_POA_7_ASC",
  BATCH_CLAIMS_SUM_POA_7_DESC = "BATCH_CLAIMS_SUM_POA_7_DESC",
  BATCH_CLAIMS_SUM_POA_8_ASC = "BATCH_CLAIMS_SUM_POA_8_ASC",
  BATCH_CLAIMS_SUM_POA_8_DESC = "BATCH_CLAIMS_SUM_POA_8_DESC",
  BATCH_CLAIMS_SUM_POA_9_ASC = "BATCH_CLAIMS_SUM_POA_9_ASC",
  BATCH_CLAIMS_SUM_POA_9_DESC = "BATCH_CLAIMS_SUM_POA_9_DESC",
  BATCH_CLAIMS_SUM_POA_10_ASC = "BATCH_CLAIMS_SUM_POA_10_ASC",
  BATCH_CLAIMS_SUM_POA_10_DESC = "BATCH_CLAIMS_SUM_POA_10_DESC",
  BATCH_CLAIMS_SUM_POA_11_ASC = "BATCH_CLAIMS_SUM_POA_11_ASC",
  BATCH_CLAIMS_SUM_POA_11_DESC = "BATCH_CLAIMS_SUM_POA_11_DESC",
  BATCH_CLAIMS_SUM_POA_12_ASC = "BATCH_CLAIMS_SUM_POA_12_ASC",
  BATCH_CLAIMS_SUM_POA_12_DESC = "BATCH_CLAIMS_SUM_POA_12_DESC",
  BATCH_CLAIMS_SUM_POA_13_ASC = "BATCH_CLAIMS_SUM_POA_13_ASC",
  BATCH_CLAIMS_SUM_POA_13_DESC = "BATCH_CLAIMS_SUM_POA_13_DESC",
  BATCH_CLAIMS_SUM_POA_14_ASC = "BATCH_CLAIMS_SUM_POA_14_ASC",
  BATCH_CLAIMS_SUM_POA_14_DESC = "BATCH_CLAIMS_SUM_POA_14_DESC",
  BATCH_CLAIMS_SUM_POA_15_ASC = "BATCH_CLAIMS_SUM_POA_15_ASC",
  BATCH_CLAIMS_SUM_POA_15_DESC = "BATCH_CLAIMS_SUM_POA_15_DESC",
  BATCH_CLAIMS_SUM_POA_16_ASC = "BATCH_CLAIMS_SUM_POA_16_ASC",
  BATCH_CLAIMS_SUM_POA_16_DESC = "BATCH_CLAIMS_SUM_POA_16_DESC",
  BATCH_CLAIMS_SUM_POA_17_ASC = "BATCH_CLAIMS_SUM_POA_17_ASC",
  BATCH_CLAIMS_SUM_POA_17_DESC = "BATCH_CLAIMS_SUM_POA_17_DESC",
  BATCH_CLAIMS_SUM_POA_18_ASC = "BATCH_CLAIMS_SUM_POA_18_ASC",
  BATCH_CLAIMS_SUM_POA_18_DESC = "BATCH_CLAIMS_SUM_POA_18_DESC",
  BATCH_CLAIMS_SUM_POA_19_ASC = "BATCH_CLAIMS_SUM_POA_19_ASC",
  BATCH_CLAIMS_SUM_POA_19_DESC = "BATCH_CLAIMS_SUM_POA_19_DESC",
  BATCH_CLAIMS_SUM_POA_20_ASC = "BATCH_CLAIMS_SUM_POA_20_ASC",
  BATCH_CLAIMS_SUM_POA_20_DESC = "BATCH_CLAIMS_SUM_POA_20_DESC",
  BATCH_CLAIMS_SUM_POA_21_ASC = "BATCH_CLAIMS_SUM_POA_21_ASC",
  BATCH_CLAIMS_SUM_POA_21_DESC = "BATCH_CLAIMS_SUM_POA_21_DESC",
  BATCH_CLAIMS_SUM_POA_22_ASC = "BATCH_CLAIMS_SUM_POA_22_ASC",
  BATCH_CLAIMS_SUM_POA_22_DESC = "BATCH_CLAIMS_SUM_POA_22_DESC",
  BATCH_CLAIMS_SUM_POA_23_ASC = "BATCH_CLAIMS_SUM_POA_23_ASC",
  BATCH_CLAIMS_SUM_POA_23_DESC = "BATCH_CLAIMS_SUM_POA_23_DESC",
  BATCH_CLAIMS_SUM_POA_24_ASC = "BATCH_CLAIMS_SUM_POA_24_ASC",
  BATCH_CLAIMS_SUM_POA_24_DESC = "BATCH_CLAIMS_SUM_POA_24_DESC",
  BATCH_CLAIMS_SUM_POA_25_ASC = "BATCH_CLAIMS_SUM_POA_25_ASC",
  BATCH_CLAIMS_SUM_POA_25_DESC = "BATCH_CLAIMS_SUM_POA_25_DESC",
  BATCH_CLAIMS_SUM_PREPAY_DENY_ASC = "BATCH_CLAIMS_SUM_PREPAY_DENY_ASC",
  BATCH_CLAIMS_SUM_PREPAY_DENY_DESC = "BATCH_CLAIMS_SUM_PREPAY_DENY_DESC",
  BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_SUM_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_SUM_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_SUM_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_SUM_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_SUM_PROVIDER_ID_ASC = "BATCH_CLAIMS_SUM_PROVIDER_ID_ASC",
  BATCH_CLAIMS_SUM_PROVIDER_ID_DESC = "BATCH_CLAIMS_SUM_PROVIDER_ID_DESC",
  BATCH_CLAIMS_SUM_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_SUM_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_SUM_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_SUM_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_SUM_UPDATED_AT_ASC = "BATCH_CLAIMS_SUM_UPDATED_AT_ASC",
  BATCH_CLAIMS_SUM_UPDATED_AT_DESC = "BATCH_CLAIMS_SUM_UPDATED_AT_DESC",
  BATCH_CLAIMS_SUM_VERSION_ASC = "BATCH_CLAIMS_SUM_VERSION_ASC",
  BATCH_CLAIMS_SUM_VERSION_DESC = "BATCH_CLAIMS_SUM_VERSION_DESC",
  BATCH_CLAIMS_SUM_VERSION_GROUP_ASC = "BATCH_CLAIMS_SUM_VERSION_GROUP_ASC",
  BATCH_CLAIMS_SUM_VERSION_GROUP_DESC = "BATCH_CLAIMS_SUM_VERSION_GROUP_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ICN_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ICN_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_DESC",
  BATCH_FILE_NAME_ASC = "BATCH_FILE_NAME_ASC",
  BATCH_FILE_NAME_DESC = "BATCH_FILE_NAME_DESC",
  BATCH_FILE_URL_ASC = "BATCH_FILE_URL_ASC",
  BATCH_FILE_URL_DESC = "BATCH_FILE_URL_DESC",
  BATCH_NAME_ASC = "BATCH_NAME_ASC",
  BATCH_NAME_DESC = "BATCH_NAME_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ID_ASC = "INSURER_BY_INSURER_ID__CLIENT_ID_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ID_DESC = "INSURER_BY_INSURER_ID__CLIENT_ID_DESC",
  INSURER_BY_INSURER_ID__CREATED_AT_ASC = "INSURER_BY_INSURER_ID__CREATED_AT_ASC",
  INSURER_BY_INSURER_ID__CREATED_AT_DESC = "INSURER_BY_INSURER_ID__CREATED_AT_DESC",
  INSURER_BY_INSURER_ID__ID_ASC = "INSURER_BY_INSURER_ID__ID_ASC",
  INSURER_BY_INSURER_ID__ID_DESC = "INSURER_BY_INSURER_ID__ID_DESC",
  INSURER_BY_INSURER_ID__NAME_ASC = "INSURER_BY_INSURER_ID__NAME_ASC",
  INSURER_BY_INSURER_ID__NAME_DESC = "INSURER_BY_INSURER_ID__NAME_DESC",
  INSURER_BY_INSURER_ID__UPDATED_AT_ASC = "INSURER_BY_INSURER_ID__UPDATED_AT_ASC",
  INSURER_BY_INSURER_ID__UPDATED_AT_DESC = "INSURER_BY_INSURER_ID__UPDATED_AT_DESC",
  INSURER_ID_ASC = "INSURER_ID_ASC",
  INSURER_ID_DESC = "INSURER_ID_DESC",
  NATURAL = "NATURAL",
  OWNER_ID_ASC = "OWNER_ID_ASC",
  OWNER_ID_DESC = "OWNER_ID_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["BigFloat"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["BigFloat"]["input"]>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["BigInt"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["BigInt"]["input"]>>;
};

export type BlockerSegmentHistoryEntry = {
  __typename?: "BlockerSegmentHistoryEntry";
  context?: Maybe<Scalars["JSON"]["output"]>;
  enteredAt: Scalars["Datetime"]["output"];
  exitedAt?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["ID"]["output"];
  segment: StageTrackerBlockerSegment;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
};

export type BucketClaim = Node & {
  __typename?: "BucketClaim";
  /** Reads a single `AuditorBucket` that is related to this `BucketClaim`. */
  auditorBucket?: Maybe<AuditorBucket>;
  auditorBucketId: Scalars["UUID"]["output"];
  /** Reads a single `BatchClaim` that is related to this `BucketClaim`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  selectionMethod?: Maybe<Scalars["JSON"]["output"]>;
  status: AuditFindingClaimStatus;
  updatedAt: Scalars["Datetime"]["output"];
};

export type BucketClaimAggregates = {
  __typename?: "BucketClaimAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BucketClaimDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `BucketClaim` object types. */
export type BucketClaimAggregatesFilter = {
  /** Distinct count aggregate over matching `BucketClaim` objects. */
  distinctCount?: InputMaybe<BucketClaimDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BucketClaim` object to be included within the aggregate. */
  filter?: InputMaybe<BucketClaimFilter>;
};

/** The `auditorBucket` to be created by this mutation. */
export type BucketClaimAuditorBucketIdFkeyAuditorBucketCreateInput = {
  assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
  auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The `bucketClaim` to be created by this mutation. */
export type BucketClaimAuditorBucketIdFkeyBucketClaimCreateInput = {
  auditorBucketToAuditorBucketId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BucketClaimBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  selectionMethod?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<AuditFindingClaimStatus>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditorBucket` in the `BucketClaimInput` mutation. */
export type BucketClaimAuditorBucketIdFkeyInput = {
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorBucketAuditorBucketPkeyConnect>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorBucketNodeIdConnect>;
  /** A `AuditorBucketInput` object that will be created and connected to this object. */
  create?: InputMaybe<BucketClaimAuditorBucketIdFkeyAuditorBucketCreateInput>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteById?: InputMaybe<AuditorBucketAuditorBucketPkeyDelete>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<AuditorBucketNodeIdDelete>;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorBucketOnBucketClaimForBucketClaimAuditorBucketIdFkeyUsingAuditorBucketPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `bucketClaim` in the `AuditorBucketInput` mutation. */
export type BucketClaimAuditorBucketIdFkeyInverseInput = {
  /** The primary key(s) for `bucketClaim` for the far side of the relationship. */
  connectByBatchClaimId?: InputMaybe<
    Array<BucketClaimBucketClaimBatchClaimIdKeyConnect>
  >;
  /** The primary key(s) for `bucketClaim` for the far side of the relationship. */
  connectByBatchClaimIdAndAuditorBucketId?: InputMaybe<
    Array<BucketClaimBucketClaimBatchClaimIdAuditorBucketIdKeyConnect>
  >;
  /** The primary key(s) for `bucketClaim` for the far side of the relationship. */
  connectById?: InputMaybe<Array<BucketClaimBucketClaimPkeyConnect>>;
  /** The primary key(s) for `bucketClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<BucketClaimNodeIdConnect>>;
  /** A `BucketClaimInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<BucketClaimAuditorBucketIdFkeyBucketClaimCreateInput>
  >;
  /** The primary key(s) and patch data for `bucketClaim` for the far side of the relationship. */
  updateByBatchClaimId?: InputMaybe<
    Array<BucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyUsingBucketClaimBatchClaimIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `bucketClaim` for the far side of the relationship. */
  updateByBatchClaimIdAndAuditorBucketId?: InputMaybe<
    Array<BucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyUsingBucketClaimBatchClaimIdAuditorBucketIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `bucketClaim` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<BucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyUsingBucketClaimPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `bucketClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorBucketOnBucketClaimForBucketClaimAuditorBucketIdFkeyNodeIdUpdate>
  >;
};

/** The `bucketClaim` to be created by this mutation. */
export type BucketClaimBatchClaimIdFkeyBucketClaimCreateInput = {
  auditorBucketId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketToAuditorBucketId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<BucketClaimBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  selectionMethod?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<AuditFindingClaimStatus>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `batchClaim` in the `BucketClaimInput` mutation. */
export type BucketClaimBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `bucketClaim` in the `BatchClaimInput` mutation. */
export type BucketClaimBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `bucketClaim` for the far side of the relationship. */
  connectByBatchClaimId?: InputMaybe<BucketClaimBucketClaimBatchClaimIdKeyConnect>;
  /** The primary key(s) for `bucketClaim` for the far side of the relationship. */
  connectByBatchClaimIdAndAuditorBucketId?: InputMaybe<BucketClaimBucketClaimBatchClaimIdAuditorBucketIdKeyConnect>;
  /** The primary key(s) for `bucketClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BucketClaimBucketClaimPkeyConnect>;
  /** The primary key(s) for `bucketClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BucketClaimNodeIdConnect>;
  /** A `BucketClaimInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<BucketClaimBatchClaimIdFkeyBucketClaimCreateInput>>;
  /** The primary key(s) and patch data for `bucketClaim` for the far side of the relationship. */
  updateByBatchClaimId?: InputMaybe<BucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBucketClaimBatchClaimIdKeyUpdate>;
  /** The primary key(s) and patch data for `bucketClaim` for the far side of the relationship. */
  updateByBatchClaimIdAndAuditorBucketId?: InputMaybe<BucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBucketClaimBatchClaimIdAuditorBucketIdKeyUpdate>;
  /** The primary key(s) and patch data for `bucketClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBucketClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `bucketClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyNodeIdUpdate>;
};

/** The fields on `bucketClaim` to look up the row to connect. */
export type BucketClaimBucketClaimBatchClaimIdAuditorBucketIdKeyConnect = {
  auditorBucketId: Scalars["UUID"]["input"];
  batchClaimId: Scalars["UUID"]["input"];
};

/** The fields on `bucketClaim` to look up the row to connect. */
export type BucketClaimBucketClaimBatchClaimIdKeyConnect = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The fields on `bucketClaim` to look up the row to connect. */
export type BucketClaimBucketClaimPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `BucketClaim` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BucketClaimCondition = {
  /** Checks for equality with the object’s `auditorBucketId` field. */
  auditorBucketId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `selectionMethod` field. */
  selectionMethod?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<AuditFindingClaimStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type BucketClaimDistinctCountAggregateFilter = {
  auditorBucketId?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  selectionMethod?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type BucketClaimDistinctCountAggregates = {
  __typename?: "BucketClaimDistinctCountAggregates";
  /** Distinct count of auditorBucketId across the matching connection */
  auditorBucketId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of selectionMethod across the matching connection */
  selectionMethod?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `BucketClaim` object types. All fields are combined with a logical ‘and.’ */
export type BucketClaimFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BucketClaimFilter>>;
  /** Filter by the object’s `auditorBucket` relation. */
  auditorBucket?: InputMaybe<AuditorBucketFilter>;
  /** Filter by the object’s `auditorBucketId` field. */
  auditorBucketId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BucketClaimFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BucketClaimFilter>>;
  /** Filter by the object’s `selectionMethod` field. */
  selectionMethod?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<AuditFindingClaimStatusFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `BucketClaim` for usage during aggregation. */
export enum BucketClaimGroupBy {
  AUDITOR_BUCKET_ID = "AUDITOR_BUCKET_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  SELECTION_METHOD = "SELECTION_METHOD",
  STATUS = "STATUS",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type BucketClaimHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BucketClaimHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `BucketClaim` aggregates. */
export type BucketClaimHavingInput = {
  AND?: InputMaybe<Array<BucketClaimHavingInput>>;
  OR?: InputMaybe<Array<BucketClaimHavingInput>>;
  average?: InputMaybe<BucketClaimHavingAverageInput>;
  distinctCount?: InputMaybe<BucketClaimHavingDistinctCountInput>;
  max?: InputMaybe<BucketClaimHavingMaxInput>;
  min?: InputMaybe<BucketClaimHavingMinInput>;
  stddevPopulation?: InputMaybe<BucketClaimHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BucketClaimHavingStddevSampleInput>;
  sum?: InputMaybe<BucketClaimHavingSumInput>;
  variancePopulation?: InputMaybe<BucketClaimHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BucketClaimHavingVarianceSampleInput>;
};

export type BucketClaimHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BucketClaimHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BucketClaimHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BucketClaimHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BucketClaimHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BucketClaimHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type BucketClaimHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `BucketClaim` */
export type BucketClaimInput = {
  auditorBucketId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketToAuditorBucketId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BucketClaimBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  selectionMethod?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<AuditFindingClaimStatus>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type BucketClaimNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `bucketClaim` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type BucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorBucket` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucket` being updated. */
    patch: AuditorBucketPatch;
  };

/** The fields on `bucketClaim` to look up the row to update. */
export type BucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyUsingBucketClaimBatchClaimIdAuditorBucketIdKeyUpdate =
  {
    auditorBucketId: Scalars["UUID"]["input"];
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `bucketClaim` being updated. */
    patch: updateBucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyPatch;
  };

/** The fields on `bucketClaim` to look up the row to update. */
export type BucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyUsingBucketClaimBatchClaimIdKeyUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `bucketClaim` being updated. */
    patch: updateBucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyPatch;
  };

/** The fields on `bucketClaim` to look up the row to update. */
export type BucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyUsingBucketClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `bucketClaim` being updated. */
    patch: updateBucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type BucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `bucketClaim` to look up the row to update. */
export type BucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBucketClaimBatchClaimIdAuditorBucketIdKeyUpdate =
  {
    auditorBucketId: Scalars["UUID"]["input"];
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `bucketClaim` being updated. */
    patch: updateBucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyPatch;
  };

/** The fields on `bucketClaim` to look up the row to update. */
export type BucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBucketClaimBatchClaimIdKeyUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `bucketClaim` being updated. */
    patch: updateBucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyPatch;
  };

/** The fields on `bucketClaim` to look up the row to update. */
export type BucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyUsingBucketClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `bucketClaim` being updated. */
    patch: updateBucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `BucketClaim`. Fields that are set will be updated. */
export type BucketClaimPatch = {
  auditorBucketId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketToAuditorBucketId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<BucketClaimBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  selectionMethod?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<AuditFindingClaimStatus>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** A connection to a list of `BucketClaim` values. */
export type BucketClaimsConnection = {
  __typename?: "BucketClaimsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BucketClaimAggregates>;
  /** A list of edges which contains the `BucketClaim` and cursor to aid in pagination. */
  edges: Array<BucketClaimsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BucketClaimAggregates>>;
  /** A list of `BucketClaim` objects. */
  nodes: Array<Maybe<BucketClaim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BucketClaim` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `BucketClaim` values. */
export type BucketClaimsConnectiongroupedAggregatesArgs = {
  groupBy: Array<BucketClaimGroupBy>;
  having?: InputMaybe<BucketClaimHavingInput>;
};

/** A `BucketClaim` edge in the connection. */
export type BucketClaimsEdge = {
  __typename?: "BucketClaimsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `BucketClaim` at the end of the edge. */
  node?: Maybe<BucketClaim>;
};

/** Methods to use when ordering `BucketClaim`. */
export enum BucketClaimsOrderBy {
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ASSIGNEE_ID_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ASSIGNEE_ID_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ASSIGNEE_ID_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ASSIGNEE_ID_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__AUTHOR_ID_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__AUTHOR_ID_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__AUTHOR_ID_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__AUTHOR_ID_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__CREATED_AT_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__CREATED_AT_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__CREATED_AT_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__CREATED_AT_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__DUE_DATE_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__DUE_DATE_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__DUE_DATE_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__DUE_DATE_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__FILTER_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__FILTER_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__FILTER_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__FILTER_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ID_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ID_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ID_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__ID_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__INSURER_ID_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__INSURER_ID_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__INSURER_ID_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__INSURER_ID_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__NAME_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__NAME_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__NAME_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__NAME_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__PROVIDER_ID_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__PROVIDER_ID_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__PROVIDER_ID_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__PROVIDER_ID_DESC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__UPDATED_AT_ASC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__UPDATED_AT_ASC",
  AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__UPDATED_AT_DESC = "AUDITOR_BUCKET_BY_AUDITOR_BUCKET_ID__UPDATED_AT_DESC",
  AUDITOR_BUCKET_ID_ASC = "AUDITOR_BUCKET_ID_ASC",
  AUDITOR_BUCKET_ID_DESC = "AUDITOR_BUCKET_ID_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_ID_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_ID_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_ID_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_ID_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_METHOD_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_METHOD_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_METHOD_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_METHOD_DESC",
  AUDIT_SELECTION_METHODS_AVERAGE_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_AVERAGE_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_AVERAGE_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_AVERAGE_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_COUNT_ASC = "AUDIT_SELECTION_METHODS_COUNT_ASC",
  AUDIT_SELECTION_METHODS_COUNT_DESC = "AUDIT_SELECTION_METHODS_COUNT_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_ID_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_ID_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_ID_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_ID_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_METHOD_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_METHOD_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_METHOD_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_METHOD_DESC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_MAX_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_MAX_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_MAX_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_MAX_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_MAX_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_MAX_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_MAX_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_MAX_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_MAX_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_MAX_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_MAX_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_MAX_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_MAX_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_MAX_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_MAX_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_MAX_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_MAX_ID_ASC = "AUDIT_SELECTION_METHODS_MAX_ID_ASC",
  AUDIT_SELECTION_METHODS_MAX_ID_DESC = "AUDIT_SELECTION_METHODS_MAX_ID_DESC",
  AUDIT_SELECTION_METHODS_MAX_METHOD_ASC = "AUDIT_SELECTION_METHODS_MAX_METHOD_ASC",
  AUDIT_SELECTION_METHODS_MAX_METHOD_DESC = "AUDIT_SELECTION_METHODS_MAX_METHOD_DESC",
  AUDIT_SELECTION_METHODS_MAX_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_MAX_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_MAX_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_MAX_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_MIN_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_MIN_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_MIN_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_MIN_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_MIN_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_MIN_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_MIN_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_MIN_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_MIN_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_MIN_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_MIN_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_MIN_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_MIN_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_MIN_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_MIN_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_MIN_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_MIN_ID_ASC = "AUDIT_SELECTION_METHODS_MIN_ID_ASC",
  AUDIT_SELECTION_METHODS_MIN_ID_DESC = "AUDIT_SELECTION_METHODS_MIN_ID_DESC",
  AUDIT_SELECTION_METHODS_MIN_METHOD_ASC = "AUDIT_SELECTION_METHODS_MIN_METHOD_ASC",
  AUDIT_SELECTION_METHODS_MIN_METHOD_DESC = "AUDIT_SELECTION_METHODS_MIN_METHOD_DESC",
  AUDIT_SELECTION_METHODS_MIN_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_MIN_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_MIN_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_MIN_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_METHOD_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_METHOD_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_METHOD_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_METHOD_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_ID_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_ID_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_ID_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_ID_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_METHOD_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_METHOD_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_METHOD_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_METHOD_DESC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_SUM_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_SUM_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_SUM_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_SUM_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_SUM_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_SUM_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_SUM_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_SUM_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_SUM_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_SUM_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_SUM_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_SUM_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_SUM_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_SUM_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_SUM_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_SUM_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_SUM_ID_ASC = "AUDIT_SELECTION_METHODS_SUM_ID_ASC",
  AUDIT_SELECTION_METHODS_SUM_ID_DESC = "AUDIT_SELECTION_METHODS_SUM_ID_DESC",
  AUDIT_SELECTION_METHODS_SUM_METHOD_ASC = "AUDIT_SELECTION_METHODS_SUM_METHOD_ASC",
  AUDIT_SELECTION_METHODS_SUM_METHOD_DESC = "AUDIT_SELECTION_METHODS_SUM_METHOD_DESC",
  AUDIT_SELECTION_METHODS_SUM_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_SUM_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_SUM_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_SUM_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_METHOD_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_METHOD_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_METHOD_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_METHOD_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_AUDIT_SELECTION_JOB_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_AUDIT_SELECTION_JOB_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_AUDIT_SELECTION_JOB_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_AUDIT_SELECTION_JOB_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BUCKET_CLAIM_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BUCKET_CLAIM_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BUCKET_CLAIM_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_BUCKET_CLAIM_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_ID_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_ID_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_METHOD_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_METHOD_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_METHOD_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_METHOD_DESC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_SELECTION_METHODS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  SELECTION_METHOD_ASC = "SELECTION_METHOD_ASC",
  SELECTION_METHOD_DESC = "SELECTION_METHOD_DESC",
  STATUS_ASC = "STATUS_ASC",
  STATUS_DESC = "STATUS_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** All input for the `bucketClaimsUpdateStatus` mutation. */
export type BucketClaimsUpdateStatusInput = {
  bucketClaims?: InputMaybe<Array<InputMaybe<BucketClaimInput>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our `bucketClaimsUpdateStatus` mutation. */
export type BucketClaimsUpdateStatusPayload = {
  __typename?: "BucketClaimsUpdateStatusPayload";
  boolean?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Case = {
  __typename?: "Case";
  agentTypes?: Maybe<Array<CaseAgentType>>;
  agents?: Maybe<Array<Agent>>;
  /**
   * The batch_claim linked to this case via v3.claim_case, or null if
   * no claim is associated yet. The linkage row is written by
   * getCasesByClaimId when a case is auto-created for a claim (see
   * ClaimService.pgInsertClaimCase). Nullable because ask_autodor
   * cases may exist without a claim (e.g. seeded demo cases,
   * chat-only cases).
   */
  claim?: Maybe<BatchClaim>;
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  createdAt: Scalars["String"]["output"];
  files?: Maybe<Array<File>>;
  id: Scalars["UUID"]["output"];
  latestQuestion?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  queue?: Maybe<AskAutodorQueue>;
  status?: Maybe<CaseStatus>;
};

export type CaseAgentType = {
  __typename?: "CaseAgentType";
  taskDisplayName: Scalars["String"]["output"];
  taskId: Scalars["UUID"]["output"];
  workflowStatus: Scalars["Int"]["output"];
};

export enum CaseStatus {
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  IN_PROGRESS = "IN_PROGRESS",
  PROCESSING = "PROCESSING",
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
}

/**
 * Connection arguments for paginating through Cases.
 *
 * Note: The filter fields (filter, filterArray, filterGraph) are mutually exclusive.
 * Only one filter type may be provided per query. An error will be returned if multiple filter types are specified.
 */
export type CasesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  /**
   * Array-based filter (legacy support, will be replaced by graph filters in a future version).
   * Mutually exclusive with filterArray and filterGraph.
   */
  filter?: InputMaybe<Array<CasesFilter>>;
  /**
   * Explicit array-based filter.
   * Mutually exclusive with filter and filterGraph.
   */
  filterArray?: InputMaybe<Array<CasesFilter>>;
  /**
   * PostGraphile-style object graph filter.
   * Mutually exclusive with filter and filterArray.
   */
  filterGraph?: InputMaybe<CasesFilterGraph>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CasesOrdering>>;
  queueId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type CasesConnection = {
  __typename?: "CasesConnection";
  edges: Array<CasesEdge>;
  nodes: Array<Case>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type CasesEdge = {
  __typename?: "CasesEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Case;
};

/** Supports all PostGraphile-style operators */
export type CasesFieldFilter = {
  distinctFrom?: InputMaybe<Scalars["JSON"]["input"]>;
  endsWith?: InputMaybe<Scalars["String"]["input"]>;
  endsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  equalTo?: InputMaybe<Scalars["JSON"]["input"]>;
  equalToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  greaterThan?: InputMaybe<Scalars["JSON"]["input"]>;
  greaterThanInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  greaterThanOrEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["JSON"]["input"]>>;
  inInsensitive?: InputMaybe<Array<Scalars["String"]["input"]>>;
  includes?: InputMaybe<Scalars["String"]["input"]>;
  includesInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  lessThan?: InputMaybe<Scalars["JSON"]["input"]>;
  lessThanInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  lessThanOrEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  like?: InputMaybe<Scalars["String"]["input"]>;
  likeInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  notDistinctFrom?: InputMaybe<Scalars["JSON"]["input"]>;
  notEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  notIn?: InputMaybe<Array<Scalars["JSON"]["input"]>>;
  notLike?: InputMaybe<Scalars["String"]["input"]>;
  notLikeInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
  startsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
};

export type CasesFilter = {
  field: CasesFilterField;
  op: CasesFilterOperator;
  value: Scalars["JSON"]["input"];
};

export enum CasesFilterField {
  AGENT_TYPE = "AGENT_TYPE",
  CREATED_AT = "CREATED_AT",
  ID = "ID",
  NAME = "NAME",
  QUEUE_ID = "QUEUE_ID",
  QUEUE_NAME = "QUEUE_NAME",
  STATUS = "STATUS",
}

/** PostGraphile-style object graph filter */
export type CasesFilterGraph = {
  /** Filter by the object's `agent_type` field. */
  agent_type?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CasesFilterGraph>>;
  /** Filter by the object's `created_at` field. */
  created_at?: InputMaybe<DatetimeFilter>;
  /** Filter by the object's `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object's `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CasesFilterGraph>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CasesFilterGraph>>;
  /** Filter by the object's `queue_id` field. */
  queue_id?: InputMaybe<UUIDFilter>;
  /** Filter by the object's `queue_name` field. */
  queue_name?: InputMaybe<StringFilter>;
  /** Filter by the object's `status` field. */
  status?: InputMaybe<StringFilter>;
};

export enum CasesFilterOperator {
  ANY = "ANY",
  EQ = "EQ",
  GT = "GT",
  ILIKE = "ILIKE",
  IN = "IN",
  LIKE = "LIKE",
  LT = "LT",
}

export type CasesInput = {
  queueId?: InputMaybe<Scalars["ID"]["input"]>;
};

export enum CasesOrderField {
  CREATED_AT = "CREATED_AT",
  ID = "ID",
  NAME = "NAME",
  STATUS = "STATUS",
}

export type CasesOrdering = {
  direction?: SortDirection;
  field: CasesOrderField;
};

export type Citation = {
  __typename?: "Citation";
  annotation?: Maybe<FileAiAnnotation>;
  annotationId?: Maybe<Scalars["UUID"]["output"]>;
  key: Scalars["String"]["output"];
};

export type Claim = {
  __typename?: "Claim";
  autodor?: Maybe<Autodor>;
  /**
   * Claim facets with human-readable slugs instead of UUIDs.
   * Facet keys and keyword values are resolved to slugs where possible.
   * Unknown/deleted facets or keywords remain as UUIDs for debugging.
   * Returns flat JSON object: { facet_slug: value, ... }
   * Compare with claimFacet.facets to see UUID-keyed version.
   */
  claimProperties?: Maybe<Scalars["JSON"]["output"]>;
  /**
   * Per-status counts of active findings on this claim. Always
   * claim-wide — never narrowed by an active findings.statusFilter,
   * so the UI can display what's being filtered out.
   */
  findingStatusCounts: FindingStatusCounts;
  /**
   * Findings on this claim, optionally filtered to a set of statuses
   * and/or a set of authors. When a filter is omitted, that dimension
   * does not constrain the result. When both are provided, findings
   * must match both (AND across filters).
   */
  findings: Array<Finding>;
  icn: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  itemizedBillLines: Array<ItemizedBillLine>;
  permissions: Array<Scalars["String"]["output"]>;
};

export type ClaimfindingsArgs = {
  createdByFilter?: InputMaybe<FindingCreatedByFilterInput>;
  statusFilter?: InputMaybe<Array<FindingStatus>>;
};

/**
 * UI hints only — NOT authorization. Do not use to gate security-sensitive
 * operations; OpenFGA Check at mutation time is SoT for enforcement (T7+).
 * Fail closed when OpenFGA is unavailable (never returns allow-all).
 */
export type ClaimActionPermissions = {
  __typename?: "ClaimActionPermissions";
  /** True when the caller has organization admin_role (bypass hint for UI). */
  bypassOrganizationAdmin: Scalars["Boolean"]["output"];
  claimId: Scalars["UUID"]["output"];
  createBlocker: Scalars["Boolean"]["output"];
  createFinding: Scalars["Boolean"]["output"];
  currentStageId?: Maybe<Scalars["UUID"]["output"]>;
  deleteBlocker: Scalars["Boolean"]["output"];
  editBlocker: Scalars["Boolean"]["output"];
  editFinding: Scalars["Boolean"]["output"];
  editStage: Scalars["Boolean"]["output"];
};

/** Backs claim blocker lifecycle configuration; parallel to v3.claim_audit_phase. */
export type ClaimAuditBlocker = Node & {
  __typename?: "ClaimAuditBlocker";
  authorId?: Maybe<Scalars["UUID"]["output"]>;
  createdAt: Scalars["Datetime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  labelOrder?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  stagesFacetId: Scalars["UUID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type ClaimAuditBlockerAggregates = {
  __typename?: "ClaimAuditBlockerAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ClaimAuditBlockerAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ClaimAuditBlockerDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ClaimAuditBlockerMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ClaimAuditBlockerMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ClaimAuditBlockerStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ClaimAuditBlockerStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ClaimAuditBlockerSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ClaimAuditBlockerVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ClaimAuditBlockerVarianceSampleAggregates>;
};

export type ClaimAuditBlockerAverageAggregates = {
  __typename?: "ClaimAuditBlockerAverageAggregates";
  /** Mean average of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
};

/**
 * A condition to be used against `ClaimAuditBlocker` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ClaimAuditBlockerCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `labelOrder` field. */
  labelOrder?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `stagesFacetId` field. */
  stagesFacetId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type ClaimAuditBlockerDistinctCountAggregates = {
  __typename?: "ClaimAuditBlockerDistinctCountAggregates";
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of labelOrder across the matching connection */
  labelOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of slug across the matching connection */
  slug?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of stagesFacetId across the matching connection */
  stagesFacetId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ClaimAuditBlocker` object types. All fields are combined with a logical ‘and.’ */
export type ClaimAuditBlockerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClaimAuditBlockerFilter>>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `labelOrder` field. */
  labelOrder?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClaimAuditBlockerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClaimAuditBlockerFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `stagesFacetId` field. */
  stagesFacetId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `ClaimAuditBlocker` for usage during aggregation. */
export enum ClaimAuditBlockerGroupBy {
  AUTHOR_ID = "AUTHOR_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DESCRIPTION = "DESCRIPTION",
  LABEL_ORDER = "LABEL_ORDER",
  NAME = "NAME",
  SORT_ORDER = "SORT_ORDER",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type ClaimAuditBlockerHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  sortOrder?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  sortOrder?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ClaimAuditBlocker` aggregates. */
export type ClaimAuditBlockerHavingInput = {
  AND?: InputMaybe<Array<ClaimAuditBlockerHavingInput>>;
  OR?: InputMaybe<Array<ClaimAuditBlockerHavingInput>>;
  average?: InputMaybe<ClaimAuditBlockerHavingAverageInput>;
  distinctCount?: InputMaybe<ClaimAuditBlockerHavingDistinctCountInput>;
  max?: InputMaybe<ClaimAuditBlockerHavingMaxInput>;
  min?: InputMaybe<ClaimAuditBlockerHavingMinInput>;
  stddevPopulation?: InputMaybe<ClaimAuditBlockerHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ClaimAuditBlockerHavingStddevSampleInput>;
  sum?: InputMaybe<ClaimAuditBlockerHavingSumInput>;
  variancePopulation?: InputMaybe<ClaimAuditBlockerHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ClaimAuditBlockerHavingVarianceSampleInput>;
};

export type ClaimAuditBlockerHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  sortOrder?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  sortOrder?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  sortOrder?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  sortOrder?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  sortOrder?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  sortOrder?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  sortOrder?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerMaxAggregates = {
  __typename?: "ClaimAuditBlockerMaxAggregates";
  /** Maximum of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars["Int"]["output"]>;
};

export type ClaimAuditBlockerMinAggregates = {
  __typename?: "ClaimAuditBlockerMinAggregates";
  /** Minimum of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars["Int"]["output"]>;
};

/** A connection to a list of `ClaimAuditBlockerStageAvailability` values. */
export type ClaimAuditBlockerStageAvailabilitiesConnection = {
  __typename?: "ClaimAuditBlockerStageAvailabilitiesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ClaimAuditBlockerStageAvailabilityAggregates>;
  /** A list of edges which contains the `ClaimAuditBlockerStageAvailability` and cursor to aid in pagination. */
  edges: Array<ClaimAuditBlockerStageAvailabilitiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<
    Array<ClaimAuditBlockerStageAvailabilityAggregates>
  >;
  /** A list of `ClaimAuditBlockerStageAvailability` objects. */
  nodes: Array<Maybe<ClaimAuditBlockerStageAvailability>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClaimAuditBlockerStageAvailability` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ClaimAuditBlockerStageAvailability` values. */
export type ClaimAuditBlockerStageAvailabilitiesConnectiongroupedAggregatesArgs =
  {
    groupBy: Array<ClaimAuditBlockerStageAvailabilityGroupBy>;
    having?: InputMaybe<ClaimAuditBlockerStageAvailabilityHavingInput>;
  };

/** A `ClaimAuditBlockerStageAvailability` edge in the connection. */
export type ClaimAuditBlockerStageAvailabilitiesEdge = {
  __typename?: "ClaimAuditBlockerStageAvailabilitiesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ClaimAuditBlockerStageAvailability` at the end of the edge. */
  node?: Maybe<ClaimAuditBlockerStageAvailability>;
};

/** Methods to use when ordering `ClaimAuditBlockerStageAvailability`. */
export enum ClaimAuditBlockerStageAvailabilitiesOrderBy {
  AUDIT_TYPE_ASC = "AUDIT_TYPE_ASC",
  AUDIT_TYPE_DESC = "AUDIT_TYPE_DESC",
  BLOCKER_STAGE_KEYWORD_ID_ASC = "BLOCKER_STAGE_KEYWORD_ID_ASC",
  BLOCKER_STAGE_KEYWORD_ID_DESC = "BLOCKER_STAGE_KEYWORD_ID_DESC",
  CLIENT_SLUG_ASC = "CLIENT_SLUG_ASC",
  CLIENT_SLUG_DESC = "CLIENT_SLUG_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PAYMENT_TYPE_ASC = "PAYMENT_TYPE_ASC",
  PAYMENT_TYPE_DESC = "PAYMENT_TYPE_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

/** Which blocker stages are enabled for a given client, audit type, and payment type (from lifecycle blocker matrix). */
export type ClaimAuditBlockerStageAvailability = Node & {
  __typename?: "ClaimAuditBlockerStageAvailability";
  auditType: Scalars["String"]["output"];
  blockerStageKeywordId: Scalars["UUID"]["output"];
  clientSlug: Scalars["String"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  paymentType: Scalars["String"]["output"];
};

export type ClaimAuditBlockerStageAvailabilityAggregates = {
  __typename?: "ClaimAuditBlockerStageAvailabilityAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ClaimAuditBlockerStageAvailabilityDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * A condition to be used against `ClaimAuditBlockerStageAvailability` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type ClaimAuditBlockerStageAvailabilityCondition = {
  /** Checks for equality with the object’s `auditType` field. */
  auditType?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `blockerStageKeywordId` field. */
  blockerStageKeywordId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `clientSlug` field. */
  clientSlug?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `paymentType` field. */
  paymentType?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClaimAuditBlockerStageAvailabilityDistinctCountAggregates = {
  __typename?: "ClaimAuditBlockerStageAvailabilityDistinctCountAggregates";
  /** Distinct count of auditType across the matching connection */
  auditType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of blockerStageKeywordId across the matching connection */
  blockerStageKeywordId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientSlug across the matching connection */
  clientSlug?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of paymentType across the matching connection */
  paymentType?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ClaimAuditBlockerStageAvailability` object types. All fields are combined with a logical ‘and.’ */
export type ClaimAuditBlockerStageAvailabilityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClaimAuditBlockerStageAvailabilityFilter>>;
  /** Filter by the object’s `auditType` field. */
  auditType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `blockerStageKeywordId` field. */
  blockerStageKeywordId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `clientSlug` field. */
  clientSlug?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClaimAuditBlockerStageAvailabilityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClaimAuditBlockerStageAvailabilityFilter>>;
  /** Filter by the object’s `paymentType` field. */
  paymentType?: InputMaybe<StringFilter>;
};

/** Grouping methods for `ClaimAuditBlockerStageAvailability` for usage during aggregation. */
export enum ClaimAuditBlockerStageAvailabilityGroupBy {
  AUDIT_TYPE = "AUDIT_TYPE",
  BLOCKER_STAGE_KEYWORD_ID = "BLOCKER_STAGE_KEYWORD_ID",
  CLIENT_SLUG = "CLIENT_SLUG",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  PAYMENT_TYPE = "PAYMENT_TYPE",
}

export type ClaimAuditBlockerStageAvailabilityHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerStageAvailabilityHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ClaimAuditBlockerStageAvailability` aggregates. */
export type ClaimAuditBlockerStageAvailabilityHavingInput = {
  AND?: InputMaybe<Array<ClaimAuditBlockerStageAvailabilityHavingInput>>;
  OR?: InputMaybe<Array<ClaimAuditBlockerStageAvailabilityHavingInput>>;
  average?: InputMaybe<ClaimAuditBlockerStageAvailabilityHavingAverageInput>;
  distinctCount?: InputMaybe<ClaimAuditBlockerStageAvailabilityHavingDistinctCountInput>;
  max?: InputMaybe<ClaimAuditBlockerStageAvailabilityHavingMaxInput>;
  min?: InputMaybe<ClaimAuditBlockerStageAvailabilityHavingMinInput>;
  stddevPopulation?: InputMaybe<ClaimAuditBlockerStageAvailabilityHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ClaimAuditBlockerStageAvailabilityHavingStddevSampleInput>;
  sum?: InputMaybe<ClaimAuditBlockerStageAvailabilityHavingSumInput>;
  variancePopulation?: InputMaybe<ClaimAuditBlockerStageAvailabilityHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ClaimAuditBlockerStageAvailabilityHavingVarianceSampleInput>;
};

export type ClaimAuditBlockerStageAvailabilityHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerStageAvailabilityHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerStageAvailabilityHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerStageAvailabilityHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerStageAvailabilityHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerStageAvailabilityHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerStageAvailabilityHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditBlockerStddevPopulationAggregates = {
  __typename?: "ClaimAuditBlockerStddevPopulationAggregates";
  /** Population standard deviation of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimAuditBlockerStddevSampleAggregates = {
  __typename?: "ClaimAuditBlockerStddevSampleAggregates";
  /** Sample standard deviation of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimAuditBlockerSumAggregates = {
  __typename?: "ClaimAuditBlockerSumAggregates";
  /** Sum of sortOrder across the matching connection */
  sortOrder: Scalars["BigInt"]["output"];
};

export type ClaimAuditBlockerVariancePopulationAggregates = {
  __typename?: "ClaimAuditBlockerVariancePopulationAggregates";
  /** Population variance of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimAuditBlockerVarianceSampleAggregates = {
  __typename?: "ClaimAuditBlockerVarianceSampleAggregates";
  /** Sample variance of sortOrder across the matching connection */
  sortOrder?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** A connection to a list of `ClaimAuditBlocker` values. */
export type ClaimAuditBlockersConnection = {
  __typename?: "ClaimAuditBlockersConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ClaimAuditBlockerAggregates>;
  /** A list of edges which contains the `ClaimAuditBlocker` and cursor to aid in pagination. */
  edges: Array<ClaimAuditBlockersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ClaimAuditBlockerAggregates>>;
  /** A list of `ClaimAuditBlocker` objects. */
  nodes: Array<Maybe<ClaimAuditBlocker>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClaimAuditBlocker` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ClaimAuditBlocker` values. */
export type ClaimAuditBlockersConnectiongroupedAggregatesArgs = {
  groupBy: Array<ClaimAuditBlockerGroupBy>;
  having?: InputMaybe<ClaimAuditBlockerHavingInput>;
};

/** A `ClaimAuditBlocker` edge in the connection. */
export type ClaimAuditBlockersEdge = {
  __typename?: "ClaimAuditBlockersEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ClaimAuditBlocker` at the end of the edge. */
  node?: Maybe<ClaimAuditBlocker>;
};

/** Methods to use when ordering `ClaimAuditBlocker`. */
export enum ClaimAuditBlockersOrderBy {
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DESCRIPTION_ASC = "DESCRIPTION_ASC",
  DESCRIPTION_DESC = "DESCRIPTION_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  LABEL_ORDER_ASC = "LABEL_ORDER_ASC",
  LABEL_ORDER_DESC = "LABEL_ORDER_DESC",
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  SLUG_ASC = "SLUG_ASC",
  SLUG_DESC = "SLUG_DESC",
  SORT_ORDER_ASC = "SORT_ORDER_ASC",
  SORT_ORDER_DESC = "SORT_ORDER_DESC",
  STAGES_FACET_ID_ASC = "STAGES_FACET_ID_ASC",
  STAGES_FACET_ID_DESC = "STAGES_FACET_ID_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type ClaimAuditGroup = Node & {
  __typename?: "ClaimAuditGroup";
  appealDueDate?: Maybe<Scalars["Date"]["output"]>;
  auditDueDate?: Maybe<Scalars["Date"]["output"]>;
  auditStartDate?: Maybe<Scalars["Date"]["output"]>;
  auditType?: Maybe<ClaimAuditType>;
  /** Reads a single `AuditorUser` that is related to this `ClaimAuditGroup`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads and enables pagination through a set of `BatchClaimState`. */
  batchClaimStates: BatchClaimStatesConnection;
  clientReportSentDate?: Maybe<Scalars["Date"]["output"]>;
  /**
   * Comments on this audit group, newest first. Hard-capped at
   * 500 rows — this is a guardrail, not a paging mechanism.
   * Internal-only: admins and auditors read all rows; provider and
   * payer roles have no grant on the underlying table and will be
   * rejected with permission denied.
   */
  comments: Array<ClaimAuditGroupComment>;
  createdAt: Scalars["Datetime"]["output"];
  createdBy: Scalars["UUID"]["output"];
  disputeDueDate?: Maybe<Scalars["Date"]["output"]>;
  disputeReceivedDate?: Maybe<Scalars["Date"]["output"]>;
  docReqDueDate?: Maybe<Scalars["Date"]["output"]>;
  dueDate?: Maybe<Scalars["Date"]["output"]>;
  finalProviderReportSentDate?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["UUID"]["output"];
  initialProviderReportSentDate?: Maybe<Scalars["Date"]["output"]>;
  /** Reads a single `Insurer` that is related to this `ClaimAuditGroup`. */
  insurer?: Maybe<Insurer>;
  insurerId?: Maybe<Scalars["UUID"]["output"]>;
  name: Scalars["String"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  qaDueDate?: Maybe<Scalars["Date"]["output"]>;
  tatStartDate?: Maybe<Scalars["Date"]["output"]>;
  /** Total claims currently assigned to this audit group. */
  totalClaimsCount: Scalars["Int"]["output"];
};

export type ClaimAuditGroupbatchClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimStateCondition>;
  filter?: InputMaybe<BatchClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimStatesOrderBy>>;
};

export type ClaimAuditGroupAggregates = {
  __typename?: "ClaimAuditGroupAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ClaimAuditGroupDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `ClaimAuditGroup` object types. */
export type ClaimAuditGroupAggregatesFilter = {
  /** Distinct count aggregate over matching `ClaimAuditGroup` objects. */
  distinctCount?: InputMaybe<ClaimAuditGroupDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ClaimAuditGroup` object to be included within the aggregate. */
  filter?: InputMaybe<ClaimAuditGroupFilter>;
};

/** The fields on `claimAuditGroup` to look up the row to connect. */
export type ClaimAuditGroupClaimAuditGroupNameKeyConnect = {
  name: Scalars["String"]["input"];
};

/** The fields on `claimAuditGroup` to look up the row to delete. */
export type ClaimAuditGroupClaimAuditGroupNameKeyDelete = {
  name: Scalars["String"]["input"];
};

/** The fields on `claimAuditGroup` to look up the row to connect. */
export type ClaimAuditGroupClaimAuditGroupPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `claimAuditGroup` to look up the row to delete. */
export type ClaimAuditGroupClaimAuditGroupPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/**
 * A free-text comment posted on a ClaimAuditGroup by an internal user
 * (admin or auditor). Append-only: no edit or delete surface.
 */
export type ClaimAuditGroupComment = {
  __typename?: "ClaimAuditGroupComment";
  authorId: Scalars["UUID"]["output"];
  /**
   * Display name of the author, joined from auditor_user
   * (first_name + ' ' + last_name). Empty string if the author row
   * cannot be resolved (deleted user) or if both name parts are
   * blank. Partial names skip the missing part rather than emitting
   * a stray space.
   */
  authorName: Scalars["String"]["output"];
  body: Scalars["String"]["output"];
  claimAuditGroupId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `ClaimAuditGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ClaimAuditGroupCondition = {
  /** Checks for equality with the object’s `appealDueDate` field. */
  appealDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `auditDueDate` field. */
  auditDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `auditStartDate` field. */
  auditStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `auditType` field. */
  auditType?: InputMaybe<ClaimAuditType>;
  /** Checks for equality with the object’s `clientReportSentDate` field. */
  clientReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `disputeDueDate` field. */
  disputeDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `disputeReceivedDate` field. */
  disputeReceivedDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `docReqDueDate` field. */
  docReqDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `dueDate` field. */
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `finalProviderReportSentDate` field. */
  finalProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `initialProviderReportSentDate` field. */
  initialProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `insurerId` field. */
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `qaDueDate` field. */
  qaDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `tatStartDate` field. */
  tatStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `ClaimAuditGroupInput` mutation. */
export type ClaimAuditGroupCreatedByFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `claimAuditGroup` in the `AuditorUserInput` mutation. */
export type ClaimAuditGroupCreatedByFkeyInverseInput = {
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ClaimAuditGroupClaimAuditGroupPkeyConnect>>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  connectByName?: InputMaybe<
    Array<ClaimAuditGroupClaimAuditGroupNameKeyConnect>
  >;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ClaimAuditGroupNodeIdConnect>>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ClaimAuditGroupClaimAuditGroupPkeyDelete>>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  deleteByName?: InputMaybe<Array<ClaimAuditGroupClaimAuditGroupNameKeyDelete>>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ClaimAuditGroupNodeIdDelete>>;
  /** Flag indicating whether all other `claimAuditGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `claimAuditGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyUsingClaimAuditGroupPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `claimAuditGroup` for the far side of the relationship. */
  updateByName?: InputMaybe<
    Array<ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyUsingClaimAuditGroupNameKeyUpdate>
  >;
  /** The primary key(s) and patch data for `claimAuditGroup` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyNodeIdUpdate>
  >;
};

export type ClaimAuditGroupDistinctCountAggregateFilter = {
  appealDueDate?: InputMaybe<BigIntFilter>;
  auditDueDate?: InputMaybe<BigIntFilter>;
  auditStartDate?: InputMaybe<BigIntFilter>;
  auditType?: InputMaybe<BigIntFilter>;
  clientReportSentDate?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  createdBy?: InputMaybe<BigIntFilter>;
  disputeDueDate?: InputMaybe<BigIntFilter>;
  disputeReceivedDate?: InputMaybe<BigIntFilter>;
  docReqDueDate?: InputMaybe<BigIntFilter>;
  dueDate?: InputMaybe<BigIntFilter>;
  finalProviderReportSentDate?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  initialProviderReportSentDate?: InputMaybe<BigIntFilter>;
  insurerId?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<BigIntFilter>;
  qaDueDate?: InputMaybe<BigIntFilter>;
  tatStartDate?: InputMaybe<BigIntFilter>;
};

export type ClaimAuditGroupDistinctCountAggregates = {
  __typename?: "ClaimAuditGroupDistinctCountAggregates";
  /** Distinct count of appealDueDate across the matching connection */
  appealDueDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditDueDate across the matching connection */
  auditDueDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditStartDate across the matching connection */
  auditStartDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditType across the matching connection */
  auditType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientReportSentDate across the matching connection */
  clientReportSentDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of disputeDueDate across the matching connection */
  disputeDueDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of disputeReceivedDate across the matching connection */
  disputeReceivedDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of docReqDueDate across the matching connection */
  docReqDueDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dueDate across the matching connection */
  dueDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of finalProviderReportSentDate across the matching connection */
  finalProviderReportSentDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of initialProviderReportSentDate across the matching connection */
  initialProviderReportSentDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of insurerId across the matching connection */
  insurerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of qaDueDate across the matching connection */
  qaDueDate?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of tatStartDate across the matching connection */
  tatStartDate?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ClaimAuditGroup` object types. All fields are combined with a logical ‘and.’ */
export type ClaimAuditGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClaimAuditGroupFilter>>;
  /** Filter by the object’s `appealDueDate` field. */
  appealDueDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `auditDueDate` field. */
  auditDueDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `auditStartDate` field. */
  auditStartDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `auditType` field. */
  auditType?: InputMaybe<ClaimAuditTypeFilter>;
  /** Filter by the object’s `auditorUserByCreatedBy` relation. */
  auditorUserByCreatedBy?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `batchClaimStates` relation. */
  batchClaimStates?: InputMaybe<ClaimAuditGroupToManyBatchClaimStateFilter>;
  /** Some related `batchClaimStates` exist. */
  batchClaimStatesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `clientReportSentDate` field. */
  clientReportSentDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `disputeDueDate` field. */
  disputeDueDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `disputeReceivedDate` field. */
  disputeReceivedDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `docReqDueDate` field. */
  docReqDueDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `dueDate` field. */
  dueDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `finalProviderReportSentDate` field. */
  finalProviderReportSentDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `initialProviderReportSentDate` field. */
  initialProviderReportSentDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `insurer` relation. */
  insurer?: InputMaybe<InsurerFilter>;
  /** A related `insurer` exists. */
  insurerExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `insurerId` field. */
  insurerId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClaimAuditGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClaimAuditGroupFilter>>;
  /** Filter by the object’s `qaDueDate` field. */
  qaDueDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `tatStartDate` field. */
  tatStartDate?: InputMaybe<DateFilter>;
};

/** Grouping methods for `ClaimAuditGroup` for usage during aggregation. */
export enum ClaimAuditGroupGroupBy {
  APPEAL_DUE_DATE = "APPEAL_DUE_DATE",
  AUDIT_DUE_DATE = "AUDIT_DUE_DATE",
  AUDIT_START_DATE = "AUDIT_START_DATE",
  AUDIT_TYPE = "AUDIT_TYPE",
  CLIENT_REPORT_SENT_DATE = "CLIENT_REPORT_SENT_DATE",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  CREATED_BY = "CREATED_BY",
  DISPUTE_DUE_DATE = "DISPUTE_DUE_DATE",
  DISPUTE_RECEIVED_DATE = "DISPUTE_RECEIVED_DATE",
  DOC_REQ_DUE_DATE = "DOC_REQ_DUE_DATE",
  DUE_DATE = "DUE_DATE",
  FINAL_PROVIDER_REPORT_SENT_DATE = "FINAL_PROVIDER_REPORT_SENT_DATE",
  INITIAL_PROVIDER_REPORT_SENT_DATE = "INITIAL_PROVIDER_REPORT_SENT_DATE",
  INSURER_ID = "INSURER_ID",
  QA_DUE_DATE = "QA_DUE_DATE",
  TAT_START_DATE = "TAT_START_DATE",
}

export type ClaimAuditGroupHavingAverageInput = {
  appealDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  disputeDueDate?: InputMaybe<HavingDatetimeFilter>;
  disputeReceivedDate?: InputMaybe<HavingDatetimeFilter>;
  docReqDueDate?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  finalProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  initialProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  qaDueDate?: InputMaybe<HavingDatetimeFilter>;
  tatStartDate?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditGroupHavingDistinctCountInput = {
  appealDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  disputeDueDate?: InputMaybe<HavingDatetimeFilter>;
  disputeReceivedDate?: InputMaybe<HavingDatetimeFilter>;
  docReqDueDate?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  finalProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  initialProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  qaDueDate?: InputMaybe<HavingDatetimeFilter>;
  tatStartDate?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ClaimAuditGroup` aggregates. */
export type ClaimAuditGroupHavingInput = {
  AND?: InputMaybe<Array<ClaimAuditGroupHavingInput>>;
  OR?: InputMaybe<Array<ClaimAuditGroupHavingInput>>;
  average?: InputMaybe<ClaimAuditGroupHavingAverageInput>;
  distinctCount?: InputMaybe<ClaimAuditGroupHavingDistinctCountInput>;
  max?: InputMaybe<ClaimAuditGroupHavingMaxInput>;
  min?: InputMaybe<ClaimAuditGroupHavingMinInput>;
  stddevPopulation?: InputMaybe<ClaimAuditGroupHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ClaimAuditGroupHavingStddevSampleInput>;
  sum?: InputMaybe<ClaimAuditGroupHavingSumInput>;
  variancePopulation?: InputMaybe<ClaimAuditGroupHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ClaimAuditGroupHavingVarianceSampleInput>;
};

export type ClaimAuditGroupHavingMaxInput = {
  appealDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  disputeDueDate?: InputMaybe<HavingDatetimeFilter>;
  disputeReceivedDate?: InputMaybe<HavingDatetimeFilter>;
  docReqDueDate?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  finalProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  initialProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  qaDueDate?: InputMaybe<HavingDatetimeFilter>;
  tatStartDate?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditGroupHavingMinInput = {
  appealDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  disputeDueDate?: InputMaybe<HavingDatetimeFilter>;
  disputeReceivedDate?: InputMaybe<HavingDatetimeFilter>;
  docReqDueDate?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  finalProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  initialProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  qaDueDate?: InputMaybe<HavingDatetimeFilter>;
  tatStartDate?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditGroupHavingStddevPopulationInput = {
  appealDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  disputeDueDate?: InputMaybe<HavingDatetimeFilter>;
  disputeReceivedDate?: InputMaybe<HavingDatetimeFilter>;
  docReqDueDate?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  finalProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  initialProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  qaDueDate?: InputMaybe<HavingDatetimeFilter>;
  tatStartDate?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditGroupHavingStddevSampleInput = {
  appealDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  disputeDueDate?: InputMaybe<HavingDatetimeFilter>;
  disputeReceivedDate?: InputMaybe<HavingDatetimeFilter>;
  docReqDueDate?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  finalProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  initialProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  qaDueDate?: InputMaybe<HavingDatetimeFilter>;
  tatStartDate?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditGroupHavingSumInput = {
  appealDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  disputeDueDate?: InputMaybe<HavingDatetimeFilter>;
  disputeReceivedDate?: InputMaybe<HavingDatetimeFilter>;
  docReqDueDate?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  finalProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  initialProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  qaDueDate?: InputMaybe<HavingDatetimeFilter>;
  tatStartDate?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditGroupHavingVariancePopulationInput = {
  appealDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  disputeDueDate?: InputMaybe<HavingDatetimeFilter>;
  disputeReceivedDate?: InputMaybe<HavingDatetimeFilter>;
  docReqDueDate?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  finalProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  initialProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  qaDueDate?: InputMaybe<HavingDatetimeFilter>;
  tatStartDate?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimAuditGroupHavingVarianceSampleInput = {
  appealDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditDueDate?: InputMaybe<HavingDatetimeFilter>;
  auditStartDate?: InputMaybe<HavingDatetimeFilter>;
  clientReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  disputeDueDate?: InputMaybe<HavingDatetimeFilter>;
  disputeReceivedDate?: InputMaybe<HavingDatetimeFilter>;
  docReqDueDate?: InputMaybe<HavingDatetimeFilter>;
  dueDate?: InputMaybe<HavingDatetimeFilter>;
  finalProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  initialProviderReportSentDate?: InputMaybe<HavingDatetimeFilter>;
  qaDueDate?: InputMaybe<HavingDatetimeFilter>;
  tatStartDate?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `ClaimAuditGroup` */
export type ClaimAuditGroupInput = {
  appealDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  auditDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  auditStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  auditType?: InputMaybe<ClaimAuditType>;
  auditorUserToCreatedBy?: InputMaybe<ClaimAuditGroupCreatedByFkeyInput>;
  batchClaimStatesUsingId?: InputMaybe<BatchClaimStateClaimAuditGroupIdFkeyInverseInput>;
  clientReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  disputeDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  disputeReceivedDate?: InputMaybe<Scalars["Date"]["input"]>;
  docReqDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  finalProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  initialProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInput>;
  name: Scalars["String"]["input"];
  qaDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  tatStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

/** The `claimAuditGroup` to be created by this mutation. */
export type ClaimAuditGroupInsurerIdFkeyClaimAuditGroupCreateInput = {
  appealDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  auditDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  auditStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  auditType?: InputMaybe<ClaimAuditType>;
  auditorUserToCreatedBy?: InputMaybe<ClaimAuditGroupCreatedByFkeyInput>;
  batchClaimStatesUsingId?: InputMaybe<BatchClaimStateClaimAuditGroupIdFkeyInverseInput>;
  clientReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  disputeDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  disputeReceivedDate?: InputMaybe<Scalars["Date"]["input"]>;
  docReqDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  finalProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  initialProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  insurerToInsurerId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInput>;
  name: Scalars["String"]["input"];
  qaDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  tatStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

/** Input for the nested mutation of `insurer` in the `ClaimAuditGroupInput` mutation. */
export type ClaimAuditGroupInsurerIdFkeyInput = {
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByClientAbbreviation?: InputMaybe<InsurerInsurerUniqueClientAbbreviationConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectById?: InputMaybe<InsurerInsurerPkeyConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByName?: InputMaybe<InsurerInsurerUniqueNameConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<InsurerNodeIdConnect>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByClientAbbreviation?: InputMaybe<InsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateById?: InputMaybe<InsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyUsingInsurerPkeyUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByName?: InputMaybe<InsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyUsingInsurerUniqueNameUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `claimAuditGroup` in the `InsurerInput` mutation. */
export type ClaimAuditGroupInsurerIdFkeyInverseInput = {
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ClaimAuditGroupClaimAuditGroupPkeyConnect>>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  connectByName?: InputMaybe<
    Array<ClaimAuditGroupClaimAuditGroupNameKeyConnect>
  >;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ClaimAuditGroupNodeIdConnect>>;
  /** A `ClaimAuditGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ClaimAuditGroupInsurerIdFkeyClaimAuditGroupCreateInput>
  >;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ClaimAuditGroupClaimAuditGroupPkeyDelete>>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  deleteByName?: InputMaybe<Array<ClaimAuditGroupClaimAuditGroupNameKeyDelete>>;
  /** The primary key(s) for `claimAuditGroup` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ClaimAuditGroupNodeIdDelete>>;
  /** Flag indicating whether all other `claimAuditGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `claimAuditGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyUsingClaimAuditGroupPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `claimAuditGroup` for the far side of the relationship. */
  updateByName?: InputMaybe<
    Array<ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyUsingClaimAuditGroupNameKeyUpdate>
  >;
  /** The primary key(s) and patch data for `claimAuditGroup` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<InsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyNodeIdUpdate>
  >;
};

/** The globally unique `ID` look up for the row to connect. */
export type ClaimAuditGroupNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `claimAuditGroup` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to delete. */
export type ClaimAuditGroupNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `claimAuditGroup` to be deleted. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ClaimAuditGroupOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimState` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimState` being updated. */
    patch: BatchClaimStatePatch;
  };

/** The fields on `claimAuditGroup` to look up the row to update. */
export type ClaimAuditGroupOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyUsingClaimAuditGroupNameKeyUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
    patch: updateClaimAuditGroupOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyPatch;
  };

/** The fields on `claimAuditGroup` to look up the row to update. */
export type ClaimAuditGroupOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyUsingClaimAuditGroupPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
    patch: updateClaimAuditGroupOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `claimAuditGroup` to look up the row to update. */
export type ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyUsingClaimAuditGroupNameKeyUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
    patch: updateClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyPatch;
  };

/** The fields on `claimAuditGroup` to look up the row to update. */
export type ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyUsingClaimAuditGroupPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
    patch: updateClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `insurer` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: InsurerPatch;
  };

/** The fields on `claimAuditGroup` to look up the row to update. */
export type ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyUsingClaimAuditGroupNameKeyUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
    patch: updateClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyPatch;
  };

/** The fields on `claimAuditGroup` to look up the row to update. */
export type ClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyUsingClaimAuditGroupPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
    patch: updateClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyPatch;
  };

/** Represents an update to a `ClaimAuditGroup`. Fields that are set will be updated. */
export type ClaimAuditGroupPatch = {
  appealDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  auditDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  auditStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  auditType?: InputMaybe<ClaimAuditType>;
  auditorUserToCreatedBy?: InputMaybe<ClaimAuditGroupCreatedByFkeyInput>;
  batchClaimStatesUsingId?: InputMaybe<BatchClaimStateClaimAuditGroupIdFkeyInverseInput>;
  clientReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  disputeDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  disputeReceivedDate?: InputMaybe<Scalars["Date"]["input"]>;
  docReqDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  dueDate?: InputMaybe<Scalars["Date"]["input"]>;
  finalProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  initialProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  qaDueDate?: InputMaybe<Scalars["Date"]["input"]>;
  tatStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

/** A filter to be used against many `BatchClaimState` object types. All fields are combined with a logical ‘and.’ */
export type ClaimAuditGroupToManyBatchClaimStateFilter = {
  /** Aggregates across related `BatchClaimState` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimStateAggregatesFilter>;
  /** Every related `BatchClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimStateFilter>;
  /** No related `BatchClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimStateFilter>;
  /** Some related `BatchClaimState` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimStateFilter>;
};

/** A connection to a list of `ClaimAuditGroup` values. */
export type ClaimAuditGroupsConnection = {
  __typename?: "ClaimAuditGroupsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ClaimAuditGroupAggregates>;
  /** A list of edges which contains the `ClaimAuditGroup` and cursor to aid in pagination. */
  edges: Array<ClaimAuditGroupsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ClaimAuditGroupAggregates>>;
  /** A list of `ClaimAuditGroup` objects. */
  nodes: Array<Maybe<ClaimAuditGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClaimAuditGroup` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ClaimAuditGroup` values. */
export type ClaimAuditGroupsConnectiongroupedAggregatesArgs = {
  groupBy: Array<ClaimAuditGroupGroupBy>;
  having?: InputMaybe<ClaimAuditGroupHavingInput>;
};

/** A `ClaimAuditGroup` edge in the connection. */
export type ClaimAuditGroupsEdge = {
  __typename?: "ClaimAuditGroupsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ClaimAuditGroup` at the end of the edge. */
  node?: Maybe<ClaimAuditGroup>;
};

/** Methods to use when ordering `ClaimAuditGroup`. */
export enum ClaimAuditGroupsOrderBy {
  APPEAL_DUE_DATE_ASC = "APPEAL_DUE_DATE_ASC",
  APPEAL_DUE_DATE_DESC = "APPEAL_DUE_DATE_DESC",
  AUDITOR_USER_BY_CREATED_BY__CREATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__CREATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__CREATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__CREATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__EMAIL_ASC = "AUDITOR_USER_BY_CREATED_BY__EMAIL_ASC",
  AUDITOR_USER_BY_CREATED_BY__EMAIL_DESC = "AUDITOR_USER_BY_CREATED_BY__EMAIL_DESC",
  AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_ASC = "AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_ASC",
  AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_DESC = "AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_DESC",
  AUDITOR_USER_BY_CREATED_BY__IDP_SUB_ASC = "AUDITOR_USER_BY_CREATED_BY__IDP_SUB_ASC",
  AUDITOR_USER_BY_CREATED_BY__IDP_SUB_DESC = "AUDITOR_USER_BY_CREATED_BY__IDP_SUB_DESC",
  AUDITOR_USER_BY_CREATED_BY__ID_ASC = "AUDITOR_USER_BY_CREATED_BY__ID_ASC",
  AUDITOR_USER_BY_CREATED_BY__ID_DESC = "AUDITOR_USER_BY_CREATED_BY__ID_DESC",
  AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_CREATED_BY__LAST_NAME_ASC = "AUDITOR_USER_BY_CREATED_BY__LAST_NAME_ASC",
  AUDITOR_USER_BY_CREATED_BY__LAST_NAME_DESC = "AUDITOR_USER_BY_CREATED_BY__LAST_NAME_DESC",
  AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_ASC = "AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_DESC = "AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_CREATED_BY__READ_ONLY_ASC = "AUDITOR_USER_BY_CREATED_BY__READ_ONLY_ASC",
  AUDITOR_USER_BY_CREATED_BY__READ_ONLY_DESC = "AUDITOR_USER_BY_CREATED_BY__READ_ONLY_DESC",
  AUDITOR_USER_BY_CREATED_BY__TITLE_ASC = "AUDITOR_USER_BY_CREATED_BY__TITLE_ASC",
  AUDITOR_USER_BY_CREATED_BY__TITLE_DESC = "AUDITOR_USER_BY_CREATED_BY__TITLE_DESC",
  AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__USER_TYPE_ASC = "AUDITOR_USER_BY_CREATED_BY__USER_TYPE_ASC",
  AUDITOR_USER_BY_CREATED_BY__USER_TYPE_DESC = "AUDITOR_USER_BY_CREATED_BY__USER_TYPE_DESC",
  AUDIT_DUE_DATE_ASC = "AUDIT_DUE_DATE_ASC",
  AUDIT_DUE_DATE_DESC = "AUDIT_DUE_DATE_DESC",
  AUDIT_START_DATE_ASC = "AUDIT_START_DATE_ASC",
  AUDIT_START_DATE_DESC = "AUDIT_START_DATE_DESC",
  AUDIT_TYPE_ASC = "AUDIT_TYPE_ASC",
  AUDIT_TYPE_DESC = "AUDIT_TYPE_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_COUNT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_COUNT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_COUNT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_COUNT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_MAX_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_MAX_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_MAX_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_MAX_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_MAX_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_MAX_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_MAX_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_MAX_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_MAX_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_MAX_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_MIN_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_MIN_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_MIN_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_MIN_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_MIN_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_MIN_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_MIN_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_MIN_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_MIN_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_MIN_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_SUM_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_SUM_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_SUM_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_SUM_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_SUM_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_SUM_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_SUM_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_SUM_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_SUM_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_SUM_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_BY_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_BY_ASC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_BY_ASC",
  BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_BY_DESC = "BATCH_CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_BY_DESC",
  BATCH_CLAIM_STATES_AVERAGE_APPEALED_ASC = "BATCH_CLAIM_STATES_AVERAGE_APPEALED_ASC",
  BATCH_CLAIM_STATES_AVERAGE_APPEALED_DESC = "BATCH_CLAIM_STATES_AVERAGE_APPEALED_DESC",
  BATCH_CLAIM_STATES_AVERAGE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_AVERAGE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_AVERAGE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_AVERAGE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_AVERAGE_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_AVERAGE_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_AVERAGE_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_AVERAGE_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_AVERAGE_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_AVERAGE_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_AVERAGE_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_AVERAGE_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_AVERAGE_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_DUE_DATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_DUE_DATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_ID_ASC = "BATCH_CLAIM_STATES_AVERAGE_ID_ASC",
  BATCH_CLAIM_STATES_AVERAGE_ID_DESC = "BATCH_CLAIM_STATES_AVERAGE_ID_DESC",
  BATCH_CLAIM_STATES_AVERAGE_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_AVERAGE_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_AVERAGE_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_AVERAGE_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_AVERAGE_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_AVERAGE_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_AVERAGE_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_PAY_DENY_ASC = "BATCH_CLAIM_STATES_AVERAGE_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_AVERAGE_PAY_DENY_DESC = "BATCH_CLAIM_STATES_AVERAGE_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_AVERAGE_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_AVERAGE_REPORTED_ASC = "BATCH_CLAIM_STATES_AVERAGE_REPORTED_ASC",
  BATCH_CLAIM_STATES_AVERAGE_REPORTED_DESC = "BATCH_CLAIM_STATES_AVERAGE_REPORTED_DESC",
  BATCH_CLAIM_STATES_AVERAGE_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_AVERAGE_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_AVERAGE_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_AVERAGE_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_AVERAGE_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_AVERAGE_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_AVERAGE_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_AVERAGE_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_BY_CLAIM_AUDIT_GROUP_ID__COUNT_ASC = "BATCH_CLAIM_STATES_BY_CLAIM_AUDIT_GROUP_ID__COUNT_ASC",
  BATCH_CLAIM_STATES_BY_CLAIM_AUDIT_GROUP_ID__COUNT_DESC = "BATCH_CLAIM_STATES_BY_CLAIM_AUDIT_GROUP_ID__COUNT_DESC",
  BATCH_CLAIM_STATES_COUNT_ASC = "BATCH_CLAIM_STATES_COUNT_ASC",
  BATCH_CLAIM_STATES_COUNT_DESC = "BATCH_CLAIM_STATES_COUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_APPEALED_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_APPEALED_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_APPEALED_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_APPEALED_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DUE_DATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_DUE_DATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_PAY_DENY_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_PAY_DENY_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_REPORTED_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_REPORTED_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_REPORTED_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_REPORTED_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_DISTINCT_COUNT_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_APPEALED_ASC = "BATCH_CLAIM_STATES_MAX_APPEALED_ASC",
  BATCH_CLAIM_STATES_MAX_APPEALED_DESC = "BATCH_CLAIM_STATES_MAX_APPEALED_DESC",
  BATCH_CLAIM_STATES_MAX_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_MAX_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_MAX_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_MAX_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_MAX_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_MAX_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_MAX_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_MAX_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_MAX_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_MAX_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_MAX_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_MAX_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_MAX_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_MAX_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_MAX_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_MAX_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_MAX_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_MAX_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_MAX_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_MAX_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_MAX_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_MAX_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MAX_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_MAX_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MAX_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_DUE_DATE_ASC = "BATCH_CLAIM_STATES_MAX_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_MAX_DUE_DATE_DESC = "BATCH_CLAIM_STATES_MAX_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_MAX_ID_ASC = "BATCH_CLAIM_STATES_MAX_ID_ASC",
  BATCH_CLAIM_STATES_MAX_ID_DESC = "BATCH_CLAIM_STATES_MAX_ID_DESC",
  BATCH_CLAIM_STATES_MAX_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_MAX_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_MAX_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_MAX_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_MAX_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_MAX_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_MAX_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_MAX_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_MAX_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_PAY_DENY_ASC = "BATCH_CLAIM_STATES_MAX_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_MAX_PAY_DENY_DESC = "BATCH_CLAIM_STATES_MAX_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MAX_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_MAX_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MAX_REPORTED_ASC = "BATCH_CLAIM_STATES_MAX_REPORTED_ASC",
  BATCH_CLAIM_STATES_MAX_REPORTED_DESC = "BATCH_CLAIM_STATES_MAX_REPORTED_DESC",
  BATCH_CLAIM_STATES_MAX_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_MAX_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_MAX_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_MAX_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_MAX_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MAX_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MAX_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MAX_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_APPEALED_ASC = "BATCH_CLAIM_STATES_MIN_APPEALED_ASC",
  BATCH_CLAIM_STATES_MIN_APPEALED_DESC = "BATCH_CLAIM_STATES_MIN_APPEALED_DESC",
  BATCH_CLAIM_STATES_MIN_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_MIN_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_MIN_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_MIN_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_MIN_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_MIN_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_MIN_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_MIN_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_MIN_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_MIN_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_MIN_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_MIN_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_MIN_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_MIN_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_MIN_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_MIN_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_MIN_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_MIN_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_MIN_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_MIN_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_MIN_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_MIN_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MIN_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_MIN_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MIN_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_DUE_DATE_ASC = "BATCH_CLAIM_STATES_MIN_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_MIN_DUE_DATE_DESC = "BATCH_CLAIM_STATES_MIN_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_MIN_ID_ASC = "BATCH_CLAIM_STATES_MIN_ID_ASC",
  BATCH_CLAIM_STATES_MIN_ID_DESC = "BATCH_CLAIM_STATES_MIN_ID_DESC",
  BATCH_CLAIM_STATES_MIN_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_MIN_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_MIN_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_MIN_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_MIN_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_MIN_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_MIN_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_MIN_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_MIN_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_PAY_DENY_ASC = "BATCH_CLAIM_STATES_MIN_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_MIN_PAY_DENY_DESC = "BATCH_CLAIM_STATES_MIN_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_MIN_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_MIN_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_MIN_REPORTED_ASC = "BATCH_CLAIM_STATES_MIN_REPORTED_ASC",
  BATCH_CLAIM_STATES_MIN_REPORTED_DESC = "BATCH_CLAIM_STATES_MIN_REPORTED_DESC",
  BATCH_CLAIM_STATES_MIN_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_MIN_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_MIN_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_MIN_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_MIN_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_MIN_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_MIN_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_MIN_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_APPEALED_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_APPEALED_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_APPEALED_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_APPEALED_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DUE_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_DUE_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_PAY_DENY_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_PAY_DENY_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_REPORTED_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_REPORTED_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_REPORTED_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_REPORTED_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_POPULATION_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_APPEALED_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_APPEALED_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_APPEALED_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_APPEALED_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DUE_DATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_DUE_DATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_PAY_DENY_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_PAY_DENY_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_REPORTED_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_REPORTED_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_REPORTED_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_REPORTED_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_STDDEV_SAMPLE_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_APPEALED_ASC = "BATCH_CLAIM_STATES_SUM_APPEALED_ASC",
  BATCH_CLAIM_STATES_SUM_APPEALED_DESC = "BATCH_CLAIM_STATES_SUM_APPEALED_DESC",
  BATCH_CLAIM_STATES_SUM_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_SUM_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_SUM_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_SUM_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_SUM_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_SUM_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_SUM_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_SUM_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_SUM_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_SUM_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_SUM_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_SUM_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_SUM_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_SUM_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_SUM_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_SUM_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_SUM_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_SUM_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_SUM_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_SUM_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_SUM_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_SUM_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_SUM_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_SUM_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_SUM_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_DUE_DATE_ASC = "BATCH_CLAIM_STATES_SUM_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_SUM_DUE_DATE_DESC = "BATCH_CLAIM_STATES_SUM_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_SUM_ID_ASC = "BATCH_CLAIM_STATES_SUM_ID_ASC",
  BATCH_CLAIM_STATES_SUM_ID_DESC = "BATCH_CLAIM_STATES_SUM_ID_DESC",
  BATCH_CLAIM_STATES_SUM_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_SUM_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_SUM_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_SUM_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_SUM_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_SUM_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_SUM_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_SUM_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_SUM_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_PAY_DENY_ASC = "BATCH_CLAIM_STATES_SUM_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_SUM_PAY_DENY_DESC = "BATCH_CLAIM_STATES_SUM_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_SUM_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_SUM_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_SUM_REPORTED_ASC = "BATCH_CLAIM_STATES_SUM_REPORTED_ASC",
  BATCH_CLAIM_STATES_SUM_REPORTED_DESC = "BATCH_CLAIM_STATES_SUM_REPORTED_DESC",
  BATCH_CLAIM_STATES_SUM_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_SUM_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_SUM_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_SUM_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_SUM_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_SUM_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_SUM_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_SUM_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_APPEALED_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_APPEALED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_APPEALED_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_APPEALED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DUE_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_DUE_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_PAY_DENY_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_PAY_DENY_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_REPORTED_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_REPORTED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_REPORTED_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_REPORTED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_POPULATION_WORKFLOW_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_APPEALED_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_APPEALED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_APPEALED_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_APPEALED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDIT_START_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDIT_START_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDIT_START_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_AUDIT_START_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_GROUP_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_TYPE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_TYPE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_TYPE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLAIM_AUDIT_TYPE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_RECOVERY_COLLECTION_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CLIENT_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_PHASE_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_PHASE_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_PHASE_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_PHASE_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_STAGE_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_STAGE_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_STAGE_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_CURRENT_STAGE_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DETERMINED_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DISPUTED_FINDING_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DOCUMENTATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DUE_DATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DUE_DATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DUE_DATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_DUE_DATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_INVOICE_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_PROVIDER_ACTIVE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_PROVIDER_ACTIVE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_PROVIDER_ACTIVE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_PROVIDER_ACTIVE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_REALIZED_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_REALIZED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_REALIZED_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_IS_REALIZED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_NEGOTIATION_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_ON_HOLD_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PAY_DENY_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PAY_DENY_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PAY_DENY_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PAY_DENY_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_ADJUSTED_ALLOWED_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_CLIENT_SAVINGS_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_CLIENT_SAVINGS_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_CLIENT_SAVINGS_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_CLIENT_SAVINGS_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_POTENTIAL_DISCREPANT_AMOUNT_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_PROVIDER_SIGN_OFF_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_QA_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_QA_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_QA_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_QA_CLAIM_STATE_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_REPORTED_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_REPORTED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_REPORTED_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_REPORTED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_TECH_DENIED_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_TECH_DENIED_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_TECH_DENIED_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_TECH_DENIED_DESC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_CLAIM_STATE_ASC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_CLAIM_STATE_ASC",
  BATCH_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_CLAIM_STATE_DESC = "BATCH_CLAIM_STATES_VARIANCE_SAMPLE_WORKFLOW_CLAIM_STATE_DESC",
  CLIENT_REPORT_SENT_DATE_ASC = "CLIENT_REPORT_SENT_DATE_ASC",
  CLIENT_REPORT_SENT_DATE_DESC = "CLIENT_REPORT_SENT_DATE_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  CREATED_BY_ASC = "CREATED_BY_ASC",
  CREATED_BY_DESC = "CREATED_BY_DESC",
  DISPUTE_DUE_DATE_ASC = "DISPUTE_DUE_DATE_ASC",
  DISPUTE_DUE_DATE_DESC = "DISPUTE_DUE_DATE_DESC",
  DISPUTE_RECEIVED_DATE_ASC = "DISPUTE_RECEIVED_DATE_ASC",
  DISPUTE_RECEIVED_DATE_DESC = "DISPUTE_RECEIVED_DATE_DESC",
  DOC_REQ_DUE_DATE_ASC = "DOC_REQ_DUE_DATE_ASC",
  DOC_REQ_DUE_DATE_DESC = "DOC_REQ_DUE_DATE_DESC",
  DUE_DATE_ASC = "DUE_DATE_ASC",
  DUE_DATE_DESC = "DUE_DATE_DESC",
  FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ID_ASC = "INSURER_BY_INSURER_ID__CLIENT_ID_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ID_DESC = "INSURER_BY_INSURER_ID__CLIENT_ID_DESC",
  INSURER_BY_INSURER_ID__CREATED_AT_ASC = "INSURER_BY_INSURER_ID__CREATED_AT_ASC",
  INSURER_BY_INSURER_ID__CREATED_AT_DESC = "INSURER_BY_INSURER_ID__CREATED_AT_DESC",
  INSURER_BY_INSURER_ID__ID_ASC = "INSURER_BY_INSURER_ID__ID_ASC",
  INSURER_BY_INSURER_ID__ID_DESC = "INSURER_BY_INSURER_ID__ID_DESC",
  INSURER_BY_INSURER_ID__NAME_ASC = "INSURER_BY_INSURER_ID__NAME_ASC",
  INSURER_BY_INSURER_ID__NAME_DESC = "INSURER_BY_INSURER_ID__NAME_DESC",
  INSURER_BY_INSURER_ID__UPDATED_AT_ASC = "INSURER_BY_INSURER_ID__UPDATED_AT_ASC",
  INSURER_BY_INSURER_ID__UPDATED_AT_DESC = "INSURER_BY_INSURER_ID__UPDATED_AT_DESC",
  INSURER_ID_ASC = "INSURER_ID_ASC",
  INSURER_ID_DESC = "INSURER_ID_DESC",
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  QA_DUE_DATE_ASC = "QA_DUE_DATE_ASC",
  QA_DUE_DATE_DESC = "QA_DUE_DATE_DESC",
  TAT_START_DATE_ASC = "TAT_START_DATE_ASC",
  TAT_START_DATE_DESC = "TAT_START_DATE_DESC",
}

/** Product-configured lifecycle stage shortcuts (from current stage to suggested targets). */
export type ClaimAuditStageSuggestion = Node & {
  __typename?: "ClaimAuditStageSuggestion";
  createdAt: Scalars["Datetime"]["output"];
  fromStageKeywordId: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  priority: Scalars["Int"]["output"];
  toStageKeywordId: Scalars["UUID"]["output"];
};

export type ClaimAuditStageSuggestionAggregates = {
  __typename?: "ClaimAuditStageSuggestionAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ClaimAuditStageSuggestionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ClaimAuditStageSuggestionDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ClaimAuditStageSuggestionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ClaimAuditStageSuggestionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ClaimAuditStageSuggestionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ClaimAuditStageSuggestionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ClaimAuditStageSuggestionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ClaimAuditStageSuggestionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ClaimAuditStageSuggestionVarianceSampleAggregates>;
};

export type ClaimAuditStageSuggestionAverageAggregates = {
  __typename?: "ClaimAuditStageSuggestionAverageAggregates";
  /** Mean average of priority across the matching connection */
  priority?: Maybe<Scalars["BigFloat"]["output"]>;
};

/**
 * A condition to be used against `ClaimAuditStageSuggestion` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ClaimAuditStageSuggestionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `fromStageKeywordId` field. */
  fromStageKeywordId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `toStageKeywordId` field. */
  toStageKeywordId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type ClaimAuditStageSuggestionDistinctCountAggregates = {
  __typename?: "ClaimAuditStageSuggestionDistinctCountAggregates";
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of fromStageKeywordId across the matching connection */
  fromStageKeywordId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of priority across the matching connection */
  priority?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of toStageKeywordId across the matching connection */
  toStageKeywordId?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ClaimAuditStageSuggestion` object types. All fields are combined with a logical ‘and.’ */
export type ClaimAuditStageSuggestionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClaimAuditStageSuggestionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fromStageKeywordId` field. */
  fromStageKeywordId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClaimAuditStageSuggestionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClaimAuditStageSuggestionFilter>>;
  /** Filter by the object’s `priority` field. */
  priority?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toStageKeywordId` field. */
  toStageKeywordId?: InputMaybe<UUIDFilter>;
};

/** Grouping methods for `ClaimAuditStageSuggestion` for usage during aggregation. */
export enum ClaimAuditStageSuggestionGroupBy {
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  FROM_STAGE_KEYWORD_ID = "FROM_STAGE_KEYWORD_ID",
  PRIORITY = "PRIORITY",
  TO_STAGE_KEYWORD_ID = "TO_STAGE_KEYWORD_ID",
}

export type ClaimAuditStageSuggestionHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
};

export type ClaimAuditStageSuggestionHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `ClaimAuditStageSuggestion` aggregates. */
export type ClaimAuditStageSuggestionHavingInput = {
  AND?: InputMaybe<Array<ClaimAuditStageSuggestionHavingInput>>;
  OR?: InputMaybe<Array<ClaimAuditStageSuggestionHavingInput>>;
  average?: InputMaybe<ClaimAuditStageSuggestionHavingAverageInput>;
  distinctCount?: InputMaybe<ClaimAuditStageSuggestionHavingDistinctCountInput>;
  max?: InputMaybe<ClaimAuditStageSuggestionHavingMaxInput>;
  min?: InputMaybe<ClaimAuditStageSuggestionHavingMinInput>;
  stddevPopulation?: InputMaybe<ClaimAuditStageSuggestionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ClaimAuditStageSuggestionHavingStddevSampleInput>;
  sum?: InputMaybe<ClaimAuditStageSuggestionHavingSumInput>;
  variancePopulation?: InputMaybe<ClaimAuditStageSuggestionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ClaimAuditStageSuggestionHavingVarianceSampleInput>;
};

export type ClaimAuditStageSuggestionHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
};

export type ClaimAuditStageSuggestionHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
};

export type ClaimAuditStageSuggestionHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
};

export type ClaimAuditStageSuggestionHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
};

export type ClaimAuditStageSuggestionHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
};

export type ClaimAuditStageSuggestionHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
};

export type ClaimAuditStageSuggestionHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
};

export type ClaimAuditStageSuggestionMaxAggregates = {
  __typename?: "ClaimAuditStageSuggestionMaxAggregates";
  /** Maximum of priority across the matching connection */
  priority?: Maybe<Scalars["Int"]["output"]>;
};

export type ClaimAuditStageSuggestionMinAggregates = {
  __typename?: "ClaimAuditStageSuggestionMinAggregates";
  /** Minimum of priority across the matching connection */
  priority?: Maybe<Scalars["Int"]["output"]>;
};

export type ClaimAuditStageSuggestionStddevPopulationAggregates = {
  __typename?: "ClaimAuditStageSuggestionStddevPopulationAggregates";
  /** Population standard deviation of priority across the matching connection */
  priority?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimAuditStageSuggestionStddevSampleAggregates = {
  __typename?: "ClaimAuditStageSuggestionStddevSampleAggregates";
  /** Sample standard deviation of priority across the matching connection */
  priority?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimAuditStageSuggestionSumAggregates = {
  __typename?: "ClaimAuditStageSuggestionSumAggregates";
  /** Sum of priority across the matching connection */
  priority: Scalars["BigInt"]["output"];
};

export type ClaimAuditStageSuggestionVariancePopulationAggregates = {
  __typename?: "ClaimAuditStageSuggestionVariancePopulationAggregates";
  /** Population variance of priority across the matching connection */
  priority?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimAuditStageSuggestionVarianceSampleAggregates = {
  __typename?: "ClaimAuditStageSuggestionVarianceSampleAggregates";
  /** Sample variance of priority across the matching connection */
  priority?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** A connection to a list of `ClaimAuditStageSuggestion` values. */
export type ClaimAuditStageSuggestionsConnection = {
  __typename?: "ClaimAuditStageSuggestionsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ClaimAuditStageSuggestionAggregates>;
  /** A list of edges which contains the `ClaimAuditStageSuggestion` and cursor to aid in pagination. */
  edges: Array<ClaimAuditStageSuggestionsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ClaimAuditStageSuggestionAggregates>>;
  /** A list of `ClaimAuditStageSuggestion` objects. */
  nodes: Array<Maybe<ClaimAuditStageSuggestion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClaimAuditStageSuggestion` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ClaimAuditStageSuggestion` values. */
export type ClaimAuditStageSuggestionsConnectiongroupedAggregatesArgs = {
  groupBy: Array<ClaimAuditStageSuggestionGroupBy>;
  having?: InputMaybe<ClaimAuditStageSuggestionHavingInput>;
};

/** A `ClaimAuditStageSuggestion` edge in the connection. */
export type ClaimAuditStageSuggestionsEdge = {
  __typename?: "ClaimAuditStageSuggestionsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ClaimAuditStageSuggestion` at the end of the edge. */
  node?: Maybe<ClaimAuditStageSuggestion>;
};

/** Methods to use when ordering `ClaimAuditStageSuggestion`. */
export enum ClaimAuditStageSuggestionsOrderBy {
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  FROM_STAGE_KEYWORD_ID_ASC = "FROM_STAGE_KEYWORD_ID_ASC",
  FROM_STAGE_KEYWORD_ID_DESC = "FROM_STAGE_KEYWORD_ID_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PRIORITY_ASC = "PRIORITY_ASC",
  PRIORITY_DESC = "PRIORITY_DESC",
  TO_STAGE_KEYWORD_ID_ASC = "TO_STAGE_KEYWORD_ID_ASC",
  TO_STAGE_KEYWORD_ID_DESC = "TO_STAGE_KEYWORD_ID_DESC",
}

export enum ClaimAuditType {
  /** All Patient Refined Diagnosis Related Group */
  APR_DRG = "APR_DRG",
  /** Ambulatory Surgical Center */
  ASC = "ASC",
  /** Diagnosis Related Group */
  DRG = "DRG",
  /** Itemized Bill Review */
  IBR = "IBR",
  /** Medicare Severity Diagnosis Related Group */
  MS_DRG = "MS_DRG",
  /** Outpatient Prospective Payment System */
  OPPS = "OPPS",
  /** Revenue Driven */
  RD = "RD",
}

/** A filter to be used against ClaimAuditType fields. All fields are combined with a logical ‘and.’ */
export type ClaimAuditTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ClaimAuditType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ClaimAuditType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ClaimAuditType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ClaimAuditType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ClaimAuditType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ClaimAuditType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ClaimAuditType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ClaimAuditType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ClaimAuditType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ClaimAuditType>>;
};

export type ClaimAuditTypeInfo = {
  __typename?: "ClaimAuditTypeInfo";
  description?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
};

export type ClaimAuditTypesResponse = {
  __typename?: "ClaimAuditTypesResponse";
  claimAuditTypeDescriptions: Array<ClaimAuditTypeInfo>;
  claimAuditTypes: Array<Scalars["String"]["output"]>;
};

export type ClaimBlocker = {
  __typename?: "ClaimBlocker";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  labelOrder: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  segments: Array<ClaimBlockerSegment>;
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
};

export type ClaimBlockerSegment = {
  __typename?: "ClaimBlockerSegment";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  labelOrder: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
};

export enum ClaimComputationStrategyKind {
  CLAIM_LEVEL_PAYMENT_RATE = "CLAIM_LEVEL_PAYMENT_RATE",
  CLAIM_LINE_LEVEL_PAYMENT_RATE = "CLAIM_LINE_LEVEL_PAYMENT_RATE",
}

/** A filter to be used against ClaimComputationStrategyKind fields. All fields are combined with a logical ‘and.’ */
export type ClaimComputationStrategyKindFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ClaimComputationStrategyKind>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ClaimComputationStrategyKind>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ClaimComputationStrategyKind>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ClaimComputationStrategyKind>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ClaimComputationStrategyKind>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ClaimComputationStrategyKind>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ClaimComputationStrategyKind>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ClaimComputationStrategyKind>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ClaimComputationStrategyKind>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ClaimComputationStrategyKind>>;
};

/** Operators for the ever-in filter. Values are dimension-specific slugs (e.g. phase slug for claimEverInPhase, compound "<phase>/<stage>" for claimEverInStage) or the resolved UUID. */
export type ClaimEverInPhaseFilterInput = {
  /** Match if claim currently has this value OR any history row set this value. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match if claim currently has any value in this list OR any history row set any value in this list. */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Operators for the ever-in filter. Values are dimension-specific slugs (e.g. phase slug for claimEverInPhase, compound "<phase>/<stage>" for claimEverInStage) or the resolved UUID. */
export type ClaimEverInStageFilterInput = {
  /** Match if claim currently has this value OR any history row set this value. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match if claim currently has any value in this list OR any history row set any value in this list. */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Claim facets JSONB storage. Reads allowed directly for analytics/dashboards. Writes must use v3.set_claim_facet() or v3.delete_claim_facet() functions to ensure history tracking. */
export type ClaimFacet = Node & {
  __typename?: "ClaimFacet";
  /** Reads a single `BatchClaim` that is related to this `ClaimFacet`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  /**
   * JSONB object storing facet values using facet UUID as keys.
   *    Example: {"ce92d675-0fae-5973-b7b1-56d84d53a87c": "9c9623ea-f047-5a34-84cf-272bc8f56dd0"}
   *    where first UUID = facet ID, second = value (keyword UUID for keyword-type facets)
   */
  facets: Scalars["JSON"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type ClaimFacetAggregates = {
  __typename?: "ClaimFacetAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ClaimFacetDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** The fields on `claimFacet` to look up the row to connect. */
export type ClaimFacetClaimFacetsBatchClaimIdKeyConnect = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The fields on `claimFacet` to look up the row to connect. */
export type ClaimFacetClaimFacetsPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `ClaimFacet` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ClaimFacetCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `facets` field. */
  facets?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type ClaimFacetDistinctCountAggregates = {
  __typename?: "ClaimFacetDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of facets across the matching connection */
  facets?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ClaimFacet` object types. All fields are combined with a logical ‘and.’ */
export type ClaimFacetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClaimFacetFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `facets` field. */
  facets?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClaimFacetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClaimFacetFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `ClaimFacetHistory` values. */
export type ClaimFacetHistoriesConnection = {
  __typename?: "ClaimFacetHistoriesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ClaimFacetHistoryAggregates>;
  /** A list of edges which contains the `ClaimFacetHistory` and cursor to aid in pagination. */
  edges: Array<ClaimFacetHistoriesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ClaimFacetHistoryAggregates>>;
  /** A list of `ClaimFacetHistory` objects. */
  nodes: Array<Maybe<ClaimFacetHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClaimFacetHistory` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ClaimFacetHistory` values. */
export type ClaimFacetHistoriesConnectiongroupedAggregatesArgs = {
  groupBy: Array<ClaimFacetHistoryGroupBy>;
  having?: InputMaybe<ClaimFacetHistoryHavingInput>;
};

/** A `ClaimFacetHistory` edge in the connection. */
export type ClaimFacetHistoriesEdge = {
  __typename?: "ClaimFacetHistoriesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ClaimFacetHistory` at the end of the edge. */
  node?: Maybe<ClaimFacetHistory>;
};

/** Methods to use when ordering `ClaimFacetHistory`. */
export enum ClaimFacetHistoriesOrderBy {
  APPLIED_AT_ASC = "APPLIED_AT_ASC",
  APPLIED_AT_DESC = "APPLIED_AT_DESC",
  APPLIED_BY_ASC = "APPLIED_BY_ASC",
  APPLIED_BY_DESC = "APPLIED_BY_DESC",
  AUDITOR_USER_BY_APPLIED_BY__CREATED_AT_ASC = "AUDITOR_USER_BY_APPLIED_BY__CREATED_AT_ASC",
  AUDITOR_USER_BY_APPLIED_BY__CREATED_AT_DESC = "AUDITOR_USER_BY_APPLIED_BY__CREATED_AT_DESC",
  AUDITOR_USER_BY_APPLIED_BY__EMAIL_ASC = "AUDITOR_USER_BY_APPLIED_BY__EMAIL_ASC",
  AUDITOR_USER_BY_APPLIED_BY__EMAIL_DESC = "AUDITOR_USER_BY_APPLIED_BY__EMAIL_DESC",
  AUDITOR_USER_BY_APPLIED_BY__FIRST_NAME_ASC = "AUDITOR_USER_BY_APPLIED_BY__FIRST_NAME_ASC",
  AUDITOR_USER_BY_APPLIED_BY__FIRST_NAME_DESC = "AUDITOR_USER_BY_APPLIED_BY__FIRST_NAME_DESC",
  AUDITOR_USER_BY_APPLIED_BY__IDP_SUB_ASC = "AUDITOR_USER_BY_APPLIED_BY__IDP_SUB_ASC",
  AUDITOR_USER_BY_APPLIED_BY__IDP_SUB_DESC = "AUDITOR_USER_BY_APPLIED_BY__IDP_SUB_DESC",
  AUDITOR_USER_BY_APPLIED_BY__ID_ASC = "AUDITOR_USER_BY_APPLIED_BY__ID_ASC",
  AUDITOR_USER_BY_APPLIED_BY__ID_DESC = "AUDITOR_USER_BY_APPLIED_BY__ID_DESC",
  AUDITOR_USER_BY_APPLIED_BY__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_APPLIED_BY__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_APPLIED_BY__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_APPLIED_BY__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_APPLIED_BY__LAST_NAME_ASC = "AUDITOR_USER_BY_APPLIED_BY__LAST_NAME_ASC",
  AUDITOR_USER_BY_APPLIED_BY__LAST_NAME_DESC = "AUDITOR_USER_BY_APPLIED_BY__LAST_NAME_DESC",
  AUDITOR_USER_BY_APPLIED_BY__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_APPLIED_BY__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_APPLIED_BY__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_APPLIED_BY__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_APPLIED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_APPLIED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_APPLIED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_APPLIED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_APPLIED_BY__PROVIDER_ID_ASC = "AUDITOR_USER_BY_APPLIED_BY__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_APPLIED_BY__PROVIDER_ID_DESC = "AUDITOR_USER_BY_APPLIED_BY__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_APPLIED_BY__READ_ONLY_ASC = "AUDITOR_USER_BY_APPLIED_BY__READ_ONLY_ASC",
  AUDITOR_USER_BY_APPLIED_BY__READ_ONLY_DESC = "AUDITOR_USER_BY_APPLIED_BY__READ_ONLY_DESC",
  AUDITOR_USER_BY_APPLIED_BY__TITLE_ASC = "AUDITOR_USER_BY_APPLIED_BY__TITLE_ASC",
  AUDITOR_USER_BY_APPLIED_BY__TITLE_DESC = "AUDITOR_USER_BY_APPLIED_BY__TITLE_DESC",
  AUDITOR_USER_BY_APPLIED_BY__UPDATED_AT_ASC = "AUDITOR_USER_BY_APPLIED_BY__UPDATED_AT_ASC",
  AUDITOR_USER_BY_APPLIED_BY__UPDATED_AT_DESC = "AUDITOR_USER_BY_APPLIED_BY__UPDATED_AT_DESC",
  AUDITOR_USER_BY_APPLIED_BY__USER_TYPE_ASC = "AUDITOR_USER_BY_APPLIED_BY__USER_TYPE_ASC",
  AUDITOR_USER_BY_APPLIED_BY__USER_TYPE_DESC = "AUDITOR_USER_BY_APPLIED_BY__USER_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CONTEXT_ASC = "CONTEXT_ASC",
  CONTEXT_DESC = "CONTEXT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  OPERATION_TYPE_ASC = "OPERATION_TYPE_ASC",
  OPERATION_TYPE_DESC = "OPERATION_TYPE_DESC",
  PATH_ASC = "PATH_ASC",
  PATH_DESC = "PATH_DESC",
  PREVIOUS_VALUE_ASC = "PREVIOUS_VALUE_ASC",
  PREVIOUS_VALUE_DESC = "PREVIOUS_VALUE_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  VALUE_ASC = "VALUE_ASC",
  VALUE_DESC = "VALUE_DESC",
}

/**
 * Audit log of explicit facet writes. One row is inserted per facet per call
 * into v3.set_claim_facet/v3.set_claim_facets, capturing operation_type
 * (add/replace/remove), value, previous_value, applied_by, and a structured
 * context jsonb identifying the source.
 *
 * INVARIANT — interpreting the audit trail:
 * - If v3.claim_facets has a value for facet X but no v3.claim_facet_history
 *   row exists for that (batch_claim_id, facet) pair, that value was written
 *   by the create-time default trigger
 *   (facets.initialize_claim_facets_with_defaults). The trigger uses a bare
 *   INSERT and intentionally does not write history — at scale most ingested
 *   claims never reach audit and recording defaults for them all would be
 *   pure noise. The first subsequent v3.set_claim_facet call that touches
 *   the facet records a "replace" row whose previous_value is the default,
 *   so the default is recoverable retroactively.
 * - An "add" history row with previous_value IS NULL = the first explicit
 *   write through the service path.
 * - A "replace" history row with non-NULL previous_value = a subsequent
 *   service-path write.
 *
 * This invariant assumes ALL post-default writes go through set_claim_facet[s].
 * If some future code path writes directly to v3.claim_facets (UPDATE … jsonb_set,
 * INSERT, etc.), it bypasses history and breaks the invariant. New write paths
 * should route through set_claim_facet[s] or, if they cannot, document the
 * exception and the audit-trail implications.
 */
export type ClaimFacetHistory = Node & {
  __typename?: "ClaimFacetHistory";
  appliedAt: Scalars["Datetime"]["output"];
  appliedBy?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `AuditorUser` that is related to this `ClaimFacetHistory`. */
  auditorUserByAppliedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `ClaimFacetHistory`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  context?: Maybe<Scalars["JSON"]["output"]>;
  id: Scalars["BigInt"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** JSON patch operation: add, replace, or remove */
  operationType: Scalars["String"]["output"];
  /** JSON path to changed field using facet UUID (e.g., /ce92d675-0fae-5973-b7b1-56d84d53a87c) */
  path: Scalars["String"]["output"];
  previousValue?: Maybe<Scalars["JSON"]["output"]>;
  value?: Maybe<Scalars["JSON"]["output"]>;
};

export type ClaimFacetHistoryAggregates = {
  __typename?: "ClaimFacetHistoryAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ClaimFacetHistoryAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ClaimFacetHistoryDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ClaimFacetHistoryMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ClaimFacetHistoryMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ClaimFacetHistoryStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ClaimFacetHistoryStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ClaimFacetHistorySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ClaimFacetHistoryVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ClaimFacetHistoryVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `ClaimFacetHistory` object types. */
export type ClaimFacetHistoryAggregatesFilter = {
  /** Mean average aggregate over matching `ClaimFacetHistory` objects. */
  average?: InputMaybe<ClaimFacetHistoryAverageAggregateFilter>;
  /** Distinct count aggregate over matching `ClaimFacetHistory` objects. */
  distinctCount?: InputMaybe<ClaimFacetHistoryDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ClaimFacetHistory` object to be included within the aggregate. */
  filter?: InputMaybe<ClaimFacetHistoryFilter>;
  /** Maximum aggregate over matching `ClaimFacetHistory` objects. */
  max?: InputMaybe<ClaimFacetHistoryMaxAggregateFilter>;
  /** Minimum aggregate over matching `ClaimFacetHistory` objects. */
  min?: InputMaybe<ClaimFacetHistoryMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `ClaimFacetHistory` objects. */
  stddevPopulation?: InputMaybe<ClaimFacetHistoryStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `ClaimFacetHistory` objects. */
  stddevSample?: InputMaybe<ClaimFacetHistoryStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `ClaimFacetHistory` objects. */
  sum?: InputMaybe<ClaimFacetHistorySumAggregateFilter>;
  /** Population variance aggregate over matching `ClaimFacetHistory` objects. */
  variancePopulation?: InputMaybe<ClaimFacetHistoryVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `ClaimFacetHistory` objects. */
  varianceSample?: InputMaybe<ClaimFacetHistoryVarianceSampleAggregateFilter>;
};

/** Input for the nested mutation of `auditorUser` in the `ClaimFacetHistoryInput` mutation. */
export type ClaimFacetHistoryAppliedByFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `claimFacetHistory` in the `AuditorUserInput` mutation. */
export type ClaimFacetHistoryAppliedByFkeyInverseInput = {
  /** The primary key(s) for `claimFacetHistory` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ClaimFacetHistoryClaimFacetHistoryPkeyConnect>
  >;
  /** The primary key(s) for `claimFacetHistory` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ClaimFacetHistoryNodeIdConnect>>;
  /** The primary key(s) and patch data for `claimFacetHistory` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyUsingClaimFacetHistoryPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `claimFacetHistory` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyNodeIdUpdate>
  >;
};

export type ClaimFacetHistoryAverageAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
};

export type ClaimFacetHistoryAverageAggregates = {
  __typename?: "ClaimFacetHistoryAverageAggregates";
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** Input for the nested mutation of `batchClaim` in the `ClaimFacetHistoryInput` mutation. */
export type ClaimFacetHistoryBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `claimFacetHistory` in the `BatchClaimInput` mutation. */
export type ClaimFacetHistoryBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `claimFacetHistory` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ClaimFacetHistoryClaimFacetHistoryPkeyConnect>
  >;
  /** The primary key(s) for `claimFacetHistory` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ClaimFacetHistoryNodeIdConnect>>;
  /** The primary key(s) and patch data for `claimFacetHistory` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyUsingClaimFacetHistoryPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `claimFacetHistory` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/** The fields on `claimFacetHistory` to look up the row to connect. */
export type ClaimFacetHistoryClaimFacetHistoryPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/**
 * A condition to be used against `ClaimFacetHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ClaimFacetHistoryCondition = {
  /** Checks for equality with the object’s `appliedAt` field. */
  appliedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `appliedBy` field. */
  appliedBy?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `context` field. */
  context?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `operationType` field. */
  operationType?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `previousValue` field. */
  previousValue?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type ClaimFacetHistoryDistinctCountAggregateFilter = {
  appliedAt?: InputMaybe<BigIntFilter>;
  appliedBy?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  context?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  operationType?: InputMaybe<BigIntFilter>;
  path?: InputMaybe<BigIntFilter>;
  previousValue?: InputMaybe<BigIntFilter>;
  value?: InputMaybe<BigIntFilter>;
};

export type ClaimFacetHistoryDistinctCountAggregates = {
  __typename?: "ClaimFacetHistoryDistinctCountAggregates";
  /** Distinct count of appliedAt across the matching connection */
  appliedAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of appliedBy across the matching connection */
  appliedBy?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of context across the matching connection */
  context?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of operationType across the matching connection */
  operationType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of path across the matching connection */
  path?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of previousValue across the matching connection */
  previousValue?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of value across the matching connection */
  value?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ClaimFacetHistory` object types. All fields are combined with a logical ‘and.’ */
export type ClaimFacetHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClaimFacetHistoryFilter>>;
  /** Filter by the object’s `appliedAt` field. */
  appliedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `appliedBy` field. */
  appliedBy?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `auditorUserByAppliedBy` relation. */
  auditorUserByAppliedBy?: InputMaybe<AuditorUserFilter>;
  /** A related `auditorUserByAppliedBy` exists. */
  auditorUserByAppliedByExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `context` field. */
  context?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClaimFacetHistoryFilter>;
  /** Filter by the object’s `operationType` field. */
  operationType?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClaimFacetHistoryFilter>>;
  /** Filter by the object’s `path` field. */
  path?: InputMaybe<StringFilter>;
  /** Filter by the object’s `previousValue` field. */
  previousValue?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JSONFilter>;
};

/** Grouping methods for `ClaimFacetHistory` for usage during aggregation. */
export enum ClaimFacetHistoryGroupBy {
  APPLIED_AT = "APPLIED_AT",
  APPLIED_AT_TRUNCATED_TO_DAY = "APPLIED_AT_TRUNCATED_TO_DAY",
  APPLIED_AT_TRUNCATED_TO_HOUR = "APPLIED_AT_TRUNCATED_TO_HOUR",
  APPLIED_BY = "APPLIED_BY",
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CONTEXT = "CONTEXT",
  OPERATION_TYPE = "OPERATION_TYPE",
  PATH = "PATH",
  PREVIOUS_VALUE = "PREVIOUS_VALUE",
  VALUE = "VALUE",
}

export type ClaimFacetHistoryHavingAverageInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryHavingDistinctCountInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `ClaimFacetHistory` aggregates. */
export type ClaimFacetHistoryHavingInput = {
  AND?: InputMaybe<Array<ClaimFacetHistoryHavingInput>>;
  OR?: InputMaybe<Array<ClaimFacetHistoryHavingInput>>;
  average?: InputMaybe<ClaimFacetHistoryHavingAverageInput>;
  distinctCount?: InputMaybe<ClaimFacetHistoryHavingDistinctCountInput>;
  max?: InputMaybe<ClaimFacetHistoryHavingMaxInput>;
  min?: InputMaybe<ClaimFacetHistoryHavingMinInput>;
  stddevPopulation?: InputMaybe<ClaimFacetHistoryHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ClaimFacetHistoryHavingStddevSampleInput>;
  sum?: InputMaybe<ClaimFacetHistoryHavingSumInput>;
  variancePopulation?: InputMaybe<ClaimFacetHistoryHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ClaimFacetHistoryHavingVarianceSampleInput>;
};

export type ClaimFacetHistoryHavingMaxInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryHavingMinInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryHavingStddevPopulationInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryHavingStddevSampleInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryHavingSumInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryHavingVariancePopulationInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryHavingVarianceSampleInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryMaxAggregateFilter = {
  id?: InputMaybe<BigIntFilter>;
};

export type ClaimFacetHistoryMaxAggregates = {
  __typename?: "ClaimFacetHistoryMaxAggregates";
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

export type ClaimFacetHistoryMinAggregateFilter = {
  id?: InputMaybe<BigIntFilter>;
};

export type ClaimFacetHistoryMinAggregates = {
  __typename?: "ClaimFacetHistoryMinAggregates";
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ClaimFacetHistoryNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `claimFacetHistory` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `claimFacetHistory` to look up the row to update. */
export type ClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyUsingClaimFacetHistoryPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `claimFacetHistory` being updated. */
    patch: updateClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `claimFacetHistory` to look up the row to update. */
export type ClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyUsingClaimFacetHistoryPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `claimFacetHistory` being updated. */
    patch: updateClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `ClaimFacetHistory`. Fields that are set will be updated. */
export type ClaimFacetHistoryPatch = {
  appliedBy?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAppliedBy?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInput>;
};

/**
 * Human-readable view of claim facet history with ICN and user email.
 * Useful for auditing and debugging facet changes. The applied_by_email and batch_claim_id are included to satisfy the integration with the eventHistoryTimeline service module
 */
export type ClaimFacetHistoryReadable = {
  __typename?: "ClaimFacetHistoryReadable";
  appliedAt?: Maybe<Scalars["Datetime"]["output"]>;
  appliedBy?: Maybe<Scalars["UUID"]["output"]>;
  appliedByEmail?: Maybe<Scalars["String"]["output"]>;
  batchClaimId?: Maybe<Scalars["UUID"]["output"]>;
  context?: Maybe<Scalars["JSON"]["output"]>;
  createdAt?: Maybe<Scalars["Datetime"]["output"]>;
  icn?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["BigInt"]["output"]>;
  operationType?: Maybe<Scalars["String"]["output"]>;
  path?: Maybe<Scalars["String"]["output"]>;
  previousValue?: Maybe<Scalars["JSON"]["output"]>;
  value?: Maybe<Scalars["JSON"]["output"]>;
};

export type ClaimFacetHistoryReadableAggregates = {
  __typename?: "ClaimFacetHistoryReadableAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ClaimFacetHistoryReadableAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ClaimFacetHistoryReadableDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ClaimFacetHistoryReadableMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ClaimFacetHistoryReadableMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ClaimFacetHistoryReadableStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ClaimFacetHistoryReadableStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ClaimFacetHistoryReadableSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ClaimFacetHistoryReadableVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ClaimFacetHistoryReadableVarianceSampleAggregates>;
};

export type ClaimFacetHistoryReadableAverageAggregates = {
  __typename?: "ClaimFacetHistoryReadableAverageAggregates";
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars["BigFloat"]["output"]>;
};

/**
 * A condition to be used against `ClaimFacetHistoryReadable` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ClaimFacetHistoryReadableCondition = {
  /** Checks for equality with the object’s `appliedAt` field. */
  appliedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `appliedBy` field. */
  appliedBy?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `appliedByEmail` field. */
  appliedByEmail?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `context` field. */
  context?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `icn` field. */
  icn?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `operationType` field. */
  operationType?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `previousValue` field. */
  previousValue?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type ClaimFacetHistoryReadableDistinctCountAggregates = {
  __typename?: "ClaimFacetHistoryReadableDistinctCountAggregates";
  /** Distinct count of appliedAt across the matching connection */
  appliedAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of appliedBy across the matching connection */
  appliedBy?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of appliedByEmail across the matching connection */
  appliedByEmail?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of context across the matching connection */
  context?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of icn across the matching connection */
  icn?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of operationType across the matching connection */
  operationType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of path across the matching connection */
  path?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of previousValue across the matching connection */
  previousValue?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of value across the matching connection */
  value?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ClaimFacetHistoryReadable` object types. All fields are combined with a logical ‘and.’ */
export type ClaimFacetHistoryReadableFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClaimFacetHistoryReadableFilter>>;
  /** Filter by the object’s `appliedAt` field. */
  appliedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `appliedBy` field. */
  appliedBy?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `appliedByEmail` field. */
  appliedByEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `context` field. */
  context?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `icn` field. */
  icn?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClaimFacetHistoryReadableFilter>;
  /** Filter by the object’s `operationType` field. */
  operationType?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClaimFacetHistoryReadableFilter>>;
  /** Filter by the object’s `path` field. */
  path?: InputMaybe<StringFilter>;
  /** Filter by the object’s `previousValue` field. */
  previousValue?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JSONFilter>;
};

/** Grouping methods for `ClaimFacetHistoryReadable` for usage during aggregation. */
export enum ClaimFacetHistoryReadableGroupBy {
  APPLIED_AT = "APPLIED_AT",
  APPLIED_AT_TRUNCATED_TO_DAY = "APPLIED_AT_TRUNCATED_TO_DAY",
  APPLIED_AT_TRUNCATED_TO_HOUR = "APPLIED_AT_TRUNCATED_TO_HOUR",
  APPLIED_BY = "APPLIED_BY",
  APPLIED_BY_EMAIL = "APPLIED_BY_EMAIL",
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CONTEXT = "CONTEXT",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  ICN = "ICN",
  ID = "ID",
  OPERATION_TYPE = "OPERATION_TYPE",
  PATH = "PATH",
  PREVIOUS_VALUE = "PREVIOUS_VALUE",
  VALUE = "VALUE",
}

export type ClaimFacetHistoryReadableHavingAverageInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryReadableHavingDistinctCountInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `ClaimFacetHistoryReadable` aggregates. */
export type ClaimFacetHistoryReadableHavingInput = {
  AND?: InputMaybe<Array<ClaimFacetHistoryReadableHavingInput>>;
  OR?: InputMaybe<Array<ClaimFacetHistoryReadableHavingInput>>;
  average?: InputMaybe<ClaimFacetHistoryReadableHavingAverageInput>;
  distinctCount?: InputMaybe<ClaimFacetHistoryReadableHavingDistinctCountInput>;
  max?: InputMaybe<ClaimFacetHistoryReadableHavingMaxInput>;
  min?: InputMaybe<ClaimFacetHistoryReadableHavingMinInput>;
  stddevPopulation?: InputMaybe<ClaimFacetHistoryReadableHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ClaimFacetHistoryReadableHavingStddevSampleInput>;
  sum?: InputMaybe<ClaimFacetHistoryReadableHavingSumInput>;
  variancePopulation?: InputMaybe<ClaimFacetHistoryReadableHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ClaimFacetHistoryReadableHavingVarianceSampleInput>;
};

export type ClaimFacetHistoryReadableHavingMaxInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryReadableHavingMinInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryReadableHavingStddevPopulationInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryReadableHavingStddevSampleInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryReadableHavingSumInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryReadableHavingVariancePopulationInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryReadableHavingVarianceSampleInput = {
  appliedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  id?: InputMaybe<HavingBigintFilter>;
};

export type ClaimFacetHistoryReadableMaxAggregates = {
  __typename?: "ClaimFacetHistoryReadableMaxAggregates";
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

export type ClaimFacetHistoryReadableMinAggregates = {
  __typename?: "ClaimFacetHistoryReadableMinAggregates";
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

export type ClaimFacetHistoryReadableStddevPopulationAggregates = {
  __typename?: "ClaimFacetHistoryReadableStddevPopulationAggregates";
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimFacetHistoryReadableStddevSampleAggregates = {
  __typename?: "ClaimFacetHistoryReadableStddevSampleAggregates";
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimFacetHistoryReadableSumAggregates = {
  __typename?: "ClaimFacetHistoryReadableSumAggregates";
  /** Sum of id across the matching connection */
  id: Scalars["BigFloat"]["output"];
};

export type ClaimFacetHistoryReadableVariancePopulationAggregates = {
  __typename?: "ClaimFacetHistoryReadableVariancePopulationAggregates";
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimFacetHistoryReadableVarianceSampleAggregates = {
  __typename?: "ClaimFacetHistoryReadableVarianceSampleAggregates";
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** A connection to a list of `ClaimFacetHistoryReadable` values. */
export type ClaimFacetHistoryReadablesConnection = {
  __typename?: "ClaimFacetHistoryReadablesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ClaimFacetHistoryReadableAggregates>;
  /** A list of edges which contains the `ClaimFacetHistoryReadable` and cursor to aid in pagination. */
  edges: Array<ClaimFacetHistoryReadablesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ClaimFacetHistoryReadableAggregates>>;
  /** A list of `ClaimFacetHistoryReadable` objects. */
  nodes: Array<Maybe<ClaimFacetHistoryReadable>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClaimFacetHistoryReadable` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ClaimFacetHistoryReadable` values. */
export type ClaimFacetHistoryReadablesConnectiongroupedAggregatesArgs = {
  groupBy: Array<ClaimFacetHistoryReadableGroupBy>;
  having?: InputMaybe<ClaimFacetHistoryReadableHavingInput>;
};

/** A `ClaimFacetHistoryReadable` edge in the connection. */
export type ClaimFacetHistoryReadablesEdge = {
  __typename?: "ClaimFacetHistoryReadablesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ClaimFacetHistoryReadable` at the end of the edge. */
  node?: Maybe<ClaimFacetHistoryReadable>;
};

/** Methods to use when ordering `ClaimFacetHistoryReadable`. */
export enum ClaimFacetHistoryReadablesOrderBy {
  APPLIED_AT_ASC = "APPLIED_AT_ASC",
  APPLIED_AT_DESC = "APPLIED_AT_DESC",
  APPLIED_BY_ASC = "APPLIED_BY_ASC",
  APPLIED_BY_DESC = "APPLIED_BY_DESC",
  APPLIED_BY_EMAIL_ASC = "APPLIED_BY_EMAIL_ASC",
  APPLIED_BY_EMAIL_DESC = "APPLIED_BY_EMAIL_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CONTEXT_ASC = "CONTEXT_ASC",
  CONTEXT_DESC = "CONTEXT_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ICN_ASC = "ICN_ASC",
  ICN_DESC = "ICN_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  OPERATION_TYPE_ASC = "OPERATION_TYPE_ASC",
  OPERATION_TYPE_DESC = "OPERATION_TYPE_DESC",
  PATH_ASC = "PATH_ASC",
  PATH_DESC = "PATH_DESC",
  PREVIOUS_VALUE_ASC = "PREVIOUS_VALUE_ASC",
  PREVIOUS_VALUE_DESC = "PREVIOUS_VALUE_DESC",
  VALUE_ASC = "VALUE_ASC",
  VALUE_DESC = "VALUE_DESC",
}

export type ClaimFacetHistoryStddevPopulationAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
};

export type ClaimFacetHistoryStddevPopulationAggregates = {
  __typename?: "ClaimFacetHistoryStddevPopulationAggregates";
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimFacetHistoryStddevSampleAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
};

export type ClaimFacetHistoryStddevSampleAggregates = {
  __typename?: "ClaimFacetHistoryStddevSampleAggregates";
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimFacetHistorySumAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
};

export type ClaimFacetHistorySumAggregates = {
  __typename?: "ClaimFacetHistorySumAggregates";
  /** Sum of id across the matching connection */
  id: Scalars["BigFloat"]["output"];
};

export type ClaimFacetHistoryVariancePopulationAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
};

export type ClaimFacetHistoryVariancePopulationAggregates = {
  __typename?: "ClaimFacetHistoryVariancePopulationAggregates";
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type ClaimFacetHistoryVarianceSampleAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
};

export type ClaimFacetHistoryVarianceSampleAggregates = {
  __typename?: "ClaimFacetHistoryVarianceSampleAggregates";
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ClaimFacetNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `claimFacet` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ClaimFacetOnClaimFacetForClaimFacetsBatchClaimIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `batchClaim` being updated. */
  patch: BatchClaimPatch;
};

/** The fields on `claimFacet` to look up the row to update. */
export type ClaimFacetOnClaimFacetForClaimFacetsBatchClaimIdFkeyUsingClaimFacetsBatchClaimIdKeyUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `claimFacet` being updated. */
    patch: updateClaimFacetOnClaimFacetForClaimFacetsBatchClaimIdFkeyPatch;
  };

/** The fields on `claimFacet` to look up the row to update. */
export type ClaimFacetOnClaimFacetForClaimFacetsBatchClaimIdFkeyUsingClaimFacetsPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `claimFacet` being updated. */
    patch: updateClaimFacetOnClaimFacetForClaimFacetsBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `ClaimFacet`. Fields that are set will be updated. */
export type ClaimFacetPatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInput>;
};

/** Input for the nested mutation of `batchClaim` in the `ClaimFacetInput` mutation. */
export type ClaimFacetsBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ClaimFacetOnClaimFacetForClaimFacetsBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `claimFacet` in the `BatchClaimInput` mutation. */
export type ClaimFacetsBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `claimFacet` for the far side of the relationship. */
  connectByBatchClaimId?: InputMaybe<ClaimFacetClaimFacetsBatchClaimIdKeyConnect>;
  /** The primary key(s) for `claimFacet` for the far side of the relationship. */
  connectById?: InputMaybe<ClaimFacetClaimFacetsPkeyConnect>;
  /** The primary key(s) for `claimFacet` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ClaimFacetNodeIdConnect>;
  /** The primary key(s) and patch data for `claimFacet` for the far side of the relationship. */
  updateByBatchClaimId?: InputMaybe<ClaimFacetOnClaimFacetForClaimFacetsBatchClaimIdFkeyUsingClaimFacetsBatchClaimIdKeyUpdate>;
  /** The primary key(s) and patch data for `claimFacet` for the far side of the relationship. */
  updateById?: InputMaybe<ClaimFacetOnClaimFacetForClaimFacetsBatchClaimIdFkeyUsingClaimFacetsPkeyUpdate>;
  /** The primary key(s) and patch data for `claimFacet` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<BatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyNodeIdUpdate>;
};

/** A connection to a list of `ClaimFacet` values. */
export type ClaimFacetsConnection = {
  __typename?: "ClaimFacetsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ClaimFacetAggregates>;
  /** A list of edges which contains the `ClaimFacet` and cursor to aid in pagination. */
  edges: Array<ClaimFacetsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ClaimFacetAggregates>>;
  /** A list of `ClaimFacet` objects. */
  nodes: Array<Maybe<ClaimFacet>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClaimFacet` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ClaimFacet` values. */
export type ClaimFacetsConnectiongroupedAggregatesArgs = {
  groupBy: Array<ClaimFacetsGroupBy>;
  having?: InputMaybe<ClaimFacetsHavingInput>;
};

/** A `ClaimFacet` edge in the connection. */
export type ClaimFacetsEdge = {
  __typename?: "ClaimFacetsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ClaimFacet` at the end of the edge. */
  node?: Maybe<ClaimFacet>;
};

/** Grouping methods for `ClaimFacet` for usage during aggregation. */
export enum ClaimFacetsGroupBy {
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  FACETS = "FACETS",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type ClaimFacetsHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimFacetsHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ClaimFacet` aggregates. */
export type ClaimFacetsHavingInput = {
  AND?: InputMaybe<Array<ClaimFacetsHavingInput>>;
  OR?: InputMaybe<Array<ClaimFacetsHavingInput>>;
  average?: InputMaybe<ClaimFacetsHavingAverageInput>;
  distinctCount?: InputMaybe<ClaimFacetsHavingDistinctCountInput>;
  max?: InputMaybe<ClaimFacetsHavingMaxInput>;
  min?: InputMaybe<ClaimFacetsHavingMinInput>;
  stddevPopulation?: InputMaybe<ClaimFacetsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ClaimFacetsHavingStddevSampleInput>;
  sum?: InputMaybe<ClaimFacetsHavingSumInput>;
  variancePopulation?: InputMaybe<ClaimFacetsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ClaimFacetsHavingVarianceSampleInput>;
};

export type ClaimFacetsHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimFacetsHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimFacetsHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimFacetsHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimFacetsHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimFacetsHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimFacetsHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `ClaimFacet`. */
export enum ClaimFacetsOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  FACETS_ASC = "FACETS_ASC",
  FACETS_DESC = "FACETS_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type ClaimIntakeInput = {
  claimNumber: Scalars["String"]["input"];
  documentUploadKind: DocumentUploadKind;
  fileName: Scalars["String"]["input"];
  fileType: Scalars["String"]["input"];
  insurerId: Scalars["UUID"]["input"];
};

export type ClaimIntakeResponse = {
  __typename?: "ClaimIntakeResponse";
  tags?: Maybe<Scalars["String"]["output"]>;
  url: Scalars["String"]["output"];
};

/** Per-claim register with mr_attached boolean. Consumers filter by client_abbreviation. */
export type ClaimMrReport = {
  __typename?: "ClaimMrReport";
  claimFileName?: Maybe<Scalars["String"]["output"]>;
  claimId?: Maybe<Scalars["UUID"]["output"]>;
  claimNumber?: Maybe<Scalars["String"]["output"]>;
  clientAbbreviation?: Maybe<Scalars["String"]["output"]>;
  insurerId?: Maybe<Scalars["UUID"]["output"]>;
  mrAttached?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ClaimMrReportAggregates = {
  __typename?: "ClaimMrReportAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ClaimMrReportDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * A condition to be used against `ClaimMrReport` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ClaimMrReportCondition = {
  /** Checks for equality with the object’s `claimFileName` field. */
  claimFileName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `claimId` field. */
  claimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `claimNumber` field. */
  claimNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `clientAbbreviation` field. */
  clientAbbreviation?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `insurerId` field. */
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `mrAttached` field. */
  mrAttached?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ClaimMrReportDistinctCountAggregates = {
  __typename?: "ClaimMrReportDistinctCountAggregates";
  /** Distinct count of claimFileName across the matching connection */
  claimFileName?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of claimId across the matching connection */
  claimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of claimNumber across the matching connection */
  claimNumber?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientAbbreviation across the matching connection */
  clientAbbreviation?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of insurerId across the matching connection */
  insurerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of mrAttached across the matching connection */
  mrAttached?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ClaimMrReport` object types. All fields are combined with a logical ‘and.’ */
export type ClaimMrReportFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClaimMrReportFilter>>;
  /** Filter by the object’s `claimFileName` field. */
  claimFileName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `claimId` field. */
  claimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `claimNumber` field. */
  claimNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientAbbreviation` field. */
  clientAbbreviation?: InputMaybe<StringFilter>;
  /** Filter by the object’s `insurerId` field. */
  insurerId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `mrAttached` field. */
  mrAttached?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClaimMrReportFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClaimMrReportFilter>>;
};

/** Grouping methods for `ClaimMrReport` for usage during aggregation. */
export enum ClaimMrReportGroupBy {
  CLAIM_FILE_NAME = "CLAIM_FILE_NAME",
  CLAIM_ID = "CLAIM_ID",
  CLAIM_NUMBER = "CLAIM_NUMBER",
  CLIENT_ABBREVIATION = "CLIENT_ABBREVIATION",
  INSURER_ID = "INSURER_ID",
  MR_ATTACHED = "MR_ATTACHED",
}

/** Conditions for `ClaimMrReport` aggregates. */
export type ClaimMrReportHavingInput = {
  AND?: InputMaybe<Array<ClaimMrReportHavingInput>>;
  OR?: InputMaybe<Array<ClaimMrReportHavingInput>>;
};

/** A connection to a list of `ClaimMrReport` values. */
export type ClaimMrReportsConnection = {
  __typename?: "ClaimMrReportsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ClaimMrReportAggregates>;
  /** A list of edges which contains the `ClaimMrReport` and cursor to aid in pagination. */
  edges: Array<ClaimMrReportsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ClaimMrReportAggregates>>;
  /** A list of `ClaimMrReport` objects. */
  nodes: Array<Maybe<ClaimMrReport>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClaimMrReport` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ClaimMrReport` values. */
export type ClaimMrReportsConnectiongroupedAggregatesArgs = {
  groupBy: Array<ClaimMrReportGroupBy>;
  having?: InputMaybe<ClaimMrReportHavingInput>;
};

/** A `ClaimMrReport` edge in the connection. */
export type ClaimMrReportsEdge = {
  __typename?: "ClaimMrReportsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ClaimMrReport` at the end of the edge. */
  node?: Maybe<ClaimMrReport>;
};

/** Methods to use when ordering `ClaimMrReport`. */
export enum ClaimMrReportsOrderBy {
  CLAIM_FILE_NAME_ASC = "CLAIM_FILE_NAME_ASC",
  CLAIM_FILE_NAME_DESC = "CLAIM_FILE_NAME_DESC",
  CLAIM_ID_ASC = "CLAIM_ID_ASC",
  CLAIM_ID_DESC = "CLAIM_ID_DESC",
  CLAIM_NUMBER_ASC = "CLAIM_NUMBER_ASC",
  CLAIM_NUMBER_DESC = "CLAIM_NUMBER_DESC",
  CLIENT_ABBREVIATION_ASC = "CLIENT_ABBREVIATION_ASC",
  CLIENT_ABBREVIATION_DESC = "CLIENT_ABBREVIATION_DESC",
  INSURER_ID_ASC = "INSURER_ID_ASC",
  INSURER_ID_DESC = "INSURER_ID_DESC",
  MR_ATTACHED_ASC = "MR_ATTACHED_ASC",
  MR_ATTACHED_DESC = "MR_ATTACHED_DESC",
  NATURAL = "NATURAL",
}

export type ClaimPhase = {
  __typename?: "ClaimPhase";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  labelOrder: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** Same as slug; stable snake_case alias for SQL / UI joins. */
  phase_slug: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  stages: Array<ClaimStage>;
};

/** Filter by claim lifecycle phase keyword (e.g. "intake", "audit"). Values may be supplied as the keyword slug or its resolved UUID. Slugs are resolved sync via uuidv5; no DB lookup. Backed by idx_claim_facets_phase_extracted (uuid expression btree). */
export type ClaimPhaseFacetFilterInput = {
  /** Exact match. Accepts a phase slug or keyword UUID. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match any phase in the list (slug or UUID). */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** True for claims with no phase set; false for set. */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Not equal. Accepts a phase slug or keyword UUID. */
  notEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match no phase in the list (slug or UUID). */
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ClaimPolicyDocument = Node & {
  __typename?: "ClaimPolicyDocument";
  /** Reads a single `BatchClaim` that is related to this `ClaimPolicyDocument`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  documentId: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type ClaimPolicyDocumentAggregates = {
  __typename?: "ClaimPolicyDocumentAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ClaimPolicyDocumentDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `ClaimPolicyDocument` object types. */
export type ClaimPolicyDocumentAggregatesFilter = {
  /** Distinct count aggregate over matching `ClaimPolicyDocument` objects. */
  distinctCount?: InputMaybe<ClaimPolicyDocumentDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ClaimPolicyDocument` object to be included within the aggregate. */
  filter?: InputMaybe<ClaimPolicyDocumentFilter>;
};

/** Input for the nested mutation of `batchClaim` in the `ClaimPolicyDocumentInput` mutation. */
export type ClaimPolicyDocumentBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ClaimPolicyDocumentOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `claimPolicyDocument` in the `BatchClaimInput` mutation. */
export type ClaimPolicyDocumentBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `claimPolicyDocument` for the far side of the relationship. */
  connectByBatchClaimIdAndDocumentId?: InputMaybe<
    Array<ClaimPolicyDocumentClaimPolicyDocumentBatchClaimIdDocumentIdKeyConnect>
  >;
  /** The primary key(s) for `claimPolicyDocument` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ClaimPolicyDocumentClaimPolicyDocumentPkeyConnect>
  >;
  /** The primary key(s) for `claimPolicyDocument` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ClaimPolicyDocumentNodeIdConnect>>;
  /** The primary key(s) and patch data for `claimPolicyDocument` for the far side of the relationship. */
  updateByBatchClaimIdAndDocumentId?: InputMaybe<
    Array<ClaimPolicyDocumentOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyUsingClaimPolicyDocumentBatchClaimIdDocumentIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `claimPolicyDocument` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ClaimPolicyDocumentOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyUsingClaimPolicyDocumentPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `claimPolicyDocument` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/** The fields on `claimPolicyDocument` to look up the row to connect. */
export type ClaimPolicyDocumentClaimPolicyDocumentBatchClaimIdDocumentIdKeyConnect =
  {
    batchClaimId: Scalars["UUID"]["input"];
    documentId: Scalars["UUID"]["input"];
  };

/** The fields on `claimPolicyDocument` to look up the row to connect. */
export type ClaimPolicyDocumentClaimPolicyDocumentPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `ClaimPolicyDocument` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ClaimPolicyDocumentCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type ClaimPolicyDocumentDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  documentId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type ClaimPolicyDocumentDistinctCountAggregates = {
  __typename?: "ClaimPolicyDocumentDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of documentId across the matching connection */
  documentId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ClaimPolicyDocument` object types. All fields are combined with a logical ‘and.’ */
export type ClaimPolicyDocumentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClaimPolicyDocumentFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClaimPolicyDocumentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClaimPolicyDocumentFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `ClaimPolicyDocument` for usage during aggregation. */
export enum ClaimPolicyDocumentGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DOCUMENT_ID = "DOCUMENT_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type ClaimPolicyDocumentHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimPolicyDocumentHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ClaimPolicyDocument` aggregates. */
export type ClaimPolicyDocumentHavingInput = {
  AND?: InputMaybe<Array<ClaimPolicyDocumentHavingInput>>;
  OR?: InputMaybe<Array<ClaimPolicyDocumentHavingInput>>;
  average?: InputMaybe<ClaimPolicyDocumentHavingAverageInput>;
  distinctCount?: InputMaybe<ClaimPolicyDocumentHavingDistinctCountInput>;
  max?: InputMaybe<ClaimPolicyDocumentHavingMaxInput>;
  min?: InputMaybe<ClaimPolicyDocumentHavingMinInput>;
  stddevPopulation?: InputMaybe<ClaimPolicyDocumentHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ClaimPolicyDocumentHavingStddevSampleInput>;
  sum?: InputMaybe<ClaimPolicyDocumentHavingSumInput>;
  variancePopulation?: InputMaybe<ClaimPolicyDocumentHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ClaimPolicyDocumentHavingVarianceSampleInput>;
};

export type ClaimPolicyDocumentHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimPolicyDocumentHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimPolicyDocumentHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimPolicyDocumentHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimPolicyDocumentHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimPolicyDocumentHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClaimPolicyDocumentHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ClaimPolicyDocumentNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `claimPolicyDocument` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ClaimPolicyDocumentOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `claimPolicyDocument` to look up the row to update. */
export type ClaimPolicyDocumentOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyUsingClaimPolicyDocumentBatchClaimIdDocumentIdKeyUpdate =
  {
    batchClaimId: Scalars["UUID"]["input"];
    documentId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `claimPolicyDocument` being updated. */
    patch: updateClaimPolicyDocumentOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyPatch;
  };

/** The fields on `claimPolicyDocument` to look up the row to update. */
export type ClaimPolicyDocumentOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyUsingClaimPolicyDocumentPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `claimPolicyDocument` being updated. */
    patch: updateClaimPolicyDocumentOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `ClaimPolicyDocument`. Fields that are set will be updated. */
export type ClaimPolicyDocumentPatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInput>;
};

/** A connection to a list of `ClaimPolicyDocument` values. */
export type ClaimPolicyDocumentsConnection = {
  __typename?: "ClaimPolicyDocumentsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ClaimPolicyDocumentAggregates>;
  /** A list of edges which contains the `ClaimPolicyDocument` and cursor to aid in pagination. */
  edges: Array<ClaimPolicyDocumentsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ClaimPolicyDocumentAggregates>>;
  /** A list of `ClaimPolicyDocument` objects. */
  nodes: Array<Maybe<ClaimPolicyDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClaimPolicyDocument` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ClaimPolicyDocument` values. */
export type ClaimPolicyDocumentsConnectiongroupedAggregatesArgs = {
  groupBy: Array<ClaimPolicyDocumentGroupBy>;
  having?: InputMaybe<ClaimPolicyDocumentHavingInput>;
};

/** A `ClaimPolicyDocument` edge in the connection. */
export type ClaimPolicyDocumentsEdge = {
  __typename?: "ClaimPolicyDocumentsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ClaimPolicyDocument` at the end of the edge. */
  node?: Maybe<ClaimPolicyDocument>;
};

/** Methods to use when ordering `ClaimPolicyDocument`. */
export enum ClaimPolicyDocumentsOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DOCUMENT_ID_ASC = "DOCUMENT_ID_ASC",
  DOCUMENT_ID_DESC = "DOCUMENT_ID_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** Match claims that ever had claim_lifecycle_phase set to the given value in their history. Values may be phase slugs (e.g. "audit") or the resolved phase UUID. Slugs are resolved sync via uuidv5; no DB lookup. Backed by two btree indexes on v3.claim_facet_history: idx_claim_facet_history_claim_path_value serves the per-claim correlated subquery when outer batch_claim is already narrowed (the common filter case); idx_claim_facet_history_path_value_claim serves sparse cross-claim scans like "any claim ever in <rare phase>" when no outer narrowing exists. */
export type ClaimPreviouslyInPhaseFacetFilterInput = {
  /** Match if any history row set phase to this value. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match if any history row set phase to any of these values. */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Match claims that ever had claim_lifecycle_stage set to the given value in their history. Values are compound slugs in the form `<phase>/<stage>` (e.g. "audit/QA_REVIEW") or stage keyword UUIDs. Compound slugs are resolved sync via uuidv5; no DB lookup. Backed by two btree indexes on v3.claim_facet_history: idx_claim_facet_history_claim_path_value serves the per-claim correlated subquery when outer batch_claim is already narrowed (the common filter case); idx_claim_facet_history_path_value_claim serves sparse cross-claim scans like "any claim ever in <rare stage>" when no outer narrowing exists. */
export type ClaimPreviouslyInStageFacetFilterInput = {
  /** Match if any history row set stage to this value. Accepts a "<phase>/<stage>" compound slug or stage UUID. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match if any history row set stage to any of these values. Each entry: compound slug or UUID. */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ClaimReportTransferInput = {
  claimIds: Array<Scalars["UUID"]["input"]>;
  clientDestinationId: Scalars["UUID"]["input"];
  namingConvention: OutgoingFileNamePatternType;
  types: Array<AuditFindingReportType>;
};

/**
 * A rev code observed on the active IB lines of a claim, sourced from
 * v3.active_ib_lines_view.
 */
export type ClaimRevCode = {
  __typename?: "ClaimRevCode";
  revCode: Scalars["String"]["output"];
};

/**
 * Lifecycle role assignment on a claim (user × role × claim).
 * Does NOT use batch_claim_assignee / auditor work-queue assignees.
 */
export type ClaimRoleAssignment = {
  __typename?: "ClaimRoleAssignment";
  role: LifecycleRole;
  roleId: Scalars["UUID"]["output"];
  user?: Maybe<AuditorUser>;
  userId: Scalars["UUID"]["output"];
};

export type ClaimRoleAssignmentInput = {
  roleId: Scalars["UUID"]["input"];
  userId: Scalars["UUID"]["input"];
};

export type ClaimRoleAssignments = {
  __typename?: "ClaimRoleAssignments";
  assignments: Array<ClaimRoleAssignment>;
  claimId: Scalars["UUID"]["output"];
  /** OCC token — pass as expectedUpdatedAt on save. */
  updatedAt: Scalars["Datetime"]["output"];
};

export type ClaimStage = {
  __typename?: "ClaimStage";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  labelOrder: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  nextRecommendedStage?: Maybe<ClaimStage>;
  phase: ClaimPhase;
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  /**
   * UI-facing Who/What summary as two paragraphs (derived from who + what):
   *
   * Who: PI Ops Associate, Data Ingestion Analyst
   *
   * What: Closes out duplicates/versioned claims; ...
   */
  stageDetail?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<ClaimStageType>;
  /** What the responsible role(s) do at this stage (claim lifecycle cheat sheet What). */
  what?: Maybe<Scalars["String"]["output"]>;
  /** Role(s) responsible for this stage (claim lifecycle cheat sheet Who). */
  who: Array<Scalars["String"]["output"]>;
};

/** Filter by claim lifecycle stage. Stage values are compound slugs in the form `<phase>/<stage>` (e.g. "audit/QA_REVIEW") or stage keyword UUIDs. The compound form is required for slugs because stage slugs may collide across phase facets. Backed by idx_claim_facets_stage_extracted (uuid expression btree). */
export type ClaimStageFacetFilterInput = {
  /** Exact match. Accepts a "<phase>/<stage>" compound slug or stage UUID. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match any stage in the list. Each entry: compound slug or UUID. */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** True for claims with no stage set. */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Not equal. Compound slug or stage UUID. */
  notEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match no stage in the list. Each entry: compound slug or UUID. */
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Filter by claim lifecycle stage (claim_lifecycle_stage facet on batch_claim). */
export type ClaimStageFilter = {
  /** Filter by lifecycle stage keyword id. */
  id?: InputMaybe<ClaimStageIdFilter>;
};

/** Filter by claim lifecycle stage keyword id (`claim_lifecycle_stage` facet). */
export type ClaimStageIdFilter = {
  /** Match if stage keyword id equals this value. */
  equalTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Match if stage keyword id is any of these. */
  in?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
};

export enum ClaimStageType {
  CLOSED = "CLOSED",
  SENT = "SENT",
}

/** Legacy homepage Phases pane (scoped by saved queue filter when queueId is set). */
export type ClaimsSummary = {
  __typename?: "ClaimsSummary";
  phasesSummary: Array<ClaimsSummaryPhaseSummary>;
};

/** Per-phase claim count for the legacy claimsSummary query (homepage Phases pane). */
export type ClaimsSummaryPhaseSummary = {
  __typename?: "ClaimsSummaryPhaseSummary";
  numberOfClaims: Scalars["Int"]["output"];
  phase: ClaimPhase;
};

export type ClientSendReportTransfer = {
  __typename?: "ClientSendReportTransfer";
  clientDestinationS3Bucket: Scalars["String"]["output"];
  clientDestinationS3Key: Scalars["String"]["output"];
  clientId: Scalars["UUID"]["output"];
  clientReportName: Scalars["String"]["output"];
  clientTransferMethodId?: Maybe<Scalars["UUID"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  createdBy?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  reportId: Scalars["UUID"]["output"];
  reportOriginalVersionId: Scalars["UUID"]["output"];
  s3Response?: Maybe<Scalars["JSON"]["output"]>;
  status: Scalars["String"]["output"];
  transferMethodType?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["Date"]["output"]>;
};

export type ClientSendTransferMethod = {
  __typename?: "ClientSendTransferMethod";
  clientId: Scalars["UUID"]["output"];
  createdAt: Scalars["Date"]["output"];
  displayName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  method: Scalars["String"]["output"];
  outgoingFileNamePattern: OutgoingFileNamePattern;
  preferred: Scalars["Boolean"]["output"];
  s3BucketName?: Maybe<Scalars["String"]["output"]>;
  s3DestinationKeyPrefix?: Maybe<Scalars["String"]["output"]>;
  sftpUrl?: Maybe<Scalars["String"]["output"]>;
};

export type ClientSignOffClaimState = Node & {
  __typename?: "ClientSignOffClaimState";
  /** Reads a single `BatchClaim` that is related to this `ClientSignOffClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  clientSignOffState: Scalars["String"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

export type ClientSignOffClaimStateAggregates = {
  __typename?: "ClientSignOffClaimStateAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ClientSignOffClaimStateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `ClientSignOffClaimState` object types. */
export type ClientSignOffClaimStateAggregatesFilter = {
  /** Distinct count aggregate over matching `ClientSignOffClaimState` objects. */
  distinctCount?: InputMaybe<ClientSignOffClaimStateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ClientSignOffClaimState` object to be included within the aggregate. */
  filter?: InputMaybe<ClientSignOffClaimStateFilter>;
};

/** The `clientSignOffClaimState` to be created by this mutation. */
export type ClientSignOffClaimStateBatchClaimIdFkClientSignOffClaimStateCreateInput =
  {
    batchClaimToBatchClaimId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInput>;
    clientSignOffState?: InputMaybe<Scalars["String"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `batchClaim` in the `ClientSignOffClaimStateInput` mutation. */
export type ClientSignOffClaimStateBatchClaimIdFkInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ClientSignOffClaimStateOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkNodeIdUpdate>;
};

/** Input for the nested mutation of `clientSignOffClaimState` in the `BatchClaimInput` mutation. */
export type ClientSignOffClaimStateBatchClaimIdFkInverseInput = {
  /** The primary key(s) for `clientSignOffClaimState` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ClientSignOffClaimStateClientSignOffClaimStatePkeyConnect>
  >;
  /** The primary key(s) for `clientSignOffClaimState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ClientSignOffClaimStateNodeIdConnect>>;
  /** A `ClientSignOffClaimStateInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ClientSignOffClaimStateBatchClaimIdFkClientSignOffClaimStateCreateInput>
  >;
  /** The primary key(s) and patch data for `clientSignOffClaimState` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ClientSignOffClaimStateOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkUsingClientSignOffClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `clientSignOffClaimState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkNodeIdUpdate>
  >;
};

/** The fields on `clientSignOffClaimState` to look up the row to connect. */
export type ClientSignOffClaimStateClientSignOffClaimStatePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `ClientSignOffClaimState` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ClientSignOffClaimStateCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `clientSignOffState` field. */
  clientSignOffState?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type ClientSignOffClaimStateDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  clientSignOffState?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type ClientSignOffClaimStateDistinctCountAggregates = {
  __typename?: "ClientSignOffClaimStateDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientSignOffState across the matching connection */
  clientSignOffState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

export enum ClientSignOffClaimStateEnum {
  CLIENT_NO_SIGN_OFF = "CLIENT_NO_SIGN_OFF",
  CLIENT_SIGN_OFF = "CLIENT_SIGN_OFF",
}

/** A filter to be used against ClientSignOffClaimStateEnum fields. All fields are combined with a logical ‘and.’ */
export type ClientSignOffClaimStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ClientSignOffClaimStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ClientSignOffClaimStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ClientSignOffClaimStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ClientSignOffClaimStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ClientSignOffClaimStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ClientSignOffClaimStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ClientSignOffClaimStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ClientSignOffClaimStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ClientSignOffClaimStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ClientSignOffClaimStateEnum>>;
};

/** A filter to be used against `ClientSignOffClaimState` object types. All fields are combined with a logical ‘and.’ */
export type ClientSignOffClaimStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClientSignOffClaimStateFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `clientSignOffState` field. */
  clientSignOffState?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClientSignOffClaimStateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClientSignOffClaimStateFilter>>;
};

/** Grouping methods for `ClientSignOffClaimState` for usage during aggregation. */
export enum ClientSignOffClaimStateGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CLIENT_SIGN_OFF_STATE = "CLIENT_SIGN_OFF_STATE",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
}

export type ClientSignOffClaimStateHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClientSignOffClaimStateHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ClientSignOffClaimState` aggregates. */
export type ClientSignOffClaimStateHavingInput = {
  AND?: InputMaybe<Array<ClientSignOffClaimStateHavingInput>>;
  OR?: InputMaybe<Array<ClientSignOffClaimStateHavingInput>>;
  average?: InputMaybe<ClientSignOffClaimStateHavingAverageInput>;
  distinctCount?: InputMaybe<ClientSignOffClaimStateHavingDistinctCountInput>;
  max?: InputMaybe<ClientSignOffClaimStateHavingMaxInput>;
  min?: InputMaybe<ClientSignOffClaimStateHavingMinInput>;
  stddevPopulation?: InputMaybe<ClientSignOffClaimStateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ClientSignOffClaimStateHavingStddevSampleInput>;
  sum?: InputMaybe<ClientSignOffClaimStateHavingSumInput>;
  variancePopulation?: InputMaybe<ClientSignOffClaimStateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ClientSignOffClaimStateHavingVarianceSampleInput>;
};

export type ClientSignOffClaimStateHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClientSignOffClaimStateHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClientSignOffClaimStateHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClientSignOffClaimStateHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClientSignOffClaimStateHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClientSignOffClaimStateHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ClientSignOffClaimStateHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `ClientSignOffClaimState` */
export type ClientSignOffClaimStateInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInput>;
  clientSignOffState?: InputMaybe<Scalars["String"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ClientSignOffClaimStateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `clientSignOffClaimState` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ClientSignOffClaimStateOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `clientSignOffClaimState` to look up the row to update. */
export type ClientSignOffClaimStateOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkUsingClientSignOffClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `clientSignOffClaimState` being updated. */
    patch: updateClientSignOffClaimStateOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkPatch;
  };

/** Represents an update to a `ClientSignOffClaimState`. Fields that are set will be updated. */
export type ClientSignOffClaimStatePatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInput>;
};

/** A connection to a list of `ClientSignOffClaimState` values. */
export type ClientSignOffClaimStatesConnection = {
  __typename?: "ClientSignOffClaimStatesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ClientSignOffClaimStateAggregates>;
  /** A list of edges which contains the `ClientSignOffClaimState` and cursor to aid in pagination. */
  edges: Array<ClientSignOffClaimStatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ClientSignOffClaimStateAggregates>>;
  /** A list of `ClientSignOffClaimState` objects. */
  nodes: Array<Maybe<ClientSignOffClaimState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClientSignOffClaimState` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ClientSignOffClaimState` values. */
export type ClientSignOffClaimStatesConnectiongroupedAggregatesArgs = {
  groupBy: Array<ClientSignOffClaimStateGroupBy>;
  having?: InputMaybe<ClientSignOffClaimStateHavingInput>;
};

/** A `ClientSignOffClaimState` edge in the connection. */
export type ClientSignOffClaimStatesEdge = {
  __typename?: "ClientSignOffClaimStatesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ClientSignOffClaimState` at the end of the edge. */
  node?: Maybe<ClientSignOffClaimState>;
};

/** Methods to use when ordering `ClientSignOffClaimState`. */
export enum ClientSignOffClaimStatesOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CLIENT_SIGN_OFF_STATE_ASC = "CLIENT_SIGN_OFF_STATE_ASC",
  CLIENT_SIGN_OFF_STATE_DESC = "CLIENT_SIGN_OFF_STATE_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

export type ConfirmFileUploadSuccessInput = {
  fileId: Scalars["UUID"]["input"];
  fileUploadId: Scalars["UUID"]["input"];
};

export type CreateAgentArtifactBodyInput = {
  agentMetadata: CreateAgentMetadataInput;
  artifacts?: InputMaybe<Array<CreateAgentArtifactBodyInput>>;
  citations?: InputMaybe<Array<CreateCitationInput>>;
  errorMessage?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  parentId?: InputMaybe<Scalars["UUID"]["input"]>;
  recommendation?: InputMaybe<Scalars["JSON"]["input"]>;
  sequenceNumber: Scalars["Int"]["input"];
  taskArtifactOutput?: InputMaybe<Scalars["JSON"]["input"]>;
  taskArtifactTemplateKey?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  workflowStatusId: Scalars["Int"]["input"];
};

export type CreateAgentArtifactInput = {
  citations?: InputMaybe<Array<CreateCitationInput>>;
  externalId?: InputMaybe<Scalars["UUID"]["input"]>;
  result: CreateAgentArtifactBodyInput;
  taskArtifactOutput?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type CreateAgentArtifactTemplateInput = {
  artifactTemplateKey: Scalars["String"]["input"];
  jsonSchema: Scalars["JSON"]["input"];
};

export type CreateAgentMetadataInput = {
  caseId?: InputMaybe<Scalars["UUID"]["input"]>;
  claimId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentIds: Array<Scalars["UUID"]["input"]>;
  instanceId: Scalars["UUID"]["input"];
  taskDisplayLabel: Scalars["String"]["input"];
  taskId: Scalars["UUID"]["input"];
  taskName?: InputMaybe<Scalars["String"]["input"]>;
  totalMessages?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CreateAnnotationLabelInput = {
  category: AnnotationLabelCategory;
  label: Scalars["String"]["input"];
  labelDescription?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
};

export type CreateAskAutodorQueueInput = {
  name: Scalars["String"]["input"];
};

/** All input for the create `AuditFinding` mutation. */
export type CreateAuditFindingInput = {
  /** The `AuditFinding` to be created by this mutation. */
  auditFinding: AuditFindingInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AuditFinding` mutation. */
export type CreateAuditFindingPayload = {
  __typename?: "CreateAuditFindingPayload";
  /** The `AuditFinding` that was created by this mutation. */
  auditFinding?: Maybe<AuditFinding>;
  /** An edge for our `AuditFinding`. May be used by Relay 1. */
  auditFindingEdge?: Maybe<AuditFindingsEdge>;
  /** Reads a single `AuditFindingJob` that is related to this `AuditFinding`. */
  auditFindingJob?: Maybe<AuditFindingJob>;
  /** Reads a single `AuditFindingRuleType` that is related to this `AuditFinding`. */
  auditFindingRuleTypeByAuditFindingRuleType?: Maybe<AuditFindingRuleType>;
  /** Reads a single `AuditorUser` that is related to this `AuditFinding`. */
  author?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `AuditFinding`. */
  batchClaim?: Maybe<BatchClaim>;
  /** Reads a single `BatchClaimLine` that is related to this `AuditFinding`. */
  batchClaimLine?: Maybe<BatchClaimLine>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `AuditFinding` that is related to this `AuditFinding`. */
  previousVersion?: Maybe<AuditFinding>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `AuditFinding` mutation. */
export type CreateAuditFindingPayloadauditFindingEdgeArgs = {
  orderBy?: InputMaybe<Array<AuditFindingsOrderBy>>;
};

/** All input for the create `AuditFindingReasonCode` mutation. */
export type CreateAuditFindingReasonCodeInput = {
  /** The `AuditFindingReasonCode` to be created by this mutation. */
  auditFindingReasonCode: AuditFindingReasonCodeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AuditFindingReasonCode` mutation. */
export type CreateAuditFindingReasonCodePayload = {
  __typename?: "CreateAuditFindingReasonCodePayload";
  /** Reads a single `AuditFinding` that is related to this `AuditFindingReasonCode`. */
  auditFinding?: Maybe<AuditFinding>;
  /** The `AuditFindingReasonCode` that was created by this mutation. */
  auditFindingReasonCode?: Maybe<AuditFindingReasonCode>;
  /** An edge for our `AuditFindingReasonCode`. May be used by Relay 1. */
  auditFindingReasonCodeEdge?: Maybe<AuditFindingReasonCodesEdge>;
  /** Reads a single `AuditorUser` that is related to this `AuditFindingReasonCode`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ReasonCode` that is related to this `AuditFindingReasonCode`. */
  reasonCode?: Maybe<ReasonCode>;
};

/** The output of our create `AuditFindingReasonCode` mutation. */
export type CreateAuditFindingReasonCodePayloadauditFindingReasonCodeEdgeArgs =
  {
    orderBy?: InputMaybe<Array<AuditFindingReasonCodesOrderBy>>;
  };

/** All input for the create `AuditFindingReview` mutation. */
export type CreateAuditFindingReviewInput = {
  /** The `AuditFindingReview` to be created by this mutation. */
  auditFindingReview: AuditFindingReviewInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AuditFindingReview` mutation. */
export type CreateAuditFindingReviewPayload = {
  __typename?: "CreateAuditFindingReviewPayload";
  /** The `AuditFindingReview` that was created by this mutation. */
  auditFindingReview?: Maybe<AuditFindingReview>;
  /** An edge for our `AuditFindingReview`. May be used by Relay 1. */
  auditFindingReviewEdge?: Maybe<AuditFindingReviewsEdge>;
  /** Reads a single `AuditorUser` that is related to this `AuditFindingReview`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `AuditFinding` that is related to this `AuditFindingReview`. */
  original?: Maybe<AuditFinding>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AuditFinding` that is related to this `AuditFindingReview`. */
  review?: Maybe<AuditFinding>;
};

/** The output of our create `AuditFindingReview` mutation. */
export type CreateAuditFindingReviewPayloadauditFindingReviewEdgeArgs = {
  orderBy?: InputMaybe<Array<AuditFindingReviewsOrderBy>>;
};

export type CreateAuditFindingValuesInput = {
  auditFindingRuleType: Scalars["String"]["input"];
  autodorFindingId?: InputMaybe<Scalars["String"]["input"]>;
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  confidence: Scalars["BigFloat"]["input"];
  improperPaymentCost: Scalars["Float"]["input"];
  improperPaymentReason: Scalars["String"]["input"];
  improperPaymentUnitsCharged: Scalars["Int"]["input"];
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CreateAuditFindingsPayload = {
  __typename?: "CreateAuditFindingsPayload";
  auditFindings: Array<AuditFinding>;
};

export type CreateAuditStatusInput = {
  color: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  icon: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  sortIndex: Scalars["Int"]["input"];
};

/** All input for the create `AuditorBucketAssignee` mutation. */
export type CreateAuditorBucketAssigneeInput = {
  /** The `AuditorBucketAssignee` to be created by this mutation. */
  auditorBucketAssignee: AuditorBucketAssigneeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AuditorBucketAssignee` mutation. */
export type CreateAuditorBucketAssigneePayload = {
  __typename?: "CreateAuditorBucketAssigneePayload";
  /** Reads a single `AuditorBucket` that is related to this `AuditorBucketAssignee`. */
  auditorBucket?: Maybe<AuditorBucket>;
  /** The `AuditorBucketAssignee` that was created by this mutation. */
  auditorBucketAssignee?: Maybe<AuditorBucketAssignee>;
  /** An edge for our `AuditorBucketAssignee`. May be used by Relay 1. */
  auditorBucketAssigneeEdge?: Maybe<AuditorBucketAssigneesEdge>;
  /** Reads a single `AuditorUser` that is related to this `AuditorBucketAssignee`. */
  auditorUser?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `AuditorBucketAssignee` mutation. */
export type CreateAuditorBucketAssigneePayloadauditorBucketAssigneeEdgeArgs = {
  orderBy?: InputMaybe<Array<AuditorBucketAssigneesOrderBy>>;
};

/** All input for the create `AuditorBucket` mutation. */
export type CreateAuditorBucketInput = {
  /** The `AuditorBucket` to be created by this mutation. */
  auditorBucket: AuditorBucketInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AuditorBucket` mutation. */
export type CreateAuditorBucketPayload = {
  __typename?: "CreateAuditorBucketPayload";
  /** Reads a single `AuditorUser` that is related to this `AuditorBucket`. */
  assignee?: Maybe<AuditorUser>;
  /** The `AuditorBucket` that was created by this mutation. */
  auditorBucket?: Maybe<AuditorBucket>;
  /** An edge for our `AuditorBucket`. May be used by Relay 1. */
  auditorBucketEdge?: Maybe<AuditorBucketsEdge>;
  /** Reads a single `AuditorUser` that is related to this `AuditorBucket`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Insurer` that is related to this `AuditorBucket`. */
  insurer?: Maybe<Insurer>;
  /** Reads a single `Provider` that is related to this `AuditorBucket`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `AuditorBucket` mutation. */
export type CreateAuditorBucketPayloadauditorBucketEdgeArgs = {
  orderBy?: InputMaybe<Array<AuditorBucketsOrderBy>>;
};

/** All input for the create `BatchClaimAppealed` mutation. */
export type CreateBatchClaimAppealedInput = {
  /** The `BatchClaimAppealed` to be created by this mutation. */
  batchClaimAppealed: BatchClaimAppealedInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimAppealed` mutation. */
export type CreateBatchClaimAppealedPayload = {
  __typename?: "CreateBatchClaimAppealedPayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimAppealed`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAppealed`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimAppealed` that was created by this mutation. */
  batchClaimAppealed?: Maybe<BatchClaimAppealed>;
  /** An edge for our `BatchClaimAppealed`. May be used by Relay 1. */
  batchClaimAppealedEdge?: Maybe<BatchClaimAppealedsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimAppealed` mutation. */
export type CreateBatchClaimAppealedPayloadbatchClaimAppealedEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimAppealedsOrderBy>>;
};

/** All input for the create `BatchClaimAssignee` mutation. */
export type CreateBatchClaimAssigneeInput = {
  /** The `BatchClaimAssignee` to be created by this mutation. */
  batchClaimAssignee: BatchClaimAssigneeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimAssignee` mutation. */
export type CreateBatchClaimAssigneePayload = {
  __typename?: "CreateBatchClaimAssigneePayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimAssignee`. */
  auditorUser?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAssignee`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimAssignee` that was created by this mutation. */
  batchClaimAssignee?: Maybe<BatchClaimAssignee>;
  /** An edge for our `BatchClaimAssignee`. May be used by Relay 1. */
  batchClaimAssigneeEdge?: Maybe<BatchClaimAssigneesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimAssignee` mutation. */
export type CreateBatchClaimAssigneePayloadbatchClaimAssigneeEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimAssigneesOrderBy>>;
};

/** All input for the create `BatchClaimAuditStartDate` mutation. */
export type CreateBatchClaimAuditStartDateInput = {
  /** The `BatchClaimAuditStartDate` to be created by this mutation. */
  batchClaimAuditStartDate: BatchClaimAuditStartDateInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimAuditStartDate` mutation. */
export type CreateBatchClaimAuditStartDatePayload = {
  __typename?: "CreateBatchClaimAuditStartDatePayload";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAuditStartDate`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimAuditStartDate` that was created by this mutation. */
  batchClaimAuditStartDate?: Maybe<BatchClaimAuditStartDate>;
  /** An edge for our `BatchClaimAuditStartDate`. May be used by Relay 1. */
  batchClaimAuditStartDateEdge?: Maybe<BatchClaimAuditStartDatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimAuditStartDate` mutation. */
export type CreateBatchClaimAuditStartDatePayloadbatchClaimAuditStartDateEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BatchClaimAuditStartDatesOrderBy>>;
  };

/** All input for the create `BatchClaimAuditType` mutation. */
export type CreateBatchClaimAuditTypeInput = {
  /** The `BatchClaimAuditType` to be created by this mutation. */
  batchClaimAuditType: BatchClaimAuditTypeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimAuditType` mutation. */
export type CreateBatchClaimAuditTypePayload = {
  __typename?: "CreateBatchClaimAuditTypePayload";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAuditType`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimAuditType` that was created by this mutation. */
  batchClaimAuditType?: Maybe<BatchClaimAuditType>;
  /** An edge for our `BatchClaimAuditType`. May be used by Relay 1. */
  batchClaimAuditTypeEdge?: Maybe<BatchClaimAuditTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimAuditType` mutation. */
export type CreateBatchClaimAuditTypePayloadbatchClaimAuditTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimAuditTypesOrderBy>>;
};

/** All input for the create `BatchClaimAuditor` mutation. */
export type CreateBatchClaimAuditorInput = {
  /** The `BatchClaimAuditor` to be created by this mutation. */
  batchClaimAuditor: BatchClaimAuditorInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimAuditor` mutation. */
export type CreateBatchClaimAuditorPayload = {
  __typename?: "CreateBatchClaimAuditorPayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimAuditor`. */
  auditorUser?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAuditor`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimAuditor` that was created by this mutation. */
  batchClaimAuditor?: Maybe<BatchClaimAuditor>;
  /** An edge for our `BatchClaimAuditor`. May be used by Relay 1. */
  batchClaimAuditorEdge?: Maybe<BatchClaimAuditorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimAuditor` mutation. */
export type CreateBatchClaimAuditorPayloadbatchClaimAuditorEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimAuditorsOrderBy>>;
};

/** All input for the create `BatchClaimClientRecoveryAmount` mutation. */
export type CreateBatchClaimClientRecoveryAmountInput = {
  /** The `BatchClaimClientRecoveryAmount` to be created by this mutation. */
  batchClaimClientRecoveryAmount: BatchClaimClientRecoveryAmountInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimClientRecoveryAmount` mutation. */
export type CreateBatchClaimClientRecoveryAmountPayload = {
  __typename?: "CreateBatchClaimClientRecoveryAmountPayload";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimClientRecoveryAmount`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimClientRecoveryAmount` that was created by this mutation. */
  batchClaimClientRecoveryAmount?: Maybe<BatchClaimClientRecoveryAmount>;
  /** An edge for our `BatchClaimClientRecoveryAmount`. May be used by Relay 1. */
  batchClaimClientRecoveryAmountEdge?: Maybe<BatchClaimClientRecoveryAmountsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimClientRecoveryAmount` mutation. */
export type CreateBatchClaimClientRecoveryAmountPayloadbatchClaimClientRecoveryAmountEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BatchClaimClientRecoveryAmountsOrderBy>>;
  };

/** All input for the create `BatchClaimClientRecoveryCollectionDate` mutation. */
export type CreateBatchClaimClientRecoveryCollectionDateInput = {
  /** The `BatchClaimClientRecoveryCollectionDate` to be created by this mutation. */
  batchClaimClientRecoveryCollectionDate: BatchClaimClientRecoveryCollectionDateInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimClientRecoveryCollectionDate` mutation. */
export type CreateBatchClaimClientRecoveryCollectionDatePayload = {
  __typename?: "CreateBatchClaimClientRecoveryCollectionDatePayload";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimClientRecoveryCollectionDate`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimClientRecoveryCollectionDate` that was created by this mutation. */
  batchClaimClientRecoveryCollectionDate?: Maybe<BatchClaimClientRecoveryCollectionDate>;
  /** An edge for our `BatchClaimClientRecoveryCollectionDate`. May be used by Relay 1. */
  batchClaimClientRecoveryCollectionDateEdge?: Maybe<BatchClaimClientRecoveryCollectionDatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimClientRecoveryCollectionDate` mutation. */
export type CreateBatchClaimClientRecoveryCollectionDatePayloadbatchClaimClientRecoveryCollectionDateEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BatchClaimClientRecoveryCollectionDatesOrderBy>>;
  };

/** All input for the create `BatchClaimDocument` mutation. */
export type CreateBatchClaimDocumentInput = {
  /** The `BatchClaimDocument` to be created by this mutation. */
  batchClaimDocument: BatchClaimDocumentInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimDocument` mutation. */
export type CreateBatchClaimDocumentPayload = {
  __typename?: "CreateBatchClaimDocumentPayload";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimDocument`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimDocument` that was created by this mutation. */
  batchClaimDocument?: Maybe<BatchClaimDocument>;
  /** An edge for our `BatchClaimDocument`. May be used by Relay 1. */
  batchClaimDocumentEdge?: Maybe<BatchClaimDocumentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimDocument` mutation. */
export type CreateBatchClaimDocumentPayloadbatchClaimDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimDocumentsOrderBy>>;
};

/** All input for the create `BatchClaimDueDate` mutation. */
export type CreateBatchClaimDueDateInput = {
  /** The `BatchClaimDueDate` to be created by this mutation. */
  batchClaimDueDate: BatchClaimDueDateInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimDueDate` mutation. */
export type CreateBatchClaimDueDatePayload = {
  __typename?: "CreateBatchClaimDueDatePayload";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimDueDate`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimDueDate` that was created by this mutation. */
  batchClaimDueDate?: Maybe<BatchClaimDueDate>;
  /** An edge for our `BatchClaimDueDate`. May be used by Relay 1. */
  batchClaimDueDateEdge?: Maybe<BatchClaimDueDatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimDueDate` mutation. */
export type CreateBatchClaimDueDatePayloadbatchClaimDueDateEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimDueDatesOrderBy>>;
};

/** All input for the create `BatchClaimLineItemAudit` mutation. */
export type CreateBatchClaimLineItemAuditInput = {
  /** The `BatchClaimLineItemAudit` to be created by this mutation. */
  batchClaimLineItemAudit: BatchClaimLineItemAuditInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimLineItemAudit` mutation. */
export type CreateBatchClaimLineItemAuditPayload = {
  __typename?: "CreateBatchClaimLineItemAuditPayload";
  /** Reads a single `AuditFinding` that is related to this `BatchClaimLineItemAudit`. */
  auditFinding?: Maybe<AuditFinding>;
  /** Reads a single `AuditorUser` that is related to this `BatchClaimLineItemAudit`. */
  author?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaimLineItem` that is related to this `BatchClaimLineItemAudit`. */
  batchClaimLineItem?: Maybe<BatchClaimLineItem>;
  /** The `BatchClaimLineItemAudit` that was created by this mutation. */
  batchClaimLineItemAudit?: Maybe<BatchClaimLineItemAudit>;
  /** An edge for our `BatchClaimLineItemAudit`. May be used by Relay 1. */
  batchClaimLineItemAuditEdge?: Maybe<BatchClaimLineItemAuditsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimLineItemAudit` mutation. */
export type CreateBatchClaimLineItemAuditPayloadbatchClaimLineItemAuditEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BatchClaimLineItemAuditsOrderBy>>;
  };

/** All input for the create `BatchClaimLineItem` mutation. */
export type CreateBatchClaimLineItemInput = {
  /** The `BatchClaimLineItem` to be created by this mutation. */
  batchClaimLineItem: BatchClaimLineItemInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** All input for the create `BatchClaimLineItemNnIbLine` mutation. */
export type CreateBatchClaimLineItemNnIbLineInput = {
  /** The `BatchClaimLineItemNnIbLine` to be created by this mutation. */
  batchClaimLineItemNnIbLine: BatchClaimLineItemNnIbLineInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimLineItemNnIbLine` mutation. */
export type CreateBatchClaimLineItemNnIbLinePayload = {
  __typename?: "CreateBatchClaimLineItemNnIbLinePayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimLineItemNnIbLine`. */
  author?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaimLineItem` that is related to this `BatchClaimLineItemNnIbLine`. */
  batchClaimLineItem?: Maybe<BatchClaimLineItem>;
  /** The `BatchClaimLineItemNnIbLine` that was created by this mutation. */
  batchClaimLineItemNnIbLine?: Maybe<BatchClaimLineItemNnIbLine>;
  /** An edge for our `BatchClaimLineItemNnIbLine`. May be used by Relay 1. */
  batchClaimLineItemNnIbLineEdge?: Maybe<BatchClaimLineItemNnIbLinesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `NnIbLine` that is related to this `BatchClaimLineItemNnIbLine`. */
  nnIbLine?: Maybe<NnIbLine>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimLineItemNnIbLine` mutation. */
export type CreateBatchClaimLineItemNnIbLinePayloadbatchClaimLineItemNnIbLineEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BatchClaimLineItemNnIbLinesOrderBy>>;
  };

/** The output of our create `BatchClaimLineItem` mutation. */
export type CreateBatchClaimLineItemPayload = {
  __typename?: "CreateBatchClaimLineItemPayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimLineItem`. */
  author?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimLineItem`. */
  batchClaim?: Maybe<BatchClaim>;
  /** Reads a single `BatchClaimLine` that is related to this `BatchClaimLineItem`. */
  batchClaimLine?: Maybe<BatchClaimLine>;
  /** The `BatchClaimLineItem` that was created by this mutation. */
  batchClaimLineItem?: Maybe<BatchClaimLineItem>;
  /** An edge for our `BatchClaimLineItem`. May be used by Relay 1. */
  batchClaimLineItemEdge?: Maybe<BatchClaimLineItemsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimLineItem` mutation. */
export type CreateBatchClaimLineItemPayloadbatchClaimLineItemEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimLineItemsOrderBy>>;
};

export type CreateBatchClaimLineItemValuesInput = {
  alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
  dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateOfServiceStart: Scalars["Datetime"]["input"];
  description: Scalars["String"]["input"];
  ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  itemNumber?: InputMaybe<Scalars["String"]["input"]>;
  lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
  nnIbLineValues?: InputMaybe<Array<CreateIbLineValueInput>>;
  originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  procedureCode?: InputMaybe<Scalars["String"]["input"]>;
  procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
  revCode?: InputMaybe<Scalars["String"]["input"]>;
  unitCharge: Scalars["BigFloat"]["input"];
  units: Scalars["Int"]["input"];
};

/** All input for the create `BatchClaimPayDeny` mutation. */
export type CreateBatchClaimPayDenyInput = {
  /** The `BatchClaimPayDeny` to be created by this mutation. */
  batchClaimPayDeny: BatchClaimPayDenyInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimPayDeny` mutation. */
export type CreateBatchClaimPayDenyPayload = {
  __typename?: "CreateBatchClaimPayDenyPayload";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimPayDeny`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimPayDeny` that was created by this mutation. */
  batchClaimPayDeny?: Maybe<BatchClaimPayDeny>;
  /** An edge for our `BatchClaimPayDeny`. May be used by Relay 1. */
  batchClaimPayDenyEdge?: Maybe<BatchClaimPayDeniesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimPayDeny` mutation. */
export type CreateBatchClaimPayDenyPayloadbatchClaimPayDenyEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimPayDeniesOrderBy>>;
};

/** All input for the create `BatchClaimTechDenial` mutation. */
export type CreateBatchClaimTechDenialInput = {
  /** The `BatchClaimTechDenial` to be created by this mutation. */
  batchClaimTechDenial: BatchClaimTechDenialInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BatchClaimTechDenial` mutation. */
export type CreateBatchClaimTechDenialPayload = {
  __typename?: "CreateBatchClaimTechDenialPayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimTechDenial`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimTechDenial`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimTechDenial` that was created by this mutation. */
  batchClaimTechDenial?: Maybe<BatchClaimTechDenial>;
  /** An edge for our `BatchClaimTechDenial`. May be used by Relay 1. */
  batchClaimTechDenialEdge?: Maybe<BatchClaimTechDenialsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BatchClaimTechDenial` mutation. */
export type CreateBatchClaimTechDenialPayloadbatchClaimTechDenialEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimTechDenialsOrderBy>>;
};

/** All input for the create `BucketClaim` mutation. */
export type CreateBucketClaimInput = {
  /** The `BucketClaim` to be created by this mutation. */
  bucketClaim: BucketClaimInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `BucketClaim` mutation. */
export type CreateBucketClaimPayload = {
  __typename?: "CreateBucketClaimPayload";
  /** Reads a single `AuditorBucket` that is related to this `BucketClaim`. */
  auditorBucket?: Maybe<AuditorBucket>;
  /** Reads a single `BatchClaim` that is related to this `BucketClaim`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BucketClaim` that was created by this mutation. */
  bucketClaim?: Maybe<BucketClaim>;
  /** An edge for our `BucketClaim`. May be used by Relay 1. */
  bucketClaimEdge?: Maybe<BucketClaimsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `BucketClaim` mutation. */
export type CreateBucketClaimPayloadbucketClaimEdgeArgs = {
  orderBy?: InputMaybe<Array<BucketClaimsOrderBy>>;
};

export type CreateCaseInput = {
  caseReceivedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  files?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name: Scalars["String"]["input"];
  queueId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateCitationInput = {
  annotation: CreateFileAiAnnotationInput;
  key: Scalars["String"]["input"];
};

/** authorId is intentionally omitted — the author is always the JWT user. */
export type CreateClaimAuditGroupCommentInput = {
  body: Scalars["String"]["input"];
  claimAuditGroupId: Scalars["UUID"]["input"];
};

export type CreateClaimAuditGroupCommentPayload = {
  __typename?: "CreateClaimAuditGroupCommentPayload";
  claimAuditGroupComment: ClaimAuditGroupComment;
};

/** All input for the create `ClaimAuditGroup` mutation. */
export type CreateClaimAuditGroupInput = {
  /** The `ClaimAuditGroup` to be created by this mutation. */
  claimAuditGroup: ClaimAuditGroupInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `ClaimAuditGroup` mutation. */
export type CreateClaimAuditGroupPayload = {
  __typename?: "CreateClaimAuditGroupPayload";
  /** Reads a single `AuditorUser` that is related to this `ClaimAuditGroup`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** The `ClaimAuditGroup` that was created by this mutation. */
  claimAuditGroup?: Maybe<ClaimAuditGroup>;
  /** An edge for our `ClaimAuditGroup`. May be used by Relay 1. */
  claimAuditGroupEdge?: Maybe<ClaimAuditGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Insurer` that is related to this `ClaimAuditGroup`. */
  insurer?: Maybe<Insurer>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ClaimAuditGroup` mutation. */
export type CreateClaimAuditGroupPayloadclaimAuditGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ClaimAuditGroupsOrderBy>>;
};

/** All input for the create `ClientSignOffClaimState` mutation. */
export type CreateClientSignOffClaimStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ClientSignOffClaimState` to be created by this mutation. */
  clientSignOffClaimState: ClientSignOffClaimStateInput;
};

/** The output of our create `ClientSignOffClaimState` mutation. */
export type CreateClientSignOffClaimStatePayload = {
  __typename?: "CreateClientSignOffClaimStatePayload";
  /** Reads a single `BatchClaim` that is related to this `ClientSignOffClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `ClientSignOffClaimState` that was created by this mutation. */
  clientSignOffClaimState?: Maybe<ClientSignOffClaimState>;
  /** An edge for our `ClientSignOffClaimState`. May be used by Relay 1. */
  clientSignOffClaimStateEdge?: Maybe<ClientSignOffClaimStatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ClientSignOffClaimState` mutation. */
export type CreateClientSignOffClaimStatePayloadclientSignOffClaimStateEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ClientSignOffClaimStatesOrderBy>>;
  };

export type CreateDirectoryInput = {
  name: Scalars["String"]["input"];
  parentDirectoryId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** All input for the create `DisputedFinding` mutation. */
export type CreateDisputedFindingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DisputedFinding` to be created by this mutation. */
  disputedFinding: DisputedFindingInput;
};

/** The output of our create `DisputedFinding` mutation. */
export type CreateDisputedFindingPayload = {
  __typename?: "CreateDisputedFindingPayload";
  /** Reads a single `AuditorUser` that is related to this `DisputedFinding`. */
  author?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `DisputedFinding`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `DisputedFinding` that was created by this mutation. */
  disputedFinding?: Maybe<DisputedFinding>;
  /** An edge for our `DisputedFinding`. May be used by Relay 1. */
  disputedFindingEdge?: Maybe<DisputedFindingsEdge>;
  /** Reads a single `Provider` that is related to this `DisputedFinding`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `DisputedFinding` mutation. */
export type CreateDisputedFindingPayloaddisputedFindingEdgeArgs = {
  orderBy?: InputMaybe<Array<DisputedFindingsOrderBy>>;
};

/** All input for the `createDisputedFindings` mutation. */
export type CreateDisputedFindingsInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The output of our `createDisputedFindings` mutation. */
export type CreateDisputedFindingsPayload = {
  __typename?: "CreateDisputedFindingsPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  disputedFindings?: Maybe<Array<Maybe<DisputedFinding>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `DocumentRequestCreated` mutation. */
export type CreateDocumentRequestCreatedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DocumentRequestCreated` to be created by this mutation. */
  documentRequestCreated: DocumentRequestCreatedInput;
};

/** The output of our create `DocumentRequestCreated` mutation. */
export type CreateDocumentRequestCreatedPayload = {
  __typename?: "CreateDocumentRequestCreatedPayload";
  /** Reads a single `MessageCreated` that is related to this `DocumentRequestCreated`. */
  _deprecatedMessageCreated?: Maybe<MessageCreated>;
  /** Reads a single `BatchClaim` that is related to this `DocumentRequestCreated`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `DocumentRequestCreated` that was created by this mutation. */
  documentRequestCreated?: Maybe<DocumentRequestCreated>;
  /** An edge for our `DocumentRequestCreated`. May be used by Relay 1. */
  documentRequestCreatedEdge?: Maybe<DocumentRequestCreatedsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `DocumentRequestCreated` mutation. */
export type CreateDocumentRequestCreatedPayloaddocumentRequestCreatedEdgeArgs =
  {
    orderBy?: InputMaybe<Array<DocumentRequestCreatedsOrderBy>>;
  };

/** All input for the create `DocumentUploadCreated` mutation. */
export type CreateDocumentUploadCreatedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DocumentUploadCreated` to be created by this mutation. */
  documentUploadCreated: DocumentUploadCreatedInput;
};

/** The output of our create `DocumentUploadCreated` mutation. */
export type CreateDocumentUploadCreatedPayload = {
  __typename?: "CreateDocumentUploadCreatedPayload";
  /** Reads a single `MessageCreated` that is related to this `DocumentUploadCreated`. */
  _deprecatedMessage?: Maybe<MessageCreated>;
  /** Reads a single `AuditorUser` that is related to this `DocumentUploadCreated`. */
  author?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `DocumentUploadCreated`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `DocumentUploadCreated` that was created by this mutation. */
  documentUploadCreated?: Maybe<DocumentUploadCreated>;
  /** An edge for our `DocumentUploadCreated`. May be used by Relay 1. */
  documentUploadCreatedEdge?: Maybe<DocumentUploadCreatedsEdge>;
  /** Reads a single `Provider` that is related to this `DocumentUploadCreated`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `DocumentUploadCreated` mutation. */
export type CreateDocumentUploadCreatedPayloaddocumentUploadCreatedEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentUploadCreatedsOrderBy>>;
};

/** All input for the create `DocumentationClaimState` mutation. */
export type CreateDocumentationClaimStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DocumentationClaimState` to be created by this mutation. */
  documentationClaimState: DocumentationClaimStateInput;
};

/** The output of our create `DocumentationClaimState` mutation. */
export type CreateDocumentationClaimStatePayload = {
  __typename?: "CreateDocumentationClaimStatePayload";
  /** Reads a single `AuditorUser` that is related to this `DocumentationClaimState`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `DocumentationClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `DocumentationClaimState` that was created by this mutation. */
  documentationClaimState?: Maybe<DocumentationClaimState>;
  /** An edge for our `DocumentationClaimState`. May be used by Relay 1. */
  documentationClaimStateEdge?: Maybe<DocumentationClaimStatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `DocumentationClaimState` mutation. */
export type CreateDocumentationClaimStatePayloaddocumentationClaimStateEdgeArgs =
  {
    orderBy?: InputMaybe<Array<DocumentationClaimStatesOrderBy>>;
  };

/** All input for the `createDocumentationRequests` mutation. */
export type CreateDocumentationRequestsInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our `createDocumentationRequests` mutation. */
export type CreateDocumentationRequestsPayload = {
  __typename?: "CreateDocumentationRequestsPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  documentRequestCreateds?: Maybe<Array<Maybe<DocumentRequestCreated>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `DocumentationSelectionSet` mutation. */
export type CreateDocumentationSelectionSetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DocumentationSelectionSet` to be created by this mutation. */
  documentationSelectionSet: DocumentationSelectionSetInput;
};

/** The output of our create `DocumentationSelectionSet` mutation. */
export type CreateDocumentationSelectionSetPayload = {
  __typename?: "CreateDocumentationSelectionSetPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `DocumentationSelectionSet` that was created by this mutation. */
  documentationSelectionSet?: Maybe<DocumentationSelectionSet>;
  /** An edge for our `DocumentationSelectionSet`. May be used by Relay 1. */
  documentationSelectionSetEdge?: Maybe<DocumentationSelectionSetsEdge>;
  /** Reads a single `Provider` that is related to this `DocumentationSelectionSet`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `DocumentationSelectionSet` mutation. */
export type CreateDocumentationSelectionSetPayloaddocumentationSelectionSetEdgeArgs =
  {
    orderBy?: InputMaybe<Array<DocumentationSelectionSetsOrderBy>>;
  };

/** Input for creating a new facet */
export type CreateFacetInput = {
  dataType: FacetDataType;
  description?: InputMaybe<Scalars["String"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  slug: Scalars["String"]["input"];
};

/** Input for creating a facet keyword */
export type CreateFacetKeywordInput = {
  colorCode?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  facetId: Scalars["UUID"]["input"];
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  slug: Scalars["String"]["input"];
  sortOrder?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CreateFileAiAnnotationInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  coordinates?: InputMaybe<Array<FileAnnotationCoordinatesInput>>;
  fileId: Scalars["UUID"]["input"];
  labels: Array<Scalars["String"]["input"]>;
  pageIndex: Scalars["Int"]["input"];
  sourceText?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateFileAnnotationInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  coordinates?: InputMaybe<Array<FileAnnotationCoordinatesInput>>;
  labels: Array<Scalars["String"]["input"]>;
  pageIndex: Scalars["Int"]["input"];
  sourceText?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateIbLineFindingValueInputV2 = {
  auditFindingValues: AuditFindingValuesInputV2;
  batchClaimLineItemValues: BatchClaimLineItemValuesInputV2;
};

export type CreateIbLineFindingsInput = {
  authorId: Scalars["UUID"]["input"];
  batchClaimId: Scalars["UUID"]["input"];
  batchClaimLineId: Scalars["UUID"]["input"];
  values: Array<CreateIbLineFindingsInputValue>;
};

export type CreateIbLineFindingsInputV2 = {
  authorId: Scalars["UUID"]["input"];
  /**
   * Automation that authored the finding. Required when status is
   * SUGGESTED and rejected otherwise. The (id, kind) pair must exist in
   * automation_author and not be soft-deleted; the rules and agents
   * services register themselves via upsertAutomationAuthor before
   * writing findings.
   */
  automationSource?: InputMaybe<AutomationSourceInput>;
  batchClaimId: Scalars["UUID"]["input"];
  batchClaimLineId: Scalars["UUID"]["input"];
  /**
   * Stamped onto the primary reviewed_audit_finding row written for
   * each created finding. Valid on ACCEPTED and DECLINED creates;
   * rejected on SUGGESTED (no verdict row is written for SUGGESTED,
   * so there is nothing to attach the rationale to). Never applied
   * to side-effect auto-decline rows on prior findings sharing the
   * same IB line.
   */
  rationale?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Optional status to attach to the new findings:
   * - SUGGESTED: write the audit_finding with needs_review=true and
   *   skip the reviewed_audit_finding insert.
   * - DECLINED: insert a reviewed_audit_finding row with accepted=false.
   * - ACCEPTED (or omitted): insert a reviewed_audit_finding row with
   *   accepted=true. Any prior ACCEPTED finding on the same IB line
   *   is auto-declined; see autoDeclinedFindings on the output type.
   */
  status?: InputMaybe<FindingStatus>;
  values: Array<CreateIbLineFindingValueInputV2>;
};

export type CreateIbLineFindingsInputValue = {
  auditFindingValues: CreateAuditFindingValuesInput;
  batchClaimLineItemValues: CreateBatchClaimLineItemValuesInput;
};

export type CreateIbLineFindingsOutputV2 = {
  __typename?: "CreateIbLineFindingsOutputV2";
  auditFindings: Array<FindingV2>;
  /**
   * Findings auto-declined to preserve the one-accepted-per-item
   * invariant when a new ACCEPTED finding lands on a line with an
   * existing accepted finding. Empty for SUGGESTED/DECLINED.
   */
  autoDeclinedFindings: Array<FindingV2>;
};

export type CreateIbLineValueInput = {
  fingerprint: Scalars["UUID"]["input"];
  s3Key: Scalars["String"]["input"];
};

/** All input for the create `InsurerUser` mutation. */
export type CreateInsurerUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `InsurerUser` to be created by this mutation. */
  insurerUser: InsurerUserInput;
};

/** The output of our create `InsurerUser` mutation. */
export type CreateInsurerUserPayload = {
  __typename?: "CreateInsurerUserPayload";
  /** Reads a single `AuditorUser` that is related to this `InsurerUser`. */
  auditorUser?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Insurer` that is related to this `InsurerUser`. */
  insurer?: Maybe<Insurer>;
  /** The `InsurerUser` that was created by this mutation. */
  insurerUser?: Maybe<InsurerUser>;
  /** An edge for our `InsurerUser`. May be used by Relay 1. */
  insurerUserEdge?: Maybe<InsurerUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `InsurerUser` mutation. */
export type CreateInsurerUserPayloadinsurerUserEdgeArgs = {
  orderBy?: InputMaybe<Array<InsurerUsersOrderBy>>;
};

/** All input for the create `InvoiceClaimState` mutation. */
export type CreateInvoiceClaimStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `InvoiceClaimState` to be created by this mutation. */
  invoiceClaimState: InvoiceClaimStateInput;
};

/** The output of our create `InvoiceClaimState` mutation. */
export type CreateInvoiceClaimStatePayload = {
  __typename?: "CreateInvoiceClaimStatePayload";
  /** Reads a single `BatchClaim` that is related to this `InvoiceClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `InvoiceClaimState` that was created by this mutation. */
  invoiceClaimState?: Maybe<InvoiceClaimState>;
  /** An edge for our `InvoiceClaimState`. May be used by Relay 1. */
  invoiceClaimStateEdge?: Maybe<InvoiceClaimStatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `InvoiceClaimState` mutation. */
export type CreateInvoiceClaimStatePayloadinvoiceClaimStateEdgeArgs = {
  orderBy?: InputMaybe<Array<InvoiceClaimStatesOrderBy>>;
};

export type CreateLifecycleRoleInput = {
  /**
   * Derive tenant from this claim (BatchClaim.insurer_id). Optional if
   * insurerId is set or the user belongs to exactly one insurer.
   */
  claimId?: InputMaybe<Scalars["UUID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Explicit tenant (BatchClaim.insurerId). Optional if claimId is set or
   * the user belongs to exactly one insurer.
   */
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  name: Scalars["String"]["input"];
};

/** All input for the create `MessageCreated` mutation. */
export type CreateMessageCreatedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `MessageCreated` to be created by this mutation. */
  messageCreated: MessageCreatedInput;
};

/** The output of our create `MessageCreated` mutation. */
export type CreateMessageCreatedPayload = {
  __typename?: "CreateMessageCreatedPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DocumentRequestCreated` that is related to this `MessageCreated`. */
  documentRequestCreated?: Maybe<DocumentRequestCreated>;
  /** Reads a single `DocumentUploadCreated` that is related to this `MessageCreated`. */
  documentUploadCreated?: Maybe<DocumentUploadCreated>;
  /** The `MessageCreated` that was created by this mutation. */
  messageCreated?: Maybe<MessageCreated>;
  /** An edge for our `MessageCreated`. May be used by Relay 1. */
  messageCreatedEdge?: Maybe<MessageCreatedsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AuditorUser` that is related to this `MessageCreated`. */
  senderUser?: Maybe<AuditorUser>;
};

/** The output of our create `MessageCreated` mutation. */
export type CreateMessageCreatedPayloadmessageCreatedEdgeArgs = {
  orderBy?: InputMaybe<Array<MessageCreatedsOrderBy>>;
};

/** All input for the create `MessageSent` mutation. */
export type CreateMessageSentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `MessageSent` to be created by this mutation. */
  messageSent: MessageSentInput;
};

/** The output of our create `MessageSent` mutation. */
export type CreateMessageSentPayload = {
  __typename?: "CreateMessageSentPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `MessageCreated` that is related to this `MessageSent`. */
  message?: Maybe<MessageCreated>;
  /** The `MessageSent` that was created by this mutation. */
  messageSent?: Maybe<MessageSent>;
  /** An edge for our `MessageSent`. May be used by Relay 1. */
  messageSentEdge?: Maybe<MessageSentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `AuditorUser` that is related to this `MessageSent`. */
  recipientUser?: Maybe<AuditorUser>;
  /** Reads a single `MessageSent` that is related to this `MessageSent`. */
  responseToMessageSent?: Maybe<MessageSent>;
  /** Reads a single `MessageSent` that is related to this `MessageSent`. */
  seedMessageSent?: Maybe<MessageSent>;
};

/** The output of our create `MessageSent` mutation. */
export type CreateMessageSentPayloadmessageSentEdgeArgs = {
  orderBy?: InputMaybe<Array<MessageSentsOrderBy>>;
};

/** All input for the create `NegotiationClaimState` mutation. */
export type CreateNegotiationClaimStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `NegotiationClaimState` to be created by this mutation. */
  negotiationClaimState: NegotiationClaimStateInput;
};

/** The output of our create `NegotiationClaimState` mutation. */
export type CreateNegotiationClaimStatePayload = {
  __typename?: "CreateNegotiationClaimStatePayload";
  /** Reads a single `BatchClaim` that is related to this `NegotiationClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `NegotiationClaimState` that was created by this mutation. */
  negotiationClaimState?: Maybe<NegotiationClaimState>;
  /** An edge for our `NegotiationClaimState`. May be used by Relay 1. */
  negotiationClaimStateEdge?: Maybe<NegotiationClaimStatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `NegotiationClaimState` mutation. */
export type CreateNegotiationClaimStatePayloadnegotiationClaimStateEdgeArgs = {
  orderBy?: InputMaybe<Array<NegotiationClaimStatesOrderBy>>;
};

/** All input for the create `NnIbLine` mutation. */
export type CreateNnIbLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `NnIbLine` to be created by this mutation. */
  nnIbLine: NnIbLineInput;
};

/** The output of our create `NnIbLine` mutation. */
export type CreateNnIbLinePayload = {
  __typename?: "CreateNnIbLinePayload";
  /** Reads a single `AuditorUser` that is related to this `NnIbLine`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `NnIbLine` that was created by this mutation. */
  nnIbLine?: Maybe<NnIbLine>;
  /** An edge for our `NnIbLine`. May be used by Relay 1. */
  nnIbLineEdge?: Maybe<NnIbLinesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `NnIbLine` mutation. */
export type CreateNnIbLinePayloadnnIbLineEdgeArgs = {
  orderBy?: InputMaybe<Array<NnIbLinesOrderBy>>;
};

/** All input for the create `OnHoldClaimState` mutation. */
export type CreateOnHoldClaimStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `OnHoldClaimState` to be created by this mutation. */
  onHoldClaimState: OnHoldClaimStateInput;
};

/** The output of our create `OnHoldClaimState` mutation. */
export type CreateOnHoldClaimStatePayload = {
  __typename?: "CreateOnHoldClaimStatePayload";
  /** Reads a single `BatchClaim` that is related to this `OnHoldClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `OnHoldClaimState` that was created by this mutation. */
  onHoldClaimState?: Maybe<OnHoldClaimState>;
  /** An edge for our `OnHoldClaimState`. May be used by Relay 1. */
  onHoldClaimStateEdge?: Maybe<OnHoldClaimStatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `OnHoldClaimState` mutation. */
export type CreateOnHoldClaimStatePayloadonHoldClaimStateEdgeArgs = {
  orderBy?: InputMaybe<Array<OnHoldClaimStatesOrderBy>>;
};

/** All input for the create `ProviderSignOffClaimState` mutation. */
export type CreateProviderSignOffClaimStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ProviderSignOffClaimState` to be created by this mutation. */
  providerSignOffClaimState: ProviderSignOffClaimStateInput;
};

/** The output of our create `ProviderSignOffClaimState` mutation. */
export type CreateProviderSignOffClaimStatePayload = {
  __typename?: "CreateProviderSignOffClaimStatePayload";
  /** Reads a single `BatchClaim` that is related to this `ProviderSignOffClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `ProviderSignOffClaimState` that was created by this mutation. */
  providerSignOffClaimState?: Maybe<ProviderSignOffClaimState>;
  /** An edge for our `ProviderSignOffClaimState`. May be used by Relay 1. */
  providerSignOffClaimStateEdge?: Maybe<ProviderSignOffClaimStatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProviderSignOffClaimState` mutation. */
export type CreateProviderSignOffClaimStatePayloadproviderSignOffClaimStateEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ProviderSignOffClaimStatesOrderBy>>;
  };

/** All input for the create `ProviderUserFacility` mutation. */
export type CreateProviderUserFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ProviderUserFacility` to be created by this mutation. */
  providerUserFacility: ProviderUserFacilityInput;
};

/** The output of our create `ProviderUserFacility` mutation. */
export type CreateProviderUserFacilityPayload = {
  __typename?: "CreateProviderUserFacilityPayload";
  /** Reads a single `AuditorUser` that is related to this `ProviderUserFacility`. */
  auditorUser?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Provider` that is related to this `ProviderUserFacility`. */
  provider?: Maybe<Provider>;
  /** The `ProviderUserFacility` that was created by this mutation. */
  providerUserFacility?: Maybe<ProviderUserFacility>;
  /** An edge for our `ProviderUserFacility`. May be used by Relay 1. */
  providerUserFacilityEdge?: Maybe<ProviderUserFacilitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `ProviderUserFacility` mutation. */
export type CreateProviderUserFacilityPayloadproviderUserFacilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderUserFacilitiesOrderBy>>;
};

/** All input for the create `QaClaimStateRow` mutation. */
export type CreateQaClaimStateRowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `QaClaimStateRow` to be created by this mutation. */
  qaClaimStateRow: QaClaimStateRowInput;
};

/** The output of our create `QaClaimStateRow` mutation. */
export type CreateQaClaimStateRowPayload = {
  __typename?: "CreateQaClaimStateRowPayload";
  /** Reads a single `AuditorUser` that is related to this `QaClaimStateRow`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `QaClaimStateRow`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `QaClaimStateRow` that was created by this mutation. */
  qaClaimStateRow?: Maybe<QaClaimStateRow>;
  /** An edge for our `QaClaimStateRow`. May be used by Relay 1. */
  qaClaimStateRowEdge?: Maybe<QaClaimStateRowsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our create `QaClaimStateRow` mutation. */
export type CreateQaClaimStateRowPayloadqaClaimStateRowEdgeArgs = {
  orderBy?: InputMaybe<Array<QaClaimStateRowsOrderBy>>;
};

/** All input for the create `Queue` mutation. */
export type CreateQueueInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `Queue` to be created by this mutation. */
  queue: QueueInput;
};

/** The output of our create `Queue` mutation. */
export type CreateQueuePayload = {
  __typename?: "CreateQueuePayload";
  /** Reads a single `AuditorUser` that is related to this `Queue`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Queue` that was created by this mutation. */
  queue?: Maybe<Queue>;
  /** An edge for our `Queue`. May be used by Relay 1. */
  queueEdge?: Maybe<QueuesEdge>;
};

/** The output of our create `Queue` mutation. */
export type CreateQueuePayloadqueueEdgeArgs = {
  orderBy?: InputMaybe<Array<QueuesOrderBy>>;
};

/** All input for the `createReportedClaims` mutation. */
export type CreateReportedClaimsInput = {
  claims?: InputMaybe<Array<InputMaybe<ReportedClaimInput>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our `createReportedClaims` mutation. */
export type CreateReportedClaimsPayload = {
  __typename?: "CreateReportedClaimsPayload";
  boolean?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `createReportedFindings` mutation. */
export type CreateReportedFindingsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  findings?: InputMaybe<Array<InputMaybe<ReportedFindingInput>>>;
};

/** The output of our `createReportedFindings` mutation. */
export type CreateReportedFindingsPayload = {
  __typename?: "CreateReportedFindingsPayload";
  boolean?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `ReviewedAuditFinding` mutation. */
export type CreateReviewedAuditFindingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ReviewedAuditFinding` to be created by this mutation. */
  reviewedAuditFinding: ReviewedAuditFindingInput;
};

/** The output of our create `ReviewedAuditFinding` mutation. */
export type CreateReviewedAuditFindingPayload = {
  __typename?: "CreateReviewedAuditFindingPayload";
  /** Reads a single `AuditFinding` that is related to this `ReviewedAuditFinding`. */
  auditFinding?: Maybe<AuditFinding>;
  /** Reads a single `AuditorUser` that is related to this `ReviewedAuditFinding`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ReviewedAuditFinding` that was created by this mutation. */
  reviewedAuditFinding?: Maybe<ReviewedAuditFinding>;
  /** An edge for our `ReviewedAuditFinding`. May be used by Relay 1. */
  reviewedAuditFindingEdge?: Maybe<ReviewedAuditFindingsEdge>;
};

/** The output of our create `ReviewedAuditFinding` mutation. */
export type CreateReviewedAuditFindingPayloadreviewedAuditFindingEdgeArgs = {
  orderBy?: InputMaybe<Array<ReviewedAuditFindingsOrderBy>>;
};

/** All input for the create `S3AuditDocumentation` mutation. */
export type CreateS3AuditDocumentationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `S3AuditDocumentation` to be created by this mutation. */
  s3AuditDocumentation: S3AuditDocumentationInput;
};

/** The output of our create `S3AuditDocumentation` mutation. */
export type CreateS3AuditDocumentationPayload = {
  __typename?: "CreateS3AuditDocumentationPayload";
  /** Reads a single `BatchClaim` that is related to this `S3AuditDocumentation`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `S3AuditDocumentation` that was created by this mutation. */
  s3AuditDocumentation?: Maybe<S3AuditDocumentation>;
  /** An edge for our `S3AuditDocumentation`. May be used by Relay 1. */
  s3AuditDocumentationEdge?: Maybe<S3AuditDocumentationsEdge>;
};

/** The output of our create `S3AuditDocumentation` mutation. */
export type CreateS3AuditDocumentationPayloads3AuditDocumentationEdgeArgs = {
  orderBy?: InputMaybe<Array<S3AuditDocumentationsOrderBy>>;
};

/** All input for the create `SsoDomainIdentityProvider` mutation. */
export type CreateSsoDomainIdentityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `SsoDomainIdentityProvider` to be created by this mutation. */
  ssoDomainIdentityProvider: SsoDomainIdentityProviderInput;
};

/** The output of our create `SsoDomainIdentityProvider` mutation. */
export type CreateSsoDomainIdentityProviderPayload = {
  __typename?: "CreateSsoDomainIdentityProviderPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SsoDomainIdentityProvider` that was created by this mutation. */
  ssoDomainIdentityProvider?: Maybe<SsoDomainIdentityProvider>;
  /** An edge for our `SsoDomainIdentityProvider`. May be used by Relay 1. */
  ssoDomainIdentityProviderEdge?: Maybe<SsoDomainIdentityProvidersEdge>;
};

/** The output of our create `SsoDomainIdentityProvider` mutation. */
export type CreateSsoDomainIdentityProviderPayloadssoDomainIdentityProviderEdgeArgs =
  {
    orderBy?: InputMaybe<Array<SsoDomainIdentityProvidersOrderBy>>;
  };

export type CreateUbClaimFindingsInput = {
  auditFindingValues: CreateAuditFindingValuesInput;
  authorId: Scalars["UUID"]["input"];
  batchClaimIds: Array<Scalars["UUID"]["input"]>;
};

export type CreateUbClaimLineFindingsInput = {
  auditFindingValues: CreateAuditFindingValuesInput;
  authorId: Scalars["UUID"]["input"];
  batchClaimId: Scalars["UUID"]["input"];
  batchClaimLineIds: Array<Scalars["UUID"]["input"]>;
};

export type CreateUserInput = {
  email: Scalars["String"]["input"];
  facilities?: InputMaybe<Array<Scalars["String"]["input"]>>;
  firstName: Scalars["String"]["input"];
  insurers?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  userType: UserTypeEnum;
  username: Scalars["String"]["input"];
};

/** All input for the create `UserInviteCreated` mutation. */
export type CreateUserInviteCreatedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `UserInviteCreated` to be created by this mutation. */
  userInviteCreated: UserInviteCreatedInput;
};

/** The output of our create `UserInviteCreated` mutation. */
export type CreateUserInviteCreatedPayload = {
  __typename?: "CreateUserInviteCreatedPayload";
  /** Reads a single `AuditorUser` that is related to this `UserInviteCreated`. */
  auditorUser?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `MessageCreated` that is related to this `UserInviteCreated`. */
  message?: Maybe<MessageCreated>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserInviteCreated` that was created by this mutation. */
  userInviteCreated?: Maybe<UserInviteCreated>;
  /** An edge for our `UserInviteCreated`. May be used by Relay 1. */
  userInviteCreatedEdge?: Maybe<UserInviteCreatedsEdge>;
};

/** The output of our create `UserInviteCreated` mutation. */
export type CreateUserInviteCreatedPayloaduserInviteCreatedEdgeArgs = {
  orderBy?: InputMaybe<Array<UserInviteCreatedsOrderBy>>;
};

export type CreateUserOutput = {
  __typename?: "CreateUserOutput";
  asyncUserMembershipUpdateTriggered?: Maybe<Scalars["Boolean"]["output"]>;
  user: AuditorUser;
};

/** All input for the create `WorkflowClaimState` mutation. */
export type CreateWorkflowClaimStateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WorkflowClaimState` to be created by this mutation. */
  workflowClaimState: WorkflowClaimStateInput;
};

/** The output of our create `WorkflowClaimState` mutation. */
export type CreateWorkflowClaimStatePayload = {
  __typename?: "CreateWorkflowClaimStatePayload";
  /** Reads a single `BatchClaim` that is related to this `WorkflowClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WorkflowClaimState` that was created by this mutation. */
  workflowClaimState?: Maybe<WorkflowClaimState>;
  /** An edge for our `WorkflowClaimState`. May be used by Relay 1. */
  workflowClaimStateEdge?: Maybe<WorkflowClaimStatesEdge>;
};

/** The output of our create `WorkflowClaimState` mutation. */
export type CreateWorkflowClaimStatePayloadworkflowClaimStateEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowClaimStatesOrderBy>>;
};

/**
 * An automation (rule or agent) credited with authoring a Finding.
 * name is read live from automation_author so renames propagate on
 * the next read of every finding the automation authored.
 */
export type CreatedByAutomation = {
  __typename?: "CreatedByAutomation";
  id: Scalars["UUID"]["output"];
  kind: AutomationKindEnum;
  name: Scalars["String"]["output"];
};

/**
 * A human auditor credited with authoring a Finding. Sourced from
 * auditor_user.
 */
export type CreatedByUser = {
  __typename?: "CreatedByUser";
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  lastName: Scalars["String"]["output"];
  userType: UserType;
};

export type Csv = {
  __typename?: "Csv";
  header?: Maybe<CsvRow>;
  id: Scalars["UUID"]["output"];
  rows: Array<Scalars["JSON"]["output"]>;
  s3Key: Scalars["String"]["output"];
};

export type CsvRow = {
  __typename?: "CsvRow";
  values: Array<Maybe<Scalars["String"]["output"]>>;
};

/** Right pane: claim counts per lifecycle phase (labelOrder + name). */
export type DashboardPhaseSummary = {
  __typename?: "DashboardPhaseSummary";
  claims: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  labelOrder: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
};

export type DashboardSummary = {
  __typename?: "DashboardSummary";
  allowedAmount: Scalars["Float"]["output"];
  billedAmount: Scalars["Float"]["output"];
  /**
   * Total claims in the scoped set. Scope is the role claim pool when input.filter
   * is omitted, or claims matching BatchClaimFilter when a filter is provided.
   * Currently equal to claimsMatchingCriteria.
   */
  claims: Scalars["Int"]["output"];
  claimsAwaitingDocumentation: Scalars["Int"]["output"];
  /** Claims with documentation_claim_state DOCUMENTS_RECEIVED (awaiting ingestion). */
  claimsAwaitingIngestion: Scalars["Int"]["output"];
  /**
   * Claims in the scoped set (see claims). Use the same BatchClaimFilter as the
   * claim table when filtering; without a filter, counts the role claim pool for type.
   */
  claimsMatchingCriteria: Scalars["Int"]["output"];
  claimsOnHold: Scalars["Int"]["output"];
  /**
   * Claims with at least one active Document blocker instance not in a closed
   * stage (CLOSED_DOCUMENT_PROCESSED, CLOSED_NO_RESPONSE).
   */
  claimsWithActiveDocumentBlockers: Scalars["Int"]["output"];
  /**
   * Claims with at least one active On Hold blocker instance not in a closed
   * stage (CLOSED_ON_HOLD_RESOLVED).
   */
  claimsWithActiveOnHoldBlockers: Scalars["Int"]["output"];
  claimsWithReports: Scalars["Int"]["output"];
  determinedSaving: Scalars["Float"]["output"];
  determinedSavingPerLife: Scalars["Float"]["output"];
  discrepantAmount: Scalars["Float"]["output"];
  lives: Scalars["Int"]["output"];
  providers: Scalars["Int"]["output"];
};

export type DashboardSummaryInput = {
  /** When set, claim-list summary counts match the filtered claim table (queue view). */
  filter?: InputMaybe<BatchClaimFilter>;
  type: DashboardSummaryType;
};

/**
 * Lifecycle stage grouping for the homepage dashboard.
 * IN_REVIEW = phases other than 'closed' (non-closed claim_facets phase pool).
 * REVIEWED = stage CLOSED_CLIENT_REPORT_SENT (reviewed claim_facets stage only).
 */
export enum DashboardSummaryType {
  IN_REVIEW = "IN_REVIEW",
  REVIEWED = "REVIEWED",
}

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["Date"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["Date"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["Date"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["Date"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["Date"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["Date"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["Date"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["Date"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["Date"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["Datetime"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["Datetime"]["input"]>>;
};

/** A filter to be used against Datetime List fields. All fields are combined with a logical ‘and.’ */
export type DatetimeListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars["Datetime"]["input"]>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars["Datetime"]["input"]>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars["Datetime"]["input"]>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars["Datetime"]["input"]>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars["Datetime"]["input"]>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<
    Array<InputMaybe<Scalars["Datetime"]["input"]>>
  >;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars["Datetime"]["input"]>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<
    Array<InputMaybe<Scalars["Datetime"]["input"]>>
  >;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars["Datetime"]["input"]>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars["Datetime"]["input"]>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars["Datetime"]["input"]>>>;
};

export type DeclineFindingsByIBLineItemIdsInput = {
  authorId: Scalars["UUID"]["input"];
  batchClaimLineItemIds: Array<Scalars["UUID"]["input"]>;
  rationale?: InputMaybe<Scalars["String"]["input"]>;
};

export type DeclineFindingsByIBLineItemIdsPayload = {
  __typename?: "DeclineFindingsByIBLineItemIdsPayload";
  latestReviews: Array<DeclinedAuditFindingReview>;
};

export type DeclinedAuditFindingReview = {
  __typename?: "DeclinedAuditFindingReview";
  accepted: Scalars["Boolean"]["output"];
  auditFindingId: Scalars["UUID"]["output"];
  auditFindingSummary?: Maybe<AuditFindingSummary>;
  authorId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  deleted: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  rationale?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

/**
 * # Overview
 * Maps the default strategy to use for a given batch claim based the insurer for the claim.
 * This table represents the beginning of a data model based around user settings, where the user (in this case the payer), could indicate something like their preferred claim computation strategy.
 */
export type DefaultStrategyByInsurer = Node & {
  __typename?: "DefaultStrategyByInsurer";
  id: Scalars["UUID"]["output"];
  /** Reads a single `Insurer` that is related to this `DefaultStrategyByInsurer`. */
  insurer?: Maybe<Insurer>;
  insurerId: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  strategy: ClaimComputationStrategyKind;
};

export type DefaultStrategyByInsurerAggregates = {
  __typename?: "DefaultStrategyByInsurerAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<DefaultStrategyByInsurerDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * A condition to be used against `DefaultStrategyByInsurer` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DefaultStrategyByInsurerCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `insurerId` field. */
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `strategy` field. */
  strategy?: InputMaybe<ClaimComputationStrategyKind>;
};

/** The fields on `defaultStrategyByInsurer` to look up the row to connect. */
export type DefaultStrategyByInsurerDefaultStrategyByInsurerInsurerIdKeyConnect =
  {
    insurerId: Scalars["UUID"]["input"];
  };

/** The fields on `defaultStrategyByInsurer` to look up the row to connect. */
export type DefaultStrategyByInsurerDefaultStrategyByInsurerPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

export type DefaultStrategyByInsurerDistinctCountAggregates = {
  __typename?: "DefaultStrategyByInsurerDistinctCountAggregates";
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of insurerId across the matching connection */
  insurerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of strategy across the matching connection */
  strategy?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `DefaultStrategyByInsurer` object types. All fields are combined with a logical ‘and.’ */
export type DefaultStrategyByInsurerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DefaultStrategyByInsurerFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `insurer` relation. */
  insurer?: InputMaybe<InsurerFilter>;
  /** Filter by the object’s `insurerId` field. */
  insurerId?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DefaultStrategyByInsurerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DefaultStrategyByInsurerFilter>>;
  /** Filter by the object’s `strategy` field. */
  strategy?: InputMaybe<ClaimComputationStrategyKindFilter>;
};

/** Grouping methods for `DefaultStrategyByInsurer` for usage during aggregation. */
export enum DefaultStrategyByInsurerGroupBy {
  STRATEGY = "STRATEGY",
}

/** Conditions for `DefaultStrategyByInsurer` aggregates. */
export type DefaultStrategyByInsurerHavingInput = {
  AND?: InputMaybe<Array<DefaultStrategyByInsurerHavingInput>>;
  OR?: InputMaybe<Array<DefaultStrategyByInsurerHavingInput>>;
};

/** Input for the nested mutation of `insurer` in the `DefaultStrategyByInsurerInput` mutation. */
export type DefaultStrategyByInsurerInsurerFkeyInput = {
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByClientAbbreviation?: InputMaybe<InsurerInsurerUniqueClientAbbreviationConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectById?: InputMaybe<InsurerInsurerPkeyConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByName?: InputMaybe<InsurerInsurerUniqueNameConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<InsurerNodeIdConnect>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByClientAbbreviation?: InputMaybe<InsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyUsingInsurerUniqueClientAbbreviationUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateById?: InputMaybe<InsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyUsingInsurerPkeyUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByName?: InputMaybe<InsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyUsingInsurerUniqueNameUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DefaultStrategyByInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `defaultStrategyByInsurer` in the `InsurerInput` mutation. */
export type DefaultStrategyByInsurerInsurerFkeyInverseInput = {
  /** The primary key(s) for `defaultStrategyByInsurer` for the far side of the relationship. */
  connectById?: InputMaybe<DefaultStrategyByInsurerDefaultStrategyByInsurerPkeyConnect>;
  /** The primary key(s) for `defaultStrategyByInsurer` for the far side of the relationship. */
  connectByInsurerId?: InputMaybe<DefaultStrategyByInsurerDefaultStrategyByInsurerInsurerIdKeyConnect>;
  /** The primary key(s) for `defaultStrategyByInsurer` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<DefaultStrategyByInsurerNodeIdConnect>;
  /** The primary key(s) and patch data for `defaultStrategyByInsurer` for the far side of the relationship. */
  updateById?: InputMaybe<DefaultStrategyByInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyUsingDefaultStrategyByInsurerPkeyUpdate>;
  /** The primary key(s) and patch data for `defaultStrategyByInsurer` for the far side of the relationship. */
  updateByInsurerId?: InputMaybe<DefaultStrategyByInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyUsingDefaultStrategyByInsurerInsurerIdKeyUpdate>;
  /** The primary key(s) and patch data for `defaultStrategyByInsurer` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyNodeIdUpdate>;
};

/** The globally unique `ID` look up for the row to connect. */
export type DefaultStrategyByInsurerNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `defaultStrategyByInsurer` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type DefaultStrategyByInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `insurer` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: InsurerPatch;
  };

/** The fields on `defaultStrategyByInsurer` to look up the row to update. */
export type DefaultStrategyByInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyUsingDefaultStrategyByInsurerInsurerIdKeyUpdate =
  {
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `defaultStrategyByInsurer` being updated. */
    patch: updateDefaultStrategyByInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyPatch;
  };

/** The fields on `defaultStrategyByInsurer` to look up the row to update. */
export type DefaultStrategyByInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyUsingDefaultStrategyByInsurerPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `defaultStrategyByInsurer` being updated. */
    patch: updateDefaultStrategyByInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyPatch;
  };

/** Represents an update to a `DefaultStrategyByInsurer`. Fields that are set will be updated. */
export type DefaultStrategyByInsurerPatch = {
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInput>;
};

/** A connection to a list of `DefaultStrategyByInsurer` values. */
export type DefaultStrategyByInsurersConnection = {
  __typename?: "DefaultStrategyByInsurersConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<DefaultStrategyByInsurerAggregates>;
  /** A list of edges which contains the `DefaultStrategyByInsurer` and cursor to aid in pagination. */
  edges: Array<DefaultStrategyByInsurersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<DefaultStrategyByInsurerAggregates>>;
  /** A list of `DefaultStrategyByInsurer` objects. */
  nodes: Array<Maybe<DefaultStrategyByInsurer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DefaultStrategyByInsurer` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `DefaultStrategyByInsurer` values. */
export type DefaultStrategyByInsurersConnectiongroupedAggregatesArgs = {
  groupBy: Array<DefaultStrategyByInsurerGroupBy>;
  having?: InputMaybe<DefaultStrategyByInsurerHavingInput>;
};

/** A `DefaultStrategyByInsurer` edge in the connection. */
export type DefaultStrategyByInsurersEdge = {
  __typename?: "DefaultStrategyByInsurersEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DefaultStrategyByInsurer` at the end of the edge. */
  node?: Maybe<DefaultStrategyByInsurer>;
};

/** Methods to use when ordering `DefaultStrategyByInsurer`. */
export enum DefaultStrategyByInsurersOrderBy {
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ID_ASC = "INSURER_BY_INSURER_ID__CLIENT_ID_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ID_DESC = "INSURER_BY_INSURER_ID__CLIENT_ID_DESC",
  INSURER_BY_INSURER_ID__CREATED_AT_ASC = "INSURER_BY_INSURER_ID__CREATED_AT_ASC",
  INSURER_BY_INSURER_ID__CREATED_AT_DESC = "INSURER_BY_INSURER_ID__CREATED_AT_DESC",
  INSURER_BY_INSURER_ID__ID_ASC = "INSURER_BY_INSURER_ID__ID_ASC",
  INSURER_BY_INSURER_ID__ID_DESC = "INSURER_BY_INSURER_ID__ID_DESC",
  INSURER_BY_INSURER_ID__NAME_ASC = "INSURER_BY_INSURER_ID__NAME_ASC",
  INSURER_BY_INSURER_ID__NAME_DESC = "INSURER_BY_INSURER_ID__NAME_DESC",
  INSURER_BY_INSURER_ID__UPDATED_AT_ASC = "INSURER_BY_INSURER_ID__UPDATED_AT_ASC",
  INSURER_BY_INSURER_ID__UPDATED_AT_DESC = "INSURER_BY_INSURER_ID__UPDATED_AT_DESC",
  INSURER_ID_ASC = "INSURER_ID_ASC",
  INSURER_ID_DESC = "INSURER_ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  STRATEGY_ASC = "STRATEGY_ASC",
  STRATEGY_DESC = "STRATEGY_DESC",
}

/** All input for the `deleteAuditorBucketByNodeId` mutation. */
export type DeleteAuditorBucketByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `AuditorBucket` to be deleted. */
  nodeId: Scalars["ID"]["input"];
};

/** All input for the `deleteAuditorBucket` mutation. */
export type DeleteAuditorBucketInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `AuditorBucket` mutation. */
export type DeleteAuditorBucketPayload = {
  __typename?: "DeleteAuditorBucketPayload";
  /** Reads a single `AuditorUser` that is related to this `AuditorBucket`. */
  assignee?: Maybe<AuditorUser>;
  /** The `AuditorBucket` that was deleted by this mutation. */
  auditorBucket?: Maybe<AuditorBucket>;
  /** An edge for our `AuditorBucket`. May be used by Relay 1. */
  auditorBucketEdge?: Maybe<AuditorBucketsEdge>;
  /** Reads a single `AuditorUser` that is related to this `AuditorBucket`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  deletedAuditorBucketNodeId?: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `Insurer` that is related to this `AuditorBucket`. */
  insurer?: Maybe<Insurer>;
  /** Reads a single `Provider` that is related to this `AuditorBucket`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `AuditorBucket` mutation. */
export type DeleteAuditorBucketPayloadauditorBucketEdgeArgs = {
  orderBy?: InputMaybe<Array<AuditorBucketsOrderBy>>;
};

/** All input for the `deleteBatchClaimAppealedByBatchClaimId` mutation. */
export type DeleteBatchClaimAppealedByBatchClaimIdInput = {
  batchClaimId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** All input for the `deleteBatchClaimAppealedByNodeId` mutation. */
export type DeleteBatchClaimAppealedByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `BatchClaimAppealed` to be deleted. */
  nodeId: Scalars["ID"]["input"];
};

/** All input for the `deleteBatchClaimAppealed` mutation. */
export type DeleteBatchClaimAppealedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `BatchClaimAppealed` mutation. */
export type DeleteBatchClaimAppealedPayload = {
  __typename?: "DeleteBatchClaimAppealedPayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimAppealed`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAppealed`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimAppealed` that was deleted by this mutation. */
  batchClaimAppealed?: Maybe<BatchClaimAppealed>;
  /** An edge for our `BatchClaimAppealed`. May be used by Relay 1. */
  batchClaimAppealedEdge?: Maybe<BatchClaimAppealedsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  deletedBatchClaimAppealedNodeId?: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BatchClaimAppealed` mutation. */
export type DeleteBatchClaimAppealedPayloadbatchClaimAppealedEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimAppealedsOrderBy>>;
};

/** All input for the `deleteBatchClaimTechDenialByBatchClaimId` mutation. */
export type DeleteBatchClaimTechDenialByBatchClaimIdInput = {
  batchClaimId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** All input for the `deleteBatchClaimTechDenialByNodeId` mutation. */
export type DeleteBatchClaimTechDenialByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `BatchClaimTechDenial` to be deleted. */
  nodeId: Scalars["ID"]["input"];
};

/** All input for the `deleteBatchClaimTechDenial` mutation. */
export type DeleteBatchClaimTechDenialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `BatchClaimTechDenial` mutation. */
export type DeleteBatchClaimTechDenialPayload = {
  __typename?: "DeleteBatchClaimTechDenialPayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimTechDenial`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimTechDenial`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimTechDenial` that was deleted by this mutation. */
  batchClaimTechDenial?: Maybe<BatchClaimTechDenial>;
  /** An edge for our `BatchClaimTechDenial`. May be used by Relay 1. */
  batchClaimTechDenialEdge?: Maybe<BatchClaimTechDenialsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  deletedBatchClaimTechDenialNodeId?: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `BatchClaimTechDenial` mutation. */
export type DeleteBatchClaimTechDenialPayloadbatchClaimTechDenialEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimTechDenialsOrderBy>>;
};

/** All input for the `deleteClaimAuditGroupByName` mutation. */
export type DeleteClaimAuditGroupByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

/** All input for the `deleteClaimAuditGroupByNodeId` mutation. */
export type DeleteClaimAuditGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `ClaimAuditGroup` to be deleted. */
  nodeId: Scalars["ID"]["input"];
};

/** All input for the `deleteClaimAuditGroup` mutation. */
export type DeleteClaimAuditGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `ClaimAuditGroup` mutation. */
export type DeleteClaimAuditGroupPayload = {
  __typename?: "DeleteClaimAuditGroupPayload";
  /** Reads a single `AuditorUser` that is related to this `ClaimAuditGroup`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** The `ClaimAuditGroup` that was deleted by this mutation. */
  claimAuditGroup?: Maybe<ClaimAuditGroup>;
  /** An edge for our `ClaimAuditGroup`. May be used by Relay 1. */
  claimAuditGroupEdge?: Maybe<ClaimAuditGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  deletedClaimAuditGroupNodeId?: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `Insurer` that is related to this `ClaimAuditGroup`. */
  insurer?: Maybe<Insurer>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ClaimAuditGroup` mutation. */
export type DeleteClaimAuditGroupPayloadclaimAuditGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ClaimAuditGroupsOrderBy>>;
};

/** All input for the `deleteDocumentationRequests` mutation. */
export type DeleteDocumentationRequestsInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our `deleteDocumentationRequests` mutation. */
export type DeleteDocumentationRequestsPayload = {
  __typename?: "DeleteDocumentationRequestsPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  documentRequestCreateds?: Maybe<Array<Maybe<DocumentRequestCreated>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type DeleteFindingsByAutomationSourceInput = {
  automationKind: AutomationKindEnum;
  automationSourceId: Scalars["UUID"]["input"];
};

export type DeleteFindingsByAutomationSourcePayload = {
  __typename?: "DeleteFindingsByAutomationSourcePayload";
  /** IDs of findings soft-deleted by this call. */
  deletedFindingIds: Array<Scalars["UUID"]["output"]>;
  /** IDs of findings kept — either the claim is already in audit, or an auditor has reviewed the finding. */
  retainedFindingIds: Array<Scalars["UUID"]["output"]>;
};

/** All input for the `deleteKeysFromS3Cache` mutation. */
export type DeleteKeysFromS3CacheInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  s3Keys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** The output of our `deleteKeysFromS3Cache` mutation. */
export type DeleteKeysFromS3CachePayload = {
  __typename?: "DeleteKeysFromS3CachePayload";
  boolean?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type DeleteLifecycleRoleInput = {
  id: Scalars["UUID"]["input"];
  version: Scalars["Int"]["input"];
};

/** All input for the `deleteProviderUserFacilityByNodeId` mutation. */
export type DeleteProviderUserFacilityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `ProviderUserFacility` to be deleted. */
  nodeId: Scalars["ID"]["input"];
};

/** All input for the `deleteProviderUserFacilityByProviderIdAndAuditorUserId` mutation. */
export type DeleteProviderUserFacilityByProviderIdAndAuditorUserIdInput = {
  auditorUserId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  providerId: Scalars["String"]["input"];
};

/** All input for the `deleteProviderUserFacility` mutation. */
export type DeleteProviderUserFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `ProviderUserFacility` mutation. */
export type DeleteProviderUserFacilityPayload = {
  __typename?: "DeleteProviderUserFacilityPayload";
  /** Reads a single `AuditorUser` that is related to this `ProviderUserFacility`. */
  auditorUser?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  deletedProviderUserFacilityNodeId?: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `Provider` that is related to this `ProviderUserFacility`. */
  provider?: Maybe<Provider>;
  /** The `ProviderUserFacility` that was deleted by this mutation. */
  providerUserFacility?: Maybe<ProviderUserFacility>;
  /** An edge for our `ProviderUserFacility`. May be used by Relay 1. */
  providerUserFacilityEdge?: Maybe<ProviderUserFacilitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `ProviderUserFacility` mutation. */
export type DeleteProviderUserFacilityPayloadproviderUserFacilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderUserFacilitiesOrderBy>>;
};

/** All input for the `deleteSsoDomainIdentityProviderByDomainAndEnvironmentAndTenantId` mutation. */
export type DeleteSsoDomainIdentityProviderByDomainAndEnvironmentAndTenantIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    domain: Scalars["String"]["input"];
    environment: Scalars["String"]["input"];
    tenantId: Scalars["String"]["input"];
  };

/** All input for the `deleteSsoDomainIdentityProviderByNodeId` mutation. */
export type DeleteSsoDomainIdentityProviderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `SsoDomainIdentityProvider` to be deleted. */
  nodeId: Scalars["ID"]["input"];
};

/** All input for the `deleteSsoDomainIdentityProvider` mutation. */
export type DeleteSsoDomainIdentityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `SsoDomainIdentityProvider` mutation. */
export type DeleteSsoDomainIdentityProviderPayload = {
  __typename?: "DeleteSsoDomainIdentityProviderPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  deletedSsoDomainIdentityProviderNodeId?: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SsoDomainIdentityProvider` that was deleted by this mutation. */
  ssoDomainIdentityProvider?: Maybe<SsoDomainIdentityProvider>;
  /** An edge for our `SsoDomainIdentityProvider`. May be used by Relay 1. */
  ssoDomainIdentityProviderEdge?: Maybe<SsoDomainIdentityProvidersEdge>;
};

/** The output of our delete `SsoDomainIdentityProvider` mutation. */
export type DeleteSsoDomainIdentityProviderPayloadssoDomainIdentityProviderEdgeArgs =
  {
    orderBy?: InputMaybe<Array<SsoDomainIdentityProvidersOrderBy>>;
  };

export type DeleteStageTrackerBlockerInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /**
   * Open-history id of the blocker instance to resolve.
   * Required when the claim has more than one active blocker.
   */
  blockerId?: InputMaybe<Scalars["ID"]["input"]>;
  context?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type DemoAgentArtifactInput = {
  citations?: InputMaybe<Array<DemoAgentCitationInput>>;
  inline_citations?: InputMaybe<Array<DemoAgentInlineCitationInput>>;
  markdown: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
};

export type DemoAgentCitationInput = {
  citation_key: Scalars["String"]["input"];
  document_id: Scalars["String"]["input"];
  page_index: Scalars["Int"]["input"];
};

export type DemoAgentInlineCitationAnnotationInput = {
  coordinates?: InputMaybe<Array<DemoAgentInlineCitationCoordinatesInput>>;
  file: DemoAgentInlineCitationFileInput;
  id: Scalars["String"]["input"];
  page_index: Scalars["Int"]["input"];
};

export type DemoAgentInlineCitationCoordinatesInput = {
  height: Scalars["Float"]["input"];
  left: Scalars["Float"]["input"];
  top: Scalars["Float"]["input"];
  width: Scalars["Float"]["input"];
};

export type DemoAgentInlineCitationFileInput = {
  file_name?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

export type DemoAgentInlineCitationInput = {
  annotations?: InputMaybe<Array<DemoAgentInlineCitationAnnotationInput>>;
  citation_type?: InputMaybe<InlineCitationType>;
  key: Scalars["String"]["input"];
};

export type DemoAgentInput = {
  artifacts: Array<DemoAgentArtifactInput>;
  caseId?: InputMaybe<Scalars["UUID"]["input"]>;
  caseName?: InputMaybe<Scalars["String"]["input"]>;
  caseReceivedAt?: InputMaybe<Scalars["String"]["input"]>;
  documentIds: Array<Scalars["UUID"]["input"]>;
  queueId?: InputMaybe<Scalars["UUID"]["input"]>;
  queueName?: InputMaybe<Scalars["String"]["input"]>;
  taskArtifactTemplateKey?: InputMaybe<Scalars["String"]["input"]>;
  taskDisplayLabel: Scalars["String"]["input"];
};

export type DemoAgentResult = {
  __typename?: "DemoAgentResult";
  agentArtifactId: Scalars["UUID"]["output"];
  caseId: Scalars["UUID"]["output"];
  queueId: Scalars["UUID"]["output"];
};

export type DemoPreviewAgentDocumentMappingInput = {
  newDocumentId: Scalars["UUID"]["input"];
  oldDocumentId: Scalars["UUID"]["input"];
};

export type DemoPreviewAgentInput = {
  overrides: DemoPreviewAgentOverridesInput;
  rootArtifact: Scalars["JSON"]["input"];
};

export type DemoPreviewAgentOverridesInput = {
  caseId?: InputMaybe<Scalars["UUID"]["input"]>;
  caseName?: InputMaybe<Scalars["String"]["input"]>;
  caseReceivedAt?: InputMaybe<Scalars["String"]["input"]>;
  documentMappings: Array<DemoPreviewAgentDocumentMappingInput>;
  queueId?: InputMaybe<Scalars["UUID"]["input"]>;
  queueName?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * A denial code from the v3.audit_finding_rule_type catalog. Universal
 * — not tenant-scoped. The FE buckets UB vs IB on `claimDataType`.
 */
export type DenialCode = {
  __typename?: "DenialCode";
  claimDataType: Scalars["String"]["output"];
  code: Scalars["String"]["output"];
  deprecated: Scalars["Boolean"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  displayName: Scalars["String"]["output"];
};

export type Directory = {
  __typename?: "Directory";
  archived: Scalars["Boolean"]["output"];
  createdAt: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  items: Array<FileOrDirectory>;
  modifiedAt: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  parentDirectory?: Maybe<Directory>;
  path: Array<DirectoryPathNode>;
};

export type DirectoryitemsArgs = {
  input?: InputMaybe<DirectoryItemsInput>;
};

export type DirectoryItemsInput = {
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DirectoryPathNode = {
  __typename?: "DirectoryPathNode";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type DisputedFinding = Node & {
  __typename?: "DisputedFinding";
  /** Reads a single `AuditorUser` that is related to this `DisputedFinding`. */
  author?: Maybe<AuditorUser>;
  authorId: Scalars["UUID"]["output"];
  /** Reads a single `BatchClaim` that is related to this `DisputedFinding`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  deleted: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `Provider` that is related to this `DisputedFinding`. */
  provider?: Maybe<Provider>;
  providerId: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type DisputedFindingAggregates = {
  __typename?: "DisputedFindingAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<DisputedFindingDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `DisputedFinding` object types. */
export type DisputedFindingAggregatesFilter = {
  /** Distinct count aggregate over matching `DisputedFinding` objects. */
  distinctCount?: InputMaybe<DisputedFindingDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `DisputedFinding` object to be included within the aggregate. */
  filter?: InputMaybe<DisputedFindingFilter>;
};

/** The `disputedFinding` to be created by this mutation. */
export type DisputedFindingAuthorIdFkeyDisputedFindingCreateInput = {
  auditorUserToAuthorId?: InputMaybe<DisputedFindingAuthorIdFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<DisputedFindingProviderIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `DisputedFindingInput` mutation. */
export type DisputedFindingAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DisputedFindingOnDisputedFindingForDisputedFindingAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `disputedFinding` in the `AuditorUserInput` mutation. */
export type DisputedFindingAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `disputedFinding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DisputedFindingDisputedFindingPkeyConnect>>;
  /** The primary key(s) for `disputedFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DisputedFindingNodeIdConnect>>;
  /** A `DisputedFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DisputedFindingAuthorIdFkeyDisputedFindingCreateInput>
  >;
  /** The primary key(s) and patch data for `disputedFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DisputedFindingOnDisputedFindingForDisputedFindingAuthorIdFkeyUsingDisputedFindingPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `disputedFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyNodeIdUpdate>
  >;
};

/** The `disputedFinding` to be created by this mutation. */
export type DisputedFindingBatchClaimIdFkeyDisputedFindingCreateInput = {
  auditorUserToAuthorId?: InputMaybe<DisputedFindingAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<DisputedFindingProviderIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `batchClaim` in the `DisputedFindingInput` mutation. */
export type DisputedFindingBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DisputedFindingOnDisputedFindingForDisputedFindingBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `disputedFinding` in the `BatchClaimInput` mutation. */
export type DisputedFindingBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `disputedFinding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DisputedFindingDisputedFindingPkeyConnect>>;
  /** The primary key(s) for `disputedFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DisputedFindingNodeIdConnect>>;
  /** A `DisputedFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DisputedFindingBatchClaimIdFkeyDisputedFindingCreateInput>
  >;
  /** The primary key(s) and patch data for `disputedFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DisputedFindingOnDisputedFindingForDisputedFindingBatchClaimIdFkeyUsingDisputedFindingPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `disputedFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyNodeIdUpdate>
  >;
};

export enum DisputedFindingClaimStateEnum {
  DISPUTED = "DISPUTED",
  NOT_DISPUTED = "NOT_DISPUTED",
}

/** A filter to be used against DisputedFindingClaimStateEnum fields. All fields are combined with a logical ‘and.’ */
export type DisputedFindingClaimStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DisputedFindingClaimStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DisputedFindingClaimStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DisputedFindingClaimStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DisputedFindingClaimStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DisputedFindingClaimStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DisputedFindingClaimStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DisputedFindingClaimStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DisputedFindingClaimStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DisputedFindingClaimStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DisputedFindingClaimStateEnum>>;
};

/**
 * A condition to be used against `DisputedFinding` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DisputedFindingCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The fields on `disputedFinding` to look up the row to connect. */
export type DisputedFindingDisputedFindingPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

export type DisputedFindingDistinctCountAggregateFilter = {
  authorId?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  deleted?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  providerId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type DisputedFindingDistinctCountAggregates = {
  __typename?: "DisputedFindingDistinctCountAggregates";
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of deleted across the matching connection */
  deleted?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of providerId across the matching connection */
  providerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `DisputedFinding` object types. All fields are combined with a logical ‘and.’ */
export type DisputedFindingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DisputedFindingFilter>>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DisputedFindingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DisputedFindingFilter>>;
  /** Filter by the object’s `provider` relation. */
  provider?: InputMaybe<ProviderFilter>;
  /** Filter by the object’s `providerId` field. */
  providerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `DisputedFinding` for usage during aggregation. */
export enum DisputedFindingGroupBy {
  AUTHOR_ID = "AUTHOR_ID",
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DELETED = "DELETED",
  PROVIDER_ID = "PROVIDER_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type DisputedFindingHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DisputedFindingHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `DisputedFinding` aggregates. */
export type DisputedFindingHavingInput = {
  AND?: InputMaybe<Array<DisputedFindingHavingInput>>;
  OR?: InputMaybe<Array<DisputedFindingHavingInput>>;
  average?: InputMaybe<DisputedFindingHavingAverageInput>;
  distinctCount?: InputMaybe<DisputedFindingHavingDistinctCountInput>;
  max?: InputMaybe<DisputedFindingHavingMaxInput>;
  min?: InputMaybe<DisputedFindingHavingMinInput>;
  stddevPopulation?: InputMaybe<DisputedFindingHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<DisputedFindingHavingStddevSampleInput>;
  sum?: InputMaybe<DisputedFindingHavingSumInput>;
  variancePopulation?: InputMaybe<DisputedFindingHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<DisputedFindingHavingVarianceSampleInput>;
};

export type DisputedFindingHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DisputedFindingHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DisputedFindingHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DisputedFindingHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DisputedFindingHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DisputedFindingHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DisputedFindingHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `DisputedFinding` */
export type DisputedFindingInput = {
  auditorUserToAuthorId?: InputMaybe<DisputedFindingAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<DisputedFindingProviderIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type DisputedFindingNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `disputedFinding` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type DisputedFindingOnDisputedFindingForDisputedFindingAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `disputedFinding` to look up the row to update. */
export type DisputedFindingOnDisputedFindingForDisputedFindingAuthorIdFkeyUsingDisputedFindingPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `disputedFinding` being updated. */
    patch: updateDisputedFindingOnDisputedFindingForDisputedFindingAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type DisputedFindingOnDisputedFindingForDisputedFindingBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `disputedFinding` to look up the row to update. */
export type DisputedFindingOnDisputedFindingForDisputedFindingBatchClaimIdFkeyUsingDisputedFindingPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `disputedFinding` being updated. */
    patch: updateDisputedFindingOnDisputedFindingForDisputedFindingBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type DisputedFindingOnDisputedFindingForDisputedFindingProviderIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `provider` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: ProviderPatch;
  };

/** The fields on `disputedFinding` to look up the row to update. */
export type DisputedFindingOnDisputedFindingForDisputedFindingProviderIdFkeyUsingDisputedFindingPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `disputedFinding` being updated. */
    patch: updateDisputedFindingOnDisputedFindingForDisputedFindingProviderIdFkeyPatch;
  };

/** Represents an update to a `DisputedFinding`. Fields that are set will be updated. */
export type DisputedFindingPatch = {
  auditorUserToAuthorId?: InputMaybe<DisputedFindingAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInput>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<DisputedFindingProviderIdFkeyInput>;
};

/** The `disputedFinding` to be created by this mutation. */
export type DisputedFindingProviderIdFkeyDisputedFindingCreateInput = {
  auditorUserToAuthorId?: InputMaybe<DisputedFindingAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  providerToProviderId?: InputMaybe<DisputedFindingProviderIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `provider` in the `DisputedFindingInput` mutation. */
export type DisputedFindingProviderIdFkeyInput = {
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectById?: InputMaybe<ProviderProviderPkeyConnect>;
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProviderNodeIdConnect>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateById?: InputMaybe<ProviderOnDisputedFindingForDisputedFindingProviderIdFkeyUsingProviderPkeyUpdate>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DisputedFindingOnDisputedFindingForDisputedFindingProviderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `disputedFinding` in the `ProviderInput` mutation. */
export type DisputedFindingProviderIdFkeyInverseInput = {
  /** The primary key(s) for `disputedFinding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DisputedFindingDisputedFindingPkeyConnect>>;
  /** The primary key(s) for `disputedFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DisputedFindingNodeIdConnect>>;
  /** A `DisputedFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DisputedFindingProviderIdFkeyDisputedFindingCreateInput>
  >;
  /** The primary key(s) and patch data for `disputedFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DisputedFindingOnDisputedFindingForDisputedFindingProviderIdFkeyUsingDisputedFindingPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `disputedFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<ProviderOnDisputedFindingForDisputedFindingProviderIdFkeyNodeIdUpdate>
  >;
};

/** A connection to a list of `DisputedFinding` values. */
export type DisputedFindingsConnection = {
  __typename?: "DisputedFindingsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<DisputedFindingAggregates>;
  /** A list of edges which contains the `DisputedFinding` and cursor to aid in pagination. */
  edges: Array<DisputedFindingsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<DisputedFindingAggregates>>;
  /** A list of `DisputedFinding` objects. */
  nodes: Array<Maybe<DisputedFinding>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DisputedFinding` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `DisputedFinding` values. */
export type DisputedFindingsConnectiongroupedAggregatesArgs = {
  groupBy: Array<DisputedFindingGroupBy>;
  having?: InputMaybe<DisputedFindingHavingInput>;
};

/** A `DisputedFinding` edge in the connection. */
export type DisputedFindingsEdge = {
  __typename?: "DisputedFindingsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DisputedFinding` at the end of the edge. */
  node?: Maybe<DisputedFinding>;
};

/** Methods to use when ordering `DisputedFinding`. */
export enum DisputedFindingsOrderBy {
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DELETED_ASC = "DELETED_ASC",
  DELETED_DESC = "DELETED_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__CITY_ASC = "PROVIDER_BY_PROVIDER_ID__CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__CITY_DESC = "PROVIDER_BY_PROVIDER_ID__CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC",
  PROVIDER_BY_PROVIDER_ID__ID_ASC = "PROVIDER_BY_PROVIDER_ID__ID_ASC",
  PROVIDER_BY_PROVIDER_ID__ID_DESC = "PROVIDER_BY_PROVIDER_ID__ID_DESC",
  PROVIDER_BY_PROVIDER_ID__NAME_ASC = "PROVIDER_BY_PROVIDER_ID__NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__NAME_DESC = "PROVIDER_BY_PROVIDER_ID__NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__NPI_ASC = "PROVIDER_BY_PROVIDER_ID__NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__NPI_DESC = "PROVIDER_BY_PROVIDER_ID__NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC",
  PROVIDER_BY_PROVIDER_ID__SPEC_ASC = "PROVIDER_BY_PROVIDER_ID__SPEC_ASC",
  PROVIDER_BY_PROVIDER_ID__SPEC_DESC = "PROVIDER_BY_PROVIDER_ID__SPEC_DESC",
  PROVIDER_BY_PROVIDER_ID__STATE_ASC = "PROVIDER_BY_PROVIDER_ID__STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__STATE_DESC = "PROVIDER_BY_PROVIDER_ID__STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC",
  PROVIDER_ID_ASC = "PROVIDER_ID_ASC",
  PROVIDER_ID_DESC = "PROVIDER_ID_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** Filter by Document blocker stage. Stage values are slugs from the document blocker category (e.g. "DOCUMENT_NEEDED") or stage keyword UUIDs. `isNull: true` matches claims with no active Document blocker. Claims may have multiple blocker categories active simultaneously. Use top-level `or` to combine blank with stage multi-select. */
export type DocumentBlockerStageFacetFilterInput = {
  /** Exact stage match for an active blocker of this category. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match any stage in the list (OR). Only active blockers of this category. */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** True when no active Document blocker exists on the claim. */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Stage not equal for an active blocker of this category. */
  notEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match no stage in the list. Only active blockers of this category. */
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/**
 * ### Overview
 * Stores a record of a documentation requests.
 * Feeds the cache.batch_claim_documentation_claim_state function to output to --> batch_claim_state.documentation_claim_state
 *  Has a _deleted_ boolean to specify the removal of a request.
 * This is an append only table, a documentation request is deleted by inserting a new row with deleted=true
 */
export type DocumentRequestCreated = Node & {
  __typename?: "DocumentRequestCreated";
  /** Reads a single `MessageCreated` that is related to this `DocumentRequestCreated`. */
  _deprecatedMessageCreated?: Maybe<MessageCreated>;
  _deprecatedMessageCreatedId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `BatchClaim` that is related to this `DocumentRequestCreated`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  deleted: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads and enables pagination through a set of `MessageCreated`. */
  messageCreateds: MessageCreatedsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

/**
 * ### Overview
 * Stores a record of a documentation requests.
 * Feeds the cache.batch_claim_documentation_claim_state function to output to --> batch_claim_state.documentation_claim_state
 *  Has a _deleted_ boolean to specify the removal of a request.
 * This is an append only table, a documentation request is deleted by inserting a new row with deleted=true
 */
export type DocumentRequestCreatedmessageCreatedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MessageCreatedCondition>;
  filter?: InputMaybe<MessageCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MessageCreatedsOrderBy>>;
};

export type DocumentRequestCreatedAggregates = {
  __typename?: "DocumentRequestCreatedAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<DocumentRequestCreatedDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `DocumentRequestCreated` object types. */
export type DocumentRequestCreatedAggregatesFilter = {
  /** Distinct count aggregate over matching `DocumentRequestCreated` objects. */
  distinctCount?: InputMaybe<DocumentRequestCreatedDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `DocumentRequestCreated` object to be included within the aggregate. */
  filter?: InputMaybe<DocumentRequestCreatedFilter>;
};

/** The `documentRequestCreated` to be created by this mutation. */
export type DocumentRequestCreatedBatchClaimIdFkDocumentRequestCreatedCreateInput =
  {
    _deprecatedMessageCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    messageCreatedToDeprecatedMessageCreatedId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInverseInput>;
  };

/** Input for the nested mutation of `batchClaim` in the `DocumentRequestCreatedInput` mutation. */
export type DocumentRequestCreatedBatchClaimIdFkInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkNodeIdUpdate>;
};

/** Input for the nested mutation of `documentRequestCreated` in the `BatchClaimInput` mutation. */
export type DocumentRequestCreatedBatchClaimIdFkInverseInput = {
  /** The primary key(s) for `documentRequestCreated` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DocumentRequestCreatedDocumentRequestCreatedPkeyConnect>
  >;
  /** The primary key(s) for `documentRequestCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DocumentRequestCreatedNodeIdConnect>>;
  /** A `DocumentRequestCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DocumentRequestCreatedBatchClaimIdFkDocumentRequestCreatedCreateInput>
  >;
  /** The primary key(s) and patch data for `documentRequestCreated` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkUsingDocumentRequestCreatedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `documentRequestCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `DocumentRequestCreated` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentRequestCreatedCondition = {
  /** Checks for equality with the object’s `_deprecatedMessageCreatedId` field. */
  _deprecatedMessageCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type DocumentRequestCreatedDistinctCountAggregateFilter = {
  _deprecatedMessageCreatedId?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  deleted?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type DocumentRequestCreatedDistinctCountAggregates = {
  __typename?: "DocumentRequestCreatedDistinctCountAggregates";
  /** Distinct count of _deprecatedMessageCreatedId across the matching connection */
  _deprecatedMessageCreatedId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of deleted across the matching connection */
  deleted?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

/** The fields on `documentRequestCreated` to look up the row to connect. */
export type DocumentRequestCreatedDocumentRequestCreatedPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A filter to be used against `DocumentRequestCreated` object types. All fields are combined with a logical ‘and.’ */
export type DocumentRequestCreatedFilter = {
  /** Filter by the object’s `_deprecatedMessageCreated` relation. */
  _deprecatedMessageCreated?: InputMaybe<MessageCreatedFilter>;
  /** A related `_deprecatedMessageCreated` exists. */
  _deprecatedMessageCreatedExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `_deprecatedMessageCreatedId` field. */
  _deprecatedMessageCreatedId?: InputMaybe<UUIDFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentRequestCreatedFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `messageCreateds` relation. */
  messageCreateds?: InputMaybe<DocumentRequestCreatedToManyMessageCreatedFilter>;
  /** Some related `messageCreateds` exist. */
  messageCreatedsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentRequestCreatedFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentRequestCreatedFilter>>;
};

/** Grouping methods for `DocumentRequestCreated` for usage during aggregation. */
export enum DocumentRequestCreatedGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DELETED = "DELETED",
  _DEPRECATED_MESSAGE_CREATED_ID = "_DEPRECATED_MESSAGE_CREATED_ID",
}

export type DocumentRequestCreatedHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentRequestCreatedHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `DocumentRequestCreated` aggregates. */
export type DocumentRequestCreatedHavingInput = {
  AND?: InputMaybe<Array<DocumentRequestCreatedHavingInput>>;
  OR?: InputMaybe<Array<DocumentRequestCreatedHavingInput>>;
  average?: InputMaybe<DocumentRequestCreatedHavingAverageInput>;
  distinctCount?: InputMaybe<DocumentRequestCreatedHavingDistinctCountInput>;
  max?: InputMaybe<DocumentRequestCreatedHavingMaxInput>;
  min?: InputMaybe<DocumentRequestCreatedHavingMinInput>;
  stddevPopulation?: InputMaybe<DocumentRequestCreatedHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<DocumentRequestCreatedHavingStddevSampleInput>;
  sum?: InputMaybe<DocumentRequestCreatedHavingSumInput>;
  variancePopulation?: InputMaybe<DocumentRequestCreatedHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<DocumentRequestCreatedHavingVarianceSampleInput>;
};

export type DocumentRequestCreatedHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentRequestCreatedHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentRequestCreatedHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentRequestCreatedHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentRequestCreatedHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentRequestCreatedHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentRequestCreatedHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `DocumentRequestCreated` */
export type DocumentRequestCreatedInput = {
  _deprecatedMessageCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  messageCreatedToDeprecatedMessageCreatedId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInput>;
  messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInverseInput>;
};

/** The `documentRequestCreated` to be created by this mutation. */
export type DocumentRequestCreatedMessageCreatedIdFkDocumentRequestCreatedCreateInput =
  {
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    messageCreatedToDeprecatedMessageCreatedId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInverseInput>;
  };

/** Input for the nested mutation of `messageCreated` in the `DocumentRequestCreatedInput` mutation. */
export type DocumentRequestCreatedMessageCreatedIdFkInput = {
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectById?: InputMaybe<MessageCreatedMessageCreatedPkeyConnect>;
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MessageCreatedNodeIdConnect>;
  /** A `MessageCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkMessageCreatedCreateInput>;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateById?: InputMaybe<MessageCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkUsingMessageCreatedPkeyUpdate>;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkNodeIdUpdate>;
};

/** Input for the nested mutation of `documentRequestCreated` in the `MessageCreatedInput` mutation. */
export type DocumentRequestCreatedMessageCreatedIdFkInverseInput = {
  /** The primary key(s) for `documentRequestCreated` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DocumentRequestCreatedDocumentRequestCreatedPkeyConnect>
  >;
  /** The primary key(s) for `documentRequestCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DocumentRequestCreatedNodeIdConnect>>;
  /** A `DocumentRequestCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DocumentRequestCreatedMessageCreatedIdFkDocumentRequestCreatedCreateInput>
  >;
  /** The primary key(s) and patch data for `documentRequestCreated` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkUsingDocumentRequestCreatedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `documentRequestCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<MessageCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkNodeIdUpdate>
  >;
};

/** The `messageCreated` to be created by this mutation. */
export type DocumentRequestCreatedMessageCreatedIdFkMessageCreatedCreateInput =
  {
    auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
    documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    kind: MessageCreatedKind;
    message?: InputMaybe<Scalars["String"]["input"]>;
    messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
    senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
  };

/** The globally unique `ID` look up for the row to connect. */
export type DocumentRequestCreatedNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `documentRequestCreated` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type DocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `documentRequestCreated` to look up the row to update. */
export type DocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkUsingDocumentRequestCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `documentRequestCreated` being updated. */
    patch: updateDocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type DocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `messageCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: MessageCreatedPatch;
  };

/** The fields on `documentRequestCreated` to look up the row to update. */
export type DocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkUsingDocumentRequestCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `documentRequestCreated` being updated. */
    patch: updateDocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type DocumentRequestCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `messageCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: MessageCreatedPatch;
  };

/** The fields on `documentRequestCreated` to look up the row to update. */
export type DocumentRequestCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyUsingDocumentRequestCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `documentRequestCreated` being updated. */
    patch: updateDocumentRequestCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyPatch;
  };

/** Represents an update to a `DocumentRequestCreated`. Fields that are set will be updated. */
export type DocumentRequestCreatedPatch = {
  _deprecatedMessageCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInput>;
  messageCreatedToDeprecatedMessageCreatedId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInput>;
  messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInverseInput>;
};

/** A filter to be used against many `MessageCreated` object types. All fields are combined with a logical ‘and.’ */
export type DocumentRequestCreatedToManyMessageCreatedFilter = {
  /** Aggregates across related `MessageCreated` match the filter criteria. */
  aggregates?: InputMaybe<MessageCreatedAggregatesFilter>;
  /** Every related `MessageCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MessageCreatedFilter>;
  /** No related `MessageCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MessageCreatedFilter>;
  /** Some related `MessageCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MessageCreatedFilter>;
};

/** A connection to a list of `DocumentRequestCreated` values. */
export type DocumentRequestCreatedsConnection = {
  __typename?: "DocumentRequestCreatedsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<DocumentRequestCreatedAggregates>;
  /** A list of edges which contains the `DocumentRequestCreated` and cursor to aid in pagination. */
  edges: Array<DocumentRequestCreatedsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<DocumentRequestCreatedAggregates>>;
  /** A list of `DocumentRequestCreated` objects. */
  nodes: Array<Maybe<DocumentRequestCreated>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentRequestCreated` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `DocumentRequestCreated` values. */
export type DocumentRequestCreatedsConnectiongroupedAggregatesArgs = {
  groupBy: Array<DocumentRequestCreatedGroupBy>;
  having?: InputMaybe<DocumentRequestCreatedHavingInput>;
};

/** A `DocumentRequestCreated` edge in the connection. */
export type DocumentRequestCreatedsEdge = {
  __typename?: "DocumentRequestCreatedsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DocumentRequestCreated` at the end of the edge. */
  node?: Maybe<DocumentRequestCreated>;
};

/** Methods to use when ordering `DocumentRequestCreated`. */
export enum DocumentRequestCreatedsOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DELETED_ASC = "DELETED_ASC",
  DELETED_DESC = "DELETED_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  MESSAGE_CREATEDS_AVERAGE_CREATED_AT_ASC = "MESSAGE_CREATEDS_AVERAGE_CREATED_AT_ASC",
  MESSAGE_CREATEDS_AVERAGE_CREATED_AT_DESC = "MESSAGE_CREATEDS_AVERAGE_CREATED_AT_DESC",
  MESSAGE_CREATEDS_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_AVERAGE_ID_ASC = "MESSAGE_CREATEDS_AVERAGE_ID_ASC",
  MESSAGE_CREATEDS_AVERAGE_ID_DESC = "MESSAGE_CREATEDS_AVERAGE_ID_DESC",
  MESSAGE_CREATEDS_AVERAGE_KIND_ASC = "MESSAGE_CREATEDS_AVERAGE_KIND_ASC",
  MESSAGE_CREATEDS_AVERAGE_KIND_DESC = "MESSAGE_CREATEDS_AVERAGE_KIND_DESC",
  MESSAGE_CREATEDS_AVERAGE_MESSAGE_ASC = "MESSAGE_CREATEDS_AVERAGE_MESSAGE_ASC",
  MESSAGE_CREATEDS_AVERAGE_MESSAGE_DESC = "MESSAGE_CREATEDS_AVERAGE_MESSAGE_DESC",
  MESSAGE_CREATEDS_AVERAGE_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_AVERAGE_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_AVERAGE_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_AVERAGE_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_BY_DOCUMENT_REQUEST_CREATED_ID__COUNT_ASC = "MESSAGE_CREATEDS_BY_DOCUMENT_REQUEST_CREATED_ID__COUNT_ASC",
  MESSAGE_CREATEDS_BY_DOCUMENT_REQUEST_CREATED_ID__COUNT_DESC = "MESSAGE_CREATEDS_BY_DOCUMENT_REQUEST_CREATED_ID__COUNT_DESC",
  MESSAGE_CREATEDS_COUNT_ASC = "MESSAGE_CREATEDS_COUNT_ASC",
  MESSAGE_CREATEDS_COUNT_DESC = "MESSAGE_CREATEDS_COUNT_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_ID_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_ID_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_ID_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_ID_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_KIND_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_KIND_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_KIND_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_KIND_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_MESSAGE_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_MESSAGE_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_MESSAGE_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_MESSAGE_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_MAX_CREATED_AT_ASC = "MESSAGE_CREATEDS_MAX_CREATED_AT_ASC",
  MESSAGE_CREATEDS_MAX_CREATED_AT_DESC = "MESSAGE_CREATEDS_MAX_CREATED_AT_DESC",
  MESSAGE_CREATEDS_MAX_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_MAX_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_MAX_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_MAX_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_MAX_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_MAX_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_MAX_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_MAX_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_MAX_ID_ASC = "MESSAGE_CREATEDS_MAX_ID_ASC",
  MESSAGE_CREATEDS_MAX_ID_DESC = "MESSAGE_CREATEDS_MAX_ID_DESC",
  MESSAGE_CREATEDS_MAX_KIND_ASC = "MESSAGE_CREATEDS_MAX_KIND_ASC",
  MESSAGE_CREATEDS_MAX_KIND_DESC = "MESSAGE_CREATEDS_MAX_KIND_DESC",
  MESSAGE_CREATEDS_MAX_MESSAGE_ASC = "MESSAGE_CREATEDS_MAX_MESSAGE_ASC",
  MESSAGE_CREATEDS_MAX_MESSAGE_DESC = "MESSAGE_CREATEDS_MAX_MESSAGE_DESC",
  MESSAGE_CREATEDS_MAX_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_MAX_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_MAX_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_MAX_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_MIN_CREATED_AT_ASC = "MESSAGE_CREATEDS_MIN_CREATED_AT_ASC",
  MESSAGE_CREATEDS_MIN_CREATED_AT_DESC = "MESSAGE_CREATEDS_MIN_CREATED_AT_DESC",
  MESSAGE_CREATEDS_MIN_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_MIN_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_MIN_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_MIN_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_MIN_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_MIN_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_MIN_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_MIN_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_MIN_ID_ASC = "MESSAGE_CREATEDS_MIN_ID_ASC",
  MESSAGE_CREATEDS_MIN_ID_DESC = "MESSAGE_CREATEDS_MIN_ID_DESC",
  MESSAGE_CREATEDS_MIN_KIND_ASC = "MESSAGE_CREATEDS_MIN_KIND_ASC",
  MESSAGE_CREATEDS_MIN_KIND_DESC = "MESSAGE_CREATEDS_MIN_KIND_DESC",
  MESSAGE_CREATEDS_MIN_MESSAGE_ASC = "MESSAGE_CREATEDS_MIN_MESSAGE_ASC",
  MESSAGE_CREATEDS_MIN_MESSAGE_DESC = "MESSAGE_CREATEDS_MIN_MESSAGE_DESC",
  MESSAGE_CREATEDS_MIN_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_MIN_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_MIN_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_MIN_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_ID_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_ID_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_KIND_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_KIND_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_KIND_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_KIND_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_MESSAGE_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_MESSAGE_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_MESSAGE_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_MESSAGE_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_ID_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_ID_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_KIND_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_KIND_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_KIND_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_KIND_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_MESSAGE_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_MESSAGE_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_MESSAGE_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_MESSAGE_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_SUM_CREATED_AT_ASC = "MESSAGE_CREATEDS_SUM_CREATED_AT_ASC",
  MESSAGE_CREATEDS_SUM_CREATED_AT_DESC = "MESSAGE_CREATEDS_SUM_CREATED_AT_DESC",
  MESSAGE_CREATEDS_SUM_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_SUM_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_SUM_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_SUM_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_SUM_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_SUM_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_SUM_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_SUM_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_SUM_ID_ASC = "MESSAGE_CREATEDS_SUM_ID_ASC",
  MESSAGE_CREATEDS_SUM_ID_DESC = "MESSAGE_CREATEDS_SUM_ID_DESC",
  MESSAGE_CREATEDS_SUM_KIND_ASC = "MESSAGE_CREATEDS_SUM_KIND_ASC",
  MESSAGE_CREATEDS_SUM_KIND_DESC = "MESSAGE_CREATEDS_SUM_KIND_DESC",
  MESSAGE_CREATEDS_SUM_MESSAGE_ASC = "MESSAGE_CREATEDS_SUM_MESSAGE_ASC",
  MESSAGE_CREATEDS_SUM_MESSAGE_DESC = "MESSAGE_CREATEDS_SUM_MESSAGE_DESC",
  MESSAGE_CREATEDS_SUM_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_SUM_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_SUM_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_SUM_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_KIND_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_KIND_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_KIND_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_KIND_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_MESSAGE_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_MESSAGE_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_MESSAGE_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_MESSAGE_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_KIND_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_KIND_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_KIND_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_KIND_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_SENDER_USER_ID_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__CREATED_AT_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__CREATED_AT_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__CREATED_AT_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__CREATED_AT_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__ID_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__ID_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__ID_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__ID_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__KIND_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__KIND_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__KIND_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__KIND_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__MESSAGE_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__MESSAGE_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__MESSAGE_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__MESSAGE_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__SENDER_USER_ID_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__SENDER_USER_ID_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__SENDER_USER_ID_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_CREATED_ID__SENDER_USER_ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  _DEPRECATED_MESSAGE_CREATED_ID_ASC = "_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  _DEPRECATED_MESSAGE_CREATED_ID_DESC = "_DEPRECATED_MESSAGE_CREATED_ID_DESC",
}

export type DocumentState = {
  __typename?: "DocumentState";
  createdAt: Scalars["Date"]["output"];
  documentId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  state: DocumentStateEnum;
  updatedAt: Scalars["Date"]["output"];
};

export enum DocumentStateEnum {
  optimized = "optimized",
  uploaded = "uploaded",
  vectorized = "vectorized",
}

export type DocumentStateInput = {
  documentId: Scalars["UUID"]["input"];
  state: DocumentStateEnum;
};

/**
 * ## Overview
 *  Tracks uploads that are made through the application. Owned by the `Documentation Service` - its not actually feeding any state calculations, just serving as an application log.
 */
export type DocumentUploadCreated = Node & {
  __typename?: "DocumentUploadCreated";
  /** Reads a single `MessageCreated` that is related to this `DocumentUploadCreated`. */
  _deprecatedMessage?: Maybe<MessageCreated>;
  _deprecatedMessageId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `AuditorUser` that is related to this `DocumentUploadCreated`. */
  author?: Maybe<AuditorUser>;
  authorId: Scalars["UUID"]["output"];
  /** Reads a single `BatchClaim` that is related to this `DocumentUploadCreated`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  claimInquiryRequestId?: Maybe<Scalars["UUID"]["output"]>;
  createdAt: Scalars["Datetime"]["output"];
  fileLocation: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  kind: DocumentUploadKind;
  /** Reads and enables pagination through a set of `MessageCreated`. */
  messageCreateds: MessageCreatedsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `Provider` that is related to this `DocumentUploadCreated`. */
  provider?: Maybe<Provider>;
  providerId: Scalars["String"]["output"];
};

/**
 * ## Overview
 *  Tracks uploads that are made through the application. Owned by the `Documentation Service` - its not actually feeding any state calculations, just serving as an application log.
 */
export type DocumentUploadCreatedmessageCreatedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MessageCreatedCondition>;
  filter?: InputMaybe<MessageCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MessageCreatedsOrderBy>>;
};

export type DocumentUploadCreatedAggregates = {
  __typename?: "DocumentUploadCreatedAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<DocumentUploadCreatedDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `DocumentUploadCreated` object types. */
export type DocumentUploadCreatedAggregatesFilter = {
  /** Distinct count aggregate over matching `DocumentUploadCreated` objects. */
  distinctCount?: InputMaybe<DocumentUploadCreatedDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `DocumentUploadCreated` object to be included within the aggregate. */
  filter?: InputMaybe<DocumentUploadCreatedFilter>;
};

/** The `documentUploadCreated` to be created by this mutation. */
export type DocumentUploadCreatedAuthorIdFkeyDocumentUploadCreatedCreateInput =
  {
    _deprecatedMessageId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
    claimInquiryRequestId?: InputMaybe<Scalars["UUID"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileLocation: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    kind: DocumentUploadKind;
    messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
  };

/** Input for the nested mutation of `auditorUser` in the `DocumentUploadCreatedInput` mutation. */
export type DocumentUploadCreatedAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `documentUploadCreated` in the `AuditorUserInput` mutation. */
export type DocumentUploadCreatedAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `documentUploadCreated` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DocumentUploadCreatedDocumentUploadCreatedPkeyConnect>
  >;
  /** The primary key(s) for `documentUploadCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DocumentUploadCreatedNodeIdConnect>>;
  /** A `DocumentUploadCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DocumentUploadCreatedAuthorIdFkeyDocumentUploadCreatedCreateInput>
  >;
  /** The primary key(s) and patch data for `documentUploadCreated` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyUsingDocumentUploadCreatedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `documentUploadCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyNodeIdUpdate>
  >;
};

/** The `documentUploadCreated` to be created by this mutation. */
export type DocumentUploadCreatedBatchClaimIdFkDocumentUploadCreatedCreateInput =
  {
    _deprecatedMessageId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
    claimInquiryRequestId?: InputMaybe<Scalars["UUID"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileLocation: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    kind: DocumentUploadKind;
    messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
  };

/** Input for the nested mutation of `batchClaim` in the `DocumentUploadCreatedInput` mutation. */
export type DocumentUploadCreatedBatchClaimIdFkInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkNodeIdUpdate>;
};

/** Input for the nested mutation of `documentUploadCreated` in the `BatchClaimInput` mutation. */
export type DocumentUploadCreatedBatchClaimIdFkInverseInput = {
  /** The primary key(s) for `documentUploadCreated` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DocumentUploadCreatedDocumentUploadCreatedPkeyConnect>
  >;
  /** The primary key(s) for `documentUploadCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DocumentUploadCreatedNodeIdConnect>>;
  /** A `DocumentUploadCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DocumentUploadCreatedBatchClaimIdFkDocumentUploadCreatedCreateInput>
  >;
  /** The primary key(s) and patch data for `documentUploadCreated` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkUsingDocumentUploadCreatedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `documentUploadCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `DocumentUploadCreated` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentUploadCreatedCondition = {
  /** Checks for equality with the object’s `_deprecatedMessageId` field. */
  _deprecatedMessageId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `claimInquiryRequestId` field. */
  claimInquiryRequestId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `fileLocation` field. */
  fileLocation?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<DocumentUploadKind>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars["String"]["input"]>;
};

export type DocumentUploadCreatedDistinctCountAggregateFilter = {
  _deprecatedMessageId?: InputMaybe<BigIntFilter>;
  authorId?: InputMaybe<BigIntFilter>;
  batchClaimId?: InputMaybe<BigIntFilter>;
  claimInquiryRequestId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  fileLocation?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  kind?: InputMaybe<BigIntFilter>;
  providerId?: InputMaybe<BigIntFilter>;
};

export type DocumentUploadCreatedDistinctCountAggregates = {
  __typename?: "DocumentUploadCreatedDistinctCountAggregates";
  /** Distinct count of _deprecatedMessageId across the matching connection */
  _deprecatedMessageId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of claimInquiryRequestId across the matching connection */
  claimInquiryRequestId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of fileLocation across the matching connection */
  fileLocation?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of kind across the matching connection */
  kind?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of providerId across the matching connection */
  providerId?: Maybe<Scalars["BigInt"]["output"]>;
};

/** The fields on `documentUploadCreated` to look up the row to connect. */
export type DocumentUploadCreatedDocumentUploadCreatedPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A filter to be used against `DocumentUploadCreated` object types. All fields are combined with a logical ‘and.’ */
export type DocumentUploadCreatedFilter = {
  /** Filter by the object’s `_deprecatedMessage` relation. */
  _deprecatedMessage?: InputMaybe<MessageCreatedFilter>;
  /** A related `_deprecatedMessage` exists. */
  _deprecatedMessageExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `_deprecatedMessageId` field. */
  _deprecatedMessageId?: InputMaybe<UUIDFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentUploadCreatedFilter>>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `claimInquiryRequestId` field. */
  claimInquiryRequestId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileLocation` field. */
  fileLocation?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `kind` field. */
  kind?: InputMaybe<DocumentUploadKindFilter>;
  /** Filter by the object’s `messageCreateds` relation. */
  messageCreateds?: InputMaybe<DocumentUploadCreatedToManyMessageCreatedFilter>;
  /** Some related `messageCreateds` exist. */
  messageCreatedsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentUploadCreatedFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentUploadCreatedFilter>>;
  /** Filter by the object’s `provider` relation. */
  provider?: InputMaybe<ProviderFilter>;
  /** Filter by the object’s `providerId` field. */
  providerId?: InputMaybe<StringFilter>;
};

/** Grouping methods for `DocumentUploadCreated` for usage during aggregation. */
export enum DocumentUploadCreatedGroupBy {
  AUTHOR_ID = "AUTHOR_ID",
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CLAIM_INQUIRY_REQUEST_ID = "CLAIM_INQUIRY_REQUEST_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  FILE_LOCATION = "FILE_LOCATION",
  KIND = "KIND",
  PROVIDER_ID = "PROVIDER_ID",
  _DEPRECATED_MESSAGE_ID = "_DEPRECATED_MESSAGE_ID",
}

export type DocumentUploadCreatedHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentUploadCreatedHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `DocumentUploadCreated` aggregates. */
export type DocumentUploadCreatedHavingInput = {
  AND?: InputMaybe<Array<DocumentUploadCreatedHavingInput>>;
  OR?: InputMaybe<Array<DocumentUploadCreatedHavingInput>>;
  average?: InputMaybe<DocumentUploadCreatedHavingAverageInput>;
  distinctCount?: InputMaybe<DocumentUploadCreatedHavingDistinctCountInput>;
  max?: InputMaybe<DocumentUploadCreatedHavingMaxInput>;
  min?: InputMaybe<DocumentUploadCreatedHavingMinInput>;
  stddevPopulation?: InputMaybe<DocumentUploadCreatedHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<DocumentUploadCreatedHavingStddevSampleInput>;
  sum?: InputMaybe<DocumentUploadCreatedHavingSumInput>;
  variancePopulation?: InputMaybe<DocumentUploadCreatedHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<DocumentUploadCreatedHavingVarianceSampleInput>;
};

export type DocumentUploadCreatedHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentUploadCreatedHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentUploadCreatedHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentUploadCreatedHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentUploadCreatedHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentUploadCreatedHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentUploadCreatedHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `DocumentUploadCreated` */
export type DocumentUploadCreatedInput = {
  _deprecatedMessageId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
  claimInquiryRequestId?: InputMaybe<Scalars["UUID"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileLocation: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  kind: DocumentUploadKind;
  messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
  messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
};

/** The `documentUploadCreated` to be created by this mutation. */
export type DocumentUploadCreatedMessageIdFkeyDocumentUploadCreatedCreateInput =
  {
    auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
    claimInquiryRequestId?: InputMaybe<Scalars["UUID"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileLocation: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    kind: DocumentUploadKind;
    messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
  };

/** Input for the nested mutation of `messageCreated` in the `DocumentUploadCreatedInput` mutation. */
export type DocumentUploadCreatedMessageIdFkeyInput = {
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectById?: InputMaybe<MessageCreatedMessageCreatedPkeyConnect>;
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MessageCreatedNodeIdConnect>;
  /** A `MessageCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentUploadCreatedMessageIdFkeyMessageCreatedCreateInput>;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateById?: InputMaybe<MessageCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyUsingMessageCreatedPkeyUpdate>;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `documentUploadCreated` in the `MessageCreatedInput` mutation. */
export type DocumentUploadCreatedMessageIdFkeyInverseInput = {
  /** The primary key(s) for `documentUploadCreated` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DocumentUploadCreatedDocumentUploadCreatedPkeyConnect>
  >;
  /** The primary key(s) for `documentUploadCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DocumentUploadCreatedNodeIdConnect>>;
  /** A `DocumentUploadCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DocumentUploadCreatedMessageIdFkeyDocumentUploadCreatedCreateInput>
  >;
  /** The primary key(s) and patch data for `documentUploadCreated` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyUsingDocumentUploadCreatedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `documentUploadCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<MessageCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyNodeIdUpdate>
  >;
};

/** The `messageCreated` to be created by this mutation. */
export type DocumentUploadCreatedMessageIdFkeyMessageCreatedCreateInput = {
  auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
  documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  kind: MessageCreatedKind;
  message?: InputMaybe<Scalars["String"]["input"]>;
  messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
  senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type DocumentUploadCreatedNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `documentUploadCreated` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `documentUploadCreated` to look up the row to update. */
export type DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyUsingDocumentUploadCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
    patch: updateDocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `documentUploadCreated` to look up the row to update. */
export type DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkUsingDocumentUploadCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
    patch: updateDocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `messageCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: MessageCreatedPatch;
  };

/** The fields on `documentUploadCreated` to look up the row to update. */
export type DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyUsingDocumentUploadCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
    patch: updateDocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `provider` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: ProviderPatch;
  };

/** The fields on `documentUploadCreated` to look up the row to update. */
export type DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyUsingDocumentUploadCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
    patch: updateDocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type DocumentUploadCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `messageCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: MessageCreatedPatch;
  };

/** The fields on `documentUploadCreated` to look up the row to update. */
export type DocumentUploadCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyUsingDocumentUploadCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
    patch: updateDocumentUploadCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyPatch;
  };

/** Represents an update to a `DocumentUploadCreated`. Fields that are set will be updated. */
export type DocumentUploadCreatedPatch = {
  _deprecatedMessageId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
  messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
  messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
};

/** The `documentUploadCreated` to be created by this mutation. */
export type DocumentUploadCreatedProviderIdFkeyDocumentUploadCreatedCreateInput =
  {
    _deprecatedMessageId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
    claimInquiryRequestId?: InputMaybe<Scalars["UUID"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileLocation: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    kind: DocumentUploadKind;
    messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
    providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
  };

/** Input for the nested mutation of `provider` in the `DocumentUploadCreatedInput` mutation. */
export type DocumentUploadCreatedProviderIdFkeyInput = {
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectById?: InputMaybe<ProviderProviderPkeyConnect>;
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProviderNodeIdConnect>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateById?: InputMaybe<ProviderOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyUsingProviderPkeyUpdate>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `documentUploadCreated` in the `ProviderInput` mutation. */
export type DocumentUploadCreatedProviderIdFkeyInverseInput = {
  /** The primary key(s) for `documentUploadCreated` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DocumentUploadCreatedDocumentUploadCreatedPkeyConnect>
  >;
  /** The primary key(s) for `documentUploadCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DocumentUploadCreatedNodeIdConnect>>;
  /** A `DocumentUploadCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DocumentUploadCreatedProviderIdFkeyDocumentUploadCreatedCreateInput>
  >;
  /** The primary key(s) and patch data for `documentUploadCreated` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyUsingDocumentUploadCreatedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `documentUploadCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<ProviderOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyNodeIdUpdate>
  >;
};

/** A filter to be used against many `MessageCreated` object types. All fields are combined with a logical ‘and.’ */
export type DocumentUploadCreatedToManyMessageCreatedFilter = {
  /** Aggregates across related `MessageCreated` match the filter criteria. */
  aggregates?: InputMaybe<MessageCreatedAggregatesFilter>;
  /** Every related `MessageCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MessageCreatedFilter>;
  /** No related `MessageCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MessageCreatedFilter>;
  /** Some related `MessageCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MessageCreatedFilter>;
};

/** A connection to a list of `DocumentUploadCreated` values. */
export type DocumentUploadCreatedsConnection = {
  __typename?: "DocumentUploadCreatedsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<DocumentUploadCreatedAggregates>;
  /** A list of edges which contains the `DocumentUploadCreated` and cursor to aid in pagination. */
  edges: Array<DocumentUploadCreatedsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<DocumentUploadCreatedAggregates>>;
  /** A list of `DocumentUploadCreated` objects. */
  nodes: Array<Maybe<DocumentUploadCreated>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentUploadCreated` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `DocumentUploadCreated` values. */
export type DocumentUploadCreatedsConnectiongroupedAggregatesArgs = {
  groupBy: Array<DocumentUploadCreatedGroupBy>;
  having?: InputMaybe<DocumentUploadCreatedHavingInput>;
};

/** A `DocumentUploadCreated` edge in the connection. */
export type DocumentUploadCreatedsEdge = {
  __typename?: "DocumentUploadCreatedsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DocumentUploadCreated` at the end of the edge. */
  node?: Maybe<DocumentUploadCreated>;
};

/** Methods to use when ordering `DocumentUploadCreated`. */
export enum DocumentUploadCreatedsOrderBy {
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REQUEST_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  FILE_LOCATION_ASC = "FILE_LOCATION_ASC",
  FILE_LOCATION_DESC = "FILE_LOCATION_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  KIND_ASC = "KIND_ASC",
  KIND_DESC = "KIND_DESC",
  MESSAGE_CREATEDS_AVERAGE_CREATED_AT_ASC = "MESSAGE_CREATEDS_AVERAGE_CREATED_AT_ASC",
  MESSAGE_CREATEDS_AVERAGE_CREATED_AT_DESC = "MESSAGE_CREATEDS_AVERAGE_CREATED_AT_DESC",
  MESSAGE_CREATEDS_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_AVERAGE_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_AVERAGE_ID_ASC = "MESSAGE_CREATEDS_AVERAGE_ID_ASC",
  MESSAGE_CREATEDS_AVERAGE_ID_DESC = "MESSAGE_CREATEDS_AVERAGE_ID_DESC",
  MESSAGE_CREATEDS_AVERAGE_KIND_ASC = "MESSAGE_CREATEDS_AVERAGE_KIND_ASC",
  MESSAGE_CREATEDS_AVERAGE_KIND_DESC = "MESSAGE_CREATEDS_AVERAGE_KIND_DESC",
  MESSAGE_CREATEDS_AVERAGE_MESSAGE_ASC = "MESSAGE_CREATEDS_AVERAGE_MESSAGE_ASC",
  MESSAGE_CREATEDS_AVERAGE_MESSAGE_DESC = "MESSAGE_CREATEDS_AVERAGE_MESSAGE_DESC",
  MESSAGE_CREATEDS_AVERAGE_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_AVERAGE_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_AVERAGE_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_AVERAGE_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_BY_DOCUMENT_UPLOAD_CREATED_ID__COUNT_ASC = "MESSAGE_CREATEDS_BY_DOCUMENT_UPLOAD_CREATED_ID__COUNT_ASC",
  MESSAGE_CREATEDS_BY_DOCUMENT_UPLOAD_CREATED_ID__COUNT_DESC = "MESSAGE_CREATEDS_BY_DOCUMENT_UPLOAD_CREATED_ID__COUNT_DESC",
  MESSAGE_CREATEDS_COUNT_ASC = "MESSAGE_CREATEDS_COUNT_ASC",
  MESSAGE_CREATEDS_COUNT_DESC = "MESSAGE_CREATEDS_COUNT_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_ID_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_ID_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_ID_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_ID_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_KIND_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_KIND_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_KIND_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_KIND_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_MESSAGE_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_MESSAGE_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_MESSAGE_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_MESSAGE_DESC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_DISTINCT_COUNT_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_DISTINCT_COUNT_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_DISTINCT_COUNT_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_MAX_CREATED_AT_ASC = "MESSAGE_CREATEDS_MAX_CREATED_AT_ASC",
  MESSAGE_CREATEDS_MAX_CREATED_AT_DESC = "MESSAGE_CREATEDS_MAX_CREATED_AT_DESC",
  MESSAGE_CREATEDS_MAX_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_MAX_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_MAX_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_MAX_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_MAX_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_MAX_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_MAX_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_MAX_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_MAX_ID_ASC = "MESSAGE_CREATEDS_MAX_ID_ASC",
  MESSAGE_CREATEDS_MAX_ID_DESC = "MESSAGE_CREATEDS_MAX_ID_DESC",
  MESSAGE_CREATEDS_MAX_KIND_ASC = "MESSAGE_CREATEDS_MAX_KIND_ASC",
  MESSAGE_CREATEDS_MAX_KIND_DESC = "MESSAGE_CREATEDS_MAX_KIND_DESC",
  MESSAGE_CREATEDS_MAX_MESSAGE_ASC = "MESSAGE_CREATEDS_MAX_MESSAGE_ASC",
  MESSAGE_CREATEDS_MAX_MESSAGE_DESC = "MESSAGE_CREATEDS_MAX_MESSAGE_DESC",
  MESSAGE_CREATEDS_MAX_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_MAX_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_MAX_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_MAX_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_MIN_CREATED_AT_ASC = "MESSAGE_CREATEDS_MIN_CREATED_AT_ASC",
  MESSAGE_CREATEDS_MIN_CREATED_AT_DESC = "MESSAGE_CREATEDS_MIN_CREATED_AT_DESC",
  MESSAGE_CREATEDS_MIN_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_MIN_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_MIN_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_MIN_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_MIN_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_MIN_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_MIN_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_MIN_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_MIN_ID_ASC = "MESSAGE_CREATEDS_MIN_ID_ASC",
  MESSAGE_CREATEDS_MIN_ID_DESC = "MESSAGE_CREATEDS_MIN_ID_DESC",
  MESSAGE_CREATEDS_MIN_KIND_ASC = "MESSAGE_CREATEDS_MIN_KIND_ASC",
  MESSAGE_CREATEDS_MIN_KIND_DESC = "MESSAGE_CREATEDS_MIN_KIND_DESC",
  MESSAGE_CREATEDS_MIN_MESSAGE_ASC = "MESSAGE_CREATEDS_MIN_MESSAGE_ASC",
  MESSAGE_CREATEDS_MIN_MESSAGE_DESC = "MESSAGE_CREATEDS_MIN_MESSAGE_DESC",
  MESSAGE_CREATEDS_MIN_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_MIN_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_MIN_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_MIN_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_ID_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_ID_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_KIND_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_KIND_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_KIND_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_KIND_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_MESSAGE_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_MESSAGE_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_MESSAGE_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_MESSAGE_DESC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_STDDEV_POPULATION_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_POPULATION_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_STDDEV_POPULATION_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_ID_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_ID_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_ID_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_KIND_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_KIND_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_KIND_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_KIND_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_MESSAGE_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_MESSAGE_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_MESSAGE_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_MESSAGE_DESC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_STDDEV_SAMPLE_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_STDDEV_SAMPLE_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_SUM_CREATED_AT_ASC = "MESSAGE_CREATEDS_SUM_CREATED_AT_ASC",
  MESSAGE_CREATEDS_SUM_CREATED_AT_DESC = "MESSAGE_CREATEDS_SUM_CREATED_AT_DESC",
  MESSAGE_CREATEDS_SUM_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_SUM_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_SUM_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_SUM_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_SUM_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_SUM_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_SUM_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_SUM_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_SUM_ID_ASC = "MESSAGE_CREATEDS_SUM_ID_ASC",
  MESSAGE_CREATEDS_SUM_ID_DESC = "MESSAGE_CREATEDS_SUM_ID_DESC",
  MESSAGE_CREATEDS_SUM_KIND_ASC = "MESSAGE_CREATEDS_SUM_KIND_ASC",
  MESSAGE_CREATEDS_SUM_KIND_DESC = "MESSAGE_CREATEDS_SUM_KIND_DESC",
  MESSAGE_CREATEDS_SUM_MESSAGE_ASC = "MESSAGE_CREATEDS_SUM_MESSAGE_ASC",
  MESSAGE_CREATEDS_SUM_MESSAGE_DESC = "MESSAGE_CREATEDS_SUM_MESSAGE_DESC",
  MESSAGE_CREATEDS_SUM_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_SUM_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_SUM_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_SUM_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_KIND_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_KIND_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_KIND_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_KIND_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_MESSAGE_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_MESSAGE_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_MESSAGE_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_MESSAGE_DESC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_POPULATION_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_POPULATION_SENDER_USER_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_ID_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_KIND_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_KIND_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_KIND_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_KIND_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_MESSAGE_DESC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_SENDER_USER_ID_ASC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_SENDER_USER_ID_ASC",
  MESSAGE_CREATEDS_VARIANCE_SAMPLE_SENDER_USER_ID_DESC = "MESSAGE_CREATEDS_VARIANCE_SAMPLE_SENDER_USER_ID_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__CREATED_AT_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__CREATED_AT_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__CREATED_AT_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__CREATED_AT_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__ID_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__ID_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__ID_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__ID_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__KIND_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__KIND_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__KIND_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__KIND_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__MESSAGE_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__MESSAGE_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__MESSAGE_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__MESSAGE_DESC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__SENDER_USER_ID_ASC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__SENDER_USER_ID_ASC",
  MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__SENDER_USER_ID_DESC = "MESSAGE_CREATED_BY_DEPRECATED_MESSAGE_ID__SENDER_USER_ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__CITY_ASC = "PROVIDER_BY_PROVIDER_ID__CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__CITY_DESC = "PROVIDER_BY_PROVIDER_ID__CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC",
  PROVIDER_BY_PROVIDER_ID__ID_ASC = "PROVIDER_BY_PROVIDER_ID__ID_ASC",
  PROVIDER_BY_PROVIDER_ID__ID_DESC = "PROVIDER_BY_PROVIDER_ID__ID_DESC",
  PROVIDER_BY_PROVIDER_ID__NAME_ASC = "PROVIDER_BY_PROVIDER_ID__NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__NAME_DESC = "PROVIDER_BY_PROVIDER_ID__NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__NPI_ASC = "PROVIDER_BY_PROVIDER_ID__NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__NPI_DESC = "PROVIDER_BY_PROVIDER_ID__NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC",
  PROVIDER_BY_PROVIDER_ID__SPEC_ASC = "PROVIDER_BY_PROVIDER_ID__SPEC_ASC",
  PROVIDER_BY_PROVIDER_ID__SPEC_DESC = "PROVIDER_BY_PROVIDER_ID__SPEC_DESC",
  PROVIDER_BY_PROVIDER_ID__STATE_ASC = "PROVIDER_BY_PROVIDER_ID__STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__STATE_DESC = "PROVIDER_BY_PROVIDER_ID__STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC",
  PROVIDER_ID_ASC = "PROVIDER_ID_ASC",
  PROVIDER_ID_DESC = "PROVIDER_ID_DESC",
  _DEPRECATED_MESSAGE_ID_ASC = "_DEPRECATED_MESSAGE_ID_ASC",
  _DEPRECATED_MESSAGE_ID_DESC = "_DEPRECATED_MESSAGE_ID_DESC",
}

export enum DocumentUploadKind {
  BILLING_RECORD = "BILLING_RECORD",
  CONSULTATIONS = "CONSULTATIONS",
  DISCHARGE_SUMMARY = "DISCHARGE_SUMMARY",
  EMERGENCY_ROOM_RECORDS = "EMERGENCY_ROOM_RECORDS",
  FACE_SHEET = "FACE_SHEET",
  FACILITY_CHARGEMASTER = "FACILITY_CHARGEMASTER",
  HISTORY_AND_PHYSICAL = "HISTORY_AND_PHYSICAL",
  ICD10_CM_CODES_SUBMITTED = "ICD10_CM_CODES_SUBMITTED",
  ITEMIZED_BILL = "ITEMIZED_BILL",
  LABORATORY_REPORTS = "LABORATORY_REPORTS",
  MEDICAL_RECORD = "MEDICAL_RECORD",
  NURSING_NOTES = "NURSING_NOTES",
  OPERATIVE_REPORTS = "OPERATIVE_REPORTS",
  OTHER = "OTHER",
  PATHOLOGY_REPORTS = "PATHOLOGY_REPORTS",
  PHYSICIAN_ORDERS = "PHYSICIAN_ORDERS",
  PHYSICIAN_PROGRESS_NOTES = "PHYSICIAN_PROGRESS_NOTES",
  RADIOLOGY_REPORTS = "RADIOLOGY_REPORTS",
  THERAPY_TREATMENT_PLAN_WITH_NOTES = "THERAPY_TREATMENT_PLAN_WITH_NOTES",
  UB04_CLAIM_FORM = "UB04_CLAIM_FORM",
}

/** A filter to be used against DocumentUploadKind fields. All fields are combined with a logical ‘and.’ */
export type DocumentUploadKindFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DocumentUploadKind>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DocumentUploadKind>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DocumentUploadKind>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DocumentUploadKind>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DocumentUploadKind>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DocumentUploadKind>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DocumentUploadKind>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DocumentUploadKind>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DocumentUploadKind>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DocumentUploadKind>>;
};

/**
 * ### Overview
 * Append-only history of documentation_claim_state values for a batch_claim. Rows are
 * written via v3.set_documentation_claim_states (exposed as the setDocumentationClaimStates
 * mutation). The latest row drives the cached value on v3.batch_claim_state.documentation_claim_state
 * via the t1_update_cache_documentation_claim_state_on_documentation trigger.
 *
 * Allowed values are restricted by CHECK to NO_REQUESTS, AWAITING_UPLOAD, and DOCUMENTS_RECEIVED.
 */
export type DocumentationClaimState = Node & {
  __typename?: "DocumentationClaimState";
  /** Reads a single `AuditorUser` that is related to this `DocumentationClaimState`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `DocumentationClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  createdBy: Scalars["UUID"]["output"];
  documentationState: DocumentationClaimStateEnum;
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

export type DocumentationClaimStateAggregates = {
  __typename?: "DocumentationClaimStateAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<DocumentationClaimStateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `DocumentationClaimState` object types. */
export type DocumentationClaimStateAggregatesFilter = {
  /** Distinct count aggregate over matching `DocumentationClaimState` objects. */
  distinctCount?: InputMaybe<DocumentationClaimStateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `DocumentationClaimState` object to be included within the aggregate. */
  filter?: InputMaybe<DocumentationClaimStateFilter>;
};

/** The `documentationClaimState` to be created by this mutation. */
export type DocumentationClaimStateBatchClaimIdFkeyDocumentationClaimStateCreateInput =
  {
    auditorUserToCreatedBy?: InputMaybe<DocumentationClaimStateCreatedByFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
    documentationState: DocumentationClaimStateEnum;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `batchClaim` in the `DocumentationClaimStateInput` mutation. */
export type DocumentationClaimStateBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `documentationClaimState` in the `BatchClaimInput` mutation. */
export type DocumentationClaimStateBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `documentationClaimState` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DocumentationClaimStateDocumentationClaimStatePkeyConnect>
  >;
  /** The primary key(s) for `documentationClaimState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DocumentationClaimStateNodeIdConnect>>;
  /** A `DocumentationClaimStateInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DocumentationClaimStateBatchClaimIdFkeyDocumentationClaimStateCreateInput>
  >;
  /** The primary key(s) and patch data for `documentationClaimState` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyUsingDocumentationClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `documentationClaimState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `DocumentationClaimState` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentationClaimStateCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `documentationState` field. */
  documentationState?: InputMaybe<DocumentationClaimStateEnum>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `documentationClaimState` to be created by this mutation. */
export type DocumentationClaimStateCreatedByFkeyDocumentationClaimStateCreateInput =
  {
    auditorUserToCreatedBy?: InputMaybe<DocumentationClaimStateCreatedByFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    documentationState: DocumentationClaimStateEnum;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `auditorUser` in the `DocumentationClaimStateInput` mutation. */
export type DocumentationClaimStateCreatedByFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `documentationClaimState` in the `AuditorUserInput` mutation. */
export type DocumentationClaimStateCreatedByFkeyInverseInput = {
  /** The primary key(s) for `documentationClaimState` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DocumentationClaimStateDocumentationClaimStatePkeyConnect>
  >;
  /** The primary key(s) for `documentationClaimState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DocumentationClaimStateNodeIdConnect>>;
  /** A `DocumentationClaimStateInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DocumentationClaimStateCreatedByFkeyDocumentationClaimStateCreateInput>
  >;
  /** The primary key(s) and patch data for `documentationClaimState` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyUsingDocumentationClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `documentationClaimState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyNodeIdUpdate>
  >;
};

export type DocumentationClaimStateDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  createdBy?: InputMaybe<BigIntFilter>;
  documentationState?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type DocumentationClaimStateDistinctCountAggregates = {
  __typename?: "DocumentationClaimStateDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of documentationState across the matching connection */
  documentationState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
};

/** The fields on `documentationClaimState` to look up the row to connect. */
export type DocumentationClaimStateDocumentationClaimStatePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

export enum DocumentationClaimStateEnum {
  AWAITING_UPLOAD = "AWAITING_UPLOAD",
  DOCUMENTS_RECEIVED = "DOCUMENTS_RECEIVED",
  NO_REQUESTS = "NO_REQUESTS",
  PROCESSING_ISSUE = "PROCESSING_ISSUE",
  REQUEST_DRAFTED = "REQUEST_DRAFTED",
}

/** A filter to be used against DocumentationClaimStateEnum fields. All fields are combined with a logical ‘and.’ */
export type DocumentationClaimStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DocumentationClaimStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DocumentationClaimStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DocumentationClaimStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DocumentationClaimStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DocumentationClaimStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DocumentationClaimStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DocumentationClaimStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DocumentationClaimStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DocumentationClaimStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DocumentationClaimStateEnum>>;
};

/** A filter to be used against `DocumentationClaimState` object types. All fields are combined with a logical ‘and.’ */
export type DocumentationClaimStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentationClaimStateFilter>>;
  /** Filter by the object’s `auditorUserByCreatedBy` relation. */
  auditorUserByCreatedBy?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `documentationState` field. */
  documentationState?: InputMaybe<DocumentationClaimStateEnumFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentationClaimStateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentationClaimStateFilter>>;
};

/** Grouping methods for `DocumentationClaimState` for usage during aggregation. */
export enum DocumentationClaimStateGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  CREATED_BY = "CREATED_BY",
  DOCUMENTATION_STATE = "DOCUMENTATION_STATE",
}

export type DocumentationClaimStateHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentationClaimStateHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `DocumentationClaimState` aggregates. */
export type DocumentationClaimStateHavingInput = {
  AND?: InputMaybe<Array<DocumentationClaimStateHavingInput>>;
  OR?: InputMaybe<Array<DocumentationClaimStateHavingInput>>;
  average?: InputMaybe<DocumentationClaimStateHavingAverageInput>;
  distinctCount?: InputMaybe<DocumentationClaimStateHavingDistinctCountInput>;
  max?: InputMaybe<DocumentationClaimStateHavingMaxInput>;
  min?: InputMaybe<DocumentationClaimStateHavingMinInput>;
  stddevPopulation?: InputMaybe<DocumentationClaimStateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<DocumentationClaimStateHavingStddevSampleInput>;
  sum?: InputMaybe<DocumentationClaimStateHavingSumInput>;
  variancePopulation?: InputMaybe<DocumentationClaimStateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<DocumentationClaimStateHavingVarianceSampleInput>;
};

export type DocumentationClaimStateHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentationClaimStateHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentationClaimStateHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentationClaimStateHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentationClaimStateHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentationClaimStateHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type DocumentationClaimStateHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `DocumentationClaimState` */
export type DocumentationClaimStateInput = {
  auditorUserToCreatedBy?: InputMaybe<DocumentationClaimStateCreatedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  documentationState: DocumentationClaimStateEnum;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type DocumentationClaimStateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `documentationClaimState` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type DocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `documentationClaimState` to look up the row to update. */
export type DocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyUsingDocumentationClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `documentationClaimState` being updated. */
    patch: updateDocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type DocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `documentationClaimState` to look up the row to update. */
export type DocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyUsingDocumentationClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `documentationClaimState` being updated. */
    patch: updateDocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyPatch;
  };

/** Represents an update to a `DocumentationClaimState`. Fields that are set will be updated. */
export type DocumentationClaimStatePatch = {
  auditorUserToCreatedBy?: InputMaybe<DocumentationClaimStateCreatedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInput>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A connection to a list of `DocumentationClaimState` values. */
export type DocumentationClaimStatesConnection = {
  __typename?: "DocumentationClaimStatesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<DocumentationClaimStateAggregates>;
  /** A list of edges which contains the `DocumentationClaimState` and cursor to aid in pagination. */
  edges: Array<DocumentationClaimStatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<DocumentationClaimStateAggregates>>;
  /** A list of `DocumentationClaimState` objects. */
  nodes: Array<Maybe<DocumentationClaimState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentationClaimState` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `DocumentationClaimState` values. */
export type DocumentationClaimStatesConnectiongroupedAggregatesArgs = {
  groupBy: Array<DocumentationClaimStateGroupBy>;
  having?: InputMaybe<DocumentationClaimStateHavingInput>;
};

/** A `DocumentationClaimState` edge in the connection. */
export type DocumentationClaimStatesEdge = {
  __typename?: "DocumentationClaimStatesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DocumentationClaimState` at the end of the edge. */
  node?: Maybe<DocumentationClaimState>;
};

/** Methods to use when ordering `DocumentationClaimState`. */
export enum DocumentationClaimStatesOrderBy {
  AUDITOR_USER_BY_CREATED_BY__CREATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__CREATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__CREATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__CREATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__EMAIL_ASC = "AUDITOR_USER_BY_CREATED_BY__EMAIL_ASC",
  AUDITOR_USER_BY_CREATED_BY__EMAIL_DESC = "AUDITOR_USER_BY_CREATED_BY__EMAIL_DESC",
  AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_ASC = "AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_ASC",
  AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_DESC = "AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_DESC",
  AUDITOR_USER_BY_CREATED_BY__IDP_SUB_ASC = "AUDITOR_USER_BY_CREATED_BY__IDP_SUB_ASC",
  AUDITOR_USER_BY_CREATED_BY__IDP_SUB_DESC = "AUDITOR_USER_BY_CREATED_BY__IDP_SUB_DESC",
  AUDITOR_USER_BY_CREATED_BY__ID_ASC = "AUDITOR_USER_BY_CREATED_BY__ID_ASC",
  AUDITOR_USER_BY_CREATED_BY__ID_DESC = "AUDITOR_USER_BY_CREATED_BY__ID_DESC",
  AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_CREATED_BY__LAST_NAME_ASC = "AUDITOR_USER_BY_CREATED_BY__LAST_NAME_ASC",
  AUDITOR_USER_BY_CREATED_BY__LAST_NAME_DESC = "AUDITOR_USER_BY_CREATED_BY__LAST_NAME_DESC",
  AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_ASC = "AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_DESC = "AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_CREATED_BY__READ_ONLY_ASC = "AUDITOR_USER_BY_CREATED_BY__READ_ONLY_ASC",
  AUDITOR_USER_BY_CREATED_BY__READ_ONLY_DESC = "AUDITOR_USER_BY_CREATED_BY__READ_ONLY_DESC",
  AUDITOR_USER_BY_CREATED_BY__TITLE_ASC = "AUDITOR_USER_BY_CREATED_BY__TITLE_ASC",
  AUDITOR_USER_BY_CREATED_BY__TITLE_DESC = "AUDITOR_USER_BY_CREATED_BY__TITLE_DESC",
  AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__USER_TYPE_ASC = "AUDITOR_USER_BY_CREATED_BY__USER_TYPE_ASC",
  AUDITOR_USER_BY_CREATED_BY__USER_TYPE_DESC = "AUDITOR_USER_BY_CREATED_BY__USER_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  CREATED_BY_ASC = "CREATED_BY_ASC",
  CREATED_BY_DESC = "CREATED_BY_DESC",
  DOCUMENTATION_STATE_ASC = "DOCUMENTATION_STATE_ASC",
  DOCUMENTATION_STATE_DESC = "DOCUMENTATION_STATE_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

export type DocumentationSelectionSet = Node & {
  __typename?: "DocumentationSelectionSet";
  createdAt: Scalars["Datetime"]["output"];
  etag: Scalars["String"]["output"];
  filename: Scalars["String"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `Provider` that is related to this `DocumentationSelectionSet`. */
  provider?: Maybe<Provider>;
  providerId: Scalars["String"]["output"];
  s3Key: Scalars["String"]["output"];
  selectionSet: Scalars["Int"]["output"];
};

export type DocumentationSelectionSetAggregates = {
  __typename?: "DocumentationSelectionSetAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<DocumentationSelectionSetAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<DocumentationSelectionSetDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<DocumentationSelectionSetMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<DocumentationSelectionSetMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<DocumentationSelectionSetStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<DocumentationSelectionSetStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<DocumentationSelectionSetSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<DocumentationSelectionSetVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<DocumentationSelectionSetVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `DocumentationSelectionSet` object types. */
export type DocumentationSelectionSetAggregatesFilter = {
  /** Mean average aggregate over matching `DocumentationSelectionSet` objects. */
  average?: InputMaybe<DocumentationSelectionSetAverageAggregateFilter>;
  /** Distinct count aggregate over matching `DocumentationSelectionSet` objects. */
  distinctCount?: InputMaybe<DocumentationSelectionSetDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `DocumentationSelectionSet` object to be included within the aggregate. */
  filter?: InputMaybe<DocumentationSelectionSetFilter>;
  /** Maximum aggregate over matching `DocumentationSelectionSet` objects. */
  max?: InputMaybe<DocumentationSelectionSetMaxAggregateFilter>;
  /** Minimum aggregate over matching `DocumentationSelectionSet` objects. */
  min?: InputMaybe<DocumentationSelectionSetMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `DocumentationSelectionSet` objects. */
  stddevPopulation?: InputMaybe<DocumentationSelectionSetStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `DocumentationSelectionSet` objects. */
  stddevSample?: InputMaybe<DocumentationSelectionSetStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `DocumentationSelectionSet` objects. */
  sum?: InputMaybe<DocumentationSelectionSetSumAggregateFilter>;
  /** Population variance aggregate over matching `DocumentationSelectionSet` objects. */
  variancePopulation?: InputMaybe<DocumentationSelectionSetVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `DocumentationSelectionSet` objects. */
  varianceSample?: InputMaybe<DocumentationSelectionSetVarianceSampleAggregateFilter>;
};

export type DocumentationSelectionSetAverageAggregateFilter = {
  selectionSet?: InputMaybe<BigFloatFilter>;
};

export type DocumentationSelectionSetAverageAggregates = {
  __typename?: "DocumentationSelectionSetAverageAggregates";
  /** Mean average of selectionSet across the matching connection */
  selectionSet?: Maybe<Scalars["BigFloat"]["output"]>;
};

/**
 * A condition to be used against `DocumentationSelectionSet` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentationSelectionSetCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `etag` field. */
  etag?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `filename` field. */
  filename?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `s3Key` field. */
  s3Key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `selectionSet` field. */
  selectionSet?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DocumentationSelectionSetDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  etag?: InputMaybe<BigIntFilter>;
  filename?: InputMaybe<BigIntFilter>;
  providerId?: InputMaybe<BigIntFilter>;
  s3Key?: InputMaybe<BigIntFilter>;
  selectionSet?: InputMaybe<BigIntFilter>;
};

export type DocumentationSelectionSetDistinctCountAggregates = {
  __typename?: "DocumentationSelectionSetDistinctCountAggregates";
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of etag across the matching connection */
  etag?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of filename across the matching connection */
  filename?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of providerId across the matching connection */
  providerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of s3Key across the matching connection */
  s3Key?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of selectionSet across the matching connection */
  selectionSet?: Maybe<Scalars["BigInt"]["output"]>;
};

/** The fields on `documentationSelectionSet` to look up the row to connect. */
export type DocumentationSelectionSetDocumentationSelectionSetPkeyConnect = {
  etag: Scalars["String"]["input"];
};

/** The fields on `documentationSelectionSet` to look up the row to connect. */
export type DocumentationSelectionSetDocumentationSelectionSetS3KeyKeyConnect =
  {
    s3Key: Scalars["String"]["input"];
  };

/** A filter to be used against `DocumentationSelectionSet` object types. All fields are combined with a logical ‘and.’ */
export type DocumentationSelectionSetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentationSelectionSetFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `etag` field. */
  etag?: InputMaybe<StringFilter>;
  /** Filter by the object’s `filename` field. */
  filename?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentationSelectionSetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentationSelectionSetFilter>>;
  /** Filter by the object’s `provider` relation. */
  provider?: InputMaybe<ProviderFilter>;
  /** Filter by the object’s `providerId` field. */
  providerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `s3Key` field. */
  s3Key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `selectionSet` field. */
  selectionSet?: InputMaybe<IntFilter>;
};

/** Grouping methods for `DocumentationSelectionSet` for usage during aggregation. */
export enum DocumentationSelectionSetGroupBy {
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  FILENAME = "FILENAME",
  PROVIDER_ID = "PROVIDER_ID",
  SELECTION_SET = "SELECTION_SET",
}

export type DocumentationSelectionSetHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  selectionSet?: InputMaybe<HavingIntFilter>;
};

export type DocumentationSelectionSetHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  selectionSet?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `DocumentationSelectionSet` aggregates. */
export type DocumentationSelectionSetHavingInput = {
  AND?: InputMaybe<Array<DocumentationSelectionSetHavingInput>>;
  OR?: InputMaybe<Array<DocumentationSelectionSetHavingInput>>;
  average?: InputMaybe<DocumentationSelectionSetHavingAverageInput>;
  distinctCount?: InputMaybe<DocumentationSelectionSetHavingDistinctCountInput>;
  max?: InputMaybe<DocumentationSelectionSetHavingMaxInput>;
  min?: InputMaybe<DocumentationSelectionSetHavingMinInput>;
  stddevPopulation?: InputMaybe<DocumentationSelectionSetHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<DocumentationSelectionSetHavingStddevSampleInput>;
  sum?: InputMaybe<DocumentationSelectionSetHavingSumInput>;
  variancePopulation?: InputMaybe<DocumentationSelectionSetHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<DocumentationSelectionSetHavingVarianceSampleInput>;
};

export type DocumentationSelectionSetHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  selectionSet?: InputMaybe<HavingIntFilter>;
};

export type DocumentationSelectionSetHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  selectionSet?: InputMaybe<HavingIntFilter>;
};

export type DocumentationSelectionSetHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  selectionSet?: InputMaybe<HavingIntFilter>;
};

export type DocumentationSelectionSetHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  selectionSet?: InputMaybe<HavingIntFilter>;
};

export type DocumentationSelectionSetHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  selectionSet?: InputMaybe<HavingIntFilter>;
};

export type DocumentationSelectionSetHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  selectionSet?: InputMaybe<HavingIntFilter>;
};

export type DocumentationSelectionSetHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  selectionSet?: InputMaybe<HavingIntFilter>;
};

/** An input for mutations affecting `DocumentationSelectionSet` */
export type DocumentationSelectionSetInput = {
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  etag: Scalars["String"]["input"];
  filename: Scalars["String"]["input"];
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInput>;
  s3Key: Scalars["String"]["input"];
  selectionSet: Scalars["Int"]["input"];
};

export type DocumentationSelectionSetMaxAggregateFilter = {
  selectionSet?: InputMaybe<IntFilter>;
};

export type DocumentationSelectionSetMaxAggregates = {
  __typename?: "DocumentationSelectionSetMaxAggregates";
  /** Maximum of selectionSet across the matching connection */
  selectionSet?: Maybe<Scalars["Int"]["output"]>;
};

export type DocumentationSelectionSetMinAggregateFilter = {
  selectionSet?: InputMaybe<IntFilter>;
};

export type DocumentationSelectionSetMinAggregates = {
  __typename?: "DocumentationSelectionSetMinAggregates";
  /** Minimum of selectionSet across the matching connection */
  selectionSet?: Maybe<Scalars["Int"]["output"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type DocumentationSelectionSetNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `documentationSelectionSet` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type DocumentationSelectionSetOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `provider` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: ProviderPatch;
  };

/** The fields on `documentationSelectionSet` to look up the row to update. */
export type DocumentationSelectionSetOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyUsingDocumentationSelectionSetPkeyUpdate =
  {
    etag: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `documentationSelectionSet` being updated. */
    patch: updateDocumentationSelectionSetOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyPatch;
  };

/** The fields on `documentationSelectionSet` to look up the row to update. */
export type DocumentationSelectionSetOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyUsingDocumentationSelectionSetS3KeyKeyUpdate =
  {
    /** An object where the defined keys will be set on the `documentationSelectionSet` being updated. */
    patch: updateDocumentationSelectionSetOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyPatch;
    s3Key: Scalars["String"]["input"];
  };

/** Represents an update to a `DocumentationSelectionSet`. Fields that are set will be updated. */
export type DocumentationSelectionSetPatch = {
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInput>;
};

/** The `documentationSelectionSet` to be created by this mutation. */
export type DocumentationSelectionSetProviderIdFkeyDocumentationSelectionSetCreateInput =
  {
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    etag: Scalars["String"]["input"];
    filename: Scalars["String"]["input"];
    providerToProviderId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInput>;
    s3Key: Scalars["String"]["input"];
    selectionSet: Scalars["Int"]["input"];
  };

/** Input for the nested mutation of `provider` in the `DocumentationSelectionSetInput` mutation. */
export type DocumentationSelectionSetProviderIdFkeyInput = {
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectById?: InputMaybe<ProviderProviderPkeyConnect>;
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProviderNodeIdConnect>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateById?: InputMaybe<ProviderOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyUsingProviderPkeyUpdate>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DocumentationSelectionSetOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `documentationSelectionSet` in the `ProviderInput` mutation. */
export type DocumentationSelectionSetProviderIdFkeyInverseInput = {
  /** The primary key(s) for `documentationSelectionSet` for the far side of the relationship. */
  connectByEtag?: InputMaybe<
    Array<DocumentationSelectionSetDocumentationSelectionSetPkeyConnect>
  >;
  /** The primary key(s) for `documentationSelectionSet` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DocumentationSelectionSetNodeIdConnect>>;
  /** The primary key(s) for `documentationSelectionSet` for the far side of the relationship. */
  connectByS3Key?: InputMaybe<
    Array<DocumentationSelectionSetDocumentationSelectionSetS3KeyKeyConnect>
  >;
  /** A `DocumentationSelectionSetInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DocumentationSelectionSetProviderIdFkeyDocumentationSelectionSetCreateInput>
  >;
  /** The primary key(s) and patch data for `documentationSelectionSet` for the far side of the relationship. */
  updateByEtag?: InputMaybe<
    Array<DocumentationSelectionSetOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyUsingDocumentationSelectionSetPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `documentationSelectionSet` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<ProviderOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyNodeIdUpdate>
  >;
  /** The primary key(s) and patch data for `documentationSelectionSet` for the far side of the relationship. */
  updateByS3Key?: InputMaybe<
    Array<DocumentationSelectionSetOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyUsingDocumentationSelectionSetS3KeyKeyUpdate>
  >;
};

export type DocumentationSelectionSetStddevPopulationAggregateFilter = {
  selectionSet?: InputMaybe<BigFloatFilter>;
};

export type DocumentationSelectionSetStddevPopulationAggregates = {
  __typename?: "DocumentationSelectionSetStddevPopulationAggregates";
  /** Population standard deviation of selectionSet across the matching connection */
  selectionSet?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type DocumentationSelectionSetStddevSampleAggregateFilter = {
  selectionSet?: InputMaybe<BigFloatFilter>;
};

export type DocumentationSelectionSetStddevSampleAggregates = {
  __typename?: "DocumentationSelectionSetStddevSampleAggregates";
  /** Sample standard deviation of selectionSet across the matching connection */
  selectionSet?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type DocumentationSelectionSetSumAggregateFilter = {
  selectionSet?: InputMaybe<BigIntFilter>;
};

export type DocumentationSelectionSetSumAggregates = {
  __typename?: "DocumentationSelectionSetSumAggregates";
  /** Sum of selectionSet across the matching connection */
  selectionSet: Scalars["BigInt"]["output"];
};

export type DocumentationSelectionSetVariancePopulationAggregateFilter = {
  selectionSet?: InputMaybe<BigFloatFilter>;
};

export type DocumentationSelectionSetVariancePopulationAggregates = {
  __typename?: "DocumentationSelectionSetVariancePopulationAggregates";
  /** Population variance of selectionSet across the matching connection */
  selectionSet?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type DocumentationSelectionSetVarianceSampleAggregateFilter = {
  selectionSet?: InputMaybe<BigFloatFilter>;
};

export type DocumentationSelectionSetVarianceSampleAggregates = {
  __typename?: "DocumentationSelectionSetVarianceSampleAggregates";
  /** Sample variance of selectionSet across the matching connection */
  selectionSet?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** A connection to a list of `DocumentationSelectionSet` values. */
export type DocumentationSelectionSetsConnection = {
  __typename?: "DocumentationSelectionSetsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<DocumentationSelectionSetAggregates>;
  /** A list of edges which contains the `DocumentationSelectionSet` and cursor to aid in pagination. */
  edges: Array<DocumentationSelectionSetsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<DocumentationSelectionSetAggregates>>;
  /** A list of `DocumentationSelectionSet` objects. */
  nodes: Array<Maybe<DocumentationSelectionSet>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentationSelectionSet` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `DocumentationSelectionSet` values. */
export type DocumentationSelectionSetsConnectiongroupedAggregatesArgs = {
  groupBy: Array<DocumentationSelectionSetGroupBy>;
  having?: InputMaybe<DocumentationSelectionSetHavingInput>;
};

/** A `DocumentationSelectionSet` edge in the connection. */
export type DocumentationSelectionSetsEdge = {
  __typename?: "DocumentationSelectionSetsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DocumentationSelectionSet` at the end of the edge. */
  node?: Maybe<DocumentationSelectionSet>;
};

/** Methods to use when ordering `DocumentationSelectionSet`. */
export enum DocumentationSelectionSetsOrderBy {
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ETAG_ASC = "ETAG_ASC",
  ETAG_DESC = "ETAG_DESC",
  FILENAME_ASC = "FILENAME_ASC",
  FILENAME_DESC = "FILENAME_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__CITY_ASC = "PROVIDER_BY_PROVIDER_ID__CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__CITY_DESC = "PROVIDER_BY_PROVIDER_ID__CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC",
  PROVIDER_BY_PROVIDER_ID__ID_ASC = "PROVIDER_BY_PROVIDER_ID__ID_ASC",
  PROVIDER_BY_PROVIDER_ID__ID_DESC = "PROVIDER_BY_PROVIDER_ID__ID_DESC",
  PROVIDER_BY_PROVIDER_ID__NAME_ASC = "PROVIDER_BY_PROVIDER_ID__NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__NAME_DESC = "PROVIDER_BY_PROVIDER_ID__NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__NPI_ASC = "PROVIDER_BY_PROVIDER_ID__NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__NPI_DESC = "PROVIDER_BY_PROVIDER_ID__NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC",
  PROVIDER_BY_PROVIDER_ID__SPEC_ASC = "PROVIDER_BY_PROVIDER_ID__SPEC_ASC",
  PROVIDER_BY_PROVIDER_ID__SPEC_DESC = "PROVIDER_BY_PROVIDER_ID__SPEC_DESC",
  PROVIDER_BY_PROVIDER_ID__STATE_ASC = "PROVIDER_BY_PROVIDER_ID__STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__STATE_DESC = "PROVIDER_BY_PROVIDER_ID__STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC",
  PROVIDER_ID_ASC = "PROVIDER_ID_ASC",
  PROVIDER_ID_DESC = "PROVIDER_ID_DESC",
  S3_KEY_ASC = "S3_KEY_ASC",
  S3_KEY_DESC = "S3_KEY_DESC",
  SELECTION_SET_ASC = "SELECTION_SET_ASC",
  SELECTION_SET_DESC = "SELECTION_SET_DESC",
}

export type DuplicateLifecycleRoleInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  sourceRoleId: Scalars["UUID"]["input"];
};

export type EditAuditorUserInput = {
  facilities: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type EmailServerResponse = {
  __typename?: "EmailServerResponse";
  rejected?: Maybe<Scalars["String"]["output"]>;
  response?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export enum EventHistoryExcludeType {
  DOCUMENT_UPLOADS = "DOCUMENT_UPLOADS",
  LIFECYCLE_FACETS = "LIFECYCLE_FACETS",
  NON_LIFECYCLE_FACETS = "NON_LIFECYCLE_FACETS",
  STATES = "STATES",
}

/** Facet definition - metadata about a facet category */
export type Facet = {
  __typename?: "Facet";
  createdAt: Scalars["Datetime"]["output"];
  dataType: FacetDataType;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  /** Keywords (values) available for this facet */
  keywords: Array<FacetKeyword>;
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

/** Facet definition - metadata about a facet category */
export type FacetkeywordsArgs = {
  includeInactive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Raw facet filter leaf with type-specific casting. Specifies the facet by key (slug or UUID), declares the data type so SQL emission casts correctly, and applies operators in `filter`. Prefer typed facet filter inputs (e.g. claimStageFacetFilter) when one exists for the facet you want to filter on. */
export type FacetConditionInput = {
  /** Comparison operators to apply */
  filter: FacetValueFilterInput;
  /** The facet key to filter on. Accepts a slug (e.g. "audit_status") or the resolved UUID. Slugs are resolved via uuidv5 sync, no DB. */
  key: Scalars["String"]["input"];
  /** Data type of the facet value. Determines SQL cast emission so the planner can match expression indexes (e.g. ::uuid for keyword). */
  type: FacetValueType;
};

/** Facet data type enumeration */
export enum FacetDataType {
  BLOCKER_INSTANCES = "BLOCKER_INSTANCES",
  BLOCKER_LIFECYCLE_AGGREGATE = "BLOCKER_LIFECYCLE_AGGREGATE",
  BLOCKER_PHASE_POINTER = "BLOCKER_PHASE_POINTER",
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
  KEYWORD = "KEYWORD",
  LIFECYCLE_AGGREGATE = "LIFECYCLE_AGGREGATE",
  LIFECYCLE_PHASE_POINTER = "LIFECYCLE_PHASE_POINTER",
  NUMBER = "NUMBER",
  STRING = "STRING",
  UUID = "UUID",
}

/** Facet data type definition */
export type FacetDataTypeDef = {
  __typename?: "FacetDataTypeDef";
  description?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
};

/** Recursive composition for claim facet filtering. Sibling fields imply AND (standard GraphQL filter idiom). Use `and` / `or` / `not` for explicit logical composition. The `facet` slot accepts a raw FacetConditionInput; typed slots (e.g. `claimStage`) provide ergonomic, index-matched alternatives. All slots compile to a single optimized EXISTS subquery against v3.claim_facets. */
export type FacetFilterInput = {
  /** Combine nested filters with AND logic */
  and?: InputMaybe<Array<FacetFilterInput>>;
  /** Filter by audit status keyword (e.g. "CLAIM_READY", "CLOSED"). Values may be supplied as the keyword slug or its resolved UUID. Slugs are resolved sync via uuidv5; no DB lookup. Backed by claim_facets_audit_status_idx (uuid expression btree). NOTE: planned for removal — see source file header. */
  auditStatus?: InputMaybe<AuditStatusFacetFilterInput>;
  /** Filter by claim lifecycle phase keyword (e.g. "intake", "audit"). Values may be supplied as the keyword slug or its resolved UUID. Slugs are resolved sync via uuidv5; no DB lookup. Backed by idx_claim_facets_phase_extracted (uuid expression btree). */
  claimPhase?: InputMaybe<ClaimPhaseFacetFilterInput>;
  /** Filter by claim lifecycle stage. Stage values are compound slugs in the form `<phase>/<stage>` (e.g. "audit/QA_REVIEW") or stage keyword UUIDs. The compound form is required for slugs because stage slugs may collide across phase facets. Backed by idx_claim_facets_stage_extracted (uuid expression btree). */
  claimStage?: InputMaybe<ClaimStageFacetFilterInput>;
  /** Filter by Document blocker stage. Stage values are slugs from the document blocker category (e.g. "DOCUMENT_NEEDED") or stage keyword UUIDs. `isNull: true` matches claims with no active Document blocker. Claims may have multiple blocker categories active simultaneously. Use top-level `or` to combine blank with stage multi-select. */
  documentBlockerStage?: InputMaybe<DocumentBlockerStageFacetFilterInput>;
  /** Raw facet filter leaf. Use a typed slot (e.g. `claimStage`) when one exists for your facet — typed slots ensure the SQL cast matches the corresponding expression index. */
  facet?: InputMaybe<FacetConditionInput>;
  /** Negate the nested filter */
  not?: InputMaybe<FacetFilterInput>;
  /** Filter by On Hold blocker stage. Stage values are slugs from the on_hold blocker category (e.g. "ON_HOLD") or stage keyword UUIDs. `isNull: true` matches claims with no active On Hold blocker. Claims may have multiple blocker categories active simultaneously. Use top-level `or` to combine blank with stage multi-select. */
  onHoldBlockerStage?: InputMaybe<OnHoldBlockerStageFacetFilterInput>;
  /** Combine nested filters with OR logic */
  or?: InputMaybe<Array<FacetFilterInput>>;
};

/** Raw facet-history filter leaf. Match rows in claim_facet_history where the write targeted the given facet key and the recorded value matches the operator predicate. Storage shape: history rows have path = "/<facet-uuid>" and value = to_jsonb(scalar). Prefer typed history slots when one exists for your facet. */
export type FacetHistoryConditionInput = {
  /** Value operators to apply against the history value. */
  filter: FacetHistoryValueFilterInput;
  /** Facet key. Slug (e.g. "claim_lifecycle_phase") or resolved UUID. */
  key: Scalars["String"]["input"];
  /** Data type of the facet value. History values are stored as jsonb strings for all facets in scope; the type here is for slug resolution consistency with the current-state side. */
  type: FacetValueType;
};

/** Recursive composition for claim facet history filtering. Sibling fields imply AND; use and/or/not for explicit composition. All slots compile to a single optimized EXISTS subquery against v3.claim_facet_history. Peer to FacetFilterInput; the two are independent — compose current-and-history predicates at the outer condition/filter level, not within either tree. */
export type FacetHistoryFilterInput = {
  /** Combine nested filters with AND logic. */
  and?: InputMaybe<Array<FacetHistoryFilterInput>>;
  /** Match claims that ever had claim_lifecycle_phase set to the given value in their history. Values may be phase slugs (e.g. "audit") or the resolved phase UUID. Slugs are resolved sync via uuidv5; no DB lookup. Backed by two btree indexes on v3.claim_facet_history: idx_claim_facet_history_claim_path_value serves the per-claim correlated subquery when outer batch_claim is already narrowed (the common filter case); idx_claim_facet_history_path_value_claim serves sparse cross-claim scans like "any claim ever in <rare phase>" when no outer narrowing exists. */
  claimPreviouslyInPhase?: InputMaybe<ClaimPreviouslyInPhaseFacetFilterInput>;
  /** Match claims that ever had claim_lifecycle_stage set to the given value in their history. Values are compound slugs in the form `<phase>/<stage>` (e.g. "audit/QA_REVIEW") or stage keyword UUIDs. Compound slugs are resolved sync via uuidv5; no DB lookup. Backed by two btree indexes on v3.claim_facet_history: idx_claim_facet_history_claim_path_value serves the per-claim correlated subquery when outer batch_claim is already narrowed (the common filter case); idx_claim_facet_history_path_value_claim serves sparse cross-claim scans like "any claim ever in <rare stage>" when no outer narrowing exists. */
  claimPreviouslyInStage?: InputMaybe<ClaimPreviouslyInStageFacetFilterInput>;
  /** Raw facet-history filter leaf. Match history rows by facet key and value. */
  facetHistory?: InputMaybe<FacetHistoryConditionInput>;
  /** Negate the nested filter. */
  not?: InputMaybe<FacetHistoryFilterInput>;
  /** Combine nested filters with OR logic. */
  or?: InputMaybe<Array<FacetHistoryFilterInput>>;
};

/** Comparison operators for matching a value in claim facet history. History rows store the value that was written at a moment in time; each row is one write. Use `equalTo` to match a specific value or `in` to match any of several. Negation is expressed with `not:` at the graph level. */
export type FacetHistoryValueFilterInput = {
  /** Match if any history row for this facet key has this value. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match if any history row for this facet key has any of these values. */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Facet keyword (value) for a facet */
export type FacetKeyword = {
  __typename?: "FacetKeyword";
  colorCode?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Datetime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  /** The facet this keyword belongs to */
  facet?: Maybe<Facet>;
  facetId: Scalars["UUID"]["output"];
  iconCode?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

/** Comparison operators for filtering a facet value. NOTE: Pattern matching operators (includes, startsWith, endsWith, like) work on stored values. For keyword facets, stored values are UUIDs, so use equalTo/in/notIn with keyword slugs instead. Query BatchClaim.claimFacet.facets to inspect stored values. */
export type FacetValueFilterInput = {
  /** Pattern match: ends with substring. Works on stored value (UUID for keywords) */
  endsWith?: InputMaybe<Scalars["String"]["input"]>;
  /** Exact match. For keyword facets, use keyword slug (e.g., "CLAIM_READY") */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  greaterThan?: InputMaybe<Scalars["String"]["input"]>;
  greaterThanOrEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match any value in array. For keyword facets, use keyword slugs */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Pattern match: contains substring. Works on stored value (UUID for keywords) */
  includes?: InputMaybe<Scalars["String"]["input"]>;
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  lessThan?: InputMaybe<Scalars["String"]["input"]>;
  lessThanOrEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Pattern match: SQL LIKE pattern. Works on stored value (UUID for keywords) */
  like?: InputMaybe<Scalars["String"]["input"]>;
  /** Not equal. For keyword facets, use keyword slug */
  notEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match none of the values in array. For keyword facets, use keyword slugs */
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Pattern match: starts with substring. Works on stored value (UUID for keywords) */
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
};

/** Data type of a facet value for type-specific filtering and comparison */
export enum FacetValueType {
  /** Cast as boolean */
  BOOLEAN = "BOOLEAN",
  /** Cast as date */
  DATE = "DATE",
  /** Keep as JSON */
  JSON = "JSON",
  /** Cast as uuid. Use for keyword facets (stored values are keyword UUIDs). Slug values in equalTo/in/notIn are resolved to keyword UUIDs via uuidv5 before SQL emission. Matches the per-facet uuid expression btree indexes (idx_claim_facets_<facet>_extracted). */
  KEYWORD = "KEYWORD",
  /** Cast as numeric/decimal */
  NUMERIC = "NUMERIC",
  /** Cast as text */
  STRING = "STRING",
}

export type FeatureFlag = {
  __typename?: "FeatureFlag";
  enabled: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
};

/**
 * Debug payload showing every registered flag's resolved value
 * for the calling user, plus the evaluation context used for feature-flag evaluation.
 */
export type FeatureFlagDebugResult = {
  __typename?: "FeatureFlagDebugResult";
  /** The OpenFeature evaluation context used for feature-flag evaluation on this request. */
  evaluationContext: Scalars["JSON"]["output"];
  flags: Array<FeatureFlagValue>;
};

/**
 * One feature flag's resolved value for the calling user, with enough
 * metadata to debug targeting issues.
 */
export type FeatureFlagValue = {
  __typename?: "FeatureFlagValue";
  /** Registry default — what callers receive when DevCycle is unreachable or the flag is missing. */
  defaultValue?: Maybe<Scalars["JSON"]["output"]>;
  /**
   * The OpenFeature evaluation context used to resolve this flag for the
   * calling user (user_id, customData.role, customData.tenant, etc.).
   * Use it to confirm which targeting inputs — e.g. which tenant — were
   * sent to DevCycle. Evaluates against the calling user's own context
   * only; it does not impersonate other users.
   */
  evaluationContext?: Maybe<Scalars["JSON"]["output"]>;
  /** True when resolvedValue equals defaultValue. */
  isDefault: Scalars["Boolean"]["output"];
  /** DevCycle flag key (kebab-case). */
  key: Scalars["String"]["output"];
  /** Value returned for the calling user's evaluation context. */
  resolvedValue?: Maybe<Scalars["JSON"]["output"]>;
  /** Flag type from the registry: boolean, string, number, or object. */
  type: Scalars["String"]["output"];
};

export type File = {
  __typename?: "File";
  archived: Scalars["Boolean"]["output"];
  createdAt: Scalars["String"]["output"];
  deleted: Scalars["Boolean"]["output"];
  documentStates?: Maybe<Array<DocumentStateEnum>>;
  fileAiAnnotations?: Maybe<Array<FileAiAnnotation>>;
  fileName: Scalars["String"]["output"];
  fileUserAnnotations?: Maybe<Array<FileUserAnnotation>>;
  id: Scalars["ID"]["output"];
  modifiedAt: Scalars["String"]["output"];
  parentDirectory?: Maybe<Directory>;
  readyToSearch: Scalars["Boolean"]["output"];
  signedDownloadUrl?: Maybe<SignedDownloadUrl>;
  size: Scalars["Int"]["output"];
  /**
   * The timestamp when the document upload was first confirmed by the system.
   *
   * Returns NULL in the following cases:
   * - Document was created on or before 2024-11-05 (pre-migration data limitation)
   * - Document upload was never confirmed (no processing states exist)
   *
   * For documents uploaded after 2024-11-05, this represents the earliest timestamp
   * when the system confirmed it received/processed the file. This is typically
   * within seconds of the user-initiated upload (98.6% of cases), but may be later
   * if the upload was healed by automated processing (0.2% of cases).
   */
  uploadConfirmedAt?: Maybe<Scalars["String"]["output"]>;
  uploadPending: Scalars["Boolean"]["output"];
};

export type FileAiAnnotation = Annotation & {
  __typename?: "FileAiAnnotation";
  authorId: Scalars["ID"]["output"];
  comment?: Maybe<Scalars["String"]["output"]>;
  coordinates: Array<FileAnnotationCoordinates>;
  createdAt: Scalars["Datetime"]["output"];
  file?: Maybe<File>;
  fileId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  pageIndex: Scalars["Int"]["output"];
  sourceText?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

export type FileAnnotationCoordinates = {
  __typename?: "FileAnnotationCoordinates";
  height: Scalars["Float"]["output"];
  left: Scalars["Float"]["output"];
  top: Scalars["Float"]["output"];
  width: Scalars["Float"]["output"];
};

export type FileAnnotationCoordinatesInput = {
  height: Scalars["Float"]["input"];
  left: Scalars["Float"]["input"];
  top: Scalars["Float"]["input"];
  width: Scalars["Float"]["input"];
};

export type FileOrDirectory = Directory | File;

export type FileUserAnnotation = Annotation & {
  __typename?: "FileUserAnnotation";
  authorId: Scalars["ID"]["output"];
  comment?: Maybe<Scalars["String"]["output"]>;
  coordinates: Array<FileAnnotationCoordinates>;
  createdAt: Scalars["Datetime"]["output"];
  creator?: Maybe<AuditorUser>;
  file?: Maybe<File>;
  fileId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  pageIndex: Scalars["Int"]["output"];
  sourceText?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

export type FilesInput = {
  archived?: InputMaybe<Scalars["Boolean"]["input"]>;
  caseId?: InputMaybe<Scalars["ID"]["input"]>;
  fileIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  parentDirectoryId?: InputMaybe<Scalars["ID"]["input"]>;
  queueId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type Finding = {
  __typename?: "Finding";
  accepted?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use createdBy. Kept for backwards compatibility while consumers migrate. */
  author: FindingAuthor;
  autodorFindingId?: Maybe<Scalars["UUID"]["output"]>;
  autodorFindingS3Key?: Maybe<Scalars["String"]["output"]>;
  confidence?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  createdBy: FindingCreatedBy;
  findingItemizedBillData?: Maybe<FindingItemizedBillData>;
  id: Scalars["UUID"]["output"];
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  improperPaymentReason?: Maybe<Scalars["String"]["output"]>;
  improperPaymentUnitsCharged?: Maybe<Scalars["Int"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  isOriginal?: Maybe<Scalars["Boolean"]["output"]>;
  latestReview?: Maybe<LatestReview>;
  metaDataAocPrimaryCode?: Maybe<Scalars["String"]["output"]>;
  metaDataEmCode?: Maybe<Scalars["String"]["output"]>;
  metaDataEmCorrectLevel?: Maybe<Scalars["Int"]["output"]>;
  metaDataEmOriginalLevel?: Maybe<Scalars["Int"]["output"]>;
  metaDataNcciMueAdjudicationValue?: Maybe<Scalars["Int"]["output"]>;
  metaDataNcciMueOhpMueValue?: Maybe<Scalars["Int"]["output"]>;
  metaDataNcciPtpCode?: Maybe<Scalars["String"]["output"]>;
  metaDataNcciPtpModifier?: Maybe<Scalars["Int"]["output"]>;
  metaDataPricingCorrectPrice?: Maybe<Scalars["Float"]["output"]>;
  metaDataUnitsCorrectUnits?: Maybe<Scalars["Int"]["output"]>;
  needsReview: Scalars["Boolean"]["output"];
  ruleType?: Maybe<Scalars["String"]["output"]>;
  seedType?: Maybe<Scalars["String"]["output"]>;
  status: FindingStatus;
  superseded?: Maybe<Scalars["Boolean"]["output"]>;
  updatedAt?: Maybe<Scalars["Date"]["output"]>;
};

export type FindingAuthor = {
  __typename?: "FindingAuthor";
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  lastName: Scalars["String"]["output"];
  userType: Scalars["String"]["output"];
};

/**
 * The user or automation credited with authoring a Finding. Discriminated
 * by which registry the finding's row points at: NULL automation columns
 * → CreatedByUser (read from auditor_user); populated → CreatedByAutomation
 * (read live from automation_author so renames propagate).
 */
export type FindingCreatedBy = CreatedByAutomation | CreatedByUser;

/**
 * Multi-select author filter for Claim.findings. userIds matches the
 * finding's author_id for human-authored findings; automationSourceIds
 * matches the rule or agent that produced the finding. Both arrays are
 * unioned so a caller can select humans AND automations in one request.
 * Omitted or all-empty means no constraint.
 */
export type FindingCreatedByFilterInput = {
  automationSourceIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  userIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
};

export type FindingItemizedBillData = {
  __typename?: "FindingItemizedBillData";
  alaRowId?: Maybe<Scalars["UUID"]["output"]>;
  authorId?: Maybe<Scalars["UUID"]["output"]>;
  batchClaimLineId?: Maybe<Scalars["UUID"]["output"]>;
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  dateOfServiceEnd?: Maybe<Scalars["Date"]["output"]>;
  dateOfServiceStart?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  ibLineId?: Maybe<Scalars["UUID"]["output"]>;
  ibLineVersionFingerprint?: Maybe<Scalars["UUID"]["output"]>;
  id?: Maybe<Scalars["UUID"]["output"]>;
  itemNumber?: Maybe<Scalars["String"]["output"]>;
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  originalBilledAmount?: Maybe<Scalars["Float"]["output"]>;
  procedureCode?: Maybe<Scalars["String"]["output"]>;
  procedureCodeModifier?: Maybe<Scalars["String"]["output"]>;
  revCode?: Maybe<Scalars["String"]["output"]>;
  s3InputSource?: Maybe<Scalars["String"]["output"]>;
  stale?: Maybe<Scalars["Boolean"]["output"]>;
  unitCharge?: Maybe<Scalars["Float"]["output"]>;
  units?: Maybe<Scalars["Int"]["output"]>;
  updatedAt?: Maybe<Scalars["Date"]["output"]>;
  versionFingerprint?: Maybe<Scalars["UUID"]["output"]>;
};

/**
 * Patch applied uniformly to every finding in updateFindings.
 * Patch semantics follow GraphQL convention:
 * - omitting a field leaves the predecessor's value unchanged
 * - setting a field to a value overlays it on the successor
 * - setting a field to null clears the column (currently meaningful
 *   only on nullable columns; today the four scalar columns are NOT
 *   NULL, so null will fail at insert time — omit the field instead)
 *
 * Status DECLINED writes a declining verdict on the successor;
 * ACCEPTED or omitted writes an accepting verdict (the auditor's
 * save is read as endorsement). When ACCEPTED, prior accepted
 * findings on the same IB lines are auto-declined.
 */
export type FindingPatch = {
  /** Batch claim line (UB line) association on the successor. Setting this to a different line than the predecessor's breaks lineage — the predecessor is declined and the successor is written as a brand-new finding on the new line. Omit to keep predecessor's value; null to clear. */
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Denial code on the successor. Omit to keep predecessor's value; null to clear. */
  denialCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Determined savings on the successor. Omit to keep predecessor's value; null to clear. */
  determinedSavings?: InputMaybe<Scalars["Float"]["input"]>;
  /** Discrepant billed amount on the successor. Omit to keep predecessor's value; null to clear. */
  discrepantBilledAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Discrepant quantity on the successor. Omit to keep predecessor's value; null to clear. */
  discrepantQuantity?: InputMaybe<Scalars["Int"]["input"]>;
  /** Rationale text on the successor. Omit to keep predecessor's value; null to clear. */
  rationale?: InputMaybe<Scalars["String"]["input"]>;
  /** Rev code on the successor. Omit to keep predecessor's value; null to clear. */
  revCode?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<FindingStatus>;
};

/**
 * Status of a Finding, expressing whether a human has rendered a verdict on it:
 * - ACCEPTED  — a human accepted the finding most recently.
 * - DECLINED  — a human declined the finding most recently.
 * - SUGGESTED — the finding has no current human verdict and is awaiting review.
 *   Either it was created by an upstream service (e.g. Autodor) awaiting
 *   auditor review, or any prior verdict has been withdrawn (soft-deleted).
 *
 * Derived at query time from the latest non-deleted reviewed_audit_finding;
 * no column is persisted on audit_finding.
 */
export enum FindingStatus {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  SUGGESTED = "SUGGESTED",
}

export type FindingStatusCounts = {
  __typename?: "FindingStatusCounts";
  accepted: Scalars["Int"]["output"];
  declined: Scalars["Int"]["output"];
  suggested: Scalars["Int"]["output"];
};

export type FindingV2 = {
  __typename?: "FindingV2";
  accepted?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use createdBy. Kept for backwards compatibility while consumers migrate. */
  author: FindingAuthor;
  autodorFindingId?: Maybe<Scalars["UUID"]["output"]>;
  autodorFindingS3Key?: Maybe<Scalars["String"]["output"]>;
  batchClaimLineId: Scalars["UUID"]["output"];
  batchClaimLineItemAudit?: Maybe<BatchClaimLineItemAuditV2>;
  confidence?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  createdBy: FindingCreatedBy;
  id: Scalars["UUID"]["output"];
  improperPaymentCost?: Maybe<Scalars["Float"]["output"]>;
  improperPaymentReason?: Maybe<Scalars["String"]["output"]>;
  improperPaymentUnitsCharged?: Maybe<Scalars["Int"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  isOriginal?: Maybe<Scalars["Boolean"]["output"]>;
  latestReview?: Maybe<LatestReview>;
  metaDataAocPrimaryCode?: Maybe<Scalars["String"]["output"]>;
  metaDataEmCode?: Maybe<Scalars["String"]["output"]>;
  metaDataEmCorrectLevel?: Maybe<Scalars["Int"]["output"]>;
  metaDataEmOriginalLevel?: Maybe<Scalars["Int"]["output"]>;
  metaDataNcciMueAdjudicationValue?: Maybe<Scalars["Int"]["output"]>;
  metaDataNcciMueOhpMueValue?: Maybe<Scalars["Int"]["output"]>;
  metaDataNcciPtpCode?: Maybe<Scalars["String"]["output"]>;
  metaDataNcciPtpModifier?: Maybe<Scalars["Int"]["output"]>;
  metaDataPricingCorrectPrice?: Maybe<Scalars["Float"]["output"]>;
  metaDataUnitsCorrectUnits?: Maybe<Scalars["Int"]["output"]>;
  needsReview: Scalars["Boolean"]["output"];
  ruleType?: Maybe<Scalars["String"]["output"]>;
  seedType?: Maybe<Scalars["String"]["output"]>;
  status: FindingStatus;
  superseded?: Maybe<Scalars["Boolean"]["output"]>;
  updatedAt?: Maybe<Scalars["Date"]["output"]>;
};

/** The `auditorBucket` to be created by this mutation. */
export type FkeyAuditorBucketProviderIdAuditorBucketCreateInput = {
  assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
  auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `provider` in the `AuditorBucketInput` mutation. */
export type FkeyAuditorBucketProviderIdInput = {
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectById?: InputMaybe<ProviderProviderPkeyConnect>;
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProviderNodeIdConnect>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateById?: InputMaybe<ProviderOnAuditorBucketForFkeyAuditorBucketProviderIdUsingProviderPkeyUpdate>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditorBucketOnAuditorBucketForFkeyAuditorBucketProviderIdNodeIdUpdate>;
};

/** Input for the nested mutation of `auditorBucket` in the `ProviderInput` mutation. */
export type FkeyAuditorBucketProviderIdInverseInput = {
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditorBucketAuditorBucketPkeyConnect>>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditorBucketNodeIdConnect>>;
  /** A `AuditorBucketInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FkeyAuditorBucketProviderIdAuditorBucketCreateInput>
  >;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AuditorBucketAuditorBucketPkeyDelete>>;
  /** The primary key(s) for `auditorBucket` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<AuditorBucketNodeIdDelete>>;
  /** Flag indicating whether all other `auditorBucket` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditorBucketOnAuditorBucketForFkeyAuditorBucketProviderIdUsingAuditorBucketPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditorBucket` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<ProviderOnAuditorBucketForFkeyAuditorBucketProviderIdNodeIdUpdate>
  >;
};

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["Float"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["Float"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["Float"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["Float"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["Float"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["Float"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["Float"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["Float"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
};

export type FloatStat = {
  __typename?: "FloatStat";
  description: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  operationType: OperationTypeEnum;
  units: FloatUnitsEnum;
  value: Scalars["Float"]["output"];
};

export enum FloatUnitsEnum {
  DOLLARS = "DOLLARS",
}

export type FoxitCredentials = {
  __typename?: "FoxitCredentials";
  key: Scalars["String"]["output"];
  sn: Scalars["String"]["output"];
};

export type GenerateReportResponse = {
  __typename?: "GenerateReportResponse";
  auditFindingReportId?: Maybe<Scalars["UUID"]["output"]>;
  auditFindingReportViewId: Scalars["UUID"]["output"];
  reportUrl: Scalars["String"]["output"];
};

export type HavingBigfloatFilter = {
  equalTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
  greaterThan?: InputMaybe<Scalars["BigFloat"]["input"]>;
  greaterThanOrEqualTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
  lessThan?: InputMaybe<Scalars["BigFloat"]["input"]>;
  lessThanOrEqualTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
  notEqualTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
};

export type HavingBigintFilter = {
  equalTo?: InputMaybe<Scalars["BigInt"]["input"]>;
  greaterThan?: InputMaybe<Scalars["BigInt"]["input"]>;
  greaterThanOrEqualTo?: InputMaybe<Scalars["BigInt"]["input"]>;
  lessThan?: InputMaybe<Scalars["BigInt"]["input"]>;
  lessThanOrEqualTo?: InputMaybe<Scalars["BigInt"]["input"]>;
  notEqualTo?: InputMaybe<Scalars["BigInt"]["input"]>;
};

export type HavingDatetimeFilter = {
  equalTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  greaterThan?: InputMaybe<Scalars["Datetime"]["input"]>;
  greaterThanOrEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  lessThan?: InputMaybe<Scalars["Datetime"]["input"]>;
  lessThanOrEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  notEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type HavingFloatFilter = {
  equalTo?: InputMaybe<Scalars["Float"]["input"]>;
  greaterThan?: InputMaybe<Scalars["Float"]["input"]>;
  greaterThanOrEqualTo?: InputMaybe<Scalars["Float"]["input"]>;
  lessThan?: InputMaybe<Scalars["Float"]["input"]>;
  lessThanOrEqualTo?: InputMaybe<Scalars["Float"]["input"]>;
  notEqualTo?: InputMaybe<Scalars["Float"]["input"]>;
};

export type HavingIntFilter = {
  equalTo?: InputMaybe<Scalars["Int"]["input"]>;
  greaterThan?: InputMaybe<Scalars["Int"]["input"]>;
  greaterThanOrEqualTo?: InputMaybe<Scalars["Int"]["input"]>;
  lessThan?: InputMaybe<Scalars["Int"]["input"]>;
  lessThanOrEqualTo?: InputMaybe<Scalars["Int"]["input"]>;
  notEqualTo?: InputMaybe<Scalars["Int"]["input"]>;
};

export type HistoricStatistics = {
  __typename?: "HistoricStatistics";
  allowedAmount: FloatStat;
  billedAmount: FloatStat;
  claimsAssigned: IntStat;
  claimsCompleted: IntStat;
  claimsInProgress: IntStat;
  claimsReceived: IntStat;
  claimsReviewed: IntStat;
  clientRealizedSavings: FloatStat;
  determinedDiscrepantAmount: FloatStat;
  numberOfLives: IntStat;
  numberOfProviders: IntStat;
  savingsPerLife: FloatStat;
};

export type HistoryTimelineEvent = {
  __typename?: "HistoryTimelineEvent";
  action: Scalars["String"]["output"];
  actor?: Maybe<AuditorUser>;
  created_at: Scalars["String"]["output"];
  eventType: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  metaData?: Maybe<Scalars["String"]["output"]>;
};

export type HistoryTimelineEvents = {
  __typename?: "HistoryTimelineEvents";
  events: Array<Maybe<HistoryTimelineEvent>>;
};

export type HumanProcessingRequest = Node & {
  __typename?: "HumanProcessingRequest";
  createdAt?: Maybe<Scalars["Datetime"]["output"]>;
  errorDetails?: Maybe<Scalars["String"]["output"]>;
  extraDetails?: Maybe<Scalars["JSON"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  priority: Scalars["Int"]["output"];
  pulledDates?: Maybe<Array<Maybe<Scalars["Datetime"]["output"]>>>;
  requestType: HumanProcessingRequestType;
  requeuedDates?: Maybe<Array<Maybe<Scalars["Datetime"]["output"]>>>;
  runId: Scalars["Int"]["output"];
  /** Reads a single `S3AuditDocumentation` that is related to this `HumanProcessingRequest`. */
  s3AuditDocumentation?: Maybe<S3AuditDocumentation>;
  s3AuditDocumentationId: Scalars["UUID"]["output"];
  status: HumanProcessingRequestStatus;
  successDetails?: Maybe<Scalars["JSON"]["output"]>;
  updatedAt?: Maybe<Scalars["Datetime"]["output"]>;
  username?: Maybe<Scalars["String"]["output"]>;
};

export type HumanProcessingRequestAggregates = {
  __typename?: "HumanProcessingRequestAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<HumanProcessingRequestAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<HumanProcessingRequestDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<HumanProcessingRequestMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<HumanProcessingRequestMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<HumanProcessingRequestStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<HumanProcessingRequestStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<HumanProcessingRequestSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<HumanProcessingRequestVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<HumanProcessingRequestVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `HumanProcessingRequest` object types. */
export type HumanProcessingRequestAggregatesFilter = {
  /** Mean average aggregate over matching `HumanProcessingRequest` objects. */
  average?: InputMaybe<HumanProcessingRequestAverageAggregateFilter>;
  /** Distinct count aggregate over matching `HumanProcessingRequest` objects. */
  distinctCount?: InputMaybe<HumanProcessingRequestDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `HumanProcessingRequest` object to be included within the aggregate. */
  filter?: InputMaybe<HumanProcessingRequestFilter>;
  /** Maximum aggregate over matching `HumanProcessingRequest` objects. */
  max?: InputMaybe<HumanProcessingRequestMaxAggregateFilter>;
  /** Minimum aggregate over matching `HumanProcessingRequest` objects. */
  min?: InputMaybe<HumanProcessingRequestMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `HumanProcessingRequest` objects. */
  stddevPopulation?: InputMaybe<HumanProcessingRequestStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `HumanProcessingRequest` objects. */
  stddevSample?: InputMaybe<HumanProcessingRequestStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `HumanProcessingRequest` objects. */
  sum?: InputMaybe<HumanProcessingRequestSumAggregateFilter>;
  /** Population variance aggregate over matching `HumanProcessingRequest` objects. */
  variancePopulation?: InputMaybe<HumanProcessingRequestVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `HumanProcessingRequest` objects. */
  varianceSample?: InputMaybe<HumanProcessingRequestVarianceSampleAggregateFilter>;
};

export type HumanProcessingRequestAverageAggregateFilter = {
  priority?: InputMaybe<BigFloatFilter>;
  runId?: InputMaybe<BigFloatFilter>;
};

export type HumanProcessingRequestAverageAggregates = {
  __typename?: "HumanProcessingRequestAverageAggregates";
  /** Mean average of priority across the matching connection */
  priority?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Mean average of runId across the matching connection */
  runId?: Maybe<Scalars["BigFloat"]["output"]>;
};

/**
 * A condition to be used against `HumanProcessingRequest` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type HumanProcessingRequestCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `errorDetails` field. */
  errorDetails?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `extraDetails` field. */
  extraDetails?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `pulledDates` field. */
  pulledDates?: InputMaybe<Array<InputMaybe<Scalars["Datetime"]["input"]>>>;
  /** Checks for equality with the object’s `requestType` field. */
  requestType?: InputMaybe<HumanProcessingRequestType>;
  /** Checks for equality with the object’s `requeuedDates` field. */
  requeuedDates?: InputMaybe<Array<InputMaybe<Scalars["Datetime"]["input"]>>>;
  /** Checks for equality with the object’s `runId` field. */
  runId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `s3AuditDocumentationId` field. */
  s3AuditDocumentationId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<HumanProcessingRequestStatus>;
  /** Checks for equality with the object’s `successDetails` field. */
  successDetails?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `username` field. */
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type HumanProcessingRequestDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  errorDetails?: InputMaybe<BigIntFilter>;
  extraDetails?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  priority?: InputMaybe<BigIntFilter>;
  pulledDates?: InputMaybe<BigIntFilter>;
  requestType?: InputMaybe<BigIntFilter>;
  requeuedDates?: InputMaybe<BigIntFilter>;
  runId?: InputMaybe<BigIntFilter>;
  s3AuditDocumentationId?: InputMaybe<BigIntFilter>;
  status?: InputMaybe<BigIntFilter>;
  successDetails?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  username?: InputMaybe<BigIntFilter>;
};

export type HumanProcessingRequestDistinctCountAggregates = {
  __typename?: "HumanProcessingRequestDistinctCountAggregates";
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of errorDetails across the matching connection */
  errorDetails?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of extraDetails across the matching connection */
  extraDetails?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of priority across the matching connection */
  priority?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of pulledDates across the matching connection */
  pulledDates?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of requestType across the matching connection */
  requestType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of requeuedDates across the matching connection */
  requeuedDates?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of runId across the matching connection */
  runId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of s3AuditDocumentationId across the matching connection */
  s3AuditDocumentationId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of status across the matching connection */
  status?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of successDetails across the matching connection */
  successDetails?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of username across the matching connection */
  username?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `HumanProcessingRequest` object types. All fields are combined with a logical ‘and.’ */
export type HumanProcessingRequestFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<HumanProcessingRequestFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `errorDetails` field. */
  errorDetails?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extraDetails` field. */
  extraDetails?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<HumanProcessingRequestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<HumanProcessingRequestFilter>>;
  /** Filter by the object’s `priority` field. */
  priority?: InputMaybe<IntFilter>;
  /** Filter by the object’s `pulledDates` field. */
  pulledDates?: InputMaybe<DatetimeListFilter>;
  /** Filter by the object’s `requestType` field. */
  requestType?: InputMaybe<HumanProcessingRequestTypeFilter>;
  /** Filter by the object’s `requeuedDates` field. */
  requeuedDates?: InputMaybe<DatetimeListFilter>;
  /** Filter by the object’s `runId` field. */
  runId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `s3AuditDocumentation` relation. */
  s3AuditDocumentation?: InputMaybe<S3AuditDocumentationFilter>;
  /** Filter by the object’s `s3AuditDocumentationId` field. */
  s3AuditDocumentationId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<HumanProcessingRequestStatusFilter>;
  /** Filter by the object’s `successDetails` field. */
  successDetails?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `username` field. */
  username?: InputMaybe<StringFilter>;
};

/** Grouping methods for `HumanProcessingRequest` for usage during aggregation. */
export enum HumanProcessingRequestGroupBy {
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  ERROR_DETAILS = "ERROR_DETAILS",
  EXTRA_DETAILS = "EXTRA_DETAILS",
  PRIORITY = "PRIORITY",
  PULLED_DATES = "PULLED_DATES",
  REQUEST_TYPE = "REQUEST_TYPE",
  REQUEUED_DATES = "REQUEUED_DATES",
  RUN_ID = "RUN_ID",
  S3_AUDIT_DOCUMENTATION_ID = "S3_AUDIT_DOCUMENTATION_ID",
  STATUS = "STATUS",
  SUCCESS_DETAILS = "SUCCESS_DETAILS",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
  USERNAME = "USERNAME",
}

export type HumanProcessingRequestHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  runId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type HumanProcessingRequestHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  runId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `HumanProcessingRequest` aggregates. */
export type HumanProcessingRequestHavingInput = {
  AND?: InputMaybe<Array<HumanProcessingRequestHavingInput>>;
  OR?: InputMaybe<Array<HumanProcessingRequestHavingInput>>;
  average?: InputMaybe<HumanProcessingRequestHavingAverageInput>;
  distinctCount?: InputMaybe<HumanProcessingRequestHavingDistinctCountInput>;
  max?: InputMaybe<HumanProcessingRequestHavingMaxInput>;
  min?: InputMaybe<HumanProcessingRequestHavingMinInput>;
  stddevPopulation?: InputMaybe<HumanProcessingRequestHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<HumanProcessingRequestHavingStddevSampleInput>;
  sum?: InputMaybe<HumanProcessingRequestHavingSumInput>;
  variancePopulation?: InputMaybe<HumanProcessingRequestHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<HumanProcessingRequestHavingVarianceSampleInput>;
};

export type HumanProcessingRequestHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  runId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type HumanProcessingRequestHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  runId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type HumanProcessingRequestHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  runId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type HumanProcessingRequestHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  runId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type HumanProcessingRequestHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  runId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type HumanProcessingRequestHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  runId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type HumanProcessingRequestHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  priority?: InputMaybe<HavingIntFilter>;
  runId?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** The fields on `humanProcessingRequest` to look up the row to connect. */
export type HumanProcessingRequestHumanProcessingRequestPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `humanProcessingRequest` to look up the row to connect. */
export type HumanProcessingRequestHumanProcessingRequestUniqueRunIdAndTypeConnect =
  {
    requestType: HumanProcessingRequestType;
    runId: Scalars["Int"]["input"];
    s3AuditDocumentationId: Scalars["UUID"]["input"];
  };

export type HumanProcessingRequestMaxAggregateFilter = {
  priority?: InputMaybe<IntFilter>;
  runId?: InputMaybe<IntFilter>;
};

export type HumanProcessingRequestMaxAggregates = {
  __typename?: "HumanProcessingRequestMaxAggregates";
  /** Maximum of priority across the matching connection */
  priority?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of runId across the matching connection */
  runId?: Maybe<Scalars["Int"]["output"]>;
};

export type HumanProcessingRequestMinAggregateFilter = {
  priority?: InputMaybe<IntFilter>;
  runId?: InputMaybe<IntFilter>;
};

export type HumanProcessingRequestMinAggregates = {
  __typename?: "HumanProcessingRequestMinAggregates";
  /** Minimum of priority across the matching connection */
  priority?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of runId across the matching connection */
  runId?: Maybe<Scalars["Int"]["output"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type HumanProcessingRequestNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `humanProcessingRequest` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type HumanProcessingRequestOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `s3AuditDocumentation` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `s3AuditDocumentation` being updated. */
    patch: S3AuditDocumentationPatch;
  };

/** The fields on `humanProcessingRequest` to look up the row to update. */
export type HumanProcessingRequestOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyUsingHumanProcessingRequestPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `humanProcessingRequest` being updated. */
    patch: updateHumanProcessingRequestOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyPatch;
  };

/** The fields on `humanProcessingRequest` to look up the row to update. */
export type HumanProcessingRequestOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyUsingHumanProcessingRequestUniqueRunIdAndTypeUpdate =
  {
    /** An object where the defined keys will be set on the `humanProcessingRequest` being updated. */
    patch: updateHumanProcessingRequestOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyPatch;
    requestType: HumanProcessingRequestType;
    runId: Scalars["Int"]["input"];
    s3AuditDocumentationId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `HumanProcessingRequest`. Fields that are set will be updated. */
export type HumanProcessingRequestPatch = {
  s3AuditDocumentationId?: InputMaybe<Scalars["UUID"]["input"]>;
  s3AuditDocumentationToS3AuditDocumentationId?: InputMaybe<HumanProcessingRequestS3AuditDocumentationIdFkeyInput>;
};

/** Input for the nested mutation of `s3AuditDocumentation` in the `HumanProcessingRequestInput` mutation. */
export type HumanProcessingRequestS3AuditDocumentationIdFkeyInput = {
  /** The primary key(s) for `s3AuditDocumentation` for the far side of the relationship. */
  connectById?: InputMaybe<S3AuditDocumentationS3AuditDocumentationPkeyConnect>;
  /** The primary key(s) for `s3AuditDocumentation` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<S3AuditDocumentationNodeIdConnect>;
  /** The primary key(s) and patch data for `s3AuditDocumentation` for the far side of the relationship. */
  updateById?: InputMaybe<S3AuditDocumentationOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyUsingS3AuditDocumentationPkeyUpdate>;
  /** The primary key(s) and patch data for `s3AuditDocumentation` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<HumanProcessingRequestOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `humanProcessingRequest` in the `S3AuditDocumentationInput` mutation. */
export type HumanProcessingRequestS3AuditDocumentationIdFkeyInverseInput = {
  /** The primary key(s) for `humanProcessingRequest` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<HumanProcessingRequestHumanProcessingRequestPkeyConnect>
  >;
  /** The primary key(s) for `humanProcessingRequest` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<HumanProcessingRequestNodeIdConnect>>;
  /** The primary key(s) for `humanProcessingRequest` for the far side of the relationship. */
  connectByRunIdAndS3AuditDocumentationIdAndRequestType?: InputMaybe<
    Array<HumanProcessingRequestHumanProcessingRequestUniqueRunIdAndTypeConnect>
  >;
  /** The primary key(s) and patch data for `humanProcessingRequest` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<HumanProcessingRequestOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyUsingHumanProcessingRequestPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `humanProcessingRequest` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<S3AuditDocumentationOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyNodeIdUpdate>
  >;
  /** The primary key(s) and patch data for `humanProcessingRequest` for the far side of the relationship. */
  updateByRunIdAndS3AuditDocumentationIdAndRequestType?: InputMaybe<
    Array<HumanProcessingRequestOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyUsingHumanProcessingRequestUniqueRunIdAndTypeUpdate>
  >;
};

export enum HumanProcessingRequestStatus {
  CANCELED = "CANCELED",
  FAILURE = "FAILURE",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
}

/** A filter to be used against HumanProcessingRequestStatus fields. All fields are combined with a logical ‘and.’ */
export type HumanProcessingRequestStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<HumanProcessingRequestStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<HumanProcessingRequestStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<HumanProcessingRequestStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<HumanProcessingRequestStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<HumanProcessingRequestStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<HumanProcessingRequestStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<HumanProcessingRequestStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<HumanProcessingRequestStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<HumanProcessingRequestStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<HumanProcessingRequestStatus>>;
};

export type HumanProcessingRequestStddevPopulationAggregateFilter = {
  priority?: InputMaybe<BigFloatFilter>;
  runId?: InputMaybe<BigFloatFilter>;
};

export type HumanProcessingRequestStddevPopulationAggregates = {
  __typename?: "HumanProcessingRequestStddevPopulationAggregates";
  /** Population standard deviation of priority across the matching connection */
  priority?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population standard deviation of runId across the matching connection */
  runId?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type HumanProcessingRequestStddevSampleAggregateFilter = {
  priority?: InputMaybe<BigFloatFilter>;
  runId?: InputMaybe<BigFloatFilter>;
};

export type HumanProcessingRequestStddevSampleAggregates = {
  __typename?: "HumanProcessingRequestStddevSampleAggregates";
  /** Sample standard deviation of priority across the matching connection */
  priority?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample standard deviation of runId across the matching connection */
  runId?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type HumanProcessingRequestSumAggregateFilter = {
  priority?: InputMaybe<BigIntFilter>;
  runId?: InputMaybe<BigIntFilter>;
};

export type HumanProcessingRequestSumAggregates = {
  __typename?: "HumanProcessingRequestSumAggregates";
  /** Sum of priority across the matching connection */
  priority: Scalars["BigInt"]["output"];
  /** Sum of runId across the matching connection */
  runId: Scalars["BigInt"]["output"];
};

export enum HumanProcessingRequestType {
  ANNOTATE_IB = "ANNOTATE_IB",
  CLAIM_REVIEW = "CLAIM_REVIEW",
  CLASSIFY_DOC = "CLASSIFY_DOC",
  COLA_AND_ISIB = "COLA_AND_ISIB",
  EDIT_PDF = "EDIT_PDF",
  INSPECT_STRUCTURE = "INSPECT_STRUCTURE",
  REVIEW_CSV = "REVIEW_CSV",
}

/** A filter to be used against HumanProcessingRequestType fields. All fields are combined with a logical ‘and.’ */
export type HumanProcessingRequestTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<HumanProcessingRequestType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<HumanProcessingRequestType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<HumanProcessingRequestType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<HumanProcessingRequestType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<HumanProcessingRequestType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<HumanProcessingRequestType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<HumanProcessingRequestType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<HumanProcessingRequestType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<HumanProcessingRequestType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<HumanProcessingRequestType>>;
};

export type HumanProcessingRequestVariancePopulationAggregateFilter = {
  priority?: InputMaybe<BigFloatFilter>;
  runId?: InputMaybe<BigFloatFilter>;
};

export type HumanProcessingRequestVariancePopulationAggregates = {
  __typename?: "HumanProcessingRequestVariancePopulationAggregates";
  /** Population variance of priority across the matching connection */
  priority?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Population variance of runId across the matching connection */
  runId?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type HumanProcessingRequestVarianceSampleAggregateFilter = {
  priority?: InputMaybe<BigFloatFilter>;
  runId?: InputMaybe<BigFloatFilter>;
};

export type HumanProcessingRequestVarianceSampleAggregates = {
  __typename?: "HumanProcessingRequestVarianceSampleAggregates";
  /** Sample variance of priority across the matching connection */
  priority?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sample variance of runId across the matching connection */
  runId?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** A connection to a list of `HumanProcessingRequest` values. */
export type HumanProcessingRequestsConnection = {
  __typename?: "HumanProcessingRequestsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<HumanProcessingRequestAggregates>;
  /** A list of edges which contains the `HumanProcessingRequest` and cursor to aid in pagination. */
  edges: Array<HumanProcessingRequestsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<HumanProcessingRequestAggregates>>;
  /** A list of `HumanProcessingRequest` objects. */
  nodes: Array<Maybe<HumanProcessingRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `HumanProcessingRequest` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `HumanProcessingRequest` values. */
export type HumanProcessingRequestsConnectiongroupedAggregatesArgs = {
  groupBy: Array<HumanProcessingRequestGroupBy>;
  having?: InputMaybe<HumanProcessingRequestHavingInput>;
};

/** A `HumanProcessingRequest` edge in the connection. */
export type HumanProcessingRequestsEdge = {
  __typename?: "HumanProcessingRequestsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `HumanProcessingRequest` at the end of the edge. */
  node?: Maybe<HumanProcessingRequest>;
};

/** Methods to use when ordering `HumanProcessingRequest`. */
export enum HumanProcessingRequestsOrderBy {
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ERROR_DETAILS_ASC = "ERROR_DETAILS_ASC",
  ERROR_DETAILS_DESC = "ERROR_DETAILS_DESC",
  EXTRA_DETAILS_ASC = "EXTRA_DETAILS_ASC",
  EXTRA_DETAILS_DESC = "EXTRA_DETAILS_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PRIORITY_ASC = "PRIORITY_ASC",
  PRIORITY_DESC = "PRIORITY_DESC",
  PULLED_DATES_ASC = "PULLED_DATES_ASC",
  PULLED_DATES_DESC = "PULLED_DATES_DESC",
  REQUEST_TYPE_ASC = "REQUEST_TYPE_ASC",
  REQUEST_TYPE_DESC = "REQUEST_TYPE_DESC",
  REQUEUED_DATES_ASC = "REQUEUED_DATES_ASC",
  REQUEUED_DATES_DESC = "REQUEUED_DATES_DESC",
  RUN_ID_ASC = "RUN_ID_ASC",
  RUN_ID_DESC = "RUN_ID_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__BATCH_CLAIM_ID_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__BATCH_CLAIM_ID_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__BATCH_CLAIM_ID_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__BATCH_CLAIM_ID_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ETAG_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ETAG_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ETAG_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ETAG_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__FILENAME_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__FILENAME_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__FILENAME_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__FILENAME_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ICN_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ICN_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ICN_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ICN_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ID_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ID_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ID_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ID_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__IS_UPLOADED_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__IS_UPLOADED_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__IS_UPLOADED_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__IS_UPLOADED_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__LAST_MODIFIED_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__LAST_MODIFIED_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__LAST_MODIFIED_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__LAST_MODIFIED_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ORIGINAL_FILE_ID_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ORIGINAL_FILE_ID_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ORIGINAL_FILE_ID_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__ORIGINAL_FILE_ID_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__PROCESS_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__PROCESS_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__PROCESS_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__PROCESS_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__PROVIDER_ID_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__PROVIDER_ID_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__PROVIDER_ID_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__PROVIDER_ID_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__S3_KEY_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__S3_KEY_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__S3_KEY_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__S3_KEY_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SIZE_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SIZE_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SIZE_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SIZE_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SUB_FILE_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SUB_FILE_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SUB_FILE_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SUB_FILE_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SUB_PROCESS_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SUB_PROCESS_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SUB_PROCESS_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__SUB_PROCESS_DESC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__TAGS_ASC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__TAGS_ASC",
  S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__TAGS_DESC = "S3_AUDIT_DOCUMENTATION_BY_S3_AUDIT_DOCUMENTATION_ID__TAGS_DESC",
  S3_AUDIT_DOCUMENTATION_ID_ASC = "S3_AUDIT_DOCUMENTATION_ID_ASC",
  S3_AUDIT_DOCUMENTATION_ID_DESC = "S3_AUDIT_DOCUMENTATION_ID_DESC",
  STATUS_ASC = "STATUS_ASC",
  STATUS_DESC = "STATUS_DESC",
  SUCCESS_DETAILS_ASC = "SUCCESS_DETAILS_ASC",
  SUCCESS_DETAILS_DESC = "SUCCESS_DETAILS_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
  USERNAME_ASC = "USERNAME_ASC",
  USERNAME_DESC = "USERNAME_DESC",
}

export type IAgentMessage = {
  agent?: Maybe<Agent>;
  agentId: Scalars["ID"]["output"];
  citations?: Maybe<Array<InlineCitations>>;
  content: AgentMessageContent;
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  messages?: Maybe<Array<AgentMessage>>;
  name: Scalars["String"]["output"];
  parentReferenceId?: Maybe<Scalars["UUID"]["output"]>;
  referenceId?: Maybe<Scalars["UUID"]["output"]>;
  revision?: Maybe<AgentMessageRevision>;
  schema?: Maybe<Scalars["JSON"]["output"]>;
  sequence: Scalars["Int"]["output"];
  subTaskId?: Maybe<Scalars["UUID"]["output"]>;
  userValidation?: Maybe<AgentMessageUserValidation>;
  workflowStatusId: Scalars["Int"]["output"];
};

export enum InlineCitationType {
  FILE_PREVIEW = "FILE_PREVIEW",
}

export type InlineCitations = {
  __typename?: "InlineCitations";
  annotation: Annotation;
  citationType: InlineCitationType;
  key: Scalars["String"]["output"];
};

export type Insurer = Node & {
  __typename?: "Insurer";
  /** Reads and enables pagination through a set of `AuditFindingReport`. */
  auditFindingReports: AuditFindingReportsConnection;
  /** Reads and enables pagination through a set of `AuditorBucket`. */
  auditorBuckets: AuditorBucketsConnection;
  /** Reads and enables pagination through a set of `BatchClaim`. */
  batchClaims: BatchClaimsConnection;
  /** Reads and enables pagination through a set of `BatchFile`. */
  batchFiles: BatchFilesConnection;
  /** Reads and enables pagination through a set of `ClaimAuditGroup`. */
  claimAuditGroups: ClaimAuditGroupsConnection;
  /**
   * ### Overview
   * Identifies the set of claims for a given insurer that are assigned to the current auditor user.
   * The auditor user is identified using the uuid in the jwt of the active user, so this is meant to be called by a logged in user within the application.
   */
  claimsAssignedToAuditor: BatchClaimsConnection;
  clientAbbreviation: Scalars["String"]["output"];
  clientId?: Maybe<Scalars["UUID"]["output"]>;
  createdAt: Scalars["Datetime"]["output"];
  /** Reads a single `DefaultStrategyByInsurer` that is related to this `Insurer`. */
  defaultStrategyByInsurer?: Maybe<DefaultStrategyByInsurer>;
  /**
   * Reads and enables pagination through a set of `DefaultStrategyByInsurer`.
   * @deprecated Please use defaultStrategyByInsurer instead
   */
  defaultStrategyByInsurers: DefaultStrategyByInsurersConnection;
  id: Scalars["UUID"]["output"];
  /** Reads a single `InsurerClaimIntakeDropboxPermitted` that is related to this `Insurer`. */
  insurerClaimIntakeDropboxPermitted?: Maybe<InsurerClaimIntakeDropboxPermitted>;
  /**
   * Reads and enables pagination through a set of `InsurerClaimIntakeDropboxPermitted`.
   * @deprecated Please use insurerClaimIntakeDropboxPermitted instead
   */
  insurerClaimIntakeDropboxPermitteds: InsurerClaimIntakeDropboxPermittedsConnection;
  /** Reads and enables pagination through a set of `InsurerOrganization`. */
  insurerOrganizationsByMemberId: InsurerOrganizationsConnection;
  /** Reads and enables pagination through a set of `InsurerOrganization`. */
  insurerOrganizationsByOrganizationId: InsurerOrganizationsConnection;
  /** Reads and enables pagination through a set of `InsurerUser`. */
  insurerUsers: InsurerUsersConnection;
  name: Scalars["String"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type InsurerauditFindingReportsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReportCondition>;
  filter?: InputMaybe<AuditFindingReportFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReportsOrderBy>>;
};

export type InsurerauditorBucketsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditorBucketCondition>;
  filter?: InputMaybe<AuditorBucketFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditorBucketsOrderBy>>;
};

export type InsurerbatchClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimCondition>;
  filter?: InputMaybe<BatchClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimsOrderBy>>;
};

export type InsurerbatchFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchFileCondition>;
  filter?: InputMaybe<BatchFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchFilesOrderBy>>;
};

export type InsurerclaimAuditGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimAuditGroupCondition>;
  filter?: InputMaybe<ClaimAuditGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimAuditGroupsOrderBy>>;
};

export type InsurerclaimsAssignedToAuditorArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<BatchClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InsurerdefaultStrategyByInsurersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DefaultStrategyByInsurerCondition>;
  filter?: InputMaybe<DefaultStrategyByInsurerFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DefaultStrategyByInsurersOrderBy>>;
};

export type InsurerinsurerClaimIntakeDropboxPermittedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<InsurerClaimIntakeDropboxPermittedCondition>;
  filter?: InputMaybe<InsurerClaimIntakeDropboxPermittedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<InsurerClaimIntakeDropboxPermittedsOrderBy>>;
};

export type InsurerinsurerOrganizationsByMemberIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<InsurerOrganizationCondition>;
  filter?: InputMaybe<InsurerOrganizationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<InsurerOrganizationsOrderBy>>;
};

export type InsurerinsurerOrganizationsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<InsurerOrganizationCondition>;
  filter?: InputMaybe<InsurerOrganizationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<InsurerOrganizationsOrderBy>>;
};

export type InsurerinsurerUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<InsurerUserCondition>;
  filter?: InputMaybe<InsurerUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<InsurerUsersOrderBy>>;
};

export type InsurerAggregates = {
  __typename?: "InsurerAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<InsurerDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * # Overview
 * A join table that defines which insurer_ids are permitted to perform dropbox-style uploads to the alaffia-claim-intake bucket.
 */
export type InsurerClaimIntakeDropboxPermitted = {
  __typename?: "InsurerClaimIntakeDropboxPermitted";
  id?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `Insurer` that is related to this `InsurerClaimIntakeDropboxPermitted`. */
  insurer?: Maybe<Insurer>;
  insurerId?: Maybe<Scalars["UUID"]["output"]>;
};

export type InsurerClaimIntakeDropboxPermittedAggregates = {
  __typename?: "InsurerClaimIntakeDropboxPermittedAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<InsurerClaimIntakeDropboxPermittedDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * A condition to be used against `InsurerClaimIntakeDropboxPermitted` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type InsurerClaimIntakeDropboxPermittedCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `insurerId` field. */
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type InsurerClaimIntakeDropboxPermittedDistinctCountAggregates = {
  __typename?: "InsurerClaimIntakeDropboxPermittedDistinctCountAggregates";
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of insurerId across the matching connection */
  insurerId?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `InsurerClaimIntakeDropboxPermitted` object types. All fields are combined with a logical ‘and.’ */
export type InsurerClaimIntakeDropboxPermittedFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InsurerClaimIntakeDropboxPermittedFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `insurer` relation. */
  insurer?: InputMaybe<InsurerFilter>;
  /** A related `insurer` exists. */
  insurerExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `insurerId` field. */
  insurerId?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InsurerClaimIntakeDropboxPermittedFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InsurerClaimIntakeDropboxPermittedFilter>>;
};

/** Grouping methods for `InsurerClaimIntakeDropboxPermitted` for usage during aggregation. */
export enum InsurerClaimIntakeDropboxPermittedGroupBy {
  ID = "ID",
}

/** Conditions for `InsurerClaimIntakeDropboxPermitted` aggregates. */
export type InsurerClaimIntakeDropboxPermittedHavingInput = {
  AND?: InputMaybe<Array<InsurerClaimIntakeDropboxPermittedHavingInput>>;
  OR?: InputMaybe<Array<InsurerClaimIntakeDropboxPermittedHavingInput>>;
};

/** The fields on `insurerClaimIntakeDropboxPermitted` to look up the row to connect. */
export type InsurerClaimIntakeDropboxPermittedInsurerClaimIntakeDropboxPermittedInsurerIdKeyConnect =
  {
    insurerId: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `insurer` in the `InsurerClaimIntakeDropboxPermittedInput` mutation. */
export type InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInput = {
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByClientAbbreviation?: InputMaybe<InsurerInsurerUniqueClientAbbreviationConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectById?: InputMaybe<InsurerInsurerPkeyConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByName?: InputMaybe<InsurerInsurerUniqueNameConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<InsurerNodeIdConnect>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByClientAbbreviation?: InputMaybe<InsurerOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateById?: InputMaybe<InsurerOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyUsingInsurerPkeyUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByName?: InputMaybe<InsurerOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyUsingInsurerUniqueNameUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InsurerClaimIntakeDropboxPermittedOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `insurerClaimIntakeDropboxPermitted` in the `InsurerInput` mutation. */
export type InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput = {
  /** The primary key(s) for `insurerClaimIntakeDropboxPermitted` for the far side of the relationship. */
  connectByInsurerId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerClaimIntakeDropboxPermittedInsurerIdKeyConnect>;
  /** The primary key(s) and patch data for `insurerClaimIntakeDropboxPermitted` for the far side of the relationship. */
  updateByInsurerId?: InputMaybe<InsurerClaimIntakeDropboxPermittedOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyUsingInsurerClaimIntakeDropboxPermittedInsurerIdKeyUpdate>;
};

/** The globally unique `ID` look up for the row to update. */
export type InsurerClaimIntakeDropboxPermittedOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `insurer` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: InsurerPatch;
  };

/** The fields on `insurerClaimIntakeDropboxPermitted` to look up the row to update. */
export type InsurerClaimIntakeDropboxPermittedOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyUsingInsurerClaimIntakeDropboxPermittedInsurerIdKeyUpdate =
  {
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurerClaimIntakeDropboxPermitted` being updated. */
    patch: updateInsurerClaimIntakeDropboxPermittedOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyPatch;
  };

/** A connection to a list of `InsurerClaimIntakeDropboxPermitted` values. */
export type InsurerClaimIntakeDropboxPermittedsConnection = {
  __typename?: "InsurerClaimIntakeDropboxPermittedsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<InsurerClaimIntakeDropboxPermittedAggregates>;
  /** A list of edges which contains the `InsurerClaimIntakeDropboxPermitted` and cursor to aid in pagination. */
  edges: Array<InsurerClaimIntakeDropboxPermittedsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<
    Array<InsurerClaimIntakeDropboxPermittedAggregates>
  >;
  /** A list of `InsurerClaimIntakeDropboxPermitted` objects. */
  nodes: Array<Maybe<InsurerClaimIntakeDropboxPermitted>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsurerClaimIntakeDropboxPermitted` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `InsurerClaimIntakeDropboxPermitted` values. */
export type InsurerClaimIntakeDropboxPermittedsConnectiongroupedAggregatesArgs =
  {
    groupBy: Array<InsurerClaimIntakeDropboxPermittedGroupBy>;
    having?: InputMaybe<InsurerClaimIntakeDropboxPermittedHavingInput>;
  };

/** A `InsurerClaimIntakeDropboxPermitted` edge in the connection. */
export type InsurerClaimIntakeDropboxPermittedsEdge = {
  __typename?: "InsurerClaimIntakeDropboxPermittedsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `InsurerClaimIntakeDropboxPermitted` at the end of the edge. */
  node?: Maybe<InsurerClaimIntakeDropboxPermitted>;
};

/** Methods to use when ordering `InsurerClaimIntakeDropboxPermitted`. */
export enum InsurerClaimIntakeDropboxPermittedsOrderBy {
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ID_ASC = "INSURER_BY_INSURER_ID__CLIENT_ID_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ID_DESC = "INSURER_BY_INSURER_ID__CLIENT_ID_DESC",
  INSURER_BY_INSURER_ID__CREATED_AT_ASC = "INSURER_BY_INSURER_ID__CREATED_AT_ASC",
  INSURER_BY_INSURER_ID__CREATED_AT_DESC = "INSURER_BY_INSURER_ID__CREATED_AT_DESC",
  INSURER_BY_INSURER_ID__ID_ASC = "INSURER_BY_INSURER_ID__ID_ASC",
  INSURER_BY_INSURER_ID__ID_DESC = "INSURER_BY_INSURER_ID__ID_DESC",
  INSURER_BY_INSURER_ID__NAME_ASC = "INSURER_BY_INSURER_ID__NAME_ASC",
  INSURER_BY_INSURER_ID__NAME_DESC = "INSURER_BY_INSURER_ID__NAME_DESC",
  INSURER_BY_INSURER_ID__UPDATED_AT_ASC = "INSURER_BY_INSURER_ID__UPDATED_AT_ASC",
  INSURER_BY_INSURER_ID__UPDATED_AT_DESC = "INSURER_BY_INSURER_ID__UPDATED_AT_DESC",
  INSURER_ID_ASC = "INSURER_ID_ASC",
  INSURER_ID_DESC = "INSURER_ID_DESC",
  NATURAL = "NATURAL",
}

/** A condition to be used against `Insurer` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type InsurerCondition = {
  /** Checks for equality with the object’s `clientAbbreviation` field. */
  clientAbbreviation?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type InsurerDistinctCountAggregates = {
  __typename?: "InsurerDistinctCountAggregates";
  /** Distinct count of clientAbbreviation across the matching connection */
  clientAbbreviation?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientId across the matching connection */
  clientId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `Insurer` object types. All fields are combined with a logical ‘and.’ */
export type InsurerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InsurerFilter>>;
  /** Filter by the object’s `auditFindingReports` relation. */
  auditFindingReports?: InputMaybe<InsurerToManyAuditFindingReportFilter>;
  /** Some related `auditFindingReports` exist. */
  auditFindingReportsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `auditorBuckets` relation. */
  auditorBuckets?: InputMaybe<InsurerToManyAuditorBucketFilter>;
  /** Some related `auditorBuckets` exist. */
  auditorBucketsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaims` relation. */
  batchClaims?: InputMaybe<InsurerToManyBatchClaimFilter>;
  /** Some related `batchClaims` exist. */
  batchClaimsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchFiles` relation. */
  batchFiles?: InputMaybe<InsurerToManyBatchFileFilter>;
  /** Some related `batchFiles` exist. */
  batchFilesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `claimAuditGroups` relation. */
  claimAuditGroups?: InputMaybe<InsurerToManyClaimAuditGroupFilter>;
  /** Some related `claimAuditGroups` exist. */
  claimAuditGroupsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `clientAbbreviation` field. */
  clientAbbreviation?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultStrategyByInsurer` relation. */
  defaultStrategyByInsurer?: InputMaybe<DefaultStrategyByInsurerFilter>;
  /** A related `defaultStrategyByInsurer` exists. */
  defaultStrategyByInsurerExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `insurerClaimIntakeDropboxPermitted` relation. */
  insurerClaimIntakeDropboxPermitted?: InputMaybe<InsurerClaimIntakeDropboxPermittedFilter>;
  /** A related `insurerClaimIntakeDropboxPermitted` exists. */
  insurerClaimIntakeDropboxPermittedExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `insurerOrganizationsByMemberId` relation. */
  insurerOrganizationsByMemberId?: InputMaybe<InsurerToManyInsurerOrganizationFilter>;
  /** Some related `insurerOrganizationsByMemberId` exist. */
  insurerOrganizationsByMemberIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `insurerOrganizationsByOrganizationId` relation. */
  insurerOrganizationsByOrganizationId?: InputMaybe<InsurerToManyInsurerOrganizationFilter>;
  /** Some related `insurerOrganizationsByOrganizationId` exist. */
  insurerOrganizationsByOrganizationIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `insurerUsers` relation. */
  insurerUsers?: InputMaybe<InsurerToManyInsurerUserFilter>;
  /** Some related `insurerUsers` exist. */
  insurerUsersExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InsurerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InsurerFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `Insurer` for usage during aggregation. */
export enum InsurerGroupBy {
  CLIENT_ID = "CLIENT_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type InsurerHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Insurer` aggregates. */
export type InsurerHavingInput = {
  AND?: InputMaybe<Array<InsurerHavingInput>>;
  OR?: InputMaybe<Array<InsurerHavingInput>>;
  average?: InputMaybe<InsurerHavingAverageInput>;
  distinctCount?: InputMaybe<InsurerHavingDistinctCountInput>;
  max?: InputMaybe<InsurerHavingMaxInput>;
  min?: InputMaybe<InsurerHavingMinInput>;
  stddevPopulation?: InputMaybe<InsurerHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<InsurerHavingStddevSampleInput>;
  sum?: InputMaybe<InsurerHavingSumInput>;
  variancePopulation?: InputMaybe<InsurerHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<InsurerHavingVarianceSampleInput>;
};

export type InsurerHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** The fields on `insurer` to look up the row to connect. */
export type InsurerInsurerPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `insurer` to look up the row to connect. */
export type InsurerInsurerUniqueClientAbbreviationConnect = {
  clientAbbreviation: Scalars["String"]["input"];
};

/** The fields on `insurer` to look up the row to connect. */
export type InsurerInsurerUniqueNameConnect = {
  name: Scalars["String"]["input"];
};

/** The globally unique `ID` look up for the row to connect. */
export type InsurerNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `insurer` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type InsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReport` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: AuditFindingReportPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyUsingInsurerPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate =
  {
    clientAbbreviation: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyUsingInsurerUniqueNameUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type InsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `auditorBucket` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `auditorBucket` being updated. */
  patch: AuditorBucketPatch;
};

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyUsingInsurerPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate =
  {
    clientAbbreviation: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyUsingInsurerUniqueNameUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type InsurerOnBatchClaimForBatchClaimInsurerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `batchClaim` being updated. */
  patch: BatchClaimPatch;
};

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnBatchClaimForBatchClaimInsurerIdFkeyUsingInsurerPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnBatchClaimForBatchClaimInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnBatchClaimForBatchClaimInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate =
  {
    clientAbbreviation: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnBatchClaimForBatchClaimInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnBatchClaimForBatchClaimInsurerIdFkeyUsingInsurerUniqueNameUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnBatchClaimForBatchClaimInsurerIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type InsurerOnBatchFileForBatchFileInsurerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `batchFile` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `batchFile` being updated. */
  patch: BatchFilePatch;
};

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnBatchFileForBatchFileInsurerIdFkeyUsingInsurerPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnBatchFileForBatchFileInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnBatchFileForBatchFileInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate =
  {
    clientAbbreviation: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnBatchFileForBatchFileInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnBatchFileForBatchFileInsurerIdFkeyUsingInsurerUniqueNameUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnBatchFileForBatchFileInsurerIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type InsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `claimAuditGroup` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
    patch: ClaimAuditGroupPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyUsingInsurerPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate =
  {
    clientAbbreviation: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyUsingInsurerUniqueNameUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type InsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `defaultStrategyByInsurer` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `defaultStrategyByInsurer` being updated. */
    patch: DefaultStrategyByInsurerPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyUsingInsurerPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyUsingInsurerUniqueClientAbbreviationUpdate =
  {
    clientAbbreviation: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyUsingInsurerUniqueNameUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyUsingInsurerPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate =
  {
    clientAbbreviation: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyUsingInsurerUniqueNameUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type InsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `insurerOrganization` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `insurerOrganization` being updated. */
    patch: InsurerOrganizationPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyUsingInsurerPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyUsingInsurerUniqueClientAbbreviationUpdate =
  {
    clientAbbreviation: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyUsingInsurerUniqueNameUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type InsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `insurerOrganization` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `insurerOrganization` being updated. */
    patch: InsurerOrganizationPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyUsingInsurerPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyUsingInsurerUniqueClientAbbreviationUpdate =
  {
    clientAbbreviation: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyUsingInsurerUniqueNameUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type InsurerOnInsurerUserForInsurerUserInsurerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `insurerUser` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `insurerUser` being updated. */
  patch: InsurerUserPatch;
};

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerUserForInsurerUserInsurerIdFkeyUsingInsurerPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerUserForInsurerUserInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerUserForInsurerUserInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate =
  {
    clientAbbreviation: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerUserForInsurerUserInsurerIdFkeyPatch;
  };

/** The fields on `insurer` to look up the row to update. */
export type InsurerOnInsurerUserForInsurerUserInsurerIdFkeyUsingInsurerUniqueNameUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: updateInsurerOnInsurerUserForInsurerUserInsurerIdFkeyPatch;
  };

export type InsurerOrganization = Node & {
  __typename?: "InsurerOrganization";
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads a single `Insurer` that is related to this `InsurerOrganization`. */
  member?: Maybe<Insurer>;
  memberId: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `Insurer` that is related to this `InsurerOrganization`. */
  organization?: Maybe<Insurer>;
  organizationId: Scalars["UUID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type InsurerOrganizationAggregates = {
  __typename?: "InsurerOrganizationAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<InsurerOrganizationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `InsurerOrganization` object types. */
export type InsurerOrganizationAggregatesFilter = {
  /** Distinct count aggregate over matching `InsurerOrganization` objects. */
  distinctCount?: InputMaybe<InsurerOrganizationDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `InsurerOrganization` object to be included within the aggregate. */
  filter?: InputMaybe<InsurerOrganizationFilter>;
};

/**
 * A condition to be used against `InsurerOrganization` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type InsurerOrganizationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type InsurerOrganizationDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  memberId?: InputMaybe<BigIntFilter>;
  organizationId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type InsurerOrganizationDistinctCountAggregates = {
  __typename?: "InsurerOrganizationDistinctCountAggregates";
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of memberId across the matching connection */
  memberId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of organizationId across the matching connection */
  organizationId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `InsurerOrganization` object types. All fields are combined with a logical ‘and.’ */
export type InsurerOrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InsurerOrganizationFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<InsurerFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InsurerOrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InsurerOrganizationFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<InsurerFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `InsurerOrganization` for usage during aggregation. */
export enum InsurerOrganizationGroupBy {
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  MEMBER_ID = "MEMBER_ID",
  ORGANIZATION_ID = "ORGANIZATION_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type InsurerOrganizationHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerOrganizationHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `InsurerOrganization` aggregates. */
export type InsurerOrganizationHavingInput = {
  AND?: InputMaybe<Array<InsurerOrganizationHavingInput>>;
  OR?: InputMaybe<Array<InsurerOrganizationHavingInput>>;
  average?: InputMaybe<InsurerOrganizationHavingAverageInput>;
  distinctCount?: InputMaybe<InsurerOrganizationHavingDistinctCountInput>;
  max?: InputMaybe<InsurerOrganizationHavingMaxInput>;
  min?: InputMaybe<InsurerOrganizationHavingMinInput>;
  stddevPopulation?: InputMaybe<InsurerOrganizationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<InsurerOrganizationHavingStddevSampleInput>;
  sum?: InputMaybe<InsurerOrganizationHavingSumInput>;
  variancePopulation?: InputMaybe<InsurerOrganizationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<InsurerOrganizationHavingVarianceSampleInput>;
};

export type InsurerOrganizationHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerOrganizationHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerOrganizationHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerOrganizationHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerOrganizationHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerOrganizationHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerOrganizationHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** The fields on `insurerOrganization` to look up the row to connect. */
export type InsurerOrganizationInsurerOrganizationMemberIdOrganizationIdKeyConnect =
  {
    memberId: Scalars["UUID"]["input"];
    organizationId: Scalars["UUID"]["input"];
  };

/** The fields on `insurerOrganization` to look up the row to connect. */
export type InsurerOrganizationInsurerOrganizationPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `insurer` in the `InsurerOrganizationInput` mutation. */
export type InsurerOrganizationMemberIdFkeyInput = {
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByClientAbbreviation?: InputMaybe<InsurerInsurerUniqueClientAbbreviationConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectById?: InputMaybe<InsurerInsurerPkeyConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByName?: InputMaybe<InsurerInsurerUniqueNameConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<InsurerNodeIdConnect>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByClientAbbreviation?: InputMaybe<InsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyUsingInsurerUniqueClientAbbreviationUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateById?: InputMaybe<InsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyUsingInsurerPkeyUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByName?: InputMaybe<InsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyUsingInsurerUniqueNameUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `insurerOrganization` in the `InsurerInput` mutation. */
export type InsurerOrganizationMemberIdFkeyInverseInput = {
  /** The primary key(s) for `insurerOrganization` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<InsurerOrganizationInsurerOrganizationPkeyConnect>
  >;
  /** The primary key(s) for `insurerOrganization` for the far side of the relationship. */
  connectByMemberIdAndOrganizationId?: InputMaybe<
    Array<InsurerOrganizationInsurerOrganizationMemberIdOrganizationIdKeyConnect>
  >;
  /** The primary key(s) for `insurerOrganization` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<InsurerOrganizationNodeIdConnect>>;
  /** The primary key(s) and patch data for `insurerOrganization` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyUsingInsurerOrganizationPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `insurerOrganization` for the far side of the relationship. */
  updateByMemberIdAndOrganizationId?: InputMaybe<
    Array<InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyUsingInsurerOrganizationMemberIdOrganizationIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `insurerOrganization` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<InsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyNodeIdUpdate>
  >;
};

/** The globally unique `ID` look up for the row to connect. */
export type InsurerOrganizationNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `insurerOrganization` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `insurer` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: InsurerPatch;
  };

/** The fields on `insurerOrganization` to look up the row to update. */
export type InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyUsingInsurerOrganizationMemberIdOrganizationIdKeyUpdate =
  {
    memberId: Scalars["UUID"]["input"];
    organizationId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurerOrganization` being updated. */
    patch: updateInsurerOrganizationOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyPatch;
  };

/** The fields on `insurerOrganization` to look up the row to update. */
export type InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyUsingInsurerOrganizationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurerOrganization` being updated. */
    patch: updateInsurerOrganizationOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `insurer` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `insurer` being updated. */
    patch: InsurerPatch;
  };

/** The fields on `insurerOrganization` to look up the row to update. */
export type InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyUsingInsurerOrganizationMemberIdOrganizationIdKeyUpdate =
  {
    memberId: Scalars["UUID"]["input"];
    organizationId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurerOrganization` being updated. */
    patch: updateInsurerOrganizationOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyPatch;
  };

/** The fields on `insurerOrganization` to look up the row to update. */
export type InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyUsingInsurerOrganizationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurerOrganization` being updated. */
    patch: updateInsurerOrganizationOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyPatch;
  };

/** Input for the nested mutation of `insurer` in the `InsurerOrganizationInput` mutation. */
export type InsurerOrganizationOrganizationIdFkeyInput = {
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByClientAbbreviation?: InputMaybe<InsurerInsurerUniqueClientAbbreviationConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectById?: InputMaybe<InsurerInsurerPkeyConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByName?: InputMaybe<InsurerInsurerUniqueNameConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<InsurerNodeIdConnect>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByClientAbbreviation?: InputMaybe<InsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyUsingInsurerUniqueClientAbbreviationUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateById?: InputMaybe<InsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyUsingInsurerPkeyUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByName?: InputMaybe<InsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyUsingInsurerUniqueNameUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `insurerOrganization` in the `InsurerInput` mutation. */
export type InsurerOrganizationOrganizationIdFkeyInverseInput = {
  /** The primary key(s) for `insurerOrganization` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<InsurerOrganizationInsurerOrganizationPkeyConnect>
  >;
  /** The primary key(s) for `insurerOrganization` for the far side of the relationship. */
  connectByMemberIdAndOrganizationId?: InputMaybe<
    Array<InsurerOrganizationInsurerOrganizationMemberIdOrganizationIdKeyConnect>
  >;
  /** The primary key(s) for `insurerOrganization` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<InsurerOrganizationNodeIdConnect>>;
  /** The primary key(s) and patch data for `insurerOrganization` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyUsingInsurerOrganizationPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `insurerOrganization` for the far side of the relationship. */
  updateByMemberIdAndOrganizationId?: InputMaybe<
    Array<InsurerOrganizationOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyUsingInsurerOrganizationMemberIdOrganizationIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `insurerOrganization` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<InsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyNodeIdUpdate>
  >;
};

/** Represents an update to a `InsurerOrganization`. Fields that are set will be updated. */
export type InsurerOrganizationPatch = {
  insurerToMemberId?: InputMaybe<InsurerOrganizationMemberIdFkeyInput>;
  insurerToOrganizationId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInput>;
  memberId?: InputMaybe<Scalars["UUID"]["input"]>;
  organizationId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A connection to a list of `InsurerOrganization` values. */
export type InsurerOrganizationsConnection = {
  __typename?: "InsurerOrganizationsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<InsurerOrganizationAggregates>;
  /** A list of edges which contains the `InsurerOrganization` and cursor to aid in pagination. */
  edges: Array<InsurerOrganizationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<InsurerOrganizationAggregates>>;
  /** A list of `InsurerOrganization` objects. */
  nodes: Array<Maybe<InsurerOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsurerOrganization` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `InsurerOrganization` values. */
export type InsurerOrganizationsConnectiongroupedAggregatesArgs = {
  groupBy: Array<InsurerOrganizationGroupBy>;
  having?: InputMaybe<InsurerOrganizationHavingInput>;
};

/** A `InsurerOrganization` edge in the connection. */
export type InsurerOrganizationsEdge = {
  __typename?: "InsurerOrganizationsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `InsurerOrganization` at the end of the edge. */
  node?: Maybe<InsurerOrganization>;
};

/** Methods to use when ordering `InsurerOrganization`. */
export enum InsurerOrganizationsOrderBy {
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INSURER_BY_MEMBER_ID__CLIENT_ABBREVIATION_ASC = "INSURER_BY_MEMBER_ID__CLIENT_ABBREVIATION_ASC",
  INSURER_BY_MEMBER_ID__CLIENT_ABBREVIATION_DESC = "INSURER_BY_MEMBER_ID__CLIENT_ABBREVIATION_DESC",
  INSURER_BY_MEMBER_ID__CLIENT_ID_ASC = "INSURER_BY_MEMBER_ID__CLIENT_ID_ASC",
  INSURER_BY_MEMBER_ID__CLIENT_ID_DESC = "INSURER_BY_MEMBER_ID__CLIENT_ID_DESC",
  INSURER_BY_MEMBER_ID__CREATED_AT_ASC = "INSURER_BY_MEMBER_ID__CREATED_AT_ASC",
  INSURER_BY_MEMBER_ID__CREATED_AT_DESC = "INSURER_BY_MEMBER_ID__CREATED_AT_DESC",
  INSURER_BY_MEMBER_ID__ID_ASC = "INSURER_BY_MEMBER_ID__ID_ASC",
  INSURER_BY_MEMBER_ID__ID_DESC = "INSURER_BY_MEMBER_ID__ID_DESC",
  INSURER_BY_MEMBER_ID__NAME_ASC = "INSURER_BY_MEMBER_ID__NAME_ASC",
  INSURER_BY_MEMBER_ID__NAME_DESC = "INSURER_BY_MEMBER_ID__NAME_DESC",
  INSURER_BY_MEMBER_ID__UPDATED_AT_ASC = "INSURER_BY_MEMBER_ID__UPDATED_AT_ASC",
  INSURER_BY_MEMBER_ID__UPDATED_AT_DESC = "INSURER_BY_MEMBER_ID__UPDATED_AT_DESC",
  INSURER_BY_ORGANIZATION_ID__CLIENT_ABBREVIATION_ASC = "INSURER_BY_ORGANIZATION_ID__CLIENT_ABBREVIATION_ASC",
  INSURER_BY_ORGANIZATION_ID__CLIENT_ABBREVIATION_DESC = "INSURER_BY_ORGANIZATION_ID__CLIENT_ABBREVIATION_DESC",
  INSURER_BY_ORGANIZATION_ID__CLIENT_ID_ASC = "INSURER_BY_ORGANIZATION_ID__CLIENT_ID_ASC",
  INSURER_BY_ORGANIZATION_ID__CLIENT_ID_DESC = "INSURER_BY_ORGANIZATION_ID__CLIENT_ID_DESC",
  INSURER_BY_ORGANIZATION_ID__CREATED_AT_ASC = "INSURER_BY_ORGANIZATION_ID__CREATED_AT_ASC",
  INSURER_BY_ORGANIZATION_ID__CREATED_AT_DESC = "INSURER_BY_ORGANIZATION_ID__CREATED_AT_DESC",
  INSURER_BY_ORGANIZATION_ID__ID_ASC = "INSURER_BY_ORGANIZATION_ID__ID_ASC",
  INSURER_BY_ORGANIZATION_ID__ID_DESC = "INSURER_BY_ORGANIZATION_ID__ID_DESC",
  INSURER_BY_ORGANIZATION_ID__NAME_ASC = "INSURER_BY_ORGANIZATION_ID__NAME_ASC",
  INSURER_BY_ORGANIZATION_ID__NAME_DESC = "INSURER_BY_ORGANIZATION_ID__NAME_DESC",
  INSURER_BY_ORGANIZATION_ID__UPDATED_AT_ASC = "INSURER_BY_ORGANIZATION_ID__UPDATED_AT_ASC",
  INSURER_BY_ORGANIZATION_ID__UPDATED_AT_DESC = "INSURER_BY_ORGANIZATION_ID__UPDATED_AT_DESC",
  MEMBER_ID_ASC = "MEMBER_ID_ASC",
  MEMBER_ID_DESC = "MEMBER_ID_DESC",
  NATURAL = "NATURAL",
  ORGANIZATION_ID_ASC = "ORGANIZATION_ID_ASC",
  ORGANIZATION_ID_DESC = "ORGANIZATION_ID_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** Represents an update to a `Insurer`. Fields that are set will be updated. */
export type InsurerPatch = {
  auditFindingReportsUsingId?: InputMaybe<AuditFindingReportInsurerIdFkeyInverseInput>;
  auditorBucketsUsingId?: InputMaybe<AuditorBucketInsurerIdFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimInsurerIdFkeyInverseInput>;
  batchFilesUsingId?: InputMaybe<BatchFileInsurerIdFkeyInverseInput>;
  claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInverseInput>;
  defaultStrategyByInsurerUsingId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInverseInput>;
  insurerClaimIntakeDropboxPermittedUsingId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput>;
  insurerOrganizationsToMemberIdUsingId?: InputMaybe<InsurerOrganizationMemberIdFkeyInverseInput>;
  insurerOrganizationsToOrganizationIdUsingId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInverseInput>;
  insurerUsersUsingId?: InputMaybe<InsurerUserInsurerIdFkeyInverseInput>;
};

/** A filter to be used against many `AuditFindingReport` object types. All fields are combined with a logical ‘and.’ */
export type InsurerToManyAuditFindingReportFilter = {
  /** Aggregates across related `AuditFindingReport` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingReportAggregatesFilter>;
  /** Every related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingReportFilter>;
  /** No related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingReportFilter>;
  /** Some related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingReportFilter>;
};

/** A filter to be used against many `AuditorBucket` object types. All fields are combined with a logical ‘and.’ */
export type InsurerToManyAuditorBucketFilter = {
  /** Aggregates across related `AuditorBucket` match the filter criteria. */
  aggregates?: InputMaybe<AuditorBucketAggregatesFilter>;
  /** Every related `AuditorBucket` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditorBucketFilter>;
  /** No related `AuditorBucket` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditorBucketFilter>;
  /** Some related `AuditorBucket` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditorBucketFilter>;
};

/** A filter to be used against many `BatchClaim` object types. All fields are combined with a logical ‘and.’ */
export type InsurerToManyBatchClaimFilter = {
  /** Aggregates across related `BatchClaim` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAggregatesFilter>;
  /** Every related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimFilter>;
  /** No related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimFilter>;
  /** Some related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimFilter>;
};

/** A filter to be used against many `BatchFile` object types. All fields are combined with a logical ‘and.’ */
export type InsurerToManyBatchFileFilter = {
  /** Aggregates across related `BatchFile` match the filter criteria. */
  aggregates?: InputMaybe<BatchFileAggregatesFilter>;
  /** Every related `BatchFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchFileFilter>;
  /** No related `BatchFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchFileFilter>;
  /** Some related `BatchFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchFileFilter>;
};

/** A filter to be used against many `ClaimAuditGroup` object types. All fields are combined with a logical ‘and.’ */
export type InsurerToManyClaimAuditGroupFilter = {
  /** Aggregates across related `ClaimAuditGroup` match the filter criteria. */
  aggregates?: InputMaybe<ClaimAuditGroupAggregatesFilter>;
  /** Every related `ClaimAuditGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ClaimAuditGroupFilter>;
  /** No related `ClaimAuditGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ClaimAuditGroupFilter>;
  /** Some related `ClaimAuditGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ClaimAuditGroupFilter>;
};

/** A filter to be used against many `InsurerOrganization` object types. All fields are combined with a logical ‘and.’ */
export type InsurerToManyInsurerOrganizationFilter = {
  /** Aggregates across related `InsurerOrganization` match the filter criteria. */
  aggregates?: InputMaybe<InsurerOrganizationAggregatesFilter>;
  /** Every related `InsurerOrganization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<InsurerOrganizationFilter>;
  /** No related `InsurerOrganization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<InsurerOrganizationFilter>;
  /** Some related `InsurerOrganization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<InsurerOrganizationFilter>;
};

/** A filter to be used against many `InsurerUser` object types. All fields are combined with a logical ‘and.’ */
export type InsurerToManyInsurerUserFilter = {
  /** Aggregates across related `InsurerUser` match the filter criteria. */
  aggregates?: InputMaybe<InsurerUserAggregatesFilter>;
  /** Every related `InsurerUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<InsurerUserFilter>;
  /** No related `InsurerUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<InsurerUserFilter>;
  /** Some related `InsurerUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<InsurerUserFilter>;
};

export type InsurerUser = Node & {
  __typename?: "InsurerUser";
  /** Reads a single `AuditorUser` that is related to this `InsurerUser`. */
  auditorUser?: Maybe<AuditorUser>;
  auditorUserId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads a single `Insurer` that is related to this `InsurerUser`. */
  insurer?: Maybe<Insurer>;
  insurerId: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type InsurerUserAggregates = {
  __typename?: "InsurerUserAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<InsurerUserDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `InsurerUser` object types. */
export type InsurerUserAggregatesFilter = {
  /** Distinct count aggregate over matching `InsurerUser` objects. */
  distinctCount?: InputMaybe<InsurerUserDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `InsurerUser` object to be included within the aggregate. */
  filter?: InputMaybe<InsurerUserFilter>;
};

/** Input for the nested mutation of `auditorUser` in the `InsurerUserInput` mutation. */
export type InsurerUserAuditorUserIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InsurerUserOnInsurerUserForInsurerUserAuditorUserIdFkeyNodeIdUpdate>;
};

/** The `insurerUser` to be created by this mutation. */
export type InsurerUserAuditorUserIdFkeyInsurerUserCreateInput = {
  auditorUserToAuditorUserId?: InputMaybe<InsurerUserAuditorUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<InsurerUserInsurerIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `insurerUser` in the `AuditorUserInput` mutation. */
export type InsurerUserAuditorUserIdFkeyInverseInput = {
  /** The primary key(s) for `insurerUser` for the far side of the relationship. */
  connectByAuditorUserIdAndInsurerId?: InputMaybe<
    Array<InsurerUserInsurerUserAuditorUserIdInsurerIdKeyConnect>
  >;
  /** The primary key(s) for `insurerUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<InsurerUserInsurerUserPkeyConnect>>;
  /** The primary key(s) for `insurerUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<InsurerUserNodeIdConnect>>;
  /** A `InsurerUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<InsurerUserAuditorUserIdFkeyInsurerUserCreateInput>
  >;
  /** The primary key(s) and patch data for `insurerUser` for the far side of the relationship. */
  updateByAuditorUserIdAndInsurerId?: InputMaybe<
    Array<InsurerUserOnInsurerUserForInsurerUserAuditorUserIdFkeyUsingInsurerUserAuditorUserIdInsurerIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `insurerUser` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<InsurerUserOnInsurerUserForInsurerUserAuditorUserIdFkeyUsingInsurerUserPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `insurerUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `InsurerUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type InsurerUserCondition = {
  /** Checks for equality with the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `insurerId` field. */
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type InsurerUserDistinctCountAggregateFilter = {
  auditorUserId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  insurerId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type InsurerUserDistinctCountAggregates = {
  __typename?: "InsurerUserDistinctCountAggregates";
  /** Distinct count of auditorUserId across the matching connection */
  auditorUserId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of insurerId across the matching connection */
  insurerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `InsurerUser` object types. All fields are combined with a logical ‘and.’ */
export type InsurerUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InsurerUserFilter>>;
  /** Filter by the object’s `auditorUser` relation. */
  auditorUser?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `insurer` relation. */
  insurer?: InputMaybe<InsurerFilter>;
  /** Filter by the object’s `insurerId` field. */
  insurerId?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InsurerUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InsurerUserFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `InsurerUser` for usage during aggregation. */
export enum InsurerUserGroupBy {
  AUDITOR_USER_ID = "AUDITOR_USER_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  INSURER_ID = "INSURER_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type InsurerUserHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerUserHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `InsurerUser` aggregates. */
export type InsurerUserHavingInput = {
  AND?: InputMaybe<Array<InsurerUserHavingInput>>;
  OR?: InputMaybe<Array<InsurerUserHavingInput>>;
  average?: InputMaybe<InsurerUserHavingAverageInput>;
  distinctCount?: InputMaybe<InsurerUserHavingDistinctCountInput>;
  max?: InputMaybe<InsurerUserHavingMaxInput>;
  min?: InputMaybe<InsurerUserHavingMinInput>;
  stddevPopulation?: InputMaybe<InsurerUserHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<InsurerUserHavingStddevSampleInput>;
  sum?: InputMaybe<InsurerUserHavingSumInput>;
  variancePopulation?: InputMaybe<InsurerUserHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<InsurerUserHavingVarianceSampleInput>;
};

export type InsurerUserHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerUserHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerUserHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerUserHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerUserHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerUserHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InsurerUserHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `InsurerUser` */
export type InsurerUserInput = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<InsurerUserAuditorUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<InsurerUserInsurerIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `insurer` in the `InsurerUserInput` mutation. */
export type InsurerUserInsurerIdFkeyInput = {
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByClientAbbreviation?: InputMaybe<InsurerInsurerUniqueClientAbbreviationConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectById?: InputMaybe<InsurerInsurerPkeyConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByName?: InputMaybe<InsurerInsurerUniqueNameConnect>;
  /** The primary key(s) for `insurer` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<InsurerNodeIdConnect>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByClientAbbreviation?: InputMaybe<InsurerOnInsurerUserForInsurerUserInsurerIdFkeyUsingInsurerUniqueClientAbbreviationUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateById?: InputMaybe<InsurerOnInsurerUserForInsurerUserInsurerIdFkeyUsingInsurerPkeyUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByName?: InputMaybe<InsurerOnInsurerUserForInsurerUserInsurerIdFkeyUsingInsurerUniqueNameUpdate>;
  /** The primary key(s) and patch data for `insurer` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InsurerUserOnInsurerUserForInsurerUserInsurerIdFkeyNodeIdUpdate>;
};

/** The `insurerUser` to be created by this mutation. */
export type InsurerUserInsurerIdFkeyInsurerUserCreateInput = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<InsurerUserAuditorUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<InsurerUserInsurerIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `insurerUser` in the `InsurerInput` mutation. */
export type InsurerUserInsurerIdFkeyInverseInput = {
  /** The primary key(s) for `insurerUser` for the far side of the relationship. */
  connectByAuditorUserIdAndInsurerId?: InputMaybe<
    Array<InsurerUserInsurerUserAuditorUserIdInsurerIdKeyConnect>
  >;
  /** The primary key(s) for `insurerUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<InsurerUserInsurerUserPkeyConnect>>;
  /** The primary key(s) for `insurerUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<InsurerUserNodeIdConnect>>;
  /** A `InsurerUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<InsurerUserInsurerIdFkeyInsurerUserCreateInput>>;
  /** The primary key(s) and patch data for `insurerUser` for the far side of the relationship. */
  updateByAuditorUserIdAndInsurerId?: InputMaybe<
    Array<InsurerUserOnInsurerUserForInsurerUserInsurerIdFkeyUsingInsurerUserAuditorUserIdInsurerIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `insurerUser` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<InsurerUserOnInsurerUserForInsurerUserInsurerIdFkeyUsingInsurerUserPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `insurerUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<InsurerOnInsurerUserForInsurerUserInsurerIdFkeyNodeIdUpdate>
  >;
};

/** The fields on `insurerUser` to look up the row to connect. */
export type InsurerUserInsurerUserAuditorUserIdInsurerIdKeyConnect = {
  auditorUserId: Scalars["UUID"]["input"];
  insurerId: Scalars["UUID"]["input"];
};

/** The fields on `insurerUser` to look up the row to connect. */
export type InsurerUserInsurerUserPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The globally unique `ID` look up for the row to connect. */
export type InsurerUserNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `insurerUser` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type InsurerUserOnInsurerUserForInsurerUserAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `insurerUser` to look up the row to update. */
export type InsurerUserOnInsurerUserForInsurerUserAuditorUserIdFkeyUsingInsurerUserAuditorUserIdInsurerIdKeyUpdate =
  {
    auditorUserId: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurerUser` being updated. */
    patch: updateInsurerUserOnInsurerUserForInsurerUserAuditorUserIdFkeyPatch;
  };

/** The fields on `insurerUser` to look up the row to update. */
export type InsurerUserOnInsurerUserForInsurerUserAuditorUserIdFkeyUsingInsurerUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurerUser` being updated. */
    patch: updateInsurerUserOnInsurerUserForInsurerUserAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type InsurerUserOnInsurerUserForInsurerUserInsurerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `insurer` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `insurer` being updated. */
  patch: InsurerPatch;
};

/** The fields on `insurerUser` to look up the row to update. */
export type InsurerUserOnInsurerUserForInsurerUserInsurerIdFkeyUsingInsurerUserAuditorUserIdInsurerIdKeyUpdate =
  {
    auditorUserId: Scalars["UUID"]["input"];
    insurerId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurerUser` being updated. */
    patch: updateInsurerUserOnInsurerUserForInsurerUserInsurerIdFkeyPatch;
  };

/** The fields on `insurerUser` to look up the row to update. */
export type InsurerUserOnInsurerUserForInsurerUserInsurerIdFkeyUsingInsurerUserPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `insurerUser` being updated. */
    patch: updateInsurerUserOnInsurerUserForInsurerUserInsurerIdFkeyPatch;
  };

/** Represents an update to a `InsurerUser`. Fields that are set will be updated. */
export type InsurerUserPatch = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<InsurerUserAuditorUserIdFkeyInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<InsurerUserInsurerIdFkeyInput>;
};

/** A connection to a list of `InsurerUser` values. */
export type InsurerUsersConnection = {
  __typename?: "InsurerUsersConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<InsurerUserAggregates>;
  /** A list of edges which contains the `InsurerUser` and cursor to aid in pagination. */
  edges: Array<InsurerUsersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<InsurerUserAggregates>>;
  /** A list of `InsurerUser` objects. */
  nodes: Array<Maybe<InsurerUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsurerUser` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `InsurerUser` values. */
export type InsurerUsersConnectiongroupedAggregatesArgs = {
  groupBy: Array<InsurerUserGroupBy>;
  having?: InputMaybe<InsurerUserHavingInput>;
};

/** A `InsurerUser` edge in the connection. */
export type InsurerUsersEdge = {
  __typename?: "InsurerUsersEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `InsurerUser` at the end of the edge. */
  node?: Maybe<InsurerUser>;
};

/** Methods to use when ordering `InsurerUser`. */
export enum InsurerUsersOrderBy {
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC",
  AUDITOR_USER_ID_ASC = "AUDITOR_USER_ID_ASC",
  AUDITOR_USER_ID_DESC = "AUDITOR_USER_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC = "INSURER_BY_INSURER_ID__CLIENT_ABBREVIATION_DESC",
  INSURER_BY_INSURER_ID__CLIENT_ID_ASC = "INSURER_BY_INSURER_ID__CLIENT_ID_ASC",
  INSURER_BY_INSURER_ID__CLIENT_ID_DESC = "INSURER_BY_INSURER_ID__CLIENT_ID_DESC",
  INSURER_BY_INSURER_ID__CREATED_AT_ASC = "INSURER_BY_INSURER_ID__CREATED_AT_ASC",
  INSURER_BY_INSURER_ID__CREATED_AT_DESC = "INSURER_BY_INSURER_ID__CREATED_AT_DESC",
  INSURER_BY_INSURER_ID__ID_ASC = "INSURER_BY_INSURER_ID__ID_ASC",
  INSURER_BY_INSURER_ID__ID_DESC = "INSURER_BY_INSURER_ID__ID_DESC",
  INSURER_BY_INSURER_ID__NAME_ASC = "INSURER_BY_INSURER_ID__NAME_ASC",
  INSURER_BY_INSURER_ID__NAME_DESC = "INSURER_BY_INSURER_ID__NAME_DESC",
  INSURER_BY_INSURER_ID__UPDATED_AT_ASC = "INSURER_BY_INSURER_ID__UPDATED_AT_ASC",
  INSURER_BY_INSURER_ID__UPDATED_AT_DESC = "INSURER_BY_INSURER_ID__UPDATED_AT_DESC",
  INSURER_ID_ASC = "INSURER_ID_ASC",
  INSURER_ID_DESC = "INSURER_ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** A connection to a list of `Insurer` values. */
export type InsurersConnection = {
  __typename?: "InsurersConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<InsurerAggregates>;
  /** A list of edges which contains the `Insurer` and cursor to aid in pagination. */
  edges: Array<InsurersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<InsurerAggregates>>;
  /** A list of `Insurer` objects. */
  nodes: Array<Maybe<Insurer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Insurer` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `Insurer` values. */
export type InsurersConnectiongroupedAggregatesArgs = {
  groupBy: Array<InsurerGroupBy>;
  having?: InputMaybe<InsurerHavingInput>;
};

/** A `Insurer` edge in the connection. */
export type InsurersEdge = {
  __typename?: "InsurersEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Insurer` at the end of the edge. */
  node?: Maybe<Insurer>;
};

/** Methods to use when ordering `Insurer`. */
export enum InsurersOrderBy {
  AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_AVERAGE_CREATED_AT_ASC = "AUDITOR_BUCKETS_AVERAGE_CREATED_AT_ASC",
  AUDITOR_BUCKETS_AVERAGE_CREATED_AT_DESC = "AUDITOR_BUCKETS_AVERAGE_CREATED_AT_DESC",
  AUDITOR_BUCKETS_AVERAGE_DUE_DATE_ASC = "AUDITOR_BUCKETS_AVERAGE_DUE_DATE_ASC",
  AUDITOR_BUCKETS_AVERAGE_DUE_DATE_DESC = "AUDITOR_BUCKETS_AVERAGE_DUE_DATE_DESC",
  AUDITOR_BUCKETS_AVERAGE_FILTER_ASC = "AUDITOR_BUCKETS_AVERAGE_FILTER_ASC",
  AUDITOR_BUCKETS_AVERAGE_FILTER_DESC = "AUDITOR_BUCKETS_AVERAGE_FILTER_DESC",
  AUDITOR_BUCKETS_AVERAGE_ID_ASC = "AUDITOR_BUCKETS_AVERAGE_ID_ASC",
  AUDITOR_BUCKETS_AVERAGE_ID_DESC = "AUDITOR_BUCKETS_AVERAGE_ID_DESC",
  AUDITOR_BUCKETS_AVERAGE_INSURER_ID_ASC = "AUDITOR_BUCKETS_AVERAGE_INSURER_ID_ASC",
  AUDITOR_BUCKETS_AVERAGE_INSURER_ID_DESC = "AUDITOR_BUCKETS_AVERAGE_INSURER_ID_DESC",
  AUDITOR_BUCKETS_AVERAGE_NAME_ASC = "AUDITOR_BUCKETS_AVERAGE_NAME_ASC",
  AUDITOR_BUCKETS_AVERAGE_NAME_DESC = "AUDITOR_BUCKETS_AVERAGE_NAME_DESC",
  AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_ASC = "AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_DESC = "AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_BY_INSURER_ID__COUNT_ASC = "AUDITOR_BUCKETS_BY_INSURER_ID__COUNT_ASC",
  AUDITOR_BUCKETS_BY_INSURER_ID__COUNT_DESC = "AUDITOR_BUCKETS_BY_INSURER_ID__COUNT_DESC",
  AUDITOR_BUCKETS_COUNT_ASC = "AUDITOR_BUCKETS_COUNT_ASC",
  AUDITOR_BUCKETS_COUNT_DESC = "AUDITOR_BUCKETS_COUNT_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_ID_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_ID_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_ID_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_ID_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_MAX_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_MAX_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_MAX_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_MAX_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_MAX_CREATED_AT_ASC = "AUDITOR_BUCKETS_MAX_CREATED_AT_ASC",
  AUDITOR_BUCKETS_MAX_CREATED_AT_DESC = "AUDITOR_BUCKETS_MAX_CREATED_AT_DESC",
  AUDITOR_BUCKETS_MAX_DUE_DATE_ASC = "AUDITOR_BUCKETS_MAX_DUE_DATE_ASC",
  AUDITOR_BUCKETS_MAX_DUE_DATE_DESC = "AUDITOR_BUCKETS_MAX_DUE_DATE_DESC",
  AUDITOR_BUCKETS_MAX_FILTER_ASC = "AUDITOR_BUCKETS_MAX_FILTER_ASC",
  AUDITOR_BUCKETS_MAX_FILTER_DESC = "AUDITOR_BUCKETS_MAX_FILTER_DESC",
  AUDITOR_BUCKETS_MAX_ID_ASC = "AUDITOR_BUCKETS_MAX_ID_ASC",
  AUDITOR_BUCKETS_MAX_ID_DESC = "AUDITOR_BUCKETS_MAX_ID_DESC",
  AUDITOR_BUCKETS_MAX_INSURER_ID_ASC = "AUDITOR_BUCKETS_MAX_INSURER_ID_ASC",
  AUDITOR_BUCKETS_MAX_INSURER_ID_DESC = "AUDITOR_BUCKETS_MAX_INSURER_ID_DESC",
  AUDITOR_BUCKETS_MAX_NAME_ASC = "AUDITOR_BUCKETS_MAX_NAME_ASC",
  AUDITOR_BUCKETS_MAX_NAME_DESC = "AUDITOR_BUCKETS_MAX_NAME_DESC",
  AUDITOR_BUCKETS_MAX_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_MAX_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_MAX_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_MAX_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_MAX_UPDATED_AT_ASC = "AUDITOR_BUCKETS_MAX_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_MAX_UPDATED_AT_DESC = "AUDITOR_BUCKETS_MAX_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_MIN_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_MIN_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_MIN_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_MIN_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_MIN_CREATED_AT_ASC = "AUDITOR_BUCKETS_MIN_CREATED_AT_ASC",
  AUDITOR_BUCKETS_MIN_CREATED_AT_DESC = "AUDITOR_BUCKETS_MIN_CREATED_AT_DESC",
  AUDITOR_BUCKETS_MIN_DUE_DATE_ASC = "AUDITOR_BUCKETS_MIN_DUE_DATE_ASC",
  AUDITOR_BUCKETS_MIN_DUE_DATE_DESC = "AUDITOR_BUCKETS_MIN_DUE_DATE_DESC",
  AUDITOR_BUCKETS_MIN_FILTER_ASC = "AUDITOR_BUCKETS_MIN_FILTER_ASC",
  AUDITOR_BUCKETS_MIN_FILTER_DESC = "AUDITOR_BUCKETS_MIN_FILTER_DESC",
  AUDITOR_BUCKETS_MIN_ID_ASC = "AUDITOR_BUCKETS_MIN_ID_ASC",
  AUDITOR_BUCKETS_MIN_ID_DESC = "AUDITOR_BUCKETS_MIN_ID_DESC",
  AUDITOR_BUCKETS_MIN_INSURER_ID_ASC = "AUDITOR_BUCKETS_MIN_INSURER_ID_ASC",
  AUDITOR_BUCKETS_MIN_INSURER_ID_DESC = "AUDITOR_BUCKETS_MIN_INSURER_ID_DESC",
  AUDITOR_BUCKETS_MIN_NAME_ASC = "AUDITOR_BUCKETS_MIN_NAME_ASC",
  AUDITOR_BUCKETS_MIN_NAME_DESC = "AUDITOR_BUCKETS_MIN_NAME_DESC",
  AUDITOR_BUCKETS_MIN_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_MIN_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_MIN_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_MIN_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_MIN_UPDATED_AT_ASC = "AUDITOR_BUCKETS_MIN_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_MIN_UPDATED_AT_DESC = "AUDITOR_BUCKETS_MIN_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_ID_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_ID_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_SUM_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_SUM_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_SUM_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_SUM_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_SUM_CREATED_AT_ASC = "AUDITOR_BUCKETS_SUM_CREATED_AT_ASC",
  AUDITOR_BUCKETS_SUM_CREATED_AT_DESC = "AUDITOR_BUCKETS_SUM_CREATED_AT_DESC",
  AUDITOR_BUCKETS_SUM_DUE_DATE_ASC = "AUDITOR_BUCKETS_SUM_DUE_DATE_ASC",
  AUDITOR_BUCKETS_SUM_DUE_DATE_DESC = "AUDITOR_BUCKETS_SUM_DUE_DATE_DESC",
  AUDITOR_BUCKETS_SUM_FILTER_ASC = "AUDITOR_BUCKETS_SUM_FILTER_ASC",
  AUDITOR_BUCKETS_SUM_FILTER_DESC = "AUDITOR_BUCKETS_SUM_FILTER_DESC",
  AUDITOR_BUCKETS_SUM_ID_ASC = "AUDITOR_BUCKETS_SUM_ID_ASC",
  AUDITOR_BUCKETS_SUM_ID_DESC = "AUDITOR_BUCKETS_SUM_ID_DESC",
  AUDITOR_BUCKETS_SUM_INSURER_ID_ASC = "AUDITOR_BUCKETS_SUM_INSURER_ID_ASC",
  AUDITOR_BUCKETS_SUM_INSURER_ID_DESC = "AUDITOR_BUCKETS_SUM_INSURER_ID_DESC",
  AUDITOR_BUCKETS_SUM_NAME_ASC = "AUDITOR_BUCKETS_SUM_NAME_ASC",
  AUDITOR_BUCKETS_SUM_NAME_DESC = "AUDITOR_BUCKETS_SUM_NAME_DESC",
  AUDITOR_BUCKETS_SUM_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_SUM_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_SUM_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_SUM_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_SUM_UPDATED_AT_ASC = "AUDITOR_BUCKETS_SUM_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_SUM_UPDATED_AT_DESC = "AUDITOR_BUCKETS_SUM_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_TITLE_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_TITLE_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_INSURER_ID__COUNT_ASC = "AUDIT_FINDING_REPORTS_BY_INSURER_ID__COUNT_ASC",
  AUDIT_FINDING_REPORTS_BY_INSURER_ID__COUNT_DESC = "AUDIT_FINDING_REPORTS_BY_INSURER_ID__COUNT_DESC",
  AUDIT_FINDING_REPORTS_COUNT_ASC = "AUDIT_FINDING_REPORTS_COUNT_ASC",
  AUDIT_FINDING_REPORTS_COUNT_DESC = "AUDIT_FINDING_REPORTS_COUNT_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_MAX_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_MAX_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_MAX_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_MAX_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_MAX_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_S3_URL_ASC = "AUDIT_FINDING_REPORTS_MAX_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_MAX_S3_URL_DESC = "AUDIT_FINDING_REPORTS_MAX_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_MAX_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_MAX_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_MAX_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_MAX_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_MAX_TITLE_ASC = "AUDIT_FINDING_REPORTS_MAX_TITLE_ASC",
  AUDIT_FINDING_REPORTS_MAX_TITLE_DESC = "AUDIT_FINDING_REPORTS_MAX_TITLE_DESC",
  AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_MAX_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_MIN_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_MIN_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_MIN_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_MIN_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_MIN_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_S3_URL_ASC = "AUDIT_FINDING_REPORTS_MIN_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_MIN_S3_URL_DESC = "AUDIT_FINDING_REPORTS_MIN_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_MIN_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_MIN_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_MIN_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_MIN_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_MIN_TITLE_ASC = "AUDIT_FINDING_REPORTS_MIN_TITLE_ASC",
  AUDIT_FINDING_REPORTS_MIN_TITLE_DESC = "AUDIT_FINDING_REPORTS_MIN_TITLE_DESC",
  AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_MIN_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_SUM_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_SUM_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_SUM_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_SUM_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_SUM_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_S3_URL_ASC = "AUDIT_FINDING_REPORTS_SUM_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_SUM_S3_URL_DESC = "AUDIT_FINDING_REPORTS_SUM_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_SUM_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_SUM_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_SUM_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_SUM_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_SUM_TITLE_ASC = "AUDIT_FINDING_REPORTS_SUM_TITLE_ASC",
  AUDIT_FINDING_REPORTS_SUM_TITLE_DESC = "AUDIT_FINDING_REPORTS_SUM_TITLE_DESC",
  AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_SUM_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_DESC",
  BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_AVERAGE_ADM_TYPE_ASC = "BATCH_CLAIMS_AVERAGE_ADM_TYPE_ASC",
  BATCH_CLAIMS_AVERAGE_ADM_TYPE_DESC = "BATCH_CLAIMS_AVERAGE_ADM_TYPE_DESC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_AVERAGE_APR_DRG_ASC = "BATCH_CLAIMS_AVERAGE_APR_DRG_ASC",
  BATCH_CLAIMS_AVERAGE_APR_DRG_DESC = "BATCH_CLAIMS_AVERAGE_APR_DRG_DESC",
  BATCH_CLAIMS_AVERAGE_AUTHOR_ID_ASC = "BATCH_CLAIMS_AVERAGE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_AVERAGE_AUTHOR_ID_DESC = "BATCH_CLAIMS_AVERAGE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_AVERAGE_BILL_TYPE_ASC = "BATCH_CLAIMS_AVERAGE_BILL_TYPE_ASC",
  BATCH_CLAIMS_AVERAGE_BILL_TYPE_DESC = "BATCH_CLAIMS_AVERAGE_BILL_TYPE_DESC",
  BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_ICN_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_ICN_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIMS_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIMS_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIMS_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_ADMIT_ASC = "BATCH_CLAIMS_AVERAGE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_ADMIT_DESC = "BATCH_CLAIMS_AVERAGE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_1_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_1_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_1_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_1_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_2_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_2_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_2_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_2_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_3_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_3_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_3_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_3_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_4_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_4_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_4_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_4_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_5_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_5_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_5_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_5_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_6_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_6_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_6_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_6_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_7_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_7_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_7_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_7_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_8_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_8_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_8_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_8_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_9_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_9_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_9_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_9_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_10_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_10_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_10_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_10_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_11_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_11_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_11_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_11_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_12_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_12_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_12_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_12_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_13_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_13_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_13_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_13_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_14_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_14_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_14_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_14_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_15_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_15_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_15_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_15_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_16_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_16_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_16_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_16_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_17_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_17_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_17_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_17_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_18_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_18_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_18_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_18_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_19_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_19_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_19_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_19_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_20_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_20_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_20_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_20_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_21_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_21_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_21_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_21_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_22_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_22_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_22_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_22_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_23_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_23_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_23_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_23_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_24_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_24_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_24_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_24_DESC",
  BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_AVERAGE_DRG_CODE_ASC = "BATCH_CLAIMS_AVERAGE_DRG_CODE_ASC",
  BATCH_CLAIMS_AVERAGE_DRG_CODE_DESC = "BATCH_CLAIMS_AVERAGE_DRG_CODE_DESC",
  BATCH_CLAIMS_AVERAGE_ICN_ASC = "BATCH_CLAIMS_AVERAGE_ICN_ASC",
  BATCH_CLAIMS_AVERAGE_ICN_DESC = "BATCH_CLAIMS_AVERAGE_ICN_DESC",
  BATCH_CLAIMS_AVERAGE_ID_ASC = "BATCH_CLAIMS_AVERAGE_ID_ASC",
  BATCH_CLAIMS_AVERAGE_ID_DESC = "BATCH_CLAIMS_AVERAGE_ID_DESC",
  BATCH_CLAIMS_AVERAGE_INSURER_ID_ASC = "BATCH_CLAIMS_AVERAGE_INSURER_ID_ASC",
  BATCH_CLAIMS_AVERAGE_INSURER_ID_DESC = "BATCH_CLAIMS_AVERAGE_INSURER_ID_DESC",
  BATCH_CLAIMS_AVERAGE_OWNER_ID_ASC = "BATCH_CLAIMS_AVERAGE_OWNER_ID_ASC",
  BATCH_CLAIMS_AVERAGE_OWNER_ID_DESC = "BATCH_CLAIMS_AVERAGE_OWNER_ID_DESC",
  BATCH_CLAIMS_AVERAGE_PAID_DATE_ASC = "BATCH_CLAIMS_AVERAGE_PAID_DATE_ASC",
  BATCH_CLAIMS_AVERAGE_PAID_DATE_DESC = "BATCH_CLAIMS_AVERAGE_PAID_DATE_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_DOB_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_DOB_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_ID_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_ID_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_ID_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_ID_DESC",
  BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_AVERAGE_POA_1_ASC = "BATCH_CLAIMS_AVERAGE_POA_1_ASC",
  BATCH_CLAIMS_AVERAGE_POA_1_DESC = "BATCH_CLAIMS_AVERAGE_POA_1_DESC",
  BATCH_CLAIMS_AVERAGE_POA_2_ASC = "BATCH_CLAIMS_AVERAGE_POA_2_ASC",
  BATCH_CLAIMS_AVERAGE_POA_2_DESC = "BATCH_CLAIMS_AVERAGE_POA_2_DESC",
  BATCH_CLAIMS_AVERAGE_POA_3_ASC = "BATCH_CLAIMS_AVERAGE_POA_3_ASC",
  BATCH_CLAIMS_AVERAGE_POA_3_DESC = "BATCH_CLAIMS_AVERAGE_POA_3_DESC",
  BATCH_CLAIMS_AVERAGE_POA_4_ASC = "BATCH_CLAIMS_AVERAGE_POA_4_ASC",
  BATCH_CLAIMS_AVERAGE_POA_4_DESC = "BATCH_CLAIMS_AVERAGE_POA_4_DESC",
  BATCH_CLAIMS_AVERAGE_POA_5_ASC = "BATCH_CLAIMS_AVERAGE_POA_5_ASC",
  BATCH_CLAIMS_AVERAGE_POA_5_DESC = "BATCH_CLAIMS_AVERAGE_POA_5_DESC",
  BATCH_CLAIMS_AVERAGE_POA_6_ASC = "BATCH_CLAIMS_AVERAGE_POA_6_ASC",
  BATCH_CLAIMS_AVERAGE_POA_6_DESC = "BATCH_CLAIMS_AVERAGE_POA_6_DESC",
  BATCH_CLAIMS_AVERAGE_POA_7_ASC = "BATCH_CLAIMS_AVERAGE_POA_7_ASC",
  BATCH_CLAIMS_AVERAGE_POA_7_DESC = "BATCH_CLAIMS_AVERAGE_POA_7_DESC",
  BATCH_CLAIMS_AVERAGE_POA_8_ASC = "BATCH_CLAIMS_AVERAGE_POA_8_ASC",
  BATCH_CLAIMS_AVERAGE_POA_8_DESC = "BATCH_CLAIMS_AVERAGE_POA_8_DESC",
  BATCH_CLAIMS_AVERAGE_POA_9_ASC = "BATCH_CLAIMS_AVERAGE_POA_9_ASC",
  BATCH_CLAIMS_AVERAGE_POA_9_DESC = "BATCH_CLAIMS_AVERAGE_POA_9_DESC",
  BATCH_CLAIMS_AVERAGE_POA_10_ASC = "BATCH_CLAIMS_AVERAGE_POA_10_ASC",
  BATCH_CLAIMS_AVERAGE_POA_10_DESC = "BATCH_CLAIMS_AVERAGE_POA_10_DESC",
  BATCH_CLAIMS_AVERAGE_POA_11_ASC = "BATCH_CLAIMS_AVERAGE_POA_11_ASC",
  BATCH_CLAIMS_AVERAGE_POA_11_DESC = "BATCH_CLAIMS_AVERAGE_POA_11_DESC",
  BATCH_CLAIMS_AVERAGE_POA_12_ASC = "BATCH_CLAIMS_AVERAGE_POA_12_ASC",
  BATCH_CLAIMS_AVERAGE_POA_12_DESC = "BATCH_CLAIMS_AVERAGE_POA_12_DESC",
  BATCH_CLAIMS_AVERAGE_POA_13_ASC = "BATCH_CLAIMS_AVERAGE_POA_13_ASC",
  BATCH_CLAIMS_AVERAGE_POA_13_DESC = "BATCH_CLAIMS_AVERAGE_POA_13_DESC",
  BATCH_CLAIMS_AVERAGE_POA_14_ASC = "BATCH_CLAIMS_AVERAGE_POA_14_ASC",
  BATCH_CLAIMS_AVERAGE_POA_14_DESC = "BATCH_CLAIMS_AVERAGE_POA_14_DESC",
  BATCH_CLAIMS_AVERAGE_POA_15_ASC = "BATCH_CLAIMS_AVERAGE_POA_15_ASC",
  BATCH_CLAIMS_AVERAGE_POA_15_DESC = "BATCH_CLAIMS_AVERAGE_POA_15_DESC",
  BATCH_CLAIMS_AVERAGE_POA_16_ASC = "BATCH_CLAIMS_AVERAGE_POA_16_ASC",
  BATCH_CLAIMS_AVERAGE_POA_16_DESC = "BATCH_CLAIMS_AVERAGE_POA_16_DESC",
  BATCH_CLAIMS_AVERAGE_POA_17_ASC = "BATCH_CLAIMS_AVERAGE_POA_17_ASC",
  BATCH_CLAIMS_AVERAGE_POA_17_DESC = "BATCH_CLAIMS_AVERAGE_POA_17_DESC",
  BATCH_CLAIMS_AVERAGE_POA_18_ASC = "BATCH_CLAIMS_AVERAGE_POA_18_ASC",
  BATCH_CLAIMS_AVERAGE_POA_18_DESC = "BATCH_CLAIMS_AVERAGE_POA_18_DESC",
  BATCH_CLAIMS_AVERAGE_POA_19_ASC = "BATCH_CLAIMS_AVERAGE_POA_19_ASC",
  BATCH_CLAIMS_AVERAGE_POA_19_DESC = "BATCH_CLAIMS_AVERAGE_POA_19_DESC",
  BATCH_CLAIMS_AVERAGE_POA_20_ASC = "BATCH_CLAIMS_AVERAGE_POA_20_ASC",
  BATCH_CLAIMS_AVERAGE_POA_20_DESC = "BATCH_CLAIMS_AVERAGE_POA_20_DESC",
  BATCH_CLAIMS_AVERAGE_POA_21_ASC = "BATCH_CLAIMS_AVERAGE_POA_21_ASC",
  BATCH_CLAIMS_AVERAGE_POA_21_DESC = "BATCH_CLAIMS_AVERAGE_POA_21_DESC",
  BATCH_CLAIMS_AVERAGE_POA_22_ASC = "BATCH_CLAIMS_AVERAGE_POA_22_ASC",
  BATCH_CLAIMS_AVERAGE_POA_22_DESC = "BATCH_CLAIMS_AVERAGE_POA_22_DESC",
  BATCH_CLAIMS_AVERAGE_POA_23_ASC = "BATCH_CLAIMS_AVERAGE_POA_23_ASC",
  BATCH_CLAIMS_AVERAGE_POA_23_DESC = "BATCH_CLAIMS_AVERAGE_POA_23_DESC",
  BATCH_CLAIMS_AVERAGE_POA_24_ASC = "BATCH_CLAIMS_AVERAGE_POA_24_ASC",
  BATCH_CLAIMS_AVERAGE_POA_24_DESC = "BATCH_CLAIMS_AVERAGE_POA_24_DESC",
  BATCH_CLAIMS_AVERAGE_POA_25_ASC = "BATCH_CLAIMS_AVERAGE_POA_25_ASC",
  BATCH_CLAIMS_AVERAGE_POA_25_DESC = "BATCH_CLAIMS_AVERAGE_POA_25_DESC",
  BATCH_CLAIMS_AVERAGE_PREPAY_DENY_ASC = "BATCH_CLAIMS_AVERAGE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_AVERAGE_PREPAY_DENY_DESC = "BATCH_CLAIMS_AVERAGE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_AVERAGE_PROVIDER_ID_ASC = "BATCH_CLAIMS_AVERAGE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_AVERAGE_PROVIDER_ID_DESC = "BATCH_CLAIMS_AVERAGE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIMS_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIMS_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIMS_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIMS_AVERAGE_VERSION_ASC = "BATCH_CLAIMS_AVERAGE_VERSION_ASC",
  BATCH_CLAIMS_AVERAGE_VERSION_DESC = "BATCH_CLAIMS_AVERAGE_VERSION_DESC",
  BATCH_CLAIMS_AVERAGE_VERSION_GROUP_ASC = "BATCH_CLAIMS_AVERAGE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_AVERAGE_VERSION_GROUP_DESC = "BATCH_CLAIMS_AVERAGE_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_INSURER_ID__COUNT_ASC = "BATCH_CLAIMS_BY_INSURER_ID__COUNT_ASC",
  BATCH_CLAIMS_BY_INSURER_ID__COUNT_DESC = "BATCH_CLAIMS_BY_INSURER_ID__COUNT_DESC",
  BATCH_CLAIMS_COUNT_ASC = "BATCH_CLAIMS_COUNT_ASC",
  BATCH_CLAIMS_COUNT_DESC = "BATCH_CLAIMS_COUNT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ICN_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ICN_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ICN_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ICN_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_1_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_1_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_1_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_1_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_2_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_2_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_2_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_2_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_3_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_3_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_3_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_3_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_4_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_4_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_4_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_4_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_5_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_5_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_5_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_5_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_6_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_6_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_6_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_6_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_7_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_7_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_7_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_7_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_8_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_8_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_8_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_8_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_9_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_9_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_9_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_9_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_10_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_10_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_10_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_10_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_11_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_11_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_11_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_11_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_12_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_12_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_12_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_12_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_13_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_13_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_13_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_13_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_14_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_14_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_14_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_14_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_15_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_15_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_15_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_15_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_16_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_16_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_16_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_16_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_17_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_17_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_17_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_17_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_18_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_18_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_18_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_18_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_19_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_19_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_19_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_19_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_20_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_20_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_20_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_20_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_21_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_21_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_21_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_21_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_22_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_22_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_22_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_22_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_23_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_23_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_23_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_23_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_24_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_24_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_24_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_24_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_25_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_25_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_25_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_25_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_DESC",
  BATCH_CLAIMS_MAX_ADMIT_DIAG_ASC = "BATCH_CLAIMS_MAX_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_MAX_ADMIT_DIAG_DESC = "BATCH_CLAIMS_MAX_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_MAX_ADM_TYPE_ASC = "BATCH_CLAIMS_MAX_ADM_TYPE_ASC",
  BATCH_CLAIMS_MAX_ADM_TYPE_DESC = "BATCH_CLAIMS_MAX_ADM_TYPE_DESC",
  BATCH_CLAIMS_MAX_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_MAX_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_MAX_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_MAX_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_MAX_APR_DRG_ASC = "BATCH_CLAIMS_MAX_APR_DRG_ASC",
  BATCH_CLAIMS_MAX_APR_DRG_DESC = "BATCH_CLAIMS_MAX_APR_DRG_DESC",
  BATCH_CLAIMS_MAX_AUTHOR_ID_ASC = "BATCH_CLAIMS_MAX_AUTHOR_ID_ASC",
  BATCH_CLAIMS_MAX_AUTHOR_ID_DESC = "BATCH_CLAIMS_MAX_AUTHOR_ID_DESC",
  BATCH_CLAIMS_MAX_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_MAX_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_MAX_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_MAX_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_MAX_BILL_TYPE_ASC = "BATCH_CLAIMS_MAX_BILL_TYPE_ASC",
  BATCH_CLAIMS_MAX_BILL_TYPE_DESC = "BATCH_CLAIMS_MAX_BILL_TYPE_DESC",
  BATCH_CLAIMS_MAX_CLAIM_TYPE_ASC = "BATCH_CLAIMS_MAX_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_MAX_CLAIM_TYPE_DESC = "BATCH_CLAIMS_MAX_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_MAX_CLIENT_ICN_ASC = "BATCH_CLAIMS_MAX_CLIENT_ICN_ASC",
  BATCH_CLAIMS_MAX_CLIENT_ICN_DESC = "BATCH_CLAIMS_MAX_CLIENT_ICN_DESC",
  BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_MAX_CREATED_AT_ASC = "BATCH_CLAIMS_MAX_CREATED_AT_ASC",
  BATCH_CLAIMS_MAX_CREATED_AT_DESC = "BATCH_CLAIMS_MAX_CREATED_AT_DESC",
  BATCH_CLAIMS_MAX_DATE_ADMIT_ASC = "BATCH_CLAIMS_MAX_DATE_ADMIT_ASC",
  BATCH_CLAIMS_MAX_DATE_ADMIT_DESC = "BATCH_CLAIMS_MAX_DATE_ADMIT_DESC",
  BATCH_CLAIMS_MAX_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_MAX_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_MAX_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_MAX_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_MAX_DIAG_1_ASC = "BATCH_CLAIMS_MAX_DIAG_1_ASC",
  BATCH_CLAIMS_MAX_DIAG_1_DESC = "BATCH_CLAIMS_MAX_DIAG_1_DESC",
  BATCH_CLAIMS_MAX_DIAG_2_ASC = "BATCH_CLAIMS_MAX_DIAG_2_ASC",
  BATCH_CLAIMS_MAX_DIAG_2_DESC = "BATCH_CLAIMS_MAX_DIAG_2_DESC",
  BATCH_CLAIMS_MAX_DIAG_3_ASC = "BATCH_CLAIMS_MAX_DIAG_3_ASC",
  BATCH_CLAIMS_MAX_DIAG_3_DESC = "BATCH_CLAIMS_MAX_DIAG_3_DESC",
  BATCH_CLAIMS_MAX_DIAG_4_ASC = "BATCH_CLAIMS_MAX_DIAG_4_ASC",
  BATCH_CLAIMS_MAX_DIAG_4_DESC = "BATCH_CLAIMS_MAX_DIAG_4_DESC",
  BATCH_CLAIMS_MAX_DIAG_5_ASC = "BATCH_CLAIMS_MAX_DIAG_5_ASC",
  BATCH_CLAIMS_MAX_DIAG_5_DESC = "BATCH_CLAIMS_MAX_DIAG_5_DESC",
  BATCH_CLAIMS_MAX_DIAG_6_ASC = "BATCH_CLAIMS_MAX_DIAG_6_ASC",
  BATCH_CLAIMS_MAX_DIAG_6_DESC = "BATCH_CLAIMS_MAX_DIAG_6_DESC",
  BATCH_CLAIMS_MAX_DIAG_7_ASC = "BATCH_CLAIMS_MAX_DIAG_7_ASC",
  BATCH_CLAIMS_MAX_DIAG_7_DESC = "BATCH_CLAIMS_MAX_DIAG_7_DESC",
  BATCH_CLAIMS_MAX_DIAG_8_ASC = "BATCH_CLAIMS_MAX_DIAG_8_ASC",
  BATCH_CLAIMS_MAX_DIAG_8_DESC = "BATCH_CLAIMS_MAX_DIAG_8_DESC",
  BATCH_CLAIMS_MAX_DIAG_9_ASC = "BATCH_CLAIMS_MAX_DIAG_9_ASC",
  BATCH_CLAIMS_MAX_DIAG_9_DESC = "BATCH_CLAIMS_MAX_DIAG_9_DESC",
  BATCH_CLAIMS_MAX_DIAG_10_ASC = "BATCH_CLAIMS_MAX_DIAG_10_ASC",
  BATCH_CLAIMS_MAX_DIAG_10_DESC = "BATCH_CLAIMS_MAX_DIAG_10_DESC",
  BATCH_CLAIMS_MAX_DIAG_11_ASC = "BATCH_CLAIMS_MAX_DIAG_11_ASC",
  BATCH_CLAIMS_MAX_DIAG_11_DESC = "BATCH_CLAIMS_MAX_DIAG_11_DESC",
  BATCH_CLAIMS_MAX_DIAG_12_ASC = "BATCH_CLAIMS_MAX_DIAG_12_ASC",
  BATCH_CLAIMS_MAX_DIAG_12_DESC = "BATCH_CLAIMS_MAX_DIAG_12_DESC",
  BATCH_CLAIMS_MAX_DIAG_13_ASC = "BATCH_CLAIMS_MAX_DIAG_13_ASC",
  BATCH_CLAIMS_MAX_DIAG_13_DESC = "BATCH_CLAIMS_MAX_DIAG_13_DESC",
  BATCH_CLAIMS_MAX_DIAG_14_ASC = "BATCH_CLAIMS_MAX_DIAG_14_ASC",
  BATCH_CLAIMS_MAX_DIAG_14_DESC = "BATCH_CLAIMS_MAX_DIAG_14_DESC",
  BATCH_CLAIMS_MAX_DIAG_15_ASC = "BATCH_CLAIMS_MAX_DIAG_15_ASC",
  BATCH_CLAIMS_MAX_DIAG_15_DESC = "BATCH_CLAIMS_MAX_DIAG_15_DESC",
  BATCH_CLAIMS_MAX_DIAG_16_ASC = "BATCH_CLAIMS_MAX_DIAG_16_ASC",
  BATCH_CLAIMS_MAX_DIAG_16_DESC = "BATCH_CLAIMS_MAX_DIAG_16_DESC",
  BATCH_CLAIMS_MAX_DIAG_17_ASC = "BATCH_CLAIMS_MAX_DIAG_17_ASC",
  BATCH_CLAIMS_MAX_DIAG_17_DESC = "BATCH_CLAIMS_MAX_DIAG_17_DESC",
  BATCH_CLAIMS_MAX_DIAG_18_ASC = "BATCH_CLAIMS_MAX_DIAG_18_ASC",
  BATCH_CLAIMS_MAX_DIAG_18_DESC = "BATCH_CLAIMS_MAX_DIAG_18_DESC",
  BATCH_CLAIMS_MAX_DIAG_19_ASC = "BATCH_CLAIMS_MAX_DIAG_19_ASC",
  BATCH_CLAIMS_MAX_DIAG_19_DESC = "BATCH_CLAIMS_MAX_DIAG_19_DESC",
  BATCH_CLAIMS_MAX_DIAG_20_ASC = "BATCH_CLAIMS_MAX_DIAG_20_ASC",
  BATCH_CLAIMS_MAX_DIAG_20_DESC = "BATCH_CLAIMS_MAX_DIAG_20_DESC",
  BATCH_CLAIMS_MAX_DIAG_21_ASC = "BATCH_CLAIMS_MAX_DIAG_21_ASC",
  BATCH_CLAIMS_MAX_DIAG_21_DESC = "BATCH_CLAIMS_MAX_DIAG_21_DESC",
  BATCH_CLAIMS_MAX_DIAG_22_ASC = "BATCH_CLAIMS_MAX_DIAG_22_ASC",
  BATCH_CLAIMS_MAX_DIAG_22_DESC = "BATCH_CLAIMS_MAX_DIAG_22_DESC",
  BATCH_CLAIMS_MAX_DIAG_23_ASC = "BATCH_CLAIMS_MAX_DIAG_23_ASC",
  BATCH_CLAIMS_MAX_DIAG_23_DESC = "BATCH_CLAIMS_MAX_DIAG_23_DESC",
  BATCH_CLAIMS_MAX_DIAG_24_ASC = "BATCH_CLAIMS_MAX_DIAG_24_ASC",
  BATCH_CLAIMS_MAX_DIAG_24_DESC = "BATCH_CLAIMS_MAX_DIAG_24_DESC",
  BATCH_CLAIMS_MAX_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_MAX_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_MAX_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_MAX_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_MAX_DRG_CODE_ASC = "BATCH_CLAIMS_MAX_DRG_CODE_ASC",
  BATCH_CLAIMS_MAX_DRG_CODE_DESC = "BATCH_CLAIMS_MAX_DRG_CODE_DESC",
  BATCH_CLAIMS_MAX_ICN_ASC = "BATCH_CLAIMS_MAX_ICN_ASC",
  BATCH_CLAIMS_MAX_ICN_DESC = "BATCH_CLAIMS_MAX_ICN_DESC",
  BATCH_CLAIMS_MAX_ID_ASC = "BATCH_CLAIMS_MAX_ID_ASC",
  BATCH_CLAIMS_MAX_ID_DESC = "BATCH_CLAIMS_MAX_ID_DESC",
  BATCH_CLAIMS_MAX_INSURER_ID_ASC = "BATCH_CLAIMS_MAX_INSURER_ID_ASC",
  BATCH_CLAIMS_MAX_INSURER_ID_DESC = "BATCH_CLAIMS_MAX_INSURER_ID_DESC",
  BATCH_CLAIMS_MAX_OWNER_ID_ASC = "BATCH_CLAIMS_MAX_OWNER_ID_ASC",
  BATCH_CLAIMS_MAX_OWNER_ID_DESC = "BATCH_CLAIMS_MAX_OWNER_ID_DESC",
  BATCH_CLAIMS_MAX_PAID_DATE_ASC = "BATCH_CLAIMS_MAX_PAID_DATE_ASC",
  BATCH_CLAIMS_MAX_PAID_DATE_DESC = "BATCH_CLAIMS_MAX_PAID_DATE_DESC",
  BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_MAX_PATIENT_DOB_ASC = "BATCH_CLAIMS_MAX_PATIENT_DOB_ASC",
  BATCH_CLAIMS_MAX_PATIENT_DOB_DESC = "BATCH_CLAIMS_MAX_PATIENT_DOB_DESC",
  BATCH_CLAIMS_MAX_PATIENT_GENDER_ASC = "BATCH_CLAIMS_MAX_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_MAX_PATIENT_GENDER_DESC = "BATCH_CLAIMS_MAX_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_MAX_PATIENT_ID_ASC = "BATCH_CLAIMS_MAX_PATIENT_ID_ASC",
  BATCH_CLAIMS_MAX_PATIENT_ID_DESC = "BATCH_CLAIMS_MAX_PATIENT_ID_DESC",
  BATCH_CLAIMS_MAX_PAYMENT_RATE_ASC = "BATCH_CLAIMS_MAX_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_MAX_PAYMENT_RATE_DESC = "BATCH_CLAIMS_MAX_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_MAX_POA_1_ASC = "BATCH_CLAIMS_MAX_POA_1_ASC",
  BATCH_CLAIMS_MAX_POA_1_DESC = "BATCH_CLAIMS_MAX_POA_1_DESC",
  BATCH_CLAIMS_MAX_POA_2_ASC = "BATCH_CLAIMS_MAX_POA_2_ASC",
  BATCH_CLAIMS_MAX_POA_2_DESC = "BATCH_CLAIMS_MAX_POA_2_DESC",
  BATCH_CLAIMS_MAX_POA_3_ASC = "BATCH_CLAIMS_MAX_POA_3_ASC",
  BATCH_CLAIMS_MAX_POA_3_DESC = "BATCH_CLAIMS_MAX_POA_3_DESC",
  BATCH_CLAIMS_MAX_POA_4_ASC = "BATCH_CLAIMS_MAX_POA_4_ASC",
  BATCH_CLAIMS_MAX_POA_4_DESC = "BATCH_CLAIMS_MAX_POA_4_DESC",
  BATCH_CLAIMS_MAX_POA_5_ASC = "BATCH_CLAIMS_MAX_POA_5_ASC",
  BATCH_CLAIMS_MAX_POA_5_DESC = "BATCH_CLAIMS_MAX_POA_5_DESC",
  BATCH_CLAIMS_MAX_POA_6_ASC = "BATCH_CLAIMS_MAX_POA_6_ASC",
  BATCH_CLAIMS_MAX_POA_6_DESC = "BATCH_CLAIMS_MAX_POA_6_DESC",
  BATCH_CLAIMS_MAX_POA_7_ASC = "BATCH_CLAIMS_MAX_POA_7_ASC",
  BATCH_CLAIMS_MAX_POA_7_DESC = "BATCH_CLAIMS_MAX_POA_7_DESC",
  BATCH_CLAIMS_MAX_POA_8_ASC = "BATCH_CLAIMS_MAX_POA_8_ASC",
  BATCH_CLAIMS_MAX_POA_8_DESC = "BATCH_CLAIMS_MAX_POA_8_DESC",
  BATCH_CLAIMS_MAX_POA_9_ASC = "BATCH_CLAIMS_MAX_POA_9_ASC",
  BATCH_CLAIMS_MAX_POA_9_DESC = "BATCH_CLAIMS_MAX_POA_9_DESC",
  BATCH_CLAIMS_MAX_POA_10_ASC = "BATCH_CLAIMS_MAX_POA_10_ASC",
  BATCH_CLAIMS_MAX_POA_10_DESC = "BATCH_CLAIMS_MAX_POA_10_DESC",
  BATCH_CLAIMS_MAX_POA_11_ASC = "BATCH_CLAIMS_MAX_POA_11_ASC",
  BATCH_CLAIMS_MAX_POA_11_DESC = "BATCH_CLAIMS_MAX_POA_11_DESC",
  BATCH_CLAIMS_MAX_POA_12_ASC = "BATCH_CLAIMS_MAX_POA_12_ASC",
  BATCH_CLAIMS_MAX_POA_12_DESC = "BATCH_CLAIMS_MAX_POA_12_DESC",
  BATCH_CLAIMS_MAX_POA_13_ASC = "BATCH_CLAIMS_MAX_POA_13_ASC",
  BATCH_CLAIMS_MAX_POA_13_DESC = "BATCH_CLAIMS_MAX_POA_13_DESC",
  BATCH_CLAIMS_MAX_POA_14_ASC = "BATCH_CLAIMS_MAX_POA_14_ASC",
  BATCH_CLAIMS_MAX_POA_14_DESC = "BATCH_CLAIMS_MAX_POA_14_DESC",
  BATCH_CLAIMS_MAX_POA_15_ASC = "BATCH_CLAIMS_MAX_POA_15_ASC",
  BATCH_CLAIMS_MAX_POA_15_DESC = "BATCH_CLAIMS_MAX_POA_15_DESC",
  BATCH_CLAIMS_MAX_POA_16_ASC = "BATCH_CLAIMS_MAX_POA_16_ASC",
  BATCH_CLAIMS_MAX_POA_16_DESC = "BATCH_CLAIMS_MAX_POA_16_DESC",
  BATCH_CLAIMS_MAX_POA_17_ASC = "BATCH_CLAIMS_MAX_POA_17_ASC",
  BATCH_CLAIMS_MAX_POA_17_DESC = "BATCH_CLAIMS_MAX_POA_17_DESC",
  BATCH_CLAIMS_MAX_POA_18_ASC = "BATCH_CLAIMS_MAX_POA_18_ASC",
  BATCH_CLAIMS_MAX_POA_18_DESC = "BATCH_CLAIMS_MAX_POA_18_DESC",
  BATCH_CLAIMS_MAX_POA_19_ASC = "BATCH_CLAIMS_MAX_POA_19_ASC",
  BATCH_CLAIMS_MAX_POA_19_DESC = "BATCH_CLAIMS_MAX_POA_19_DESC",
  BATCH_CLAIMS_MAX_POA_20_ASC = "BATCH_CLAIMS_MAX_POA_20_ASC",
  BATCH_CLAIMS_MAX_POA_20_DESC = "BATCH_CLAIMS_MAX_POA_20_DESC",
  BATCH_CLAIMS_MAX_POA_21_ASC = "BATCH_CLAIMS_MAX_POA_21_ASC",
  BATCH_CLAIMS_MAX_POA_21_DESC = "BATCH_CLAIMS_MAX_POA_21_DESC",
  BATCH_CLAIMS_MAX_POA_22_ASC = "BATCH_CLAIMS_MAX_POA_22_ASC",
  BATCH_CLAIMS_MAX_POA_22_DESC = "BATCH_CLAIMS_MAX_POA_22_DESC",
  BATCH_CLAIMS_MAX_POA_23_ASC = "BATCH_CLAIMS_MAX_POA_23_ASC",
  BATCH_CLAIMS_MAX_POA_23_DESC = "BATCH_CLAIMS_MAX_POA_23_DESC",
  BATCH_CLAIMS_MAX_POA_24_ASC = "BATCH_CLAIMS_MAX_POA_24_ASC",
  BATCH_CLAIMS_MAX_POA_24_DESC = "BATCH_CLAIMS_MAX_POA_24_DESC",
  BATCH_CLAIMS_MAX_POA_25_ASC = "BATCH_CLAIMS_MAX_POA_25_ASC",
  BATCH_CLAIMS_MAX_POA_25_DESC = "BATCH_CLAIMS_MAX_POA_25_DESC",
  BATCH_CLAIMS_MAX_PREPAY_DENY_ASC = "BATCH_CLAIMS_MAX_PREPAY_DENY_ASC",
  BATCH_CLAIMS_MAX_PREPAY_DENY_DESC = "BATCH_CLAIMS_MAX_PREPAY_DENY_DESC",
  BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_MAX_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_MAX_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_MAX_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_MAX_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_MAX_PROVIDER_ID_ASC = "BATCH_CLAIMS_MAX_PROVIDER_ID_ASC",
  BATCH_CLAIMS_MAX_PROVIDER_ID_DESC = "BATCH_CLAIMS_MAX_PROVIDER_ID_DESC",
  BATCH_CLAIMS_MAX_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_MAX_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_MAX_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_MAX_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_MAX_UPDATED_AT_ASC = "BATCH_CLAIMS_MAX_UPDATED_AT_ASC",
  BATCH_CLAIMS_MAX_UPDATED_AT_DESC = "BATCH_CLAIMS_MAX_UPDATED_AT_DESC",
  BATCH_CLAIMS_MAX_VERSION_ASC = "BATCH_CLAIMS_MAX_VERSION_ASC",
  BATCH_CLAIMS_MAX_VERSION_DESC = "BATCH_CLAIMS_MAX_VERSION_DESC",
  BATCH_CLAIMS_MAX_VERSION_GROUP_ASC = "BATCH_CLAIMS_MAX_VERSION_GROUP_ASC",
  BATCH_CLAIMS_MAX_VERSION_GROUP_DESC = "BATCH_CLAIMS_MAX_VERSION_GROUP_DESC",
  BATCH_CLAIMS_MIN_ADMIT_DIAG_ASC = "BATCH_CLAIMS_MIN_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_MIN_ADMIT_DIAG_DESC = "BATCH_CLAIMS_MIN_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_MIN_ADM_TYPE_ASC = "BATCH_CLAIMS_MIN_ADM_TYPE_ASC",
  BATCH_CLAIMS_MIN_ADM_TYPE_DESC = "BATCH_CLAIMS_MIN_ADM_TYPE_DESC",
  BATCH_CLAIMS_MIN_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_MIN_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_MIN_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_MIN_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_MIN_APR_DRG_ASC = "BATCH_CLAIMS_MIN_APR_DRG_ASC",
  BATCH_CLAIMS_MIN_APR_DRG_DESC = "BATCH_CLAIMS_MIN_APR_DRG_DESC",
  BATCH_CLAIMS_MIN_AUTHOR_ID_ASC = "BATCH_CLAIMS_MIN_AUTHOR_ID_ASC",
  BATCH_CLAIMS_MIN_AUTHOR_ID_DESC = "BATCH_CLAIMS_MIN_AUTHOR_ID_DESC",
  BATCH_CLAIMS_MIN_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_MIN_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_MIN_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_MIN_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_MIN_BILL_TYPE_ASC = "BATCH_CLAIMS_MIN_BILL_TYPE_ASC",
  BATCH_CLAIMS_MIN_BILL_TYPE_DESC = "BATCH_CLAIMS_MIN_BILL_TYPE_DESC",
  BATCH_CLAIMS_MIN_CLAIM_TYPE_ASC = "BATCH_CLAIMS_MIN_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_MIN_CLAIM_TYPE_DESC = "BATCH_CLAIMS_MIN_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_MIN_CLIENT_ICN_ASC = "BATCH_CLAIMS_MIN_CLIENT_ICN_ASC",
  BATCH_CLAIMS_MIN_CLIENT_ICN_DESC = "BATCH_CLAIMS_MIN_CLIENT_ICN_DESC",
  BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_MIN_CREATED_AT_ASC = "BATCH_CLAIMS_MIN_CREATED_AT_ASC",
  BATCH_CLAIMS_MIN_CREATED_AT_DESC = "BATCH_CLAIMS_MIN_CREATED_AT_DESC",
  BATCH_CLAIMS_MIN_DATE_ADMIT_ASC = "BATCH_CLAIMS_MIN_DATE_ADMIT_ASC",
  BATCH_CLAIMS_MIN_DATE_ADMIT_DESC = "BATCH_CLAIMS_MIN_DATE_ADMIT_DESC",
  BATCH_CLAIMS_MIN_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_MIN_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_MIN_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_MIN_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_MIN_DIAG_1_ASC = "BATCH_CLAIMS_MIN_DIAG_1_ASC",
  BATCH_CLAIMS_MIN_DIAG_1_DESC = "BATCH_CLAIMS_MIN_DIAG_1_DESC",
  BATCH_CLAIMS_MIN_DIAG_2_ASC = "BATCH_CLAIMS_MIN_DIAG_2_ASC",
  BATCH_CLAIMS_MIN_DIAG_2_DESC = "BATCH_CLAIMS_MIN_DIAG_2_DESC",
  BATCH_CLAIMS_MIN_DIAG_3_ASC = "BATCH_CLAIMS_MIN_DIAG_3_ASC",
  BATCH_CLAIMS_MIN_DIAG_3_DESC = "BATCH_CLAIMS_MIN_DIAG_3_DESC",
  BATCH_CLAIMS_MIN_DIAG_4_ASC = "BATCH_CLAIMS_MIN_DIAG_4_ASC",
  BATCH_CLAIMS_MIN_DIAG_4_DESC = "BATCH_CLAIMS_MIN_DIAG_4_DESC",
  BATCH_CLAIMS_MIN_DIAG_5_ASC = "BATCH_CLAIMS_MIN_DIAG_5_ASC",
  BATCH_CLAIMS_MIN_DIAG_5_DESC = "BATCH_CLAIMS_MIN_DIAG_5_DESC",
  BATCH_CLAIMS_MIN_DIAG_6_ASC = "BATCH_CLAIMS_MIN_DIAG_6_ASC",
  BATCH_CLAIMS_MIN_DIAG_6_DESC = "BATCH_CLAIMS_MIN_DIAG_6_DESC",
  BATCH_CLAIMS_MIN_DIAG_7_ASC = "BATCH_CLAIMS_MIN_DIAG_7_ASC",
  BATCH_CLAIMS_MIN_DIAG_7_DESC = "BATCH_CLAIMS_MIN_DIAG_7_DESC",
  BATCH_CLAIMS_MIN_DIAG_8_ASC = "BATCH_CLAIMS_MIN_DIAG_8_ASC",
  BATCH_CLAIMS_MIN_DIAG_8_DESC = "BATCH_CLAIMS_MIN_DIAG_8_DESC",
  BATCH_CLAIMS_MIN_DIAG_9_ASC = "BATCH_CLAIMS_MIN_DIAG_9_ASC",
  BATCH_CLAIMS_MIN_DIAG_9_DESC = "BATCH_CLAIMS_MIN_DIAG_9_DESC",
  BATCH_CLAIMS_MIN_DIAG_10_ASC = "BATCH_CLAIMS_MIN_DIAG_10_ASC",
  BATCH_CLAIMS_MIN_DIAG_10_DESC = "BATCH_CLAIMS_MIN_DIAG_10_DESC",
  BATCH_CLAIMS_MIN_DIAG_11_ASC = "BATCH_CLAIMS_MIN_DIAG_11_ASC",
  BATCH_CLAIMS_MIN_DIAG_11_DESC = "BATCH_CLAIMS_MIN_DIAG_11_DESC",
  BATCH_CLAIMS_MIN_DIAG_12_ASC = "BATCH_CLAIMS_MIN_DIAG_12_ASC",
  BATCH_CLAIMS_MIN_DIAG_12_DESC = "BATCH_CLAIMS_MIN_DIAG_12_DESC",
  BATCH_CLAIMS_MIN_DIAG_13_ASC = "BATCH_CLAIMS_MIN_DIAG_13_ASC",
  BATCH_CLAIMS_MIN_DIAG_13_DESC = "BATCH_CLAIMS_MIN_DIAG_13_DESC",
  BATCH_CLAIMS_MIN_DIAG_14_ASC = "BATCH_CLAIMS_MIN_DIAG_14_ASC",
  BATCH_CLAIMS_MIN_DIAG_14_DESC = "BATCH_CLAIMS_MIN_DIAG_14_DESC",
  BATCH_CLAIMS_MIN_DIAG_15_ASC = "BATCH_CLAIMS_MIN_DIAG_15_ASC",
  BATCH_CLAIMS_MIN_DIAG_15_DESC = "BATCH_CLAIMS_MIN_DIAG_15_DESC",
  BATCH_CLAIMS_MIN_DIAG_16_ASC = "BATCH_CLAIMS_MIN_DIAG_16_ASC",
  BATCH_CLAIMS_MIN_DIAG_16_DESC = "BATCH_CLAIMS_MIN_DIAG_16_DESC",
  BATCH_CLAIMS_MIN_DIAG_17_ASC = "BATCH_CLAIMS_MIN_DIAG_17_ASC",
  BATCH_CLAIMS_MIN_DIAG_17_DESC = "BATCH_CLAIMS_MIN_DIAG_17_DESC",
  BATCH_CLAIMS_MIN_DIAG_18_ASC = "BATCH_CLAIMS_MIN_DIAG_18_ASC",
  BATCH_CLAIMS_MIN_DIAG_18_DESC = "BATCH_CLAIMS_MIN_DIAG_18_DESC",
  BATCH_CLAIMS_MIN_DIAG_19_ASC = "BATCH_CLAIMS_MIN_DIAG_19_ASC",
  BATCH_CLAIMS_MIN_DIAG_19_DESC = "BATCH_CLAIMS_MIN_DIAG_19_DESC",
  BATCH_CLAIMS_MIN_DIAG_20_ASC = "BATCH_CLAIMS_MIN_DIAG_20_ASC",
  BATCH_CLAIMS_MIN_DIAG_20_DESC = "BATCH_CLAIMS_MIN_DIAG_20_DESC",
  BATCH_CLAIMS_MIN_DIAG_21_ASC = "BATCH_CLAIMS_MIN_DIAG_21_ASC",
  BATCH_CLAIMS_MIN_DIAG_21_DESC = "BATCH_CLAIMS_MIN_DIAG_21_DESC",
  BATCH_CLAIMS_MIN_DIAG_22_ASC = "BATCH_CLAIMS_MIN_DIAG_22_ASC",
  BATCH_CLAIMS_MIN_DIAG_22_DESC = "BATCH_CLAIMS_MIN_DIAG_22_DESC",
  BATCH_CLAIMS_MIN_DIAG_23_ASC = "BATCH_CLAIMS_MIN_DIAG_23_ASC",
  BATCH_CLAIMS_MIN_DIAG_23_DESC = "BATCH_CLAIMS_MIN_DIAG_23_DESC",
  BATCH_CLAIMS_MIN_DIAG_24_ASC = "BATCH_CLAIMS_MIN_DIAG_24_ASC",
  BATCH_CLAIMS_MIN_DIAG_24_DESC = "BATCH_CLAIMS_MIN_DIAG_24_DESC",
  BATCH_CLAIMS_MIN_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_MIN_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_MIN_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_MIN_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_MIN_DRG_CODE_ASC = "BATCH_CLAIMS_MIN_DRG_CODE_ASC",
  BATCH_CLAIMS_MIN_DRG_CODE_DESC = "BATCH_CLAIMS_MIN_DRG_CODE_DESC",
  BATCH_CLAIMS_MIN_ICN_ASC = "BATCH_CLAIMS_MIN_ICN_ASC",
  BATCH_CLAIMS_MIN_ICN_DESC = "BATCH_CLAIMS_MIN_ICN_DESC",
  BATCH_CLAIMS_MIN_ID_ASC = "BATCH_CLAIMS_MIN_ID_ASC",
  BATCH_CLAIMS_MIN_ID_DESC = "BATCH_CLAIMS_MIN_ID_DESC",
  BATCH_CLAIMS_MIN_INSURER_ID_ASC = "BATCH_CLAIMS_MIN_INSURER_ID_ASC",
  BATCH_CLAIMS_MIN_INSURER_ID_DESC = "BATCH_CLAIMS_MIN_INSURER_ID_DESC",
  BATCH_CLAIMS_MIN_OWNER_ID_ASC = "BATCH_CLAIMS_MIN_OWNER_ID_ASC",
  BATCH_CLAIMS_MIN_OWNER_ID_DESC = "BATCH_CLAIMS_MIN_OWNER_ID_DESC",
  BATCH_CLAIMS_MIN_PAID_DATE_ASC = "BATCH_CLAIMS_MIN_PAID_DATE_ASC",
  BATCH_CLAIMS_MIN_PAID_DATE_DESC = "BATCH_CLAIMS_MIN_PAID_DATE_DESC",
  BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_MIN_PATIENT_DOB_ASC = "BATCH_CLAIMS_MIN_PATIENT_DOB_ASC",
  BATCH_CLAIMS_MIN_PATIENT_DOB_DESC = "BATCH_CLAIMS_MIN_PATIENT_DOB_DESC",
  BATCH_CLAIMS_MIN_PATIENT_GENDER_ASC = "BATCH_CLAIMS_MIN_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_MIN_PATIENT_GENDER_DESC = "BATCH_CLAIMS_MIN_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_MIN_PATIENT_ID_ASC = "BATCH_CLAIMS_MIN_PATIENT_ID_ASC",
  BATCH_CLAIMS_MIN_PATIENT_ID_DESC = "BATCH_CLAIMS_MIN_PATIENT_ID_DESC",
  BATCH_CLAIMS_MIN_PAYMENT_RATE_ASC = "BATCH_CLAIMS_MIN_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_MIN_PAYMENT_RATE_DESC = "BATCH_CLAIMS_MIN_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_MIN_POA_1_ASC = "BATCH_CLAIMS_MIN_POA_1_ASC",
  BATCH_CLAIMS_MIN_POA_1_DESC = "BATCH_CLAIMS_MIN_POA_1_DESC",
  BATCH_CLAIMS_MIN_POA_2_ASC = "BATCH_CLAIMS_MIN_POA_2_ASC",
  BATCH_CLAIMS_MIN_POA_2_DESC = "BATCH_CLAIMS_MIN_POA_2_DESC",
  BATCH_CLAIMS_MIN_POA_3_ASC = "BATCH_CLAIMS_MIN_POA_3_ASC",
  BATCH_CLAIMS_MIN_POA_3_DESC = "BATCH_CLAIMS_MIN_POA_3_DESC",
  BATCH_CLAIMS_MIN_POA_4_ASC = "BATCH_CLAIMS_MIN_POA_4_ASC",
  BATCH_CLAIMS_MIN_POA_4_DESC = "BATCH_CLAIMS_MIN_POA_4_DESC",
  BATCH_CLAIMS_MIN_POA_5_ASC = "BATCH_CLAIMS_MIN_POA_5_ASC",
  BATCH_CLAIMS_MIN_POA_5_DESC = "BATCH_CLAIMS_MIN_POA_5_DESC",
  BATCH_CLAIMS_MIN_POA_6_ASC = "BATCH_CLAIMS_MIN_POA_6_ASC",
  BATCH_CLAIMS_MIN_POA_6_DESC = "BATCH_CLAIMS_MIN_POA_6_DESC",
  BATCH_CLAIMS_MIN_POA_7_ASC = "BATCH_CLAIMS_MIN_POA_7_ASC",
  BATCH_CLAIMS_MIN_POA_7_DESC = "BATCH_CLAIMS_MIN_POA_7_DESC",
  BATCH_CLAIMS_MIN_POA_8_ASC = "BATCH_CLAIMS_MIN_POA_8_ASC",
  BATCH_CLAIMS_MIN_POA_8_DESC = "BATCH_CLAIMS_MIN_POA_8_DESC",
  BATCH_CLAIMS_MIN_POA_9_ASC = "BATCH_CLAIMS_MIN_POA_9_ASC",
  BATCH_CLAIMS_MIN_POA_9_DESC = "BATCH_CLAIMS_MIN_POA_9_DESC",
  BATCH_CLAIMS_MIN_POA_10_ASC = "BATCH_CLAIMS_MIN_POA_10_ASC",
  BATCH_CLAIMS_MIN_POA_10_DESC = "BATCH_CLAIMS_MIN_POA_10_DESC",
  BATCH_CLAIMS_MIN_POA_11_ASC = "BATCH_CLAIMS_MIN_POA_11_ASC",
  BATCH_CLAIMS_MIN_POA_11_DESC = "BATCH_CLAIMS_MIN_POA_11_DESC",
  BATCH_CLAIMS_MIN_POA_12_ASC = "BATCH_CLAIMS_MIN_POA_12_ASC",
  BATCH_CLAIMS_MIN_POA_12_DESC = "BATCH_CLAIMS_MIN_POA_12_DESC",
  BATCH_CLAIMS_MIN_POA_13_ASC = "BATCH_CLAIMS_MIN_POA_13_ASC",
  BATCH_CLAIMS_MIN_POA_13_DESC = "BATCH_CLAIMS_MIN_POA_13_DESC",
  BATCH_CLAIMS_MIN_POA_14_ASC = "BATCH_CLAIMS_MIN_POA_14_ASC",
  BATCH_CLAIMS_MIN_POA_14_DESC = "BATCH_CLAIMS_MIN_POA_14_DESC",
  BATCH_CLAIMS_MIN_POA_15_ASC = "BATCH_CLAIMS_MIN_POA_15_ASC",
  BATCH_CLAIMS_MIN_POA_15_DESC = "BATCH_CLAIMS_MIN_POA_15_DESC",
  BATCH_CLAIMS_MIN_POA_16_ASC = "BATCH_CLAIMS_MIN_POA_16_ASC",
  BATCH_CLAIMS_MIN_POA_16_DESC = "BATCH_CLAIMS_MIN_POA_16_DESC",
  BATCH_CLAIMS_MIN_POA_17_ASC = "BATCH_CLAIMS_MIN_POA_17_ASC",
  BATCH_CLAIMS_MIN_POA_17_DESC = "BATCH_CLAIMS_MIN_POA_17_DESC",
  BATCH_CLAIMS_MIN_POA_18_ASC = "BATCH_CLAIMS_MIN_POA_18_ASC",
  BATCH_CLAIMS_MIN_POA_18_DESC = "BATCH_CLAIMS_MIN_POA_18_DESC",
  BATCH_CLAIMS_MIN_POA_19_ASC = "BATCH_CLAIMS_MIN_POA_19_ASC",
  BATCH_CLAIMS_MIN_POA_19_DESC = "BATCH_CLAIMS_MIN_POA_19_DESC",
  BATCH_CLAIMS_MIN_POA_20_ASC = "BATCH_CLAIMS_MIN_POA_20_ASC",
  BATCH_CLAIMS_MIN_POA_20_DESC = "BATCH_CLAIMS_MIN_POA_20_DESC",
  BATCH_CLAIMS_MIN_POA_21_ASC = "BATCH_CLAIMS_MIN_POA_21_ASC",
  BATCH_CLAIMS_MIN_POA_21_DESC = "BATCH_CLAIMS_MIN_POA_21_DESC",
  BATCH_CLAIMS_MIN_POA_22_ASC = "BATCH_CLAIMS_MIN_POA_22_ASC",
  BATCH_CLAIMS_MIN_POA_22_DESC = "BATCH_CLAIMS_MIN_POA_22_DESC",
  BATCH_CLAIMS_MIN_POA_23_ASC = "BATCH_CLAIMS_MIN_POA_23_ASC",
  BATCH_CLAIMS_MIN_POA_23_DESC = "BATCH_CLAIMS_MIN_POA_23_DESC",
  BATCH_CLAIMS_MIN_POA_24_ASC = "BATCH_CLAIMS_MIN_POA_24_ASC",
  BATCH_CLAIMS_MIN_POA_24_DESC = "BATCH_CLAIMS_MIN_POA_24_DESC",
  BATCH_CLAIMS_MIN_POA_25_ASC = "BATCH_CLAIMS_MIN_POA_25_ASC",
  BATCH_CLAIMS_MIN_POA_25_DESC = "BATCH_CLAIMS_MIN_POA_25_DESC",
  BATCH_CLAIMS_MIN_PREPAY_DENY_ASC = "BATCH_CLAIMS_MIN_PREPAY_DENY_ASC",
  BATCH_CLAIMS_MIN_PREPAY_DENY_DESC = "BATCH_CLAIMS_MIN_PREPAY_DENY_DESC",
  BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_MIN_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_MIN_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_MIN_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_MIN_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_MIN_PROVIDER_ID_ASC = "BATCH_CLAIMS_MIN_PROVIDER_ID_ASC",
  BATCH_CLAIMS_MIN_PROVIDER_ID_DESC = "BATCH_CLAIMS_MIN_PROVIDER_ID_DESC",
  BATCH_CLAIMS_MIN_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_MIN_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_MIN_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_MIN_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_MIN_UPDATED_AT_ASC = "BATCH_CLAIMS_MIN_UPDATED_AT_ASC",
  BATCH_CLAIMS_MIN_UPDATED_AT_DESC = "BATCH_CLAIMS_MIN_UPDATED_AT_DESC",
  BATCH_CLAIMS_MIN_VERSION_ASC = "BATCH_CLAIMS_MIN_VERSION_ASC",
  BATCH_CLAIMS_MIN_VERSION_DESC = "BATCH_CLAIMS_MIN_VERSION_DESC",
  BATCH_CLAIMS_MIN_VERSION_GROUP_ASC = "BATCH_CLAIMS_MIN_VERSION_GROUP_ASC",
  BATCH_CLAIMS_MIN_VERSION_GROUP_DESC = "BATCH_CLAIMS_MIN_VERSION_GROUP_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ICN_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ICN_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ICN_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ICN_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_1_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_1_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_1_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_1_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_2_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_2_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_2_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_2_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_3_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_3_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_3_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_3_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_4_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_4_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_4_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_4_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_5_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_5_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_5_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_5_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_6_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_6_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_6_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_6_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_7_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_7_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_7_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_7_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_8_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_8_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_8_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_8_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_9_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_9_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_9_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_9_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_10_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_10_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_10_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_10_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_11_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_11_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_11_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_11_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_12_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_12_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_12_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_12_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_13_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_13_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_13_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_13_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_14_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_14_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_14_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_14_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_15_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_15_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_15_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_15_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_16_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_16_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_16_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_16_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_17_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_17_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_17_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_17_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_18_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_18_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_18_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_18_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_19_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_19_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_19_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_19_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_20_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_20_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_20_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_20_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_21_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_21_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_21_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_21_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_22_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_22_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_22_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_22_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_23_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_23_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_23_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_23_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_24_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_24_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_24_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_24_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_25_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_25_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_25_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_25_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ICN_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ICN_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ICN_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ICN_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_DESC",
  BATCH_CLAIMS_SUM_ADMIT_DIAG_ASC = "BATCH_CLAIMS_SUM_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_SUM_ADMIT_DIAG_DESC = "BATCH_CLAIMS_SUM_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_SUM_ADM_TYPE_ASC = "BATCH_CLAIMS_SUM_ADM_TYPE_ASC",
  BATCH_CLAIMS_SUM_ADM_TYPE_DESC = "BATCH_CLAIMS_SUM_ADM_TYPE_DESC",
  BATCH_CLAIMS_SUM_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_SUM_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_SUM_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_SUM_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_SUM_APR_DRG_ASC = "BATCH_CLAIMS_SUM_APR_DRG_ASC",
  BATCH_CLAIMS_SUM_APR_DRG_DESC = "BATCH_CLAIMS_SUM_APR_DRG_DESC",
  BATCH_CLAIMS_SUM_AUTHOR_ID_ASC = "BATCH_CLAIMS_SUM_AUTHOR_ID_ASC",
  BATCH_CLAIMS_SUM_AUTHOR_ID_DESC = "BATCH_CLAIMS_SUM_AUTHOR_ID_DESC",
  BATCH_CLAIMS_SUM_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_SUM_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_SUM_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_SUM_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_SUM_BILL_TYPE_ASC = "BATCH_CLAIMS_SUM_BILL_TYPE_ASC",
  BATCH_CLAIMS_SUM_BILL_TYPE_DESC = "BATCH_CLAIMS_SUM_BILL_TYPE_DESC",
  BATCH_CLAIMS_SUM_CLAIM_TYPE_ASC = "BATCH_CLAIMS_SUM_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_SUM_CLAIM_TYPE_DESC = "BATCH_CLAIMS_SUM_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_SUM_CLIENT_ICN_ASC = "BATCH_CLAIMS_SUM_CLIENT_ICN_ASC",
  BATCH_CLAIMS_SUM_CLIENT_ICN_DESC = "BATCH_CLAIMS_SUM_CLIENT_ICN_DESC",
  BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_SUM_CREATED_AT_ASC = "BATCH_CLAIMS_SUM_CREATED_AT_ASC",
  BATCH_CLAIMS_SUM_CREATED_AT_DESC = "BATCH_CLAIMS_SUM_CREATED_AT_DESC",
  BATCH_CLAIMS_SUM_DATE_ADMIT_ASC = "BATCH_CLAIMS_SUM_DATE_ADMIT_ASC",
  BATCH_CLAIMS_SUM_DATE_ADMIT_DESC = "BATCH_CLAIMS_SUM_DATE_ADMIT_DESC",
  BATCH_CLAIMS_SUM_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_SUM_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_SUM_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_SUM_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_SUM_DIAG_1_ASC = "BATCH_CLAIMS_SUM_DIAG_1_ASC",
  BATCH_CLAIMS_SUM_DIAG_1_DESC = "BATCH_CLAIMS_SUM_DIAG_1_DESC",
  BATCH_CLAIMS_SUM_DIAG_2_ASC = "BATCH_CLAIMS_SUM_DIAG_2_ASC",
  BATCH_CLAIMS_SUM_DIAG_2_DESC = "BATCH_CLAIMS_SUM_DIAG_2_DESC",
  BATCH_CLAIMS_SUM_DIAG_3_ASC = "BATCH_CLAIMS_SUM_DIAG_3_ASC",
  BATCH_CLAIMS_SUM_DIAG_3_DESC = "BATCH_CLAIMS_SUM_DIAG_3_DESC",
  BATCH_CLAIMS_SUM_DIAG_4_ASC = "BATCH_CLAIMS_SUM_DIAG_4_ASC",
  BATCH_CLAIMS_SUM_DIAG_4_DESC = "BATCH_CLAIMS_SUM_DIAG_4_DESC",
  BATCH_CLAIMS_SUM_DIAG_5_ASC = "BATCH_CLAIMS_SUM_DIAG_5_ASC",
  BATCH_CLAIMS_SUM_DIAG_5_DESC = "BATCH_CLAIMS_SUM_DIAG_5_DESC",
  BATCH_CLAIMS_SUM_DIAG_6_ASC = "BATCH_CLAIMS_SUM_DIAG_6_ASC",
  BATCH_CLAIMS_SUM_DIAG_6_DESC = "BATCH_CLAIMS_SUM_DIAG_6_DESC",
  BATCH_CLAIMS_SUM_DIAG_7_ASC = "BATCH_CLAIMS_SUM_DIAG_7_ASC",
  BATCH_CLAIMS_SUM_DIAG_7_DESC = "BATCH_CLAIMS_SUM_DIAG_7_DESC",
  BATCH_CLAIMS_SUM_DIAG_8_ASC = "BATCH_CLAIMS_SUM_DIAG_8_ASC",
  BATCH_CLAIMS_SUM_DIAG_8_DESC = "BATCH_CLAIMS_SUM_DIAG_8_DESC",
  BATCH_CLAIMS_SUM_DIAG_9_ASC = "BATCH_CLAIMS_SUM_DIAG_9_ASC",
  BATCH_CLAIMS_SUM_DIAG_9_DESC = "BATCH_CLAIMS_SUM_DIAG_9_DESC",
  BATCH_CLAIMS_SUM_DIAG_10_ASC = "BATCH_CLAIMS_SUM_DIAG_10_ASC",
  BATCH_CLAIMS_SUM_DIAG_10_DESC = "BATCH_CLAIMS_SUM_DIAG_10_DESC",
  BATCH_CLAIMS_SUM_DIAG_11_ASC = "BATCH_CLAIMS_SUM_DIAG_11_ASC",
  BATCH_CLAIMS_SUM_DIAG_11_DESC = "BATCH_CLAIMS_SUM_DIAG_11_DESC",
  BATCH_CLAIMS_SUM_DIAG_12_ASC = "BATCH_CLAIMS_SUM_DIAG_12_ASC",
  BATCH_CLAIMS_SUM_DIAG_12_DESC = "BATCH_CLAIMS_SUM_DIAG_12_DESC",
  BATCH_CLAIMS_SUM_DIAG_13_ASC = "BATCH_CLAIMS_SUM_DIAG_13_ASC",
  BATCH_CLAIMS_SUM_DIAG_13_DESC = "BATCH_CLAIMS_SUM_DIAG_13_DESC",
  BATCH_CLAIMS_SUM_DIAG_14_ASC = "BATCH_CLAIMS_SUM_DIAG_14_ASC",
  BATCH_CLAIMS_SUM_DIAG_14_DESC = "BATCH_CLAIMS_SUM_DIAG_14_DESC",
  BATCH_CLAIMS_SUM_DIAG_15_ASC = "BATCH_CLAIMS_SUM_DIAG_15_ASC",
  BATCH_CLAIMS_SUM_DIAG_15_DESC = "BATCH_CLAIMS_SUM_DIAG_15_DESC",
  BATCH_CLAIMS_SUM_DIAG_16_ASC = "BATCH_CLAIMS_SUM_DIAG_16_ASC",
  BATCH_CLAIMS_SUM_DIAG_16_DESC = "BATCH_CLAIMS_SUM_DIAG_16_DESC",
  BATCH_CLAIMS_SUM_DIAG_17_ASC = "BATCH_CLAIMS_SUM_DIAG_17_ASC",
  BATCH_CLAIMS_SUM_DIAG_17_DESC = "BATCH_CLAIMS_SUM_DIAG_17_DESC",
  BATCH_CLAIMS_SUM_DIAG_18_ASC = "BATCH_CLAIMS_SUM_DIAG_18_ASC",
  BATCH_CLAIMS_SUM_DIAG_18_DESC = "BATCH_CLAIMS_SUM_DIAG_18_DESC",
  BATCH_CLAIMS_SUM_DIAG_19_ASC = "BATCH_CLAIMS_SUM_DIAG_19_ASC",
  BATCH_CLAIMS_SUM_DIAG_19_DESC = "BATCH_CLAIMS_SUM_DIAG_19_DESC",
  BATCH_CLAIMS_SUM_DIAG_20_ASC = "BATCH_CLAIMS_SUM_DIAG_20_ASC",
  BATCH_CLAIMS_SUM_DIAG_20_DESC = "BATCH_CLAIMS_SUM_DIAG_20_DESC",
  BATCH_CLAIMS_SUM_DIAG_21_ASC = "BATCH_CLAIMS_SUM_DIAG_21_ASC",
  BATCH_CLAIMS_SUM_DIAG_21_DESC = "BATCH_CLAIMS_SUM_DIAG_21_DESC",
  BATCH_CLAIMS_SUM_DIAG_22_ASC = "BATCH_CLAIMS_SUM_DIAG_22_ASC",
  BATCH_CLAIMS_SUM_DIAG_22_DESC = "BATCH_CLAIMS_SUM_DIAG_22_DESC",
  BATCH_CLAIMS_SUM_DIAG_23_ASC = "BATCH_CLAIMS_SUM_DIAG_23_ASC",
  BATCH_CLAIMS_SUM_DIAG_23_DESC = "BATCH_CLAIMS_SUM_DIAG_23_DESC",
  BATCH_CLAIMS_SUM_DIAG_24_ASC = "BATCH_CLAIMS_SUM_DIAG_24_ASC",
  BATCH_CLAIMS_SUM_DIAG_24_DESC = "BATCH_CLAIMS_SUM_DIAG_24_DESC",
  BATCH_CLAIMS_SUM_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_SUM_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_SUM_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_SUM_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_SUM_DRG_CODE_ASC = "BATCH_CLAIMS_SUM_DRG_CODE_ASC",
  BATCH_CLAIMS_SUM_DRG_CODE_DESC = "BATCH_CLAIMS_SUM_DRG_CODE_DESC",
  BATCH_CLAIMS_SUM_ICN_ASC = "BATCH_CLAIMS_SUM_ICN_ASC",
  BATCH_CLAIMS_SUM_ICN_DESC = "BATCH_CLAIMS_SUM_ICN_DESC",
  BATCH_CLAIMS_SUM_ID_ASC = "BATCH_CLAIMS_SUM_ID_ASC",
  BATCH_CLAIMS_SUM_ID_DESC = "BATCH_CLAIMS_SUM_ID_DESC",
  BATCH_CLAIMS_SUM_INSURER_ID_ASC = "BATCH_CLAIMS_SUM_INSURER_ID_ASC",
  BATCH_CLAIMS_SUM_INSURER_ID_DESC = "BATCH_CLAIMS_SUM_INSURER_ID_DESC",
  BATCH_CLAIMS_SUM_OWNER_ID_ASC = "BATCH_CLAIMS_SUM_OWNER_ID_ASC",
  BATCH_CLAIMS_SUM_OWNER_ID_DESC = "BATCH_CLAIMS_SUM_OWNER_ID_DESC",
  BATCH_CLAIMS_SUM_PAID_DATE_ASC = "BATCH_CLAIMS_SUM_PAID_DATE_ASC",
  BATCH_CLAIMS_SUM_PAID_DATE_DESC = "BATCH_CLAIMS_SUM_PAID_DATE_DESC",
  BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_SUM_PATIENT_DOB_ASC = "BATCH_CLAIMS_SUM_PATIENT_DOB_ASC",
  BATCH_CLAIMS_SUM_PATIENT_DOB_DESC = "BATCH_CLAIMS_SUM_PATIENT_DOB_DESC",
  BATCH_CLAIMS_SUM_PATIENT_GENDER_ASC = "BATCH_CLAIMS_SUM_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_SUM_PATIENT_GENDER_DESC = "BATCH_CLAIMS_SUM_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_SUM_PATIENT_ID_ASC = "BATCH_CLAIMS_SUM_PATIENT_ID_ASC",
  BATCH_CLAIMS_SUM_PATIENT_ID_DESC = "BATCH_CLAIMS_SUM_PATIENT_ID_DESC",
  BATCH_CLAIMS_SUM_PAYMENT_RATE_ASC = "BATCH_CLAIMS_SUM_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_SUM_PAYMENT_RATE_DESC = "BATCH_CLAIMS_SUM_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_SUM_POA_1_ASC = "BATCH_CLAIMS_SUM_POA_1_ASC",
  BATCH_CLAIMS_SUM_POA_1_DESC = "BATCH_CLAIMS_SUM_POA_1_DESC",
  BATCH_CLAIMS_SUM_POA_2_ASC = "BATCH_CLAIMS_SUM_POA_2_ASC",
  BATCH_CLAIMS_SUM_POA_2_DESC = "BATCH_CLAIMS_SUM_POA_2_DESC",
  BATCH_CLAIMS_SUM_POA_3_ASC = "BATCH_CLAIMS_SUM_POA_3_ASC",
  BATCH_CLAIMS_SUM_POA_3_DESC = "BATCH_CLAIMS_SUM_POA_3_DESC",
  BATCH_CLAIMS_SUM_POA_4_ASC = "BATCH_CLAIMS_SUM_POA_4_ASC",
  BATCH_CLAIMS_SUM_POA_4_DESC = "BATCH_CLAIMS_SUM_POA_4_DESC",
  BATCH_CLAIMS_SUM_POA_5_ASC = "BATCH_CLAIMS_SUM_POA_5_ASC",
  BATCH_CLAIMS_SUM_POA_5_DESC = "BATCH_CLAIMS_SUM_POA_5_DESC",
  BATCH_CLAIMS_SUM_POA_6_ASC = "BATCH_CLAIMS_SUM_POA_6_ASC",
  BATCH_CLAIMS_SUM_POA_6_DESC = "BATCH_CLAIMS_SUM_POA_6_DESC",
  BATCH_CLAIMS_SUM_POA_7_ASC = "BATCH_CLAIMS_SUM_POA_7_ASC",
  BATCH_CLAIMS_SUM_POA_7_DESC = "BATCH_CLAIMS_SUM_POA_7_DESC",
  BATCH_CLAIMS_SUM_POA_8_ASC = "BATCH_CLAIMS_SUM_POA_8_ASC",
  BATCH_CLAIMS_SUM_POA_8_DESC = "BATCH_CLAIMS_SUM_POA_8_DESC",
  BATCH_CLAIMS_SUM_POA_9_ASC = "BATCH_CLAIMS_SUM_POA_9_ASC",
  BATCH_CLAIMS_SUM_POA_9_DESC = "BATCH_CLAIMS_SUM_POA_9_DESC",
  BATCH_CLAIMS_SUM_POA_10_ASC = "BATCH_CLAIMS_SUM_POA_10_ASC",
  BATCH_CLAIMS_SUM_POA_10_DESC = "BATCH_CLAIMS_SUM_POA_10_DESC",
  BATCH_CLAIMS_SUM_POA_11_ASC = "BATCH_CLAIMS_SUM_POA_11_ASC",
  BATCH_CLAIMS_SUM_POA_11_DESC = "BATCH_CLAIMS_SUM_POA_11_DESC",
  BATCH_CLAIMS_SUM_POA_12_ASC = "BATCH_CLAIMS_SUM_POA_12_ASC",
  BATCH_CLAIMS_SUM_POA_12_DESC = "BATCH_CLAIMS_SUM_POA_12_DESC",
  BATCH_CLAIMS_SUM_POA_13_ASC = "BATCH_CLAIMS_SUM_POA_13_ASC",
  BATCH_CLAIMS_SUM_POA_13_DESC = "BATCH_CLAIMS_SUM_POA_13_DESC",
  BATCH_CLAIMS_SUM_POA_14_ASC = "BATCH_CLAIMS_SUM_POA_14_ASC",
  BATCH_CLAIMS_SUM_POA_14_DESC = "BATCH_CLAIMS_SUM_POA_14_DESC",
  BATCH_CLAIMS_SUM_POA_15_ASC = "BATCH_CLAIMS_SUM_POA_15_ASC",
  BATCH_CLAIMS_SUM_POA_15_DESC = "BATCH_CLAIMS_SUM_POA_15_DESC",
  BATCH_CLAIMS_SUM_POA_16_ASC = "BATCH_CLAIMS_SUM_POA_16_ASC",
  BATCH_CLAIMS_SUM_POA_16_DESC = "BATCH_CLAIMS_SUM_POA_16_DESC",
  BATCH_CLAIMS_SUM_POA_17_ASC = "BATCH_CLAIMS_SUM_POA_17_ASC",
  BATCH_CLAIMS_SUM_POA_17_DESC = "BATCH_CLAIMS_SUM_POA_17_DESC",
  BATCH_CLAIMS_SUM_POA_18_ASC = "BATCH_CLAIMS_SUM_POA_18_ASC",
  BATCH_CLAIMS_SUM_POA_18_DESC = "BATCH_CLAIMS_SUM_POA_18_DESC",
  BATCH_CLAIMS_SUM_POA_19_ASC = "BATCH_CLAIMS_SUM_POA_19_ASC",
  BATCH_CLAIMS_SUM_POA_19_DESC = "BATCH_CLAIMS_SUM_POA_19_DESC",
  BATCH_CLAIMS_SUM_POA_20_ASC = "BATCH_CLAIMS_SUM_POA_20_ASC",
  BATCH_CLAIMS_SUM_POA_20_DESC = "BATCH_CLAIMS_SUM_POA_20_DESC",
  BATCH_CLAIMS_SUM_POA_21_ASC = "BATCH_CLAIMS_SUM_POA_21_ASC",
  BATCH_CLAIMS_SUM_POA_21_DESC = "BATCH_CLAIMS_SUM_POA_21_DESC",
  BATCH_CLAIMS_SUM_POA_22_ASC = "BATCH_CLAIMS_SUM_POA_22_ASC",
  BATCH_CLAIMS_SUM_POA_22_DESC = "BATCH_CLAIMS_SUM_POA_22_DESC",
  BATCH_CLAIMS_SUM_POA_23_ASC = "BATCH_CLAIMS_SUM_POA_23_ASC",
  BATCH_CLAIMS_SUM_POA_23_DESC = "BATCH_CLAIMS_SUM_POA_23_DESC",
  BATCH_CLAIMS_SUM_POA_24_ASC = "BATCH_CLAIMS_SUM_POA_24_ASC",
  BATCH_CLAIMS_SUM_POA_24_DESC = "BATCH_CLAIMS_SUM_POA_24_DESC",
  BATCH_CLAIMS_SUM_POA_25_ASC = "BATCH_CLAIMS_SUM_POA_25_ASC",
  BATCH_CLAIMS_SUM_POA_25_DESC = "BATCH_CLAIMS_SUM_POA_25_DESC",
  BATCH_CLAIMS_SUM_PREPAY_DENY_ASC = "BATCH_CLAIMS_SUM_PREPAY_DENY_ASC",
  BATCH_CLAIMS_SUM_PREPAY_DENY_DESC = "BATCH_CLAIMS_SUM_PREPAY_DENY_DESC",
  BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_SUM_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_SUM_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_SUM_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_SUM_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_SUM_PROVIDER_ID_ASC = "BATCH_CLAIMS_SUM_PROVIDER_ID_ASC",
  BATCH_CLAIMS_SUM_PROVIDER_ID_DESC = "BATCH_CLAIMS_SUM_PROVIDER_ID_DESC",
  BATCH_CLAIMS_SUM_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_SUM_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_SUM_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_SUM_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_SUM_UPDATED_AT_ASC = "BATCH_CLAIMS_SUM_UPDATED_AT_ASC",
  BATCH_CLAIMS_SUM_UPDATED_AT_DESC = "BATCH_CLAIMS_SUM_UPDATED_AT_DESC",
  BATCH_CLAIMS_SUM_VERSION_ASC = "BATCH_CLAIMS_SUM_VERSION_ASC",
  BATCH_CLAIMS_SUM_VERSION_DESC = "BATCH_CLAIMS_SUM_VERSION_DESC",
  BATCH_CLAIMS_SUM_VERSION_GROUP_ASC = "BATCH_CLAIMS_SUM_VERSION_GROUP_ASC",
  BATCH_CLAIMS_SUM_VERSION_GROUP_DESC = "BATCH_CLAIMS_SUM_VERSION_GROUP_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ICN_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ICN_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_AVERAGE_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_COUNT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_COUNT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_COUNT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_COUNT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_DISTINCT_COUNT_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MAX_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_MIN_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_POPULATION_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_STDDEV_SAMPLE_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_SUM_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_POPULATION_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_LAST_APPLIED_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_LAST_APPLIED_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_LAST_APPLIED_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_LAST_APPLIED_VERSION_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_VERSION_ASC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_VERSION_ASC",
  BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_VERSION_DESC = "BATCH_CLAIM_CURRENT_STAGE_STATES_VARIANCE_SAMPLE_VERSION_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_COUNT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_COUNT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_COUNT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_COUNT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_ROLE_ASSIGNMENT_STATES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_FILES_AVERAGE_AUTHOR_ID_ASC = "BATCH_FILES_AVERAGE_AUTHOR_ID_ASC",
  BATCH_FILES_AVERAGE_AUTHOR_ID_DESC = "BATCH_FILES_AVERAGE_AUTHOR_ID_DESC",
  BATCH_FILES_AVERAGE_BATCH_FILE_NAME_ASC = "BATCH_FILES_AVERAGE_BATCH_FILE_NAME_ASC",
  BATCH_FILES_AVERAGE_BATCH_FILE_NAME_DESC = "BATCH_FILES_AVERAGE_BATCH_FILE_NAME_DESC",
  BATCH_FILES_AVERAGE_BATCH_FILE_URL_ASC = "BATCH_FILES_AVERAGE_BATCH_FILE_URL_ASC",
  BATCH_FILES_AVERAGE_BATCH_FILE_URL_DESC = "BATCH_FILES_AVERAGE_BATCH_FILE_URL_DESC",
  BATCH_FILES_AVERAGE_BATCH_NAME_ASC = "BATCH_FILES_AVERAGE_BATCH_NAME_ASC",
  BATCH_FILES_AVERAGE_BATCH_NAME_DESC = "BATCH_FILES_AVERAGE_BATCH_NAME_DESC",
  BATCH_FILES_AVERAGE_CREATED_AT_ASC = "BATCH_FILES_AVERAGE_CREATED_AT_ASC",
  BATCH_FILES_AVERAGE_CREATED_AT_DESC = "BATCH_FILES_AVERAGE_CREATED_AT_DESC",
  BATCH_FILES_AVERAGE_ID_ASC = "BATCH_FILES_AVERAGE_ID_ASC",
  BATCH_FILES_AVERAGE_ID_DESC = "BATCH_FILES_AVERAGE_ID_DESC",
  BATCH_FILES_AVERAGE_INSURER_ID_ASC = "BATCH_FILES_AVERAGE_INSURER_ID_ASC",
  BATCH_FILES_AVERAGE_INSURER_ID_DESC = "BATCH_FILES_AVERAGE_INSURER_ID_DESC",
  BATCH_FILES_AVERAGE_OWNER_ID_ASC = "BATCH_FILES_AVERAGE_OWNER_ID_ASC",
  BATCH_FILES_AVERAGE_OWNER_ID_DESC = "BATCH_FILES_AVERAGE_OWNER_ID_DESC",
  BATCH_FILES_AVERAGE_UPDATED_AT_ASC = "BATCH_FILES_AVERAGE_UPDATED_AT_ASC",
  BATCH_FILES_AVERAGE_UPDATED_AT_DESC = "BATCH_FILES_AVERAGE_UPDATED_AT_DESC",
  BATCH_FILES_BY_INSURER_ID__COUNT_ASC = "BATCH_FILES_BY_INSURER_ID__COUNT_ASC",
  BATCH_FILES_BY_INSURER_ID__COUNT_DESC = "BATCH_FILES_BY_INSURER_ID__COUNT_DESC",
  BATCH_FILES_COUNT_ASC = "BATCH_FILES_COUNT_ASC",
  BATCH_FILES_COUNT_DESC = "BATCH_FILES_COUNT_DESC",
  BATCH_FILES_DISTINCT_COUNT_AUTHOR_ID_ASC = "BATCH_FILES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  BATCH_FILES_DISTINCT_COUNT_AUTHOR_ID_DESC = "BATCH_FILES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_NAME_ASC = "BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_NAME_ASC",
  BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_NAME_DESC = "BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_NAME_DESC",
  BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_URL_ASC = "BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_URL_ASC",
  BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_URL_DESC = "BATCH_FILES_DISTINCT_COUNT_BATCH_FILE_URL_DESC",
  BATCH_FILES_DISTINCT_COUNT_BATCH_NAME_ASC = "BATCH_FILES_DISTINCT_COUNT_BATCH_NAME_ASC",
  BATCH_FILES_DISTINCT_COUNT_BATCH_NAME_DESC = "BATCH_FILES_DISTINCT_COUNT_BATCH_NAME_DESC",
  BATCH_FILES_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_FILES_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_FILES_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_FILES_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_FILES_DISTINCT_COUNT_ID_ASC = "BATCH_FILES_DISTINCT_COUNT_ID_ASC",
  BATCH_FILES_DISTINCT_COUNT_ID_DESC = "BATCH_FILES_DISTINCT_COUNT_ID_DESC",
  BATCH_FILES_DISTINCT_COUNT_INSURER_ID_ASC = "BATCH_FILES_DISTINCT_COUNT_INSURER_ID_ASC",
  BATCH_FILES_DISTINCT_COUNT_INSURER_ID_DESC = "BATCH_FILES_DISTINCT_COUNT_INSURER_ID_DESC",
  BATCH_FILES_DISTINCT_COUNT_OWNER_ID_ASC = "BATCH_FILES_DISTINCT_COUNT_OWNER_ID_ASC",
  BATCH_FILES_DISTINCT_COUNT_OWNER_ID_DESC = "BATCH_FILES_DISTINCT_COUNT_OWNER_ID_DESC",
  BATCH_FILES_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_FILES_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_FILES_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_FILES_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_FILES_MAX_AUTHOR_ID_ASC = "BATCH_FILES_MAX_AUTHOR_ID_ASC",
  BATCH_FILES_MAX_AUTHOR_ID_DESC = "BATCH_FILES_MAX_AUTHOR_ID_DESC",
  BATCH_FILES_MAX_BATCH_FILE_NAME_ASC = "BATCH_FILES_MAX_BATCH_FILE_NAME_ASC",
  BATCH_FILES_MAX_BATCH_FILE_NAME_DESC = "BATCH_FILES_MAX_BATCH_FILE_NAME_DESC",
  BATCH_FILES_MAX_BATCH_FILE_URL_ASC = "BATCH_FILES_MAX_BATCH_FILE_URL_ASC",
  BATCH_FILES_MAX_BATCH_FILE_URL_DESC = "BATCH_FILES_MAX_BATCH_FILE_URL_DESC",
  BATCH_FILES_MAX_BATCH_NAME_ASC = "BATCH_FILES_MAX_BATCH_NAME_ASC",
  BATCH_FILES_MAX_BATCH_NAME_DESC = "BATCH_FILES_MAX_BATCH_NAME_DESC",
  BATCH_FILES_MAX_CREATED_AT_ASC = "BATCH_FILES_MAX_CREATED_AT_ASC",
  BATCH_FILES_MAX_CREATED_AT_DESC = "BATCH_FILES_MAX_CREATED_AT_DESC",
  BATCH_FILES_MAX_ID_ASC = "BATCH_FILES_MAX_ID_ASC",
  BATCH_FILES_MAX_ID_DESC = "BATCH_FILES_MAX_ID_DESC",
  BATCH_FILES_MAX_INSURER_ID_ASC = "BATCH_FILES_MAX_INSURER_ID_ASC",
  BATCH_FILES_MAX_INSURER_ID_DESC = "BATCH_FILES_MAX_INSURER_ID_DESC",
  BATCH_FILES_MAX_OWNER_ID_ASC = "BATCH_FILES_MAX_OWNER_ID_ASC",
  BATCH_FILES_MAX_OWNER_ID_DESC = "BATCH_FILES_MAX_OWNER_ID_DESC",
  BATCH_FILES_MAX_UPDATED_AT_ASC = "BATCH_FILES_MAX_UPDATED_AT_ASC",
  BATCH_FILES_MAX_UPDATED_AT_DESC = "BATCH_FILES_MAX_UPDATED_AT_DESC",
  BATCH_FILES_MIN_AUTHOR_ID_ASC = "BATCH_FILES_MIN_AUTHOR_ID_ASC",
  BATCH_FILES_MIN_AUTHOR_ID_DESC = "BATCH_FILES_MIN_AUTHOR_ID_DESC",
  BATCH_FILES_MIN_BATCH_FILE_NAME_ASC = "BATCH_FILES_MIN_BATCH_FILE_NAME_ASC",
  BATCH_FILES_MIN_BATCH_FILE_NAME_DESC = "BATCH_FILES_MIN_BATCH_FILE_NAME_DESC",
  BATCH_FILES_MIN_BATCH_FILE_URL_ASC = "BATCH_FILES_MIN_BATCH_FILE_URL_ASC",
  BATCH_FILES_MIN_BATCH_FILE_URL_DESC = "BATCH_FILES_MIN_BATCH_FILE_URL_DESC",
  BATCH_FILES_MIN_BATCH_NAME_ASC = "BATCH_FILES_MIN_BATCH_NAME_ASC",
  BATCH_FILES_MIN_BATCH_NAME_DESC = "BATCH_FILES_MIN_BATCH_NAME_DESC",
  BATCH_FILES_MIN_CREATED_AT_ASC = "BATCH_FILES_MIN_CREATED_AT_ASC",
  BATCH_FILES_MIN_CREATED_AT_DESC = "BATCH_FILES_MIN_CREATED_AT_DESC",
  BATCH_FILES_MIN_ID_ASC = "BATCH_FILES_MIN_ID_ASC",
  BATCH_FILES_MIN_ID_DESC = "BATCH_FILES_MIN_ID_DESC",
  BATCH_FILES_MIN_INSURER_ID_ASC = "BATCH_FILES_MIN_INSURER_ID_ASC",
  BATCH_FILES_MIN_INSURER_ID_DESC = "BATCH_FILES_MIN_INSURER_ID_DESC",
  BATCH_FILES_MIN_OWNER_ID_ASC = "BATCH_FILES_MIN_OWNER_ID_ASC",
  BATCH_FILES_MIN_OWNER_ID_DESC = "BATCH_FILES_MIN_OWNER_ID_DESC",
  BATCH_FILES_MIN_UPDATED_AT_ASC = "BATCH_FILES_MIN_UPDATED_AT_ASC",
  BATCH_FILES_MIN_UPDATED_AT_DESC = "BATCH_FILES_MIN_UPDATED_AT_DESC",
  BATCH_FILES_STDDEV_POPULATION_AUTHOR_ID_ASC = "BATCH_FILES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  BATCH_FILES_STDDEV_POPULATION_AUTHOR_ID_DESC = "BATCH_FILES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_NAME_ASC = "BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_NAME_ASC",
  BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_NAME_DESC = "BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_NAME_DESC",
  BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_URL_ASC = "BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_URL_ASC",
  BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_URL_DESC = "BATCH_FILES_STDDEV_POPULATION_BATCH_FILE_URL_DESC",
  BATCH_FILES_STDDEV_POPULATION_BATCH_NAME_ASC = "BATCH_FILES_STDDEV_POPULATION_BATCH_NAME_ASC",
  BATCH_FILES_STDDEV_POPULATION_BATCH_NAME_DESC = "BATCH_FILES_STDDEV_POPULATION_BATCH_NAME_DESC",
  BATCH_FILES_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_FILES_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_FILES_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_FILES_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_FILES_STDDEV_POPULATION_ID_ASC = "BATCH_FILES_STDDEV_POPULATION_ID_ASC",
  BATCH_FILES_STDDEV_POPULATION_ID_DESC = "BATCH_FILES_STDDEV_POPULATION_ID_DESC",
  BATCH_FILES_STDDEV_POPULATION_INSURER_ID_ASC = "BATCH_FILES_STDDEV_POPULATION_INSURER_ID_ASC",
  BATCH_FILES_STDDEV_POPULATION_INSURER_ID_DESC = "BATCH_FILES_STDDEV_POPULATION_INSURER_ID_DESC",
  BATCH_FILES_STDDEV_POPULATION_OWNER_ID_ASC = "BATCH_FILES_STDDEV_POPULATION_OWNER_ID_ASC",
  BATCH_FILES_STDDEV_POPULATION_OWNER_ID_DESC = "BATCH_FILES_STDDEV_POPULATION_OWNER_ID_DESC",
  BATCH_FILES_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_FILES_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_FILES_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_FILES_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_FILES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "BATCH_FILES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  BATCH_FILES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "BATCH_FILES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_NAME_ASC = "BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_NAME_ASC",
  BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_NAME_DESC = "BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_NAME_DESC",
  BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_URL_ASC = "BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_URL_ASC",
  BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_URL_DESC = "BATCH_FILES_STDDEV_SAMPLE_BATCH_FILE_URL_DESC",
  BATCH_FILES_STDDEV_SAMPLE_BATCH_NAME_ASC = "BATCH_FILES_STDDEV_SAMPLE_BATCH_NAME_ASC",
  BATCH_FILES_STDDEV_SAMPLE_BATCH_NAME_DESC = "BATCH_FILES_STDDEV_SAMPLE_BATCH_NAME_DESC",
  BATCH_FILES_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_FILES_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_FILES_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_FILES_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_FILES_STDDEV_SAMPLE_ID_ASC = "BATCH_FILES_STDDEV_SAMPLE_ID_ASC",
  BATCH_FILES_STDDEV_SAMPLE_ID_DESC = "BATCH_FILES_STDDEV_SAMPLE_ID_DESC",
  BATCH_FILES_STDDEV_SAMPLE_INSURER_ID_ASC = "BATCH_FILES_STDDEV_SAMPLE_INSURER_ID_ASC",
  BATCH_FILES_STDDEV_SAMPLE_INSURER_ID_DESC = "BATCH_FILES_STDDEV_SAMPLE_INSURER_ID_DESC",
  BATCH_FILES_STDDEV_SAMPLE_OWNER_ID_ASC = "BATCH_FILES_STDDEV_SAMPLE_OWNER_ID_ASC",
  BATCH_FILES_STDDEV_SAMPLE_OWNER_ID_DESC = "BATCH_FILES_STDDEV_SAMPLE_OWNER_ID_DESC",
  BATCH_FILES_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_FILES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_FILES_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_FILES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_FILES_SUM_AUTHOR_ID_ASC = "BATCH_FILES_SUM_AUTHOR_ID_ASC",
  BATCH_FILES_SUM_AUTHOR_ID_DESC = "BATCH_FILES_SUM_AUTHOR_ID_DESC",
  BATCH_FILES_SUM_BATCH_FILE_NAME_ASC = "BATCH_FILES_SUM_BATCH_FILE_NAME_ASC",
  BATCH_FILES_SUM_BATCH_FILE_NAME_DESC = "BATCH_FILES_SUM_BATCH_FILE_NAME_DESC",
  BATCH_FILES_SUM_BATCH_FILE_URL_ASC = "BATCH_FILES_SUM_BATCH_FILE_URL_ASC",
  BATCH_FILES_SUM_BATCH_FILE_URL_DESC = "BATCH_FILES_SUM_BATCH_FILE_URL_DESC",
  BATCH_FILES_SUM_BATCH_NAME_ASC = "BATCH_FILES_SUM_BATCH_NAME_ASC",
  BATCH_FILES_SUM_BATCH_NAME_DESC = "BATCH_FILES_SUM_BATCH_NAME_DESC",
  BATCH_FILES_SUM_CREATED_AT_ASC = "BATCH_FILES_SUM_CREATED_AT_ASC",
  BATCH_FILES_SUM_CREATED_AT_DESC = "BATCH_FILES_SUM_CREATED_AT_DESC",
  BATCH_FILES_SUM_ID_ASC = "BATCH_FILES_SUM_ID_ASC",
  BATCH_FILES_SUM_ID_DESC = "BATCH_FILES_SUM_ID_DESC",
  BATCH_FILES_SUM_INSURER_ID_ASC = "BATCH_FILES_SUM_INSURER_ID_ASC",
  BATCH_FILES_SUM_INSURER_ID_DESC = "BATCH_FILES_SUM_INSURER_ID_DESC",
  BATCH_FILES_SUM_OWNER_ID_ASC = "BATCH_FILES_SUM_OWNER_ID_ASC",
  BATCH_FILES_SUM_OWNER_ID_DESC = "BATCH_FILES_SUM_OWNER_ID_DESC",
  BATCH_FILES_SUM_UPDATED_AT_ASC = "BATCH_FILES_SUM_UPDATED_AT_ASC",
  BATCH_FILES_SUM_UPDATED_AT_DESC = "BATCH_FILES_SUM_UPDATED_AT_DESC",
  BATCH_FILES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "BATCH_FILES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  BATCH_FILES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "BATCH_FILES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_NAME_ASC = "BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_NAME_ASC",
  BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_NAME_DESC = "BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_NAME_DESC",
  BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_URL_ASC = "BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_URL_ASC",
  BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_URL_DESC = "BATCH_FILES_VARIANCE_POPULATION_BATCH_FILE_URL_DESC",
  BATCH_FILES_VARIANCE_POPULATION_BATCH_NAME_ASC = "BATCH_FILES_VARIANCE_POPULATION_BATCH_NAME_ASC",
  BATCH_FILES_VARIANCE_POPULATION_BATCH_NAME_DESC = "BATCH_FILES_VARIANCE_POPULATION_BATCH_NAME_DESC",
  BATCH_FILES_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_FILES_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_FILES_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_FILES_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_FILES_VARIANCE_POPULATION_ID_ASC = "BATCH_FILES_VARIANCE_POPULATION_ID_ASC",
  BATCH_FILES_VARIANCE_POPULATION_ID_DESC = "BATCH_FILES_VARIANCE_POPULATION_ID_DESC",
  BATCH_FILES_VARIANCE_POPULATION_INSURER_ID_ASC = "BATCH_FILES_VARIANCE_POPULATION_INSURER_ID_ASC",
  BATCH_FILES_VARIANCE_POPULATION_INSURER_ID_DESC = "BATCH_FILES_VARIANCE_POPULATION_INSURER_ID_DESC",
  BATCH_FILES_VARIANCE_POPULATION_OWNER_ID_ASC = "BATCH_FILES_VARIANCE_POPULATION_OWNER_ID_ASC",
  BATCH_FILES_VARIANCE_POPULATION_OWNER_ID_DESC = "BATCH_FILES_VARIANCE_POPULATION_OWNER_ID_DESC",
  BATCH_FILES_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_FILES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_FILES_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_FILES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_FILES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "BATCH_FILES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  BATCH_FILES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "BATCH_FILES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_NAME_ASC = "BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_NAME_ASC",
  BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_NAME_DESC = "BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_NAME_DESC",
  BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_URL_ASC = "BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_URL_ASC",
  BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_URL_DESC = "BATCH_FILES_VARIANCE_SAMPLE_BATCH_FILE_URL_DESC",
  BATCH_FILES_VARIANCE_SAMPLE_BATCH_NAME_ASC = "BATCH_FILES_VARIANCE_SAMPLE_BATCH_NAME_ASC",
  BATCH_FILES_VARIANCE_SAMPLE_BATCH_NAME_DESC = "BATCH_FILES_VARIANCE_SAMPLE_BATCH_NAME_DESC",
  BATCH_FILES_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_FILES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_FILES_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_FILES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_FILES_VARIANCE_SAMPLE_ID_ASC = "BATCH_FILES_VARIANCE_SAMPLE_ID_ASC",
  BATCH_FILES_VARIANCE_SAMPLE_ID_DESC = "BATCH_FILES_VARIANCE_SAMPLE_ID_DESC",
  BATCH_FILES_VARIANCE_SAMPLE_INSURER_ID_ASC = "BATCH_FILES_VARIANCE_SAMPLE_INSURER_ID_ASC",
  BATCH_FILES_VARIANCE_SAMPLE_INSURER_ID_DESC = "BATCH_FILES_VARIANCE_SAMPLE_INSURER_ID_DESC",
  BATCH_FILES_VARIANCE_SAMPLE_OWNER_ID_ASC = "BATCH_FILES_VARIANCE_SAMPLE_OWNER_ID_ASC",
  BATCH_FILES_VARIANCE_SAMPLE_OWNER_ID_DESC = "BATCH_FILES_VARIANCE_SAMPLE_OWNER_ID_DESC",
  BATCH_FILES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_FILES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_FILES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_FILES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_ID_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_ID_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_ID_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_ID_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_NAME_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_NAME_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_NAME_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_NAME_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_AVERAGE_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_AVERAGE_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_AVERAGE_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_AVERAGE_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_BY_INSURER_ID__COUNT_ASC = "CLAIM_AUDIT_GROUPS_BY_INSURER_ID__COUNT_ASC",
  CLAIM_AUDIT_GROUPS_BY_INSURER_ID__COUNT_DESC = "CLAIM_AUDIT_GROUPS_BY_INSURER_ID__COUNT_DESC",
  CLAIM_AUDIT_GROUPS_COUNT_ASC = "CLAIM_AUDIT_GROUPS_COUNT_ASC",
  CLAIM_AUDIT_GROUPS_COUNT_DESC = "CLAIM_AUDIT_GROUPS_COUNT_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_ID_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_ID_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_ID_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_ID_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_NAME_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_NAME_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_NAME_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_NAME_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_DISTINCT_COUNT_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_MAX_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_MAX_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_MAX_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_MAX_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_MAX_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_MAX_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_MAX_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_MAX_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_MAX_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_MAX_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_ID_ASC = "CLAIM_AUDIT_GROUPS_MAX_ID_ASC",
  CLAIM_AUDIT_GROUPS_MAX_ID_DESC = "CLAIM_AUDIT_GROUPS_MAX_ID_DESC",
  CLAIM_AUDIT_GROUPS_MAX_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_MAX_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_MAX_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_MAX_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_MAX_NAME_ASC = "CLAIM_AUDIT_GROUPS_MAX_NAME_ASC",
  CLAIM_AUDIT_GROUPS_MAX_NAME_DESC = "CLAIM_AUDIT_GROUPS_MAX_NAME_DESC",
  CLAIM_AUDIT_GROUPS_MAX_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MAX_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_MAX_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MAX_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_MAX_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_MIN_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_MIN_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_MIN_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_MIN_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_MIN_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_MIN_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_MIN_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_MIN_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_MIN_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_MIN_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_ID_ASC = "CLAIM_AUDIT_GROUPS_MIN_ID_ASC",
  CLAIM_AUDIT_GROUPS_MIN_ID_DESC = "CLAIM_AUDIT_GROUPS_MIN_ID_DESC",
  CLAIM_AUDIT_GROUPS_MIN_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_MIN_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_MIN_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_MIN_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_MIN_NAME_ASC = "CLAIM_AUDIT_GROUPS_MIN_NAME_ASC",
  CLAIM_AUDIT_GROUPS_MIN_NAME_DESC = "CLAIM_AUDIT_GROUPS_MIN_NAME_DESC",
  CLAIM_AUDIT_GROUPS_MIN_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_MIN_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_MIN_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_MIN_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_MIN_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_ID_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_ID_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_ID_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_ID_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_NAME_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_NAME_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_NAME_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_NAME_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_POPULATION_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_ID_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_ID_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_ID_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_ID_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_NAME_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_NAME_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_NAME_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_NAME_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_STDDEV_SAMPLE_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_SUM_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_SUM_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_SUM_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_SUM_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_SUM_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_SUM_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_SUM_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_SUM_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_SUM_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_SUM_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_ID_ASC = "CLAIM_AUDIT_GROUPS_SUM_ID_ASC",
  CLAIM_AUDIT_GROUPS_SUM_ID_DESC = "CLAIM_AUDIT_GROUPS_SUM_ID_DESC",
  CLAIM_AUDIT_GROUPS_SUM_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_SUM_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_SUM_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_SUM_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_SUM_NAME_ASC = "CLAIM_AUDIT_GROUPS_SUM_NAME_ASC",
  CLAIM_AUDIT_GROUPS_SUM_NAME_DESC = "CLAIM_AUDIT_GROUPS_SUM_NAME_DESC",
  CLAIM_AUDIT_GROUPS_SUM_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_SUM_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_SUM_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_SUM_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_SUM_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_ID_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_ID_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_ID_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_ID_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_NAME_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_NAME_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_NAME_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_NAME_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_POPULATION_TAT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_APPEAL_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_APPEAL_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_APPEAL_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_APPEAL_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_START_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_TYPE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_TYPE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_TYPE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_AUDIT_TYPE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CLIENT_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CLIENT_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CLIENT_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CLIENT_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_BY_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_BY_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_BY_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_CREATED_BY_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DISPUTE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DISPUTE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DISPUTE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DISPUTE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DISPUTE_RECEIVED_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DISPUTE_RECEIVED_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DISPUTE_RECEIVED_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DISPUTE_RECEIVED_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DOC_REQ_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DOC_REQ_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DOC_REQ_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DOC_REQ_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_FINAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_ID_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_ID_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_INITIAL_PROVIDER_REPORT_SENT_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_INSURER_ID_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_INSURER_ID_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_NAME_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_NAME_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_NAME_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_NAME_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_QA_DUE_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_QA_DUE_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_QA_DUE_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_QA_DUE_DATE_DESC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_TAT_START_DATE_ASC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_TAT_START_DATE_ASC",
  CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_TAT_START_DATE_DESC = "CLAIM_AUDIT_GROUPS_VARIANCE_SAMPLE_TAT_START_DATE_DESC",
  CLIENT_ABBREVIATION_ASC = "CLIENT_ABBREVIATION_ASC",
  CLIENT_ABBREVIATION_DESC = "CLIENT_ABBREVIATION_DESC",
  CLIENT_ID_ASC = "CLIENT_ID_ASC",
  CLIENT_ID_DESC = "CLIENT_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__ID_ASC = "DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__ID_ASC",
  DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__ID_DESC = "DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__ID_DESC",
  DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__INSURER_ID_ASC = "DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__INSURER_ID_ASC",
  DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__INSURER_ID_DESC = "DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__INSURER_ID_DESC",
  DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__STRATEGY_ASC = "DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__STRATEGY_ASC",
  DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__STRATEGY_DESC = "DEFAULT_STRATEGY_BY_INSURER_BY_INSURER_ID__STRATEGY_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INSURER_CLAIM_INTAKE_DROPBOX_PERMITTED_BY_INSURER_ID__ID_ASC = "INSURER_CLAIM_INTAKE_DROPBOX_PERMITTED_BY_INSURER_ID__ID_ASC",
  INSURER_CLAIM_INTAKE_DROPBOX_PERMITTED_BY_INSURER_ID__ID_DESC = "INSURER_CLAIM_INTAKE_DROPBOX_PERMITTED_BY_INSURER_ID__ID_DESC",
  INSURER_CLAIM_INTAKE_DROPBOX_PERMITTED_BY_INSURER_ID__INSURER_ID_ASC = "INSURER_CLAIM_INTAKE_DROPBOX_PERMITTED_BY_INSURER_ID__INSURER_ID_ASC",
  INSURER_CLAIM_INTAKE_DROPBOX_PERMITTED_BY_INSURER_ID__INSURER_ID_DESC = "INSURER_CLAIM_INTAKE_DROPBOX_PERMITTED_BY_INSURER_ID__INSURER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_AVERAGE_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_COUNT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_COUNT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_COUNT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_COUNT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MAX_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_MIN_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_SUM_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID__COUNT_ASC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID__COUNT_ASC",
  INSURER_ORGANIZATIONS_BY_MEMBER_ID__COUNT_DESC = "INSURER_ORGANIZATIONS_BY_MEMBER_ID__COUNT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_AVERAGE_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_COUNT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_COUNT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_COUNT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_COUNT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MAX_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_MIN_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_SUM_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_MEMBER_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_MEMBER_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_MEMBER_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_MEMBER_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_ORGANIZATION_ID_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_ORGANIZATION_ID_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_ORGANIZATION_ID_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_ORGANIZATION_ID_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID__COUNT_ASC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID__COUNT_ASC",
  INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID__COUNT_DESC = "INSURER_ORGANIZATIONS_BY_ORGANIZATION_ID__COUNT_DESC",
  INSURER_USERS_AVERAGE_AUDITOR_USER_ID_ASC = "INSURER_USERS_AVERAGE_AUDITOR_USER_ID_ASC",
  INSURER_USERS_AVERAGE_AUDITOR_USER_ID_DESC = "INSURER_USERS_AVERAGE_AUDITOR_USER_ID_DESC",
  INSURER_USERS_AVERAGE_CREATED_AT_ASC = "INSURER_USERS_AVERAGE_CREATED_AT_ASC",
  INSURER_USERS_AVERAGE_CREATED_AT_DESC = "INSURER_USERS_AVERAGE_CREATED_AT_DESC",
  INSURER_USERS_AVERAGE_ID_ASC = "INSURER_USERS_AVERAGE_ID_ASC",
  INSURER_USERS_AVERAGE_ID_DESC = "INSURER_USERS_AVERAGE_ID_DESC",
  INSURER_USERS_AVERAGE_INSURER_ID_ASC = "INSURER_USERS_AVERAGE_INSURER_ID_ASC",
  INSURER_USERS_AVERAGE_INSURER_ID_DESC = "INSURER_USERS_AVERAGE_INSURER_ID_DESC",
  INSURER_USERS_AVERAGE_UPDATED_AT_ASC = "INSURER_USERS_AVERAGE_UPDATED_AT_ASC",
  INSURER_USERS_AVERAGE_UPDATED_AT_DESC = "INSURER_USERS_AVERAGE_UPDATED_AT_DESC",
  INSURER_USERS_BY_INSURER_ID__COUNT_ASC = "INSURER_USERS_BY_INSURER_ID__COUNT_ASC",
  INSURER_USERS_BY_INSURER_ID__COUNT_DESC = "INSURER_USERS_BY_INSURER_ID__COUNT_DESC",
  INSURER_USERS_COUNT_ASC = "INSURER_USERS_COUNT_ASC",
  INSURER_USERS_COUNT_DESC = "INSURER_USERS_COUNT_DESC",
  INSURER_USERS_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "INSURER_USERS_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  INSURER_USERS_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "INSURER_USERS_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  INSURER_USERS_DISTINCT_COUNT_CREATED_AT_ASC = "INSURER_USERS_DISTINCT_COUNT_CREATED_AT_ASC",
  INSURER_USERS_DISTINCT_COUNT_CREATED_AT_DESC = "INSURER_USERS_DISTINCT_COUNT_CREATED_AT_DESC",
  INSURER_USERS_DISTINCT_COUNT_ID_ASC = "INSURER_USERS_DISTINCT_COUNT_ID_ASC",
  INSURER_USERS_DISTINCT_COUNT_ID_DESC = "INSURER_USERS_DISTINCT_COUNT_ID_DESC",
  INSURER_USERS_DISTINCT_COUNT_INSURER_ID_ASC = "INSURER_USERS_DISTINCT_COUNT_INSURER_ID_ASC",
  INSURER_USERS_DISTINCT_COUNT_INSURER_ID_DESC = "INSURER_USERS_DISTINCT_COUNT_INSURER_ID_DESC",
  INSURER_USERS_DISTINCT_COUNT_UPDATED_AT_ASC = "INSURER_USERS_DISTINCT_COUNT_UPDATED_AT_ASC",
  INSURER_USERS_DISTINCT_COUNT_UPDATED_AT_DESC = "INSURER_USERS_DISTINCT_COUNT_UPDATED_AT_DESC",
  INSURER_USERS_MAX_AUDITOR_USER_ID_ASC = "INSURER_USERS_MAX_AUDITOR_USER_ID_ASC",
  INSURER_USERS_MAX_AUDITOR_USER_ID_DESC = "INSURER_USERS_MAX_AUDITOR_USER_ID_DESC",
  INSURER_USERS_MAX_CREATED_AT_ASC = "INSURER_USERS_MAX_CREATED_AT_ASC",
  INSURER_USERS_MAX_CREATED_AT_DESC = "INSURER_USERS_MAX_CREATED_AT_DESC",
  INSURER_USERS_MAX_ID_ASC = "INSURER_USERS_MAX_ID_ASC",
  INSURER_USERS_MAX_ID_DESC = "INSURER_USERS_MAX_ID_DESC",
  INSURER_USERS_MAX_INSURER_ID_ASC = "INSURER_USERS_MAX_INSURER_ID_ASC",
  INSURER_USERS_MAX_INSURER_ID_DESC = "INSURER_USERS_MAX_INSURER_ID_DESC",
  INSURER_USERS_MAX_UPDATED_AT_ASC = "INSURER_USERS_MAX_UPDATED_AT_ASC",
  INSURER_USERS_MAX_UPDATED_AT_DESC = "INSURER_USERS_MAX_UPDATED_AT_DESC",
  INSURER_USERS_MIN_AUDITOR_USER_ID_ASC = "INSURER_USERS_MIN_AUDITOR_USER_ID_ASC",
  INSURER_USERS_MIN_AUDITOR_USER_ID_DESC = "INSURER_USERS_MIN_AUDITOR_USER_ID_DESC",
  INSURER_USERS_MIN_CREATED_AT_ASC = "INSURER_USERS_MIN_CREATED_AT_ASC",
  INSURER_USERS_MIN_CREATED_AT_DESC = "INSURER_USERS_MIN_CREATED_AT_DESC",
  INSURER_USERS_MIN_ID_ASC = "INSURER_USERS_MIN_ID_ASC",
  INSURER_USERS_MIN_ID_DESC = "INSURER_USERS_MIN_ID_DESC",
  INSURER_USERS_MIN_INSURER_ID_ASC = "INSURER_USERS_MIN_INSURER_ID_ASC",
  INSURER_USERS_MIN_INSURER_ID_DESC = "INSURER_USERS_MIN_INSURER_ID_DESC",
  INSURER_USERS_MIN_UPDATED_AT_ASC = "INSURER_USERS_MIN_UPDATED_AT_ASC",
  INSURER_USERS_MIN_UPDATED_AT_DESC = "INSURER_USERS_MIN_UPDATED_AT_DESC",
  INSURER_USERS_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "INSURER_USERS_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  INSURER_USERS_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "INSURER_USERS_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  INSURER_USERS_STDDEV_POPULATION_CREATED_AT_ASC = "INSURER_USERS_STDDEV_POPULATION_CREATED_AT_ASC",
  INSURER_USERS_STDDEV_POPULATION_CREATED_AT_DESC = "INSURER_USERS_STDDEV_POPULATION_CREATED_AT_DESC",
  INSURER_USERS_STDDEV_POPULATION_ID_ASC = "INSURER_USERS_STDDEV_POPULATION_ID_ASC",
  INSURER_USERS_STDDEV_POPULATION_ID_DESC = "INSURER_USERS_STDDEV_POPULATION_ID_DESC",
  INSURER_USERS_STDDEV_POPULATION_INSURER_ID_ASC = "INSURER_USERS_STDDEV_POPULATION_INSURER_ID_ASC",
  INSURER_USERS_STDDEV_POPULATION_INSURER_ID_DESC = "INSURER_USERS_STDDEV_POPULATION_INSURER_ID_DESC",
  INSURER_USERS_STDDEV_POPULATION_UPDATED_AT_ASC = "INSURER_USERS_STDDEV_POPULATION_UPDATED_AT_ASC",
  INSURER_USERS_STDDEV_POPULATION_UPDATED_AT_DESC = "INSURER_USERS_STDDEV_POPULATION_UPDATED_AT_DESC",
  INSURER_USERS_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "INSURER_USERS_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  INSURER_USERS_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "INSURER_USERS_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  INSURER_USERS_STDDEV_SAMPLE_CREATED_AT_ASC = "INSURER_USERS_STDDEV_SAMPLE_CREATED_AT_ASC",
  INSURER_USERS_STDDEV_SAMPLE_CREATED_AT_DESC = "INSURER_USERS_STDDEV_SAMPLE_CREATED_AT_DESC",
  INSURER_USERS_STDDEV_SAMPLE_ID_ASC = "INSURER_USERS_STDDEV_SAMPLE_ID_ASC",
  INSURER_USERS_STDDEV_SAMPLE_ID_DESC = "INSURER_USERS_STDDEV_SAMPLE_ID_DESC",
  INSURER_USERS_STDDEV_SAMPLE_INSURER_ID_ASC = "INSURER_USERS_STDDEV_SAMPLE_INSURER_ID_ASC",
  INSURER_USERS_STDDEV_SAMPLE_INSURER_ID_DESC = "INSURER_USERS_STDDEV_SAMPLE_INSURER_ID_DESC",
  INSURER_USERS_STDDEV_SAMPLE_UPDATED_AT_ASC = "INSURER_USERS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  INSURER_USERS_STDDEV_SAMPLE_UPDATED_AT_DESC = "INSURER_USERS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  INSURER_USERS_SUM_AUDITOR_USER_ID_ASC = "INSURER_USERS_SUM_AUDITOR_USER_ID_ASC",
  INSURER_USERS_SUM_AUDITOR_USER_ID_DESC = "INSURER_USERS_SUM_AUDITOR_USER_ID_DESC",
  INSURER_USERS_SUM_CREATED_AT_ASC = "INSURER_USERS_SUM_CREATED_AT_ASC",
  INSURER_USERS_SUM_CREATED_AT_DESC = "INSURER_USERS_SUM_CREATED_AT_DESC",
  INSURER_USERS_SUM_ID_ASC = "INSURER_USERS_SUM_ID_ASC",
  INSURER_USERS_SUM_ID_DESC = "INSURER_USERS_SUM_ID_DESC",
  INSURER_USERS_SUM_INSURER_ID_ASC = "INSURER_USERS_SUM_INSURER_ID_ASC",
  INSURER_USERS_SUM_INSURER_ID_DESC = "INSURER_USERS_SUM_INSURER_ID_DESC",
  INSURER_USERS_SUM_UPDATED_AT_ASC = "INSURER_USERS_SUM_UPDATED_AT_ASC",
  INSURER_USERS_SUM_UPDATED_AT_DESC = "INSURER_USERS_SUM_UPDATED_AT_DESC",
  INSURER_USERS_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "INSURER_USERS_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  INSURER_USERS_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "INSURER_USERS_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  INSURER_USERS_VARIANCE_POPULATION_CREATED_AT_ASC = "INSURER_USERS_VARIANCE_POPULATION_CREATED_AT_ASC",
  INSURER_USERS_VARIANCE_POPULATION_CREATED_AT_DESC = "INSURER_USERS_VARIANCE_POPULATION_CREATED_AT_DESC",
  INSURER_USERS_VARIANCE_POPULATION_ID_ASC = "INSURER_USERS_VARIANCE_POPULATION_ID_ASC",
  INSURER_USERS_VARIANCE_POPULATION_ID_DESC = "INSURER_USERS_VARIANCE_POPULATION_ID_DESC",
  INSURER_USERS_VARIANCE_POPULATION_INSURER_ID_ASC = "INSURER_USERS_VARIANCE_POPULATION_INSURER_ID_ASC",
  INSURER_USERS_VARIANCE_POPULATION_INSURER_ID_DESC = "INSURER_USERS_VARIANCE_POPULATION_INSURER_ID_DESC",
  INSURER_USERS_VARIANCE_POPULATION_UPDATED_AT_ASC = "INSURER_USERS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  INSURER_USERS_VARIANCE_POPULATION_UPDATED_AT_DESC = "INSURER_USERS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  INSURER_USERS_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "INSURER_USERS_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  INSURER_USERS_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "INSURER_USERS_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  INSURER_USERS_VARIANCE_SAMPLE_CREATED_AT_ASC = "INSURER_USERS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  INSURER_USERS_VARIANCE_SAMPLE_CREATED_AT_DESC = "INSURER_USERS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  INSURER_USERS_VARIANCE_SAMPLE_ID_ASC = "INSURER_USERS_VARIANCE_SAMPLE_ID_ASC",
  INSURER_USERS_VARIANCE_SAMPLE_ID_DESC = "INSURER_USERS_VARIANCE_SAMPLE_ID_DESC",
  INSURER_USERS_VARIANCE_SAMPLE_INSURER_ID_ASC = "INSURER_USERS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  INSURER_USERS_VARIANCE_SAMPLE_INSURER_ID_DESC = "INSURER_USERS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  INSURER_USERS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "INSURER_USERS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  INSURER_USERS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "INSURER_USERS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_AVERAGE_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_COUNT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_COUNT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_COUNT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_COUNT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_DISTINCT_COUNT_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MAX_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_MIN_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_POPULATION_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_STDDEV_SAMPLE_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_SUM_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_POPULATION_ROLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ACTOR_USER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ACTOR_USER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ACTOR_USER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ACTOR_USER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_CREATED_AT_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_CREATED_AT_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_EVENT_KIND_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_EVENT_KIND_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_EVENT_KIND_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_EVENT_KIND_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_INSURER_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_INSURER_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_PAYLOAD_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_PAYLOAD_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_PAYLOAD_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_PAYLOAD_DESC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ROLE_ID_ASC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ROLE_ID_ASC",
  LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ROLE_ID_DESC = "LIFECYCLE_PERMISSION_AUDIT_EVENTS_VARIANCE_SAMPLE_ROLE_ID_DESC",
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["Int"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["Int"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["Int"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["Int"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["Int"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["Int"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["Int"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["Int"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type IntStat = {
  __typename?: "IntStat";
  description: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  operationType: OperationTypeEnum;
  units: IntUnitsEnum;
  value: Scalars["Int"]["output"];
};

export enum IntUnitsEnum {
  CLAIMS = "CLAIMS",
  LIVES = "LIVES",
  PROVIDERS = "PROVIDERS",
}

export type InvoiceClaimState = Node & {
  __typename?: "InvoiceClaimState";
  /** Reads a single `BatchClaim` that is related to this `InvoiceClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  invoiceState: Scalars["String"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

export type InvoiceClaimStateAggregates = {
  __typename?: "InvoiceClaimStateAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<InvoiceClaimStateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `InvoiceClaimState` object types. */
export type InvoiceClaimStateAggregatesFilter = {
  /** Distinct count aggregate over matching `InvoiceClaimState` objects. */
  distinctCount?: InputMaybe<InvoiceClaimStateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `InvoiceClaimState` object to be included within the aggregate. */
  filter?: InputMaybe<InvoiceClaimStateFilter>;
};

/** Input for the nested mutation of `batchClaim` in the `InvoiceClaimStateInput` mutation. */
export type InvoiceClaimStateBatchClaimIdFkInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InvoiceClaimStateOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkNodeIdUpdate>;
};

/** Input for the nested mutation of `invoiceClaimState` in the `BatchClaimInput` mutation. */
export type InvoiceClaimStateBatchClaimIdFkInverseInput = {
  /** The primary key(s) for `invoiceClaimState` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<InvoiceClaimStateInvoiceClaimStatePkeyConnect>
  >;
  /** The primary key(s) for `invoiceClaimState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<InvoiceClaimStateNodeIdConnect>>;
  /** A `InvoiceClaimStateInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<InvoiceClaimStateBatchClaimIdFkInvoiceClaimStateCreateInput>
  >;
  /** The primary key(s) and patch data for `invoiceClaimState` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<InvoiceClaimStateOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkUsingInvoiceClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `invoiceClaimState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkNodeIdUpdate>
  >;
};

/** The `invoiceClaimState` to be created by this mutation. */
export type InvoiceClaimStateBatchClaimIdFkInvoiceClaimStateCreateInput = {
  batchClaimToBatchClaimId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  invoiceState?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * A condition to be used against `InvoiceClaimState` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InvoiceClaimStateCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `invoiceState` field. */
  invoiceState?: InputMaybe<Scalars["String"]["input"]>;
};

export type InvoiceClaimStateDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  invoiceState?: InputMaybe<BigIntFilter>;
};

export type InvoiceClaimStateDistinctCountAggregates = {
  __typename?: "InvoiceClaimStateDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of invoiceState across the matching connection */
  invoiceState?: Maybe<Scalars["BigInt"]["output"]>;
};

export enum InvoiceClaimStateEnum {
  NOT_PAID = "NOT_PAID",
  NOT_READY_TO_INVOICE = "NOT_READY_TO_INVOICE",
  PAID = "PAID",
  READY_TO_INVOICE = "READY_TO_INVOICE",
  SENT = "SENT",
}

/** A filter to be used against InvoiceClaimStateEnum fields. All fields are combined with a logical ‘and.’ */
export type InvoiceClaimStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<InvoiceClaimStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<InvoiceClaimStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<InvoiceClaimStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<InvoiceClaimStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<InvoiceClaimStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<InvoiceClaimStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<InvoiceClaimStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<InvoiceClaimStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<InvoiceClaimStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<InvoiceClaimStateEnum>>;
};

/** A filter to be used against `InvoiceClaimState` object types. All fields are combined with a logical ‘and.’ */
export type InvoiceClaimStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InvoiceClaimStateFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `invoiceState` field. */
  invoiceState?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InvoiceClaimStateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InvoiceClaimStateFilter>>;
};

/** Grouping methods for `InvoiceClaimState` for usage during aggregation. */
export enum InvoiceClaimStateGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  INVOICE_STATE = "INVOICE_STATE",
}

export type InvoiceClaimStateHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InvoiceClaimStateHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `InvoiceClaimState` aggregates. */
export type InvoiceClaimStateHavingInput = {
  AND?: InputMaybe<Array<InvoiceClaimStateHavingInput>>;
  OR?: InputMaybe<Array<InvoiceClaimStateHavingInput>>;
  average?: InputMaybe<InvoiceClaimStateHavingAverageInput>;
  distinctCount?: InputMaybe<InvoiceClaimStateHavingDistinctCountInput>;
  max?: InputMaybe<InvoiceClaimStateHavingMaxInput>;
  min?: InputMaybe<InvoiceClaimStateHavingMinInput>;
  stddevPopulation?: InputMaybe<InvoiceClaimStateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<InvoiceClaimStateHavingStddevSampleInput>;
  sum?: InputMaybe<InvoiceClaimStateHavingSumInput>;
  variancePopulation?: InputMaybe<InvoiceClaimStateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<InvoiceClaimStateHavingVarianceSampleInput>;
};

export type InvoiceClaimStateHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InvoiceClaimStateHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InvoiceClaimStateHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InvoiceClaimStateHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InvoiceClaimStateHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InvoiceClaimStateHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type InvoiceClaimStateHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `InvoiceClaimState` */
export type InvoiceClaimStateInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  invoiceState?: InputMaybe<Scalars["String"]["input"]>;
};

/** The fields on `invoiceClaimState` to look up the row to connect. */
export type InvoiceClaimStateInvoiceClaimStatePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The globally unique `ID` look up for the row to connect. */
export type InvoiceClaimStateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `invoiceClaimState` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type InvoiceClaimStateOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `invoiceClaimState` to look up the row to update. */
export type InvoiceClaimStateOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkUsingInvoiceClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `invoiceClaimState` being updated. */
    patch: updateInvoiceClaimStateOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkPatch;
  };

/** Represents an update to a `InvoiceClaimState`. Fields that are set will be updated. */
export type InvoiceClaimStatePatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInput>;
};

/** A connection to a list of `InvoiceClaimState` values. */
export type InvoiceClaimStatesConnection = {
  __typename?: "InvoiceClaimStatesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<InvoiceClaimStateAggregates>;
  /** A list of edges which contains the `InvoiceClaimState` and cursor to aid in pagination. */
  edges: Array<InvoiceClaimStatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<InvoiceClaimStateAggregates>>;
  /** A list of `InvoiceClaimState` objects. */
  nodes: Array<Maybe<InvoiceClaimState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InvoiceClaimState` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `InvoiceClaimState` values. */
export type InvoiceClaimStatesConnectiongroupedAggregatesArgs = {
  groupBy: Array<InvoiceClaimStateGroupBy>;
  having?: InputMaybe<InvoiceClaimStateHavingInput>;
};

/** A `InvoiceClaimState` edge in the connection. */
export type InvoiceClaimStatesEdge = {
  __typename?: "InvoiceClaimStatesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `InvoiceClaimState` at the end of the edge. */
  node?: Maybe<InvoiceClaimState>;
};

/** Methods to use when ordering `InvoiceClaimState`. */
export enum InvoiceClaimStatesOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INVOICE_STATE_ASC = "INVOICE_STATE_ASC",
  INVOICE_STATE_DESC = "INVOICE_STATE_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

export type ItemizedBill = {
  __typename?: "ItemizedBill";
  csv: Csv;
  id: Scalars["UUID"]["output"];
};

export type ItemizedBillLine = {
  __typename?: "ItemizedBillLine";
  alaRowId?: Maybe<Scalars["UUID"]["output"]>;
  chinDescription?: Maybe<Scalars["String"]["output"]>;
  chinItemNumber?: Maybe<Scalars["String"]["output"]>;
  chinModifier?: Maybe<Scalars["String"]["output"]>;
  chinProcedureCode?: Maybe<Scalars["String"]["output"]>;
  chinRevCode?: Maybe<Scalars["String"]["output"]>;
  dateOfService?: Maybe<Scalars["Date"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  findings: Array<Scalars["UUID"]["output"]>;
  groupCode?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  itemNumber?: Maybe<Scalars["String"]["output"]>;
  lineNumber?: Maybe<Scalars["Int"]["output"]>;
  procedureCode?: Maybe<Scalars["String"]["output"]>;
  procedureCodeModifier?: Maybe<Scalars["String"]["output"]>;
  revCode?: Maybe<Scalars["String"]["output"]>;
  s3InputSourceId?: Maybe<Scalars["UUID"]["output"]>;
  totalCharge?: Maybe<Scalars["Float"]["output"]>;
  units?: Maybe<Scalars["Int"]["output"]>;
  versionFingerprint?: Maybe<Scalars["UUID"]["output"]>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JSONFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars["String"]["input"]>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["JSON"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["JSON"]["input"]>>;
};

export type JsonPatchOperation = {
  from?: InputMaybe<Scalars["String"]["input"]>;
  op: Scalars["String"]["input"];
  path: Scalars["String"]["input"];
  value?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type LatestReview = {
  __typename?: "LatestReview";
  authorId: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  deleted: Scalars["Boolean"]["output"];
  rationale?: Maybe<Scalars["String"]["output"]>;
};

export enum LifecycleMatrixAction {
  CREATE_BLOCKER = "CREATE_BLOCKER",
  CREATE_FINDING = "CREATE_FINDING",
  DELETE_BLOCKER = "DELETE_BLOCKER",
  EDIT_BLOCKER = "EDIT_BLOCKER",
  EDIT_FINDING = "EDIT_FINDING",
  EDIT_STAGE = "EDIT_STAGE",
}

/**
 * Insurer-scoped lifecycle role for Settings (PG cache; OpenFGA is SoT for Check).
 * insurerId is returned on reads; tenant is resolved server-side on writes/queries.
 */
export type LifecycleRole = {
  __typename?: "LifecycleRole";
  createdAt: Scalars["Datetime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  insurerId?: Maybe<Scalars["UUID"]["output"]>;
  isDeleted: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
  version: Scalars["Int"]["output"];
};

export type LifecycleStageHistoryEntry = {
  __typename?: "LifecycleStageHistoryEntry";
  appliedByUserId?: Maybe<Scalars["UUID"]["output"]>;
  context?: Maybe<Scalars["JSON"]["output"]>;
  enteredAt: Scalars["Datetime"]["output"];
  exitedAt?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["ID"]["output"];
  stage: StageTrackerStage;
};

export type LifecycleStageRecommendation = {
  __typename?: "LifecycleStageRecommendation";
  nextRecommendedStage?: Maybe<StageTrackerStage>;
  stage: StageTrackerStage;
  suggestedStages: Array<StageTrackerSuggestedStage>;
};

export type LifecycleStageSuggestionInput = {
  priority: Scalars["Int"]["input"];
  targetStageId?: InputMaybe<Scalars["UUID"]["input"]>;
  targetStageSlug?: InputMaybe<Scalars["String"]["input"]>;
};

export enum MFAOption {
  EMAIL_OTP = "EMAIL_OTP",
  SMS_MFA = "SMS_MFA",
  SOFTWARE_TOKEN_MFA = "SOFTWARE_TOKEN_MFA",
}

export type MUEAuditRule = {
  __typename?: "MUEAuditRule";
  code: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  editType: Scalars["String"]["output"];
  mai: Scalars["String"]["output"];
  num: Scalars["Int"]["output"];
  rationale: MUEAuditRuleRationale;
};

export type MUEAuditRuleRationale = {
  __typename?: "MUEAuditRuleRationale";
  enumeration: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type Message = {
  __typename?: "Message";
  citations?: Maybe<Array<InlineCitations>>;
  createdAt: Scalars["String"]["output"];
  feedback?: Maybe<Array<PromptFeedback>>;
  id: Scalars["ID"]["output"];
  promptInputState: Scalars["String"]["output"];
  promptText: Scalars["String"]["output"];
  response?: Maybe<PromptResponse>;
  thread: Thread;
};

/**
 * ## Overview
 * Records messages created (aka notifications sent). Owned and written to by the Notification Service.
 *  More message types can be created by adding a nullable foreign key to a table owned by a separate service,
 * as well as a new message_created_kind enum
 */
export type MessageCreated = Node & {
  __typename?: "MessageCreated";
  createdAt: Scalars["Datetime"]["output"];
  /** Reads a single `DocumentRequestCreated` that is related to this `MessageCreated`. */
  documentRequestCreated?: Maybe<DocumentRequestCreated>;
  documentRequestCreatedId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `DocumentRequestCreated`. */
  documentRequestCreatedsByDeprecatedMessageCreatedId: DocumentRequestCreatedsConnection;
  /** Reads a single `DocumentUploadCreated` that is related to this `MessageCreated`. */
  documentUploadCreated?: Maybe<DocumentUploadCreated>;
  documentUploadCreatedId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `DocumentUploadCreated`. */
  documentUploadCreatedsByDeprecatedMessageId: DocumentUploadCreatedsConnection;
  id: Scalars["UUID"]["output"];
  kind: MessageCreatedKind;
  message?: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `MessageSent`. */
  messageSentsByMessageId: MessageSentsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `AuditorUser` that is related to this `MessageCreated`. */
  senderUser?: Maybe<AuditorUser>;
  senderUserId: Scalars["UUID"]["output"];
  /** Reads and enables pagination through a set of `UserInviteCreated`. */
  userInviteCreatedsByMessageId: UserInviteCreatedsConnection;
};

/**
 * ## Overview
 * Records messages created (aka notifications sent). Owned and written to by the Notification Service.
 *  More message types can be created by adding a nullable foreign key to a table owned by a separate service,
 * as well as a new message_created_kind enum
 */
export type MessageCreateddocumentRequestCreatedsByDeprecatedMessageCreatedIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DocumentRequestCreatedCondition>;
    filter?: InputMaybe<DocumentRequestCreatedFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DocumentRequestCreatedsOrderBy>>;
  };

/**
 * ## Overview
 * Records messages created (aka notifications sent). Owned and written to by the Notification Service.
 *  More message types can be created by adding a nullable foreign key to a table owned by a separate service,
 * as well as a new message_created_kind enum
 */
export type MessageCreateddocumentUploadCreatedsByDeprecatedMessageIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentUploadCreatedCondition>;
  filter?: InputMaybe<DocumentUploadCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentUploadCreatedsOrderBy>>;
};

/**
 * ## Overview
 * Records messages created (aka notifications sent). Owned and written to by the Notification Service.
 *  More message types can be created by adding a nullable foreign key to a table owned by a separate service,
 * as well as a new message_created_kind enum
 */
export type MessageCreatedmessageSentsByMessageIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MessageSentCondition>;
  filter?: InputMaybe<MessageSentFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MessageSentsOrderBy>>;
};

/**
 * ## Overview
 * Records messages created (aka notifications sent). Owned and written to by the Notification Service.
 *  More message types can be created by adding a nullable foreign key to a table owned by a separate service,
 * as well as a new message_created_kind enum
 */
export type MessageCreateduserInviteCreatedsByMessageIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserInviteCreatedCondition>;
  filter?: InputMaybe<UserInviteCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserInviteCreatedsOrderBy>>;
};

export type MessageCreatedAggregates = {
  __typename?: "MessageCreatedAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<MessageCreatedDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `MessageCreated` object types. */
export type MessageCreatedAggregatesFilter = {
  /** Distinct count aggregate over matching `MessageCreated` objects. */
  distinctCount?: InputMaybe<MessageCreatedDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `MessageCreated` object to be included within the aggregate. */
  filter?: InputMaybe<MessageCreatedFilter>;
};

/**
 * A condition to be used against `MessageCreated` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MessageCreatedCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `documentRequestCreatedId` field. */
  documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `documentUploadCreatedId` field. */
  documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<MessageCreatedKind>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `senderUserId` field. */
  senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type MessageCreatedDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  documentRequestCreatedId?: InputMaybe<BigIntFilter>;
  documentUploadCreatedId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  kind?: InputMaybe<BigIntFilter>;
  message?: InputMaybe<BigIntFilter>;
  senderUserId?: InputMaybe<BigIntFilter>;
};

export type MessageCreatedDistinctCountAggregates = {
  __typename?: "MessageCreatedDistinctCountAggregates";
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of documentRequestCreatedId across the matching connection */
  documentRequestCreatedId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of documentUploadCreatedId across the matching connection */
  documentUploadCreatedId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of kind across the matching connection */
  kind?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of message across the matching connection */
  message?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of senderUserId across the matching connection */
  senderUserId?: Maybe<Scalars["BigInt"]["output"]>;
};

/** The `documentRequestCreated` to be created by this mutation. */
export type MessageCreatedDocumentRequestCreatedIdFkeyDocumentRequestCreatedCreateInput =
  {
    _deprecatedMessageCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    messageCreatedToDeprecatedMessageCreatedId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInverseInput>;
  };

/** Input for the nested mutation of `documentRequestCreated` in the `MessageCreatedInput` mutation. */
export type MessageCreatedDocumentRequestCreatedIdFkeyInput = {
  /** The primary key(s) for `documentRequestCreated` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentRequestCreatedDocumentRequestCreatedPkeyConnect>;
  /** The primary key(s) for `documentRequestCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<DocumentRequestCreatedNodeIdConnect>;
  /** A `DocumentRequestCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyDocumentRequestCreatedCreateInput>;
  /** The primary key(s) and patch data for `documentRequestCreated` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentRequestCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyUsingDocumentRequestCreatedPkeyUpdate>;
  /** The primary key(s) and patch data for `documentRequestCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MessageCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `messageCreated` in the `DocumentRequestCreatedInput` mutation. */
export type MessageCreatedDocumentRequestCreatedIdFkeyInverseInput = {
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MessageCreatedMessageCreatedPkeyConnect>>;
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MessageCreatedNodeIdConnect>>;
  /** A `MessageCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<MessageCreatedDocumentRequestCreatedIdFkeyMessageCreatedCreateInput>
  >;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MessageCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyUsingMessageCreatedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<DocumentRequestCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyNodeIdUpdate>
  >;
};

/** The `messageCreated` to be created by this mutation. */
export type MessageCreatedDocumentRequestCreatedIdFkeyMessageCreatedCreateInput =
  {
    auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
    documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    kind: MessageCreatedKind;
    message?: InputMaybe<Scalars["String"]["input"]>;
    messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
    senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
  };

/** The `documentUploadCreated` to be created by this mutation. */
export type MessageCreatedDocumentUploadCreatedIdFkeyDocumentUploadCreatedCreateInput =
  {
    _deprecatedMessageId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
    claimInquiryRequestId?: InputMaybe<Scalars["UUID"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileLocation: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    kind: DocumentUploadKind;
    messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
  };

/** Input for the nested mutation of `documentUploadCreated` in the `MessageCreatedInput` mutation. */
export type MessageCreatedDocumentUploadCreatedIdFkeyInput = {
  /** The primary key(s) for `documentUploadCreated` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentUploadCreatedDocumentUploadCreatedPkeyConnect>;
  /** The primary key(s) for `documentUploadCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<DocumentUploadCreatedNodeIdConnect>;
  /** A `DocumentUploadCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyDocumentUploadCreatedCreateInput>;
  /** The primary key(s) and patch data for `documentUploadCreated` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentUploadCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyUsingDocumentUploadCreatedPkeyUpdate>;
  /** The primary key(s) and patch data for `documentUploadCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MessageCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `messageCreated` in the `DocumentUploadCreatedInput` mutation. */
export type MessageCreatedDocumentUploadCreatedIdFkeyInverseInput = {
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MessageCreatedMessageCreatedPkeyConnect>>;
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MessageCreatedNodeIdConnect>>;
  /** A `MessageCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<MessageCreatedDocumentUploadCreatedIdFkeyMessageCreatedCreateInput>
  >;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MessageCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyUsingMessageCreatedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<DocumentUploadCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyNodeIdUpdate>
  >;
};

/** The `messageCreated` to be created by this mutation. */
export type MessageCreatedDocumentUploadCreatedIdFkeyMessageCreatedCreateInput =
  {
    auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
    documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    kind: MessageCreatedKind;
    message?: InputMaybe<Scalars["String"]["input"]>;
    messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
    senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
  };

/** A filter to be used against `MessageCreated` object types. All fields are combined with a logical ‘and.’ */
export type MessageCreatedFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MessageCreatedFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `documentRequestCreated` relation. */
  documentRequestCreated?: InputMaybe<DocumentRequestCreatedFilter>;
  /** A related `documentRequestCreated` exists. */
  documentRequestCreatedExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `documentRequestCreatedId` field. */
  documentRequestCreatedId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `documentRequestCreatedsByDeprecatedMessageCreatedId` relation. */
  documentRequestCreatedsByDeprecatedMessageCreatedId?: InputMaybe<MessageCreatedToManyDocumentRequestCreatedFilter>;
  /** Some related `documentRequestCreatedsByDeprecatedMessageCreatedId` exist. */
  documentRequestCreatedsByDeprecatedMessageCreatedIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `documentUploadCreated` relation. */
  documentUploadCreated?: InputMaybe<DocumentUploadCreatedFilter>;
  /** A related `documentUploadCreated` exists. */
  documentUploadCreatedExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `documentUploadCreatedId` field. */
  documentUploadCreatedId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `documentUploadCreatedsByDeprecatedMessageId` relation. */
  documentUploadCreatedsByDeprecatedMessageId?: InputMaybe<MessageCreatedToManyDocumentUploadCreatedFilter>;
  /** Some related `documentUploadCreatedsByDeprecatedMessageId` exist. */
  documentUploadCreatedsByDeprecatedMessageIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `kind` field. */
  kind?: InputMaybe<MessageCreatedKindFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Filter by the object’s `messageSentsByMessageId` relation. */
  messageSentsByMessageId?: InputMaybe<MessageCreatedToManyMessageSentFilter>;
  /** Some related `messageSentsByMessageId` exist. */
  messageSentsByMessageIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Negates the expression. */
  not?: InputMaybe<MessageCreatedFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MessageCreatedFilter>>;
  /** Filter by the object’s `senderUser` relation. */
  senderUser?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `senderUserId` field. */
  senderUserId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `userInviteCreatedsByMessageId` relation. */
  userInviteCreatedsByMessageId?: InputMaybe<MessageCreatedToManyUserInviteCreatedFilter>;
  /** Some related `userInviteCreatedsByMessageId` exist. */
  userInviteCreatedsByMessageIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Grouping methods for `MessageCreated` for usage during aggregation. */
export enum MessageCreatedGroupBy {
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DOCUMENT_REQUEST_CREATED_ID = "DOCUMENT_REQUEST_CREATED_ID",
  DOCUMENT_UPLOAD_CREATED_ID = "DOCUMENT_UPLOAD_CREATED_ID",
  KIND = "KIND",
  MESSAGE = "MESSAGE",
  SENDER_USER_ID = "SENDER_USER_ID",
}

export type MessageCreatedHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageCreatedHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `MessageCreated` aggregates. */
export type MessageCreatedHavingInput = {
  AND?: InputMaybe<Array<MessageCreatedHavingInput>>;
  OR?: InputMaybe<Array<MessageCreatedHavingInput>>;
  average?: InputMaybe<MessageCreatedHavingAverageInput>;
  distinctCount?: InputMaybe<MessageCreatedHavingDistinctCountInput>;
  max?: InputMaybe<MessageCreatedHavingMaxInput>;
  min?: InputMaybe<MessageCreatedHavingMinInput>;
  stddevPopulation?: InputMaybe<MessageCreatedHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<MessageCreatedHavingStddevSampleInput>;
  sum?: InputMaybe<MessageCreatedHavingSumInput>;
  variancePopulation?: InputMaybe<MessageCreatedHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<MessageCreatedHavingVarianceSampleInput>;
};

export type MessageCreatedHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageCreatedHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageCreatedHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageCreatedHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageCreatedHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageCreatedHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageCreatedHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `MessageCreated` */
export type MessageCreatedInput = {
  auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
  documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  kind: MessageCreatedKind;
  message?: InputMaybe<Scalars["String"]["input"]>;
  messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
  senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
};

export enum MessageCreatedKind {
  CLAIM_INQUIRY_REPLY_CREATED = "CLAIM_INQUIRY_REPLY_CREATED",
  CLAIM_INQUIRY_REQUEST_CREATED = "CLAIM_INQUIRY_REQUEST_CREATED",
  DOCUMENT_REQUEST_CREATED = "DOCUMENT_REQUEST_CREATED",
  DOCUMENT_UPLOAD_CREATED = "DOCUMENT_UPLOAD_CREATED",
  FINAL_AUDIT_FINDING_REPORT_REVIEW_REPLY_CREATED = "FINAL_AUDIT_FINDING_REPORT_REVIEW_REPLY_CREATED",
  FINAL_AUDIT_FINDING_REPORT_REVIEW_REQUEST_CREATED = "FINAL_AUDIT_FINDING_REPORT_REVIEW_REQUEST_CREATED",
  PRELIMINARY_AUDIT_REPORT_REVIEW_REPLY_CREATED = "PRELIMINARY_AUDIT_REPORT_REVIEW_REPLY_CREATED",
  PRELIMINARY_AUDIT_REPORT_REVIEW_REQUEST_CREATED = "PRELIMINARY_AUDIT_REPORT_REVIEW_REQUEST_CREATED",
  REPORT_CREATED = "REPORT_CREATED",
  USER_INVITE_CREATED = "USER_INVITE_CREATED",
}

/** A filter to be used against MessageCreatedKind fields. All fields are combined with a logical ‘and.’ */
export type MessageCreatedKindFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MessageCreatedKind>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MessageCreatedKind>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MessageCreatedKind>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MessageCreatedKind>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MessageCreatedKind>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MessageCreatedKind>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MessageCreatedKind>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MessageCreatedKind>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MessageCreatedKind>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MessageCreatedKind>>;
};

/** The fields on `messageCreated` to look up the row to connect. */
export type MessageCreatedMessageCreatedPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The globally unique `ID` look up for the row to connect. */
export type MessageCreatedNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `messageCreated` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type MessageCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `documentRequestCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `documentRequestCreated` being updated. */
    patch: DocumentRequestCreatedPatch;
  };

/** The fields on `messageCreated` to look up the row to update. */
export type MessageCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkUsingMessageCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: updateMessageCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type MessageCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `documentUploadCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
    patch: DocumentUploadCreatedPatch;
  };

/** The fields on `messageCreated` to look up the row to update. */
export type MessageCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyUsingMessageCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: updateMessageCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type MessageCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `documentRequestCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `documentRequestCreated` being updated. */
    patch: DocumentRequestCreatedPatch;
  };

/** The fields on `messageCreated` to look up the row to update. */
export type MessageCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyUsingMessageCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: updateMessageCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type MessageCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `documentUploadCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
    patch: DocumentUploadCreatedPatch;
  };

/** The fields on `messageCreated` to look up the row to update. */
export type MessageCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyUsingMessageCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: updateMessageCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type MessageCreatedOnMessageCreatedForMessageCreatedSenderUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `messageCreated` to look up the row to update. */
export type MessageCreatedOnMessageCreatedForMessageCreatedSenderUserIdFkeyUsingMessageCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: updateMessageCreatedOnMessageCreatedForMessageCreatedSenderUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type MessageCreatedOnMessageSentForMessageSentMessageIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `messageSent` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `messageSent` being updated. */
    patch: MessageSentPatch;
  };

/** The fields on `messageCreated` to look up the row to update. */
export type MessageCreatedOnMessageSentForMessageSentMessageIdFkeyUsingMessageCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: updateMessageCreatedOnMessageSentForMessageSentMessageIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type MessageCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `userInviteCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `userInviteCreated` being updated. */
    patch: UserInviteCreatedPatch;
  };

/** The fields on `messageCreated` to look up the row to update. */
export type MessageCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyUsingMessageCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: updateMessageCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyPatch;
  };

/** Represents an update to a `MessageCreated`. Fields that are set will be updated. */
export type MessageCreatedPatch = {
  auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
  documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
  documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
  messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
  senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
};

/** Input for the nested mutation of `auditorUser` in the `MessageCreatedInput` mutation. */
export type MessageCreatedSenderUserIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MessageCreatedOnMessageCreatedForMessageCreatedSenderUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `messageCreated` in the `AuditorUserInput` mutation. */
export type MessageCreatedSenderUserIdFkeyInverseInput = {
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MessageCreatedMessageCreatedPkeyConnect>>;
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MessageCreatedNodeIdConnect>>;
  /** A `MessageCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<MessageCreatedSenderUserIdFkeyMessageCreatedCreateInput>
  >;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MessageCreatedOnMessageCreatedForMessageCreatedSenderUserIdFkeyUsingMessageCreatedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyNodeIdUpdate>
  >;
};

/** The `messageCreated` to be created by this mutation. */
export type MessageCreatedSenderUserIdFkeyMessageCreatedCreateInput = {
  auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
  documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  kind: MessageCreatedKind;
  message?: InputMaybe<Scalars["String"]["input"]>;
  messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
};

/** A filter to be used against many `DocumentRequestCreated` object types. All fields are combined with a logical ‘and.’ */
export type MessageCreatedToManyDocumentRequestCreatedFilter = {
  /** Aggregates across related `DocumentRequestCreated` match the filter criteria. */
  aggregates?: InputMaybe<DocumentRequestCreatedAggregatesFilter>;
  /** Every related `DocumentRequestCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentRequestCreatedFilter>;
  /** No related `DocumentRequestCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentRequestCreatedFilter>;
  /** Some related `DocumentRequestCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentRequestCreatedFilter>;
};

/** A filter to be used against many `DocumentUploadCreated` object types. All fields are combined with a logical ‘and.’ */
export type MessageCreatedToManyDocumentUploadCreatedFilter = {
  /** Aggregates across related `DocumentUploadCreated` match the filter criteria. */
  aggregates?: InputMaybe<DocumentUploadCreatedAggregatesFilter>;
  /** Every related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUploadCreatedFilter>;
  /** No related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUploadCreatedFilter>;
  /** Some related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUploadCreatedFilter>;
};

/** A filter to be used against many `MessageSent` object types. All fields are combined with a logical ‘and.’ */
export type MessageCreatedToManyMessageSentFilter = {
  /** Aggregates across related `MessageSent` match the filter criteria. */
  aggregates?: InputMaybe<MessageSentAggregatesFilter>;
  /** Every related `MessageSent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MessageSentFilter>;
  /** No related `MessageSent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MessageSentFilter>;
  /** Some related `MessageSent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MessageSentFilter>;
};

/** A filter to be used against many `UserInviteCreated` object types. All fields are combined with a logical ‘and.’ */
export type MessageCreatedToManyUserInviteCreatedFilter = {
  /** Aggregates across related `UserInviteCreated` match the filter criteria. */
  aggregates?: InputMaybe<UserInviteCreatedAggregatesFilter>;
  /** Every related `UserInviteCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserInviteCreatedFilter>;
  /** No related `UserInviteCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserInviteCreatedFilter>;
  /** Some related `UserInviteCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserInviteCreatedFilter>;
};

/** A connection to a list of `MessageCreated` values. */
export type MessageCreatedsConnection = {
  __typename?: "MessageCreatedsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<MessageCreatedAggregates>;
  /** A list of edges which contains the `MessageCreated` and cursor to aid in pagination. */
  edges: Array<MessageCreatedsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<MessageCreatedAggregates>>;
  /** A list of `MessageCreated` objects. */
  nodes: Array<Maybe<MessageCreated>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MessageCreated` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `MessageCreated` values. */
export type MessageCreatedsConnectiongroupedAggregatesArgs = {
  groupBy: Array<MessageCreatedGroupBy>;
  having?: InputMaybe<MessageCreatedHavingInput>;
};

/** A `MessageCreated` edge in the connection. */
export type MessageCreatedsEdge = {
  __typename?: "MessageCreatedsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `MessageCreated` at the end of the edge. */
  node?: Maybe<MessageCreated>;
};

/** Methods to use when ordering `MessageCreated`. */
export enum MessageCreatedsOrderBy {
  AUDITOR_USER_BY_SENDER_USER_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__EMAIL_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__EMAIL_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__EMAIL_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__EMAIL_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__ID_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__ID_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__ID_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__ID_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__TITLE_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__TITLE_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__TITLE_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__TITLE_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_SENDER_USER_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_SENDER_USER_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_SENDER_USER_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_SENDER_USER_ID__USER_TYPE_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_AVERAGE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_COUNT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_COUNT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_COUNT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_COUNT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MAX_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_MIN_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_SUM_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_AVERAGE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_COUNT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_COUNT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_COUNT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_COUNT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MAX_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_MIN_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_SUM_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_AVERAGE_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_COUNT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_COUNT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_COUNT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_COUNT_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_DISTINCT_COUNT_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MAX_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_MIN_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_POPULATION_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_STDDEV_SAMPLE_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_SUM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_POPULATION_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_DELETED_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_DELETED_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_DELETED_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_DELETED_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_ID_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_ID_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_ID_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID_VARIANCE_SAMPLE_ID_DESC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID__COUNT_ASC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID__COUNT_ASC",
  DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID__COUNT_DESC = "DOCUMENT_REQUEST_CREATEDS_BY_DEPRECATED_MESSAGE_CREATED_ID__COUNT_DESC",
  DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__BATCH_CLAIM_ID_ASC = "DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__BATCH_CLAIM_ID_ASC",
  DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__BATCH_CLAIM_ID_DESC = "DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__BATCH_CLAIM_ID_DESC",
  DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__CREATED_AT_ASC = "DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__CREATED_AT_ASC",
  DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__CREATED_AT_DESC = "DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__CREATED_AT_DESC",
  DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__DELETED_ASC = "DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__DELETED_ASC",
  DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__DELETED_DESC = "DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__DELETED_DESC",
  DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__ID_ASC = "DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__ID_ASC",
  DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__ID_DESC = "DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID__ID_DESC",
  DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID___DEPRECATED_MESSAGE_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID___DEPRECATED_MESSAGE_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID___DEPRECATED_MESSAGE_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATED_BY_DOCUMENT_REQUEST_CREATED_ID___DEPRECATED_MESSAGE_CREATED_ID_DESC",
  DOCUMENT_REQUEST_CREATED_ID_ASC = "DOCUMENT_REQUEST_CREATED_ID_ASC",
  DOCUMENT_REQUEST_CREATED_ID_DESC = "DOCUMENT_REQUEST_CREATED_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_AVERAGE_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_COUNT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_COUNT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_COUNT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_COUNT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_DISTINCT_COUNT_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MAX_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_MIN_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_POPULATION_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_SUM_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID__COUNT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID__COUNT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID__COUNT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_DEPRECATED_MESSAGE_ID__COUNT_DESC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__ID_ASC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__ID_ASC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__ID_DESC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__ID_DESC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__KIND_ASC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__KIND_ASC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__KIND_DESC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__KIND_DESC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID__PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID___DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID___DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID___DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATED_BY_DOCUMENT_UPLOAD_CREATED_ID___DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATED_ID_ASC = "DOCUMENT_UPLOAD_CREATED_ID_ASC",
  DOCUMENT_UPLOAD_CREATED_ID_DESC = "DOCUMENT_UPLOAD_CREATED_ID_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  KIND_ASC = "KIND_ASC",
  KIND_DESC = "KIND_DESC",
  MESSAGE_ASC = "MESSAGE_ASC",
  MESSAGE_DESC = "MESSAGE_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_AVERAGE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_COUNT_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_COUNT_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_COUNT_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_COUNT_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_CREATED_AT_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_CREATED_AT_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MAX_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MAX_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_CREATED_AT_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_CREATED_AT_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_MIN_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_MIN_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_CREATED_AT_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_CREATED_AT_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_SUM_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_SUM_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_MESSAGE_ID__COUNT_ASC = "MESSAGE_SENTS_BY_MESSAGE_ID__COUNT_ASC",
  MESSAGE_SENTS_BY_MESSAGE_ID__COUNT_DESC = "MESSAGE_SENTS_BY_MESSAGE_ID__COUNT_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_READ_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_READ_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_READ_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_AVERAGE_READ_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_COUNT_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_COUNT_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_COUNT_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_COUNT_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_READ_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_READ_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_READ_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_READ_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_READ_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_READ_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_READ_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MAX_READ_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_READ_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_READ_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_READ_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_MIN_READ_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_READ_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_READ_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_READ_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_READ_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_READ_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_READ_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_READ_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_READ_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_READ_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_READ_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_READ_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_SUM_READ_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_READ_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_READ_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_READ_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_READ_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_READ_ASC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_READ_ASC",
  MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_READ_DESC = "MESSAGE_UPDATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_READ_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  SENDER_USER_ID_ASC = "SENDER_USER_ID_ASC",
  SENDER_USER_ID_DESC = "SENDER_USER_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_AVERAGE_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_COUNT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_COUNT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_COUNT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_COUNT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_DISTINCT_COUNT_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MAX_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_MIN_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_POPULATION_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_STDDEV_SAMPLE_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_SUM_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_POPULATION_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_TEMPORARY_PASSWORD_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_TEMPORARY_PASSWORD_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_TEMPORARY_PASSWORD_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_TEMPORARY_PASSWORD_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID__COUNT_ASC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID__COUNT_ASC",
  USER_INVITE_CREATEDS_BY_MESSAGE_ID__COUNT_DESC = "USER_INVITE_CREATEDS_BY_MESSAGE_ID__COUNT_DESC",
}

export type MessageSent = Node & {
  __typename?: "MessageSent";
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads a single `MessageCreated` that is related to this `MessageSent`. */
  message?: Maybe<MessageCreated>;
  messageId: Scalars["UUID"]["output"];
  /** Reads and enables pagination through a set of `MessageSent`. */
  messageSentsByResponseToMessageSentId: MessageSentsConnection;
  /** Reads and enables pagination through a set of `MessageSent`. */
  messageSentsBySeedMessageSentId: MessageSentsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `AuditorUser` that is related to this `MessageSent`. */
  recipientUser?: Maybe<AuditorUser>;
  recipientUserId: Scalars["UUID"]["output"];
  /** Reads a single `MessageSent` that is related to this `MessageSent`. */
  responseToMessageSent?: Maybe<MessageSent>;
  responseToMessageSentId?: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `MessageSent` that is related to this `MessageSent`. */
  seedMessageSent?: Maybe<MessageSent>;
  seedMessageSentId?: Maybe<Scalars["UUID"]["output"]>;
};

export type MessageSentmessageSentsByResponseToMessageSentIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MessageSentCondition>;
  filter?: InputMaybe<MessageSentFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MessageSentsOrderBy>>;
};

export type MessageSentmessageSentsBySeedMessageSentIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MessageSentCondition>;
  filter?: InputMaybe<MessageSentFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MessageSentsOrderBy>>;
};

export type MessageSentAggregates = {
  __typename?: "MessageSentAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<MessageSentDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `MessageSent` object types. */
export type MessageSentAggregatesFilter = {
  /** Distinct count aggregate over matching `MessageSent` objects. */
  distinctCount?: InputMaybe<MessageSentDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `MessageSent` object to be included within the aggregate. */
  filter?: InputMaybe<MessageSentFilter>;
};

/**
 * A condition to be used against `MessageSent` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MessageSentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `messageId` field. */
  messageId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `recipientUserId` field. */
  recipientUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `responseToMessageSentId` field. */
  responseToMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `seedMessageSentId` field. */
  seedMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type MessageSentDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  messageId?: InputMaybe<BigIntFilter>;
  recipientUserId?: InputMaybe<BigIntFilter>;
  responseToMessageSentId?: InputMaybe<BigIntFilter>;
  seedMessageSentId?: InputMaybe<BigIntFilter>;
};

export type MessageSentDistinctCountAggregates = {
  __typename?: "MessageSentDistinctCountAggregates";
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of messageId across the matching connection */
  messageId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of recipientUserId across the matching connection */
  recipientUserId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of responseToMessageSentId across the matching connection */
  responseToMessageSentId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of seedMessageSentId across the matching connection */
  seedMessageSentId?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `MessageSent` object types. All fields are combined with a logical ‘and.’ */
export type MessageSentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MessageSentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `message` relation. */
  message?: InputMaybe<MessageCreatedFilter>;
  /** Filter by the object’s `messageId` field. */
  messageId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `messageSentsByResponseToMessageSentId` relation. */
  messageSentsByResponseToMessageSentId?: InputMaybe<MessageSentToManyMessageSentFilter>;
  /** Some related `messageSentsByResponseToMessageSentId` exist. */
  messageSentsByResponseToMessageSentIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `messageSentsBySeedMessageSentId` relation. */
  messageSentsBySeedMessageSentId?: InputMaybe<MessageSentToManyMessageSentFilter>;
  /** Some related `messageSentsBySeedMessageSentId` exist. */
  messageSentsBySeedMessageSentIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Negates the expression. */
  not?: InputMaybe<MessageSentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MessageSentFilter>>;
  /** Filter by the object’s `recipientUser` relation. */
  recipientUser?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `recipientUserId` field. */
  recipientUserId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `responseToMessageSent` relation. */
  responseToMessageSent?: InputMaybe<MessageSentFilter>;
  /** A related `responseToMessageSent` exists. */
  responseToMessageSentExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `responseToMessageSentId` field. */
  responseToMessageSentId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `seedMessageSent` relation. */
  seedMessageSent?: InputMaybe<MessageSentFilter>;
  /** A related `seedMessageSent` exists. */
  seedMessageSentExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `seedMessageSentId` field. */
  seedMessageSentId?: InputMaybe<UUIDFilter>;
};

/** Grouping methods for `MessageSent` for usage during aggregation. */
export enum MessageSentGroupBy {
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  MESSAGE_ID = "MESSAGE_ID",
  RECIPIENT_USER_ID = "RECIPIENT_USER_ID",
  RESPONSE_TO_MESSAGE_SENT_ID = "RESPONSE_TO_MESSAGE_SENT_ID",
  SEED_MESSAGE_SENT_ID = "SEED_MESSAGE_SENT_ID",
}

export type MessageSentHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageSentHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `MessageSent` aggregates. */
export type MessageSentHavingInput = {
  AND?: InputMaybe<Array<MessageSentHavingInput>>;
  OR?: InputMaybe<Array<MessageSentHavingInput>>;
  average?: InputMaybe<MessageSentHavingAverageInput>;
  distinctCount?: InputMaybe<MessageSentHavingDistinctCountInput>;
  max?: InputMaybe<MessageSentHavingMaxInput>;
  min?: InputMaybe<MessageSentHavingMinInput>;
  stddevPopulation?: InputMaybe<MessageSentHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<MessageSentHavingStddevSampleInput>;
  sum?: InputMaybe<MessageSentHavingSumInput>;
  variancePopulation?: InputMaybe<MessageSentHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<MessageSentHavingVarianceSampleInput>;
};

export type MessageSentHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageSentHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageSentHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageSentHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageSentHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageSentHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MessageSentHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `MessageSent` */
export type MessageSentInput = {
  auditorUserToRecipientUserId?: InputMaybe<MessageSentRecipientUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  emailTemplate?: InputMaybe<MessageSentInputEmailTemplateType>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  messageCreatedToMessageId?: InputMaybe<MessageSentMessageIdFkeyInput>;
  messageId?: InputMaybe<Scalars["UUID"]["input"]>;
  messageSentToResponseToMessageSentId?: InputMaybe<ResponseToMessageSentIdMessageSentIdFkInput>;
  messageSentToSeedMessageSentId?: InputMaybe<SeedMessageSentIdMessageSentIdFkInput>;
  recipientUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  responseToMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  seedMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  sendEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum MessageSentInputEmailTemplateType {
  ONBOARD_AA_INTERNAL = "ONBOARD_AA_INTERNAL",
  ONBOARD_COMMERCIAL = "ONBOARD_COMMERCIAL",
  ONBOARD_INTERNAL = "ONBOARD_INTERNAL",
  ONBOARD_MDH = "ONBOARD_MDH",
}

/** Input for the nested mutation of `messageCreated` in the `MessageSentInput` mutation. */
export type MessageSentMessageIdFkeyInput = {
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectById?: InputMaybe<MessageCreatedMessageCreatedPkeyConnect>;
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MessageCreatedNodeIdConnect>;
  /** A `MessageCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<MessageSentMessageIdFkeyMessageCreatedCreateInput>;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateById?: InputMaybe<MessageCreatedOnMessageSentForMessageSentMessageIdFkeyUsingMessageCreatedPkeyUpdate>;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MessageSentOnMessageSentForMessageSentMessageIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `messageSent` in the `MessageCreatedInput` mutation. */
export type MessageSentMessageIdFkeyInverseInput = {
  /** The primary key(s) for `messageSent` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MessageSentMessageSentPkeyConnect>>;
  /** The primary key(s) for `messageSent` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MessageSentNodeIdConnect>>;
  /** A `MessageSentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MessageSentMessageIdFkeyMessageSentCreateInput>>;
  /** The primary key(s) and patch data for `messageSent` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MessageSentOnMessageSentForMessageSentMessageIdFkeyUsingMessageSentPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `messageSent` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<MessageCreatedOnMessageSentForMessageSentMessageIdFkeyNodeIdUpdate>
  >;
};

/** The `messageCreated` to be created by this mutation. */
export type MessageSentMessageIdFkeyMessageCreatedCreateInput = {
  auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
  documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  kind: MessageCreatedKind;
  message?: InputMaybe<Scalars["String"]["input"]>;
  messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
  senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
};

/** The `messageSent` to be created by this mutation. */
export type MessageSentMessageIdFkeyMessageSentCreateInput = {
  auditorUserToRecipientUserId?: InputMaybe<MessageSentRecipientUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  emailTemplate?: InputMaybe<MessageSentInputEmailTemplateType>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  messageCreatedToMessageId?: InputMaybe<MessageSentMessageIdFkeyInput>;
  messageSentToResponseToMessageSentId?: InputMaybe<ResponseToMessageSentIdMessageSentIdFkInput>;
  messageSentToSeedMessageSentId?: InputMaybe<SeedMessageSentIdMessageSentIdFkInput>;
  recipientUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  responseToMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  seedMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  sendEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The fields on `messageSent` to look up the row to connect. */
export type MessageSentMessageSentPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The globally unique `ID` look up for the row to connect. */
export type MessageSentNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `messageSent` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type MessageSentOnMessageSentForMessageSentMessageIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `messageCreated` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `messageCreated` being updated. */
  patch: MessageCreatedPatch;
};

/** The fields on `messageSent` to look up the row to update. */
export type MessageSentOnMessageSentForMessageSentMessageIdFkeyUsingMessageSentPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `messageSent` being updated. */
    patch: updateMessageSentOnMessageSentForMessageSentMessageIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type MessageSentOnMessageSentForMessageSentRecipientUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `messageSent` to look up the row to update. */
export type MessageSentOnMessageSentForMessageSentRecipientUserIdFkeyUsingMessageSentPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `messageSent` being updated. */
    patch: updateMessageSentOnMessageSentForMessageSentRecipientUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type MessageSentOnMessageSentForResponseToMessageSentIdMessageSentIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `messageSent` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `messageSent` being updated. */
    patch: MessageSentPatch;
  };

/** The fields on `messageSent` to look up the row to update. */
export type MessageSentOnMessageSentForResponseToMessageSentIdMessageSentIdFkUsingMessageSentPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `messageSent` being updated. */
    patch: updateMessageSentOnMessageSentForResponseToMessageSentIdMessageSentIdFkPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type MessageSentOnMessageSentForSeedMessageSentIdMessageSentIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `messageSent` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `messageSent` being updated. */
    patch: MessageSentPatch;
  };

/** The fields on `messageSent` to look up the row to update. */
export type MessageSentOnMessageSentForSeedMessageSentIdMessageSentIdFkUsingMessageSentPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `messageSent` being updated. */
    patch: updateMessageSentOnMessageSentForSeedMessageSentIdMessageSentIdFkPatch;
  };

/** Represents an update to a `MessageSent`. Fields that are set will be updated. */
export type MessageSentPatch = {
  auditorUserToRecipientUserId?: InputMaybe<MessageSentRecipientUserIdFkeyInput>;
  messageCreatedToMessageId?: InputMaybe<MessageSentMessageIdFkeyInput>;
  messageId?: InputMaybe<Scalars["UUID"]["input"]>;
  messageSentToResponseToMessageSentId?: InputMaybe<ResponseToMessageSentIdMessageSentIdFkInput>;
  messageSentToSeedMessageSentId?: InputMaybe<SeedMessageSentIdMessageSentIdFkInput>;
  recipientUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  responseToMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  seedMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `auditorUser` in the `MessageSentInput` mutation. */
export type MessageSentRecipientUserIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MessageSentOnMessageSentForMessageSentRecipientUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `messageSent` in the `AuditorUserInput` mutation. */
export type MessageSentRecipientUserIdFkeyInverseInput = {
  /** The primary key(s) for `messageSent` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MessageSentMessageSentPkeyConnect>>;
  /** The primary key(s) for `messageSent` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MessageSentNodeIdConnect>>;
  /** A `MessageSentInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<MessageSentRecipientUserIdFkeyMessageSentCreateInput>
  >;
  /** The primary key(s) and patch data for `messageSent` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MessageSentOnMessageSentForMessageSentRecipientUserIdFkeyUsingMessageSentPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `messageSent` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyNodeIdUpdate>
  >;
};

/** The `messageSent` to be created by this mutation. */
export type MessageSentRecipientUserIdFkeyMessageSentCreateInput = {
  auditorUserToRecipientUserId?: InputMaybe<MessageSentRecipientUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  emailTemplate?: InputMaybe<MessageSentInputEmailTemplateType>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  messageCreatedToMessageId?: InputMaybe<MessageSentMessageIdFkeyInput>;
  messageId?: InputMaybe<Scalars["UUID"]["input"]>;
  messageSentToResponseToMessageSentId?: InputMaybe<ResponseToMessageSentIdMessageSentIdFkInput>;
  messageSentToSeedMessageSentId?: InputMaybe<SeedMessageSentIdMessageSentIdFkInput>;
  responseToMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  seedMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  sendEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A filter to be used against many `MessageSent` object types. All fields are combined with a logical ‘and.’ */
export type MessageSentToManyMessageSentFilter = {
  /** Aggregates across related `MessageSent` match the filter criteria. */
  aggregates?: InputMaybe<MessageSentAggregatesFilter>;
  /** Every related `MessageSent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MessageSentFilter>;
  /** No related `MessageSent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MessageSentFilter>;
  /** Some related `MessageSent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MessageSentFilter>;
};

/** A connection to a list of `MessageSent` values. */
export type MessageSentsConnection = {
  __typename?: "MessageSentsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<MessageSentAggregates>;
  /** A list of edges which contains the `MessageSent` and cursor to aid in pagination. */
  edges: Array<MessageSentsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<MessageSentAggregates>>;
  /** A list of `MessageSent` objects. */
  nodes: Array<Maybe<MessageSent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MessageSent` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `MessageSent` values. */
export type MessageSentsConnectiongroupedAggregatesArgs = {
  groupBy: Array<MessageSentGroupBy>;
  having?: InputMaybe<MessageSentHavingInput>;
};

/** A `MessageSent` edge in the connection. */
export type MessageSentsEdge = {
  __typename?: "MessageSentsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `MessageSent` at the end of the edge. */
  node?: Maybe<MessageSent>;
};

/** Methods to use when ordering `MessageSent`. */
export enum MessageSentsOrderBy {
  AUDITOR_USER_BY_RECIPIENT_USER_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__EMAIL_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__EMAIL_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__EMAIL_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__EMAIL_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__ID_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__ID_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__ID_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__ID_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__TITLE_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__TITLE_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__TITLE_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__TITLE_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_RECIPIENT_USER_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_RECIPIENT_USER_ID__USER_TYPE_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__CREATED_AT_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__CREATED_AT_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__CREATED_AT_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__CREATED_AT_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__ID_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__ID_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__ID_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__ID_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__KIND_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__KIND_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__KIND_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__KIND_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__MESSAGE_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__MESSAGE_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__MESSAGE_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__MESSAGE_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__SENDER_USER_ID_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__SENDER_USER_ID_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__SENDER_USER_ID_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__SENDER_USER_ID_DESC",
  MESSAGE_ID_ASC = "MESSAGE_ID_ASC",
  MESSAGE_ID_DESC = "MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_AVERAGE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_COUNT_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_COUNT_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_COUNT_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_COUNT_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MAX_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_MIN_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_SUM_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID__COUNT_ASC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID__COUNT_ASC",
  MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID__COUNT_DESC = "MESSAGE_SENTS_BY_RESPONSE_TO_MESSAGE_SENT_ID__COUNT_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_AVERAGE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_COUNT_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_COUNT_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_COUNT_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_COUNT_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_CREATED_AT_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_CREATED_AT_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_DISTINCT_COUNT_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_CREATED_AT_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_CREATED_AT_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MAX_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_CREATED_AT_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_CREATED_AT_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_MIN_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_CREATED_AT_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_CREATED_AT_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_POPULATION_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_STDDEV_SAMPLE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_CREATED_AT_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_CREATED_AT_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_SUM_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_CREATED_AT_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_CREATED_AT_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_POPULATION_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_CREATED_AT_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_CREATED_AT_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_CREATED_AT_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_CREATED_AT_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RECIPIENT_USER_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID_VARIANCE_SAMPLE_SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID__COUNT_ASC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID__COUNT_ASC",
  MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID__COUNT_DESC = "MESSAGE_SENTS_BY_SEED_MESSAGE_SENT_ID__COUNT_DESC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__CREATED_AT_ASC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__CREATED_AT_ASC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__CREATED_AT_DESC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__CREATED_AT_DESC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__ID_ASC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__ID_ASC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__ID_DESC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__ID_DESC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__MESSAGE_ID_ASC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__MESSAGE_ID_ASC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__MESSAGE_ID_DESC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__MESSAGE_ID_DESC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__RECIPIENT_USER_ID_ASC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__RECIPIENT_USER_ID_ASC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__RECIPIENT_USER_ID_DESC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__RECIPIENT_USER_ID_DESC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENT_BY_RESPONSE_TO_MESSAGE_SENT_ID__SEED_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__CREATED_AT_ASC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__CREATED_AT_ASC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__CREATED_AT_DESC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__CREATED_AT_DESC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__ID_ASC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__ID_ASC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__ID_DESC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__ID_DESC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__MESSAGE_ID_ASC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__MESSAGE_ID_ASC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__MESSAGE_ID_DESC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__MESSAGE_ID_DESC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__RECIPIENT_USER_ID_ASC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__RECIPIENT_USER_ID_ASC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__RECIPIENT_USER_ID_DESC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__RECIPIENT_USER_ID_DESC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__RESPONSE_TO_MESSAGE_SENT_ID_ASC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__RESPONSE_TO_MESSAGE_SENT_ID_DESC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__SEED_MESSAGE_SENT_ID_ASC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__SEED_MESSAGE_SENT_ID_ASC",
  MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__SEED_MESSAGE_SENT_ID_DESC = "MESSAGE_SENT_BY_SEED_MESSAGE_SENT_ID__SEED_MESSAGE_SENT_ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  RECIPIENT_USER_ID_ASC = "RECIPIENT_USER_ID_ASC",
  RECIPIENT_USER_ID_DESC = "RECIPIENT_USER_ID_DESC",
  RESPONSE_TO_MESSAGE_SENT_ID_ASC = "RESPONSE_TO_MESSAGE_SENT_ID_ASC",
  RESPONSE_TO_MESSAGE_SENT_ID_DESC = "RESPONSE_TO_MESSAGE_SENT_ID_DESC",
  SEED_MESSAGE_SENT_ID_ASC = "SEED_MESSAGE_SENT_ID_ASC",
  SEED_MESSAGE_SENT_ID_DESC = "SEED_MESSAGE_SENT_ID_DESC",
}

/** Connection arguments for paginating through Messages. */
export type MessagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MessagesOrdering>>;
};

export type MessagesConnection = {
  __typename?: "MessagesConnection";
  edges: Array<MessagesEdge>;
  nodes: Array<Message>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type MessagesEdge = {
  __typename?: "MessagesEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Message;
};

export enum MessagesOrderField {
  CREATED_AT = "CREATED_AT",
  ID = "ID",
}

export type MessagesOrdering = {
  direction?: SortDirection;
  field: MessagesOrderField;
};

export type MoveCasesToQueueInput = {
  caseIds: Array<Scalars["ID"]["input"]>;
  queueId: Scalars["ID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: "Mutation";
  acceptAgentMessage: AgentMessage;
  appendDocumentState: DocumentStateEnum;
  archiveDirectory?: Maybe<Directory>;
  archiveFile?: Maybe<File>;
  askAutodorCreateSavedPrompt: AskAutodorCreateSavedPromptResponse;
  askAutodorDeleteSavedPrompt: Scalars["Boolean"]["output"];
  askAutodorResetSavedPromptTags: Scalars["Boolean"]["output"];
  /** Assign one or more batch claims to an audit group. */
  assignClaimsToAuditGroup: AssignClaimsToAuditGroupPayload;
  /**
   * ### Overview
   * DEPRECATED: Updates the status of a set of bucket claims specified.
   * Bucket claims are deprecated, and the application instead uses the workstation view to group sets of claims for application users.
   */
  bucketClaimsUpdateStatus?: Maybe<BucketClaimsUpdateStatusPayload>;
  confirmFileUploadSuccess: File;
  confirmFileUploadSuccessAlaffiaApp: Scalars["Boolean"]["output"];
  createAgentArtifact: AgentArtifact;
  createAgentArtifactTemplate: AgentArtifactTemplate;
  createAgentDemo: DemoAgentResult;
  createAgentDemoPreview: DemoAgentResult;
  createAgentMessageRecommendationRevision: AgentRecommendation;
  createAgentMessageRevision: AgentMessage;
  createAgentRecommendationRevision: AgentRecommendation;
  createAnnotationLabel: AnnotationLabel;
  createAskAutodorQueue: AskAutodorQueue;
  /** Creates a single `AuditFinding`. */
  createAuditFinding?: Maybe<CreateAuditFindingPayload>;
  /** Creates a single `AuditFindingReasonCode`. */
  createAuditFindingReasonCode?: Maybe<CreateAuditFindingReasonCodePayload>;
  /** Creates a single `AuditFindingReview`. */
  createAuditFindingReview?: Maybe<CreateAuditFindingReviewPayload>;
  createAuditStatus: AuditStatus;
  /** Creates a single `AuditorBucket`. */
  createAuditorBucket?: Maybe<CreateAuditorBucketPayload>;
  /** Creates a single `AuditorBucketAssignee`. */
  createAuditorBucketAssignee?: Maybe<CreateAuditorBucketAssigneePayload>;
  /** Creates a single `BatchClaimAppealed`. */
  createBatchClaimAppealed?: Maybe<CreateBatchClaimAppealedPayload>;
  /** Creates a single `BatchClaimAssignee`. */
  createBatchClaimAssignee?: Maybe<CreateBatchClaimAssigneePayload>;
  /** Creates a single `BatchClaimAuditStartDate`. */
  createBatchClaimAuditStartDate?: Maybe<CreateBatchClaimAuditStartDatePayload>;
  /** Creates a single `BatchClaimAuditType`. */
  createBatchClaimAuditType?: Maybe<CreateBatchClaimAuditTypePayload>;
  /** Creates a single `BatchClaimAuditor`. */
  createBatchClaimAuditor?: Maybe<CreateBatchClaimAuditorPayload>;
  /** Creates a single `BatchClaimClientRecoveryAmount`. */
  createBatchClaimClientRecoveryAmount?: Maybe<CreateBatchClaimClientRecoveryAmountPayload>;
  /** Creates a single `BatchClaimClientRecoveryCollectionDate`. */
  createBatchClaimClientRecoveryCollectionDate?: Maybe<CreateBatchClaimClientRecoveryCollectionDatePayload>;
  /**
   * Post a new comment on a BatchClaim. The author is the JWT user.
   * Body must be 1-1000 characters; whitespace-only is rejected.
   */
  createBatchClaimComment: BatchClaimComment;
  /** Creates a single `BatchClaimDocument`. */
  createBatchClaimDocument?: Maybe<CreateBatchClaimDocumentPayload>;
  /** Creates a single `BatchClaimDueDate`. */
  createBatchClaimDueDate?: Maybe<CreateBatchClaimDueDatePayload>;
  /** Creates a single `BatchClaimLineItem`. */
  createBatchClaimLineItem?: Maybe<CreateBatchClaimLineItemPayload>;
  /** Creates a single `BatchClaimLineItemAudit`. */
  createBatchClaimLineItemAudit?: Maybe<CreateBatchClaimLineItemAuditPayload>;
  /** Creates a single `BatchClaimLineItemNnIbLine`. */
  createBatchClaimLineItemNnIbLine?: Maybe<CreateBatchClaimLineItemNnIbLinePayload>;
  /** Creates a single `BatchClaimPayDeny`. */
  createBatchClaimPayDeny?: Maybe<CreateBatchClaimPayDenyPayload>;
  /** Creates a single `BatchClaimTechDenial`. */
  createBatchClaimTechDenial?: Maybe<CreateBatchClaimTechDenialPayload>;
  /** Creates a single `BucketClaim`. */
  createBucketClaim?: Maybe<CreateBucketClaimPayload>;
  createCase: Case;
  /** Creates a single `ClaimAuditGroup`. */
  createClaimAuditGroup?: Maybe<CreateClaimAuditGroupPayload>;
  /**
   * Post a comment on a ClaimAuditGroup as the JWT user (admin or auditor).
   * Body must be non-blank and at most 1000 characters.
   */
  createClaimAuditGroupComment: CreateClaimAuditGroupCommentPayload;
  /** Creates a single `ClientSignOffClaimState`. */
  createClientSignOffClaimState?: Maybe<CreateClientSignOffClaimStatePayload>;
  createDirectory: Directory;
  /** Creates a single `DisputedFinding`. */
  createDisputedFinding?: Maybe<CreateDisputedFindingPayload>;
  /**
   * ### Overview
   * Bulk Inserts on v3.disputed_finding for the set of batch_claim_ids passed.
   * Writable by admin_role, auditor_role (via setClaimDisputed), and provider_role
   * (table GRANTs). Each call appends a row; deleted=true clears Disputed for the
   * claim (latest row wins via cache.batch_claim_disputed_finding_claim_state).
   */
  createDisputedFindings?: Maybe<CreateDisputedFindingsPayload>;
  /** Creates a single `DocumentRequestCreated`. */
  createDocumentRequestCreated?: Maybe<CreateDocumentRequestCreatedPayload>;
  /** Creates a single `DocumentUploadCreated`. */
  createDocumentUploadCreated?: Maybe<CreateDocumentUploadCreatedPayload>;
  /** Creates a single `DocumentationClaimState`. */
  createDocumentationClaimState?: Maybe<CreateDocumentationClaimStatePayload>;
  /**
   * ## Overview
   * Inserts records into document_request_created for an array of batch_claim. Triggers an update of batch_claim_state.documentation_claim_state by calling function t2_update_cache_document_claim_state_on_doc_req
   */
  createDocumentationRequests?: Maybe<CreateDocumentationRequestsPayload>;
  /** Creates a single `DocumentationSelectionSet`. */
  createDocumentationSelectionSet?: Maybe<CreateDocumentationSelectionSetPayload>;
  /** Create a new facet (admin only) */
  createFacet?: Maybe<Facet>;
  /** Create a new facet keyword (admin only) */
  createFacetKeyword?: Maybe<FacetKeyword>;
  createFileAiAnnotation: FileAiAnnotation;
  createFileAnnotation: FileUserAnnotation;
  createIbLineFindings: CreateAuditFindingsPayload;
  /**
   * V2 of createIbLineFindings - uses batch SQL INSERTs for improved performance.
   * Same interface as V1 for backwards compatibility.
   */
  createIbLineFindingsV2: CreateIbLineFindingsOutputV2;
  /** Creates a single `InsurerUser`. */
  createInsurerUser?: Maybe<CreateInsurerUserPayload>;
  /** Creates a single `InvoiceClaimState`. */
  createInvoiceClaimState?: Maybe<CreateInvoiceClaimStatePayload>;
  createLifecycleRole: LifecycleRole;
  /** Creates a single `MessageCreated`. */
  createMessageCreated?: Maybe<CreateMessageCreatedPayload>;
  /** Creates a single `MessageSent`. */
  createMessageSent?: Maybe<CreateMessageSentPayload>;
  /** Creates a single `NegotiationClaimState`. */
  createNegotiationClaimState?: Maybe<CreateNegotiationClaimStatePayload>;
  /** Creates a single `NnIbLine`. */
  createNnIbLine?: Maybe<CreateNnIbLinePayload>;
  /** Creates a single `OnHoldClaimState`. */
  createOnHoldClaimState?: Maybe<CreateOnHoldClaimStatePayload>;
  /** Creates a single `ProviderSignOffClaimState`. */
  createProviderSignOffClaimState?: Maybe<CreateProviderSignOffClaimStatePayload>;
  /** Creates a single `ProviderUserFacility`. */
  createProviderUserFacility?: Maybe<CreateProviderUserFacilityPayload>;
  /** Creates a single `QaClaimStateRow`. */
  createQaClaimStateRow?: Maybe<CreateQaClaimStateRowPayload>;
  /** Creates a single `Queue`. */
  createQueue?: Maybe<CreateQueuePayload>;
  /**
   * # Overview
   * Creates the reported claim entries to track reporting of a batch of claims received as input.
   * This routine is called by the report service primarily, mirroring the pattern used for reporting audit findings.
   * Therefore, generally the only caller of this function should be the report service using the reporter role in the database, at report generation time.
   */
  createReportedClaims?: Maybe<CreateReportedClaimsPayload>;
  /**
   * ### Overview
   * Inserts an array of reported findings into the reported findings table.
   */
  createReportedFindings?: Maybe<CreateReportedFindingsPayload>;
  /** Creates a single `ReviewedAuditFinding`. */
  createReviewedAuditFinding?: Maybe<CreateReviewedAuditFindingPayload>;
  /** Creates a single `S3AuditDocumentation`. */
  createS3AuditDocumentation?: Maybe<CreateS3AuditDocumentationPayload>;
  /** Creates a single `SsoDomainIdentityProvider`. */
  createSsoDomainIdentityProvider?: Maybe<CreateSsoDomainIdentityProviderPayload>;
  createUbClaimFindings: CreateAuditFindingsPayload;
  createUbClaimLineFindings: CreateAuditFindingsPayload;
  createUser: CreateUserOutput;
  /** Creates a single `UserInviteCreated`. */
  createUserInviteCreated?: Maybe<CreateUserInviteCreatedPayload>;
  /** Creates a single `WorkflowClaimState`. */
  createWorkflowClaimState?: Maybe<CreateWorkflowClaimStatePayload>;
  declineFindingsByIBLineItemIds: DeclineFindingsByIBLineItemIdsPayload;
  deleteAgent: Agent;
  deleteAskAutodorQueue?: Maybe<AskAutodorQueue>;
  deleteAuditStatus?: Maybe<AuditStatus>;
  /** Deletes a single `AuditorBucket` using a unique key. */
  deleteAuditorBucket?: Maybe<DeleteAuditorBucketPayload>;
  /** Deletes a single `AuditorBucket` using its globally unique id. */
  deleteAuditorBucketByNodeId?: Maybe<DeleteAuditorBucketPayload>;
  /** Deletes a single `BatchClaimAppealed` using a unique key. */
  deleteBatchClaimAppealed?: Maybe<DeleteBatchClaimAppealedPayload>;
  /** Deletes a single `BatchClaimAppealed` using a unique key. */
  deleteBatchClaimAppealedByBatchClaimId?: Maybe<DeleteBatchClaimAppealedPayload>;
  /** Deletes a single `BatchClaimAppealed` using its globally unique id. */
  deleteBatchClaimAppealedByNodeId?: Maybe<DeleteBatchClaimAppealedPayload>;
  /** Deletes a single `BatchClaimTechDenial` using a unique key. */
  deleteBatchClaimTechDenial?: Maybe<DeleteBatchClaimTechDenialPayload>;
  /** Deletes a single `BatchClaimTechDenial` using a unique key. */
  deleteBatchClaimTechDenialByBatchClaimId?: Maybe<DeleteBatchClaimTechDenialPayload>;
  /** Deletes a single `BatchClaimTechDenial` using its globally unique id. */
  deleteBatchClaimTechDenialByNodeId?: Maybe<DeleteBatchClaimTechDenialPayload>;
  deleteCase?: Maybe<Case>;
  /** Deletes a single `ClaimAuditGroup` using a unique key. */
  deleteClaimAuditGroup?: Maybe<DeleteClaimAuditGroupPayload>;
  /** Deletes a single `ClaimAuditGroup` using a unique key. */
  deleteClaimAuditGroupByName?: Maybe<DeleteClaimAuditGroupPayload>;
  /** Deletes a single `ClaimAuditGroup` using its globally unique id. */
  deleteClaimAuditGroupByNodeId?: Maybe<DeleteClaimAuditGroupPayload>;
  deleteDirectory?: Maybe<Directory>;
  /**
   * # Overview
   * Inserts records into document_upload_created for an array of batch_claim, with deleted=true
   */
  deleteDocumentationRequests?: Maybe<DeleteDocumentationRequestsPayload>;
  deleteFile?: Maybe<File>;
  deleteFileAnnotation: Scalars["Boolean"]["output"];
  /**
   * Called when a rule or agent is unpublished.
   * Soft deletes suggested findings the automation authored.
   */
  deleteFindingsByAutomationSource: DeleteFindingsByAutomationSourcePayload;
  /**
   * ##Overview
   * Deletes s3_audit_documentation cache records given an array of s3Keys
   */
  deleteKeysFromS3Cache?: Maybe<DeleteKeysFromS3CachePayload>;
  deleteLifecycleRole: LifecycleRole;
  /** Deletes a single `ProviderUserFacility` using a unique key. */
  deleteProviderUserFacility?: Maybe<DeleteProviderUserFacilityPayload>;
  /** Deletes a single `ProviderUserFacility` using its globally unique id. */
  deleteProviderUserFacilityByNodeId?: Maybe<DeleteProviderUserFacilityPayload>;
  /** Deletes a single `ProviderUserFacility` using a unique key. */
  deleteProviderUserFacilityByProviderIdAndAuditorUserId?: Maybe<DeleteProviderUserFacilityPayload>;
  /** Deletes a single `SsoDomainIdentityProvider` using a unique key. */
  deleteSsoDomainIdentityProvider?: Maybe<DeleteSsoDomainIdentityProviderPayload>;
  /** Deletes a single `SsoDomainIdentityProvider` using a unique key. */
  deleteSsoDomainIdentityProviderByDomainAndEnvironmentAndTenantId?: Maybe<DeleteSsoDomainIdentityProviderPayload>;
  /** Deletes a single `SsoDomainIdentityProvider` using its globally unique id. */
  deleteSsoDomainIdentityProviderByNodeId?: Maybe<DeleteSsoDomainIdentityProviderPayload>;
  deleteStageTrackerBlocker: StageTracker;
  duplicateLifecycleRole: LifecycleRole;
  editAuditorUser: AuditorUser;
  generateDocRequestReport?: Maybe<Scalars["Boolean"]["output"]>;
  generateReport: GenerateReportResponse;
  moveCasesToQueue: Array<Case>;
  onboardUser: OnboardUserOutput;
  openStageTrackerBlocker: StageTracker;
  prepareFileForUpload: PrepareFileForUploadResult;
  prompt: Message;
  ratePromptResponse: PromptResponse;
  /**
   * ## Overview
   * Refreshes the audit documentation cache table for either a provider id, or a specific claim for that provider.
   * Audit documentation is populated in our s3 schema our foreign data wrapper.
   * The foreign data wrapper re-fetches each row in the table at query time, leading to very slow query times.
   * Our cache is a copy of the s3.audit_documentation table into the v3 schema to enable faster query access patterns there.
   * Certain events, like an application user uploading new audit documentation may automatically trigger or call this function.
   * Pass force_refresh as true in the input arguments if you must guarantee a refresh.
   * Caution: the column ordering matters in the select call, as it dictates the column mapping in the cached table.
   */
  refreshS3AuditDocumentation?: Maybe<RefreshS3AuditDocumentationPayload>;
  reviewAuditFindings: ReviewAuditFindingsPayload;
  /**
   * Bulk accept / decline / delete of audit findings. One INSERT
   * (or one UPDATE for DELETE) for the whole batch, rather than N
   * nested updateAuditFinding mutations.
   */
  reviewAuditFindingsV2: ReviewAuditFindingsV2Payload;
  s3CreateObjectHandler?: Maybe<S3CreateObjectHandlerResponse>;
  s3DataImport: Scalars["Boolean"]["output"];
  saveCasesAsQueue: AskAutodorQueue;
  saveClaimRoleAssignments: SaveClaimRoleAssignmentsResult;
  saveRolePermissionMatrix: RolePermissionMatrix;
  scheduleAgentFlowRun: Scalars["Boolean"]["output"];
  sendClaimReportsToClient: Array<Report>;
  sendDocumentUploadNotification: NotificationResponse;
  sendUserOnboardNotification: NotificationResponse;
  /**
   * ### Overview
   * Bulk Inserts on v3.batch_claim_assignee for the set of batch_claim_ids passed
   */
  setAssignees?: Maybe<SetAssigneesPayload>;
  /**
   * ### Overview
   * Bulk Inserts on batch_claim_audit_start_date for the set of batch_claim_ids and date passed.
   *
   * Parameters:
   * - batch_claim_ids: Array of batch claim UUIDs
   * - audit_start_date: The audit start date to set (or NULL to mark existing dates as deleted)
   *
   * Behavior:
   * - If audit_start_date IS NULL: marks existing audit start dates as deleted for the provided batch_claim_ids
   * - If audit_start_date IS NOT NULL: sets the same audit_start_date for all provided batch_claim_ids
   */
  setAuditStartDates?: Maybe<SetAuditStartDatesPayload>;
  setClaimAppealed: Array<BatchClaim>;
  setClaimAuditTypes: Array<BatchClaim>;
  setClaimAuditors: Array<BatchClaim>;
  setClaimDisputed: Array<BatchClaim>;
  setClaimLifecycleStage: BatchClaim;
  setClaimQaStates: Array<BatchClaim>;
  /**
   * Sets the claim lifecycle phase and stage for the given stage id.
   * Requires DB role allowed to execute set_claim_facet (admin / auditor).
   */
  setClaimStage: Array<BatchClaim>;
  setClaimTechDenials: Array<BatchClaim>;
  /**
   * ### Overview
   * Bulk inserts on batch_claim_client_recovery_amount for the set of batch_claim_ids and amount passed.
   *
   * Parameters:
   * - batch_claim_ids: Array of batch claim UUIDs
   * - client_recovery_amount: The recovery amount to set or NULL to mark existing amounts as deleted
   *
   * Behavior:
   * - If client_recovery_amount IS NULL: marks existing recovery amounts as deleted for the provided batch_claim_ids
   * - If client_recovery_amount IS NOT NULL: sets the same recovery amount for all provided batch_claim_ids
   */
  setClientRecoveryAmounts?: Maybe<SetClientRecoveryAmountsPayload>;
  /**
   * ### Overview
   * Bulk inserts on batch_claim_client_recovery_collection_date for the set of batch_claim_ids and date passed.
   *
   * Parameters:
   * - batch_claim_ids: Array of batch claim UUIDs
   * - client_recovery_collection_date: The collection date to set (or NULL to mark existing dates as deleted)
   *
   * Behavior:
   * - If client_recovery_collection_date IS NULL: marks existing collection dates as deleted for the provided batch_claim_ids
   * - If client_recovery_collection_date IS NOT NULL: sets the same collection date for all provided batch_claim_ids
   */
  setClientRecoveryCollectionDates?: Maybe<SetClientRecoveryCollectionDatesPayload>;
  /**
   * ### Overview
   * Bulk Inserts on v3.client_sign_off_claim_state for the set of batch_claim_ids passed
   */
  setClientSignOffClaimStates?: Maybe<SetClientSignOffClaimStatesPayload>;
  /**
   * ### Overview
   * Bulk inserts on v3.documentation_claim_state for the set of batch_claim_ids passed.
   * Exposed by postgraphile as the `setDocumentationClaimStates` mutation. Writable by
   * admin_role, auditor_role, and developer_role (RLS INSERT policies + table GRANTs).
   * NO_REQUESTS, AWAITING_UPLOAD, DOCUMENTS_RECEIVED, and PROCESSING_ISSUE are accepted
   * (enforced by a CHECK constraint on the history table).
   */
  setDocumentationClaimStates?: Maybe<SetDocumentationClaimStatesPayload>;
  /**
   * ### Overview
   * Bulk Inserts on batch_claim_due_date for the set of batch_claim_ids and dates passed
   */
  setDueDates?: Maybe<SetDueDatesPayload>;
  /**
   * Set the status of one or more findings to ACCEPTED or DECLINED.
   * For each finding whose current status differs from the requested
   * one, appends a new reviewed_audit_finding row (preserving the
   * audit trail). Findings already at the requested status are a
   * no-op unless a rationale is supplied — see SetFindingStatusInput.
   *
   * When status is ACCEPTED, any prior accepted finding on the same
   * IB line as a transitioning finding is auto-declined in the same
   * transaction. Findings in the input list are never themselves
   * auto-declined, so a re-accept of an already-accepted finding
   * leaves it untouched.
   */
  setFindingStatus: SetFindingStatusPayload;
  /**
   * ### Overview
   * Bulk Inserts on v3.invoice_claim_state for the set of batch_claim_ids passed
   */
  setInvoiceClaimStates?: Maybe<SetInvoiceClaimStatesPayload>;
  /**
   * Admin-only: configure next recommended stage and optional shortcut
   * suggestions for a lifecycle catalog stage (product matrix).
   */
  setLifecycleStageRecommendation: LifecycleStageRecommendation;
  /**
   * ### Overview
   * Bulk Inserts on v3.negotiation_claim_state for the set of batch_claim_ids passed
   */
  setNegotiationClaimStates?: Maybe<SetNegotiationClaimStatesPayload>;
  /**
   * ### Overview
   * Bulk Inserts on v3.on_hold_claim_state for the set of batch_claim_ids passed
   */
  setOnHoldClaimStates?: Maybe<SetOnHoldClaimStatesPayload>;
  /**
   * Designates the given document as the primary medical record for the
   * batch claim. If another document on the same claim is already marked
   * primary, it is unset in the same transaction so the invariant of at
   * most one primary per claim is preserved.
   *
   * Errors if the document is not already attached to the claim (no row
   * exists in v3.batch_claim_document for the pair).
   */
  setPrimaryMedicalRecord: File;
  /**
   * ### Overview
   * Bulk Inserts on v3.provider_sign_off_claim_state for the set of batch_claim_ids passed
   */
  setProviderSignOffClaimStates?: Maybe<SetProviderSignOffClaimStatesPayload>;
  /**
   * ### Overview
   * Bulk Inserts on v3.qa_claim_state for the set of batch_claim_ids passed
   */
  setQaClaimStates?: Maybe<SetQaClaimStatesPayload>;
  setStageTrackerBlockerSegment: StageTracker;
  setUserMfaPreference: UserMfaPreferenceResponse;
  /**
   * ### Overview
   * Bulk Inserts on v3.workflow_claim_state for the set of batch_claim_ids passed
   */
  setWorkflowClaimStates?: Maybe<SetWorkflowClaimStatesPayload>;
  /**
   * Soft-delete a comment. Allowed for the original author or any
   * admin (moderation). One-way: deleted comments cannot be restored
   * and are filtered from the listing. Returns the deleted row with
   * deletedAt + deletedBy populated.
   */
  softDeleteBatchClaimComment: BatchClaimComment;
  /**
   * Remove one or more claims from an audit group. Scoped: only
   * rows whose current `claimAuditGroupId` matches the input are
   * removed (concurrent-modification safety). Idempotent — claims
   * not in the target group are silent no-ops.
   */
  unassignClaimsFromAuditGroup: ClaimAuditGroup;
  unsetAgentMessageUserValidation: AgentMessage;
  updateAskAutodorQueue?: Maybe<AskAutodorQueue>;
  /** Updates a single `AuditFinding` using a unique key and a patch. */
  updateAuditFinding?: Maybe<UpdateAuditFindingPayload>;
  /** Updates a single `AuditFinding` using its globally unique id and a patch. */
  updateAuditFindingByNodeId?: Maybe<UpdateAuditFindingPayload>;
  /** Updates a single `AuditFindingReasonCode` using a unique key and a patch. */
  updateAuditFindingReasonCode?: Maybe<UpdateAuditFindingReasonCodePayload>;
  /** Updates a single `AuditFindingReasonCode` using its globally unique id and a patch. */
  updateAuditFindingReasonCodeByNodeId?: Maybe<UpdateAuditFindingReasonCodePayload>;
  updateAuditStatus: AuditStatus;
  updateAuditStatuses: Array<AuditStatus>;
  /** Updates a single `AuditorBucket` using a unique key and a patch. */
  updateAuditorBucket?: Maybe<UpdateAuditorBucketPayload>;
  /** Updates a single `AuditorBucket` using its globally unique id and a patch. */
  updateAuditorBucketByNodeId?: Maybe<UpdateAuditorBucketPayload>;
  /** Updates a single `BatchClaimAppealed` using a unique key and a patch. */
  updateBatchClaimAppealed?: Maybe<UpdateBatchClaimAppealedPayload>;
  /** Updates a single `BatchClaimAppealed` using a unique key and a patch. */
  updateBatchClaimAppealedByBatchClaimId?: Maybe<UpdateBatchClaimAppealedPayload>;
  /** Updates a single `BatchClaimAppealed` using its globally unique id and a patch. */
  updateBatchClaimAppealedByNodeId?: Maybe<UpdateBatchClaimAppealedPayload>;
  /** Updates a single `BatchClaimAuditType` using a unique key and a patch. */
  updateBatchClaimAuditType?: Maybe<UpdateBatchClaimAuditTypePayload>;
  /** Updates a single `BatchClaimAuditType` using a unique key and a patch. */
  updateBatchClaimAuditTypeByBatchClaimId?: Maybe<UpdateBatchClaimAuditTypePayload>;
  /** Updates a single `BatchClaimAuditType` using its globally unique id and a patch. */
  updateBatchClaimAuditTypeByNodeId?: Maybe<UpdateBatchClaimAuditTypePayload>;
  /**
   * Edit the body of a comment. Author-only: callers can only edit
   * comments they wrote. Body must be 1-1000 characters;
   * whitespace-only is rejected.
   */
  updateBatchClaimComment: BatchClaimComment;
  /** Updates a single `BatchClaimDocument` using a unique key and a patch. */
  updateBatchClaimDocument?: Maybe<UpdateBatchClaimDocumentPayload>;
  /** Updates a single `BatchClaimDocument` using a unique key and a patch. */
  updateBatchClaimDocumentByBatchClaimIdAndDocumentId?: Maybe<UpdateBatchClaimDocumentPayload>;
  /** Updates a single `BatchClaimDocument` using a unique key and a patch. */
  updateBatchClaimDocumentByBatchClaimIdAndIsPrimaryMedicalRecord?: Maybe<UpdateBatchClaimDocumentPayload>;
  /** Updates a single `BatchClaimDocument` using its globally unique id and a patch. */
  updateBatchClaimDocumentByNodeId?: Maybe<UpdateBatchClaimDocumentPayload>;
  /** Updates a single `BatchClaimLineItem` using a unique key and a patch. */
  updateBatchClaimLineItem?: Maybe<UpdateBatchClaimLineItemPayload>;
  /** Updates a single `BatchClaimLineItem` using its globally unique id and a patch. */
  updateBatchClaimLineItemByNodeId?: Maybe<UpdateBatchClaimLineItemPayload>;
  /** Updates a single `BatchClaimLineItemNnIbLine` using a unique key and a patch. */
  updateBatchClaimLineItemNnIbLine?: Maybe<UpdateBatchClaimLineItemNnIbLinePayload>;
  /** Updates a single `BatchClaimLineItemNnIbLine` using a unique key and a patch. */
  updateBatchClaimLineItemNnIbLineByBatchClaimLineItemIdAndNnIbLineId?: Maybe<UpdateBatchClaimLineItemNnIbLinePayload>;
  /** Updates a single `BatchClaimLineItemNnIbLine` using its globally unique id and a patch. */
  updateBatchClaimLineItemNnIbLineByNodeId?: Maybe<UpdateBatchClaimLineItemNnIbLinePayload>;
  /** Updates a single `BatchClaimPayDeny` using a unique key and a patch. */
  updateBatchClaimPayDeny?: Maybe<UpdateBatchClaimPayDenyPayload>;
  /** Updates a single `BatchClaimPayDeny` using a unique key and a patch. */
  updateBatchClaimPayDenyByBatchClaimId?: Maybe<UpdateBatchClaimPayDenyPayload>;
  /** Updates a single `BatchClaimPayDeny` using its globally unique id and a patch. */
  updateBatchClaimPayDenyByNodeId?: Maybe<UpdateBatchClaimPayDenyPayload>;
  /** Updates a single `BatchClaimTechDenial` using a unique key and a patch. */
  updateBatchClaimTechDenial?: Maybe<UpdateBatchClaimTechDenialPayload>;
  /** Updates a single `BatchClaimTechDenial` using a unique key and a patch. */
  updateBatchClaimTechDenialByBatchClaimId?: Maybe<UpdateBatchClaimTechDenialPayload>;
  /** Updates a single `BatchClaimTechDenial` using its globally unique id and a patch. */
  updateBatchClaimTechDenialByNodeId?: Maybe<UpdateBatchClaimTechDenialPayload>;
  /**
   * # Overview
   * Recalculates the computed values for a claim line in response to the strategy used by a batch claim being updated.
   * This function is not directly a trigger function, as the trigger function that calls this function is on the batch claim table.
   */
  updateBclComputationsFromComputationStrategy?: Maybe<UpdateBclComputationsFromComputationStrategyPayload>;
  /**
   * # Overview
   * Recalculates the computed values for a claim line item in response to the strategy used by a batch claim being updated.
   * This function is not directly a trigger function, as the trigger function that calls this function is on the batch claim table.
   */
  updateBcliComputationsFromComputationStrategy?: Maybe<UpdateBcliComputationsFromComputationStrategyPayload>;
  /** Updates a single `BucketClaim` using a unique key and a patch. */
  updateBucketClaim?: Maybe<UpdateBucketClaimPayload>;
  /** Updates a single `BucketClaim` using a unique key and a patch. */
  updateBucketClaimByBatchClaimId?: Maybe<UpdateBucketClaimPayload>;
  /** Updates a single `BucketClaim` using a unique key and a patch. */
  updateBucketClaimByBatchClaimIdAndAuditorBucketId?: Maybe<UpdateBucketClaimPayload>;
  /** Updates a single `BucketClaim` using its globally unique id and a patch. */
  updateBucketClaimByNodeId?: Maybe<UpdateBucketClaimPayload>;
  updateCase: Case;
  /** Updates a single `ClaimAuditGroup` using a unique key and a patch. */
  updateClaimAuditGroup?: Maybe<UpdateClaimAuditGroupPayload>;
  /** Updates a single `ClaimAuditGroup` using a unique key and a patch. */
  updateClaimAuditGroupByName?: Maybe<UpdateClaimAuditGroupPayload>;
  /** Updates a single `ClaimAuditGroup` using its globally unique id and a patch. */
  updateClaimAuditGroupByNodeId?: Maybe<UpdateClaimAuditGroupPayload>;
  updateDirectory?: Maybe<Directory>;
  /** Update a facet (admin only) */
  updateFacet?: Maybe<Facet>;
  /** Update a facet keyword (admin only) */
  updateFacetKeyword?: Maybe<FacetKeyword>;
  updateFile?: Maybe<File>;
  /**
   * Apply a uniform patch to multiple findings, creating versioned
   * successors. All-or-nothing transaction. Trusts the caller to
   * have grouped findings by identical patch values; the backend
   * does not enforce homogeneity. RLS-filtered: a finding the
   * caller can't see is treated as missing.
   */
  updateFindings: UpdateFindingsPayload;
  updateLifecycleRole: LifecycleRole;
  /** Updates a single `NnIbLine` using a unique key and a patch. */
  updateNnIbLine?: Maybe<UpdateNnIbLinePayload>;
  /** Updates a single `NnIbLine` using a unique key and a patch. */
  updateNnIbLineByFingerprintAndS3Key?: Maybe<UpdateNnIbLinePayload>;
  /** Updates a single `NnIbLine` using its globally unique id and a patch. */
  updateNnIbLineByNodeId?: Maybe<UpdateNnIbLinePayload>;
  /** Updates a single `ProviderUserFacility` using a unique key and a patch. */
  updateProviderUserFacility?: Maybe<UpdateProviderUserFacilityPayload>;
  /** Updates a single `ProviderUserFacility` using its globally unique id and a patch. */
  updateProviderUserFacilityByNodeId?: Maybe<UpdateProviderUserFacilityPayload>;
  /** Updates a single `ProviderUserFacility` using a unique key and a patch. */
  updateProviderUserFacilityByProviderIdAndAuditorUserId?: Maybe<UpdateProviderUserFacilityPayload>;
  /** Updates a single `Queue` using a unique key and a patch. */
  updateQueue?: Maybe<UpdateQueuePayload>;
  /** Updates a single `Queue` using its globally unique id and a patch. */
  updateQueueByNodeId?: Maybe<UpdateQueuePayload>;
  /** Updates a single `ReviewedAuditFinding` using a unique key and a patch. */
  updateReviewedAuditFinding?: Maybe<UpdateReviewedAuditFindingPayload>;
  /** Updates a single `ReviewedAuditFinding` using its globally unique id and a patch. */
  updateReviewedAuditFindingByNodeId?: Maybe<UpdateReviewedAuditFindingPayload>;
  /** Updates a single `S3AuditDocumentation` using a unique key and a patch. */
  updateS3AuditDocumentation?: Maybe<UpdateS3AuditDocumentationPayload>;
  /** Updates a single `S3AuditDocumentation` using its globally unique id and a patch. */
  updateS3AuditDocumentationByNodeId?: Maybe<UpdateS3AuditDocumentationPayload>;
  /** Updates a single `SsoDomainIdentityProvider` using a unique key and a patch. */
  updateSsoDomainIdentityProvider?: Maybe<UpdateSsoDomainIdentityProviderPayload>;
  /** Updates a single `SsoDomainIdentityProvider` using a unique key and a patch. */
  updateSsoDomainIdentityProviderByDomainAndEnvironmentAndTenantId?: Maybe<UpdateSsoDomainIdentityProviderPayload>;
  /** Updates a single `SsoDomainIdentityProvider` using its globally unique id and a patch. */
  updateSsoDomainIdentityProviderByNodeId?: Maybe<UpdateSsoDomainIdentityProviderPayload>;
  updateUserProfile?: Maybe<Scalars["Boolean"]["output"]>;
  upsertAutomationAuthor: UpsertAutomationAuthorPayload;
  versionAuditFindings: CreateAuditFindingsPayload;
  versionReport: GenerateReportResponse;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationacceptAgentMessageArgs = {
  agentMessageId: Scalars["UUID"]["input"];
  revisionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationappendDocumentStateArgs = {
  input: DocumentStateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationarchiveDirectoryArgs = {
  id: Scalars["ID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationarchiveFileArgs = {
  id: Scalars["ID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationaskAutodorCreateSavedPromptArgs = {
  input: AskAutodorCreateSavedPromptInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationaskAutodorDeleteSavedPromptArgs = {
  input: AskAutodorDeleteSavedPromptInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationaskAutodorResetSavedPromptTagsArgs = {
  input?: InputMaybe<AskAutodorSavedPromptsNewTagsInput>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationassignClaimsToAuditGroupArgs = {
  input: AssignClaimsToAuditGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationbucketClaimsUpdateStatusArgs = {
  input: BucketClaimsUpdateStatusInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationconfirmFileUploadSuccessArgs = {
  input: ConfirmFileUploadSuccessInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationconfirmFileUploadSuccessAlaffiaAppArgs = {
  input: ConfirmFileUploadSuccessInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAgentArtifactArgs = {
  input: CreateAgentArtifactInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAgentArtifactTemplateArgs = {
  input: CreateAgentArtifactTemplateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAgentDemoArgs = {
  input: DemoAgentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAgentDemoPreviewArgs = {
  previewAgentInput: DemoPreviewAgentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAgentMessageRecommendationRevisionArgs = {
  agentMessageId: Scalars["UUID"]["input"];
  input: AgentRecommendationRevisionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAgentMessageRevisionArgs = {
  agentMessageId: Scalars["UUID"]["input"];
  input: AgentMessageRevisionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAgentRecommendationRevisionArgs = {
  agentId: Scalars["ID"]["input"];
  input: AgentRecommendationRevisionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAnnotationLabelArgs = {
  input: CreateAnnotationLabelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAskAutodorQueueArgs = {
  input: CreateAskAutodorQueueInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAuditFindingArgs = {
  input: CreateAuditFindingInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAuditFindingReasonCodeArgs = {
  input: CreateAuditFindingReasonCodeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAuditFindingReviewArgs = {
  input: CreateAuditFindingReviewInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAuditStatusArgs = {
  input: CreateAuditStatusInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAuditorBucketArgs = {
  input: CreateAuditorBucketInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateAuditorBucketAssigneeArgs = {
  input: CreateAuditorBucketAssigneeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimAppealedArgs = {
  input: CreateBatchClaimAppealedInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimAssigneeArgs = {
  input: CreateBatchClaimAssigneeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimAuditStartDateArgs = {
  input: CreateBatchClaimAuditStartDateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimAuditTypeArgs = {
  input: CreateBatchClaimAuditTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimAuditorArgs = {
  input: CreateBatchClaimAuditorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimClientRecoveryAmountArgs = {
  input: CreateBatchClaimClientRecoveryAmountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimClientRecoveryCollectionDateArgs = {
  input: CreateBatchClaimClientRecoveryCollectionDateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimCommentArgs = {
  batchClaimId: Scalars["UUID"]["input"];
  body: Scalars["String"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimDocumentArgs = {
  input: CreateBatchClaimDocumentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimDueDateArgs = {
  input: CreateBatchClaimDueDateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimLineItemArgs = {
  input: CreateBatchClaimLineItemInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimLineItemAuditArgs = {
  input: CreateBatchClaimLineItemAuditInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimLineItemNnIbLineArgs = {
  input: CreateBatchClaimLineItemNnIbLineInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimPayDenyArgs = {
  input: CreateBatchClaimPayDenyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBatchClaimTechDenialArgs = {
  input: CreateBatchClaimTechDenialInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateBucketClaimArgs = {
  input: CreateBucketClaimInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateCaseArgs = {
  input: CreateCaseInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateClaimAuditGroupArgs = {
  input: CreateClaimAuditGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateClaimAuditGroupCommentArgs = {
  input: CreateClaimAuditGroupCommentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateClientSignOffClaimStateArgs = {
  input: CreateClientSignOffClaimStateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateDirectoryArgs = {
  input: CreateDirectoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateDisputedFindingArgs = {
  input: CreateDisputedFindingInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateDisputedFindingsArgs = {
  input: CreateDisputedFindingsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateDocumentRequestCreatedArgs = {
  input: CreateDocumentRequestCreatedInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateDocumentUploadCreatedArgs = {
  input: CreateDocumentUploadCreatedInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateDocumentationClaimStateArgs = {
  input: CreateDocumentationClaimStateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateDocumentationRequestsArgs = {
  input: CreateDocumentationRequestsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateDocumentationSelectionSetArgs = {
  input: CreateDocumentationSelectionSetInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateFacetArgs = {
  input: CreateFacetInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateFacetKeywordArgs = {
  input: CreateFacetKeywordInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateFileAiAnnotationArgs = {
  input: CreateFileAiAnnotationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateFileAnnotationArgs = {
  fileId: Scalars["ID"]["input"];
  input: CreateFileAnnotationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateIbLineFindingsArgs = {
  input: CreateIbLineFindingsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateIbLineFindingsV2Args = {
  input: CreateIbLineFindingsInputV2;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateInsurerUserArgs = {
  input: CreateInsurerUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateInvoiceClaimStateArgs = {
  input: CreateInvoiceClaimStateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateLifecycleRoleArgs = {
  input: CreateLifecycleRoleInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateMessageCreatedArgs = {
  input: CreateMessageCreatedInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateMessageSentArgs = {
  input: CreateMessageSentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateNegotiationClaimStateArgs = {
  input: CreateNegotiationClaimStateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateNnIbLineArgs = {
  input: CreateNnIbLineInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateOnHoldClaimStateArgs = {
  input: CreateOnHoldClaimStateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateProviderSignOffClaimStateArgs = {
  input: CreateProviderSignOffClaimStateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateProviderUserFacilityArgs = {
  input: CreateProviderUserFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateQaClaimStateRowArgs = {
  input: CreateQaClaimStateRowInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateQueueArgs = {
  input: CreateQueueInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateReportedClaimsArgs = {
  input: CreateReportedClaimsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateReportedFindingsArgs = {
  input: CreateReportedFindingsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateReviewedAuditFindingArgs = {
  input: CreateReviewedAuditFindingInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateS3AuditDocumentationArgs = {
  input: CreateS3AuditDocumentationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateSsoDomainIdentityProviderArgs = {
  input: CreateSsoDomainIdentityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateUbClaimFindingsArgs = {
  input: CreateUbClaimFindingsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateUbClaimLineFindingsArgs = {
  input: CreateUbClaimLineFindingsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateUserArgs = {
  input: CreateUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateUserInviteCreatedArgs = {
  input: CreateUserInviteCreatedInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationcreateWorkflowClaimStateArgs = {
  input: CreateWorkflowClaimStateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeclineFindingsByIBLineItemIdsArgs = {
  input: DeclineFindingsByIBLineItemIdsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteAgentArgs = {
  agentId: Scalars["ID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteAskAutodorQueueArgs = {
  id: Scalars["ID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteAuditStatusArgs = {
  id: Scalars["ID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteAuditorBucketArgs = {
  input: DeleteAuditorBucketInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteAuditorBucketByNodeIdArgs = {
  input: DeleteAuditorBucketByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteBatchClaimAppealedArgs = {
  input: DeleteBatchClaimAppealedInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteBatchClaimAppealedByBatchClaimIdArgs = {
  input: DeleteBatchClaimAppealedByBatchClaimIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteBatchClaimAppealedByNodeIdArgs = {
  input: DeleteBatchClaimAppealedByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteBatchClaimTechDenialArgs = {
  input: DeleteBatchClaimTechDenialInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteBatchClaimTechDenialByBatchClaimIdArgs = {
  input: DeleteBatchClaimTechDenialByBatchClaimIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteBatchClaimTechDenialByNodeIdArgs = {
  input: DeleteBatchClaimTechDenialByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteCaseArgs = {
  id: Scalars["ID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteClaimAuditGroupArgs = {
  input: DeleteClaimAuditGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteClaimAuditGroupByNameArgs = {
  input: DeleteClaimAuditGroupByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteClaimAuditGroupByNodeIdArgs = {
  input: DeleteClaimAuditGroupByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteDirectoryArgs = {
  id: Scalars["ID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteDocumentationRequestsArgs = {
  input: DeleteDocumentationRequestsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteFileArgs = {
  id: Scalars["ID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteFileAnnotationArgs = {
  id: Scalars["ID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteFindingsByAutomationSourceArgs = {
  input: DeleteFindingsByAutomationSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteKeysFromS3CacheArgs = {
  input: DeleteKeysFromS3CacheInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteLifecycleRoleArgs = {
  input: DeleteLifecycleRoleInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteProviderUserFacilityArgs = {
  input: DeleteProviderUserFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteProviderUserFacilityByNodeIdArgs = {
  input: DeleteProviderUserFacilityByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteProviderUserFacilityByProviderIdAndAuditorUserIdArgs =
  {
    input: DeleteProviderUserFacilityByProviderIdAndAuditorUserIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteSsoDomainIdentityProviderArgs = {
  input: DeleteSsoDomainIdentityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteSsoDomainIdentityProviderByDomainAndEnvironmentAndTenantIdArgs =
  {
    input: DeleteSsoDomainIdentityProviderByDomainAndEnvironmentAndTenantIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteSsoDomainIdentityProviderByNodeIdArgs = {
  input: DeleteSsoDomainIdentityProviderByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationdeleteStageTrackerBlockerArgs = {
  input: DeleteStageTrackerBlockerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationduplicateLifecycleRoleArgs = {
  input: DuplicateLifecycleRoleInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationeditAuditorUserArgs = {
  input: EditAuditorUserInput;
  userId: Scalars["ID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationgenerateDocRequestReportArgs = {
  providerId: Scalars["String"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationgenerateReportArgs = {
  batchClaimIds: Array<Scalars["UUID"]["input"]>;
  primaryPiaId: Scalars["UUID"]["input"];
  reportSubtype: AuditFindingReportSubtype;
  reportType: AuditFindingReportType;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationmoveCasesToQueueArgs = {
  input: MoveCasesToQueueInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationonboardUserArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationopenStageTrackerBlockerArgs = {
  input: OpenStageTrackerBlockerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationprepareFileForUploadArgs = {
  input: PrepareFileForUploadInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationpromptArgs = {
  input: PromptInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationratePromptResponseArgs = {
  promptResponseId: Scalars["ID"]["input"];
  rating?: InputMaybe<PromptResponseRatingType>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationrefreshS3AuditDocumentationArgs = {
  input: RefreshS3AuditDocumentationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationreviewAuditFindingsArgs = {
  input: ReviewAuditFindingsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationreviewAuditFindingsV2Args = {
  input: ReviewAuditFindingsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutations3CreateObjectHandlerArgs = {
  s3Key: Scalars["String"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutations3DataImportArgs = {
  input: S3DataImportInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsaveCasesAsQueueArgs = {
  input: SaveCasesAsQueueInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsaveClaimRoleAssignmentsArgs = {
  input: SaveClaimRoleAssignmentsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsaveRolePermissionMatrixArgs = {
  input: SaveRolePermissionMatrixInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationscheduleAgentFlowRunArgs = {
  input: ScheduleAgentFlowRunInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsendClaimReportsToClientArgs = {
  input: ClaimReportTransferInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsendDocumentUploadNotificationArgs = {
  input: SendDocumentUploadNoficationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsendUserOnboardNotificationArgs = {
  input: SendUserOnboardNotificationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetAssigneesArgs = {
  input: SetAssigneesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetAuditStartDatesArgs = {
  input: SetAuditStartDatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetClaimAppealedArgs = {
  input: SetClaimAppealedInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetClaimAuditTypesArgs = {
  input: SetClaimAuditTypesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetClaimAuditorsArgs = {
  input: SetClaimAuditorsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetClaimDisputedArgs = {
  input: SetClaimDisputedInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetClaimLifecycleStageArgs = {
  input: SetClaimLifecycleStageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetClaimQaStatesArgs = {
  input: SetClaimQaStatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetClaimStageArgs = {
  input: SetClaimStageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetClaimTechDenialsArgs = {
  input: SetClaimTechDenialsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetClientRecoveryAmountsArgs = {
  input: SetClientRecoveryAmountsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetClientRecoveryCollectionDatesArgs = {
  input: SetClientRecoveryCollectionDatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetClientSignOffClaimStatesArgs = {
  input: SetClientSignOffClaimStatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetDocumentationClaimStatesArgs = {
  input: SetDocumentationClaimStatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetDueDatesArgs = {
  input: SetDueDatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetFindingStatusArgs = {
  input: SetFindingStatusInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetInvoiceClaimStatesArgs = {
  input: SetInvoiceClaimStatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetLifecycleStageRecommendationArgs = {
  input: SetLifecycleStageRecommendationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetNegotiationClaimStatesArgs = {
  input: SetNegotiationClaimStatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetOnHoldClaimStatesArgs = {
  input: SetOnHoldClaimStatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetPrimaryMedicalRecordArgs = {
  batchClaimId: Scalars["UUID"]["input"];
  documentId: Scalars["UUID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetProviderSignOffClaimStatesArgs = {
  input: SetProviderSignOffClaimStatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetQaClaimStatesArgs = {
  input: SetQaClaimStatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetStageTrackerBlockerSegmentArgs = {
  input: SetStageTrackerBlockerSegmentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetUserMfaPreferenceArgs = {
  input: UserMfaPreferenceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsetWorkflowClaimStatesArgs = {
  input: SetWorkflowClaimStatesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationsoftDeleteBatchClaimCommentArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationunassignClaimsFromAuditGroupArgs = {
  input: UnassignClaimsFromAuditGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationunsetAgentMessageUserValidationArgs = {
  agentMessageId: Scalars["UUID"]["input"];
  revisionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAskAutodorQueueArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateAskAutodorQueueInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAuditFindingArgs = {
  input: UpdateAuditFindingInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAuditFindingByNodeIdArgs = {
  input: UpdateAuditFindingByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAuditFindingReasonCodeArgs = {
  input: UpdateAuditFindingReasonCodeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAuditFindingReasonCodeByNodeIdArgs = {
  input: UpdateAuditFindingReasonCodeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAuditStatusArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateAuditStatusInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAuditStatusesArgs = {
  input: UpdateAuditStatusesInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAuditorBucketArgs = {
  input: UpdateAuditorBucketInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateAuditorBucketByNodeIdArgs = {
  input: UpdateAuditorBucketByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimAppealedArgs = {
  input: UpdateBatchClaimAppealedInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimAppealedByBatchClaimIdArgs = {
  input: UpdateBatchClaimAppealedByBatchClaimIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimAppealedByNodeIdArgs = {
  input: UpdateBatchClaimAppealedByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimAuditTypeArgs = {
  input: UpdateBatchClaimAuditTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimAuditTypeByBatchClaimIdArgs = {
  input: UpdateBatchClaimAuditTypeByBatchClaimIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimAuditTypeByNodeIdArgs = {
  input: UpdateBatchClaimAuditTypeByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimCommentArgs = {
  body: Scalars["String"]["input"];
  id: Scalars["UUID"]["input"];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimDocumentArgs = {
  input: UpdateBatchClaimDocumentInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimDocumentByBatchClaimIdAndDocumentIdArgs = {
  input: UpdateBatchClaimDocumentByBatchClaimIdAndDocumentIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimDocumentByBatchClaimIdAndIsPrimaryMedicalRecordArgs =
  {
    input: UpdateBatchClaimDocumentByBatchClaimIdAndIsPrimaryMedicalRecordInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimDocumentByNodeIdArgs = {
  input: UpdateBatchClaimDocumentByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimLineItemArgs = {
  input: UpdateBatchClaimLineItemInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimLineItemByNodeIdArgs = {
  input: UpdateBatchClaimLineItemByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimLineItemNnIbLineArgs = {
  input: UpdateBatchClaimLineItemNnIbLineInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimLineItemNnIbLineByBatchClaimLineItemIdAndNnIbLineIdArgs =
  {
    input: UpdateBatchClaimLineItemNnIbLineByBatchClaimLineItemIdAndNnIbLineIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimLineItemNnIbLineByNodeIdArgs = {
  input: UpdateBatchClaimLineItemNnIbLineByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimPayDenyArgs = {
  input: UpdateBatchClaimPayDenyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimPayDenyByBatchClaimIdArgs = {
  input: UpdateBatchClaimPayDenyByBatchClaimIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimPayDenyByNodeIdArgs = {
  input: UpdateBatchClaimPayDenyByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimTechDenialArgs = {
  input: UpdateBatchClaimTechDenialInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimTechDenialByBatchClaimIdArgs = {
  input: UpdateBatchClaimTechDenialByBatchClaimIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBatchClaimTechDenialByNodeIdArgs = {
  input: UpdateBatchClaimTechDenialByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBclComputationsFromComputationStrategyArgs = {
  input: UpdateBclComputationsFromComputationStrategyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBcliComputationsFromComputationStrategyArgs = {
  input: UpdateBcliComputationsFromComputationStrategyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBucketClaimArgs = {
  input: UpdateBucketClaimInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBucketClaimByBatchClaimIdArgs = {
  input: UpdateBucketClaimByBatchClaimIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBucketClaimByBatchClaimIdAndAuditorBucketIdArgs = {
  input: UpdateBucketClaimByBatchClaimIdAndAuditorBucketIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateBucketClaimByNodeIdArgs = {
  input: UpdateBucketClaimByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateCaseArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateCaseInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateClaimAuditGroupArgs = {
  input: UpdateClaimAuditGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateClaimAuditGroupByNameArgs = {
  input: UpdateClaimAuditGroupByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateClaimAuditGroupByNodeIdArgs = {
  input: UpdateClaimAuditGroupByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateDirectoryArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateDirectoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateFacetArgs = {
  input: UpdateFacetInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateFacetKeywordArgs = {
  input: UpdateFacetKeywordInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateFileArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateFileInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateFindingsArgs = {
  input: UpdateFindingsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateLifecycleRoleArgs = {
  input: UpdateLifecycleRoleInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateNnIbLineArgs = {
  input: UpdateNnIbLineInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateNnIbLineByFingerprintAndS3KeyArgs = {
  input: UpdateNnIbLineByFingerprintAndS3KeyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateNnIbLineByNodeIdArgs = {
  input: UpdateNnIbLineByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateProviderUserFacilityArgs = {
  input: UpdateProviderUserFacilityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateProviderUserFacilityByNodeIdArgs = {
  input: UpdateProviderUserFacilityByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateProviderUserFacilityByProviderIdAndAuditorUserIdArgs =
  {
    input: UpdateProviderUserFacilityByProviderIdAndAuditorUserIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateQueueArgs = {
  input: UpdateQueueInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateQueueByNodeIdArgs = {
  input: UpdateQueueByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateReviewedAuditFindingArgs = {
  input: UpdateReviewedAuditFindingInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateReviewedAuditFindingByNodeIdArgs = {
  input: UpdateReviewedAuditFindingByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateS3AuditDocumentationArgs = {
  input: UpdateS3AuditDocumentationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateS3AuditDocumentationByNodeIdArgs = {
  input: UpdateS3AuditDocumentationByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateSsoDomainIdentityProviderArgs = {
  input: UpdateSsoDomainIdentityProviderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateSsoDomainIdentityProviderByDomainAndEnvironmentAndTenantIdArgs =
  {
    input: UpdateSsoDomainIdentityProviderByDomainAndEnvironmentAndTenantIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateSsoDomainIdentityProviderByNodeIdArgs = {
  input: UpdateSsoDomainIdentityProviderByNodeIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupdateUserProfileArgs = {
  input: UserProfileInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationupsertAutomationAuthorArgs = {
  input: UpsertAutomationAuthorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationversionAuditFindingsArgs = {
  input: VersionAuditFindingsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationversionReportArgs = {
  reportId: Scalars["UUID"]["input"];
  reportSubtype: AuditFindingReportSubtype;
  reportType: AuditFindingReportType;
};

export type NegotiationClaimState = Node & {
  __typename?: "NegotiationClaimState";
  /** Reads a single `BatchClaim` that is related to this `NegotiationClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  negotiationState: Scalars["String"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

export type NegotiationClaimStateAggregates = {
  __typename?: "NegotiationClaimStateAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<NegotiationClaimStateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `NegotiationClaimState` object types. */
export type NegotiationClaimStateAggregatesFilter = {
  /** Distinct count aggregate over matching `NegotiationClaimState` objects. */
  distinctCount?: InputMaybe<NegotiationClaimStateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `NegotiationClaimState` object to be included within the aggregate. */
  filter?: InputMaybe<NegotiationClaimStateFilter>;
};

/** Input for the nested mutation of `batchClaim` in the `NegotiationClaimStateInput` mutation. */
export type NegotiationClaimStateBatchClaimIdFkInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<NegotiationClaimStateOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkNodeIdUpdate>;
};

/** Input for the nested mutation of `negotiationClaimState` in the `BatchClaimInput` mutation. */
export type NegotiationClaimStateBatchClaimIdFkInverseInput = {
  /** The primary key(s) for `negotiationClaimState` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<NegotiationClaimStateNegotiationClaimStatePkeyConnect>
  >;
  /** The primary key(s) for `negotiationClaimState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<NegotiationClaimStateNodeIdConnect>>;
  /** A `NegotiationClaimStateInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<NegotiationClaimStateBatchClaimIdFkNegotiationClaimStateCreateInput>
  >;
  /** The primary key(s) and patch data for `negotiationClaimState` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<NegotiationClaimStateOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkUsingNegotiationClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `negotiationClaimState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkNodeIdUpdate>
  >;
};

/** The `negotiationClaimState` to be created by this mutation. */
export type NegotiationClaimStateBatchClaimIdFkNegotiationClaimStateCreateInput =
  {
    batchClaimToBatchClaimId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    negotiationState?: InputMaybe<Scalars["String"]["input"]>;
  };

/**
 * A condition to be used against `NegotiationClaimState` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type NegotiationClaimStateCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `negotiationState` field. */
  negotiationState?: InputMaybe<Scalars["String"]["input"]>;
};

export type NegotiationClaimStateDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  negotiationState?: InputMaybe<BigIntFilter>;
};

export type NegotiationClaimStateDistinctCountAggregates = {
  __typename?: "NegotiationClaimStateDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of negotiationState across the matching connection */
  negotiationState?: Maybe<Scalars["BigInt"]["output"]>;
};

export enum NegotiationClaimStateEnum {
  NEGOTIATING = "NEGOTIATING",
  NOT_NEGOTIATING = "NOT_NEGOTIATING",
}

/** A filter to be used against NegotiationClaimStateEnum fields. All fields are combined with a logical ‘and.’ */
export type NegotiationClaimStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<NegotiationClaimStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<NegotiationClaimStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<NegotiationClaimStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<NegotiationClaimStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<NegotiationClaimStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<NegotiationClaimStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<NegotiationClaimStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<NegotiationClaimStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<NegotiationClaimStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<NegotiationClaimStateEnum>>;
};

/** A filter to be used against `NegotiationClaimState` object types. All fields are combined with a logical ‘and.’ */
export type NegotiationClaimStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NegotiationClaimStateFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `negotiationState` field. */
  negotiationState?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NegotiationClaimStateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NegotiationClaimStateFilter>>;
};

/** Grouping methods for `NegotiationClaimState` for usage during aggregation. */
export enum NegotiationClaimStateGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  NEGOTIATION_STATE = "NEGOTIATION_STATE",
}

export type NegotiationClaimStateHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NegotiationClaimStateHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `NegotiationClaimState` aggregates. */
export type NegotiationClaimStateHavingInput = {
  AND?: InputMaybe<Array<NegotiationClaimStateHavingInput>>;
  OR?: InputMaybe<Array<NegotiationClaimStateHavingInput>>;
  average?: InputMaybe<NegotiationClaimStateHavingAverageInput>;
  distinctCount?: InputMaybe<NegotiationClaimStateHavingDistinctCountInput>;
  max?: InputMaybe<NegotiationClaimStateHavingMaxInput>;
  min?: InputMaybe<NegotiationClaimStateHavingMinInput>;
  stddevPopulation?: InputMaybe<NegotiationClaimStateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<NegotiationClaimStateHavingStddevSampleInput>;
  sum?: InputMaybe<NegotiationClaimStateHavingSumInput>;
  variancePopulation?: InputMaybe<NegotiationClaimStateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<NegotiationClaimStateHavingVarianceSampleInput>;
};

export type NegotiationClaimStateHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NegotiationClaimStateHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NegotiationClaimStateHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NegotiationClaimStateHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NegotiationClaimStateHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NegotiationClaimStateHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NegotiationClaimStateHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `NegotiationClaimState` */
export type NegotiationClaimStateInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  negotiationState?: InputMaybe<Scalars["String"]["input"]>;
};

/** The fields on `negotiationClaimState` to look up the row to connect. */
export type NegotiationClaimStateNegotiationClaimStatePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The globally unique `ID` look up for the row to connect. */
export type NegotiationClaimStateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `negotiationClaimState` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type NegotiationClaimStateOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `negotiationClaimState` to look up the row to update. */
export type NegotiationClaimStateOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkUsingNegotiationClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `negotiationClaimState` being updated. */
    patch: updateNegotiationClaimStateOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkPatch;
  };

/** Represents an update to a `NegotiationClaimState`. Fields that are set will be updated. */
export type NegotiationClaimStatePatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInput>;
};

/** A connection to a list of `NegotiationClaimState` values. */
export type NegotiationClaimStatesConnection = {
  __typename?: "NegotiationClaimStatesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<NegotiationClaimStateAggregates>;
  /** A list of edges which contains the `NegotiationClaimState` and cursor to aid in pagination. */
  edges: Array<NegotiationClaimStatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<NegotiationClaimStateAggregates>>;
  /** A list of `NegotiationClaimState` objects. */
  nodes: Array<Maybe<NegotiationClaimState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NegotiationClaimState` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `NegotiationClaimState` values. */
export type NegotiationClaimStatesConnectiongroupedAggregatesArgs = {
  groupBy: Array<NegotiationClaimStateGroupBy>;
  having?: InputMaybe<NegotiationClaimStateHavingInput>;
};

/** A `NegotiationClaimState` edge in the connection. */
export type NegotiationClaimStatesEdge = {
  __typename?: "NegotiationClaimStatesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `NegotiationClaimState` at the end of the edge. */
  node?: Maybe<NegotiationClaimState>;
};

/** Methods to use when ordering `NegotiationClaimState`. */
export enum NegotiationClaimStatesOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  NEGOTIATION_STATE_ASC = "NEGOTIATION_STATE_ASC",
  NEGOTIATION_STATE_DESC = "NEGOTIATION_STATE_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

export type NnIbLine = Node & {
  __typename?: "NnIbLine";
  /** Reads a single `AuditorUser` that is related to this `NnIbLine`. */
  author?: Maybe<AuditorUser>;
  authorId: Scalars["UUID"]["output"];
  /** Reads and enables pagination through a set of `BatchClaimLineItemNnIbLine`. */
  batchClaimLineItemNnIbLines: BatchClaimLineItemNnIbLinesConnection;
  createdAt: Scalars["Datetime"]["output"];
  fingerprint: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  s3Key: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type NnIbLinebatchClaimLineItemNnIbLinesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemNnIbLineCondition>;
  filter?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemNnIbLinesOrderBy>>;
};

export type NnIbLineAggregates = {
  __typename?: "NnIbLineAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<NnIbLineDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `NnIbLine` object types. */
export type NnIbLineAggregatesFilter = {
  /** Distinct count aggregate over matching `NnIbLine` objects. */
  distinctCount?: InputMaybe<NnIbLineDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `NnIbLine` object to be included within the aggregate. */
  filter?: InputMaybe<NnIbLineFilter>;
};

/** Input for the nested mutation of `auditorUser` in the `NnIbLineInput` mutation. */
export type NnIbLineAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<NnIbLineOnNnIbLineForNnIbLineAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `nnIbLine` in the `AuditorUserInput` mutation. */
export type NnIbLineAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `nnIbLine` for the far side of the relationship. */
  connectByFingerprintAndS3Key?: InputMaybe<
    Array<NnIbLineNnIbLineFingerprintS3KeyKeyConnect>
  >;
  /** The primary key(s) for `nnIbLine` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NnIbLineNnIbLinePkeyConnect>>;
  /** The primary key(s) for `nnIbLine` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<NnIbLineNodeIdConnect>>;
  /** A `NnIbLineInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NnIbLineAuthorIdFkeyNnIbLineCreateInput>>;
  /** The primary key(s) and patch data for `nnIbLine` for the far side of the relationship. */
  updateByFingerprintAndS3Key?: InputMaybe<
    Array<NnIbLineOnNnIbLineForNnIbLineAuthorIdFkeyUsingNnIbLineFingerprintS3KeyKeyUpdate>
  >;
  /** The primary key(s) and patch data for `nnIbLine` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<NnIbLineOnNnIbLineForNnIbLineAuthorIdFkeyUsingNnIbLinePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `nnIbLine` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyNodeIdUpdate>
  >;
};

/** The `nnIbLine` to be created by this mutation. */
export type NnIbLineAuthorIdFkeyNnIbLineCreateInput = {
  auditorUserToAuthorId?: InputMaybe<NnIbLineAuthorIdFkeyInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  fingerprint: Scalars["UUID"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  s3Key: Scalars["String"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/**
 * A condition to be used against `NnIbLine` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type NnIbLineCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `fingerprint` field. */
  fingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `s3Key` field. */
  s3Key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type NnIbLineDistinctCountAggregateFilter = {
  authorId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  fingerprint?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  s3Key?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type NnIbLineDistinctCountAggregates = {
  __typename?: "NnIbLineDistinctCountAggregates";
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of fingerprint across the matching connection */
  fingerprint?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of s3Key across the matching connection */
  s3Key?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `NnIbLine` object types. All fields are combined with a logical ‘and.’ */
export type NnIbLineFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NnIbLineFilter>>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `batchClaimLineItemNnIbLines` relation. */
  batchClaimLineItemNnIbLines?: InputMaybe<NnIbLineToManyBatchClaimLineItemNnIbLineFilter>;
  /** Some related `batchClaimLineItemNnIbLines` exist. */
  batchClaimLineItemNnIbLinesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fingerprint` field. */
  fingerprint?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NnIbLineFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NnIbLineFilter>>;
  /** Filter by the object’s `s3Key` field. */
  s3Key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `NnIbLine` for usage during aggregation. */
export enum NnIbLineGroupBy {
  AUTHOR_ID = "AUTHOR_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  FINGERPRINT = "FINGERPRINT",
  S3_KEY = "S3_KEY",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type NnIbLineHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NnIbLineHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `NnIbLine` aggregates. */
export type NnIbLineHavingInput = {
  AND?: InputMaybe<Array<NnIbLineHavingInput>>;
  OR?: InputMaybe<Array<NnIbLineHavingInput>>;
  average?: InputMaybe<NnIbLineHavingAverageInput>;
  distinctCount?: InputMaybe<NnIbLineHavingDistinctCountInput>;
  max?: InputMaybe<NnIbLineHavingMaxInput>;
  min?: InputMaybe<NnIbLineHavingMinInput>;
  stddevPopulation?: InputMaybe<NnIbLineHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<NnIbLineHavingStddevSampleInput>;
  sum?: InputMaybe<NnIbLineHavingSumInput>;
  variancePopulation?: InputMaybe<NnIbLineHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<NnIbLineHavingVarianceSampleInput>;
};

export type NnIbLineHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NnIbLineHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NnIbLineHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NnIbLineHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NnIbLineHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NnIbLineHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type NnIbLineHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `NnIbLine` */
export type NnIbLineInput = {
  auditorUserToAuthorId?: InputMaybe<NnIbLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  fingerprint: Scalars["UUID"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  s3Key: Scalars["String"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The fields on `nnIbLine` to look up the row to connect. */
export type NnIbLineNnIbLineFingerprintS3KeyKeyConnect = {
  fingerprint: Scalars["UUID"]["input"];
  s3Key: Scalars["String"]["input"];
};

/** The fields on `nnIbLine` to look up the row to connect. */
export type NnIbLineNnIbLinePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The globally unique `ID` look up for the row to connect. */
export type NnIbLineNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `nnIbLine` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type NnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaimLineItemNnIbLine` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
    patch: BatchClaimLineItemNnIbLinePatch;
  };

/** The fields on `nnIbLine` to look up the row to update. */
export type NnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyUsingNnIbLineFingerprintS3KeyKeyUpdate =
  {
    fingerprint: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `nnIbLine` being updated. */
    patch: updateNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyPatch;
    s3Key: Scalars["String"]["input"];
  };

/** The fields on `nnIbLine` to look up the row to update. */
export type NnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyUsingNnIbLinePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `nnIbLine` being updated. */
    patch: updateNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type NnIbLineOnNnIbLineForNnIbLineAuthorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `auditorUser` being updated. */
  patch: AuditorUserPatch;
};

/** The fields on `nnIbLine` to look up the row to update. */
export type NnIbLineOnNnIbLineForNnIbLineAuthorIdFkeyUsingNnIbLineFingerprintS3KeyKeyUpdate =
  {
    fingerprint: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `nnIbLine` being updated. */
    patch: updateNnIbLineOnNnIbLineForNnIbLineAuthorIdFkeyPatch;
    s3Key: Scalars["String"]["input"];
  };

/** The fields on `nnIbLine` to look up the row to update. */
export type NnIbLineOnNnIbLineForNnIbLineAuthorIdFkeyUsingNnIbLinePkeyUpdate = {
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `nnIbLine` being updated. */
  patch: updateNnIbLineOnNnIbLineForNnIbLineAuthorIdFkeyPatch;
};

/** Represents an update to a `NnIbLine`. Fields that are set will be updated. */
export type NnIbLinePatch = {
  auditorUserToAuthorId?: InputMaybe<NnIbLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  fingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  s3Key?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** A filter to be used against many `BatchClaimLineItemNnIbLine` object types. All fields are combined with a logical ‘and.’ */
export type NnIbLineToManyBatchClaimLineItemNnIbLineFilter = {
  /** Aggregates across related `BatchClaimLineItemNnIbLine` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimLineItemNnIbLineAggregatesFilter>;
  /** Every related `BatchClaimLineItemNnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
  /** No related `BatchClaimLineItemNnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
  /** Some related `BatchClaimLineItemNnIbLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
};

export type NnIbLineValueInputV2 = {
  fingerprint: Scalars["String"]["input"];
  s3Key: Scalars["String"]["input"];
};

/** A connection to a list of `NnIbLine` values. */
export type NnIbLinesConnection = {
  __typename?: "NnIbLinesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<NnIbLineAggregates>;
  /** A list of edges which contains the `NnIbLine` and cursor to aid in pagination. */
  edges: Array<NnIbLinesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<NnIbLineAggregates>>;
  /** A list of `NnIbLine` objects. */
  nodes: Array<Maybe<NnIbLine>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NnIbLine` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `NnIbLine` values. */
export type NnIbLinesConnectiongroupedAggregatesArgs = {
  groupBy: Array<NnIbLineGroupBy>;
  having?: InputMaybe<NnIbLineHavingInput>;
};

/** A `NnIbLine` edge in the connection. */
export type NnIbLinesEdge = {
  __typename?: "NnIbLinesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `NnIbLine` at the end of the edge. */
  node?: Maybe<NnIbLine>;
};

/** Methods to use when ordering `NnIbLine`. */
export enum NnIbLinesOrderBy {
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_NN_IB_LINE_ID__COUNT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_NN_IB_LINE_ID__COUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_NN_IB_LINE_ID__COUNT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_BY_NN_IB_LINE_ID__COUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_COUNT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MAX_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_MIN_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_SUM_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ITEM_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_NN_IB_LINE_ID_DESC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIM_LINE_ITEM_NN_IB_LINES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  FINGERPRINT_ASC = "FINGERPRINT_ASC",
  FINGERPRINT_DESC = "FINGERPRINT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  S3_KEY_ASC = "S3_KEY_ASC",
  S3_KEY_DESC = "S3_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
};

export type NonBillableAuditRule = {
  __typename?: "NonBillableAuditRule";
  code: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
};

export type NotificationDigest = {
  __typename?: "NotificationDigest";
  email: EmailServerResponse;
  messageSentId?: Maybe<Scalars["UUID"]["output"]>;
  recipientUserEmail: Scalars["String"]["output"];
  recipientUserId: Scalars["UUID"]["output"];
};

export type NotificationResponse = {
  __typename?: "NotificationResponse";
  messageCreatedId: Scalars["UUID"]["output"];
  notificationKind: Scalars["String"]["output"];
  notifications: Array<Maybe<NotificationDigest>>;
};

export type NpiProvider = {
  __typename?: "NpiProvider";
  npi?: Maybe<Scalars["String"]["output"]>;
  providers?: Maybe<Array<Maybe<Provider>>>;
};

/** A filter to be used against `NpiProvider` object types. All fields are combined with a logical ‘and.’ */
export type NpiProviderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NpiProviderFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<NpiProviderFilter>;
  /** Filter by the object’s `npi` field. */
  npi?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NpiProviderFilter>>;
};

/** A connection to a list of `NpiProvider` values. */
export type NpiProvidersConnection = {
  __typename?: "NpiProvidersConnection";
  /** A list of edges which contains the `NpiProvider` and cursor to aid in pagination. */
  edges: Array<NpiProvidersEdge>;
  /** A list of `NpiProvider` objects. */
  nodes: Array<Maybe<NpiProvider>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NpiProvider` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `NpiProvider` edge in the connection. */
export type NpiProvidersEdge = {
  __typename?: "NpiProvidersEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `NpiProvider` at the end of the edge. */
  node?: Maybe<NpiProvider>;
};

/** Filter by On Hold blocker stage. Stage values are slugs from the on_hold blocker category (e.g. "ON_HOLD") or stage keyword UUIDs. `isNull: true` matches claims with no active On Hold blocker. Claims may have multiple blocker categories active simultaneously. Use top-level `or` to combine blank with stage multi-select. */
export type OnHoldBlockerStageFacetFilterInput = {
  /** Exact stage match for an active blocker of this category. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match any stage in the list (OR). Only active blockers of this category. */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** True when no active On Hold blocker exists on the claim. */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Stage not equal for an active blocker of this category. */
  notEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Match no stage in the list. Only active blockers of this category. */
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type OnHoldClaimState = Node & {
  __typename?: "OnHoldClaimState";
  /** Reads a single `BatchClaim` that is related to this `OnHoldClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  onHoldState: Scalars["String"]["output"];
};

export type OnHoldClaimStateAggregates = {
  __typename?: "OnHoldClaimStateAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OnHoldClaimStateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `OnHoldClaimState` object types. */
export type OnHoldClaimStateAggregatesFilter = {
  /** Distinct count aggregate over matching `OnHoldClaimState` objects. */
  distinctCount?: InputMaybe<OnHoldClaimStateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OnHoldClaimState` object to be included within the aggregate. */
  filter?: InputMaybe<OnHoldClaimStateFilter>;
};

/** Input for the nested mutation of `batchClaim` in the `OnHoldClaimStateInput` mutation. */
export type OnHoldClaimStateBatchClaimIdFkInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OnHoldClaimStateOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkNodeIdUpdate>;
};

/** Input for the nested mutation of `onHoldClaimState` in the `BatchClaimInput` mutation. */
export type OnHoldClaimStateBatchClaimIdFkInverseInput = {
  /** The primary key(s) for `onHoldClaimState` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OnHoldClaimStateOnHoldClaimStatePkeyConnect>>;
  /** The primary key(s) for `onHoldClaimState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OnHoldClaimStateNodeIdConnect>>;
  /** A `OnHoldClaimStateInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<OnHoldClaimStateBatchClaimIdFkOnHoldClaimStateCreateInput>
  >;
  /** The primary key(s) and patch data for `onHoldClaimState` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<OnHoldClaimStateOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkUsingOnHoldClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `onHoldClaimState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkNodeIdUpdate>
  >;
};

/** The `onHoldClaimState` to be created by this mutation. */
export type OnHoldClaimStateBatchClaimIdFkOnHoldClaimStateCreateInput = {
  batchClaimToBatchClaimId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  onHoldState?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * A condition to be used against `OnHoldClaimState` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OnHoldClaimStateCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `onHoldState` field. */
  onHoldState?: InputMaybe<Scalars["String"]["input"]>;
};

export type OnHoldClaimStateDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  onHoldState?: InputMaybe<BigIntFilter>;
};

export type OnHoldClaimStateDistinctCountAggregates = {
  __typename?: "OnHoldClaimStateDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of onHoldState across the matching connection */
  onHoldState?: Maybe<Scalars["BigInt"]["output"]>;
};

export enum OnHoldClaimStateEnum {
  NOT_ON_HOLD = "NOT_ON_HOLD",
  ON_HOLD = "ON_HOLD",
}

/** A filter to be used against OnHoldClaimStateEnum fields. All fields are combined with a logical ‘and.’ */
export type OnHoldClaimStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OnHoldClaimStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OnHoldClaimStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OnHoldClaimStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OnHoldClaimStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OnHoldClaimStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OnHoldClaimStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OnHoldClaimStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OnHoldClaimStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OnHoldClaimStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OnHoldClaimStateEnum>>;
};

/** A filter to be used against `OnHoldClaimState` object types. All fields are combined with a logical ‘and.’ */
export type OnHoldClaimStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OnHoldClaimStateFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OnHoldClaimStateFilter>;
  /** Filter by the object’s `onHoldState` field. */
  onHoldState?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OnHoldClaimStateFilter>>;
};

/** Grouping methods for `OnHoldClaimState` for usage during aggregation. */
export enum OnHoldClaimStateGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  ON_HOLD_STATE = "ON_HOLD_STATE",
}

export type OnHoldClaimStateHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OnHoldClaimStateHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `OnHoldClaimState` aggregates. */
export type OnHoldClaimStateHavingInput = {
  AND?: InputMaybe<Array<OnHoldClaimStateHavingInput>>;
  OR?: InputMaybe<Array<OnHoldClaimStateHavingInput>>;
  average?: InputMaybe<OnHoldClaimStateHavingAverageInput>;
  distinctCount?: InputMaybe<OnHoldClaimStateHavingDistinctCountInput>;
  max?: InputMaybe<OnHoldClaimStateHavingMaxInput>;
  min?: InputMaybe<OnHoldClaimStateHavingMinInput>;
  stddevPopulation?: InputMaybe<OnHoldClaimStateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OnHoldClaimStateHavingStddevSampleInput>;
  sum?: InputMaybe<OnHoldClaimStateHavingSumInput>;
  variancePopulation?: InputMaybe<OnHoldClaimStateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OnHoldClaimStateHavingVarianceSampleInput>;
};

export type OnHoldClaimStateHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OnHoldClaimStateHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OnHoldClaimStateHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OnHoldClaimStateHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OnHoldClaimStateHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OnHoldClaimStateHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type OnHoldClaimStateHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `OnHoldClaimState` */
export type OnHoldClaimStateInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  onHoldState?: InputMaybe<Scalars["String"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type OnHoldClaimStateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `onHoldClaimState` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The fields on `onHoldClaimState` to look up the row to connect. */
export type OnHoldClaimStateOnHoldClaimStatePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type OnHoldClaimStateOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `onHoldClaimState` to look up the row to update. */
export type OnHoldClaimStateOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkUsingOnHoldClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `onHoldClaimState` being updated. */
    patch: updateOnHoldClaimStateOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkPatch;
  };

/** Represents an update to a `OnHoldClaimState`. Fields that are set will be updated. */
export type OnHoldClaimStatePatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInput>;
};

/** A connection to a list of `OnHoldClaimState` values. */
export type OnHoldClaimStatesConnection = {
  __typename?: "OnHoldClaimStatesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OnHoldClaimStateAggregates>;
  /** A list of edges which contains the `OnHoldClaimState` and cursor to aid in pagination. */
  edges: Array<OnHoldClaimStatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OnHoldClaimStateAggregates>>;
  /** A list of `OnHoldClaimState` objects. */
  nodes: Array<Maybe<OnHoldClaimState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OnHoldClaimState` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `OnHoldClaimState` values. */
export type OnHoldClaimStatesConnectiongroupedAggregatesArgs = {
  groupBy: Array<OnHoldClaimStateGroupBy>;
  having?: InputMaybe<OnHoldClaimStateHavingInput>;
};

/** A `OnHoldClaimState` edge in the connection. */
export type OnHoldClaimStatesEdge = {
  __typename?: "OnHoldClaimStatesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `OnHoldClaimState` at the end of the edge. */
  node?: Maybe<OnHoldClaimState>;
};

/** Methods to use when ordering `OnHoldClaimState`. */
export enum OnHoldClaimStatesOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  ON_HOLD_STATE_ASC = "ON_HOLD_STATE_ASC",
  ON_HOLD_STATE_DESC = "ON_HOLD_STATE_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
}

export type OnboardUserOutput = {
  __typename?: "OnboardUserOutput";
  message: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type OpenStageTrackerBlockerInput = {
  batchClaimId: Scalars["UUID"]["input"];
  blockerSlug: Scalars["String"]["input"];
  context?: InputMaybe<Scalars["JSON"]["input"]>;
  segmentSlug?: InputMaybe<Scalars["String"]["input"]>;
};

export enum OperationTypeEnum {
  AVERAGE = "AVERAGE",
  COUNT = "COUNT",
  SUM = "SUM",
}

export enum OutgoingFileNamePattern {
  REPORT_TYPE_DASH_ALAFFIA_CLAIM_NUMBER = "REPORT_TYPE_DASH_ALAFFIA_CLAIM_NUMBER",
  REPORT_TYPE_DASH_CLIENT_CLAIM_NUMBER = "REPORT_TYPE_DASH_CLIENT_CLAIM_NUMBER",
}

export enum OutgoingFileNamePatternType {
  REPORT_TYPE_DASH_ALAFFIA_CLAIM_NUMBER = "REPORT_TYPE_DASH_ALAFFIA_CLAIM_NUMBER",
  REPORT_TYPE_DASH_CLIENT_CLAIM_NUMBER = "REPORT_TYPE_DASH_CLIENT_CLAIM_NUMBER",
}

export type PTPAuditRule = {
  __typename?: "PTPAuditRule";
  colOneCode: Scalars["String"]["output"];
  colTwoCode: Scalars["String"]["output"];
  extendedDescription: Scalars["String"]["output"];
  rationale: Scalars["String"]["output"];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["Cursor"]["output"]>;
};

/** Available via batchClaim.patient. */
export type PatientDatum = Node & {
  __typename?: "PatientDatum";
  /** Reads and enables pagination through a set of `BatchClaim`. */
  batchClaimsByPatientId: BatchClaimsConnection;
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  payerPatientId: Scalars["String"]["output"];
  /** The state of the patient.  This is not required or provided by all clients, but for certain clients is required for correctly reporting findings. */
  state?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

/** Available via batchClaim.patient. */
export type PatientDatumbatchClaimsByPatientIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimCondition>;
  filter?: InputMaybe<BatchClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimsOrderBy>>;
};

/** A filter to be used against `PatientDatum` object types. All fields are combined with a logical ‘and.’ */
export type PatientDatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PatientDatumFilter>>;
  /** Filter by the object’s `batchClaimsByPatientId` relation. */
  batchClaimsByPatientId?: InputMaybe<PatientDatumToManyBatchClaimFilter>;
  /** Some related `batchClaimsByPatientId` exist. */
  batchClaimsByPatientIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PatientDatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PatientDatumFilter>>;
  /** Filter by the object’s `payerPatientId` field. */
  payerPatientId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The globally unique `ID` look up for the row to connect. */
export type PatientDatumNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `patientDatum` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type PatientDatumOnBatchClaimForBatchClaimPatientIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `batchClaim` being updated. */
  patch: BatchClaimPatch;
};

/** The fields on `patientDatum` to look up the row to update. */
export type PatientDatumOnBatchClaimForBatchClaimPatientIdFkeyUsingPatientDataMedicaidIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `patientDatum` being updated. */
    patch: updatePatientDatumOnBatchClaimForBatchClaimPatientIdFkeyPatch;
    payerPatientId: Scalars["String"]["input"];
  };

/** The fields on `patientDatum` to look up the row to update. */
export type PatientDatumOnBatchClaimForBatchClaimPatientIdFkeyUsingPatientDataPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `patientDatum` being updated. */
    patch: updatePatientDatumOnBatchClaimForBatchClaimPatientIdFkeyPatch;
  };

/** Represents an update to a `PatientDatum`. Fields that are set will be updated. */
export type PatientDatumPatch = {
  batchClaimsUsingId?: InputMaybe<BatchClaimPatientIdFkeyInverseInput>;
};

/** The fields on `patientDatum` to look up the row to connect. */
export type PatientDatumPatientDataMedicaidIdKeyConnect = {
  payerPatientId: Scalars["String"]["input"];
};

/** The fields on `patientDatum` to look up the row to connect. */
export type PatientDatumPatientDataPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A filter to be used against many `BatchClaim` object types. All fields are combined with a logical ‘and.’ */
export type PatientDatumToManyBatchClaimFilter = {
  /** Aggregates across related `BatchClaim` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAggregatesFilter>;
  /** Every related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimFilter>;
  /** No related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimFilter>;
  /** Some related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimFilter>;
};

export type PreflightReportTransfer = {
  __typename?: "PreflightReportTransfer";
  clientDestinations: Array<ClientSendTransferMethod>;
  namingConventions: Array<PreflightReportTransferNamingConvention>;
  reportTypes: Array<AuditFindingReportType>;
  summary: Array<TransferSummaryItem>;
  transferableClaims: Array<ReportClaim>;
};

export type PreflightReportTransferInput = {
  claimIds: Array<Scalars["UUID"]["input"]>;
  types: Array<AuditFindingReportType>;
};

export type PreflightReportTransferNamingConvention = {
  __typename?: "PreflightReportTransferNamingConvention";
  description: Scalars["String"]["output"];
  displayName: Scalars["String"]["output"];
  namingConvention: OutgoingFileNamePatternType;
};

/** Input for the nested mutation of `auditorUser` in the `AuditFindingReportInput` mutation. */
export type PreliminaryAuditFindingReportAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingReport` in the `AuditorUserInput` mutation. */
export type PreliminaryAuditFindingReportAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuditFindingReportPreliminaryAuditFindingReportPkeyConnect>
  >;
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingReportNodeIdConnect>>;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyNodeIdUpdate>
  >;
};

/** Input for the nested mutation of `provider` in the `AuditFindingReportInput` mutation. */
export type PreliminaryAuditFindingReportProviderIdFkeyInput = {
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectById?: InputMaybe<ProviderProviderPkeyConnect>;
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProviderNodeIdConnect>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateById?: InputMaybe<ProviderOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyUsingProviderPkeyUpdate>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `auditFindingReport` in the `ProviderInput` mutation. */
export type PreliminaryAuditFindingReportProviderIdFkeyInverseInput = {
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuditFindingReportPreliminaryAuditFindingReportPkeyConnect>
  >;
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AuditFindingReportNodeIdConnect>>;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<ProviderOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyNodeIdUpdate>
  >;
};

export type PrepareFileForUploadInput = {
  caseId?: InputMaybe<Scalars["ID"]["input"]>;
  fileName: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  parentDirectoryId?: InputMaybe<Scalars["ID"]["input"]>;
  queueId?: InputMaybe<Scalars["ID"]["input"]>;
  size: Scalars["Int"]["input"];
};

export type PrepareFileForUploadResult = {
  __typename?: "PrepareFileForUploadResult";
  fileId: Scalars["ID"]["output"];
  fileUploadId: Scalars["UUID"]["output"];
  signedUploadUrl: SignedUploadUrl;
};

export type ProcedureCode = Node & {
  __typename?: "ProcedureCode";
  codeType: Scalars["String"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["String"]["output"];
  lastUpdated?: Maybe<Scalars["Datetime"]["output"]>;
  longDescription: Scalars["String"]["output"];
  mediumDescription?: Maybe<Scalars["String"]["output"]>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `ProcedureCodeType` that is related to this `ProcedureCode`. */
  procedureCodeTypeByCodeType?: Maybe<ProcedureCodeType>;
  shortDescription: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type ProcedureCodeAggregates = {
  __typename?: "ProcedureCodeAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ProcedureCodeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `ProcedureCode` object types. */
export type ProcedureCodeAggregatesFilter = {
  /** Distinct count aggregate over matching `ProcedureCode` objects. */
  distinctCount?: InputMaybe<ProcedureCodeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ProcedureCode` object to be included within the aggregate. */
  filter?: InputMaybe<ProcedureCodeFilter>;
};

/**
 * A condition to be used against `ProcedureCode` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProcedureCodeCondition = {
  /** Checks for equality with the object’s `codeType` field. */
  codeType?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `longDescription` field. */
  longDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `mediumDescription` field. */
  mediumDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `shortDescription` field. */
  shortDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type ProcedureCodeDistinctCountAggregateFilter = {
  codeType?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastUpdated?: InputMaybe<BigIntFilter>;
  longDescription?: InputMaybe<BigIntFilter>;
  mediumDescription?: InputMaybe<BigIntFilter>;
  shortDescription?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type ProcedureCodeDistinctCountAggregates = {
  __typename?: "ProcedureCodeDistinctCountAggregates";
  /** Distinct count of codeType across the matching connection */
  codeType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of lastUpdated across the matching connection */
  lastUpdated?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of longDescription across the matching connection */
  longDescription?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of mediumDescription across the matching connection */
  mediumDescription?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of shortDescription across the matching connection */
  shortDescription?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ProcedureCode` object types. All fields are combined with a logical ‘and.’ */
export type ProcedureCodeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProcedureCodeFilter>>;
  /** Filter by the object’s `codeType` field. */
  codeType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `longDescription` field. */
  longDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mediumDescription` field. */
  mediumDescription?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProcedureCodeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProcedureCodeFilter>>;
  /** Filter by the object’s `procedureCodeTypeByCodeType` relation. */
  procedureCodeTypeByCodeType?: InputMaybe<ProcedureCodeTypeFilter>;
  /** Filter by the object’s `shortDescription` field. */
  shortDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `ProcedureCode` for usage during aggregation. */
export enum ProcedureCodeGroupBy {
  CODE_TYPE = "CODE_TYPE",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  LAST_UPDATED = "LAST_UPDATED",
  LAST_UPDATED_TRUNCATED_TO_DAY = "LAST_UPDATED_TRUNCATED_TO_DAY",
  LAST_UPDATED_TRUNCATED_TO_HOUR = "LAST_UPDATED_TRUNCATED_TO_HOUR",
  LONG_DESCRIPTION = "LONG_DESCRIPTION",
  MEDIUM_DESCRIPTION = "MEDIUM_DESCRIPTION",
  SHORT_DESCRIPTION = "SHORT_DESCRIPTION",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type ProcedureCodeHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProcedureCodeHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ProcedureCode` aggregates. */
export type ProcedureCodeHavingInput = {
  AND?: InputMaybe<Array<ProcedureCodeHavingInput>>;
  OR?: InputMaybe<Array<ProcedureCodeHavingInput>>;
  average?: InputMaybe<ProcedureCodeHavingAverageInput>;
  distinctCount?: InputMaybe<ProcedureCodeHavingDistinctCountInput>;
  max?: InputMaybe<ProcedureCodeHavingMaxInput>;
  min?: InputMaybe<ProcedureCodeHavingMinInput>;
  stddevPopulation?: InputMaybe<ProcedureCodeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ProcedureCodeHavingStddevSampleInput>;
  sum?: InputMaybe<ProcedureCodeHavingSumInput>;
  variancePopulation?: InputMaybe<ProcedureCodeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ProcedureCodeHavingVarianceSampleInput>;
};

export type ProcedureCodeHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProcedureCodeHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProcedureCodeHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProcedureCodeHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProcedureCodeHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProcedureCodeHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProcedureCodeHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProcedureCodeType = {
  __typename?: "ProcedureCodeType";
  description: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `ProcedureCode`. */
  procedureCodesByCodeType: ProcedureCodesConnection;
  type: Scalars["String"]["output"];
};

export type ProcedureCodeTypeprocedureCodesByCodeTypeArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProcedureCodeCondition>;
  filter?: InputMaybe<ProcedureCodeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProcedureCodesOrderBy>>;
};

export type ProcedureCodeTypeAggregates = {
  __typename?: "ProcedureCodeTypeAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ProcedureCodeTypeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * A condition to be used against `ProcedureCodeType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProcedureCodeTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProcedureCodeTypeDistinctCountAggregates = {
  __typename?: "ProcedureCodeTypeDistinctCountAggregates";
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ProcedureCodeType` object types. All fields are combined with a logical ‘and.’ */
export type ProcedureCodeTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProcedureCodeTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProcedureCodeTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProcedureCodeTypeFilter>>;
  /** Filter by the object’s `procedureCodesByCodeType` relation. */
  procedureCodesByCodeType?: InputMaybe<ProcedureCodeTypeToManyProcedureCodeFilter>;
  /** Some related `procedureCodesByCodeType` exist. */
  procedureCodesByCodeTypeExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** Grouping methods for `ProcedureCodeType` for usage during aggregation. */
export enum ProcedureCodeTypeGroupBy {
  DESCRIPTION = "DESCRIPTION",
}

/** Conditions for `ProcedureCodeType` aggregates. */
export type ProcedureCodeTypeHavingInput = {
  AND?: InputMaybe<Array<ProcedureCodeTypeHavingInput>>;
  OR?: InputMaybe<Array<ProcedureCodeTypeHavingInput>>;
};

/** A filter to be used against many `ProcedureCode` object types. All fields are combined with a logical ‘and.’ */
export type ProcedureCodeTypeToManyProcedureCodeFilter = {
  /** Aggregates across related `ProcedureCode` match the filter criteria. */
  aggregates?: InputMaybe<ProcedureCodeAggregatesFilter>;
  /** Every related `ProcedureCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcedureCodeFilter>;
  /** No related `ProcedureCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcedureCodeFilter>;
  /** Some related `ProcedureCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcedureCodeFilter>;
};

/** A connection to a list of `ProcedureCodeType` values. */
export type ProcedureCodeTypesConnection = {
  __typename?: "ProcedureCodeTypesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ProcedureCodeTypeAggregates>;
  /** A list of edges which contains the `ProcedureCodeType` and cursor to aid in pagination. */
  edges: Array<ProcedureCodeTypesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ProcedureCodeTypeAggregates>>;
  /** A list of `ProcedureCodeType` objects. */
  nodes: Array<Maybe<ProcedureCodeType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcedureCodeType` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ProcedureCodeType` values. */
export type ProcedureCodeTypesConnectiongroupedAggregatesArgs = {
  groupBy: Array<ProcedureCodeTypeGroupBy>;
  having?: InputMaybe<ProcedureCodeTypeHavingInput>;
};

/** A `ProcedureCodeType` edge in the connection. */
export type ProcedureCodeTypesEdge = {
  __typename?: "ProcedureCodeTypesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ProcedureCodeType` at the end of the edge. */
  node?: Maybe<ProcedureCodeType>;
};

/** Methods to use when ordering `ProcedureCodeType`. */
export enum ProcedureCodeTypesOrderBy {
  DESCRIPTION_ASC = "DESCRIPTION_ASC",
  DESCRIPTION_DESC = "DESCRIPTION_DESC",
  NATURAL = "NATURAL",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_CODE_TYPE_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_CODE_TYPE_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_CODE_TYPE_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_CODE_TYPE_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_CREATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_CREATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_CREATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_CREATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_ID_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_ID_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_ID_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_ID_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_LAST_UPDATED_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_LAST_UPDATED_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_LAST_UPDATED_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_LAST_UPDATED_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_LONG_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_LONG_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_LONG_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_LONG_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_MEDIUM_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_MEDIUM_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_MEDIUM_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_MEDIUM_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_SHORT_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_SHORT_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_SHORT_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_SHORT_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_UPDATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_UPDATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_UPDATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_AVERAGE_UPDATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_COUNT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_COUNT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_COUNT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_COUNT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_CODE_TYPE_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_CODE_TYPE_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_CODE_TYPE_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_CODE_TYPE_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_CREATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_CREATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_CREATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_CREATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_ID_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_ID_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_ID_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_ID_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_LAST_UPDATED_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_LAST_UPDATED_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_LAST_UPDATED_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_LAST_UPDATED_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_LONG_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_LONG_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_LONG_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_LONG_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_MEDIUM_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_MEDIUM_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_MEDIUM_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_MEDIUM_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_SHORT_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_SHORT_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_SHORT_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_SHORT_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_UPDATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_UPDATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_UPDATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_DISTINCT_COUNT_UPDATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_CODE_TYPE_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_CODE_TYPE_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_CODE_TYPE_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_CODE_TYPE_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_CREATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_CREATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_CREATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_CREATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_ID_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_ID_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_ID_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_ID_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_LAST_UPDATED_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_LAST_UPDATED_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_LAST_UPDATED_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_LAST_UPDATED_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_LONG_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_LONG_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_LONG_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_LONG_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_MEDIUM_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_MEDIUM_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_MEDIUM_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_MEDIUM_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_SHORT_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_SHORT_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_SHORT_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_SHORT_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_UPDATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_UPDATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MAX_UPDATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MAX_UPDATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_CODE_TYPE_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_CODE_TYPE_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_CODE_TYPE_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_CODE_TYPE_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_CREATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_CREATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_CREATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_CREATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_ID_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_ID_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_ID_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_ID_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_LAST_UPDATED_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_LAST_UPDATED_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_LAST_UPDATED_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_LAST_UPDATED_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_LONG_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_LONG_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_LONG_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_LONG_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_MEDIUM_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_MEDIUM_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_MEDIUM_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_MEDIUM_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_SHORT_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_SHORT_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_SHORT_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_SHORT_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_UPDATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_UPDATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_MIN_UPDATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_MIN_UPDATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_CODE_TYPE_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_CODE_TYPE_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_CODE_TYPE_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_CODE_TYPE_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_CREATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_CREATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_CREATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_CREATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_ID_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_ID_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_ID_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_ID_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_LAST_UPDATED_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_LAST_UPDATED_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_LAST_UPDATED_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_LAST_UPDATED_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_LONG_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_LONG_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_LONG_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_LONG_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_MEDIUM_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_MEDIUM_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_MEDIUM_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_MEDIUM_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_SHORT_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_SHORT_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_SHORT_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_SHORT_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_UPDATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_UPDATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_UPDATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_POPULATION_UPDATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_CODE_TYPE_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_CODE_TYPE_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_CODE_TYPE_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_CODE_TYPE_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_CREATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_CREATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_CREATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_CREATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_ID_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_ID_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_ID_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_ID_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_LAST_UPDATED_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_LAST_UPDATED_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_LAST_UPDATED_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_LAST_UPDATED_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_LONG_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_LONG_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_LONG_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_LONG_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_MEDIUM_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_MEDIUM_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_MEDIUM_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_MEDIUM_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_SHORT_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_SHORT_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_SHORT_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_SHORT_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_UPDATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_UPDATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_UPDATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_STDDEV_SAMPLE_UPDATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_CODE_TYPE_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_CODE_TYPE_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_CODE_TYPE_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_CODE_TYPE_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_CREATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_CREATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_CREATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_CREATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_ID_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_ID_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_ID_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_ID_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_LAST_UPDATED_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_LAST_UPDATED_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_LAST_UPDATED_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_LAST_UPDATED_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_LONG_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_LONG_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_LONG_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_LONG_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_MEDIUM_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_MEDIUM_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_MEDIUM_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_MEDIUM_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_SHORT_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_SHORT_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_SHORT_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_SHORT_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_UPDATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_UPDATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_SUM_UPDATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_SUM_UPDATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_CODE_TYPE_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_CODE_TYPE_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_CODE_TYPE_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_CODE_TYPE_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_CREATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_CREATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_CREATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_CREATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_ID_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_ID_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_ID_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_ID_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_LAST_UPDATED_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_LAST_UPDATED_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_LAST_UPDATED_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_LAST_UPDATED_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_LONG_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_LONG_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_LONG_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_LONG_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_MEDIUM_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_MEDIUM_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_MEDIUM_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_MEDIUM_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_SHORT_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_SHORT_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_SHORT_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_SHORT_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_UPDATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_UPDATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_UPDATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_POPULATION_UPDATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_CODE_TYPE_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_CODE_TYPE_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_CODE_TYPE_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_CODE_TYPE_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_CREATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_CREATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_CREATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_CREATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_ID_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_ID_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_ID_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_ID_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_LAST_UPDATED_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_LAST_UPDATED_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_LAST_UPDATED_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_LAST_UPDATED_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_LONG_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_LONG_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_LONG_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_LONG_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_MEDIUM_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_MEDIUM_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_MEDIUM_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_MEDIUM_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_SHORT_DESCRIPTION_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_SHORT_DESCRIPTION_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_SHORT_DESCRIPTION_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_SHORT_DESCRIPTION_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_UPDATED_AT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_UPDATED_AT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  PROCEDURE_CODES_BY_CODE_TYPE__COUNT_ASC = "PROCEDURE_CODES_BY_CODE_TYPE__COUNT_ASC",
  PROCEDURE_CODES_BY_CODE_TYPE__COUNT_DESC = "PROCEDURE_CODES_BY_CODE_TYPE__COUNT_DESC",
  TYPE_ASC = "TYPE_ASC",
  TYPE_DESC = "TYPE_DESC",
}

/** A connection to a list of `ProcedureCode` values. */
export type ProcedureCodesConnection = {
  __typename?: "ProcedureCodesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ProcedureCodeAggregates>;
  /** A list of edges which contains the `ProcedureCode` and cursor to aid in pagination. */
  edges: Array<ProcedureCodesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ProcedureCodeAggregates>>;
  /** A list of `ProcedureCode` objects. */
  nodes: Array<Maybe<ProcedureCode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcedureCode` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ProcedureCode` values. */
export type ProcedureCodesConnectiongroupedAggregatesArgs = {
  groupBy: Array<ProcedureCodeGroupBy>;
  having?: InputMaybe<ProcedureCodeHavingInput>;
};

/** A `ProcedureCode` edge in the connection. */
export type ProcedureCodesEdge = {
  __typename?: "ProcedureCodesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ProcedureCode` at the end of the edge. */
  node?: Maybe<ProcedureCode>;
};

/** Methods to use when ordering `ProcedureCode`. */
export enum ProcedureCodesOrderBy {
  CODE_TYPE_ASC = "CODE_TYPE_ASC",
  CODE_TYPE_DESC = "CODE_TYPE_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  LAST_UPDATED_ASC = "LAST_UPDATED_ASC",
  LAST_UPDATED_DESC = "LAST_UPDATED_DESC",
  LONG_DESCRIPTION_ASC = "LONG_DESCRIPTION_ASC",
  LONG_DESCRIPTION_DESC = "LONG_DESCRIPTION_DESC",
  MEDIUM_DESCRIPTION_ASC = "MEDIUM_DESCRIPTION_ASC",
  MEDIUM_DESCRIPTION_DESC = "MEDIUM_DESCRIPTION_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROCEDURE_CODE_TYPE_BY_CODE_TYPE__DESCRIPTION_ASC = "PROCEDURE_CODE_TYPE_BY_CODE_TYPE__DESCRIPTION_ASC",
  PROCEDURE_CODE_TYPE_BY_CODE_TYPE__DESCRIPTION_DESC = "PROCEDURE_CODE_TYPE_BY_CODE_TYPE__DESCRIPTION_DESC",
  PROCEDURE_CODE_TYPE_BY_CODE_TYPE__TYPE_ASC = "PROCEDURE_CODE_TYPE_BY_CODE_TYPE__TYPE_ASC",
  PROCEDURE_CODE_TYPE_BY_CODE_TYPE__TYPE_DESC = "PROCEDURE_CODE_TYPE_BY_CODE_TYPE__TYPE_DESC",
  SHORT_DESCRIPTION_ASC = "SHORT_DESCRIPTION_ASC",
  SHORT_DESCRIPTION_DESC = "SHORT_DESCRIPTION_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type PromptFeedback = {
  __typename?: "PromptFeedback";
  cause?: Maybe<Scalars["String"]["output"]>;
  level: PromptFeedbackLevel;
  message: Scalars["String"]["output"];
};

export enum PromptFeedbackLevel {
  ERROR = "ERROR",
  INFO = "INFO",
  WARNING = "WARNING",
}

export type PromptInput = {
  fileIds: Array<Scalars["ID"]["input"]>;
  inputState: Scalars["String"]["input"];
  promptText: Scalars["String"]["input"];
  searchKeywords?: InputMaybe<Array<Scalars["String"]["input"]>>;
  threadId: Scalars["ID"]["input"];
};

export type PromptResponse = {
  __typename?: "PromptResponse";
  contextFiles: Array<File>;
  createdAt: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  pages: Array<PromptResponsePage>;
  promptText: Scalars["String"]["output"];
  ratings: PromptResponseRating;
  responseText: Scalars["String"]["output"];
  searchKeywords?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type PromptResponsePage = {
  __typename?: "PromptResponsePage";
  confidence?: Maybe<Scalars["Float"]["output"]>;
  file: File;
  fileId: Scalars["UUID"]["output"];
  filePageId?: Maybe<Scalars["UUID"]["output"]>;
  pageNumber: Scalars["Int"]["output"];
  textMatched: Scalars["String"]["output"];
};

export type PromptResponseRating = {
  __typename?: "PromptResponseRating";
  currentUserRating?: Maybe<PromptResponseRatingType>;
  downRatings: Scalars["Int"]["output"];
  upRatings: Scalars["Int"]["output"];
};

export enum PromptResponseRatingType {
  DOWN = "DOWN",
  UP = "UP",
}

export type Provider = Node & {
  __typename?: "Provider";
  /** Reads and enables pagination through a set of `AuditFindingReport`. */
  auditFindingReports: AuditFindingReportsConnection;
  /** Reads and enables pagination through a set of `AuditorBucket`. */
  auditorBuckets: AuditorBucketsConnection;
  /** Reads and enables pagination through a set of `AuditorUser`. */
  auditorUsers: AuditorUsersConnection;
  /** Reads and enables pagination through a set of `BatchClaim`. */
  batchClaims: BatchClaimsConnection;
  /**
   * ### billing_city
   *  the billing city for this provider as provided by the client
   */
  billingCity?: Maybe<Scalars["String"]["output"]>;
  /**
   * ### billing_name
   *  the billing name for this provider as provided by the client
   */
  billingName?: Maybe<Scalars["String"]["output"]>;
  /**
   * ### billing_npi
   *  the billing NPI for this provider as provided by the client
   */
  billingNpi?: Maybe<Scalars["String"]["output"]>;
  /**
   * ### billing_state
   *  the billing state for this provider as provided by the client
   */
  billingState?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  /**
   * ### client_billing_id
   *  the id for this billing provider as provided by the client
   */
  clientBillingId?: Maybe<Scalars["String"]["output"]>;
  /**
   * ### client_provider_id
   *  the id for this provider as provided by the client
   */
  clientProviderId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Datetime"]["output"];
  /** Reads and enables pagination through a set of `DisputedFinding`. */
  disputedFindings: DisputedFindingsConnection;
  /** Reads and enables pagination through a set of `DocumentUploadCreated`. */
  documentUploadCreateds: DocumentUploadCreatedsConnection;
  /** Reads and enables pagination through a set of `DocumentationSelectionSet`. */
  documentationSelectionSets: DocumentationSelectionSetsConnection;
  id: Scalars["String"]["output"];
  /**
   * ### Overview
   * Calculates improper payment cost per provider using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Aggregate>;
  /**
   * ### Overview
   * Calculates improper payment cost per claim using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCostPerClaim?: Maybe<Aggregate>;
  name: Scalars["String"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  npi: Scalars["String"]["output"];
  practiceType: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `ProviderUserFacility`. */
  providerUserFacilities: ProviderUserFacilitiesConnection;
  spec?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  supportingDocCount: Scalars["Int"]["output"];
  /**
   * ### tax_ein
   *  the tax ein for this provider as provided by the client
   */
  taxEin?: Maybe<Scalars["String"]["output"]>;
  uniquePatients: Scalars["Int"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type ProviderauditFindingReportsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReportCondition>;
  filter?: InputMaybe<AuditFindingReportFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReportsOrderBy>>;
};

export type ProviderauditorBucketsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditorBucketCondition>;
  filter?: InputMaybe<AuditorBucketFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditorBucketsOrderBy>>;
};

export type ProviderauditorUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditorUserCondition>;
  filter?: InputMaybe<AuditorUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditorUsersOrderBy>>;
};

export type ProviderbatchClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimCondition>;
  filter?: InputMaybe<BatchClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimsOrderBy>>;
};

export type ProviderdisputedFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DisputedFindingCondition>;
  filter?: InputMaybe<DisputedFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DisputedFindingsOrderBy>>;
};

export type ProviderdocumentUploadCreatedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentUploadCreatedCondition>;
  filter?: InputMaybe<DocumentUploadCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentUploadCreatedsOrderBy>>;
};

export type ProviderdocumentationSelectionSetsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentationSelectionSetCondition>;
  filter?: InputMaybe<DocumentationSelectionSetFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentationSelectionSetsOrderBy>>;
};

export type ProviderimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProviderimproperPaymentCostPerClaimArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProviderproviderUserFacilitiesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProviderUserFacilityCondition>;
  filter?: InputMaybe<ProviderUserFacilityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProviderUserFacilitiesOrderBy>>;
};

export type ProviderAggregates = {
  __typename?: "ProviderAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ProviderDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type ProviderAuditStat = {
  __typename?: "ProviderAuditStat";
  autoImproperPaymentCost: Aggregate;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  potentialImproperPaymentCost: Aggregate;
};

/**
 * Per-provider claim-state breakdown for the homepage table (scoped by role).
 * Not for PROVIDER — use providerDashboardSummary instead.
 */
export type ProviderClaimsMetrics = {
  __typename?: "ProviderClaimsMetrics";
  claimsAwaitingDocumentation: Scalars["Int"]["output"];
  /** Claims with documentation_claim_state DOCUMENTS_RECEIVED (awaiting ingestion). */
  claimsAwaitingIngestion: Scalars["Int"]["output"];
  /** Historic reviewed claims (see statistics claimsReviewed). */
  claimsReviewed: Scalars["Int"]["output"];
  /** Active under-review claims (IN_PROGRESS within active pool). */
  claimsUnderReview: Scalars["Int"]["output"];
  providerId: Scalars["String"]["output"];
  providerName: Scalars["String"]["output"];
  providerNpi: Scalars["String"]["output"];
};

/**
 * A condition to be used against `Provider` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProviderCondition = {
  /** Checks for equality with the object’s `billingCity` field. */
  billingCity?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `billingName` field. */
  billingName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `billingNpi` field. */
  billingNpi?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `billingState` field. */
  billingState?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `clientBillingId` field. */
  clientBillingId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `clientProviderId` field. */
  clientProviderId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `npi` field. */
  npi?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `practiceType` field. */
  practiceType?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `spec` field. */
  spec?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `taxEin` field. */
  taxEin?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type ProviderDashboardSummary = {
  __typename?: "ProviderDashboardSummary";
  claimsAwaitingDocumentIngestion: Scalars["Int"]["output"];
  claimsAwaitingDocuments: Scalars["Int"]["output"];
};

export type ProviderDistinctCountAggregates = {
  __typename?: "ProviderDistinctCountAggregates";
  /** Distinct count of billingCity across the matching connection */
  billingCity?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of billingName across the matching connection */
  billingName?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of billingNpi across the matching connection */
  billingNpi?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of billingState across the matching connection */
  billingState?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of city across the matching connection */
  city?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientBillingId across the matching connection */
  clientBillingId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of clientProviderId across the matching connection */
  clientProviderId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Calculates improper payment cost per provider using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCost?: Maybe<Scalars["BigInt"]["output"]>;
  /**
   * Distinct count of this field across the matching connection.
   *
   * ---
   *
   * ### Overview
   * Calculates improper payment cost per claim using heuristics to omit certain findings generated by Autodor.
   */
  improperPaymentCostPerClaim?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of npi across the matching connection */
  npi?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of practiceType across the matching connection */
  practiceType?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of spec across the matching connection */
  spec?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of state across the matching connection */
  state?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of taxEin across the matching connection */
  taxEin?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

export type ProviderDistinctCountAggregatesimproperPaymentCostArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProviderDistinctCountAggregatesimproperPaymentCostPerClaimArgs = {
  autodorVersionUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `Provider` object types. All fields are combined with a logical ‘and.’ */
export type ProviderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProviderFilter>>;
  /** Filter by the object’s `auditFindingReports` relation. */
  auditFindingReports?: InputMaybe<ProviderToManyAuditFindingReportFilter>;
  /** Some related `auditFindingReports` exist. */
  auditFindingReportsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `auditorBuckets` relation. */
  auditorBuckets?: InputMaybe<ProviderToManyAuditorBucketFilter>;
  /** Some related `auditorBuckets` exist. */
  auditorBucketsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `auditorUsers` relation. */
  auditorUsers?: InputMaybe<ProviderToManyAuditorUserFilter>;
  /** Some related `auditorUsers` exist. */
  auditorUsersExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `batchClaims` relation. */
  batchClaims?: InputMaybe<ProviderToManyBatchClaimFilter>;
  /** Some related `batchClaims` exist. */
  batchClaimsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `billingCity` field. */
  billingCity?: InputMaybe<StringFilter>;
  /** Filter by the object’s `billingName` field. */
  billingName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `billingNpi` field. */
  billingNpi?: InputMaybe<StringFilter>;
  /** Filter by the object’s `billingState` field. */
  billingState?: InputMaybe<StringFilter>;
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientBillingId` field. */
  clientBillingId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientProviderId` field. */
  clientProviderId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `disputedFindings` relation. */
  disputedFindings?: InputMaybe<ProviderToManyDisputedFindingFilter>;
  /** Some related `disputedFindings` exist. */
  disputedFindingsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `documentUploadCreateds` relation. */
  documentUploadCreateds?: InputMaybe<ProviderToManyDocumentUploadCreatedFilter>;
  /** Some related `documentUploadCreateds` exist. */
  documentUploadCreatedsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `documentationSelectionSets` relation. */
  documentationSelectionSets?: InputMaybe<ProviderToManyDocumentationSelectionSetFilter>;
  /** Some related `documentationSelectionSets` exist. */
  documentationSelectionSetsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProviderFilter>;
  /** Filter by the object’s `npi` field. */
  npi?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProviderFilter>>;
  /** Filter by the object’s `practiceType` field. */
  practiceType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `providerUserFacilities` relation. */
  providerUserFacilities?: InputMaybe<ProviderToManyProviderUserFacilityFilter>;
  /** Some related `providerUserFacilities` exist. */
  providerUserFacilitiesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `spec` field. */
  spec?: InputMaybe<StringFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<StringFilter>;
  /** Filter by the object’s `taxEin` field. */
  taxEin?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `Provider` for usage during aggregation. */
export enum ProviderGroupBy {
  BILLING_CITY = "BILLING_CITY",
  BILLING_NAME = "BILLING_NAME",
  BILLING_NPI = "BILLING_NPI",
  BILLING_STATE = "BILLING_STATE",
  CITY = "CITY",
  CLIENT_BILLING_ID = "CLIENT_BILLING_ID",
  CLIENT_PROVIDER_ID = "CLIENT_PROVIDER_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  NAME = "NAME",
  NPI = "NPI",
  PRACTICE_TYPE = "PRACTICE_TYPE",
  SPEC = "SPEC",
  STATE = "STATE",
  TAX_EIN = "TAX_EIN",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type ProviderHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Provider` aggregates. */
export type ProviderHavingInput = {
  AND?: InputMaybe<Array<ProviderHavingInput>>;
  OR?: InputMaybe<Array<ProviderHavingInput>>;
  average?: InputMaybe<ProviderHavingAverageInput>;
  distinctCount?: InputMaybe<ProviderHavingDistinctCountInput>;
  max?: InputMaybe<ProviderHavingMaxInput>;
  min?: InputMaybe<ProviderHavingMinInput>;
  stddevPopulation?: InputMaybe<ProviderHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ProviderHavingStddevSampleInput>;
  sum?: InputMaybe<ProviderHavingSumInput>;
  variancePopulation?: InputMaybe<ProviderHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ProviderHavingVarianceSampleInput>;
};

export type ProviderHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ProviderNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `provider` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ProviderOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReport` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: AuditFindingReportPatch;
  };

/** The fields on `provider` to look up the row to update. */
export type ProviderOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyUsingProviderPkeyUpdate =
  {
    id: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: updateProviderOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ProviderOnAuditorBucketForFkeyAuditorBucketProviderIdNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorBucket` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorBucket` being updated. */
    patch: AuditorBucketPatch;
  };

/** The fields on `provider` to look up the row to update. */
export type ProviderOnAuditorBucketForFkeyAuditorBucketProviderIdUsingProviderPkeyUpdate =
  {
    id: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: updateProviderOnAuditorBucketForFkeyAuditorBucketProviderIdPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ProviderOnAuditorUserForAuditorUserProviderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `auditorUser` being updated. */
  patch: AuditorUserPatch;
};

/** The fields on `provider` to look up the row to update. */
export type ProviderOnAuditorUserForAuditorUserProviderIdFkeyUsingProviderPkeyUpdate =
  {
    id: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: updateProviderOnAuditorUserForAuditorUserProviderIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ProviderOnBatchClaimForBatchClaimProviderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `batchClaim` being updated. */
  patch: BatchClaimPatch;
};

/** The fields on `provider` to look up the row to update. */
export type ProviderOnBatchClaimForBatchClaimProviderIdFkeyUsingProviderPkeyUpdate =
  {
    id: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: updateProviderOnBatchClaimForBatchClaimProviderIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ProviderOnDisputedFindingForDisputedFindingProviderIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `disputedFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `disputedFinding` being updated. */
    patch: DisputedFindingPatch;
  };

/** The fields on `provider` to look up the row to update. */
export type ProviderOnDisputedFindingForDisputedFindingProviderIdFkeyUsingProviderPkeyUpdate =
  {
    id: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: updateProviderOnDisputedFindingForDisputedFindingProviderIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ProviderOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `documentUploadCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
    patch: DocumentUploadCreatedPatch;
  };

/** The fields on `provider` to look up the row to update. */
export type ProviderOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyUsingProviderPkeyUpdate =
  {
    id: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: updateProviderOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ProviderOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `documentationSelectionSet` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `documentationSelectionSet` being updated. */
    patch: DocumentationSelectionSetPatch;
  };

/** The fields on `provider` to look up the row to update. */
export type ProviderOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyUsingProviderPkeyUpdate =
  {
    id: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: updateProviderOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ProviderOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `providerUserFacility` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `providerUserFacility` being updated. */
    patch: ProviderUserFacilityPatch;
  };

/** The fields on `provider` to look up the row to update. */
export type ProviderOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyUsingProviderPkeyUpdate =
  {
    id: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: updateProviderOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyPatch;
  };

/** Represents an update to a `Provider`. Fields that are set will be updated. */
export type ProviderPatch = {
  auditFindingReportsUsingId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInverseInput>;
  auditorBucketsUsingId?: InputMaybe<FkeyAuditorBucketProviderIdInverseInput>;
  auditorUsersUsingId?: InputMaybe<AuditorUserProviderIdFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimProviderIdFkeyInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingProviderIdFkeyInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInverseInput>;
  documentationSelectionSetsUsingId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInverseInput>;
  providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInverseInput>;
};

/** The fields on `provider` to look up the row to connect. */
export type ProviderProviderPkeyConnect = {
  id: Scalars["String"]["input"];
};

export type ProviderSignOffClaimState = Node & {
  __typename?: "ProviderSignOffClaimState";
  /** Reads a single `BatchClaim` that is related to this `ProviderSignOffClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  providerSignOffState: Scalars["String"]["output"];
};

export type ProviderSignOffClaimStateAggregates = {
  __typename?: "ProviderSignOffClaimStateAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ProviderSignOffClaimStateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `ProviderSignOffClaimState` object types. */
export type ProviderSignOffClaimStateAggregatesFilter = {
  /** Distinct count aggregate over matching `ProviderSignOffClaimState` objects. */
  distinctCount?: InputMaybe<ProviderSignOffClaimStateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ProviderSignOffClaimState` object to be included within the aggregate. */
  filter?: InputMaybe<ProviderSignOffClaimStateFilter>;
};

/** Input for the nested mutation of `batchClaim` in the `ProviderSignOffClaimStateInput` mutation. */
export type ProviderSignOffClaimStateBatchClaimIdFkInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProviderSignOffClaimStateOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkNodeIdUpdate>;
};

/** Input for the nested mutation of `providerSignOffClaimState` in the `BatchClaimInput` mutation. */
export type ProviderSignOffClaimStateBatchClaimIdFkInverseInput = {
  /** The primary key(s) for `providerSignOffClaimState` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ProviderSignOffClaimStateProviderSignOffClaimStatePkeyConnect>
  >;
  /** The primary key(s) for `providerSignOffClaimState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProviderSignOffClaimStateNodeIdConnect>>;
  /** A `ProviderSignOffClaimStateInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ProviderSignOffClaimStateBatchClaimIdFkProviderSignOffClaimStateCreateInput>
  >;
  /** The primary key(s) and patch data for `providerSignOffClaimState` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProviderSignOffClaimStateOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkUsingProviderSignOffClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `providerSignOffClaimState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkNodeIdUpdate>
  >;
};

/** The `providerSignOffClaimState` to be created by this mutation. */
export type ProviderSignOffClaimStateBatchClaimIdFkProviderSignOffClaimStateCreateInput =
  {
    batchClaimToBatchClaimId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    providerSignOffState?: InputMaybe<Scalars["String"]["input"]>;
  };

/**
 * A condition to be used against `ProviderSignOffClaimState` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProviderSignOffClaimStateCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `providerSignOffState` field. */
  providerSignOffState?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProviderSignOffClaimStateDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  providerSignOffState?: InputMaybe<BigIntFilter>;
};

export type ProviderSignOffClaimStateDistinctCountAggregates = {
  __typename?: "ProviderSignOffClaimStateDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of providerSignOffState across the matching connection */
  providerSignOffState?: Maybe<Scalars["BigInt"]["output"]>;
};

export enum ProviderSignOffClaimStateEnum {
  PROVIDER_NO_SIGN_OFF = "PROVIDER_NO_SIGN_OFF",
  PROVIDER_SIGN_OFF = "PROVIDER_SIGN_OFF",
}

/** A filter to be used against ProviderSignOffClaimStateEnum fields. All fields are combined with a logical ‘and.’ */
export type ProviderSignOffClaimStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ProviderSignOffClaimStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ProviderSignOffClaimStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ProviderSignOffClaimStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ProviderSignOffClaimStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ProviderSignOffClaimStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ProviderSignOffClaimStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ProviderSignOffClaimStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ProviderSignOffClaimStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ProviderSignOffClaimStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ProviderSignOffClaimStateEnum>>;
};

/** A filter to be used against `ProviderSignOffClaimState` object types. All fields are combined with a logical ‘and.’ */
export type ProviderSignOffClaimStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProviderSignOffClaimStateFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProviderSignOffClaimStateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProviderSignOffClaimStateFilter>>;
  /** Filter by the object’s `providerSignOffState` field. */
  providerSignOffState?: InputMaybe<StringFilter>;
};

/** Grouping methods for `ProviderSignOffClaimState` for usage during aggregation. */
export enum ProviderSignOffClaimStateGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  PROVIDER_SIGN_OFF_STATE = "PROVIDER_SIGN_OFF_STATE",
}

export type ProviderSignOffClaimStateHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderSignOffClaimStateHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ProviderSignOffClaimState` aggregates. */
export type ProviderSignOffClaimStateHavingInput = {
  AND?: InputMaybe<Array<ProviderSignOffClaimStateHavingInput>>;
  OR?: InputMaybe<Array<ProviderSignOffClaimStateHavingInput>>;
  average?: InputMaybe<ProviderSignOffClaimStateHavingAverageInput>;
  distinctCount?: InputMaybe<ProviderSignOffClaimStateHavingDistinctCountInput>;
  max?: InputMaybe<ProviderSignOffClaimStateHavingMaxInput>;
  min?: InputMaybe<ProviderSignOffClaimStateHavingMinInput>;
  stddevPopulation?: InputMaybe<ProviderSignOffClaimStateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ProviderSignOffClaimStateHavingStddevSampleInput>;
  sum?: InputMaybe<ProviderSignOffClaimStateHavingSumInput>;
  variancePopulation?: InputMaybe<ProviderSignOffClaimStateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ProviderSignOffClaimStateHavingVarianceSampleInput>;
};

export type ProviderSignOffClaimStateHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderSignOffClaimStateHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderSignOffClaimStateHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderSignOffClaimStateHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderSignOffClaimStateHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderSignOffClaimStateHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderSignOffClaimStateHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `ProviderSignOffClaimState` */
export type ProviderSignOffClaimStateInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  providerSignOffState?: InputMaybe<Scalars["String"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ProviderSignOffClaimStateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `providerSignOffClaimState` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ProviderSignOffClaimStateOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `providerSignOffClaimState` to look up the row to update. */
export type ProviderSignOffClaimStateOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkUsingProviderSignOffClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `providerSignOffClaimState` being updated. */
    patch: updateProviderSignOffClaimStateOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkPatch;
  };

/** Represents an update to a `ProviderSignOffClaimState`. Fields that are set will be updated. */
export type ProviderSignOffClaimStatePatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInput>;
};

/** The fields on `providerSignOffClaimState` to look up the row to connect. */
export type ProviderSignOffClaimStateProviderSignOffClaimStatePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `ProviderSignOffClaimState` values. */
export type ProviderSignOffClaimStatesConnection = {
  __typename?: "ProviderSignOffClaimStatesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ProviderSignOffClaimStateAggregates>;
  /** A list of edges which contains the `ProviderSignOffClaimState` and cursor to aid in pagination. */
  edges: Array<ProviderSignOffClaimStatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ProviderSignOffClaimStateAggregates>>;
  /** A list of `ProviderSignOffClaimState` objects. */
  nodes: Array<Maybe<ProviderSignOffClaimState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProviderSignOffClaimState` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ProviderSignOffClaimState` values. */
export type ProviderSignOffClaimStatesConnectiongroupedAggregatesArgs = {
  groupBy: Array<ProviderSignOffClaimStateGroupBy>;
  having?: InputMaybe<ProviderSignOffClaimStateHavingInput>;
};

/** A `ProviderSignOffClaimState` edge in the connection. */
export type ProviderSignOffClaimStatesEdge = {
  __typename?: "ProviderSignOffClaimStatesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ProviderSignOffClaimState` at the end of the edge. */
  node?: Maybe<ProviderSignOffClaimState>;
};

/** Methods to use when ordering `ProviderSignOffClaimState`. */
export enum ProviderSignOffClaimStatesOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROVIDER_SIGN_OFF_STATE_ASC = "PROVIDER_SIGN_OFF_STATE_ASC",
  PROVIDER_SIGN_OFF_STATE_DESC = "PROVIDER_SIGN_OFF_STATE_DESC",
}

/** A filter to be used against many `AuditFindingReport` object types. All fields are combined with a logical ‘and.’ */
export type ProviderToManyAuditFindingReportFilter = {
  /** Aggregates across related `AuditFindingReport` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingReportAggregatesFilter>;
  /** Every related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingReportFilter>;
  /** No related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingReportFilter>;
  /** Some related `AuditFindingReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingReportFilter>;
};

/** A filter to be used against many `AuditorBucket` object types. All fields are combined with a logical ‘and.’ */
export type ProviderToManyAuditorBucketFilter = {
  /** Aggregates across related `AuditorBucket` match the filter criteria. */
  aggregates?: InputMaybe<AuditorBucketAggregatesFilter>;
  /** Every related `AuditorBucket` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditorBucketFilter>;
  /** No related `AuditorBucket` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditorBucketFilter>;
  /** Some related `AuditorBucket` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditorBucketFilter>;
};

/** A filter to be used against many `AuditorUser` object types. All fields are combined with a logical ‘and.’ */
export type ProviderToManyAuditorUserFilter = {
  /** Aggregates across related `AuditorUser` match the filter criteria. */
  aggregates?: InputMaybe<AuditorUserAggregatesFilter>;
  /** Every related `AuditorUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditorUserFilter>;
  /** No related `AuditorUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditorUserFilter>;
  /** Some related `AuditorUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditorUserFilter>;
};

/** A filter to be used against many `BatchClaim` object types. All fields are combined with a logical ‘and.’ */
export type ProviderToManyBatchClaimFilter = {
  /** Aggregates across related `BatchClaim` match the filter criteria. */
  aggregates?: InputMaybe<BatchClaimAggregatesFilter>;
  /** Every related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BatchClaimFilter>;
  /** No related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BatchClaimFilter>;
  /** Some related `BatchClaim` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BatchClaimFilter>;
};

/** A filter to be used against many `DisputedFinding` object types. All fields are combined with a logical ‘and.’ */
export type ProviderToManyDisputedFindingFilter = {
  /** Aggregates across related `DisputedFinding` match the filter criteria. */
  aggregates?: InputMaybe<DisputedFindingAggregatesFilter>;
  /** Every related `DisputedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DisputedFindingFilter>;
  /** No related `DisputedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DisputedFindingFilter>;
  /** Some related `DisputedFinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DisputedFindingFilter>;
};

/** A filter to be used against many `DocumentUploadCreated` object types. All fields are combined with a logical ‘and.’ */
export type ProviderToManyDocumentUploadCreatedFilter = {
  /** Aggregates across related `DocumentUploadCreated` match the filter criteria. */
  aggregates?: InputMaybe<DocumentUploadCreatedAggregatesFilter>;
  /** Every related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUploadCreatedFilter>;
  /** No related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUploadCreatedFilter>;
  /** Some related `DocumentUploadCreated` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUploadCreatedFilter>;
};

/** A filter to be used against many `DocumentationSelectionSet` object types. All fields are combined with a logical ‘and.’ */
export type ProviderToManyDocumentationSelectionSetFilter = {
  /** Aggregates across related `DocumentationSelectionSet` match the filter criteria. */
  aggregates?: InputMaybe<DocumentationSelectionSetAggregatesFilter>;
  /** Every related `DocumentationSelectionSet` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentationSelectionSetFilter>;
  /** No related `DocumentationSelectionSet` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentationSelectionSetFilter>;
  /** Some related `DocumentationSelectionSet` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentationSelectionSetFilter>;
};

/** A filter to be used against many `ProviderUserFacility` object types. All fields are combined with a logical ‘and.’ */
export type ProviderToManyProviderUserFacilityFilter = {
  /** Aggregates across related `ProviderUserFacility` match the filter criteria. */
  aggregates?: InputMaybe<ProviderUserFacilityAggregatesFilter>;
  /** Every related `ProviderUserFacility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProviderUserFacilityFilter>;
  /** No related `ProviderUserFacility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProviderUserFacilityFilter>;
  /** Some related `ProviderUserFacility` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProviderUserFacilityFilter>;
};

/** Input for the nested mutation of `auditorUser` in the `ProviderUserFacilityInput` mutation. */
export type ProviderUserFacilitiesAuditorUserIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `providerUserFacility` in the `AuditorUserInput` mutation. */
export type ProviderUserFacilitiesAuditorUserIdFkeyInverseInput = {
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ProviderUserFacilityProviderUserFacilitiesPkeyConnect>
  >;
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProviderUserFacilityNodeIdConnect>>;
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  connectByProviderIdAndAuditorUserId?: InputMaybe<
    Array<ProviderUserFacilityProviderUserFacilitiesAuditorUserIdUniqueConnect>
  >;
  /** A `ProviderUserFacilityInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ProviderUserFacilitiesAuditorUserIdFkeyProviderUserFacilitiesCreateInput>
  >;
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ProviderUserFacilityProviderUserFacilitiesPkeyDelete>
  >;
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProviderUserFacilityNodeIdDelete>>;
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  deleteByProviderIdAndAuditorUserId?: InputMaybe<
    Array<ProviderUserFacilityProviderUserFacilitiesAuditorUserIdUniqueDelete>
  >;
  /** Flag indicating whether all other `providerUserFacility` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `providerUserFacility` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyUsingProviderUserFacilitiesPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `providerUserFacility` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyNodeIdUpdate>
  >;
  /** The primary key(s) and patch data for `providerUserFacility` for the far side of the relationship. */
  updateByProviderIdAndAuditorUserId?: InputMaybe<
    Array<ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyUsingProviderUserFacilitiesAuditorUserIdUniqueUpdate>
  >;
};

/** The `providerUserFacility` to be created by this mutation. */
export type ProviderUserFacilitiesAuditorUserIdFkeyProviderUserFacilitiesCreateInput =
  {
    auditorUserToAuditorUserId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** A connection to a list of `ProviderUserFacility` values. */
export type ProviderUserFacilitiesConnection = {
  __typename?: "ProviderUserFacilitiesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ProviderUserFacilityAggregates>;
  /** A list of edges which contains the `ProviderUserFacility` and cursor to aid in pagination. */
  edges: Array<ProviderUserFacilitiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ProviderUserFacilityAggregates>>;
  /** A list of `ProviderUserFacility` objects. */
  nodes: Array<Maybe<ProviderUserFacility>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProviderUserFacility` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ProviderUserFacility` values. */
export type ProviderUserFacilitiesConnectiongroupedAggregatesArgs = {
  groupBy: Array<ProviderUserFacilitiesGroupBy>;
  having?: InputMaybe<ProviderUserFacilitiesHavingInput>;
};

/** A `ProviderUserFacility` edge in the connection. */
export type ProviderUserFacilitiesEdge = {
  __typename?: "ProviderUserFacilitiesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ProviderUserFacility` at the end of the edge. */
  node?: Maybe<ProviderUserFacility>;
};

/** Grouping methods for `ProviderUserFacility` for usage during aggregation. */
export enum ProviderUserFacilitiesGroupBy {
  AUDITOR_USER_ID = "AUDITOR_USER_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  PROVIDER_ID = "PROVIDER_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type ProviderUserFacilitiesHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderUserFacilitiesHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ProviderUserFacility` aggregates. */
export type ProviderUserFacilitiesHavingInput = {
  AND?: InputMaybe<Array<ProviderUserFacilitiesHavingInput>>;
  OR?: InputMaybe<Array<ProviderUserFacilitiesHavingInput>>;
  average?: InputMaybe<ProviderUserFacilitiesHavingAverageInput>;
  distinctCount?: InputMaybe<ProviderUserFacilitiesHavingDistinctCountInput>;
  max?: InputMaybe<ProviderUserFacilitiesHavingMaxInput>;
  min?: InputMaybe<ProviderUserFacilitiesHavingMinInput>;
  stddevPopulation?: InputMaybe<ProviderUserFacilitiesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ProviderUserFacilitiesHavingStddevSampleInput>;
  sum?: InputMaybe<ProviderUserFacilitiesHavingSumInput>;
  variancePopulation?: InputMaybe<ProviderUserFacilitiesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ProviderUserFacilitiesHavingVarianceSampleInput>;
};

export type ProviderUserFacilitiesHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderUserFacilitiesHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderUserFacilitiesHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderUserFacilitiesHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderUserFacilitiesHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderUserFacilitiesHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ProviderUserFacilitiesHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `ProviderUserFacility`. */
export enum ProviderUserFacilitiesOrderBy {
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC",
  AUDITOR_USER_ID_ASC = "AUDITOR_USER_ID_ASC",
  AUDITOR_USER_ID_DESC = "AUDITOR_USER_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC = "PROVIDER_BY_PROVIDER_ID__BILLING_STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__CITY_ASC = "PROVIDER_BY_PROVIDER_ID__CITY_ASC",
  PROVIDER_BY_PROVIDER_ID__CITY_DESC = "PROVIDER_BY_PROVIDER_ID__CITY_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_BILLING_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_ASC",
  PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC = "PROVIDER_BY_PROVIDER_ID__CLIENT_PROVIDER_ID_DESC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__CREATED_AT_DESC",
  PROVIDER_BY_PROVIDER_ID__ID_ASC = "PROVIDER_BY_PROVIDER_ID__ID_ASC",
  PROVIDER_BY_PROVIDER_ID__ID_DESC = "PROVIDER_BY_PROVIDER_ID__ID_DESC",
  PROVIDER_BY_PROVIDER_ID__NAME_ASC = "PROVIDER_BY_PROVIDER_ID__NAME_ASC",
  PROVIDER_BY_PROVIDER_ID__NAME_DESC = "PROVIDER_BY_PROVIDER_ID__NAME_DESC",
  PROVIDER_BY_PROVIDER_ID__NPI_ASC = "PROVIDER_BY_PROVIDER_ID__NPI_ASC",
  PROVIDER_BY_PROVIDER_ID__NPI_DESC = "PROVIDER_BY_PROVIDER_ID__NPI_DESC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_ASC",
  PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC = "PROVIDER_BY_PROVIDER_ID__PRACTICE_TYPE_DESC",
  PROVIDER_BY_PROVIDER_ID__SPEC_ASC = "PROVIDER_BY_PROVIDER_ID__SPEC_ASC",
  PROVIDER_BY_PROVIDER_ID__SPEC_DESC = "PROVIDER_BY_PROVIDER_ID__SPEC_DESC",
  PROVIDER_BY_PROVIDER_ID__STATE_ASC = "PROVIDER_BY_PROVIDER_ID__STATE_ASC",
  PROVIDER_BY_PROVIDER_ID__STATE_DESC = "PROVIDER_BY_PROVIDER_ID__STATE_DESC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_ASC",
  PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC = "PROVIDER_BY_PROVIDER_ID__TAX_EIN_DESC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_ASC",
  PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC = "PROVIDER_BY_PROVIDER_ID__UPDATED_AT_DESC",
  PROVIDER_ID_ASC = "PROVIDER_ID_ASC",
  PROVIDER_ID_DESC = "PROVIDER_ID_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** Input for the nested mutation of `provider` in the `ProviderUserFacilityInput` mutation. */
export type ProviderUserFacilitiesProviderIdFkeyInput = {
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectById?: InputMaybe<ProviderProviderPkeyConnect>;
  /** The primary key(s) for `provider` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProviderNodeIdConnect>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateById?: InputMaybe<ProviderOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyUsingProviderPkeyUpdate>;
  /** The primary key(s) and patch data for `provider` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `providerUserFacility` in the `ProviderInput` mutation. */
export type ProviderUserFacilitiesProviderIdFkeyInverseInput = {
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ProviderUserFacilityProviderUserFacilitiesPkeyConnect>
  >;
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProviderUserFacilityNodeIdConnect>>;
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  connectByProviderIdAndAuditorUserId?: InputMaybe<
    Array<ProviderUserFacilityProviderUserFacilitiesAuditorUserIdUniqueConnect>
  >;
  /** A `ProviderUserFacilityInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ProviderUserFacilitiesProviderIdFkeyProviderUserFacilitiesCreateInput>
  >;
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ProviderUserFacilityProviderUserFacilitiesPkeyDelete>
  >;
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProviderUserFacilityNodeIdDelete>>;
  /** The primary key(s) for `providerUserFacility` for the far side of the relationship. */
  deleteByProviderIdAndAuditorUserId?: InputMaybe<
    Array<ProviderUserFacilityProviderUserFacilitiesAuditorUserIdUniqueDelete>
  >;
  /** Flag indicating whether all other `providerUserFacility` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `providerUserFacility` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyUsingProviderUserFacilitiesPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `providerUserFacility` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<ProviderOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyNodeIdUpdate>
  >;
  /** The primary key(s) and patch data for `providerUserFacility` for the far side of the relationship. */
  updateByProviderIdAndAuditorUserId?: InputMaybe<
    Array<ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyUsingProviderUserFacilitiesAuditorUserIdUniqueUpdate>
  >;
};

/** The `providerUserFacility` to be created by this mutation. */
export type ProviderUserFacilitiesProviderIdFkeyProviderUserFacilitiesCreateInput =
  {
    auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuditorUserId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    providerToProviderId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

export type ProviderUserFacility = Node & {
  __typename?: "ProviderUserFacility";
  /** Reads a single `AuditorUser` that is related to this `ProviderUserFacility`. */
  auditorUser?: Maybe<AuditorUser>;
  auditorUserId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  /** Reads a single `Provider` that is related to this `ProviderUserFacility`. */
  provider?: Maybe<Provider>;
  providerId: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type ProviderUserFacilityAggregates = {
  __typename?: "ProviderUserFacilityAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ProviderUserFacilityDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `ProviderUserFacility` object types. */
export type ProviderUserFacilityAggregatesFilter = {
  /** Distinct count aggregate over matching `ProviderUserFacility` objects. */
  distinctCount?: InputMaybe<ProviderUserFacilityDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ProviderUserFacility` object to be included within the aggregate. */
  filter?: InputMaybe<ProviderUserFacilityFilter>;
};

/**
 * A condition to be used against `ProviderUserFacility` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ProviderUserFacilityCondition = {
  /** Checks for equality with the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type ProviderUserFacilityDistinctCountAggregateFilter = {
  auditorUserId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  providerId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type ProviderUserFacilityDistinctCountAggregates = {
  __typename?: "ProviderUserFacilityDistinctCountAggregates";
  /** Distinct count of auditorUserId across the matching connection */
  auditorUserId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of providerId across the matching connection */
  providerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ProviderUserFacility` object types. All fields are combined with a logical ‘and.’ */
export type ProviderUserFacilityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProviderUserFacilityFilter>>;
  /** Filter by the object’s `auditorUser` relation. */
  auditorUser?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProviderUserFacilityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProviderUserFacilityFilter>>;
  /** Filter by the object’s `provider` relation. */
  provider?: InputMaybe<ProviderFilter>;
  /** Filter by the object’s `providerId` field. */
  providerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProviderUserFacility` */
export type ProviderUserFacilityInput = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ProviderUserFacilityNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `providerUserFacility` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to delete. */
export type ProviderUserFacilityNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `providerUserFacility` to be deleted. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `providerUserFacility` to look up the row to update. */
export type ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyUsingProviderUserFacilitiesAuditorUserIdUniqueUpdate =
  {
    auditorUserId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `providerUserFacility` being updated. */
    patch: updateProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyPatch;
    providerId: Scalars["String"]["input"];
  };

/** The fields on `providerUserFacility` to look up the row to update. */
export type ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyUsingProviderUserFacilitiesPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `providerUserFacility` being updated. */
    patch: updateProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `provider` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `provider` being updated. */
    patch: ProviderPatch;
  };

/** The fields on `providerUserFacility` to look up the row to update. */
export type ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyUsingProviderUserFacilitiesAuditorUserIdUniqueUpdate =
  {
    auditorUserId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `providerUserFacility` being updated. */
    patch: updateProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyPatch;
    providerId: Scalars["String"]["input"];
  };

/** The fields on `providerUserFacility` to look up the row to update. */
export type ProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyUsingProviderUserFacilitiesPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `providerUserFacility` being updated. */
    patch: updateProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyPatch;
  };

/** Represents an update to a `ProviderUserFacility`. Fields that are set will be updated. */
export type ProviderUserFacilityPatch = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The fields on `providerUserFacility` to look up the row to connect. */
export type ProviderUserFacilityProviderUserFacilitiesAuditorUserIdUniqueConnect =
  {
    auditorUserId: Scalars["UUID"]["input"];
    providerId: Scalars["String"]["input"];
  };

/** The fields on `providerUserFacility` to look up the row to delete. */
export type ProviderUserFacilityProviderUserFacilitiesAuditorUserIdUniqueDelete =
  {
    auditorUserId: Scalars["UUID"]["input"];
    providerId: Scalars["String"]["input"];
  };

/** The fields on `providerUserFacility` to look up the row to connect. */
export type ProviderUserFacilityProviderUserFacilitiesPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `providerUserFacility` to look up the row to delete. */
export type ProviderUserFacilityProviderUserFacilitiesPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `Provider` values. */
export type ProvidersConnection = {
  __typename?: "ProvidersConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ProviderAggregates>;
  /** A list of edges which contains the `Provider` and cursor to aid in pagination. */
  edges: Array<ProvidersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ProviderAggregates>>;
  /** A list of `Provider` objects. */
  nodes: Array<Maybe<Provider>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Provider` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `Provider` values. */
export type ProvidersConnectiongroupedAggregatesArgs = {
  groupBy: Array<ProviderGroupBy>;
  having?: InputMaybe<ProviderHavingInput>;
};

/** A `Provider` edge in the connection. */
export type ProvidersEdge = {
  __typename?: "ProvidersEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Provider` at the end of the edge. */
  node?: Maybe<Provider>;
};

/** Methods to use when ordering `Provider`. */
export enum ProvidersOrderBy {
  AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_AVERAGE_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_AVERAGE_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_AVERAGE_CREATED_AT_ASC = "AUDITOR_BUCKETS_AVERAGE_CREATED_AT_ASC",
  AUDITOR_BUCKETS_AVERAGE_CREATED_AT_DESC = "AUDITOR_BUCKETS_AVERAGE_CREATED_AT_DESC",
  AUDITOR_BUCKETS_AVERAGE_DUE_DATE_ASC = "AUDITOR_BUCKETS_AVERAGE_DUE_DATE_ASC",
  AUDITOR_BUCKETS_AVERAGE_DUE_DATE_DESC = "AUDITOR_BUCKETS_AVERAGE_DUE_DATE_DESC",
  AUDITOR_BUCKETS_AVERAGE_FILTER_ASC = "AUDITOR_BUCKETS_AVERAGE_FILTER_ASC",
  AUDITOR_BUCKETS_AVERAGE_FILTER_DESC = "AUDITOR_BUCKETS_AVERAGE_FILTER_DESC",
  AUDITOR_BUCKETS_AVERAGE_ID_ASC = "AUDITOR_BUCKETS_AVERAGE_ID_ASC",
  AUDITOR_BUCKETS_AVERAGE_ID_DESC = "AUDITOR_BUCKETS_AVERAGE_ID_DESC",
  AUDITOR_BUCKETS_AVERAGE_INSURER_ID_ASC = "AUDITOR_BUCKETS_AVERAGE_INSURER_ID_ASC",
  AUDITOR_BUCKETS_AVERAGE_INSURER_ID_DESC = "AUDITOR_BUCKETS_AVERAGE_INSURER_ID_DESC",
  AUDITOR_BUCKETS_AVERAGE_NAME_ASC = "AUDITOR_BUCKETS_AVERAGE_NAME_ASC",
  AUDITOR_BUCKETS_AVERAGE_NAME_DESC = "AUDITOR_BUCKETS_AVERAGE_NAME_DESC",
  AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_AVERAGE_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_ASC = "AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_DESC = "AUDITOR_BUCKETS_AVERAGE_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_BY_PROVIDER_ID__COUNT_ASC = "AUDITOR_BUCKETS_BY_PROVIDER_ID__COUNT_ASC",
  AUDITOR_BUCKETS_BY_PROVIDER_ID__COUNT_DESC = "AUDITOR_BUCKETS_BY_PROVIDER_ID__COUNT_DESC",
  AUDITOR_BUCKETS_COUNT_ASC = "AUDITOR_BUCKETS_COUNT_ASC",
  AUDITOR_BUCKETS_COUNT_DESC = "AUDITOR_BUCKETS_COUNT_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_DUE_DATE_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_FILTER_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_ID_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_ID_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_ID_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_ID_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_INSURER_ID_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_NAME_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDITOR_BUCKETS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_MAX_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_MAX_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_MAX_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_MAX_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_MAX_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_MAX_CREATED_AT_ASC = "AUDITOR_BUCKETS_MAX_CREATED_AT_ASC",
  AUDITOR_BUCKETS_MAX_CREATED_AT_DESC = "AUDITOR_BUCKETS_MAX_CREATED_AT_DESC",
  AUDITOR_BUCKETS_MAX_DUE_DATE_ASC = "AUDITOR_BUCKETS_MAX_DUE_DATE_ASC",
  AUDITOR_BUCKETS_MAX_DUE_DATE_DESC = "AUDITOR_BUCKETS_MAX_DUE_DATE_DESC",
  AUDITOR_BUCKETS_MAX_FILTER_ASC = "AUDITOR_BUCKETS_MAX_FILTER_ASC",
  AUDITOR_BUCKETS_MAX_FILTER_DESC = "AUDITOR_BUCKETS_MAX_FILTER_DESC",
  AUDITOR_BUCKETS_MAX_ID_ASC = "AUDITOR_BUCKETS_MAX_ID_ASC",
  AUDITOR_BUCKETS_MAX_ID_DESC = "AUDITOR_BUCKETS_MAX_ID_DESC",
  AUDITOR_BUCKETS_MAX_INSURER_ID_ASC = "AUDITOR_BUCKETS_MAX_INSURER_ID_ASC",
  AUDITOR_BUCKETS_MAX_INSURER_ID_DESC = "AUDITOR_BUCKETS_MAX_INSURER_ID_DESC",
  AUDITOR_BUCKETS_MAX_NAME_ASC = "AUDITOR_BUCKETS_MAX_NAME_ASC",
  AUDITOR_BUCKETS_MAX_NAME_DESC = "AUDITOR_BUCKETS_MAX_NAME_DESC",
  AUDITOR_BUCKETS_MAX_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_MAX_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_MAX_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_MAX_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_MAX_UPDATED_AT_ASC = "AUDITOR_BUCKETS_MAX_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_MAX_UPDATED_AT_DESC = "AUDITOR_BUCKETS_MAX_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_MIN_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_MIN_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_MIN_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_MIN_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_MIN_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_MIN_CREATED_AT_ASC = "AUDITOR_BUCKETS_MIN_CREATED_AT_ASC",
  AUDITOR_BUCKETS_MIN_CREATED_AT_DESC = "AUDITOR_BUCKETS_MIN_CREATED_AT_DESC",
  AUDITOR_BUCKETS_MIN_DUE_DATE_ASC = "AUDITOR_BUCKETS_MIN_DUE_DATE_ASC",
  AUDITOR_BUCKETS_MIN_DUE_DATE_DESC = "AUDITOR_BUCKETS_MIN_DUE_DATE_DESC",
  AUDITOR_BUCKETS_MIN_FILTER_ASC = "AUDITOR_BUCKETS_MIN_FILTER_ASC",
  AUDITOR_BUCKETS_MIN_FILTER_DESC = "AUDITOR_BUCKETS_MIN_FILTER_DESC",
  AUDITOR_BUCKETS_MIN_ID_ASC = "AUDITOR_BUCKETS_MIN_ID_ASC",
  AUDITOR_BUCKETS_MIN_ID_DESC = "AUDITOR_BUCKETS_MIN_ID_DESC",
  AUDITOR_BUCKETS_MIN_INSURER_ID_ASC = "AUDITOR_BUCKETS_MIN_INSURER_ID_ASC",
  AUDITOR_BUCKETS_MIN_INSURER_ID_DESC = "AUDITOR_BUCKETS_MIN_INSURER_ID_DESC",
  AUDITOR_BUCKETS_MIN_NAME_ASC = "AUDITOR_BUCKETS_MIN_NAME_ASC",
  AUDITOR_BUCKETS_MIN_NAME_DESC = "AUDITOR_BUCKETS_MIN_NAME_DESC",
  AUDITOR_BUCKETS_MIN_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_MIN_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_MIN_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_MIN_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_MIN_UPDATED_AT_ASC = "AUDITOR_BUCKETS_MIN_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_MIN_UPDATED_AT_DESC = "AUDITOR_BUCKETS_MIN_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_DUE_DATE_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_FILTER_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_ID_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_ID_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_INSURER_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_NAME_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDITOR_BUCKETS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_DUE_DATE_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_FILTER_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_INSURER_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_NAME_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDITOR_BUCKETS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_SUM_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_SUM_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_SUM_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_SUM_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_SUM_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_SUM_CREATED_AT_ASC = "AUDITOR_BUCKETS_SUM_CREATED_AT_ASC",
  AUDITOR_BUCKETS_SUM_CREATED_AT_DESC = "AUDITOR_BUCKETS_SUM_CREATED_AT_DESC",
  AUDITOR_BUCKETS_SUM_DUE_DATE_ASC = "AUDITOR_BUCKETS_SUM_DUE_DATE_ASC",
  AUDITOR_BUCKETS_SUM_DUE_DATE_DESC = "AUDITOR_BUCKETS_SUM_DUE_DATE_DESC",
  AUDITOR_BUCKETS_SUM_FILTER_ASC = "AUDITOR_BUCKETS_SUM_FILTER_ASC",
  AUDITOR_BUCKETS_SUM_FILTER_DESC = "AUDITOR_BUCKETS_SUM_FILTER_DESC",
  AUDITOR_BUCKETS_SUM_ID_ASC = "AUDITOR_BUCKETS_SUM_ID_ASC",
  AUDITOR_BUCKETS_SUM_ID_DESC = "AUDITOR_BUCKETS_SUM_ID_DESC",
  AUDITOR_BUCKETS_SUM_INSURER_ID_ASC = "AUDITOR_BUCKETS_SUM_INSURER_ID_ASC",
  AUDITOR_BUCKETS_SUM_INSURER_ID_DESC = "AUDITOR_BUCKETS_SUM_INSURER_ID_DESC",
  AUDITOR_BUCKETS_SUM_NAME_ASC = "AUDITOR_BUCKETS_SUM_NAME_ASC",
  AUDITOR_BUCKETS_SUM_NAME_DESC = "AUDITOR_BUCKETS_SUM_NAME_DESC",
  AUDITOR_BUCKETS_SUM_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_SUM_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_SUM_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_SUM_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_SUM_UPDATED_AT_ASC = "AUDITOR_BUCKETS_SUM_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_SUM_UPDATED_AT_DESC = "AUDITOR_BUCKETS_SUM_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_DUE_DATE_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_FILTER_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_INSURER_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_NAME_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDITOR_BUCKETS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_ASSIGNEE_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_DUE_DATE_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_FILTER_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_NAME_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDITOR_BUCKETS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDITOR_USERS_AVERAGE_CREATED_AT_ASC = "AUDITOR_USERS_AVERAGE_CREATED_AT_ASC",
  AUDITOR_USERS_AVERAGE_CREATED_AT_DESC = "AUDITOR_USERS_AVERAGE_CREATED_AT_DESC",
  AUDITOR_USERS_AVERAGE_EMAIL_ASC = "AUDITOR_USERS_AVERAGE_EMAIL_ASC",
  AUDITOR_USERS_AVERAGE_EMAIL_DESC = "AUDITOR_USERS_AVERAGE_EMAIL_DESC",
  AUDITOR_USERS_AVERAGE_FIRST_NAME_ASC = "AUDITOR_USERS_AVERAGE_FIRST_NAME_ASC",
  AUDITOR_USERS_AVERAGE_FIRST_NAME_DESC = "AUDITOR_USERS_AVERAGE_FIRST_NAME_DESC",
  AUDITOR_USERS_AVERAGE_IDP_SUB_ASC = "AUDITOR_USERS_AVERAGE_IDP_SUB_ASC",
  AUDITOR_USERS_AVERAGE_IDP_SUB_DESC = "AUDITOR_USERS_AVERAGE_IDP_SUB_DESC",
  AUDITOR_USERS_AVERAGE_ID_ASC = "AUDITOR_USERS_AVERAGE_ID_ASC",
  AUDITOR_USERS_AVERAGE_ID_DESC = "AUDITOR_USERS_AVERAGE_ID_DESC",
  AUDITOR_USERS_AVERAGE_INTERNAL_ONLY_ASC = "AUDITOR_USERS_AVERAGE_INTERNAL_ONLY_ASC",
  AUDITOR_USERS_AVERAGE_INTERNAL_ONLY_DESC = "AUDITOR_USERS_AVERAGE_INTERNAL_ONLY_DESC",
  AUDITOR_USERS_AVERAGE_LAST_NAME_ASC = "AUDITOR_USERS_AVERAGE_LAST_NAME_ASC",
  AUDITOR_USERS_AVERAGE_LAST_NAME_DESC = "AUDITOR_USERS_AVERAGE_LAST_NAME_DESC",
  AUDITOR_USERS_AVERAGE_MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USERS_AVERAGE_MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USERS_AVERAGE_MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USERS_AVERAGE_MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USERS_AVERAGE_PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USERS_AVERAGE_PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USERS_AVERAGE_PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USERS_AVERAGE_PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USERS_AVERAGE_PROVIDER_ID_ASC = "AUDITOR_USERS_AVERAGE_PROVIDER_ID_ASC",
  AUDITOR_USERS_AVERAGE_PROVIDER_ID_DESC = "AUDITOR_USERS_AVERAGE_PROVIDER_ID_DESC",
  AUDITOR_USERS_AVERAGE_READ_ONLY_ASC = "AUDITOR_USERS_AVERAGE_READ_ONLY_ASC",
  AUDITOR_USERS_AVERAGE_READ_ONLY_DESC = "AUDITOR_USERS_AVERAGE_READ_ONLY_DESC",
  AUDITOR_USERS_AVERAGE_TITLE_ASC = "AUDITOR_USERS_AVERAGE_TITLE_ASC",
  AUDITOR_USERS_AVERAGE_TITLE_DESC = "AUDITOR_USERS_AVERAGE_TITLE_DESC",
  AUDITOR_USERS_AVERAGE_UPDATED_AT_ASC = "AUDITOR_USERS_AVERAGE_UPDATED_AT_ASC",
  AUDITOR_USERS_AVERAGE_UPDATED_AT_DESC = "AUDITOR_USERS_AVERAGE_UPDATED_AT_DESC",
  AUDITOR_USERS_AVERAGE_USER_TYPE_ASC = "AUDITOR_USERS_AVERAGE_USER_TYPE_ASC",
  AUDITOR_USERS_AVERAGE_USER_TYPE_DESC = "AUDITOR_USERS_AVERAGE_USER_TYPE_DESC",
  AUDITOR_USERS_BY_PROVIDER_ID__COUNT_ASC = "AUDITOR_USERS_BY_PROVIDER_ID__COUNT_ASC",
  AUDITOR_USERS_BY_PROVIDER_ID__COUNT_DESC = "AUDITOR_USERS_BY_PROVIDER_ID__COUNT_DESC",
  AUDITOR_USERS_COUNT_ASC = "AUDITOR_USERS_COUNT_ASC",
  AUDITOR_USERS_COUNT_DESC = "AUDITOR_USERS_COUNT_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_CREATED_AT_ASC = "AUDITOR_USERS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_CREATED_AT_DESC = "AUDITOR_USERS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_EMAIL_ASC = "AUDITOR_USERS_DISTINCT_COUNT_EMAIL_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_EMAIL_DESC = "AUDITOR_USERS_DISTINCT_COUNT_EMAIL_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_FIRST_NAME_ASC = "AUDITOR_USERS_DISTINCT_COUNT_FIRST_NAME_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_FIRST_NAME_DESC = "AUDITOR_USERS_DISTINCT_COUNT_FIRST_NAME_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_IDP_SUB_ASC = "AUDITOR_USERS_DISTINCT_COUNT_IDP_SUB_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_IDP_SUB_DESC = "AUDITOR_USERS_DISTINCT_COUNT_IDP_SUB_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_ID_ASC = "AUDITOR_USERS_DISTINCT_COUNT_ID_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_ID_DESC = "AUDITOR_USERS_DISTINCT_COUNT_ID_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_INTERNAL_ONLY_ASC = "AUDITOR_USERS_DISTINCT_COUNT_INTERNAL_ONLY_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_INTERNAL_ONLY_DESC = "AUDITOR_USERS_DISTINCT_COUNT_INTERNAL_ONLY_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_LAST_NAME_ASC = "AUDITOR_USERS_DISTINCT_COUNT_LAST_NAME_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_LAST_NAME_DESC = "AUDITOR_USERS_DISTINCT_COUNT_LAST_NAME_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USERS_DISTINCT_COUNT_MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USERS_DISTINCT_COUNT_MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USERS_DISTINCT_COUNT_PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USERS_DISTINCT_COUNT_PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUDITOR_USERS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUDITOR_USERS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_READ_ONLY_ASC = "AUDITOR_USERS_DISTINCT_COUNT_READ_ONLY_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_READ_ONLY_DESC = "AUDITOR_USERS_DISTINCT_COUNT_READ_ONLY_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_TITLE_ASC = "AUDITOR_USERS_DISTINCT_COUNT_TITLE_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_TITLE_DESC = "AUDITOR_USERS_DISTINCT_COUNT_TITLE_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDITOR_USERS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDITOR_USERS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDITOR_USERS_DISTINCT_COUNT_USER_TYPE_ASC = "AUDITOR_USERS_DISTINCT_COUNT_USER_TYPE_ASC",
  AUDITOR_USERS_DISTINCT_COUNT_USER_TYPE_DESC = "AUDITOR_USERS_DISTINCT_COUNT_USER_TYPE_DESC",
  AUDITOR_USERS_MAX_CREATED_AT_ASC = "AUDITOR_USERS_MAX_CREATED_AT_ASC",
  AUDITOR_USERS_MAX_CREATED_AT_DESC = "AUDITOR_USERS_MAX_CREATED_AT_DESC",
  AUDITOR_USERS_MAX_EMAIL_ASC = "AUDITOR_USERS_MAX_EMAIL_ASC",
  AUDITOR_USERS_MAX_EMAIL_DESC = "AUDITOR_USERS_MAX_EMAIL_DESC",
  AUDITOR_USERS_MAX_FIRST_NAME_ASC = "AUDITOR_USERS_MAX_FIRST_NAME_ASC",
  AUDITOR_USERS_MAX_FIRST_NAME_DESC = "AUDITOR_USERS_MAX_FIRST_NAME_DESC",
  AUDITOR_USERS_MAX_IDP_SUB_ASC = "AUDITOR_USERS_MAX_IDP_SUB_ASC",
  AUDITOR_USERS_MAX_IDP_SUB_DESC = "AUDITOR_USERS_MAX_IDP_SUB_DESC",
  AUDITOR_USERS_MAX_ID_ASC = "AUDITOR_USERS_MAX_ID_ASC",
  AUDITOR_USERS_MAX_ID_DESC = "AUDITOR_USERS_MAX_ID_DESC",
  AUDITOR_USERS_MAX_INTERNAL_ONLY_ASC = "AUDITOR_USERS_MAX_INTERNAL_ONLY_ASC",
  AUDITOR_USERS_MAX_INTERNAL_ONLY_DESC = "AUDITOR_USERS_MAX_INTERNAL_ONLY_DESC",
  AUDITOR_USERS_MAX_LAST_NAME_ASC = "AUDITOR_USERS_MAX_LAST_NAME_ASC",
  AUDITOR_USERS_MAX_LAST_NAME_DESC = "AUDITOR_USERS_MAX_LAST_NAME_DESC",
  AUDITOR_USERS_MAX_MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USERS_MAX_MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USERS_MAX_MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USERS_MAX_MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USERS_MAX_PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USERS_MAX_PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USERS_MAX_PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USERS_MAX_PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USERS_MAX_PROVIDER_ID_ASC = "AUDITOR_USERS_MAX_PROVIDER_ID_ASC",
  AUDITOR_USERS_MAX_PROVIDER_ID_DESC = "AUDITOR_USERS_MAX_PROVIDER_ID_DESC",
  AUDITOR_USERS_MAX_READ_ONLY_ASC = "AUDITOR_USERS_MAX_READ_ONLY_ASC",
  AUDITOR_USERS_MAX_READ_ONLY_DESC = "AUDITOR_USERS_MAX_READ_ONLY_DESC",
  AUDITOR_USERS_MAX_TITLE_ASC = "AUDITOR_USERS_MAX_TITLE_ASC",
  AUDITOR_USERS_MAX_TITLE_DESC = "AUDITOR_USERS_MAX_TITLE_DESC",
  AUDITOR_USERS_MAX_UPDATED_AT_ASC = "AUDITOR_USERS_MAX_UPDATED_AT_ASC",
  AUDITOR_USERS_MAX_UPDATED_AT_DESC = "AUDITOR_USERS_MAX_UPDATED_AT_DESC",
  AUDITOR_USERS_MAX_USER_TYPE_ASC = "AUDITOR_USERS_MAX_USER_TYPE_ASC",
  AUDITOR_USERS_MAX_USER_TYPE_DESC = "AUDITOR_USERS_MAX_USER_TYPE_DESC",
  AUDITOR_USERS_MIN_CREATED_AT_ASC = "AUDITOR_USERS_MIN_CREATED_AT_ASC",
  AUDITOR_USERS_MIN_CREATED_AT_DESC = "AUDITOR_USERS_MIN_CREATED_AT_DESC",
  AUDITOR_USERS_MIN_EMAIL_ASC = "AUDITOR_USERS_MIN_EMAIL_ASC",
  AUDITOR_USERS_MIN_EMAIL_DESC = "AUDITOR_USERS_MIN_EMAIL_DESC",
  AUDITOR_USERS_MIN_FIRST_NAME_ASC = "AUDITOR_USERS_MIN_FIRST_NAME_ASC",
  AUDITOR_USERS_MIN_FIRST_NAME_DESC = "AUDITOR_USERS_MIN_FIRST_NAME_DESC",
  AUDITOR_USERS_MIN_IDP_SUB_ASC = "AUDITOR_USERS_MIN_IDP_SUB_ASC",
  AUDITOR_USERS_MIN_IDP_SUB_DESC = "AUDITOR_USERS_MIN_IDP_SUB_DESC",
  AUDITOR_USERS_MIN_ID_ASC = "AUDITOR_USERS_MIN_ID_ASC",
  AUDITOR_USERS_MIN_ID_DESC = "AUDITOR_USERS_MIN_ID_DESC",
  AUDITOR_USERS_MIN_INTERNAL_ONLY_ASC = "AUDITOR_USERS_MIN_INTERNAL_ONLY_ASC",
  AUDITOR_USERS_MIN_INTERNAL_ONLY_DESC = "AUDITOR_USERS_MIN_INTERNAL_ONLY_DESC",
  AUDITOR_USERS_MIN_LAST_NAME_ASC = "AUDITOR_USERS_MIN_LAST_NAME_ASC",
  AUDITOR_USERS_MIN_LAST_NAME_DESC = "AUDITOR_USERS_MIN_LAST_NAME_DESC",
  AUDITOR_USERS_MIN_MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USERS_MIN_MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USERS_MIN_MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USERS_MIN_MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USERS_MIN_PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USERS_MIN_PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USERS_MIN_PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USERS_MIN_PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USERS_MIN_PROVIDER_ID_ASC = "AUDITOR_USERS_MIN_PROVIDER_ID_ASC",
  AUDITOR_USERS_MIN_PROVIDER_ID_DESC = "AUDITOR_USERS_MIN_PROVIDER_ID_DESC",
  AUDITOR_USERS_MIN_READ_ONLY_ASC = "AUDITOR_USERS_MIN_READ_ONLY_ASC",
  AUDITOR_USERS_MIN_READ_ONLY_DESC = "AUDITOR_USERS_MIN_READ_ONLY_DESC",
  AUDITOR_USERS_MIN_TITLE_ASC = "AUDITOR_USERS_MIN_TITLE_ASC",
  AUDITOR_USERS_MIN_TITLE_DESC = "AUDITOR_USERS_MIN_TITLE_DESC",
  AUDITOR_USERS_MIN_UPDATED_AT_ASC = "AUDITOR_USERS_MIN_UPDATED_AT_ASC",
  AUDITOR_USERS_MIN_UPDATED_AT_DESC = "AUDITOR_USERS_MIN_UPDATED_AT_DESC",
  AUDITOR_USERS_MIN_USER_TYPE_ASC = "AUDITOR_USERS_MIN_USER_TYPE_ASC",
  AUDITOR_USERS_MIN_USER_TYPE_DESC = "AUDITOR_USERS_MIN_USER_TYPE_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_CREATED_AT_ASC = "AUDITOR_USERS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_CREATED_AT_DESC = "AUDITOR_USERS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_EMAIL_ASC = "AUDITOR_USERS_STDDEV_POPULATION_EMAIL_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_EMAIL_DESC = "AUDITOR_USERS_STDDEV_POPULATION_EMAIL_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_FIRST_NAME_ASC = "AUDITOR_USERS_STDDEV_POPULATION_FIRST_NAME_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_FIRST_NAME_DESC = "AUDITOR_USERS_STDDEV_POPULATION_FIRST_NAME_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_IDP_SUB_ASC = "AUDITOR_USERS_STDDEV_POPULATION_IDP_SUB_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_IDP_SUB_DESC = "AUDITOR_USERS_STDDEV_POPULATION_IDP_SUB_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_ID_ASC = "AUDITOR_USERS_STDDEV_POPULATION_ID_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_ID_DESC = "AUDITOR_USERS_STDDEV_POPULATION_ID_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_INTERNAL_ONLY_ASC = "AUDITOR_USERS_STDDEV_POPULATION_INTERNAL_ONLY_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_INTERNAL_ONLY_DESC = "AUDITOR_USERS_STDDEV_POPULATION_INTERNAL_ONLY_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_LAST_NAME_ASC = "AUDITOR_USERS_STDDEV_POPULATION_LAST_NAME_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_LAST_NAME_DESC = "AUDITOR_USERS_STDDEV_POPULATION_LAST_NAME_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USERS_STDDEV_POPULATION_MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USERS_STDDEV_POPULATION_MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USERS_STDDEV_POPULATION_PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USERS_STDDEV_POPULATION_PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUDITOR_USERS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUDITOR_USERS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_READ_ONLY_ASC = "AUDITOR_USERS_STDDEV_POPULATION_READ_ONLY_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_READ_ONLY_DESC = "AUDITOR_USERS_STDDEV_POPULATION_READ_ONLY_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_TITLE_ASC = "AUDITOR_USERS_STDDEV_POPULATION_TITLE_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_TITLE_DESC = "AUDITOR_USERS_STDDEV_POPULATION_TITLE_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDITOR_USERS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDITOR_USERS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDITOR_USERS_STDDEV_POPULATION_USER_TYPE_ASC = "AUDITOR_USERS_STDDEV_POPULATION_USER_TYPE_ASC",
  AUDITOR_USERS_STDDEV_POPULATION_USER_TYPE_DESC = "AUDITOR_USERS_STDDEV_POPULATION_USER_TYPE_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_EMAIL_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_EMAIL_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_EMAIL_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_EMAIL_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_FIRST_NAME_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_FIRST_NAME_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_FIRST_NAME_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_FIRST_NAME_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_IDP_SUB_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_IDP_SUB_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_IDP_SUB_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_IDP_SUB_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_ID_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_ID_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_ID_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_ID_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_INTERNAL_ONLY_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_INTERNAL_ONLY_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_INTERNAL_ONLY_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_INTERNAL_ONLY_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_LAST_NAME_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_LAST_NAME_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_LAST_NAME_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_LAST_NAME_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_READ_ONLY_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_READ_ONLY_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_READ_ONLY_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_READ_ONLY_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_TITLE_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_TITLE_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_TITLE_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_TITLE_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDITOR_USERS_STDDEV_SAMPLE_USER_TYPE_ASC = "AUDITOR_USERS_STDDEV_SAMPLE_USER_TYPE_ASC",
  AUDITOR_USERS_STDDEV_SAMPLE_USER_TYPE_DESC = "AUDITOR_USERS_STDDEV_SAMPLE_USER_TYPE_DESC",
  AUDITOR_USERS_SUM_CREATED_AT_ASC = "AUDITOR_USERS_SUM_CREATED_AT_ASC",
  AUDITOR_USERS_SUM_CREATED_AT_DESC = "AUDITOR_USERS_SUM_CREATED_AT_DESC",
  AUDITOR_USERS_SUM_EMAIL_ASC = "AUDITOR_USERS_SUM_EMAIL_ASC",
  AUDITOR_USERS_SUM_EMAIL_DESC = "AUDITOR_USERS_SUM_EMAIL_DESC",
  AUDITOR_USERS_SUM_FIRST_NAME_ASC = "AUDITOR_USERS_SUM_FIRST_NAME_ASC",
  AUDITOR_USERS_SUM_FIRST_NAME_DESC = "AUDITOR_USERS_SUM_FIRST_NAME_DESC",
  AUDITOR_USERS_SUM_IDP_SUB_ASC = "AUDITOR_USERS_SUM_IDP_SUB_ASC",
  AUDITOR_USERS_SUM_IDP_SUB_DESC = "AUDITOR_USERS_SUM_IDP_SUB_DESC",
  AUDITOR_USERS_SUM_ID_ASC = "AUDITOR_USERS_SUM_ID_ASC",
  AUDITOR_USERS_SUM_ID_DESC = "AUDITOR_USERS_SUM_ID_DESC",
  AUDITOR_USERS_SUM_INTERNAL_ONLY_ASC = "AUDITOR_USERS_SUM_INTERNAL_ONLY_ASC",
  AUDITOR_USERS_SUM_INTERNAL_ONLY_DESC = "AUDITOR_USERS_SUM_INTERNAL_ONLY_DESC",
  AUDITOR_USERS_SUM_LAST_NAME_ASC = "AUDITOR_USERS_SUM_LAST_NAME_ASC",
  AUDITOR_USERS_SUM_LAST_NAME_DESC = "AUDITOR_USERS_SUM_LAST_NAME_DESC",
  AUDITOR_USERS_SUM_MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USERS_SUM_MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USERS_SUM_MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USERS_SUM_MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USERS_SUM_PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USERS_SUM_PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USERS_SUM_PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USERS_SUM_PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USERS_SUM_PROVIDER_ID_ASC = "AUDITOR_USERS_SUM_PROVIDER_ID_ASC",
  AUDITOR_USERS_SUM_PROVIDER_ID_DESC = "AUDITOR_USERS_SUM_PROVIDER_ID_DESC",
  AUDITOR_USERS_SUM_READ_ONLY_ASC = "AUDITOR_USERS_SUM_READ_ONLY_ASC",
  AUDITOR_USERS_SUM_READ_ONLY_DESC = "AUDITOR_USERS_SUM_READ_ONLY_DESC",
  AUDITOR_USERS_SUM_TITLE_ASC = "AUDITOR_USERS_SUM_TITLE_ASC",
  AUDITOR_USERS_SUM_TITLE_DESC = "AUDITOR_USERS_SUM_TITLE_DESC",
  AUDITOR_USERS_SUM_UPDATED_AT_ASC = "AUDITOR_USERS_SUM_UPDATED_AT_ASC",
  AUDITOR_USERS_SUM_UPDATED_AT_DESC = "AUDITOR_USERS_SUM_UPDATED_AT_DESC",
  AUDITOR_USERS_SUM_USER_TYPE_ASC = "AUDITOR_USERS_SUM_USER_TYPE_ASC",
  AUDITOR_USERS_SUM_USER_TYPE_DESC = "AUDITOR_USERS_SUM_USER_TYPE_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_EMAIL_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_EMAIL_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_EMAIL_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_EMAIL_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_FIRST_NAME_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_FIRST_NAME_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_FIRST_NAME_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_FIRST_NAME_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_IDP_SUB_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_IDP_SUB_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_IDP_SUB_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_IDP_SUB_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_ID_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_ID_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_ID_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_ID_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_INTERNAL_ONLY_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_INTERNAL_ONLY_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_INTERNAL_ONLY_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_INTERNAL_ONLY_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_LAST_NAME_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_LAST_NAME_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_LAST_NAME_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_LAST_NAME_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_READ_ONLY_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_READ_ONLY_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_READ_ONLY_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_READ_ONLY_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_TITLE_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_TITLE_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_TITLE_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_TITLE_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDITOR_USERS_VARIANCE_POPULATION_USER_TYPE_ASC = "AUDITOR_USERS_VARIANCE_POPULATION_USER_TYPE_ASC",
  AUDITOR_USERS_VARIANCE_POPULATION_USER_TYPE_DESC = "AUDITOR_USERS_VARIANCE_POPULATION_USER_TYPE_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_EMAIL_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_EMAIL_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_EMAIL_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_EMAIL_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_FIRST_NAME_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_FIRST_NAME_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_FIRST_NAME_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_FIRST_NAME_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_IDP_SUB_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_IDP_SUB_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_IDP_SUB_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_IDP_SUB_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_ID_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_ID_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_ID_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_ID_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_INTERNAL_ONLY_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_INTERNAL_ONLY_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_INTERNAL_ONLY_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_INTERNAL_ONLY_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_LAST_NAME_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_LAST_NAME_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_LAST_NAME_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_LAST_NAME_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_READ_ONLY_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_READ_ONLY_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_READ_ONLY_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_READ_ONLY_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_TITLE_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_TITLE_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_TITLE_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_TITLE_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDITOR_USERS_VARIANCE_SAMPLE_USER_TYPE_ASC = "AUDITOR_USERS_VARIANCE_SAMPLE_USER_TYPE_ASC",
  AUDITOR_USERS_VARIANCE_SAMPLE_USER_TYPE_DESC = "AUDITOR_USERS_VARIANCE_SAMPLE_USER_TYPE_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_TITLE_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_TITLE_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_AVERAGE_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_BY_PROVIDER_ID__COUNT_ASC = "AUDIT_FINDING_REPORTS_BY_PROVIDER_ID__COUNT_ASC",
  AUDIT_FINDING_REPORTS_BY_PROVIDER_ID__COUNT_DESC = "AUDIT_FINDING_REPORTS_BY_PROVIDER_ID__COUNT_DESC",
  AUDIT_FINDING_REPORTS_COUNT_ASC = "AUDIT_FINDING_REPORTS_COUNT_ASC",
  AUDIT_FINDING_REPORTS_COUNT_DESC = "AUDIT_FINDING_REPORTS_COUNT_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_TITLE_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_DISTINCT_COUNT_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_MAX_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_MAX_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_MAX_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_MAX_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_MAX_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_MAX_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_MAX_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_MAX_S3_URL_ASC = "AUDIT_FINDING_REPORTS_MAX_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_MAX_S3_URL_DESC = "AUDIT_FINDING_REPORTS_MAX_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_MAX_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_MAX_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_MAX_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_MAX_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_MAX_TITLE_ASC = "AUDIT_FINDING_REPORTS_MAX_TITLE_ASC",
  AUDIT_FINDING_REPORTS_MAX_TITLE_DESC = "AUDIT_FINDING_REPORTS_MAX_TITLE_DESC",
  AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_MAX_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_MAX_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_MAX_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_MAX_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_MAX_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_MIN_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_MIN_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_MIN_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_MIN_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_MIN_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_MIN_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_MIN_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_MIN_S3_URL_ASC = "AUDIT_FINDING_REPORTS_MIN_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_MIN_S3_URL_DESC = "AUDIT_FINDING_REPORTS_MIN_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_MIN_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_MIN_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_MIN_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_MIN_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_MIN_TITLE_ASC = "AUDIT_FINDING_REPORTS_MIN_TITLE_ASC",
  AUDIT_FINDING_REPORTS_MIN_TITLE_DESC = "AUDIT_FINDING_REPORTS_MIN_TITLE_DESC",
  AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_MIN_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_MIN_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_MIN_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_MIN_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_MIN_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_TITLE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_POPULATION_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_STDDEV_SAMPLE_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_SUM_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_SUM_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_SUM_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_SUM_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_SUM_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_SUM_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_SUM_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_SUM_S3_URL_ASC = "AUDIT_FINDING_REPORTS_SUM_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_SUM_S3_URL_DESC = "AUDIT_FINDING_REPORTS_SUM_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_SUM_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_SUM_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_SUM_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_SUM_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_SUM_TITLE_ASC = "AUDIT_FINDING_REPORTS_SUM_TITLE_ASC",
  AUDIT_FINDING_REPORTS_SUM_TITLE_DESC = "AUDIT_FINDING_REPORTS_SUM_TITLE_DESC",
  AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_SUM_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_SUM_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_SUM_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_SUM_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_SUM_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_TITLE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_POPULATION_VIEW_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_URL_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_S3_VERSION_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_TITLE_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_ASC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_ASC",
  AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_DESC = "AUDIT_FINDING_REPORTS_VARIANCE_SAMPLE_VIEW_ID_DESC",
  BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_AVERAGE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_AVERAGE_ADM_TYPE_ASC = "BATCH_CLAIMS_AVERAGE_ADM_TYPE_ASC",
  BATCH_CLAIMS_AVERAGE_ADM_TYPE_DESC = "BATCH_CLAIMS_AVERAGE_ADM_TYPE_DESC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_AVERAGE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_AVERAGE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_AVERAGE_APR_DRG_ASC = "BATCH_CLAIMS_AVERAGE_APR_DRG_ASC",
  BATCH_CLAIMS_AVERAGE_APR_DRG_DESC = "BATCH_CLAIMS_AVERAGE_APR_DRG_DESC",
  BATCH_CLAIMS_AVERAGE_AUTHOR_ID_ASC = "BATCH_CLAIMS_AVERAGE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_AVERAGE_AUTHOR_ID_DESC = "BATCH_CLAIMS_AVERAGE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_AVERAGE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_AVERAGE_BILL_TYPE_ASC = "BATCH_CLAIMS_AVERAGE_BILL_TYPE_ASC",
  BATCH_CLAIMS_AVERAGE_BILL_TYPE_DESC = "BATCH_CLAIMS_AVERAGE_BILL_TYPE_DESC",
  BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_AVERAGE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_ICN_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_ICN_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_AVERAGE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_AVERAGE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_AVERAGE_CREATED_AT_ASC = "BATCH_CLAIMS_AVERAGE_CREATED_AT_ASC",
  BATCH_CLAIMS_AVERAGE_CREATED_AT_DESC = "BATCH_CLAIMS_AVERAGE_CREATED_AT_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_ADMIT_ASC = "BATCH_CLAIMS_AVERAGE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_ADMIT_DESC = "BATCH_CLAIMS_AVERAGE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_AVERAGE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_AVERAGE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_1_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_1_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_1_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_1_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_2_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_2_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_2_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_2_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_3_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_3_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_3_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_3_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_4_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_4_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_4_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_4_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_5_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_5_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_5_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_5_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_6_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_6_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_6_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_6_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_7_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_7_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_7_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_7_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_8_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_8_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_8_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_8_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_9_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_9_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_9_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_9_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_10_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_10_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_10_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_10_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_11_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_11_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_11_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_11_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_12_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_12_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_12_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_12_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_13_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_13_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_13_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_13_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_14_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_14_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_14_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_14_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_15_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_15_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_15_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_15_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_16_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_16_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_16_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_16_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_17_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_17_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_17_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_17_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_18_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_18_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_18_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_18_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_19_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_19_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_19_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_19_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_20_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_20_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_20_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_20_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_21_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_21_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_21_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_21_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_22_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_22_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_22_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_22_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_23_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_23_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_23_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_23_DESC",
  BATCH_CLAIMS_AVERAGE_DIAG_24_ASC = "BATCH_CLAIMS_AVERAGE_DIAG_24_ASC",
  BATCH_CLAIMS_AVERAGE_DIAG_24_DESC = "BATCH_CLAIMS_AVERAGE_DIAG_24_DESC",
  BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_AVERAGE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_AVERAGE_DRG_CODE_ASC = "BATCH_CLAIMS_AVERAGE_DRG_CODE_ASC",
  BATCH_CLAIMS_AVERAGE_DRG_CODE_DESC = "BATCH_CLAIMS_AVERAGE_DRG_CODE_DESC",
  BATCH_CLAIMS_AVERAGE_ICN_ASC = "BATCH_CLAIMS_AVERAGE_ICN_ASC",
  BATCH_CLAIMS_AVERAGE_ICN_DESC = "BATCH_CLAIMS_AVERAGE_ICN_DESC",
  BATCH_CLAIMS_AVERAGE_ID_ASC = "BATCH_CLAIMS_AVERAGE_ID_ASC",
  BATCH_CLAIMS_AVERAGE_ID_DESC = "BATCH_CLAIMS_AVERAGE_ID_DESC",
  BATCH_CLAIMS_AVERAGE_INSURER_ID_ASC = "BATCH_CLAIMS_AVERAGE_INSURER_ID_ASC",
  BATCH_CLAIMS_AVERAGE_INSURER_ID_DESC = "BATCH_CLAIMS_AVERAGE_INSURER_ID_DESC",
  BATCH_CLAIMS_AVERAGE_OWNER_ID_ASC = "BATCH_CLAIMS_AVERAGE_OWNER_ID_ASC",
  BATCH_CLAIMS_AVERAGE_OWNER_ID_DESC = "BATCH_CLAIMS_AVERAGE_OWNER_ID_DESC",
  BATCH_CLAIMS_AVERAGE_PAID_DATE_ASC = "BATCH_CLAIMS_AVERAGE_PAID_DATE_ASC",
  BATCH_CLAIMS_AVERAGE_PAID_DATE_DESC = "BATCH_CLAIMS_AVERAGE_PAID_DATE_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_DOB_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_DOB_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_AVERAGE_PATIENT_ID_ASC = "BATCH_CLAIMS_AVERAGE_PATIENT_ID_ASC",
  BATCH_CLAIMS_AVERAGE_PATIENT_ID_DESC = "BATCH_CLAIMS_AVERAGE_PATIENT_ID_DESC",
  BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_AVERAGE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_AVERAGE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_AVERAGE_POA_1_ASC = "BATCH_CLAIMS_AVERAGE_POA_1_ASC",
  BATCH_CLAIMS_AVERAGE_POA_1_DESC = "BATCH_CLAIMS_AVERAGE_POA_1_DESC",
  BATCH_CLAIMS_AVERAGE_POA_2_ASC = "BATCH_CLAIMS_AVERAGE_POA_2_ASC",
  BATCH_CLAIMS_AVERAGE_POA_2_DESC = "BATCH_CLAIMS_AVERAGE_POA_2_DESC",
  BATCH_CLAIMS_AVERAGE_POA_3_ASC = "BATCH_CLAIMS_AVERAGE_POA_3_ASC",
  BATCH_CLAIMS_AVERAGE_POA_3_DESC = "BATCH_CLAIMS_AVERAGE_POA_3_DESC",
  BATCH_CLAIMS_AVERAGE_POA_4_ASC = "BATCH_CLAIMS_AVERAGE_POA_4_ASC",
  BATCH_CLAIMS_AVERAGE_POA_4_DESC = "BATCH_CLAIMS_AVERAGE_POA_4_DESC",
  BATCH_CLAIMS_AVERAGE_POA_5_ASC = "BATCH_CLAIMS_AVERAGE_POA_5_ASC",
  BATCH_CLAIMS_AVERAGE_POA_5_DESC = "BATCH_CLAIMS_AVERAGE_POA_5_DESC",
  BATCH_CLAIMS_AVERAGE_POA_6_ASC = "BATCH_CLAIMS_AVERAGE_POA_6_ASC",
  BATCH_CLAIMS_AVERAGE_POA_6_DESC = "BATCH_CLAIMS_AVERAGE_POA_6_DESC",
  BATCH_CLAIMS_AVERAGE_POA_7_ASC = "BATCH_CLAIMS_AVERAGE_POA_7_ASC",
  BATCH_CLAIMS_AVERAGE_POA_7_DESC = "BATCH_CLAIMS_AVERAGE_POA_7_DESC",
  BATCH_CLAIMS_AVERAGE_POA_8_ASC = "BATCH_CLAIMS_AVERAGE_POA_8_ASC",
  BATCH_CLAIMS_AVERAGE_POA_8_DESC = "BATCH_CLAIMS_AVERAGE_POA_8_DESC",
  BATCH_CLAIMS_AVERAGE_POA_9_ASC = "BATCH_CLAIMS_AVERAGE_POA_9_ASC",
  BATCH_CLAIMS_AVERAGE_POA_9_DESC = "BATCH_CLAIMS_AVERAGE_POA_9_DESC",
  BATCH_CLAIMS_AVERAGE_POA_10_ASC = "BATCH_CLAIMS_AVERAGE_POA_10_ASC",
  BATCH_CLAIMS_AVERAGE_POA_10_DESC = "BATCH_CLAIMS_AVERAGE_POA_10_DESC",
  BATCH_CLAIMS_AVERAGE_POA_11_ASC = "BATCH_CLAIMS_AVERAGE_POA_11_ASC",
  BATCH_CLAIMS_AVERAGE_POA_11_DESC = "BATCH_CLAIMS_AVERAGE_POA_11_DESC",
  BATCH_CLAIMS_AVERAGE_POA_12_ASC = "BATCH_CLAIMS_AVERAGE_POA_12_ASC",
  BATCH_CLAIMS_AVERAGE_POA_12_DESC = "BATCH_CLAIMS_AVERAGE_POA_12_DESC",
  BATCH_CLAIMS_AVERAGE_POA_13_ASC = "BATCH_CLAIMS_AVERAGE_POA_13_ASC",
  BATCH_CLAIMS_AVERAGE_POA_13_DESC = "BATCH_CLAIMS_AVERAGE_POA_13_DESC",
  BATCH_CLAIMS_AVERAGE_POA_14_ASC = "BATCH_CLAIMS_AVERAGE_POA_14_ASC",
  BATCH_CLAIMS_AVERAGE_POA_14_DESC = "BATCH_CLAIMS_AVERAGE_POA_14_DESC",
  BATCH_CLAIMS_AVERAGE_POA_15_ASC = "BATCH_CLAIMS_AVERAGE_POA_15_ASC",
  BATCH_CLAIMS_AVERAGE_POA_15_DESC = "BATCH_CLAIMS_AVERAGE_POA_15_DESC",
  BATCH_CLAIMS_AVERAGE_POA_16_ASC = "BATCH_CLAIMS_AVERAGE_POA_16_ASC",
  BATCH_CLAIMS_AVERAGE_POA_16_DESC = "BATCH_CLAIMS_AVERAGE_POA_16_DESC",
  BATCH_CLAIMS_AVERAGE_POA_17_ASC = "BATCH_CLAIMS_AVERAGE_POA_17_ASC",
  BATCH_CLAIMS_AVERAGE_POA_17_DESC = "BATCH_CLAIMS_AVERAGE_POA_17_DESC",
  BATCH_CLAIMS_AVERAGE_POA_18_ASC = "BATCH_CLAIMS_AVERAGE_POA_18_ASC",
  BATCH_CLAIMS_AVERAGE_POA_18_DESC = "BATCH_CLAIMS_AVERAGE_POA_18_DESC",
  BATCH_CLAIMS_AVERAGE_POA_19_ASC = "BATCH_CLAIMS_AVERAGE_POA_19_ASC",
  BATCH_CLAIMS_AVERAGE_POA_19_DESC = "BATCH_CLAIMS_AVERAGE_POA_19_DESC",
  BATCH_CLAIMS_AVERAGE_POA_20_ASC = "BATCH_CLAIMS_AVERAGE_POA_20_ASC",
  BATCH_CLAIMS_AVERAGE_POA_20_DESC = "BATCH_CLAIMS_AVERAGE_POA_20_DESC",
  BATCH_CLAIMS_AVERAGE_POA_21_ASC = "BATCH_CLAIMS_AVERAGE_POA_21_ASC",
  BATCH_CLAIMS_AVERAGE_POA_21_DESC = "BATCH_CLAIMS_AVERAGE_POA_21_DESC",
  BATCH_CLAIMS_AVERAGE_POA_22_ASC = "BATCH_CLAIMS_AVERAGE_POA_22_ASC",
  BATCH_CLAIMS_AVERAGE_POA_22_DESC = "BATCH_CLAIMS_AVERAGE_POA_22_DESC",
  BATCH_CLAIMS_AVERAGE_POA_23_ASC = "BATCH_CLAIMS_AVERAGE_POA_23_ASC",
  BATCH_CLAIMS_AVERAGE_POA_23_DESC = "BATCH_CLAIMS_AVERAGE_POA_23_DESC",
  BATCH_CLAIMS_AVERAGE_POA_24_ASC = "BATCH_CLAIMS_AVERAGE_POA_24_ASC",
  BATCH_CLAIMS_AVERAGE_POA_24_DESC = "BATCH_CLAIMS_AVERAGE_POA_24_DESC",
  BATCH_CLAIMS_AVERAGE_POA_25_ASC = "BATCH_CLAIMS_AVERAGE_POA_25_ASC",
  BATCH_CLAIMS_AVERAGE_POA_25_DESC = "BATCH_CLAIMS_AVERAGE_POA_25_DESC",
  BATCH_CLAIMS_AVERAGE_PREPAY_DENY_ASC = "BATCH_CLAIMS_AVERAGE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_AVERAGE_PREPAY_DENY_DESC = "BATCH_CLAIMS_AVERAGE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_AVERAGE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_AVERAGE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_AVERAGE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_AVERAGE_PROVIDER_ID_ASC = "BATCH_CLAIMS_AVERAGE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_AVERAGE_PROVIDER_ID_DESC = "BATCH_CLAIMS_AVERAGE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_AVERAGE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_AVERAGE_UPDATED_AT_ASC = "BATCH_CLAIMS_AVERAGE_UPDATED_AT_ASC",
  BATCH_CLAIMS_AVERAGE_UPDATED_AT_DESC = "BATCH_CLAIMS_AVERAGE_UPDATED_AT_DESC",
  BATCH_CLAIMS_AVERAGE_VERSION_ASC = "BATCH_CLAIMS_AVERAGE_VERSION_ASC",
  BATCH_CLAIMS_AVERAGE_VERSION_DESC = "BATCH_CLAIMS_AVERAGE_VERSION_DESC",
  BATCH_CLAIMS_AVERAGE_VERSION_GROUP_ASC = "BATCH_CLAIMS_AVERAGE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_AVERAGE_VERSION_GROUP_DESC = "BATCH_CLAIMS_AVERAGE_VERSION_GROUP_DESC",
  BATCH_CLAIMS_BY_PROVIDER_ID__COUNT_ASC = "BATCH_CLAIMS_BY_PROVIDER_ID__COUNT_ASC",
  BATCH_CLAIMS_BY_PROVIDER_ID__COUNT_DESC = "BATCH_CLAIMS_BY_PROVIDER_ID__COUNT_DESC",
  BATCH_CLAIMS_COUNT_ASC = "BATCH_CLAIMS_COUNT_ASC",
  BATCH_CLAIMS_COUNT_DESC = "BATCH_CLAIMS_COUNT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ADM_TYPE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_APR_DRG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_BILL_TYPE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_ICN_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_CREATED_AT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_ADMIT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_1_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_2_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_3_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_4_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_5_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_6_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_7_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_8_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_9_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_10_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_11_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_12_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_13_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_14_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_15_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_16_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_17_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_18_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_19_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_20_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_21_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_22_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_23_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DIAG_24_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_DRG_CODE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ICN_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ICN_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ICN_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ICN_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_INSURER_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_OWNER_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PAID_DATE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_DOB_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PATIENT_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_1_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_1_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_1_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_1_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_2_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_2_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_2_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_2_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_3_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_3_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_3_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_3_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_4_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_4_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_4_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_4_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_5_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_5_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_5_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_5_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_6_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_6_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_6_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_6_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_7_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_7_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_7_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_7_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_8_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_8_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_8_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_8_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_9_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_9_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_9_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_9_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_10_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_10_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_10_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_10_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_11_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_11_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_11_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_11_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_12_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_12_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_12_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_12_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_13_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_13_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_13_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_13_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_14_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_14_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_14_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_14_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_15_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_15_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_15_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_15_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_16_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_16_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_16_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_16_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_17_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_17_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_17_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_17_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_18_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_18_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_18_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_18_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_19_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_19_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_19_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_19_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_20_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_20_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_20_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_20_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_21_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_21_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_21_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_21_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_22_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_22_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_22_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_22_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_23_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_23_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_23_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_23_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_24_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_24_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_24_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_24_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_25_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_25_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_POA_25_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_POA_25_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PREPAY_DENY_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_UPDATED_AT_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_DESC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_ASC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_ASC",
  BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_DESC = "BATCH_CLAIMS_DISTINCT_COUNT_VERSION_GROUP_DESC",
  BATCH_CLAIMS_MAX_ADMIT_DIAG_ASC = "BATCH_CLAIMS_MAX_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_MAX_ADMIT_DIAG_DESC = "BATCH_CLAIMS_MAX_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_MAX_ADM_TYPE_ASC = "BATCH_CLAIMS_MAX_ADM_TYPE_ASC",
  BATCH_CLAIMS_MAX_ADM_TYPE_DESC = "BATCH_CLAIMS_MAX_ADM_TYPE_DESC",
  BATCH_CLAIMS_MAX_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_MAX_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_MAX_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_MAX_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_MAX_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_MAX_APR_DRG_ASC = "BATCH_CLAIMS_MAX_APR_DRG_ASC",
  BATCH_CLAIMS_MAX_APR_DRG_DESC = "BATCH_CLAIMS_MAX_APR_DRG_DESC",
  BATCH_CLAIMS_MAX_AUTHOR_ID_ASC = "BATCH_CLAIMS_MAX_AUTHOR_ID_ASC",
  BATCH_CLAIMS_MAX_AUTHOR_ID_DESC = "BATCH_CLAIMS_MAX_AUTHOR_ID_DESC",
  BATCH_CLAIMS_MAX_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_MAX_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_MAX_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_MAX_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_MAX_BILL_TYPE_ASC = "BATCH_CLAIMS_MAX_BILL_TYPE_ASC",
  BATCH_CLAIMS_MAX_BILL_TYPE_DESC = "BATCH_CLAIMS_MAX_BILL_TYPE_DESC",
  BATCH_CLAIMS_MAX_CLAIM_TYPE_ASC = "BATCH_CLAIMS_MAX_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_MAX_CLAIM_TYPE_DESC = "BATCH_CLAIMS_MAX_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_MAX_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_MAX_CLIENT_ICN_ASC = "BATCH_CLAIMS_MAX_CLIENT_ICN_ASC",
  BATCH_CLAIMS_MAX_CLIENT_ICN_DESC = "BATCH_CLAIMS_MAX_CLIENT_ICN_DESC",
  BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_MAX_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_MAX_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_MAX_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_MAX_CREATED_AT_ASC = "BATCH_CLAIMS_MAX_CREATED_AT_ASC",
  BATCH_CLAIMS_MAX_CREATED_AT_DESC = "BATCH_CLAIMS_MAX_CREATED_AT_DESC",
  BATCH_CLAIMS_MAX_DATE_ADMIT_ASC = "BATCH_CLAIMS_MAX_DATE_ADMIT_ASC",
  BATCH_CLAIMS_MAX_DATE_ADMIT_DESC = "BATCH_CLAIMS_MAX_DATE_ADMIT_DESC",
  BATCH_CLAIMS_MAX_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_MAX_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_MAX_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_MAX_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_MAX_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_MAX_DIAG_1_ASC = "BATCH_CLAIMS_MAX_DIAG_1_ASC",
  BATCH_CLAIMS_MAX_DIAG_1_DESC = "BATCH_CLAIMS_MAX_DIAG_1_DESC",
  BATCH_CLAIMS_MAX_DIAG_2_ASC = "BATCH_CLAIMS_MAX_DIAG_2_ASC",
  BATCH_CLAIMS_MAX_DIAG_2_DESC = "BATCH_CLAIMS_MAX_DIAG_2_DESC",
  BATCH_CLAIMS_MAX_DIAG_3_ASC = "BATCH_CLAIMS_MAX_DIAG_3_ASC",
  BATCH_CLAIMS_MAX_DIAG_3_DESC = "BATCH_CLAIMS_MAX_DIAG_3_DESC",
  BATCH_CLAIMS_MAX_DIAG_4_ASC = "BATCH_CLAIMS_MAX_DIAG_4_ASC",
  BATCH_CLAIMS_MAX_DIAG_4_DESC = "BATCH_CLAIMS_MAX_DIAG_4_DESC",
  BATCH_CLAIMS_MAX_DIAG_5_ASC = "BATCH_CLAIMS_MAX_DIAG_5_ASC",
  BATCH_CLAIMS_MAX_DIAG_5_DESC = "BATCH_CLAIMS_MAX_DIAG_5_DESC",
  BATCH_CLAIMS_MAX_DIAG_6_ASC = "BATCH_CLAIMS_MAX_DIAG_6_ASC",
  BATCH_CLAIMS_MAX_DIAG_6_DESC = "BATCH_CLAIMS_MAX_DIAG_6_DESC",
  BATCH_CLAIMS_MAX_DIAG_7_ASC = "BATCH_CLAIMS_MAX_DIAG_7_ASC",
  BATCH_CLAIMS_MAX_DIAG_7_DESC = "BATCH_CLAIMS_MAX_DIAG_7_DESC",
  BATCH_CLAIMS_MAX_DIAG_8_ASC = "BATCH_CLAIMS_MAX_DIAG_8_ASC",
  BATCH_CLAIMS_MAX_DIAG_8_DESC = "BATCH_CLAIMS_MAX_DIAG_8_DESC",
  BATCH_CLAIMS_MAX_DIAG_9_ASC = "BATCH_CLAIMS_MAX_DIAG_9_ASC",
  BATCH_CLAIMS_MAX_DIAG_9_DESC = "BATCH_CLAIMS_MAX_DIAG_9_DESC",
  BATCH_CLAIMS_MAX_DIAG_10_ASC = "BATCH_CLAIMS_MAX_DIAG_10_ASC",
  BATCH_CLAIMS_MAX_DIAG_10_DESC = "BATCH_CLAIMS_MAX_DIAG_10_DESC",
  BATCH_CLAIMS_MAX_DIAG_11_ASC = "BATCH_CLAIMS_MAX_DIAG_11_ASC",
  BATCH_CLAIMS_MAX_DIAG_11_DESC = "BATCH_CLAIMS_MAX_DIAG_11_DESC",
  BATCH_CLAIMS_MAX_DIAG_12_ASC = "BATCH_CLAIMS_MAX_DIAG_12_ASC",
  BATCH_CLAIMS_MAX_DIAG_12_DESC = "BATCH_CLAIMS_MAX_DIAG_12_DESC",
  BATCH_CLAIMS_MAX_DIAG_13_ASC = "BATCH_CLAIMS_MAX_DIAG_13_ASC",
  BATCH_CLAIMS_MAX_DIAG_13_DESC = "BATCH_CLAIMS_MAX_DIAG_13_DESC",
  BATCH_CLAIMS_MAX_DIAG_14_ASC = "BATCH_CLAIMS_MAX_DIAG_14_ASC",
  BATCH_CLAIMS_MAX_DIAG_14_DESC = "BATCH_CLAIMS_MAX_DIAG_14_DESC",
  BATCH_CLAIMS_MAX_DIAG_15_ASC = "BATCH_CLAIMS_MAX_DIAG_15_ASC",
  BATCH_CLAIMS_MAX_DIAG_15_DESC = "BATCH_CLAIMS_MAX_DIAG_15_DESC",
  BATCH_CLAIMS_MAX_DIAG_16_ASC = "BATCH_CLAIMS_MAX_DIAG_16_ASC",
  BATCH_CLAIMS_MAX_DIAG_16_DESC = "BATCH_CLAIMS_MAX_DIAG_16_DESC",
  BATCH_CLAIMS_MAX_DIAG_17_ASC = "BATCH_CLAIMS_MAX_DIAG_17_ASC",
  BATCH_CLAIMS_MAX_DIAG_17_DESC = "BATCH_CLAIMS_MAX_DIAG_17_DESC",
  BATCH_CLAIMS_MAX_DIAG_18_ASC = "BATCH_CLAIMS_MAX_DIAG_18_ASC",
  BATCH_CLAIMS_MAX_DIAG_18_DESC = "BATCH_CLAIMS_MAX_DIAG_18_DESC",
  BATCH_CLAIMS_MAX_DIAG_19_ASC = "BATCH_CLAIMS_MAX_DIAG_19_ASC",
  BATCH_CLAIMS_MAX_DIAG_19_DESC = "BATCH_CLAIMS_MAX_DIAG_19_DESC",
  BATCH_CLAIMS_MAX_DIAG_20_ASC = "BATCH_CLAIMS_MAX_DIAG_20_ASC",
  BATCH_CLAIMS_MAX_DIAG_20_DESC = "BATCH_CLAIMS_MAX_DIAG_20_DESC",
  BATCH_CLAIMS_MAX_DIAG_21_ASC = "BATCH_CLAIMS_MAX_DIAG_21_ASC",
  BATCH_CLAIMS_MAX_DIAG_21_DESC = "BATCH_CLAIMS_MAX_DIAG_21_DESC",
  BATCH_CLAIMS_MAX_DIAG_22_ASC = "BATCH_CLAIMS_MAX_DIAG_22_ASC",
  BATCH_CLAIMS_MAX_DIAG_22_DESC = "BATCH_CLAIMS_MAX_DIAG_22_DESC",
  BATCH_CLAIMS_MAX_DIAG_23_ASC = "BATCH_CLAIMS_MAX_DIAG_23_ASC",
  BATCH_CLAIMS_MAX_DIAG_23_DESC = "BATCH_CLAIMS_MAX_DIAG_23_DESC",
  BATCH_CLAIMS_MAX_DIAG_24_ASC = "BATCH_CLAIMS_MAX_DIAG_24_ASC",
  BATCH_CLAIMS_MAX_DIAG_24_DESC = "BATCH_CLAIMS_MAX_DIAG_24_DESC",
  BATCH_CLAIMS_MAX_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_MAX_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_MAX_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_MAX_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_MAX_DRG_CODE_ASC = "BATCH_CLAIMS_MAX_DRG_CODE_ASC",
  BATCH_CLAIMS_MAX_DRG_CODE_DESC = "BATCH_CLAIMS_MAX_DRG_CODE_DESC",
  BATCH_CLAIMS_MAX_ICN_ASC = "BATCH_CLAIMS_MAX_ICN_ASC",
  BATCH_CLAIMS_MAX_ICN_DESC = "BATCH_CLAIMS_MAX_ICN_DESC",
  BATCH_CLAIMS_MAX_ID_ASC = "BATCH_CLAIMS_MAX_ID_ASC",
  BATCH_CLAIMS_MAX_ID_DESC = "BATCH_CLAIMS_MAX_ID_DESC",
  BATCH_CLAIMS_MAX_INSURER_ID_ASC = "BATCH_CLAIMS_MAX_INSURER_ID_ASC",
  BATCH_CLAIMS_MAX_INSURER_ID_DESC = "BATCH_CLAIMS_MAX_INSURER_ID_DESC",
  BATCH_CLAIMS_MAX_OWNER_ID_ASC = "BATCH_CLAIMS_MAX_OWNER_ID_ASC",
  BATCH_CLAIMS_MAX_OWNER_ID_DESC = "BATCH_CLAIMS_MAX_OWNER_ID_DESC",
  BATCH_CLAIMS_MAX_PAID_DATE_ASC = "BATCH_CLAIMS_MAX_PAID_DATE_ASC",
  BATCH_CLAIMS_MAX_PAID_DATE_DESC = "BATCH_CLAIMS_MAX_PAID_DATE_DESC",
  BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_MAX_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_MAX_PATIENT_DOB_ASC = "BATCH_CLAIMS_MAX_PATIENT_DOB_ASC",
  BATCH_CLAIMS_MAX_PATIENT_DOB_DESC = "BATCH_CLAIMS_MAX_PATIENT_DOB_DESC",
  BATCH_CLAIMS_MAX_PATIENT_GENDER_ASC = "BATCH_CLAIMS_MAX_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_MAX_PATIENT_GENDER_DESC = "BATCH_CLAIMS_MAX_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_MAX_PATIENT_ID_ASC = "BATCH_CLAIMS_MAX_PATIENT_ID_ASC",
  BATCH_CLAIMS_MAX_PATIENT_ID_DESC = "BATCH_CLAIMS_MAX_PATIENT_ID_DESC",
  BATCH_CLAIMS_MAX_PAYMENT_RATE_ASC = "BATCH_CLAIMS_MAX_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_MAX_PAYMENT_RATE_DESC = "BATCH_CLAIMS_MAX_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_MAX_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_MAX_POA_1_ASC = "BATCH_CLAIMS_MAX_POA_1_ASC",
  BATCH_CLAIMS_MAX_POA_1_DESC = "BATCH_CLAIMS_MAX_POA_1_DESC",
  BATCH_CLAIMS_MAX_POA_2_ASC = "BATCH_CLAIMS_MAX_POA_2_ASC",
  BATCH_CLAIMS_MAX_POA_2_DESC = "BATCH_CLAIMS_MAX_POA_2_DESC",
  BATCH_CLAIMS_MAX_POA_3_ASC = "BATCH_CLAIMS_MAX_POA_3_ASC",
  BATCH_CLAIMS_MAX_POA_3_DESC = "BATCH_CLAIMS_MAX_POA_3_DESC",
  BATCH_CLAIMS_MAX_POA_4_ASC = "BATCH_CLAIMS_MAX_POA_4_ASC",
  BATCH_CLAIMS_MAX_POA_4_DESC = "BATCH_CLAIMS_MAX_POA_4_DESC",
  BATCH_CLAIMS_MAX_POA_5_ASC = "BATCH_CLAIMS_MAX_POA_5_ASC",
  BATCH_CLAIMS_MAX_POA_5_DESC = "BATCH_CLAIMS_MAX_POA_5_DESC",
  BATCH_CLAIMS_MAX_POA_6_ASC = "BATCH_CLAIMS_MAX_POA_6_ASC",
  BATCH_CLAIMS_MAX_POA_6_DESC = "BATCH_CLAIMS_MAX_POA_6_DESC",
  BATCH_CLAIMS_MAX_POA_7_ASC = "BATCH_CLAIMS_MAX_POA_7_ASC",
  BATCH_CLAIMS_MAX_POA_7_DESC = "BATCH_CLAIMS_MAX_POA_7_DESC",
  BATCH_CLAIMS_MAX_POA_8_ASC = "BATCH_CLAIMS_MAX_POA_8_ASC",
  BATCH_CLAIMS_MAX_POA_8_DESC = "BATCH_CLAIMS_MAX_POA_8_DESC",
  BATCH_CLAIMS_MAX_POA_9_ASC = "BATCH_CLAIMS_MAX_POA_9_ASC",
  BATCH_CLAIMS_MAX_POA_9_DESC = "BATCH_CLAIMS_MAX_POA_9_DESC",
  BATCH_CLAIMS_MAX_POA_10_ASC = "BATCH_CLAIMS_MAX_POA_10_ASC",
  BATCH_CLAIMS_MAX_POA_10_DESC = "BATCH_CLAIMS_MAX_POA_10_DESC",
  BATCH_CLAIMS_MAX_POA_11_ASC = "BATCH_CLAIMS_MAX_POA_11_ASC",
  BATCH_CLAIMS_MAX_POA_11_DESC = "BATCH_CLAIMS_MAX_POA_11_DESC",
  BATCH_CLAIMS_MAX_POA_12_ASC = "BATCH_CLAIMS_MAX_POA_12_ASC",
  BATCH_CLAIMS_MAX_POA_12_DESC = "BATCH_CLAIMS_MAX_POA_12_DESC",
  BATCH_CLAIMS_MAX_POA_13_ASC = "BATCH_CLAIMS_MAX_POA_13_ASC",
  BATCH_CLAIMS_MAX_POA_13_DESC = "BATCH_CLAIMS_MAX_POA_13_DESC",
  BATCH_CLAIMS_MAX_POA_14_ASC = "BATCH_CLAIMS_MAX_POA_14_ASC",
  BATCH_CLAIMS_MAX_POA_14_DESC = "BATCH_CLAIMS_MAX_POA_14_DESC",
  BATCH_CLAIMS_MAX_POA_15_ASC = "BATCH_CLAIMS_MAX_POA_15_ASC",
  BATCH_CLAIMS_MAX_POA_15_DESC = "BATCH_CLAIMS_MAX_POA_15_DESC",
  BATCH_CLAIMS_MAX_POA_16_ASC = "BATCH_CLAIMS_MAX_POA_16_ASC",
  BATCH_CLAIMS_MAX_POA_16_DESC = "BATCH_CLAIMS_MAX_POA_16_DESC",
  BATCH_CLAIMS_MAX_POA_17_ASC = "BATCH_CLAIMS_MAX_POA_17_ASC",
  BATCH_CLAIMS_MAX_POA_17_DESC = "BATCH_CLAIMS_MAX_POA_17_DESC",
  BATCH_CLAIMS_MAX_POA_18_ASC = "BATCH_CLAIMS_MAX_POA_18_ASC",
  BATCH_CLAIMS_MAX_POA_18_DESC = "BATCH_CLAIMS_MAX_POA_18_DESC",
  BATCH_CLAIMS_MAX_POA_19_ASC = "BATCH_CLAIMS_MAX_POA_19_ASC",
  BATCH_CLAIMS_MAX_POA_19_DESC = "BATCH_CLAIMS_MAX_POA_19_DESC",
  BATCH_CLAIMS_MAX_POA_20_ASC = "BATCH_CLAIMS_MAX_POA_20_ASC",
  BATCH_CLAIMS_MAX_POA_20_DESC = "BATCH_CLAIMS_MAX_POA_20_DESC",
  BATCH_CLAIMS_MAX_POA_21_ASC = "BATCH_CLAIMS_MAX_POA_21_ASC",
  BATCH_CLAIMS_MAX_POA_21_DESC = "BATCH_CLAIMS_MAX_POA_21_DESC",
  BATCH_CLAIMS_MAX_POA_22_ASC = "BATCH_CLAIMS_MAX_POA_22_ASC",
  BATCH_CLAIMS_MAX_POA_22_DESC = "BATCH_CLAIMS_MAX_POA_22_DESC",
  BATCH_CLAIMS_MAX_POA_23_ASC = "BATCH_CLAIMS_MAX_POA_23_ASC",
  BATCH_CLAIMS_MAX_POA_23_DESC = "BATCH_CLAIMS_MAX_POA_23_DESC",
  BATCH_CLAIMS_MAX_POA_24_ASC = "BATCH_CLAIMS_MAX_POA_24_ASC",
  BATCH_CLAIMS_MAX_POA_24_DESC = "BATCH_CLAIMS_MAX_POA_24_DESC",
  BATCH_CLAIMS_MAX_POA_25_ASC = "BATCH_CLAIMS_MAX_POA_25_ASC",
  BATCH_CLAIMS_MAX_POA_25_DESC = "BATCH_CLAIMS_MAX_POA_25_DESC",
  BATCH_CLAIMS_MAX_PREPAY_DENY_ASC = "BATCH_CLAIMS_MAX_PREPAY_DENY_ASC",
  BATCH_CLAIMS_MAX_PREPAY_DENY_DESC = "BATCH_CLAIMS_MAX_PREPAY_DENY_DESC",
  BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_MAX_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_MAX_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_MAX_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_MAX_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_MAX_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_MAX_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_MAX_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_MAX_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_MAX_PROVIDER_ID_ASC = "BATCH_CLAIMS_MAX_PROVIDER_ID_ASC",
  BATCH_CLAIMS_MAX_PROVIDER_ID_DESC = "BATCH_CLAIMS_MAX_PROVIDER_ID_DESC",
  BATCH_CLAIMS_MAX_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_MAX_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_MAX_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_MAX_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_MAX_UPDATED_AT_ASC = "BATCH_CLAIMS_MAX_UPDATED_AT_ASC",
  BATCH_CLAIMS_MAX_UPDATED_AT_DESC = "BATCH_CLAIMS_MAX_UPDATED_AT_DESC",
  BATCH_CLAIMS_MAX_VERSION_ASC = "BATCH_CLAIMS_MAX_VERSION_ASC",
  BATCH_CLAIMS_MAX_VERSION_DESC = "BATCH_CLAIMS_MAX_VERSION_DESC",
  BATCH_CLAIMS_MAX_VERSION_GROUP_ASC = "BATCH_CLAIMS_MAX_VERSION_GROUP_ASC",
  BATCH_CLAIMS_MAX_VERSION_GROUP_DESC = "BATCH_CLAIMS_MAX_VERSION_GROUP_DESC",
  BATCH_CLAIMS_MIN_ADMIT_DIAG_ASC = "BATCH_CLAIMS_MIN_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_MIN_ADMIT_DIAG_DESC = "BATCH_CLAIMS_MIN_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_MIN_ADM_TYPE_ASC = "BATCH_CLAIMS_MIN_ADM_TYPE_ASC",
  BATCH_CLAIMS_MIN_ADM_TYPE_DESC = "BATCH_CLAIMS_MIN_ADM_TYPE_DESC",
  BATCH_CLAIMS_MIN_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_MIN_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_MIN_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_MIN_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_MIN_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_MIN_APR_DRG_ASC = "BATCH_CLAIMS_MIN_APR_DRG_ASC",
  BATCH_CLAIMS_MIN_APR_DRG_DESC = "BATCH_CLAIMS_MIN_APR_DRG_DESC",
  BATCH_CLAIMS_MIN_AUTHOR_ID_ASC = "BATCH_CLAIMS_MIN_AUTHOR_ID_ASC",
  BATCH_CLAIMS_MIN_AUTHOR_ID_DESC = "BATCH_CLAIMS_MIN_AUTHOR_ID_DESC",
  BATCH_CLAIMS_MIN_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_MIN_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_MIN_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_MIN_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_MIN_BILL_TYPE_ASC = "BATCH_CLAIMS_MIN_BILL_TYPE_ASC",
  BATCH_CLAIMS_MIN_BILL_TYPE_DESC = "BATCH_CLAIMS_MIN_BILL_TYPE_DESC",
  BATCH_CLAIMS_MIN_CLAIM_TYPE_ASC = "BATCH_CLAIMS_MIN_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_MIN_CLAIM_TYPE_DESC = "BATCH_CLAIMS_MIN_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_MIN_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_MIN_CLIENT_ICN_ASC = "BATCH_CLAIMS_MIN_CLIENT_ICN_ASC",
  BATCH_CLAIMS_MIN_CLIENT_ICN_DESC = "BATCH_CLAIMS_MIN_CLIENT_ICN_DESC",
  BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_MIN_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_MIN_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_MIN_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_MIN_CREATED_AT_ASC = "BATCH_CLAIMS_MIN_CREATED_AT_ASC",
  BATCH_CLAIMS_MIN_CREATED_AT_DESC = "BATCH_CLAIMS_MIN_CREATED_AT_DESC",
  BATCH_CLAIMS_MIN_DATE_ADMIT_ASC = "BATCH_CLAIMS_MIN_DATE_ADMIT_ASC",
  BATCH_CLAIMS_MIN_DATE_ADMIT_DESC = "BATCH_CLAIMS_MIN_DATE_ADMIT_DESC",
  BATCH_CLAIMS_MIN_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_MIN_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_MIN_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_MIN_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_MIN_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_MIN_DIAG_1_ASC = "BATCH_CLAIMS_MIN_DIAG_1_ASC",
  BATCH_CLAIMS_MIN_DIAG_1_DESC = "BATCH_CLAIMS_MIN_DIAG_1_DESC",
  BATCH_CLAIMS_MIN_DIAG_2_ASC = "BATCH_CLAIMS_MIN_DIAG_2_ASC",
  BATCH_CLAIMS_MIN_DIAG_2_DESC = "BATCH_CLAIMS_MIN_DIAG_2_DESC",
  BATCH_CLAIMS_MIN_DIAG_3_ASC = "BATCH_CLAIMS_MIN_DIAG_3_ASC",
  BATCH_CLAIMS_MIN_DIAG_3_DESC = "BATCH_CLAIMS_MIN_DIAG_3_DESC",
  BATCH_CLAIMS_MIN_DIAG_4_ASC = "BATCH_CLAIMS_MIN_DIAG_4_ASC",
  BATCH_CLAIMS_MIN_DIAG_4_DESC = "BATCH_CLAIMS_MIN_DIAG_4_DESC",
  BATCH_CLAIMS_MIN_DIAG_5_ASC = "BATCH_CLAIMS_MIN_DIAG_5_ASC",
  BATCH_CLAIMS_MIN_DIAG_5_DESC = "BATCH_CLAIMS_MIN_DIAG_5_DESC",
  BATCH_CLAIMS_MIN_DIAG_6_ASC = "BATCH_CLAIMS_MIN_DIAG_6_ASC",
  BATCH_CLAIMS_MIN_DIAG_6_DESC = "BATCH_CLAIMS_MIN_DIAG_6_DESC",
  BATCH_CLAIMS_MIN_DIAG_7_ASC = "BATCH_CLAIMS_MIN_DIAG_7_ASC",
  BATCH_CLAIMS_MIN_DIAG_7_DESC = "BATCH_CLAIMS_MIN_DIAG_7_DESC",
  BATCH_CLAIMS_MIN_DIAG_8_ASC = "BATCH_CLAIMS_MIN_DIAG_8_ASC",
  BATCH_CLAIMS_MIN_DIAG_8_DESC = "BATCH_CLAIMS_MIN_DIAG_8_DESC",
  BATCH_CLAIMS_MIN_DIAG_9_ASC = "BATCH_CLAIMS_MIN_DIAG_9_ASC",
  BATCH_CLAIMS_MIN_DIAG_9_DESC = "BATCH_CLAIMS_MIN_DIAG_9_DESC",
  BATCH_CLAIMS_MIN_DIAG_10_ASC = "BATCH_CLAIMS_MIN_DIAG_10_ASC",
  BATCH_CLAIMS_MIN_DIAG_10_DESC = "BATCH_CLAIMS_MIN_DIAG_10_DESC",
  BATCH_CLAIMS_MIN_DIAG_11_ASC = "BATCH_CLAIMS_MIN_DIAG_11_ASC",
  BATCH_CLAIMS_MIN_DIAG_11_DESC = "BATCH_CLAIMS_MIN_DIAG_11_DESC",
  BATCH_CLAIMS_MIN_DIAG_12_ASC = "BATCH_CLAIMS_MIN_DIAG_12_ASC",
  BATCH_CLAIMS_MIN_DIAG_12_DESC = "BATCH_CLAIMS_MIN_DIAG_12_DESC",
  BATCH_CLAIMS_MIN_DIAG_13_ASC = "BATCH_CLAIMS_MIN_DIAG_13_ASC",
  BATCH_CLAIMS_MIN_DIAG_13_DESC = "BATCH_CLAIMS_MIN_DIAG_13_DESC",
  BATCH_CLAIMS_MIN_DIAG_14_ASC = "BATCH_CLAIMS_MIN_DIAG_14_ASC",
  BATCH_CLAIMS_MIN_DIAG_14_DESC = "BATCH_CLAIMS_MIN_DIAG_14_DESC",
  BATCH_CLAIMS_MIN_DIAG_15_ASC = "BATCH_CLAIMS_MIN_DIAG_15_ASC",
  BATCH_CLAIMS_MIN_DIAG_15_DESC = "BATCH_CLAIMS_MIN_DIAG_15_DESC",
  BATCH_CLAIMS_MIN_DIAG_16_ASC = "BATCH_CLAIMS_MIN_DIAG_16_ASC",
  BATCH_CLAIMS_MIN_DIAG_16_DESC = "BATCH_CLAIMS_MIN_DIAG_16_DESC",
  BATCH_CLAIMS_MIN_DIAG_17_ASC = "BATCH_CLAIMS_MIN_DIAG_17_ASC",
  BATCH_CLAIMS_MIN_DIAG_17_DESC = "BATCH_CLAIMS_MIN_DIAG_17_DESC",
  BATCH_CLAIMS_MIN_DIAG_18_ASC = "BATCH_CLAIMS_MIN_DIAG_18_ASC",
  BATCH_CLAIMS_MIN_DIAG_18_DESC = "BATCH_CLAIMS_MIN_DIAG_18_DESC",
  BATCH_CLAIMS_MIN_DIAG_19_ASC = "BATCH_CLAIMS_MIN_DIAG_19_ASC",
  BATCH_CLAIMS_MIN_DIAG_19_DESC = "BATCH_CLAIMS_MIN_DIAG_19_DESC",
  BATCH_CLAIMS_MIN_DIAG_20_ASC = "BATCH_CLAIMS_MIN_DIAG_20_ASC",
  BATCH_CLAIMS_MIN_DIAG_20_DESC = "BATCH_CLAIMS_MIN_DIAG_20_DESC",
  BATCH_CLAIMS_MIN_DIAG_21_ASC = "BATCH_CLAIMS_MIN_DIAG_21_ASC",
  BATCH_CLAIMS_MIN_DIAG_21_DESC = "BATCH_CLAIMS_MIN_DIAG_21_DESC",
  BATCH_CLAIMS_MIN_DIAG_22_ASC = "BATCH_CLAIMS_MIN_DIAG_22_ASC",
  BATCH_CLAIMS_MIN_DIAG_22_DESC = "BATCH_CLAIMS_MIN_DIAG_22_DESC",
  BATCH_CLAIMS_MIN_DIAG_23_ASC = "BATCH_CLAIMS_MIN_DIAG_23_ASC",
  BATCH_CLAIMS_MIN_DIAG_23_DESC = "BATCH_CLAIMS_MIN_DIAG_23_DESC",
  BATCH_CLAIMS_MIN_DIAG_24_ASC = "BATCH_CLAIMS_MIN_DIAG_24_ASC",
  BATCH_CLAIMS_MIN_DIAG_24_DESC = "BATCH_CLAIMS_MIN_DIAG_24_DESC",
  BATCH_CLAIMS_MIN_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_MIN_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_MIN_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_MIN_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_MIN_DRG_CODE_ASC = "BATCH_CLAIMS_MIN_DRG_CODE_ASC",
  BATCH_CLAIMS_MIN_DRG_CODE_DESC = "BATCH_CLAIMS_MIN_DRG_CODE_DESC",
  BATCH_CLAIMS_MIN_ICN_ASC = "BATCH_CLAIMS_MIN_ICN_ASC",
  BATCH_CLAIMS_MIN_ICN_DESC = "BATCH_CLAIMS_MIN_ICN_DESC",
  BATCH_CLAIMS_MIN_ID_ASC = "BATCH_CLAIMS_MIN_ID_ASC",
  BATCH_CLAIMS_MIN_ID_DESC = "BATCH_CLAIMS_MIN_ID_DESC",
  BATCH_CLAIMS_MIN_INSURER_ID_ASC = "BATCH_CLAIMS_MIN_INSURER_ID_ASC",
  BATCH_CLAIMS_MIN_INSURER_ID_DESC = "BATCH_CLAIMS_MIN_INSURER_ID_DESC",
  BATCH_CLAIMS_MIN_OWNER_ID_ASC = "BATCH_CLAIMS_MIN_OWNER_ID_ASC",
  BATCH_CLAIMS_MIN_OWNER_ID_DESC = "BATCH_CLAIMS_MIN_OWNER_ID_DESC",
  BATCH_CLAIMS_MIN_PAID_DATE_ASC = "BATCH_CLAIMS_MIN_PAID_DATE_ASC",
  BATCH_CLAIMS_MIN_PAID_DATE_DESC = "BATCH_CLAIMS_MIN_PAID_DATE_DESC",
  BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_MIN_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_MIN_PATIENT_DOB_ASC = "BATCH_CLAIMS_MIN_PATIENT_DOB_ASC",
  BATCH_CLAIMS_MIN_PATIENT_DOB_DESC = "BATCH_CLAIMS_MIN_PATIENT_DOB_DESC",
  BATCH_CLAIMS_MIN_PATIENT_GENDER_ASC = "BATCH_CLAIMS_MIN_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_MIN_PATIENT_GENDER_DESC = "BATCH_CLAIMS_MIN_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_MIN_PATIENT_ID_ASC = "BATCH_CLAIMS_MIN_PATIENT_ID_ASC",
  BATCH_CLAIMS_MIN_PATIENT_ID_DESC = "BATCH_CLAIMS_MIN_PATIENT_ID_DESC",
  BATCH_CLAIMS_MIN_PAYMENT_RATE_ASC = "BATCH_CLAIMS_MIN_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_MIN_PAYMENT_RATE_DESC = "BATCH_CLAIMS_MIN_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_MIN_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_MIN_POA_1_ASC = "BATCH_CLAIMS_MIN_POA_1_ASC",
  BATCH_CLAIMS_MIN_POA_1_DESC = "BATCH_CLAIMS_MIN_POA_1_DESC",
  BATCH_CLAIMS_MIN_POA_2_ASC = "BATCH_CLAIMS_MIN_POA_2_ASC",
  BATCH_CLAIMS_MIN_POA_2_DESC = "BATCH_CLAIMS_MIN_POA_2_DESC",
  BATCH_CLAIMS_MIN_POA_3_ASC = "BATCH_CLAIMS_MIN_POA_3_ASC",
  BATCH_CLAIMS_MIN_POA_3_DESC = "BATCH_CLAIMS_MIN_POA_3_DESC",
  BATCH_CLAIMS_MIN_POA_4_ASC = "BATCH_CLAIMS_MIN_POA_4_ASC",
  BATCH_CLAIMS_MIN_POA_4_DESC = "BATCH_CLAIMS_MIN_POA_4_DESC",
  BATCH_CLAIMS_MIN_POA_5_ASC = "BATCH_CLAIMS_MIN_POA_5_ASC",
  BATCH_CLAIMS_MIN_POA_5_DESC = "BATCH_CLAIMS_MIN_POA_5_DESC",
  BATCH_CLAIMS_MIN_POA_6_ASC = "BATCH_CLAIMS_MIN_POA_6_ASC",
  BATCH_CLAIMS_MIN_POA_6_DESC = "BATCH_CLAIMS_MIN_POA_6_DESC",
  BATCH_CLAIMS_MIN_POA_7_ASC = "BATCH_CLAIMS_MIN_POA_7_ASC",
  BATCH_CLAIMS_MIN_POA_7_DESC = "BATCH_CLAIMS_MIN_POA_7_DESC",
  BATCH_CLAIMS_MIN_POA_8_ASC = "BATCH_CLAIMS_MIN_POA_8_ASC",
  BATCH_CLAIMS_MIN_POA_8_DESC = "BATCH_CLAIMS_MIN_POA_8_DESC",
  BATCH_CLAIMS_MIN_POA_9_ASC = "BATCH_CLAIMS_MIN_POA_9_ASC",
  BATCH_CLAIMS_MIN_POA_9_DESC = "BATCH_CLAIMS_MIN_POA_9_DESC",
  BATCH_CLAIMS_MIN_POA_10_ASC = "BATCH_CLAIMS_MIN_POA_10_ASC",
  BATCH_CLAIMS_MIN_POA_10_DESC = "BATCH_CLAIMS_MIN_POA_10_DESC",
  BATCH_CLAIMS_MIN_POA_11_ASC = "BATCH_CLAIMS_MIN_POA_11_ASC",
  BATCH_CLAIMS_MIN_POA_11_DESC = "BATCH_CLAIMS_MIN_POA_11_DESC",
  BATCH_CLAIMS_MIN_POA_12_ASC = "BATCH_CLAIMS_MIN_POA_12_ASC",
  BATCH_CLAIMS_MIN_POA_12_DESC = "BATCH_CLAIMS_MIN_POA_12_DESC",
  BATCH_CLAIMS_MIN_POA_13_ASC = "BATCH_CLAIMS_MIN_POA_13_ASC",
  BATCH_CLAIMS_MIN_POA_13_DESC = "BATCH_CLAIMS_MIN_POA_13_DESC",
  BATCH_CLAIMS_MIN_POA_14_ASC = "BATCH_CLAIMS_MIN_POA_14_ASC",
  BATCH_CLAIMS_MIN_POA_14_DESC = "BATCH_CLAIMS_MIN_POA_14_DESC",
  BATCH_CLAIMS_MIN_POA_15_ASC = "BATCH_CLAIMS_MIN_POA_15_ASC",
  BATCH_CLAIMS_MIN_POA_15_DESC = "BATCH_CLAIMS_MIN_POA_15_DESC",
  BATCH_CLAIMS_MIN_POA_16_ASC = "BATCH_CLAIMS_MIN_POA_16_ASC",
  BATCH_CLAIMS_MIN_POA_16_DESC = "BATCH_CLAIMS_MIN_POA_16_DESC",
  BATCH_CLAIMS_MIN_POA_17_ASC = "BATCH_CLAIMS_MIN_POA_17_ASC",
  BATCH_CLAIMS_MIN_POA_17_DESC = "BATCH_CLAIMS_MIN_POA_17_DESC",
  BATCH_CLAIMS_MIN_POA_18_ASC = "BATCH_CLAIMS_MIN_POA_18_ASC",
  BATCH_CLAIMS_MIN_POA_18_DESC = "BATCH_CLAIMS_MIN_POA_18_DESC",
  BATCH_CLAIMS_MIN_POA_19_ASC = "BATCH_CLAIMS_MIN_POA_19_ASC",
  BATCH_CLAIMS_MIN_POA_19_DESC = "BATCH_CLAIMS_MIN_POA_19_DESC",
  BATCH_CLAIMS_MIN_POA_20_ASC = "BATCH_CLAIMS_MIN_POA_20_ASC",
  BATCH_CLAIMS_MIN_POA_20_DESC = "BATCH_CLAIMS_MIN_POA_20_DESC",
  BATCH_CLAIMS_MIN_POA_21_ASC = "BATCH_CLAIMS_MIN_POA_21_ASC",
  BATCH_CLAIMS_MIN_POA_21_DESC = "BATCH_CLAIMS_MIN_POA_21_DESC",
  BATCH_CLAIMS_MIN_POA_22_ASC = "BATCH_CLAIMS_MIN_POA_22_ASC",
  BATCH_CLAIMS_MIN_POA_22_DESC = "BATCH_CLAIMS_MIN_POA_22_DESC",
  BATCH_CLAIMS_MIN_POA_23_ASC = "BATCH_CLAIMS_MIN_POA_23_ASC",
  BATCH_CLAIMS_MIN_POA_23_DESC = "BATCH_CLAIMS_MIN_POA_23_DESC",
  BATCH_CLAIMS_MIN_POA_24_ASC = "BATCH_CLAIMS_MIN_POA_24_ASC",
  BATCH_CLAIMS_MIN_POA_24_DESC = "BATCH_CLAIMS_MIN_POA_24_DESC",
  BATCH_CLAIMS_MIN_POA_25_ASC = "BATCH_CLAIMS_MIN_POA_25_ASC",
  BATCH_CLAIMS_MIN_POA_25_DESC = "BATCH_CLAIMS_MIN_POA_25_DESC",
  BATCH_CLAIMS_MIN_PREPAY_DENY_ASC = "BATCH_CLAIMS_MIN_PREPAY_DENY_ASC",
  BATCH_CLAIMS_MIN_PREPAY_DENY_DESC = "BATCH_CLAIMS_MIN_PREPAY_DENY_DESC",
  BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_MIN_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_MIN_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_MIN_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_MIN_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_MIN_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_MIN_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_MIN_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_MIN_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_MIN_PROVIDER_ID_ASC = "BATCH_CLAIMS_MIN_PROVIDER_ID_ASC",
  BATCH_CLAIMS_MIN_PROVIDER_ID_DESC = "BATCH_CLAIMS_MIN_PROVIDER_ID_DESC",
  BATCH_CLAIMS_MIN_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_MIN_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_MIN_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_MIN_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_MIN_UPDATED_AT_ASC = "BATCH_CLAIMS_MIN_UPDATED_AT_ASC",
  BATCH_CLAIMS_MIN_UPDATED_AT_DESC = "BATCH_CLAIMS_MIN_UPDATED_AT_DESC",
  BATCH_CLAIMS_MIN_VERSION_ASC = "BATCH_CLAIMS_MIN_VERSION_ASC",
  BATCH_CLAIMS_MIN_VERSION_DESC = "BATCH_CLAIMS_MIN_VERSION_DESC",
  BATCH_CLAIMS_MIN_VERSION_GROUP_ASC = "BATCH_CLAIMS_MIN_VERSION_GROUP_ASC",
  BATCH_CLAIMS_MIN_VERSION_GROUP_DESC = "BATCH_CLAIMS_MIN_VERSION_GROUP_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ADM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_APR_DRG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_BILL_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_ICN_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_ADMIT_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_1_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_2_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_3_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_4_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_5_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_6_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_7_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_8_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_9_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_10_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_11_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_12_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_13_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_14_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_15_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_16_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_17_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_18_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_19_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_20_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_21_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_22_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_23_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DIAG_24_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_DRG_CODE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ICN_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ICN_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ICN_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ICN_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_OWNER_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PAID_DATE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_DOB_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PATIENT_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_1_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_1_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_1_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_1_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_2_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_2_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_2_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_2_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_3_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_3_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_3_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_3_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_4_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_4_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_4_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_4_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_5_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_5_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_5_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_5_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_6_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_6_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_6_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_6_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_7_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_7_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_7_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_7_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_8_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_8_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_8_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_8_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_9_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_9_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_9_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_9_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_10_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_10_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_10_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_10_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_11_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_11_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_11_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_11_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_12_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_12_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_12_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_12_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_13_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_13_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_13_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_13_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_14_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_14_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_14_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_14_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_15_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_15_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_15_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_15_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_16_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_16_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_16_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_16_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_17_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_17_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_17_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_17_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_18_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_18_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_18_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_18_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_19_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_19_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_19_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_19_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_20_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_20_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_20_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_20_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_21_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_21_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_21_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_21_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_22_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_22_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_22_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_22_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_23_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_23_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_23_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_23_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_24_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_24_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_24_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_24_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_25_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_25_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_POA_25_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_POA_25_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PREPAY_DENY_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_DESC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_ASC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_ASC",
  BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_DESC = "BATCH_CLAIMS_STDDEV_POPULATION_VERSION_GROUP_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ADM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_APR_DRG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_BILL_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_1_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_2_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_3_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_4_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_5_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_6_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_7_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_8_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_9_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_10_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_11_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_12_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_13_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_14_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_15_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_16_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_17_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_18_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_19_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_20_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_21_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_22_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_23_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DIAG_24_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_DRG_CODE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ICN_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ICN_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ICN_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ICN_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_OWNER_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAID_DATE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PATIENT_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_1_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_2_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_3_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_4_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_5_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_6_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_7_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_8_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_9_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_10_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_11_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_12_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_13_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_14_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_15_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_16_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_17_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_18_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_19_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_20_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_21_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_22_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_23_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_24_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_POA_25_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_DESC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_ASC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_DESC = "BATCH_CLAIMS_STDDEV_SAMPLE_VERSION_GROUP_DESC",
  BATCH_CLAIMS_SUM_ADMIT_DIAG_ASC = "BATCH_CLAIMS_SUM_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_SUM_ADMIT_DIAG_DESC = "BATCH_CLAIMS_SUM_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_SUM_ADM_TYPE_ASC = "BATCH_CLAIMS_SUM_ADM_TYPE_ASC",
  BATCH_CLAIMS_SUM_ADM_TYPE_DESC = "BATCH_CLAIMS_SUM_ADM_TYPE_DESC",
  BATCH_CLAIMS_SUM_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_SUM_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_SUM_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_SUM_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_SUM_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_SUM_APR_DRG_ASC = "BATCH_CLAIMS_SUM_APR_DRG_ASC",
  BATCH_CLAIMS_SUM_APR_DRG_DESC = "BATCH_CLAIMS_SUM_APR_DRG_DESC",
  BATCH_CLAIMS_SUM_AUTHOR_ID_ASC = "BATCH_CLAIMS_SUM_AUTHOR_ID_ASC",
  BATCH_CLAIMS_SUM_AUTHOR_ID_DESC = "BATCH_CLAIMS_SUM_AUTHOR_ID_DESC",
  BATCH_CLAIMS_SUM_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_SUM_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_SUM_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_SUM_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_SUM_BILL_TYPE_ASC = "BATCH_CLAIMS_SUM_BILL_TYPE_ASC",
  BATCH_CLAIMS_SUM_BILL_TYPE_DESC = "BATCH_CLAIMS_SUM_BILL_TYPE_DESC",
  BATCH_CLAIMS_SUM_CLAIM_TYPE_ASC = "BATCH_CLAIMS_SUM_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_SUM_CLAIM_TYPE_DESC = "BATCH_CLAIMS_SUM_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_SUM_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_SUM_CLIENT_ICN_ASC = "BATCH_CLAIMS_SUM_CLIENT_ICN_ASC",
  BATCH_CLAIMS_SUM_CLIENT_ICN_DESC = "BATCH_CLAIMS_SUM_CLIENT_ICN_DESC",
  BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_SUM_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_SUM_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_SUM_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_SUM_CREATED_AT_ASC = "BATCH_CLAIMS_SUM_CREATED_AT_ASC",
  BATCH_CLAIMS_SUM_CREATED_AT_DESC = "BATCH_CLAIMS_SUM_CREATED_AT_DESC",
  BATCH_CLAIMS_SUM_DATE_ADMIT_ASC = "BATCH_CLAIMS_SUM_DATE_ADMIT_ASC",
  BATCH_CLAIMS_SUM_DATE_ADMIT_DESC = "BATCH_CLAIMS_SUM_DATE_ADMIT_DESC",
  BATCH_CLAIMS_SUM_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_SUM_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_SUM_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_SUM_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_SUM_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_SUM_DIAG_1_ASC = "BATCH_CLAIMS_SUM_DIAG_1_ASC",
  BATCH_CLAIMS_SUM_DIAG_1_DESC = "BATCH_CLAIMS_SUM_DIAG_1_DESC",
  BATCH_CLAIMS_SUM_DIAG_2_ASC = "BATCH_CLAIMS_SUM_DIAG_2_ASC",
  BATCH_CLAIMS_SUM_DIAG_2_DESC = "BATCH_CLAIMS_SUM_DIAG_2_DESC",
  BATCH_CLAIMS_SUM_DIAG_3_ASC = "BATCH_CLAIMS_SUM_DIAG_3_ASC",
  BATCH_CLAIMS_SUM_DIAG_3_DESC = "BATCH_CLAIMS_SUM_DIAG_3_DESC",
  BATCH_CLAIMS_SUM_DIAG_4_ASC = "BATCH_CLAIMS_SUM_DIAG_4_ASC",
  BATCH_CLAIMS_SUM_DIAG_4_DESC = "BATCH_CLAIMS_SUM_DIAG_4_DESC",
  BATCH_CLAIMS_SUM_DIAG_5_ASC = "BATCH_CLAIMS_SUM_DIAG_5_ASC",
  BATCH_CLAIMS_SUM_DIAG_5_DESC = "BATCH_CLAIMS_SUM_DIAG_5_DESC",
  BATCH_CLAIMS_SUM_DIAG_6_ASC = "BATCH_CLAIMS_SUM_DIAG_6_ASC",
  BATCH_CLAIMS_SUM_DIAG_6_DESC = "BATCH_CLAIMS_SUM_DIAG_6_DESC",
  BATCH_CLAIMS_SUM_DIAG_7_ASC = "BATCH_CLAIMS_SUM_DIAG_7_ASC",
  BATCH_CLAIMS_SUM_DIAG_7_DESC = "BATCH_CLAIMS_SUM_DIAG_7_DESC",
  BATCH_CLAIMS_SUM_DIAG_8_ASC = "BATCH_CLAIMS_SUM_DIAG_8_ASC",
  BATCH_CLAIMS_SUM_DIAG_8_DESC = "BATCH_CLAIMS_SUM_DIAG_8_DESC",
  BATCH_CLAIMS_SUM_DIAG_9_ASC = "BATCH_CLAIMS_SUM_DIAG_9_ASC",
  BATCH_CLAIMS_SUM_DIAG_9_DESC = "BATCH_CLAIMS_SUM_DIAG_9_DESC",
  BATCH_CLAIMS_SUM_DIAG_10_ASC = "BATCH_CLAIMS_SUM_DIAG_10_ASC",
  BATCH_CLAIMS_SUM_DIAG_10_DESC = "BATCH_CLAIMS_SUM_DIAG_10_DESC",
  BATCH_CLAIMS_SUM_DIAG_11_ASC = "BATCH_CLAIMS_SUM_DIAG_11_ASC",
  BATCH_CLAIMS_SUM_DIAG_11_DESC = "BATCH_CLAIMS_SUM_DIAG_11_DESC",
  BATCH_CLAIMS_SUM_DIAG_12_ASC = "BATCH_CLAIMS_SUM_DIAG_12_ASC",
  BATCH_CLAIMS_SUM_DIAG_12_DESC = "BATCH_CLAIMS_SUM_DIAG_12_DESC",
  BATCH_CLAIMS_SUM_DIAG_13_ASC = "BATCH_CLAIMS_SUM_DIAG_13_ASC",
  BATCH_CLAIMS_SUM_DIAG_13_DESC = "BATCH_CLAIMS_SUM_DIAG_13_DESC",
  BATCH_CLAIMS_SUM_DIAG_14_ASC = "BATCH_CLAIMS_SUM_DIAG_14_ASC",
  BATCH_CLAIMS_SUM_DIAG_14_DESC = "BATCH_CLAIMS_SUM_DIAG_14_DESC",
  BATCH_CLAIMS_SUM_DIAG_15_ASC = "BATCH_CLAIMS_SUM_DIAG_15_ASC",
  BATCH_CLAIMS_SUM_DIAG_15_DESC = "BATCH_CLAIMS_SUM_DIAG_15_DESC",
  BATCH_CLAIMS_SUM_DIAG_16_ASC = "BATCH_CLAIMS_SUM_DIAG_16_ASC",
  BATCH_CLAIMS_SUM_DIAG_16_DESC = "BATCH_CLAIMS_SUM_DIAG_16_DESC",
  BATCH_CLAIMS_SUM_DIAG_17_ASC = "BATCH_CLAIMS_SUM_DIAG_17_ASC",
  BATCH_CLAIMS_SUM_DIAG_17_DESC = "BATCH_CLAIMS_SUM_DIAG_17_DESC",
  BATCH_CLAIMS_SUM_DIAG_18_ASC = "BATCH_CLAIMS_SUM_DIAG_18_ASC",
  BATCH_CLAIMS_SUM_DIAG_18_DESC = "BATCH_CLAIMS_SUM_DIAG_18_DESC",
  BATCH_CLAIMS_SUM_DIAG_19_ASC = "BATCH_CLAIMS_SUM_DIAG_19_ASC",
  BATCH_CLAIMS_SUM_DIAG_19_DESC = "BATCH_CLAIMS_SUM_DIAG_19_DESC",
  BATCH_CLAIMS_SUM_DIAG_20_ASC = "BATCH_CLAIMS_SUM_DIAG_20_ASC",
  BATCH_CLAIMS_SUM_DIAG_20_DESC = "BATCH_CLAIMS_SUM_DIAG_20_DESC",
  BATCH_CLAIMS_SUM_DIAG_21_ASC = "BATCH_CLAIMS_SUM_DIAG_21_ASC",
  BATCH_CLAIMS_SUM_DIAG_21_DESC = "BATCH_CLAIMS_SUM_DIAG_21_DESC",
  BATCH_CLAIMS_SUM_DIAG_22_ASC = "BATCH_CLAIMS_SUM_DIAG_22_ASC",
  BATCH_CLAIMS_SUM_DIAG_22_DESC = "BATCH_CLAIMS_SUM_DIAG_22_DESC",
  BATCH_CLAIMS_SUM_DIAG_23_ASC = "BATCH_CLAIMS_SUM_DIAG_23_ASC",
  BATCH_CLAIMS_SUM_DIAG_23_DESC = "BATCH_CLAIMS_SUM_DIAG_23_DESC",
  BATCH_CLAIMS_SUM_DIAG_24_ASC = "BATCH_CLAIMS_SUM_DIAG_24_ASC",
  BATCH_CLAIMS_SUM_DIAG_24_DESC = "BATCH_CLAIMS_SUM_DIAG_24_DESC",
  BATCH_CLAIMS_SUM_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_SUM_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_SUM_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_SUM_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_SUM_DRG_CODE_ASC = "BATCH_CLAIMS_SUM_DRG_CODE_ASC",
  BATCH_CLAIMS_SUM_DRG_CODE_DESC = "BATCH_CLAIMS_SUM_DRG_CODE_DESC",
  BATCH_CLAIMS_SUM_ICN_ASC = "BATCH_CLAIMS_SUM_ICN_ASC",
  BATCH_CLAIMS_SUM_ICN_DESC = "BATCH_CLAIMS_SUM_ICN_DESC",
  BATCH_CLAIMS_SUM_ID_ASC = "BATCH_CLAIMS_SUM_ID_ASC",
  BATCH_CLAIMS_SUM_ID_DESC = "BATCH_CLAIMS_SUM_ID_DESC",
  BATCH_CLAIMS_SUM_INSURER_ID_ASC = "BATCH_CLAIMS_SUM_INSURER_ID_ASC",
  BATCH_CLAIMS_SUM_INSURER_ID_DESC = "BATCH_CLAIMS_SUM_INSURER_ID_DESC",
  BATCH_CLAIMS_SUM_OWNER_ID_ASC = "BATCH_CLAIMS_SUM_OWNER_ID_ASC",
  BATCH_CLAIMS_SUM_OWNER_ID_DESC = "BATCH_CLAIMS_SUM_OWNER_ID_DESC",
  BATCH_CLAIMS_SUM_PAID_DATE_ASC = "BATCH_CLAIMS_SUM_PAID_DATE_ASC",
  BATCH_CLAIMS_SUM_PAID_DATE_DESC = "BATCH_CLAIMS_SUM_PAID_DATE_DESC",
  BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_SUM_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_SUM_PATIENT_DOB_ASC = "BATCH_CLAIMS_SUM_PATIENT_DOB_ASC",
  BATCH_CLAIMS_SUM_PATIENT_DOB_DESC = "BATCH_CLAIMS_SUM_PATIENT_DOB_DESC",
  BATCH_CLAIMS_SUM_PATIENT_GENDER_ASC = "BATCH_CLAIMS_SUM_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_SUM_PATIENT_GENDER_DESC = "BATCH_CLAIMS_SUM_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_SUM_PATIENT_ID_ASC = "BATCH_CLAIMS_SUM_PATIENT_ID_ASC",
  BATCH_CLAIMS_SUM_PATIENT_ID_DESC = "BATCH_CLAIMS_SUM_PATIENT_ID_DESC",
  BATCH_CLAIMS_SUM_PAYMENT_RATE_ASC = "BATCH_CLAIMS_SUM_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_SUM_PAYMENT_RATE_DESC = "BATCH_CLAIMS_SUM_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_SUM_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_SUM_POA_1_ASC = "BATCH_CLAIMS_SUM_POA_1_ASC",
  BATCH_CLAIMS_SUM_POA_1_DESC = "BATCH_CLAIMS_SUM_POA_1_DESC",
  BATCH_CLAIMS_SUM_POA_2_ASC = "BATCH_CLAIMS_SUM_POA_2_ASC",
  BATCH_CLAIMS_SUM_POA_2_DESC = "BATCH_CLAIMS_SUM_POA_2_DESC",
  BATCH_CLAIMS_SUM_POA_3_ASC = "BATCH_CLAIMS_SUM_POA_3_ASC",
  BATCH_CLAIMS_SUM_POA_3_DESC = "BATCH_CLAIMS_SUM_POA_3_DESC",
  BATCH_CLAIMS_SUM_POA_4_ASC = "BATCH_CLAIMS_SUM_POA_4_ASC",
  BATCH_CLAIMS_SUM_POA_4_DESC = "BATCH_CLAIMS_SUM_POA_4_DESC",
  BATCH_CLAIMS_SUM_POA_5_ASC = "BATCH_CLAIMS_SUM_POA_5_ASC",
  BATCH_CLAIMS_SUM_POA_5_DESC = "BATCH_CLAIMS_SUM_POA_5_DESC",
  BATCH_CLAIMS_SUM_POA_6_ASC = "BATCH_CLAIMS_SUM_POA_6_ASC",
  BATCH_CLAIMS_SUM_POA_6_DESC = "BATCH_CLAIMS_SUM_POA_6_DESC",
  BATCH_CLAIMS_SUM_POA_7_ASC = "BATCH_CLAIMS_SUM_POA_7_ASC",
  BATCH_CLAIMS_SUM_POA_7_DESC = "BATCH_CLAIMS_SUM_POA_7_DESC",
  BATCH_CLAIMS_SUM_POA_8_ASC = "BATCH_CLAIMS_SUM_POA_8_ASC",
  BATCH_CLAIMS_SUM_POA_8_DESC = "BATCH_CLAIMS_SUM_POA_8_DESC",
  BATCH_CLAIMS_SUM_POA_9_ASC = "BATCH_CLAIMS_SUM_POA_9_ASC",
  BATCH_CLAIMS_SUM_POA_9_DESC = "BATCH_CLAIMS_SUM_POA_9_DESC",
  BATCH_CLAIMS_SUM_POA_10_ASC = "BATCH_CLAIMS_SUM_POA_10_ASC",
  BATCH_CLAIMS_SUM_POA_10_DESC = "BATCH_CLAIMS_SUM_POA_10_DESC",
  BATCH_CLAIMS_SUM_POA_11_ASC = "BATCH_CLAIMS_SUM_POA_11_ASC",
  BATCH_CLAIMS_SUM_POA_11_DESC = "BATCH_CLAIMS_SUM_POA_11_DESC",
  BATCH_CLAIMS_SUM_POA_12_ASC = "BATCH_CLAIMS_SUM_POA_12_ASC",
  BATCH_CLAIMS_SUM_POA_12_DESC = "BATCH_CLAIMS_SUM_POA_12_DESC",
  BATCH_CLAIMS_SUM_POA_13_ASC = "BATCH_CLAIMS_SUM_POA_13_ASC",
  BATCH_CLAIMS_SUM_POA_13_DESC = "BATCH_CLAIMS_SUM_POA_13_DESC",
  BATCH_CLAIMS_SUM_POA_14_ASC = "BATCH_CLAIMS_SUM_POA_14_ASC",
  BATCH_CLAIMS_SUM_POA_14_DESC = "BATCH_CLAIMS_SUM_POA_14_DESC",
  BATCH_CLAIMS_SUM_POA_15_ASC = "BATCH_CLAIMS_SUM_POA_15_ASC",
  BATCH_CLAIMS_SUM_POA_15_DESC = "BATCH_CLAIMS_SUM_POA_15_DESC",
  BATCH_CLAIMS_SUM_POA_16_ASC = "BATCH_CLAIMS_SUM_POA_16_ASC",
  BATCH_CLAIMS_SUM_POA_16_DESC = "BATCH_CLAIMS_SUM_POA_16_DESC",
  BATCH_CLAIMS_SUM_POA_17_ASC = "BATCH_CLAIMS_SUM_POA_17_ASC",
  BATCH_CLAIMS_SUM_POA_17_DESC = "BATCH_CLAIMS_SUM_POA_17_DESC",
  BATCH_CLAIMS_SUM_POA_18_ASC = "BATCH_CLAIMS_SUM_POA_18_ASC",
  BATCH_CLAIMS_SUM_POA_18_DESC = "BATCH_CLAIMS_SUM_POA_18_DESC",
  BATCH_CLAIMS_SUM_POA_19_ASC = "BATCH_CLAIMS_SUM_POA_19_ASC",
  BATCH_CLAIMS_SUM_POA_19_DESC = "BATCH_CLAIMS_SUM_POA_19_DESC",
  BATCH_CLAIMS_SUM_POA_20_ASC = "BATCH_CLAIMS_SUM_POA_20_ASC",
  BATCH_CLAIMS_SUM_POA_20_DESC = "BATCH_CLAIMS_SUM_POA_20_DESC",
  BATCH_CLAIMS_SUM_POA_21_ASC = "BATCH_CLAIMS_SUM_POA_21_ASC",
  BATCH_CLAIMS_SUM_POA_21_DESC = "BATCH_CLAIMS_SUM_POA_21_DESC",
  BATCH_CLAIMS_SUM_POA_22_ASC = "BATCH_CLAIMS_SUM_POA_22_ASC",
  BATCH_CLAIMS_SUM_POA_22_DESC = "BATCH_CLAIMS_SUM_POA_22_DESC",
  BATCH_CLAIMS_SUM_POA_23_ASC = "BATCH_CLAIMS_SUM_POA_23_ASC",
  BATCH_CLAIMS_SUM_POA_23_DESC = "BATCH_CLAIMS_SUM_POA_23_DESC",
  BATCH_CLAIMS_SUM_POA_24_ASC = "BATCH_CLAIMS_SUM_POA_24_ASC",
  BATCH_CLAIMS_SUM_POA_24_DESC = "BATCH_CLAIMS_SUM_POA_24_DESC",
  BATCH_CLAIMS_SUM_POA_25_ASC = "BATCH_CLAIMS_SUM_POA_25_ASC",
  BATCH_CLAIMS_SUM_POA_25_DESC = "BATCH_CLAIMS_SUM_POA_25_DESC",
  BATCH_CLAIMS_SUM_PREPAY_DENY_ASC = "BATCH_CLAIMS_SUM_PREPAY_DENY_ASC",
  BATCH_CLAIMS_SUM_PREPAY_DENY_DESC = "BATCH_CLAIMS_SUM_PREPAY_DENY_DESC",
  BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_SUM_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_SUM_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_SUM_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_SUM_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_SUM_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_SUM_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_SUM_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_SUM_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_SUM_PROVIDER_ID_ASC = "BATCH_CLAIMS_SUM_PROVIDER_ID_ASC",
  BATCH_CLAIMS_SUM_PROVIDER_ID_DESC = "BATCH_CLAIMS_SUM_PROVIDER_ID_DESC",
  BATCH_CLAIMS_SUM_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_SUM_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_SUM_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_SUM_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_SUM_UPDATED_AT_ASC = "BATCH_CLAIMS_SUM_UPDATED_AT_ASC",
  BATCH_CLAIMS_SUM_UPDATED_AT_DESC = "BATCH_CLAIMS_SUM_UPDATED_AT_DESC",
  BATCH_CLAIMS_SUM_VERSION_ASC = "BATCH_CLAIMS_SUM_VERSION_ASC",
  BATCH_CLAIMS_SUM_VERSION_DESC = "BATCH_CLAIMS_SUM_VERSION_DESC",
  BATCH_CLAIMS_SUM_VERSION_GROUP_ASC = "BATCH_CLAIMS_SUM_VERSION_GROUP_ASC",
  BATCH_CLAIMS_SUM_VERSION_GROUP_DESC = "BATCH_CLAIMS_SUM_VERSION_GROUP_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ADM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_APR_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_BILL_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_CREATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_ADMIT_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_1_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_2_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_3_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_4_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_5_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_6_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_7_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_8_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_9_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_10_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_11_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_12_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_13_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_14_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_15_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_16_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_17_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_18_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_19_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_20_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_21_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_22_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_23_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DIAG_24_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_DRG_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ICN_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ICN_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_INSURER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_OWNER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAID_DATE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_DOB_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PATIENT_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_1_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_2_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_3_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_4_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_5_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_6_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_7_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_8_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_9_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_10_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_11_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_12_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_13_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_14_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_15_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_16_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_17_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_18_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_19_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_20_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_21_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_22_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_23_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_24_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_POA_25_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREPAY_DENY_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_DESC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_ASC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_ASC",
  BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_DESC = "BATCH_CLAIMS_VARIANCE_POPULATION_VERSION_GROUP_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADMIT_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ADM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_CHARGED_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_APR_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BATCH_FILE_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_BILL_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLAIM_TYPE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CLIENT_PLAN_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_ADMIT_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_DISCHARGE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_1_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_2_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_3_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_4_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_5_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_6_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_7_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_8_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_9_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_10_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_11_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_12_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_13_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_14_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_15_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_16_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_17_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_18_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_19_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_20_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_21_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_22_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_23_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DIAG_24_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DISCHARGE_STATUS_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_DRG_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ICN_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_INSURER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_OWNER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAID_DATE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_DOB_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_GENDER_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PATIENT_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PAYMENT_RATE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_1_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_2_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_3_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_4_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_5_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_6_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_7_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_8_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_9_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_10_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_11_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_12_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_13_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_14_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_15_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_16_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_17_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_18_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_19_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_20_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_21_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_22_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_23_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_24_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_POA_25_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREPAY_DENY_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_DIAG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_POA_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_1_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_2_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_3_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_4_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_5_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_6_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_7_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_8_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_9_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROCEDURE_CODE_10_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_SUBMITTED_DRG_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_DESC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_ASC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_ASC",
  BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_DESC = "BATCH_CLAIMS_VARIANCE_SAMPLE_VERSION_GROUP_DESC",
  BILLING_CITY_ASC = "BILLING_CITY_ASC",
  BILLING_CITY_DESC = "BILLING_CITY_DESC",
  BILLING_NAME_ASC = "BILLING_NAME_ASC",
  BILLING_NAME_DESC = "BILLING_NAME_DESC",
  BILLING_NPI_ASC = "BILLING_NPI_ASC",
  BILLING_NPI_DESC = "BILLING_NPI_DESC",
  BILLING_STATE_ASC = "BILLING_STATE_ASC",
  BILLING_STATE_DESC = "BILLING_STATE_DESC",
  CITY_ASC = "CITY_ASC",
  CITY_DESC = "CITY_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_AVERAGE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_COUNT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_COUNT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_COUNT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_COUNT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MAX_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_MAX_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MAX_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_MAX_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MAX_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_MAX_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MAX_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_MAX_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MAX_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_MAX_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MAX_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_MAX_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MAX_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_MAX_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MAX_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_MAX_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MIN_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_MIN_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MIN_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_MIN_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MIN_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_MIN_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MIN_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_MIN_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MIN_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_MIN_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MIN_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_MIN_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MIN_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_MIN_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_MIN_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_MIN_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_SUM_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_SUM_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_SUM_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_SUM_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_SUM_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_SUM_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_SUM_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_SUM_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_SUM_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_SUM_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_SUM_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_SUM_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_SUM_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_SUM_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_SUM_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_SUM_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REPLY_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_AVERAGE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_COUNT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MAX_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_MIN_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_SUM_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_AUDIT_FINDING_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_LINE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_DOCUMENT_UPLOAD_KIND_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_MESSAGE_ID_DESC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "CLAIM_INQUIRY_REQUEST_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  CLIENT_BILLING_ID_ASC = "CLIENT_BILLING_ID_ASC",
  CLIENT_BILLING_ID_DESC = "CLIENT_BILLING_ID_DESC",
  CLIENT_PROVIDER_ID_ASC = "CLIENT_PROVIDER_ID_ASC",
  CLIENT_PROVIDER_ID_DESC = "CLIENT_PROVIDER_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_AVERAGE_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_AVERAGE_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_AVERAGE_CREATED_AT_ASC = "DISPUTED_FINDINGS_AVERAGE_CREATED_AT_ASC",
  DISPUTED_FINDINGS_AVERAGE_CREATED_AT_DESC = "DISPUTED_FINDINGS_AVERAGE_CREATED_AT_DESC",
  DISPUTED_FINDINGS_AVERAGE_DELETED_ASC = "DISPUTED_FINDINGS_AVERAGE_DELETED_ASC",
  DISPUTED_FINDINGS_AVERAGE_DELETED_DESC = "DISPUTED_FINDINGS_AVERAGE_DELETED_DESC",
  DISPUTED_FINDINGS_AVERAGE_ID_ASC = "DISPUTED_FINDINGS_AVERAGE_ID_ASC",
  DISPUTED_FINDINGS_AVERAGE_ID_DESC = "DISPUTED_FINDINGS_AVERAGE_ID_DESC",
  DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_AVERAGE_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_ASC = "DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_DESC = "DISPUTED_FINDINGS_AVERAGE_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_BY_PROVIDER_ID__COUNT_ASC = "DISPUTED_FINDINGS_BY_PROVIDER_ID__COUNT_ASC",
  DISPUTED_FINDINGS_BY_PROVIDER_ID__COUNT_DESC = "DISPUTED_FINDINGS_BY_PROVIDER_ID__COUNT_DESC",
  DISPUTED_FINDINGS_COUNT_ASC = "DISPUTED_FINDINGS_COUNT_ASC",
  DISPUTED_FINDINGS_COUNT_DESC = "DISPUTED_FINDINGS_COUNT_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_CREATED_AT_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_DELETED_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_ID_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_ID_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_ID_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_ID_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC = "DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC = "DISPUTED_FINDINGS_DISTINCT_COUNT_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_MAX_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_MAX_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_MAX_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_MAX_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_MAX_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_MAX_CREATED_AT_ASC = "DISPUTED_FINDINGS_MAX_CREATED_AT_ASC",
  DISPUTED_FINDINGS_MAX_CREATED_AT_DESC = "DISPUTED_FINDINGS_MAX_CREATED_AT_DESC",
  DISPUTED_FINDINGS_MAX_DELETED_ASC = "DISPUTED_FINDINGS_MAX_DELETED_ASC",
  DISPUTED_FINDINGS_MAX_DELETED_DESC = "DISPUTED_FINDINGS_MAX_DELETED_DESC",
  DISPUTED_FINDINGS_MAX_ID_ASC = "DISPUTED_FINDINGS_MAX_ID_ASC",
  DISPUTED_FINDINGS_MAX_ID_DESC = "DISPUTED_FINDINGS_MAX_ID_DESC",
  DISPUTED_FINDINGS_MAX_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_MAX_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_MAX_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_MAX_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_MAX_UPDATED_AT_ASC = "DISPUTED_FINDINGS_MAX_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_MAX_UPDATED_AT_DESC = "DISPUTED_FINDINGS_MAX_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_MIN_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_MIN_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_MIN_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_MIN_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_MIN_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_MIN_CREATED_AT_ASC = "DISPUTED_FINDINGS_MIN_CREATED_AT_ASC",
  DISPUTED_FINDINGS_MIN_CREATED_AT_DESC = "DISPUTED_FINDINGS_MIN_CREATED_AT_DESC",
  DISPUTED_FINDINGS_MIN_DELETED_ASC = "DISPUTED_FINDINGS_MIN_DELETED_ASC",
  DISPUTED_FINDINGS_MIN_DELETED_DESC = "DISPUTED_FINDINGS_MIN_DELETED_DESC",
  DISPUTED_FINDINGS_MIN_ID_ASC = "DISPUTED_FINDINGS_MIN_ID_ASC",
  DISPUTED_FINDINGS_MIN_ID_DESC = "DISPUTED_FINDINGS_MIN_ID_DESC",
  DISPUTED_FINDINGS_MIN_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_MIN_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_MIN_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_MIN_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_MIN_UPDATED_AT_ASC = "DISPUTED_FINDINGS_MIN_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_MIN_UPDATED_AT_DESC = "DISPUTED_FINDINGS_MIN_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_CREATED_AT_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_DELETED_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_ID_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_ID_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC = "DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC = "DISPUTED_FINDINGS_STDDEV_POPULATION_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_CREATED_AT_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_DELETED_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC = "DISPUTED_FINDINGS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_SUM_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_SUM_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_SUM_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_SUM_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_SUM_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_SUM_CREATED_AT_ASC = "DISPUTED_FINDINGS_SUM_CREATED_AT_ASC",
  DISPUTED_FINDINGS_SUM_CREATED_AT_DESC = "DISPUTED_FINDINGS_SUM_CREATED_AT_DESC",
  DISPUTED_FINDINGS_SUM_DELETED_ASC = "DISPUTED_FINDINGS_SUM_DELETED_ASC",
  DISPUTED_FINDINGS_SUM_DELETED_DESC = "DISPUTED_FINDINGS_SUM_DELETED_DESC",
  DISPUTED_FINDINGS_SUM_ID_ASC = "DISPUTED_FINDINGS_SUM_ID_ASC",
  DISPUTED_FINDINGS_SUM_ID_DESC = "DISPUTED_FINDINGS_SUM_ID_DESC",
  DISPUTED_FINDINGS_SUM_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_SUM_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_SUM_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_SUM_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_SUM_UPDATED_AT_ASC = "DISPUTED_FINDINGS_SUM_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_SUM_UPDATED_AT_DESC = "DISPUTED_FINDINGS_SUM_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_CREATED_AT_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_DELETED_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC = "DISPUTED_FINDINGS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_DELETED_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "DISPUTED_FINDINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_CREATED_AT_ASC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_CREATED_AT_ASC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_CREATED_AT_DESC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_CREATED_AT_DESC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_ETAG_ASC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_ETAG_ASC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_ETAG_DESC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_ETAG_DESC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_FILENAME_ASC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_FILENAME_ASC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_FILENAME_DESC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_FILENAME_DESC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_PROVIDER_ID_ASC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_PROVIDER_ID_ASC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_PROVIDER_ID_DESC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_PROVIDER_ID_DESC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_S3_KEY_ASC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_S3_KEY_ASC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_S3_KEY_DESC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_S3_KEY_DESC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_SELECTION_SET_ASC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_SELECTION_SET_ASC",
  DOCUMENTATION_SELECTION_SETS_AVERAGE_SELECTION_SET_DESC = "DOCUMENTATION_SELECTION_SETS_AVERAGE_SELECTION_SET_DESC",
  DOCUMENTATION_SELECTION_SETS_BY_PROVIDER_ID__COUNT_ASC = "DOCUMENTATION_SELECTION_SETS_BY_PROVIDER_ID__COUNT_ASC",
  DOCUMENTATION_SELECTION_SETS_BY_PROVIDER_ID__COUNT_DESC = "DOCUMENTATION_SELECTION_SETS_BY_PROVIDER_ID__COUNT_DESC",
  DOCUMENTATION_SELECTION_SETS_COUNT_ASC = "DOCUMENTATION_SELECTION_SETS_COUNT_ASC",
  DOCUMENTATION_SELECTION_SETS_COUNT_DESC = "DOCUMENTATION_SELECTION_SETS_COUNT_DESC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_CREATED_AT_ASC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_CREATED_AT_ASC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_CREATED_AT_DESC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_CREATED_AT_DESC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_ETAG_ASC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_ETAG_ASC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_ETAG_DESC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_ETAG_DESC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_FILENAME_ASC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_FILENAME_ASC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_FILENAME_DESC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_FILENAME_DESC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_PROVIDER_ID_ASC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_PROVIDER_ID_DESC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_S3_KEY_ASC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_S3_KEY_ASC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_S3_KEY_DESC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_S3_KEY_DESC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_SELECTION_SET_ASC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_SELECTION_SET_ASC",
  DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_SELECTION_SET_DESC = "DOCUMENTATION_SELECTION_SETS_DISTINCT_COUNT_SELECTION_SET_DESC",
  DOCUMENTATION_SELECTION_SETS_MAX_CREATED_AT_ASC = "DOCUMENTATION_SELECTION_SETS_MAX_CREATED_AT_ASC",
  DOCUMENTATION_SELECTION_SETS_MAX_CREATED_AT_DESC = "DOCUMENTATION_SELECTION_SETS_MAX_CREATED_AT_DESC",
  DOCUMENTATION_SELECTION_SETS_MAX_ETAG_ASC = "DOCUMENTATION_SELECTION_SETS_MAX_ETAG_ASC",
  DOCUMENTATION_SELECTION_SETS_MAX_ETAG_DESC = "DOCUMENTATION_SELECTION_SETS_MAX_ETAG_DESC",
  DOCUMENTATION_SELECTION_SETS_MAX_FILENAME_ASC = "DOCUMENTATION_SELECTION_SETS_MAX_FILENAME_ASC",
  DOCUMENTATION_SELECTION_SETS_MAX_FILENAME_DESC = "DOCUMENTATION_SELECTION_SETS_MAX_FILENAME_DESC",
  DOCUMENTATION_SELECTION_SETS_MAX_PROVIDER_ID_ASC = "DOCUMENTATION_SELECTION_SETS_MAX_PROVIDER_ID_ASC",
  DOCUMENTATION_SELECTION_SETS_MAX_PROVIDER_ID_DESC = "DOCUMENTATION_SELECTION_SETS_MAX_PROVIDER_ID_DESC",
  DOCUMENTATION_SELECTION_SETS_MAX_S3_KEY_ASC = "DOCUMENTATION_SELECTION_SETS_MAX_S3_KEY_ASC",
  DOCUMENTATION_SELECTION_SETS_MAX_S3_KEY_DESC = "DOCUMENTATION_SELECTION_SETS_MAX_S3_KEY_DESC",
  DOCUMENTATION_SELECTION_SETS_MAX_SELECTION_SET_ASC = "DOCUMENTATION_SELECTION_SETS_MAX_SELECTION_SET_ASC",
  DOCUMENTATION_SELECTION_SETS_MAX_SELECTION_SET_DESC = "DOCUMENTATION_SELECTION_SETS_MAX_SELECTION_SET_DESC",
  DOCUMENTATION_SELECTION_SETS_MIN_CREATED_AT_ASC = "DOCUMENTATION_SELECTION_SETS_MIN_CREATED_AT_ASC",
  DOCUMENTATION_SELECTION_SETS_MIN_CREATED_AT_DESC = "DOCUMENTATION_SELECTION_SETS_MIN_CREATED_AT_DESC",
  DOCUMENTATION_SELECTION_SETS_MIN_ETAG_ASC = "DOCUMENTATION_SELECTION_SETS_MIN_ETAG_ASC",
  DOCUMENTATION_SELECTION_SETS_MIN_ETAG_DESC = "DOCUMENTATION_SELECTION_SETS_MIN_ETAG_DESC",
  DOCUMENTATION_SELECTION_SETS_MIN_FILENAME_ASC = "DOCUMENTATION_SELECTION_SETS_MIN_FILENAME_ASC",
  DOCUMENTATION_SELECTION_SETS_MIN_FILENAME_DESC = "DOCUMENTATION_SELECTION_SETS_MIN_FILENAME_DESC",
  DOCUMENTATION_SELECTION_SETS_MIN_PROVIDER_ID_ASC = "DOCUMENTATION_SELECTION_SETS_MIN_PROVIDER_ID_ASC",
  DOCUMENTATION_SELECTION_SETS_MIN_PROVIDER_ID_DESC = "DOCUMENTATION_SELECTION_SETS_MIN_PROVIDER_ID_DESC",
  DOCUMENTATION_SELECTION_SETS_MIN_S3_KEY_ASC = "DOCUMENTATION_SELECTION_SETS_MIN_S3_KEY_ASC",
  DOCUMENTATION_SELECTION_SETS_MIN_S3_KEY_DESC = "DOCUMENTATION_SELECTION_SETS_MIN_S3_KEY_DESC",
  DOCUMENTATION_SELECTION_SETS_MIN_SELECTION_SET_ASC = "DOCUMENTATION_SELECTION_SETS_MIN_SELECTION_SET_ASC",
  DOCUMENTATION_SELECTION_SETS_MIN_SELECTION_SET_DESC = "DOCUMENTATION_SELECTION_SETS_MIN_SELECTION_SET_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_CREATED_AT_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_CREATED_AT_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_CREATED_AT_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_CREATED_AT_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_ETAG_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_ETAG_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_ETAG_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_ETAG_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_FILENAME_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_FILENAME_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_FILENAME_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_FILENAME_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_PROVIDER_ID_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_PROVIDER_ID_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_S3_KEY_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_S3_KEY_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_S3_KEY_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_S3_KEY_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_SELECTION_SET_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_SELECTION_SET_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_SELECTION_SET_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_POPULATION_SELECTION_SET_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_CREATED_AT_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_CREATED_AT_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_CREATED_AT_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_CREATED_AT_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_ETAG_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_ETAG_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_ETAG_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_ETAG_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_FILENAME_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_FILENAME_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_FILENAME_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_FILENAME_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_S3_KEY_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_S3_KEY_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_S3_KEY_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_S3_KEY_DESC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_SELECTION_SET_ASC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_SELECTION_SET_ASC",
  DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_SELECTION_SET_DESC = "DOCUMENTATION_SELECTION_SETS_STDDEV_SAMPLE_SELECTION_SET_DESC",
  DOCUMENTATION_SELECTION_SETS_SUM_CREATED_AT_ASC = "DOCUMENTATION_SELECTION_SETS_SUM_CREATED_AT_ASC",
  DOCUMENTATION_SELECTION_SETS_SUM_CREATED_AT_DESC = "DOCUMENTATION_SELECTION_SETS_SUM_CREATED_AT_DESC",
  DOCUMENTATION_SELECTION_SETS_SUM_ETAG_ASC = "DOCUMENTATION_SELECTION_SETS_SUM_ETAG_ASC",
  DOCUMENTATION_SELECTION_SETS_SUM_ETAG_DESC = "DOCUMENTATION_SELECTION_SETS_SUM_ETAG_DESC",
  DOCUMENTATION_SELECTION_SETS_SUM_FILENAME_ASC = "DOCUMENTATION_SELECTION_SETS_SUM_FILENAME_ASC",
  DOCUMENTATION_SELECTION_SETS_SUM_FILENAME_DESC = "DOCUMENTATION_SELECTION_SETS_SUM_FILENAME_DESC",
  DOCUMENTATION_SELECTION_SETS_SUM_PROVIDER_ID_ASC = "DOCUMENTATION_SELECTION_SETS_SUM_PROVIDER_ID_ASC",
  DOCUMENTATION_SELECTION_SETS_SUM_PROVIDER_ID_DESC = "DOCUMENTATION_SELECTION_SETS_SUM_PROVIDER_ID_DESC",
  DOCUMENTATION_SELECTION_SETS_SUM_S3_KEY_ASC = "DOCUMENTATION_SELECTION_SETS_SUM_S3_KEY_ASC",
  DOCUMENTATION_SELECTION_SETS_SUM_S3_KEY_DESC = "DOCUMENTATION_SELECTION_SETS_SUM_S3_KEY_DESC",
  DOCUMENTATION_SELECTION_SETS_SUM_SELECTION_SET_ASC = "DOCUMENTATION_SELECTION_SETS_SUM_SELECTION_SET_ASC",
  DOCUMENTATION_SELECTION_SETS_SUM_SELECTION_SET_DESC = "DOCUMENTATION_SELECTION_SETS_SUM_SELECTION_SET_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_CREATED_AT_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_CREATED_AT_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_CREATED_AT_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_CREATED_AT_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_ETAG_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_ETAG_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_ETAG_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_ETAG_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_FILENAME_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_FILENAME_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_FILENAME_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_FILENAME_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_S3_KEY_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_S3_KEY_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_S3_KEY_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_S3_KEY_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_SELECTION_SET_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_SELECTION_SET_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_SELECTION_SET_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_POPULATION_SELECTION_SET_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_CREATED_AT_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_CREATED_AT_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_ETAG_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_ETAG_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_ETAG_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_ETAG_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_FILENAME_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_FILENAME_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_FILENAME_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_FILENAME_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_S3_KEY_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_S3_KEY_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_S3_KEY_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_S3_KEY_DESC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_SELECTION_SET_ASC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_SELECTION_SET_ASC",
  DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_SELECTION_SET_DESC = "DOCUMENTATION_SELECTION_SETS_VARIANCE_SAMPLE_SELECTION_SET_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_AVERAGE_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_BY_PROVIDER_ID__COUNT_ASC = "DOCUMENT_UPLOAD_CREATEDS_BY_PROVIDER_ID__COUNT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_BY_PROVIDER_ID__COUNT_DESC = "DOCUMENT_UPLOAD_CREATEDS_BY_PROVIDER_ID__COUNT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_COUNT_ASC = "DOCUMENT_UPLOAD_CREATEDS_COUNT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_COUNT_DESC = "DOCUMENT_UPLOAD_CREATEDS_COUNT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_DISTINCT_COUNT_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MAX_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_MIN_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_POPULATION_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_SUM_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_BATCH_CLAIM_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CLAIM_INQUIRY_REQUEST_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_DEPRECATED_MESSAGE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_FILE_LOCATION_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_ID_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_KIND_DESC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "DOCUMENT_UPLOAD_CREATEDS_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
  NATURAL = "NATURAL",
  NPI_ASC = "NPI_ASC",
  NPI_DESC = "NPI_DESC",
  PRACTICE_TYPE_ASC = "PRACTICE_TYPE_ASC",
  PRACTICE_TYPE_DESC = "PRACTICE_TYPE_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROVIDER_USER_FACILITIES_AVERAGE_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_AVERAGE_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_AVERAGE_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_AVERAGE_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_AVERAGE_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_AVERAGE_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_AVERAGE_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_AVERAGE_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_AVERAGE_ID_ASC = "PROVIDER_USER_FACILITIES_AVERAGE_ID_ASC",
  PROVIDER_USER_FACILITIES_AVERAGE_ID_DESC = "PROVIDER_USER_FACILITIES_AVERAGE_ID_DESC",
  PROVIDER_USER_FACILITIES_AVERAGE_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_AVERAGE_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_AVERAGE_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_AVERAGE_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_AVERAGE_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_AVERAGE_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_AVERAGE_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_AVERAGE_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_BY_PROVIDER_ID__COUNT_ASC = "PROVIDER_USER_FACILITIES_BY_PROVIDER_ID__COUNT_ASC",
  PROVIDER_USER_FACILITIES_BY_PROVIDER_ID__COUNT_DESC = "PROVIDER_USER_FACILITIES_BY_PROVIDER_ID__COUNT_DESC",
  PROVIDER_USER_FACILITIES_COUNT_ASC = "PROVIDER_USER_FACILITIES_COUNT_ASC",
  PROVIDER_USER_FACILITIES_COUNT_DESC = "PROVIDER_USER_FACILITIES_COUNT_DESC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_ID_ASC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_ID_ASC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_ID_DESC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_ID_DESC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_DISTINCT_COUNT_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_DISTINCT_COUNT_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_MAX_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_MAX_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_MAX_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_MAX_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_MAX_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_MAX_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_MAX_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_MAX_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_MAX_ID_ASC = "PROVIDER_USER_FACILITIES_MAX_ID_ASC",
  PROVIDER_USER_FACILITIES_MAX_ID_DESC = "PROVIDER_USER_FACILITIES_MAX_ID_DESC",
  PROVIDER_USER_FACILITIES_MAX_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_MAX_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_MAX_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_MAX_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_MAX_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_MAX_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_MAX_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_MAX_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_MIN_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_MIN_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_MIN_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_MIN_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_MIN_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_MIN_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_MIN_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_MIN_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_MIN_ID_ASC = "PROVIDER_USER_FACILITIES_MIN_ID_ASC",
  PROVIDER_USER_FACILITIES_MIN_ID_DESC = "PROVIDER_USER_FACILITIES_MIN_ID_DESC",
  PROVIDER_USER_FACILITIES_MIN_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_MIN_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_MIN_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_MIN_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_MIN_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_MIN_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_MIN_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_MIN_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_POPULATION_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_STDDEV_POPULATION_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_SUM_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_SUM_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_SUM_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_SUM_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_SUM_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_SUM_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_SUM_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_SUM_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_SUM_ID_ASC = "PROVIDER_USER_FACILITIES_SUM_ID_ASC",
  PROVIDER_USER_FACILITIES_SUM_ID_DESC = "PROVIDER_USER_FACILITIES_SUM_ID_DESC",
  PROVIDER_USER_FACILITIES_SUM_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_SUM_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_SUM_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_SUM_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_SUM_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_SUM_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_SUM_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_SUM_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_AUDITOR_USER_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_AUDITOR_USER_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_CREATED_AT_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_CREATED_AT_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_PROVIDER_ID_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_PROVIDER_ID_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_PROVIDER_ID_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_PROVIDER_ID_DESC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "PROVIDER_USER_FACILITIES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  SPEC_ASC = "SPEC_ASC",
  SPEC_DESC = "SPEC_DESC",
  STATE_ASC = "STATE_ASC",
  STATE_DESC = "STATE_DESC",
  TAX_EIN_ASC = "TAX_EIN_ASC",
  TAX_EIN_DESC = "TAX_EIN_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export enum QaClaimState {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_NEEDED = "NOT_NEEDED",
  TODO = "TODO",
}

/** Input for the nested mutation of `batchClaim` in the `QaClaimStateRowInput` mutation. */
export type QaClaimStateBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<QaClaimStateRowOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `qaClaimStateRow` in the `BatchClaimInput` mutation. */
export type QaClaimStateBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `qaClaimStateRow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<QaClaimStateRowQaClaimStatePkeyConnect>>;
  /** The primary key(s) for `qaClaimStateRow` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<QaClaimStateRowNodeIdConnect>>;
  /** A `QaClaimStateRowInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<QaClaimStateBatchClaimIdFkeyQaClaimStateCreateInput>
  >;
  /** The primary key(s) and patch data for `qaClaimStateRow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<QaClaimStateRowOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyUsingQaClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `qaClaimStateRow` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/** The `qaClaimStateRow` to be created by this mutation. */
export type QaClaimStateBatchClaimIdFkeyQaClaimStateCreateInput = {
  auditorUserToCreatedBy?: InputMaybe<QaClaimStateCreatedByFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  qaClaimState: QaClaimStateOptions;
};

/** Input for the nested mutation of `auditorUser` in the `QaClaimStateRowInput` mutation. */
export type QaClaimStateCreatedByFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<QaClaimStateRowOnQaClaimStateRowForQaClaimStateCreatedByFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `qaClaimStateRow` in the `AuditorUserInput` mutation. */
export type QaClaimStateCreatedByFkeyInverseInput = {
  /** The primary key(s) for `qaClaimStateRow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<QaClaimStateRowQaClaimStatePkeyConnect>>;
  /** The primary key(s) for `qaClaimStateRow` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<QaClaimStateRowNodeIdConnect>>;
  /** A `QaClaimStateRowInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<QaClaimStateCreatedByFkeyQaClaimStateCreateInput>>;
  /** The primary key(s) and patch data for `qaClaimStateRow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<QaClaimStateRowOnQaClaimStateRowForQaClaimStateCreatedByFkeyUsingQaClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `qaClaimStateRow` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyNodeIdUpdate>
  >;
};

/** The `qaClaimStateRow` to be created by this mutation. */
export type QaClaimStateCreatedByFkeyQaClaimStateCreateInput = {
  auditorUserToCreatedBy?: InputMaybe<QaClaimStateCreatedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  qaClaimState: QaClaimStateOptions;
};

export enum QaClaimStateOptions {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_NEEDED = "NOT_NEEDED",
  TODO = "TODO",
}

/** A filter to be used against QaClaimStateOptions fields. All fields are combined with a logical ‘and.’ */
export type QaClaimStateOptionsFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<QaClaimStateOptions>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<QaClaimStateOptions>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<QaClaimStateOptions>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<QaClaimStateOptions>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<QaClaimStateOptions>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<QaClaimStateOptions>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<QaClaimStateOptions>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<QaClaimStateOptions>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<QaClaimStateOptions>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<QaClaimStateOptions>>;
};

export type QaClaimStateRow = Node & {
  __typename?: "QaClaimStateRow";
  /** Reads a single `AuditorUser` that is related to this `QaClaimStateRow`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `QaClaimStateRow`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  createdBy: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  qaClaimState: QaClaimStateOptions;
};

export type QaClaimStateRowAggregates = {
  __typename?: "QaClaimStateRowAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<QaClaimStateRowDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `QaClaimStateRow` object types. */
export type QaClaimStateRowAggregatesFilter = {
  /** Distinct count aggregate over matching `QaClaimStateRow` objects. */
  distinctCount?: InputMaybe<QaClaimStateRowDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `QaClaimStateRow` object to be included within the aggregate. */
  filter?: InputMaybe<QaClaimStateRowFilter>;
};

/**
 * A condition to be used against `QaClaimStateRow` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type QaClaimStateRowCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `qaClaimState` field. */
  qaClaimState?: InputMaybe<QaClaimStateOptions>;
};

export type QaClaimStateRowDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  createdBy?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  qaClaimState?: InputMaybe<BigIntFilter>;
};

export type QaClaimStateRowDistinctCountAggregates = {
  __typename?: "QaClaimStateRowDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdBy across the matching connection */
  createdBy?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of qaClaimState across the matching connection */
  qaClaimState?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `QaClaimStateRow` object types. All fields are combined with a logical ‘and.’ */
export type QaClaimStateRowFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<QaClaimStateRowFilter>>;
  /** Filter by the object’s `auditorUserByCreatedBy` relation. */
  auditorUserByCreatedBy?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<QaClaimStateRowFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<QaClaimStateRowFilter>>;
  /** Filter by the object’s `qaClaimState` field. */
  qaClaimState?: InputMaybe<QaClaimStateOptionsFilter>;
};

/** Grouping methods for `QaClaimStateRow` for usage during aggregation. */
export enum QaClaimStateRowGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  CREATED_BY = "CREATED_BY",
  QA_CLAIM_STATE = "QA_CLAIM_STATE",
}

export type QaClaimStateRowHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QaClaimStateRowHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `QaClaimStateRow` aggregates. */
export type QaClaimStateRowHavingInput = {
  AND?: InputMaybe<Array<QaClaimStateRowHavingInput>>;
  OR?: InputMaybe<Array<QaClaimStateRowHavingInput>>;
  average?: InputMaybe<QaClaimStateRowHavingAverageInput>;
  distinctCount?: InputMaybe<QaClaimStateRowHavingDistinctCountInput>;
  max?: InputMaybe<QaClaimStateRowHavingMaxInput>;
  min?: InputMaybe<QaClaimStateRowHavingMinInput>;
  stddevPopulation?: InputMaybe<QaClaimStateRowHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<QaClaimStateRowHavingStddevSampleInput>;
  sum?: InputMaybe<QaClaimStateRowHavingSumInput>;
  variancePopulation?: InputMaybe<QaClaimStateRowHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<QaClaimStateRowHavingVarianceSampleInput>;
};

export type QaClaimStateRowHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QaClaimStateRowHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QaClaimStateRowHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QaClaimStateRowHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QaClaimStateRowHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QaClaimStateRowHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QaClaimStateRowHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `QaClaimStateRow` */
export type QaClaimStateRowInput = {
  auditorUserToCreatedBy?: InputMaybe<QaClaimStateCreatedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  qaClaimState: QaClaimStateOptions;
};

/** The globally unique `ID` look up for the row to connect. */
export type QaClaimStateRowNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `qaClaimStateRow` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type QaClaimStateRowOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `qaClaimStateRow` to look up the row to update. */
export type QaClaimStateRowOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyUsingQaClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `qaClaimStateRow` being updated. */
    patch: updateQaClaimStateRowOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type QaClaimStateRowOnQaClaimStateRowForQaClaimStateCreatedByFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `qaClaimStateRow` to look up the row to update. */
export type QaClaimStateRowOnQaClaimStateRowForQaClaimStateCreatedByFkeyUsingQaClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `qaClaimStateRow` being updated. */
    patch: updateQaClaimStateRowOnQaClaimStateRowForQaClaimStateCreatedByFkeyPatch;
  };

/** Represents an update to a `QaClaimStateRow`. Fields that are set will be updated. */
export type QaClaimStateRowPatch = {
  auditorUserToCreatedBy?: InputMaybe<QaClaimStateCreatedByFkeyInput>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInput>;
  createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `qaClaimStateRow` to look up the row to connect. */
export type QaClaimStateRowQaClaimStatePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `QaClaimStateRow` values. */
export type QaClaimStateRowsConnection = {
  __typename?: "QaClaimStateRowsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<QaClaimStateRowAggregates>;
  /** A list of edges which contains the `QaClaimStateRow` and cursor to aid in pagination. */
  edges: Array<QaClaimStateRowsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<QaClaimStateRowAggregates>>;
  /** A list of `QaClaimStateRow` objects. */
  nodes: Array<Maybe<QaClaimStateRow>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `QaClaimStateRow` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `QaClaimStateRow` values. */
export type QaClaimStateRowsConnectiongroupedAggregatesArgs = {
  groupBy: Array<QaClaimStateRowGroupBy>;
  having?: InputMaybe<QaClaimStateRowHavingInput>;
};

/** A `QaClaimStateRow` edge in the connection. */
export type QaClaimStateRowsEdge = {
  __typename?: "QaClaimStateRowsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `QaClaimStateRow` at the end of the edge. */
  node?: Maybe<QaClaimStateRow>;
};

/** Methods to use when ordering `QaClaimStateRow`. */
export enum QaClaimStateRowsOrderBy {
  AUDITOR_USER_BY_CREATED_BY__CREATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__CREATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__CREATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__CREATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__EMAIL_ASC = "AUDITOR_USER_BY_CREATED_BY__EMAIL_ASC",
  AUDITOR_USER_BY_CREATED_BY__EMAIL_DESC = "AUDITOR_USER_BY_CREATED_BY__EMAIL_DESC",
  AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_ASC = "AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_ASC",
  AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_DESC = "AUDITOR_USER_BY_CREATED_BY__FIRST_NAME_DESC",
  AUDITOR_USER_BY_CREATED_BY__IDP_SUB_ASC = "AUDITOR_USER_BY_CREATED_BY__IDP_SUB_ASC",
  AUDITOR_USER_BY_CREATED_BY__IDP_SUB_DESC = "AUDITOR_USER_BY_CREATED_BY__IDP_SUB_DESC",
  AUDITOR_USER_BY_CREATED_BY__ID_ASC = "AUDITOR_USER_BY_CREATED_BY__ID_ASC",
  AUDITOR_USER_BY_CREATED_BY__ID_DESC = "AUDITOR_USER_BY_CREATED_BY__ID_DESC",
  AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_CREATED_BY__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_CREATED_BY__LAST_NAME_ASC = "AUDITOR_USER_BY_CREATED_BY__LAST_NAME_ASC",
  AUDITOR_USER_BY_CREATED_BY__LAST_NAME_DESC = "AUDITOR_USER_BY_CREATED_BY__LAST_NAME_DESC",
  AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_CREATED_BY__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_ASC = "AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_DESC = "AUDITOR_USER_BY_CREATED_BY__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_CREATED_BY__READ_ONLY_ASC = "AUDITOR_USER_BY_CREATED_BY__READ_ONLY_ASC",
  AUDITOR_USER_BY_CREATED_BY__READ_ONLY_DESC = "AUDITOR_USER_BY_CREATED_BY__READ_ONLY_DESC",
  AUDITOR_USER_BY_CREATED_BY__TITLE_ASC = "AUDITOR_USER_BY_CREATED_BY__TITLE_ASC",
  AUDITOR_USER_BY_CREATED_BY__TITLE_DESC = "AUDITOR_USER_BY_CREATED_BY__TITLE_DESC",
  AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_ASC = "AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_ASC",
  AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_DESC = "AUDITOR_USER_BY_CREATED_BY__UPDATED_AT_DESC",
  AUDITOR_USER_BY_CREATED_BY__USER_TYPE_ASC = "AUDITOR_USER_BY_CREATED_BY__USER_TYPE_ASC",
  AUDITOR_USER_BY_CREATED_BY__USER_TYPE_DESC = "AUDITOR_USER_BY_CREATED_BY__USER_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  CREATED_BY_ASC = "CREATED_BY_ASC",
  CREATED_BY_DESC = "CREATED_BY_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  QA_CLAIM_STATE_ASC = "QA_CLAIM_STATE_ASC",
  QA_CLAIM_STATE_DESC = "QA_CLAIM_STATE_DESC",
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: "Query";
  /**
   * Returns the single currently-accepted human finding (if any) per IB
   * line ID. A finding qualifies when its latest non-deleted review is an
   * accept and it is the active version. IDs with no accepted finding are
   * omitted.
   */
  acceptedFindingsByIbLineIds: Array<AcceptedFindingByIbLine>;
  activeClaimAssignee?: Maybe<ActiveClaimAssignee>;
  activeClaimAssigneeByBatchClaimIdAndAuditorUserId?: Maybe<ActiveClaimAssignee>;
  /** Reads a single `ActiveClaimAssignee` using its globally unique `ID`. */
  activeClaimAssigneeByNodeId?: Maybe<ActiveClaimAssignee>;
  /** Reads and enables pagination through a set of `ActiveClaimAssignee`. */
  activeClaimAssignees?: Maybe<ActiveClaimAssigneesConnection>;
  /** Reads and enables pagination through a set of `ActiveIbLinesView`. */
  activeIbLinesViews?: Maybe<ActiveIbLinesViewsConnection>;
  activeStatistics: ActiveStatistics;
  agent?: Maybe<Agent>;
  agentArtifact: AgentArtifact;
  agentArtifactTemplate: AgentArtifactTemplate;
  agentTypes: Array<AgentType>;
  agents: Array<Agent>;
  annotationLabels: Array<AnnotationLabel>;
  annotations: Array<Annotation>;
  askAutodorFileVectorsExist?: Maybe<AskAutodorFileVectorsExistResponse>;
  askAutodorGetSavedPrompts: Array<AskAutodorSavedPrompt>;
  askAutodorQueue?: Maybe<AskAutodorQueue>;
  askAutodorQueueNames: Array<AskAutodorQueueName>;
  askAutodorQueues: AskAutodorQueuesConnection;
  askAutodorQueuesConnection: AskAutodorQueuesConnection;
  auditFinding?: Maybe<AuditFinding>;
  /** Reads a single `AuditFinding` using its globally unique `ID`. */
  auditFindingByNodeId?: Maybe<AuditFinding>;
  auditFindingJob?: Maybe<AuditFindingJob>;
  /** Reads a single `AuditFindingJob` using its globally unique `ID`. */
  auditFindingJobByNodeId?: Maybe<AuditFindingJob>;
  /** Reads and enables pagination through a set of `AuditFindingJob`. */
  auditFindingJobs?: Maybe<AuditFindingJobsConnection>;
  auditFindingReasonCode?: Maybe<AuditFindingReasonCode>;
  /** Reads a single `AuditFindingReasonCode` using its globally unique `ID`. */
  auditFindingReasonCodeByNodeId?: Maybe<AuditFindingReasonCode>;
  /** Reads and enables pagination through a set of `AuditFindingReasonCode`. */
  auditFindingReasonCodes?: Maybe<AuditFindingReasonCodesConnection>;
  auditFindingReport?: Maybe<AuditFindingReport>;
  /** Reads a single `AuditFindingReport` using its globally unique `ID`. */
  auditFindingReportByNodeId?: Maybe<AuditFindingReport>;
  /** Reads and enables pagination through a set of `AuditFindingReport`. */
  auditFindingReports?: Maybe<AuditFindingReportsConnection>;
  auditFindingReview?: Maybe<AuditFindingReview>;
  /** Reads a single `AuditFindingReview` using its globally unique `ID`. */
  auditFindingReviewByNodeId?: Maybe<AuditFindingReview>;
  auditFindingReviewByReviewId?: Maybe<AuditFindingReview>;
  auditFindingReviewByReviewIdAndOriginalId?: Maybe<AuditFindingReview>;
  /** Reads and enables pagination through a set of `AuditFindingReview`. */
  auditFindingReviews?: Maybe<AuditFindingReviewsConnection>;
  auditFindingRuleType?: Maybe<AuditFindingRuleType>;
  /** Reads a single `AuditFindingRuleType` using its globally unique `ID`. */
  auditFindingRuleTypeByNodeId?: Maybe<AuditFindingRuleType>;
  /** Reads and enables pagination through a set of `AuditFindingRuleType`. */
  auditFindingRuleTypes?: Maybe<AuditFindingRuleTypesConnection>;
  /** Reads and enables pagination through a set of `AuditFinding`. */
  auditFindings?: Maybe<AuditFindingsConnection>;
  /** Get a single audit status by ID */
  auditStatus?: Maybe<AuditStatus>;
  auditStatuses: Array<AuditStatus>;
  auditorBucket?: Maybe<AuditorBucket>;
  auditorBucketAssignee?: Maybe<AuditorBucketAssignee>;
  /** Reads a single `AuditorBucketAssignee` using its globally unique `ID`. */
  auditorBucketAssigneeByNodeId?: Maybe<AuditorBucketAssignee>;
  /** Reads and enables pagination through a set of `AuditorBucketAssignee`. */
  auditorBucketAssignees?: Maybe<AuditorBucketAssigneesConnection>;
  /** Reads a single `AuditorBucket` using its globally unique `ID`. */
  auditorBucketByNodeId?: Maybe<AuditorBucket>;
  /** Reads and enables pagination through a set of `AuditorBucket`. */
  auditorBuckets?: Maybe<AuditorBucketsConnection>;
  auditorUser?: Maybe<AuditorUser>;
  auditorUserByEmail?: Maybe<AuditorUser>;
  auditorUserByIdpSub?: Maybe<AuditorUser>;
  /** Reads a single `AuditorUser` using its globally unique `ID`. */
  auditorUserByNodeId?: Maybe<AuditorUser>;
  /** Reads and enables pagination through a set of `AuditorUser`. */
  auditorUsers?: Maybe<AuditorUsersConnection>;
  autodor?: Maybe<Autodor>;
  automationAuthor?: Maybe<AutomationSource>;
  batchClaim?: Maybe<BatchClaim>;
  batchClaimAppealed?: Maybe<BatchClaimAppealed>;
  batchClaimAppealedByBatchClaimId?: Maybe<BatchClaimAppealed>;
  /** Reads a single `BatchClaimAppealed` using its globally unique `ID`. */
  batchClaimAppealedByNodeId?: Maybe<BatchClaimAppealed>;
  /** Reads and enables pagination through a set of `BatchClaimAppealed`. */
  batchClaimAppealeds?: Maybe<BatchClaimAppealedsConnection>;
  batchClaimAssignee?: Maybe<BatchClaimAssignee>;
  /** Reads a single `BatchClaimAssignee` using its globally unique `ID`. */
  batchClaimAssigneeByNodeId?: Maybe<BatchClaimAssignee>;
  /** Reads and enables pagination through a set of `BatchClaimAssignee`. */
  batchClaimAssignees?: Maybe<BatchClaimAssigneesConnection>;
  batchClaimAuditStartDate?: Maybe<BatchClaimAuditStartDate>;
  /** Reads a single `BatchClaimAuditStartDate` using its globally unique `ID`. */
  batchClaimAuditStartDateByNodeId?: Maybe<BatchClaimAuditStartDate>;
  /** Reads and enables pagination through a set of `BatchClaimAuditStartDate`. */
  batchClaimAuditStartDates?: Maybe<BatchClaimAuditStartDatesConnection>;
  batchClaimAuditType?: Maybe<BatchClaimAuditType>;
  batchClaimAuditTypeByBatchClaimId?: Maybe<BatchClaimAuditType>;
  /** Reads a single `BatchClaimAuditType` using its globally unique `ID`. */
  batchClaimAuditTypeByNodeId?: Maybe<BatchClaimAuditType>;
  /** Reads and enables pagination through a set of `BatchClaimAuditType`. */
  batchClaimAuditTypes?: Maybe<BatchClaimAuditTypesConnection>;
  batchClaimAuditor?: Maybe<BatchClaimAuditor>;
  /** Reads a single `BatchClaimAuditor` using its globally unique `ID`. */
  batchClaimAuditorByNodeId?: Maybe<BatchClaimAuditor>;
  /** Reads and enables pagination through a set of `BatchClaimAuditor`. */
  batchClaimAuditors?: Maybe<BatchClaimAuditorsConnection>;
  batchClaimByIcn?: Maybe<BatchClaim>;
  batchClaimByIdAndInsurerId?: Maybe<BatchClaim>;
  /** Reads a single `BatchClaim` using its globally unique `ID`. */
  batchClaimByNodeId?: Maybe<BatchClaim>;
  batchClaimClientRecoveryAmount?: Maybe<BatchClaimClientRecoveryAmount>;
  /** Reads a single `BatchClaimClientRecoveryAmount` using its globally unique `ID`. */
  batchClaimClientRecoveryAmountByNodeId?: Maybe<BatchClaimClientRecoveryAmount>;
  /** Reads and enables pagination through a set of `BatchClaimClientRecoveryAmount`. */
  batchClaimClientRecoveryAmounts?: Maybe<BatchClaimClientRecoveryAmountsConnection>;
  batchClaimClientRecoveryCollectionDate?: Maybe<BatchClaimClientRecoveryCollectionDate>;
  /** Reads a single `BatchClaimClientRecoveryCollectionDate` using its globally unique `ID`. */
  batchClaimClientRecoveryCollectionDateByNodeId?: Maybe<BatchClaimClientRecoveryCollectionDate>;
  /** Reads and enables pagination through a set of `BatchClaimClientRecoveryCollectionDate`. */
  batchClaimClientRecoveryCollectionDates?: Maybe<BatchClaimClientRecoveryCollectionDatesConnection>;
  batchClaimDocument?: Maybe<BatchClaimDocument>;
  batchClaimDocumentByBatchClaimIdAndDocumentId?: Maybe<BatchClaimDocument>;
  batchClaimDocumentByBatchClaimIdAndIsPrimaryMedicalRecord?: Maybe<BatchClaimDocument>;
  /** Reads a single `BatchClaimDocument` using its globally unique `ID`. */
  batchClaimDocumentByNodeId?: Maybe<BatchClaimDocument>;
  /** Reads and enables pagination through a set of `BatchClaimDocument`. */
  batchClaimDocuments?: Maybe<BatchClaimDocumentsConnection>;
  batchClaimDueDate?: Maybe<BatchClaimDueDate>;
  /** Reads a single `BatchClaimDueDate` using its globally unique `ID`. */
  batchClaimDueDateByNodeId?: Maybe<BatchClaimDueDate>;
  /** Reads and enables pagination through a set of `BatchClaimDueDate`. */
  batchClaimDueDates?: Maybe<BatchClaimDueDatesConnection>;
  batchClaimLine?: Maybe<BatchClaimLine>;
  /** Reads a single `BatchClaimLine` using its globally unique `ID`. */
  batchClaimLineByNodeId?: Maybe<BatchClaimLine>;
  batchClaimLineComputedValue?: Maybe<BatchClaimLineComputedValue>;
  /** Reads a single `BatchClaimLineComputedValue` using its globally unique `ID`. */
  batchClaimLineComputedValueByNodeId?: Maybe<BatchClaimLineComputedValue>;
  /** Reads and enables pagination through a set of `BatchClaimLineComputedValue`. */
  batchClaimLineComputedValues?: Maybe<BatchClaimLineComputedValuesConnection>;
  batchClaimLineItem?: Maybe<BatchClaimLineItem>;
  batchClaimLineItemAudit?: Maybe<BatchClaimLineItemAudit>;
  batchClaimLineItemAuditByAuditFindingId?: Maybe<BatchClaimLineItemAudit>;
  /** Reads a single `BatchClaimLineItemAudit` using its globally unique `ID`. */
  batchClaimLineItemAuditByNodeId?: Maybe<BatchClaimLineItemAudit>;
  /** Reads and enables pagination through a set of `BatchClaimLineItemAudit`. */
  batchClaimLineItemAudits?: Maybe<BatchClaimLineItemAuditsConnection>;
  /** Reads a single `BatchClaimLineItem` using its globally unique `ID`. */
  batchClaimLineItemByNodeId?: Maybe<BatchClaimLineItem>;
  batchClaimLineItemComputedValue?: Maybe<BatchClaimLineItemComputedValue>;
  /** Reads a single `BatchClaimLineItemComputedValue` using its globally unique `ID`. */
  batchClaimLineItemComputedValueByNodeId?: Maybe<BatchClaimLineItemComputedValue>;
  /** Reads and enables pagination through a set of `BatchClaimLineItemComputedValue`. */
  batchClaimLineItemComputedValues?: Maybe<BatchClaimLineItemComputedValuesConnection>;
  batchClaimLineItemNnIbLine?: Maybe<BatchClaimLineItemNnIbLine>;
  batchClaimLineItemNnIbLineByBatchClaimLineItemIdAndNnIbLineId?: Maybe<BatchClaimLineItemNnIbLine>;
  /** Reads a single `BatchClaimLineItemNnIbLine` using its globally unique `ID`. */
  batchClaimLineItemNnIbLineByNodeId?: Maybe<BatchClaimLineItemNnIbLine>;
  /** Reads and enables pagination through a set of `BatchClaimLineItemNnIbLine`. */
  batchClaimLineItemNnIbLines?: Maybe<BatchClaimLineItemNnIbLinesConnection>;
  /** Reads and enables pagination through a set of `BatchClaimLineItem`. */
  batchClaimLineItems?: Maybe<BatchClaimLineItemsConnection>;
  /** Reads and enables pagination through a set of `BatchClaimLine`. */
  batchClaimLines?: Maybe<BatchClaimLinesConnection>;
  /** Reads and enables pagination through a set of `BatchClaimPayDeny`. */
  batchClaimPayDenies?: Maybe<BatchClaimPayDeniesConnection>;
  batchClaimPayDeny?: Maybe<BatchClaimPayDeny>;
  batchClaimPayDenyByBatchClaimId?: Maybe<BatchClaimPayDeny>;
  /** Reads a single `BatchClaimPayDeny` using its globally unique `ID`. */
  batchClaimPayDenyByNodeId?: Maybe<BatchClaimPayDeny>;
  batchClaimState?: Maybe<BatchClaimState>;
  /** Reads a single `BatchClaimState` using its globally unique `ID`. */
  batchClaimStateByNodeId?: Maybe<BatchClaimState>;
  /** Reads and enables pagination through a set of `BatchClaimState`. */
  batchClaimStates?: Maybe<BatchClaimStatesConnection>;
  /** Performance helper: batch_claim_state rows visible to providers (is_provider_active = true). */
  batchClaimStatesWithActiveStates?: Maybe<BatchClaimStatesConnection>;
  batchClaimTechDenial?: Maybe<BatchClaimTechDenial>;
  batchClaimTechDenialByBatchClaimId?: Maybe<BatchClaimTechDenial>;
  /** Reads a single `BatchClaimTechDenial` using its globally unique `ID`. */
  batchClaimTechDenialByNodeId?: Maybe<BatchClaimTechDenial>;
  /** Reads and enables pagination through a set of `BatchClaimTechDenial`. */
  batchClaimTechDenials?: Maybe<BatchClaimTechDenialsConnection>;
  /** Reads and enables pagination through a set of `BatchClaim`. */
  batchClaims?: Maybe<BatchClaimsConnection>;
  /**
   * ### Overview
   * Returns the claims assigned to the active auditor user as identified by the uuid in the active application user jwt token.
   * The cache schema is queried to identify the active claim assignees.
   */
  batchClaimsAssignedToAuditor?: Maybe<BatchClaimsConnection>;
  batchFile?: Maybe<BatchFile>;
  /** Reads a single `BatchFile` using its globally unique `ID`. */
  batchFileByNodeId?: Maybe<BatchFile>;
  /** Reads and enables pagination through a set of `BatchFile`. */
  batchFiles?: Maybe<BatchFilesConnection>;
  bucketClaim?: Maybe<BucketClaim>;
  bucketClaimByBatchClaimId?: Maybe<BucketClaim>;
  bucketClaimByBatchClaimIdAndAuditorBucketId?: Maybe<BucketClaim>;
  /** Reads a single `BucketClaim` using its globally unique `ID`. */
  bucketClaimByNodeId?: Maybe<BucketClaim>;
  /** Reads and enables pagination through a set of `BucketClaim`. */
  bucketClaims?: Maybe<BucketClaimsConnection>;
  /**
   * User-scoped capability slugs the current user has, in flat
   * dot-notation form (e.g. "claim.canTransitionStage"). Use for
   * page-level UI decisions (column visibility, menu items)
   * independent of any specific claim.
   *
   * Optional filter: dot-notation entries. A namespace-only
   * entry ("claim") narrows the response to that namespace's
   * slugs; a fully-qualified entry ("claim.canTransitionStage")
   * narrows to just that slug. No filter returns every slug the
   * user has across every namespace.
   *
   * For a specific claim's permissions, use BatchClaim.permissions
   * or Claim.permissions. Those fields return the same slugs
   * evaluated per-instance, but with the namespace prefix stripped
   * (e.g. "claim.canTransitionStage" here appears there as
   * "canTransitionStage"). Strip the leading "NAMESPACE." if you
   * need to cross-reference between the two lists.
   */
  capabilities: Array<Scalars["String"]["output"]>;
  case: Case;
  cases: Array<Case>;
  casesConnection: CasesConnection;
  claim?: Maybe<Claim>;
  /**
   * UI hints for which lifecycle matrix actions to show/enable on a claim.
   * NOT authorization. Available to ADMINISTRATOR, AUDITOR, PAYER, and PROVIDER.
   */
  claimActionPermissions: ClaimActionPermissions;
  claimAuditBlocker?: Maybe<ClaimAuditBlocker>;
  /** Reads a single `ClaimAuditBlocker` using its globally unique `ID`. */
  claimAuditBlockerByNodeId?: Maybe<ClaimAuditBlocker>;
  claimAuditBlockerBySlug?: Maybe<ClaimAuditBlocker>;
  claimAuditBlockerByStagesFacetId?: Maybe<ClaimAuditBlocker>;
  /** Reads and enables pagination through a set of `ClaimAuditBlockerStageAvailability`. */
  claimAuditBlockerStageAvailabilities?: Maybe<ClaimAuditBlockerStageAvailabilitiesConnection>;
  claimAuditBlockerStageAvailability?: Maybe<ClaimAuditBlockerStageAvailability>;
  claimAuditBlockerStageAvailabilityByClientSlugAndAuditTypeAndPaymentTypeAndBlockerStageKeywordId?: Maybe<ClaimAuditBlockerStageAvailability>;
  /** Reads a single `ClaimAuditBlockerStageAvailability` using its globally unique `ID`. */
  claimAuditBlockerStageAvailabilityByNodeId?: Maybe<ClaimAuditBlockerStageAvailability>;
  /** Reads and enables pagination through a set of `ClaimAuditBlocker`. */
  claimAuditBlockers?: Maybe<ClaimAuditBlockersConnection>;
  claimAuditGroup?: Maybe<ClaimAuditGroup>;
  claimAuditGroupByName?: Maybe<ClaimAuditGroup>;
  /** Reads a single `ClaimAuditGroup` using its globally unique `ID`. */
  claimAuditGroupByNodeId?: Maybe<ClaimAuditGroup>;
  /** Reads and enables pagination through a set of `ClaimAuditGroup`. */
  claimAuditGroups?: Maybe<ClaimAuditGroupsConnection>;
  claimAuditStageSuggestion?: Maybe<ClaimAuditStageSuggestion>;
  claimAuditStageSuggestionByFromStageKeywordIdAndPriority?: Maybe<ClaimAuditStageSuggestion>;
  claimAuditStageSuggestionByFromStageKeywordIdAndToStageKeywordId?: Maybe<ClaimAuditStageSuggestion>;
  /** Reads a single `ClaimAuditStageSuggestion` using its globally unique `ID`. */
  claimAuditStageSuggestionByNodeId?: Maybe<ClaimAuditStageSuggestion>;
  /** Reads and enables pagination through a set of `ClaimAuditStageSuggestion`. */
  claimAuditStageSuggestions?: Maybe<ClaimAuditStageSuggestionsConnection>;
  claimAuditTypes: ClaimAuditTypesResponse;
  /** Catalog of claim audit blockers (Document, On Hold) with segment options. */
  claimBlockers: Array<ClaimBlocker>;
  claimCases: Array<Case>;
  claimFacet?: Maybe<ClaimFacet>;
  claimFacetByBatchClaimId?: Maybe<ClaimFacet>;
  /** Reads a single `ClaimFacet` using its globally unique `ID`. */
  claimFacetByNodeId?: Maybe<ClaimFacet>;
  /** Reads and enables pagination through a set of `ClaimFacetHistory`. */
  claimFacetHistories?: Maybe<ClaimFacetHistoriesConnection>;
  claimFacetHistory?: Maybe<ClaimFacetHistory>;
  /** Reads a single `ClaimFacetHistory` using its globally unique `ID`. */
  claimFacetHistoryByNodeId?: Maybe<ClaimFacetHistory>;
  /** Reads and enables pagination through a set of `ClaimFacetHistoryReadable`. */
  claimFacetHistoryReadables?: Maybe<ClaimFacetHistoryReadablesConnection>;
  /** Reads and enables pagination through a set of `ClaimFacet`. */
  claimFacets?: Maybe<ClaimFacetsConnection>;
  claimIntake: ClaimIntakeResponse;
  /** Reads and enables pagination through a set of `ClaimMrReport`. */
  claimMrReports?: Maybe<ClaimMrReportsConnection>;
  /** All lifecycle phases with nested stages (UI-aligned ClaimPhase / ClaimStage types). */
  claimPhases: Array<ClaimPhase>;
  claimPolicyDocument?: Maybe<ClaimPolicyDocument>;
  claimPolicyDocumentByBatchClaimIdAndDocumentId?: Maybe<ClaimPolicyDocument>;
  /** Reads a single `ClaimPolicyDocument` using its globally unique `ID`. */
  claimPolicyDocumentByNodeId?: Maybe<ClaimPolicyDocument>;
  /** Reads and enables pagination through a set of `ClaimPolicyDocument`. */
  claimPolicyDocuments?: Maybe<ClaimPolicyDocumentsConnection>;
  claimRoleAssignments: ClaimRoleAssignments;
  /** Legacy homepage Phases pane. Pass v3.queue id to scope counts to a saved queue filter. */
  claimsSummary: ClaimsSummary;
  clientSignOffClaimState?: Maybe<ClientSignOffClaimState>;
  /** Reads a single `ClientSignOffClaimState` using its globally unique `ID`. */
  clientSignOffClaimStateByNodeId?: Maybe<ClientSignOffClaimState>;
  /** Reads and enables pagination through a set of `ClientSignOffClaimState`. */
  clientSignOffClaimStates?: Maybe<ClientSignOffClaimStatesConnection>;
  /**
   * Homepage summary scoped by lifecycle stage (or BatchClaimFilter when input.filter is set).
   * Not for PROVIDER — use providerDashboardSummary instead.
   */
  dashboardSummary: DashboardSummary;
  /**
   * Returns every registered flag's resolved value for the calling user,
   * plus the evaluation context. Use this to debug why a user is (or
   * isn't) seeing a flag-gated feature.
   */
  debugFeatureFlags: FeatureFlagDebugResult;
  defaultStrategyByInsurer?: Maybe<DefaultStrategyByInsurer>;
  defaultStrategyByInsurerByInsurerId?: Maybe<DefaultStrategyByInsurer>;
  /** Reads a single `DefaultStrategyByInsurer` using its globally unique `ID`. */
  defaultStrategyByInsurerByNodeId?: Maybe<DefaultStrategyByInsurer>;
  /** Reads and enables pagination through a set of `DefaultStrategyByInsurer`. */
  defaultStrategyByInsurers?: Maybe<DefaultStrategyByInsurersConnection>;
  /**
   * Returns the denial code catalog from v3.audit_finding_rule_type,
   * ordered by displayName ASC. Optional filter by claimDataType
   * ('UB_CLAIM' | 'UB_CLAIM_LINE' | 'IB_CLAIM_LINE'). Deprecated codes
   * are excluded by default.
   */
  denialCodes: Array<DenialCode>;
  directory?: Maybe<Directory>;
  disputedFinding?: Maybe<DisputedFinding>;
  /** Reads a single `DisputedFinding` using its globally unique `ID`. */
  disputedFindingByNodeId?: Maybe<DisputedFinding>;
  /** Reads and enables pagination through a set of `DisputedFinding`. */
  disputedFindings?: Maybe<DisputedFindingsConnection>;
  documentRequestCreated?: Maybe<DocumentRequestCreated>;
  /** Reads a single `DocumentRequestCreated` using its globally unique `ID`. */
  documentRequestCreatedByNodeId?: Maybe<DocumentRequestCreated>;
  /** Reads and enables pagination through a set of `DocumentRequestCreated`. */
  documentRequestCreateds?: Maybe<DocumentRequestCreatedsConnection>;
  documentUploadCreated?: Maybe<DocumentUploadCreated>;
  /** Reads a single `DocumentUploadCreated` using its globally unique `ID`. */
  documentUploadCreatedByNodeId?: Maybe<DocumentUploadCreated>;
  /** Reads and enables pagination through a set of `DocumentUploadCreated`. */
  documentUploadCreateds?: Maybe<DocumentUploadCreatedsConnection>;
  documentationClaimState?: Maybe<DocumentationClaimState>;
  /** Reads a single `DocumentationClaimState` using its globally unique `ID`. */
  documentationClaimStateByNodeId?: Maybe<DocumentationClaimState>;
  /** Reads and enables pagination through a set of `DocumentationClaimState`. */
  documentationClaimStates?: Maybe<DocumentationClaimStatesConnection>;
  documentationSelectionSet?: Maybe<DocumentationSelectionSet>;
  /** Reads a single `DocumentationSelectionSet` using its globally unique `ID`. */
  documentationSelectionSetByNodeId?: Maybe<DocumentationSelectionSet>;
  documentationSelectionSetByS3Key?: Maybe<DocumentationSelectionSet>;
  /** Reads and enables pagination through a set of `DocumentationSelectionSet`. */
  documentationSelectionSets?: Maybe<DocumentationSelectionSetsConnection>;
  /** Get a facet by ID */
  facet?: Maybe<Facet>;
  /** Get a facet by slug */
  facetBySlug?: Maybe<Facet>;
  /** Get all facet data types */
  facetDataTypes: Array<FacetDataTypeDef>;
  /** Get a keyword by ID */
  facetKeyword?: Maybe<FacetKeyword>;
  /** Get all keywords for a facet */
  facetKeywords: Array<FacetKeyword>;
  /** Get all facets */
  facets: Array<Facet>;
  /**
   * Resolves a single registered flag for the calling user. The key must
   * match a flag registered in service/featureFlag/registry.ts; unknown
   * keys raise an error rather than silently returning a default.
   */
  featureFlag: FeatureFlagValue;
  /**
   * Resolves any flag key for the calling user without requiring a
   * registry entry. Lets product code consume a DevCycle flag without
   * first registering it in service/featureFlag/registry.ts — useful for
   * moving fast on flag-gated features. Caller supplies the flag's type
   * and the default value to fall back to if DevCycle is unreachable or
   * the key is missing.
   */
  featureFlagDynamic: FeatureFlagValue;
  features: Array<FeatureFlag>;
  file?: Maybe<File>;
  fileAiAnnotations: Array<FileAiAnnotation>;
  fileDownloadUrl: SignedDownloadUrl;
  fileUserAnnotations: Array<FileUserAnnotation>;
  files: Array<File>;
  finding?: Maybe<Finding>;
  foxitCredentials: FoxitCredentials;
  /**
   * ### Overview
   * DEPRECATED: This function was previously used to calculate the view id for an audit finding report.
   * The view id is a uuid that represents a family of reports over a group of claims.
   * This calculation is now done natively in the report service, so this function is no longer used.
   */
  generateAuditFindingReportViewId?: Maybe<Scalars["UUID"]["output"]>;
  /**
   * ### Overview
   *  Generates fingerprint of values used by generated column batch_claim_line_item.fingerprint -and- app logic to determine if new version is needed
   */
  generateBcliVersionFingerprint?: Maybe<Scalars["UUID"]["output"]>;
  historicStatistics: HistoricStatistics;
  /**
   * ### Overview
   * Calculates total time spent performing human processing review on a document for a given review, specified by id.
   * This aids in metrics and observability over our document review pipelines that our annotators use.
   */
  hprCalculateTimeSpentSecs?: Maybe<Scalars["BigFloat"]["output"]>;
  humanProcessingRequest?: Maybe<HumanProcessingRequest>;
  /** Reads a single `HumanProcessingRequest` using its globally unique `ID`. */
  humanProcessingRequestByNodeId?: Maybe<HumanProcessingRequest>;
  humanProcessingRequestByRunIdAndS3AuditDocumentationIdAndRequestType?: Maybe<HumanProcessingRequest>;
  /** Reads and enables pagination through a set of `HumanProcessingRequest`. */
  humanProcessingRequests?: Maybe<HumanProcessingRequestsConnection>;
  insurer?: Maybe<Insurer>;
  insurerByClientAbbreviation?: Maybe<Insurer>;
  insurerByName?: Maybe<Insurer>;
  /** Reads a single `Insurer` using its globally unique `ID`. */
  insurerByNodeId?: Maybe<Insurer>;
  insurerClaimIntakeDropboxPermittedByInsurerId?: Maybe<InsurerClaimIntakeDropboxPermitted>;
  /** Reads and enables pagination through a set of `InsurerClaimIntakeDropboxPermitted`. */
  insurerClaimIntakeDropboxPermitteds?: Maybe<InsurerClaimIntakeDropboxPermittedsConnection>;
  insurerOrganization?: Maybe<InsurerOrganization>;
  insurerOrganizationByMemberIdAndOrganizationId?: Maybe<InsurerOrganization>;
  /** Reads a single `InsurerOrganization` using its globally unique `ID`. */
  insurerOrganizationByNodeId?: Maybe<InsurerOrganization>;
  /** Reads and enables pagination through a set of `InsurerOrganization`. */
  insurerOrganizations?: Maybe<InsurerOrganizationsConnection>;
  insurerUser?: Maybe<InsurerUser>;
  insurerUserByAuditorUserIdAndInsurerId?: Maybe<InsurerUser>;
  /** Reads a single `InsurerUser` using its globally unique `ID`. */
  insurerUserByNodeId?: Maybe<InsurerUser>;
  /** Reads and enables pagination through a set of `InsurerUser`. */
  insurerUsers?: Maybe<InsurerUsersConnection>;
  /** Reads and enables pagination through a set of `Insurer`. */
  insurers?: Maybe<InsurersConnection>;
  /**
   * ### Overview
   * Identifies the set of insurers where batch claims for those insurers are assigned to the current auditor user.
   * The auditor user is identified using the uuid in the jwt of the active user, so this is meant to be called by a logged in user within the application.
   */
  insurersAssignedToAuditor?: Maybe<InsurersConnection>;
  invoiceClaimState?: Maybe<InvoiceClaimState>;
  /** Reads a single `InvoiceClaimState` using its globally unique `ID`. */
  invoiceClaimStateByNodeId?: Maybe<InvoiceClaimState>;
  /** Reads and enables pagination through a set of `InvoiceClaimState`. */
  invoiceClaimStates?: Maybe<InvoiceClaimStatesConnection>;
  itemizedBillLines?: Maybe<Array<ItemizedBillLine>>;
  /**
   * ### Overview
   * Retrieves the most recent auditor user created by Autodor.
   */
  latestAutodorVersionUserId?: Maybe<Scalars["UUID"]["output"]>;
  lifecycleRole?: Maybe<LifecycleRole>;
  lifecycleRoles: Array<LifecycleRole>;
  messageCreated?: Maybe<MessageCreated>;
  /** Reads a single `MessageCreated` using its globally unique `ID`. */
  messageCreatedByNodeId?: Maybe<MessageCreated>;
  /** Reads and enables pagination through a set of `MessageCreated`. */
  messageCreateds?: Maybe<MessageCreatedsConnection>;
  messageSent?: Maybe<MessageSent>;
  /** Reads a single `MessageSent` using its globally unique `ID`. */
  messageSentByNodeId?: Maybe<MessageSent>;
  /** Reads and enables pagination through a set of `MessageSent`. */
  messageSents?: Maybe<MessageSentsConnection>;
  negotiationClaimState?: Maybe<NegotiationClaimState>;
  /** Reads a single `NegotiationClaimState` using its globally unique `ID`. */
  negotiationClaimStateByNodeId?: Maybe<NegotiationClaimState>;
  /** Reads and enables pagination through a set of `NegotiationClaimState`. */
  negotiationClaimStates?: Maybe<NegotiationClaimStatesConnection>;
  nnIbLine?: Maybe<NnIbLine>;
  nnIbLineByFingerprintAndS3Key?: Maybe<NnIbLine>;
  /** Reads a single `NnIbLine` using its globally unique `ID`. */
  nnIbLineByNodeId?: Maybe<NnIbLine>;
  /** Reads and enables pagination through a set of `NnIbLine`. */
  nnIbLines?: Maybe<NnIbLinesConnection>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars["ID"]["output"];
  onHoldClaimState?: Maybe<OnHoldClaimState>;
  /** Reads a single `OnHoldClaimState` using its globally unique `ID`. */
  onHoldClaimStateByNodeId?: Maybe<OnHoldClaimState>;
  /** Reads and enables pagination through a set of `OnHoldClaimState`. */
  onHoldClaimStates?: Maybe<OnHoldClaimStatesConnection>;
  patientDatum?: Maybe<PatientDatum>;
  /** Reads a single `PatientDatum` using its globally unique `ID`. */
  patientDatumByNodeId?: Maybe<PatientDatum>;
  patientDatumByPayerPatientId?: Maybe<PatientDatum>;
  preflightReportTransfer: PreflightReportTransfer;
  procedureCode?: Maybe<ProcedureCode>;
  /** Reads a single `ProcedureCode` using its globally unique `ID`. */
  procedureCodeByNodeId?: Maybe<ProcedureCode>;
  procedureCodeTypeByType?: Maybe<ProcedureCodeType>;
  /** Reads and enables pagination through a set of `ProcedureCodeType`. */
  procedureCodeTypes?: Maybe<ProcedureCodeTypesConnection>;
  /** Reads and enables pagination through a set of `ProcedureCode`. */
  procedureCodes?: Maybe<ProcedureCodesConnection>;
  provider?: Maybe<Provider>;
  providerAuditStats: Array<ProviderAuditStat>;
  /** Reads a single `Provider` using its globally unique `ID`. */
  providerByNodeId?: Maybe<Provider>;
  /**
   * Per-provider claim-state breakdown for the homepage table.
   * Not for PROVIDER — use providerDashboardSummary instead.
   */
  providerClaimsMetrics: Array<ProviderClaimsMetrics>;
  /** PROVIDER-only summary (documents requested / received counts). */
  providerDashboardSummary: ProviderDashboardSummary;
  providerSignOffClaimState?: Maybe<ProviderSignOffClaimState>;
  /** Reads a single `ProviderSignOffClaimState` using its globally unique `ID`. */
  providerSignOffClaimStateByNodeId?: Maybe<ProviderSignOffClaimState>;
  /** Reads and enables pagination through a set of `ProviderSignOffClaimState`. */
  providerSignOffClaimStates?: Maybe<ProviderSignOffClaimStatesConnection>;
  /** Reads and enables pagination through a set of `ProviderUserFacility`. */
  providerUserFacilities?: Maybe<ProviderUserFacilitiesConnection>;
  providerUserFacility?: Maybe<ProviderUserFacility>;
  /** Reads a single `ProviderUserFacility` using its globally unique `ID`. */
  providerUserFacilityByNodeId?: Maybe<ProviderUserFacility>;
  providerUserFacilityByProviderIdAndAuditorUserId?: Maybe<ProviderUserFacility>;
  /** Reads and enables pagination through a set of `Provider`. */
  providers?: Maybe<ProvidersConnection>;
  qaClaimStateRow?: Maybe<QaClaimStateRow>;
  /** Reads a single `QaClaimStateRow` using its globally unique `ID`. */
  qaClaimStateRowByNodeId?: Maybe<QaClaimStateRow>;
  /** Reads and enables pagination through a set of `QaClaimStateRow`. */
  qaClaimStateRows?: Maybe<QaClaimStateRowsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  queue?: Maybe<Queue>;
  /** Reads a single `Queue` using its globally unique `ID`. */
  queueByNodeId?: Maybe<Queue>;
  /**
   * Filter-aware queue overview (Claims Summary + Phases). Pass the same BatchClaimFilter as the claim table.
   * Not for PROVIDER.
   */
  queueClaimListOverview: QueueClaimListOverview;
  /** Reads and enables pagination through a set of `Queue`. */
  queues?: Maybe<QueuesConnection>;
  reasonCode?: Maybe<ReasonCode>;
  /** Reads a single `ReasonCode` using its globally unique `ID`. */
  reasonCodeByNodeId?: Maybe<ReasonCode>;
  /** Reads and enables pagination through a set of `ReasonCode`. */
  reasonCodes?: Maybe<ReasonCodesConnection>;
  reportTransfers: Array<ClientSendReportTransfer>;
  reportedClaim?: Maybe<ReportedClaim>;
  /** Reads a single `ReportedClaim` using its globally unique `ID`. */
  reportedClaimByNodeId?: Maybe<ReportedClaim>;
  /** Reads and enables pagination through a set of `ReportedClaim`. */
  reportedClaims?: Maybe<ReportedClaimsConnection>;
  reportedFinding?: Maybe<ReportedFinding>;
  /** Reads a single `ReportedFinding` using its globally unique `ID`. */
  reportedFindingByNodeId?: Maybe<ReportedFinding>;
  /** Reads and enables pagination through a set of `ReportedFinding`. */
  reportedFindings?: Maybe<ReportedFindingsConnection>;
  /**
   * Returns the distinct rev codes present on the active IB lines of
   * a claim, ordered ascending. Empty array if the claim has no IB
   * lines, or if the caller cannot see the claim under RLS.
   */
  revCodesByClaimId: Array<ClaimRevCode>;
  reviewedAuditFinding?: Maybe<ReviewedAuditFinding>;
  /** Reads a single `ReviewedAuditFinding` using its globally unique `ID`. */
  reviewedAuditFindingByNodeId?: Maybe<ReviewedAuditFinding>;
  /** Reads and enables pagination through a set of `ReviewedAuditFinding`. */
  reviewedAuditFindings?: Maybe<ReviewedAuditFindingsConnection>;
  rolePermissionMatrix: RolePermissionMatrix;
  s3AuditDocumentation?: Maybe<S3AuditDocumentation>;
  /** Reads a single `S3AuditDocumentation` using its globally unique `ID`. */
  s3AuditDocumentationByNodeId?: Maybe<S3AuditDocumentation>;
  /** Reads and enables pagination through a set of `S3AuditDocumentation`. */
  s3AuditDocumentations?: Maybe<S3AuditDocumentationsConnection>;
  searchInFile: Array<SearchResult>;
  ssoDomainIdentityProvider?: Maybe<SsoDomainIdentityProvider>;
  ssoDomainIdentityProviderByDomainAndEnvironmentAndTenantId?: Maybe<SsoDomainIdentityProvider>;
  /** Reads a single `SsoDomainIdentityProvider` using its globally unique `ID`. */
  ssoDomainIdentityProviderByNodeId?: Maybe<SsoDomainIdentityProvider>;
  /** Reads and enables pagination through a set of `SsoDomainIdentityProvider`. */
  ssoDomainIdentityProviders?: Maybe<SsoDomainIdentityProvidersConnection>;
  thread: Thread;
  threads: Array<Thread>;
  /**
   * ### Overview
   * Retrieves the unique set of health care providers by their unique id called an NPI.
   */
  uniqueNpiProviders?: Maybe<NpiProvidersConnection>;
  /**
   * ### Overview
   * Select the distinct procedure codes at the batch claim line level.
   * Effectively, this is a list of codes that are more detailed about medical procedures done for services present on the unified bill (UB).
   */
  uniqueProcedureCodes?: Maybe<UniqueProcedureCodesConnection>;
  /**
   * ### Overview
   * Select the distinct revenue codes present at the batch claim line level.
   * Effectively, this is a list of services present on a unified bill (UB).
   */
  uniqueRevCodes?: Maybe<UniqueRevCodesConnection>;
  user?: Maybe<User>;
  userInviteCreated?: Maybe<UserInviteCreated>;
  /** Reads a single `UserInviteCreated` using its globally unique `ID`. */
  userInviteCreatedByNodeId?: Maybe<UserInviteCreated>;
  /** Reads and enables pagination through a set of `UserInviteCreated`. */
  userInviteCreateds?: Maybe<UserInviteCreatedsConnection>;
  /**
   * ### Overview
   * Check if a provider user is assigned to a given facility by querying the mapping table `v3.provider_user_facilities`.
   * *Note*: provider users can only interact with claims data for facilities they are associated to
   */
  userIsAssignedToProviderFacility?: Maybe<Scalars["Boolean"]["output"]>;
  userTenantName: Scalars["String"]["output"];
  workflowClaimState?: Maybe<WorkflowClaimState>;
  /** Reads a single `WorkflowClaimState` using its globally unique `ID`. */
  workflowClaimStateByNodeId?: Maybe<WorkflowClaimState>;
  /** Reads and enables pagination through a set of `WorkflowClaimState`. */
  workflowClaimStates?: Maybe<WorkflowClaimStatesConnection>;
};

/** The root query type which gives access points into the data universe. */
export type QueryacceptedFindingsByIbLineIdsArgs = {
  ibLineIds: Array<Scalars["UUID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryactiveClaimAssigneeArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryactiveClaimAssigneeByBatchClaimIdAndAuditorUserIdArgs = {
  auditorUserId: Scalars["UUID"]["input"];
  batchClaimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryactiveClaimAssigneeByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryactiveClaimAssigneesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ActiveClaimAssigneeCondition>;
  filter?: InputMaybe<ActiveClaimAssigneeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ActiveClaimAssigneesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryactiveIbLinesViewsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ActiveIbLinesViewCondition>;
  filter?: InputMaybe<ActiveIbLinesViewFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ActiveIbLinesViewsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryagentArgs = {
  id: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryagentArtifactArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryagentArtifactTemplateArgs = {
  artifactTemplateKey: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryagentsArgs = {
  input: AgentsInput;
};

/** The root query type which gives access points into the data universe. */
export type QueryannotationsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryaskAutodorFileVectorsExistArgs = {
  input?: InputMaybe<AskAutodorFileVectorsExistInput>;
};

/** The root query type which gives access points into the data universe. */
export type QueryaskAutodorGetSavedPromptsArgs = {
  input?: InputMaybe<AskAutodorGetSavedPromptsInput>;
};

/** The root query type which gives access points into the data universe. */
export type QueryaskAutodorQueueArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryaskAutodorQueuesArgs = {
  args?: InputMaybe<AskAutodorQueuesArgs>;
};

/** The root query type which gives access points into the data universe. */
export type QueryaskAutodorQueuesConnectionArgs = {
  args?: InputMaybe<AskAutodorQueuesArgs>;
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingJobArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingJobByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingJobsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingJobCondition>;
  filter?: InputMaybe<AuditFindingJobFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingJobsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingReasonCodeArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingReasonCodeByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingReasonCodesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReasonCodeCondition>;
  filter?: InputMaybe<AuditFindingReasonCodeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReasonCodesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingReportArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingReportByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingReportsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReportCondition>;
  filter?: InputMaybe<AuditFindingReportFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReportsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingReviewArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingReviewByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingReviewByReviewIdArgs = {
  reviewId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingReviewByReviewIdAndOriginalIdArgs = {
  originalId: Scalars["UUID"]["input"];
  reviewId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingReviewsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReviewCondition>;
  filter?: InputMaybe<AuditFindingReviewFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReviewsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingRuleTypeArgs = {
  type: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingRuleTypeByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingRuleTypesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingRuleTypeCondition>;
  filter?: InputMaybe<AuditFindingRuleTypeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingRuleTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryauditFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingCondition>;
  filter?: InputMaybe<AuditFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryauditStatusArgs = {
  id: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditorBucketArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditorBucketAssigneeArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditorBucketAssigneeByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditorBucketAssigneesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditorBucketAssigneeCondition>;
  filter?: InputMaybe<AuditorBucketAssigneeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditorBucketAssigneesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryauditorBucketByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditorBucketsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditorBucketCondition>;
  filter?: InputMaybe<AuditorBucketFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditorBucketsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryauditorUserArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditorUserByEmailArgs = {
  email: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditorUserByIdpSubArgs = {
  idpSub: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditorUserByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryauditorUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditorUserCondition>;
  filter?: InputMaybe<AuditorUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditorUsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryautodorArgs = {
  claimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryautomationAuthorArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAppealedArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAppealedByBatchClaimIdArgs = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAppealedByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAppealedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAppealedCondition>;
  filter?: InputMaybe<BatchClaimAppealedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAppealedsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAssigneeArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAssigneeByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAssigneesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAssigneeCondition>;
  filter?: InputMaybe<BatchClaimAssigneeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAssigneesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAuditStartDateArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAuditStartDateByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAuditStartDatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAuditStartDateCondition>;
  filter?: InputMaybe<BatchClaimAuditStartDateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAuditStartDatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAuditTypeArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAuditTypeByBatchClaimIdArgs = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAuditTypeByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAuditTypesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAuditTypeCondition>;
  filter?: InputMaybe<BatchClaimAuditTypeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAuditTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAuditorArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAuditorByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimAuditorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimAuditorCondition>;
  filter?: InputMaybe<BatchClaimAuditorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimAuditorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimByIcnArgs = {
  icn: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimByIdAndInsurerIdArgs = {
  id: Scalars["UUID"]["input"];
  insurerId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimClientRecoveryAmountArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimClientRecoveryAmountByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimClientRecoveryAmountsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimClientRecoveryAmountCondition>;
  filter?: InputMaybe<BatchClaimClientRecoveryAmountFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimClientRecoveryAmountsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimClientRecoveryCollectionDateArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimClientRecoveryCollectionDateByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimClientRecoveryCollectionDatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimClientRecoveryCollectionDateCondition>;
  filter?: InputMaybe<BatchClaimClientRecoveryCollectionDateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimClientRecoveryCollectionDatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimDocumentArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimDocumentByBatchClaimIdAndDocumentIdArgs = {
  batchClaimId: Scalars["UUID"]["input"];
  documentId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimDocumentByBatchClaimIdAndIsPrimaryMedicalRecordArgs =
  {
    batchClaimId: Scalars["UUID"]["input"];
    isPrimaryMedicalRecord: Scalars["Boolean"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimDocumentByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimDocumentsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimDocumentCondition>;
  filter?: InputMaybe<BatchClaimDocumentFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimDocumentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimDueDateArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimDueDateByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimDueDatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimDueDateCondition>;
  filter?: InputMaybe<BatchClaimDueDateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimDueDatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineComputedValueArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineComputedValueByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineComputedValuesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineComputedValueCondition>;
  filter?: InputMaybe<BatchClaimLineComputedValueFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineComputedValuesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemAuditArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemAuditByAuditFindingIdArgs = {
  auditFindingId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemAuditByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemAuditsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemAuditCondition>;
  filter?: InputMaybe<BatchClaimLineItemAuditFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemAuditsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemComputedValueArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemComputedValueByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemComputedValuesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemComputedValueCondition>;
  filter?: InputMaybe<BatchClaimLineItemComputedValueFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemComputedValuesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemNnIbLineArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemNnIbLineByBatchClaimLineItemIdAndNnIbLineIdArgs =
  {
    batchClaimLineItemId: Scalars["UUID"]["input"];
    nnIbLineId: Scalars["UUID"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemNnIbLineByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemNnIbLinesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemNnIbLineCondition>;
  filter?: InputMaybe<BatchClaimLineItemNnIbLineFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemNnIbLinesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLineItemsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineItemCondition>;
  filter?: InputMaybe<BatchClaimLineItemFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLineItemsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimLinesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimLineCondition>;
  filter?: InputMaybe<BatchClaimLineFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimLinesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimPayDeniesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimPayDenyCondition>;
  filter?: InputMaybe<BatchClaimPayDenyFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimPayDeniesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimPayDenyArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimPayDenyByBatchClaimIdArgs = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimPayDenyByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimStateArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimStateByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimStateCondition>;
  filter?: InputMaybe<BatchClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimStatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimStatesWithActiveStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<BatchClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimTechDenialArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimTechDenialByBatchClaimIdArgs = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimTechDenialByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimTechDenialsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimTechDenialCondition>;
  filter?: InputMaybe<BatchClaimTechDenialFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimTechDenialsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchClaimCondition>;
  filter?: InputMaybe<BatchClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchClaimsAssignedToAuditorArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<BatchClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchClaimsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchFileArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchFileByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybatchFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BatchFileCondition>;
  filter?: InputMaybe<BatchFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BatchFilesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerybucketClaimArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybucketClaimByBatchClaimIdArgs = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybucketClaimByBatchClaimIdAndAuditorBucketIdArgs = {
  auditorBucketId: Scalars["UUID"]["input"];
  batchClaimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybucketClaimByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerybucketClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<BucketClaimCondition>;
  filter?: InputMaybe<BucketClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<BucketClaimsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerycapabilitiesArgs = {
  filter?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerycaseArgs = {
  id: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerycasesArgs = {
  input?: InputMaybe<CasesInput>;
};

/** The root query type which gives access points into the data universe. */
export type QuerycasesConnectionArgs = {
  args?: InputMaybe<CasesArgs>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimArgs = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimActionPermissionsArgs = {
  claimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditBlockerArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditBlockerByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditBlockerBySlugArgs = {
  slug: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditBlockerByStagesFacetIdArgs = {
  stagesFacetId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditBlockerStageAvailabilitiesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimAuditBlockerStageAvailabilityCondition>;
  filter?: InputMaybe<ClaimAuditBlockerStageAvailabilityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimAuditBlockerStageAvailabilitiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditBlockerStageAvailabilityArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditBlockerStageAvailabilityByClientSlugAndAuditTypeAndPaymentTypeAndBlockerStageKeywordIdArgs =
  {
    auditType: Scalars["String"]["input"];
    blockerStageKeywordId: Scalars["UUID"]["input"];
    clientSlug: Scalars["String"]["input"];
    paymentType: Scalars["String"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditBlockerStageAvailabilityByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditBlockersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimAuditBlockerCondition>;
  filter?: InputMaybe<ClaimAuditBlockerFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimAuditBlockersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditGroupArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditGroupByNameArgs = {
  name: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditGroupByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimAuditGroupCondition>;
  filter?: InputMaybe<ClaimAuditGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimAuditGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditStageSuggestionArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditStageSuggestionByFromStageKeywordIdAndPriorityArgs =
  {
    fromStageKeywordId: Scalars["UUID"]["input"];
    priority: Scalars["Int"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditStageSuggestionByFromStageKeywordIdAndToStageKeywordIdArgs =
  {
    fromStageKeywordId: Scalars["UUID"]["input"];
    toStageKeywordId: Scalars["UUID"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditStageSuggestionByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimAuditStageSuggestionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimAuditStageSuggestionCondition>;
  filter?: InputMaybe<ClaimAuditStageSuggestionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimAuditStageSuggestionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimCasesArgs = {
  claimId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimFacetArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimFacetByBatchClaimIdArgs = {
  batchClaimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimFacetByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimFacetHistoriesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimFacetHistoryCondition>;
  filter?: InputMaybe<ClaimFacetHistoryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimFacetHistoriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimFacetHistoryArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimFacetHistoryByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimFacetHistoryReadablesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimFacetHistoryReadableCondition>;
  filter?: InputMaybe<ClaimFacetHistoryReadableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimFacetHistoryReadablesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimFacetsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimFacetCondition>;
  filter?: InputMaybe<ClaimFacetFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimFacetsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimIntakeArgs = {
  input: ClaimIntakeInput;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimMrReportsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimMrReportCondition>;
  filter?: InputMaybe<ClaimMrReportFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimMrReportsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimPolicyDocumentArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimPolicyDocumentByBatchClaimIdAndDocumentIdArgs = {
  batchClaimId: Scalars["UUID"]["input"];
  documentId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimPolicyDocumentByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimPolicyDocumentsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClaimPolicyDocumentCondition>;
  filter?: InputMaybe<ClaimPolicyDocumentFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClaimPolicyDocumentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimRoleAssignmentsArgs = {
  claimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclaimsSummaryArgs = {
  queueId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryclientSignOffClaimStateArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclientSignOffClaimStateByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryclientSignOffClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ClientSignOffClaimStateCondition>;
  filter?: InputMaybe<ClientSignOffClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ClientSignOffClaimStatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerydashboardSummaryArgs = {
  input: DashboardSummaryInput;
};

/** The root query type which gives access points into the data universe. */
export type QuerydefaultStrategyByInsurerArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydefaultStrategyByInsurerByInsurerIdArgs = {
  insurerId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydefaultStrategyByInsurerByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydefaultStrategyByInsurersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DefaultStrategyByInsurerCondition>;
  filter?: InputMaybe<DefaultStrategyByInsurerFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DefaultStrategyByInsurersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerydenialCodesArgs = {
  claimDataType?: InputMaybe<Scalars["String"]["input"]>;
  includeDeprecated?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QuerydirectoryArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QuerydisputedFindingArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydisputedFindingByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydisputedFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DisputedFindingCondition>;
  filter?: InputMaybe<DisputedFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DisputedFindingsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentRequestCreatedArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentRequestCreatedByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentRequestCreatedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentRequestCreatedCondition>;
  filter?: InputMaybe<DocumentRequestCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentRequestCreatedsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentUploadCreatedArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentUploadCreatedByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentUploadCreatedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentUploadCreatedCondition>;
  filter?: InputMaybe<DocumentUploadCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentUploadCreatedsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentationClaimStateArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentationClaimStateByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentationClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentationClaimStateCondition>;
  filter?: InputMaybe<DocumentationClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentationClaimStatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentationSelectionSetArgs = {
  etag: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentationSelectionSetByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentationSelectionSetByS3KeyArgs = {
  s3Key: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerydocumentationSelectionSetsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DocumentationSelectionSetCondition>;
  filter?: InputMaybe<DocumentationSelectionSetFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DocumentationSelectionSetsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryfacetArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryfacetBySlugArgs = {
  slug: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryfacetKeywordArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryfacetKeywordsArgs = {
  facetId: Scalars["UUID"]["input"];
  includeInactive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryfacetsArgs = {
  includeInactive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryfeatureFlagArgs = {
  key: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryfeatureFlagDynamicArgs = {
  defaultValue: Scalars["JSON"]["input"];
  key: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryfeaturesArgs = {
  key?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryfileArgs = {
  id: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryfileAiAnnotationsArgs = {
  fileId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryfileDownloadUrlArgs = {
  id: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryfileUserAnnotationsArgs = {
  fileId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryfilesArgs = {
  input?: InputMaybe<FilesInput>;
};

/** The root query type which gives access points into the data universe. */
export type QueryfindingArgs = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QuerygenerateAuditFindingReportViewIdArgs = {
  claimFilter?: InputMaybe<Scalars["JSON"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QuerygenerateBcliVersionFingerprintArgs = {
  alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateOfServiceStart?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  itemNumber?: InputMaybe<Scalars["String"]["input"]>;
  lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
  originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  procedureCode?: InputMaybe<Scalars["String"]["input"]>;
  procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
  revCode?: InputMaybe<Scalars["String"]["input"]>;
  unitCharge?: InputMaybe<Scalars["BigFloat"]["input"]>;
  units?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryhprCalculateTimeSpentSecsArgs = {
  hprId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryhumanProcessingRequestArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryhumanProcessingRequestByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryhumanProcessingRequestByRunIdAndS3AuditDocumentationIdAndRequestTypeArgs =
  {
    requestType: HumanProcessingRequestType;
    runId: Scalars["Int"]["input"];
    s3AuditDocumentationId: Scalars["UUID"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryhumanProcessingRequestsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<HumanProcessingRequestCondition>;
  filter?: InputMaybe<HumanProcessingRequestFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<HumanProcessingRequestsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerByClientAbbreviationArgs = {
  clientAbbreviation: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerByNameArgs = {
  name: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerClaimIntakeDropboxPermittedByInsurerIdArgs = {
  insurerId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerClaimIntakeDropboxPermittedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<InsurerClaimIntakeDropboxPermittedCondition>;
  filter?: InputMaybe<InsurerClaimIntakeDropboxPermittedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<InsurerClaimIntakeDropboxPermittedsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerOrganizationArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerOrganizationByMemberIdAndOrganizationIdArgs = {
  memberId: Scalars["UUID"]["input"];
  organizationId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerOrganizationByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerOrganizationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<InsurerOrganizationCondition>;
  filter?: InputMaybe<InsurerOrganizationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<InsurerOrganizationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerUserArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerUserByAuditorUserIdAndInsurerIdArgs = {
  auditorUserId: Scalars["UUID"]["input"];
  insurerId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerUserByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurerUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<InsurerUserCondition>;
  filter?: InputMaybe<InsurerUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<InsurerUsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<InsurerCondition>;
  filter?: InputMaybe<InsurerFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<InsurersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryinsurersAssignedToAuditorArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<InsurerFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryinvoiceClaimStateArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinvoiceClaimStateByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryinvoiceClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<InvoiceClaimStateCondition>;
  filter?: InputMaybe<InvoiceClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<InvoiceClaimStatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryitemizedBillLinesArgs = {
  ids: Array<Scalars["UUID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QuerylifecycleRoleArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerylifecycleRolesArgs = {
  claimId?: InputMaybe<Scalars["UUID"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QuerymessageCreatedArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerymessageCreatedByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerymessageCreatedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MessageCreatedCondition>;
  filter?: InputMaybe<MessageCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MessageCreatedsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerymessageSentArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerymessageSentByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerymessageSentsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MessageSentCondition>;
  filter?: InputMaybe<MessageSentFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MessageSentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerynegotiationClaimStateArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerynegotiationClaimStateByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerynegotiationClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<NegotiationClaimStateCondition>;
  filter?: InputMaybe<NegotiationClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<NegotiationClaimStatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerynnIbLineArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerynnIbLineByFingerprintAndS3KeyArgs = {
  fingerprint: Scalars["UUID"]["input"];
  s3Key: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerynnIbLineByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerynnIbLinesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<NnIbLineCondition>;
  filter?: InputMaybe<NnIbLineFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<NnIbLinesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerynodeArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryonHoldClaimStateArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryonHoldClaimStateByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryonHoldClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<OnHoldClaimStateCondition>;
  filter?: InputMaybe<OnHoldClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<OnHoldClaimStatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerypatientDatumArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerypatientDatumByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerypatientDatumByPayerPatientIdArgs = {
  payerPatientId: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerypreflightReportTransferArgs = {
  input: PreflightReportTransferInput;
};

/** The root query type which gives access points into the data universe. */
export type QueryprocedureCodeArgs = {
  id: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryprocedureCodeByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryprocedureCodeTypeByTypeArgs = {
  type: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryprocedureCodeTypesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProcedureCodeTypeCondition>;
  filter?: InputMaybe<ProcedureCodeTypeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProcedureCodeTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryprocedureCodesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProcedureCodeCondition>;
  filter?: InputMaybe<ProcedureCodeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProcedureCodesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryproviderArgs = {
  id: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryproviderAuditStatsArgs = {
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryproviderByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryproviderSignOffClaimStateArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryproviderSignOffClaimStateByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryproviderSignOffClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProviderSignOffClaimStateCondition>;
  filter?: InputMaybe<ProviderSignOffClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProviderSignOffClaimStatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryproviderUserFacilitiesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProviderUserFacilityCondition>;
  filter?: InputMaybe<ProviderUserFacilityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProviderUserFacilitiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryproviderUserFacilityArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryproviderUserFacilityByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryproviderUserFacilityByProviderIdAndAuditorUserIdArgs = {
  auditorUserId: Scalars["UUID"]["input"];
  providerId: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryprovidersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProviderCondition>;
  filter?: InputMaybe<ProviderFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProvidersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryqaClaimStateRowArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryqaClaimStateRowByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryqaClaimStateRowsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<QaClaimStateRowCondition>;
  filter?: InputMaybe<QaClaimStateRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<QaClaimStateRowsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryqueueArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryqueueByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryqueueClaimListOverviewArgs = {
  input: DashboardSummaryInput;
};

/** The root query type which gives access points into the data universe. */
export type QueryqueuesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<QueueCondition>;
  filter?: InputMaybe<QueueFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<QueuesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryreasonCodeArgs = {
  id: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryreasonCodeByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryreasonCodesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ReasonCodeCondition>;
  filter?: InputMaybe<ReasonCodeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ReasonCodesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryreportedClaimArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryreportedClaimByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryreportedClaimsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ReportedClaimCondition>;
  filter?: InputMaybe<ReportedClaimFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ReportedClaimsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryreportedFindingArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryreportedFindingByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryreportedFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ReportedFindingCondition>;
  filter?: InputMaybe<ReportedFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ReportedFindingsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryrevCodesByClaimIdArgs = {
  claimId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryreviewedAuditFindingArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryreviewedAuditFindingByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryreviewedAuditFindingsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ReviewedAuditFindingCondition>;
  filter?: InputMaybe<ReviewedAuditFindingFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ReviewedAuditFindingsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryrolePermissionMatrixArgs = {
  roleId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type Querys3AuditDocumentationArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type Querys3AuditDocumentationByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type Querys3AuditDocumentationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<S3AuditDocumentationCondition>;
  filter?: InputMaybe<S3AuditDocumentationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<S3AuditDocumentationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerysearchInFileArgs = {
  fileId: Scalars["ID"]["input"];
  query: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryssoDomainIdentityProviderArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryssoDomainIdentityProviderByDomainAndEnvironmentAndTenantIdArgs =
  {
    domain: Scalars["String"]["input"];
    environment: Scalars["String"]["input"];
    tenantId: Scalars["String"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryssoDomainIdentityProviderByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryssoDomainIdentityProvidersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<SsoDomainIdentityProviderCondition>;
  filter?: InputMaybe<SsoDomainIdentityProviderFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<SsoDomainIdentityProvidersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerythreadArgs = {
  id: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerythreadsArgs = {
  input: ThreadsInput;
};

/** The root query type which gives access points into the data universe. */
export type QueryuniqueNpiProvidersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<NpiProviderFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryuniqueProcedureCodesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<StringFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryuniqueRevCodesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<StringFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryuserArgs = {
  id: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryuserInviteCreatedArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryuserInviteCreatedByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryuserInviteCreatedsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserInviteCreatedCondition>;
  filter?: InputMaybe<UserInviteCreatedFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserInviteCreatedsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryuserIsAssignedToProviderFacilityArgs = {
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryworkflowClaimStateArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryworkflowClaimStateByNodeIdArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryworkflowClaimStatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowClaimStateCondition>;
  filter?: InputMaybe<WorkflowClaimStateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowClaimStatesOrderBy>>;
};

export type Queue = Node & {
  __typename?: "Queue";
  /** Reads a single `AuditorUser` that is related to this `Queue`. */
  author?: Maybe<AuditorUser>;
  authorId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  deleted: Scalars["Boolean"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  filter: Scalars["JSON"]["output"];
  id: Scalars["UUID"]["output"];
  indexedFilterTags?: Maybe<Scalars["JSON"]["output"]>;
  name: Scalars["String"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type QueueAggregates = {
  __typename?: "QueueAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<QueueDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `Queue` object types. */
export type QueueAggregatesFilter = {
  /** Distinct count aggregate over matching `Queue` objects. */
  distinctCount?: InputMaybe<QueueDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Queue` object to be included within the aggregate. */
  filter?: InputMaybe<QueueFilter>;
};

/** Input for the nested mutation of `auditorUser` in the `QueueInput` mutation. */
export type QueueAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnQueueForQueueAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnQueueForQueueAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnQueueForQueueAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<QueueOnQueueForQueueAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `queue` in the `AuditorUserInput` mutation. */
export type QueueAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `queue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<QueueQueuePkeyConnect>>;
  /** The primary key(s) for `queue` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<QueueNodeIdConnect>>;
  /** A `QueueInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<QueueAuthorIdFkeyQueueCreateInput>>;
  /** The primary key(s) and patch data for `queue` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<QueueOnQueueForQueueAuthorIdFkeyUsingQueuePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `queue` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnQueueForQueueAuthorIdFkeyNodeIdUpdate>
  >;
};

/** The `queue` to be created by this mutation. */
export type QueueAuthorIdFkeyQueueCreateInput = {
  auditorUserToAuthorId?: InputMaybe<QueueAuthorIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  filter: Scalars["JSON"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  indexedFilterTags?: InputMaybe<Scalars["JSON"]["input"]>;
  name: Scalars["String"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Home / queue overview: left Claims Summary + right Phases. */
export type QueueClaimListOverview = {
  __typename?: "QueueClaimListOverview";
  phases: Array<DashboardPhaseSummary>;
  summary: DashboardSummary;
};

/** A condition to be used against `Queue` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type QueueCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `filter` field. */
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `indexedFilterTags` field. */
  indexedFilterTags?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type QueueDistinctCountAggregateFilter = {
  authorId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  deleted?: InputMaybe<BigIntFilter>;
  description?: InputMaybe<BigIntFilter>;
  filter?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  indexedFilterTags?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type QueueDistinctCountAggregates = {
  __typename?: "QueueDistinctCountAggregates";
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of deleted across the matching connection */
  deleted?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of filter across the matching connection */
  filter?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of indexedFilterTags across the matching connection */
  indexedFilterTags?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `Queue` object types. All fields are combined with a logical ‘and.’ */
export type QueueFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<QueueFilter>>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `filter` field. */
  filter?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `indexedFilterTags` field. */
  indexedFilterTags?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<QueueFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<QueueFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `Queue` for usage during aggregation. */
export enum QueueGroupBy {
  AUTHOR_ID = "AUTHOR_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DELETED = "DELETED",
  DESCRIPTION = "DESCRIPTION",
  FILTER = "FILTER",
  INDEXED_FILTER_TAGS = "INDEXED_FILTER_TAGS",
  NAME = "NAME",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type QueueHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QueueHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Queue` aggregates. */
export type QueueHavingInput = {
  AND?: InputMaybe<Array<QueueHavingInput>>;
  OR?: InputMaybe<Array<QueueHavingInput>>;
  average?: InputMaybe<QueueHavingAverageInput>;
  distinctCount?: InputMaybe<QueueHavingDistinctCountInput>;
  max?: InputMaybe<QueueHavingMaxInput>;
  min?: InputMaybe<QueueHavingMinInput>;
  stddevPopulation?: InputMaybe<QueueHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<QueueHavingStddevSampleInput>;
  sum?: InputMaybe<QueueHavingSumInput>;
  variancePopulation?: InputMaybe<QueueHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<QueueHavingVarianceSampleInput>;
};

export type QueueHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QueueHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QueueHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QueueHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QueueHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QueueHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type QueueHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `Queue` */
export type QueueInput = {
  auditorUserToAuthorId?: InputMaybe<QueueAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  filter: Scalars["JSON"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  indexedFilterTags?: InputMaybe<Scalars["JSON"]["input"]>;
  name: Scalars["String"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type QueueNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `queue` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type QueueOnQueueForQueueAuthorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `auditorUser` being updated. */
  patch: AuditorUserPatch;
};

/** The fields on `queue` to look up the row to update. */
export type QueueOnQueueForQueueAuthorIdFkeyUsingQueuePkeyUpdate = {
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `queue` being updated. */
  patch: updateQueueOnQueueForQueueAuthorIdFkeyPatch;
};

/** Represents an update to a `Queue`. Fields that are set will be updated. */
export type QueuePatch = {
  auditorUserToAuthorId?: InputMaybe<QueueAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  indexedFilterTags?: InputMaybe<Scalars["JSON"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The fields on `queue` to look up the row to connect. */
export type QueueQueuePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `Queue` values. */
export type QueuesConnection = {
  __typename?: "QueuesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<QueueAggregates>;
  /** A list of edges which contains the `Queue` and cursor to aid in pagination. */
  edges: Array<QueuesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<QueueAggregates>>;
  /** A list of `Queue` objects. */
  nodes: Array<Maybe<Queue>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Queue` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `Queue` values. */
export type QueuesConnectiongroupedAggregatesArgs = {
  groupBy: Array<QueueGroupBy>;
  having?: InputMaybe<QueueHavingInput>;
};

/** A `Queue` edge in the connection. */
export type QueuesEdge = {
  __typename?: "QueuesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Queue` at the end of the edge. */
  node?: Maybe<Queue>;
};

/** Methods to use when ordering `Queue`. */
export enum QueuesOrderBy {
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DELETED_ASC = "DELETED_ASC",
  DELETED_DESC = "DELETED_DESC",
  DESCRIPTION_ASC = "DESCRIPTION_ASC",
  DESCRIPTION_DESC = "DESCRIPTION_DESC",
  FILTER_ASC = "FILTER_ASC",
  FILTER_DESC = "FILTER_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  INDEXED_FILTER_TAGS_ASC = "INDEXED_FILTER_TAGS_ASC",
  INDEXED_FILTER_TAGS_DESC = "INDEXED_FILTER_TAGS_DESC",
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type ReasonCode = Node & {
  __typename?: "ReasonCode";
  /** Reads and enables pagination through a set of `AuditFindingReasonCode`. */
  auditFindingReasonCodes: AuditFindingReasonCodesConnection;
  createdAt: Scalars["Datetime"]["output"];
  dateEffectiveEnd?: Maybe<Scalars["Datetime"]["output"]>;
  dateEffectiveStart?: Maybe<Scalars["Datetime"]["output"]>;
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  lastUpdated?: Maybe<Scalars["Datetime"]["output"]>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

export type ReasonCodeauditFindingReasonCodesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditFindingReasonCodeCondition>;
  filter?: InputMaybe<AuditFindingReasonCodeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditFindingReasonCodesOrderBy>>;
};

export type ReasonCodeAggregates = {
  __typename?: "ReasonCodeAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ReasonCodeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * A condition to be used against `ReasonCode` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ReasonCodeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateEffectiveEnd` field. */
  dateEffectiveEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateEffectiveStart` field. */
  dateEffectiveStart?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `notes` field. */
  notes?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type ReasonCodeDistinctCountAggregates = {
  __typename?: "ReasonCodeDistinctCountAggregates";
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dateEffectiveEnd across the matching connection */
  dateEffectiveEnd?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of dateEffectiveStart across the matching connection */
  dateEffectiveStart?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of description across the matching connection */
  description?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of lastUpdated across the matching connection */
  lastUpdated?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of notes across the matching connection */
  notes?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ReasonCode` object types. All fields are combined with a logical ‘and.’ */
export type ReasonCodeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReasonCodeFilter>>;
  /** Filter by the object’s `auditFindingReasonCodes` relation. */
  auditFindingReasonCodes?: InputMaybe<ReasonCodeToManyAuditFindingReasonCodeFilter>;
  /** Some related `auditFindingReasonCodes` exist. */
  auditFindingReasonCodesExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateEffectiveEnd` field. */
  dateEffectiveEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateEffectiveStart` field. */
  dateEffectiveStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReasonCodeFilter>;
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReasonCodeFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `ReasonCode` for usage during aggregation. */
export enum ReasonCodeGroupBy {
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DATE_EFFECTIVE_END = "DATE_EFFECTIVE_END",
  DATE_EFFECTIVE_END_TRUNCATED_TO_DAY = "DATE_EFFECTIVE_END_TRUNCATED_TO_DAY",
  DATE_EFFECTIVE_END_TRUNCATED_TO_HOUR = "DATE_EFFECTIVE_END_TRUNCATED_TO_HOUR",
  DATE_EFFECTIVE_START = "DATE_EFFECTIVE_START",
  DATE_EFFECTIVE_START_TRUNCATED_TO_DAY = "DATE_EFFECTIVE_START_TRUNCATED_TO_DAY",
  DATE_EFFECTIVE_START_TRUNCATED_TO_HOUR = "DATE_EFFECTIVE_START_TRUNCATED_TO_HOUR",
  DESCRIPTION = "DESCRIPTION",
  LAST_UPDATED = "LAST_UPDATED",
  LAST_UPDATED_TRUNCATED_TO_DAY = "LAST_UPDATED_TRUNCATED_TO_DAY",
  LAST_UPDATED_TRUNCATED_TO_HOUR = "LAST_UPDATED_TRUNCATED_TO_HOUR",
  NOTES = "NOTES",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type ReasonCodeHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveEnd?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveStart?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReasonCodeHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveEnd?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveStart?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ReasonCode` aggregates. */
export type ReasonCodeHavingInput = {
  AND?: InputMaybe<Array<ReasonCodeHavingInput>>;
  OR?: InputMaybe<Array<ReasonCodeHavingInput>>;
  average?: InputMaybe<ReasonCodeHavingAverageInput>;
  distinctCount?: InputMaybe<ReasonCodeHavingDistinctCountInput>;
  max?: InputMaybe<ReasonCodeHavingMaxInput>;
  min?: InputMaybe<ReasonCodeHavingMinInput>;
  stddevPopulation?: InputMaybe<ReasonCodeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ReasonCodeHavingStddevSampleInput>;
  sum?: InputMaybe<ReasonCodeHavingSumInput>;
  variancePopulation?: InputMaybe<ReasonCodeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ReasonCodeHavingVarianceSampleInput>;
};

export type ReasonCodeHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveEnd?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveStart?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReasonCodeHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveEnd?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveStart?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReasonCodeHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveEnd?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveStart?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReasonCodeHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveEnd?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveStart?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReasonCodeHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveEnd?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveStart?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReasonCodeHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveEnd?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveStart?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReasonCodeHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveEnd?: InputMaybe<HavingDatetimeFilter>;
  dateEffectiveStart?: InputMaybe<HavingDatetimeFilter>;
  lastUpdated?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ReasonCodeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `reasonCode` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReasonCode` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReasonCode` being updated. */
    patch: AuditFindingReasonCodePatch;
  };

/** The fields on `reasonCode` to look up the row to update. */
export type ReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyUsingReasonCodePkeyUpdate =
  {
    id: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `reasonCode` being updated. */
    patch: updateReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyPatch;
  };

/** Represents an update to a `ReasonCode`. Fields that are set will be updated. */
export type ReasonCodePatch = {
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeReasonCodeIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateEffectiveEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateEffectiveStart?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  lastUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The fields on `reasonCode` to look up the row to connect. */
export type ReasonCodeReasonCodePkeyConnect = {
  id: Scalars["String"]["input"];
};

/** A filter to be used against many `AuditFindingReasonCode` object types. All fields are combined with a logical ‘and.’ */
export type ReasonCodeToManyAuditFindingReasonCodeFilter = {
  /** Aggregates across related `AuditFindingReasonCode` match the filter criteria. */
  aggregates?: InputMaybe<AuditFindingReasonCodeAggregatesFilter>;
  /** Every related `AuditFindingReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditFindingReasonCodeFilter>;
  /** No related `AuditFindingReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditFindingReasonCodeFilter>;
  /** Some related `AuditFindingReasonCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditFindingReasonCodeFilter>;
};

/** A connection to a list of `ReasonCode` values. */
export type ReasonCodesConnection = {
  __typename?: "ReasonCodesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ReasonCodeAggregates>;
  /** A list of edges which contains the `ReasonCode` and cursor to aid in pagination. */
  edges: Array<ReasonCodesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ReasonCodeAggregates>>;
  /** A list of `ReasonCode` objects. */
  nodes: Array<Maybe<ReasonCode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReasonCode` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ReasonCode` values. */
export type ReasonCodesConnectiongroupedAggregatesArgs = {
  groupBy: Array<ReasonCodeGroupBy>;
  having?: InputMaybe<ReasonCodeHavingInput>;
};

/** A `ReasonCode` edge in the connection. */
export type ReasonCodesEdge = {
  __typename?: "ReasonCodesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ReasonCode` at the end of the edge. */
  node?: Maybe<ReasonCode>;
};

/** Methods to use when ordering `ReasonCode`. */
export enum ReasonCodesOrderBy {
  AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_ID_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_ID_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_AVERAGE_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_BY_REASON_CODE_ID__COUNT_ASC = "AUDIT_FINDING_REASON_CODES_BY_REASON_CODE_ID__COUNT_ASC",
  AUDIT_FINDING_REASON_CODES_BY_REASON_CODE_ID__COUNT_DESC = "AUDIT_FINDING_REASON_CODES_BY_REASON_CODE_ID__COUNT_DESC",
  AUDIT_FINDING_REASON_CODES_COUNT_ASC = "AUDIT_FINDING_REASON_CODES_COUNT_ASC",
  AUDIT_FINDING_REASON_CODES_COUNT_DESC = "AUDIT_FINDING_REASON_CODES_COUNT_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_ID_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_DISTINCT_COUNT_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_MAX_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_MAX_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_MAX_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_ID_ASC = "AUDIT_FINDING_REASON_CODES_MAX_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_ID_DESC = "AUDIT_FINDING_REASON_CODES_MAX_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_MAX_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_MAX_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_MIN_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_MIN_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_MIN_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_ID_ASC = "AUDIT_FINDING_REASON_CODES_MIN_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_ID_DESC = "AUDIT_FINDING_REASON_CODES_MIN_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_MIN_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_MIN_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_STDDEV_SAMPLE_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_SUM_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_SUM_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_SUM_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_ID_ASC = "AUDIT_FINDING_REASON_CODES_SUM_ID_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_ID_DESC = "AUDIT_FINDING_REASON_CODES_SUM_ID_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_SUM_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_SUM_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_POPULATION_UPDATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_AUTHOR_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_CREATED_AT_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_REASON_CODE_ID_DESC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_ASC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_DESC = "AUDIT_FINDING_REASON_CODES_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DATE_EFFECTIVE_END_ASC = "DATE_EFFECTIVE_END_ASC",
  DATE_EFFECTIVE_END_DESC = "DATE_EFFECTIVE_END_DESC",
  DATE_EFFECTIVE_START_ASC = "DATE_EFFECTIVE_START_ASC",
  DATE_EFFECTIVE_START_DESC = "DATE_EFFECTIVE_START_DESC",
  DESCRIPTION_ASC = "DESCRIPTION_ASC",
  DESCRIPTION_DESC = "DESCRIPTION_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  LAST_UPDATED_ASC = "LAST_UPDATED_ASC",
  LAST_UPDATED_DESC = "LAST_UPDATED_DESC",
  NATURAL = "NATURAL",
  NOTES_ASC = "NOTES_ASC",
  NOTES_DESC = "NOTES_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** All input for the `refreshS3AuditDocumentation` mutation. */
export type RefreshS3AuditDocumentationInput = {
  batchClaimIcn?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  forceRefresh?: InputMaybe<Scalars["Boolean"]["input"]>;
  pId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our `refreshS3AuditDocumentation` mutation. */
export type RefreshS3AuditDocumentationPayload = {
  __typename?: "RefreshS3AuditDocumentationPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  uuids?: Maybe<Array<Maybe<Scalars["UUID"]["output"]>>>;
};

export type Report = {
  __typename?: "Report";
  claims: Array<ReportClaim>;
  clientId: Scalars["UUID"]["output"];
  clientSendReportTransfers: Array<ClientSendReportTransfer>;
  id: Scalars["UUID"]["output"];
  insurerId: Scalars["UUID"]["output"];
  /**
   * Resolves to null on success. When the report transfer succeeded
   * but the post-transfer lifecycle advance to
   * closed/CLOSED_CLIENT_REPORT_SENT (99.1) failed for the report's
   * claim, this subfield resolver throws so the failure surfaces in
   * the GraphQL errors[] alongside data. The top-level mutation
   * payload is unaffected — the transfer rows were committed.
   */
  lifecycleUpdateError?: Maybe<Scalars["String"]["output"]>;
  originalVersionId: Scalars["UUID"]["output"];
  reportS3Key: Scalars["String"]["output"];
  reportType: AuditFindingReportType;
};

export type ReportAggregate = {
  __typename?: "ReportAggregate";
  count?: Maybe<Scalars["Int"]["output"]>;
  endDate?: Maybe<Scalars["Datetime"]["output"]>;
  startDate?: Maybe<Scalars["Datetime"]["output"]>;
  sum?: Maybe<Scalars["Float"]["output"]>;
};

export type ReportClaim = {
  __typename?: "ReportClaim";
  clientIcn?: Maybe<Scalars["String"]["output"]>;
  icn: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
};

/**
 * Tracks the claims reported in a given audit finding report.
 * This is useful for historical audit purposes, but mainly exists to track the computatio strategy used on each claim at the time that the report was generated.
 * We must track these per report since the uniqueness of the report according to our business rules and the actual calculations in the report itself depend on the strategy selected for each claim.
 */
export type ReportedClaim = Node & {
  __typename?: "ReportedClaim";
  /** Reads a single `AuditFindingReport` that is related to this `ReportedClaim`. */
  auditFindingReport?: Maybe<AuditFindingReport>;
  auditFindingReportId: Scalars["UUID"]["output"];
  /** Reads a single `BatchClaim` that is related to this `ReportedClaim`. */
  claim?: Maybe<BatchClaim>;
  claimId: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  strategy: ClaimComputationStrategyKind;
};

export type ReportedClaimAggregates = {
  __typename?: "ReportedClaimAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ReportedClaimDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `ReportedClaim` object types. */
export type ReportedClaimAggregatesFilter = {
  /** Distinct count aggregate over matching `ReportedClaim` objects. */
  distinctCount?: InputMaybe<ReportedClaimDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ReportedClaim` object to be included within the aggregate. */
  filter?: InputMaybe<ReportedClaimFilter>;
};

/** Input for the nested mutation of `auditFindingReport` in the `ReportedClaimInput` mutation. */
export type ReportedClaimAuditFindingReportIdAuditFindingReportIdInput = {
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingReportPreliminaryAuditFindingReportPkeyConnect>;
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingReportNodeIdConnect>;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingReportOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdUsingPreliminaryAuditFindingReportPkeyUpdate>;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ReportedClaimOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdNodeIdUpdate>;
};

/** Input for the nested mutation of `reportedClaim` in the `AuditFindingReportInput` mutation. */
export type ReportedClaimAuditFindingReportIdAuditFindingReportIdInverseInput =
  {
    /** The primary key(s) for `reportedClaim` for the far side of the relationship. */
    connectById?: InputMaybe<Array<ReportedClaimReportedClaimPkeyConnect>>;
    /** The primary key(s) for `reportedClaim` for the far side of the relationship. */
    connectByNodeId?: InputMaybe<Array<ReportedClaimNodeIdConnect>>;
    /** The primary key(s) and patch data for `reportedClaim` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<ReportedClaimOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdUsingReportedClaimPkeyUpdate>
    >;
    /** The primary key(s) and patch data for `reportedClaim` for the far side of the relationship. */
    updateByNodeId?: InputMaybe<
      Array<AuditFindingReportOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdNodeIdUpdate>
    >;
  };

/** Input for the nested mutation of `batchClaim` in the `ReportedClaimInput` mutation. */
export type ReportedClaimClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnReportedClaimForReportedClaimClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnReportedClaimForReportedClaimClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnReportedClaimForReportedClaimClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ReportedClaimOnReportedClaimForReportedClaimClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `reportedClaim` in the `BatchClaimInput` mutation. */
export type ReportedClaimClaimIdFkeyInverseInput = {
  /** The primary key(s) for `reportedClaim` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ReportedClaimReportedClaimPkeyConnect>>;
  /** The primary key(s) for `reportedClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ReportedClaimNodeIdConnect>>;
  /** The primary key(s) and patch data for `reportedClaim` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ReportedClaimOnReportedClaimForReportedClaimClaimIdFkeyUsingReportedClaimPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `reportedClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnReportedClaimForReportedClaimClaimIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `ReportedClaim` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ReportedClaimCondition = {
  /** Checks for equality with the object’s `auditFindingReportId` field. */
  auditFindingReportId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `claimId` field. */
  claimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `strategy` field. */
  strategy?: InputMaybe<ClaimComputationStrategyKind>;
};

export type ReportedClaimDistinctCountAggregateFilter = {
  auditFindingReportId?: InputMaybe<BigIntFilter>;
  claimId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  strategy?: InputMaybe<BigIntFilter>;
};

export type ReportedClaimDistinctCountAggregates = {
  __typename?: "ReportedClaimDistinctCountAggregates";
  /** Distinct count of auditFindingReportId across the matching connection */
  auditFindingReportId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of claimId across the matching connection */
  claimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of strategy across the matching connection */
  strategy?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ReportedClaim` object types. All fields are combined with a logical ‘and.’ */
export type ReportedClaimFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReportedClaimFilter>>;
  /** Filter by the object’s `auditFindingReport` relation. */
  auditFindingReport?: InputMaybe<AuditFindingReportFilter>;
  /** Filter by the object’s `auditFindingReportId` field. */
  auditFindingReportId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `claim` relation. */
  claim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `claimId` field. */
  claimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReportedClaimFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReportedClaimFilter>>;
  /** Filter by the object’s `strategy` field. */
  strategy?: InputMaybe<ClaimComputationStrategyKindFilter>;
};

/** Grouping methods for `ReportedClaim` for usage during aggregation. */
export enum ReportedClaimGroupBy {
  AUDIT_FINDING_REPORT_ID = "AUDIT_FINDING_REPORT_ID",
  CLAIM_ID = "CLAIM_ID",
  STRATEGY = "STRATEGY",
}

/** Conditions for `ReportedClaim` aggregates. */
export type ReportedClaimHavingInput = {
  AND?: InputMaybe<Array<ReportedClaimHavingInput>>;
  OR?: InputMaybe<Array<ReportedClaimHavingInput>>;
};

/** An input for mutations affecting `ReportedClaim` */
export type ReportedClaimInput = {
  auditFindingReportId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingReportToAuditFindingReportId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInput>;
  batchClaimToClaimId?: InputMaybe<ReportedClaimClaimIdFkeyInput>;
  claimId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ReportedClaimNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `reportedClaim` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ReportedClaimOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReport` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: AuditFindingReportPatch;
  };

/** The fields on `reportedClaim` to look up the row to update. */
export type ReportedClaimOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdUsingReportedClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `reportedClaim` being updated. */
    patch: updateReportedClaimOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ReportedClaimOnReportedClaimForReportedClaimClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `reportedClaim` to look up the row to update. */
export type ReportedClaimOnReportedClaimForReportedClaimClaimIdFkeyUsingReportedClaimPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `reportedClaim` being updated. */
    patch: updateReportedClaimOnReportedClaimForReportedClaimClaimIdFkeyPatch;
  };

/** Represents an update to a `ReportedClaim`. Fields that are set will be updated. */
export type ReportedClaimPatch = {
  auditFindingReportId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingReportToAuditFindingReportId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInput>;
  batchClaimToClaimId?: InputMaybe<ReportedClaimClaimIdFkeyInput>;
  claimId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `reportedClaim` to look up the row to connect. */
export type ReportedClaimReportedClaimPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `ReportedClaim` values. */
export type ReportedClaimsConnection = {
  __typename?: "ReportedClaimsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ReportedClaimAggregates>;
  /** A list of edges which contains the `ReportedClaim` and cursor to aid in pagination. */
  edges: Array<ReportedClaimsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ReportedClaimAggregates>>;
  /** A list of `ReportedClaim` objects. */
  nodes: Array<Maybe<ReportedClaim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReportedClaim` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ReportedClaim` values. */
export type ReportedClaimsConnectiongroupedAggregatesArgs = {
  groupBy: Array<ReportedClaimGroupBy>;
  having?: InputMaybe<ReportedClaimHavingInput>;
};

/** A `ReportedClaim` edge in the connection. */
export type ReportedClaimsEdge = {
  __typename?: "ReportedClaimsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ReportedClaim` at the end of the edge. */
  node?: Maybe<ReportedClaim>;
};

/** Methods to use when ordering `ReportedClaim`. */
export enum ReportedClaimsOrderBy {
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CREATED_AT_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CREATED_AT_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CREATED_AT_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CREATED_AT_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__INSURER_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__INSURER_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__INSURER_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__INSURER_ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PROVIDER_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PROVIDER_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_URL_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_URL_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_URL_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_URL_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_VERSION_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_VERSION_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_VERSION_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_VERSION_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__TITLE_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__TITLE_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__TITLE_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__TITLE_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__UPDATED_AT_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__UPDATED_AT_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__UPDATED_AT_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__VIEW_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__VIEW_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__VIEW_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__VIEW_ID_DESC",
  AUDIT_FINDING_REPORT_ID_ASC = "AUDIT_FINDING_REPORT_ID_ASC",
  AUDIT_FINDING_REPORT_ID_DESC = "AUDIT_FINDING_REPORT_ID_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_CLAIM_ID__VERSION_GROUP_DESC",
  CLAIM_ID_ASC = "CLAIM_ID_ASC",
  CLAIM_ID_DESC = "CLAIM_ID_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  STRATEGY_ASC = "STRATEGY_ASC",
  STRATEGY_DESC = "STRATEGY_DESC",
}

export type ReportedFinding = Node & {
  __typename?: "ReportedFinding";
  /** Reads a single `AuditFinding` that is related to this `ReportedFinding`. */
  auditFinding?: Maybe<AuditFinding>;
  auditFindingId: Scalars["UUID"]["output"];
  /** Reads a single `AuditFindingReport` that is related to this `ReportedFinding`. */
  auditFindingReport?: Maybe<AuditFindingReport>;
  auditFindingReportId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type ReportedFindingAggregates = {
  __typename?: "ReportedFindingAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ReportedFindingDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `ReportedFinding` object types. */
export type ReportedFindingAggregatesFilter = {
  /** Distinct count aggregate over matching `ReportedFinding` objects. */
  distinctCount?: InputMaybe<ReportedFindingDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ReportedFinding` object to be included within the aggregate. */
  filter?: InputMaybe<ReportedFindingFilter>;
};

/** Input for the nested mutation of `auditFinding` in the `ReportedFindingInput` mutation. */
export type ReportedFindingAuditFindingIdFkeyInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingAuditFindingClaimLinePkeyConnect>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingNodeIdConnect>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyUsingAuditFindingClaimLinePkeyUpdate>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ReportedFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `reportedFinding` in the `AuditFindingInput` mutation. */
export type ReportedFindingAuditFindingIdFkeyInverseInput = {
  /** The primary key(s) for `reportedFinding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ReportedFindingReportedFindingPkeyConnect>>;
  /** The primary key(s) for `reportedFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ReportedFindingNodeIdConnect>>;
  /** The primary key(s) and patch data for `reportedFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ReportedFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyUsingReportedFindingPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `reportedFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyNodeIdUpdate>
  >;
};

/** Input for the nested mutation of `auditFindingReport` in the `ReportedFindingInput` mutation. */
export type ReportedFindingAuditFindingReportIdFkeyInput = {
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingReportPreliminaryAuditFindingReportPkeyConnect>;
  /** The primary key(s) for `auditFindingReport` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingReportNodeIdConnect>;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingReportOnReportedFindingForReportedFindingAuditFindingReportIdFkeyUsingPreliminaryAuditFindingReportPkeyUpdate>;
  /** The primary key(s) and patch data for `auditFindingReport` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ReportedFindingOnReportedFindingForReportedFindingAuditFindingReportIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `reportedFinding` in the `AuditFindingReportInput` mutation. */
export type ReportedFindingAuditFindingReportIdFkeyInverseInput = {
  /** The primary key(s) for `reportedFinding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ReportedFindingReportedFindingPkeyConnect>>;
  /** The primary key(s) for `reportedFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ReportedFindingNodeIdConnect>>;
  /** The primary key(s) and patch data for `reportedFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ReportedFindingOnReportedFindingForReportedFindingAuditFindingReportIdFkeyUsingReportedFindingPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `reportedFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditFindingReportOnReportedFindingForReportedFindingAuditFindingReportIdFkeyNodeIdUpdate>
  >;
};

/**
 * A condition to be used against `ReportedFinding` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ReportedFindingCondition = {
  /** Checks for equality with the object’s `auditFindingId` field. */
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `auditFindingReportId` field. */
  auditFindingReportId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type ReportedFindingDistinctCountAggregateFilter = {
  auditFindingId?: InputMaybe<BigIntFilter>;
  auditFindingReportId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type ReportedFindingDistinctCountAggregates = {
  __typename?: "ReportedFindingDistinctCountAggregates";
  /** Distinct count of auditFindingId across the matching connection */
  auditFindingId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditFindingReportId across the matching connection */
  auditFindingReportId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ReportedFinding` object types. All fields are combined with a logical ‘and.’ */
export type ReportedFindingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReportedFindingFilter>>;
  /** Filter by the object’s `auditFinding` relation. */
  auditFinding?: InputMaybe<AuditFindingFilter>;
  /** Filter by the object’s `auditFindingId` field. */
  auditFindingId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `auditFindingReport` relation. */
  auditFindingReport?: InputMaybe<AuditFindingReportFilter>;
  /** Filter by the object’s `auditFindingReportId` field. */
  auditFindingReportId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReportedFindingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReportedFindingFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `ReportedFinding` for usage during aggregation. */
export enum ReportedFindingGroupBy {
  AUDIT_FINDING_ID = "AUDIT_FINDING_ID",
  AUDIT_FINDING_REPORT_ID = "AUDIT_FINDING_REPORT_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type ReportedFindingHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReportedFindingHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ReportedFinding` aggregates. */
export type ReportedFindingHavingInput = {
  AND?: InputMaybe<Array<ReportedFindingHavingInput>>;
  OR?: InputMaybe<Array<ReportedFindingHavingInput>>;
  average?: InputMaybe<ReportedFindingHavingAverageInput>;
  distinctCount?: InputMaybe<ReportedFindingHavingDistinctCountInput>;
  max?: InputMaybe<ReportedFindingHavingMaxInput>;
  min?: InputMaybe<ReportedFindingHavingMinInput>;
  stddevPopulation?: InputMaybe<ReportedFindingHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ReportedFindingHavingStddevSampleInput>;
  sum?: InputMaybe<ReportedFindingHavingSumInput>;
  variancePopulation?: InputMaybe<ReportedFindingHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ReportedFindingHavingVarianceSampleInput>;
};

export type ReportedFindingHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReportedFindingHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReportedFindingHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReportedFindingHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReportedFindingHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReportedFindingHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReportedFindingHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `ReportedFinding` */
export type ReportedFindingInput = {
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingReportId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingReportToAuditFindingReportId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInput>;
  auditFindingToAuditFindingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ReportedFindingNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `reportedFinding` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ReportedFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `reportedFinding` to look up the row to update. */
export type ReportedFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyUsingReportedFindingPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `reportedFinding` being updated. */
    patch: updateReportedFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ReportedFindingOnReportedFindingForReportedFindingAuditFindingReportIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFindingReport` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFindingReport` being updated. */
    patch: AuditFindingReportPatch;
  };

/** The fields on `reportedFinding` to look up the row to update. */
export type ReportedFindingOnReportedFindingForReportedFindingAuditFindingReportIdFkeyUsingReportedFindingPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `reportedFinding` being updated. */
    patch: updateReportedFindingOnReportedFindingForReportedFindingAuditFindingReportIdFkeyPatch;
  };

/** Represents an update to a `ReportedFinding`. Fields that are set will be updated. */
export type ReportedFindingPatch = {
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingReportId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingReportToAuditFindingReportId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInput>;
  auditFindingToAuditFindingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInput>;
};

/** The fields on `reportedFinding` to look up the row to connect. */
export type ReportedFindingReportedFindingPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `ReportedFinding` values. */
export type ReportedFindingsConnection = {
  __typename?: "ReportedFindingsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ReportedFindingAggregates>;
  /** A list of edges which contains the `ReportedFinding` and cursor to aid in pagination. */
  edges: Array<ReportedFindingsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ReportedFindingAggregates>>;
  /** A list of `ReportedFinding` objects. */
  nodes: Array<Maybe<ReportedFinding>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReportedFinding` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ReportedFinding` values. */
export type ReportedFindingsConnectiongroupedAggregatesArgs = {
  groupBy: Array<ReportedFindingGroupBy>;
  having?: InputMaybe<ReportedFindingHavingInput>;
};

/** A `ReportedFinding` edge in the connection. */
export type ReportedFindingsEdge = {
  __typename?: "ReportedFindingsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ReportedFinding` at the end of the edge. */
  node?: Maybe<ReportedFinding>;
};

/** Methods to use when ordering `ReportedFinding`. */
export enum ReportedFindingsOrderBy {
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_DESC",
  AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_SUBTYPE_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_SUBTYPE_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_SUBTYPE_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_SUBTYPE_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_TYPE_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_TYPE_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_TYPE_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUDIT_FINDING_REPORT_TYPE_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CLAIM_FILTER_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CLAIM_FILTER_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CLAIM_FILTER_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CLAIM_FILTER_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CREATED_AT_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CREATED_AT_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CREATED_AT_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__CREATED_AT_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__INSURER_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__INSURER_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__INSURER_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__INSURER_ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ORIGINAL_VERSION_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ORIGINAL_VERSION_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ORIGINAL_VERSION_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__ORIGINAL_VERSION_ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PRIMARY_PIA_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PRIMARY_PIA_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PRIMARY_PIA_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PRIMARY_PIA_ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PROVIDER_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PROVIDER_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PROVIDER_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__PROVIDER_ID_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_URL_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_URL_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_URL_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_URL_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_VERSION_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_VERSION_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_VERSION_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__S3_VERSION_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__TITLE_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__TITLE_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__TITLE_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__TITLE_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__UPDATED_AT_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__UPDATED_AT_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__UPDATED_AT_DESC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__VIEW_ID_ASC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__VIEW_ID_ASC",
  AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__VIEW_ID_DESC = "AUDIT_FINDING_REPORT_BY_AUDIT_FINDING_REPORT_ID__VIEW_ID_DESC",
  AUDIT_FINDING_REPORT_ID_ASC = "AUDIT_FINDING_REPORT_ID_ASC",
  AUDIT_FINDING_REPORT_ID_DESC = "AUDIT_FINDING_REPORT_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

/** Input for the nested mutation of `messageSent` in the `MessageSentInput` mutation. */
export type ResponseToMessageSentIdMessageSentIdFkInput = {
  /** The primary key(s) for `messageSent` for the far side of the relationship. */
  connectById?: InputMaybe<MessageSentMessageSentPkeyConnect>;
  /** The primary key(s) for `messageSent` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MessageSentNodeIdConnect>;
  /** A `MessageSentInput` object that will be created and connected to this object. */
  create?: InputMaybe<ResponseToMessageSentIdMessageSentIdFkMessageSentCreateInput>;
  /** The primary key(s) and patch data for `messageSent` for the far side of the relationship. */
  updateById?: InputMaybe<MessageSentOnMessageSentForResponseToMessageSentIdMessageSentIdFkUsingMessageSentPkeyUpdate>;
  /** The primary key(s) and patch data for `messageSent` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MessageSentOnMessageSentForResponseToMessageSentIdMessageSentIdFkNodeIdUpdate>;
};

/** The `messageSent` to be created by this mutation. */
export type ResponseToMessageSentIdMessageSentIdFkMessageSentCreateInput = {
  auditorUserToRecipientUserId?: InputMaybe<MessageSentRecipientUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  emailTemplate?: InputMaybe<MessageSentInputEmailTemplateType>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  messageCreatedToMessageId?: InputMaybe<MessageSentMessageIdFkeyInput>;
  messageId?: InputMaybe<Scalars["UUID"]["input"]>;
  messageSentToResponseToMessageSentId?: InputMaybe<ResponseToMessageSentIdMessageSentIdFkInput>;
  messageSentToSeedMessageSentId?: InputMaybe<SeedMessageSentIdMessageSentIdFkInput>;
  recipientUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  seedMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  sendEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ReviewAuditFindingsInput = {
  auditFindingIds: Array<Scalars["UUID"]["input"]>;
  authorId: Scalars["UUID"]["input"];
  operation: ReviewAuditFindingsOperation;
};

export enum ReviewAuditFindingsOperation {
  ACCEPT = "ACCEPT",
  DECLINE = "DECLINE",
  DELETE = "DELETE",
}

export type ReviewAuditFindingsPayload = {
  __typename?: "ReviewAuditFindingsPayload";
  latestReviews: Array<ReviewedAuditFinding>;
};

/**
 * Payload for reviewAuditFindingsV2. Owns its own review-row type
 * (ReviewedAuditFindingV2) rather than the PostGraphile-generated
 * ReviewedAuditFinding so the plugin can resolve the nested
 * auditFinding field without stepping on the shared schema type.
 */
export type ReviewAuditFindingsV2Payload = {
  __typename?: "ReviewAuditFindingsV2Payload";
  latestReviews: Array<ReviewedAuditFindingV2>;
};

export type ReviewedAuditFinding = Node & {
  __typename?: "ReviewedAuditFinding";
  accepted: Scalars["Boolean"]["output"];
  /** Reads a single `AuditFinding` that is related to this `ReviewedAuditFinding`. */
  auditFinding?: Maybe<AuditFinding>;
  auditFindingId: Scalars["UUID"]["output"];
  /** Reads a single `AuditorUser` that is related to this `ReviewedAuditFinding`. */
  author?: Maybe<AuditorUser>;
  authorId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  deleted: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  rationale?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

export type ReviewedAuditFindingAggregates = {
  __typename?: "ReviewedAuditFindingAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ReviewedAuditFindingDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `ReviewedAuditFinding` object types. */
export type ReviewedAuditFindingAggregatesFilter = {
  /** Distinct count aggregate over matching `ReviewedAuditFinding` objects. */
  distinctCount?: InputMaybe<ReviewedAuditFindingDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ReviewedAuditFinding` object to be included within the aggregate. */
  filter?: InputMaybe<ReviewedAuditFindingFilter>;
};

/** The `auditFinding` to be created by this mutation. */
export type ReviewedAuditFindingAuditFindingIdFkeyAuditFindingCreateInput = {
  auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
  auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
  auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
  auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
  auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
  auditFindingSeedType: AuditFindingSeedType;
  auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
  auditType?: InputMaybe<AuditTypeEnum>;
  auditorComment?: InputMaybe<Scalars["String"]["input"]>;
  auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
  autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
  autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
  batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
  batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
  confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  improperPaymentCost: Scalars["Float"]["input"];
  improperPaymentReason: Scalars["String"]["input"];
  improperPaymentUnitsCharged: Scalars["Int"]["input"];
  metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
  metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
  metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
  metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview: Scalars["Boolean"]["input"];
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `auditFinding` in the `ReviewedAuditFindingInput` mutation. */
export type ReviewedAuditFindingAuditFindingIdFkeyInput = {
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<AuditFindingAuditFindingClaimLinePkeyConnect>;
  /** The primary key(s) for `auditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditFindingNodeIdConnect>;
  /** A `AuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyAuditFindingCreateInput>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<AuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyUsingAuditFindingClaimLinePkeyUpdate>;
  /** The primary key(s) and patch data for `auditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `reviewedAuditFinding` in the `AuditFindingInput` mutation. */
export type ReviewedAuditFindingAuditFindingIdFkeyInverseInput = {
  /** The primary key(s) for `reviewedAuditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ReviewedAuditFindingReviewedAuditFindingPkeyConnect>
  >;
  /** The primary key(s) for `reviewedAuditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ReviewedAuditFindingNodeIdConnect>>;
  /** A `ReviewedAuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ReviewedAuditFindingAuditFindingIdFkeyReviewedAuditFindingCreateInput>
  >;
  /** The primary key(s) and patch data for `reviewedAuditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyUsingReviewedAuditFindingPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `reviewedAuditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyNodeIdUpdate>
  >;
};

/** The `reviewedAuditFinding` to be created by this mutation. */
export type ReviewedAuditFindingAuditFindingIdFkeyReviewedAuditFindingCreateInput =
  {
    accepted?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditFindingToAuditFindingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    rationale?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** Input for the nested mutation of `auditorUser` in the `ReviewedAuditFindingInput` mutation. */
export type ReviewedAuditFindingAuthorIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `reviewedAuditFinding` in the `AuditorUserInput` mutation. */
export type ReviewedAuditFindingAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `reviewedAuditFinding` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ReviewedAuditFindingReviewedAuditFindingPkeyConnect>
  >;
  /** The primary key(s) for `reviewedAuditFinding` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ReviewedAuditFindingNodeIdConnect>>;
  /** A `ReviewedAuditFindingInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ReviewedAuditFindingAuthorIdFkeyReviewedAuditFindingCreateInput>
  >;
  /** The primary key(s) and patch data for `reviewedAuditFinding` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyUsingReviewedAuditFindingPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `reviewedAuditFinding` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyNodeIdUpdate>
  >;
};

/** The `reviewedAuditFinding` to be created by this mutation. */
export type ReviewedAuditFindingAuthorIdFkeyReviewedAuditFindingCreateInput = {
  accepted?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingToAuditFindingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  rationale?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/**
 * A condition to be used against `ReviewedAuditFinding` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ReviewedAuditFindingCondition = {
  /** Checks for equality with the object’s `accepted` field. */
  accepted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `auditFindingId` field. */
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `rationale` field. */
  rationale?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type ReviewedAuditFindingDistinctCountAggregateFilter = {
  accepted?: InputMaybe<BigIntFilter>;
  auditFindingId?: InputMaybe<BigIntFilter>;
  authorId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  deleted?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  rationale?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type ReviewedAuditFindingDistinctCountAggregates = {
  __typename?: "ReviewedAuditFindingDistinctCountAggregates";
  /** Distinct count of accepted across the matching connection */
  accepted?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of auditFindingId across the matching connection */
  auditFindingId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of authorId across the matching connection */
  authorId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of deleted across the matching connection */
  deleted?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of rationale across the matching connection */
  rationale?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `ReviewedAuditFinding` object types. All fields are combined with a logical ‘and.’ */
export type ReviewedAuditFindingFilter = {
  /** Filter by the object’s `accepted` field. */
  accepted?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReviewedAuditFindingFilter>>;
  /** Filter by the object’s `auditFinding` relation. */
  auditFinding?: InputMaybe<AuditFindingFilter>;
  /** Filter by the object’s `auditFindingId` field. */
  auditFindingId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `author` relation. */
  author?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `authorId` field. */
  authorId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReviewedAuditFindingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReviewedAuditFindingFilter>>;
  /** Filter by the object’s `rationale` field. */
  rationale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `ReviewedAuditFinding` for usage during aggregation. */
export enum ReviewedAuditFindingGroupBy {
  ACCEPTED = "ACCEPTED",
  AUDIT_FINDING_ID = "AUDIT_FINDING_ID",
  AUTHOR_ID = "AUTHOR_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DELETED = "DELETED",
  RATIONALE = "RATIONALE",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type ReviewedAuditFindingHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReviewedAuditFindingHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ReviewedAuditFinding` aggregates. */
export type ReviewedAuditFindingHavingInput = {
  AND?: InputMaybe<Array<ReviewedAuditFindingHavingInput>>;
  OR?: InputMaybe<Array<ReviewedAuditFindingHavingInput>>;
  average?: InputMaybe<ReviewedAuditFindingHavingAverageInput>;
  distinctCount?: InputMaybe<ReviewedAuditFindingHavingDistinctCountInput>;
  max?: InputMaybe<ReviewedAuditFindingHavingMaxInput>;
  min?: InputMaybe<ReviewedAuditFindingHavingMinInput>;
  stddevPopulation?: InputMaybe<ReviewedAuditFindingHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ReviewedAuditFindingHavingStddevSampleInput>;
  sum?: InputMaybe<ReviewedAuditFindingHavingSumInput>;
  variancePopulation?: InputMaybe<ReviewedAuditFindingHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ReviewedAuditFindingHavingVarianceSampleInput>;
};

export type ReviewedAuditFindingHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReviewedAuditFindingHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReviewedAuditFindingHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReviewedAuditFindingHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReviewedAuditFindingHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReviewedAuditFindingHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ReviewedAuditFindingHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `ReviewedAuditFinding` */
export type ReviewedAuditFindingInput = {
  accepted?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingToAuditFindingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  rationale?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ReviewedAuditFindingNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `reviewedAuditFinding` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type ReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditFinding` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditFinding` being updated. */
    patch: AuditFindingPatch;
  };

/** The fields on `reviewedAuditFinding` to look up the row to update. */
export type ReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyUsingReviewedAuditFindingPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `reviewedAuditFinding` being updated. */
    patch: updateReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type ReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `reviewedAuditFinding` to look up the row to update. */
export type ReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyUsingReviewedAuditFindingPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `reviewedAuditFinding` being updated. */
    patch: updateReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyPatch;
  };

/** Represents an update to a `ReviewedAuditFinding`. Fields that are set will be updated. */
export type ReviewedAuditFindingPatch = {
  accepted?: InputMaybe<Scalars["Boolean"]["input"]>;
  auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditFindingToAuditFindingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInput>;
  auditorUserToAuthorId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  rationale?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The fields on `reviewedAuditFinding` to look up the row to connect. */
export type ReviewedAuditFindingReviewedAuditFindingPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/**
 * A review row returned by reviewAuditFindingsV2. Mirrors the
 * scalar shape of ReviewedAuditFinding, with a flat
 * auditFindingSummary rather than the full PostGraphile
 * AuditFinding type. See AuditFindingSummary for the fields
 * exposed; callers who need the full AuditFinding should chain a
 * follow-up query on auditFindingId.
 */
export type ReviewedAuditFindingV2 = {
  __typename?: "ReviewedAuditFindingV2";
  accepted: Scalars["Boolean"]["output"];
  auditFindingId: Scalars["UUID"]["output"];
  auditFindingSummary?: Maybe<AuditFindingSummary>;
  authorId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  deleted: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  rationale?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Datetime"]["output"];
};

/** A connection to a list of `ReviewedAuditFinding` values. */
export type ReviewedAuditFindingsConnection = {
  __typename?: "ReviewedAuditFindingsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ReviewedAuditFindingAggregates>;
  /** A list of edges which contains the `ReviewedAuditFinding` and cursor to aid in pagination. */
  edges: Array<ReviewedAuditFindingsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ReviewedAuditFindingAggregates>>;
  /** A list of `ReviewedAuditFinding` objects. */
  nodes: Array<Maybe<ReviewedAuditFinding>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReviewedAuditFinding` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `ReviewedAuditFinding` values. */
export type ReviewedAuditFindingsConnectiongroupedAggregatesArgs = {
  groupBy: Array<ReviewedAuditFindingGroupBy>;
  having?: InputMaybe<ReviewedAuditFindingHavingInput>;
};

/** A `ReviewedAuditFinding` edge in the connection. */
export type ReviewedAuditFindingsEdge = {
  __typename?: "ReviewedAuditFindingsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ReviewedAuditFinding` at the end of the edge. */
  node?: Maybe<ReviewedAuditFinding>;
};

/** Methods to use when ordering `ReviewedAuditFinding`. */
export enum ReviewedAuditFindingsOrderBy {
  ACCEPTED_ASC = "ACCEPTED_ASC",
  ACCEPTED_DESC = "ACCEPTED_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUTHOR_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUTHOR_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUTHOR_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUTHOR_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUTHOR_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUTHOR_ID__USER_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_COMMENT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDITOR_REVIEWED_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_JOB_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_RULE_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_FINDING_SEED_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUDIT_TYPE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTHOR_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTODOR_FINDING_S3_KEY_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_KIND_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__AUTOMATION_SOURCE_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__BATCH_CLAIM_LINE_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CONFIDENCE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__CREATED_AT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_AT_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__DELETED_BY_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_COST_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_REASON_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__IMPROPER_PAYMENT_UNITS_CHARGED_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_AOC_PRIMARY_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_CORRECT_LEVEL_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_EM_ORIGINAL_LEVEL_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_AJUDICATION_VALUE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_MUE_OHP_MUE_VALUE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_CODE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_NCCI_PTP_MODIFIER_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_PRICING_CORRECT_PRICE_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__META_DATA_UNITS_CORRECT_UNITS_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__NEEDS_REVIEW_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__PREVIOUS_VERSION_ID_DESC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_ASC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_ASC",
  AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_DESC = "AUDIT_FINDING_BY_AUDIT_FINDING_ID__UPDATED_AT_DESC",
  AUDIT_FINDING_ID_ASC = "AUDIT_FINDING_ID_ASC",
  AUDIT_FINDING_ID_DESC = "AUDIT_FINDING_ID_DESC",
  AUTHOR_ID_ASC = "AUTHOR_ID_ASC",
  AUTHOR_ID_DESC = "AUTHOR_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DELETED_ASC = "DELETED_ASC",
  DELETED_DESC = "DELETED_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  RATIONALE_ASC = "RATIONALE_ASC",
  RATIONALE_DESC = "RATIONALE_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type RolePermissionMatrix = {
  __typename?: "RolePermissionMatrix";
  insurerId?: Maybe<Scalars["UUID"]["output"]>;
  phases: Array<RolePermissionMatrixPhase>;
  roleId: Scalars["UUID"]["output"];
  version: Scalars["Int"]["output"];
};

export type RolePermissionMatrixGrant = {
  __typename?: "RolePermissionMatrixGrant";
  action: LifecycleMatrixAction;
  granted: Scalars["Boolean"]["output"];
};

export type RolePermissionMatrixPhase = {
  __typename?: "RolePermissionMatrixPhase";
  actionStates: Array<RolePermissionMatrixPhaseActionState>;
  /** True when every stage in the phase has every matrix action granted. */
  allStagesGranted: Scalars["Boolean"]["output"];
  phaseId: Scalars["UUID"]["output"];
  phaseName: Scalars["String"]["output"];
  phaseSlug: Scalars["String"]["output"];
  stages: Array<RolePermissionMatrixStageRow>;
};

export type RolePermissionMatrixPhaseActionState = {
  __typename?: "RolePermissionMatrixPhaseActionState";
  action: LifecycleMatrixAction;
  allStagesGranted: Scalars["Boolean"]["output"];
};

export type RolePermissionMatrixStageRow = {
  __typename?: "RolePermissionMatrixStageRow";
  grants: Array<RolePermissionMatrixGrant>;
  stageId: Scalars["UUID"]["output"];
  stageName: Scalars["String"]["output"];
  stageSlug: Scalars["String"]["output"];
};

/** ##Overview cache output of the objects in alaffia-audit-documentation S3 Bucket./n/n Foreign server table (s3.audit_documentation) reading from pg data wrapper written in steampipe./n/nSteampipe code parses the S3 path convention into the columns in this table */
export type S3AuditDocumentation = Node & {
  __typename?: "S3AuditDocumentation";
  /** Reads a single `BatchClaim` that is related to this `S3AuditDocumentation`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  etag?: Maybe<Scalars["String"]["output"]>;
  filename: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `HumanProcessingRequest`. */
  humanProcessingRequests: HumanProcessingRequestsConnection;
  icn: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  isUploaded: Scalars["Boolean"]["output"];
  lastModified?: Maybe<Scalars["Datetime"]["output"]>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  originalFileId?: Maybe<Scalars["UUID"]["output"]>;
  process?: Maybe<Scalars["String"]["output"]>;
  providerId: Scalars["String"]["output"];
  s3Key: Scalars["String"]["output"];
  size: Scalars["Int"]["output"];
  subFile?: Maybe<Scalars["String"]["output"]>;
  subProcess?: Maybe<Scalars["String"]["output"]>;
  tags?: Maybe<Scalars["JSON"]["output"]>;
};

/** ##Overview cache output of the objects in alaffia-audit-documentation S3 Bucket./n/n Foreign server table (s3.audit_documentation) reading from pg data wrapper written in steampipe./n/nSteampipe code parses the S3 path convention into the columns in this table */
export type S3AuditDocumentationhumanProcessingRequestsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<HumanProcessingRequestCondition>;
  filter?: InputMaybe<HumanProcessingRequestFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<HumanProcessingRequestsOrderBy>>;
};

export type S3AuditDocumentationAggregates = {
  __typename?: "S3AuditDocumentationAggregates";
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<S3AuditDocumentationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<S3AuditDocumentationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<S3AuditDocumentationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<S3AuditDocumentationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<S3AuditDocumentationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<S3AuditDocumentationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<S3AuditDocumentationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<S3AuditDocumentationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<S3AuditDocumentationVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `S3AuditDocumentation` object types. */
export type S3AuditDocumentationAggregatesFilter = {
  /** Mean average aggregate over matching `S3AuditDocumentation` objects. */
  average?: InputMaybe<S3AuditDocumentationAverageAggregateFilter>;
  /** Distinct count aggregate over matching `S3AuditDocumentation` objects. */
  distinctCount?: InputMaybe<S3AuditDocumentationDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `S3AuditDocumentation` object to be included within the aggregate. */
  filter?: InputMaybe<S3AuditDocumentationFilter>;
  /** Maximum aggregate over matching `S3AuditDocumentation` objects. */
  max?: InputMaybe<S3AuditDocumentationMaxAggregateFilter>;
  /** Minimum aggregate over matching `S3AuditDocumentation` objects. */
  min?: InputMaybe<S3AuditDocumentationMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `S3AuditDocumentation` objects. */
  stddevPopulation?: InputMaybe<S3AuditDocumentationStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `S3AuditDocumentation` objects. */
  stddevSample?: InputMaybe<S3AuditDocumentationStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `S3AuditDocumentation` objects. */
  sum?: InputMaybe<S3AuditDocumentationSumAggregateFilter>;
  /** Population variance aggregate over matching `S3AuditDocumentation` objects. */
  variancePopulation?: InputMaybe<S3AuditDocumentationVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `S3AuditDocumentation` objects. */
  varianceSample?: InputMaybe<S3AuditDocumentationVarianceSampleAggregateFilter>;
};

export type S3AuditDocumentationAverageAggregateFilter = {
  size?: InputMaybe<BigFloatFilter>;
};

export type S3AuditDocumentationAverageAggregates = {
  __typename?: "S3AuditDocumentationAverageAggregates";
  /** Mean average of size across the matching connection */
  size?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** Input for the nested mutation of `batchClaim` in the `S3AuditDocumentationInput` mutation. */
export type S3AuditDocumentationBatchClaimIdFkeyInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<S3AuditDocumentationOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `s3AuditDocumentation` in the `BatchClaimInput` mutation. */
export type S3AuditDocumentationBatchClaimIdFkeyInverseInput = {
  /** The primary key(s) for `s3AuditDocumentation` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<S3AuditDocumentationS3AuditDocumentationPkeyConnect>
  >;
  /** The primary key(s) for `s3AuditDocumentation` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<S3AuditDocumentationNodeIdConnect>>;
  /** A `S3AuditDocumentationInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<S3AuditDocumentationBatchClaimIdFkeyS3AuditDocumentationCreateInput>
  >;
  /** The primary key(s) and patch data for `s3AuditDocumentation` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<S3AuditDocumentationOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyUsingS3AuditDocumentationPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `s3AuditDocumentation` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyNodeIdUpdate>
  >;
};

/** The `s3AuditDocumentation` to be created by this mutation. */
export type S3AuditDocumentationBatchClaimIdFkeyS3AuditDocumentationCreateInput =
  {
    batchClaimToBatchClaimId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInput>;
    etag?: InputMaybe<Scalars["String"]["input"]>;
    filename: Scalars["String"]["input"];
    humanProcessingRequestsUsingId?: InputMaybe<HumanProcessingRequestS3AuditDocumentationIdFkeyInverseInput>;
    icn: Scalars["String"]["input"];
    id: Scalars["UUID"]["input"];
    isUploaded?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastModified?: InputMaybe<Scalars["Datetime"]["input"]>;
    originalFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    process?: InputMaybe<Scalars["String"]["input"]>;
    providerId: Scalars["String"]["input"];
    s3Key: Scalars["String"]["input"];
    size: Scalars["Int"]["input"];
    subFile?: InputMaybe<Scalars["String"]["input"]>;
    subProcess?: InputMaybe<Scalars["String"]["input"]>;
    tags?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/**
 * A condition to be used against `S3AuditDocumentation` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type S3AuditDocumentationCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `etag` field. */
  etag?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `filename` field. */
  filename?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `icn` field. */
  icn?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `isUploaded` field. */
  isUploaded?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `lastModified` field. */
  lastModified?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `originalFileId` field. */
  originalFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `process` field. */
  process?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `s3Key` field. */
  s3Key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `size` field. */
  size?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `subFile` field. */
  subFile?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `subProcess` field. */
  subProcess?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type S3AuditDocumentationDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  etag?: InputMaybe<BigIntFilter>;
  filename?: InputMaybe<BigIntFilter>;
  icn?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isUploaded?: InputMaybe<BigIntFilter>;
  lastModified?: InputMaybe<BigIntFilter>;
  originalFileId?: InputMaybe<BigIntFilter>;
  process?: InputMaybe<BigIntFilter>;
  providerId?: InputMaybe<BigIntFilter>;
  s3Key?: InputMaybe<BigIntFilter>;
  size?: InputMaybe<BigIntFilter>;
  subFile?: InputMaybe<BigIntFilter>;
  subProcess?: InputMaybe<BigIntFilter>;
  tags?: InputMaybe<BigIntFilter>;
};

export type S3AuditDocumentationDistinctCountAggregates = {
  __typename?: "S3AuditDocumentationDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of etag across the matching connection */
  etag?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of filename across the matching connection */
  filename?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of icn across the matching connection */
  icn?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of isUploaded across the matching connection */
  isUploaded?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of lastModified across the matching connection */
  lastModified?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of originalFileId across the matching connection */
  originalFileId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of process across the matching connection */
  process?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of providerId across the matching connection */
  providerId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of s3Key across the matching connection */
  s3Key?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of size across the matching connection */
  size?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of subFile across the matching connection */
  subFile?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of subProcess across the matching connection */
  subProcess?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of tags across the matching connection */
  tags?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `S3AuditDocumentation` object types. All fields are combined with a logical ‘and.’ */
export type S3AuditDocumentationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<S3AuditDocumentationFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `etag` field. */
  etag?: InputMaybe<StringFilter>;
  /** Filter by the object’s `filename` field. */
  filename?: InputMaybe<StringFilter>;
  /** Filter by the object’s `humanProcessingRequests` relation. */
  humanProcessingRequests?: InputMaybe<S3AuditDocumentationToManyHumanProcessingRequestFilter>;
  /** Some related `humanProcessingRequests` exist. */
  humanProcessingRequestsExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `icn` field. */
  icn?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `isUploaded` field. */
  isUploaded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastModified` field. */
  lastModified?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<S3AuditDocumentationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<S3AuditDocumentationFilter>>;
  /** Filter by the object’s `originalFileId` field. */
  originalFileId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `process` field. */
  process?: InputMaybe<StringFilter>;
  /** Filter by the object’s `providerId` field. */
  providerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `s3Key` field. */
  s3Key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `size` field. */
  size?: InputMaybe<IntFilter>;
  /** Filter by the object’s `subFile` field. */
  subFile?: InputMaybe<StringFilter>;
  /** Filter by the object’s `subProcess` field. */
  subProcess?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tags` field. */
  tags?: InputMaybe<JSONFilter>;
};

/** Grouping methods for `S3AuditDocumentation` for usage during aggregation. */
export enum S3AuditDocumentationGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  ETAG = "ETAG",
  FILENAME = "FILENAME",
  ICN = "ICN",
  IS_UPLOADED = "IS_UPLOADED",
  LAST_MODIFIED = "LAST_MODIFIED",
  LAST_MODIFIED_TRUNCATED_TO_DAY = "LAST_MODIFIED_TRUNCATED_TO_DAY",
  LAST_MODIFIED_TRUNCATED_TO_HOUR = "LAST_MODIFIED_TRUNCATED_TO_HOUR",
  ORIGINAL_FILE_ID = "ORIGINAL_FILE_ID",
  PROCESS = "PROCESS",
  PROVIDER_ID = "PROVIDER_ID",
  S3_KEY = "S3_KEY",
  SIZE = "SIZE",
  SUB_FILE = "SUB_FILE",
  SUB_PROCESS = "SUB_PROCESS",
  TAGS = "TAGS",
}

export type S3AuditDocumentationHavingAverageInput = {
  lastModified?: InputMaybe<HavingDatetimeFilter>;
  size?: InputMaybe<HavingIntFilter>;
};

export type S3AuditDocumentationHavingDistinctCountInput = {
  lastModified?: InputMaybe<HavingDatetimeFilter>;
  size?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `S3AuditDocumentation` aggregates. */
export type S3AuditDocumentationHavingInput = {
  AND?: InputMaybe<Array<S3AuditDocumentationHavingInput>>;
  OR?: InputMaybe<Array<S3AuditDocumentationHavingInput>>;
  average?: InputMaybe<S3AuditDocumentationHavingAverageInput>;
  distinctCount?: InputMaybe<S3AuditDocumentationHavingDistinctCountInput>;
  max?: InputMaybe<S3AuditDocumentationHavingMaxInput>;
  min?: InputMaybe<S3AuditDocumentationHavingMinInput>;
  stddevPopulation?: InputMaybe<S3AuditDocumentationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<S3AuditDocumentationHavingStddevSampleInput>;
  sum?: InputMaybe<S3AuditDocumentationHavingSumInput>;
  variancePopulation?: InputMaybe<S3AuditDocumentationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<S3AuditDocumentationHavingVarianceSampleInput>;
};

export type S3AuditDocumentationHavingMaxInput = {
  lastModified?: InputMaybe<HavingDatetimeFilter>;
  size?: InputMaybe<HavingIntFilter>;
};

export type S3AuditDocumentationHavingMinInput = {
  lastModified?: InputMaybe<HavingDatetimeFilter>;
  size?: InputMaybe<HavingIntFilter>;
};

export type S3AuditDocumentationHavingStddevPopulationInput = {
  lastModified?: InputMaybe<HavingDatetimeFilter>;
  size?: InputMaybe<HavingIntFilter>;
};

export type S3AuditDocumentationHavingStddevSampleInput = {
  lastModified?: InputMaybe<HavingDatetimeFilter>;
  size?: InputMaybe<HavingIntFilter>;
};

export type S3AuditDocumentationHavingSumInput = {
  lastModified?: InputMaybe<HavingDatetimeFilter>;
  size?: InputMaybe<HavingIntFilter>;
};

export type S3AuditDocumentationHavingVariancePopulationInput = {
  lastModified?: InputMaybe<HavingDatetimeFilter>;
  size?: InputMaybe<HavingIntFilter>;
};

export type S3AuditDocumentationHavingVarianceSampleInput = {
  lastModified?: InputMaybe<HavingDatetimeFilter>;
  size?: InputMaybe<HavingIntFilter>;
};

/** An input for mutations affecting `S3AuditDocumentation` */
export type S3AuditDocumentationInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInput>;
  etag?: InputMaybe<Scalars["String"]["input"]>;
  filename: Scalars["String"]["input"];
  humanProcessingRequestsUsingId?: InputMaybe<HumanProcessingRequestS3AuditDocumentationIdFkeyInverseInput>;
  icn: Scalars["String"]["input"];
  id: Scalars["UUID"]["input"];
  isUploaded?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastModified?: InputMaybe<Scalars["Datetime"]["input"]>;
  originalFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  process?: InputMaybe<Scalars["String"]["input"]>;
  providerId: Scalars["String"]["input"];
  s3Key: Scalars["String"]["input"];
  size: Scalars["Int"]["input"];
  subFile?: InputMaybe<Scalars["String"]["input"]>;
  subProcess?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type S3AuditDocumentationMaxAggregateFilter = {
  size?: InputMaybe<IntFilter>;
};

export type S3AuditDocumentationMaxAggregates = {
  __typename?: "S3AuditDocumentationMaxAggregates";
  /** Maximum of size across the matching connection */
  size?: Maybe<Scalars["Int"]["output"]>;
};

export type S3AuditDocumentationMinAggregateFilter = {
  size?: InputMaybe<IntFilter>;
};

export type S3AuditDocumentationMinAggregates = {
  __typename?: "S3AuditDocumentationMinAggregates";
  /** Minimum of size across the matching connection */
  size?: Maybe<Scalars["Int"]["output"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type S3AuditDocumentationNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `s3AuditDocumentation` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type S3AuditDocumentationOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `humanProcessingRequest` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `humanProcessingRequest` being updated. */
    patch: HumanProcessingRequestPatch;
  };

/** The fields on `s3AuditDocumentation` to look up the row to update. */
export type S3AuditDocumentationOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyUsingS3AuditDocumentationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `s3AuditDocumentation` being updated. */
    patch: updateS3AuditDocumentationOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type S3AuditDocumentationOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `s3AuditDocumentation` to look up the row to update. */
export type S3AuditDocumentationOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyUsingS3AuditDocumentationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `s3AuditDocumentation` being updated. */
    patch: updateS3AuditDocumentationOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyPatch;
  };

/** Represents an update to a `S3AuditDocumentation`. Fields that are set will be updated. */
export type S3AuditDocumentationPatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInput>;
  etag?: InputMaybe<Scalars["String"]["input"]>;
  filename?: InputMaybe<Scalars["String"]["input"]>;
  humanProcessingRequestsUsingId?: InputMaybe<HumanProcessingRequestS3AuditDocumentationIdFkeyInverseInput>;
  icn?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isUploaded?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastModified?: InputMaybe<Scalars["Datetime"]["input"]>;
  originalFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  process?: InputMaybe<Scalars["String"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  s3Key?: InputMaybe<Scalars["String"]["input"]>;
  size?: InputMaybe<Scalars["Int"]["input"]>;
  subFile?: InputMaybe<Scalars["String"]["input"]>;
  subProcess?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Scalars["JSON"]["input"]>;
};

/** The fields on `s3AuditDocumentation` to look up the row to connect. */
export type S3AuditDocumentationS3AuditDocumentationPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

export type S3AuditDocumentationStddevPopulationAggregateFilter = {
  size?: InputMaybe<BigFloatFilter>;
};

export type S3AuditDocumentationStddevPopulationAggregates = {
  __typename?: "S3AuditDocumentationStddevPopulationAggregates";
  /** Population standard deviation of size across the matching connection */
  size?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type S3AuditDocumentationStddevSampleAggregateFilter = {
  size?: InputMaybe<BigFloatFilter>;
};

export type S3AuditDocumentationStddevSampleAggregates = {
  __typename?: "S3AuditDocumentationStddevSampleAggregates";
  /** Sample standard deviation of size across the matching connection */
  size?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type S3AuditDocumentationSumAggregateFilter = {
  size?: InputMaybe<BigIntFilter>;
};

export type S3AuditDocumentationSumAggregates = {
  __typename?: "S3AuditDocumentationSumAggregates";
  /** Sum of size across the matching connection */
  size: Scalars["BigInt"]["output"];
};

/** A filter to be used against many `HumanProcessingRequest` object types. All fields are combined with a logical ‘and.’ */
export type S3AuditDocumentationToManyHumanProcessingRequestFilter = {
  /** Aggregates across related `HumanProcessingRequest` match the filter criteria. */
  aggregates?: InputMaybe<HumanProcessingRequestAggregatesFilter>;
  /** Every related `HumanProcessingRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<HumanProcessingRequestFilter>;
  /** No related `HumanProcessingRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<HumanProcessingRequestFilter>;
  /** Some related `HumanProcessingRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<HumanProcessingRequestFilter>;
};

export type S3AuditDocumentationVariancePopulationAggregateFilter = {
  size?: InputMaybe<BigFloatFilter>;
};

export type S3AuditDocumentationVariancePopulationAggregates = {
  __typename?: "S3AuditDocumentationVariancePopulationAggregates";
  /** Population variance of size across the matching connection */
  size?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type S3AuditDocumentationVarianceSampleAggregateFilter = {
  size?: InputMaybe<BigFloatFilter>;
};

export type S3AuditDocumentationVarianceSampleAggregates = {
  __typename?: "S3AuditDocumentationVarianceSampleAggregates";
  /** Sample variance of size across the matching connection */
  size?: Maybe<Scalars["BigFloat"]["output"]>;
};

/** A connection to a list of `S3AuditDocumentation` values. */
export type S3AuditDocumentationsConnection = {
  __typename?: "S3AuditDocumentationsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<S3AuditDocumentationAggregates>;
  /** A list of edges which contains the `S3AuditDocumentation` and cursor to aid in pagination. */
  edges: Array<S3AuditDocumentationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<S3AuditDocumentationAggregates>>;
  /** A list of `S3AuditDocumentation` objects. */
  nodes: Array<Maybe<S3AuditDocumentation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `S3AuditDocumentation` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `S3AuditDocumentation` values. */
export type S3AuditDocumentationsConnectiongroupedAggregatesArgs = {
  groupBy: Array<S3AuditDocumentationGroupBy>;
  having?: InputMaybe<S3AuditDocumentationHavingInput>;
};

/** A `S3AuditDocumentation` edge in the connection. */
export type S3AuditDocumentationsEdge = {
  __typename?: "S3AuditDocumentationsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `S3AuditDocumentation` at the end of the edge. */
  node?: Maybe<S3AuditDocumentation>;
};

/** Methods to use when ordering `S3AuditDocumentation`. */
export enum S3AuditDocumentationsOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  ETAG_ASC = "ETAG_ASC",
  ETAG_DESC = "ETAG_DESC",
  FILENAME_ASC = "FILENAME_ASC",
  FILENAME_DESC = "FILENAME_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_CREATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_CREATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_CREATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_CREATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_ERROR_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_ERROR_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_ERROR_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_ERROR_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_EXTRA_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_EXTRA_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_EXTRA_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_EXTRA_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_ID_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_ID_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_PRIORITY_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_PRIORITY_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_PRIORITY_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_PRIORITY_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_PULLED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_PULLED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_PULLED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_PULLED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_REQUEST_TYPE_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_REQUEST_TYPE_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_REQUEST_TYPE_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_REQUEST_TYPE_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_REQUEUED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_REQUEUED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_REQUEUED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_REQUEUED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_RUN_ID_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_RUN_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_RUN_ID_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_RUN_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_S3_AUDIT_DOCUMENTATION_ID_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_S3_AUDIT_DOCUMENTATION_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_S3_AUDIT_DOCUMENTATION_ID_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_S3_AUDIT_DOCUMENTATION_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_STATUS_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_STATUS_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_STATUS_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_STATUS_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_SUCCESS_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_SUCCESS_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_SUCCESS_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_SUCCESS_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_UPDATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_UPDATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_UPDATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_UPDATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_USERNAME_ASC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_USERNAME_ASC",
  HUMAN_PROCESSING_REQUESTS_AVERAGE_USERNAME_DESC = "HUMAN_PROCESSING_REQUESTS_AVERAGE_USERNAME_DESC",
  HUMAN_PROCESSING_REQUESTS_BY_S3_AUDIT_DOCUMENTATION_ID__COUNT_ASC = "HUMAN_PROCESSING_REQUESTS_BY_S3_AUDIT_DOCUMENTATION_ID__COUNT_ASC",
  HUMAN_PROCESSING_REQUESTS_BY_S3_AUDIT_DOCUMENTATION_ID__COUNT_DESC = "HUMAN_PROCESSING_REQUESTS_BY_S3_AUDIT_DOCUMENTATION_ID__COUNT_DESC",
  HUMAN_PROCESSING_REQUESTS_COUNT_ASC = "HUMAN_PROCESSING_REQUESTS_COUNT_ASC",
  HUMAN_PROCESSING_REQUESTS_COUNT_DESC = "HUMAN_PROCESSING_REQUESTS_COUNT_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_CREATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_CREATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_CREATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_CREATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_ERROR_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_ERROR_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_ERROR_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_ERROR_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_EXTRA_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_EXTRA_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_EXTRA_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_EXTRA_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_ID_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_ID_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_PRIORITY_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_PRIORITY_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_PRIORITY_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_PRIORITY_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_PULLED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_PULLED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_PULLED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_PULLED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_REQUEST_TYPE_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_REQUEST_TYPE_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_REQUEST_TYPE_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_REQUEST_TYPE_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_REQUEUED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_REQUEUED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_REQUEUED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_REQUEUED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_RUN_ID_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_RUN_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_RUN_ID_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_RUN_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_S3_AUDIT_DOCUMENTATION_ID_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_S3_AUDIT_DOCUMENTATION_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_S3_AUDIT_DOCUMENTATION_ID_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_S3_AUDIT_DOCUMENTATION_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_STATUS_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_STATUS_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_STATUS_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_STATUS_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_SUCCESS_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_SUCCESS_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_SUCCESS_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_SUCCESS_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_UPDATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_UPDATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_UPDATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_UPDATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_USERNAME_ASC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_USERNAME_ASC",
  HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_USERNAME_DESC = "HUMAN_PROCESSING_REQUESTS_DISTINCT_COUNT_USERNAME_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_CREATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_CREATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_CREATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_CREATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_ERROR_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_ERROR_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_ERROR_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_ERROR_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_EXTRA_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_EXTRA_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_EXTRA_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_EXTRA_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_ID_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_ID_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_PRIORITY_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_PRIORITY_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_PRIORITY_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_PRIORITY_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_PULLED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_PULLED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_PULLED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_PULLED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_REQUEST_TYPE_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_REQUEST_TYPE_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_REQUEST_TYPE_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_REQUEST_TYPE_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_REQUEUED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_REQUEUED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_REQUEUED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_REQUEUED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_RUN_ID_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_RUN_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_RUN_ID_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_RUN_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_S3_AUDIT_DOCUMENTATION_ID_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_S3_AUDIT_DOCUMENTATION_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_S3_AUDIT_DOCUMENTATION_ID_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_S3_AUDIT_DOCUMENTATION_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_STATUS_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_STATUS_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_STATUS_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_STATUS_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_SUCCESS_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_SUCCESS_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_SUCCESS_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_SUCCESS_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_UPDATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_UPDATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_UPDATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_UPDATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_MAX_USERNAME_ASC = "HUMAN_PROCESSING_REQUESTS_MAX_USERNAME_ASC",
  HUMAN_PROCESSING_REQUESTS_MAX_USERNAME_DESC = "HUMAN_PROCESSING_REQUESTS_MAX_USERNAME_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_CREATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_CREATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_CREATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_CREATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_ERROR_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_ERROR_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_ERROR_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_ERROR_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_EXTRA_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_EXTRA_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_EXTRA_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_EXTRA_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_ID_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_ID_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_PRIORITY_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_PRIORITY_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_PRIORITY_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_PRIORITY_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_PULLED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_PULLED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_PULLED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_PULLED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_REQUEST_TYPE_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_REQUEST_TYPE_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_REQUEST_TYPE_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_REQUEST_TYPE_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_REQUEUED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_REQUEUED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_REQUEUED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_REQUEUED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_RUN_ID_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_RUN_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_RUN_ID_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_RUN_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_S3_AUDIT_DOCUMENTATION_ID_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_S3_AUDIT_DOCUMENTATION_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_S3_AUDIT_DOCUMENTATION_ID_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_S3_AUDIT_DOCUMENTATION_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_STATUS_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_STATUS_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_STATUS_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_STATUS_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_SUCCESS_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_SUCCESS_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_SUCCESS_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_SUCCESS_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_UPDATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_UPDATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_UPDATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_UPDATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_MIN_USERNAME_ASC = "HUMAN_PROCESSING_REQUESTS_MIN_USERNAME_ASC",
  HUMAN_PROCESSING_REQUESTS_MIN_USERNAME_DESC = "HUMAN_PROCESSING_REQUESTS_MIN_USERNAME_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_CREATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_CREATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_CREATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_CREATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_ERROR_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_ERROR_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_ERROR_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_ERROR_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_EXTRA_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_EXTRA_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_EXTRA_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_EXTRA_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_ID_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_ID_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_PRIORITY_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_PRIORITY_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_PRIORITY_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_PRIORITY_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_PULLED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_PULLED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_PULLED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_PULLED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_REQUEST_TYPE_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_REQUEST_TYPE_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_REQUEST_TYPE_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_REQUEST_TYPE_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_REQUEUED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_REQUEUED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_REQUEUED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_REQUEUED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_RUN_ID_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_RUN_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_RUN_ID_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_RUN_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_S3_AUDIT_DOCUMENTATION_ID_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_S3_AUDIT_DOCUMENTATION_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_S3_AUDIT_DOCUMENTATION_ID_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_S3_AUDIT_DOCUMENTATION_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_STATUS_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_STATUS_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_STATUS_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_STATUS_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_SUCCESS_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_SUCCESS_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_SUCCESS_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_SUCCESS_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_UPDATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_UPDATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_UPDATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_UPDATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_USERNAME_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_USERNAME_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_USERNAME_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_POPULATION_USERNAME_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_CREATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_CREATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_CREATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_CREATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_ERROR_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_ERROR_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_ERROR_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_ERROR_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_EXTRA_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_EXTRA_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_EXTRA_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_EXTRA_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_ID_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_ID_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_PRIORITY_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_PRIORITY_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_PRIORITY_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_PRIORITY_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_PULLED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_PULLED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_PULLED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_PULLED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_REQUEST_TYPE_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_REQUEST_TYPE_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_REQUEST_TYPE_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_REQUEST_TYPE_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_REQUEUED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_REQUEUED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_REQUEUED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_REQUEUED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_RUN_ID_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_RUN_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_RUN_ID_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_RUN_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_S3_AUDIT_DOCUMENTATION_ID_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_S3_AUDIT_DOCUMENTATION_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_S3_AUDIT_DOCUMENTATION_ID_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_S3_AUDIT_DOCUMENTATION_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_STATUS_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_STATUS_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_STATUS_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_STATUS_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_SUCCESS_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_SUCCESS_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_SUCCESS_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_SUCCESS_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_UPDATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_UPDATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_UPDATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_UPDATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_USERNAME_ASC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_USERNAME_ASC",
  HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_USERNAME_DESC = "HUMAN_PROCESSING_REQUESTS_STDDEV_SAMPLE_USERNAME_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_CREATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_CREATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_CREATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_CREATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_ERROR_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_ERROR_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_ERROR_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_ERROR_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_EXTRA_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_EXTRA_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_EXTRA_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_EXTRA_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_ID_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_ID_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_PRIORITY_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_PRIORITY_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_PRIORITY_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_PRIORITY_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_PULLED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_PULLED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_PULLED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_PULLED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_REQUEST_TYPE_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_REQUEST_TYPE_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_REQUEST_TYPE_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_REQUEST_TYPE_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_REQUEUED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_REQUEUED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_REQUEUED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_REQUEUED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_RUN_ID_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_RUN_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_RUN_ID_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_RUN_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_S3_AUDIT_DOCUMENTATION_ID_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_S3_AUDIT_DOCUMENTATION_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_S3_AUDIT_DOCUMENTATION_ID_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_S3_AUDIT_DOCUMENTATION_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_STATUS_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_STATUS_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_STATUS_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_STATUS_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_SUCCESS_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_SUCCESS_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_SUCCESS_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_SUCCESS_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_UPDATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_UPDATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_UPDATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_UPDATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_SUM_USERNAME_ASC = "HUMAN_PROCESSING_REQUESTS_SUM_USERNAME_ASC",
  HUMAN_PROCESSING_REQUESTS_SUM_USERNAME_DESC = "HUMAN_PROCESSING_REQUESTS_SUM_USERNAME_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_CREATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_CREATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_CREATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_CREATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_ERROR_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_ERROR_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_ERROR_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_ERROR_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_EXTRA_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_EXTRA_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_EXTRA_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_EXTRA_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_ID_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_ID_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_PRIORITY_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_PRIORITY_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_PRIORITY_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_PRIORITY_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_PULLED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_PULLED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_PULLED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_PULLED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_REQUEST_TYPE_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_REQUEST_TYPE_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_REQUEST_TYPE_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_REQUEST_TYPE_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_REQUEUED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_REQUEUED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_REQUEUED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_REQUEUED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_RUN_ID_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_RUN_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_RUN_ID_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_RUN_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_S3_AUDIT_DOCUMENTATION_ID_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_S3_AUDIT_DOCUMENTATION_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_S3_AUDIT_DOCUMENTATION_ID_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_S3_AUDIT_DOCUMENTATION_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_STATUS_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_STATUS_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_STATUS_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_STATUS_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_SUCCESS_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_SUCCESS_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_SUCCESS_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_SUCCESS_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_UPDATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_UPDATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_UPDATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_UPDATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_USERNAME_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_USERNAME_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_USERNAME_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_POPULATION_USERNAME_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_CREATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_CREATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_CREATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_CREATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_ERROR_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_ERROR_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_ERROR_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_ERROR_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_EXTRA_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_EXTRA_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_EXTRA_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_EXTRA_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_ID_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_ID_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_PRIORITY_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_PRIORITY_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_PRIORITY_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_PRIORITY_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_PULLED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_PULLED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_PULLED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_PULLED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_REQUEST_TYPE_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_REQUEST_TYPE_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_REQUEST_TYPE_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_REQUEST_TYPE_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_REQUEUED_DATES_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_REQUEUED_DATES_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_REQUEUED_DATES_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_REQUEUED_DATES_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_RUN_ID_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_RUN_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_RUN_ID_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_RUN_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_S3_AUDIT_DOCUMENTATION_ID_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_S3_AUDIT_DOCUMENTATION_ID_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_S3_AUDIT_DOCUMENTATION_ID_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_S3_AUDIT_DOCUMENTATION_ID_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_STATUS_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_STATUS_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_STATUS_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_STATUS_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_SUCCESS_DETAILS_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_SUCCESS_DETAILS_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_SUCCESS_DETAILS_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_SUCCESS_DETAILS_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_UPDATED_AT_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_UPDATED_AT_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_UPDATED_AT_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_UPDATED_AT_DESC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_USERNAME_ASC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_USERNAME_ASC",
  HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_USERNAME_DESC = "HUMAN_PROCESSING_REQUESTS_VARIANCE_SAMPLE_USERNAME_DESC",
  ICN_ASC = "ICN_ASC",
  ICN_DESC = "ICN_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  IS_UPLOADED_ASC = "IS_UPLOADED_ASC",
  IS_UPLOADED_DESC = "IS_UPLOADED_DESC",
  LAST_MODIFIED_ASC = "LAST_MODIFIED_ASC",
  LAST_MODIFIED_DESC = "LAST_MODIFIED_DESC",
  NATURAL = "NATURAL",
  ORIGINAL_FILE_ID_ASC = "ORIGINAL_FILE_ID_ASC",
  ORIGINAL_FILE_ID_DESC = "ORIGINAL_FILE_ID_DESC",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  PROCESS_ASC = "PROCESS_ASC",
  PROCESS_DESC = "PROCESS_DESC",
  PROVIDER_ID_ASC = "PROVIDER_ID_ASC",
  PROVIDER_ID_DESC = "PROVIDER_ID_DESC",
  S3_KEY_ASC = "S3_KEY_ASC",
  S3_KEY_DESC = "S3_KEY_DESC",
  SIZE_ASC = "SIZE_ASC",
  SIZE_DESC = "SIZE_DESC",
  SUB_FILE_ASC = "SUB_FILE_ASC",
  SUB_FILE_DESC = "SUB_FILE_DESC",
  SUB_PROCESS_ASC = "SUB_PROCESS_ASC",
  SUB_PROCESS_DESC = "SUB_PROCESS_DESC",
  TAGS_ASC = "TAGS_ASC",
  TAGS_DESC = "TAGS_DESC",
}

export type S3CreateObjectHandlerResponse = {
  __typename?: "S3CreateObjectHandlerResponse";
  documentUploadNotification?: Maybe<NotificationResponse>;
  error?: Maybe<Scalars["String"]["output"]>;
  icn?: Maybe<Scalars["String"]["output"]>;
  providerId?: Maybe<Scalars["String"]["output"]>;
  s3Key: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type S3DataImportInput = {
  columnMap: Scalars["String"]["input"];
  isTest?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind: S3DataImportKind;
  prefix: Scalars["String"]["input"];
};

export enum S3DataImportKind {
  CLAIM = "CLAIM",
  MUE = "MUE",
  PTP = "PTP",
}

export type SaveCasesAsQueueInput = {
  caseIds: Array<Scalars["ID"]["input"]>;
  queueName: Scalars["String"]["input"];
};

export type SaveClaimRoleAssignmentsConflict = {
  __typename?: "SaveClaimRoleAssignmentsConflict";
  current: ClaimRoleAssignments;
  message: Scalars["String"]["output"];
};

export type SaveClaimRoleAssignmentsInput = {
  assignments: Array<ClaimRoleAssignmentInput>;
  /** Insurer is derived from this claim; do not pass insurerId. */
  claimId: Scalars["UUID"]["input"];
  expectedUpdatedAt: Scalars["Datetime"]["input"];
};

export type SaveClaimRoleAssignmentsPayload = {
  __typename?: "SaveClaimRoleAssignmentsPayload";
  claimRoleAssignments: ClaimRoleAssignments;
};

export type SaveClaimRoleAssignmentsResult =
  | SaveClaimRoleAssignmentsConflict
  | SaveClaimRoleAssignmentsPayload;

export type SaveRolePermissionMatrixGrantInput = {
  action: LifecycleMatrixAction;
  stageKeywordId: Scalars["UUID"]["input"];
};

export type SaveRolePermissionMatrixInput = {
  grants: Array<SaveRolePermissionMatrixGrantInput>;
  roleId: Scalars["UUID"]["input"];
  version: Scalars["Int"]["input"];
};

export type ScheduleAgentFlowRunInput = {
  caseId: Scalars["UUID"]["input"];
  documentIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  taskToRun: Scalars["String"]["input"];
};

export type SearchResult = {
  __typename?: "SearchResult";
  confidence: Scalars["Float"]["output"];
  fileId: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  pageNumber: Scalars["Int"]["output"];
  results: Scalars["Int"]["output"];
  textMatched: Scalars["String"]["output"];
};

/** Input for the nested mutation of `messageSent` in the `MessageSentInput` mutation. */
export type SeedMessageSentIdMessageSentIdFkInput = {
  /** The primary key(s) for `messageSent` for the far side of the relationship. */
  connectById?: InputMaybe<MessageSentMessageSentPkeyConnect>;
  /** The primary key(s) for `messageSent` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MessageSentNodeIdConnect>;
  /** A `MessageSentInput` object that will be created and connected to this object. */
  create?: InputMaybe<SeedMessageSentIdMessageSentIdFkMessageSentCreateInput>;
  /** The primary key(s) and patch data for `messageSent` for the far side of the relationship. */
  updateById?: InputMaybe<MessageSentOnMessageSentForSeedMessageSentIdMessageSentIdFkUsingMessageSentPkeyUpdate>;
  /** The primary key(s) and patch data for `messageSent` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MessageSentOnMessageSentForSeedMessageSentIdMessageSentIdFkNodeIdUpdate>;
};

/** The `messageSent` to be created by this mutation. */
export type SeedMessageSentIdMessageSentIdFkMessageSentCreateInput = {
  auditorUserToRecipientUserId?: InputMaybe<MessageSentRecipientUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  emailTemplate?: InputMaybe<MessageSentInputEmailTemplateType>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  messageCreatedToMessageId?: InputMaybe<MessageSentMessageIdFkeyInput>;
  messageId?: InputMaybe<Scalars["UUID"]["input"]>;
  messageSentToResponseToMessageSentId?: InputMaybe<ResponseToMessageSentIdMessageSentIdFkInput>;
  messageSentToSeedMessageSentId?: InputMaybe<SeedMessageSentIdMessageSentIdFkInput>;
  recipientUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  responseToMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  sendEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SeedType {
  IB_CLAIM_LINE = "IB_CLAIM_LINE",
  UB_CLAIM_LINE = "UB_CLAIM_LINE",
}

export type SendDocumentUploadNoficationInput = {
  documentUploadCreatedId: Scalars["UUID"]["input"];
  documentUploadKind: DocumentUploadKind;
  senderUserId: Scalars["UUID"]["input"];
};

export type SendUserOnboardNotificationInput = {
  emailTemplate: MessageSentInputEmailTemplateType;
  userId: Scalars["UUID"]["input"];
};

/** All input for the `setAssignees` mutation. */
export type SetAssigneesInput = {
  auditorUserId: Scalars["UUID"]["input"];
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  unassigned?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The output of our `setAssignees` mutation. */
export type SetAssigneesPayload = {
  __typename?: "SetAssigneesPayload";
  batchClaimAssignees?: Maybe<Array<Maybe<BatchClaimAssignee>>>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setAuditStartDates` mutation. */
export type SetAuditStartDatesInput = {
  auditStartDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  batchClaimIds?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our `setAuditStartDates` mutation. */
export type SetAuditStartDatesPayload = {
  __typename?: "SetAuditStartDatesPayload";
  batchClaimAuditStartDates?: Maybe<Array<Maybe<BatchClaimAuditStartDate>>>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type SetClaimAppealedInput = {
  /** true = Appealed (Set Appealed). null = clear (Delete Appealed). */
  appealed?: InputMaybe<Scalars["Boolean"]["input"]>;
  batchClaimIds: Array<Scalars["UUID"]["input"]>;
};

export type SetClaimAuditTypesInput = {
  auditType?: InputMaybe<ClaimAuditType>;
  batchClaimIds: Array<Scalars["UUID"]["input"]>;
};

export type SetClaimAuditorsInput = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimIds: Array<Scalars["UUID"]["input"]>;
};

export type SetClaimDisputedInput = {
  batchClaimIds: Array<Scalars["UUID"]["input"]>;
  /**
   * true = Disputed (Set Disputed). null = clear (Delete Disputed).
   * Wraps create_disputed_findings for Claims Table / Claim Details UX.
   */
  disputed?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SetClaimLifecycleStageInput = {
  batchClaimId: Scalars["UUID"]["input"];
  context?: InputMaybe<Scalars["JSON"]["input"]>;
  targetStageId?: InputMaybe<Scalars["UUID"]["input"]>;
  targetStageSlug?: InputMaybe<Scalars["String"]["input"]>;
};

export type SetClaimQaStatesInput = {
  batchClaimIds: Array<Scalars["UUID"]["input"]>;
  qaClaimState: QaClaimState;
};

export type SetClaimStageInput = {
  batchClaimIds: Array<Scalars["UUID"]["input"]>;
  claimStageId: Scalars["UUID"]["input"];
  context?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type SetClaimTechDenialsInput = {
  batchClaimIds: Array<Scalars["UUID"]["input"]>;
  /** true = Tech Denied (Set Tech Deny). null = clear (Delete Tech Deny). */
  techDenied?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** All input for the `setClientRecoveryAmounts` mutation. */
export type SetClientRecoveryAmountsInput = {
  batchClaimIds?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  clientRecoveryAmount?: InputMaybe<Scalars["Float"]["input"]>;
};

/** The output of our `setClientRecoveryAmounts` mutation. */
export type SetClientRecoveryAmountsPayload = {
  __typename?: "SetClientRecoveryAmountsPayload";
  batchClaimClientRecoveryAmounts?: Maybe<
    Array<Maybe<BatchClaimClientRecoveryAmount>>
  >;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setClientRecoveryCollectionDates` mutation. */
export type SetClientRecoveryCollectionDatesInput = {
  batchClaimIds?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  clientRecoveryCollectionDate?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The output of our `setClientRecoveryCollectionDates` mutation. */
export type SetClientRecoveryCollectionDatesPayload = {
  __typename?: "SetClientRecoveryCollectionDatesPayload";
  batchClaimClientRecoveryCollectionDates?: Maybe<
    Array<Maybe<BatchClaimClientRecoveryCollectionDate>>
  >;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setClientSignOffClaimStates` mutation. */
export type SetClientSignOffClaimStatesInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  clientSignOffState: ClientSignOffClaimStateEnum;
};

/** The output of our `setClientSignOffClaimStates` mutation. */
export type SetClientSignOffClaimStatesPayload = {
  __typename?: "SetClientSignOffClaimStatesPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  clientSignOffClaimStates?: Maybe<Array<Maybe<ClientSignOffClaimState>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setDocumentationClaimStates` mutation. */
export type SetDocumentationClaimStatesInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  documentationState: DocumentationClaimStateEnum;
};

/** The output of our `setDocumentationClaimStates` mutation. */
export type SetDocumentationClaimStatesPayload = {
  __typename?: "SetDocumentationClaimStatesPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  documentationClaimStates?: Maybe<Array<Maybe<DocumentationClaimState>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setDueDates` mutation. */
export type SetDueDatesInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  dueDates: Array<InputMaybe<Scalars["Datetime"]["input"]>>;
};

/** The output of our `setDueDates` mutation. */
export type SetDueDatesPayload = {
  __typename?: "SetDueDatesPayload";
  batchClaimDueDates?: Maybe<Array<Maybe<BatchClaimDueDate>>>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/**
 * Input for setFindingStatus. status must be ACCEPTED or DECLINED;
 * SUGGESTED is not user-settable and is rejected by the validator.
 */
export type SetFindingStatusInput = {
  findingIds: Array<Scalars["UUID"]["input"]>;
  /**
   * Stamped onto every review row written by this call. Supplying a
   * rationale on a re-affirm (same status as current) forces a new
   * row so the rationale is captured; without one, a re-affirm stays
   * a no-op. Never applied to side-effect auto-decline rows.
   */
  rationale?: InputMaybe<Scalars["String"]["input"]>;
  status: FindingStatus;
};

export type SetFindingStatusPayload = {
  __typename?: "SetFindingStatusPayload";
  /**
   * Findings auto-declined as a side effect of accepting a finding
   * on a line that already had a different accepted finding. Empty
   * when status is DECLINED, and empty for ACCEPTED when no prior
   * accepted finding existed on any affected line (or when the only
   * prior accept was a finding in the input list, which is never
   * auto-declined by this mutation).
   */
  autoDeclinedFindings: Array<FindingV2>;
  /**
   * The current state of every finding in the input, after any
   * transitions. No-op findings (already at the requested status)
   * are echoed back unchanged so the client can apply a single
   * cache-update strategy.
   */
  findings: Array<FindingV2>;
};

/** All input for the `setInvoiceClaimStates` mutation. */
export type SetInvoiceClaimStatesInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  invoiceState: InvoiceClaimStateEnum;
};

/** The output of our `setInvoiceClaimStates` mutation. */
export type SetInvoiceClaimStatesPayload = {
  __typename?: "SetInvoiceClaimStatesPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  invoiceClaimStates?: Maybe<Array<Maybe<InvoiceClaimState>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type SetLifecycleStageRecommendationInput = {
  nextRecommendedStageId?: InputMaybe<Scalars["UUID"]["input"]>;
  nextRecommendedStageSlug?: InputMaybe<Scalars["String"]["input"]>;
  stageId?: InputMaybe<Scalars["UUID"]["input"]>;
  stageSlug?: InputMaybe<Scalars["String"]["input"]>;
  suggestedStages?: InputMaybe<Array<LifecycleStageSuggestionInput>>;
};

/** All input for the `setNegotiationClaimStates` mutation. */
export type SetNegotiationClaimStatesInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  negotiationState: NegotiationClaimStateEnum;
};

/** The output of our `setNegotiationClaimStates` mutation. */
export type SetNegotiationClaimStatesPayload = {
  __typename?: "SetNegotiationClaimStatesPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  negotiationClaimStates?: Maybe<Array<Maybe<NegotiationClaimState>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setOnHoldClaimStates` mutation. */
export type SetOnHoldClaimStatesInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  onHoldState: OnHoldClaimStateEnum;
};

/** The output of our `setOnHoldClaimStates` mutation. */
export type SetOnHoldClaimStatesPayload = {
  __typename?: "SetOnHoldClaimStatesPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  onHoldClaimStates?: Maybe<Array<Maybe<OnHoldClaimState>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setProviderSignOffClaimStates` mutation. */
export type SetProviderSignOffClaimStatesInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  providerSignOffState: ProviderSignOffClaimStateEnum;
};

/** The output of our `setProviderSignOffClaimStates` mutation. */
export type SetProviderSignOffClaimStatesPayload = {
  __typename?: "SetProviderSignOffClaimStatesPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  providerSignOffClaimStates?: Maybe<Array<Maybe<ProviderSignOffClaimState>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setQaClaimStates` mutation. */
export type SetQaClaimStatesInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  qaClaimState: QaClaimStateOptions;
};

/** The output of our `setQaClaimStates` mutation. */
export type SetQaClaimStatesPayload = {
  __typename?: "SetQaClaimStatesPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  qaClaimStateRows?: Maybe<Array<Maybe<QaClaimStateRow>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type SetStageTrackerBlockerSegmentInput = {
  batchClaimId: Scalars["UUID"]["input"];
  /**
   * Open-history id of the blocker instance to update.
   * Required when the claim has more than one active blocker.
   */
  blockerId?: InputMaybe<Scalars["ID"]["input"]>;
  context?: InputMaybe<Scalars["JSON"]["input"]>;
  targetSegmentId?: InputMaybe<Scalars["UUID"]["input"]>;
  targetSegmentSlug?: InputMaybe<Scalars["String"]["input"]>;
};

/** All input for the `setWorkflowClaimStates` mutation. */
export type SetWorkflowClaimStatesInput = {
  batchClaimIds: Array<InputMaybe<Scalars["UUID"]["input"]>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  workflowState: WorkflowClaimStateEnum;
};

/** The output of our `setWorkflowClaimStates` mutation. */
export type SetWorkflowClaimStatesPayload = {
  __typename?: "SetWorkflowClaimStatesPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  workflowClaimStates?: Maybe<Array<Maybe<WorkflowClaimState>>>;
};

export type SignedDownloadUrl = {
  __typename?: "SignedDownloadUrl";
  fileId: Scalars["ID"]["output"];
  url: Scalars["String"]["output"];
};

export type SignedUploadUrl = {
  __typename?: "SignedUploadUrl";
  fields: Scalars["JSON"]["output"];
  url: Scalars["String"]["output"];
};

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

/** SSO domain-to-IdP routing. Discovery endpoint queries this to map email domains to Cognito IdPs. */
export type SsoDomainIdentityProvider = Node & {
  __typename?: "SsoDomainIdentityProvider";
  config: Scalars["JSON"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  domain: Scalars["String"]["output"];
  environment: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  tenantId: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type SsoDomainIdentityProviderAggregates = {
  __typename?: "SsoDomainIdentityProviderAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<SsoDomainIdentityProviderDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * A condition to be used against `SsoDomainIdentityProvider` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type SsoDomainIdentityProviderCondition = {
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `domain` field. */
  domain?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `environment` field. */
  environment?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type SsoDomainIdentityProviderDistinctCountAggregates = {
  __typename?: "SsoDomainIdentityProviderDistinctCountAggregates";
  /** Distinct count of config across the matching connection */
  config?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of domain across the matching connection */
  domain?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of environment across the matching connection */
  environment?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of isActive across the matching connection */
  isActive?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of tenantId across the matching connection */
  tenantId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `SsoDomainIdentityProvider` object types. All fields are combined with a logical ‘and.’ */
export type SsoDomainIdentityProviderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SsoDomainIdentityProviderFilter>>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JSONFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `domain` field. */
  domain?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environment` field. */
  environment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SsoDomainIdentityProviderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SsoDomainIdentityProviderFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `SsoDomainIdentityProvider` for usage during aggregation. */
export enum SsoDomainIdentityProviderGroupBy {
  CONFIG = "CONFIG",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  DOMAIN = "DOMAIN",
  ENVIRONMENT = "ENVIRONMENT",
  IS_ACTIVE = "IS_ACTIVE",
  TENANT_ID = "TENANT_ID",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type SsoDomainIdentityProviderHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type SsoDomainIdentityProviderHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `SsoDomainIdentityProvider` aggregates. */
export type SsoDomainIdentityProviderHavingInput = {
  AND?: InputMaybe<Array<SsoDomainIdentityProviderHavingInput>>;
  OR?: InputMaybe<Array<SsoDomainIdentityProviderHavingInput>>;
  average?: InputMaybe<SsoDomainIdentityProviderHavingAverageInput>;
  distinctCount?: InputMaybe<SsoDomainIdentityProviderHavingDistinctCountInput>;
  max?: InputMaybe<SsoDomainIdentityProviderHavingMaxInput>;
  min?: InputMaybe<SsoDomainIdentityProviderHavingMinInput>;
  stddevPopulation?: InputMaybe<SsoDomainIdentityProviderHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<SsoDomainIdentityProviderHavingStddevSampleInput>;
  sum?: InputMaybe<SsoDomainIdentityProviderHavingSumInput>;
  variancePopulation?: InputMaybe<SsoDomainIdentityProviderHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<SsoDomainIdentityProviderHavingVarianceSampleInput>;
};

export type SsoDomainIdentityProviderHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type SsoDomainIdentityProviderHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type SsoDomainIdentityProviderHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type SsoDomainIdentityProviderHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type SsoDomainIdentityProviderHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type SsoDomainIdentityProviderHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type SsoDomainIdentityProviderHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `SsoDomainIdentityProvider` */
export type SsoDomainIdentityProviderInput = {
  config: Scalars["JSON"]["input"];
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  domain: Scalars["String"]["input"];
  environment: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  tenantId: Scalars["String"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Represents an update to a `SsoDomainIdentityProvider`. Fields that are set will be updated. */
export type SsoDomainIdentityProviderPatch = {
  config?: InputMaybe<Scalars["JSON"]["input"]>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  domain?: InputMaybe<Scalars["String"]["input"]>;
  environment?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** A connection to a list of `SsoDomainIdentityProvider` values. */
export type SsoDomainIdentityProvidersConnection = {
  __typename?: "SsoDomainIdentityProvidersConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<SsoDomainIdentityProviderAggregates>;
  /** A list of edges which contains the `SsoDomainIdentityProvider` and cursor to aid in pagination. */
  edges: Array<SsoDomainIdentityProvidersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<SsoDomainIdentityProviderAggregates>>;
  /** A list of `SsoDomainIdentityProvider` objects. */
  nodes: Array<Maybe<SsoDomainIdentityProvider>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SsoDomainIdentityProvider` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `SsoDomainIdentityProvider` values. */
export type SsoDomainIdentityProvidersConnectiongroupedAggregatesArgs = {
  groupBy: Array<SsoDomainIdentityProviderGroupBy>;
  having?: InputMaybe<SsoDomainIdentityProviderHavingInput>;
};

/** A `SsoDomainIdentityProvider` edge in the connection. */
export type SsoDomainIdentityProvidersEdge = {
  __typename?: "SsoDomainIdentityProvidersEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `SsoDomainIdentityProvider` at the end of the edge. */
  node?: Maybe<SsoDomainIdentityProvider>;
};

/** Methods to use when ordering `SsoDomainIdentityProvider`. */
export enum SsoDomainIdentityProvidersOrderBy {
  CONFIG_ASC = "CONFIG_ASC",
  CONFIG_DESC = "CONFIG_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DOMAIN_ASC = "DOMAIN_ASC",
  DOMAIN_DESC = "DOMAIN_DESC",
  ENVIRONMENT_ASC = "ENVIRONMENT_ASC",
  ENVIRONMENT_DESC = "ENVIRONMENT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  IS_ACTIVE_ASC = "IS_ACTIVE_ASC",
  IS_ACTIVE_DESC = "IS_ACTIVE_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  TENANT_ID_ASC = "TENANT_ID_ASC",
  TENANT_ID_DESC = "TENANT_ID_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type StageTracker = {
  __typename?: "StageTracker";
  blockers: Array<StageTrackerBlocker>;
  canChangeStage: Scalars["Boolean"]["output"];
  changeStageDisabledReason?: Maybe<Scalars["String"]["output"]>;
  currentStage: StageTrackerStage;
  currentStageEnteredAt?: Maybe<Scalars["Datetime"]["output"]>;
  nextRecommendedStage?: Maybe<StageTrackerStage>;
  phases: Array<StageTrackerPhase>;
  stageHistory: Array<LifecycleStageHistoryEntry>;
  /**
   * Shortcut targets for the current stage from the product matrix
   * (claim_audit_stage_suggestion). When the matrix has no rows for the
   * current stage but nextRecommendedStage is set, returns that stage
   * alone at priority 1 so linear paths still expose a non-empty list.
   */
  suggestedStages: Array<StageTrackerSuggestedStage>;
  visitedStageIds: Array<Scalars["UUID"]["output"]>;
};

export type StageTrackerBlocker = {
  __typename?: "StageTrackerBlocker";
  canChangeSegment: Scalars["Boolean"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  createdDuringStage: StageTrackerStage;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  segmentHistory: Array<BlockerSegmentHistoryEntry>;
  segments: Array<StageTrackerBlockerSegment>;
  status: StageTrackerBlockerStatus;
  title: Scalars["String"]["output"];
};

export type StageTrackerBlockerSegment = {
  __typename?: "StageTrackerBlockerSegment";
  id: Scalars["UUID"]["output"];
  label: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  status: StageTrackerBlockerSegmentStatus;
};

export enum StageTrackerBlockerSegmentStatus {
  COMPLETED = "COMPLETED",
  CURRENT = "CURRENT",
  NOT_STARTED = "NOT_STARTED",
}

export enum StageTrackerBlockerStatus {
  ACTIVE = "ACTIVE",
  RESOLVED = "RESOLVED",
}

export type StageTrackerPhase = {
  __typename?: "StageTrackerPhase";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  labelOrder: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  stages: Array<StageTrackerStage>;
  status?: Maybe<StageTrackerPhaseStatus>;
};

/**
 * Phase-level rollup status. BLOCKED is reserved and no longer emitted
 * (active blockers no longer suspend the lifecycle rail).
 */
export enum StageTrackerPhaseStatus {
  BLOCKED = "BLOCKED",
  COMPLETED = "COMPLETED",
  CURRENT = "CURRENT",
  NOT_STARTED = "NOT_STARTED",
  SKIPPED = "SKIPPED",
}

export type StageTrackerStage = {
  __typename?: "StageTrackerStage";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  labelOrder: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  /**
   * UI-facing Who/What summary as two paragraphs (same format as
   * ClaimStage.stageDetail), derived from catalog stage_who / stage_what:
   *
   * Who: PI Ops Associate, Data Ingestion Analyst
   *
   * What: Closes out duplicates/versioned claims; ...
   */
  stageDetail?: Maybe<Scalars["String"]["output"]>;
  status: StageTrackerStageStatus;
  type?: Maybe<ClaimStageType>;
};

/**
 * Stage status. BLOCKED is reserved and no longer emitted (active blockers
 * no longer suspend the lifecycle rail).
 */
export enum StageTrackerStageStatus {
  BLOCKED = "BLOCKED",
  COMPLETED = "COMPLETED",
  CURRENT = "CURRENT",
  NOT_STARTED = "NOT_STARTED",
  SKIPPED = "SKIPPED",
}

export type StageTrackerSuggestedStage = {
  __typename?: "StageTrackerSuggestedStage";
  priority: Scalars["Int"]["output"];
  stage: StageTrackerStage;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["String"]["input"]>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars["String"]["input"]>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars["String"]["input"]>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["String"]["input"]>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars["String"]["input"]>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["String"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
};

export type SupportingDocumentation = {
  __typename?: "SupportingDocumentation";
  signedUpload: PrepareFileForUploadResult;
};

export type SupportingDocumentationsignedUploadArgs = {
  input: SupportingDocumentationUploadInput;
};

export type SupportingDocumentationUploadInput = {
  documentUploadKind: DocumentUploadKind;
  prepareFileForUploadInput: PrepareFileForUploadInput;
};

export type TestType = {
  __typename?: "TestType";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Thread = {
  __typename?: "Thread";
  agent?: Maybe<Agent>;
  case: Case;
  createdAt: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  messages: Array<Message>;
  messagesConnection: MessagesConnection;
  name: Scalars["String"]["output"];
};

export type ThreadmessagesConnectionArgs = {
  args?: InputMaybe<MessagesArgs>;
};

export type ThreadsInput = {
  caseId: Scalars["ID"]["input"];
};

export type TransferSummaryItem = {
  __typename?: "TransferSummaryItem";
  description: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UUIDFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
};

/** A filter to be used against UUID List fields. All fields are combined with a logical ‘and.’ */
export type UUIDListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<
    Array<InputMaybe<Scalars["UUID"]["input"]>>
  >;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
};

export type UnassignClaimsFromAuditGroupInput = {
  batchClaimIds: Array<Scalars["UUID"]["input"]>;
  claimAuditGroupId: Scalars["UUID"]["input"];
};

/** A `String` edge in the connection. */
export type UniqueProcedureCodeEdge = {
  __typename?: "UniqueProcedureCodeEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `String` at the end of the edge. */
  node?: Maybe<Scalars["String"]["output"]>;
};

/** A connection to a list of `String` values. */
export type UniqueProcedureCodesConnection = {
  __typename?: "UniqueProcedureCodesConnection";
  /** A list of edges which contains the `String` and cursor to aid in pagination. */
  edges: Array<UniqueProcedureCodeEdge>;
  /** A list of `String` objects. */
  nodes: Array<Maybe<Scalars["String"]["output"]>>;
  /** The count of *all* `String` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `String` edge in the connection. */
export type UniqueRevCodeEdge = {
  __typename?: "UniqueRevCodeEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `String` at the end of the edge. */
  node?: Maybe<Scalars["String"]["output"]>;
};

/** A connection to a list of `String` values. */
export type UniqueRevCodesConnection = {
  __typename?: "UniqueRevCodesConnection";
  /** A list of edges which contains the `String` and cursor to aid in pagination. */
  edges: Array<UniqueRevCodeEdge>;
  /** A list of `String` objects. */
  nodes: Array<Maybe<Scalars["String"]["output"]>>;
  /** The count of *all* `String` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

export type UpdateAskAutodorQueueInput = {
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** All input for the `updateAuditFindingByNodeId` mutation. */
export type UpdateAuditFindingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `AuditFinding` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `AuditFinding` being updated. */
  patch: AuditFindingPatch;
};

/** All input for the `updateAuditFinding` mutation. */
export type UpdateAuditFindingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `AuditFinding` being updated. */
  patch: AuditFindingPatch;
};

/** The output of our update `AuditFinding` mutation. */
export type UpdateAuditFindingPayload = {
  __typename?: "UpdateAuditFindingPayload";
  /** The `AuditFinding` that was updated by this mutation. */
  auditFinding?: Maybe<AuditFinding>;
  /** An edge for our `AuditFinding`. May be used by Relay 1. */
  auditFindingEdge?: Maybe<AuditFindingsEdge>;
  /** Reads a single `AuditFindingJob` that is related to this `AuditFinding`. */
  auditFindingJob?: Maybe<AuditFindingJob>;
  /** Reads a single `AuditFindingRuleType` that is related to this `AuditFinding`. */
  auditFindingRuleTypeByAuditFindingRuleType?: Maybe<AuditFindingRuleType>;
  /** Reads a single `AuditorUser` that is related to this `AuditFinding`. */
  author?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `AuditFinding`. */
  batchClaim?: Maybe<BatchClaim>;
  /** Reads a single `BatchClaimLine` that is related to this `AuditFinding`. */
  batchClaimLine?: Maybe<BatchClaimLine>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `AuditFinding` that is related to this `AuditFinding`. */
  previousVersion?: Maybe<AuditFinding>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `AuditFinding` mutation. */
export type UpdateAuditFindingPayloadauditFindingEdgeArgs = {
  orderBy?: InputMaybe<Array<AuditFindingsOrderBy>>;
};

/** All input for the `updateAuditFindingReasonCodeByNodeId` mutation. */
export type UpdateAuditFindingReasonCodeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `AuditFindingReasonCode` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `AuditFindingReasonCode` being updated. */
  patch: AuditFindingReasonCodePatch;
};

/** All input for the `updateAuditFindingReasonCode` mutation. */
export type UpdateAuditFindingReasonCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `AuditFindingReasonCode` being updated. */
  patch: AuditFindingReasonCodePatch;
};

/** The output of our update `AuditFindingReasonCode` mutation. */
export type UpdateAuditFindingReasonCodePayload = {
  __typename?: "UpdateAuditFindingReasonCodePayload";
  /** Reads a single `AuditFinding` that is related to this `AuditFindingReasonCode`. */
  auditFinding?: Maybe<AuditFinding>;
  /** The `AuditFindingReasonCode` that was updated by this mutation. */
  auditFindingReasonCode?: Maybe<AuditFindingReasonCode>;
  /** An edge for our `AuditFindingReasonCode`. May be used by Relay 1. */
  auditFindingReasonCodeEdge?: Maybe<AuditFindingReasonCodesEdge>;
  /** Reads a single `AuditorUser` that is related to this `AuditFindingReasonCode`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ReasonCode` that is related to this `AuditFindingReasonCode`. */
  reasonCode?: Maybe<ReasonCode>;
};

/** The output of our update `AuditFindingReasonCode` mutation. */
export type UpdateAuditFindingReasonCodePayloadauditFindingReasonCodeEdgeArgs =
  {
    orderBy?: InputMaybe<Array<AuditFindingReasonCodesOrderBy>>;
  };

export type UpdateAuditStatusInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sortIndex?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateAuditStatusItemInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sortIndex?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateAuditStatusesInput = {
  deletedIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  statuses: Array<UpdateAuditStatusItemInput>;
};

/** All input for the `updateAuditorBucketByNodeId` mutation. */
export type UpdateAuditorBucketByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `AuditorBucket` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `AuditorBucket` being updated. */
  patch: AuditorBucketPatch;
};

/** All input for the `updateAuditorBucket` mutation. */
export type UpdateAuditorBucketInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `AuditorBucket` being updated. */
  patch: AuditorBucketPatch;
};

/** The output of our update `AuditorBucket` mutation. */
export type UpdateAuditorBucketPayload = {
  __typename?: "UpdateAuditorBucketPayload";
  /** Reads a single `AuditorUser` that is related to this `AuditorBucket`. */
  assignee?: Maybe<AuditorUser>;
  /** The `AuditorBucket` that was updated by this mutation. */
  auditorBucket?: Maybe<AuditorBucket>;
  /** An edge for our `AuditorBucket`. May be used by Relay 1. */
  auditorBucketEdge?: Maybe<AuditorBucketsEdge>;
  /** Reads a single `AuditorUser` that is related to this `AuditorBucket`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Insurer` that is related to this `AuditorBucket`. */
  insurer?: Maybe<Insurer>;
  /** Reads a single `Provider` that is related to this `AuditorBucket`. */
  provider?: Maybe<Provider>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `AuditorBucket` mutation. */
export type UpdateAuditorBucketPayloadauditorBucketEdgeArgs = {
  orderBy?: InputMaybe<Array<AuditorBucketsOrderBy>>;
};

/** All input for the `updateBatchClaimAppealedByBatchClaimId` mutation. */
export type UpdateBatchClaimAppealedByBatchClaimIdInput = {
  batchClaimId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `BatchClaimAppealed` being updated. */
  patch: BatchClaimAppealedPatch;
};

/** All input for the `updateBatchClaimAppealedByNodeId` mutation. */
export type UpdateBatchClaimAppealedByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `BatchClaimAppealed` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimAppealed` being updated. */
  patch: BatchClaimAppealedPatch;
};

/** All input for the `updateBatchClaimAppealed` mutation. */
export type UpdateBatchClaimAppealedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimAppealed` being updated. */
  patch: BatchClaimAppealedPatch;
};

/** The output of our update `BatchClaimAppealed` mutation. */
export type UpdateBatchClaimAppealedPayload = {
  __typename?: "UpdateBatchClaimAppealedPayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimAppealed`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAppealed`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimAppealed` that was updated by this mutation. */
  batchClaimAppealed?: Maybe<BatchClaimAppealed>;
  /** An edge for our `BatchClaimAppealed`. May be used by Relay 1. */
  batchClaimAppealedEdge?: Maybe<BatchClaimAppealedsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BatchClaimAppealed` mutation. */
export type UpdateBatchClaimAppealedPayloadbatchClaimAppealedEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimAppealedsOrderBy>>;
};

/** All input for the `updateBatchClaimAuditTypeByBatchClaimId` mutation. */
export type UpdateBatchClaimAuditTypeByBatchClaimIdInput = {
  batchClaimId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `BatchClaimAuditType` being updated. */
  patch: BatchClaimAuditTypePatch;
};

/** All input for the `updateBatchClaimAuditTypeByNodeId` mutation. */
export type UpdateBatchClaimAuditTypeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `BatchClaimAuditType` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimAuditType` being updated. */
  patch: BatchClaimAuditTypePatch;
};

/** All input for the `updateBatchClaimAuditType` mutation. */
export type UpdateBatchClaimAuditTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimAuditType` being updated. */
  patch: BatchClaimAuditTypePatch;
};

/** The output of our update `BatchClaimAuditType` mutation. */
export type UpdateBatchClaimAuditTypePayload = {
  __typename?: "UpdateBatchClaimAuditTypePayload";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimAuditType`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimAuditType` that was updated by this mutation. */
  batchClaimAuditType?: Maybe<BatchClaimAuditType>;
  /** An edge for our `BatchClaimAuditType`. May be used by Relay 1. */
  batchClaimAuditTypeEdge?: Maybe<BatchClaimAuditTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BatchClaimAuditType` mutation. */
export type UpdateBatchClaimAuditTypePayloadbatchClaimAuditTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimAuditTypesOrderBy>>;
};

/** All input for the `updateBatchClaimDocumentByBatchClaimIdAndDocumentId` mutation. */
export type UpdateBatchClaimDocumentByBatchClaimIdAndDocumentIdInput = {
  batchClaimId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  documentId: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimDocument` being updated. */
  patch: BatchClaimDocumentPatch;
};

/** All input for the `updateBatchClaimDocumentByBatchClaimIdAndIsPrimaryMedicalRecord` mutation. */
export type UpdateBatchClaimDocumentByBatchClaimIdAndIsPrimaryMedicalRecordInput =
  {
    batchClaimId: Scalars["UUID"]["input"];
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Marks this document as the primary medical record for the batch claim. Nullable-or-TRUE; FALSE is disallowed. At most one document per batch_claim_id may have this set to TRUE (enforced by the deferrable compound UNIQUE constraint on (batch_claim_id, is_primary_medical_record) — NULLs are distinct so only TRUE rows collide).
     *
     * @omit create,update
     */
    isPrimaryMedicalRecord: Scalars["Boolean"]["input"];
    /** An object where the defined keys will be set on the `BatchClaimDocument` being updated. */
    patch: BatchClaimDocumentPatch;
  };

/** All input for the `updateBatchClaimDocumentByNodeId` mutation. */
export type UpdateBatchClaimDocumentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `BatchClaimDocument` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimDocument` being updated. */
  patch: BatchClaimDocumentPatch;
};

/** All input for the `updateBatchClaimDocument` mutation. */
export type UpdateBatchClaimDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimDocument` being updated. */
  patch: BatchClaimDocumentPatch;
};

/** The output of our update `BatchClaimDocument` mutation. */
export type UpdateBatchClaimDocumentPayload = {
  __typename?: "UpdateBatchClaimDocumentPayload";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimDocument`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimDocument` that was updated by this mutation. */
  batchClaimDocument?: Maybe<BatchClaimDocument>;
  /** An edge for our `BatchClaimDocument`. May be used by Relay 1. */
  batchClaimDocumentEdge?: Maybe<BatchClaimDocumentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BatchClaimDocument` mutation. */
export type UpdateBatchClaimDocumentPayloadbatchClaimDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimDocumentsOrderBy>>;
};

/** All input for the `updateBatchClaimLineItemByNodeId` mutation. */
export type UpdateBatchClaimLineItemByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `BatchClaimLineItem` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimLineItem` being updated. */
  patch: BatchClaimLineItemPatch;
};

/** All input for the `updateBatchClaimLineItem` mutation. */
export type UpdateBatchClaimLineItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimLineItem` being updated. */
  patch: BatchClaimLineItemPatch;
};

/** All input for the `updateBatchClaimLineItemNnIbLineByBatchClaimLineItemIdAndNnIbLineId` mutation. */
export type UpdateBatchClaimLineItemNnIbLineByBatchClaimLineItemIdAndNnIbLineIdInput =
  {
    batchClaimLineItemId: Scalars["UUID"]["input"];
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    nnIbLineId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `BatchClaimLineItemNnIbLine` being updated. */
    patch: BatchClaimLineItemNnIbLinePatch;
  };

/** All input for the `updateBatchClaimLineItemNnIbLineByNodeId` mutation. */
export type UpdateBatchClaimLineItemNnIbLineByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `BatchClaimLineItemNnIbLine` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimLineItemNnIbLine` being updated. */
  patch: BatchClaimLineItemNnIbLinePatch;
};

/** All input for the `updateBatchClaimLineItemNnIbLine` mutation. */
export type UpdateBatchClaimLineItemNnIbLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimLineItemNnIbLine` being updated. */
  patch: BatchClaimLineItemNnIbLinePatch;
};

/** The output of our update `BatchClaimLineItemNnIbLine` mutation. */
export type UpdateBatchClaimLineItemNnIbLinePayload = {
  __typename?: "UpdateBatchClaimLineItemNnIbLinePayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimLineItemNnIbLine`. */
  author?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaimLineItem` that is related to this `BatchClaimLineItemNnIbLine`. */
  batchClaimLineItem?: Maybe<BatchClaimLineItem>;
  /** The `BatchClaimLineItemNnIbLine` that was updated by this mutation. */
  batchClaimLineItemNnIbLine?: Maybe<BatchClaimLineItemNnIbLine>;
  /** An edge for our `BatchClaimLineItemNnIbLine`. May be used by Relay 1. */
  batchClaimLineItemNnIbLineEdge?: Maybe<BatchClaimLineItemNnIbLinesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `NnIbLine` that is related to this `BatchClaimLineItemNnIbLine`. */
  nnIbLine?: Maybe<NnIbLine>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BatchClaimLineItemNnIbLine` mutation. */
export type UpdateBatchClaimLineItemNnIbLinePayloadbatchClaimLineItemNnIbLineEdgeArgs =
  {
    orderBy?: InputMaybe<Array<BatchClaimLineItemNnIbLinesOrderBy>>;
  };

/** The output of our update `BatchClaimLineItem` mutation. */
export type UpdateBatchClaimLineItemPayload = {
  __typename?: "UpdateBatchClaimLineItemPayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimLineItem`. */
  author?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimLineItem`. */
  batchClaim?: Maybe<BatchClaim>;
  /** Reads a single `BatchClaimLine` that is related to this `BatchClaimLineItem`. */
  batchClaimLine?: Maybe<BatchClaimLine>;
  /** The `BatchClaimLineItem` that was updated by this mutation. */
  batchClaimLineItem?: Maybe<BatchClaimLineItem>;
  /** An edge for our `BatchClaimLineItem`. May be used by Relay 1. */
  batchClaimLineItemEdge?: Maybe<BatchClaimLineItemsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BatchClaimLineItem` mutation. */
export type UpdateBatchClaimLineItemPayloadbatchClaimLineItemEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimLineItemsOrderBy>>;
};

/** All input for the `updateBatchClaimPayDenyByBatchClaimId` mutation. */
export type UpdateBatchClaimPayDenyByBatchClaimIdInput = {
  batchClaimId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `BatchClaimPayDeny` being updated. */
  patch: BatchClaimPayDenyPatch;
};

/** All input for the `updateBatchClaimPayDenyByNodeId` mutation. */
export type UpdateBatchClaimPayDenyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `BatchClaimPayDeny` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimPayDeny` being updated. */
  patch: BatchClaimPayDenyPatch;
};

/** All input for the `updateBatchClaimPayDeny` mutation. */
export type UpdateBatchClaimPayDenyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimPayDeny` being updated. */
  patch: BatchClaimPayDenyPatch;
};

/** The output of our update `BatchClaimPayDeny` mutation. */
export type UpdateBatchClaimPayDenyPayload = {
  __typename?: "UpdateBatchClaimPayDenyPayload";
  /** Reads a single `BatchClaim` that is related to this `BatchClaimPayDeny`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimPayDeny` that was updated by this mutation. */
  batchClaimPayDeny?: Maybe<BatchClaimPayDeny>;
  /** An edge for our `BatchClaimPayDeny`. May be used by Relay 1. */
  batchClaimPayDenyEdge?: Maybe<BatchClaimPayDeniesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BatchClaimPayDeny` mutation. */
export type UpdateBatchClaimPayDenyPayloadbatchClaimPayDenyEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimPayDeniesOrderBy>>;
};

/** All input for the `updateBatchClaimTechDenialByBatchClaimId` mutation. */
export type UpdateBatchClaimTechDenialByBatchClaimIdInput = {
  batchClaimId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `BatchClaimTechDenial` being updated. */
  patch: BatchClaimTechDenialPatch;
};

/** All input for the `updateBatchClaimTechDenialByNodeId` mutation. */
export type UpdateBatchClaimTechDenialByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `BatchClaimTechDenial` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimTechDenial` being updated. */
  patch: BatchClaimTechDenialPatch;
};

/** All input for the `updateBatchClaimTechDenial` mutation. */
export type UpdateBatchClaimTechDenialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `BatchClaimTechDenial` being updated. */
  patch: BatchClaimTechDenialPatch;
};

/** The output of our update `BatchClaimTechDenial` mutation. */
export type UpdateBatchClaimTechDenialPayload = {
  __typename?: "UpdateBatchClaimTechDenialPayload";
  /** Reads a single `AuditorUser` that is related to this `BatchClaimTechDenial`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** Reads a single `BatchClaim` that is related to this `BatchClaimTechDenial`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BatchClaimTechDenial` that was updated by this mutation. */
  batchClaimTechDenial?: Maybe<BatchClaimTechDenial>;
  /** An edge for our `BatchClaimTechDenial`. May be used by Relay 1. */
  batchClaimTechDenialEdge?: Maybe<BatchClaimTechDenialsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BatchClaimTechDenial` mutation. */
export type UpdateBatchClaimTechDenialPayloadbatchClaimTechDenialEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchClaimTechDenialsOrderBy>>;
};

/** All input for the `updateBclComputationsFromComputationStrategy` mutation. */
export type UpdateBclComputationsFromComputationStrategyInput = {
  bcl?: InputMaybe<BatchClaimLineInput>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our `updateBclComputationsFromComputationStrategy` mutation. */
export type UpdateBclComputationsFromComputationStrategyPayload = {
  __typename?: "UpdateBclComputationsFromComputationStrategyPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateBcliComputationsFromComputationStrategy` mutation. */
export type UpdateBcliComputationsFromComputationStrategyInput = {
  bcli?: InputMaybe<BatchClaimLineItemInput>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our `updateBcliComputationsFromComputationStrategy` mutation. */
export type UpdateBcliComputationsFromComputationStrategyPayload = {
  __typename?: "UpdateBcliComputationsFromComputationStrategyPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateBucketClaimByBatchClaimIdAndAuditorBucketId` mutation. */
export type UpdateBucketClaimByBatchClaimIdAndAuditorBucketIdInput = {
  auditorBucketId: Scalars["UUID"]["input"];
  batchClaimId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `BucketClaim` being updated. */
  patch: BucketClaimPatch;
};

/** All input for the `updateBucketClaimByBatchClaimId` mutation. */
export type UpdateBucketClaimByBatchClaimIdInput = {
  batchClaimId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `BucketClaim` being updated. */
  patch: BucketClaimPatch;
};

/** All input for the `updateBucketClaimByNodeId` mutation. */
export type UpdateBucketClaimByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `BucketClaim` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `BucketClaim` being updated. */
  patch: BucketClaimPatch;
};

/** All input for the `updateBucketClaim` mutation. */
export type UpdateBucketClaimInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `BucketClaim` being updated. */
  patch: BucketClaimPatch;
};

/** The output of our update `BucketClaim` mutation. */
export type UpdateBucketClaimPayload = {
  __typename?: "UpdateBucketClaimPayload";
  /** Reads a single `AuditorBucket` that is related to this `BucketClaim`. */
  auditorBucket?: Maybe<AuditorBucket>;
  /** Reads a single `BatchClaim` that is related to this `BucketClaim`. */
  batchClaim?: Maybe<BatchClaim>;
  /** The `BucketClaim` that was updated by this mutation. */
  bucketClaim?: Maybe<BucketClaim>;
  /** An edge for our `BucketClaim`. May be used by Relay 1. */
  bucketClaimEdge?: Maybe<BucketClaimsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `BucketClaim` mutation. */
export type UpdateBucketClaimPayloadbucketClaimEdgeArgs = {
  orderBy?: InputMaybe<Array<BucketClaimsOrderBy>>;
};

export type UpdateCaseInput = {
  completed?: InputMaybe<Scalars["Boolean"]["input"]>;
  fileIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  queueId?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<CaseStatus>;
};

/** All input for the `updateClaimAuditGroupByName` mutation. */
export type UpdateClaimAuditGroupByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  /** An object where the defined keys will be set on the `ClaimAuditGroup` being updated. */
  patch: ClaimAuditGroupPatch;
};

/** All input for the `updateClaimAuditGroupByNodeId` mutation. */
export type UpdateClaimAuditGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `ClaimAuditGroup` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `ClaimAuditGroup` being updated. */
  patch: ClaimAuditGroupPatch;
};

/** All input for the `updateClaimAuditGroup` mutation. */
export type UpdateClaimAuditGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `ClaimAuditGroup` being updated. */
  patch: ClaimAuditGroupPatch;
};

/** The output of our update `ClaimAuditGroup` mutation. */
export type UpdateClaimAuditGroupPayload = {
  __typename?: "UpdateClaimAuditGroupPayload";
  /** Reads a single `AuditorUser` that is related to this `ClaimAuditGroup`. */
  auditorUserByCreatedBy?: Maybe<AuditorUser>;
  /** The `ClaimAuditGroup` that was updated by this mutation. */
  claimAuditGroup?: Maybe<ClaimAuditGroup>;
  /** An edge for our `ClaimAuditGroup`. May be used by Relay 1. */
  claimAuditGroupEdge?: Maybe<ClaimAuditGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Insurer` that is related to this `ClaimAuditGroup`. */
  insurer?: Maybe<Insurer>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ClaimAuditGroup` mutation. */
export type UpdateClaimAuditGroupPayloadclaimAuditGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ClaimAuditGroupsOrderBy>>;
};

export type UpdateDirectoryInput = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  parentDirectoryId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Input for updating a facet */
export type UpdateFacetInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for updating a facet keyword */
export type UpdateFacetKeywordInput = {
  colorCode?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateFileInput = {
  parentDirectoryId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateFindingsInput = {
  findingIds: Array<Scalars["UUID"]["input"]>;
  patch: FindingPatch;
};

export type UpdateFindingsPayload = {
  __typename?: "UpdateFindingsPayload";
  /**
   * Findings on the same IB line that were auto-declined to
   * preserve the one-accepted-per-line invariant. Empty unless
   * patch.status is ACCEPTED.
   */
  autoDeclinedFindings: Array<FindingV2>;
  /** The new versioned successors — one per input finding. */
  findings: Array<FindingV2>;
  /**
   * The replaced predecessors — their isActive is false after the
   * cache refresh because the successors are now the head of the
   * lineage chain.
   */
  replacedFindings: Array<FindingV2>;
};

export type UpdateLifecycleRoleInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  version: Scalars["Int"]["input"];
};

/** All input for the `updateNnIbLineByFingerprintAndS3Key` mutation. */
export type UpdateNnIbLineByFingerprintAndS3KeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  fingerprint: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `NnIbLine` being updated. */
  patch: NnIbLinePatch;
  s3Key: Scalars["String"]["input"];
};

/** All input for the `updateNnIbLineByNodeId` mutation. */
export type UpdateNnIbLineByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `NnIbLine` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `NnIbLine` being updated. */
  patch: NnIbLinePatch;
};

/** All input for the `updateNnIbLine` mutation. */
export type UpdateNnIbLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `NnIbLine` being updated. */
  patch: NnIbLinePatch;
};

/** The output of our update `NnIbLine` mutation. */
export type UpdateNnIbLinePayload = {
  __typename?: "UpdateNnIbLinePayload";
  /** Reads a single `AuditorUser` that is related to this `NnIbLine`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** The `NnIbLine` that was updated by this mutation. */
  nnIbLine?: Maybe<NnIbLine>;
  /** An edge for our `NnIbLine`. May be used by Relay 1. */
  nnIbLineEdge?: Maybe<NnIbLinesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `NnIbLine` mutation. */
export type UpdateNnIbLinePayloadnnIbLineEdgeArgs = {
  orderBy?: InputMaybe<Array<NnIbLinesOrderBy>>;
};

/** All input for the `updateProviderUserFacilityByNodeId` mutation. */
export type UpdateProviderUserFacilityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `ProviderUserFacility` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `ProviderUserFacility` being updated. */
  patch: ProviderUserFacilityPatch;
};

/** All input for the `updateProviderUserFacilityByProviderIdAndAuditorUserId` mutation. */
export type UpdateProviderUserFacilityByProviderIdAndAuditorUserIdInput = {
  auditorUserId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `ProviderUserFacility` being updated. */
  patch: ProviderUserFacilityPatch;
  providerId: Scalars["String"]["input"];
};

/** All input for the `updateProviderUserFacility` mutation. */
export type UpdateProviderUserFacilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `ProviderUserFacility` being updated. */
  patch: ProviderUserFacilityPatch;
};

/** The output of our update `ProviderUserFacility` mutation. */
export type UpdateProviderUserFacilityPayload = {
  __typename?: "UpdateProviderUserFacilityPayload";
  /** Reads a single `AuditorUser` that is related to this `ProviderUserFacility`. */
  auditorUser?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Provider` that is related to this `ProviderUserFacility`. */
  provider?: Maybe<Provider>;
  /** The `ProviderUserFacility` that was updated by this mutation. */
  providerUserFacility?: Maybe<ProviderUserFacility>;
  /** An edge for our `ProviderUserFacility`. May be used by Relay 1. */
  providerUserFacilityEdge?: Maybe<ProviderUserFacilitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `ProviderUserFacility` mutation. */
export type UpdateProviderUserFacilityPayloadproviderUserFacilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ProviderUserFacilitiesOrderBy>>;
};

/** All input for the `updateQueueByNodeId` mutation. */
export type UpdateQueueByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `Queue` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `Queue` being updated. */
  patch: QueuePatch;
};

/** All input for the `updateQueue` mutation. */
export type UpdateQueueInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `Queue` being updated. */
  patch: QueuePatch;
};

/** The output of our update `Queue` mutation. */
export type UpdateQueuePayload = {
  __typename?: "UpdateQueuePayload";
  /** Reads a single `AuditorUser` that is related to this `Queue`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Queue` that was updated by this mutation. */
  queue?: Maybe<Queue>;
  /** An edge for our `Queue`. May be used by Relay 1. */
  queueEdge?: Maybe<QueuesEdge>;
};

/** The output of our update `Queue` mutation. */
export type UpdateQueuePayloadqueueEdgeArgs = {
  orderBy?: InputMaybe<Array<QueuesOrderBy>>;
};

/** All input for the `updateReviewedAuditFindingByNodeId` mutation. */
export type UpdateReviewedAuditFindingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `ReviewedAuditFinding` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `ReviewedAuditFinding` being updated. */
  patch: ReviewedAuditFindingPatch;
};

/** All input for the `updateReviewedAuditFinding` mutation. */
export type UpdateReviewedAuditFindingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `ReviewedAuditFinding` being updated. */
  patch: ReviewedAuditFindingPatch;
};

/** The output of our update `ReviewedAuditFinding` mutation. */
export type UpdateReviewedAuditFindingPayload = {
  __typename?: "UpdateReviewedAuditFindingPayload";
  /** Reads a single `AuditFinding` that is related to this `ReviewedAuditFinding`. */
  auditFinding?: Maybe<AuditFinding>;
  /** Reads a single `AuditorUser` that is related to this `ReviewedAuditFinding`. */
  author?: Maybe<AuditorUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ReviewedAuditFinding` that was updated by this mutation. */
  reviewedAuditFinding?: Maybe<ReviewedAuditFinding>;
  /** An edge for our `ReviewedAuditFinding`. May be used by Relay 1. */
  reviewedAuditFindingEdge?: Maybe<ReviewedAuditFindingsEdge>;
};

/** The output of our update `ReviewedAuditFinding` mutation. */
export type UpdateReviewedAuditFindingPayloadreviewedAuditFindingEdgeArgs = {
  orderBy?: InputMaybe<Array<ReviewedAuditFindingsOrderBy>>;
};

/** All input for the `updateS3AuditDocumentationByNodeId` mutation. */
export type UpdateS3AuditDocumentationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `S3AuditDocumentation` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `S3AuditDocumentation` being updated. */
  patch: S3AuditDocumentationPatch;
};

/** All input for the `updateS3AuditDocumentation` mutation. */
export type UpdateS3AuditDocumentationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `S3AuditDocumentation` being updated. */
  patch: S3AuditDocumentationPatch;
};

/** The output of our update `S3AuditDocumentation` mutation. */
export type UpdateS3AuditDocumentationPayload = {
  __typename?: "UpdateS3AuditDocumentationPayload";
  /** Reads a single `BatchClaim` that is related to this `S3AuditDocumentation`. */
  batchClaim?: Maybe<BatchClaim>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `S3AuditDocumentation` that was updated by this mutation. */
  s3AuditDocumentation?: Maybe<S3AuditDocumentation>;
  /** An edge for our `S3AuditDocumentation`. May be used by Relay 1. */
  s3AuditDocumentationEdge?: Maybe<S3AuditDocumentationsEdge>;
};

/** The output of our update `S3AuditDocumentation` mutation. */
export type UpdateS3AuditDocumentationPayloads3AuditDocumentationEdgeArgs = {
  orderBy?: InputMaybe<Array<S3AuditDocumentationsOrderBy>>;
};

/** All input for the `updateSsoDomainIdentityProviderByDomainAndEnvironmentAndTenantId` mutation. */
export type UpdateSsoDomainIdentityProviderByDomainAndEnvironmentAndTenantIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    domain: Scalars["String"]["input"];
    environment: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `SsoDomainIdentityProvider` being updated. */
    patch: SsoDomainIdentityProviderPatch;
    tenantId: Scalars["String"]["input"];
  };

/** All input for the `updateSsoDomainIdentityProviderByNodeId` mutation. */
export type UpdateSsoDomainIdentityProviderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The globally unique `ID` which will identify a single `SsoDomainIdentityProvider` to be updated. */
  nodeId: Scalars["ID"]["input"];
  /** An object where the defined keys will be set on the `SsoDomainIdentityProvider` being updated. */
  patch: SsoDomainIdentityProviderPatch;
};

/** All input for the `updateSsoDomainIdentityProvider` mutation. */
export type UpdateSsoDomainIdentityProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `SsoDomainIdentityProvider` being updated. */
  patch: SsoDomainIdentityProviderPatch;
};

/** The output of our update `SsoDomainIdentityProvider` mutation. */
export type UpdateSsoDomainIdentityProviderPayload = {
  __typename?: "UpdateSsoDomainIdentityProviderPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SsoDomainIdentityProvider` that was updated by this mutation. */
  ssoDomainIdentityProvider?: Maybe<SsoDomainIdentityProvider>;
  /** An edge for our `SsoDomainIdentityProvider`. May be used by Relay 1. */
  ssoDomainIdentityProviderEdge?: Maybe<SsoDomainIdentityProvidersEdge>;
};

/** The output of our update `SsoDomainIdentityProvider` mutation. */
export type UpdateSsoDomainIdentityProviderPayloadssoDomainIdentityProviderEdgeArgs =
  {
    orderBy?: InputMaybe<Array<SsoDomainIdentityProvidersOrderBy>>;
  };

export type UpsertAutomationAuthorInput = {
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["UUID"]["input"];
  kind: AutomationKindEnum;
  name: Scalars["String"]["input"];
};

export type UpsertAutomationAuthorPayload = {
  __typename?: "UpsertAutomationAuthorPayload";
  automationAuthor: AutomationSource;
};

export type User = {
  __typename?: "User";
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  lastName: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  userType: UserType;
};

export type UserCognitoSettings = {
  __typename?: "UserCognitoSettings";
  preferredMfaSetting: MFAOption;
  username: Scalars["String"]["output"];
};

export type UserInviteCreated = Node & {
  __typename?: "UserInviteCreated";
  /** Reads a single `AuditorUser` that is related to this `UserInviteCreated`. */
  auditorUser?: Maybe<AuditorUser>;
  auditorUserId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads a single `MessageCreated` that is related to this `UserInviteCreated`. */
  message?: Maybe<MessageCreated>;
  messageId: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  temporaryPassword: Scalars["String"]["output"];
  updatedAt: Scalars["Datetime"]["output"];
};

export type UserInviteCreatedAggregates = {
  __typename?: "UserInviteCreatedAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserInviteCreatedDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `UserInviteCreated` object types. */
export type UserInviteCreatedAggregatesFilter = {
  /** Distinct count aggregate over matching `UserInviteCreated` objects. */
  distinctCount?: InputMaybe<UserInviteCreatedDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserInviteCreated` object to be included within the aggregate. */
  filter?: InputMaybe<UserInviteCreatedFilter>;
};

/** Input for the nested mutation of `auditorUser` in the `UserInviteCreatedInput` mutation. */
export type UserInviteCreatedAuditorUserIdFkeyInput = {
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<AuditorUserAuditorUserEmailUniqueKeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectById?: InputMaybe<AuditorUserAuditorUserPkeyConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByIdpSub?: InputMaybe<AuditorUserAuditorUserIdpSubUniqueConnect>;
  /** The primary key(s) for `auditorUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AuditorUserNodeIdConnect>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<AuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyUsingAuditorUserEmailUniqueKeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateById?: InputMaybe<AuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyUsingAuditorUserPkeyUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByIdpSub?: InputMaybe<AuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyUsingAuditorUserIdpSubUniqueUpdate>;
  /** The primary key(s) and patch data for `auditorUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserInviteCreatedOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `userInviteCreated` in the `AuditorUserInput` mutation. */
export type UserInviteCreatedAuditorUserIdFkeyInverseInput = {
  /** The primary key(s) for `userInviteCreated` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<UserInviteCreatedUserInviteCreatedPkeyConnect>
  >;
  /** The primary key(s) for `userInviteCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<UserInviteCreatedNodeIdConnect>>;
  /** A `UserInviteCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<UserInviteCreatedAuditorUserIdFkeyUserInviteCreatedCreateInput>
  >;
  /** The primary key(s) and patch data for `userInviteCreated` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<UserInviteCreatedOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyUsingUserInviteCreatedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `userInviteCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<AuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyNodeIdUpdate>
  >;
};

/** The `userInviteCreated` to be created by this mutation. */
export type UserInviteCreatedAuditorUserIdFkeyUserInviteCreatedCreateInput = {
  auditorUserToAuditorUserId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  messageCreatedToMessageId?: InputMaybe<UserInviteCreatedMessageIdFkeyInput>;
  messageId?: InputMaybe<Scalars["UUID"]["input"]>;
  temporaryPassword: Scalars["String"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/**
 * A condition to be used against `UserInviteCreated` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserInviteCreatedCondition = {
  /** Checks for equality with the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `messageId` field. */
  messageId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `temporaryPassword` field. */
  temporaryPassword?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type UserInviteCreatedDistinctCountAggregateFilter = {
  auditorUserId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  messageId?: InputMaybe<BigIntFilter>;
  temporaryPassword?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type UserInviteCreatedDistinctCountAggregates = {
  __typename?: "UserInviteCreatedDistinctCountAggregates";
  /** Distinct count of auditorUserId across the matching connection */
  auditorUserId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of messageId across the matching connection */
  messageId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of temporaryPassword across the matching connection */
  temporaryPassword?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars["BigInt"]["output"]>;
};

/** A filter to be used against `UserInviteCreated` object types. All fields are combined with a logical ‘and.’ */
export type UserInviteCreatedFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserInviteCreatedFilter>>;
  /** Filter by the object’s `auditorUser` relation. */
  auditorUser?: InputMaybe<AuditorUserFilter>;
  /** Filter by the object’s `auditorUserId` field. */
  auditorUserId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `message` relation. */
  message?: InputMaybe<MessageCreatedFilter>;
  /** Filter by the object’s `messageId` field. */
  messageId?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserInviteCreatedFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserInviteCreatedFilter>>;
  /** Filter by the object’s `temporaryPassword` field. */
  temporaryPassword?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `UserInviteCreated` for usage during aggregation. */
export enum UserInviteCreatedGroupBy {
  AUDITOR_USER_ID = "AUDITOR_USER_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  MESSAGE_ID = "MESSAGE_ID",
  TEMPORARY_PASSWORD = "TEMPORARY_PASSWORD",
  UPDATED_AT = "UPDATED_AT",
  UPDATED_AT_TRUNCATED_TO_DAY = "UPDATED_AT_TRUNCATED_TO_DAY",
  UPDATED_AT_TRUNCATED_TO_HOUR = "UPDATED_AT_TRUNCATED_TO_HOUR",
}

export type UserInviteCreatedHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserInviteCreatedHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `UserInviteCreated` aggregates. */
export type UserInviteCreatedHavingInput = {
  AND?: InputMaybe<Array<UserInviteCreatedHavingInput>>;
  OR?: InputMaybe<Array<UserInviteCreatedHavingInput>>;
  average?: InputMaybe<UserInviteCreatedHavingAverageInput>;
  distinctCount?: InputMaybe<UserInviteCreatedHavingDistinctCountInput>;
  max?: InputMaybe<UserInviteCreatedHavingMaxInput>;
  min?: InputMaybe<UserInviteCreatedHavingMinInput>;
  stddevPopulation?: InputMaybe<UserInviteCreatedHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserInviteCreatedHavingStddevSampleInput>;
  sum?: InputMaybe<UserInviteCreatedHavingSumInput>;
  variancePopulation?: InputMaybe<UserInviteCreatedHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserInviteCreatedHavingVarianceSampleInput>;
};

export type UserInviteCreatedHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserInviteCreatedHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserInviteCreatedHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserInviteCreatedHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserInviteCreatedHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserInviteCreatedHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserInviteCreatedHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `UserInviteCreated` */
export type UserInviteCreatedInput = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  messageCreatedToMessageId?: InputMaybe<UserInviteCreatedMessageIdFkeyInput>;
  messageId?: InputMaybe<Scalars["UUID"]["input"]>;
  temporaryPassword: Scalars["String"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Input for the nested mutation of `messageCreated` in the `UserInviteCreatedInput` mutation. */
export type UserInviteCreatedMessageIdFkeyInput = {
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectById?: InputMaybe<MessageCreatedMessageCreatedPkeyConnect>;
  /** The primary key(s) for `messageCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MessageCreatedNodeIdConnect>;
  /** A `MessageCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserInviteCreatedMessageIdFkeyMessageCreatedCreateInput>;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateById?: InputMaybe<MessageCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyUsingMessageCreatedPkeyUpdate>;
  /** The primary key(s) and patch data for `messageCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserInviteCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `userInviteCreated` in the `MessageCreatedInput` mutation. */
export type UserInviteCreatedMessageIdFkeyInverseInput = {
  /** The primary key(s) for `userInviteCreated` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<UserInviteCreatedUserInviteCreatedPkeyConnect>
  >;
  /** The primary key(s) for `userInviteCreated` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<UserInviteCreatedNodeIdConnect>>;
  /** A `UserInviteCreatedInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<UserInviteCreatedMessageIdFkeyUserInviteCreatedCreateInput>
  >;
  /** The primary key(s) and patch data for `userInviteCreated` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<UserInviteCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyUsingUserInviteCreatedPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `userInviteCreated` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<MessageCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyNodeIdUpdate>
  >;
};

/** The `messageCreated` to be created by this mutation. */
export type UserInviteCreatedMessageIdFkeyMessageCreatedCreateInput = {
  auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
  documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
  documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  kind: MessageCreatedKind;
  message?: InputMaybe<Scalars["String"]["input"]>;
  messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
  senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
};

/** The `userInviteCreated` to be created by this mutation. */
export type UserInviteCreatedMessageIdFkeyUserInviteCreatedCreateInput = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  messageCreatedToMessageId?: InputMaybe<UserInviteCreatedMessageIdFkeyInput>;
  temporaryPassword: Scalars["String"]["input"];
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type UserInviteCreatedNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userInviteCreated` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type UserInviteCreatedOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `auditorUser` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `auditorUser` being updated. */
    patch: AuditorUserPatch;
  };

/** The fields on `userInviteCreated` to look up the row to update. */
export type UserInviteCreatedOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyUsingUserInviteCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `userInviteCreated` being updated. */
    patch: updateUserInviteCreatedOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyPatch;
  };

/** The globally unique `ID` look up for the row to update. */
export type UserInviteCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `messageCreated` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `messageCreated` being updated. */
    patch: MessageCreatedPatch;
  };

/** The fields on `userInviteCreated` to look up the row to update. */
export type UserInviteCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyUsingUserInviteCreatedPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `userInviteCreated` being updated. */
    patch: updateUserInviteCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyPatch;
  };

/** Represents an update to a `UserInviteCreated`. Fields that are set will be updated. */
export type UserInviteCreatedPatch = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInput>;
  messageCreatedToMessageId?: InputMaybe<UserInviteCreatedMessageIdFkeyInput>;
  messageId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `userInviteCreated` to look up the row to connect. */
export type UserInviteCreatedUserInviteCreatedPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `UserInviteCreated` values. */
export type UserInviteCreatedsConnection = {
  __typename?: "UserInviteCreatedsConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserInviteCreatedAggregates>;
  /** A list of edges which contains the `UserInviteCreated` and cursor to aid in pagination. */
  edges: Array<UserInviteCreatedsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserInviteCreatedAggregates>>;
  /** A list of `UserInviteCreated` objects. */
  nodes: Array<Maybe<UserInviteCreated>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserInviteCreated` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `UserInviteCreated` values. */
export type UserInviteCreatedsConnectiongroupedAggregatesArgs = {
  groupBy: Array<UserInviteCreatedGroupBy>;
  having?: InputMaybe<UserInviteCreatedHavingInput>;
};

/** A `UserInviteCreated` edge in the connection. */
export type UserInviteCreatedsEdge = {
  __typename?: "UserInviteCreatedsEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `UserInviteCreated` at the end of the edge. */
  node?: Maybe<UserInviteCreated>;
};

/** Methods to use when ordering `UserInviteCreated`. */
export enum UserInviteCreatedsOrderBy {
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__CREATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__EMAIL_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__FIRST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__INTERNAL_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__LAST_NAME_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__MIGRATED_TO_FEDERATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PRE_SSO_MIGRATION_IDP_SUB_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__PROVIDER_ID_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__READ_ONLY_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__TITLE_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__UPDATED_AT_DESC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_ASC",
  AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC = "AUDITOR_USER_BY_AUDITOR_USER_ID__USER_TYPE_DESC",
  AUDITOR_USER_ID_ASC = "AUDITOR_USER_ID_ASC",
  AUDITOR_USER_ID_DESC = "AUDITOR_USER_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__CREATED_AT_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__CREATED_AT_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__CREATED_AT_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__CREATED_AT_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_REQUEST_CREATED_ID_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__DOCUMENT_UPLOAD_CREATED_ID_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__ID_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__ID_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__ID_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__ID_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__KIND_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__KIND_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__KIND_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__KIND_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__MESSAGE_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__MESSAGE_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__MESSAGE_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__MESSAGE_DESC",
  MESSAGE_CREATED_BY_MESSAGE_ID__SENDER_USER_ID_ASC = "MESSAGE_CREATED_BY_MESSAGE_ID__SENDER_USER_ID_ASC",
  MESSAGE_CREATED_BY_MESSAGE_ID__SENDER_USER_ID_DESC = "MESSAGE_CREATED_BY_MESSAGE_ID__SENDER_USER_ID_DESC",
  MESSAGE_ID_ASC = "MESSAGE_ID_ASC",
  MESSAGE_ID_DESC = "MESSAGE_ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  TEMPORARY_PASSWORD_ASC = "TEMPORARY_PASSWORD_ASC",
  TEMPORARY_PASSWORD_DESC = "TEMPORARY_PASSWORD_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
}

export type UserMfaPreferenceInput = {
  userCode: Scalars["String"]["input"];
};

export type UserMfaPreferenceResponse = {
  __typename?: "UserMfaPreferenceResponse";
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type UserProfile = {
  __typename?: "UserProfile";
  addressCity: Scalars["String"]["output"];
  addressState: Scalars["String"]["output"];
  addressStreet: Scalars["String"]["output"];
  addressZipcode: Scalars["String"]["output"];
  avatar: Scalars["String"]["output"];
  company: Scalars["String"]["output"];
  mfaType: Scalars["String"]["output"];
  mobilePhoneNumber: Scalars["String"]["output"];
  workPhoneNumber: Scalars["String"]["output"];
};

export type UserProfileInput = {
  addressCity: Scalars["String"]["input"];
  addressState: Scalars["String"]["input"];
  addressStreet: Scalars["String"]["input"];
  addressZipcode: Scalars["String"]["input"];
  avatar: Scalars["String"]["input"];
  company: Scalars["String"]["input"];
  workPhoneNumber: Scalars["String"]["input"];
};

export enum UserType {
  ADMINISTRATOR = "ADMINISTRATOR",
  AUDITOR = "AUDITOR",
  PAYER = "PAYER",
  PROVIDER = "PROVIDER",
  SYS = "SYS",
}

export enum UserTypeEnum {
  ADMINISTRATOR = "ADMINISTRATOR",
  AUDITOR = "AUDITOR",
  PAYER = "PAYER",
  PROVIDER = "PROVIDER",
  SYS = "SYS",
}

/** A filter to be used against UserTypeEnum fields. All fields are combined with a logical ‘and.’ */
export type UserTypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserTypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserTypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserTypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserTypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserTypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserTypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserTypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserTypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserTypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserTypeEnum>>;
};

export type VersionAuditFindingsInput = {
  auditFindingReviewValues: Array<AuditFindingReviewValuesInput>;
  authorId: Scalars["UUID"]["input"];
};

export type WorkflowClaimState = Node & {
  __typename?: "WorkflowClaimState";
  /** Reads a single `BatchClaim` that is related to this `WorkflowClaimState`. */
  batchClaim?: Maybe<BatchClaim>;
  batchClaimId: Scalars["UUID"]["output"];
  createdAt: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars["ID"]["output"];
  workflowState: Scalars["String"]["output"];
};

export type WorkflowClaimStateAggregates = {
  __typename?: "WorkflowClaimStateAggregates";
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<WorkflowClaimStateDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** A filter to be used against aggregates of `WorkflowClaimState` object types. */
export type WorkflowClaimStateAggregatesFilter = {
  /** Distinct count aggregate over matching `WorkflowClaimState` objects. */
  distinctCount?: InputMaybe<WorkflowClaimStateDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `WorkflowClaimState` object to be included within the aggregate. */
  filter?: InputMaybe<WorkflowClaimStateFilter>;
};

/** Input for the nested mutation of `batchClaim` in the `WorkflowClaimStateInput` mutation. */
export type WorkflowClaimStateBatchClaimIdFkInput = {
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIcn?: InputMaybe<BatchClaimBatchClaimIcnKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectById?: InputMaybe<BatchClaimBatchClaimPkeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByIdAndInsurerId?: InputMaybe<BatchClaimBatchClaimIdInsurerKeyConnect>;
  /** The primary key(s) for `batchClaim` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<BatchClaimNodeIdConnect>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIcn?: InputMaybe<BatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkUsingBatchClaimIcnKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateById?: InputMaybe<BatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkUsingBatchClaimPkeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByIdAndInsurerId?: InputMaybe<BatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkUsingBatchClaimIdInsurerKeyUpdate>;
  /** The primary key(s) and patch data for `batchClaim` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<WorkflowClaimStateOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkNodeIdUpdate>;
};

/** Input for the nested mutation of `workflowClaimState` in the `BatchClaimInput` mutation. */
export type WorkflowClaimStateBatchClaimIdFkInverseInput = {
  /** The primary key(s) for `workflowClaimState` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<WorkflowClaimStateWorkflowClaimStatePkeyConnect>
  >;
  /** The primary key(s) for `workflowClaimState` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<WorkflowClaimStateNodeIdConnect>>;
  /** A `WorkflowClaimStateInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowClaimStateBatchClaimIdFkWorkflowClaimStateCreateInput>
  >;
  /** The primary key(s) and patch data for `workflowClaimState` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowClaimStateOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkUsingWorkflowClaimStatePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `workflowClaimState` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<
    Array<BatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkNodeIdUpdate>
  >;
};

/** The `workflowClaimState` to be created by this mutation. */
export type WorkflowClaimStateBatchClaimIdFkWorkflowClaimStateCreateInput = {
  batchClaimToBatchClaimId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowState?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * A condition to be used against `WorkflowClaimState` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WorkflowClaimStateCondition = {
  /** Checks for equality with the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `workflowState` field. */
  workflowState?: InputMaybe<Scalars["String"]["input"]>;
};

export type WorkflowClaimStateDistinctCountAggregateFilter = {
  batchClaimId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  workflowState?: InputMaybe<BigIntFilter>;
};

export type WorkflowClaimStateDistinctCountAggregates = {
  __typename?: "WorkflowClaimStateDistinctCountAggregates";
  /** Distinct count of batchClaimId across the matching connection */
  batchClaimId?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars["BigInt"]["output"]>;
  /** Distinct count of workflowState across the matching connection */
  workflowState?: Maybe<Scalars["BigInt"]["output"]>;
};

export enum WorkflowClaimStateEnum {
  CLAIM_READY = "CLAIM_READY",
  CLAIM_RECEIVED = "CLAIM_RECEIVED",
  CLOSED = "CLOSED",
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  REPORTED_TO_CLIENT = "REPORTED_TO_CLIENT",
  REPORTED_TO_PROVIDER = "REPORTED_TO_PROVIDER",
  TO_DO = "TO_DO",
}

/** A filter to be used against WorkflowClaimStateEnum fields. All fields are combined with a logical ‘and.’ */
export type WorkflowClaimStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<WorkflowClaimStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<WorkflowClaimStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<WorkflowClaimStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<WorkflowClaimStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<WorkflowClaimStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<WorkflowClaimStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<WorkflowClaimStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<WorkflowClaimStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<WorkflowClaimStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<WorkflowClaimStateEnum>>;
};

/** A filter to be used against `WorkflowClaimState` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowClaimStateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowClaimStateFilter>>;
  /** Filter by the object’s `batchClaim` relation. */
  batchClaim?: InputMaybe<BatchClaimFilter>;
  /** Filter by the object’s `batchClaimId` field. */
  batchClaimId?: InputMaybe<UUIDFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UUIDFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowClaimStateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowClaimStateFilter>>;
  /** Filter by the object’s `workflowState` field. */
  workflowState?: InputMaybe<StringFilter>;
};

/** Grouping methods for `WorkflowClaimState` for usage during aggregation. */
export enum WorkflowClaimStateGroupBy {
  BATCH_CLAIM_ID = "BATCH_CLAIM_ID",
  CREATED_AT = "CREATED_AT",
  CREATED_AT_TRUNCATED_TO_DAY = "CREATED_AT_TRUNCATED_TO_DAY",
  CREATED_AT_TRUNCATED_TO_HOUR = "CREATED_AT_TRUNCATED_TO_HOUR",
  WORKFLOW_STATE = "WORKFLOW_STATE",
}

export type WorkflowClaimStateHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type WorkflowClaimStateHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `WorkflowClaimState` aggregates. */
export type WorkflowClaimStateHavingInput = {
  AND?: InputMaybe<Array<WorkflowClaimStateHavingInput>>;
  OR?: InputMaybe<Array<WorkflowClaimStateHavingInput>>;
  average?: InputMaybe<WorkflowClaimStateHavingAverageInput>;
  distinctCount?: InputMaybe<WorkflowClaimStateHavingDistinctCountInput>;
  max?: InputMaybe<WorkflowClaimStateHavingMaxInput>;
  min?: InputMaybe<WorkflowClaimStateHavingMinInput>;
  stddevPopulation?: InputMaybe<WorkflowClaimStateHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<WorkflowClaimStateHavingStddevSampleInput>;
  sum?: InputMaybe<WorkflowClaimStateHavingSumInput>;
  variancePopulation?: InputMaybe<WorkflowClaimStateHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<WorkflowClaimStateHavingVarianceSampleInput>;
};

export type WorkflowClaimStateHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type WorkflowClaimStateHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type WorkflowClaimStateHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type WorkflowClaimStateHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type WorkflowClaimStateHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type WorkflowClaimStateHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

export type WorkflowClaimStateHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
};

/** An input for mutations affecting `WorkflowClaimState` */
export type WorkflowClaimStateInput = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowState?: InputMaybe<Scalars["String"]["input"]>;
};

/** The globally unique `ID` look up for the row to connect. */
export type WorkflowClaimStateNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `workflowClaimState` to be connected. */
  nodeId: Scalars["ID"]["input"];
};

/** The globally unique `ID` look up for the row to update. */
export type WorkflowClaimStateOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkNodeIdUpdate =
  {
    /** The globally unique `ID` which identifies a single `batchClaim` to be connected. */
    nodeId: Scalars["ID"]["input"];
    /** An object where the defined keys will be set on the `batchClaim` being updated. */
    patch: BatchClaimPatch;
  };

/** The fields on `workflowClaimState` to look up the row to update. */
export type WorkflowClaimStateOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkUsingWorkflowClaimStatePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowClaimState` being updated. */
    patch: updateWorkflowClaimStateOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkPatch;
  };

/** Represents an update to a `WorkflowClaimState`. Fields that are set will be updated. */
export type WorkflowClaimStatePatch = {
  batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimToBatchClaimId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInput>;
};

/** The fields on `workflowClaimState` to look up the row to connect. */
export type WorkflowClaimStateWorkflowClaimStatePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `WorkflowClaimState` values. */
export type WorkflowClaimStatesConnection = {
  __typename?: "WorkflowClaimStatesConnection";
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<WorkflowClaimStateAggregates>;
  /** A list of edges which contains the `WorkflowClaimState` and cursor to aid in pagination. */
  edges: Array<WorkflowClaimStatesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<WorkflowClaimStateAggregates>>;
  /** A list of `WorkflowClaimState` objects. */
  nodes: Array<Maybe<WorkflowClaimState>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowClaimState` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A connection to a list of `WorkflowClaimState` values. */
export type WorkflowClaimStatesConnectiongroupedAggregatesArgs = {
  groupBy: Array<WorkflowClaimStateGroupBy>;
  having?: InputMaybe<WorkflowClaimStateHavingInput>;
};

/** A `WorkflowClaimState` edge in the connection. */
export type WorkflowClaimStatesEdge = {
  __typename?: "WorkflowClaimStatesEdge";
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WorkflowClaimState` at the end of the edge. */
  node?: Maybe<WorkflowClaimState>;
};

/** Methods to use when ordering `WorkflowClaimState`. */
export enum WorkflowClaimStatesOrderBy {
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADMIT_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ADM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_CHARGED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AMOUNT_REIMBURSED_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__APR_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__AUTHOR_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BATCH_FILE_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__BILL_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLAIM_TYPE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_GROUP_NAME_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_LINE_OF_BUSINESS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CLIENT_PLAN_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__COMPUTATION_STRATEGY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__CREATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_ADMIT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_DISCHARGE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_END_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DATE_OF_SERVICE_START_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DIAG_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DISCHARGE_STATUS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DOCUMENT_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__DRG_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ICN_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__INSURER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__LIFECYCLE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__ON_HOLD_BLOCKER_STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__OWNER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAID_DATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_CONTROL_NUMBER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_DOB_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_GENDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PATIENT_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PAYMENT_RATE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PERMITTED_INSURER_USERS_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PHASE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_11_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_12_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_13_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_14_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_15_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_16_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_17_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_18_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_19_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_20_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_21_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_22_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_23_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_24_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__POA_25_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREPAY_DENY_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PREVIOUS_VERSION_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_DIAG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_POA_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PRINCIPAL_PROCEDURE_CODE_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_1_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_2_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_3_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_4_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_5_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_6_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_7_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_8_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_9_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROCEDURE_CODE_10_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__PROVIDER_ID_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__STAGE_SORT_ORDER_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__SUBMITTED_DRG_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__UPDATED_AT_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_DESC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_ASC",
  BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC = "BATCH_CLAIM_BY_BATCH_CLAIM_ID__VERSION_GROUP_DESC",
  BATCH_CLAIM_ID_ASC = "BATCH_CLAIM_ID_ASC",
  BATCH_CLAIM_ID_DESC = "BATCH_CLAIM_ID_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  ID_ASC = "ID_ASC",
  ID_DESC = "ID_DESC",
  NATURAL = "NATURAL",
  PRIMARY_KEY_ASC = "PRIMARY_KEY_ASC",
  PRIMARY_KEY_DESC = "PRIMARY_KEY_DESC",
  WORKFLOW_STATE_ASC = "WORKFLOW_STATE_ASC",
  WORKFLOW_STATE_DESC = "WORKFLOW_STATE_DESC",
}

/** An object where the defined keys will be set on the `activeClaimAssignee` being updated. */
export type updateActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyPatch =
  {
    auditorUserToAuditorUserId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `activeClaimAssignee` being updated. */
export type updateActiveClaimAssigneeOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyPatch =
  {
    auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuditorUserId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `auditFindingJob` being updated. */
export type updateAuditFindingJobOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyPatch =
  {
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingJobAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<AuditFindingJobBatchFileIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `auditFindingJob` being updated. */
export type updateAuditFindingJobOnAuditFindingJobForAuditFindingJobAuthorIdFkeyPatch =
  {
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingJobAuthorIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<AuditFindingJobBatchFileIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `auditFindingJob` being updated. */
export type updateAuditFindingJobOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyPatch =
  {
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingJobAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<AuditFindingJobBatchFileIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyPatch =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnAuditFindingForAuditFindingClaimLineAuditFindingJobIdFkeyPatch =
  {
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyPatch =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyPatch =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyPatch =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnAuditFindingForAuditFindingClaimLinePreviousVersionIdFkeyPatch =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyPatch =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyPatch =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyPatch =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyPatch =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyPatch =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFinding` being updated. */
export type updateAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyPatch =
  {
    auditFindingJobId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingJobToAuditFindingJobId?: InputMaybe<AuditFindingClaimLineAuditFindingJobIdFkeyInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInverseInput>;
    auditFindingReviewToReviewIdUsingId?: InputMaybe<AuditFindingReviewReviewIdFkeyInverseInput>;
    auditFindingReviewsToOriginalIdUsingId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInverseInput>;
    auditFindingRuleType?: InputMaybe<Scalars["String"]["input"]>;
    auditFindingRuleTypeToAuditFindingRuleType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInput>;
    auditFindingSeedType?: InputMaybe<AuditFindingSeedType>;
    auditFindingToPreviousVersionId?: InputMaybe<AuditFindingClaimLinePreviousVersionIdFkeyInput>;
    auditType?: InputMaybe<AuditTypeEnum>;
    auditorComment?: InputMaybe<Scalars["String"]["input"]>;
    auditorReviewed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The id of the autodor finding that was used to create this finding. References and ID in an S3 JSON file, will soon be converted to a proper foreign key to autodor"s table of findings */
    autodorFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The s3 bucket location of the file that contains the autodor finding that was used to create this audit finding. Together with the autodor_finding_id allows one to query the upstream autodor data. This is a temporary measure until there is a proper foreign key to the autodor service tables, or an API endpoint for autodor to serve suggested findings based on the autodor_finding_id */
    autodorFindingS3Key?: InputMaybe<Scalars["String"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditUsingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInput>;
    confidence?: InputMaybe<Scalars["BigFloat"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    improperPaymentCost?: InputMaybe<Scalars["Float"]["input"]>;
    improperPaymentReason?: InputMaybe<Scalars["String"]["input"]>;
    improperPaymentUnitsCharged?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataAocPrimaryCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataEmCorrectLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataEmOriginalLevel?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueAjudicationValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciMueOhpMueValue?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataNcciPtpCode?: InputMaybe<Scalars["String"]["input"]>;
    metaDataNcciPtpModifier?: InputMaybe<Scalars["Int"]["input"]>;
    metaDataPricingCorrectPrice?: InputMaybe<Scalars["BigFloat"]["input"]>;
    metaDataUnitsCorrectUnits?: InputMaybe<Scalars["Int"]["input"]>;
    needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInverseInput>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInverseInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFindingReasonCode` being updated. */
export type updateAuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuditFindingIdFkeyPatch =
  {
    auditFindingToAuditFindingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    reasonCodeId?: InputMaybe<Scalars["String"]["input"]>;
    reasonCodeToReasonCodeId?: InputMaybe<AuditFindingReasonCodeReasonCodeIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFindingReasonCode` being updated. */
export type updateAuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyPatch =
  {
    auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingToAuditFindingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    reasonCodeId?: InputMaybe<Scalars["String"]["input"]>;
    reasonCodeToReasonCodeId?: InputMaybe<AuditFindingReasonCodeReasonCodeIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFindingReasonCode` being updated. */
export type updateAuditFindingReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyPatch =
  {
    auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingToAuditFindingId?: InputMaybe<AuditFindingReasonCodeAuditFindingIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    reasonCodeToReasonCodeId?: InputMaybe<AuditFindingReasonCodeReasonCodeIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFindingReport` being updated. */
export type updateAuditFindingReportOnAuditFindingReportForAuditFindingReportInsurerIdFkeyPatch =
  {
    auditFindingReportToOriginalVersionId?: InputMaybe<AuditFindingReportOriginalVersionIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInput>;
    auditorUserToPrimaryPiaId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditFindingReportInsurerIdFkeyInput>;
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    primaryPiaId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInverseInput>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `auditFindingReport` being updated. */
export type updateAuditFindingReportOnAuditFindingReportForAuditFindingReportOriginalVersionIdFkeyPatch =
  {
    auditFindingReportToOriginalVersionId?: InputMaybe<AuditFindingReportOriginalVersionIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInput>;
    auditorUserToPrimaryPiaId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditFindingReportInsurerIdFkeyInput>;
    primaryPiaId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInverseInput>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `auditFindingReport` being updated. */
export type updateAuditFindingReportOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyPatch =
  {
    auditFindingReportToOriginalVersionId?: InputMaybe<AuditFindingReportOriginalVersionIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInput>;
    auditorUserToPrimaryPiaId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditFindingReportInsurerIdFkeyInput>;
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInverseInput>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `auditFindingReport` being updated. */
export type updateAuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyPatch =
  {
    auditFindingReportToOriginalVersionId?: InputMaybe<AuditFindingReportOriginalVersionIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInput>;
    auditorUserToPrimaryPiaId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditFindingReportInsurerIdFkeyInput>;
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    primaryPiaId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInverseInput>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `auditFindingReport` being updated. */
export type updateAuditFindingReportOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyPatch =
  {
    auditFindingReportToOriginalVersionId?: InputMaybe<AuditFindingReportOriginalVersionIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInput>;
    auditorUserToPrimaryPiaId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditFindingReportInsurerIdFkeyInput>;
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    primaryPiaId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerToProviderId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInverseInput>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `auditFindingReport` being updated. */
export type updateAuditFindingReportOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdPatch =
  {
    auditFindingReportToOriginalVersionId?: InputMaybe<AuditFindingReportOriginalVersionIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInput>;
    auditorUserToPrimaryPiaId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditFindingReportInsurerIdFkeyInput>;
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    primaryPiaId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInverseInput>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `auditFindingReport` being updated. */
export type updateAuditFindingReportOnReportedFindingForReportedFindingAuditFindingReportIdFkeyPatch =
  {
    auditFindingReportToOriginalVersionId?: InputMaybe<AuditFindingReportOriginalVersionIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInput>;
    auditorUserToPrimaryPiaId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditFindingReportInsurerIdFkeyInput>;
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    primaryPiaId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInverseInput>;
    reportedFindingsUsingId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `auditFindingReview` being updated. */
export type updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyPatch =
  {
    auditFindingToOriginalId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInput>;
    auditFindingToReviewId?: InputMaybe<AuditFindingReviewReviewIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInput>;
    originalId?: InputMaybe<Scalars["UUID"]["input"]>;
    reviewId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFindingReview` being updated. */
export type updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewOriginalIdFkeyPatch =
  {
    auditFindingToOriginalId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInput>;
    auditFindingToReviewId?: InputMaybe<AuditFindingReviewReviewIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    reviewId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFindingReview` being updated. */
export type updateAuditFindingReviewOnAuditFindingReviewForAuditFindingReviewReviewIdFkeyPatch =
  {
    auditFindingToOriginalId?: InputMaybe<AuditFindingReviewOriginalIdFkeyInput>;
    auditFindingToReviewId?: InputMaybe<AuditFindingReviewReviewIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    originalId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditFindingRuleType` being updated. */
export type updateAuditFindingRuleTypeOnAuditFindingForAuditFindingAuditFindingRuleTypeFkeyPatch =
  {
    auditFindingsUsingType?: InputMaybe<AuditFindingAuditFindingRuleTypeFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `auditorBucketAssignee` being updated. */
export type updateAuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyPatch =
  {
    auditorBucketToAuditorBucketId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInput>;
    auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuditorUserId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `auditorBucketAssignee` being updated. */
export type updateAuditorBucketAssigneeOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyPatch =
  {
    auditorBucketId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorBucketToAuditorBucketId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInput>;
    auditorUserToAuditorUserId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `auditorBucket` being updated. */
export type updateAuditorBucketOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorBucketIdFkeyPatch =
  {
    assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
    auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    filter?: InputMaybe<Scalars["JSON"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditorBucket` being updated. */
export type updateAuditorBucketOnAuditorBucketForAuditorBucketAssigneeIdFkeyPatch =
  {
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
    auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    filter?: InputMaybe<Scalars["JSON"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditorBucket` being updated. */
export type updateAuditorBucketOnAuditorBucketForAuditorBucketAuthorIdFkeyPatch =
  {
    assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
    auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
    bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    filter?: InputMaybe<Scalars["JSON"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditorBucket` being updated. */
export type updateAuditorBucketOnAuditorBucketForAuditorBucketInsurerIdFkeyPatch =
  {
    assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
    auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    filter?: InputMaybe<Scalars["JSON"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditorBucket` being updated. */
export type updateAuditorBucketOnAuditorBucketForFkeyAuditorBucketProviderIdPatch =
  {
    assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
    auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    filter?: InputMaybe<Scalars["JSON"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditorBucket` being updated. */
export type updateAuditorBucketOnBucketClaimForBucketClaimAuditorBucketIdFkeyPatch =
  {
    assigneeId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorBucketIdFkeyInverseInput>;
    auditorUserToAssigneeId?: InputMaybe<AuditorBucketAssigneeIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<AuditorBucketAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    bucketClaimsUsingId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dueDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    filter?: InputMaybe<Scalars["JSON"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<AuditorBucketInsurerIdFkeyInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<FkeyAuditorBucketProviderIdInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnActiveClaimAssigneeForActiveClaimAssigneesAuditorUserIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnAuditFindingForAuditFindingClaimLineAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnAuditFindingJobForAuditFindingJobAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnAuditFindingReasonCodeForAuditFindingReasonCodeAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnAuditFindingReportForAuditFindingReportPrimaryPiaIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnAuditFindingReportForPreliminaryAuditFindingReportAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnAuditFindingReviewForAuditFindingReviewAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnAuditorBucketAssigneeForAuditorBucketAssigneeAuditorUserIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnAuditorBucketForAuditorBucketAssigneeIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnAuditorBucketForAuditorBucketAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnAuditorUserForAuditorUserProviderIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
  auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
  auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
  auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
  auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
  auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
  auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
  batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
  batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
  batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
  batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
  batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
  claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The sub (id) generated by the external IDP system (e.g. Cognito) */
  idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
  internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
  messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
  /** Timestamp when user migrated to federated SSO via first login. */
  migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
  /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
  preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
  providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
  queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
  userType?: InputMaybe<UserTypeEnum>;
};

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnBatchClaimForBatchClaimAuthorIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
  auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
  auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
  auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
  auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
  auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
  auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
  batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
  batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
  batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
  batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
  batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
  claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The sub (id) generated by the external IDP system (e.g. Cognito) */
  idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
  internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
  messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
  /** Timestamp when user migrated to federated SSO via first login. */
  migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
  /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
  preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
  providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
  queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
  userType?: InputMaybe<UserTypeEnum>;
};

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnBatchFileForBatchFileAuthorIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
  auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
  auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
  auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
  auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
  auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
  auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
  batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
  batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
  batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
  batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
  batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
  claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The sub (id) generated by the external IDP system (e.g. Cognito) */
  idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
  internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
  messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
  /** Timestamp when user migrated to federated SSO via first login. */
  migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
  /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
  preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
  providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
  queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
  userType?: InputMaybe<UserTypeEnum>;
};

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnDisputedFindingForDisputedFindingAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnInsurerUserForInsurerUserAuditorUserIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnMessageCreatedForMessageCreatedSenderUserIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnMessageSentForMessageSentRecipientUserIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnNnIbLineForNnIbLineAuthorIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
  auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
  auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
  auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
  auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
  auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
  auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
  batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
  batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
  batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
  batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
  batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
  claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The sub (id) generated by the external IDP system (e.g. Cognito) */
  idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
  internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
  messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
  /** Timestamp when user migrated to federated SSO via first login. */
  migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
  /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
  preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
  providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
  queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
  userType?: InputMaybe<UserTypeEnum>;
};

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnQaClaimStateRowForQaClaimStateCreatedByFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnQueueForQueueAuthorIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
  auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
  auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
  auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
  auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
  auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
  auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
  auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
  auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
  batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
  batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
  batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
  batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
  batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
  claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The sub (id) generated by the external IDP system (e.g. Cognito) */
  idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
  internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
  messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
  /** Timestamp when user migrated to federated SSO via first login. */
  migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
  /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
  preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
  providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
  queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
  userType?: InputMaybe<UserTypeEnum>;
};

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `auditorUser` being updated. */
export type updateAuditorUserOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesAuditorUserIdFkeyInverseInput>;
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobAuthorIdFkeyInverseInput>;
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeAuthorIdFkeyInverseInput>;
    auditFindingReportsToAuthorIdUsingId?: InputMaybe<PreliminaryAuditFindingReportAuthorIdFkeyInverseInput>;
    auditFindingReportsToPrimaryPiaIdUsingId?: InputMaybe<AuditFindingReportPrimaryPiaIdFkeyInverseInput>;
    auditFindingReviewsUsingId?: InputMaybe<AuditFindingReviewAuthorIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineAuthorIdFkeyInverseInput>;
    auditorBucketAssigneesUsingId?: InputMaybe<AuditorBucketAssigneeAuditorUserIdFkeyInverseInput>;
    auditorBucketsToAssigneeIdUsingId?: InputMaybe<AuditorBucketAssigneeIdFkeyInverseInput>;
    auditorBucketsToAuthorIdUsingId?: InputMaybe<AuditorBucketAuthorIdFkeyInverseInput>;
    batchClaimAppealedsUsingId?: InputMaybe<BatchClaimAppealedCreatedByFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInverseInput>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInverseInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInverseInput>;
    batchClaimTechDenialsUsingId?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimAuthorIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileAuthorIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupCreatedByFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingAuthorIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateCreatedByFkeyInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    /** The sub (id) generated by the external IDP system (e.g. Cognito) */
    idpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerUsersUsingId?: InputMaybe<InsurerUserAuditorUserIdFkeyInverseInput>;
    internalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedSenderUserIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentRecipientUserIdFkeyInverseInput>;
    /** Timestamp when user migrated to federated SSO via first login. */
    migratedToFederatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    nnIbLinesUsingId?: InputMaybe<NnIbLineAuthorIdFkeyInverseInput>;
    /** Original native Cognito sub before SSO migration. NULL for non-migrated users. */
    preSsoMigrationIdpSub?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<AuditorUserProviderIdFkeyInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInverseInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateCreatedByFkeyInverseInput>;
    queuesUsingId?: InputMaybe<QueueAuthorIdFkeyInverseInput>;
    readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    reviewedAuditFindingsUsingId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInverseInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInverseInput>;
    userType?: InputMaybe<UserTypeEnum>;
  };

/** An object where the defined keys will be set on the `batchClaimAppealed` being updated. */
export type updateBatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyPatch =
  {
    appealed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToCreatedBy?: InputMaybe<BatchClaimAppealedCreatedByFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimAppealed` being updated. */
export type updateBatchClaimAppealedOnBatchClaimAppealedForBatchClaimAppealedCreatedByFkeyPatch =
  {
    appealed?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditorUserToCreatedBy?: InputMaybe<BatchClaimAppealedCreatedByFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimAssignee` being updated. */
export type updateBatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeAuditorUserIdFkeyPatch =
  {
    auditorUserToAuditorUserId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimAssignee` being updated. */
export type updateBatchClaimAssigneeOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyPatch =
  {
    auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuditorUserId?: InputMaybe<BatchClaimAssigneeAuditorUserIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimAuditStartDate` being updated. */
export type updateBatchClaimAuditStartDateOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimAuditType` being updated. */
export type updateBatchClaimAuditTypeOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyPatch =
  {
    auditType?: InputMaybe<ClaimAuditType>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimAuditor` being updated. */
export type updateBatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorAuditorUserIdFkeyPatch =
  {
    auditorUserToAuditorUserId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimAuditor` being updated. */
export type updateBatchClaimAuditorOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyPatch =
  {
    auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuditorUserId?: InputMaybe<BatchClaimAuditorAuditorUserIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimClientRecoveryAmount` being updated. */
export type updateBatchClaimClientRecoveryAmountOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimClientRecoveryCollectionDate` being updated. */
export type updateBatchClaimClientRecoveryCollectionDateOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimDocument` being updated. */
export type updateBatchClaimDocumentOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInput>;
    /**
     * Marks this document as the primary medical record for the batch claim. Nullable-or-TRUE; FALSE is disallowed. At most one document per batch_claim_id may have this set to TRUE (enforced by the deferrable compound UNIQUE constraint on (batch_claim_id, is_primary_medical_record) — NULLs are distinct so only TRUE rows collide).
     *
     * @omit create,update
     */
    isPrimaryMedicalRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimDueDate` being updated. */
export type updateBatchClaimDueDateOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInput>;
  };

/** An object where the defined keys will be set on the `batchClaimLineComputedValue` being updated. */
export type updateBatchClaimLineComputedValueOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyPatch =
  {
    batchClaimLineToId?: InputMaybe<BatchClaimLineComputedValuesIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
export type updateBatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuditFindingClaimLineIdFkeyPatch =
  {
    auditFindingToAuditFindingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
export type updateBatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditAuthorIdFkeyPatch =
  {
    auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingToAuditFindingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInput>;
    batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItemAudit` being updated. */
export type updateBatchClaimLineItemAuditOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyPatch =
  {
    auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingToAuditFindingId?: InputMaybe<BatchClaimLineItemAuditAuditFindingClaimLineIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuditAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItemComputedValue` being updated. */
export type updateBatchClaimLineItemComputedValueOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyPatch =
  {
    batchClaimLineItemToId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
export type updateBatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineAuthorIdFkeyPatch =
  {
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInput>;
    batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    nnIbLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    nnIbLineToNnIbLineId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
export type updateBatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyPatch =
  {
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    nnIbLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    nnIbLineToNnIbLineId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItemNnIbLine` being updated. */
export type updateBatchClaimLineItemNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyPatch =
  {
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemNnIbLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemToBatchClaimLineItemId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    nnIbLineToNnIbLineId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
export type updateBatchClaimLineItemOnBatchClaimLineItemAuditForBatchClaimLineItemAuditBatchClaimLineItemIdFkeyPatch =
  {
    /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
    alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceStart?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    itemNumber?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the order of the IB line in the source CSV input. */
    lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
    originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
    /**
     * ### original_version_id
     *  Original version id, used in versioning
     */
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    /**
     * ### previous_version_id
     *  Previous version id, used in versioning
     */
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    procedureCode?: InputMaybe<Scalars["String"]["input"]>;
    procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
    revCode?: InputMaybe<Scalars["String"]["input"]>;
    /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
    s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
    tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
    unitCharge?: InputMaybe<Scalars["BigFloat"]["input"]>;
    units?: InputMaybe<Scalars["Int"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    /**
     * ### version_fingerprint
     *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
     */
    versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
export type updateBatchClaimLineItemOnBatchClaimLineItemComputedValueForBatchClaimLineItemComputedValuesIdFkeyPatch =
  {
    /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
    alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceStart?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
    itemNumber?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the order of the IB line in the source CSV input. */
    lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
    originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
    /**
     * ### original_version_id
     *  Original version id, used in versioning
     */
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    /**
     * ### previous_version_id
     *  Previous version id, used in versioning
     */
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    procedureCode?: InputMaybe<Scalars["String"]["input"]>;
    procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
    revCode?: InputMaybe<Scalars["String"]["input"]>;
    /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
    s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
    tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
    unitCharge?: InputMaybe<Scalars["BigFloat"]["input"]>;
    units?: InputMaybe<Scalars["Int"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    /**
     * ### version_fingerprint
     *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
     */
    versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
export type updateBatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemAuthorIdFkeyPatch =
  {
    /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
    alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceStart?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    itemNumber?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the order of the IB line in the source CSV input. */
    lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
    originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
    /**
     * ### original_version_id
     *  Original version id, used in versioning
     */
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    /**
     * ### previous_version_id
     *  Previous version id, used in versioning
     */
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    procedureCode?: InputMaybe<Scalars["String"]["input"]>;
    procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
    revCode?: InputMaybe<Scalars["String"]["input"]>;
    /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
    s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
    tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
    unitCharge?: InputMaybe<Scalars["BigFloat"]["input"]>;
    units?: InputMaybe<Scalars["Int"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    /**
     * ### version_fingerprint
     *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
     */
    versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
export type updateBatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyPatch =
  {
    /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
    alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceStart?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    itemNumber?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the order of the IB line in the source CSV input. */
    lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
    originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
    /**
     * ### original_version_id
     *  Original version id, used in versioning
     */
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    /**
     * ### previous_version_id
     *  Previous version id, used in versioning
     */
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    procedureCode?: InputMaybe<Scalars["String"]["input"]>;
    procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
    revCode?: InputMaybe<Scalars["String"]["input"]>;
    /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
    s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
    tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
    unitCharge?: InputMaybe<Scalars["BigFloat"]["input"]>;
    units?: InputMaybe<Scalars["Int"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    /**
     * ### version_fingerprint
     *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
     */
    versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
export type updateBatchClaimLineItemOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyPatch =
  {
    /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
    alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceStart?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    itemNumber?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the order of the IB line in the source CSV input. */
    lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
    originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
    /**
     * ### original_version_id
     *  Original version id, used in versioning
     */
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    /**
     * ### previous_version_id
     *  Previous version id, used in versioning
     */
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    procedureCode?: InputMaybe<Scalars["String"]["input"]>;
    procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
    revCode?: InputMaybe<Scalars["String"]["input"]>;
    /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
    s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
    tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
    unitCharge?: InputMaybe<Scalars["BigFloat"]["input"]>;
    units?: InputMaybe<Scalars["Int"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    /**
     * ### version_fingerprint
     *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
     */
    versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimLineItem` being updated. */
export type updateBatchClaimLineItemOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyPatch =
  {
    /** # The ala_row_id as generated by the IB extraction process, and related to bounding box of text in pdf page.  Relates record back to the given row in s3_input_source bounding box of text on a given page. */
    alaRowId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimLineItemAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemAuditsUsingId?: InputMaybe<BatchClaimLineItemAuditBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineItemComputedValueUsingId?: InputMaybe<BatchClaimLineItemComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineBatchClaimLineItemIdFkeyInverseInput>;
    batchClaimLineToBatchClaimLineId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateOfServiceStart?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    ibLineId?: InputMaybe<Scalars["UUID"]["input"]>;
    ibLineVersionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    itemNumber?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the order of the IB line in the source CSV input. */
    lineNumber?: InputMaybe<Scalars["Int"]["input"]>;
    originalBilledAmount?: InputMaybe<Scalars["BigFloat"]["input"]>;
    /**
     * ### original_version_id
     *  Original version id, used in versioning
     */
    originalVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    /** # Represents the PDF page number from which the IB line was extracted. Zero-indexed. */
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    /**
     * ### previous_version_id
     *  Previous version id, used in versioning
     */
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    procedureCode?: InputMaybe<Scalars["String"]["input"]>;
    procedureCodeModifier?: InputMaybe<Scalars["String"]["input"]>;
    revCode?: InputMaybe<Scalars["String"]["input"]>;
    /** # s3_audit_documentation.id key of input to IBIN.  Using id allows for limiting PII/PHI speard from raw s3 keys. */
    s3InputSource?: InputMaybe<Scalars["String"]["input"]>;
    /** # Represents the table number from which the IB line was extracted, according to Textract. Zero-indexed. */
    tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
    unitCharge?: InputMaybe<Scalars["BigFloat"]["input"]>;
    units?: InputMaybe<Scalars["Int"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    /**
     * ### version_fingerprint
     *  Fingerprint of values used by app logic to determine if new version is needed, generated by function generate_bcli_fingerprint
     */
    versionFingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimLine` being updated. */
export type updateBatchClaimLineOnAuditFindingForAuditFindingClaimLineBatchClaimLineIdFkeyPatch =
  {
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInverseInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineComputedValueUsingId?: InputMaybe<BatchClaimLineComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInverseInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimLine` being updated. */
export type updateBatchClaimLineOnBatchClaimLineComputedValueForBatchClaimLineComputedValuesIdFkeyPatch =
  {
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInverseInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineComputedValueUsingId?: InputMaybe<BatchClaimLineComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInverseInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimLine` being updated. */
export type updateBatchClaimLineOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyPatch =
  {
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInverseInput>;
    batchClaimLineComputedValueUsingId?: InputMaybe<BatchClaimLineComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInverseInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimLine` being updated. */
export type updateBatchClaimLineOnBatchClaimLineItemForBatchClaimLineItemBatchClaimLineIdFkeyPatch =
  {
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimLineIdFkeyInverseInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineComputedValueUsingId?: InputMaybe<BatchClaimLineComputedValuesIdFkeyInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimLineIdFkeyInverseInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnActiveClaimAssigneeForActiveClaimAssigneesBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnAuditFindingForAuditFindingClaimLineBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimAppealedForBatchClaimAppealedBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimAssigneeForBatchClaimAssigneeBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimAuditStartDateForBatchClaimAuditStartDateBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimAuditTypeForBatchClaimAuditTypeBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimAuditorForBatchClaimAuditorBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimClientRecoveryAmountForBatchClaimClientRecoveryAmountBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimClientRecoveryCollectionDateForBatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimDocumentForBatchClaimDocumentBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimDueDateForBatchClaimDueDateBatchClaimIdFkPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimForBatchClaimAuthorIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
  batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
  batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
  batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
  batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
  batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
  batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
  batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
  batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
  batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
  batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
  bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
  claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
  claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
  clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
  invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
  negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
  onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
  patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
  patientId?: InputMaybe<Scalars["UUID"]["input"]>;
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
  providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
  reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
  s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
  workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
};

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimForBatchClaimBatchFileIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
  batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
  batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
  batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
  batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
  batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
  batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
  batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
  batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
  batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
  bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
  claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
  claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
  clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
  invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
  negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
  onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
  patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
  patientId?: InputMaybe<Scalars["UUID"]["input"]>;
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
  providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
  reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
  s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
  workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
};

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimForBatchClaimInsurerIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
  batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
  batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
  batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
  batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
  batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
  batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
  batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
  batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
  batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
  bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
  claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
  claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
  clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
  insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
  invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
  negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
  onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
  patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
  patientId?: InputMaybe<Scalars["UUID"]["input"]>;
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
  providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
  reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
  s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
  workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
};

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimForBatchClaimPatientIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
  batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
  batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
  batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
  batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
  batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
  batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
  batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
  batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
  batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
  bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
  claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
  claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
  clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
  invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
  negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
  onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
  patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
  providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
  reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
  s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
  workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
};

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimForBatchClaimPreviousVersionIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimForBatchClaimProviderIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
  batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
  batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
  batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
  batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
  batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
  batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
  batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
  batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
  batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
  bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
  claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
  claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
  clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
  invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
  negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
  onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
  patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
  patientId?: InputMaybe<Scalars["UUID"]["input"]>;
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
  providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
  reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
  s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
  workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
};

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimLineForBatchClaimLineBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimLineItemForBatchClaimLineItemBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
  batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
  batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
  batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
  batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
  batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
  batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
  batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
  batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
  batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
  bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
  claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
  claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
  clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
  invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
  negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
  onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
  patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
  patientId?: InputMaybe<Scalars["UUID"]["input"]>;
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
  providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
  reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
  s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
  workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
};

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnClaimFacetForClaimFacetsBatchClaimIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
  batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
  batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
  batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
  batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
  batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
  batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
  batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
  batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
  batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
  bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
  claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
  claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
  clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
  invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
  negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
  onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
  patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
  patientId?: InputMaybe<Scalars["UUID"]["input"]>;
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
  providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
  reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
  s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
  workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
};

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnDisputedFindingForDisputedFindingBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnReportedClaimForReportedClaimClaimIdFkeyPatch = {
  activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
  auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
  batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
  batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
  batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
  batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
  batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
  batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
  batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
  batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
  batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
  batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
  batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
  batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
  batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
  bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
  claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
  claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
  claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
  clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
  documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
  documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
  invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
  negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
  onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
  patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
  patientId?: InputMaybe<Scalars["UUID"]["input"]>;
  previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
  providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
  qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
  reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
  s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
  workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
};

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaim` being updated. */
export type updateBatchClaimOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkPatch =
  {
    activeClaimAssigneesUsingId?: InputMaybe<ActiveClaimAssigneesBatchClaimIdFkeyInverseInput>;
    auditFindingsUsingId?: InputMaybe<AuditFindingClaimLineBatchClaimIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchClaimAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimAppealedUsingId?: InputMaybe<BatchClaimAppealedBatchClaimIdFkeyInverseInput>;
    batchClaimAssigneesUsingId?: InputMaybe<BatchClaimAssigneeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditStartDatesUsingId?: InputMaybe<BatchClaimAuditStartDateBatchClaimIdFkeyInverseInput>;
    batchClaimAuditTypeUsingId?: InputMaybe<BatchClaimAuditTypeBatchClaimIdFkeyInverseInput>;
    batchClaimAuditorsUsingId?: InputMaybe<BatchClaimAuditorBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryAmountsUsingId?: InputMaybe<BatchClaimClientRecoveryAmountBatchClaimIdFkeyInverseInput>;
    batchClaimClientRecoveryCollectionDatesUsingId?: InputMaybe<BatchClaimClientRecoveryCollectionDateBatchClaimIdFkeyInverseInput>;
    batchClaimDocumentsUsingId?: InputMaybe<BatchClaimDocumentBatchClaimIdFkeyInverseInput>;
    batchClaimDueDatesUsingId?: InputMaybe<BatchClaimDueDateBatchClaimIdFkInverseInput>;
    batchClaimLineItemsUsingId?: InputMaybe<BatchClaimLineItemBatchClaimIdFkeyInverseInput>;
    batchClaimLinesUsingId?: InputMaybe<BatchClaimLineBatchClaimIdFkeyInverseInput>;
    batchClaimPayDenyUsingId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInverseInput>;
    batchClaimStateUsingId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInverseInput>;
    batchClaimTechDenialUsingId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInverseInput>;
    batchClaimToPreviousVersionId?: InputMaybe<BatchClaimPreviousVersionIdFkeyInput>;
    batchFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchFileToBatchFileId?: InputMaybe<BatchClaimBatchFileIdFkeyInput>;
    bucketClaimUsingId?: InputMaybe<BucketClaimBatchClaimIdFkeyInverseInput>;
    claimFacetHistoriesUsingId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInverseInput>;
    claimFacetUsingId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInverseInput>;
    claimPolicyDocumentsUsingId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInverseInput>;
    clientSignOffClaimStatesUsingId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInverseInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInverseInput>;
    documentationClaimStatesUsingId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchClaimInsurerIdFkeyInput>;
    invoiceClaimStatesUsingId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInverseInput>;
    negotiationClaimStatesUsingId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInverseInput>;
    onHoldClaimStatesUsingId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInverseInput>;
    patientDatumToPatientId?: InputMaybe<BatchClaimPatientIdFkeyInput>;
    patientId?: InputMaybe<Scalars["UUID"]["input"]>;
    previousVersionId?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerSignOffClaimStatesUsingId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInverseInput>;
    providerToProviderId?: InputMaybe<BatchClaimProviderIdFkeyInput>;
    qaClaimStateRowsUsingId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInverseInput>;
    reportedClaimsUsingId?: InputMaybe<ReportedClaimClaimIdFkeyInverseInput>;
    s3AuditDocumentationsUsingId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInverseInput>;
    workflowClaimStatesUsingId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInverseInput>;
  };

/** An object where the defined keys will be set on the `batchClaimPayDeny` being updated. */
export type updateBatchClaimPayDenyOnBatchClaimPayDenyForBatchClaimPayDenyBatchClaimIdFkeyPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimPayDenyBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    payDeny?: InputMaybe<Scalars["Boolean"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimState` being updated. */
export type updateBatchClaimStateOnBatchClaimStateForBatchClaimStateAuditorUserIdFkeyPatch =
  {
    auditorUserToAuditorUserId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInput>;
    batchClaimToId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInput>;
    claimAuditGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    claimAuditGroupToClaimAuditGroupId?: InputMaybe<BatchClaimStateClaimAuditGroupIdFkeyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimState` being updated. */
export type updateBatchClaimStateOnBatchClaimStateForBatchClaimStateBatchClaimIdFkeyPatch =
  {
    auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuditorUserId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInput>;
    batchClaimToId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInput>;
    claimAuditGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    claimAuditGroupToClaimAuditGroupId?: InputMaybe<BatchClaimStateClaimAuditGroupIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchClaimState` being updated. */
export type updateBatchClaimStateOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyPatch =
  {
    auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuditorUserId?: InputMaybe<BatchClaimStateAuditorUserIdFkeyInput>;
    batchClaimToId?: InputMaybe<BatchClaimStateBatchClaimIdFkeyInput>;
    claimAuditGroupToClaimAuditGroupId?: InputMaybe<BatchClaimStateClaimAuditGroupIdFkeyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimTechDenial` being updated. */
export type updateBatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialBatchClaimIdFkeyPatch =
  {
    auditorUserToCreatedBy?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    techDenied?: InputMaybe<Scalars["Boolean"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchClaimTechDenial` being updated. */
export type updateBatchClaimTechDenialOnBatchClaimTechDenialForBatchClaimTechDenialCreatedByFkeyPatch =
  {
    auditorUserToCreatedBy?: InputMaybe<BatchClaimTechDenialCreatedByFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<BatchClaimTechDenialBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    techDenied?: InputMaybe<Scalars["Boolean"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `batchFile` being updated. */
export type updateBatchFileOnAuditFindingJobForAuditFindingJobBatchFileIdFkeyPatch =
  {
    auditFindingJobsUsingId?: InputMaybe<AuditFindingJobBatchFileIdFkeyInverseInput>;
    auditorUserToAuthorId?: InputMaybe<BatchFileAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimsUsingId?: InputMaybe<BatchClaimBatchFileIdFkeyInverseInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<BatchFileInsurerIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `batchFile` being updated. */
export type updateBatchFileOnBatchClaimForBatchClaimBatchFileIdFkeyPatch = {
  auditFindingJobsUsingId?: InputMaybe<AuditFindingJobBatchFileIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchFileAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimsUsingId?: InputMaybe<BatchClaimBatchFileIdFkeyInverseInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<BatchFileInsurerIdFkeyInput>;
};

/** An object where the defined keys will be set on the `batchFile` being updated. */
export type updateBatchFileOnBatchFileForBatchFileAuthorIdFkeyPatch = {
  auditFindingJobsUsingId?: InputMaybe<AuditFindingJobBatchFileIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchFileAuthorIdFkeyInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimBatchFileIdFkeyInverseInput>;
  insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
  insurerToInsurerId?: InputMaybe<BatchFileInsurerIdFkeyInput>;
};

/** An object where the defined keys will be set on the `batchFile` being updated. */
export type updateBatchFileOnBatchFileForBatchFileInsurerIdFkeyPatch = {
  auditFindingJobsUsingId?: InputMaybe<AuditFindingJobBatchFileIdFkeyInverseInput>;
  auditorUserToAuthorId?: InputMaybe<BatchFileAuthorIdFkeyInput>;
  authorId?: InputMaybe<Scalars["UUID"]["input"]>;
  batchClaimsUsingId?: InputMaybe<BatchClaimBatchFileIdFkeyInverseInput>;
  insurerToInsurerId?: InputMaybe<BatchFileInsurerIdFkeyInput>;
};

/** An object where the defined keys will be set on the `bucketClaim` being updated. */
export type updateBucketClaimOnBucketClaimForBucketClaimAuditorBucketIdFkeyPatch =
  {
    auditorBucketToAuditorBucketId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<BucketClaimBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    selectionMethod?: InputMaybe<Scalars["JSON"]["input"]>;
    status?: InputMaybe<AuditFindingClaimStatus>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `bucketClaim` being updated. */
export type updateBucketClaimOnBucketClaimForBucketClaimBatchClaimIdFkeyPatch =
  {
    auditorBucketId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorBucketToAuditorBucketId?: InputMaybe<BucketClaimAuditorBucketIdFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<BucketClaimBatchClaimIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    selectionMethod?: InputMaybe<Scalars["JSON"]["input"]>;
    status?: InputMaybe<AuditFindingClaimStatus>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
export type updateClaimAuditGroupOnBatchClaimStateForBatchClaimStateClaimAuditGroupIdFkeyPatch =
  {
    appealDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    auditDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    auditStartDate?: InputMaybe<Scalars["Date"]["input"]>;
    auditType?: InputMaybe<ClaimAuditType>;
    auditorUserToCreatedBy?: InputMaybe<ClaimAuditGroupCreatedByFkeyInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateClaimAuditGroupIdFkeyInverseInput>;
    clientReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
    disputeDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    disputeReceivedDate?: InputMaybe<Scalars["Date"]["input"]>;
    docReqDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    dueDate?: InputMaybe<Scalars["Date"]["input"]>;
    finalProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    initialProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    qaDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    tatStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  };

/** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
export type updateClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupCreatedByFkeyPatch =
  {
    appealDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    auditDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    auditStartDate?: InputMaybe<Scalars["Date"]["input"]>;
    auditType?: InputMaybe<ClaimAuditType>;
    auditorUserToCreatedBy?: InputMaybe<ClaimAuditGroupCreatedByFkeyInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateClaimAuditGroupIdFkeyInverseInput>;
    clientReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    disputeDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    disputeReceivedDate?: InputMaybe<Scalars["Date"]["input"]>;
    docReqDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    dueDate?: InputMaybe<Scalars["Date"]["input"]>;
    finalProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    initialProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    qaDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    tatStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  };

/** An object where the defined keys will be set on the `claimAuditGroup` being updated. */
export type updateClaimAuditGroupOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyPatch =
  {
    appealDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    auditDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    auditStartDate?: InputMaybe<Scalars["Date"]["input"]>;
    auditType?: InputMaybe<ClaimAuditType>;
    auditorUserToCreatedBy?: InputMaybe<ClaimAuditGroupCreatedByFkeyInput>;
    batchClaimStatesUsingId?: InputMaybe<BatchClaimStateClaimAuditGroupIdFkeyInverseInput>;
    clientReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
    disputeDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    disputeReceivedDate?: InputMaybe<Scalars["Date"]["input"]>;
    docReqDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    dueDate?: InputMaybe<Scalars["Date"]["input"]>;
    finalProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    initialProviderReportSentDate?: InputMaybe<Scalars["Date"]["input"]>;
    insurerToInsurerId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    qaDueDate?: InputMaybe<Scalars["Date"]["input"]>;
    tatStartDate?: InputMaybe<Scalars["Date"]["input"]>;
  };

/** An object where the defined keys will be set on the `claimFacetHistory` being updated. */
export type updateClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryAppliedByFkeyPatch =
  {
    auditorUserToAppliedBy?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `claimFacetHistory` being updated. */
export type updateClaimFacetHistoryOnClaimFacetHistoryForClaimFacetHistoryBatchClaimIdFkeyPatch =
  {
    appliedBy?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAppliedBy?: InputMaybe<ClaimFacetHistoryAppliedByFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<ClaimFacetHistoryBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `claimFacet` being updated. */
export type updateClaimFacetOnClaimFacetForClaimFacetsBatchClaimIdFkeyPatch = {
  batchClaimToBatchClaimId?: InputMaybe<ClaimFacetsBatchClaimIdFkeyInput>;
};

/** An object where the defined keys will be set on the `claimPolicyDocument` being updated. */
export type updateClaimPolicyDocumentOnClaimPolicyDocumentForClaimPolicyDocumentBatchClaimIdFkeyPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<ClaimPolicyDocumentBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `clientSignOffClaimState` being updated. */
export type updateClientSignOffClaimStateOnClientSignOffClaimStateForClientSignOffClaimStateBatchClaimIdFkPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<ClientSignOffClaimStateBatchClaimIdFkInput>;
  };

/** An object where the defined keys will be set on the `defaultStrategyByInsurer` being updated. */
export type updateDefaultStrategyByInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyPatch =
  {
    insurerToInsurerId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInput>;
  };

/** An object where the defined keys will be set on the `disputedFinding` being updated. */
export type updateDisputedFindingOnDisputedFindingForDisputedFindingAuthorIdFkeyPatch =
  {
    auditorUserToAuthorId?: InputMaybe<DisputedFindingAuthorIdFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInput>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<DisputedFindingProviderIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `disputedFinding` being updated. */
export type updateDisputedFindingOnDisputedFindingForDisputedFindingBatchClaimIdFkeyPatch =
  {
    auditorUserToAuthorId?: InputMaybe<DisputedFindingAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInput>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<DisputedFindingProviderIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `disputedFinding` being updated. */
export type updateDisputedFindingOnDisputedFindingForDisputedFindingProviderIdFkeyPatch =
  {
    auditorUserToAuthorId?: InputMaybe<DisputedFindingAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DisputedFindingBatchClaimIdFkeyInput>;
    providerToProviderId?: InputMaybe<DisputedFindingProviderIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `documentRequestCreated` being updated. */
export type updateDocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedBatchClaimIdFkPatch =
  {
    _deprecatedMessageCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInput>;
    messageCreatedToDeprecatedMessageCreatedId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `documentRequestCreated` being updated. */
export type updateDocumentRequestCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkPatch =
  {
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInput>;
    messageCreatedToDeprecatedMessageCreatedId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `documentRequestCreated` being updated. */
export type updateDocumentRequestCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyPatch =
  {
    _deprecatedMessageCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentRequestCreatedBatchClaimIdFkInput>;
    messageCreatedToDeprecatedMessageCreatedId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
export type updateDocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedAuthorIdFkeyPatch =
  {
    _deprecatedMessageId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
    messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
export type updateDocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedBatchClaimIdFkPatch =
  {
    _deprecatedMessageId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
    messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
export type updateDocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyPatch =
  {
    auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
    messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
export type updateDocumentUploadCreatedOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyPatch =
  {
    _deprecatedMessageId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
    messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
    providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `documentUploadCreated` being updated. */
export type updateDocumentUploadCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyPatch =
  {
    _deprecatedMessageId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuthorId?: InputMaybe<DocumentUploadCreatedAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentUploadCreatedBatchClaimIdFkInput>;
    messageCreatedToDeprecatedMessageId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInput>;
    messageCreatedsUsingId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInverseInput>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `documentationClaimState` being updated. */
export type updateDocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateBatchClaimIdFkeyPatch =
  {
    auditorUserToCreatedBy?: InputMaybe<DocumentationClaimStateCreatedByFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInput>;
    createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `documentationClaimState` being updated. */
export type updateDocumentationClaimStateOnDocumentationClaimStateForDocumentationClaimStateCreatedByFkeyPatch =
  {
    auditorUserToCreatedBy?: InputMaybe<DocumentationClaimStateCreatedByFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<DocumentationClaimStateBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `documentationSelectionSet` being updated. */
export type updateDocumentationSelectionSetOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyPatch =
  {
    providerToProviderId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `humanProcessingRequest` being updated. */
export type updateHumanProcessingRequestOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyPatch =
  {
    s3AuditDocumentationToS3AuditDocumentationId?: InputMaybe<HumanProcessingRequestS3AuditDocumentationIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `insurerClaimIntakeDropboxPermitted` being updated. */
export type updateInsurerClaimIntakeDropboxPermittedOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyPatch =
  {
    insurerToInsurerId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `insurer` being updated. */
export type updateInsurerOnAuditFindingReportForAuditFindingReportInsurerIdFkeyPatch =
  {
    auditFindingReportsUsingId?: InputMaybe<AuditFindingReportInsurerIdFkeyInverseInput>;
    auditorBucketsUsingId?: InputMaybe<AuditorBucketInsurerIdFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimInsurerIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileInsurerIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInverseInput>;
    defaultStrategyByInsurerUsingId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInverseInput>;
    insurerClaimIntakeDropboxPermittedUsingId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput>;
    insurerOrganizationsToMemberIdUsingId?: InputMaybe<InsurerOrganizationMemberIdFkeyInverseInput>;
    insurerOrganizationsToOrganizationIdUsingId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInverseInput>;
    insurerUsersUsingId?: InputMaybe<InsurerUserInsurerIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `insurer` being updated. */
export type updateInsurerOnAuditorBucketForAuditorBucketInsurerIdFkeyPatch = {
  auditFindingReportsUsingId?: InputMaybe<AuditFindingReportInsurerIdFkeyInverseInput>;
  auditorBucketsUsingId?: InputMaybe<AuditorBucketInsurerIdFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimInsurerIdFkeyInverseInput>;
  batchFilesUsingId?: InputMaybe<BatchFileInsurerIdFkeyInverseInput>;
  claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInverseInput>;
  defaultStrategyByInsurerUsingId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInverseInput>;
  insurerClaimIntakeDropboxPermittedUsingId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput>;
  insurerOrganizationsToMemberIdUsingId?: InputMaybe<InsurerOrganizationMemberIdFkeyInverseInput>;
  insurerOrganizationsToOrganizationIdUsingId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInverseInput>;
  insurerUsersUsingId?: InputMaybe<InsurerUserInsurerIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `insurer` being updated. */
export type updateInsurerOnBatchClaimForBatchClaimInsurerIdFkeyPatch = {
  auditFindingReportsUsingId?: InputMaybe<AuditFindingReportInsurerIdFkeyInverseInput>;
  auditorBucketsUsingId?: InputMaybe<AuditorBucketInsurerIdFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimInsurerIdFkeyInverseInput>;
  batchFilesUsingId?: InputMaybe<BatchFileInsurerIdFkeyInverseInput>;
  claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInverseInput>;
  defaultStrategyByInsurerUsingId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInverseInput>;
  insurerClaimIntakeDropboxPermittedUsingId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput>;
  insurerOrganizationsToMemberIdUsingId?: InputMaybe<InsurerOrganizationMemberIdFkeyInverseInput>;
  insurerOrganizationsToOrganizationIdUsingId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInverseInput>;
  insurerUsersUsingId?: InputMaybe<InsurerUserInsurerIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `insurer` being updated. */
export type updateInsurerOnBatchFileForBatchFileInsurerIdFkeyPatch = {
  auditFindingReportsUsingId?: InputMaybe<AuditFindingReportInsurerIdFkeyInverseInput>;
  auditorBucketsUsingId?: InputMaybe<AuditorBucketInsurerIdFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimInsurerIdFkeyInverseInput>;
  batchFilesUsingId?: InputMaybe<BatchFileInsurerIdFkeyInverseInput>;
  claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInverseInput>;
  defaultStrategyByInsurerUsingId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInverseInput>;
  insurerClaimIntakeDropboxPermittedUsingId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput>;
  insurerOrganizationsToMemberIdUsingId?: InputMaybe<InsurerOrganizationMemberIdFkeyInverseInput>;
  insurerOrganizationsToOrganizationIdUsingId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInverseInput>;
  insurerUsersUsingId?: InputMaybe<InsurerUserInsurerIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `insurer` being updated. */
export type updateInsurerOnClaimAuditGroupForClaimAuditGroupInsurerIdFkeyPatch =
  {
    auditFindingReportsUsingId?: InputMaybe<AuditFindingReportInsurerIdFkeyInverseInput>;
    auditorBucketsUsingId?: InputMaybe<AuditorBucketInsurerIdFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimInsurerIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileInsurerIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInverseInput>;
    defaultStrategyByInsurerUsingId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInverseInput>;
    insurerClaimIntakeDropboxPermittedUsingId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput>;
    insurerOrganizationsToMemberIdUsingId?: InputMaybe<InsurerOrganizationMemberIdFkeyInverseInput>;
    insurerOrganizationsToOrganizationIdUsingId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInverseInput>;
    insurerUsersUsingId?: InputMaybe<InsurerUserInsurerIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `insurer` being updated. */
export type updateInsurerOnDefaultStrategyByInsurerForDefaultStrategyByInsurerInsurerFkeyPatch =
  {
    auditFindingReportsUsingId?: InputMaybe<AuditFindingReportInsurerIdFkeyInverseInput>;
    auditorBucketsUsingId?: InputMaybe<AuditorBucketInsurerIdFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimInsurerIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileInsurerIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInverseInput>;
    defaultStrategyByInsurerUsingId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInverseInput>;
    insurerClaimIntakeDropboxPermittedUsingId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput>;
    insurerOrganizationsToMemberIdUsingId?: InputMaybe<InsurerOrganizationMemberIdFkeyInverseInput>;
    insurerOrganizationsToOrganizationIdUsingId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInverseInput>;
    insurerUsersUsingId?: InputMaybe<InsurerUserInsurerIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `insurer` being updated. */
export type updateInsurerOnInsurerClaimIntakeDropboxPermittedForInsurerClaimIntakeDropboxPermittedInsurerIdFkeyPatch =
  {
    auditFindingReportsUsingId?: InputMaybe<AuditFindingReportInsurerIdFkeyInverseInput>;
    auditorBucketsUsingId?: InputMaybe<AuditorBucketInsurerIdFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimInsurerIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileInsurerIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInverseInput>;
    defaultStrategyByInsurerUsingId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInverseInput>;
    insurerClaimIntakeDropboxPermittedUsingId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput>;
    insurerOrganizationsToMemberIdUsingId?: InputMaybe<InsurerOrganizationMemberIdFkeyInverseInput>;
    insurerOrganizationsToOrganizationIdUsingId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInverseInput>;
    insurerUsersUsingId?: InputMaybe<InsurerUserInsurerIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `insurer` being updated. */
export type updateInsurerOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyPatch =
  {
    auditFindingReportsUsingId?: InputMaybe<AuditFindingReportInsurerIdFkeyInverseInput>;
    auditorBucketsUsingId?: InputMaybe<AuditorBucketInsurerIdFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimInsurerIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileInsurerIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInverseInput>;
    defaultStrategyByInsurerUsingId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInverseInput>;
    insurerClaimIntakeDropboxPermittedUsingId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput>;
    insurerOrganizationsToMemberIdUsingId?: InputMaybe<InsurerOrganizationMemberIdFkeyInverseInput>;
    insurerOrganizationsToOrganizationIdUsingId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInverseInput>;
    insurerUsersUsingId?: InputMaybe<InsurerUserInsurerIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `insurer` being updated. */
export type updateInsurerOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyPatch =
  {
    auditFindingReportsUsingId?: InputMaybe<AuditFindingReportInsurerIdFkeyInverseInput>;
    auditorBucketsUsingId?: InputMaybe<AuditorBucketInsurerIdFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimInsurerIdFkeyInverseInput>;
    batchFilesUsingId?: InputMaybe<BatchFileInsurerIdFkeyInverseInput>;
    claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInverseInput>;
    defaultStrategyByInsurerUsingId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInverseInput>;
    insurerClaimIntakeDropboxPermittedUsingId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput>;
    insurerOrganizationsToMemberIdUsingId?: InputMaybe<InsurerOrganizationMemberIdFkeyInverseInput>;
    insurerOrganizationsToOrganizationIdUsingId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInverseInput>;
    insurerUsersUsingId?: InputMaybe<InsurerUserInsurerIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `insurer` being updated. */
export type updateInsurerOnInsurerUserForInsurerUserInsurerIdFkeyPatch = {
  auditFindingReportsUsingId?: InputMaybe<AuditFindingReportInsurerIdFkeyInverseInput>;
  auditorBucketsUsingId?: InputMaybe<AuditorBucketInsurerIdFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimInsurerIdFkeyInverseInput>;
  batchFilesUsingId?: InputMaybe<BatchFileInsurerIdFkeyInverseInput>;
  claimAuditGroupsUsingId?: InputMaybe<ClaimAuditGroupInsurerIdFkeyInverseInput>;
  defaultStrategyByInsurerUsingId?: InputMaybe<DefaultStrategyByInsurerInsurerFkeyInverseInput>;
  insurerClaimIntakeDropboxPermittedUsingId?: InputMaybe<InsurerClaimIntakeDropboxPermittedInsurerIdFkeyInverseInput>;
  insurerOrganizationsToMemberIdUsingId?: InputMaybe<InsurerOrganizationMemberIdFkeyInverseInput>;
  insurerOrganizationsToOrganizationIdUsingId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInverseInput>;
  insurerUsersUsingId?: InputMaybe<InsurerUserInsurerIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `insurerOrganization` being updated. */
export type updateInsurerOrganizationOnInsurerOrganizationForInsurerOrganizationMemberIdFkeyPatch =
  {
    insurerToMemberId?: InputMaybe<InsurerOrganizationMemberIdFkeyInput>;
    insurerToOrganizationId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInput>;
    organizationId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `insurerOrganization` being updated. */
export type updateInsurerOrganizationOnInsurerOrganizationForInsurerOrganizationOrganizationIdFkeyPatch =
  {
    insurerToMemberId?: InputMaybe<InsurerOrganizationMemberIdFkeyInput>;
    insurerToOrganizationId?: InputMaybe<InsurerOrganizationOrganizationIdFkeyInput>;
    memberId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `insurerUser` being updated. */
export type updateInsurerUserOnInsurerUserForInsurerUserAuditorUserIdFkeyPatch =
  {
    auditorUserToAuditorUserId?: InputMaybe<InsurerUserAuditorUserIdFkeyInput>;
    insurerId?: InputMaybe<Scalars["UUID"]["input"]>;
    insurerToInsurerId?: InputMaybe<InsurerUserInsurerIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `insurerUser` being updated. */
export type updateInsurerUserOnInsurerUserForInsurerUserInsurerIdFkeyPatch = {
  auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  auditorUserToAuditorUserId?: InputMaybe<InsurerUserAuditorUserIdFkeyInput>;
  insurerToInsurerId?: InputMaybe<InsurerUserInsurerIdFkeyInput>;
};

/** An object where the defined keys will be set on the `invoiceClaimState` being updated. */
export type updateInvoiceClaimStateOnInvoiceClaimStateForInvoiceClaimStateBatchClaimIdFkPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<InvoiceClaimStateBatchClaimIdFkInput>;
  };

/** An object where the defined keys will be set on the `messageCreated` being updated. */
export type updateMessageCreatedOnDocumentRequestCreatedForDocumentRequestCreatedMessageCreatedIdFkPatch =
  {
    auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
    documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
    documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
    senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `messageCreated` being updated. */
export type updateMessageCreatedOnDocumentUploadCreatedForDocumentUploadCreatedMessageIdFkeyPatch =
  {
    auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
    documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
    documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
    senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `messageCreated` being updated. */
export type updateMessageCreatedOnMessageCreatedForMessageCreatedDocumentRequestCreatedIdFkeyPatch =
  {
    auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
    documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
    documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
    senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `messageCreated` being updated. */
export type updateMessageCreatedOnMessageCreatedForMessageCreatedDocumentUploadCreatedIdFkeyPatch =
  {
    auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
    documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
    documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
    senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `messageCreated` being updated. */
export type updateMessageCreatedOnMessageCreatedForMessageCreatedSenderUserIdFkeyPatch =
  {
    auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
    documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
    documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `messageCreated` being updated. */
export type updateMessageCreatedOnMessageSentForMessageSentMessageIdFkeyPatch =
  {
    auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
    documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
    documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
    senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `messageCreated` being updated. */
export type updateMessageCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyPatch =
  {
    auditorUserToSenderUserId?: InputMaybe<MessageCreatedSenderUserIdFkeyInput>;
    documentRequestCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentRequestCreatedToDocumentRequestCreatedId?: InputMaybe<MessageCreatedDocumentRequestCreatedIdFkeyInput>;
    documentRequestCreatedsUsingId?: InputMaybe<DocumentRequestCreatedMessageCreatedIdFkInverseInput>;
    documentUploadCreatedId?: InputMaybe<Scalars["UUID"]["input"]>;
    documentUploadCreatedToDocumentUploadCreatedId?: InputMaybe<MessageCreatedDocumentUploadCreatedIdFkeyInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedMessageIdFkeyInverseInput>;
    messageSentsUsingId?: InputMaybe<MessageSentMessageIdFkeyInverseInput>;
    senderUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    userInviteCreatedsUsingId?: InputMaybe<UserInviteCreatedMessageIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `messageSent` being updated. */
export type updateMessageSentOnMessageSentForMessageSentMessageIdFkeyPatch = {
  auditorUserToRecipientUserId?: InputMaybe<MessageSentRecipientUserIdFkeyInput>;
  messageCreatedToMessageId?: InputMaybe<MessageSentMessageIdFkeyInput>;
  messageSentToResponseToMessageSentId?: InputMaybe<ResponseToMessageSentIdMessageSentIdFkInput>;
  messageSentToSeedMessageSentId?: InputMaybe<SeedMessageSentIdMessageSentIdFkInput>;
  recipientUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  responseToMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  seedMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `messageSent` being updated. */
export type updateMessageSentOnMessageSentForMessageSentRecipientUserIdFkeyPatch =
  {
    auditorUserToRecipientUserId?: InputMaybe<MessageSentRecipientUserIdFkeyInput>;
    messageCreatedToMessageId?: InputMaybe<MessageSentMessageIdFkeyInput>;
    messageId?: InputMaybe<Scalars["UUID"]["input"]>;
    messageSentToResponseToMessageSentId?: InputMaybe<ResponseToMessageSentIdMessageSentIdFkInput>;
    messageSentToSeedMessageSentId?: InputMaybe<SeedMessageSentIdMessageSentIdFkInput>;
    responseToMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
    seedMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `messageSent` being updated. */
export type updateMessageSentOnMessageSentForResponseToMessageSentIdMessageSentIdFkPatch =
  {
    auditorUserToRecipientUserId?: InputMaybe<MessageSentRecipientUserIdFkeyInput>;
    messageCreatedToMessageId?: InputMaybe<MessageSentMessageIdFkeyInput>;
    messageId?: InputMaybe<Scalars["UUID"]["input"]>;
    messageSentToResponseToMessageSentId?: InputMaybe<ResponseToMessageSentIdMessageSentIdFkInput>;
    messageSentToSeedMessageSentId?: InputMaybe<SeedMessageSentIdMessageSentIdFkInput>;
    recipientUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    seedMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `messageSent` being updated. */
export type updateMessageSentOnMessageSentForSeedMessageSentIdMessageSentIdFkPatch =
  {
    auditorUserToRecipientUserId?: InputMaybe<MessageSentRecipientUserIdFkeyInput>;
    messageCreatedToMessageId?: InputMaybe<MessageSentMessageIdFkeyInput>;
    messageId?: InputMaybe<Scalars["UUID"]["input"]>;
    messageSentToResponseToMessageSentId?: InputMaybe<ResponseToMessageSentIdMessageSentIdFkInput>;
    messageSentToSeedMessageSentId?: InputMaybe<SeedMessageSentIdMessageSentIdFkInput>;
    recipientUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    responseToMessageSentId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `negotiationClaimState` being updated. */
export type updateNegotiationClaimStateOnNegotiationClaimStateForNegotiationClaimStateBatchClaimIdFkPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<NegotiationClaimStateBatchClaimIdFkInput>;
  };

/** An object where the defined keys will be set on the `nnIbLine` being updated. */
export type updateNnIbLineOnBatchClaimLineItemNnIbLineForBatchClaimLineItemNnIbLineNnIbLineIdFkeyPatch =
  {
    auditorUserToAuthorId?: InputMaybe<NnIbLineAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    fingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    s3Key?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `nnIbLine` being updated. */
export type updateNnIbLineOnNnIbLineForNnIbLineAuthorIdFkeyPatch = {
  auditorUserToAuthorId?: InputMaybe<NnIbLineAuthorIdFkeyInput>;
  batchClaimLineItemNnIbLinesUsingId?: InputMaybe<BatchClaimLineItemNnIbLineNnIbLineIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  fingerprint?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  s3Key?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** An object where the defined keys will be set on the `onHoldClaimState` being updated. */
export type updateOnHoldClaimStateOnOnHoldClaimStateForOnHoldClaimStateBatchClaimIdFkPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<OnHoldClaimStateBatchClaimIdFkInput>;
  };

/** An object where the defined keys will be set on the `patientDatum` being updated. */
export type updatePatientDatumOnBatchClaimForBatchClaimPatientIdFkeyPatch = {
  batchClaimsUsingId?: InputMaybe<BatchClaimPatientIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `provider` being updated. */
export type updateProviderOnAuditFindingReportForPreliminaryAuditFindingReportProviderIdFkeyPatch =
  {
    auditFindingReportsUsingId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInverseInput>;
    auditorBucketsUsingId?: InputMaybe<FkeyAuditorBucketProviderIdInverseInput>;
    auditorUsersUsingId?: InputMaybe<AuditorUserProviderIdFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimProviderIdFkeyInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingProviderIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInverseInput>;
    documentationSelectionSetsUsingId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInverseInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `provider` being updated. */
export type updateProviderOnAuditorBucketForFkeyAuditorBucketProviderIdPatch = {
  auditFindingReportsUsingId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInverseInput>;
  auditorBucketsUsingId?: InputMaybe<FkeyAuditorBucketProviderIdInverseInput>;
  auditorUsersUsingId?: InputMaybe<AuditorUserProviderIdFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimProviderIdFkeyInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingProviderIdFkeyInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInverseInput>;
  documentationSelectionSetsUsingId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInverseInput>;
  providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `provider` being updated. */
export type updateProviderOnAuditorUserForAuditorUserProviderIdFkeyPatch = {
  auditFindingReportsUsingId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInverseInput>;
  auditorBucketsUsingId?: InputMaybe<FkeyAuditorBucketProviderIdInverseInput>;
  auditorUsersUsingId?: InputMaybe<AuditorUserProviderIdFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimProviderIdFkeyInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingProviderIdFkeyInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInverseInput>;
  documentationSelectionSetsUsingId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInverseInput>;
  providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `provider` being updated. */
export type updateProviderOnBatchClaimForBatchClaimProviderIdFkeyPatch = {
  auditFindingReportsUsingId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInverseInput>;
  auditorBucketsUsingId?: InputMaybe<FkeyAuditorBucketProviderIdInverseInput>;
  auditorUsersUsingId?: InputMaybe<AuditorUserProviderIdFkeyInverseInput>;
  batchClaimsUsingId?: InputMaybe<BatchClaimProviderIdFkeyInverseInput>;
  disputedFindingsUsingId?: InputMaybe<DisputedFindingProviderIdFkeyInverseInput>;
  documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInverseInput>;
  documentationSelectionSetsUsingId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInverseInput>;
  providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `provider` being updated. */
export type updateProviderOnDisputedFindingForDisputedFindingProviderIdFkeyPatch =
  {
    auditFindingReportsUsingId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInverseInput>;
    auditorBucketsUsingId?: InputMaybe<FkeyAuditorBucketProviderIdInverseInput>;
    auditorUsersUsingId?: InputMaybe<AuditorUserProviderIdFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimProviderIdFkeyInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingProviderIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInverseInput>;
    documentationSelectionSetsUsingId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInverseInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `provider` being updated. */
export type updateProviderOnDocumentUploadCreatedForDocumentUploadCreatedProviderIdFkeyPatch =
  {
    auditFindingReportsUsingId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInverseInput>;
    auditorBucketsUsingId?: InputMaybe<FkeyAuditorBucketProviderIdInverseInput>;
    auditorUsersUsingId?: InputMaybe<AuditorUserProviderIdFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimProviderIdFkeyInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingProviderIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInverseInput>;
    documentationSelectionSetsUsingId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInverseInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `provider` being updated. */
export type updateProviderOnDocumentationSelectionSetForDocumentationSelectionSetProviderIdFkeyPatch =
  {
    auditFindingReportsUsingId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInverseInput>;
    auditorBucketsUsingId?: InputMaybe<FkeyAuditorBucketProviderIdInverseInput>;
    auditorUsersUsingId?: InputMaybe<AuditorUserProviderIdFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimProviderIdFkeyInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingProviderIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInverseInput>;
    documentationSelectionSetsUsingId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInverseInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `provider` being updated. */
export type updateProviderOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyPatch =
  {
    auditFindingReportsUsingId?: InputMaybe<PreliminaryAuditFindingReportProviderIdFkeyInverseInput>;
    auditorBucketsUsingId?: InputMaybe<FkeyAuditorBucketProviderIdInverseInput>;
    auditorUsersUsingId?: InputMaybe<AuditorUserProviderIdFkeyInverseInput>;
    batchClaimsUsingId?: InputMaybe<BatchClaimProviderIdFkeyInverseInput>;
    disputedFindingsUsingId?: InputMaybe<DisputedFindingProviderIdFkeyInverseInput>;
    documentUploadCreatedsUsingId?: InputMaybe<DocumentUploadCreatedProviderIdFkeyInverseInput>;
    documentationSelectionSetsUsingId?: InputMaybe<DocumentationSelectionSetProviderIdFkeyInverseInput>;
    providerUserFacilitiesUsingId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInverseInput>;
  };

/** An object where the defined keys will be set on the `providerSignOffClaimState` being updated. */
export type updateProviderSignOffClaimStateOnProviderSignOffClaimStateForProviderSignOffClaimStateBatchClaimIdFkPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<ProviderSignOffClaimStateBatchClaimIdFkInput>;
  };

/** An object where the defined keys will be set on the `providerUserFacility` being updated. */
export type updateProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesAuditorUserIdFkeyPatch =
  {
    auditorUserToAuditorUserId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerToProviderId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `providerUserFacility` being updated. */
export type updateProviderUserFacilityOnProviderUserFacilityForProviderUserFacilitiesProviderIdFkeyPatch =
  {
    auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuditorUserId?: InputMaybe<ProviderUserFacilitiesAuditorUserIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    providerToProviderId?: InputMaybe<ProviderUserFacilitiesProviderIdFkeyInput>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `qaClaimStateRow` being updated. */
export type updateQaClaimStateRowOnQaClaimStateRowForQaClaimStateBatchClaimIdFkeyPatch =
  {
    auditorUserToCreatedBy?: InputMaybe<QaClaimStateCreatedByFkeyInput>;
    batchClaimToBatchClaimId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInput>;
    createdBy?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `qaClaimStateRow` being updated. */
export type updateQaClaimStateRowOnQaClaimStateRowForQaClaimStateCreatedByFkeyPatch =
  {
    auditorUserToCreatedBy?: InputMaybe<QaClaimStateCreatedByFkeyInput>;
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<QaClaimStateBatchClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `queue` being updated. */
export type updateQueueOnQueueForQueueAuthorIdFkeyPatch = {
  auditorUserToAuthorId?: InputMaybe<QueueAuthorIdFkeyInput>;
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  indexedFilterTags?: InputMaybe<Scalars["JSON"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** An object where the defined keys will be set on the `reasonCode` being updated. */
export type updateReasonCodeOnAuditFindingReasonCodeForAuditFindingReasonCodeReasonCodeIdFkeyPatch =
  {
    auditFindingReasonCodesUsingId?: InputMaybe<AuditFindingReasonCodeReasonCodeIdFkeyInverseInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateEffectiveEnd?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateEffectiveStart?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["String"]["input"]>;
    lastUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    notes?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `reportedClaim` being updated. */
export type updateReportedClaimOnReportedClaimForReportedClaimAuditFindingReportIdAuditFindingReportIdPatch =
  {
    auditFindingReportToAuditFindingReportId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInput>;
    batchClaimToClaimId?: InputMaybe<ReportedClaimClaimIdFkeyInput>;
    claimId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `reportedClaim` being updated. */
export type updateReportedClaimOnReportedClaimForReportedClaimClaimIdFkeyPatch =
  {
    auditFindingReportId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingReportToAuditFindingReportId?: InputMaybe<ReportedClaimAuditFindingReportIdAuditFindingReportIdInput>;
    batchClaimToClaimId?: InputMaybe<ReportedClaimClaimIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `reportedFinding` being updated. */
export type updateReportedFindingOnReportedFindingForReportedFindingAuditFindingIdFkeyPatch =
  {
    auditFindingReportId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingReportToAuditFindingReportId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInput>;
    auditFindingToAuditFindingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `reportedFinding` being updated. */
export type updateReportedFindingOnReportedFindingForReportedFindingAuditFindingReportIdFkeyPatch =
  {
    auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingReportToAuditFindingReportId?: InputMaybe<ReportedFindingAuditFindingReportIdFkeyInput>;
    auditFindingToAuditFindingId?: InputMaybe<ReportedFindingAuditFindingIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `reviewedAuditFinding` being updated. */
export type updateReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuditFindingIdFkeyPatch =
  {
    accepted?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditFindingToAuditFindingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInput>;
    authorId?: InputMaybe<Scalars["UUID"]["input"]>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    rationale?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `reviewedAuditFinding` being updated. */
export type updateReviewedAuditFindingOnReviewedAuditFindingForReviewedAuditFindingAuthorIdFkeyPatch =
  {
    accepted?: InputMaybe<Scalars["Boolean"]["input"]>;
    auditFindingId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditFindingToAuditFindingId?: InputMaybe<ReviewedAuditFindingAuditFindingIdFkeyInput>;
    auditorUserToAuthorId?: InputMaybe<ReviewedAuditFindingAuthorIdFkeyInput>;
    createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    rationale?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `s3AuditDocumentation` being updated. */
export type updateS3AuditDocumentationOnHumanProcessingRequestForHumanProcessingRequestS3AuditDocumentationIdFkeyPatch =
  {
    batchClaimId?: InputMaybe<Scalars["UUID"]["input"]>;
    batchClaimToBatchClaimId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInput>;
    etag?: InputMaybe<Scalars["String"]["input"]>;
    filename?: InputMaybe<Scalars["String"]["input"]>;
    humanProcessingRequestsUsingId?: InputMaybe<HumanProcessingRequestS3AuditDocumentationIdFkeyInverseInput>;
    icn?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isUploaded?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastModified?: InputMaybe<Scalars["Datetime"]["input"]>;
    originalFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    process?: InputMaybe<Scalars["String"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    s3Key?: InputMaybe<Scalars["String"]["input"]>;
    size?: InputMaybe<Scalars["Int"]["input"]>;
    subFile?: InputMaybe<Scalars["String"]["input"]>;
    subProcess?: InputMaybe<Scalars["String"]["input"]>;
    tags?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** An object where the defined keys will be set on the `s3AuditDocumentation` being updated. */
export type updateS3AuditDocumentationOnS3AuditDocumentationForS3AuditDocumentationBatchClaimIdFkeyPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<S3AuditDocumentationBatchClaimIdFkeyInput>;
    etag?: InputMaybe<Scalars["String"]["input"]>;
    filename?: InputMaybe<Scalars["String"]["input"]>;
    humanProcessingRequestsUsingId?: InputMaybe<HumanProcessingRequestS3AuditDocumentationIdFkeyInverseInput>;
    icn?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isUploaded?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastModified?: InputMaybe<Scalars["Datetime"]["input"]>;
    originalFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    process?: InputMaybe<Scalars["String"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    s3Key?: InputMaybe<Scalars["String"]["input"]>;
    size?: InputMaybe<Scalars["Int"]["input"]>;
    subFile?: InputMaybe<Scalars["String"]["input"]>;
    subProcess?: InputMaybe<Scalars["String"]["input"]>;
    tags?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** An object where the defined keys will be set on the `userInviteCreated` being updated. */
export type updateUserInviteCreatedOnUserInviteCreatedForUserInviteCreatedAuditorUserIdFkeyPatch =
  {
    auditorUserToAuditorUserId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInput>;
    messageCreatedToMessageId?: InputMaybe<UserInviteCreatedMessageIdFkeyInput>;
    messageId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `userInviteCreated` being updated. */
export type updateUserInviteCreatedOnUserInviteCreatedForUserInviteCreatedMessageIdFkeyPatch =
  {
    auditorUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    auditorUserToAuditorUserId?: InputMaybe<UserInviteCreatedAuditorUserIdFkeyInput>;
    messageCreatedToMessageId?: InputMaybe<UserInviteCreatedMessageIdFkeyInput>;
  };

/** An object where the defined keys will be set on the `workflowClaimState` being updated. */
export type updateWorkflowClaimStateOnWorkflowClaimStateForWorkflowClaimStateBatchClaimIdFkPatch =
  {
    batchClaimToBatchClaimId?: InputMaybe<WorkflowClaimStateBatchClaimIdFkInput>;
  };

export type batchClaimPrimaryMedicalRecordQueryVariables = Exact<{
  batchClaimId: Scalars["UUID"]["input"];
}>;

export type batchClaimPrimaryMedicalRecordQuery = {
  __typename?: "Query";
  batchClaim?: {
    __typename?: "BatchClaim";
    id: string;
    primaryMedicalRecord?: { __typename?: "File"; id: string } | null;
  } | null;
};

export type batchClaimLineItemFragmentFragment = {
  __typename?: "BatchClaimLineItem";
  id: string;
  dateOfServiceStart: any;
  dateOfServiceEnd?: any | null;
  revCode: string;
  procedureCode?: string | null;
  itemNumber?: string | null;
  description: string;
  units: number;
  unitCharge: number;
  batchClaimLineId?: string | null;
  authorId?: string | null;
  createdAt: any;
  updatedAt: any;
  alaRowId?: string | null;
  ibLineId?: string | null;
  batchClaimLineItemNnIbLines: {
    __typename?: "BatchClaimLineItemNnIbLinesConnection";
    nodes: Array<{
      __typename?: "BatchClaimLineItemNnIbLine";
      nnIbLineId: string;
      nnIbLine?: { __typename?: "NnIbLine"; fingerprint: string } | null;
    } | null>;
  };
};

export type reviewedAuditFindingFragmentFragment = {
  __typename?: "ReviewedAuditFinding";
  id: string;
  accepted: boolean;
  deleted: boolean;
  createdAt: any;
  updatedAt: any;
  rationale?: string | null;
};

export type auditFindingFragmentFragment = {
  __typename?: "AuditFinding";
  id: string;
  improperPaymentUnitsCharged: number;
  improperPaymentCost: number;
  improperPaymentReason: string;
  needsReview: boolean;
  auditorReviewed: boolean;
  auditorComment?: string | null;
  auditType?: AuditTypeEnum | null;
  superseded?: boolean | null;
  auditFindingRuleType: string;
  auditFindingSeedType: AuditFindingSeedType;
  confidence: number;
  isOriginal?: boolean | null;
  isActive?: boolean | null;
  accepted?: boolean | null;
  createdAt: any;
  metaDataNcciMueOhpMueValue?: number | null;
  metaDataNcciMueAjudicationValue?: number | null;
  metaDataNcciPtpModifier?: number | null;
  metaDataNcciPtpCode?: string | null;
  metaDataEmCode?: string | null;
  metaDataEmOriginalLevel?: number | null;
  metaDataEmCorrectLevel?: number | null;
  metaDataAocPrimaryCode?: string | null;
  metaDataPricingCorrectPrice?: number | null;
  metaDataUnitsCorrectUnits?: number | null;
  discrepantAmount?: number | null;
  batchClaimLineId?: string | null;
  batchClaimId: string;
  auditFindingRuleTypeByAuditFindingRuleType?: {
    __typename?: "AuditFindingRuleType";
    type: string;
    description?: string | null;
    displayName: string;
  } | null;
  reviewedAuditFinding?: {
    __typename?: "ReviewedAuditFinding";
    id: string;
    accepted: boolean;
    deleted: boolean;
    createdAt: any;
    updatedAt: any;
    rationale?: string | null;
  } | null;
  batchClaimLineItemAudit?: {
    __typename?: "BatchClaimLineItemAudit";
    id: string;
    batchClaimLineItem?: {
      __typename?: "BatchClaimLineItem";
      id: string;
      dateOfServiceStart: any;
      dateOfServiceEnd?: any | null;
      revCode: string;
      procedureCode?: string | null;
      itemNumber?: string | null;
      description: string;
      units: number;
      unitCharge: number;
      batchClaimLineId?: string | null;
      authorId?: string | null;
      createdAt: any;
      updatedAt: any;
      alaRowId?: string | null;
      ibLineId?: string | null;
      batchClaimLineItemNnIbLines: {
        __typename?: "BatchClaimLineItemNnIbLinesConnection";
        nodes: Array<{
          __typename?: "BatchClaimLineItemNnIbLine";
          nnIbLineId: string;
          nnIbLine?: { __typename?: "NnIbLine"; fingerprint: string } | null;
        } | null>;
      };
    } | null;
  } | null;
  reportedFindings: {
    __typename?: "ReportedFindingsConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "ReportedFinding";
      id: string;
      auditFindingReportId: string;
    } | null>;
  };
};

export type auditFindingReviewFragmentFragment = {
  __typename?: "AuditFindingReview";
  id: string;
  createdAt: any;
  reviewId: string;
  originalId: string;
};

export type auditFindingReviewsFragmentFragment = {
  __typename?: "AuditFinding";
  id: string;
  reviews: {
    __typename?: "AuditFindingReviewsConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "AuditFindingReview";
      id: string;
      createdAt: any;
      reviewId: string;
      originalId: string;
      auditFinding?: {
        __typename?: "AuditFinding";
        id: string;
        improperPaymentUnitsCharged: number;
        improperPaymentCost: number;
        improperPaymentReason: string;
        needsReview: boolean;
        auditorReviewed: boolean;
        auditorComment?: string | null;
        auditType?: AuditTypeEnum | null;
        superseded?: boolean | null;
        auditFindingRuleType: string;
        auditFindingSeedType: AuditFindingSeedType;
        confidence: number;
        isOriginal?: boolean | null;
        isActive?: boolean | null;
        accepted?: boolean | null;
        createdAt: any;
        metaDataNcciMueOhpMueValue?: number | null;
        metaDataNcciMueAjudicationValue?: number | null;
        metaDataNcciPtpModifier?: number | null;
        metaDataNcciPtpCode?: string | null;
        metaDataEmCode?: string | null;
        metaDataEmOriginalLevel?: number | null;
        metaDataEmCorrectLevel?: number | null;
        metaDataAocPrimaryCode?: string | null;
        metaDataPricingCorrectPrice?: number | null;
        metaDataUnitsCorrectUnits?: number | null;
        discrepantAmount?: number | null;
        batchClaimLineId?: string | null;
        batchClaimId: string;
        auditFindingRuleTypeByAuditFindingRuleType?: {
          __typename?: "AuditFindingRuleType";
          type: string;
          description?: string | null;
          displayName: string;
        } | null;
        reviewedAuditFinding?: {
          __typename?: "ReviewedAuditFinding";
          id: string;
          accepted: boolean;
          deleted: boolean;
          createdAt: any;
          updatedAt: any;
          rationale?: string | null;
        } | null;
        batchClaimLineItemAudit?: {
          __typename?: "BatchClaimLineItemAudit";
          id: string;
          batchClaimLineItem?: {
            __typename?: "BatchClaimLineItem";
            id: string;
            dateOfServiceStart: any;
            dateOfServiceEnd?: any | null;
            revCode: string;
            procedureCode?: string | null;
            itemNumber?: string | null;
            description: string;
            units: number;
            unitCharge: number;
            batchClaimLineId?: string | null;
            authorId?: string | null;
            createdAt: any;
            updatedAt: any;
            alaRowId?: string | null;
            ibLineId?: string | null;
            batchClaimLineItemNnIbLines: {
              __typename?: "BatchClaimLineItemNnIbLinesConnection";
              nodes: Array<{
                __typename?: "BatchClaimLineItemNnIbLine";
                nnIbLineId: string;
                nnIbLine?: {
                  __typename?: "NnIbLine";
                  fingerprint: string;
                } | null;
              } | null>;
            };
          } | null;
        } | null;
        reportedFindings: {
          __typename?: "ReportedFindingsConnection";
          totalCount: number;
          nodes: Array<{
            __typename?: "ReportedFinding";
            id: string;
            auditFindingReportId: string;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

export type auditFindingWithReviewFragmentFragment = {
  __typename?: "AuditFinding";
  id: string;
  improperPaymentUnitsCharged: number;
  improperPaymentCost: number;
  improperPaymentReason: string;
  needsReview: boolean;
  auditorReviewed: boolean;
  auditorComment?: string | null;
  auditType?: AuditTypeEnum | null;
  superseded?: boolean | null;
  auditFindingRuleType: string;
  auditFindingSeedType: AuditFindingSeedType;
  confidence: number;
  isOriginal?: boolean | null;
  isActive?: boolean | null;
  accepted?: boolean | null;
  createdAt: any;
  metaDataNcciMueOhpMueValue?: number | null;
  metaDataNcciMueAjudicationValue?: number | null;
  metaDataNcciPtpModifier?: number | null;
  metaDataNcciPtpCode?: string | null;
  metaDataEmCode?: string | null;
  metaDataEmOriginalLevel?: number | null;
  metaDataEmCorrectLevel?: number | null;
  metaDataAocPrimaryCode?: string | null;
  metaDataPricingCorrectPrice?: number | null;
  metaDataUnitsCorrectUnits?: number | null;
  discrepantAmount?: number | null;
  batchClaimLineId?: string | null;
  batchClaimId: string;
  original?: {
    __typename?: "AuditFindingReview";
    id: string;
    createdAt: any;
    reviewId: string;
    originalId: string;
    auditFinding?: {
      __typename?: "AuditFinding";
      id: string;
      improperPaymentUnitsCharged: number;
      improperPaymentCost: number;
      improperPaymentReason: string;
      needsReview: boolean;
      auditorReviewed: boolean;
      auditorComment?: string | null;
      auditType?: AuditTypeEnum | null;
      superseded?: boolean | null;
      auditFindingRuleType: string;
      auditFindingSeedType: AuditFindingSeedType;
      confidence: number;
      isOriginal?: boolean | null;
      isActive?: boolean | null;
      accepted?: boolean | null;
      createdAt: any;
      metaDataNcciMueOhpMueValue?: number | null;
      metaDataNcciMueAjudicationValue?: number | null;
      metaDataNcciPtpModifier?: number | null;
      metaDataNcciPtpCode?: string | null;
      metaDataEmCode?: string | null;
      metaDataEmOriginalLevel?: number | null;
      metaDataEmCorrectLevel?: number | null;
      metaDataAocPrimaryCode?: string | null;
      metaDataPricingCorrectPrice?: number | null;
      metaDataUnitsCorrectUnits?: number | null;
      discrepantAmount?: number | null;
      batchClaimLineId?: string | null;
      batchClaimId: string;
      auditFindingRuleTypeByAuditFindingRuleType?: {
        __typename?: "AuditFindingRuleType";
        type: string;
        description?: string | null;
        displayName: string;
      } | null;
      reviewedAuditFinding?: {
        __typename?: "ReviewedAuditFinding";
        id: string;
        accepted: boolean;
        deleted: boolean;
        createdAt: any;
        updatedAt: any;
        rationale?: string | null;
      } | null;
      batchClaimLineItemAudit?: {
        __typename?: "BatchClaimLineItemAudit";
        id: string;
        batchClaimLineItem?: {
          __typename?: "BatchClaimLineItem";
          id: string;
          dateOfServiceStart: any;
          dateOfServiceEnd?: any | null;
          revCode: string;
          procedureCode?: string | null;
          itemNumber?: string | null;
          description: string;
          units: number;
          unitCharge: number;
          batchClaimLineId?: string | null;
          authorId?: string | null;
          createdAt: any;
          updatedAt: any;
          alaRowId?: string | null;
          ibLineId?: string | null;
          batchClaimLineItemNnIbLines: {
            __typename?: "BatchClaimLineItemNnIbLinesConnection";
            nodes: Array<{
              __typename?: "BatchClaimLineItemNnIbLine";
              nnIbLineId: string;
              nnIbLine?: {
                __typename?: "NnIbLine";
                fingerprint: string;
              } | null;
            } | null>;
          };
        } | null;
      } | null;
      reportedFindings: {
        __typename?: "ReportedFindingsConnection";
        totalCount: number;
        nodes: Array<{
          __typename?: "ReportedFinding";
          id: string;
          auditFindingReportId: string;
        } | null>;
      };
      reviews: {
        __typename?: "AuditFindingReviewsConnection";
        totalCount: number;
        nodes: Array<{
          __typename?: "AuditFindingReview";
          id: string;
          createdAt: any;
          reviewId: string;
          originalId: string;
          auditFinding?: {
            __typename?: "AuditFinding";
            id: string;
            improperPaymentUnitsCharged: number;
            improperPaymentCost: number;
            improperPaymentReason: string;
            needsReview: boolean;
            auditorReviewed: boolean;
            auditorComment?: string | null;
            auditType?: AuditTypeEnum | null;
            superseded?: boolean | null;
            auditFindingRuleType: string;
            auditFindingSeedType: AuditFindingSeedType;
            confidence: number;
            isOriginal?: boolean | null;
            isActive?: boolean | null;
            accepted?: boolean | null;
            createdAt: any;
            metaDataNcciMueOhpMueValue?: number | null;
            metaDataNcciMueAjudicationValue?: number | null;
            metaDataNcciPtpModifier?: number | null;
            metaDataNcciPtpCode?: string | null;
            metaDataEmCode?: string | null;
            metaDataEmOriginalLevel?: number | null;
            metaDataEmCorrectLevel?: number | null;
            metaDataAocPrimaryCode?: string | null;
            metaDataPricingCorrectPrice?: number | null;
            metaDataUnitsCorrectUnits?: number | null;
            discrepantAmount?: number | null;
            batchClaimLineId?: string | null;
            batchClaimId: string;
            auditFindingRuleTypeByAuditFindingRuleType?: {
              __typename?: "AuditFindingRuleType";
              type: string;
              description?: string | null;
              displayName: string;
            } | null;
            reviewedAuditFinding?: {
              __typename?: "ReviewedAuditFinding";
              id: string;
              accepted: boolean;
              deleted: boolean;
              createdAt: any;
              updatedAt: any;
              rationale?: string | null;
            } | null;
            batchClaimLineItemAudit?: {
              __typename?: "BatchClaimLineItemAudit";
              id: string;
              batchClaimLineItem?: {
                __typename?: "BatchClaimLineItem";
                id: string;
                dateOfServiceStart: any;
                dateOfServiceEnd?: any | null;
                revCode: string;
                procedureCode?: string | null;
                itemNumber?: string | null;
                description: string;
                units: number;
                unitCharge: number;
                batchClaimLineId?: string | null;
                authorId?: string | null;
                createdAt: any;
                updatedAt: any;
                alaRowId?: string | null;
                ibLineId?: string | null;
                batchClaimLineItemNnIbLines: {
                  __typename?: "BatchClaimLineItemNnIbLinesConnection";
                  nodes: Array<{
                    __typename?: "BatchClaimLineItemNnIbLine";
                    nnIbLineId: string;
                    nnIbLine?: {
                      __typename?: "NnIbLine";
                      fingerprint: string;
                    } | null;
                  } | null>;
                };
              } | null;
            } | null;
            reportedFindings: {
              __typename?: "ReportedFindingsConnection";
              totalCount: number;
              nodes: Array<{
                __typename?: "ReportedFinding";
                id: string;
                auditFindingReportId: string;
              } | null>;
            };
          } | null;
        } | null>;
      };
    } | null;
  } | null;
  auditFindingRuleTypeByAuditFindingRuleType?: {
    __typename?: "AuditFindingRuleType";
    type: string;
    description?: string | null;
    displayName: string;
  } | null;
  reviewedAuditFinding?: {
    __typename?: "ReviewedAuditFinding";
    id: string;
    accepted: boolean;
    deleted: boolean;
    createdAt: any;
    updatedAt: any;
    rationale?: string | null;
  } | null;
  batchClaimLineItemAudit?: {
    __typename?: "BatchClaimLineItemAudit";
    id: string;
    batchClaimLineItem?: {
      __typename?: "BatchClaimLineItem";
      id: string;
      dateOfServiceStart: any;
      dateOfServiceEnd?: any | null;
      revCode: string;
      procedureCode?: string | null;
      itemNumber?: string | null;
      description: string;
      units: number;
      unitCharge: number;
      batchClaimLineId?: string | null;
      authorId?: string | null;
      createdAt: any;
      updatedAt: any;
      alaRowId?: string | null;
      ibLineId?: string | null;
      batchClaimLineItemNnIbLines: {
        __typename?: "BatchClaimLineItemNnIbLinesConnection";
        nodes: Array<{
          __typename?: "BatchClaimLineItemNnIbLine";
          nnIbLineId: string;
          nnIbLine?: { __typename?: "NnIbLine"; fingerprint: string } | null;
        } | null>;
      };
    } | null;
  } | null;
  reportedFindings: {
    __typename?: "ReportedFindingsConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "ReportedFinding";
      id: string;
      auditFindingReportId: string;
    } | null>;
  };
  reviews: {
    __typename?: "AuditFindingReviewsConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "AuditFindingReview";
      id: string;
      createdAt: any;
      reviewId: string;
      originalId: string;
      auditFinding?: {
        __typename?: "AuditFinding";
        id: string;
        improperPaymentUnitsCharged: number;
        improperPaymentCost: number;
        improperPaymentReason: string;
        needsReview: boolean;
        auditorReviewed: boolean;
        auditorComment?: string | null;
        auditType?: AuditTypeEnum | null;
        superseded?: boolean | null;
        auditFindingRuleType: string;
        auditFindingSeedType: AuditFindingSeedType;
        confidence: number;
        isOriginal?: boolean | null;
        isActive?: boolean | null;
        accepted?: boolean | null;
        createdAt: any;
        metaDataNcciMueOhpMueValue?: number | null;
        metaDataNcciMueAjudicationValue?: number | null;
        metaDataNcciPtpModifier?: number | null;
        metaDataNcciPtpCode?: string | null;
        metaDataEmCode?: string | null;
        metaDataEmOriginalLevel?: number | null;
        metaDataEmCorrectLevel?: number | null;
        metaDataAocPrimaryCode?: string | null;
        metaDataPricingCorrectPrice?: number | null;
        metaDataUnitsCorrectUnits?: number | null;
        discrepantAmount?: number | null;
        batchClaimLineId?: string | null;
        batchClaimId: string;
        auditFindingRuleTypeByAuditFindingRuleType?: {
          __typename?: "AuditFindingRuleType";
          type: string;
          description?: string | null;
          displayName: string;
        } | null;
        reviewedAuditFinding?: {
          __typename?: "ReviewedAuditFinding";
          id: string;
          accepted: boolean;
          deleted: boolean;
          createdAt: any;
          updatedAt: any;
          rationale?: string | null;
        } | null;
        batchClaimLineItemAudit?: {
          __typename?: "BatchClaimLineItemAudit";
          id: string;
          batchClaimLineItem?: {
            __typename?: "BatchClaimLineItem";
            id: string;
            dateOfServiceStart: any;
            dateOfServiceEnd?: any | null;
            revCode: string;
            procedureCode?: string | null;
            itemNumber?: string | null;
            description: string;
            units: number;
            unitCharge: number;
            batchClaimLineId?: string | null;
            authorId?: string | null;
            createdAt: any;
            updatedAt: any;
            alaRowId?: string | null;
            ibLineId?: string | null;
            batchClaimLineItemNnIbLines: {
              __typename?: "BatchClaimLineItemNnIbLinesConnection";
              nodes: Array<{
                __typename?: "BatchClaimLineItemNnIbLine";
                nnIbLineId: string;
                nnIbLine?: {
                  __typename?: "NnIbLine";
                  fingerprint: string;
                } | null;
              } | null>;
            };
          } | null;
        } | null;
        reportedFindings: {
          __typename?: "ReportedFindingsConnection";
          totalCount: number;
          nodes: Array<{
            __typename?: "ReportedFinding";
            id: string;
            auditFindingReportId: string;
          } | null>;
        };
      } | null;
    } | null>;
  };
};

export type versionAuditFindingFragmentFragment = {
  __typename?: "AuditFinding";
  id: string;
  improperPaymentUnitsCharged: number;
  improperPaymentCost: number;
  improperPaymentReason: string;
  needsReview: boolean;
  auditorReviewed: boolean;
  auditorComment?: string | null;
  auditType?: AuditTypeEnum | null;
  superseded?: boolean | null;
  auditFindingRuleType: string;
  auditFindingSeedType: AuditFindingSeedType;
  confidence: number;
  isOriginal?: boolean | null;
  isActive?: boolean | null;
  accepted?: boolean | null;
  createdAt: any;
  batchClaimLineId?: string | null;
  batchClaimId: string;
  batchClaimLineItemAudit?: {
    __typename?: "BatchClaimLineItemAudit";
    id: string;
    batchClaimLineItem?: {
      __typename?: "BatchClaimLineItem";
      id: string;
      dateOfServiceStart: any;
      dateOfServiceEnd?: any | null;
      revCode: string;
      procedureCode?: string | null;
      itemNumber?: string | null;
      description: string;
      units: number;
      unitCharge: number;
      batchClaimLineId?: string | null;
      authorId?: string | null;
      createdAt: any;
      updatedAt: any;
      alaRowId?: string | null;
      ibLineId?: string | null;
      batchClaimLineItemNnIbLines: {
        __typename?: "BatchClaimLineItemNnIbLinesConnection";
        nodes: Array<{
          __typename?: "BatchClaimLineItemNnIbLine";
          nnIbLineId: string;
          nnIbLine?: { __typename?: "NnIbLine"; fingerprint: string } | null;
        } | null>;
      };
    } | null;
  } | null;
};

export type findingV2FragmentFragment = {
  __typename?: "FindingV2";
  id: string;
  accepted?: boolean | null;
  autodorFindingId?: string | null;
  autodorFindingS3Key?: string | null;
  batchClaimLineId: string;
  confidence?: string | null;
  createdAt?: any | null;
  improperPaymentCost?: number | null;
  improperPaymentReason?: string | null;
  improperPaymentUnitsCharged?: number | null;
  isActive?: boolean | null;
  isOriginal?: boolean | null;
  metaDataAocPrimaryCode?: string | null;
  metaDataEmCode?: string | null;
  metaDataEmCorrectLevel?: number | null;
  metaDataEmOriginalLevel?: number | null;
  metaDataNcciMueAdjudicationValue?: number | null;
  metaDataNcciMueOhpMueValue?: number | null;
  metaDataNcciPtpCode?: string | null;
  metaDataNcciPtpModifier?: number | null;
  metaDataPricingCorrectPrice?: number | null;
  metaDataUnitsCorrectUnits?: number | null;
  needsReview: boolean;
  ruleType?: string | null;
  seedType?: string | null;
  superseded?: boolean | null;
  updatedAt?: any | null;
  createdBy:
    | {
        __typename: "CreatedByAutomation";
        id: string;
        kind: AutomationKindEnum;
        name: string;
      }
    | {
        __typename: "CreatedByUser";
        id: string;
        firstName: string;
        lastName: string;
        userType: UserType;
      };
  latestReview?: {
    __typename?: "LatestReview";
    authorId: string;
    createdAt: any;
    rationale?: string | null;
  } | null;
  batchClaimLineItemAudit?: {
    __typename?: "BatchClaimLineItemAuditV2";
    batchClaimLineItem?: {
      __typename?: "BatchClaimLineItemV2";
      revCode?: string | null;
      batchClaimLineId?: string | null;
      ibLineId?: string | null;
      alaRowId?: string | null;
    } | null;
  } | null;
};

export type batchClaimLineItemV2FragmentFragment = {
  __typename?: "BatchClaimLineItemV2";
  id?: string | null;
  dateOfServiceStart?: any | null;
  dateOfServiceEnd?: any | null;
  revCode?: string | null;
  procedureCode?: string | null;
  itemNumber?: string | null;
  description?: string | null;
  units?: number | null;
  unitCharge?: number | null;
  originalBilledAmount?: number | null;
  batchClaimLineId?: string | null;
  authorId?: string | null;
  createdAt?: any | null;
  alaRowId?: string | null;
  ibLineId?: string | null;
  versionFingerprint?: string | null;
  ibLineVersionFingerprint?: string | null;
};

export type createIbLineFindingsV2MutationVariables = Exact<{
  input: CreateIbLineFindingsInputV2;
}>;

export type createIbLineFindingsV2Mutation = {
  __typename?: "Mutation";
  createIbLineFindingsV2: {
    __typename?: "CreateIbLineFindingsOutputV2";
    auditFindings: Array<{
      __typename?: "FindingV2";
      id: string;
      batchClaimLineId: string;
      improperPaymentCost?: number | null;
      improperPaymentReason?: string | null;
      seedType?: string | null;
      ruleType?: string | null;
      confidence?: string | null;
      needsReview: boolean;
      accepted?: boolean | null;
      isActive?: boolean | null;
      status: FindingStatus;
      latestReview?: {
        __typename?: "LatestReview";
        authorId: string;
        createdAt: any;
        deleted: boolean;
      } | null;
      batchClaimLineItemAudit?: {
        __typename?: "BatchClaimLineItemAuditV2";
        batchClaimLineItem?: {
          __typename?: "BatchClaimLineItemV2";
          id?: string | null;
          dateOfServiceStart?: any | null;
          dateOfServiceEnd?: any | null;
          revCode?: string | null;
          procedureCode?: string | null;
          itemNumber?: string | null;
          description?: string | null;
          units?: number | null;
          unitCharge?: number | null;
          originalBilledAmount?: number | null;
          batchClaimLineId?: string | null;
          authorId?: string | null;
          createdAt?: any | null;
          alaRowId?: string | null;
          ibLineId?: string | null;
          versionFingerprint?: string | null;
          ibLineVersionFingerprint?: string | null;
        } | null;
      } | null;
    }>;
    autoDeclinedFindings: Array<{
      __typename?: "FindingV2";
      id: string;
      status: FindingStatus;
      isActive?: boolean | null;
      accepted?: boolean | null;
      needsReview: boolean;
      latestReview?: {
        __typename?: "LatestReview";
        authorId: string;
        createdAt: any;
        deleted: boolean;
      } | null;
      batchClaimLineItemAudit?: {
        __typename?: "BatchClaimLineItemAuditV2";
        batchClaimLineItem?: {
          __typename?: "BatchClaimLineItemV2";
          id?: string | null;
          dateOfServiceStart?: any | null;
          dateOfServiceEnd?: any | null;
          revCode?: string | null;
          procedureCode?: string | null;
          itemNumber?: string | null;
          description?: string | null;
          units?: number | null;
          unitCharge?: number | null;
          originalBilledAmount?: number | null;
          batchClaimLineId?: string | null;
          authorId?: string | null;
          createdAt?: any | null;
          alaRowId?: string | null;
          ibLineId?: string | null;
          versionFingerprint?: string | null;
          ibLineVersionFingerprint?: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type versionAuditFindingsMutationVariables = Exact<{
  input: VersionAuditFindingsInput;
}>;

export type versionAuditFindingsMutation = {
  __typename?: "Mutation";
  createAuditFindings: {
    __typename?: "CreateAuditFindingsPayload";
    auditFindings: Array<{
      __typename?: "AuditFinding";
      id: string;
      improperPaymentUnitsCharged: number;
      improperPaymentCost: number;
      improperPaymentReason: string;
      needsReview: boolean;
      auditorReviewed: boolean;
      auditorComment?: string | null;
      auditType?: AuditTypeEnum | null;
      superseded?: boolean | null;
      auditFindingRuleType: string;
      auditFindingSeedType: AuditFindingSeedType;
      confidence: number;
      isOriginal?: boolean | null;
      isActive?: boolean | null;
      accepted?: boolean | null;
      createdAt: any;
      batchClaimLineId?: string | null;
      batchClaimId: string;
      batchClaimLineItemAudit?: {
        __typename?: "BatchClaimLineItemAudit";
        id: string;
        batchClaimLineItem?: {
          __typename?: "BatchClaimLineItem";
          id: string;
          dateOfServiceStart: any;
          dateOfServiceEnd?: any | null;
          revCode: string;
          procedureCode?: string | null;
          itemNumber?: string | null;
          description: string;
          units: number;
          unitCharge: number;
          batchClaimLineId?: string | null;
          authorId?: string | null;
          createdAt: any;
          updatedAt: any;
          alaRowId?: string | null;
          ibLineId?: string | null;
          batchClaimLineItemNnIbLines: {
            __typename?: "BatchClaimLineItemNnIbLinesConnection";
            nodes: Array<{
              __typename?: "BatchClaimLineItemNnIbLine";
              nnIbLineId: string;
              nnIbLine?: {
                __typename?: "NnIbLine";
                fingerprint: string;
              } | null;
            } | null>;
          };
        } | null;
      } | null;
    }>;
  };
};

export type versionAuditFindingsWithoutClaimRefreshMutationVariables = Exact<{
  input: VersionAuditFindingsInput;
}>;

export type versionAuditFindingsWithoutClaimRefreshMutation = {
  __typename?: "Mutation";
  createAuditFindings: {
    __typename?: "CreateAuditFindingsPayload";
    auditFindings: Array<{
      __typename?: "AuditFinding";
      id: string;
      batchClaimLineId?: string | null;
      batchClaimLineItemAudit?: {
        __typename?: "BatchClaimLineItemAudit";
        batchClaimLineItem?: {
          __typename?: "BatchClaimLineItem";
          batchClaimLineId?: string | null;
          ibLineId?: string | null;
        } | null;
      } | null;
    }>;
  };
};

export type autodorFindingFragmentFragment = {
  __typename: "AutodorFinding";
  auditType: string;
  claimId: string;
  createdAt: string;
  s3Key: string;
  denialCode: string;
  description: string;
  ibLineId?: string | null;
  ibLineVersionFingerprint?: string | null;
  id: string;
  improperCharge: number;
  improperUnits: number;
  seedType: SeedType;
  stale: boolean;
  ubLineId?: string | null;
  autodorMetadata: {
    __typename?: "AutodorMetadata";
    auditType: string;
    billType: AutodorBillType;
    dateOfServiceStart: any;
    lineNumber?: number | null;
    procedureCode: string;
    procedureCodeModifier?: string | null;
    quarter: string;
    unitCharge: number;
    units: number;
    versionId: string;
    year: string;
    rule: {
      __typename: "AuditRule";
      _type: string;
      genericRule: any;
      ptp?: {
        __typename: "PTPAuditRule";
        colOneCode: string;
        colTwoCode: string;
        extendedDescription: string;
        rationale: string;
      } | null;
      mue?: {
        __typename: "MUEAuditRule";
        description: string;
        code: string;
        num: number;
        editType: string;
        mai: string;
        rationale: {
          __typename: "MUEAuditRuleRationale";
          value: string;
          enumeration: string;
        };
      } | null;
      nonBillable?: {
        __typename: "NonBillableAuditRule";
        code: string;
        description: string;
      } | null;
    };
  };
};

export type claimQueryVariables = Exact<{
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  statusFilter?: InputMaybe<Array<FindingStatus> | FindingStatus>;
}>;

export type claimQuery = {
  __typename?: "Query";
  claim?: {
    __typename: "Claim";
    id: string;
    icn: string;
    findingStatusCounts: {
      __typename?: "FindingStatusCounts";
      accepted: number;
      declined: number;
      suggested: number;
    };
    findings: Array<{
      __typename: "Finding";
      autodorFindingId?: string | null;
      autodorFindingS3Key?: string | null;
      accepted?: boolean | null;
      createdAt?: any | null;
      confidence?: string | null;
      id: string;
      improperPaymentCost?: number | null;
      improperPaymentReason?: string | null;
      improperPaymentUnitsCharged?: number | null;
      isOriginal?: boolean | null;
      status: FindingStatus;
      metaDataAocPrimaryCode?: string | null;
      metaDataEmCode?: string | null;
      metaDataEmCorrectLevel?: number | null;
      metaDataEmOriginalLevel?: number | null;
      metaDataNcciMueAdjudicationValue?: number | null;
      metaDataNcciMueOhpMueValue?: number | null;
      metaDataNcciPtpCode?: string | null;
      metaDataNcciPtpModifier?: number | null;
      metaDataPricingCorrectPrice?: number | null;
      metaDataUnitsCorrectUnits?: number | null;
      needsReview: boolean;
      ruleType?: string | null;
      seedType?: string | null;
      superseded?: boolean | null;
      updatedAt?: any | null;
      findingItemizedBillData?: {
        __typename: "FindingItemizedBillData";
        alaRowId?: string | null;
        authorId?: string | null;
        batchClaimLineId?: string | null;
        createdAt?: any | null;
        dateOfServiceEnd?: any | null;
        dateOfServiceStart?: any | null;
        description?: string | null;
        ibLineId?: string | null;
        id?: string | null;
        itemNumber?: string | null;
        lineNumber?: number | null;
        procedureCode?: string | null;
        procedureCodeModifier?: string | null;
        revCode?: string | null;
        s3InputSource?: string | null;
        stale?: boolean | null;
        unitCharge?: number | null;
        units?: number | null;
        updatedAt?: any | null;
        versionFingerprint?: string | null;
        ibLineVersionFingerprint?: string | null;
        originalBilledAmount?: number | null;
      } | null;
      createdBy:
        | {
            __typename: "CreatedByAutomation";
            id: string;
            kind: AutomationKindEnum;
            name: string;
          }
        | {
            __typename: "CreatedByUser";
            id: string;
            firstName: string;
            lastName: string;
            userType: UserType;
          };
      latestReview?: {
        __typename?: "LatestReview";
        authorId: string;
        createdAt: any;
        rationale?: string | null;
      } | null;
    }>;
    autodor?: {
      __typename?: "Autodor";
      claimId: string;
      sinks: Array<{
        __typename?: "AutodorSink";
        s3Key: string;
        timestamp: string;
      }>;
      autodorFindings: Array<{
        __typename: "AutodorFinding";
        auditType: string;
        claimId: string;
        createdAt: string;
        s3Key: string;
        denialCode: string;
        description: string;
        ibLineId?: string | null;
        ibLineVersionFingerprint?: string | null;
        id: string;
        improperCharge: number;
        improperUnits: number;
        seedType: SeedType;
        stale: boolean;
        ubLineId?: string | null;
        autodorMetadata: {
          __typename?: "AutodorMetadata";
          auditType: string;
          billType: AutodorBillType;
          dateOfServiceStart: any;
          lineNumber?: number | null;
          procedureCode: string;
          procedureCodeModifier?: string | null;
          quarter: string;
          unitCharge: number;
          units: number;
          versionId: string;
          year: string;
          rule: {
            __typename: "AuditRule";
            _type: string;
            genericRule: any;
            ptp?: {
              __typename: "PTPAuditRule";
              colOneCode: string;
              colTwoCode: string;
              extendedDescription: string;
              rationale: string;
            } | null;
            mue?: {
              __typename: "MUEAuditRule";
              description: string;
              code: string;
              num: number;
              editType: string;
              mai: string;
              rationale: {
                __typename: "MUEAuditRuleRationale";
                value: string;
                enumeration: string;
              };
            } | null;
            nonBillable?: {
              __typename: "NonBillableAuditRule";
              code: string;
              description: string;
            } | null;
          };
        };
      }>;
    } | null;
    itemizedBillLines: Array<{
      __typename: "ItemizedBillLine";
      alaRowId?: string | null;
      id: string;
      dateOfService?: any | null;
      itemNumber?: string | null;
      revCode?: string | null;
      description?: string | null;
      procedureCode?: string | null;
      procedureCodeModifier?: string | null;
      units?: number | null;
      totalCharge?: number | null;
      lineNumber?: number | null;
      findings: Array<string>;
      s3InputSourceId?: string | null;
      versionFingerprint?: string | null;
      groupCode?: string | null;
      chinDescription?: string | null;
      chinItemNumber?: string | null;
      chinModifier?: string | null;
      chinProcedureCode?: string | null;
      chinRevCode?: string | null;
    }>;
  } | null;
};

export type providerClaimQueryVariables = Exact<{
  id?: InputMaybe<Scalars["UUID"]["input"]>;
}>;

export type providerClaimQuery = {
  __typename?: "Query";
  claim?: {
    __typename: "Claim";
    id: string;
    icn: string;
    itemizedBillLines: Array<{
      __typename: "ItemizedBillLine";
      alaRowId?: string | null;
      id: string;
      dateOfService?: any | null;
      itemNumber?: string | null;
      revCode?: string | null;
      description?: string | null;
      procedureCode?: string | null;
      procedureCodeModifier?: string | null;
      units?: number | null;
      totalCharge?: number | null;
      lineNumber?: number | null;
      s3InputSourceId?: string | null;
      versionFingerprint?: string | null;
    }>;
  } | null;
};

export type claimFindingsQueryVariables = Exact<{
  id?: InputMaybe<Scalars["UUID"]["input"]>;
}>;

export type claimFindingsQuery = {
  __typename?: "Query";
  claim?: {
    __typename: "Claim";
    id: string;
    icn: string;
    findings: Array<{
      __typename: "Finding";
      autodorFindingId?: string | null;
      autodorFindingS3Key?: string | null;
      accepted?: boolean | null;
      createdAt?: any | null;
      confidence?: string | null;
      id: string;
      improperPaymentCost?: number | null;
      improperPaymentReason?: string | null;
      improperPaymentUnitsCharged?: number | null;
      isOriginal?: boolean | null;
      status: FindingStatus;
      metaDataAocPrimaryCode?: string | null;
      metaDataEmCode?: string | null;
      metaDataEmCorrectLevel?: number | null;
      metaDataEmOriginalLevel?: number | null;
      metaDataNcciMueAdjudicationValue?: number | null;
      metaDataNcciMueOhpMueValue?: number | null;
      metaDataNcciPtpCode?: string | null;
      metaDataNcciPtpModifier?: number | null;
      metaDataPricingCorrectPrice?: number | null;
      metaDataUnitsCorrectUnits?: number | null;
      needsReview: boolean;
      ruleType?: string | null;
      seedType?: string | null;
      superseded?: boolean | null;
      updatedAt?: any | null;
      findingItemizedBillData?: {
        __typename: "FindingItemizedBillData";
        alaRowId?: string | null;
        authorId?: string | null;
        batchClaimLineId?: string | null;
        createdAt?: any | null;
        dateOfServiceEnd?: any | null;
        dateOfServiceStart?: any | null;
        description?: string | null;
        ibLineId?: string | null;
        id?: string | null;
        itemNumber?: string | null;
        lineNumber?: number | null;
        procedureCode?: string | null;
        procedureCodeModifier?: string | null;
        revCode?: string | null;
        s3InputSource?: string | null;
        stale?: boolean | null;
        unitCharge?: number | null;
        units?: number | null;
        updatedAt?: any | null;
        versionFingerprint?: string | null;
        ibLineVersionFingerprint?: string | null;
        originalBilledAmount?: number | null;
      } | null;
      createdBy:
        | {
            __typename: "CreatedByAutomation";
            id: string;
            kind: AutomationKindEnum;
            name: string;
          }
        | {
            __typename: "CreatedByUser";
            id: string;
            firstName: string;
            lastName: string;
            userType: UserType;
          };
      latestReview?: {
        __typename?: "LatestReview";
        authorId: string;
        createdAt: any;
        rationale?: string | null;
      } | null;
    }>;
  } | null;
};

export type FindingItemizedBillDataFragmentFragment = {
  __typename: "FindingItemizedBillData";
  alaRowId?: string | null;
  authorId?: string | null;
  batchClaimLineId?: string | null;
  createdAt?: any | null;
  dateOfServiceEnd?: any | null;
  dateOfServiceStart?: any | null;
  description?: string | null;
  ibLineId?: string | null;
  id?: string | null;
  itemNumber?: string | null;
  lineNumber?: number | null;
  procedureCode?: string | null;
  procedureCodeModifier?: string | null;
  revCode?: string | null;
  s3InputSource?: string | null;
  stale?: boolean | null;
  unitCharge?: number | null;
  units?: number | null;
  updatedAt?: any | null;
  versionFingerprint?: string | null;
  ibLineVersionFingerprint?: string | null;
  originalBilledAmount?: number | null;
};

export type FindingFragmentFragment = {
  __typename: "Finding";
  autodorFindingId?: string | null;
  autodorFindingS3Key?: string | null;
  accepted?: boolean | null;
  createdAt?: any | null;
  confidence?: string | null;
  id: string;
  improperPaymentCost?: number | null;
  improperPaymentReason?: string | null;
  improperPaymentUnitsCharged?: number | null;
  isOriginal?: boolean | null;
  status: FindingStatus;
  metaDataAocPrimaryCode?: string | null;
  metaDataEmCode?: string | null;
  metaDataEmCorrectLevel?: number | null;
  metaDataEmOriginalLevel?: number | null;
  metaDataNcciMueAdjudicationValue?: number | null;
  metaDataNcciMueOhpMueValue?: number | null;
  metaDataNcciPtpCode?: string | null;
  metaDataNcciPtpModifier?: number | null;
  metaDataPricingCorrectPrice?: number | null;
  metaDataUnitsCorrectUnits?: number | null;
  needsReview: boolean;
  ruleType?: string | null;
  seedType?: string | null;
  superseded?: boolean | null;
  updatedAt?: any | null;
  findingItemizedBillData?: {
    __typename: "FindingItemizedBillData";
    alaRowId?: string | null;
    authorId?: string | null;
    batchClaimLineId?: string | null;
    createdAt?: any | null;
    dateOfServiceEnd?: any | null;
    dateOfServiceStart?: any | null;
    description?: string | null;
    ibLineId?: string | null;
    id?: string | null;
    itemNumber?: string | null;
    lineNumber?: number | null;
    procedureCode?: string | null;
    procedureCodeModifier?: string | null;
    revCode?: string | null;
    s3InputSource?: string | null;
    stale?: boolean | null;
    unitCharge?: number | null;
    units?: number | null;
    updatedAt?: any | null;
    versionFingerprint?: string | null;
    ibLineVersionFingerprint?: string | null;
    originalBilledAmount?: number | null;
  } | null;
  createdBy:
    | {
        __typename: "CreatedByAutomation";
        id: string;
        kind: AutomationKindEnum;
        name: string;
      }
    | {
        __typename: "CreatedByUser";
        id: string;
        firstName: string;
        lastName: string;
        userType: UserType;
      };
  latestReview?: {
    __typename?: "LatestReview";
    authorId: string;
    createdAt: any;
    rationale?: string | null;
  } | null;
};

export type FindingQueryVariables = Exact<{
  id?: InputMaybe<Scalars["UUID"]["input"]>;
}>;

export type FindingQuery = {
  __typename?: "Query";
  finding?: {
    __typename: "Finding";
    autodorFindingId?: string | null;
    autodorFindingS3Key?: string | null;
    accepted?: boolean | null;
    createdAt?: any | null;
    confidence?: string | null;
    id: string;
    improperPaymentCost?: number | null;
    improperPaymentReason?: string | null;
    improperPaymentUnitsCharged?: number | null;
    isOriginal?: boolean | null;
    status: FindingStatus;
    metaDataAocPrimaryCode?: string | null;
    metaDataEmCode?: string | null;
    metaDataEmCorrectLevel?: number | null;
    metaDataEmOriginalLevel?: number | null;
    metaDataNcciMueAdjudicationValue?: number | null;
    metaDataNcciMueOhpMueValue?: number | null;
    metaDataNcciPtpCode?: string | null;
    metaDataNcciPtpModifier?: number | null;
    metaDataPricingCorrectPrice?: number | null;
    metaDataUnitsCorrectUnits?: number | null;
    needsReview: boolean;
    ruleType?: string | null;
    seedType?: string | null;
    superseded?: boolean | null;
    updatedAt?: any | null;
    findingItemizedBillData?: {
      __typename: "FindingItemizedBillData";
      alaRowId?: string | null;
      authorId?: string | null;
      batchClaimLineId?: string | null;
      createdAt?: any | null;
      dateOfServiceEnd?: any | null;
      dateOfServiceStart?: any | null;
      description?: string | null;
      ibLineId?: string | null;
      id?: string | null;
      itemNumber?: string | null;
      lineNumber?: number | null;
      procedureCode?: string | null;
      procedureCodeModifier?: string | null;
      revCode?: string | null;
      s3InputSource?: string | null;
      stale?: boolean | null;
      unitCharge?: number | null;
      units?: number | null;
      updatedAt?: any | null;
      versionFingerprint?: string | null;
      ibLineVersionFingerprint?: string | null;
      originalBilledAmount?: number | null;
    } | null;
    createdBy:
      | {
          __typename: "CreatedByAutomation";
          id: string;
          kind: AutomationKindEnum;
          name: string;
        }
      | {
          __typename: "CreatedByUser";
          id: string;
          firstName: string;
          lastName: string;
          userType: UserType;
        };
    latestReview?: {
      __typename?: "LatestReview";
      authorId: string;
      createdAt: any;
      rationale?: string | null;
    } | null;
  } | null;
};

export type ItemizedBillLineFragmentFragment = {
  __typename: "ItemizedBillLine";
  alaRowId?: string | null;
  id: string;
  dateOfService?: any | null;
  itemNumber?: string | null;
  revCode?: string | null;
  description?: string | null;
  procedureCode?: string | null;
  procedureCodeModifier?: string | null;
  units?: number | null;
  totalCharge?: number | null;
  lineNumber?: number | null;
  findings: Array<string>;
  s3InputSourceId?: string | null;
  versionFingerprint?: string | null;
  groupCode?: string | null;
  chinDescription?: string | null;
  chinItemNumber?: string | null;
  chinModifier?: string | null;
  chinProcedureCode?: string | null;
  chinRevCode?: string | null;
};

export type ProviderItemizedBillLineFragmentFragment = {
  __typename: "ItemizedBillLine";
  alaRowId?: string | null;
  id: string;
  dateOfService?: any | null;
  itemNumber?: string | null;
  revCode?: string | null;
  description?: string | null;
  procedureCode?: string | null;
  procedureCodeModifier?: string | null;
  units?: number | null;
  totalCharge?: number | null;
  lineNumber?: number | null;
  s3InputSourceId?: string | null;
  versionFingerprint?: string | null;
};

export type ItemizedBillLinesQueryVariables = Exact<{
  ids: Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"];
}>;

export type ItemizedBillLinesQuery = {
  __typename?: "Query";
  itemizedBillLines?: Array<{
    __typename: "ItemizedBillLine";
    alaRowId?: string | null;
    id: string;
    dateOfService?: any | null;
    itemNumber?: string | null;
    revCode?: string | null;
    description?: string | null;
    procedureCode?: string | null;
    procedureCodeModifier?: string | null;
    units?: number | null;
    totalCharge?: number | null;
    lineNumber?: number | null;
    findings: Array<string>;
    s3InputSourceId?: string | null;
    versionFingerprint?: string | null;
    groupCode?: string | null;
    chinDescription?: string | null;
    chinItemNumber?: string | null;
    chinModifier?: string | null;
    chinProcedureCode?: string | null;
    chinRevCode?: string | null;
  }> | null;
};

export type reportDownloadQueryQueryVariables = Exact<{
  reportId: Scalars["UUID"]["input"];
}>;

export type reportDownloadQueryQuery = {
  __typename?: "Query";
  auditFindingReport?: {
    __typename?: "AuditFindingReport";
    id: string;
    title: string;
    downloadUrl: string;
  } | null;
};

export const reviewedAuditFindingFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "reviewedAuditFindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ReviewedAuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "rationale" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<reviewedAuditFindingFragmentFragment, unknown>;
export const batchClaimLineItemFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "batchClaimLineItemFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BatchClaimLineItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemNnIbLines" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLineId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLine" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fingerprint" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<batchClaimLineItemFragmentFragment, unknown>;
export const auditFindingFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "auditFindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentUnitsCharged" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentCost" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "needsReview" } },
          { kind: "Field", name: { kind: "Name", value: "auditorReviewed" } },
          { kind: "Field", name: { kind: "Name", value: "auditorComment" } },
          { kind: "Field", name: { kind: "Name", value: "auditType" } },
          { kind: "Field", name: { kind: "Name", value: "superseded" } },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "auditFindingRuleTypeByAuditFindingRuleType",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "auditFindingRuleType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "auditFindingSeedType" },
          },
          { kind: "Field", name: { kind: "Name", value: "confidence" } },
          { kind: "Field", name: { kind: "Name", value: "isOriginal" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueOhpMueValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueAjudicationValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpModifier" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpCode" },
          },
          { kind: "Field", name: { kind: "Name", value: "metaDataEmCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmOriginalLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmCorrectLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataAocPrimaryCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataPricingCorrectPrice" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataUnitsCorrectUnits" },
          },
          { kind: "Field", name: { kind: "Name", value: "discrepantAmount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "reviewedAuditFinding" },
            name: { kind: "Name", value: "latestReview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "reviewedAuditFindingFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemAudit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batchClaimLineItem" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "batchClaimLineItemFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportedFindings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "auditFindingReportId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "reviewedAuditFindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ReviewedAuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "rationale" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "batchClaimLineItemFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BatchClaimLineItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemNnIbLines" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLineId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLine" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fingerprint" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<auditFindingFragmentFragment, unknown>;
export const auditFindingReviewFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "auditFindingReviewFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AuditFindingReview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "reviewId" } },
          { kind: "Field", name: { kind: "Name", value: "originalId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<auditFindingReviewFragmentFragment, unknown>;
export const auditFindingReviewsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "auditFindingReviewsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "reviews" },
            name: { kind: "Name", value: "auditFindingReviewsByOriginalId" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "CREATED_AT_DESC" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "auditFindingReviewFragment",
                        },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "auditFinding" },
                        name: { kind: "Name", value: "review" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "auditFindingFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "reviewedAuditFindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ReviewedAuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "rationale" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "batchClaimLineItemFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BatchClaimLineItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemNnIbLines" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLineId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLine" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fingerprint" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "auditFindingReviewFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AuditFindingReview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "reviewId" } },
          { kind: "Field", name: { kind: "Name", value: "originalId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "auditFindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentUnitsCharged" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentCost" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "needsReview" } },
          { kind: "Field", name: { kind: "Name", value: "auditorReviewed" } },
          { kind: "Field", name: { kind: "Name", value: "auditorComment" } },
          { kind: "Field", name: { kind: "Name", value: "auditType" } },
          { kind: "Field", name: { kind: "Name", value: "superseded" } },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "auditFindingRuleTypeByAuditFindingRuleType",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "auditFindingRuleType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "auditFindingSeedType" },
          },
          { kind: "Field", name: { kind: "Name", value: "confidence" } },
          { kind: "Field", name: { kind: "Name", value: "isOriginal" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueOhpMueValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueAjudicationValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpModifier" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpCode" },
          },
          { kind: "Field", name: { kind: "Name", value: "metaDataEmCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmOriginalLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmCorrectLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataAocPrimaryCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataPricingCorrectPrice" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataUnitsCorrectUnits" },
          },
          { kind: "Field", name: { kind: "Name", value: "discrepantAmount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "reviewedAuditFinding" },
            name: { kind: "Name", value: "latestReview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "reviewedAuditFindingFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemAudit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batchClaimLineItem" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "batchClaimLineItemFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportedFindings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "auditFindingReportId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<auditFindingReviewsFragmentFragment, unknown>;
export const auditFindingWithReviewFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "auditFindingWithReviewFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "auditFindingFragment" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "auditFindingReviewsFragment" },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "original" },
            name: { kind: "Name", value: "auditFindingReviewByReviewId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "auditFindingReviewFragment" },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "auditFinding" },
                  name: { kind: "Name", value: "original" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "auditFindingFragment" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "auditFindingReviewsFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "reviewedAuditFindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ReviewedAuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "rationale" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "batchClaimLineItemFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BatchClaimLineItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemNnIbLines" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLineId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLine" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fingerprint" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "auditFindingReviewFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AuditFindingReview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "reviewId" } },
          { kind: "Field", name: { kind: "Name", value: "originalId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "auditFindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentUnitsCharged" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentCost" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "needsReview" } },
          { kind: "Field", name: { kind: "Name", value: "auditorReviewed" } },
          { kind: "Field", name: { kind: "Name", value: "auditorComment" } },
          { kind: "Field", name: { kind: "Name", value: "auditType" } },
          { kind: "Field", name: { kind: "Name", value: "superseded" } },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "auditFindingRuleTypeByAuditFindingRuleType",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "displayName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "auditFindingRuleType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "auditFindingSeedType" },
          },
          { kind: "Field", name: { kind: "Name", value: "confidence" } },
          { kind: "Field", name: { kind: "Name", value: "isOriginal" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueOhpMueValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueAjudicationValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpModifier" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpCode" },
          },
          { kind: "Field", name: { kind: "Name", value: "metaDataEmCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmOriginalLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmCorrectLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataAocPrimaryCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataPricingCorrectPrice" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataUnitsCorrectUnits" },
          },
          { kind: "Field", name: { kind: "Name", value: "discrepantAmount" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "reviewedAuditFinding" },
            name: { kind: "Name", value: "latestReview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "reviewedAuditFindingFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemAudit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batchClaimLineItem" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "batchClaimLineItemFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportedFindings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "auditFindingReportId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "auditFindingReviewsFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "reviews" },
            name: { kind: "Name", value: "auditFindingReviewsByOriginalId" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "EnumValue", value: "CREATED_AT_DESC" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "auditFindingReviewFragment",
                        },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "auditFinding" },
                        name: { kind: "Name", value: "review" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "auditFindingFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<auditFindingWithReviewFragmentFragment, unknown>;
export const versionAuditFindingFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "versionAuditFindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentUnitsCharged" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentCost" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "needsReview" } },
          { kind: "Field", name: { kind: "Name", value: "auditorReviewed" } },
          { kind: "Field", name: { kind: "Name", value: "auditorComment" } },
          { kind: "Field", name: { kind: "Name", value: "auditType" } },
          { kind: "Field", name: { kind: "Name", value: "superseded" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "auditFindingRuleType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "auditFindingSeedType" },
          },
          { kind: "Field", name: { kind: "Name", value: "confidence" } },
          { kind: "Field", name: { kind: "Name", value: "isOriginal" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemAudit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batchClaimLineItem" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "batchClaimLineItemFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "batchClaimLineItemFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BatchClaimLineItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemNnIbLines" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLineId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLine" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fingerprint" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<versionAuditFindingFragmentFragment, unknown>;
export const findingV2FragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "findingV2Fragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FindingV2" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "autodorFindingId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "autodorFindingS3Key" },
          },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "confidence" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentCost" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentReason" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentUnitsCharged" },
          },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "isOriginal" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataAocPrimaryCode" },
          },
          { kind: "Field", name: { kind: "Name", value: "metaDataEmCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmCorrectLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmOriginalLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueAdjudicationValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueOhpMueValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpModifier" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataPricingCorrectPrice" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataUnitsCorrectUnits" },
          },
          { kind: "Field", name: { kind: "Name", value: "needsReview" } },
          { kind: "Field", name: { kind: "Name", value: "ruleType" } },
          { kind: "Field", name: { kind: "Name", value: "seedType" } },
          { kind: "Field", name: { kind: "Name", value: "superseded" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreatedByUser" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userType" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreatedByAutomation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "latestReview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "authorId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "rationale" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemAudit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batchClaimLineItem" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "revCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "batchClaimLineId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ibLineId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "alaRowId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<findingV2FragmentFragment, unknown>;
export const batchClaimLineItemV2FragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "batchClaimLineItemV2Fragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BatchClaimLineItemV2" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "originalBilledAmount" },
          },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ibLineVersionFingerprint" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<batchClaimLineItemV2FragmentFragment, unknown>;
export const autodorFindingFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "autodorFindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AutodorFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "auditType" } },
          { kind: "Field", name: { kind: "Name", value: "claimId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "s3Key" } },
          { kind: "Field", name: { kind: "Name", value: "denialCode" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ibLineVersionFingerprint" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "improperCharge" } },
          { kind: "Field", name: { kind: "Name", value: "improperUnits" } },
          { kind: "Field", name: { kind: "Name", value: "seedType" } },
          { kind: "Field", name: { kind: "Name", value: "stale" } },
          { kind: "Field", name: { kind: "Name", value: "ubLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "autodorMetadata" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "auditType" } },
                { kind: "Field", name: { kind: "Name", value: "billType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateOfServiceStart" },
                },
                { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "procedureCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "procedureCodeModifier" },
                },
                { kind: "Field", name: { kind: "Name", value: "quarter" } },
                { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                { kind: "Field", name: { kind: "Name", value: "versionId" } },
                { kind: "Field", name: { kind: "Name", value: "year" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rule" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "genericRule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ptp" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "colOneCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "colTwoCode" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "extendedDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rationale" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "num" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rationale" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "enumeration",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "editType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mai" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nonBillable" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<autodorFindingFragmentFragment, unknown>;
export const FindingItemizedBillDataFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FindingItemizedBillDataFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FindingItemizedBillData" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "procedureCodeModifier" },
          },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "s3InputSource" } },
          { kind: "Field", name: { kind: "Name", value: "stale" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ibLineVersionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originalBilledAmount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindingItemizedBillDataFragmentFragment, unknown>;
export const FindingFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Finding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "autodorFindingId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "autodorFindingS3Key" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "findingItemizedBillData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "FindingItemizedBillDataFragment",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreatedByUser" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userType" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreatedByAutomation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "confidence" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentCost" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentReason" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentUnitsCharged" },
          },
          { kind: "Field", name: { kind: "Name", value: "isOriginal" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataAocPrimaryCode" },
          },
          { kind: "Field", name: { kind: "Name", value: "metaDataEmCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmCorrectLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmOriginalLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueAdjudicationValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueOhpMueValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpModifier" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataPricingCorrectPrice" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataUnitsCorrectUnits" },
          },
          { kind: "Field", name: { kind: "Name", value: "needsReview" } },
          { kind: "Field", name: { kind: "Name", value: "ruleType" } },
          { kind: "Field", name: { kind: "Name", value: "seedType" } },
          { kind: "Field", name: { kind: "Name", value: "superseded" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "latestReview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "authorId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "rationale" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FindingItemizedBillDataFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FindingItemizedBillData" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "procedureCodeModifier" },
          },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "s3InputSource" } },
          { kind: "Field", name: { kind: "Name", value: "stale" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ibLineVersionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originalBilledAmount" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindingFragmentFragment, unknown>;
export const ItemizedBillLineFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ItemizedBillLineFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ItemizedBillLine" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfService" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "procedureCodeModifier" },
          },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "totalCharge" } },
          { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
          { kind: "Field", name: { kind: "Name", value: "findings" } },
          { kind: "Field", name: { kind: "Name", value: "s3InputSourceId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
          { kind: "Field", name: { kind: "Name", value: "groupCode" } },
          { kind: "Field", name: { kind: "Name", value: "chinDescription" } },
          { kind: "Field", name: { kind: "Name", value: "chinItemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "chinModifier" } },
          { kind: "Field", name: { kind: "Name", value: "chinProcedureCode" } },
          { kind: "Field", name: { kind: "Name", value: "chinRevCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ItemizedBillLineFragmentFragment, unknown>;
export const ProviderItemizedBillLineFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProviderItemizedBillLineFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ItemizedBillLine" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfService" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "procedureCodeModifier" },
          },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "totalCharge" } },
          { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
          { kind: "Field", name: { kind: "Name", value: "s3InputSourceId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProviderItemizedBillLineFragmentFragment, unknown>;
export const batchClaimPrimaryMedicalRecordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "batchClaimPrimaryMedicalRecord" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "batchClaimId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaim" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "batchClaimId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "primaryMedicalRecord" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  batchClaimPrimaryMedicalRecordQuery,
  batchClaimPrimaryMedicalRecordQueryVariables
>;
export const createIbLineFindingsV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createIbLineFindingsV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateIbLineFindingsInputV2" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createIbLineFindingsV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "auditFindings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "batchClaimLineId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "improperPaymentCost" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "improperPaymentReason" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "seedType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ruleType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "confidence" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "needsReview" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accepted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isActive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "latestReview" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "authorId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deleted" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "batchClaimLineItemAudit",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "batchClaimLineItem",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "batchClaimLineItemV2Fragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "autoDeclinedFindings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isActive" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accepted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "needsReview" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "latestReview" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "authorId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deleted" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "batchClaimLineItemAudit",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "batchClaimLineItem",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "batchClaimLineItemV2Fragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "batchClaimLineItemV2Fragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BatchClaimLineItemV2" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "originalBilledAmount" },
          },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ibLineVersionFingerprint" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  createIbLineFindingsV2Mutation,
  createIbLineFindingsV2MutationVariables
>;
export const versionAuditFindingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "versionAuditFindings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "VersionAuditFindingsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "createAuditFindings" },
            name: { kind: "Name", value: "versionAuditFindings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "auditFindings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "versionAuditFindingFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "batchClaimLineItemFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BatchClaimLineItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemNnIbLines" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLineId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nnIbLine" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fingerprint" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "versionAuditFindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AuditFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentUnitsCharged" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentCost" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "needsReview" } },
          { kind: "Field", name: { kind: "Name", value: "auditorReviewed" } },
          { kind: "Field", name: { kind: "Name", value: "auditorComment" } },
          { kind: "Field", name: { kind: "Name", value: "auditType" } },
          { kind: "Field", name: { kind: "Name", value: "superseded" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "auditFindingRuleType" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "auditFindingSeedType" },
          },
          { kind: "Field", name: { kind: "Name", value: "confidence" } },
          { kind: "Field", name: { kind: "Name", value: "isOriginal" } },
          { kind: "Field", name: { kind: "Name", value: "isActive" } },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "batchClaimLineItemAudit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batchClaimLineItem" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "batchClaimLineItemFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  versionAuditFindingsMutation,
  versionAuditFindingsMutationVariables
>;
export const versionAuditFindingsWithoutClaimRefreshDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "versionAuditFindingsWithoutClaimRefresh" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "VersionAuditFindingsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "createAuditFindings" },
            name: { kind: "Name", value: "versionAuditFindings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "auditFindings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "batchClaimLineId" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "batchClaimLineItemAudit",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "batchClaimLineItem",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "batchClaimLineId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ibLineId" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  versionAuditFindingsWithoutClaimRefreshMutation,
  versionAuditFindingsWithoutClaimRefreshMutationVariables
>;
export const claimDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "claim" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "statusFilter" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "FindingStatus" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "claim" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "icn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "findingStatusCounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accepted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "declined" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "suggested" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "findings" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "statusFilter" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "statusFilter" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FindingFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "autodor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "claimId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sinks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "s3Key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "timestamp" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "autodorFindings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "autodorFindingFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "itemizedBillLines" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ItemizedBillLineFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FindingItemizedBillDataFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FindingItemizedBillData" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "procedureCodeModifier" },
          },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "s3InputSource" } },
          { kind: "Field", name: { kind: "Name", value: "stale" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ibLineVersionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originalBilledAmount" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Finding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "autodorFindingId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "autodorFindingS3Key" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "findingItemizedBillData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "FindingItemizedBillDataFragment",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreatedByUser" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userType" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreatedByAutomation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "confidence" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentCost" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentReason" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentUnitsCharged" },
          },
          { kind: "Field", name: { kind: "Name", value: "isOriginal" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataAocPrimaryCode" },
          },
          { kind: "Field", name: { kind: "Name", value: "metaDataEmCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmCorrectLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmOriginalLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueAdjudicationValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueOhpMueValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpModifier" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataPricingCorrectPrice" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataUnitsCorrectUnits" },
          },
          { kind: "Field", name: { kind: "Name", value: "needsReview" } },
          { kind: "Field", name: { kind: "Name", value: "ruleType" } },
          { kind: "Field", name: { kind: "Name", value: "seedType" } },
          { kind: "Field", name: { kind: "Name", value: "superseded" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "latestReview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "authorId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "rationale" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "autodorFindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AutodorFinding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "auditType" } },
          { kind: "Field", name: { kind: "Name", value: "claimId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "s3Key" } },
          { kind: "Field", name: { kind: "Name", value: "denialCode" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ibLineVersionFingerprint" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "improperCharge" } },
          { kind: "Field", name: { kind: "Name", value: "improperUnits" } },
          { kind: "Field", name: { kind: "Name", value: "seedType" } },
          { kind: "Field", name: { kind: "Name", value: "stale" } },
          { kind: "Field", name: { kind: "Name", value: "ubLineId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "autodorMetadata" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "auditType" } },
                { kind: "Field", name: { kind: "Name", value: "billType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dateOfServiceStart" },
                },
                { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "procedureCode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "procedureCodeModifier" },
                },
                { kind: "Field", name: { kind: "Name", value: "quarter" } },
                { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
                { kind: "Field", name: { kind: "Name", value: "units" } },
                { kind: "Field", name: { kind: "Name", value: "versionId" } },
                { kind: "Field", name: { kind: "Name", value: "year" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rule" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "_type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "genericRule" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ptp" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "colOneCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "colTwoCode" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "extendedDescription",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rationale" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mue" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "num" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rationale" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "enumeration",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "__typename" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "editType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mai" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nonBillable" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ItemizedBillLineFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ItemizedBillLine" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfService" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "procedureCodeModifier" },
          },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "totalCharge" } },
          { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
          { kind: "Field", name: { kind: "Name", value: "findings" } },
          { kind: "Field", name: { kind: "Name", value: "s3InputSourceId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
          { kind: "Field", name: { kind: "Name", value: "groupCode" } },
          { kind: "Field", name: { kind: "Name", value: "chinDescription" } },
          { kind: "Field", name: { kind: "Name", value: "chinItemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "chinModifier" } },
          { kind: "Field", name: { kind: "Name", value: "chinProcedureCode" } },
          { kind: "Field", name: { kind: "Name", value: "chinRevCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<claimQuery, claimQueryVariables>;
export const providerClaimDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "providerClaim" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "claim" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "icn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "itemizedBillLines" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "ProviderItemizedBillLineFragment",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProviderItemizedBillLineFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ItemizedBillLine" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfService" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "procedureCodeModifier" },
          },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "totalCharge" } },
          { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
          { kind: "Field", name: { kind: "Name", value: "s3InputSourceId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<providerClaimQuery, providerClaimQueryVariables>;
export const claimFindingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "claimFindings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "claim" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "icn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "findings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "FindingFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FindingItemizedBillDataFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FindingItemizedBillData" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "procedureCodeModifier" },
          },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "s3InputSource" } },
          { kind: "Field", name: { kind: "Name", value: "stale" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ibLineVersionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originalBilledAmount" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Finding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "autodorFindingId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "autodorFindingS3Key" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "findingItemizedBillData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "FindingItemizedBillDataFragment",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreatedByUser" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userType" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreatedByAutomation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "confidence" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentCost" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentReason" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentUnitsCharged" },
          },
          { kind: "Field", name: { kind: "Name", value: "isOriginal" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataAocPrimaryCode" },
          },
          { kind: "Field", name: { kind: "Name", value: "metaDataEmCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmCorrectLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmOriginalLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueAdjudicationValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueOhpMueValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpModifier" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataPricingCorrectPrice" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataUnitsCorrectUnits" },
          },
          { kind: "Field", name: { kind: "Name", value: "needsReview" } },
          { kind: "Field", name: { kind: "Name", value: "ruleType" } },
          { kind: "Field", name: { kind: "Name", value: "seedType" } },
          { kind: "Field", name: { kind: "Name", value: "superseded" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "latestReview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "authorId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "rationale" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<claimFindingsQuery, claimFindingsQueryVariables>;
export const FindingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Finding" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "finding" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FindingFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FindingItemizedBillDataFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FindingItemizedBillData" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "authorId" } },
          { kind: "Field", name: { kind: "Name", value: "batchClaimLineId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfServiceEnd" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "dateOfServiceStart" },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "ibLineId" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "procedureCodeModifier" },
          },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "s3InputSource" } },
          { kind: "Field", name: { kind: "Name", value: "stale" } },
          { kind: "Field", name: { kind: "Name", value: "unitCharge" } },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ibLineVersionFingerprint" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originalBilledAmount" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FindingFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Finding" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "autodorFindingId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "autodorFindingS3Key" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "findingItemizedBillData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "FindingItemizedBillDataFragment",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "accepted" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createdBy" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreatedByUser" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userType" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreatedByAutomation" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "confidence" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentCost" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentReason" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "improperPaymentUnitsCharged" },
          },
          { kind: "Field", name: { kind: "Name", value: "isOriginal" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataAocPrimaryCode" },
          },
          { kind: "Field", name: { kind: "Name", value: "metaDataEmCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmCorrectLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataEmOriginalLevel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueAdjudicationValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciMueOhpMueValue" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataNcciPtpModifier" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataPricingCorrectPrice" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metaDataUnitsCorrectUnits" },
          },
          { kind: "Field", name: { kind: "Name", value: "needsReview" } },
          { kind: "Field", name: { kind: "Name", value: "ruleType" } },
          { kind: "Field", name: { kind: "Name", value: "seedType" } },
          { kind: "Field", name: { kind: "Name", value: "superseded" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "latestReview" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "authorId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "rationale" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindingQuery, FindingQueryVariables>;
export const ItemizedBillLinesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ItemizedBillLines" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "UUID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "itemizedBillLines" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ids" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ItemizedBillLineFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ItemizedBillLineFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ItemizedBillLine" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "alaRowId" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfService" } },
          { kind: "Field", name: { kind: "Name", value: "itemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "revCode" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "procedureCode" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "procedureCodeModifier" },
          },
          { kind: "Field", name: { kind: "Name", value: "units" } },
          { kind: "Field", name: { kind: "Name", value: "totalCharge" } },
          { kind: "Field", name: { kind: "Name", value: "lineNumber" } },
          { kind: "Field", name: { kind: "Name", value: "findings" } },
          { kind: "Field", name: { kind: "Name", value: "s3InputSourceId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "versionFingerprint" },
          },
          { kind: "Field", name: { kind: "Name", value: "groupCode" } },
          { kind: "Field", name: { kind: "Name", value: "chinDescription" } },
          { kind: "Field", name: { kind: "Name", value: "chinItemNumber" } },
          { kind: "Field", name: { kind: "Name", value: "chinModifier" } },
          { kind: "Field", name: { kind: "Name", value: "chinProcedureCode" } },
          { kind: "Field", name: { kind: "Name", value: "chinRevCode" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ItemizedBillLinesQuery,
  ItemizedBillLinesQueryVariables
>;
export const reportDownloadQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "reportDownloadQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reportId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "auditFindingReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reportId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "downloadUrl" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  reportDownloadQueryQuery,
  reportDownloadQueryQueryVariables
>;
